Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
  value: function(b) {
    if (this == null)
      throw new TypeError("Array.prototype.find called on null or undefined");
    if (typeof b != "function")
      throw new TypeError("predicate must be a function");
    for (var e = Object(this), t = e.length >>> 0, n = arguments[1], a = 0; a !== t; a++)
      if (b.call(n, this[a], a, e))
        return this[a];
  }
});
Array.prototype.includes || (Array.prototype.includes = function(b) {
  if (this == null)
    throw new TypeError("Array.prototype.includes called on null or undefined");
  var e = Object(this), t = parseInt(e.length, 10) || 0;
  if (t === 0)
    return !1;
  var n = parseInt(arguments[1], 10) || 0, a;
  n >= 0 ? a = n : (a = t + n, a < 0 && (a = 0));
  for (var o; a < t; ) {
    if (o = e[a], b === o || b !== b && o !== o)
      return !0;
    a++;
  }
  return !1;
});
Array.prototype.map || (Array.prototype.map = function(b) {
  var e, t, n;
  if (this == null)
    throw new TypeError("this is null or not defined");
  var a = Object(this), o = a.length >>> 0;
  if (typeof b != "function")
    throw new TypeError(b + " is not a function");
  for (arguments.length > 1 && (e = arguments[1]), t = new Array(o), n = 0; n < o; ) {
    var h, f;
    n in a && (h = a[n], f = b.call(e, h, n, a), t[n] = f), n++;
  }
  return t;
});
String.prototype.startsWith || Object.defineProperty(String.prototype, "startsWith", {
  value: function(b, e) {
    var t = e > 0 ? e | 0 : 0;
    return this.substring(t, t + b.length) === b;
  }
});
String.prototype.endsWith || (String.prototype.endsWith = function(b, e) {
  return (e === void 0 || e > this.length) && (e = this.length), this.substring(e - b.length, e) === b;
});
var Lr = /* @__PURE__ */ ((b) => (b[b.Editor = 1] = "Editor", b[b.Viewer = 2] = "Viewer", b))(Lr || {}), Za = /* @__PURE__ */ ((b) => (b.None = "None", b.Translate = "Translate", b.Rotate = "Rotate", b.Scaling = "Scaling", b))(Za || {}), wy = /* @__PURE__ */ ((b) => (b[b.Customizer = 1] = "Customizer", b[b.Composer = 2] = "Composer", b[b.Viewer = 3] = "Viewer", b))(wy || {}), Ph = typeof Float32Array < "u" ? Float32Array : Array;
function Sy() {
  var b = new Ph(3);
  return Ph != Float32Array && (b[0] = 0, b[1] = 0, b[2] = 0), b;
}
function Mh(b) {
  var e = b[0], t = b[1], n = b[2];
  return Math.sqrt(e * e + t * t + n * n);
}
(function() {
  var b = Sy();
  return function(e, t, n, a, o, h) {
    var f, v;
    for (t || (t = 3), n || (n = 0), a ? v = Math.min(a * t + n, e.length) : v = e.length, f = n; f < v; f += t)
      b[0] = e[f], b[1] = e[f + 1], b[2] = e[f + 2], o(b, b, h), e[f] = b[0], e[f + 1] = b[1], e[f + 2] = b[2];
    return e;
  };
})();
function My(b) {
  var e = b[0], t = b[1], n = b[2], a = b[3], o = b[4], h = b[5], f = b[6], v = b[7], x = b[8], k = b[9], I = b[10], V = b[11], M = b[12], W = b[13], U = b[14], Q = b[15], D = e * h - t * o, ee = e * f - n * o, J = t * f - n * h, he = x * W - k * M, fe = x * U - I * M, X = k * U - I * W, Z = e * X - t * fe + n * he, qe = o * X - h * fe + f * he, Oe = x * J - k * ee + I * D, je = M * J - W * ee + U * D;
  return v * Z - a * qe + Q * Oe - V * je;
}
function Cy(b, e, t) {
  var n = e[0], a = e[1], o = e[2], h = e[3], f = e[4], v = e[5], x = e[6], k = e[7], I = e[8], V = e[9], M = e[10], W = e[11], U = e[12], Q = e[13], D = e[14], ee = e[15], J = t[0], he = t[1], fe = t[2], X = t[3];
  return b[0] = J * n + he * f + fe * I + X * U, b[1] = J * a + he * v + fe * V + X * Q, b[2] = J * o + he * x + fe * M + X * D, b[3] = J * h + he * k + fe * W + X * ee, J = t[4], he = t[5], fe = t[6], X = t[7], b[4] = J * n + he * f + fe * I + X * U, b[5] = J * a + he * v + fe * V + X * Q, b[6] = J * o + he * x + fe * M + X * D, b[7] = J * h + he * k + fe * W + X * ee, J = t[8], he = t[9], fe = t[10], X = t[11], b[8] = J * n + he * f + fe * I + X * U, b[9] = J * a + he * v + fe * V + X * Q, b[10] = J * o + he * x + fe * M + X * D, b[11] = J * h + he * k + fe * W + X * ee, J = t[12], he = t[13], fe = t[14], X = t[15], b[12] = J * n + he * f + fe * I + X * U, b[13] = J * a + he * v + fe * V + X * Q, b[14] = J * o + he * x + fe * M + X * D, b[15] = J * h + he * k + fe * W + X * ee, b;
}
function Ay(b, e) {
  var t = e[0], n = e[1], a = e[2], o = e[4], h = e[5], f = e[6], v = e[8], x = e[9], k = e[10];
  return b[0] = Math.sqrt(t * t + n * n + a * a), b[1] = Math.sqrt(o * o + h * h + f * f), b[2] = Math.sqrt(v * v + x * x + k * k), b;
}
function Ty(b, e) {
  var t = new Ph(3);
  Ay(t, e);
  var n = 1 / t[0], a = 1 / t[1], o = 1 / t[2], h = e[0] * n, f = e[1] * a, v = e[2] * o, x = e[4] * n, k = e[5] * a, I = e[6] * o, V = e[8] * n, M = e[9] * a, W = e[10] * o, U = h + k + W, Q = 0;
  return U > 0 ? (Q = Math.sqrt(U + 1) * 2, b[3] = 0.25 * Q, b[0] = (I - M) / Q, b[1] = (V - v) / Q, b[2] = (f - x) / Q) : h > k && h > W ? (Q = Math.sqrt(1 + h - k - W) * 2, b[3] = (I - M) / Q, b[0] = 0.25 * Q, b[1] = (f + x) / Q, b[2] = (V + v) / Q) : k > W ? (Q = Math.sqrt(1 + k - h - W) * 2, b[3] = (V - v) / Q, b[0] = (f + x) / Q, b[1] = 0.25 * Q, b[2] = (I + M) / Q) : (Q = Math.sqrt(1 + W - h - k) * 2, b[3] = (f - x) / Q, b[0] = (V + v) / Q, b[1] = (I + M) / Q, b[2] = 0.25 * Q), b;
}
var nn, cl, Oh, sa;
function Pi(b, e, t, n) {
  var a, o = arguments.length, h = o < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, t) : n;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    h = Reflect.decorate(b, e, t, n);
  else
    for (var f = b.length - 1; f >= 0; f--)
      (a = b[f]) && (h = (o < 3 ? a(h) : o > 3 ? a(e, t, h) : a(e, t)) || h);
  return o > 3 && h && Object.defineProperty(e, t, h), h;
}
(function(b) {
  b.ACCESSOR = "Accessor", b.ANIMATION = "Animation", b.ANIMATION_CHANNEL = "AnimationChannel", b.ANIMATION_SAMPLER = "AnimationSampler", b.BUFFER = "Buffer", b.CAMERA = "Camera", b.MATERIAL = "Material", b.MESH = "Mesh", b.PRIMITIVE = "Primitive", b.PRIMITIVE_TARGET = "PrimitiveTarget", b.NODE = "Node", b.ROOT = "Root", b.SCENE = "Scene", b.SKIN = "Skin", b.TEXTURE = "Texture", b.TEXTURE_INFO = "TextureInfo";
})(nn || (nn = {})), function(b) {
  b.INTERLEAVED = "interleaved", b.SEPARATE = "separate";
}(cl || (cl = {})), function(b) {
  b[b.R = 4096] = "R", b[b.G = 256] = "G", b[b.B = 16] = "B", b[b.A = 1] = "A";
}(Oh || (Oh = {})), function(b) {
  b.GLTF = "GLTF", b.GLB = "GLB";
}(sa || (sa = {}));
class wl {
  constructor(e, t, n) {
    if (this.t = void 0, this.i = void 0, this.h = void 0, this.o = !1, this.u = [], this.t = e, this.i = t, this.h = n, !t.canLink(n))
      throw new Error("Cannot link disconnected graphs/documents.");
  }
  getName() {
    return this.t;
  }
  getParent() {
    return this.i;
  }
  getChild() {
    return this.h;
  }
  setChild(e) {
    return this.h = e, this;
  }
  dispose() {
    this.o || (this.o = !0, this.u.forEach((e) => e()), this.u.length = 0);
  }
  onDispose(e) {
    return this.u.push(e), this;
  }
  isDisposed() {
    return this.o;
  }
}
class Ly {
  constructor() {
    this.l = /* @__PURE__ */ new Set(), this.p = /* @__PURE__ */ new Set(), this.g = /* @__PURE__ */ new Map(), this.v = /* @__PURE__ */ new Map(), this.u = {};
  }
  on(e, t) {
    return this.u[e] = this.u[e] || [], this.u[e].push(t), this;
  }
  emit(e, t) {
    for (const n of this.u[e] || [])
      n(t);
    return this;
  }
  getLinks() {
    return Array.from(this.p);
  }
  listParentLinks(e) {
    return Array.from(this.v.get(e) || this.l);
  }
  listParents(e) {
    return this.listParentLinks(e).map((t) => t.getParent());
  }
  listChildLinks(e) {
    return Array.from(this.g.get(e) || this.l);
  }
  listChildren(e) {
    return this.listChildLinks(e).map((t) => t.getChild());
  }
  disconnectChildren(e) {
    return (this.g.get(e) || this.l).forEach((t) => t.dispose()), this;
  }
  disconnectParents(e, t) {
    let n = Array.from(this.v.get(e) || this.l);
    return t && (n = n.filter((a) => t(a.getParent()))), n.forEach((a) => a.dispose()), this;
  }
  swapChild(e, t, n) {
    const a = this.g.get(e) || this.l;
    return Array.from(a).filter((o) => o.getChild() === t).forEach((o) => {
      this.v.get(t).delete(o), o.setChild(n), this.v.has(n) || this.v.set(n, /* @__PURE__ */ new Set()), this.v.get(n).add(o);
    }), this;
  }
  link(e, t, n) {
    if (!n)
      return null;
    const a = new wl(e, t, n);
    return this.registerLink(a), a;
  }
  registerLink(e) {
    this.p.add(e);
    const t = e.getParent();
    this.g.has(t) || this.g.set(t, /* @__PURE__ */ new Set()), this.g.get(t).add(e);
    const n = e.getChild();
    return this.v.has(n) || this.v.set(n, /* @__PURE__ */ new Set()), this.v.get(n).add(e), e.onDispose(() => this.unlink(e)), e;
  }
  unlink(e) {
    return this.p.delete(e), this.g.get(e.getParent()).delete(e), this.v.get(e.getChild()).delete(e), this;
  }
}
function Bn(b, e) {
  Object.defineProperty(b, e, { get: function() {
    return this["__" + e];
  }, set: function(t) {
    const n = this["__" + e];
    n && !Array.isArray(n) && n.dispose(), t && !Array.isArray(t) && t.onDispose(() => {
      this["__" + e] = null;
    }), this["__" + e] = t;
  }, enumerable: !0 });
}
function Yn(b, e) {
}
class br {
  static createBufferFromDataURI(e) {
    if (typeof Buffer > "u") {
      const t = atob(e.split(",")[1]), n = new Uint8Array(t.length);
      for (let a = 0; a < t.length; a++)
        n[a] = t.charCodeAt(a);
      return n.buffer;
    }
    {
      const t = e.split(",")[1], n = e.indexOf("base64") >= 0;
      return this.trim(Buffer.from(t, n ? "base64" : "utf8"));
    }
  }
  static encodeText(e) {
    return typeof TextEncoder < "u" ? new TextEncoder().encode(e).buffer : this.trim(Buffer.from(e));
  }
  static decodeText(e) {
    return typeof TextDecoder < "u" ? new TextDecoder().decode(e) : Buffer.from(e).toString("utf8");
  }
  static trim(e) {
    const { byteOffset: t, byteLength: n } = e;
    return e.buffer.slice(t, t + n);
  }
  static concat(e) {
    let t = 0;
    for (const o of e)
      t += o.byteLength;
    const n = new Uint8Array(t);
    let a = 0;
    for (const o of e)
      n.set(new Uint8Array(o), a), a += o.byteLength;
    return n.buffer;
  }
  static pad(e, t = 0) {
    const n = this.padNumber(e.byteLength);
    if (n !== e.byteLength) {
      const a = new Uint8Array(n);
      if (a.set(new Uint8Array(e)), t !== 0)
        for (let o = e.byteLength; o < n; o++)
          a[o] = t;
      return a.buffer;
    }
    return e;
  }
  static padNumber(e) {
    return 4 * Math.ceil(e / 4);
  }
  static equals(e, t) {
    if (e === t)
      return !0;
    if (e.byteLength !== t.byteLength)
      return !1;
    const n = new DataView(e), a = new DataView(t);
    let o = e.byteLength;
    for (; o--; )
      if (n.getUint8(o) !== a.getUint8(o))
        return !1;
    return !0;
  }
}
class Wo {
  static hexToFactor(e, t) {
    e = Math.floor(e);
    const n = t;
    return n[0] = (e >> 16 & 255) / 255, n[1] = (e >> 8 & 255) / 255, n[2] = (255 & e) / 255, this.convertSRGBToLinear(t, t);
  }
  static factorToHex(e) {
    const t = [...e], [n, a, o] = this.convertLinearToSRGB(e, t);
    return 255 * n << 16 ^ 255 * a << 8 ^ 255 * o << 0;
  }
  static convertSRGBToLinear(e, t) {
    const n = e, a = t;
    for (let o = 0; o < 3; o++)
      a[o] = n[o] < 0.04045 ? 0.0773993808 * n[o] : Math.pow(0.9478672986 * n[o] + 0.0521327014, 2.4);
    return t;
  }
  static convertLinearToSRGB(e, t) {
    const n = e, a = t;
    for (let o = 0; o < 3; o++)
      a[o] = n[o] < 31308e-7 ? 12.92 * n[o] : 1.055 * Math.pow(n[o], 0.41666) - 0.055;
    return t;
  }
}
class fl {
  static basename(e) {
    const t = e.split(/[\\/]/).pop();
    return t.substr(0, t.lastIndexOf("."));
  }
  static extension(e) {
    return e.indexOf("data:") !== 0 ? e.split(/[\\/]/).pop().split(/[.]/).pop() : e.indexOf("data:image/png") === 0 ? "png" : e.indexOf("data:image/jpeg") === 0 ? "jpeg" : "bin";
  }
}
class Sl {
  match(e) {
    const t = new Uint8Array(e);
    return t.length >= 8 && t[0] === 137 && t[1] === 80 && t[2] === 78 && t[3] === 71 && t[4] === 13 && t[5] === 10 && t[6] === 26 && t[7] === 10;
  }
  getSize(e) {
    const t = new DataView(e);
    return br.decodeText(e.slice(12, 16)) === Sl.PNG_FRIED_CHUNK_NAME ? [t.getUint32(32, !1), t.getUint32(36, !1)] : [t.getUint32(16, !1), t.getUint32(20, !1)];
  }
  getChannels(e) {
    return 4;
  }
}
Sl.PNG_FRIED_CHUNK_NAME = "CgBI";
class Ca {
  static registerFormat(e, t) {
    this.impls[e] = t;
  }
  static getMimeType(e) {
    for (const t in this.impls)
      if (this.impls[t].match(e))
        return t;
    return null;
  }
  static getSize(e, t) {
    return this.impls[t] ? this.impls[t].getSize(e) : null;
  }
  static getChannels(e, t) {
    return this.impls[t] ? this.impls[t].getChannels(e) : null;
  }
  static getMemSize(e, t) {
    if (!this.impls[t])
      return null;
    if (this.impls[t].getGPUByteLength)
      return this.impls[t].getGPUByteLength(e);
    let n = 0;
    const a = this.getSize(e, t);
    if (!a)
      return null;
    for (; a[0] > 1 || a[1] > 1; )
      n += a[0] * a[1] * 4, a[0] = Math.max(Math.floor(a[0] / 2), 1), a[1] = Math.max(Math.floor(a[1] / 2), 1);
    return n += 4, n;
  }
  static mimeTypeToExtension(e) {
    return e === "image/jpeg" ? "jpg" : e.split("/").pop();
  }
  static extensionToMimeType(e) {
    return e === "jpg" ? "image/jpeg" : `image/${e}`;
  }
}
function By(b, e) {
  if (e > b.byteLength)
    throw new TypeError("Corrupt JPG, exceeded buffer limits");
  if (b.getUint8(e) !== 255)
    throw new TypeError("Invalid JPG, marker table corrupted");
  return b;
}
Ca.impls = { "image/jpeg": new class {
  match(b) {
    const e = new Uint8Array(b);
    return e.length >= 3 && e[0] === 255 && e[1] === 216 && e[2] === 255;
  }
  getSize(b) {
    let e, t, n = new DataView(b, 4);
    for (; n.byteLength; ) {
      if (e = n.getUint16(0, !1), By(n, e), t = n.getUint8(e + 1), t === 192 || t === 193 || t === 194)
        return [n.getUint16(e + 7, !1), n.getUint16(e + 5, !1)];
      n = new DataView(b, n.byteOffset + e + 2);
    }
    throw new TypeError("Invalid JPG, no size found");
  }
  getChannels(b) {
    return 3;
  }
}(), "image/png": new Sl() };
class Zn {
  static identity(e) {
    return e;
  }
  static eq(e, t) {
    if (e.length !== t.length)
      return !1;
    for (let n = 0; n < e.length; n++)
      if (Math.abs(e[n] - t[n]) > 1e-5)
        return !1;
    return !0;
  }
  static denormalize(e, t) {
    switch (t) {
      case 5126:
        return e;
      case 5123:
        return e / 65535;
      case 5121:
        return e / 255;
      case 5122:
        return Math.max(e / 32767, -1);
      case 5120:
        return Math.max(e / 127, -1);
      default:
        throw new Error("Invalid component type.");
    }
  }
  static normalize(e, t) {
    switch (t) {
      case 5126:
        return e;
      case 5123:
        return Math.round(65535 * e);
      case 5121:
        return Math.round(255 * e);
      case 5122:
        return Math.round(32767 * e);
      case 5120:
        return Math.round(127 * e);
      default:
        throw new Error("Invalid component type.");
    }
  }
  static decompose(e, t, n, a) {
    let o = Mh([e[0], e[1], e[2]]);
    const h = Mh([e[4], e[5], e[6]]), f = Mh([e[8], e[9], e[10]]);
    My(e) < 0 && (o = -o), t[0] = e[12], t[1] = e[13], t[2] = e[14];
    const v = e.slice(), x = 1 / o, k = 1 / h, I = 1 / f;
    v[0] *= x, v[1] *= x, v[2] *= x, v[4] *= k, v[5] *= k, v[6] *= k, v[8] *= I, v[9] *= I, v[10] *= I, Ty(n, v), a[0] = o, a[1] = h, a[2] = f;
  }
  static compose(e, t, n, a) {
    const o = a, h = t[0], f = t[1], v = t[2], x = t[3], k = h + h, I = f + f, V = v + v, M = h * k, W = h * I, U = h * V, Q = f * I, D = f * V, ee = v * V, J = x * k, he = x * I, fe = x * V, X = n[0], Z = n[1], qe = n[2];
    return o[0] = (1 - (Q + ee)) * X, o[1] = (W + fe) * X, o[2] = (U - he) * X, o[3] = 0, o[4] = (W - fe) * Z, o[5] = (1 - (M + ee)) * Z, o[6] = (D + J) * Z, o[7] = 0, o[8] = (U + he) * qe, o[9] = (D - J) * qe, o[10] = (1 - (M + Q)) * qe, o[11] = 0, o[12] = e[0], o[13] = e[1], o[14] = e[2], o[15] = 1, o;
  }
}
class Yr {
  constructor(e) {
    this.verbosity = void 0, this.verbosity = e;
  }
  debug(e) {
    this.verbosity <= Yr.Verbosity.DEBUG && console.debug(e);
  }
  info(e) {
    this.verbosity <= Yr.Verbosity.INFO && console.info(e);
  }
  warn(e) {
    this.verbosity <= Yr.Verbosity.WARN && console.warn(e);
  }
  error(e) {
    this.verbosity <= Yr.Verbosity.ERROR && console.error(e);
  }
}
Yr.Verbosity = { SILENT: 4, ERROR: 3, WARN: 2, INFO: 1, DEBUG: 0 }, Yr.DEFAULT_INSTANCE = new Yr(Yr.Verbosity.INFO);
const uf = "23456789abdegjkmnpqrvwxyzABDEGJKMNPQRVWXYZ", cf = /* @__PURE__ */ new Set(), ky = function() {
  let b = "";
  for (let e = 0; e < 6; e++)
    b += uf.charAt(Math.floor(Math.random() * uf.length));
  return b;
}, Ey = function() {
  for (let b = 0; b < 999; b++) {
    const e = ky();
    if (!cf.has(e))
      return cf.add(e), e;
  }
  return "";
}, kn = (b) => b;
class Ta extends class {
  constructor(e) {
    this.graph = void 0, this.o = !1, this.graph = e, this.graph = e;
  }
  canLink(e) {
    return this.graph === e.graph;
  }
  isDisposed() {
    return this.o;
  }
  dispose() {
    this.graph.disconnectChildren(this), this.graph.disconnectParents(this), this.o = !0, this.graph.emit("dispose", this);
  }
  detach() {
    return this.graph.disconnectParents(this), this;
  }
  swap(e, t) {
    return this.graph.swapChild(this, e, t), this;
  }
  addGraphChild(e, t) {
    return e.push(t), t.onDispose(() => {
      const n = e.filter((a) => a !== t);
      e.length = 0;
      for (const a of n)
        e.push(a);
    }), this;
  }
  removeGraphChild(e, t) {
    return e.filter((n) => n.getChild() === t).forEach((n) => n.dispose()), this;
  }
  clearGraphChildList(e) {
    for (; e.length > 0; )
      e[0].dispose();
    return this;
  }
  listGraphParents() {
    return this.graph.listParents(this);
  }
} {
  constructor(e, t = "") {
    super(e), this.graph = void 0, this.m = {}, this.t = "", this.graph = e, this.t = t;
  }
  getName() {
    return this.t;
  }
  setName(e) {
    return this.t = e, this;
  }
  getExtras() {
    return this.m;
  }
  setExtras(e) {
    return this.m = e, this;
  }
  clone() {
    const e = new this.constructor(this.graph).copy(this, kn);
    return this.graph.emit("clone", e), e;
  }
  copy(e, t = kn) {
    return this.t = e.t, this.m = JSON.parse(JSON.stringify(e.m)), this;
  }
  detach() {
    return this.graph.disconnectParents(this, (e) => e.propertyType !== "Root"), this;
  }
  listParents() {
    return this.listGraphParents();
  }
}
const ff = "Pass extension name (string) as lookup token, not a constructor.";
class Gr extends Ta {
  constructor(...e) {
    super(...e), this.extensions = [];
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.clearGraphChildList(this.extensions), e.extensions.forEach((n) => {
      const a = n.getChild();
      this.setExtension(a.extensionName, t(a));
    }), this;
  }
  getExtension(e) {
    if (typeof e != "string")
      throw new Error(ff);
    const t = this.extensions.find((n) => n.getChild().extensionName === e);
    return t ? t.getChild() : null;
  }
  setExtension(e, t) {
    if (typeof e != "string")
      throw new Error(ff);
    const n = this.getExtension(e);
    return n && this.removeGraphChild(this.extensions, n), t ? (t.T(this), this.addGraphChild(this.extensions, this.graph.link(e, this, t))) : this;
  }
  listExtensions() {
    return this.extensions.map((e) => e.getChild());
  }
}
Pi([Yn], Gr.prototype, "extensions", void 0);
class Ci extends Gr {
  constructor(...e) {
    super(...e), this.propertyType = nn.ACCESSOR, this.S = null, this.M = Ci.Type.SCALAR, this.I = Ci.ComponentType.FLOAT, this.N = !1, this.C = Zn.identity, this.O = Zn.identity, this.buffer = null;
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.M = e.M, this.I = e.I, this.N = e.N, this.C = e.C, this.O = e.O, e.S && (this.S = e.S.slice()), this.setBuffer(e.buffer ? t(e.buffer.getChild()) : null), this;
  }
  static getElementSize(e) {
    switch (e) {
      case Ci.Type.SCALAR:
        return 1;
      case Ci.Type.VEC2:
        return 2;
      case Ci.Type.VEC3:
        return 3;
      case Ci.Type.VEC4:
      case Ci.Type.MAT2:
        return 4;
      case Ci.Type.MAT3:
        return 9;
      case Ci.Type.MAT4:
        return 16;
      default:
        throw new Error("Unexpected type: " + e);
    }
  }
  static getComponentSize(e) {
    switch (e) {
      case Ci.ComponentType.BYTE:
      case Ci.ComponentType.UNSIGNED_BYTE:
        return 1;
      case Ci.ComponentType.SHORT:
      case Ci.ComponentType.UNSIGNED_SHORT:
        return 2;
      case Ci.ComponentType.UNSIGNED_INT:
      case Ci.ComponentType.FLOAT:
        return 4;
      default:
        throw new Error("Unexpected component type: " + e);
    }
  }
  getMinNormalized(e) {
    const t = this.getElementSize();
    this.getMin(e);
    for (let n = 0; n < t; n++)
      e[n] = this.O(e[n]);
    return e;
  }
  getMin(e) {
    const t = this.getCount(), n = this.getElementSize();
    for (let a = 0; a < n; a++)
      e[a] = 1 / 0;
    for (let a = 0; a < t * n; a += n)
      for (let o = 0; o < n; o++) {
        const h = this.S[a + o];
        Number.isFinite(h) && (e[o] = Math.min(e[o], h));
      }
    return e;
  }
  getMaxNormalized(e) {
    const t = this.getElementSize();
    this.getMax(e);
    for (let n = 0; n < t; n++)
      e[n] = this.O(e[n]);
    return e;
  }
  getMax(e) {
    const t = this.getCount(), n = this.getElementSize();
    for (let a = 0; a < n; a++)
      e[a] = -1 / 0;
    for (let a = 0; a < t * n; a += n)
      for (let o = 0; o < n; o++) {
        const h = this.S[a + o];
        Number.isFinite(h) && (e[o] = Math.max(e[o], h));
      }
    return e;
  }
  getCount() {
    return this.S ? this.S.length / this.getElementSize() : 0;
  }
  getType() {
    return this.M;
  }
  setType(e) {
    return this.M = e, this;
  }
  getElementSize() {
    return Ci.getElementSize(this.M);
  }
  getComponentSize() {
    return this.S.BYTES_PER_ELEMENT;
  }
  getComponentType() {
    return this.I;
  }
  getNormalized() {
    return this.N;
  }
  setNormalized(e) {
    return this.N = e, e ? (this.O = (t) => Zn.denormalize(t, this.I), this.C = (t) => Zn.normalize(t, this.I)) : (this.O = Zn.identity, this.C = Zn.identity), this;
  }
  getScalar(e) {
    const t = this.getElementSize();
    return this.O(this.S[e * t]);
  }
  setScalar(e, t) {
    return this.S[e * this.getElementSize()] = this.C(t), this;
  }
  getElement(e, t) {
    const n = this.getElementSize();
    for (let a = 0; a < n; a++)
      t[a] = this.O(this.S[e * n + a]);
    return t;
  }
  setElement(e, t) {
    const n = this.getElementSize();
    for (let a = 0; a < n; a++)
      this.S[e * n + a] = this.C(t[a]);
    return this;
  }
  getBuffer() {
    return this.buffer ? this.buffer.getChild() : null;
  }
  setBuffer(e) {
    return this.buffer = this.graph.link("buffer", this, e), this;
  }
  getArray() {
    return this.S;
  }
  setArray(e) {
    return this.I = e ? function(t) {
      switch (t.constructor) {
        case Float32Array:
          return Ci.ComponentType.FLOAT;
        case Uint32Array:
          return Ci.ComponentType.UNSIGNED_INT;
        case Uint16Array:
          return Ci.ComponentType.UNSIGNED_SHORT;
        case Uint8Array:
          return Ci.ComponentType.UNSIGNED_BYTE;
        case Int16Array:
          return Ci.ComponentType.SHORT;
        case Int8Array:
          return Ci.ComponentType.BYTE;
        default:
          throw new Error("Unknown accessor componentType.");
      }
    }(e) : Ci.ComponentType.FLOAT, this.S = e, this;
  }
  getByteLength() {
    return this.S ? this.S.byteLength : 0;
  }
}
Ci.Type = { SCALAR: "SCALAR", VEC2: "VEC2", VEC3: "VEC3", VEC4: "VEC4", MAT2: "MAT2", MAT3: "MAT3", MAT4: "MAT4" }, Ci.ComponentType = { BYTE: 5120, UNSIGNED_BYTE: 5121, SHORT: 5122, UNSIGNED_SHORT: 5123, UNSIGNED_INT: 5125, FLOAT: 5126 }, Pi([Bn], Ci.prototype, "buffer", void 0);
class dl extends Gr {
  constructor(...e) {
    super(...e), this.propertyType = nn.ANIMATION, this.channels = [], this.samplers = [];
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.clearGraphChildList(this.channels), this.clearGraphChildList(this.samplers), e.channels.forEach((n) => this.addChannel(t(n.getChild()))), e.samplers.forEach((n) => this.addSampler(t(n.getChild()))), this;
  }
  addChannel(e) {
    const t = this.graph.link("channel", this, e);
    return this.addGraphChild(this.channels, t);
  }
  removeChannel(e) {
    return this.removeGraphChild(this.channels, e);
  }
  listChannels() {
    return this.channels.map((e) => e.getChild());
  }
  addSampler(e) {
    const t = this.graph.link("sampler", this, e);
    return this.addGraphChild(this.samplers, t);
  }
  removeSampler(e) {
    return this.removeGraphChild(this.samplers, e);
  }
  listSamplers() {
    return this.samplers.map((e) => e.getChild());
  }
}
Pi([Yn], dl.prototype, "channels", void 0), Pi([Yn], dl.prototype, "samplers", void 0);
class nl extends Ta {
  constructor(...e) {
    super(...e), this.propertyType = nn.ANIMATION_CHANNEL, this._ = null, this.targetNode = null, this.sampler = null;
  }
  copy(e, t = kn) {
    return super.copy(e, t), this._ = e._, this.setTargetNode(e.targetNode ? t(e.targetNode.getChild()) : null), this.setSampler(e.sampler ? t(e.sampler.getChild()) : null), this;
  }
  getTargetPath() {
    return this._;
  }
  setTargetPath(e) {
    return this._ = e, this;
  }
  getTargetNode() {
    return this.targetNode ? this.targetNode.getChild() : null;
  }
  setTargetNode(e) {
    return this.targetNode = this.graph.link("target.node", this, e), this;
  }
  getSampler() {
    return this.sampler ? this.sampler.getChild() : null;
  }
  setSampler(e) {
    return this.sampler = this.graph.link("sampler", this, e), this;
  }
}
nl.TargetPath = { TRANSLATION: "translation", ROTATION: "rotation", SCALE: "scale", WEIGHTS: "weights" }, Pi([Bn], nl.prototype, "targetNode", void 0), Pi([Bn], nl.prototype, "sampler", void 0);
class oa extends Ta {
  constructor(...e) {
    super(...e), this.propertyType = nn.ANIMATION_SAMPLER, this.L = oa.Interpolation.LINEAR, this.input = null, this.output = null;
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.L = e.L, this.setInput(e.input ? t(e.input.getChild()) : null), this.setOutput(e.output ? t(e.output.getChild()) : null), this;
  }
  getInterpolation() {
    return this.L;
  }
  setInterpolation(e) {
    return this.L = e, this;
  }
  getInput() {
    return this.input ? this.input.getChild() : null;
  }
  setInput(e) {
    return this.input = this.graph.link("input", this, e), this;
  }
  getOutput() {
    return this.output ? this.output.getChild() : null;
  }
  setOutput(e) {
    return this.output = this.graph.link("output", this, e), this;
  }
}
oa.Interpolation = { LINEAR: "LINEAR", STEP: "STEP", CUBICSPLINE: "CUBICSPLINE" }, Pi([Bn], oa.prototype, "input", void 0), Pi([Bn], oa.prototype, "output", void 0);
class ed extends Gr {
  constructor(...e) {
    super(...e), this.propertyType = nn.BUFFER, this.P = "";
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.P = e.P, this;
  }
  getURI() {
    return this.P;
  }
  setURI(e) {
    return this.P = e, this;
  }
}
class la extends Gr {
  constructor(...e) {
    super(...e), this.propertyType = nn.CAMERA, this.M = la.Type.PERSPECTIVE, this.U = 0.1, this.k = 100, this.F = null, this.j = 2 * Math.PI * 50 / 360, this.D = 1, this.J = 1;
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.M = e.M, this.U = e.U, this.k = e.k, this.F = e.F, this.j = e.j, this.D = e.D, this.J = e.J, this;
  }
  getType() {
    return this.M;
  }
  setType(e) {
    return this.M = e, this;
  }
  getZNear() {
    return this.U;
  }
  setZNear(e) {
    return this.U = e, this;
  }
  getZFar() {
    return this.k;
  }
  setZFar(e) {
    return this.k = e, this;
  }
  getAspectRatio() {
    return this.F;
  }
  setAspectRatio(e) {
    return this.F = e, this;
  }
  getYFov() {
    return this.j;
  }
  setYFov(e) {
    return this.j = e, this;
  }
  getXMag() {
    return this.D;
  }
  setXMag(e) {
    return this.D = e, this;
  }
  getYMag() {
    return this.J;
  }
  setYMag(e) {
    return this.J = e, this;
  }
}
la.Type = { PERSPECTIVE: "perspective", ORTHOGRAPHIC: "orthographic" };
class td extends Ta {
  constructor(e, t) {
    super(e), this.$ = void 0, this.$ = t, this.$.addExtensionProperty(this);
  }
  clone() {
    const e = new this.constructor(this.graph, this.$).copy(this, kn);
    return this.graph.emit("clone", e), e;
  }
  dispose() {
    this.$.removeExtensionProperty(this), super.dispose();
  }
  T(e) {
    if (!this.parentTypes.includes(e.propertyType))
      throw new Error(`Parent "${e.propertyType}" invalid for child "${this.propertyType}".`);
  }
}
td.EXTENSION_NAME = void 0;
class id extends wl {
  constructor(...e) {
    super(...e), this.semantic = "";
  }
  copy(e) {
    return this.semantic = e.semantic, this;
  }
}
class nd extends wl {
  copy(e) {
    return this;
  }
}
let Iy = class extends wl {
  constructor(...e) {
    super(...e), this.channels = 0;
  }
  copy(e) {
    return this.channels = e.channels, this;
  }
};
class Py extends Ly {
  linkAttribute(e, t, n) {
    if (!n)
      return null;
    const a = new id(e, t, n);
    return a.semantic = e, this.registerLink(a), a;
  }
  linkIndex(e, t, n) {
    if (!n)
      return null;
    const a = new nd(e, t, n);
    return this.registerLink(a), a;
  }
  linkTexture(e, t, n, a) {
    if (!a)
      return null;
    const o = new Iy(e, n, a);
    return o.channels = t, this.registerLink(o), o;
  }
}
class hs extends Gr {
  constructor(...e) {
    super(...e), this.propertyType = nn.TEXTURE_INFO, this.V = 0, this.W = null, this.q = null, this.Y = hs.WrapMode.REPEAT, this.H = hs.WrapMode.REPEAT;
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.V = e.V, this.W = e.W, this.q = e.q, this.Y = e.Y, this.H = e.H, this;
  }
  equals(e) {
    return this.getTexCoord() === e.getTexCoord() && this.getMagFilter() === e.getMagFilter() && this.getMinFilter() === e.getMinFilter() && this.getWrapS() === e.getWrapS() && this.getWrapT() === e.getWrapT();
  }
  getTexCoord() {
    return this.V;
  }
  setTexCoord(e) {
    return this.V = e, this;
  }
  getMagFilter() {
    return this.W;
  }
  setMagFilter(e) {
    return this.W = e, this;
  }
  getMinFilter() {
    return this.q;
  }
  setMinFilter(e) {
    return this.q = e, this;
  }
  getWrapS() {
    return this.Y;
  }
  setWrapS(e) {
    return this.Y = e, this;
  }
  getWrapT() {
    return this.H;
  }
  setWrapT(e) {
    return this.H = e, this;
  }
}
hs.WrapMode = { CLAMP_TO_EDGE: 33071, MIRRORED_REPEAT: 33648, REPEAT: 10497 }, hs.MagFilter = { NEAREST: 9728, LINEAR: 9729 }, hs.MinFilter = { NEAREST: 9728, LINEAR: 9729, NEAREST_MIPMAP_NEAREST: 9984, LINEAR_MIPMAP_NEAREST: 9985, NEAREST_MIPMAP_LINEAR: 9986, LINEAR_MIPMAP_LINEAR: 9987 };
const { R: Zo, G: qo, B: $o, A: Oy } = Oh;
class rr extends Gr {
  constructor(...e) {
    super(...e), this.propertyType = nn.MATERIAL, this.Z = rr.AlphaMode.OPAQUE, this.K = 0.5, this.X = !1, this.tt = [1, 1, 1, 1], this.st = [0, 0, 0], this.et = 1, this.it = 1, this.rt = 1, this.nt = 1, this.baseColorTexture = null, this.baseColorTextureInfo = this.graph.link("baseColorTextureInfo", this, new hs(this.graph)), this.emissiveTexture = null, this.emissiveTextureInfo = this.graph.link("emissiveTextureInfo", this, new hs(this.graph)), this.normalTexture = null, this.normalTextureInfo = this.graph.link("normalTextureInfo", this, new hs(this.graph)), this.occlusionTexture = null, this.occlusionTextureInfo = this.graph.link("occlusionTextureInfo", this, new hs(this.graph)), this.metallicRoughnessTexture = null, this.metallicRoughnessTextureInfo = this.graph.link("metallicRoughnessTextureInfo", this, new hs(this.graph));
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.Z = e.Z, this.K = e.K, this.X = e.X, this.tt = [...e.tt], this.st = [...e.st], this.et = e.et, this.it = e.it, this.rt = e.rt, this.nt = e.nt, this.setBaseColorTexture(e.baseColorTexture ? t(e.baseColorTexture.getChild()) : null), this.baseColorTextureInfo.getChild().copy(t(e.baseColorTextureInfo.getChild()), t), this.setEmissiveTexture(e.emissiveTexture ? t(e.emissiveTexture.getChild()) : null), this.emissiveTextureInfo.getChild().copy(t(e.emissiveTextureInfo.getChild()), t), this.setNormalTexture(e.normalTexture ? t(e.normalTexture.getChild()) : null), this.normalTextureInfo.getChild().copy(t(e.normalTextureInfo.getChild()), t), this.setOcclusionTexture(e.occlusionTexture ? t(e.occlusionTexture.getChild()) : null), this.occlusionTextureInfo.getChild().copy(t(e.occlusionTextureInfo.getChild()), t), this.setMetallicRoughnessTexture(e.metallicRoughnessTexture ? t(e.metallicRoughnessTexture.getChild()) : null), this.metallicRoughnessTextureInfo.getChild().copy(t(e.metallicRoughnessTextureInfo.getChild()), t), this;
  }
  equals(e) {
    if (this.getAlphaMode() !== e.getAlphaMode() || this.getAlphaCutoff() !== e.getAlphaCutoff() || this.getDoubleSided() !== e.getDoubleSided() || !Zn.eq(this.getBaseColorFactor(), e.getBaseColorFactor()) || !Zn.eq(this.getEmissiveFactor(), e.getEmissiveFactor()) || this.getNormalScale() !== e.getNormalScale() || this.getOcclusionStrength() !== e.getOcclusionStrength() || this.getRoughnessFactor() !== e.getRoughnessFactor() || this.getMetallicFactor() !== e.getMetallicFactor() || (this.getBaseColorTexture() || e.getBaseColorTexture()) && (this.getBaseColorTexture() !== e.getBaseColorTexture() || this.getBaseColorTexture() && !this.getBaseColorTextureInfo().equals(e.getBaseColorTextureInfo())) || (this.getEmissiveTexture() || e.getEmissiveTexture()) && (this.getEmissiveTexture() !== e.getEmissiveTexture() || this.getEmissiveTexture() && !this.getEmissiveTextureInfo().equals(e.getEmissiveTextureInfo())) || (this.getNormalTexture() || e.getNormalTexture()) && (this.getNormalTexture() !== e.getNormalTexture() || this.getNormalTexture() && !this.getNormalTextureInfo().equals(e.getNormalTextureInfo())) || (this.getOcclusionTexture() || e.getOcclusionTexture()) && (this.getOcclusionTexture() !== e.getOcclusionTexture() || this.getOcclusionTexture() && !this.getOcclusionTextureInfo().equals(e.getOcclusionTextureInfo())) || (this.getMetallicRoughnessTexture() || e.getMetallicRoughnessTexture()) && (this.getMetallicRoughnessTexture() !== e.getMetallicRoughnessTexture() || this.getMetallicRoughnessTexture() && !this.getMetallicRoughnessTextureInfo().equals(e.getMetallicRoughnessTextureInfo())))
      return !1;
    const t = this.listExtensions(), n = e.listExtensions();
    if (t.length !== n.length)
      return !1;
    for (let a = 0; a < t.length; a++)
      if (t[a] !== n[a])
        return !1;
    return !0;
  }
  dispose() {
    this.baseColorTextureInfo.getChild().dispose(), this.emissiveTextureInfo.getChild().dispose(), this.normalTextureInfo.getChild().dispose(), this.occlusionTextureInfo.getChild().dispose(), this.metallicRoughnessTextureInfo.getChild().dispose(), super.dispose();
  }
  getDoubleSided() {
    return this.X;
  }
  setDoubleSided(e) {
    return this.X = e, this;
  }
  getAlpha() {
    return this.tt[3];
  }
  setAlpha(e) {
    return this.tt[3] = e, this;
  }
  getAlphaMode() {
    return this.Z;
  }
  setAlphaMode(e) {
    return this.Z = e, this;
  }
  getAlphaCutoff() {
    return this.K;
  }
  setAlphaCutoff(e) {
    return this.K = e, this;
  }
  getBaseColorFactor() {
    return this.tt;
  }
  setBaseColorFactor(e) {
    return this.tt = e, this;
  }
  getBaseColorHex() {
    return Wo.factorToHex(this.tt);
  }
  setBaseColorHex(e) {
    return Wo.hexToFactor(e, this.tt), this;
  }
  getBaseColorTexture() {
    return this.baseColorTexture ? this.baseColorTexture.getChild() : null;
  }
  getBaseColorTextureInfo() {
    return this.baseColorTexture ? this.baseColorTextureInfo.getChild() : null;
  }
  setBaseColorTexture(e) {
    return this.baseColorTexture = this.graph.linkTexture("baseColorTexture", Zo | qo | $o | Oy, this, e), this;
  }
  getEmissiveFactor() {
    return this.st;
  }
  setEmissiveFactor(e) {
    return this.st = e, this;
  }
  getEmissiveHex() {
    return Wo.factorToHex(this.st);
  }
  setEmissiveHex(e) {
    return Wo.hexToFactor(e, this.st), this;
  }
  getEmissiveTexture() {
    return this.emissiveTexture ? this.emissiveTexture.getChild() : null;
  }
  getEmissiveTextureInfo() {
    return this.emissiveTexture ? this.emissiveTextureInfo.getChild() : null;
  }
  setEmissiveTexture(e) {
    return this.emissiveTexture = this.graph.linkTexture("emissiveTexture", Zo | qo | $o, this, e), this;
  }
  getNormalScale() {
    return this.et;
  }
  setNormalScale(e) {
    return this.et = e, this;
  }
  getNormalTexture() {
    return this.normalTexture ? this.normalTexture.getChild() : null;
  }
  getNormalTextureInfo() {
    return this.normalTexture ? this.normalTextureInfo.getChild() : null;
  }
  setNormalTexture(e) {
    return this.normalTexture = this.graph.linkTexture("normalTexture", Zo | qo | $o, this, e), this;
  }
  getOcclusionStrength() {
    return this.it;
  }
  setOcclusionStrength(e) {
    return this.it = e, this;
  }
  getOcclusionTexture() {
    return this.occlusionTexture ? this.occlusionTexture.getChild() : null;
  }
  getOcclusionTextureInfo() {
    return this.occlusionTexture ? this.occlusionTextureInfo.getChild() : null;
  }
  setOcclusionTexture(e) {
    return this.occlusionTexture = this.graph.linkTexture("occlusionTexture", Zo, this, e), this;
  }
  getRoughnessFactor() {
    return this.rt;
  }
  setRoughnessFactor(e) {
    return this.rt = e, this;
  }
  getMetallicFactor() {
    return this.nt;
  }
  setMetallicFactor(e) {
    return this.nt = e, this;
  }
  getMetallicRoughnessTexture() {
    return this.metallicRoughnessTexture ? this.metallicRoughnessTexture.getChild() : null;
  }
  getMetallicRoughnessTextureInfo() {
    return this.metallicRoughnessTexture ? this.metallicRoughnessTextureInfo.getChild() : null;
  }
  setMetallicRoughnessTexture(e) {
    return this.metallicRoughnessTexture = this.graph.linkTexture("metallicRoughnessTexture", qo | $o, this, e), this;
  }
}
rr.AlphaMode = { OPAQUE: "OPAQUE", MASK: "MASK", BLEND: "BLEND" }, Pi([Bn], rr.prototype, "baseColorTexture", void 0), Pi([Bn], rr.prototype, "baseColorTextureInfo", void 0), Pi([Bn], rr.prototype, "emissiveTexture", void 0), Pi([Bn], rr.prototype, "emissiveTextureInfo", void 0), Pi([Bn], rr.prototype, "normalTexture", void 0), Pi([Bn], rr.prototype, "normalTextureInfo", void 0), Pi([Bn], rr.prototype, "occlusionTexture", void 0), Pi([Bn], rr.prototype, "occlusionTextureInfo", void 0), Pi([Bn], rr.prototype, "metallicRoughnessTexture", void 0), Pi([Bn], rr.prototype, "metallicRoughnessTextureInfo", void 0);
class $h extends Gr {
  constructor(...e) {
    super(...e), this.propertyType = nn.MESH, this.ht = [], this.primitives = [];
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.ht = [...e.ht], this.clearGraphChildList(this.primitives), e.primitives.forEach((n) => this.addPrimitive(t(n.getChild()))), this;
  }
  addPrimitive(e) {
    return this.addGraphChild(this.primitives, this.graph.link("primitive", this, e));
  }
  removePrimitive(e) {
    return this.removeGraphChild(this.primitives, e);
  }
  listPrimitives() {
    return this.primitives.map((e) => e.getChild());
  }
  getWeights() {
    return this.ht;
  }
  setWeights(e) {
    return this.ht = e, this;
  }
}
Pi([Yn], $h.prototype, "primitives", void 0);
class Gs extends Gr {
  constructor(...e) {
    super(...e), this.propertyType = nn.NODE, this.ot = [0, 0, 0], this.ut = [0, 0, 0, 1], this.ct = [1, 1, 1], this.ht = [], this.i = null, this.camera = null, this.mesh = null, this.skin = null, this.children = [];
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.ot = [...e.ot], this.ut = [...e.ut], this.ct = [...e.ct], this.ht = [...e.ht], this.setCamera(e.camera ? t(e.camera.getChild()) : null), this.setMesh(e.mesh ? t(e.mesh.getChild()) : null), this.setSkin(e.skin ? t(e.skin.getChild()) : null), t !== kn && (this.clearGraphChildList(this.children), e.children.forEach((n) => this.addChild(t(n.getChild())))), this;
  }
  getTranslation() {
    return this.ot;
  }
  getRotation() {
    return this.ut;
  }
  getScale() {
    return this.ct;
  }
  setTranslation(e) {
    return this.ot = e, this;
  }
  setRotation(e) {
    return this.ut = e, this;
  }
  setScale(e) {
    return this.ct = e, this;
  }
  getMatrix() {
    return Zn.compose(this.ot, this.ut, this.ct, []);
  }
  setMatrix(e) {
    return Zn.decompose(e, this.ot, this.ut, this.ct), this;
  }
  getWorldTranslation() {
    const e = [0, 0, 0];
    return Zn.decompose(this.getWorldMatrix(), e, [0, 0, 0, 1], [1, 1, 1]), e;
  }
  getWorldRotation() {
    const e = [0, 0, 0, 1];
    return Zn.decompose(this.getWorldMatrix(), [0, 0, 0], e, [1, 1, 1]), e;
  }
  getWorldScale() {
    const e = [1, 1, 1];
    return Zn.decompose(this.getWorldMatrix(), [0, 0, 0], [0, 0, 0, 1], e), e;
  }
  getWorldMatrix() {
    const e = [];
    for (let a = this; a instanceof Gs; a = a.i)
      e.push(a);
    let t;
    const n = e.pop().getMatrix();
    for (; t = e.pop(); )
      Cy(n, n, t.getMatrix());
    return n;
  }
  addChild(e) {
    e.i && e.i.removeChild(e);
    const t = this.graph.link("child", this, e);
    return this.addGraphChild(this.children, t), e.i = this, t.onDispose(() => e.i = null), this;
  }
  removeChild(e) {
    return this.removeGraphChild(this.children, e);
  }
  listChildren() {
    return this.children.map((e) => e.getChild());
  }
  getParent() {
    return this.i;
  }
  getMesh() {
    return this.mesh ? this.mesh.getChild() : null;
  }
  setMesh(e) {
    return this.mesh = this.graph.link("mesh", this, e), this;
  }
  getCamera() {
    return this.camera ? this.camera.getChild() : null;
  }
  setCamera(e) {
    return this.camera = this.graph.link("camera", this, e), this;
  }
  getSkin() {
    return this.skin ? this.skin.getChild() : null;
  }
  setSkin(e) {
    return this.skin = this.graph.link("skin", this, e), this;
  }
  getWeights() {
    return this.ht;
  }
  setWeights(e) {
    return this.ht = e, this;
  }
  traverse(e) {
    e(this);
    for (const t of this.listChildren())
      t.traverse(e);
    return this;
  }
}
Pi([Bn], Gs.prototype, "camera", void 0), Pi([Bn], Gs.prototype, "mesh", void 0), Pi([Bn], Gs.prototype, "skin", void 0), Pi([Yn], Gs.prototype, "children", void 0);
class Ys extends Gr {
  constructor(...e) {
    super(...e), this.propertyType = nn.PRIMITIVE, this.at = Ys.Mode.TRIANGLES, this.material = null, this.indices = null, this.attributes = [], this.targets = [];
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.at = e.at, this.setIndices(e.indices ? t(e.indices.getChild()) : null), this.setMaterial(e.material ? t(e.material.getChild()) : null), this.clearGraphChildList(this.attributes), e.listSemantics().forEach((n) => {
      this.setAttribute(n, t(e.getAttribute(n)));
    }), this.clearGraphChildList(this.targets), e.targets.forEach((n) => this.addTarget(t(n.getChild()))), this;
  }
  getIndices() {
    return this.indices ? this.indices.getChild() : null;
  }
  setIndices(e) {
    return this.indices = this.graph.linkIndex("indices", this, e), this;
  }
  getAttribute(e) {
    const t = this.attributes.find((n) => n.semantic === e);
    return t ? t.getChild() : null;
  }
  setAttribute(e, t) {
    const n = this.getAttribute(e);
    if (n && this.removeGraphChild(this.attributes, n), !t)
      return this;
    const a = this.graph.linkAttribute(e, this, t);
    return this.addGraphChild(this.attributes, a);
  }
  listAttributes() {
    return this.attributes.map((e) => e.getChild());
  }
  listSemantics() {
    return this.attributes.map((e) => e.semantic);
  }
  getMaterial() {
    return this.material ? this.material.getChild() : null;
  }
  setMaterial(e) {
    return this.material = this.graph.link("material", this, e), this;
  }
  getMode() {
    return this.at;
  }
  setMode(e) {
    return this.at = e, this;
  }
  listTargets() {
    return this.targets.map((e) => e.getChild());
  }
  addTarget(e) {
    return this.addGraphChild(this.targets, this.graph.link("target", this, e)), this;
  }
  removeTarget(e) {
    return this.removeGraphChild(this.targets, e);
  }
}
Ys.Mode = { POINTS: 0, LINES: 1, LINE_LOOP: 2, LINE_STRIP: 3, TRIANGLES: 4, TRIANGLE_STRIP: 5, TRIANGLE_FAN: 6 }, Pi([Bn], Ys.prototype, "material", void 0), Pi([Bn], Ys.prototype, "indices", void 0), Pi([Yn], Ys.prototype, "attributes", void 0), Pi([Yn], Ys.prototype, "targets", void 0);
class rd extends Ta {
  constructor(...e) {
    super(...e), this.propertyType = nn.PRIMITIVE_TARGET, this.attributes = [];
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.clearGraphChildList(this.attributes), e.listSemantics().forEach((n) => {
      this.setAttribute(n, t(e.getAttribute(n)));
    }), this;
  }
  getAttribute(e) {
    const t = this.attributes.find((n) => n.semantic === e);
    return t ? t.getChild() : null;
  }
  setAttribute(e, t) {
    const n = this.getAttribute(e);
    if (n && this.removeGraphChild(this.attributes, n), !t)
      return this;
    const a = this.graph.linkAttribute(e, this, t);
    return a.semantic = e, this.addGraphChild(this.attributes, a);
  }
  listAttributes() {
    return this.attributes.map((e) => e.getChild());
  }
  listSemantics() {
    return this.attributes.map((e) => e.semantic);
  }
}
Pi([Yn], rd.prototype, "attributes", void 0);
class io extends Gr {
  constructor(...e) {
    super(...e), this.propertyType = nn.SCENE, this.children = [];
  }
  copy(e, t = kn) {
    return super.copy(e, t), t !== kn && (this.clearGraphChildList(this.children), e.children.forEach((n) => this.addChild(t(n.getChild())))), this;
  }
  addChild(e) {
    e.i && e.i.removeChild(e);
    const t = this.graph.link("child", this, e);
    return this.addGraphChild(this.children, t), e.i = this, t.onDispose(() => e.i = null), this;
  }
  removeChild(e) {
    return this.removeGraphChild(this.children, e);
  }
  listChildren() {
    return this.children.map((e) => e.getChild());
  }
  traverse(e) {
    for (const t of this.listChildren())
      t.traverse(e);
    return this;
  }
}
Pi([Yn], io.prototype, "children", void 0);
class Xa extends Gr {
  constructor(...e) {
    super(...e), this.propertyType = nn.SKIN, this.skeleton = null, this.inverseBindMatrices = null, this.joints = [];
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.setSkeleton(e.skeleton ? t(e.skeleton.getChild()) : null), this.setInverseBindMatrices(e.inverseBindMatrices ? t(e.inverseBindMatrices.getChild()) : null), this.clearGraphChildList(this.joints), e.joints.forEach((n) => this.addJoint(t(n.getChild()))), this;
  }
  getSkeleton() {
    return this.skeleton ? this.skeleton.getChild() : null;
  }
  setSkeleton(e) {
    return this.skeleton = this.graph.link("skeleton", this, e), this;
  }
  getInverseBindMatrices() {
    return this.inverseBindMatrices ? this.inverseBindMatrices.getChild() : null;
  }
  setInverseBindMatrices(e) {
    return this.inverseBindMatrices = this.graph.link("inverseBindMatrices", this, e), this;
  }
  addJoint(e) {
    const t = this.graph.link("joint", this, e);
    return this.addGraphChild(this.joints, t);
  }
  removeJoint(e) {
    return this.removeGraphChild(this.joints, e);
  }
  listJoints() {
    return this.joints.map((e) => e.getChild());
  }
}
Pi([Bn], Xa.prototype, "skeleton", void 0), Pi([Bn], Xa.prototype, "inverseBindMatrices", void 0), Pi([Yn], Xa.prototype, "joints", void 0);
class sd extends Gr {
  constructor(...e) {
    super(...e), this.propertyType = nn.TEXTURE, this.lt = null, this.ft = "", this.P = "";
  }
  copy(e, t = kn) {
    return super.copy(e, t), this.ft = e.ft, this.P = e.P, e.lt && (this.lt = e.lt.slice(0)), this;
  }
  getMimeType() {
    return this.ft || Ca.extensionToMimeType(fl.extension(this.P));
  }
  setMimeType(e) {
    return this.ft = e, this;
  }
  getURI() {
    return this.P;
  }
  setURI(e) {
    return this.P = e, this.ft = Ca.extensionToMimeType(fl.extension(e)), this;
  }
  getImage() {
    return this.lt;
  }
  setImage(e) {
    return this.lt = e, this;
  }
  getSize() {
    return this.lt ? Ca.getSize(this.lt, this.getMimeType()) : null;
  }
}
class Qr extends Ta {
  constructor(e) {
    super(e), this.propertyType = nn.ROOT, this.dt = { generator: "glTF-Transform v1.2.4", version: "2.0" }, this.gt = /* @__PURE__ */ new Set(), this.defaultScene = null, this.accessors = [], this.animations = [], this.buffers = [], this.cameras = [], this.materials = [], this.meshes = [], this.nodes = [], this.scenes = [], this.skins = [], this.textures = [], e.on("clone", (t) => this.wt(t));
  }
  clone() {
    throw new Error("Root cannot be cloned.");
  }
  copy(e, t = kn) {
    if (super.copy(e, t), t === kn)
      throw new Error("Root cannot be copied.");
    return Object.assign(this.dt, e.dt), e.accessors.forEach((n) => this.vt(t(n.getChild()))), e.animations.forEach((n) => this.Tt(t(n.getChild()))), e.buffers.forEach((n) => this.yt(t(n.getChild()))), e.cameras.forEach((n) => this.At(t(n.getChild()))), e.materials.forEach((n) => this.Et(t(n.getChild()))), e.meshes.forEach((n) => this.xt(t(n.getChild()))), e.nodes.forEach((n) => this.St(t(n.getChild()))), e.scenes.forEach((n) => this.Mt(t(n.getChild()))), e.skins.forEach((n) => this.It(t(n.getChild()))), e.textures.forEach((n) => this.bt(t(n.getChild()))), this.setDefaultScene(e.defaultScene ? t(e.defaultScene.getChild()) : null), this;
  }
  wt(e) {
    return e instanceof io ? this.Mt(e) : e instanceof Gs ? this.St(e) : e instanceof la ? this.At(e) : e instanceof Xa ? this.It(e) : e instanceof $h ? this.xt(e) : e instanceof rr ? this.Et(e) : e instanceof sd ? this.bt(e) : e instanceof dl ? this.Tt(e) : e instanceof Ci ? this.vt(e) : e instanceof ed && this.yt(e), this;
  }
  getAsset() {
    return this.dt;
  }
  listExtensionsUsed() {
    return Array.from(this.gt);
  }
  listExtensionsRequired() {
    return this.listExtensionsUsed().filter((e) => e.isRequired());
  }
  Rt(e) {
    return this.gt.add(e), this;
  }
  Nt(e) {
    return this.gt.delete(e), this;
  }
  Mt(e) {
    return this.addGraphChild(this.scenes, this.graph.link("scene", this, e));
  }
  listScenes() {
    return this.scenes.map((e) => e.getChild());
  }
  setDefaultScene(e) {
    return this.defaultScene = this.graph.link("scene", this, e), this;
  }
  getDefaultScene() {
    return this.defaultScene ? this.defaultScene.getChild() : null;
  }
  St(e) {
    return this.addGraphChild(this.nodes, this.graph.link("node", this, e));
  }
  listNodes() {
    return this.nodes.map((e) => e.getChild());
  }
  At(e) {
    return this.addGraphChild(this.cameras, this.graph.link("camera", this, e));
  }
  listCameras() {
    return this.cameras.map((e) => e.getChild());
  }
  It(e) {
    return this.addGraphChild(this.skins, this.graph.link("skin", this, e));
  }
  listSkins() {
    return this.skins.map((e) => e.getChild());
  }
  xt(e) {
    return this.addGraphChild(this.meshes, this.graph.link("mesh", this, e));
  }
  listMeshes() {
    return this.meshes.map((e) => e.getChild());
  }
  Et(e) {
    return this.addGraphChild(this.materials, this.graph.link("material", this, e));
  }
  listMaterials() {
    return this.materials.map((e) => e.getChild());
  }
  bt(e) {
    return this.addGraphChild(this.textures, this.graph.link("texture", this, e));
  }
  listTextures() {
    return this.textures.map((e) => e.getChild());
  }
  Tt(e) {
    return this.addGraphChild(this.animations, this.graph.link("animation", this, e));
  }
  listAnimations() {
    return this.animations.map((e) => e.getChild());
  }
  vt(e) {
    return this.addGraphChild(this.accessors, this.graph.link("accessor", this, e));
  }
  listAccessors() {
    return this.accessors.map((e) => e.getChild());
  }
  yt(e) {
    return this.addGraphChild(this.buffers, this.graph.link("buffer", this, e));
  }
  listBuffers() {
    return this.buffers.map((e) => e.getChild());
  }
}
Pi([Bn], Qr.prototype, "defaultScene", void 0), Pi([Yn], Qr.prototype, "accessors", void 0), Pi([Yn], Qr.prototype, "animations", void 0), Pi([Yn], Qr.prototype, "buffers", void 0), Pi([Yn], Qr.prototype, "cameras", void 0), Pi([Yn], Qr.prototype, "materials", void 0), Pi([Yn], Qr.prototype, "meshes", void 0), Pi([Yn], Qr.prototype, "nodes", void 0), Pi([Yn], Qr.prototype, "scenes", void 0), Pi([Yn], Qr.prototype, "skins", void 0), Pi([Yn], Qr.prototype, "textures", void 0);
class Xh {
  constructor() {
    this.Ct = new Py(), this.Ot = new Qr(this.Ct), this._t = Yr.DEFAULT_INSTANCE;
  }
  getRoot() {
    return this.Ot;
  }
  getGraph() {
    return this.Ct;
  }
  getLogger() {
    return this._t;
  }
  setLogger(e) {
    return this._t = e, this;
  }
  clone() {
    return new Xh().merge(this).setLogger(this._t);
  }
  merge(e) {
    const t = {};
    for (const h of e.getRoot().listExtensionsUsed()) {
      const f = this.createExtension(h.constructor);
      h.isRequired() && f.setRequired(!0), t[f.extensionName] = f;
    }
    const n = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Map();
    n.add(e.Ot), a.set(e.Ot, this.Ot);
    for (const h of e.Ct.getLinks())
      for (const f of [h.getParent(), h.getChild()]) {
        if (n.has(f))
          continue;
        let v;
        if (f.propertyType === nn.TEXTURE_INFO)
          v = f;
        else {
          const x = f.constructor;
          v = f instanceof td ? new x(this.Ct, t[f.extensionName]) : new x(this.Ct);
        }
        a.set(f, v), n.add(f);
      }
    const o = (h) => {
      const f = a.get(h);
      if (!f)
        throw new Error("Could resolve property.");
      return f;
    };
    for (const h of n) {
      const f = a.get(h);
      if (!f)
        throw new Error("Could resolve property.");
      f.copy(h, o);
    }
    return this;
  }
  async transform(...e) {
    const t = e.map((n) => n.name);
    for (const n of e)
      await n(this, { stack: t });
    return this;
  }
  createExtension(e) {
    const t = e.EXTENSION_NAME;
    return this.getRoot().listExtensionsUsed().find((n) => n.extensionName === t) || new e(this);
  }
  createScene(e = "") {
    const t = new io(this.Ct, e);
    return this.Ot.Mt(t), t;
  }
  createNode(e = "") {
    const t = new Gs(this.Ct, e);
    return this.Ot.St(t), t;
  }
  createCamera(e = "") {
    const t = new la(this.Ct, e);
    return this.Ot.At(t), t;
  }
  createSkin(e = "") {
    const t = new Xa(this.Ct, e);
    return this.Ot.It(t), t;
  }
  createMesh(e = "") {
    const t = new $h(this.Ct, e);
    return this.Ot.xt(t), t;
  }
  createPrimitive() {
    return new Ys(this.Ct);
  }
  createPrimitiveTarget(e = "") {
    return new rd(this.Ct, e);
  }
  createMaterial(e = "") {
    const t = new rr(this.Ct, e);
    return this.Ot.Et(t), t;
  }
  createTexture(e = "") {
    const t = new sd(this.Ct, e);
    return this.Ot.bt(t), t;
  }
  createAnimation(e = "") {
    const t = new dl(this.Ct, e);
    return this.Ot.Tt(t), t;
  }
  createAnimationChannel(e = "") {
    return new nl(this.Ct, e);
  }
  createAnimationSampler(e = "") {
    return new oa(this.Ct, e);
  }
  createAccessor(e = "", t = null) {
    t || (t = this.getRoot().listBuffers()[0]);
    const n = new Ci(this.Ct, e).setBuffer(t);
    return this.Ot.vt(n), n;
  }
  createBuffer(e = "") {
    const t = new ed(this.Ct, e);
    return this.Ot.yt(t), t;
  }
}
function es() {
  return (es = Object.assign || function(b) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (b[n] = t[n]);
    }
    return b;
  }).apply(this, arguments);
}
class Ny {
  constructor(e) {
    this.jsonDoc = void 0, this.buffers = [], this.bufferViews = [], this.bufferViewBuffers = [], this.accessors = [], this.textures = [], this.textureInfos = /* @__PURE__ */ new Map(), this.materials = [], this.meshes = [], this.cameras = [], this.nodes = [], this.skins = [], this.animations = [], this.scenes = [], this.jsonDoc = e;
  }
  setTextureInfo(e, t) {
    this.textureInfos.set(e, t), t.texCoord !== void 0 && e.setTexCoord(t.texCoord);
    const n = this.jsonDoc.json.textures[t.index];
    if (n.sampler === void 0)
      return;
    const a = this.jsonDoc.json.samplers[n.sampler];
    a.magFilter !== void 0 && e.setMagFilter(a.magFilter), a.minFilter !== void 0 && e.setMinFilter(a.minFilter), a.wrapS !== void 0 && e.setWrapS(a.wrapS), a.wrapT !== void 0 && e.setWrapT(a.wrapT);
  }
}
const Nh = { 5120: Int8Array, 5121: Uint8Array, 5122: Int16Array, 5123: Uint16Array, 5125: Uint32Array, 5126: Float32Array }, df = { logger: Yr.DEFAULT_INSTANCE, extensions: [], dependencies: {} };
function Xo(b, e) {
  const t = e.bufferViews[b.bufferView], n = e.jsonDoc.json.bufferViews[b.bufferView], a = Nh[b.componentType], o = Ci.getElementSize(b.type), h = a.BYTES_PER_ELEMENT;
  if (n.byteStride !== void 0 && n.byteStride !== o * h)
    return function(v, x) {
      const k = x.bufferViews[v.bufferView], I = x.jsonDoc.json.bufferViews[v.bufferView], V = Nh[v.componentType], M = Ci.getElementSize(v.type), W = V.BYTES_PER_ELEMENT, U = v.byteOffset || 0, Q = new V(v.count * M), D = new DataView(k.buffer, k.byteOffset, k.byteLength), ee = I.byteStride;
      for (let J = 0; J < v.count; J++)
        for (let he = 0; he < M; he++) {
          const fe = U + J * ee + he * W;
          let X;
          switch (v.componentType) {
            case Ci.ComponentType.FLOAT:
              X = D.getFloat32(fe, !0);
              break;
            case Ci.ComponentType.UNSIGNED_INT:
              X = D.getUint32(fe, !0);
              break;
            case Ci.ComponentType.UNSIGNED_SHORT:
              X = D.getUint16(fe, !0);
              break;
            case Ci.ComponentType.UNSIGNED_BYTE:
              X = D.getUint8(fe);
              break;
            case Ci.ComponentType.SHORT:
              X = D.getInt16(fe, !0);
              break;
            case Ci.ComponentType.BYTE:
              X = D.getInt8(fe);
              break;
            default:
              throw new Error(`Unexpected componentType "${v.componentType}".`);
          }
          Q[J * M + he] = X;
        }
      return Q;
    }(b, e);
  const f = t.byteOffset + (b.byteOffset || 0);
  return new a(t.buffer.slice(f, f + b.count * o * h));
}
var Ka, Ja;
(function(b) {
  b[b.ARRAY_BUFFER = 34962] = "ARRAY_BUFFER", b[b.ELEMENT_ARRAY_BUFFER = 34963] = "ELEMENT_ARRAY_BUFFER";
})(Ka || (Ka = {})), function(b) {
  b.ARRAY_BUFFER = "ARRAY_BUFFER", b.ELEMENT_ARRAY_BUFFER = "ELEMENT_ARRAY_BUFFER", b.INVERSE_BIND_MATRICES = "INVERSE_BIND_MATRICES", b.OTHER = "OTHER";
}(Ja || (Ja = {}));
class is {
  constructor(e, t, n) {
    this.Bt = void 0, this.jsonDoc = void 0, this.options = void 0, this.accessorIndexMap = /* @__PURE__ */ new Map(), this.bufferIndexMap = /* @__PURE__ */ new Map(), this.cameraIndexMap = /* @__PURE__ */ new Map(), this.skinIndexMap = /* @__PURE__ */ new Map(), this.materialIndexMap = /* @__PURE__ */ new Map(), this.meshIndexMap = /* @__PURE__ */ new Map(), this.nodeIndexMap = /* @__PURE__ */ new Map(), this.imageIndexMap = /* @__PURE__ */ new Map(), this.textureDefIndexMap = /* @__PURE__ */ new Map(), this.textureInfoDefMap = /* @__PURE__ */ new Map(), this.samplerDefIndexMap = /* @__PURE__ */ new Map(), this.imageBufferViews = [], this.otherBufferViews = /* @__PURE__ */ new Map(), this.otherBufferViewsIndexMap = /* @__PURE__ */ new Map(), this.extensionData = {}, this.bufferURIGenerator = void 0, this.imageURIGenerator = void 0, this.logger = void 0, this.Lt = /* @__PURE__ */ new Map(), this.accessorUsageGroupedByParent = /* @__PURE__ */ new Set(["ARRAY_BUFFER"]), this.accessorParents = /* @__PURE__ */ new Map(), this.Bt = e, this.jsonDoc = t, this.options = n;
    const a = e.getRoot(), o = a.listBuffers().length, h = a.listTextures().length;
    this.bufferURIGenerator = new gf(o > 1, n.basename), this.imageURIGenerator = new gf(h > 1, n.basename), this.logger = e.getLogger();
  }
  createTextureInfoDef(e, t) {
    const n = { magFilter: t.getMagFilter() || void 0, minFilter: t.getMinFilter() || void 0, wrapS: t.getWrapS(), wrapT: t.getWrapT() }, a = JSON.stringify(n);
    this.samplerDefIndexMap.has(a) || (this.samplerDefIndexMap.set(a, this.jsonDoc.json.samplers.length), this.jsonDoc.json.samplers.push(n));
    const o = { source: this.imageIndexMap.get(e), sampler: this.samplerDefIndexMap.get(a) }, h = JSON.stringify(o);
    this.textureDefIndexMap.has(h) || (this.textureDefIndexMap.set(h, this.jsonDoc.json.textures.length), this.jsonDoc.json.textures.push(o));
    const f = { index: this.textureDefIndexMap.get(h) };
    return t.getTexCoord() !== 0 && (f.texCoord = t.getTexCoord()), this.textureInfoDefMap.set(t, f), f;
  }
  createPropertyDef(e) {
    const t = {};
    return e.getName() && (t.name = e.getName()), Object.keys(e.getExtras()).length > 0 && (t.extras = e.getExtras()), t;
  }
  createAccessorDef(e) {
    const t = this.createPropertyDef(e);
    return t.type = e.getType(), t.componentType = e.getComponentType(), t.count = e.getCount(), this.Bt.getGraph().listParentLinks(e).some((n) => n.getName() === "POSITION" || n.getName() === "input") && (t.max = e.getMax([]).map(Math.fround), t.min = e.getMin([]).map(Math.fround)), e.getNormalized() && (t.normalized = e.getNormalized()), t;
  }
  createImageData(e, t, n) {
    if (this.options.format === sa.GLB)
      this.imageBufferViews.push(t), e.bufferView = this.jsonDoc.json.bufferViews.length, this.jsonDoc.json.bufferViews.push({ buffer: 0, byteOffset: -1, byteLength: t.byteLength });
    else {
      const a = Ca.mimeTypeToExtension(n.getMimeType());
      e.uri = this.imageURIGenerator.createURI(n, a), this.jsonDoc.resources[e.uri] = t;
    }
  }
  getAccessorUsage(e) {
    const t = this.Lt.get(e);
    if (t)
      return t;
    for (const n of this.Bt.getGraph().listParentLinks(e)) {
      if (n.getName() === "inverseBindMatrices")
        return is.BufferViewUsage.INVERSE_BIND_MATRICES;
      if (n instanceof id)
        return is.BufferViewUsage.ARRAY_BUFFER;
      if (n instanceof nd)
        return is.BufferViewUsage.ELEMENT_ARRAY_BUFFER;
    }
    return is.BufferViewUsage.OTHER;
  }
  addAccessorToUsageGroup(e, t) {
    const n = this.Lt.get(e);
    if (n && n !== t)
      throw new Error(`Accessor with usage "${n}" cannot be reused as "${t}".`);
    return this.Lt.set(e, t), this;
  }
  listAccessorUsageGroups() {
    const e = {};
    for (const [t, n] of Array.from(this.Lt.entries()))
      e[n] = e[n] || [], e[n].push(t);
    return e;
  }
}
is.BufferViewTarget = Ka, is.BufferViewUsage = Ja, is.USAGE_TO_TARGET = { [Ja.ARRAY_BUFFER]: Ka.ARRAY_BUFFER, [Ja.ELEMENT_ARRAY_BUFFER]: Ka.ELEMENT_ARRAY_BUFFER };
class gf {
  constructor(e, t) {
    this.multiple = void 0, this.basename = void 0, this.counter = 1, this.multiple = e, this.basename = t;
  }
  createURI(e, t) {
    return e.getURI() ? e.getURI() : this.multiple ? `${this.basename}_${this.counter++}.${t}` : `${this.basename}.${t}`;
  }
}
const { BufferViewUsage: Ch } = is;
var gl;
(function(b) {
  b[b.JSON = 1313821514] = "JSON", b[b.BIN = 5130562] = "BIN";
})(gl || (gl = {}));
class Ry {
  constructor() {
    this._t = Yr.DEFAULT_INSTANCE, this.gt = /* @__PURE__ */ new Set(), this.Pt = {}, this.Ut = cl.INTERLEAVED;
  }
  setLogger(e) {
    return this._t = e, this;
  }
  registerExtensions(e) {
    for (const t of e)
      this.gt.add(t), t.register();
    return this;
  }
  registerDependencies(e) {
    return Object.assign(this.Pt, e), this;
  }
  setVertexLayout(e) {
    return this.Ut = e, this;
  }
  kt(e) {
    function t(n) {
      if (n.uri && !(n.uri in e.resources) && n.uri.match(/data:/)) {
        const a = `__${Ey()}.${fl.extension(n.uri)}`;
        e.resources[a] = br.createBufferFromDataURI(n.uri), n.uri = a;
      }
    }
    (e.json.images || []).forEach((n) => {
      if (n.bufferView === void 0 && n.uri === void 0)
        throw new Error("Missing resource URI or buffer view.");
      t(n);
    }), (e.json.buffers || []).forEach(t);
  }
  readJSON(e) {
    return e = this.Ft(e), this.kt(e), (class {
      static read(t, n = df) {
        const a = es({}, df, n), { json: o } = t, h = new Xh();
        this.validate(t, a);
        const f = new Ny(t), v = o.asset, x = h.getRoot().getAsset();
        v.copyright && (x.copyright = v.copyright), v.extras && (x.extras = v.extras), o.extras !== void 0 && h.getRoot().setExtras(es({}, o.extras));
        const k = o.extensionsUsed || [], I = o.extensionsRequired || [];
        for (const ee of a.extensions)
          if (k.includes(ee.EXTENSION_NAME)) {
            const J = h.createExtension(ee).setRequired(I.includes(ee.EXTENSION_NAME));
            for (const he of J.readDependencies)
              J.install(he, a.dependencies[he]);
          }
        const V = o.buffers || [];
        h.getRoot().listExtensionsUsed().filter((ee) => ee.prereadTypes.includes(nn.BUFFER)).forEach((ee) => ee.preread(f, nn.BUFFER)), f.buffers = V.map((ee) => {
          const J = h.createBuffer(ee.name);
          return ee.extras && J.setExtras(ee.extras), ee.uri && ee.uri.indexOf("__") !== 0 && J.setURI(ee.uri), J;
        }), f.bufferViewBuffers = (o.bufferViews || []).map((ee, J) => {
          if (!f.bufferViews[J]) {
            const he = t.json.buffers[ee.buffer], fe = new Uint8Array(he.uri ? t.resources[he.uri] : t.resources["@glb.bin"], ee.byteOffset || 0, ee.byteLength);
            f.bufferViews[J] = fe;
          }
          return f.buffers[ee.buffer];
        }), f.accessors = (o.accessors || []).map((ee) => {
          const J = h.createAccessor(ee.name, f.bufferViewBuffers[ee.bufferView]).setType(ee.type);
          if (ee.extras && J.setExtras(ee.extras), ee.normalized !== void 0 && J.setNormalized(ee.normalized), ee.bufferView === void 0 && !ee.sparse)
            return J;
          let he;
          return he = ee.sparse !== void 0 ? function(fe, X) {
            const Z = Nh[fe.componentType], qe = Ci.getElementSize(fe.type);
            let Oe;
            Oe = fe.bufferView !== void 0 ? Xo(fe, X) : new Z(fe.count * qe);
            const je = fe.sparse, pt = je.count, Te = es({}, fe, je.indices, { count: pt, type: "SCALAR" }), Ze = es({}, fe, je.values, { count: pt }), ce = Xo(Te, X), ut = Xo(Ze, X);
            for (let ze = 0; ze < Te.count; ze++)
              for (let ht = 0; ht < qe; ht++)
                Oe[ce[ze] * qe + ht] = ut[ze * qe + ht];
            return Oe;
          }(ee, f) : Xo(ee, f), J.setArray(he), J;
        });
        const M = o.images || [], W = o.textures || [];
        h.getRoot().listExtensionsUsed().filter((ee) => ee.prereadTypes.includes(nn.TEXTURE)).forEach((ee) => ee.preread(f, nn.TEXTURE)), f.textures = M.map((ee) => {
          const J = h.createTexture(ee.name);
          if (ee.extras && J.setExtras(ee.extras), ee.bufferView !== void 0) {
            const he = o.bufferViews[ee.bufferView], fe = t.json.buffers[he.buffer], X = he.byteOffset || 0, Z = (fe.uri ? t.resources[fe.uri] : t.resources["@glb.bin"]).slice(X, X + he.byteLength);
            J.setImage(Z);
          } else
            ee.uri !== void 0 && (J.setImage(t.resources[ee.uri]), ee.uri.indexOf("__") !== 0 && J.setURI(ee.uri));
          if (ee.mimeType !== void 0)
            J.setMimeType(ee.mimeType);
          else if (ee.uri) {
            const he = fl.extension(ee.uri);
            J.setMimeType(Ca.extensionToMimeType(he));
          }
          return J;
        }), f.materials = (o.materials || []).map((ee) => {
          const J = h.createMaterial(ee.name);
          ee.extras && J.setExtras(ee.extras), ee.alphaMode !== void 0 && J.setAlphaMode(ee.alphaMode), ee.alphaCutoff !== void 0 && J.setAlphaCutoff(ee.alphaCutoff), ee.doubleSided !== void 0 && J.setDoubleSided(ee.doubleSided);
          const he = ee.pbrMetallicRoughness || {};
          if (he.baseColorFactor !== void 0 && J.setBaseColorFactor(he.baseColorFactor), ee.emissiveFactor !== void 0 && J.setEmissiveFactor(ee.emissiveFactor), he.metallicFactor !== void 0 && J.setMetallicFactor(he.metallicFactor), he.roughnessFactor !== void 0 && J.setRoughnessFactor(he.roughnessFactor), he.baseColorTexture !== void 0) {
            const fe = he.baseColorTexture;
            J.setBaseColorTexture(f.textures[W[fe.index].source]), f.setTextureInfo(J.getBaseColorTextureInfo(), fe);
          }
          if (ee.emissiveTexture !== void 0) {
            const fe = ee.emissiveTexture;
            J.setEmissiveTexture(f.textures[W[fe.index].source]), f.setTextureInfo(J.getEmissiveTextureInfo(), fe);
          }
          if (ee.normalTexture !== void 0) {
            const fe = ee.normalTexture;
            J.setNormalTexture(f.textures[W[fe.index].source]), f.setTextureInfo(J.getNormalTextureInfo(), fe), ee.normalTexture.scale !== void 0 && J.setNormalScale(ee.normalTexture.scale);
          }
          if (ee.occlusionTexture !== void 0) {
            const fe = ee.occlusionTexture;
            J.setOcclusionTexture(f.textures[W[fe.index].source]), f.setTextureInfo(J.getOcclusionTextureInfo(), fe), ee.occlusionTexture.strength !== void 0 && J.setOcclusionStrength(ee.occlusionTexture.strength);
          }
          if (he.metallicRoughnessTexture !== void 0) {
            const fe = he.metallicRoughnessTexture;
            J.setMetallicRoughnessTexture(f.textures[W[fe.index].source]), f.setTextureInfo(J.getMetallicRoughnessTextureInfo(), fe);
          }
          return J;
        });
        const U = o.meshes || [];
        h.getRoot().listExtensionsUsed().filter((ee) => ee.prereadTypes.includes(nn.PRIMITIVE)).forEach((ee) => ee.preread(f, nn.PRIMITIVE)), f.meshes = U.map((ee) => {
          const J = h.createMesh(ee.name);
          return ee.extras && J.setExtras(ee.extras), ee.weights !== void 0 && J.setWeights(ee.weights), (ee.primitives || []).forEach((he) => {
            const fe = h.createPrimitive();
            he.extras && fe.setExtras(he.extras), he.material !== void 0 && fe.setMaterial(f.materials[he.material]), he.mode !== void 0 && fe.setMode(he.mode);
            for (const [Z, qe] of Object.entries(he.attributes || {}))
              fe.setAttribute(Z, f.accessors[qe]);
            he.indices !== void 0 && fe.setIndices(f.accessors[he.indices]);
            const X = ee.extras && ee.extras.targetNames || [];
            (he.targets || []).forEach((Z, qe) => {
              const Oe = X[qe] || qe.toString(), je = h.createPrimitiveTarget(Oe);
              for (const [pt, Te] of Object.entries(Z))
                je.setAttribute(pt, f.accessors[Te]);
              fe.addTarget(je);
            }), J.addPrimitive(fe);
          }), J;
        }), f.cameras = (o.cameras || []).map((ee) => {
          const J = h.createCamera(ee.name).setType(ee.type);
          if (ee.extras && J.setExtras(ee.extras), ee.type === la.Type.PERSPECTIVE) {
            const he = ee.perspective;
            J.setYFov(he.yfov), J.setZNear(he.znear), he.zfar !== void 0 && J.setZFar(he.zfar), he.aspectRatio !== void 0 && J.setAspectRatio(he.aspectRatio);
          } else {
            const he = ee.orthographic;
            J.setZNear(he.znear).setZFar(he.zfar).setXMag(he.xmag).setYMag(he.ymag);
          }
          return J;
        });
        const Q = o.nodes || [];
        h.getRoot().listExtensionsUsed().filter((ee) => ee.prereadTypes.includes(nn.NODE)).forEach((ee) => ee.preread(f, nn.NODE)), f.nodes = Q.map((ee) => {
          const J = h.createNode(ee.name);
          if (ee.extras && J.setExtras(ee.extras), ee.translation !== void 0 && J.setTranslation(ee.translation), ee.rotation !== void 0 && J.setRotation(ee.rotation), ee.scale !== void 0 && J.setScale(ee.scale), ee.matrix !== void 0) {
            const he = [0, 0, 0], fe = [0, 0, 0, 1], X = [1, 1, 1];
            Zn.decompose(ee.matrix, he, fe, X), J.setTranslation(he), J.setRotation(fe), J.setScale(X);
          }
          return ee.weights !== void 0 && J.setWeights(ee.weights), J;
        }), f.skins = (o.skins || []).map((ee) => {
          const J = h.createSkin(ee.name);
          ee.extras && J.setExtras(ee.extras), ee.inverseBindMatrices !== void 0 && J.setInverseBindMatrices(f.accessors[ee.inverseBindMatrices]), ee.skeleton !== void 0 && J.setSkeleton(f.nodes[ee.skeleton]);
          for (const he of ee.joints)
            J.addJoint(f.nodes[he]);
          return J;
        }), Q.map((ee, J) => {
          const he = f.nodes[J];
          (ee.children || []).forEach((fe) => he.addChild(f.nodes[fe])), ee.mesh !== void 0 && he.setMesh(f.meshes[ee.mesh]), ee.camera !== void 0 && he.setCamera(f.cameras[ee.camera]), ee.skin !== void 0 && he.setSkin(f.skins[ee.skin]);
        }), f.animations = (o.animations || []).map((ee) => {
          const J = h.createAnimation(ee.name);
          ee.extras && J.setExtras(ee.extras);
          const he = (ee.samplers || []).map((fe) => {
            const X = h.createAnimationSampler().setInput(f.accessors[fe.input]).setOutput(f.accessors[fe.output]).setInterpolation(fe.interpolation || oa.Interpolation.LINEAR);
            return fe.extras && X.setExtras(fe.extras), J.addSampler(X), X;
          });
          return (ee.channels || []).forEach((fe) => {
            const X = h.createAnimationChannel().setSampler(he[fe.sampler]).setTargetNode(f.nodes[fe.target.node]).setTargetPath(fe.target.path);
            fe.extras && X.setExtras(fe.extras), J.addChannel(X);
          }), J;
        });
        const D = o.scenes || [];
        return h.getRoot().listExtensionsUsed().filter((ee) => ee.prereadTypes.includes(nn.SCENE)).forEach((ee) => ee.preread(f, nn.SCENE)), f.scenes = D.map((ee) => {
          const J = h.createScene(ee.name);
          return ee.extras && J.setExtras(ee.extras), (ee.nodes || []).map((he) => f.nodes[he]).forEach((he) => J.addChild(he)), J;
        }), o.scene !== void 0 && h.getRoot().setDefaultScene(f.scenes[o.scene]), h.getRoot().listExtensionsUsed().forEach((ee) => ee.read(f)), h;
      }
      static validate(t, n) {
        const a = t.json;
        if (a.asset.version !== "2.0")
          throw new Error(`Unsupported glTF version, "${a.asset.version}".`);
        if (a.extensionsRequired) {
          for (const o of a.extensionsRequired)
            if (!n.extensions.find((h) => h.EXTENSION_NAME === o))
              throw new Error(`Missing required extension, "${o}".`);
        }
        if (a.extensionsUsed)
          for (const o of a.extensionsUsed)
            n.extensions.find((h) => h.EXTENSION_NAME === o) || n.logger.warn(`Missing optional extension, "${o}".`);
      }
    }).read(e, { extensions: Array.from(this.gt), dependencies: this.Pt, logger: this._t });
  }
  writeJSON(e, t = {}) {
    if (t.format === sa.GLB && e.getRoot().listBuffers().length > 1)
      throw new Error("GLB must have 0–1 buffers.");
    return (class {
      static write(n, a) {
        const o = n.getRoot(), h = { asset: es({ generator: "glTF-Transform v1.2.4" }, o.getAsset()), extras: es({}, o.getExtras()) }, f = { json: h, resources: {} }, v = new is(n, f, a), x = a.logger || Yr.DEFAULT_INSTANCE, k = new Set(a.extensions.map((D) => D.EXTENSION_NAME)), I = n.getRoot().listExtensionsUsed().filter((D) => k.has(D.extensionName)), V = n.getRoot().listExtensionsRequired().filter((D) => k.has(D.extensionName));
        I.length < n.getRoot().listExtensionsUsed().length && x.debug("Some extensions were not registered for I/O, and will not be written.");
        for (const D of I)
          for (const ee of D.writeDependencies)
            D.install(ee, a.dependencies[ee]);
        function M(D, ee, J, he) {
          const fe = [];
          let X = 0;
          for (const qe of D) {
            const Oe = v.createAccessorDef(qe);
            Oe.bufferView = h.bufferViews.length;
            const je = br.pad(qe.getArray().buffer);
            Oe.byteOffset = X, X += je.byteLength, fe.push(je), v.accessorIndexMap.set(qe, h.accessors.length), h.accessors.push(Oe);
          }
          const Z = { buffer: ee, byteOffset: J, byteLength: br.concat(fe).byteLength };
          return he && (Z.target = he), h.bufferViews.push(Z), { buffers: fe, byteLength: X };
        }
        function W(D, ee, J) {
          const he = D[0].getCount();
          let fe = 0;
          for (const Oe of D) {
            const je = v.createAccessorDef(Oe);
            je.bufferView = h.bufferViews.length, je.byteOffset = fe;
            const pt = Oe.getElementSize(), Te = Oe.getComponentSize();
            fe += br.padNumber(pt * Te), v.accessorIndexMap.set(Oe, h.accessors.length), h.accessors.push(je);
          }
          const X = he * fe, Z = new ArrayBuffer(X), qe = new DataView(Z);
          for (let Oe = 0; Oe < he; Oe++) {
            let je = 0;
            for (const pt of D) {
              const Te = pt.getElementSize(), Ze = pt.getComponentSize(), ce = pt.getComponentType(), ut = pt.getArray();
              for (let ze = 0; ze < Te; ze++) {
                const ht = Oe * fe + je + ze * Ze, Gt = ut[Oe * Te + ze];
                switch (ce) {
                  case Ci.ComponentType.FLOAT:
                    qe.setFloat32(ht, Gt, !0);
                    break;
                  case Ci.ComponentType.BYTE:
                    qe.setInt8(ht, Gt);
                    break;
                  case Ci.ComponentType.SHORT:
                    qe.setInt16(ht, Gt, !0);
                    break;
                  case Ci.ComponentType.UNSIGNED_BYTE:
                    qe.setUint8(ht, Gt);
                    break;
                  case Ci.ComponentType.UNSIGNED_SHORT:
                    qe.setUint16(ht, Gt, !0);
                    break;
                  case Ci.ComponentType.UNSIGNED_INT:
                    qe.setUint32(ht, Gt, !0);
                    break;
                  default:
                    throw new Error("Unexpected component type: " + ce);
                }
              }
              je += br.padNumber(Te * Ze);
            }
          }
          return h.bufferViews.push({ buffer: ee, byteOffset: J, byteLength: X, byteStride: fe, target: is.BufferViewTarget.ARRAY_BUFFER }), { byteLength: X, buffers: [Z] };
        }
        const U = /* @__PURE__ */ new Map();
        for (const D of n.getGraph().getLinks()) {
          if (D.getParent() === o)
            continue;
          const ee = D.getChild();
          if (ee instanceof Ci) {
            const J = U.get(ee) || [];
            J.push(D), U.set(ee, J);
          }
        }
        if (h.accessors = [], h.bufferViews = [], h.samplers = [], h.textures = [], h.images = o.listTextures().map((D, ee) => {
          const J = v.createPropertyDef(D);
          D.getMimeType() && (J.mimeType = D.getMimeType());
          const he = D.getImage();
          return he && v.createImageData(J, he, D), v.imageIndexMap.set(D, ee), J;
        }), I.filter((D) => D.prewriteTypes.includes(nn.ACCESSOR)).forEach((D) => D.prewrite(v, nn.ACCESSOR)), o.listAccessors().forEach((D) => {
          const ee = v.accessorUsageGroupedByParent, J = v.accessorParents;
          if (v.accessorIndexMap.has(D))
            return;
          const he = U.get(D) || [], fe = v.getAccessorUsage(D);
          if (v.addAccessorToUsageGroup(D, fe), ee.has(fe)) {
            const X = he[0].getParent(), Z = J.get(X) || /* @__PURE__ */ new Set();
            Z.add(D), J.set(X, Z);
          }
        }), I.filter((D) => D.prewriteTypes.includes(nn.BUFFER)).forEach((D) => D.prewrite(v, nn.BUFFER)), (o.listAccessors().length > 0 || o.listTextures().length > 0 || v.otherBufferViews.size > 0) && o.listBuffers().length === 0)
          throw new Error("Buffer required for Document resources, but none was found.");
        h.buffers = [], o.listBuffers().forEach((D, ee) => {
          const J = v.createPropertyDef(D), he = v.accessorUsageGroupedByParent, fe = v.accessorParents, X = D.listParents().filter((Te) => Te instanceof Ci), Z = new Set(X), qe = [], Oe = h.buffers.length;
          let je = 0;
          const pt = v.listAccessorUsageGroups();
          for (const Te in pt)
            if (he.has(Te))
              for (const Ze of Array.from(fe.values())) {
                const ce = Array.from(Ze).filter((ut) => Z.has(ut)).filter((ut) => v.getAccessorUsage(ut) === Te);
                if (ce.length)
                  if (Te !== Ch.ARRAY_BUFFER || a.vertexLayout === cl.INTERLEAVED) {
                    const ut = Te === Ch.ARRAY_BUFFER ? W(ce, Oe, je) : M(ce, Oe, je);
                    je += ut.byteLength, qe.push(...ut.buffers);
                  } else
                    for (const ut of ce) {
                      const ze = W([ut], Oe, je);
                      je += ze.byteLength, qe.push(...ze.buffers);
                    }
              }
            else {
              const Ze = pt[Te].filter((ut) => Z.has(ut));
              if (!Ze.length)
                continue;
              const ce = M(Ze, Oe, je, Te === Ch.ELEMENT_ARRAY_BUFFER ? is.BufferViewTarget.ELEMENT_ARRAY_BUFFER : void 0);
              je += ce.byteLength, qe.push(...ce.buffers);
            }
          if (v.imageBufferViews.length && ee === 0) {
            for (let Te = 0; Te < v.imageBufferViews.length; Te++)
              if (h.bufferViews[h.images[Te].bufferView].byteOffset = je, je += v.imageBufferViews[Te].byteLength, qe.push(v.imageBufferViews[Te]), je % 8) {
                const Ze = 8 - je % 8;
                je += Ze, qe.push(new ArrayBuffer(Ze));
              }
          }
          if (v.otherBufferViews.has(D))
            for (const Te of v.otherBufferViews.get(D))
              h.bufferViews.push({ buffer: Oe, byteOffset: je, byteLength: Te.byteLength }), v.otherBufferViewsIndexMap.set(Te, h.bufferViews.length - 1), je += Te.byteLength, qe.push(Te);
          if (je) {
            let Te;
            a.format === sa.GLB ? Te = "@glb.bin" : (Te = v.bufferURIGenerator.createURI(D, "bin"), J.uri = Te), J.byteLength = je, f.resources[Te] = br.concat(qe);
          }
          h.buffers.push(J), v.bufferIndexMap.set(D, ee);
        }), o.listAccessors().find((D) => !D.getBuffer()) && x.warn("Skipped writing one or more Accessors: no Buffer assigned."), h.materials = o.listMaterials().map((D, ee) => {
          const J = v.createPropertyDef(D);
          if (D.getAlphaMode() !== rr.AlphaMode.OPAQUE && (J.alphaMode = D.getAlphaMode()), D.getAlphaMode() === rr.AlphaMode.MASK && (J.alphaCutoff = D.getAlphaCutoff()), D.getDoubleSided() && (J.doubleSided = !0), J.pbrMetallicRoughness = {}, Zn.eq(D.getBaseColorFactor(), [1, 1, 1, 1]) || (J.pbrMetallicRoughness.baseColorFactor = D.getBaseColorFactor()), Zn.eq(D.getEmissiveFactor(), [0, 0, 0]) || (J.emissiveFactor = D.getEmissiveFactor()), D.getRoughnessFactor() !== 1 && (J.pbrMetallicRoughness.roughnessFactor = D.getRoughnessFactor()), D.getMetallicFactor() !== 1 && (J.pbrMetallicRoughness.metallicFactor = D.getMetallicFactor()), D.getBaseColorTexture()) {
            const he = D.getBaseColorTexture(), fe = D.getBaseColorTextureInfo();
            J.pbrMetallicRoughness.baseColorTexture = v.createTextureInfoDef(he, fe);
          }
          if (D.getEmissiveTexture()) {
            const he = D.getEmissiveTexture(), fe = D.getEmissiveTextureInfo();
            J.emissiveTexture = v.createTextureInfoDef(he, fe);
          }
          if (D.getNormalTexture()) {
            const he = D.getNormalTexture(), fe = D.getNormalTextureInfo(), X = v.createTextureInfoDef(he, fe);
            D.getNormalScale() !== 1 && (X.scale = D.getNormalScale()), J.normalTexture = X;
          }
          if (D.getOcclusionTexture()) {
            const he = D.getOcclusionTexture(), fe = D.getOcclusionTextureInfo(), X = v.createTextureInfoDef(he, fe);
            D.getOcclusionStrength() !== 1 && (X.strength = D.getOcclusionStrength()), J.occlusionTexture = X;
          }
          if (D.getMetallicRoughnessTexture()) {
            const he = D.getMetallicRoughnessTexture(), fe = D.getMetallicRoughnessTextureInfo();
            J.pbrMetallicRoughness.metallicRoughnessTexture = v.createTextureInfoDef(he, fe);
          }
          return v.materialIndexMap.set(D, ee), J;
        }), h.meshes = o.listMeshes().map((D, ee) => {
          const J = v.createPropertyDef(D);
          let he = null;
          return J.primitives = D.listPrimitives().map((fe) => {
            const X = { attributes: {} };
            X.mode = fe.getMode();
            const Z = fe.getMaterial();
            Z && (X.material = v.materialIndexMap.get(Z)), Object.keys(fe.getExtras()).length && (X.extras = fe.getExtras());
            const qe = fe.getIndices();
            qe && (X.indices = v.accessorIndexMap.get(qe));
            for (const Oe of fe.listSemantics())
              X.attributes[Oe] = v.accessorIndexMap.get(fe.getAttribute(Oe));
            for (const Oe of fe.listTargets()) {
              const je = {};
              for (const pt of Oe.listSemantics())
                je[pt] = v.accessorIndexMap.get(Oe.getAttribute(pt));
              X.targets = X.targets || [], X.targets.push(je);
            }
            return fe.listTargets().length && !he && (he = fe.listTargets().map((Oe) => Oe.getName())), X;
          }), D.getWeights().length && (J.weights = D.getWeights()), he && (J.extras = J.extras || {}, J.extras.targetNames = he), v.meshIndexMap.set(D, ee), J;
        }), h.cameras = o.listCameras().map((D, ee) => {
          const J = v.createPropertyDef(D);
          if (J.type = D.getType(), J.type === la.Type.PERSPECTIVE) {
            J.perspective = { znear: D.getZNear(), zfar: D.getZFar(), yfov: D.getYFov() };
            const he = D.getAspectRatio();
            he !== null && (J.perspective.aspectRatio = he);
          } else
            J.orthographic = { znear: D.getZNear(), zfar: D.getZFar(), xmag: D.getXMag(), ymag: D.getYMag() };
          return v.cameraIndexMap.set(D, ee), J;
        }), h.nodes = o.listNodes().map((D, ee) => {
          const J = v.createPropertyDef(D);
          return Zn.eq(D.getTranslation(), [0, 0, 0]) || (J.translation = D.getTranslation()), Zn.eq(D.getRotation(), [0, 0, 0, 1]) || (J.rotation = D.getRotation()), Zn.eq(D.getScale(), [1, 1, 1]) || (J.scale = D.getScale()), D.getWeights().length && (J.weights = D.getWeights()), v.nodeIndexMap.set(D, ee), J;
        }), h.skins = o.listSkins().map((D, ee) => {
          const J = v.createPropertyDef(D), he = D.getInverseBindMatrices();
          he && (J.inverseBindMatrices = v.accessorIndexMap.get(he));
          const fe = D.getSkeleton();
          return fe && (J.skeleton = v.nodeIndexMap.get(fe)), J.joints = D.listJoints().map((X) => v.nodeIndexMap.get(X)), v.skinIndexMap.set(D, ee), J;
        }), o.listNodes().forEach((D, ee) => {
          const J = h.nodes[ee], he = D.getMesh();
          he && (J.mesh = v.meshIndexMap.get(he));
          const fe = D.getCamera();
          fe && (J.camera = v.cameraIndexMap.get(fe));
          const X = D.getSkin();
          X && (J.skin = v.skinIndexMap.get(X)), D.listChildren().length > 0 && (J.children = D.listChildren().map((Z) => v.nodeIndexMap.get(Z)));
        }), h.animations = o.listAnimations().map((D) => {
          const ee = v.createPropertyDef(D), J = /* @__PURE__ */ new Map();
          return ee.samplers = D.listSamplers().map((he, fe) => {
            const X = v.createPropertyDef(he);
            return X.input = v.accessorIndexMap.get(he.getInput()), X.output = v.accessorIndexMap.get(he.getOutput()), X.interpolation = he.getInterpolation(), J.set(he, fe), X;
          }), ee.channels = D.listChannels().map((he) => {
            const fe = v.createPropertyDef(he);
            return fe.sampler = J.get(he.getSampler()), fe.target = { node: v.nodeIndexMap.get(he.getTargetNode()), path: he.getTargetPath() }, fe;
          }), ee;
        }), h.scenes = o.listScenes().map((D) => {
          const ee = v.createPropertyDef(D);
          return ee.nodes = D.listChildren().map((J) => v.nodeIndexMap.get(J)), ee;
        });
        const Q = o.getDefaultScene();
        return Q && (h.scene = o.listScenes().indexOf(Q)), h.extensionsUsed = I.map((D) => D.extensionName), h.extensionsRequired = V.map((D) => D.extensionName), I.forEach((D) => D.write(v)), function(D) {
          const ee = [];
          for (const J in D) {
            const he = D[J];
            (Array.isArray(he) && he.length === 0 || he === null || he === "" || he && typeof he == "object" && Object.keys(he).length === 0) && ee.push(J);
          }
          for (const J of ee)
            delete D[J];
        }(h), f;
      }
    }).write(e, { format: t.format || sa.GLTF, basename: t.basename || "", logger: this._t, vertexLayout: this.Ut, dependencies: es({}, this.Pt), extensions: Array.from(this.gt) });
  }
  Ft(e) {
    const { images: t, buffers: n } = e.json;
    return e = { json: es({}, e.json), resources: es({}, e.resources) }, t && (e.json.images = t.map((a) => es({}, a))), n && (e.json.buffers = n.map((a) => es({}, a))), e;
  }
  binaryToJSON(e) {
    const t = this.Gt(e);
    this.kt(t);
    const n = t.json;
    if (n.buffers && n.buffers.some((a) => function(o, h) {
      return h.uri !== void 0 && !(h.uri in o.resources);
    }(t, a)))
      throw new Error("Cannot resolve external buffers with binaryToJSON().");
    if (n.images && n.images.some((a) => function(o, h) {
      return h.uri !== void 0 && !(h.uri in o.resources) && h.bufferView === void 0;
    }(t, a)))
      throw new Error("Cannot resolve external images with binaryToJSON().");
    return t;
  }
  Gt(e) {
    const t = new Uint32Array(e, 0, 3);
    if (t[0] !== 1179937895)
      throw new Error("Invalid glTF asset.");
    if (t[1] !== 2)
      throw new Error(`Unsupported glTF binary version, "${t[1]}".`);
    const n = new Uint32Array(e, 12, 2);
    if (n[1] !== gl.JSON)
      throw new Error("Missing required GLB JSON chunk.");
    const a = n[0], o = br.decodeText(e.slice(20, 20 + a)), h = JSON.parse(o), f = 20 + a;
    if (e.byteLength <= f)
      return { json: h, resources: {} };
    const v = new Uint32Array(e, f, 2);
    if (v[1] !== gl.BIN)
      throw new Error("Expected GLB BIN in second chunk.");
    return { json: h, resources: { "@glb.bin": e.slice(f + 8, f + 8 + v[0]) } };
  }
  readBinary(e) {
    return this.readJSON(this.binaryToJSON(e));
  }
  writeBinary(e) {
    const { json: t, resources: n } = this.writeJSON(e, { format: sa.GLB }), a = new Uint32Array([1179937895, 2, 12]), o = JSON.stringify(t), h = br.pad(br.encodeText(o), 32), f = new Uint32Array([h.byteLength, 1313821514]).buffer, v = br.concat([f, h]);
    a[a.length - 1] += v.byteLength;
    const x = Object.values(n)[0];
    if (!x || !x.byteLength)
      return br.concat([a.buffer, v]);
    const k = br.pad(x, 0), I = new Uint32Array([k.byteLength, 5130562]).buffer, V = br.concat([I, k]);
    return a[a.length - 1] += V.byteLength, br.concat([a.buffer, v, V]);
  }
}
const Dy = {};
class pf extends Ry {
  constructor(e = Dy) {
    super(), this.qt = void 0, this.qt = e;
  }
  read(e) {
    return this.readAsJSON(e).then((t) => this.readJSON(t));
  }
  readAsJSON(e) {
    return e.match(/^data:application\/octet-stream;/) || new URL(e, window.location.href).pathname.match(/\.glb$/) ? this.Jt(e) : this.zt(e);
  }
  Wt(e, t) {
    const n = [...e.json.images || [], ...e.json.buffers || []].map((a) => {
      const o = a.uri;
      return !o || o.match(/data:/) ? Promise.resolve() : fetch(function(h, f) {
        if (!function(k) {
          return !/^(?:[a-zA-Z]+:)?\//.test(k);
        }(f))
          return f;
        const v = h.split("/"), x = f.split("/");
        v.pop();
        for (let k = 0; k < x.length; k++)
          x[k] !== "." && (x[k] === ".." ? v.pop() : v.push(x[k]));
        return v.join("/");
      }(t, o), this.qt).then((h) => h.arrayBuffer()).then((h) => {
        e.resources[o] = h;
      });
    });
    return Promise.all(n).then(() => {
    });
  }
  zt(e) {
    var t = this;
    const n = { json: {}, resources: {} };
    return fetch(e, this.qt).then((a) => a.json()).then(async function(a) {
      return n.json = a, await t.Wt(n, mf(e)), t.kt(n), n;
    });
  }
  Jt(e) {
    var t = this;
    return fetch(e, this.qt).then((n) => n.arrayBuffer()).then(async function(n) {
      const a = t.Gt(n);
      return await t.Wt(a, mf(e)), t.kt(a), a;
    });
  }
}
function mf(b) {
  const e = b.lastIndexOf("/");
  return e === -1 ? "./" : b.substr(0, e + 1);
}
var zy = Object.defineProperty, Fy = (b, e, t) => e in b ? zy(b, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : b[e] = t, Ko = (b, e, t) => (Fy(b, typeof e != "symbol" ? e + "" : e, t), t), Uy = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Vy(b) {
  return b && b.__esModule && Object.prototype.hasOwnProperty.call(b, "default") ? b.default : b;
}
function Hy(b) {
  if (b.__esModule)
    return b;
  var e = b.default;
  if (typeof e == "function") {
    var t = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(b).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(b, n);
    Object.defineProperty(t, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return b[n];
      }
    });
  }), t;
}
function Yy(b) {
  throw new Error('Could not dynamically require "' + b + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var ad = { exports: {} };
const Gy = {}, jy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Gy
}, Symbol.toStringTag, { value: "Module" })), _f = /* @__PURE__ */ Hy(jy);
/*!
 * Paper.js v0.12.18 - The Swiss Army Knife of Vector Graphics Scripting.
 * http://paperjs.org/
 *
 * Copyright (c) 2011 - 2020, Jürg Lehni & Jonathan Puckey
 * http://juerglehni.com/ & https://puckey.studio/
 *
 * Distributed under the MIT license. See LICENSE file for details.
 *
 * All rights reserved.
 *
 * Date: Wed Jul 17 14:57:24 2024 +0200
 *
 ***
 *
 * Straps.js - Class inheritance library with support for bean-style accessors
 *
 * Copyright (c) 2006 - 2020 Jürg Lehni
 * http://juerglehni.com/
 *
 * Distributed under the MIT license.
 *
 ***
 *
 * Acorn.js
 * https://marijnhaverbeke.nl/acorn/
 *
 * Acorn is a tiny, fast JavaScript parser written in JavaScript,
 * created by Marijn Haverbeke and released under an MIT license.
 *
 */
(function(b) {
  (function(e, t) {
    e = e || _f;
    var n = e.window, a = e.document, o = new function() {
      var i = /^(statics|enumerable|beans|preserve)$/, r = [], s = r.slice, l = Object.create, u = Object.getOwnPropertyDescriptor, d = Object.defineProperty, p = r.forEach || function(A, T) {
        for (var G = 0, O = this.length; G < O; G++)
          A.call(T, this[G], G, this);
      }, m = function(A, T) {
        for (var G in this)
          this.hasOwnProperty(G) && A.call(T, this[G], G, this);
      }, y = Object.assign || function(A) {
        for (var T = 1, G = arguments.length; T < G; T++) {
          var O = arguments[T];
          for (var Y in O)
            O.hasOwnProperty(Y) && (A[Y] = O[Y]);
        }
        return A;
      }, S = function(A, T, G) {
        if (A) {
          var O = u(A, "length");
          (O && typeof O.value == "number" ? p : m).call(A, T, G = G || A);
        }
        return G;
      };
      function L(A, T, G, O, Y) {
        var B = {};
        function z(H, te) {
          te = te || (te = u(T, H)) && (te.get ? te : te.value), typeof te == "string" && te[0] === "#" && (te = A[te.substring(1)] || te);
          var ae = typeof te == "function", le = te, me = Y || ae && !te.base ? te && te.get ? H in A : A[H] : null, se;
          (!Y || !me) && (ae && me && (te.base = me), ae && O !== !1 && (se = H.match(/^([gs]et|is)(([A-Z])(.*))$/)) && (B[se[3].toLowerCase() + se[4]] = se[2]), (!le || ae || !le.get || typeof le.get != "function" || !E.isPlainObject(le)) && (le = { value: le, writable: !0 }), (u(A, H) || { configurable: !0 }).configurable && (le.configurable = !0, le.enumerable = G ?? !se), d(A, H, le));
        }
        if (T) {
          for (var C in T)
            T.hasOwnProperty(C) && !i.test(C) && z(C);
          for (var C in B) {
            var N = B[C], j = A["set" + N], q = A["get" + N] || j && A["is" + N];
            q && (O === !0 || q.length === 0) && z(C, { get: q, set: j });
          }
        }
        return A;
      }
      function E() {
        for (var A = 0, T = arguments.length; A < T; A++) {
          var G = arguments[A];
          G && y(this, G);
        }
        return this;
      }
      return L(E, {
        inject: function(A) {
          if (A) {
            var T = A.statics === !0 ? A : A.statics, G = A.beans, O = A.preserve;
            T !== A && L(this.prototype, A, A.enumerable, G, O), L(this, T, null, G, O);
          }
          for (var Y = 1, B = arguments.length; Y < B; Y++)
            this.inject(arguments[Y]);
          return this;
        },
        extend: function() {
          for (var A = this, T, G, O = 0, Y, B = arguments.length; O < B && !(T && G); O++)
            Y = arguments[O], T = T || Y.initialize, G = G || Y.prototype;
          return T = T || function() {
            A.apply(this, arguments);
          }, G = T.prototype = G || l(this.prototype), d(
            G,
            "constructor",
            { value: T, writable: !0, configurable: !0 }
          ), L(T, this), arguments.length && this.inject.apply(T, arguments), T.base = A, T;
        }
      }).inject({
        enumerable: !1,
        initialize: E,
        set: E,
        inject: function() {
          for (var A = 0, T = arguments.length; A < T; A++) {
            var G = arguments[A];
            G && L(this, G, G.enumerable, G.beans, G.preserve);
          }
          return this;
        },
        extend: function() {
          var A = l(this);
          return A.inject.apply(A, arguments);
        },
        each: function(A, T) {
          return S(this, A, T);
        },
        clone: function() {
          return new this.constructor(this);
        },
        statics: {
          set: y,
          each: S,
          create: l,
          define: d,
          describe: u,
          clone: function(A) {
            return y(new A.constructor(), A);
          },
          isPlainObject: function(A) {
            var T = A != null && A.constructor;
            return T && (T === Object || T === E || T.name === "Object");
          },
          pick: function(A, T) {
            return A !== t ? A : T;
          },
          slice: function(A, T, G) {
            return s.call(A, T, G);
          }
        }
      });
    }();
    b.exports = o, o.inject({
      enumerable: !1,
      toString: function() {
        return this._id != null ? (this._class || "Object") + (this._name ? " '" + this._name + "'" : " @" + this._id) : "{ " + o.each(this, function(i, r) {
          if (!/^_/.test(r)) {
            var s = typeof i;
            this.push(r + ": " + (s === "number" ? k.instance.number(i) : s === "string" ? "'" + i + "'" : i));
          }
        }, []).join(", ") + " }";
      },
      getClassName: function() {
        return this._class || "";
      },
      importJSON: function(i) {
        return o.importJSON(i, this);
      },
      exportJSON: function(i) {
        return o.exportJSON(this, i);
      },
      toJSON: function() {
        return o.serialize(this);
      },
      set: function(i, r) {
        return i && o.filter(this, i, r, this._prioritize), this;
      }
    }, {
      beans: !1,
      statics: {
        exports: {},
        extend: function i() {
          var r = i.base.apply(this, arguments), s = r.prototype._class;
          return s && !o.exports[s] && (o.exports[s] = r), r;
        },
        equals: function(i, r) {
          if (i === r)
            return !0;
          if (i && i.equals)
            return i.equals(r);
          if (r && r.equals)
            return r.equals(i);
          if (i && r && typeof i == "object" && typeof r == "object") {
            if (Array.isArray(i) && Array.isArray(r)) {
              var s = i.length;
              if (s !== r.length)
                return !1;
              for (; s--; )
                if (!o.equals(i[s], r[s]))
                  return !1;
            } else {
              var l = Object.keys(i), s = l.length;
              if (s !== Object.keys(r).length)
                return !1;
              for (; s--; ) {
                var u = l[s];
                if (!(r.hasOwnProperty(u) && o.equals(i[u], r[u])))
                  return !1;
              }
            }
            return !0;
          }
          return !1;
        },
        read: function(i, r, s, l) {
          if (this === o) {
            var u = this.peek(i, r);
            return i.__index++, u;
          }
          var d = this.prototype, p = d._readIndex, m = r || p && i.__index || 0, y = i.length, S = i[m];
          if (l = l || y - m, S instanceof this || s && s.readNull && S == null && l <= 1)
            return p && (i.__index = m + 1), S && s && s.clone ? S.clone() : S;
          if (S = o.create(d), p && (S.__read = !0), S = S.initialize.apply(S, m > 0 || m + l < y ? o.slice(i, m, m + l) : i) || S, p) {
            i.__index = m + S.__read;
            var L = S.__filtered;
            L && (i.__filtered = L, S.__filtered = t), S.__read = t;
          }
          return S;
        },
        peek: function(i, r) {
          return i[i.__index = r || i.__index || 0];
        },
        remain: function(i) {
          return i.length - (i.__index || 0);
        },
        readList: function(i, r, s, l) {
          for (var u = [], d, p = r || 0, m = l ? p + l : i.length, y = p; y < m; y++)
            u.push(Array.isArray(d = i[y]) ? this.read(d, 0, s) : this.read(i, y, s, 1));
          return u;
        },
        readNamed: function(i, r, s, l, u) {
          var d = this.getNamed(i, r), p = d !== t;
          if (p) {
            var m = i.__filtered;
            if (!m) {
              var y = this.getSource(i);
              m = i.__filtered = o.create(y), m.__unfiltered = y;
            }
            m[r] = t;
          }
          return this.read(p ? [d] : i, s, l, u);
        },
        readSupported: function(i, r) {
          var s = this.getSource(i), l = this, u = !1;
          return s && Object.keys(s).forEach(function(d) {
            if (d in r) {
              var p = l.readNamed(i, d);
              p !== t && (r[d] = p), u = !0;
            }
          }), u;
        },
        getSource: function(i) {
          var r = i.__source;
          if (r === t) {
            var s = i.length === 1 && i[0];
            r = i.__source = s && o.isPlainObject(s) ? s : null;
          }
          return r;
        },
        getNamed: function(i, r) {
          var s = this.getSource(i);
          if (s)
            return r ? s[r] : i.__filtered || s;
        },
        hasNamed: function(i, r) {
          return !!this.getNamed(i, r);
        },
        filter: function(i, r, s, l) {
          var u;
          function d(L) {
            if (!(s && L in s) && !(u && L in u)) {
              var E = r[L];
              E !== t && (i[L] = E);
            }
          }
          if (l) {
            for (var p = {}, m = 0, y, S = l.length; m < S; m++)
              (y = l[m]) in r && (d(y), p[y] = !0);
            u = p;
          }
          return Object.keys(r.__unfiltered || r).forEach(d), i;
        },
        isPlainValue: function(i, r) {
          return o.isPlainObject(i) || Array.isArray(i) || r && typeof i == "string";
        },
        serialize: function(i, r, s, l) {
          r = r || {};
          var u = !l, d;
          if (u && (r.formatter = new k(r.precision), l = {
            length: 0,
            definitions: {},
            references: {},
            add: function(E, A) {
              var T = "#" + E._id, G = this.references[T];
              if (!G) {
                this.length++;
                var O = A.call(E), Y = E._class;
                Y && O[0] !== Y && O.unshift(Y), this.definitions[T] = O, G = this.references[T] = [T];
              }
              return G;
            }
          }), i && i._serialize) {
            d = i._serialize(r, l);
            var p = i._class;
            p && !i._compactSerialize && (u || !s) && d[0] !== p && d.unshift(p);
          } else if (Array.isArray(i)) {
            d = [];
            for (var m = 0, y = i.length; m < y; m++)
              d[m] = o.serialize(i[m], r, s, l);
          } else if (o.isPlainObject(i)) {
            d = {};
            for (var S = Object.keys(i), m = 0, y = S.length; m < y; m++) {
              var L = S[m];
              d[L] = o.serialize(
                i[L],
                r,
                s,
                l
              );
            }
          } else
            typeof i == "number" ? d = r.formatter.number(i, r.precision) : d = i;
          return u && l.length > 0 ? [["dictionary", l.definitions], d] : d;
        },
        deserialize: function(i, r, s, l, u) {
          var d = i, p = !s, m = p && i && i.length && i[0][0] === "dictionary";
          if (s = s || {}, Array.isArray(i)) {
            var y = i[0], S = y === "dictionary";
            if (i.length == 1 && /^#/.test(y))
              return s.dictionary[y];
            y = o.exports[y], d = [];
            for (var L = y ? 1 : 0, E = i.length; L < E; L++)
              d.push(o.deserialize(
                i[L],
                r,
                s,
                S,
                m
              ));
            if (y) {
              var A = d;
              r ? d = r(y, A, p || u) : d = new y(A);
            }
          } else if (o.isPlainObject(i)) {
            d = {}, l && (s.dictionary = d);
            for (var T in i)
              d[T] = o.deserialize(i[T], r, s);
          }
          return m ? d[1] : d;
        },
        exportJSON: function(i, r) {
          var s = o.serialize(i, r);
          return r && r.asString == !1 ? s : JSON.stringify(s);
        },
        importJSON: function(i, r) {
          return o.deserialize(
            typeof i == "string" ? JSON.parse(i) : i,
            function(s, l, u) {
              var d = u && r && r.constructor === s, p = d ? r : o.create(s.prototype);
              if (l.length === 1 && p instanceof X && (d || !(p instanceof qe))) {
                var m = l[0];
                o.isPlainObject(m) && (m.insert = !1, d && (l = l.concat([X.INSERT])));
              }
              return (d ? p.set : s).apply(p, l), d && (r = null), p;
            }
          );
        },
        push: function(i, r) {
          var s = r.length;
          if (s < 4096)
            i.push.apply(i, r);
          else {
            var l = i.length;
            i.length += s;
            for (var u = 0; u < s; u++)
              i[l + u] = r[u];
          }
          return i;
        },
        splice: function(i, r, s, l) {
          var u = r && r.length, d = s === t;
          s = d ? i.length : s, s > i.length && (s = i.length);
          for (var p = 0; p < u; p++)
            r[p]._index = s + p;
          if (d)
            return o.push(i, r), [];
          var m = [s, l];
          r && o.push(m, r);
          for (var y = i.splice.apply(i, m), p = 0, S = y.length; p < S; p++)
            y[p]._index = t;
          for (var p = s + u, S = i.length; p < S; p++)
            i[p]._index = p;
          return y;
        },
        capitalize: function(i) {
          return i.replace(/\b[a-z]/g, function(r) {
            return r.toUpperCase();
          });
        },
        camelize: function(i) {
          return i.replace(/-(.)/g, function(r, s) {
            return s.toUpperCase();
          });
        },
        hyphenate: function(i) {
          return i.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        }
      }
    });
    var h = {
      on: function(i, r) {
        if (typeof i != "string")
          o.each(i, function(d, p) {
            this.on(p, d);
          }, this);
        else {
          var s = this._eventTypes, l = s && s[i], u = this._callbacks = this._callbacks || {};
          u = u[i] = u[i] || [], u.indexOf(r) === -1 && (u.push(r), l && l.install && u.length === 1 && l.install.call(this, i));
        }
        return this;
      },
      off: function(i, r) {
        if (typeof i != "string") {
          o.each(i, function(p, m) {
            this.off(m, p);
          }, this);
          return;
        }
        var s = this._eventTypes, l = s && s[i], u = this._callbacks && this._callbacks[i], d;
        return u && (!r || (d = u.indexOf(r)) !== -1 && u.length === 1 ? (l && l.uninstall && l.uninstall.call(this, i), delete this._callbacks[i]) : d !== -1 && u.splice(d, 1)), this;
      },
      once: function(i, r) {
        return this.on(i, function s() {
          r.apply(this, arguments), this.off(i, s);
        });
      },
      emit: function(i, r) {
        var s = this._callbacks && this._callbacks[i];
        if (!s)
          return !1;
        var l = o.slice(arguments, 1), u = r && r.target && !r.currentTarget;
        s = s.slice(), u && (r.currentTarget = this);
        for (var d = 0, p = s.length; d < p; d++)
          if (s[d].apply(this, l) == !1) {
            r && r.stop && r.stop();
            break;
          }
        return u && delete r.currentTarget, !0;
      },
      responds: function(i) {
        return !!(this._callbacks && this._callbacks[i]);
      },
      attach: "#on",
      detach: "#off",
      fire: "#emit",
      _installEvents: function(i) {
        var r = this._eventTypes, s = this._callbacks, l = i ? "install" : "uninstall";
        if (r) {
          for (var u in s)
            if (s[u].length > 0) {
              var d = r[u], p = d && d[l];
              p && p.call(this, u);
            }
        }
      },
      statics: {
        inject: function i(r) {
          var s = r._events;
          if (s) {
            var l = {};
            o.each(s, function(u, d) {
              var p = typeof u == "string", m = p ? u : d, y = o.capitalize(m), S = m.substring(2).toLowerCase();
              l[S] = p ? {} : u, m = "_" + m, r["get" + y] = function() {
                return this[m];
              }, r["set" + y] = function(L) {
                var E = this[m];
                E && this.off(S, E), L && this.on(S, L), this[m] = L;
              };
            }), r._eventTypes = l;
          }
          return i.base.apply(this, arguments);
        }
      }
    }, f = o.extend({
      _class: "PaperScope",
      initialize: function i() {
        Ve = this, this.settings = new o({
          applyMatrix: !0,
          insertItems: !0,
          handleSize: 4,
          hitTolerance: 0
        }), this.project = null, this.projects = [], this.tools = [], this._id = i._id++, i._scopes[this._id] = this;
        var r = i.prototype;
        if (!this.support) {
          var s = ft.getContext(1, 1) || {};
          r.support = {
            nativeDash: "setLineDash" in s || "mozDash" in s,
            nativeBlendModes: tt.nativeModes
          }, ft.release(s);
        }
        if (!this.agent) {
          var l = e.navigator.userAgent.toLowerCase(), u = (/(darwin|win|mac|linux|freebsd|sunos)/.exec(l) || [])[0], d = u === "darwin" ? "mac" : u, p = r.agent = r.browser = { platform: d };
          d && (p[d] = !0), l.replace(
            /(opera|chrome|safari|webkit|firefox|msie|trident|atom|node|jsdom)\/?\s*([.\d]+)(?:.*version\/([.\d]+))?(?:.*rv\:v?([.\d]+))?/g,
            function(m, y, S, L, E) {
              if (!p.chrome) {
                var A = y === "opera" ? L : /^(node|trident)$/.test(y) ? E : S;
                p.version = A, p.versionNumber = parseFloat(A), y = { trident: "msie", jsdom: "node" }[y] || y, p.name = y, p[y] = !0;
              }
            }
          ), p.chrome && delete p.webkit, p.atom && delete p.chrome;
        }
      },
      version: "0.12.18",
      getView: function() {
        var i = this.project;
        return i && i._view;
      },
      getPaper: function() {
        return this;
      },
      execute: function(i, r) {
        var s = Ve.PaperScript.execute(i, this, r);
        return Qt.updateFocus(), s;
      },
      install: function(i) {
        var r = this;
        o.each(["project", "view", "tool"], function(l) {
          o.define(i, l, {
            configurable: !0,
            get: function() {
              return r[l];
            }
          });
        });
        for (var s in this)
          !/^_/.test(s) && this[s] && (i[s] = this[s]);
      },
      setup: function(i) {
        return Ve = this, this.project = new fe(i), this;
      },
      createCanvas: function(i, r) {
        return ft.getCanvas(i, r);
      },
      activate: function() {
        Ve = this;
      },
      clear: function() {
        for (var i = this.projects, r = this.tools, s = i.length - 1; s >= 0; s--)
          i[s].remove();
        for (var s = r.length - 1; s >= 0; s--)
          r[s].remove();
      },
      remove: function() {
        this.clear(), delete f._scopes[this._id];
      },
      statics: new function() {
        function i(r) {
          return r += "Attribute", function(s, l) {
            return s[r](l) || s[r]("data-paper-" + l);
          };
        }
        return {
          _scopes: {},
          _id: 0,
          get: function(r) {
            return this._scopes[r] || null;
          },
          getAttribute: i("get"),
          hasAttribute: i("has")
        };
      }()
    }), v = o.extend(h, {
      initialize: function(i) {
        this._scope = Ve, this._index = this._scope[this._list].push(this) - 1, (i || !this._scope[this._reference]) && this.activate();
      },
      activate: function() {
        if (!this._scope)
          return !1;
        var i = this._scope[this._reference];
        return i && i !== this && i.emit("deactivate"), this._scope[this._reference] = this, this.emit("activate", i), !0;
      },
      isActive: function() {
        return this._scope[this._reference] === this;
      },
      remove: function() {
        return this._index == null ? !1 : (o.splice(this._scope[this._list], null, this._index, 1), this._scope[this._reference] == this && (this._scope[this._reference] = null), this._scope = null, !0);
      },
      getView: function() {
        return this._scope.getView();
      }
    }), x = {
      findItemBoundsCollisions: function(i, r, s) {
        function l(p) {
          for (var m = new Array(p.length), y = 0; y < p.length; y++) {
            var S = p[y].getBounds();
            m[y] = [S.left, S.top, S.right, S.bottom];
          }
          return m;
        }
        var u = l(i), d = !r || r === i ? u : l(r);
        return this.findBoundsCollisions(u, d, s || 0);
      },
      findCurveBoundsCollisions: function(i, r, s, l) {
        function u(A) {
          for (var T = Math.min, G = Math.max, O = new Array(A.length), Y = 0; Y < A.length; Y++) {
            var B = A[Y];
            O[Y] = [
              T(B[0], B[2], B[4], B[6]),
              T(B[1], B[3], B[5], B[7]),
              G(B[0], B[2], B[4], B[6]),
              G(B[1], B[3], B[5], B[7])
            ];
          }
          return O;
        }
        var d = u(i), p = !r || r === i ? d : u(r);
        if (l) {
          for (var m = this.findBoundsCollisions(
            d,
            p,
            s || 0,
            !1,
            !0
          ), y = this.findBoundsCollisions(
            d,
            p,
            s || 0,
            !0,
            !0
          ), S = [], L = 0, E = m.length; L < E; L++)
            S[L] = { hor: m[L], ver: y[L] };
          return S;
        }
        return this.findBoundsCollisions(d, p, s || 0);
      },
      findBoundsCollisions: function(i, r, s, l, u) {
        var d = !r || i === r, p = d ? i : i.concat(r), m = i.length, y = p.length;
        function S(Qe, st, mt) {
          for (var Re = 0, Fe = Qe.length; Re < Fe; ) {
            var at = Fe + Re >>> 1;
            p[Qe[at]][st] < mt ? Re = at + 1 : Fe = at;
          }
          return Re - 1;
        }
        for (var L = l ? 1 : 0, E = L + 2, A = l ? 0 : 1, T = A + 2, G = new Array(y), O = 0; O < y; O++)
          G[O] = O;
        G.sort(function(Qe, st) {
          return p[Qe][L] - p[st][L];
        });
        for (var Y = [], B = new Array(m), O = 0; O < y; O++) {
          var z = G[O], C = p[z], N = d ? z : z - m, j = z < m, q = d || !j, H = j ? [] : null;
          if (Y.length) {
            var te = S(
              Y,
              E,
              C[L] - s
            ) + 1;
            if (Y.splice(0, te), d && u) {
              H = H.concat(Y);
              for (var ae = 0; ae < Y.length; ae++) {
                var le = Y[ae];
                B[le].push(N);
              }
            } else
              for (var me = C[T], se = C[A], ae = 0; ae < Y.length; ae++) {
                var le = Y[ae], de = p[le], ve = le < m, we = d || le >= m;
                (u || (j && we || q && ve) && me >= de[A] - s && se <= de[T] + s) && (j && we && H.push(
                  d ? le : le - m
                ), q && ve && B[le].push(N));
              }
          }
          if (j && (i === r && H.push(z), B[z] = H), Y.length) {
            var Se = C[E], Ae = S(Y, E, Se);
            Y.splice(Ae + 1, 0, z);
          } else
            Y.push(z);
        }
        for (var O = 0; O < B.length; O++) {
          var Ge = B[O];
          Ge && Ge.sort(function(st, mt) {
            return st - mt;
          });
        }
        return B;
      }
    }, k = o.extend({
      initialize: function(i) {
        this.precision = o.pick(i, 5), this.multiplier = Math.pow(10, this.precision);
      },
      number: function(i) {
        return this.precision < 16 ? Math.round(i * this.multiplier) / this.multiplier : i;
      },
      pair: function(i, r, s) {
        return this.number(i) + (s || ",") + this.number(r);
      },
      point: function(i, r) {
        return this.number(i.x) + (r || ",") + this.number(i.y);
      },
      size: function(i, r) {
        return this.number(i.width) + (r || ",") + this.number(i.height);
      },
      rectangle: function(i, r) {
        return this.point(i, r) + (r || ",") + this.size(i, r);
      }
    });
    k.instance = new k();
    var I = new function() {
      var i = [
        [0.5773502691896257],
        [0, 0.7745966692414834],
        [0.33998104358485626, 0.8611363115940526],
        [0, 0.5384693101056831, 0.906179845938664],
        [0.2386191860831969, 0.6612093864662645, 0.932469514203152],
        [0, 0.4058451513773972, 0.7415311855993945, 0.9491079123427585],
        [0.1834346424956498, 0.525532409916329, 0.7966664774136267, 0.9602898564975363],
        [0, 0.3242534234038089, 0.6133714327005904, 0.8360311073266358, 0.9681602395076261],
        [0.14887433898163122, 0.4333953941292472, 0.6794095682990244, 0.8650633666889845, 0.9739065285171717],
        [0, 0.26954315595234496, 0.5190961292068118, 0.7301520055740494, 0.8870625997680953, 0.978228658146057],
        [0.1252334085114689, 0.3678314989981802, 0.5873179542866175, 0.7699026741943047, 0.9041172563704749, 0.9815606342467192],
        [0, 0.2304583159551348, 0.44849275103644687, 0.6423493394403402, 0.8015780907333099, 0.9175983992229779, 0.9841830547185881],
        [0.10805494870734367, 0.31911236892788974, 0.5152486363581541, 0.6872929048116855, 0.827201315069765, 0.9284348836635735, 0.9862838086968123],
        [0, 0.20119409399743451, 0.3941513470775634, 0.5709721726085388, 0.7244177313601701, 0.8482065834104272, 0.937273392400706, 0.9879925180204854],
        [0.09501250983763744, 0.2816035507792589, 0.45801677765722737, 0.6178762444026438, 0.755404408355003, 0.8656312023878318, 0.9445750230732326, 0.9894009349916499]
      ], r = [
        [1],
        [0.8888888888888888, 0.5555555555555556],
        [0.6521451548625461, 0.34785484513745385],
        [0.5688888888888889, 0.47862867049936647, 0.23692688505618908],
        [0.46791393457269104, 0.3607615730481386, 0.17132449237917036],
        [0.4179591836734694, 0.3818300505051189, 0.27970539148927664, 0.1294849661688697],
        [0.362683783378362, 0.31370664587788727, 0.22238103445337448, 0.10122853629037626],
        [0.3302393550012598, 0.31234707704000286, 0.26061069640293544, 0.1806481606948574, 0.08127438836157441],
        [0.29552422471475287, 0.26926671930999635, 0.21908636251598204, 0.1494513491505806, 0.06667134430868814],
        [0.2729250867779006, 0.26280454451024665, 0.23319376459199048, 0.18629021092773426, 0.1255803694649046, 0.05566856711617366],
        [0.24914704581340277, 0.2334925365383548, 0.20316742672306592, 0.16007832854334622, 0.10693932599531843, 0.04717533638651183],
        [0.2325515532308739, 0.22628318026289723, 0.2078160475368885, 0.17814598076194574, 0.13887351021978725, 0.09212149983772845, 0.04048400476531588],
        [0.2152638534631578, 0.2051984637212956, 0.18553839747793782, 0.15720316715819355, 0.12151857068790319, 0.08015808715976021, 0.03511946033175186],
        [0.2025782419255613, 0.19843148532711158, 0.1861610000155622, 0.16626920581699392, 0.13957067792615432, 0.10715922046717194, 0.07036604748810812, 0.03075324199611727],
        [0.1894506104550685, 0.18260341504492358, 0.16915651939500254, 0.14959598881657674, 0.12462897125553388, 0.09515851168249279, 0.062253523938647894, 0.027152459411754096]
      ], s = Math.abs, l = Math.sqrt, u = Math.pow, d = Math.log2 || function(E) {
        return Math.log(E) * Math.LOG2E;
      }, p = 1e-12, m = 112e-18;
      function y(E, A, T) {
        return E < A ? A : E > T ? T : E;
      }
      function S(E, A, T) {
        function G(te) {
          var ae = te * 134217729, le = te - ae, me = le + ae, se = te - me;
          return [me, se];
        }
        var O = A * A - E * T, Y = A * A + E * T;
        if (s(O) * 3 < Y) {
          var B = G(E), z = G(A), C = G(T), N = A * A, j = z[0] * z[0] - N + 2 * z[0] * z[1] + z[1] * z[1], q = E * T, H = B[0] * C[0] - q + B[0] * C[1] + B[1] * C[0] + B[1] * C[1];
          O = N - q + (j - H);
        }
        return O;
      }
      function L() {
        var E = Math.max.apply(Math, arguments);
        return E && (E < 1e-8 || E > 1e8) ? u(2, -Math.round(d(E))) : 0;
      }
      return {
        EPSILON: p,
        MACHINE_EPSILON: m,
        CURVETIME_EPSILON: 1e-8,
        GEOMETRIC_EPSILON: 1e-7,
        TRIGONOMETRIC_EPSILON: 1e-8,
        ANGULAR_EPSILON: 1e-5,
        KAPPA: 4 * (l(2) - 1) / 3,
        isZero: function(E) {
          return E >= -p && E <= p;
        },
        isMachineZero: function(E) {
          return E >= -m && E <= m;
        },
        clamp: y,
        integrate: function(E, A, T, G) {
          for (var O = i[G - 2], Y = r[G - 2], B = (T - A) * 0.5, z = B + A, C = 0, N = G + 1 >> 1, j = G & 1 ? Y[C++] * E(z) : 0; C < N; ) {
            var q = B * O[C];
            j += Y[C++] * (E(z + q) + E(z - q));
          }
          return B * j;
        },
        findRoot: function(E, A, T, G, O, Y, B) {
          for (var z = 0; z < Y; z++) {
            var C = E(T), N = C / A(T), j = T - N;
            if (s(N) < B) {
              T = j;
              break;
            }
            C > 0 ? (O = T, T = j <= G ? (G + O) * 0.5 : j) : (G = T, T = j >= O ? (G + O) * 0.5 : j);
          }
          return y(T, G, O);
        },
        solveQuadratic: function(E, A, T, G, O, Y) {
          var B, z = 1 / 0;
          if (s(E) < p) {
            if (s(A) < p)
              return s(T) < p ? -1 : 0;
            B = -T / A;
          } else {
            A *= -0.5;
            var C = S(E, A, T);
            if (C && s(C) < m) {
              var N = L(s(E), s(A), s(T));
              N && (E *= N, A *= N, T *= N, C = S(E, A, T));
            }
            if (C >= -m) {
              var j = C < 0 ? 0 : l(C), q = A + (A < 0 ? -j : j);
              q === 0 ? (B = T / E, z = -B) : (B = q / E, z = T / q);
            }
          }
          var H = 0, te = O == null, ae = O - p, le = Y + p;
          return isFinite(B) && (te || B > ae && B < le) && (G[H++] = te ? B : y(B, O, Y)), z !== B && isFinite(z) && (te || z > ae && z < le) && (G[H++] = te ? z : y(z, O, Y)), H;
        },
        solveCubic: function(E, A, T, G, O, Y, B) {
          var z = L(s(E), s(A), s(T), s(G)), C, N, j, q, H;
          z && (E *= z, A *= z, T *= z, G *= z);
          function te(Ae) {
            C = Ae;
            var Ge = E * C;
            N = Ge + A, j = N * C + T, q = (Ge + N) * C + j, H = j * C + G;
          }
          if (s(E) < p)
            E = A, N = T, j = G, C = 1 / 0;
          else if (s(G) < p)
            N = A, j = T, C = 0;
          else {
            te(-(A / E) / 3);
            var ae = H / E, le = u(s(ae), 1 / 3), me = ae < 0 ? -1 : 1, se = -q / E, de = se > 0 ? 1.324717957244746 * Math.max(le, l(se)) : le, ve = C - me * de;
            if (ve !== C) {
              do
                te(ve), ve = q === 0 ? C : C - H / q / (1 + m);
              while (me * ve > me * C);
              s(E) * C * C > s(G / C) && (j = -G / C, N = (j - T) / C);
            }
          }
          var we = I.solveQuadratic(E, N, j, O, Y, B), Se = Y == null;
          return isFinite(C) && (we === 0 || we > 0 && C !== O[0] && C !== O[1]) && (Se || C > Y - p && C < B + p) && (O[we++] = Se ? C : y(C, Y, B)), we;
        }
      };
    }(), V = {
      _id: 1,
      _pools: {},
      get: function(i) {
        if (i) {
          var r = this._pools[i];
          return r || (r = this._pools[i] = { _id: 1 }), r._id++;
        } else
          return this._id++;
      }
    }, M = o.extend({
      _class: "Point",
      _readIndex: !0,
      initialize: function(i, r) {
        var s = typeof i, l = this.__read, u = 0;
        if (s === "number") {
          var d = typeof r == "number";
          this._set(i, d ? r : i), l && (u = d ? 2 : 1);
        } else if (s === "undefined" || i === null)
          this._set(0, 0), l && (u = i === null ? 1 : 0);
        else {
          var p = s === "string" ? i.split(/[\s,]+/) || [] : i;
          u = 1, Array.isArray(p) ? this._set(+p[0], +(p.length > 1 ? p[1] : p[0])) : "x" in p ? this._set(p.x || 0, p.y || 0) : "width" in p ? this._set(p.width || 0, p.height || 0) : "angle" in p ? (this._set(p.length || 0, 0), this.setAngle(p.angle || 0)) : (this._set(0, 0), u = 0);
        }
        return l && (this.__read = u), this;
      },
      set: "#initialize",
      _set: function(i, r) {
        return this.x = i, this.y = r, this;
      },
      equals: function(i) {
        return this === i || i && (this.x === i.x && this.y === i.y || Array.isArray(i) && this.x === i[0] && this.y === i[1]) || !1;
      },
      clone: function() {
        return new M(this.x, this.y);
      },
      toString: function() {
        var i = k.instance;
        return "{ x: " + i.number(this.x) + ", y: " + i.number(this.y) + " }";
      },
      _serialize: function(i) {
        var r = i.formatter;
        return [r.number(this.x), r.number(this.y)];
      },
      getLength: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
      },
      setLength: function(i) {
        if (this.isZero()) {
          var r = this._angle || 0;
          this._set(
            Math.cos(r) * i,
            Math.sin(r) * i
          );
        } else {
          var s = i / this.getLength();
          I.isZero(s) && this.getAngle(), this._set(
            this.x * s,
            this.y * s
          );
        }
      },
      getAngle: function() {
        return this.getAngleInRadians.apply(this, arguments) * 180 / Math.PI;
      },
      setAngle: function(i) {
        this.setAngleInRadians.call(this, i * Math.PI / 180);
      },
      getAngleInDegrees: "#getAngle",
      setAngleInDegrees: "#setAngle",
      getAngleInRadians: function() {
        if (arguments.length) {
          var i = M.read(arguments), r = this.getLength() * i.getLength();
          if (I.isZero(r))
            return NaN;
          var s = this.dot(i) / r;
          return Math.acos(s < -1 ? -1 : s > 1 ? 1 : s);
        } else
          return this.isZero() ? this._angle || 0 : this._angle = Math.atan2(this.y, this.x);
      },
      setAngleInRadians: function(i) {
        if (this._angle = i, !this.isZero()) {
          var r = this.getLength();
          this._set(
            Math.cos(i) * r,
            Math.sin(i) * r
          );
        }
      },
      getQuadrant: function() {
        return this.x >= 0 ? this.y >= 0 ? 1 : 4 : this.y >= 0 ? 2 : 3;
      }
    }, {
      beans: !1,
      getDirectedAngle: function() {
        var i = M.read(arguments);
        return Math.atan2(this.cross(i), this.dot(i)) * 180 / Math.PI;
      },
      getDistance: function() {
        var i = arguments, r = M.read(i), s = r.x - this.x, l = r.y - this.y, u = s * s + l * l, d = o.read(i);
        return d ? u : Math.sqrt(u);
      },
      normalize: function(i) {
        i === t && (i = 1);
        var r = this.getLength(), s = r !== 0 ? i / r : 0, l = new M(this.x * s, this.y * s);
        return s >= 0 && (l._angle = this._angle), l;
      },
      rotate: function(i, r) {
        if (i === 0)
          return this.clone();
        i = i * Math.PI / 180;
        var s = r ? this.subtract(r) : this, l = Math.sin(i), u = Math.cos(i);
        return s = new M(
          s.x * u - s.y * l,
          s.x * l + s.y * u
        ), r ? s.add(r) : s;
      },
      transform: function(i) {
        return i ? i._transformPoint(this) : this;
      },
      add: function() {
        var i = M.read(arguments);
        return new M(this.x + i.x, this.y + i.y);
      },
      subtract: function() {
        var i = M.read(arguments);
        return new M(this.x - i.x, this.y - i.y);
      },
      multiply: function() {
        var i = M.read(arguments);
        return new M(this.x * i.x, this.y * i.y);
      },
      divide: function() {
        var i = M.read(arguments);
        return new M(this.x / i.x, this.y / i.y);
      },
      modulo: function() {
        var i = M.read(arguments);
        return new M(this.x % i.x, this.y % i.y);
      },
      negate: function() {
        return new M(-this.x, -this.y);
      },
      isInside: function() {
        return D.read(arguments).contains(this);
      },
      isClose: function() {
        var i = arguments, r = M.read(i), s = o.read(i);
        return this.getDistance(r) <= s;
      },
      isCollinear: function() {
        var i = M.read(arguments);
        return M.isCollinear(this.x, this.y, i.x, i.y);
      },
      isColinear: "#isCollinear",
      isOrthogonal: function() {
        var i = M.read(arguments);
        return M.isOrthogonal(this.x, this.y, i.x, i.y);
      },
      isZero: function() {
        var i = I.isZero;
        return i(this.x) && i(this.y);
      },
      isNaN: function() {
        return isNaN(this.x) || isNaN(this.y);
      },
      isInQuadrant: function(i) {
        return this.x * (i > 1 && i < 4 ? -1 : 1) >= 0 && this.y * (i > 2 ? -1 : 1) >= 0;
      },
      dot: function() {
        var i = M.read(arguments);
        return this.x * i.x + this.y * i.y;
      },
      cross: function() {
        var i = M.read(arguments);
        return this.x * i.y - this.y * i.x;
      },
      project: function() {
        var i = M.read(arguments), r = i.isZero() ? 0 : this.dot(i) / i.dot(i);
        return new M(
          i.x * r,
          i.y * r
        );
      },
      statics: {
        min: function() {
          var i = arguments, r = M.read(i), s = M.read(i);
          return new M(
            Math.min(r.x, s.x),
            Math.min(r.y, s.y)
          );
        },
        max: function() {
          var i = arguments, r = M.read(i), s = M.read(i);
          return new M(
            Math.max(r.x, s.x),
            Math.max(r.y, s.y)
          );
        },
        random: function() {
          return new M(Math.random(), Math.random());
        },
        isCollinear: function(i, r, s, l) {
          return Math.abs(i * l - r * s) <= Math.sqrt((i * i + r * r) * (s * s + l * l)) * 1e-8;
        },
        isOrthogonal: function(i, r, s, l) {
          return Math.abs(i * s + r * l) <= Math.sqrt((i * i + r * r) * (s * s + l * l)) * 1e-8;
        }
      }
    }, o.each(["round", "ceil", "floor", "abs"], function(i) {
      var r = Math[i];
      this[i] = function() {
        return new M(r(this.x), r(this.y));
      };
    }, {})), W = M.extend({
      initialize: function(i, r, s, l) {
        this._x = i, this._y = r, this._owner = s, this._setter = l;
      },
      _set: function(i, r, s) {
        return this._x = i, this._y = r, s || this._owner[this._setter](this), this;
      },
      getX: function() {
        return this._x;
      },
      setX: function(i) {
        this._x = i, this._owner[this._setter](this);
      },
      getY: function() {
        return this._y;
      },
      setY: function(i) {
        this._y = i, this._owner[this._setter](this);
      },
      isSelected: function() {
        return !!(this._owner._selection & this._getSelection());
      },
      setSelected: function(i) {
        this._owner._changeSelection(this._getSelection(), i);
      },
      _getSelection: function() {
        return this._setter === "setPosition" ? 4 : 0;
      }
    }), U = o.extend({
      _class: "Size",
      _readIndex: !0,
      initialize: function(i, r) {
        var s = typeof i, l = this.__read, u = 0;
        if (s === "number") {
          var d = typeof r == "number";
          this._set(i, d ? r : i), l && (u = d ? 2 : 1);
        } else if (s === "undefined" || i === null)
          this._set(0, 0), l && (u = i === null ? 1 : 0);
        else {
          var p = s === "string" ? i.split(/[\s,]+/) || [] : i;
          u = 1, Array.isArray(p) ? this._set(+p[0], +(p.length > 1 ? p[1] : p[0])) : "width" in p ? this._set(p.width || 0, p.height || 0) : "x" in p ? this._set(p.x || 0, p.y || 0) : (this._set(0, 0), u = 0);
        }
        return l && (this.__read = u), this;
      },
      set: "#initialize",
      _set: function(i, r) {
        return this.width = i, this.height = r, this;
      },
      equals: function(i) {
        return i === this || i && (this.width === i.width && this.height === i.height || Array.isArray(i) && this.width === i[0] && this.height === i[1]) || !1;
      },
      clone: function() {
        return new U(this.width, this.height);
      },
      toString: function() {
        var i = k.instance;
        return "{ width: " + i.number(this.width) + ", height: " + i.number(this.height) + " }";
      },
      _serialize: function(i) {
        var r = i.formatter;
        return [
          r.number(this.width),
          r.number(this.height)
        ];
      },
      add: function() {
        var i = U.read(arguments);
        return new U(this.width + i.width, this.height + i.height);
      },
      subtract: function() {
        var i = U.read(arguments);
        return new U(this.width - i.width, this.height - i.height);
      },
      multiply: function() {
        var i = U.read(arguments);
        return new U(this.width * i.width, this.height * i.height);
      },
      divide: function() {
        var i = U.read(arguments);
        return new U(this.width / i.width, this.height / i.height);
      },
      modulo: function() {
        var i = U.read(arguments);
        return new U(this.width % i.width, this.height % i.height);
      },
      negate: function() {
        return new U(-this.width, -this.height);
      },
      isZero: function() {
        var i = I.isZero;
        return i(this.width) && i(this.height);
      },
      isNaN: function() {
        return isNaN(this.width) || isNaN(this.height);
      },
      statics: {
        min: function(i, r) {
          return new U(
            Math.min(i.width, r.width),
            Math.min(i.height, r.height)
          );
        },
        max: function(i, r) {
          return new U(
            Math.max(i.width, r.width),
            Math.max(i.height, r.height)
          );
        },
        random: function() {
          return new U(Math.random(), Math.random());
        }
      }
    }, o.each(["round", "ceil", "floor", "abs"], function(i) {
      var r = Math[i];
      this[i] = function() {
        return new U(r(this.width), r(this.height));
      };
    }, {})), Q = U.extend({
      initialize: function(i, r, s, l) {
        this._width = i, this._height = r, this._owner = s, this._setter = l;
      },
      _set: function(i, r, s) {
        return this._width = i, this._height = r, s || this._owner[this._setter](this), this;
      },
      getWidth: function() {
        return this._width;
      },
      setWidth: function(i) {
        this._width = i, this._owner[this._setter](this);
      },
      getHeight: function() {
        return this._height;
      },
      setHeight: function(i) {
        this._height = i, this._owner[this._setter](this);
      }
    }), D = o.extend({
      _class: "Rectangle",
      _readIndex: !0,
      beans: !0,
      initialize: function(i, r, s, l) {
        var u = arguments, d = typeof i, p;
        if (d === "number" ? (this._set(i, r, s, l), p = 4) : d === "undefined" || i === null ? (this._set(0, 0, 0, 0), p = i === null ? 1 : 0) : u.length === 1 && (Array.isArray(i) ? (this._set.apply(this, i), p = 1) : i.x !== t || i.width !== t ? (this._set(
          i.x || 0,
          i.y || 0,
          i.width || 0,
          i.height || 0
        ), p = 1) : i.from === t && i.to === t && (this._set(0, 0, 0, 0), o.readSupported(u, this) && (p = 1))), p === t) {
          var m = M.readNamed(u, "from"), y = o.peek(u), S = m.x, L = m.y, E, A;
          if (y && y.x !== t || o.hasNamed(u, "to")) {
            var T = M.readNamed(u, "to");
            E = T.x - S, A = T.y - L, E < 0 && (S = T.x, E = -E), A < 0 && (L = T.y, A = -A);
          } else {
            var G = U.read(u);
            E = G.width, A = G.height;
          }
          this._set(S, L, E, A), p = u.__index;
        }
        var O = u.__filtered;
        return O && (this.__filtered = O), this.__read && (this.__read = p), this;
      },
      set: "#initialize",
      _set: function(i, r, s, l) {
        return this.x = i, this.y = r, this.width = s, this.height = l, this;
      },
      clone: function() {
        return new D(this.x, this.y, this.width, this.height);
      },
      equals: function(i) {
        var r = o.isPlainValue(i) ? D.read(arguments) : i;
        return r === this || r && this.x === r.x && this.y === r.y && this.width === r.width && this.height === r.height || !1;
      },
      toString: function() {
        var i = k.instance;
        return "{ x: " + i.number(this.x) + ", y: " + i.number(this.y) + ", width: " + i.number(this.width) + ", height: " + i.number(this.height) + " }";
      },
      _serialize: function(i) {
        var r = i.formatter;
        return [
          r.number(this.x),
          r.number(this.y),
          r.number(this.width),
          r.number(this.height)
        ];
      },
      getPoint: function(i) {
        var r = i ? M : W;
        return new r(this.x, this.y, this, "setPoint");
      },
      setPoint: function() {
        var i = M.read(arguments);
        this.x = i.x, this.y = i.y;
      },
      getSize: function(i) {
        var r = i ? U : Q;
        return new r(this.width, this.height, this, "setSize");
      },
      _fw: 1,
      _fh: 1,
      setSize: function() {
        var i = U.read(arguments), r = this._sx, s = this._sy, l = i.width, u = i.height;
        r && (this.x += (this.width - l) * r), s && (this.y += (this.height - u) * s), this.width = l, this.height = u, this._fw = this._fh = 1;
      },
      getLeft: function() {
        return this.x;
      },
      setLeft: function(i) {
        if (!this._fw) {
          var r = i - this.x;
          this.width -= this._sx === 0.5 ? r * 2 : r;
        }
        this.x = i, this._sx = this._fw = 0;
      },
      getTop: function() {
        return this.y;
      },
      setTop: function(i) {
        if (!this._fh) {
          var r = i - this.y;
          this.height -= this._sy === 0.5 ? r * 2 : r;
        }
        this.y = i, this._sy = this._fh = 0;
      },
      getRight: function() {
        return this.x + this.width;
      },
      setRight: function(i) {
        if (!this._fw) {
          var r = i - this.x;
          this.width = this._sx === 0.5 ? r * 2 : r;
        }
        this.x = i - this.width, this._sx = 1, this._fw = 0;
      },
      getBottom: function() {
        return this.y + this.height;
      },
      setBottom: function(i) {
        if (!this._fh) {
          var r = i - this.y;
          this.height = this._sy === 0.5 ? r * 2 : r;
        }
        this.y = i - this.height, this._sy = 1, this._fh = 0;
      },
      getCenterX: function() {
        return this.x + this.width / 2;
      },
      setCenterX: function(i) {
        this._fw || this._sx === 0.5 ? this.x = i - this.width / 2 : (this._sx && (this.x += (i - this.x) * 2 * this._sx), this.width = (i - this.x) * 2), this._sx = 0.5, this._fw = 0;
      },
      getCenterY: function() {
        return this.y + this.height / 2;
      },
      setCenterY: function(i) {
        this._fh || this._sy === 0.5 ? this.y = i - this.height / 2 : (this._sy && (this.y += (i - this.y) * 2 * this._sy), this.height = (i - this.y) * 2), this._sy = 0.5, this._fh = 0;
      },
      getCenter: function(i) {
        var r = i ? M : W;
        return new r(this.getCenterX(), this.getCenterY(), this, "setCenter");
      },
      setCenter: function() {
        var i = M.read(arguments);
        return this.setCenterX(i.x), this.setCenterY(i.y), this;
      },
      getArea: function() {
        return this.width * this.height;
      },
      isEmpty: function() {
        return this.width === 0 || this.height === 0;
      },
      contains: function(i) {
        return i && i.width !== t || (Array.isArray(i) ? i : arguments).length === 4 ? this._containsRectangle(D.read(arguments)) : this._containsPoint(M.read(arguments));
      },
      _containsPoint: function(i) {
        var r = i.x, s = i.y;
        return r >= this.x && s >= this.y && r <= this.x + this.width && s <= this.y + this.height;
      },
      _containsRectangle: function(i) {
        var r = i.x, s = i.y;
        return r >= this.x && s >= this.y && r + i.width <= this.x + this.width && s + i.height <= this.y + this.height;
      },
      intersects: function() {
        var i = D.read(arguments), r = o.read(arguments) || 0;
        return i.x + i.width > this.x - r && i.y + i.height > this.y - r && i.x < this.x + this.width + r && i.y < this.y + this.height + r;
      },
      intersect: function() {
        var i = D.read(arguments), r = Math.max(this.x, i.x), s = Math.max(this.y, i.y), l = Math.min(this.x + this.width, i.x + i.width), u = Math.min(this.y + this.height, i.y + i.height);
        return new D(r, s, l - r, u - s);
      },
      unite: function() {
        var i = D.read(arguments), r = Math.min(this.x, i.x), s = Math.min(this.y, i.y), l = Math.max(this.x + this.width, i.x + i.width), u = Math.max(this.y + this.height, i.y + i.height);
        return new D(r, s, l - r, u - s);
      },
      include: function() {
        var i = M.read(arguments), r = Math.min(this.x, i.x), s = Math.min(this.y, i.y), l = Math.max(this.x + this.width, i.x), u = Math.max(this.y + this.height, i.y);
        return new D(r, s, l - r, u - s);
      },
      expand: function() {
        var i = U.read(arguments), r = i.width, s = i.height;
        return new D(
          this.x - r / 2,
          this.y - s / 2,
          this.width + r,
          this.height + s
        );
      },
      scale: function(i, r) {
        return this.expand(
          this.width * i - this.width,
          this.height * (r === t ? i : r) - this.height
        );
      }
    }, o.each(
      [
        ["Top", "Left"],
        ["Top", "Right"],
        ["Bottom", "Left"],
        ["Bottom", "Right"],
        ["Left", "Center"],
        ["Top", "Center"],
        ["Right", "Center"],
        ["Bottom", "Center"]
      ],
      function(i, r) {
        var s = i.join(""), l = /^[RL]/.test(s);
        r >= 4 && (i[1] += l ? "Y" : "X");
        var u = i[l ? 0 : 1], d = i[l ? 1 : 0], p = "get" + u, m = "get" + d, y = "set" + u, S = "set" + d, L = "get" + s, E = "set" + s;
        this[L] = function(A) {
          var T = A ? M : W;
          return new T(this[p](), this[m](), this, E);
        }, this[E] = function() {
          var A = M.read(arguments);
          this[y](A.x), this[S](A.y);
        };
      },
      {
        beans: !0
      }
    )), ee = D.extend(
      {
        initialize: function(i, r, s, l, u, d) {
          this._set(i, r, s, l, !0), this._owner = u, this._setter = d;
        },
        _set: function(i, r, s, l, u) {
          return this._x = i, this._y = r, this._width = s, this._height = l, u || this._owner[this._setter](this), this;
        }
      },
      new function() {
        var i = D.prototype;
        return o.each(
          ["x", "y", "width", "height"],
          function(r) {
            var s = o.capitalize(r), l = "_" + r;
            this["get" + s] = function() {
              return this[l];
            }, this["set" + s] = function(u) {
              this[l] = u, this._dontNotify || this._owner[this._setter](this);
            };
          },
          o.each(
            [
              "Point",
              "Size",
              "Center",
              "Left",
              "Top",
              "Right",
              "Bottom",
              "CenterX",
              "CenterY",
              "TopLeft",
              "TopRight",
              "BottomLeft",
              "BottomRight",
              "LeftCenter",
              "TopCenter",
              "RightCenter",
              "BottomCenter"
            ],
            function(r) {
              var s = "set" + r;
              this[s] = function() {
                this._dontNotify = !0, i[s].apply(this, arguments), this._dontNotify = !1, this._owner[this._setter](this);
              };
            },
            {
              isSelected: function() {
                return !!(this._owner._selection & 2);
              },
              setSelected: function(r) {
                var s = this._owner;
                s._changeSelection && s._changeSelection(2, r);
              }
            }
          )
        );
      }()
    ), J = o.extend({
      _class: "Matrix",
      initialize: function i(r, s) {
        var l = arguments, u = l.length, d = !0;
        if (u >= 6 ? this._set.apply(this, l) : u === 1 || u === 2 ? r instanceof i ? this._set(
          r._a,
          r._b,
          r._c,
          r._d,
          r._tx,
          r._ty,
          s
        ) : Array.isArray(r) ? this._set.apply(
          this,
          s ? r.concat([s]) : r
        ) : d = !1 : u ? d = !1 : this.reset(), !d)
          throw new Error("Unsupported matrix parameters");
        return this;
      },
      set: "#initialize",
      _set: function(i, r, s, l, u, d, p) {
        return this._a = i, this._b = r, this._c = s, this._d = l, this._tx = u, this._ty = d, p || this._changed(), this;
      },
      _serialize: function(i, r) {
        return o.serialize(this.getValues(), i, !0, r);
      },
      _changed: function() {
        var i = this._owner;
        i && (i._applyMatrix ? i.transform(null, !0) : i._changed(25));
      },
      clone: function() {
        return new J(
          this._a,
          this._b,
          this._c,
          this._d,
          this._tx,
          this._ty
        );
      },
      equals: function(i) {
        return i === this || i && this._a === i._a && this._b === i._b && this._c === i._c && this._d === i._d && this._tx === i._tx && this._ty === i._ty;
      },
      toString: function() {
        var i = k.instance;
        return "[[" + [
          i.number(this._a),
          i.number(this._c),
          i.number(this._tx)
        ].join(", ") + "], [" + [
          i.number(this._b),
          i.number(this._d),
          i.number(this._ty)
        ].join(", ") + "]]";
      },
      reset: function(i) {
        return this._a = this._d = 1, this._b = this._c = this._tx = this._ty = 0, i || this._changed(), this;
      },
      apply: function(i, r) {
        var s = this._owner;
        return s ? (s.transform(null, o.pick(i, !0), r), this.isIdentity()) : !1;
      },
      translate: function() {
        var i = M.read(arguments), r = i.x, s = i.y;
        return this._tx += r * this._a + s * this._c, this._ty += r * this._b + s * this._d, this._changed(), this;
      },
      scale: function() {
        var i = arguments, r = M.read(i), s = M.read(i, 0, { readNull: !0 });
        return s && this.translate(s), this._a *= r.x, this._b *= r.x, this._c *= r.y, this._d *= r.y, s && this.translate(s.negate()), this._changed(), this;
      },
      rotate: function(i) {
        i *= Math.PI / 180;
        var r = M.read(arguments, 1), s = r.x, l = r.y, u = Math.cos(i), d = Math.sin(i), p = s - s * u + l * d, m = l - s * d - l * u, y = this._a, S = this._b, L = this._c, E = this._d;
        return this._a = u * y + d * L, this._b = u * S + d * E, this._c = -d * y + u * L, this._d = -d * S + u * E, this._tx += p * y + m * L, this._ty += p * S + m * E, this._changed(), this;
      },
      shear: function() {
        var i = arguments, r = M.read(i), s = M.read(i, 0, { readNull: !0 });
        s && this.translate(s);
        var l = this._a, u = this._b;
        return this._a += r.y * this._c, this._b += r.y * this._d, this._c += r.x * l, this._d += r.x * u, s && this.translate(s.negate()), this._changed(), this;
      },
      skew: function() {
        var i = arguments, r = M.read(i), s = M.read(i, 0, { readNull: !0 }), l = Math.PI / 180, u = new M(
          Math.tan(r.x * l),
          Math.tan(r.y * l)
        );
        return this.shear(u, s);
      },
      append: function(i, r) {
        if (i) {
          var s = this._a, l = this._b, u = this._c, d = this._d, p = i._a, m = i._c, y = i._b, S = i._d, L = i._tx, E = i._ty;
          this._a = p * s + y * u, this._c = m * s + S * u, this._b = p * l + y * d, this._d = m * l + S * d, this._tx += L * s + E * u, this._ty += L * l + E * d, r || this._changed();
        }
        return this;
      },
      prepend: function(i, r) {
        if (i) {
          var s = this._a, l = this._b, u = this._c, d = this._d, p = this._tx, m = this._ty, y = i._a, S = i._c, L = i._b, E = i._d, A = i._tx, T = i._ty;
          this._a = y * s + S * l, this._c = y * u + S * d, this._b = L * s + E * l, this._d = L * u + E * d, this._tx = y * p + S * m + A, this._ty = L * p + E * m + T, r || this._changed();
        }
        return this;
      },
      appended: function(i) {
        return this.clone().append(i);
      },
      prepended: function(i) {
        return this.clone().prepend(i);
      },
      invert: function() {
        var i = this._a, r = this._b, s = this._c, l = this._d, u = this._tx, d = this._ty, p = i * l - r * s, m = null;
        return p && !isNaN(p) && isFinite(u) && isFinite(d) && (this._a = l / p, this._b = -r / p, this._c = -s / p, this._d = i / p, this._tx = (s * d - l * u) / p, this._ty = (r * u - i * d) / p, m = this), m;
      },
      inverted: function() {
        return this.clone().invert();
      },
      concatenate: "#append",
      preConcatenate: "#prepend",
      chain: "#appended",
      _shiftless: function() {
        return new J(this._a, this._b, this._c, this._d, 0, 0);
      },
      _orNullIfIdentity: function() {
        return this.isIdentity() ? null : this;
      },
      isIdentity: function() {
        return this._a === 1 && this._b === 0 && this._c === 0 && this._d === 1 && this._tx === 0 && this._ty === 0;
      },
      isInvertible: function() {
        var i = this._a * this._d - this._c * this._b;
        return i && !isNaN(i) && isFinite(this._tx) && isFinite(this._ty);
      },
      isSingular: function() {
        return !this.isInvertible();
      },
      transform: function(i, r, s) {
        return arguments.length < 3 ? this._transformPoint(M.read(arguments)) : this._transformCoordinates(i, r, s);
      },
      _transformPoint: function(i, r, s) {
        var l = i.x, u = i.y;
        return r || (r = new M()), r._set(
          l * this._a + u * this._c + this._tx,
          l * this._b + u * this._d + this._ty,
          s
        );
      },
      _transformCoordinates: function(i, r, s) {
        for (var l = 0, u = 2 * s; l < u; l += 2) {
          var d = i[l], p = i[l + 1];
          r[l] = d * this._a + p * this._c + this._tx, r[l + 1] = d * this._b + p * this._d + this._ty;
        }
        return r;
      },
      _transformCorners: function(i) {
        var r = i.x, s = i.y, l = r + i.width, u = s + i.height, d = [r, s, l, s, l, u, r, u];
        return this._transformCoordinates(d, d, 4);
      },
      _transformBounds: function(i, r, s) {
        for (var l = this._transformCorners(i), u = l.slice(0, 2), d = u.slice(), p = 2; p < 8; p++) {
          var m = l[p], y = p & 1;
          m < u[y] ? u[y] = m : m > d[y] && (d[y] = m);
        }
        return r || (r = new D()), r._set(
          u[0],
          u[1],
          d[0] - u[0],
          d[1] - u[1],
          s
        );
      },
      inverseTransform: function() {
        return this._inverseTransform(M.read(arguments));
      },
      _inverseTransform: function(i, r, s) {
        var l = this._a, u = this._b, d = this._c, p = this._d, m = this._tx, y = this._ty, S = l * p - u * d, L = null;
        if (S && !isNaN(S) && isFinite(m) && isFinite(y)) {
          var E = i.x - this._tx, A = i.y - this._ty;
          r || (r = new M()), L = r._set(
            (E * p - A * d) / S,
            (A * l - E * u) / S,
            s
          );
        }
        return L;
      },
      decompose: function() {
        var i = this._a, r = this._b, s = this._c, l = this._d, u = i * l - r * s, d = Math.sqrt, p = Math.atan2, m = 180 / Math.PI, y, S, L;
        if (i !== 0 || r !== 0) {
          var E = d(i * i + r * r);
          y = Math.acos(i / E) * (r > 0 ? 1 : -1), S = [E, u / E], L = [p(i * s + r * l, E * E), 0];
        } else if (s !== 0 || l !== 0) {
          var A = d(s * s + l * l);
          y = Math.asin(s / A) * (l > 0 ? 1 : -1), S = [u / A, A], L = [0, p(i * s + r * l, A * A)];
        } else
          y = 0, L = S = [0, 0];
        return {
          translation: this.getTranslation(),
          rotation: y * m,
          scaling: new M(S),
          skewing: new M(L[0] * m, L[1] * m)
        };
      },
      getValues: function() {
        return [this._a, this._b, this._c, this._d, this._tx, this._ty];
      },
      getTranslation: function() {
        return new M(this._tx, this._ty);
      },
      getScaling: function() {
        return this.decompose().scaling;
      },
      getRotation: function() {
        return this.decompose().rotation;
      },
      applyToContext: function(i) {
        this.isIdentity() || i.transform(
          this._a,
          this._b,
          this._c,
          this._d,
          this._tx,
          this._ty
        );
      }
    }, o.each(["a", "b", "c", "d", "tx", "ty"], function(i) {
      var r = o.capitalize(i), s = "_" + i;
      this["get" + r] = function() {
        return this[s];
      }, this["set" + r] = function(l) {
        this[s] = l, this._changed();
      };
    }, {})), he = o.extend({
      _class: "Line",
      initialize: function(i, r, s, l, u) {
        var d = !1;
        arguments.length >= 4 ? (this._px = i, this._py = r, this._vx = s, this._vy = l, d = u) : (this._px = i.x, this._py = i.y, this._vx = r.x, this._vy = r.y, d = s), d || (this._vx -= this._px, this._vy -= this._py);
      },
      getPoint: function() {
        return new M(this._px, this._py);
      },
      getVector: function() {
        return new M(this._vx, this._vy);
      },
      getLength: function() {
        return this.getVector().getLength();
      },
      intersect: function(i, r) {
        return he.intersect(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i._px,
          i._py,
          i._vx,
          i._vy,
          !0,
          r
        );
      },
      getSide: function(i, r) {
        return he.getSide(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i.x,
          i.y,
          !0,
          r
        );
      },
      getDistance: function(i) {
        return Math.abs(this.getSignedDistance(i));
      },
      getSignedDistance: function(i) {
        return he.getSignedDistance(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i.x,
          i.y,
          !0
        );
      },
      isCollinear: function(i) {
        return M.isCollinear(this._vx, this._vy, i._vx, i._vy);
      },
      isOrthogonal: function(i) {
        return M.isOrthogonal(this._vx, this._vy, i._vx, i._vy);
      },
      statics: {
        intersect: function(i, r, s, l, u, d, p, m, y, S) {
          y || (s -= i, l -= r, p -= u, m -= d);
          var L = s * m - l * p;
          if (!I.isMachineZero(L)) {
            var E = i - u, A = r - d, T = (p * A - m * E) / L, G = (s * A - l * E) / L, O = 1e-12, Y = -O, B = 1 + O;
            if (S || Y < T && T < B && Y < G && G < B)
              return S || (T = T <= 0 ? 0 : T >= 1 ? 1 : T), new M(
                i + T * s,
                r + T * l
              );
          }
        },
        getSide: function(i, r, s, l, u, d, p, m) {
          p || (s -= i, l -= r);
          var y = u - i, S = d - r, L = y * l - S * s;
          return !m && I.isMachineZero(L) && (L = (y * s + y * s) / (s * s + l * l), L >= 0 && L <= 1 && (L = 0)), L < 0 ? -1 : L > 0 ? 1 : 0;
        },
        getSignedDistance: function(i, r, s, l, u, d, p) {
          return p || (s -= i, l -= r), s === 0 ? l > 0 ? u - i : i - u : l === 0 ? s < 0 ? d - r : r - d : ((u - i) * l - (d - r) * s) / (l > s ? l * Math.sqrt(1 + s * s / (l * l)) : s * Math.sqrt(1 + l * l / (s * s)));
        },
        getDistance: function(i, r, s, l, u, d, p) {
          return Math.abs(
            he.getSignedDistance(i, r, s, l, u, d, p)
          );
        }
      }
    }), fe = v.extend({
      _class: "Project",
      _list: "projects",
      _reference: "project",
      _compactSerialize: !0,
      initialize: function(i) {
        v.call(this, !0), this._children = [], this._namedChildren = {}, this._activeLayer = null, this._currentStyle = new oi(null, null, this), this._view = Qt.create(
          this,
          i || ft.getCanvas(1, 1)
        ), this._selectionItems = {}, this._selectionCount = 0, this._updateVersion = 0;
      },
      _serialize: function(i, r) {
        return o.serialize(this._children, i, !0, r);
      },
      _changed: function(i, r) {
        if (i & 1) {
          var s = this._view;
          s && (s._needsUpdate = !0, !s._requested && s._autoUpdate && s.requestUpdate());
        }
        var l = this._changes;
        if (l && r) {
          var u = this._changesById, d = r._id, p = u[d];
          p ? p.flags |= i : l.push(u[d] = { item: r, flags: i });
        }
      },
      clear: function() {
        for (var i = this._children, r = i.length - 1; r >= 0; r--)
          i[r].remove();
      },
      isEmpty: function() {
        return !this._children.length;
      },
      remove: function i() {
        return i.base.call(this) ? (this._view && this._view.remove(), !0) : !1;
      },
      getView: function() {
        return this._view;
      },
      getCurrentStyle: function() {
        return this._currentStyle;
      },
      setCurrentStyle: function(i) {
        this._currentStyle.set(i);
      },
      getIndex: function() {
        return this._index;
      },
      getOptions: function() {
        return this._scope.settings;
      },
      getLayers: function() {
        return this._children;
      },
      getActiveLayer: function() {
        return this._activeLayer || new qe({ project: this, insert: !0 });
      },
      getSymbolDefinitions: function() {
        var i = [], r = {};
        return this.getItems({
          class: pt,
          match: function(s) {
            var l = s._definition, u = l._id;
            return r[u] || (r[u] = !0, i.push(l)), !1;
          }
        }), i;
      },
      getSymbols: "getSymbolDefinitions",
      getSelectedItems: function() {
        var i = this._selectionItems, r = [];
        for (var s in i) {
          var l = i[s], u = l._selection;
          u & 1 && l.isInserted() ? r.push(l) : u || this._updateSelection(l);
        }
        return r;
      },
      _updateSelection: function(i) {
        var r = i._id, s = this._selectionItems;
        i._selection ? s[r] !== i && (this._selectionCount++, s[r] = i) : s[r] === i && (this._selectionCount--, delete s[r]);
      },
      selectAll: function() {
        for (var i = this._children, r = 0, s = i.length; r < s; r++)
          i[r].setFullySelected(!0);
      },
      deselectAll: function() {
        var i = this._selectionItems;
        for (var r in i)
          i[r].setFullySelected(!1);
      },
      addLayer: function(i) {
        return this.insertLayer(t, i);
      },
      insertLayer: function(i, r) {
        if (r instanceof qe) {
          r._remove(!1, !0), o.splice(this._children, [r], i, 0), r._setProject(this, !0);
          var s = r._name;
          s && r.setName(s), this._changes && r._changed(5), this._activeLayer || (this._activeLayer = r);
        } else
          r = null;
        return r;
      },
      _insertItem: function(i, r, s) {
        return r = this.insertLayer(i, r) || (this._activeLayer || this._insertItem(
          t,
          new qe(X.NO_INSERT),
          !0
        )).insertChild(i, r), s && r.activate && r.activate(), r;
      },
      getItems: function(i) {
        return X._getItems(this, i);
      },
      getItem: function(i) {
        return X._getItems(this, i, null, null, !0)[0] || null;
      },
      importJSON: function(i) {
        this.activate();
        var r = this._activeLayer;
        return o.importJSON(i, r && r.isEmpty() && r);
      },
      removeOn: function(i) {
        var r = this._removeSets;
        if (r) {
          i === "mouseup" && (r.mousedrag = null);
          var s = r[i];
          if (s) {
            for (var l in s) {
              var u = s[l];
              for (var d in r) {
                var p = r[d];
                p && p != s && delete p[u._id];
              }
              u.remove();
            }
            r[i] = null;
          }
        }
      },
      draw: function(i, r, s) {
        this._updateVersion++, i.save(), r.applyToContext(i);
        for (var l = this._children, u = new o({
          offset: new M(0, 0),
          pixelRatio: s,
          viewMatrix: r.isIdentity() ? null : r,
          matrices: [new J()],
          updateMatrix: !0
        }), d = 0, p = l.length; d < p; d++)
          l[d].draw(i, u);
        if (i.restore(), this._selectionCount > 0) {
          i.save(), i.strokeWidth = 1;
          var m = this._selectionItems, y = this._scope.settings.handleSize, S = this._updateVersion;
          for (var L in m)
            m[L]._drawSelection(i, r, y, m, S);
          i.restore();
        }
      }
    }), X = o.extend(
      h,
      {
        statics: {
          extend: function i(r) {
            return r._serializeFields && (r._serializeFields = o.set(
              {},
              this.prototype._serializeFields,
              r._serializeFields
            )), i.base.apply(this, arguments);
          },
          INSERT: { insert: !0 },
          NO_INSERT: { insert: !1 }
        },
        _class: "Item",
        _name: null,
        _applyMatrix: !0,
        _canApplyMatrix: !0,
        _canScaleStroke: !1,
        _pivot: null,
        _visible: !0,
        _blendMode: "normal",
        _opacity: 1,
        _locked: !1,
        _guide: !1,
        _clipMask: !1,
        _selection: 0,
        _selectBounds: !0,
        _selectChildren: !1,
        _serializeFields: {
          name: null,
          applyMatrix: null,
          matrix: new J(),
          pivot: null,
          visible: !0,
          blendMode: "normal",
          opacity: 1,
          locked: !1,
          guide: !1,
          clipMask: !1,
          selected: !1,
          data: {}
        },
        _prioritize: ["applyMatrix"]
      },
      new function() {
        var i = [
          "onMouseDown",
          "onMouseUp",
          "onMouseDrag",
          "onClick",
          "onDoubleClick",
          "onMouseMove",
          "onMouseEnter",
          "onMouseLeave"
        ];
        return o.each(
          i,
          function(r) {
            this._events[r] = {
              install: function(s) {
                this.getView()._countItemEvent(s, 1);
              },
              uninstall: function(s) {
                this.getView()._countItemEvent(s, -1);
              }
            };
          },
          {
            _events: {
              onFrame: {
                install: function() {
                  this.getView()._animateItem(this, !0);
                },
                uninstall: function() {
                  this.getView()._animateItem(this, !1);
                }
              },
              onLoad: {},
              onError: {}
            },
            statics: {
              _itemHandlers: i
            }
          }
        );
      }(),
      {
        initialize: function() {
        },
        _initialize: function(i, r) {
          var s = i && o.isPlainObject(i), l = s && i.internal === !0, u = this._matrix = new J(), d = s && i.project || Ve.project, p = Ve.settings;
          return this._id = l ? null : V.get(), this._parent = this._index = null, this._applyMatrix = this._canApplyMatrix && p.applyMatrix, r && u.translate(r), u._owner = this, this._style = new oi(d._currentStyle, this, d), l || s && i.insert == !1 || !p.insertItems && !(s && i.insert == !0) ? this._setProject(d) : (s && i.parent || d)._insertItem(t, this, !0), s && i !== X.NO_INSERT && i !== X.INSERT && this.set(i, {
            internal: !0,
            insert: !0,
            project: !0,
            parent: !0
          }), s;
        },
        _serialize: function(i, r) {
          var s = {}, l = this;
          function u(d) {
            for (var p in d) {
              var m = l[p];
              o.equals(m, p === "leading" ? d.fontSize * 1.2 : d[p]) || (s[p] = o.serialize(
                m,
                i,
                p !== "data",
                r
              ));
            }
          }
          return u(this._serializeFields), this instanceof Z || u(this._style._defaults), [this._class, s];
        },
        _changed: function(i) {
          var r = this._symbol, s = this._parent || r, l = this._project;
          i & 8 && (this._bounds = this._position = this._decomposed = t), i & 16 && (this._globalMatrix = t), s && i & 72 && X._clearBoundsCache(s), i & 2 && X._clearBoundsCache(this), l && l._changed(i, this), r && r._changed(i);
        },
        getId: function() {
          return this._id;
        },
        getName: function() {
          return this._name;
        },
        setName: function(i) {
          if (this._name && this._removeNamed(), i === +i + "")
            throw new Error(
              "Names consisting only of numbers are not supported."
            );
          var r = this._getOwner();
          if (i && r) {
            var s = r._children, l = r._namedChildren;
            (l[i] = l[i] || []).push(this), i in s || (s[i] = this);
          }
          this._name = i || t, this._changed(256);
        },
        getStyle: function() {
          return this._style;
        },
        setStyle: function(i) {
          this.getStyle().set(i);
        }
      },
      o.each(
        ["locked", "visible", "blendMode", "opacity", "guide"],
        function(i) {
          var r = o.capitalize(i), s = "_" + i, l = {
            locked: 256,
            visible: 265
          };
          this["get" + r] = function() {
            return this[s];
          }, this["set" + r] = function(u) {
            u != this[s] && (this[s] = u, this._changed(l[i] || 257));
          };
        },
        {}
      ),
      {
        beans: !0,
        getSelection: function() {
          return this._selection;
        },
        setSelection: function(i) {
          if (i !== this._selection) {
            this._selection = i;
            var r = this._project;
            r && (r._updateSelection(this), this._changed(257));
          }
        },
        _changeSelection: function(i, r) {
          var s = this._selection;
          this.setSelection(r ? s | i : s & ~i);
        },
        isSelected: function() {
          if (this._selectChildren) {
            for (var i = this._children, r = 0, s = i.length; r < s; r++)
              if (i[r].isSelected())
                return !0;
          }
          return !!(this._selection & 1);
        },
        setSelected: function(i) {
          if (this._selectChildren)
            for (var r = this._children, s = 0, l = r.length; s < l; s++)
              r[s].setSelected(i);
          this._changeSelection(1, i);
        },
        isFullySelected: function() {
          var i = this._children, r = !!(this._selection & 1);
          if (i && r) {
            for (var s = 0, l = i.length; s < l; s++)
              if (!i[s].isFullySelected())
                return !1;
            return !0;
          }
          return r;
        },
        setFullySelected: function(i) {
          var r = this._children;
          if (r)
            for (var s = 0, l = r.length; s < l; s++)
              r[s].setFullySelected(i);
          this._changeSelection(1, i);
        },
        isClipMask: function() {
          return this._clipMask;
        },
        setClipMask: function(i) {
          this._clipMask != (i = !!i) && (this._clipMask = i, i && (this.setFillColor(null), this.setStrokeColor(null)), this._changed(257), this._parent && this._parent._changed(2048));
        },
        getData: function() {
          return this._data || (this._data = {}), this._data;
        },
        setData: function(i) {
          this._data = i;
        },
        getPosition: function(i) {
          var r = i ? M : W, s = this._position || (this._position = this._getPositionFromBounds());
          return new r(s.x, s.y, this, "setPosition");
        },
        setPosition: function() {
          this.translate(M.read(arguments).subtract(this.getPosition(!0)));
        },
        _getPositionFromBounds: function(i) {
          return this._pivot ? this._matrix._transformPoint(this._pivot) : (i || this.getBounds()).getCenter(!0);
        },
        getPivot: function() {
          var i = this._pivot;
          return i ? new W(i.x, i.y, this, "setPivot") : null;
        },
        setPivot: function() {
          this._pivot = M.read(arguments, 0, { clone: !0, readNull: !0 }), this._position = t;
        }
      },
      o.each(
        {
          getStrokeBounds: { stroke: !0 },
          getHandleBounds: { handle: !0 },
          getInternalBounds: { internal: !0 }
        },
        function(i, r) {
          this[r] = function(s) {
            return this.getBounds(s, i);
          };
        },
        {
          beans: !0,
          getBounds: function(i, r) {
            var s = r || i instanceof J, l = o.set(
              {},
              s ? r : i,
              this._boundsOptions
            );
            (!l.stroke || this.getStrokeScaling()) && (l.cacheItem = this);
            var u = this._getCachedBounds(s && i, l).rect;
            return arguments.length ? u : new ee(
              u.x,
              u.y,
              u.width,
              u.height,
              this,
              "setBounds"
            );
          },
          setBounds: function() {
            var i = D.read(arguments), r = this.getBounds(), s = this._matrix, l = new J(), u = i.getCenter();
            l.translate(u), (i.width != r.width || i.height != r.height) && (s.isInvertible() || (s.set(s._backup || new J().translate(s.getTranslation())), r = this.getBounds()), l.scale(
              r.width !== 0 ? i.width / r.width : 0,
              r.height !== 0 ? i.height / r.height : 0
            )), u = r.getCenter(), l.translate(-u.x, -u.y), this.transform(l);
          },
          _getBounds: function(i, r) {
            var s = this._children;
            return !s || !s.length ? new D() : (X._updateBoundsCache(this, r.cacheItem), X._getBounds(s, i, r));
          },
          _getBoundsCacheKey: function(i, r) {
            return [
              i.stroke ? 1 : 0,
              i.handle ? 1 : 0,
              r ? 1 : 0
            ].join("");
          },
          _getCachedBounds: function(i, r, s) {
            i = i && i._orNullIfIdentity();
            var l = r.internal && !s, u = r.cacheItem, d = l ? null : this._matrix._orNullIfIdentity(), p = u && (!i || i.equals(d)) && this._getBoundsCacheKey(r, l), m = this._bounds;
            if (X._updateBoundsCache(this._parent || this._symbol, u), p && m && p in m) {
              var y = m[p];
              return {
                rect: y.rect.clone(),
                nonscaling: y.nonscaling
              };
            }
            var S = this._getBounds(i || d, r), L = S.rect || S, E = this._style, A = S.nonscaling || E.hasStroke() && !E.getStrokeScaling();
            if (p) {
              m || (this._bounds = m = {});
              var y = m[p] = {
                rect: L.clone(),
                nonscaling: A,
                internal: l
              };
            }
            return {
              rect: L,
              nonscaling: A
            };
          },
          _getStrokeMatrix: function(i, r) {
            var s = this.getStrokeScaling() ? null : r && r.internal ? this : this._parent || this._symbol && this._symbol._item, l = s ? s.getViewMatrix().invert() : i;
            return l && l._shiftless();
          },
          statics: {
            _updateBoundsCache: function(i, r) {
              if (i && r) {
                var s = r._id, l = i._boundsCache = i._boundsCache || {
                  ids: {},
                  list: []
                };
                l.ids[s] || (l.list.push(r), l.ids[s] = r);
              }
            },
            _clearBoundsCache: function(i) {
              var r = i._boundsCache;
              if (r) {
                i._bounds = i._position = i._boundsCache = t;
                for (var s = 0, l = r.list, u = l.length; s < u; s++) {
                  var d = l[s];
                  d !== i && (d._bounds = d._position = t, d._boundsCache && X._clearBoundsCache(d));
                }
              }
            },
            _getBounds: function(i, r, s) {
              var l = 1 / 0, u = -l, d = l, p = u, m = !1;
              s = s || {};
              for (var y = 0, S = i.length; y < S; y++) {
                var L = i[y];
                if (L._visible && !L.isEmpty(!0)) {
                  var E = L._getCachedBounds(
                    r && r.appended(L._matrix),
                    s,
                    !0
                  ), A = E.rect;
                  l = Math.min(A.x, l), d = Math.min(A.y, d), u = Math.max(A.x + A.width, u), p = Math.max(A.y + A.height, p), E.nonscaling && (m = !0);
                }
              }
              return {
                rect: isFinite(l) ? new D(l, d, u - l, p - d) : new D(),
                nonscaling: m
              };
            }
          }
        }
      ),
      {
        beans: !0,
        _decompose: function() {
          return this._applyMatrix ? null : this._decomposed || (this._decomposed = this._matrix.decompose());
        },
        getRotation: function() {
          var i = this._decompose();
          return i ? i.rotation : 0;
        },
        setRotation: function(i) {
          var r = this.getRotation();
          if (r != null && i != null) {
            var s = this._decomposed;
            this.rotate(i - r), s && (s.rotation = i, this._decomposed = s);
          }
        },
        getScaling: function() {
          var i = this._decompose(), r = i && i.scaling;
          return new W(r ? r.x : 1, r ? r.y : 1, this, "setScaling");
        },
        setScaling: function() {
          var i = this.getScaling(), r = M.read(arguments, 0, { clone: !0, readNull: !0 });
          if (i && r && !i.equals(r)) {
            var s = this.getRotation(), l = this._decomposed, u = new J(), d = I.isZero;
            if (d(i.x) || d(i.y))
              u.translate(l.translation), s && u.rotate(s), u.scale(r.x, r.y), this._matrix.set(u);
            else {
              var p = this.getPosition(!0);
              u.translate(p), s && u.rotate(s), u.scale(r.x / i.x, r.y / i.y), s && u.rotate(-s), u.translate(p.negate()), this.transform(u);
            }
            l && (l.scaling = r, this._decomposed = l);
          }
        },
        getMatrix: function() {
          return this._matrix;
        },
        setMatrix: function() {
          var i = this._matrix;
          i.set.apply(i, arguments);
        },
        getGlobalMatrix: function(i) {
          var r = this._globalMatrix;
          if (r)
            for (var s = this._parent, l = []; s; ) {
              if (!s._globalMatrix) {
                r = null;
                for (var u = 0, d = l.length; u < d; u++)
                  l[u]._globalMatrix = null;
                break;
              }
              l.push(s), s = s._parent;
            }
          if (!r) {
            r = this._globalMatrix = this._matrix.clone();
            var s = this._parent;
            s && r.prepend(s.getGlobalMatrix(!0));
          }
          return i ? r : r.clone();
        },
        getViewMatrix: function() {
          return this.getGlobalMatrix().prepend(this.getView()._matrix);
        },
        getApplyMatrix: function() {
          return this._applyMatrix;
        },
        setApplyMatrix: function(i) {
          (this._applyMatrix = this._canApplyMatrix && !!i) && this.transform(null, !0);
        },
        getTransformContent: "#getApplyMatrix",
        setTransformContent: "#setApplyMatrix"
      },
      {
        getProject: function() {
          return this._project;
        },
        _setProject: function(i, r) {
          if (this._project !== i) {
            this._project && this._installEvents(!1), this._project = i;
            for (var s = this._children, l = 0, u = s && s.length; l < u; l++)
              s[l]._setProject(i);
            r = !0;
          }
          r && this._installEvents(!0);
        },
        getView: function() {
          return this._project._view;
        },
        _installEvents: function i(r) {
          i.base.call(this, r);
          for (var s = this._children, l = 0, u = s && s.length; l < u; l++)
            s[l]._installEvents(r);
        },
        getLayer: function() {
          for (var i = this; i = i._parent; )
            if (i instanceof qe)
              return i;
          return null;
        },
        getParent: function() {
          return this._parent;
        },
        setParent: function(i) {
          return i.addChild(this);
        },
        _getOwner: "#getParent",
        getChildren: function() {
          return this._children;
        },
        setChildren: function(i) {
          this.removeChildren(), this.addChildren(i);
        },
        getFirstChild: function() {
          return this._children && this._children[0] || null;
        },
        getLastChild: function() {
          return this._children && this._children[this._children.length - 1] || null;
        },
        getNextSibling: function() {
          var i = this._getOwner();
          return i && i._children[this._index + 1] || null;
        },
        getPreviousSibling: function() {
          var i = this._getOwner();
          return i && i._children[this._index - 1] || null;
        },
        getIndex: function() {
          return this._index;
        },
        setIndex: function(i) {
          var r = this._parent, s = r && r._children;
          s && r.insertChildren(
            i in s ? i : t,
            [this]
          );
        },
        equals: function(i) {
          return i === this || i && this._class === i._class && this._style.equals(i._style) && this._matrix.equals(i._matrix) && this._locked === i._locked && this._visible === i._visible && this._blendMode === i._blendMode && this._opacity === i._opacity && this._clipMask === i._clipMask && this._guide === i._guide && this._equals(i) || !1;
        },
        _equals: function(i) {
          return o.equals(this._children, i._children);
        },
        clone: function(i) {
          var r = new this.constructor(X.NO_INSERT), s = this._children, l = o.pick(
            i ? i.insert : t,
            i === t || i === !0
          ), u = o.pick(i ? i.deep : t, !0);
          s && r.copyAttributes(this), (!s || u) && r.copyContent(this), s || r.copyAttributes(this), l && r.insertAbove(this);
          var d = this._name, p = this._parent;
          if (d && p) {
            for (var s = p._children, m = d, y = 1; s[d]; )
              d = m + " " + y++;
            d !== m && r.setName(d);
          }
          return r;
        },
        copyContent: function(i) {
          for (var r = i._children, s = 0, l = r && r.length; s < l; s++)
            this.addChild(r[s].clone(!1), !0);
        },
        copyAttributes: function(i, r) {
          this.setStyle(i._style);
          for (var s = [
            "_locked",
            "_visible",
            "_blendMode",
            "_opacity",
            "_clipMask",
            "_guide"
          ], l = 0, u = s.length; l < u; l++) {
            var d = s[l];
            i.hasOwnProperty(d) && (this[d] = i[d]);
          }
          r || this._matrix.set(i._matrix, !0), this.setApplyMatrix(i._applyMatrix), this.setPivot(i._pivot), this.setSelection(i._selection);
          var p = i._data, m = i._name;
          this._data = p ? o.clone(p) : null, m && this.setName(m);
        },
        rasterize: function(i, r) {
          var s, l, u;
          o.isPlainObject(i) ? (s = i.resolution, l = i.insert, u = i.raster) : (s = i, l = r), u || (u = new je(X.NO_INSERT));
          var d = this.getStrokeBounds(), p = (s || this.getView().getResolution()) / 72, m = d.getTopLeft().floor(), y = d.getBottomRight().ceil(), S = new U(y.subtract(m)), L = S.multiply(p);
          if (u.setSize(L, !0), !L.isZero()) {
            var E = u.getContext(!0), A = new J().scale(p).translate(m.negate());
            E.save(), A.applyToContext(E), this.draw(E, new o({ matrices: [A] })), E.restore();
          }
          return u._matrix.set(
            new J().translate(m.add(S.divide(2))).scale(1 / p)
          ), (l === t || l) && u.insertAbove(this), u;
        },
        contains: function() {
          var i = this._matrix;
          return i.isInvertible() && !!this._contains(i._inverseTransform(M.read(arguments)));
        },
        _contains: function(i) {
          var r = this._children;
          if (r) {
            for (var s = r.length - 1; s >= 0; s--)
              if (r[s].contains(i))
                return !0;
            return !1;
          }
          return i.isInside(this.getInternalBounds());
        },
        isInside: function() {
          return D.read(arguments).contains(this.getBounds());
        },
        _asPathItem: function() {
          return new $e.Rectangle({
            rectangle: this.getInternalBounds(),
            matrix: this._matrix,
            insert: !1
          });
        },
        intersects: function(i, r) {
          return i instanceof X ? this._asPathItem().getIntersections(
            i._asPathItem(),
            null,
            r,
            !0
          ).length > 0 : !1;
        }
      },
      new function() {
        function i() {
          var l = arguments;
          return this._hitTest(
            M.read(l),
            Ze.getOptions(l)
          );
        }
        function r() {
          var l = arguments, u = M.read(l), d = Ze.getOptions(l), p = [];
          return this._hitTest(u, new o({ all: p }, d)), p;
        }
        function s(l, u, d, p) {
          var m = this._children;
          if (m)
            for (var y = m.length - 1; y >= 0; y--) {
              var S = m[y], L = S !== p && S._hitTest(
                l,
                u,
                d
              );
              if (L && !u.all)
                return L;
            }
          return null;
        }
        return fe.inject({
          hitTest: i,
          hitTestAll: r,
          _hitTest: s
        }), {
          hitTest: i,
          hitTestAll: r,
          _hitTestChildren: s
        };
      }(),
      {
        _hitTest: function(i, r, s) {
          if (this._locked || !this._visible || this._guide && !r.guides || this.isEmpty())
            return null;
          var l = this._matrix, u = s ? s.appended(l) : this.getGlobalMatrix().prepend(this.getView()._matrix), d = Math.max(r.tolerance, 1e-12), p = r._tolerancePadding = new U(
            $e._getStrokePadding(
              d,
              l._shiftless().invert()
            )
          );
          if (i = l._inverseTransform(i), !i || !this._children && !this.getBounds({ internal: !0, stroke: !0, handle: !0 }).expand(p.multiply(2))._containsPoint(i))
            return null;
          var m = !(r.guides && !this._guide || r.selected && !this.isSelected() || r.type && r.type !== o.hyphenate(this._class) || r.class && !(this instanceof r.class)), y = r.match, S = this, L, E;
          function A(C) {
            return C && y && !y(C) && (C = null), C && r.all && r.all.push(C), C;
          }
          function T(C, N) {
            var j = N ? L["get" + N]() : S.getPosition();
            if (i.subtract(j).divide(p).length <= 1)
              return new Ze(C, S, {
                name: N ? o.hyphenate(N) : C,
                point: j
              });
          }
          var G = r.position, O = r.center, Y = r.bounds;
          if (m && this._parent && (G || O || Y)) {
            if ((O || Y) && (L = this.getInternalBounds()), E = G && T("position") || O && T("center", "Center"), !E && Y)
              for (var B = [
                "TopLeft",
                "TopRight",
                "BottomLeft",
                "BottomRight",
                "LeftCenter",
                "TopCenter",
                "RightCenter",
                "BottomCenter"
              ], z = 0; z < 8 && !E; z++)
                E = T("bounds", B[z]);
            E = A(E);
          }
          return E || (E = this._hitTestChildren(i, r, u) || m && A(this._hitTestSelf(
            i,
            r,
            u,
            this.getStrokeScaling() ? null : u._shiftless().invert()
          )) || null), E && E.point && (E.point = l.transform(E.point)), E;
        },
        _hitTestSelf: function(i, r) {
          if (r.fill && this.hasFill() && this._contains(i))
            return new Ze("fill", this);
        },
        matches: function(i, r) {
          function s(p, m) {
            for (var y in p)
              if (p.hasOwnProperty(y)) {
                var S = p[y], L = m[y];
                if (o.isPlainObject(S) && o.isPlainObject(L)) {
                  if (!s(S, L))
                    return !1;
                } else if (!o.equals(S, L))
                  return !1;
              }
            return !0;
          }
          var l = typeof i;
          if (l === "object") {
            for (var u in i)
              if (i.hasOwnProperty(u) && !this.matches(u, i[u]))
                return !1;
            return !0;
          } else {
            if (l === "function")
              return i(this);
            if (i === "match")
              return r(this);
            var d = /^(empty|editable)$/.test(i) ? this["is" + o.capitalize(i)]() : i === "type" ? o.hyphenate(this._class) : this[i];
            if (i === "class") {
              if (typeof r == "function")
                return this instanceof r;
              d = this._class;
            }
            if (typeof r == "function")
              return !!r(d);
            if (r) {
              if (r.test)
                return r.test(d);
              if (o.isPlainObject(r))
                return s(r, d);
            }
            return o.equals(d, r);
          }
        },
        getItems: function(i) {
          return X._getItems(this, i, this._matrix);
        },
        getItem: function(i) {
          return X._getItems(this, i, this._matrix, null, !0)[0] || null;
        },
        statics: {
          _getItems: function i(r, s, l, u, d) {
            if (!u) {
              var p = typeof s == "object" && s, m = p && p.overlapping, y = p && p.inside, S = m || y, A = S && D.read([S]);
              u = {
                items: [],
                recursive: p && p.recursive !== !1,
                inside: !!y,
                overlapping: !!m,
                rect: A,
                path: m && new $e.Rectangle({
                  rectangle: A,
                  insert: !1
                })
              }, p && (s = o.filter({}, s, {
                recursive: !0,
                inside: !0,
                overlapping: !0
              }));
            }
            var L = r._children, E = u.items, A = u.rect;
            l = A && (l || new J());
            for (var T = 0, G = L && L.length; T < G; T++) {
              var O = L[T], Y = l && l.appended(O._matrix), B = !0;
              if (A) {
                var S = O.getBounds(Y);
                if (!A.intersects(S))
                  continue;
                A.contains(S) || u.overlapping && (S.contains(A) || u.path.intersects(O, Y)) || (B = !1);
              }
              if (B && O.matches(s) && (E.push(O), d) || (u.recursive !== !1 && i(O, s, Y, u, d), d && E.length > 0))
                break;
            }
            return E;
          }
        }
      },
      {
        importJSON: function(i) {
          var r = o.importJSON(i, this);
          return r !== this ? this.addChild(r) : r;
        },
        addChild: function(i) {
          return this.insertChild(t, i);
        },
        insertChild: function(i, r) {
          var s = r ? this.insertChildren(i, [r]) : null;
          return s && s[0];
        },
        addChildren: function(i) {
          return this.insertChildren(this._children.length, i);
        },
        insertChildren: function(i, r) {
          var s = this._children;
          if (s && r && r.length > 0) {
            r = o.slice(r);
            for (var l = {}, u = r.length - 1; u >= 0; u--) {
              var d = r[u], p = d && d._id;
              !d || l[p] ? r.splice(u, 1) : (d._remove(!1, !0), l[p] = !0);
            }
            o.splice(s, r, i, 0);
            for (var m = this._project, y = m._changes, u = 0, S = r.length; u < S; u++) {
              var d = r[u], L = d._name;
              d._parent = this, d._setProject(m, !0), L && d.setName(L), y && d._changed(5);
            }
            this._changed(11);
          } else
            r = null;
          return r;
        },
        _insertItem: "#insertChild",
        _insertAt: function(i, r) {
          var s = i && i._getOwner(), l = i !== this && s ? this : null;
          return l && (l._remove(!1, !0), s._insertItem(i._index + r, l)), l;
        },
        insertAbove: function(i) {
          return this._insertAt(i, 1);
        },
        insertBelow: function(i) {
          return this._insertAt(i, 0);
        },
        sendToBack: function() {
          var i = this._getOwner();
          return i ? i._insertItem(0, this) : null;
        },
        bringToFront: function() {
          var i = this._getOwner();
          return i ? i._insertItem(t, this) : null;
        },
        appendTop: "#addChild",
        appendBottom: function(i) {
          return this.insertChild(0, i);
        },
        moveAbove: "#insertAbove",
        moveBelow: "#insertBelow",
        addTo: function(i) {
          return i._insertItem(t, this);
        },
        copyTo: function(i) {
          return this.clone(!1).addTo(i);
        },
        reduce: function(i) {
          var r = this._children;
          if (r && r.length === 1) {
            var s = r[0].reduce(i);
            return this._parent ? (s.insertAbove(this), this.remove()) : s.remove(), s;
          }
          return this;
        },
        _removeNamed: function() {
          var i = this._getOwner();
          if (i) {
            var r = i._children, s = i._namedChildren, l = this._name, u = s[l], d = u ? u.indexOf(this) : -1;
            d !== -1 && (r[l] == this && delete r[l], u.splice(d, 1), u.length ? r[l] = u[0] : delete s[l]);
          }
        },
        _remove: function(i, r) {
          var s = this._getOwner(), l = this._project, u = this._index;
          return this._style && this._style._dispose(), s ? (this._name && this._removeNamed(), u != null && (l._activeLayer === this && (l._activeLayer = this.getNextSibling() || this.getPreviousSibling()), o.splice(s._children, null, u, 1)), this._installEvents(!1), i && l._changes && this._changed(5), r && s._changed(11, this), this._parent = null, !0) : !1;
        },
        remove: function() {
          return this._remove(!0, !0);
        },
        replaceWith: function(i) {
          var r = i && i.insertBelow(this);
          return r && this.remove(), r;
        },
        removeChildren: function(i, r) {
          if (!this._children)
            return null;
          i = i || 0, r = o.pick(r, this._children.length);
          for (var s = o.splice(this._children, null, i, r - i), l = s.length - 1; l >= 0; l--)
            s[l]._remove(!0, !1);
          return s.length > 0 && this._changed(11), s;
        },
        clear: "#removeChildren",
        reverseChildren: function() {
          if (this._children) {
            this._children.reverse();
            for (var i = 0, r = this._children.length; i < r; i++)
              this._children[i]._index = i;
            this._changed(11);
          }
        },
        isEmpty: function(i) {
          var r = this._children, s = r ? r.length : 0;
          if (i) {
            for (var l = 0; l < s; l++)
              if (!r[l].isEmpty(i))
                return !1;
            return !0;
          }
          return !s;
        },
        isEditable: function() {
          for (var i = this; i; ) {
            if (!i._visible || i._locked)
              return !1;
            i = i._parent;
          }
          return !0;
        },
        hasFill: function() {
          return this.getStyle().hasFill();
        },
        hasStroke: function() {
          return this.getStyle().hasStroke();
        },
        hasShadow: function() {
          return this.getStyle().hasShadow();
        },
        _getOrder: function(i) {
          function r(p) {
            var m = [];
            do
              m.unshift(p);
            while (p = p._parent);
            return m;
          }
          for (var s = r(this), l = r(i), u = 0, d = Math.min(s.length, l.length); u < d; u++)
            if (s[u] != l[u])
              return s[u]._index < l[u]._index ? 1 : -1;
          return 0;
        },
        hasChildren: function() {
          return this._children && this._children.length > 0;
        },
        isInserted: function() {
          return this._parent ? this._parent.isInserted() : !1;
        },
        isAbove: function(i) {
          return this._getOrder(i) === -1;
        },
        isBelow: function(i) {
          return this._getOrder(i) === 1;
        },
        isParent: function(i) {
          return this._parent === i;
        },
        isChild: function(i) {
          return i && i._parent === this;
        },
        isDescendant: function(i) {
          for (var r = this; r = r._parent; )
            if (r === i)
              return !0;
          return !1;
        },
        isAncestor: function(i) {
          return i ? i.isDescendant(this) : !1;
        },
        isSibling: function(i) {
          return this._parent === i._parent;
        },
        isGroupedWith: function(i) {
          for (var r = this._parent; r; ) {
            if (r._parent && /^(Group|Layer|CompoundPath)$/.test(r._class) && i.isDescendant(r))
              return !0;
            r = r._parent;
          }
          return !1;
        }
      },
      o.each(["rotate", "scale", "shear", "skew"], function(i) {
        var r = i === "rotate";
        this[i] = function() {
          var s = arguments, l = (r ? o : M).read(s), u = M.read(s, 0, { readNull: !0 });
          return this.transform(new J()[i](
            l,
            u || this.getPosition(!0)
          ));
        };
      }, {
        translate: function() {
          var i = new J();
          return this.transform(i.translate.apply(i, arguments));
        },
        transform: function(i, r, s) {
          var l = this._matrix, u = i && !i.isIdentity(), d = s && this._canApplyMatrix || this._applyMatrix && (u || !l.isIdentity() || r && this._children);
          if (!u && !d)
            return this;
          if (u) {
            !i.isInvertible() && l.isInvertible() && (l._backup = l.getValues()), l.prepend(i, !0);
            var p = this._style, m = p.getFillColor(!0), y = p.getStrokeColor(!0);
            m && m.transform(i), y && y.transform(i);
          }
          if (d && (d = this._transformContent(
            l,
            r,
            s
          ))) {
            var S = this._pivot;
            S && l._transformPoint(S, S, !0), l.reset(!0), s && this._canApplyMatrix && (this._applyMatrix = !0);
          }
          var L = this._bounds, E = this._position;
          (u || d) && this._changed(25);
          var A = u && L && i.decompose();
          if (A && A.skewing.isZero() && A.rotation % 90 === 0) {
            for (var T in L) {
              var G = L[T];
              if (G.nonscaling)
                delete L[T];
              else if (d || !G.internal) {
                var O = G.rect;
                i._transformBounds(O, O);
              }
            }
            this._bounds = L;
            var Y = L[this._getBoundsCacheKey(
              this._boundsOptions || {}
            )];
            Y && (this._position = this._getPositionFromBounds(Y.rect));
          } else
            u && E && this._pivot && (this._position = i._transformPoint(E, E));
          return this;
        },
        _transformContent: function(i, r, s) {
          var l = this._children;
          if (l) {
            for (var u = 0, d = l.length; u < d; u++)
              l[u].transform(i, r, s);
            return !0;
          }
        },
        globalToLocal: function() {
          return this.getGlobalMatrix(!0)._inverseTransform(
            M.read(arguments)
          );
        },
        localToGlobal: function() {
          return this.getGlobalMatrix(!0)._transformPoint(
            M.read(arguments)
          );
        },
        parentToLocal: function() {
          return this._matrix._inverseTransform(M.read(arguments));
        },
        localToParent: function() {
          return this._matrix._transformPoint(M.read(arguments));
        },
        fitBounds: function(i, r) {
          i = D.read(arguments);
          var s = this.getBounds(), l = s.height / s.width, u = i.height / i.width, d = (r ? l > u : l < u) ? i.width / s.width : i.height / s.height, p = new D(
            new M(),
            new U(s.width * d, s.height * d)
          );
          p.setCenter(i.getCenter()), this.setBounds(p);
        }
      }),
      {
        _setStyles: function(i, r, s) {
          var l = this._style, u = this._matrix;
          if (l.hasFill() && (i.fillStyle = l.getFillColor().toCanvasStyle(i, u)), l.hasStroke()) {
            i.strokeStyle = l.getStrokeColor().toCanvasStyle(i, u), i.lineWidth = l.getStrokeWidth();
            var d = l.getStrokeJoin(), p = l.getStrokeCap(), m = l.getMiterLimit();
            if (d && (i.lineJoin = d), p && (i.lineCap = p), m && (i.miterLimit = m), Ve.support.nativeDash) {
              var y = l.getDashArray(), S = l.getDashOffset();
              y && y.length && ("setLineDash" in i ? (i.setLineDash(y), i.lineDashOffset = S) : (i.mozDash = y, i.mozDashOffset = S));
            }
          }
          if (l.hasShadow()) {
            var L = r.pixelRatio || 1, E = s._shiftless().prepend(
              new J().scale(L, L)
            ), A = E.transform(new M(l.getShadowBlur(), 0)), T = E.transform(this.getShadowOffset());
            i.shadowColor = l.getShadowColor().toCanvasStyle(i), i.shadowBlur = A.getLength(), i.shadowOffsetX = T.x, i.shadowOffsetY = T.y;
          }
        },
        draw: function(i, r, s) {
          if (this._updateVersion = this._project._updateVersion, !(!this._visible || this._opacity === 0)) {
            var l = r.matrices, u = r.viewMatrix, d = this._matrix, p = l[l.length - 1].appended(d);
            if (p.isInvertible()) {
              u = u ? u.appended(p) : p, l.push(p), r.updateMatrix && (this._globalMatrix = p);
              var m = this._blendMode, y = I.clamp(this._opacity, 0, 1), S = m === "normal", L = tt.nativeModes[m], E = S && y === 1 || r.dontStart || r.clip || (L || S && y < 1) && this._canComposite(), A = r.pixelRatio || 1, T, G, O;
              if (!E) {
                var Y = this.getStrokeBounds(u);
                if (!Y.width || !Y.height) {
                  l.pop();
                  return;
                }
                O = r.offset, G = r.offset = Y.getTopLeft().floor(), T = i, i = ft.getContext(Y.getSize().ceil().add(1).multiply(A)), A !== 1 && i.scale(A, A);
              }
              i.save();
              var B = s ? s.appended(d) : this._canScaleStroke && !this.getStrokeScaling(!0) && u, z = !E && r.clipItem, C = !B || z;
              if (E ? (i.globalAlpha = y, L && (i.globalCompositeOperation = m)) : C && i.translate(-G.x, -G.y), C && (E ? d : u).applyToContext(i), z && r.clipItem.draw(i, r.extend({ clip: !0 })), B) {
                i.setTransform(A, 0, 0, A, 0, 0);
                var N = r.offset;
                N && i.translate(-N.x, -N.y);
              }
              this._draw(i, r, u, B), i.restore(), l.pop(), r.clip && !r.dontFinish && i.clip(this.getFillRule()), E || (tt.process(
                m,
                i,
                T,
                y,
                G.subtract(O).multiply(A)
              ), ft.release(i), r.offset = O);
            }
          }
        },
        _isUpdated: function(i) {
          var r = this._parent;
          if (r instanceof It)
            return r._isUpdated(i);
          var s = this._updateVersion === i;
          return !s && r && r._visible && r._isUpdated(i) && (this._updateVersion = i, s = !0), s;
        },
        _drawSelection: function(i, r, s, l, u) {
          var d = this._selection, p = d & 1, m = d & 2 || p && this._selectBounds, y = d & 4;
          if (this._drawSelected || (p = !1), (p || m || y) && this._isUpdated(u)) {
            var S, L = this.getSelectedColor(!0) || (S = this.getLayer()) && S.getSelectedColor(!0), E = r.appended(this.getGlobalMatrix(!0)), A = s / 2;
            if (i.strokeStyle = i.fillStyle = L ? L.toCanvasStyle(i) : "#009dec", p && this._drawSelected(i, E, l), y) {
              var T = this.getPosition(!0), G = this._parent, O = G ? G.localToGlobal(T) : T, Y = O.x, B = O.y;
              i.beginPath(), i.arc(Y, B, A, 0, Math.PI * 2, !0), i.stroke();
              for (var z = [[0, -1], [1, 0], [0, 1], [-1, 0]], C = A, N = s + 1, j = 0; j < 4; j++) {
                var q = z[j], H = q[0], te = q[1];
                i.moveTo(Y + H * C, B + te * C), i.lineTo(Y + H * N, B + te * N), i.stroke();
              }
            }
            if (m) {
              var ae = E._transformCorners(this.getInternalBounds());
              i.beginPath();
              for (var j = 0; j < 8; j++)
                i[j ? "lineTo" : "moveTo"](ae[j], ae[++j]);
              i.closePath(), i.stroke();
              for (var j = 0; j < 8; j++)
                i.fillRect(
                  ae[j] - A,
                  ae[++j] - A,
                  s,
                  s
                );
            }
          }
        },
        _canComposite: function() {
          return !1;
        }
      },
      o.each(["down", "drag", "up", "move"], function(i) {
        this["removeOn" + o.capitalize(i)] = function() {
          var r = {};
          return r[i] = !0, this.removeOn(r);
        };
      }, {
        removeOn: function(i) {
          for (var r in i)
            if (i[r]) {
              var s = "mouse" + r, l = this._project, u = l._removeSets = l._removeSets || {};
              u[s] = u[s] || {}, u[s][this._id] = this;
            }
          return this;
        }
      }),
      {
        tween: function(i, r, s) {
          s || (s = r, r = i, i = null, s || (s = r, r = null));
          var l = s && s.easing, u = s && s.start, d = s != null && (typeof s == "number" ? s : s.duration), p = new et(this, i, r, d, l, u);
          function m(y) {
            p._handleFrame(y.time * 1e3), p.running || this.off("frame", m);
          }
          return d && this.on("frame", m), p;
        },
        tweenTo: function(i, r) {
          return this.tween(null, i, r);
        },
        tweenFrom: function(i, r) {
          return this.tween(i, null, r);
        }
      }
    ), Z = X.extend({
      _class: "Group",
      _selectBounds: !1,
      _selectChildren: !0,
      _serializeFields: {
        children: []
      },
      initialize: function(i) {
        this._children = [], this._namedChildren = {}, this._initialize(i) || this.addChildren(Array.isArray(i) ? i : arguments);
      },
      _changed: function i(r) {
        i.base.call(this, r), r & 2050 && (this._clipItem = t);
      },
      _getClipItem: function() {
        var i = this._clipItem;
        if (i === t) {
          i = null;
          for (var r = this._children, s = 0, l = r.length; s < l; s++)
            if (r[s]._clipMask) {
              i = r[s];
              break;
            }
          this._clipItem = i;
        }
        return i;
      },
      isClipped: function() {
        return !!this._getClipItem();
      },
      setClipped: function(i) {
        var r = this.getFirstChild();
        r && r.setClipMask(i);
      },
      _getBounds: function i(r, s) {
        var l = this._getClipItem();
        return l ? l._getCachedBounds(
          l._matrix.prepended(r),
          o.set({}, s, { stroke: !1 })
        ) : i.base.call(this, r, s);
      },
      _hitTestChildren: function i(r, s, l) {
        var u = this._getClipItem();
        return (!u || u.contains(r)) && i.base.call(
          this,
          r,
          s,
          l,
          u
        );
      },
      _draw: function(i, r) {
        var s = r.clip, l = !s && this._getClipItem();
        r = r.extend({ clipItem: l, clip: !1 }), s ? (i.beginPath(), r.dontStart = r.dontFinish = !0) : l && l.draw(i, r.extend({ clip: !0 }));
        for (var u = this._children, d = 0, p = u.length; d < p; d++) {
          var m = u[d];
          m !== l && m.draw(i, r);
        }
      }
    }), qe = Z.extend({
      _class: "Layer",
      initialize: function() {
        Z.apply(this, arguments);
      },
      _getOwner: function() {
        return this._parent || this._index != null && this._project;
      },
      isInserted: function i() {
        return this._parent ? i.base.call(this) : this._index != null;
      },
      activate: function() {
        this._project._activeLayer = this;
      },
      _hitTestSelf: function() {
      }
    }), Oe = X.extend(
      {
        _class: "Shape",
        _applyMatrix: !1,
        _canApplyMatrix: !1,
        _canScaleStroke: !0,
        _serializeFields: {
          type: null,
          size: null,
          radius: null
        },
        initialize: function(i, r) {
          this._initialize(i, r);
        },
        _equals: function(i) {
          return this._type === i._type && this._size.equals(i._size) && o.equals(this._radius, i._radius);
        },
        copyContent: function(i) {
          this.setType(i._type), this.setSize(i._size), this.setRadius(i._radius);
        },
        getType: function() {
          return this._type;
        },
        setType: function(i) {
          this._type = i;
        },
        getShape: "#getType",
        setShape: "#setType",
        getSize: function() {
          var i = this._size;
          return new Q(i.width, i.height, this, "setSize");
        },
        setSize: function() {
          var i = U.read(arguments);
          if (!this._size)
            this._size = i.clone();
          else if (!this._size.equals(i)) {
            var r = this._type, s = i.width, l = i.height;
            r === "rectangle" ? this._radius.set(U.min(this._radius, i.divide(2).abs())) : r === "circle" ? (s = l = (s + l) / 2, this._radius = s / 2) : r === "ellipse" && this._radius._set(s / 2, l / 2), this._size._set(s, l), this._changed(9);
          }
        },
        getRadius: function() {
          var i = this._radius;
          return this._type === "circle" ? i : new Q(i.width, i.height, this, "setRadius");
        },
        setRadius: function(i) {
          var r = this._type;
          if (r === "circle") {
            if (i === this._radius)
              return;
            var s = i * 2;
            this._radius = i, this._size._set(s, s);
          } else if (i = U.read(arguments), !this._radius)
            this._radius = i.clone();
          else {
            if (this._radius.equals(i))
              return;
            if (this._radius.set(i), r === "rectangle") {
              var s = U.max(this._size, i.multiply(2));
              this._size.set(s);
            } else
              r === "ellipse" && this._size._set(i.width * 2, i.height * 2);
          }
          this._changed(9);
        },
        isEmpty: function() {
          return !1;
        },
        toPath: function(i) {
          var r = new $e[o.capitalize(this._type)]({
            center: new M(),
            size: this._size,
            radius: this._radius,
            insert: !1
          });
          return r.copyAttributes(this), Ve.settings.applyMatrix && r.setApplyMatrix(!0), (i === t || i) && r.insertAbove(this), r;
        },
        toShape: "#clone",
        _asPathItem: function() {
          return this.toPath(!1);
        },
        _draw: function(i, r, s, l) {
          var u = this._style, d = u.hasFill(), p = u.hasStroke(), m = r.dontFinish || r.clip, y = !l;
          if (d || p || m) {
            var S = this._type, L = this._radius, E = S === "circle";
            if (r.dontStart || i.beginPath(), y && E)
              i.arc(0, 0, L, 0, Math.PI * 2, !0);
            else {
              var A = E ? L : L.width, T = E ? L : L.height, G = this._size, O = G.width, Y = G.height;
              if (y && S === "rectangle" && A === 0 && T === 0)
                i.rect(-O / 2, -Y / 2, O, Y);
              else {
                var B = O / 2, z = Y / 2, C = 1 - 0.5522847498307936, N = A * C, j = T * C, q = [
                  -B,
                  -z + T,
                  -B,
                  -z + j,
                  -B + N,
                  -z,
                  -B + A,
                  -z,
                  B - A,
                  -z,
                  B - N,
                  -z,
                  B,
                  -z + j,
                  B,
                  -z + T,
                  B,
                  z - T,
                  B,
                  z - j,
                  B - N,
                  z,
                  B - A,
                  z,
                  -B + A,
                  z,
                  -B + N,
                  z,
                  -B,
                  z - j,
                  -B,
                  z - T
                ];
                l && l.transform(q, q, 32), i.moveTo(q[0], q[1]), i.bezierCurveTo(q[2], q[3], q[4], q[5], q[6], q[7]), B !== A && i.lineTo(q[8], q[9]), i.bezierCurveTo(q[10], q[11], q[12], q[13], q[14], q[15]), z !== T && i.lineTo(q[16], q[17]), i.bezierCurveTo(q[18], q[19], q[20], q[21], q[22], q[23]), B !== A && i.lineTo(q[24], q[25]), i.bezierCurveTo(q[26], q[27], q[28], q[29], q[30], q[31]);
              }
            }
            i.closePath();
          }
          !m && (d || p) && (this._setStyles(i, r, s), d && (i.fill(u.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), p && i.stroke());
        },
        _canComposite: function() {
          return !(this.hasFill() && this.hasStroke());
        },
        _getBounds: function(i, r) {
          var s = new D(this._size).setCenter(0, 0), l = this._style, u = r.stroke && l.hasStroke() && l.getStrokeWidth();
          return i && (s = i._transformBounds(s)), u ? s.expand($e._getStrokePadding(
            u,
            this._getStrokeMatrix(i, r)
          )) : s;
        }
      },
      new function() {
        function i(s, l, u) {
          var d = s._radius;
          if (!d.isZero())
            for (var p = s._size.divide(2), m = 1; m <= 4; m++) {
              var y = new M(m > 1 && m < 4 ? -1 : 1, m > 2 ? -1 : 1), S = y.multiply(p), L = S.subtract(y.multiply(d)), E = new D(
                u ? S.add(y.multiply(u)) : S,
                L
              );
              if (E.contains(l))
                return { point: L, quadrant: m };
            }
        }
        function r(s, l, u, d) {
          var p = s.divide(l);
          return (!d || p.isInQuadrant(d)) && p.subtract(p.normalize()).multiply(l).divide(u).length <= 1;
        }
        return {
          _contains: function s(l) {
            if (this._type === "rectangle") {
              var u = i(this, l);
              return u ? l.subtract(u.point).divide(this._radius).getLength() <= 1 : s.base.call(this, l);
            } else
              return l.divide(this.size).getLength() <= 0.5;
          },
          _hitTestSelf: function s(l, u, d, p) {
            var m = !1, y = this._style, S = u.stroke && y.hasStroke(), L = u.fill && y.hasFill();
            if (S || L) {
              var E = this._type, A = this._radius, T = S ? y.getStrokeWidth() / 2 : 0, G = u._tolerancePadding.add(
                $e._getStrokePadding(
                  T,
                  !y.getStrokeScaling() && p
                )
              );
              if (E === "rectangle") {
                var O = G.multiply(2), Y = i(this, l, O);
                if (Y)
                  m = r(
                    l.subtract(Y.point),
                    A,
                    G,
                    Y.quadrant
                  );
                else {
                  var B = new D(this._size).setCenter(0, 0), z = B.expand(O), C = B.expand(O.negate());
                  m = z._containsPoint(l) && !C._containsPoint(l);
                }
              } else
                m = r(l, A, G);
            }
            return m ? new Ze(S ? "stroke" : "fill", this) : s.base.apply(this, arguments);
          }
        };
      }(),
      {
        statics: new function() {
          function i(r, s, l, u, d) {
            var p = o.create(Oe.prototype);
            return p._type = r, p._size = l, p._radius = u, p._initialize(o.getNamed(d), s), p;
          }
          return {
            Circle: function() {
              var r = arguments, s = M.readNamed(r, "center"), l = o.readNamed(r, "radius");
              return i(
                "circle",
                s,
                new U(l * 2),
                l,
                r
              );
            },
            Rectangle: function() {
              var r = arguments, s = D.readNamed(r, "rectangle"), l = U.min(
                U.readNamed(r, "radius"),
                s.getSize(!0).divide(2)
              );
              return i(
                "rectangle",
                s.getCenter(!0),
                s.getSize(!0),
                l,
                r
              );
            },
            Ellipse: function() {
              var r = arguments, s = Oe._readEllipse(r), l = s.radius;
              return i(
                "ellipse",
                s.center,
                l.multiply(2),
                l,
                r
              );
            },
            _readEllipse: function(r) {
              var s, l;
              if (o.hasNamed(r, "radius"))
                s = M.readNamed(r, "center"), l = U.readNamed(r, "radius");
              else {
                var u = D.readNamed(r, "rectangle");
                s = u.getCenter(!0), l = u.getSize(!0).divide(2);
              }
              return { center: s, radius: l };
            }
          };
        }()
      }
    ), je = X.extend({
      _class: "Raster",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _boundsOptions: { stroke: !1, handle: !1 },
      _serializeFields: {
        crossOrigin: null,
        source: null
      },
      _prioritize: ["crossOrigin"],
      _smoothing: "low",
      beans: !0,
      initialize: function(i, r) {
        if (!this._initialize(
          i,
          r !== t && M.read(arguments)
        )) {
          var s, l = typeof i, u = l === "string" ? a.getElementById(i) : l === "object" ? i : null;
          if (u && u !== X.NO_INSERT) {
            if (u.getContext || u.naturalHeight != null)
              s = u;
            else if (u) {
              var d = U.read(arguments);
              d.isZero() || (s = ft.getCanvas(d));
            }
          }
          s ? this.setImage(s) : this.setSource(i);
        }
        this._size || (this._size = new U(), this._loaded = !1);
      },
      _equals: function(i) {
        return this.getSource() === i.getSource();
      },
      copyContent: function(i) {
        var r = i._image, s = i._canvas;
        if (r)
          this._setImage(r);
        else if (s) {
          var l = ft.getCanvas(i._size);
          l.getContext("2d").drawImage(s, 0, 0), this._setImage(l);
        }
        this._crossOrigin = i._crossOrigin;
      },
      getSize: function() {
        var i = this._size;
        return new Q(
          i ? i.width : 0,
          i ? i.height : 0,
          this,
          "setSize"
        );
      },
      setSize: function(i, r) {
        var s = U.read(arguments);
        if (s.equals(this._size))
          r && this.clear();
        else if (s.width > 0 && s.height > 0) {
          var l = !r && this.getElement();
          this._setImage(ft.getCanvas(s)), l && this.getContext(!0).drawImage(
            l,
            0,
            0,
            s.width,
            s.height
          );
        } else
          this._canvas && ft.release(this._canvas), this._size = s.clone();
      },
      getWidth: function() {
        return this._size ? this._size.width : 0;
      },
      setWidth: function(i) {
        this.setSize(i, this.getHeight());
      },
      getHeight: function() {
        return this._size ? this._size.height : 0;
      },
      setHeight: function(i) {
        this.setSize(this.getWidth(), i);
      },
      getLoaded: function() {
        return this._loaded;
      },
      isEmpty: function() {
        var i = this._size;
        return !i || i.width === 0 && i.height === 0;
      },
      getResolution: function() {
        var i = this._matrix, r = new M(0, 0).transform(i), s = new M(1, 0).transform(i).subtract(r), l = new M(0, 1).transform(i).subtract(r);
        return new U(
          72 / s.getLength(),
          72 / l.getLength()
        );
      },
      getPpi: "#getResolution",
      getImage: function() {
        return this._image;
      },
      setImage: function(i) {
        var r = this;
        function s(l) {
          var u = r.getView(), d = l && l.type || "load";
          u && r.responds(d) && (Ve = u._scope, r.emit(d, new Gi(l)));
        }
        this._setImage(i), this._loaded ? setTimeout(s, 0) : i && Jt.add(i, {
          load: function(l) {
            r._setImage(i), s(l);
          },
          error: s
        });
      },
      _setImage: function(i) {
        this._canvas && ft.release(this._canvas), i && i.getContext ? (this._image = null, this._canvas = i, this._loaded = !0) : (this._image = i, this._canvas = null, this._loaded = !!(i && i.src && i.complete)), this._size = new U(
          i ? i.naturalWidth || i.width : 0,
          i ? i.naturalHeight || i.height : 0
        ), this._context = null, this._changed(1033);
      },
      getCanvas: function() {
        if (!this._canvas) {
          var i = ft.getContext(this._size);
          try {
            this._image && i.drawImage(this._image, 0, 0), this._canvas = i.canvas;
          } catch {
            ft.release(i);
          }
        }
        return this._canvas;
      },
      setCanvas: "#setImage",
      getContext: function(i) {
        return this._context || (this._context = this.getCanvas().getContext("2d")), i && (this._image = null, this._changed(1025)), this._context;
      },
      setContext: function(i) {
        this._context = i;
      },
      getSource: function() {
        var i = this._image;
        return i && i.src || this.toDataURL();
      },
      setSource: function(i) {
        var r = new e.Image(), s = this._crossOrigin;
        s && (r.crossOrigin = s), i && (r.src = i), this.setImage(r);
      },
      getCrossOrigin: function() {
        var i = this._image;
        return i && i.crossOrigin || this._crossOrigin || "";
      },
      setCrossOrigin: function(i) {
        this._crossOrigin = i;
        var r = this._image;
        r && (r.crossOrigin = i);
      },
      getSmoothing: function() {
        return this._smoothing;
      },
      setSmoothing: function(i) {
        this._smoothing = typeof i == "string" ? i : i ? "low" : "off", this._changed(257);
      },
      getElement: function() {
        return this._canvas || this._loaded && this._image;
      }
    }, {
      beans: !1,
      getSubCanvas: function() {
        var i = D.read(arguments), r = ft.getContext(i.getSize());
        return r.drawImage(
          this.getCanvas(),
          i.x,
          i.y,
          i.width,
          i.height,
          0,
          0,
          i.width,
          i.height
        ), r.canvas;
      },
      getSubRaster: function() {
        var i = D.read(arguments), r = new je(X.NO_INSERT);
        return r._setImage(this.getSubCanvas(i)), r.translate(i.getCenter().subtract(this.getSize().divide(2))), r._matrix.prepend(this._matrix), r.insertAbove(this), r;
      },
      toDataURL: function() {
        var i = this._image, r = i && i.src;
        if (/^data:/.test(r))
          return r;
        var s = this.getCanvas();
        return s ? s.toDataURL.apply(s, arguments) : null;
      },
      drawImage: function(i) {
        var r = M.read(arguments, 1);
        this.getContext(!0).drawImage(i, r.x, r.y);
      },
      getAverageColor: function(i) {
        var r, s;
        if (i ? i instanceof Gt ? (s = i, r = i.getBounds()) : typeof i == "object" && ("width" in i ? r = new D(i) : "x" in i && (r = new D(i.x - 0.5, i.y - 0.5, 1, 1))) : r = this.getBounds(), !r)
          return null;
        var l = 32, u = Math.min(r.width, l), d = Math.min(r.height, l), p = je._sampleContext;
        p ? p.clearRect(0, 0, l + 1, l + 1) : p = je._sampleContext = ft.getContext(
          new U(l)
        ), p.save();
        var m = new J().scale(u / r.width, d / r.height).translate(-r.x, -r.y);
        m.applyToContext(p), s && s.draw(p, new o({ clip: !0, matrices: [m] })), this._matrix.applyToContext(p);
        var y = this.getElement(), S = this._size;
        y && p.drawImage(y, -S.width / 2, -S.height / 2), p.restore();
        for (var L = p.getImageData(
          0.5,
          0.5,
          Math.ceil(u),
          Math.ceil(d)
        ).data, E = [0, 0, 0], A = 0, T = 0, G = L.length; T < G; T += 4) {
          var O = L[T + 3];
          A += O, O /= 255, E[0] += L[T] * O, E[1] += L[T + 1] * O, E[2] += L[T + 2] * O;
        }
        for (var T = 0; T < 3; T++)
          E[T] /= A;
        return A ? Tt.read(E) : null;
      },
      getPixel: function() {
        var i = M.read(arguments), r = this.getContext().getImageData(i.x, i.y, 1, 1).data;
        return new Tt(
          "rgb",
          [r[0] / 255, r[1] / 255, r[2] / 255],
          r[3] / 255
        );
      },
      setPixel: function() {
        var i = arguments, r = M.read(i), s = Tt.read(i), l = s._convert("rgb"), u = s._alpha, d = this.getContext(!0), p = d.createImageData(1, 1), m = p.data;
        m[0] = l[0] * 255, m[1] = l[1] * 255, m[2] = l[2] * 255, m[3] = u != null ? u * 255 : 255, d.putImageData(p, r.x, r.y);
      },
      clear: function() {
        var i = this._size;
        this.getContext(!0).clearRect(0, 0, i.width + 1, i.height + 1);
      },
      createImageData: function() {
        var i = U.read(arguments);
        return this.getContext().createImageData(i.width, i.height);
      },
      getImageData: function() {
        var i = D.read(arguments);
        return i.isEmpty() && (i = new D(this._size)), this.getContext().getImageData(
          i.x,
          i.y,
          i.width,
          i.height
        );
      },
      putImageData: function(i) {
        var r = M.read(arguments, 1);
        this.getContext(!0).putImageData(i, r.x, r.y);
      },
      setImageData: function(i) {
        this.setSize(i), this.getContext(!0).putImageData(i, 0, 0);
      },
      _getBounds: function(i, r) {
        var s = new D(this._size).setCenter(0, 0);
        return i ? i._transformBounds(s) : s;
      },
      _hitTestSelf: function(i) {
        if (this._contains(i)) {
          var r = this;
          return new Ze("pixel", r, {
            offset: i.add(r._size.divide(2)).round(),
            color: {
              get: function() {
                return r.getPixel(this.offset);
              }
            }
          });
        }
      },
      _draw: function(i, r, s) {
        var l = this.getElement();
        if (l && l.width > 0 && l.height > 0) {
          i.globalAlpha = I.clamp(this._opacity, 0, 1), this._setStyles(i, r, s);
          var u = this._smoothing, d = u === "off";
          Zt.setPrefixed(
            i,
            d ? "imageSmoothingEnabled" : "imageSmoothingQuality",
            d ? !1 : u
          ), i.drawImage(
            l,
            -this._size.width / 2,
            -this._size.height / 2
          );
        }
      },
      _canComposite: function() {
        return !0;
      }
    }), pt = X.extend({
      _class: "SymbolItem",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _boundsOptions: { stroke: !0 },
      _serializeFields: {
        symbol: null
      },
      initialize: function(i, r) {
        this._initialize(
          i,
          r !== t && M.read(arguments, 1)
        ) || this.setDefinition(i instanceof Te ? i : new Te(i));
      },
      _equals: function(i) {
        return this._definition === i._definition;
      },
      copyContent: function(i) {
        this.setDefinition(i._definition);
      },
      getDefinition: function() {
        return this._definition;
      },
      setDefinition: function(i) {
        this._definition = i, this._changed(9);
      },
      getSymbol: "#getDefinition",
      setSymbol: "#setDefinition",
      isEmpty: function() {
        return this._definition._item.isEmpty();
      },
      _getBounds: function(i, r) {
        var s = this._definition._item;
        return s._getCachedBounds(s._matrix.prepended(i), r);
      },
      _hitTestSelf: function(i, r, s) {
        var l = r.extend({ all: !1 }), u = this._definition._item._hitTest(i, l, s);
        return u && (u.item = this), u;
      },
      _draw: function(i, r) {
        this._definition._item.draw(i, r);
      }
    }), Te = o.extend({
      _class: "SymbolDefinition",
      initialize: function(i, r) {
        this._id = V.get(), this.project = Ve.project, i && this.setItem(i, r);
      },
      _serialize: function(i, r) {
        return r.add(this, function() {
          return o.serialize(
            [this._class, this._item],
            i,
            !1,
            r
          );
        });
      },
      _changed: function(i) {
        i & 8 && X._clearBoundsCache(this), i & 1 && this.project._changed(i);
      },
      getItem: function() {
        return this._item;
      },
      setItem: function(i, r) {
        i._symbol && (i = i.clone()), this._item && (this._item._symbol = null), this._item = i, i.remove(), i.setSelected(!1), r || i.setPosition(new M()), i._symbol = this, this._changed(9);
      },
      getDefinition: "#getItem",
      setDefinition: "#setItem",
      place: function(i) {
        return new pt(this, i);
      },
      clone: function() {
        return new Te(this._item.clone(!1));
      },
      equals: function(i) {
        return i === this || i && this._item.equals(i._item) || !1;
      }
    }), Ze = o.extend({
      _class: "HitResult",
      initialize: function(i, r, s) {
        this.type = i, this.item = r, s && this.inject(s);
      },
      statics: {
        getOptions: function(i) {
          var r = i && o.read(i);
          return new o({
            type: null,
            tolerance: Ve.settings.hitTolerance,
            fill: !r,
            stroke: !r,
            segments: !r,
            handles: !1,
            ends: !1,
            position: !1,
            center: !1,
            bounds: !1,
            guides: !1,
            selected: !1
          }, r);
        }
      }
    }), ce = o.extend({
      _class: "Segment",
      beans: !0,
      _selection: 0,
      initialize: function(i, r, s, l, u, d) {
        var p = arguments.length, m, y, S, L;
        p > 0 && (i == null || typeof i == "object" ? p === 1 && i && "point" in i ? (m = i.point, y = i.handleIn, S = i.handleOut, L = i.selection) : (m = i, y = r, S = s, L = l) : (m = [i, r], y = s !== t ? [s, l] : null, S = u !== t ? [u, d] : null)), new ut(m, this, "_point"), new ut(y, this, "_handleIn"), new ut(S, this, "_handleOut"), L && this.setSelection(L);
      },
      _serialize: function(i, r) {
        var s = this._point, l = this._selection, u = l || this.hasHandles() ? [s, this._handleIn, this._handleOut] : s;
        return l && u.push(l), o.serialize(u, i, !0, r);
      },
      _changed: function(i) {
        var r = this._path;
        if (r) {
          var s = r._curves, l = this._index, u;
          s && ((!i || i === this._point || i === this._handleIn) && (u = l > 0 ? s[l - 1] : r._closed ? s[s.length - 1] : null) && u._changed(), (!i || i === this._point || i === this._handleOut) && (u = s[l]) && u._changed()), r._changed(41);
        }
      },
      getPoint: function() {
        return this._point;
      },
      setPoint: function() {
        this._point.set(M.read(arguments));
      },
      getHandleIn: function() {
        return this._handleIn;
      },
      setHandleIn: function() {
        this._handleIn.set(M.read(arguments));
      },
      getHandleOut: function() {
        return this._handleOut;
      },
      setHandleOut: function() {
        this._handleOut.set(M.read(arguments));
      },
      hasHandles: function() {
        return !this._handleIn.isZero() || !this._handleOut.isZero();
      },
      isSmooth: function() {
        var i = this._handleIn, r = this._handleOut;
        return !i.isZero() && !r.isZero() && i.isCollinear(r);
      },
      clearHandles: function() {
        this._handleIn._set(0, 0), this._handleOut._set(0, 0);
      },
      getSelection: function() {
        return this._selection;
      },
      setSelection: function(i) {
        var r = this._selection, s = this._path;
        this._selection = i = i || 0, s && i !== r && (s._updateSelection(this, r, i), s._changed(257));
      },
      _changeSelection: function(i, r) {
        var s = this._selection;
        this.setSelection(r ? s | i : s & ~i);
      },
      isSelected: function() {
        return !!(this._selection & 7);
      },
      setSelected: function(i) {
        this._changeSelection(7, i);
      },
      getIndex: function() {
        return this._index !== t ? this._index : null;
      },
      getPath: function() {
        return this._path || null;
      },
      getCurve: function() {
        var i = this._path, r = this._index;
        return i ? (r > 0 && !i._closed && r === i._segments.length - 1 && r--, i.getCurves()[r] || null) : null;
      },
      getLocation: function() {
        var i = this.getCurve();
        return i ? new ht(i, this === i._segment1 ? 0 : 1) : null;
      },
      getNext: function() {
        var i = this._path && this._path._segments;
        return i && (i[this._index + 1] || this._path._closed && i[0]) || null;
      },
      smooth: function(i, r, s) {
        var l = i || {}, u = l.type, d = l.factor, p = this.getPrevious(), m = this.getNext(), y = (p || this)._point, S = this._point, L = (m || this)._point, E = y.getDistance(S), A = S.getDistance(L);
        if (!u || u === "catmull-rom") {
          var T = d === t ? 0.5 : d, G = Math.pow(E, T), O = G * G, Y = Math.pow(A, T), B = Y * Y;
          if (!r && p) {
            var z = 2 * B + 3 * Y * G + O, C = 3 * Y * (Y + G);
            this.setHandleIn(C !== 0 ? new M(
              (B * y._x + z * S._x - O * L._x) / C - S._x,
              (B * y._y + z * S._y - O * L._y) / C - S._y
            ) : new M());
          }
          if (!s && m) {
            var z = 2 * O + 3 * G * Y + B, C = 3 * G * (G + Y);
            this.setHandleOut(C !== 0 ? new M(
              (O * L._x + z * S._x - B * y._x) / C - S._x,
              (O * L._y + z * S._y - B * y._y) / C - S._y
            ) : new M());
          }
        } else if (u === "geometric") {
          if (p && m) {
            var N = y.subtract(L), j = d === t ? 0.4 : d, q = j * E / (E + A);
            r || this.setHandleIn(N.multiply(q)), s || this.setHandleOut(N.multiply(q - j));
          }
        } else
          throw new Error("Smoothing method '" + u + "' not supported.");
      },
      getPrevious: function() {
        var i = this._path && this._path._segments;
        return i && (i[this._index - 1] || this._path._closed && i[i.length - 1]) || null;
      },
      isFirst: function() {
        return !this._index;
      },
      isLast: function() {
        var i = this._path;
        return i && this._index === i._segments.length - 1 || !1;
      },
      reverse: function() {
        var i = this._handleIn, r = this._handleOut, s = i.clone();
        i.set(r), r.set(s);
      },
      reversed: function() {
        return new ce(this._point, this._handleOut, this._handleIn);
      },
      remove: function() {
        return this._path ? !!this._path.removeSegment(this._index) : !1;
      },
      clone: function() {
        return new ce(this._point, this._handleIn, this._handleOut);
      },
      equals: function(i) {
        return i === this || i && this._class === i._class && this._point.equals(i._point) && this._handleIn.equals(i._handleIn) && this._handleOut.equals(i._handleOut) || !1;
      },
      toString: function() {
        var i = ["point: " + this._point];
        return this._handleIn.isZero() || i.push("handleIn: " + this._handleIn), this._handleOut.isZero() || i.push("handleOut: " + this._handleOut), "{ " + i.join(", ") + " }";
      },
      transform: function(i) {
        this._transformCoordinates(i, new Array(6), !0), this._changed();
      },
      interpolate: function(i, r, s) {
        var l = 1 - s, u = s, d = i._point, p = r._point, m = i._handleIn, y = r._handleIn, S = r._handleOut, L = i._handleOut;
        this._point._set(
          l * d._x + u * p._x,
          l * d._y + u * p._y,
          !0
        ), this._handleIn._set(
          l * m._x + u * y._x,
          l * m._y + u * y._y,
          !0
        ), this._handleOut._set(
          l * L._x + u * S._x,
          l * L._y + u * S._y,
          !0
        ), this._changed();
      },
      _transformCoordinates: function(i, r, s) {
        var l = this._point, u = !s || !this._handleIn.isZero() ? this._handleIn : null, d = !s || !this._handleOut.isZero() ? this._handleOut : null, p = l._x, m = l._y, y = 2;
        return r[0] = p, r[1] = m, u && (r[y++] = u._x + p, r[y++] = u._y + m), d && (r[y++] = d._x + p, r[y++] = d._y + m), i && (i._transformCoordinates(r, r, y / 2), p = r[0], m = r[1], s ? (l._x = p, l._y = m, y = 2, u && (u._x = r[y++] - p, u._y = r[y++] - m), d && (d._x = r[y++] - p, d._y = r[y++] - m)) : (u || (r[y++] = p, r[y++] = m), d || (r[y++] = p, r[y++] = m))), r;
      }
    }), ut = M.extend({
      initialize: function(i, r, s) {
        var l, u, d;
        if (!i)
          l = u = 0;
        else if ((l = i[0]) !== t)
          u = i[1];
        else {
          var p = i;
          (l = p.x) === t && (p = M.read(arguments), l = p.x), u = p.y, d = p.selected;
        }
        this._x = l, this._y = u, this._owner = r, r[s] = this, d && this.setSelected(!0);
      },
      _set: function(i, r) {
        return this._x = i, this._y = r, this._owner._changed(this), this;
      },
      getX: function() {
        return this._x;
      },
      setX: function(i) {
        this._x = i, this._owner._changed(this);
      },
      getY: function() {
        return this._y;
      },
      setY: function(i) {
        this._y = i, this._owner._changed(this);
      },
      isZero: function() {
        var i = I.isZero;
        return i(this._x) && i(this._y);
      },
      isSelected: function() {
        return !!(this._owner._selection & this._getSelection());
      },
      setSelected: function(i) {
        this._owner._changeSelection(this._getSelection(), i);
      },
      _getSelection: function() {
        var i = this._owner;
        return this === i._point ? 1 : this === i._handleIn ? 2 : this === i._handleOut ? 4 : 0;
      }
    }), ze = o.extend(
      {
        _class: "Curve",
        beans: !0,
        initialize: function(i, r, s, l, u, d, p, m) {
          var y = arguments.length, S, L, E, A, T, G;
          y === 3 ? (this._path = i, S = r, L = s) : y ? y === 1 ? "segment1" in i ? (S = new ce(i.segment1), L = new ce(i.segment2)) : "point1" in i ? (E = i.point1, T = i.handle1, G = i.handle2, A = i.point2) : Array.isArray(i) && (E = [i[0], i[1]], A = [i[6], i[7]], T = [i[2] - i[0], i[3] - i[1]], G = [i[4] - i[6], i[5] - i[7]]) : y === 2 ? (S = new ce(i), L = new ce(r)) : y === 4 ? (E = i, T = r, G = s, A = l) : y === 8 && (E = [i, r], A = [p, m], T = [s - i, l - r], G = [u - p, d - m]) : (S = new ce(), L = new ce()), this._segment1 = S || new ce(E, null, T), this._segment2 = L || new ce(A, G, null);
        },
        _serialize: function(i, r) {
          return o.serialize(
            this.hasHandles() ? [
              this.getPoint1(),
              this.getHandle1(),
              this.getHandle2(),
              this.getPoint2()
            ] : [this.getPoint1(), this.getPoint2()],
            i,
            !0,
            r
          );
        },
        _changed: function() {
          this._length = this._bounds = t;
        },
        clone: function() {
          return new ze(this._segment1, this._segment2);
        },
        toString: function() {
          var i = ["point1: " + this._segment1._point];
          return this._segment1._handleOut.isZero() || i.push("handle1: " + this._segment1._handleOut), this._segment2._handleIn.isZero() || i.push("handle2: " + this._segment2._handleIn), i.push("point2: " + this._segment2._point), "{ " + i.join(", ") + " }";
        },
        classify: function() {
          return ze.classify(this.getValues());
        },
        remove: function() {
          var i = !1;
          if (this._path) {
            var r = this._segment2, s = r._handleOut;
            i = r.remove(), i && this._segment1._handleOut.set(s);
          }
          return i;
        },
        getPoint1: function() {
          return this._segment1._point;
        },
        setPoint1: function() {
          this._segment1._point.set(M.read(arguments));
        },
        getPoint2: function() {
          return this._segment2._point;
        },
        setPoint2: function() {
          this._segment2._point.set(M.read(arguments));
        },
        getHandle1: function() {
          return this._segment1._handleOut;
        },
        setHandle1: function() {
          this._segment1._handleOut.set(M.read(arguments));
        },
        getHandle2: function() {
          return this._segment2._handleIn;
        },
        setHandle2: function() {
          this._segment2._handleIn.set(M.read(arguments));
        },
        getSegment1: function() {
          return this._segment1;
        },
        getSegment2: function() {
          return this._segment2;
        },
        getPath: function() {
          return this._path;
        },
        getIndex: function() {
          return this._segment1._index;
        },
        getNext: function() {
          var i = this._path && this._path._curves;
          return i && (i[this._segment1._index + 1] || this._path._closed && i[0]) || null;
        },
        getPrevious: function() {
          var i = this._path && this._path._curves;
          return i && (i[this._segment1._index - 1] || this._path._closed && i[i.length - 1]) || null;
        },
        isFirst: function() {
          return !this._segment1._index;
        },
        isLast: function() {
          var i = this._path;
          return i && this._segment1._index === i._curves.length - 1 || !1;
        },
        isSelected: function() {
          return this.getPoint1().isSelected() && this.getHandle1().isSelected() && this.getHandle2().isSelected() && this.getPoint2().isSelected();
        },
        setSelected: function(i) {
          this.getPoint1().setSelected(i), this.getHandle1().setSelected(i), this.getHandle2().setSelected(i), this.getPoint2().setSelected(i);
        },
        getValues: function(i) {
          return ze.getValues(this._segment1, this._segment2, i);
        },
        getPoints: function() {
          for (var i = this.getValues(), r = [], s = 0; s < 8; s += 2)
            r.push(new M(i[s], i[s + 1]));
          return r;
        }
      },
      {
        getLength: function() {
          return this._length == null && (this._length = ze.getLength(this.getValues(), 0, 1)), this._length;
        },
        getArea: function() {
          return ze.getArea(this.getValues());
        },
        getLine: function() {
          return new he(this._segment1._point, this._segment2._point);
        },
        getPart: function(i, r) {
          return new ze(ze.getPart(this.getValues(), i, r));
        },
        getPartLength: function(i, r) {
          return ze.getLength(this.getValues(), i, r);
        },
        divideAt: function(i) {
          return this.divideAtTime(i && i.curve === this ? i.time : this.getTimeAt(i));
        },
        divideAtTime: function(i, r) {
          var s = 1e-8, l = 1 - s, u = null;
          if (i >= s && i <= l) {
            var d = ze.subdivide(this.getValues(), i), p = d[0], m = d[1], y = r || this.hasHandles(), S = this._segment1, L = this._segment2, E = this._path;
            y && (S._handleOut._set(p[2] - p[0], p[3] - p[1]), L._handleIn._set(m[4] - m[6], m[5] - m[7]));
            var A = p[6], T = p[7], G = new ce(
              new M(A, T),
              y && new M(p[4] - A, p[5] - T),
              y && new M(m[2] - A, m[3] - T)
            );
            E ? (E.insert(S._index + 1, G), u = this.getNext()) : (this._segment2 = G, this._changed(), u = new ze(G, L));
          }
          return u;
        },
        splitAt: function(i) {
          var r = this._path;
          return r ? r.splitAt(i) : null;
        },
        splitAtTime: function(i) {
          return this.splitAt(this.getLocationAtTime(i));
        },
        divide: function(i, r) {
          return this.divideAtTime(i === t ? 0.5 : r ? i : this.getTimeAt(i));
        },
        split: function(i, r) {
          return this.splitAtTime(i === t ? 0.5 : r ? i : this.getTimeAt(i));
        },
        reversed: function() {
          return new ze(this._segment2.reversed(), this._segment1.reversed());
        },
        clearHandles: function() {
          this._segment1._handleOut._set(0, 0), this._segment2._handleIn._set(0, 0);
        },
        statics: {
          getValues: function(i, r, s, l) {
            var u = i._point, d = i._handleOut, p = r._handleIn, m = r._point, y = u.x, S = u.y, L = m.x, E = m.y, A = l ? [y, S, y, S, L, E, L, E] : [
              y,
              S,
              y + d._x,
              S + d._y,
              L + p._x,
              E + p._y,
              L,
              E
            ];
            return s && s._transformCoordinates(A, A, 4), A;
          },
          subdivide: function(i, r) {
            var s = i[0], l = i[1], u = i[2], d = i[3], p = i[4], m = i[5], y = i[6], S = i[7];
            r === t && (r = 0.5);
            var L = 1 - r, E = L * s + r * u, A = L * l + r * d, T = L * u + r * p, G = L * d + r * m, O = L * p + r * y, Y = L * m + r * S, B = L * E + r * T, z = L * A + r * G, C = L * T + r * O, N = L * G + r * Y, j = L * B + r * C, q = L * z + r * N;
            return [
              [s, l, E, A, B, z, j, q],
              [j, q, C, N, O, Y, y, S]
            ];
          },
          getMonoCurves: function(i, r) {
            var s = [], l = r ? 0 : 1, u = i[l + 0], d = i[l + 2], p = i[l + 4], m = i[l + 6];
            if (u >= d == d >= p && d >= p == p >= m || ze.isStraight(i))
              s.push(i);
            else {
              var y = 3 * (d - p) - u + m, S = 2 * (u + p) - 4 * d, L = d - u, E = 1e-8, A = 1 - E, T = [], G = I.solveQuadratic(y, S, L, T, E, A);
              if (!G)
                s.push(i);
              else {
                T.sort();
                var O = T[0], Y = ze.subdivide(i, O);
                s.push(Y[0]), G > 1 && (O = (T[1] - O) / (1 - O), Y = ze.subdivide(Y[1], O), s.push(Y[0])), s.push(Y[1]);
              }
            }
            return s;
          },
          solveCubic: function(i, r, s, l, u, d) {
            var p = i[r], m = i[r + 2], y = i[r + 4], S = i[r + 6], L = 0;
            if (!(p < s && S < s && m < s && y < s || p > s && S > s && m > s && y > s)) {
              var E = 3 * (m - p), A = 3 * (y - m) - E, T = S - p - E - A;
              L = I.solveCubic(T, A, E, p - s, l, u, d);
            }
            return L;
          },
          getTimeOf: function(i, r) {
            var s = new M(i[0], i[1]), l = new M(i[6], i[7]), u = 1e-12, d = 1e-7, p = r.isClose(s, u) ? 0 : r.isClose(l, u) ? 1 : null;
            if (p === null)
              for (var m = [r.x, r.y], y = [], S = 0; S < 2; S++)
                for (var L = ze.solveCubic(i, S, m[S], y, 0, 1), E = 0; E < L; E++) {
                  var A = y[E];
                  if (r.isClose(ze.getPoint(i, A), d))
                    return A;
                }
            return r.isClose(s, d) ? 0 : r.isClose(l, d) ? 1 : null;
          },
          getNearestTime: function(i, r) {
            if (ze.isStraight(i)) {
              var s = i[0], l = i[1], u = i[6], d = i[7], p = u - s, m = d - l, y = p * p + m * m;
              if (y === 0)
                return 0;
              var S = ((r.x - s) * p + (r.y - l) * m) / y;
              return S < 1e-12 ? 0 : S > 0.999999999999 ? 1 : ze.getTimeOf(
                i,
                new M(s + S * p, l + S * m)
              );
            }
            var L = 100, E = 1 / 0, A = 0;
            function T(Y) {
              if (Y >= 0 && Y <= 1) {
                var B = r.getDistance(ze.getPoint(i, Y), !0);
                if (B < E)
                  return E = B, A = Y, !0;
              }
            }
            for (var G = 0; G <= L; G++)
              T(G / L);
            for (var O = 1 / (L * 2); O > 1e-8; )
              !T(A - O) && !T(A + O) && (O /= 2);
            return A;
          },
          getPart: function(i, r, s) {
            var l = r > s;
            if (l) {
              var u = r;
              r = s, s = u;
            }
            return r > 0 && (i = ze.subdivide(i, r)[1]), s < 1 && (i = ze.subdivide(i, (s - r) / (1 - r))[0]), l ? [i[6], i[7], i[4], i[5], i[2], i[3], i[0], i[1]] : i;
          },
          isFlatEnough: function(i, r) {
            var s = i[0], l = i[1], u = i[2], d = i[3], p = i[4], m = i[5], y = i[6], S = i[7], L = 3 * u - 2 * s - y, E = 3 * d - 2 * l - S, A = 3 * p - 2 * y - s, T = 3 * m - 2 * S - l;
            return Math.max(L * L, A * A) + Math.max(E * E, T * T) <= 16 * r * r;
          },
          getArea: function(i) {
            var r = i[0], s = i[1], l = i[2], u = i[3], d = i[4], p = i[5], m = i[6], y = i[7];
            return 3 * ((y - s) * (l + d) - (m - r) * (u + p) + u * (r - d) - l * (s - p) + y * (d + r / 3) - m * (p + s / 3)) / 20;
          },
          getBounds: function(i) {
            for (var r = i.slice(0, 2), s = r.slice(), l = [0, 0], u = 0; u < 2; u++)
              ze._addBounds(
                i[u],
                i[u + 2],
                i[u + 4],
                i[u + 6],
                u,
                0,
                r,
                s,
                l
              );
            return new D(r[0], r[1], s[0] - r[0], s[1] - r[1]);
          },
          _addBounds: function(i, r, s, l, u, d, p, m, y) {
            function S(j, q) {
              var H = j - q, te = j + q;
              H < p[u] && (p[u] = H), te > m[u] && (m[u] = te);
            }
            d /= 2;
            var L = p[u] + d, E = m[u] - d;
            if (i < L || r < L || s < L || l < L || i > E || r > E || s > E || l > E)
              if (r < i != r < l && s < i != s < l)
                S(i, 0), S(l, 0);
              else {
                var A = 3 * (r - s) - i + l, T = 2 * (i + s) - 4 * r, G = r - i, O = I.solveQuadratic(A, T, G, y), Y = 1e-8, B = 1 - Y;
                S(l, 0);
                for (var z = 0; z < O; z++) {
                  var C = y[z], N = 1 - C;
                  Y <= C && C <= B && S(
                    N * N * N * i + 3 * N * N * C * r + 3 * N * C * C * s + C * C * C * l,
                    d
                  );
                }
              }
          }
        }
      },
      o.each(
        ["getBounds", "getStrokeBounds", "getHandleBounds"],
        function(i) {
          this[i] = function() {
            this._bounds || (this._bounds = {});
            var r = this._bounds[i];
            return r || (r = this._bounds[i] = $e[i](
              [this._segment1, this._segment2],
              !1,
              this._path
            )), r.clone();
          };
        },
        {}
      ),
      o.each({
        isStraight: function(i, r, s, l) {
          if (r.isZero() && s.isZero())
            return !0;
          var u = l.subtract(i);
          if (u.isZero())
            return !1;
          if (u.isCollinear(r) && u.isCollinear(s)) {
            var d = new he(i, l), p = 1e-7;
            if (d.getDistance(i.add(r)) < p && d.getDistance(l.add(s)) < p) {
              var m = u.dot(u), y = u.dot(r) / m, S = u.dot(s) / m;
              return y >= 0 && y <= 1 && S <= 0 && S >= -1;
            }
          }
          return !1;
        },
        isLinear: function(i, r, s, l) {
          var u = l.subtract(i).divide(3);
          return r.equals(u) && s.negate().equals(u);
        }
      }, function(i, r) {
        this[r] = function(s) {
          var l = this._segment1, u = this._segment2;
          return i(
            l._point,
            l._handleOut,
            u._handleIn,
            u._point,
            s
          );
        }, this.statics[r] = function(s, l) {
          var u = s[0], d = s[1], p = s[6], m = s[7];
          return i(
            new M(u, d),
            new M(s[2] - u, s[3] - d),
            new M(s[4] - p, s[5] - m),
            new M(p, m),
            l
          );
        };
      }, {
        statics: {},
        hasHandles: function() {
          return !this._segment1._handleOut.isZero() || !this._segment2._handleIn.isZero();
        },
        hasLength: function(i) {
          return (!this.getPoint1().equals(this.getPoint2()) || this.hasHandles()) && this.getLength() > (i || 0);
        },
        isCollinear: function(i) {
          return i && this.isStraight() && i.isStraight() && this.getLine().isCollinear(i.getLine());
        },
        isHorizontal: function() {
          return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).y) < 1e-8;
        },
        isVertical: function() {
          return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).x) < 1e-8;
        }
      }),
      {
        beans: !1,
        getLocationAt: function(i, r) {
          return this.getLocationAtTime(
            r ? i : this.getTimeAt(i)
          );
        },
        getLocationAtTime: function(i) {
          return i != null && i >= 0 && i <= 1 ? new ht(this, i) : null;
        },
        getTimeAt: function(i, r) {
          return ze.getTimeAt(this.getValues(), i, r);
        },
        getParameterAt: "#getTimeAt",
        getTimesWithTangent: function() {
          var i = M.read(arguments);
          return i.isZero() ? [] : ze.getTimesWithTangent(this.getValues(), i);
        },
        getOffsetAtTime: function(i) {
          return this.getPartLength(0, i);
        },
        getLocationOf: function() {
          return this.getLocationAtTime(this.getTimeOf(M.read(arguments)));
        },
        getOffsetOf: function() {
          var i = this.getLocationOf.apply(this, arguments);
          return i ? i.getOffset() : null;
        },
        getTimeOf: function() {
          return ze.getTimeOf(this.getValues(), M.read(arguments));
        },
        getParameterOf: "#getTimeOf",
        getNearestLocation: function() {
          var i = M.read(arguments), r = this.getValues(), s = ze.getNearestTime(r, i), l = ze.getPoint(r, s);
          return new ht(this, s, l, null, i.getDistance(l));
        },
        getNearestPoint: function() {
          var i = this.getNearestLocation.apply(this, arguments);
          return i && i.getPoint();
        }
      },
      new function() {
        var i = [
          "getPoint",
          "getTangent",
          "getNormal",
          "getWeightedTangent",
          "getWeightedNormal",
          "getCurvature"
        ];
        return o.each(
          i,
          function(r) {
            this[r + "At"] = function(s, l) {
              var u = this.getValues();
              return ze[r](u, l ? s : ze.getTimeAt(u, s));
            }, this[r + "AtTime"] = function(s) {
              return ze[r](this.getValues(), s);
            };
          },
          {
            statics: {
              _evaluateMethods: i
            }
          }
        );
      }(),
      new function() {
        function i(l) {
          var u = l[0], d = l[1], p = l[2], m = l[3], y = l[4], S = l[5], L = l[6], E = l[7], A = 9 * (p - y) + 3 * (L - u), T = 6 * (u + y) - 12 * p, G = 3 * (p - u), O = 9 * (m - S) + 3 * (E - d), Y = 6 * (d + S) - 12 * m, B = 3 * (m - d);
          return function(z) {
            var C = (A * z + T) * z + G, N = (O * z + Y) * z + B;
            return Math.sqrt(C * C + N * N);
          };
        }
        function r(l, u) {
          return Math.max(2, Math.min(16, Math.ceil(Math.abs(u - l) * 32)));
        }
        function s(l, u, d, p) {
          if (u == null || u < 0 || u > 1)
            return null;
          var m = l[0], y = l[1], S = l[2], L = l[3], E = l[4], A = l[5], T = l[6], G = l[7], O = I.isZero;
          O(S - m) && O(L - y) && (S = m, L = y), O(E - T) && O(A - G) && (E = T, A = G);
          var Y = 3 * (S - m), B = 3 * (E - S) - Y, z = T - m - Y - B, C = 3 * (L - y), N = 3 * (A - L) - C, j = G - y - C - N, q, H;
          if (d === 0)
            q = u === 0 ? m : u === 1 ? T : ((z * u + B) * u + Y) * u + m, H = u === 0 ? y : u === 1 ? G : ((j * u + N) * u + C) * u + y;
          else {
            var te = 1e-8, ae = 1 - te;
            if (u < te ? (q = Y, H = C) : u > ae ? (q = 3 * (T - E), H = 3 * (G - A)) : (q = (3 * z * u + 2 * B) * u + Y, H = (3 * j * u + 2 * N) * u + C), p) {
              q === 0 && H === 0 && (u < te || u > ae) && (q = E - S, H = A - L);
              var le = Math.sqrt(q * q + H * H);
              le && (q /= le, H /= le);
            }
            if (d === 3) {
              var E = 6 * z * u + 2 * B, A = 6 * j * u + 2 * N, me = Math.pow(q * q + H * H, 3 / 2);
              q = me !== 0 ? (q * A - H * E) / me : 0, H = 0;
            }
          }
          return d === 2 ? new M(H, -q) : new M(q, H);
        }
        return { statics: {
          classify: function(l) {
            var u = l[0], d = l[1], p = l[2], m = l[3], y = l[4], S = l[5], L = l[6], E = l[7], A = u * (E - S) + d * (y - L) + L * S - E * y, T = p * (d - E) + m * (L - u) + u * E - d * L, G = y * (m - d) + S * (u - p) + p * d - m * u, O = 3 * G, Y = O - T, B = Y - T + A, z = Math.sqrt(B * B + Y * Y + O * O), C = z !== 0 ? 1 / z : 0, N = I.isZero, j = "serpentine";
            B *= C, Y *= C, O *= C;
            function q(le, me, se) {
              var de = me !== t, ve = de && me > 0 && me < 1, we = de && se > 0 && se < 1;
              return de && (!(ve || we) || le === "loop" && !(ve && we)) && (le = "arch", ve = we = !1), {
                type: le,
                roots: ve || we ? ve && we ? me < se ? [me, se] : [se, me] : [ve ? me : se] : null
              };
            }
            if (N(B))
              return N(Y) ? q(N(O) ? "line" : "quadratic") : q(j, O / (3 * Y));
            var H = 3 * Y * Y - 4 * B * O;
            if (N(H))
              return q("cusp", Y / (2 * B));
            var te = H > 0 ? Math.sqrt(H / 3) : Math.sqrt(-H), ae = 2 * B;
            return q(
              H > 0 ? j : "loop",
              (Y + te) / ae,
              (Y - te) / ae
            );
          },
          getLength: function(l, u, d, p) {
            if (u === t && (u = 0), d === t && (d = 1), ze.isStraight(l)) {
              var m = l;
              d < 1 && (m = ze.subdivide(m, d)[0], u /= d), u > 0 && (m = ze.subdivide(m, u)[1]);
              var y = m[6] - m[0], S = m[7] - m[1];
              return Math.sqrt(y * y + S * S);
            }
            return I.integrate(
              p || i(l),
              u,
              d,
              r(u, d)
            );
          },
          getTimeAt: function(l, u, d) {
            if (d === t && (d = u < 0 ? 1 : 0), u === 0)
              return d;
            var p = Math.abs, m = 1e-12, y = u > 0, S = y ? d : 0, L = y ? 1 : d, E = i(l), A = ze.getLength(l, S, L, E), T = p(u) - A;
            if (p(T) < m)
              return y ? L : S;
            if (T > m)
              return null;
            var G = u / A, O = 0;
            function Y(B) {
              return O += I.integrate(
                E,
                d,
                B,
                r(d, B)
              ), d = B, O - u;
            }
            return I.findRoot(
              Y,
              E,
              d + G,
              S,
              L,
              32,
              1e-12
            );
          },
          getPoint: function(l, u) {
            return s(l, u, 0, !1);
          },
          getTangent: function(l, u) {
            return s(l, u, 1, !0);
          },
          getWeightedTangent: function(l, u) {
            return s(l, u, 1, !1);
          },
          getNormal: function(l, u) {
            return s(l, u, 2, !0);
          },
          getWeightedNormal: function(l, u) {
            return s(l, u, 2, !1);
          },
          getCurvature: function(l, u) {
            return s(l, u, 3, !1).x;
          },
          getPeaks: function(l) {
            var u = l[0], d = l[1], p = l[2], m = l[3], y = l[4], S = l[5], L = l[6], E = l[7], A = -u + 3 * p - 3 * y + L, T = 3 * u - 6 * p + 3 * y, G = -3 * u + 3 * p, O = -d + 3 * m - 3 * S + E, Y = 3 * d - 6 * m + 3 * S, B = -3 * d + 3 * m, z = 1e-8, C = 1 - z, N = [];
            return I.solveCubic(
              9 * (A * A + O * O),
              9 * (A * T + Y * O),
              2 * (T * T + Y * Y) + 3 * (G * A + B * O),
              G * T + Y * B,
              N,
              z,
              C
            ), N.sort();
          }
        } };
      }(),
      new function() {
        function i(T, G, O, Y, B, z, C) {
          var N = !C && O.getPrevious() === B, j = !C && O !== B && O.getNext() === B, q = 1e-8, H = 1 - q;
          if (Y !== null && Y >= (N ? q : 0) && Y <= (j ? H : 1) && z !== null && z >= (j ? q : 0) && z <= (N ? H : 1)) {
            var te = new ht(O, Y, null, C), ae = new ht(B, z, null, C);
            te._intersection = ae, ae._intersection = te, (!G || G(te)) && ht.insert(T, te, !0);
          }
        }
        function r(T, G, O, Y, B, z, C, N, j, q, H, te, ae) {
          if (++j >= 4096 || ++N >= 40)
            return j;
          var le = 1e-9, me = G[0], se = G[1], de = G[6], ve = G[7], we = he.getSignedDistance, Se = we(me, se, de, ve, G[2], G[3]), Ae = we(me, se, de, ve, G[4], G[5]), Ge = Se * Ae > 0 ? 3 / 4 : 4 / 9, Qe = Ge * Math.min(0, Se, Ae), st = Ge * Math.max(0, Se, Ae), mt = we(me, se, de, ve, T[0], T[1]), Re = we(me, se, de, ve, T[2], T[3]), Fe = we(me, se, de, ve, T[4], T[5]), at = we(me, se, de, ve, T[6], T[7]), yt = s(mt, Re, Fe, at), bt = yt[0], Rt = yt[1], Pt, zt;
          if (Se === 0 && Ae === 0 && mt === 0 && Re === 0 && Fe === 0 && at === 0 || (Pt = l(bt, Rt, Qe, st)) == null || (zt = l(
            bt.reverse(),
            Rt.reverse(),
            Qe,
            st
          )) == null)
            return j;
          var Wt = q + (H - q) * Pt, Ft = q + (H - q) * zt;
          if (Math.max(ae - te, Ft - Wt) < le) {
            var Mi = (Wt + Ft) / 2, yi = (te + ae) / 2;
            i(
              B,
              z,
              C ? Y : O,
              C ? yi : Mi,
              C ? O : Y,
              C ? Mi : yi
            );
          } else {
            T = ze.getPart(T, Pt, zt);
            var Ai = ae - te;
            if (zt - Pt > 0.8)
              if (Ft - Wt > Ai) {
                var pi = ze.subdivide(T, 0.5), Mi = (Wt + Ft) / 2;
                j = r(
                  G,
                  pi[0],
                  Y,
                  O,
                  B,
                  z,
                  !C,
                  N,
                  j,
                  te,
                  ae,
                  Wt,
                  Mi
                ), j = r(
                  G,
                  pi[1],
                  Y,
                  O,
                  B,
                  z,
                  !C,
                  N,
                  j,
                  te,
                  ae,
                  Mi,
                  Ft
                );
              } else {
                var pi = ze.subdivide(G, 0.5), yi = (te + ae) / 2;
                j = r(
                  pi[0],
                  T,
                  Y,
                  O,
                  B,
                  z,
                  !C,
                  N,
                  j,
                  te,
                  yi,
                  Wt,
                  Ft
                ), j = r(
                  pi[1],
                  T,
                  Y,
                  O,
                  B,
                  z,
                  !C,
                  N,
                  j,
                  yi,
                  ae,
                  Wt,
                  Ft
                );
              }
            else
              Ai === 0 || Ai >= le ? j = r(
                G,
                T,
                Y,
                O,
                B,
                z,
                !C,
                N,
                j,
                te,
                ae,
                Wt,
                Ft
              ) : j = r(
                T,
                G,
                O,
                Y,
                B,
                z,
                C,
                N,
                j,
                Wt,
                Ft,
                te,
                ae
              );
          }
          return j;
        }
        function s(T, G, O, Y) {
          var B = [0, T], z = [1 / 3, G], C = [2 / 3, O], N = [1, Y], j = G - (2 * T + Y) / 3, q = O - (T + 2 * Y) / 3, H;
          if (j * q < 0)
            H = [[B, z, N], [B, C, N]];
          else {
            var te = j / q;
            H = [
              te >= 2 ? [B, z, N] : te <= 0.5 ? [B, C, N] : [B, z, C, N],
              [B, N]
            ];
          }
          return (j || q) < 0 ? H.reverse() : H;
        }
        function l(T, G, O, Y) {
          return T[0][1] < O ? u(T, !0, O) : G[0][1] > Y ? u(G, !1, Y) : T[0][0];
        }
        function u(T, G, O) {
          for (var Y = T[0][0], B = T[0][1], z = 1, C = T.length; z < C; z++) {
            var N = T[z][0], j = T[z][1];
            if (G ? j >= O : j <= O)
              return j === O ? N : Y + (O - B) * (N - Y) / (j - B);
            Y = N, B = j;
          }
          return null;
        }
        function d(T, G, O, Y, B) {
          var z = I.isZero;
          if (z(Y) && z(B)) {
            var C = ze.getTimeOf(T, new M(G, O));
            return C === null ? [] : [C];
          }
          for (var N = Math.atan2(-B, Y), j = Math.sin(N), q = Math.cos(N), H = [], te = [], ae = 0; ae < 8; ae += 2) {
            var le = T[ae] - G, me = T[ae + 1] - O;
            H.push(
              le * q - me * j,
              le * j + me * q
            );
          }
          return ze.solveCubic(H, 1, 0, te, 0, 1), te;
        }
        function p(T, G, O, Y, B, z, C) {
          for (var N = G[0], j = G[1], q = G[6], H = G[7], te = d(T, N, j, q - N, H - j), ae = 0, le = te.length; ae < le; ae++) {
            var me = te[ae], se = ze.getPoint(T, me), de = ze.getTimeOf(G, se);
            de !== null && i(
              B,
              z,
              C ? Y : O,
              C ? de : me,
              C ? O : Y,
              C ? me : de
            );
          }
        }
        function m(T, G, O, Y, B, z) {
          var C = he.intersect(
            T[0],
            T[1],
            T[6],
            T[7],
            G[0],
            G[1],
            G[6],
            G[7]
          );
          C && i(
            B,
            z,
            O,
            ze.getTimeOf(T, C),
            Y,
            ze.getTimeOf(G, C)
          );
        }
        function y(T, G, O, Y, B, z) {
          var C = 1e-12, N = Math.min, j = Math.max;
          if (j(T[0], T[2], T[4], T[6]) + C > N(G[0], G[2], G[4], G[6]) && N(T[0], T[2], T[4], T[6]) - C < j(G[0], G[2], G[4], G[6]) && j(T[1], T[3], T[5], T[7]) + C > N(G[1], G[3], G[5], G[7]) && N(T[1], T[3], T[5], T[7]) - C < j(G[1], G[3], G[5], G[7])) {
            var q = E(T, G);
            if (q)
              for (var H = 0; H < 2; H++) {
                var te = q[H];
                i(
                  B,
                  z,
                  O,
                  te[0],
                  Y,
                  te[1],
                  !0
                );
              }
            else {
              var ae = ze.isStraight(T), le = ze.isStraight(G), me = ae && le, se = ae && !le, de = B.length;
              if ((me ? m : ae || le ? p : r)(
                se ? G : T,
                se ? T : G,
                se ? Y : O,
                se ? O : Y,
                B,
                z,
                se,
                0,
                0,
                0,
                1,
                0,
                1
              ), !me || B.length === de)
                for (var H = 0; H < 4; H++) {
                  var ve = H >> 1, we = H & 1, Se = ve * 6, Ae = we * 6, Ge = new M(T[Se], T[Se + 1]), Qe = new M(G[Ae], G[Ae + 1]);
                  Ge.isClose(Qe, C) && i(
                    B,
                    z,
                    O,
                    ve,
                    Y,
                    we
                  );
                }
            }
          }
          return B;
        }
        function S(T, G, O, Y) {
          var B = ze.classify(T);
          if (B.type === "loop") {
            var z = B.roots;
            i(
              O,
              Y,
              G,
              z[0],
              G,
              z[1]
            );
          }
          return O;
        }
        function L(T, G, O, Y, B, z) {
          var C = 1e-7, N = !G;
          N && (G = T);
          for (var j = T.length, q = G.length, H = new Array(j), te = N ? H : new Array(q), ae = [], le = 0; le < j; le++)
            H[le] = T[le].getValues(Y);
          if (!N)
            for (var le = 0; le < q; le++)
              te[le] = G[le].getValues(B);
          for (var me = x.findCurveBoundsCollisions(
            H,
            te,
            C
          ), se = 0; se < j; se++) {
            var de = T[se], ve = H[se];
            N && S(ve, de, ae, O);
            var we = me[se];
            if (we)
              for (var Se = 0; Se < we.length; Se++) {
                if (z && ae.length)
                  return ae;
                var Ae = we[Se];
                if (!N || Ae > se) {
                  var Ge = G[Ae], Qe = te[Ae];
                  y(
                    ve,
                    Qe,
                    de,
                    Ge,
                    ae,
                    O
                  );
                }
              }
          }
          return ae;
        }
        function E(T, G) {
          function O(at) {
            var yt = at[6] - at[0], bt = at[7] - at[1];
            return yt * yt + bt * bt;
          }
          var Y = Math.abs, B = he.getDistance, z = 1e-8, C = 1e-7, N = ze.isStraight(T), j = ze.isStraight(G), q = N && j, H = O(T) < O(G), te = H ? G : T, ae = H ? T : G, le = te[0], me = te[1], se = te[6] - le, de = te[7] - me;
          if (B(le, me, se, de, ae[0], ae[1], !0) < C && B(le, me, se, de, ae[6], ae[7], !0) < C)
            !q && B(le, me, se, de, te[2], te[3], !0) < C && B(le, me, se, de, te[4], te[5], !0) < C && B(le, me, se, de, ae[2], ae[3], !0) < C && B(le, me, se, de, ae[4], ae[5], !0) < C && (N = j = q = !0);
          else if (q)
            return null;
          if (N ^ j)
            return null;
          for (var ve = [T, G], we = [], Se = 0; Se < 4 && we.length < 2; Se++) {
            var Ae = Se & 1, Ge = Ae ^ 1, Qe = Se >> 1, st = ze.getTimeOf(ve[Ae], new M(
              ve[Ge][Qe ? 6 : 0],
              ve[Ge][Qe ? 7 : 1]
            ));
            if (st != null) {
              var mt = Ae ? [Qe, st] : [st, Qe];
              (!we.length || Y(mt[0] - we[0][0]) > z && Y(mt[1] - we[0][1]) > z) && we.push(mt);
            }
            if (Se > 2 && !we.length)
              break;
          }
          if (we.length !== 2)
            we = null;
          else if (!q) {
            var Re = ze.getPart(T, we[0][0], we[1][0]), Fe = ze.getPart(G, we[0][1], we[1][1]);
            (Y(Fe[2] - Re[2]) > C || Y(Fe[3] - Re[3]) > C || Y(Fe[4] - Re[4]) > C || Y(Fe[5] - Re[5]) > C) && (we = null);
          }
          return we;
        }
        function A(T, G) {
          var O = T[0], Y = T[1], B = T[2], z = T[3], C = T[4], N = T[5], j = T[6], q = T[7], H = G.normalize(), te = H.x, ae = H.y, le = 3 * j - 9 * C + 9 * B - 3 * O, me = 3 * q - 9 * N + 9 * z - 3 * Y, se = 6 * C - 12 * B + 6 * O, de = 6 * N - 12 * z + 6 * Y, ve = 3 * B - 3 * O, we = 3 * z - 3 * Y, Se = 2 * le * ae - 2 * me * te, Ae = [];
          if (Math.abs(Se) < I.CURVETIME_EPSILON) {
            var Ge = le * we - me * ve, Se = le * de - me * se;
            if (Se != 0) {
              var Qe = -Ge / Se;
              Qe >= 0 && Qe <= 1 && Ae.push(Qe);
            }
          } else {
            var st = (se * se - 4 * le * ve) * ae * ae + (-2 * se * de + 4 * me * ve + 4 * le * we) * te * ae + (de * de - 4 * me * we) * te * te, mt = se * ae - de * te;
            if (st >= 0 && Se != 0) {
              var Re = Math.sqrt(st), Fe = -(mt + Re) / Se, at = (-mt + Re) / Se;
              Fe >= 0 && Fe <= 1 && Ae.push(Fe), at >= 0 && at <= 1 && Ae.push(at);
            }
          }
          return Ae;
        }
        return {
          getIntersections: function(T) {
            var G = this.getValues(), O = T && T !== this && T.getValues();
            return O ? y(G, O, this, T, []) : S(G, this, []);
          },
          statics: {
            getOverlaps: E,
            getIntersections: L,
            getCurveLineIntersections: d,
            getTimesWithTangent: A
          }
        };
      }()
    ), ht = o.extend(
      {
        _class: "CurveLocation",
        initialize: function(i, r, s, l, u) {
          if (r >= 0.99999999) {
            var d = i.getNext();
            d && (r = 0, i = d);
          }
          this._setCurve(i), this._time = r, this._point = s || i.getPointAtTime(r), this._overlap = l, this._distance = u, this._intersection = this._next = this._previous = null;
        },
        _setPath: function(i) {
          this._path = i, this._version = i ? i._version : 0;
        },
        _setCurve: function(i) {
          this._setPath(i._path), this._curve = i, this._segment = null, this._segment1 = i._segment1, this._segment2 = i._segment2;
        },
        _setSegment: function(i) {
          var r = i.getCurve();
          r ? this._setCurve(r) : (this._setPath(i._path), this._segment1 = i, this._segment2 = null), this._segment = i, this._time = i === this._segment1 ? 0 : 1, this._point = i._point.clone();
        },
        getSegment: function() {
          var i = this._segment;
          if (!i) {
            var r = this.getCurve(), s = this.getTime();
            s === 0 ? i = r._segment1 : s === 1 ? i = r._segment2 : s != null && (i = r.getPartLength(0, s) < r.getPartLength(s, 1) ? r._segment1 : r._segment2), this._segment = i;
          }
          return i;
        },
        getCurve: function() {
          var i = this._path, r = this;
          i && i._version !== this._version && (this._time = this._offset = this._curveOffset = this._curve = null);
          function s(l) {
            var u = l && l.getCurve();
            if (u && (r._time = u.getTimeOf(r._point)) != null)
              return r._setCurve(u), u;
          }
          return this._curve || s(this._segment) || s(this._segment1) || s(this._segment2.getPrevious());
        },
        getPath: function() {
          var i = this.getCurve();
          return i && i._path;
        },
        getIndex: function() {
          var i = this.getCurve();
          return i && i.getIndex();
        },
        getTime: function() {
          var i = this.getCurve(), r = this._time;
          return i && r == null ? this._time = i.getTimeOf(this._point) : r;
        },
        getParameter: "#getTime",
        getPoint: function() {
          return this._point;
        },
        getOffset: function() {
          var i = this._offset;
          if (i == null) {
            i = 0;
            var r = this.getPath(), s = this.getIndex();
            if (r && s != null)
              for (var l = r.getCurves(), u = 0; u < s; u++)
                i += l[u].getLength();
            this._offset = i += this.getCurveOffset();
          }
          return i;
        },
        getCurveOffset: function() {
          var i = this._curveOffset;
          if (i == null) {
            var r = this.getCurve(), s = this.getTime();
            this._curveOffset = i = s != null && r && r.getPartLength(0, s);
          }
          return i;
        },
        getIntersection: function() {
          return this._intersection;
        },
        getDistance: function() {
          return this._distance;
        },
        divide: function() {
          var i = this.getCurve(), r = i && i.divideAtTime(this.getTime());
          return r && this._setSegment(r._segment1), r;
        },
        split: function() {
          var i = this.getCurve(), r = i._path, s = i && i.splitAtTime(this.getTime());
          return s && this._setSegment(r.getLastSegment()), s;
        },
        equals: function(i, r) {
          var s = this === i;
          if (!s && i instanceof ht) {
            var l = this.getCurve(), u = i.getCurve(), d = l._path, p = u._path;
            if (d === p) {
              var m = Math.abs, y = 1e-7, S = m(this.getOffset() - i.getOffset()), L = !r && this._intersection, E = !r && i._intersection;
              s = (S < y || d && m(d.getLength() - S) < y) && (!L && !E || L && E && L.equals(E, !0));
            }
          }
          return s;
        },
        toString: function() {
          var i = [], r = this.getPoint(), s = k.instance;
          r && i.push("point: " + r);
          var l = this.getIndex();
          l != null && i.push("index: " + l);
          var u = this.getTime();
          return u != null && i.push("time: " + s.number(u)), this._distance != null && i.push("distance: " + s.number(this._distance)), "{ " + i.join(", ") + " }";
        },
        isTouching: function() {
          var i = this._intersection;
          if (i && this.getTangent().isCollinear(i.getTangent())) {
            var r = this.getCurve(), s = i.getCurve();
            return !(r.isStraight() && s.isStraight() && r.getLine().intersect(s.getLine()));
          }
          return !1;
        },
        isCrossing: function() {
          var i = this._intersection;
          if (!i)
            return !1;
          var r = this.getTime(), s = i.getTime(), l = 1e-8, u = 1 - l, d = r >= l && r <= u, p = s >= l && s <= u;
          if (d && p)
            return !this.isTouching();
          var m = this.getCurve(), y = m && r < l ? m.getPrevious() : m, S = i.getCurve(), L = S && s < l ? S.getPrevious() : S;
          if (r > u && (m = m.getNext()), s > u && (S = S.getNext()), !y || !m || !L || !S)
            return !1;
          var E = [];
          function A(te, ae) {
            var le = te.getValues(), me = ze.classify(le).roots || ze.getPeaks(le), se = me.length, de = ze.getLength(
              le,
              ae && se ? me[se - 1] : 0,
              !ae && se ? me[0] : 1
            );
            E.push(se ? de : de / 32);
          }
          function T(te, ae, le) {
            return ae < le ? te > ae && te < le : te > ae || te < le;
          }
          d || (A(y, !0), A(m, !1)), p || (A(L, !0), A(S, !1));
          var G = this.getPoint(), O = Math.min.apply(Math, E), Y = d ? m.getTangentAtTime(r) : m.getPointAt(O).subtract(G), B = d ? Y.negate() : y.getPointAt(-O).subtract(G), z = p ? S.getTangentAtTime(s) : S.getPointAt(O).subtract(G), C = p ? z.negate() : L.getPointAt(-O).subtract(G), N = B.getAngle(), j = Y.getAngle(), q = C.getAngle(), H = z.getAngle();
          return !!(d ? T(N, q, H) ^ T(j, q, H) && T(N, H, q) ^ T(j, H, q) : T(q, N, j) ^ T(H, N, j) && T(q, j, N) ^ T(H, j, N));
        },
        hasOverlap: function() {
          return !!this._overlap;
        }
      },
      o.each(ze._evaluateMethods, function(i) {
        var r = i + "At";
        this[i] = function() {
          var s = this.getCurve(), l = this.getTime();
          return l != null && s && s[r](l, !0);
        };
      }, {
        preserve: !0
      }),
      new function() {
        function i(r, s, l) {
          var u = r.length, d = 0, p = u - 1;
          function m(G, O) {
            for (var Y = G + O; Y >= -1 && Y <= u; Y += O) {
              var B = r[(Y % u + u) % u];
              if (!s.getPoint().isClose(
                B.getPoint(),
                1e-7
              ))
                break;
              if (s.equals(B))
                return B;
            }
            return null;
          }
          for (; d <= p; ) {
            var y = d + p >>> 1, S = r[y], L;
            if (l && (L = s.equals(S) ? S : m(y, -1) || m(y, 1)))
              return s._overlap && (L._overlap = L._intersection._overlap = !0), L;
            var E = s.getPath(), A = S.getPath(), T = E !== A ? E._id - A._id : s.getIndex() + s.getTime() - (S.getIndex() + S.getTime());
            T < 0 ? p = y - 1 : d = y + 1;
          }
          return r.splice(d, 0, s), s;
        }
        return { statics: {
          insert: i,
          expand: function(r) {
            for (var s = r.slice(), l = r.length - 1; l >= 0; l--)
              i(s, r[l]._intersection, !1);
            return s;
          }
        } };
      }()
    ), Gt = X.extend({
      _class: "PathItem",
      _selectBounds: !1,
      _canScaleStroke: !0,
      beans: !0,
      initialize: function() {
      },
      statics: {
        create: function(i) {
          var r, s, l;
          if (o.isPlainObject(i) ? (s = i.segments, r = i.pathData) : Array.isArray(i) ? s = i : typeof i == "string" && (r = i), s) {
            var u = s[0];
            l = u && Array.isArray(u[0]);
          } else
            r && (l = (r.match(/m/gi) || []).length > 1 || /z\s*\S+/i.test(r));
          var d = l ? It : $e;
          return new d(i);
        }
      },
      _asPathItem: function() {
        return this;
      },
      isClockwise: function() {
        return this.getArea() >= 0;
      },
      setClockwise: function(i) {
        this.isClockwise() != (i = !!i) && this.reverse();
      },
      setPathData: function(i) {
        var r = i && i.match(/[mlhvcsqtaz][^mlhvcsqtaz]*/ig), s, l = !1, u, d, p = new M(), m = new M();
        function y(C, N) {
          var j = +s[C];
          return l && (j += p[N]), j;
        }
        function S(C) {
          return new M(
            y(C, "x"),
            y(C + 1, "y")
          );
        }
        this.clear();
        for (var L = 0, E = r && r.length; L < E; L++) {
          var A = r[L], T = A[0], G = T.toLowerCase();
          s = A.match(/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g);
          var O = s && s.length;
          switch (l = T === G, u === "z" && !/[mz]/.test(G) && this.moveTo(p), G) {
            case "m":
            case "l":
              for (var Y = G === "m", B = 0; B < O; B += 2)
                this[Y ? "moveTo" : "lineTo"](p = S(B)), Y && (m = p, Y = !1);
              d = p;
              break;
            case "h":
            case "v":
              var z = G === "h" ? "x" : "y";
              p = p.clone();
              for (var B = 0; B < O; B++)
                p[z] = y(B, z), this.lineTo(p);
              d = p;
              break;
            case "c":
              for (var B = 0; B < O; B += 6)
                this.cubicCurveTo(
                  S(B),
                  d = S(B + 2),
                  p = S(B + 4)
                );
              break;
            case "s":
              for (var B = 0; B < O; B += 4)
                this.cubicCurveTo(
                  /[cs]/.test(u) ? p.multiply(2).subtract(d) : p,
                  d = S(B),
                  p = S(B + 2)
                ), u = G;
              break;
            case "q":
              for (var B = 0; B < O; B += 4)
                this.quadraticCurveTo(
                  d = S(B),
                  p = S(B + 2)
                );
              break;
            case "t":
              for (var B = 0; B < O; B += 2)
                this.quadraticCurveTo(
                  d = /[qt]/.test(u) ? p.multiply(2).subtract(d) : p,
                  p = S(B)
                ), u = G;
              break;
            case "a":
              for (var B = 0; B < O; B += 7)
                this.arcTo(
                  p = S(B + 5),
                  new U(+s[B], +s[B + 1]),
                  +s[B + 2],
                  +s[B + 4],
                  +s[B + 3]
                );
              break;
            case "z":
              this.closePath(1e-12), p = m;
              break;
          }
          u = G;
        }
      },
      _canComposite: function() {
        return !(this.hasFill() && this.hasStroke());
      },
      _contains: function(i) {
        var r = i.isInside(
          this.getBounds({ internal: !0, handle: !0 })
        ) ? this._getWinding(i) : {};
        return r.onPath || !!(this.getFillRule() === "evenodd" ? r.windingL & 1 || r.windingR & 1 : r.winding);
      },
      getIntersections: function(i, r, s, l) {
        var u = this === i || !i, d = this._matrix._orNullIfIdentity(), p = u ? d : (s || i._matrix)._orNullIfIdentity();
        return u || this.getBounds(d).intersects(
          i.getBounds(p),
          1e-12
        ) ? ze.getIntersections(
          this.getCurves(),
          !u && i.getCurves(),
          r,
          d,
          p,
          l
        ) : [];
      },
      getCrossings: function(i) {
        return this.getIntersections(i, function(r) {
          return r.isCrossing();
        });
      },
      getNearestLocation: function() {
        for (var i = M.read(arguments), r = this.getCurves(), s = 1 / 0, l = null, u = 0, d = r.length; u < d; u++) {
          var p = r[u].getNearestLocation(i);
          p._distance < s && (s = p._distance, l = p);
        }
        return l;
      },
      getNearestPoint: function() {
        var i = this.getNearestLocation.apply(this, arguments);
        return i && i.getPoint();
      },
      interpolate: function(i, r, s) {
        var l = !this._children, u = l ? "_segments" : "_children", d = i[u], p = r[u], m = this[u];
        if (!d || !p || d.length !== p.length)
          throw new Error("Invalid operands in interpolate() call: " + i + ", " + r);
        var y = m.length, S = p.length;
        if (y < S)
          for (var L = l ? ce : $e, E = y; E < S; E++)
            this.add(new L());
        else
          y > S && this[l ? "removeSegments" : "removeChildren"](S, y);
        for (var E = 0; E < S; E++)
          m[E].interpolate(d[E], p[E], s);
        l && (this.setClosed(i._closed), this._changed(9));
      },
      compare: function(i) {
        var r = !1;
        if (i) {
          var s = this._children || [this], l = i._children ? i._children.slice() : [i], u = s.length, d = l.length, p = [], m = 0;
          r = !0;
          for (var y = x.findItemBoundsCollisions(s, l, I.GEOMETRIC_EPSILON), S = u - 1; S >= 0 && r; S--) {
            var L = s[S];
            r = !1;
            var E = y[S];
            if (E)
              for (var A = E.length - 1; A >= 0 && !r; A--)
                L.compare(l[E[A]]) && (p[E[A]] || (p[E[A]] = !0, m++), r = !0);
          }
          r = r && m === d;
        }
        return r;
      }
    }), $e = Gt.extend(
      {
        _class: "Path",
        _serializeFields: {
          segments: [],
          closed: !1
        },
        initialize: function(i) {
          this._closed = !1, this._segments = [], this._version = 0;
          var r = arguments, s = Array.isArray(i) ? typeof i[0] == "object" ? i : r : i && i.size === t && (i.x !== t || i.point !== t) ? r : null;
          s && s.length > 0 ? this.setSegments(s) : (this._curves = t, this._segmentSelection = 0, !s && typeof i == "string" && (this.setPathData(i), i = null)), this._initialize(!s && i);
        },
        _equals: function(i) {
          return this._closed === i._closed && o.equals(this._segments, i._segments);
        },
        copyContent: function(i) {
          this.setSegments(i._segments), this._closed = i._closed;
        },
        _changed: function i(r) {
          if (i.base.call(this, r), r & 8) {
            if (this._length = this._area = t, r & 32)
              this._version++;
            else if (this._curves)
              for (var s = 0, l = this._curves.length; s < l; s++)
                this._curves[s]._changed();
          } else
            r & 64 && (this._bounds = t);
        },
        getStyle: function() {
          var i = this._parent;
          return (i instanceof It ? i : this)._style;
        },
        getSegments: function() {
          return this._segments;
        },
        setSegments: function(i) {
          var r = this.isFullySelected(), s = i && i.length;
          if (this._segments.length = 0, this._segmentSelection = 0, this._curves = t, s) {
            var l = i[s - 1];
            typeof l == "boolean" && (this.setClosed(l), s--), this._add(ce.readList(i, 0, {}, s));
          }
          r && this.setFullySelected(!0);
        },
        getFirstSegment: function() {
          return this._segments[0];
        },
        getLastSegment: function() {
          return this._segments[this._segments.length - 1];
        },
        getCurves: function() {
          var i = this._curves, r = this._segments;
          if (!i) {
            var s = this._countCurves();
            i = this._curves = new Array(s);
            for (var l = 0; l < s; l++)
              i[l] = new ze(
                this,
                r[l],
                r[l + 1] || r[0]
              );
          }
          return i;
        },
        getFirstCurve: function() {
          return this.getCurves()[0];
        },
        getLastCurve: function() {
          var i = this.getCurves();
          return i[i.length - 1];
        },
        isClosed: function() {
          return this._closed;
        },
        setClosed: function(i) {
          if (this._closed != (i = !!i)) {
            if (this._closed = i, this._curves) {
              var r = this._curves.length = this._countCurves();
              i && (this._curves[r - 1] = new ze(
                this,
                this._segments[r - 1],
                this._segments[0]
              ));
            }
            this._changed(41);
          }
        }
      },
      {
        beans: !0,
        getPathData: function(i, r) {
          var s = this._segments, l = s.length, u = new k(r), d = new Array(6), p = !0, m, y, S, L, E, A, T, G, O = [];
          function Y(z, C) {
            if (z._transformCoordinates(i, d), m = d[0], y = d[1], p)
              O.push("M" + u.pair(m, y)), p = !1;
            else if (E = d[2], A = d[3], E === m && A === y && T === S && G === L) {
              if (!C) {
                var N = m - S, j = y - L;
                O.push(
                  N === 0 ? "v" + u.number(j) : j === 0 ? "h" + u.number(N) : "l" + u.pair(N, j)
                );
              }
            } else
              O.push("c" + u.pair(T - S, G - L) + " " + u.pair(E - S, A - L) + " " + u.pair(m - S, y - L));
            S = m, L = y, T = d[4], G = d[5];
          }
          if (!l)
            return "";
          for (var B = 0; B < l; B++)
            Y(s[B]);
          return this._closed && l > 0 && (Y(s[0], !0), O.push("z")), O.join("");
        },
        isEmpty: function() {
          return !this._segments.length;
        },
        _transformContent: function(i) {
          for (var r = this._segments, s = new Array(6), l = 0, u = r.length; l < u; l++)
            r[l]._transformCoordinates(i, s, !0);
          return !0;
        },
        _add: function(i, r) {
          for (var s = this._segments, l = this._curves, u = i.length, d = r == null, r = d ? s.length : r, p = 0; p < u; p++) {
            var m = i[p];
            m._path && (m = i[p] = m.clone()), m._path = this, m._index = r + p, m._selection && this._updateSelection(m, 0, m._selection);
          }
          if (d)
            o.push(s, i);
          else {
            s.splice.apply(s, [r, 0].concat(i));
            for (var p = r + u, y = s.length; p < y; p++)
              s[p]._index = p;
          }
          if (l) {
            var S = this._countCurves(), L = r > 0 && r + u - 1 === S ? r - 1 : r, E = L, A = Math.min(L + u, S);
            i._curves && (l.splice.apply(l, [L, 0].concat(i._curves)), E += i._curves.length);
            for (var p = E; p < A; p++)
              l.splice(p, 0, new ze(this, null, null));
            this._adjustCurves(L, A);
          }
          return this._changed(41), i;
        },
        _adjustCurves: function(i, r) {
          for (var s = this._segments, l = this._curves, u, d = i; d < r; d++)
            u = l[d], u._path = this, u._segment1 = s[d], u._segment2 = s[d + 1] || s[0], u._changed();
          (u = l[this._closed && !i ? s.length - 1 : i - 1]) && (u._segment2 = s[i] || s[0], u._changed()), (u = l[r]) && (u._segment1 = s[r], u._changed());
        },
        _countCurves: function() {
          var i = this._segments.length;
          return !this._closed && i > 0 ? i - 1 : i;
        },
        add: function(i) {
          var r = arguments;
          return r.length > 1 && typeof i != "number" ? this._add(ce.readList(r)) : this._add([ce.read(r)])[0];
        },
        insert: function(i, r) {
          var s = arguments;
          return s.length > 2 && typeof r != "number" ? this._add(ce.readList(s, 1), i) : this._add([ce.read(s, 1)], i)[0];
        },
        addSegment: function() {
          return this._add([ce.read(arguments)])[0];
        },
        insertSegment: function(i) {
          return this._add([ce.read(arguments, 1)], i)[0];
        },
        addSegments: function(i) {
          return this._add(ce.readList(i));
        },
        insertSegments: function(i, r) {
          return this._add(ce.readList(r), i);
        },
        removeSegment: function(i) {
          return this.removeSegments(i, i + 1)[0] || null;
        },
        removeSegments: function(i, r, s) {
          i = i || 0, r = o.pick(r, this._segments.length);
          var l = this._segments, u = this._curves, d = l.length, p = l.splice(i, r - i), m = p.length;
          if (!m)
            return p;
          for (var y = 0; y < m; y++) {
            var S = p[y];
            S._selection && this._updateSelection(S, S._selection, 0), S._index = S._path = null;
          }
          for (var y = i, L = l.length; y < L; y++)
            l[y]._index = y;
          if (u) {
            for (var E = i > 0 && r === d + (this._closed ? 1 : 0) ? i - 1 : i, u = u.splice(E, m), y = u.length - 1; y >= 0; y--)
              u[y]._path = null;
            s && (p._curves = u.slice(1)), this._adjustCurves(E, E);
          }
          return this._changed(41), p;
        },
        clear: "#removeSegments",
        hasHandles: function() {
          for (var i = this._segments, r = 0, s = i.length; r < s; r++)
            if (i[r].hasHandles())
              return !0;
          return !1;
        },
        clearHandles: function() {
          for (var i = this._segments, r = 0, s = i.length; r < s; r++)
            i[r].clearHandles();
        },
        getLength: function() {
          if (this._length == null) {
            for (var i = this.getCurves(), r = 0, s = 0, l = i.length; s < l; s++)
              r += i[s].getLength();
            this._length = r;
          }
          return this._length;
        },
        getArea: function() {
          var i = this._area;
          if (i == null) {
            var r = this._segments, s = this._closed;
            i = 0;
            for (var l = 0, u = r.length; l < u; l++) {
              var d = l + 1 === u;
              i += ze.getArea(ze.getValues(
                r[l],
                r[d ? 0 : l + 1],
                null,
                d && !s
              ));
            }
            this._area = i;
          }
          return i;
        },
        isFullySelected: function() {
          var i = this._segments.length;
          return this.isSelected() && i > 0 && this._segmentSelection === i * 7;
        },
        setFullySelected: function(i) {
          i && this._selectSegments(!0), this.setSelected(i);
        },
        setSelection: function i(r) {
          r & 1 || this._selectSegments(!1), i.base.call(this, r);
        },
        _selectSegments: function(i) {
          var r = this._segments, s = r.length, l = i ? 7 : 0;
          this._segmentSelection = l * s;
          for (var u = 0; u < s; u++)
            r[u]._selection = l;
        },
        _updateSelection: function(i, r, s) {
          i._selection = s;
          var l = this._segmentSelection += s - r;
          l > 0 && this.setSelected(!0);
        },
        divideAt: function(i) {
          var r = this.getLocationAt(i), s;
          return r && (s = r.getCurve().divideAt(r.getCurveOffset())) ? s._segment1 : null;
        },
        splitAt: function(i) {
          var r = this.getLocationAt(i), s = r && r.index, l = r && r.time, u = 1e-8, d = 1 - u;
          l > d && (s++, l = 0);
          var p = this.getCurves();
          if (s >= 0 && s < p.length) {
            l >= u && p[s++].divideAtTime(l);
            var m = this.removeSegments(s, this._segments.length, !0), y;
            return this._closed ? (this.setClosed(!1), y = this) : (y = new $e(X.NO_INSERT), y.insertAbove(this), y.copyAttributes(this)), y._add(m, 0), this.addSegment(m[0]), y;
          }
          return null;
        },
        split: function(i, r) {
          var s, l = r === t ? i : (s = this.getCurves()[i]) && s.getLocationAtTime(r);
          return l != null ? this.splitAt(l) : null;
        },
        join: function(i, r) {
          var s = r || 0;
          if (i && i !== this) {
            var l = i._segments, u = this.getLastSegment(), d = i.getLastSegment();
            if (!d)
              return this;
            u && u._point.isClose(d._point, s) && i.reverse();
            var p = i.getFirstSegment();
            if (u && u._point.isClose(p._point, s))
              u.setHandleOut(p._handleOut), this._add(l.slice(1));
            else {
              var m = this.getFirstSegment();
              m && m._point.isClose(p._point, s) && i.reverse(), d = i.getLastSegment(), m && m._point.isClose(d._point, s) ? (m.setHandleIn(d._handleIn), this._add(l.slice(0, l.length - 1), 0)) : this._add(l.slice());
            }
            i._closed && this._add([l[0]]), i.remove();
          }
          var y = this.getFirstSegment(), S = this.getLastSegment();
          return y !== S && y._point.isClose(S._point, s) && (y.setHandleIn(S._handleIn), S.remove(), this.setClosed(!0)), this;
        },
        reduce: function(i) {
          for (var r = this.getCurves(), s = i && i.simplify, l = s ? 1e-7 : 0, u = r.length - 1; u >= 0; u--) {
            var d = r[u];
            !d.hasHandles() && (!d.hasLength(l) || s && d.isCollinear(d.getNext())) && d.remove();
          }
          return this;
        },
        reverse: function() {
          this._segments.reverse();
          for (var i = 0, r = this._segments.length; i < r; i++) {
            var s = this._segments[i], l = s._handleIn;
            s._handleIn = s._handleOut, s._handleOut = l, s._index = i;
          }
          this._curves = null, this._changed(9);
        },
        flatten: function(i) {
          for (var r = new rt(this, i || 0.25, 256, !0), s = r.parts, l = s.length, u = [], d = 0; d < l; d++)
            u.push(new ce(s[d].curve.slice(0, 2)));
          !this._closed && l > 0 && u.push(new ce(s[l - 1].curve.slice(6))), this.setSegments(u);
        },
        simplify: function(i) {
          var r = new it(this).fit(i || 2.5);
          return r && this.setSegments(r), !!r;
        },
        smooth: function(i) {
          var r = this, s = i || {}, l = s.type || "asymmetric", u = this._segments, d = u.length, p = this._closed;
          function m(bt, Rt) {
            var Pt = bt && bt.index;
            if (Pt != null) {
              var zt = bt.path;
              if (zt && zt !== r)
                throw new Error(bt._class + " " + Pt + " of " + zt + " is not part of " + r);
              Rt && bt instanceof ze && Pt++;
            } else
              Pt = typeof bt == "number" ? bt : Rt;
            return Math.min(Pt < 0 && p ? Pt % d : Pt < 0 ? Pt + d : Pt, d - 1);
          }
          var y = p && s.from === t && s.to === t, S = m(s.from, 0), L = m(s.to, d - 1);
          if (S > L)
            if (p)
              S -= d;
            else {
              var E = S;
              S = L, L = E;
            }
          if (/^(?:asymmetric|continuous)$/.test(l)) {
            var A = l === "asymmetric", T = Math.min, G = L - S + 1, O = G - 1, Y = y ? T(G, 4) : 1, B = Y, z = Y, C = [];
            if (p || (B = T(1, S), z = T(1, d - L - 1)), O += B + z, O <= 1)
              return;
            for (var N = 0, j = S - B; N <= O; N++, j++)
              C[N] = u[(j < 0 ? j + d : j) % d]._point;
            for (var q = C[0]._x + 2 * C[1]._x, H = C[0]._y + 2 * C[1]._y, te = 2, ae = O - 1, le = [q], me = [H], se = [te], de = [], ve = [], N = 1; N < O; N++) {
              var we = N < ae, Se = we || A ? 1 : 2, Ae = we ? 4 : A ? 2 : 7, Ge = we ? 4 : A ? 3 : 8, Qe = we ? 2 : A ? 0 : 1, st = Se / te;
              te = se[N] = Ae - st, q = le[N] = Ge * C[N]._x + Qe * C[N + 1]._x - st * q, H = me[N] = Ge * C[N]._y + Qe * C[N + 1]._y - st * H;
            }
            de[ae] = le[ae] / se[ae], ve[ae] = me[ae] / se[ae];
            for (var N = O - 2; N >= 0; N--)
              de[N] = (le[N] - de[N + 1]) / se[N], ve[N] = (me[N] - ve[N + 1]) / se[N];
            de[O] = (3 * C[O]._x - de[ae]) / 2, ve[O] = (3 * C[O]._y - ve[ae]) / 2;
            for (var N = B, mt = O - z, j = S; N <= mt; N++, j++) {
              var Re = u[j < 0 ? j + d : j], Fe = Re._point, at = de[N] - Fe._x, yt = ve[N] - Fe._y;
              (y || N < mt) && Re.setHandleOut(at, yt), (y || N > B) && Re.setHandleIn(-at, -yt);
            }
          } else
            for (var N = S; N <= L; N++)
              u[N < 0 ? N + d : N].smooth(
                s,
                !y && N === S,
                !y && N === L
              );
        },
        toShape: function(i) {
          if (!this._closed)
            return null;
          var r = this._segments, s, l, u, d;
          function p(A, T) {
            var G = r[A], O = G.getNext(), Y = r[T], B = Y.getNext();
            return G._handleOut.isZero() && O._handleIn.isZero() && Y._handleOut.isZero() && B._handleIn.isZero() && O._point.subtract(G._point).isCollinear(
              B._point.subtract(Y._point)
            );
          }
          function m(A) {
            var T = r[A], G = T.getPrevious(), O = T.getNext();
            return G._handleOut.isZero() && T._handleIn.isZero() && T._handleOut.isZero() && O._handleIn.isZero() && T._point.subtract(G._point).isOrthogonal(
              O._point.subtract(T._point)
            );
          }
          function y(A) {
            var T = r[A], G = T.getNext(), O = T._handleOut, Y = G._handleIn, B = 0.5522847498307936;
            if (O.isOrthogonal(Y)) {
              var z = T._point, C = G._point, N = new he(z, O, !0).intersect(
                new he(C, Y, !0),
                !0
              );
              return N && I.isZero(O.getLength() / N.subtract(z).getLength() - B) && I.isZero(Y.getLength() / N.subtract(C).getLength() - B);
            }
            return !1;
          }
          function S(A, T) {
            return r[A]._point.getDistance(r[T]._point);
          }
          if (!this.hasHandles() && r.length === 4 && p(0, 2) && p(1, 3) && m(1) ? (s = Oe.Rectangle, l = new U(S(0, 3), S(0, 1)), d = r[1]._point.add(r[2]._point).divide(2)) : r.length === 8 && y(0) && y(2) && y(4) && y(6) && p(1, 5) && p(3, 7) ? (s = Oe.Rectangle, l = new U(S(1, 6), S(0, 3)), u = l.subtract(new U(
            S(0, 7),
            S(1, 2)
          )).divide(2), d = r[3]._point.add(r[4]._point).divide(2)) : r.length === 4 && y(0) && y(1) && y(2) && y(3) && (I.isZero(S(0, 2) - S(1, 3)) ? (s = Oe.Circle, u = S(0, 2) / 2) : (s = Oe.Ellipse, u = new U(S(2, 0) / 2, S(3, 1) / 2)), d = r[1]._point), s) {
            var L = this.getPosition(!0), E = new s({
              center: L,
              size: l,
              radius: u,
              insert: !1
            });
            return E.copyAttributes(this, !0), E._matrix.prepend(this._matrix), E.rotate(d.subtract(L).getAngle() + 90), (i === t || i) && E.insertAbove(this), E;
          }
          return null;
        },
        toPath: "#clone",
        compare: function i(r) {
          if (!r || r instanceof It)
            return i.base.call(this, r);
          var s = this.getCurves(), l = r.getCurves(), u = s.length, d = l.length;
          if (!u || !d)
            return u == d;
          for (var p = s[0].getValues(), m = [], y = 0, S, L = 0, E, A = 0; A < d; A++) {
            var T = l[A].getValues();
            m.push(T);
            var G = ze.getOverlaps(p, T);
            if (G) {
              S = !A && G[0][0] > 0 ? d - 1 : A, E = G[0][1];
              break;
            }
          }
          for (var O = Math.abs, Y = 1e-8, T = m[S], B; p && T; ) {
            var G = ze.getOverlaps(p, T);
            if (G) {
              var z = G[0][0];
              if (O(z - L) < Y) {
                L = G[1][0], L === 1 && (p = ++y < u ? s[y].getValues() : null, L = 0);
                var C = G[0][1];
                if (O(C - E) < Y) {
                  if (B || (B = [S, C]), E = G[1][1], E === 1 && (++S >= d && (S = 0), T = m[S] || l[S].getValues(), E = 0), !p)
                    return B[0] === S && B[1] === E;
                  continue;
                }
              }
            }
            break;
          }
          return !1;
        },
        _hitTestSelf: function(i, r, s, l) {
          var u = this, d = this.getStyle(), p = this._segments, m = p.length, y = this._closed, S = r._tolerancePadding, L = S, E, A, T, G, O, Y, B = r.stroke && d.hasStroke(), z = r.fill && d.hasFill(), C = r.curves, N = B ? d.getStrokeWidth() / 2 : z && r.tolerance > 0 || C ? 0 : null;
          N !== null && (N > 0 ? (E = d.getStrokeJoin(), A = d.getStrokeCap(), T = d.getMiterLimit(), L = L.add(
            $e._getStrokePadding(N, l)
          )) : E = A = "round");
          function j(de, ve) {
            return i.subtract(de).divide(ve).length <= 1;
          }
          function q(de, ve, we) {
            if (!r.selected || ve.isSelected()) {
              var Se = de._point;
              if (ve !== Se && (ve = ve.add(Se)), j(ve, L))
                return new Ze(we, u, {
                  segment: de,
                  point: ve
                });
            }
          }
          function H(de, ve) {
            return (ve || r.segments) && q(de, de._point, "segment") || !ve && r.handles && (q(de, de._handleIn, "handle-in") || q(de, de._handleOut, "handle-out"));
          }
          function te(de) {
            G.add(de);
          }
          function ae(de) {
            var ve = y || de._index > 0 && de._index < m - 1;
            if ((ve ? E : A) === "round")
              return j(de._point, L);
            if (G = new $e({ internal: !0, closed: !0 }), ve ? de.isSmooth() || $e._addBevelJoin(
              de,
              E,
              N,
              T,
              null,
              l,
              te,
              !0
            ) : A === "square" && $e._addSquareCap(
              de,
              A,
              N,
              null,
              l,
              te,
              !0
            ), !G.isEmpty()) {
              var we;
              return G.contains(i) || (we = G.getNearestLocation(i)) && j(we.getPoint(), S);
            }
          }
          if (r.ends && !r.segments && !y) {
            if (Y = H(p[0], !0) || H(p[m - 1], !0))
              return Y;
          } else if (r.segments || r.handles) {
            for (var le = 0; le < m; le++)
              if (Y = H(p[le]))
                return Y;
          }
          if (N !== null) {
            if (O = this.getNearestLocation(i), O) {
              var me = O.getTime();
              me === 0 || me === 1 && m > 1 ? ae(O.getSegment()) || (O = null) : j(O.getPoint(), L) || (O = null);
            }
            if (!O && E === "miter" && m > 1)
              for (var le = 0; le < m; le++) {
                var se = p[le];
                if (i.getDistance(se._point) <= T * N && ae(se)) {
                  O = se.getLocation();
                  break;
                }
              }
          }
          return !O && z && this._contains(i) || O && !B && !C ? new Ze("fill", this) : O ? new Ze(B ? "stroke" : "curve", this, {
            location: O,
            point: O.getPoint()
          }) : null;
        }
      },
      o.each(
        ze._evaluateMethods,
        function(i) {
          this[i + "At"] = function(r) {
            var s = this.getLocationAt(r);
            return s && s[i]();
          };
        },
        {
          beans: !1,
          getLocationOf: function() {
            for (var i = M.read(arguments), r = this.getCurves(), s = 0, l = r.length; s < l; s++) {
              var u = r[s].getLocationOf(i);
              if (u)
                return u;
            }
            return null;
          },
          getOffsetOf: function() {
            var i = this.getLocationOf.apply(this, arguments);
            return i ? i.getOffset() : null;
          },
          getLocationAt: function(i) {
            if (typeof i == "number") {
              for (var r = this.getCurves(), s = 0, l = 0, u = r.length; l < u; l++) {
                var d = s, p = r[l];
                if (s += p.getLength(), s > i)
                  return p.getLocationAt(i - d);
              }
              if (r.length > 0 && i <= this.getLength())
                return new ht(r[r.length - 1], 1);
            } else if (i && i.getPath && i.getPath() === this)
              return i;
            return null;
          },
          getOffsetsWithTangent: function() {
            var i = M.read(arguments);
            if (i.isZero())
              return [];
            for (var r = [], s = 0, l = this.getCurves(), u = 0, d = l.length; u < d; u++) {
              for (var p = l[u], m = p.getTimesWithTangent(i), y = 0, S = m.length; y < S; y++) {
                var L = s + p.getOffsetAtTime(m[y]);
                r.indexOf(L) < 0 && r.push(L);
              }
              s += p.length;
            }
            return r;
          }
        }
      ),
      new function() {
        function i(s, l, u, d) {
          if (d <= 0)
            return;
          var p = d / 2, m = d - 2, y = p - 1, S = new Array(6), L, E;
          function A(z) {
            var C = S[z], N = S[z + 1];
            (L != C || E != N) && (s.beginPath(), s.moveTo(L, E), s.lineTo(C, N), s.stroke(), s.beginPath(), s.arc(C, N, p, 0, Math.PI * 2, !0), s.fill());
          }
          for (var T = 0, G = l.length; T < G; T++) {
            var O = l[T], Y = O._selection;
            if (O._transformCoordinates(u, S), L = S[0], E = S[1], Y & 2 && A(2), Y & 4 && A(4), s.fillRect(L - p, E - p, d, d), m > 0 && !(Y & 1)) {
              var B = s.fillStyle;
              s.fillStyle = "#ffffff", s.fillRect(L - y, E - y, m, m), s.fillStyle = B;
            }
          }
        }
        function r(s, l, u) {
          var d = l._segments, p = d.length, m = new Array(6), y = !0, S, L, E, A, T, G, O, Y;
          function B(C) {
            if (u)
              C._transformCoordinates(u, m), S = m[0], L = m[1];
            else {
              var N = C._point;
              S = N._x, L = N._y;
            }
            if (y)
              s.moveTo(S, L), y = !1;
            else {
              if (u)
                T = m[2], G = m[3];
              else {
                var j = C._handleIn;
                T = S + j._x, G = L + j._y;
              }
              T === S && G === L && O === E && Y === A ? s.lineTo(S, L) : s.bezierCurveTo(O, Y, T, G, S, L);
            }
            if (E = S, A = L, u)
              O = m[4], Y = m[5];
            else {
              var j = C._handleOut;
              O = E + j._x, Y = A + j._y;
            }
          }
          for (var z = 0; z < p; z++)
            B(d[z]);
          l._closed && p > 0 && B(d[0]);
        }
        return {
          _draw: function(s, l, u, d) {
            var p = l.dontStart, m = l.dontFinish || l.clip, y = this.getStyle(), S = y.hasFill(), L = y.hasStroke(), E = y.getDashArray(), A = !Ve.support.nativeDash && L && E && E.length;
            p || s.beginPath(), (S || L && !A || m) && (r(s, this, d), this._closed && s.closePath());
            function T(C) {
              return E[(C % A + A) % A];
            }
            if (!m && (S || L) && (this._setStyles(s, l, u), S && (s.fill(y.getFillRule()), s.shadowColor = "rgba(0,0,0,0)"), L)) {
              if (A) {
                p || s.beginPath();
                for (var G = new rt(
                  this,
                  0.25,
                  32,
                  !1,
                  d
                ), O = G.length, Y = -y.getDashOffset(), B, z = 0; Y > 0; )
                  Y -= T(z--) + T(z--);
                for (; Y < O; )
                  B = Y + T(z++), (Y > 0 || B > 0) && G.drawPart(
                    s,
                    Math.max(Y, 0),
                    Math.max(B, 0)
                  ), Y = B + T(z++);
              }
              s.stroke();
            }
          },
          _drawSelected: function(s, l) {
            s.beginPath(), r(s, this, l), s.stroke(), i(s, this._segments, l, Ve.settings.handleSize);
          }
        };
      }(),
      new function() {
        function i(r) {
          var s = r._segments;
          if (!s.length)
            throw new Error("Use a moveTo() command first");
          return s[s.length - 1];
        }
        return {
          moveTo: function() {
            var r = this._segments;
            r.length === 1 && this.removeSegment(0), r.length || this._add([new ce(M.read(arguments))]);
          },
          moveBy: function() {
            throw new Error("moveBy() is unsupported on Path items.");
          },
          lineTo: function() {
            this._add([new ce(M.read(arguments))]);
          },
          cubicCurveTo: function() {
            var r = arguments, s = M.read(r), l = M.read(r), u = M.read(r), d = i(this);
            d.setHandleOut(s.subtract(d._point)), this._add([new ce(u, l.subtract(u))]);
          },
          quadraticCurveTo: function() {
            var r = arguments, s = M.read(r), l = M.read(r), u = i(this)._point;
            this.cubicCurveTo(
              s.add(u.subtract(s).multiply(1 / 3)),
              s.add(l.subtract(s).multiply(1 / 3)),
              l
            );
          },
          curveTo: function() {
            var r = arguments, s = M.read(r), l = M.read(r), u = o.pick(o.read(r), 0.5), d = 1 - u, p = i(this)._point, m = s.subtract(p.multiply(d * d)).subtract(l.multiply(u * u)).divide(2 * u * d);
            if (m.isNaN())
              throw new Error(
                "Cannot put a curve through points with parameter = " + u
              );
            this.quadraticCurveTo(m, l);
          },
          arcTo: function() {
            var r = arguments, s = Math.abs, l = Math.sqrt, u = i(this), d = u._point, p = M.read(r), G, m = o.peek(r), y = o.pick(m, !0), S, L, E, A;
            if (typeof y == "boolean")
              var T = d.add(p).divide(2), G = T.add(T.subtract(d).rotate(
                y ? -90 : 90
              ));
            else if (o.remain(r) <= 2)
              G = p, p = M.read(r);
            else if (!d.equals(p)) {
              var O = U.read(r), Y = I.isZero;
              if (Y(O.width) || Y(O.height))
                return this.lineTo(p);
              var B = o.read(r), y = !!o.read(r), z = !!o.read(r), T = d.add(p).divide(2), C = d.subtract(T).rotate(-B), N = C.x, j = C.y, q = s(O.width), H = s(O.height), te = q * q, ae = H * H, le = N * N, me = j * j, se = l(le / te + me / ae);
              if (se > 1 && (q *= se, H *= se, te = q * q, ae = H * H), se = (te * ae - te * me - ae * le) / (te * me + ae * le), s(se) < 1e-12 && (se = 0), se < 0)
                throw new Error(
                  "Cannot create an arc with the given arguments"
                );
              S = new M(q * j / H, -H * N / q).multiply((z === y ? -1 : 1) * l(se)).rotate(B).add(T), A = new J().translate(S).rotate(B).scale(q, H), E = A._inverseTransform(d), L = E.getDirectedAngle(A._inverseTransform(p)), !y && L > 0 ? L -= 360 : y && L < 0 && (L += 360);
            }
            if (G) {
              var de = new he(
                d.add(G).divide(2),
                G.subtract(d).rotate(90),
                !0
              ), ve = new he(
                G.add(p).divide(2),
                p.subtract(G).rotate(90),
                !0
              ), we = new he(d, p), Se = we.getSide(G);
              if (S = de.intersect(ve, !0), !S) {
                if (!Se)
                  return this.lineTo(p);
                throw new Error(
                  "Cannot create an arc with the given arguments"
                );
              }
              E = d.subtract(S), L = E.getDirectedAngle(p.subtract(S));
              var Ae = we.getSide(S, !0);
              Ae === 0 ? L = Se * s(L) : Se === Ae && (L += L < 0 ? 360 : -360);
            }
            if (L) {
              for (var Ge = 1e-5, Qe = s(L), st = Qe >= 360 ? 4 : Math.ceil((Qe - Ge) / 90), mt = L / st, Re = mt * Math.PI / 360, Fe = 4 / 3 * Math.sin(Re) / (1 + Math.cos(Re)), at = [], yt = 0; yt <= st; yt++) {
                var C = p, bt = null;
                if (yt < st && (bt = E.rotate(90).multiply(Fe), A ? (C = A._transformPoint(E), bt = A._transformPoint(E.add(bt)).subtract(C)) : C = S.add(E)), !yt)
                  u.setHandleOut(bt);
                else {
                  var Rt = E.rotate(-90).multiply(Fe);
                  A && (Rt = A._transformPoint(E.add(Rt)).subtract(C)), at.push(new ce(C, Rt, bt));
                }
                E = E.rotate(mt);
              }
              this._add(at);
            }
          },
          lineBy: function() {
            var r = M.read(arguments), s = i(this)._point;
            this.lineTo(s.add(r));
          },
          curveBy: function() {
            var r = arguments, s = M.read(r), l = M.read(r), u = o.read(r), d = i(this)._point;
            this.curveTo(d.add(s), d.add(l), u);
          },
          cubicCurveBy: function() {
            var r = arguments, s = M.read(r), l = M.read(r), u = M.read(r), d = i(this)._point;
            this.cubicCurveTo(
              d.add(s),
              d.add(l),
              d.add(u)
            );
          },
          quadraticCurveBy: function() {
            var r = arguments, s = M.read(r), l = M.read(r), u = i(this)._point;
            this.quadraticCurveTo(u.add(s), u.add(l));
          },
          arcBy: function() {
            var r = arguments, s = i(this)._point, l = s.add(M.read(r)), u = o.pick(o.peek(r), !0);
            typeof u == "boolean" ? this.arcTo(l, u) : this.arcTo(l, s.add(M.read(r)));
          },
          closePath: function(r) {
            this.setClosed(!0), this.join(this, r);
          }
        };
      }(),
      {
        _getBounds: function(i, r) {
          var s = r.handle ? "getHandleBounds" : r.stroke ? "getStrokeBounds" : "getBounds";
          return $e[s](this._segments, this._closed, this, i, r);
        },
        statics: {
          getBounds: function(i, r, s, l, u, d) {
            var p = i[0];
            if (!p)
              return new D();
            var m = new Array(6), y = p._transformCoordinates(l, new Array(6)), S = y.slice(0, 2), L = S.slice(), E = new Array(2);
            function A(O) {
              O._transformCoordinates(l, m);
              for (var Y = 0; Y < 2; Y++)
                ze._addBounds(
                  y[Y],
                  y[Y + 4],
                  m[Y + 2],
                  m[Y],
                  Y,
                  d ? d[Y] : 0,
                  S,
                  L,
                  E
                );
              var B = y;
              y = m, m = B;
            }
            for (var T = 1, G = i.length; T < G; T++)
              A(i[T]);
            return r && A(p), new D(S[0], S[1], L[0] - S[0], L[1] - S[1]);
          },
          getStrokeBounds: function(i, r, s, l, u) {
            var d = s.getStyle(), p = d.hasStroke(), m = d.getStrokeWidth(), y = p && s._getStrokeMatrix(l, u), S = p && $e._getStrokePadding(
              m,
              y
            ), L = $e.getBounds(
              i,
              r,
              s,
              l,
              u,
              S
            );
            if (!p)
              return L;
            var E = m / 2, A = d.getStrokeJoin(), T = d.getStrokeCap(), G = d.getMiterLimit(), O = new D(new U(S));
            function Y(q) {
              L = L.include(q);
            }
            function B(q) {
              L = L.unite(
                O.setCenter(q._point.transform(l))
              );
            }
            function z(q, H) {
              H === "round" || q.isSmooth() ? B(q) : $e._addBevelJoin(
                q,
                H,
                E,
                G,
                l,
                y,
                Y
              );
            }
            function C(q, H) {
              H === "round" ? B(q) : $e._addSquareCap(
                q,
                H,
                E,
                l,
                y,
                Y
              );
            }
            var N = i.length - (r ? 0 : 1);
            if (N > 0) {
              for (var j = 1; j < N; j++)
                z(i[j], A);
              r ? z(i[0], A) : (C(i[0], T), C(i[i.length - 1], T));
            }
            return L;
          },
          _getStrokePadding: function(i, r) {
            if (!r)
              return [i, i];
            var s = new M(i, 0).transform(r), l = new M(0, i).transform(r), u = s.getAngleInRadians(), d = s.getLength(), p = l.getLength(), m = Math.sin(u), y = Math.cos(u), S = Math.tan(u), L = Math.atan2(p * S, d), E = Math.atan2(p, S * d);
            return [
              Math.abs(d * Math.cos(L) * y + p * Math.sin(L) * m),
              Math.abs(p * Math.sin(E) * y + d * Math.cos(E) * m)
            ];
          },
          _addBevelJoin: function(i, r, s, l, u, d, p, m) {
            var y = i.getCurve(), S = y.getPrevious(), L = y.getPoint1().transform(u), E = S.getNormalAtTime(1).multiply(s).transform(d), A = y.getNormalAtTime(0).multiply(s).transform(d), T = E.getDirectedAngle(A);
            if ((T < 0 || T >= 180) && (E = E.negate(), A = A.negate()), m && p(L), p(L.add(E)), r === "miter") {
              var G = new he(
                L.add(E),
                new M(-E.y, E.x),
                !0
              ).intersect(new he(
                L.add(A),
                new M(-A.y, A.x),
                !0
              ), !0);
              G && L.getDistance(G) <= l * s && p(G);
            }
            p(L.add(A));
          },
          _addSquareCap: function(i, r, s, l, u, d, p) {
            var m = i._point.transform(l), y = i.getLocation(), S = y.getNormal().multiply(y.getTime() === 0 ? s : -s).transform(u);
            r === "square" && (p && (d(m.subtract(S)), d(m.add(S))), m = m.add(S.rotate(-90))), d(m.add(S)), d(m.subtract(S));
          },
          getHandleBounds: function(i, r, s, l, u) {
            var d = s.getStyle(), p = u.stroke && d.hasStroke(), m, y;
            if (p) {
              var S = s._getStrokeMatrix(l, u), L = d.getStrokeWidth() / 2, E = L;
              d.getStrokeJoin() === "miter" && (E = L * d.getMiterLimit()), d.getStrokeCap() === "square" && (E = Math.max(E, L * Math.SQRT2)), m = $e._getStrokePadding(L, S), y = $e._getStrokePadding(E, S);
            }
            for (var A = new Array(6), T = 1 / 0, G = -T, O = T, Y = G, B = 0, z = i.length; B < z; B++) {
              var C = i[B];
              C._transformCoordinates(l, A);
              for (var N = 0; N < 6; N += 2) {
                var j = N ? m : y, q = j ? j[0] : 0, H = j ? j[1] : 0, te = A[N], ae = A[N + 1], le = te - q, me = te + q, se = ae - H, de = ae + H;
                le < T && (T = le), me > G && (G = me), se < O && (O = se), de > Y && (Y = de);
              }
            }
            return new D(T, O, G - T, Y - O);
          }
        }
      }
    );
    $e.inject({ statics: new function() {
      var i = 0.5522847498307936, r = [
        new ce([-1, 0], [0, i], [0, -i]),
        new ce([0, -1], [-i, 0], [i, 0]),
        new ce([1, 0], [0, -i], [0, i]),
        new ce([0, 1], [i, 0], [-i, 0])
      ];
      function s(u, d, p) {
        var m = o.getNamed(p), y = new $e(m && (m.insert == !0 ? X.INSERT : m.insert == !1 ? X.NO_INSERT : null));
        return y._add(u), y._closed = d, y.set(m, X.INSERT);
      }
      function l(u, d, p) {
        for (var m = new Array(4), y = 0; y < 4; y++) {
          var S = r[y];
          m[y] = new ce(
            S._point.multiply(d).add(u),
            S._handleIn.multiply(d),
            S._handleOut.multiply(d)
          );
        }
        return s(m, !0, p);
      }
      return {
        Line: function() {
          var u = arguments;
          return s([
            new ce(M.readNamed(u, "from")),
            new ce(M.readNamed(u, "to"))
          ], !1, u);
        },
        Circle: function() {
          var u = arguments, d = M.readNamed(u, "center"), p = o.readNamed(u, "radius");
          return l(d, new U(p), u);
        },
        Rectangle: function() {
          var u = arguments, d = D.readNamed(u, "rectangle"), p = U.readNamed(
            u,
            "radius",
            0,
            { readNull: !0 }
          ), m = d.getBottomLeft(!0), y = d.getTopLeft(!0), S = d.getTopRight(!0), L = d.getBottomRight(!0), E;
          if (!p || p.isZero())
            E = [
              new ce(m),
              new ce(y),
              new ce(S),
              new ce(L)
            ];
          else {
            p = U.min(p, d.getSize(!0).divide(2));
            var A = p.width, T = p.height, G = A * i, O = T * i;
            E = [
              new ce(m.add(A, 0), null, [-G, 0]),
              new ce(m.subtract(0, T), [0, O]),
              new ce(y.add(0, T), null, [0, -O]),
              new ce(y.add(A, 0), [-G, 0], null),
              new ce(S.subtract(A, 0), null, [G, 0]),
              new ce(S.add(0, T), [0, -O], null),
              new ce(L.subtract(0, T), null, [0, O]),
              new ce(L.subtract(A, 0), [G, 0])
            ];
          }
          return s(E, !0, u);
        },
        RoundRectangle: "#Rectangle",
        Ellipse: function() {
          var u = arguments, d = Oe._readEllipse(u);
          return l(d.center, d.radius, u);
        },
        Oval: "#Ellipse",
        Arc: function() {
          var u = arguments, d = M.readNamed(u, "from"), p = M.readNamed(u, "through"), m = M.readNamed(u, "to"), y = o.getNamed(u), S = new $e(y && y.insert == !1 && X.NO_INSERT);
          return S.moveTo(d), S.arcTo(p, m), S.set(y);
        },
        RegularPolygon: function() {
          for (var u = arguments, d = M.readNamed(u, "center"), p = o.readNamed(u, "sides"), m = o.readNamed(u, "radius"), y = 360 / p, S = p % 3 === 0, L = new M(0, S ? -m : m), E = S ? -1 : 0.5, A = new Array(p), T = 0; T < p; T++)
            A[T] = new ce(d.add(
              L.rotate((T + E) * y)
            ));
          return s(A, !0, u);
        },
        Star: function() {
          for (var u = arguments, d = M.readNamed(u, "center"), p = o.readNamed(u, "points") * 2, m = o.readNamed(u, "radius1"), y = o.readNamed(u, "radius2"), S = 360 / p, L = new M(0, -1), E = new Array(p), A = 0; A < p; A++)
            E[A] = new ce(d.add(L.rotate(S * A).multiply(A % 2 ? y : m)));
          return s(E, !0, u);
        }
      };
    }() });
    var It = Gt.extend(
      {
        _class: "CompoundPath",
        _serializeFields: {
          children: []
        },
        beans: !0,
        initialize: function(i) {
          this._children = [], this._namedChildren = {}, this._initialize(i) || (typeof i == "string" ? this.setPathData(i) : this.addChildren(Array.isArray(i) ? i : arguments));
        },
        insertChildren: function i(r, s) {
          var l = s, u = l[0];
          u && typeof u[0] == "number" && (l = [l]);
          for (var d = s.length - 1; d >= 0; d--) {
            var p = l[d];
            l === s && !(p instanceof $e) && (l = o.slice(l)), Array.isArray(p) ? l[d] = new $e({ segments: p, insert: !1 }) : p instanceof It && (l.splice.apply(l, [d, 1].concat(p.removeChildren())), p.remove());
          }
          return i.base.call(this, r, l);
        },
        reduce: function i(r) {
          for (var s = this._children, l = s.length - 1; l >= 0; l--) {
            var u = s[l].reduce(r);
            u.isEmpty() && u.remove();
          }
          if (!s.length) {
            var u = new $e(X.NO_INSERT);
            return u.copyAttributes(this), u.insertAbove(this), this.remove(), u;
          }
          return i.base.call(this);
        },
        isClosed: function() {
          for (var i = this._children, r = 0, s = i.length; r < s; r++)
            if (!i[r]._closed)
              return !1;
          return !0;
        },
        setClosed: function(i) {
          for (var r = this._children, s = 0, l = r.length; s < l; s++)
            r[s].setClosed(i);
        },
        getFirstSegment: function() {
          var i = this.getFirstChild();
          return i && i.getFirstSegment();
        },
        getLastSegment: function() {
          var i = this.getLastChild();
          return i && i.getLastSegment();
        },
        getCurves: function() {
          for (var i = this._children, r = [], s = 0, l = i.length; s < l; s++)
            o.push(r, i[s].getCurves());
          return r;
        },
        getFirstCurve: function() {
          var i = this.getFirstChild();
          return i && i.getFirstCurve();
        },
        getLastCurve: function() {
          var i = this.getLastChild();
          return i && i.getLastCurve();
        },
        getArea: function() {
          for (var i = this._children, r = 0, s = 0, l = i.length; s < l; s++)
            r += i[s].getArea();
          return r;
        },
        getLength: function() {
          for (var i = this._children, r = 0, s = 0, l = i.length; s < l; s++)
            r += i[s].getLength();
          return r;
        },
        getPathData: function(i, r) {
          for (var s = this._children, l = [], u = 0, d = s.length; u < d; u++) {
            var p = s[u], m = p._matrix;
            l.push(p.getPathData(i && !m.isIdentity() ? i.appended(m) : i, r));
          }
          return l.join("");
        },
        _hitTestChildren: function i(r, s, l) {
          return i.base.call(
            this,
            r,
            s.class === $e || s.type === "path" ? s : o.set({}, s, { fill: !1 }),
            l
          );
        },
        _draw: function(i, r, s, l) {
          var u = this._children;
          if (u.length) {
            r = r.extend({ dontStart: !0, dontFinish: !0 }), i.beginPath();
            for (var d = 0, p = u.length; d < p; d++)
              u[d].draw(i, r, l);
            if (!r.clip) {
              this._setStyles(i, r, s);
              var m = this._style;
              m.hasFill() && (i.fill(m.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), m.hasStroke() && i.stroke();
            }
          }
        },
        _drawSelected: function(i, r, s) {
          for (var l = this._children, u = 0, d = l.length; u < d; u++) {
            var p = l[u], m = p._matrix;
            s[p._id] || p._drawSelected(i, m.isIdentity() ? r : r.appended(m));
          }
        }
      },
      new function() {
        function i(r, s) {
          var l = r._children;
          if (s && !l.length)
            throw new Error("Use a moveTo() command first");
          return l[l.length - 1];
        }
        return o.each(
          [
            "lineTo",
            "cubicCurveTo",
            "quadraticCurveTo",
            "curveTo",
            "arcTo",
            "lineBy",
            "cubicCurveBy",
            "quadraticCurveBy",
            "curveBy",
            "arcBy"
          ],
          function(r) {
            this[r] = function() {
              var s = i(this, !0);
              s[r].apply(s, arguments);
            };
          },
          {
            moveTo: function() {
              var r = i(this), s = r && r.isEmpty() ? r : new $e(X.NO_INSERT);
              s !== r && this.addChild(s), s.moveTo.apply(s, arguments);
            },
            moveBy: function() {
              var r = i(this, !0), s = r && r.getLastSegment(), l = M.read(arguments);
              this.moveTo(s ? l.add(s._point) : l);
            },
            closePath: function(r) {
              i(this, !0).closePath(r);
            }
          }
        );
      }(),
      o.each(["reverse", "flatten", "simplify", "smooth"], function(i) {
        this[i] = function(r) {
          for (var s = this._children, l, u = 0, d = s.length; u < d; u++)
            l = s[u][i](r) || l;
          return l;
        };
      }, {})
    );
    Gt.inject(new function() {
      var i = Math.min, r = Math.max, s = Math.abs, l = {
        unite: { 1: !0, 2: !0 },
        intersect: { 2: !0 },
        subtract: { 1: !0 },
        exclude: { 1: !0, "-1": !0 }
      };
      function u(B) {
        return B._children || [B];
      }
      function d(B, z) {
        var C = B.clone(!1).reduce({ simplify: !0 }).transform(null, !0, !0);
        if (z) {
          for (var N = u(C), j = 0, q = N.length; j < q; j++) {
            var B = N[j];
            !B._closed && !B.isEmpty() && (B.closePath(1e-12), B.getFirstSegment().setHandleIn(0, 0), B.getLastSegment().setHandleOut(0, 0));
          }
          C = C.resolveCrossings().reorient(C.getFillRule() === "nonzero", !0);
        }
        return C;
      }
      function p(B, z, C, N, j) {
        var q = new It(X.NO_INSERT);
        return q.addChildren(B, !0), q = q.reduce({ simplify: z }), j && j.insert == !1 || q.insertAbove(N && C.isSibling(N) && C.getIndex() < N.getIndex() ? N : C), q.copyAttributes(C, !0), q;
      }
      function m(B) {
        return B.hasOverlap() || B.isCrossing();
      }
      function y(B, z, C, N) {
        if (N && (N.trace == !1 || N.stroke) && /^(subtract|intersect)$/.test(C))
          return S(B, z, C);
        var j = d(B, !0), q = z && B !== z && d(z, !0), H = l[C];
        H[C] = !0, q && (H.subtract || H.exclude) ^ (q.isClockwise() ^ j.isClockwise()) && q.reverse();
        var te = T(ht.expand(
          j.getIntersections(q, m)
        )), ae = u(j), le = q && u(q), me = [], se = [], de;
        function ve(bt) {
          for (var Rt = 0, Pt = bt.length; Rt < Pt; Rt++) {
            var zt = bt[Rt];
            o.push(me, zt._segments), o.push(se, zt.getCurves()), zt._overlapsOnly = !0;
          }
        }
        function we(bt) {
          for (var Rt = [], Pt = 0, zt = bt && bt.length; Pt < zt; Pt++)
            Rt.push(se[bt[Pt]]);
          return Rt;
        }
        if (te.length) {
          ve(ae), le && ve(le);
          for (var Se = new Array(se.length), Ae = 0, Ge = se.length; Ae < Ge; Ae++)
            Se[Ae] = se[Ae].getValues();
          for (var Qe = x.findCurveBoundsCollisions(
            Se,
            Se,
            0,
            !0
          ), st = {}, Ae = 0; Ae < se.length; Ae++) {
            var mt = se[Ae], Re = mt._path._id, Fe = st[Re] = st[Re] || {};
            Fe[mt.getIndex()] = {
              hor: we(Qe[Ae].hor),
              ver: we(Qe[Ae].ver)
            };
          }
          for (var Ae = 0, Ge = te.length; Ae < Ge; Ae++)
            O(
              te[Ae]._segment,
              j,
              q,
              st,
              H
            );
          for (var Ae = 0, Ge = me.length; Ae < Ge; Ae++) {
            var at = me[Ae], yt = at._intersection;
            at._winding || O(
              at,
              j,
              q,
              st,
              H
            ), yt && yt._overlap || (at._path._overlapsOnly = !1);
          }
          de = Y(me, H);
        } else
          de = A(
            le ? ae.concat(le) : ae.slice(),
            function(bt) {
              return !!H[bt];
            }
          );
        return p(de, !0, B, z, N);
      }
      function S(B, z, C) {
        var N = d(B), j = d(z), q = N.getIntersections(j, m), H = C === "subtract", te = C === "divide", ae = {}, le = [];
        function me(ve) {
          if (!ae[ve._id] && (te || j.contains(ve.getPointAt(ve.getLength() / 2)) ^ H))
            return le.unshift(ve), ae[ve._id] = !0;
        }
        for (var se = q.length - 1; se >= 0; se--) {
          var de = q[se].split();
          de && (me(de) && de.getFirstSegment().setHandleIn(0, 0), N.getLastSegment().setHandleOut(0, 0));
        }
        return me(N), p(le, !1, B, z);
      }
      function L(B, z) {
        for (var C = B; C; ) {
          if (C === z)
            return;
          C = C._previous;
        }
        for (; B._next && B._next !== z; )
          B = B._next;
        if (!B._next) {
          for (; z._previous; )
            z = z._previous;
          B._next = z, z._previous = B;
        }
      }
      function E(B) {
        for (var z = B.length - 1; z >= 0; z--)
          B[z].clearHandles();
      }
      function A(B, z, C) {
        var N = B && B.length;
        if (N) {
          var j = o.each(B, function(Qe, st) {
            this[Qe._id] = {
              container: null,
              winding: Qe.isClockwise() ? 1 : -1,
              index: st
            };
          }, {}), q = B.slice().sort(function(Qe, st) {
            return s(st.getArea()) - s(Qe.getArea());
          }), H = q[0], te = x.findItemBoundsCollisions(
            q,
            null,
            I.GEOMETRIC_EPSILON
          );
          C == null && (C = H.isClockwise());
          for (var ae = 0; ae < N; ae++) {
            var le = q[ae], me = j[le._id], se = 0, de = te[ae];
            if (de) {
              for (var ve = null, we = de.length - 1; we >= 0; we--)
                if (de[we] < ae) {
                  ve = ve || le.getInteriorPoint();
                  var Se = q[de[we]];
                  if (Se.contains(ve)) {
                    var Ae = j[Se._id];
                    se = Ae.winding, me.winding += se, me.container = Ae.exclude ? Ae.container : Se;
                    break;
                  }
                }
            }
            if (z(me.winding) === z(se))
              me.exclude = !0, B[me.index] = null;
            else {
              var Ge = me.container;
              le.setClockwise(
                Ge ? !Ge.isClockwise() : C
              );
            }
          }
        }
        return B;
      }
      function T(B, z, C) {
        var N = z && [], j = 1e-8, q = 1 - j, H = !1, te = C || [], ae = C && {}, le, me, se;
        function de(Rt) {
          return Rt._path._id + "." + Rt._segment1._index;
        }
        for (var ve = (C && C.length) - 1; ve >= 0; ve--) {
          var we = C[ve];
          we._path && (ae[de(we)] = !0);
        }
        for (var ve = B.length - 1; ve >= 0; ve--) {
          var Se = B[ve], Ae = Se._time, Ge = Ae, Qe = z && !z(Se), we = Se._curve, st;
          if (we && (we !== me ? (H = !we.hasHandles() || ae && ae[de(we)], le = [], se = null, me = we) : se >= j && (Ae /= se)), Qe) {
            le && le.push(Se);
            continue;
          } else
            z && N.unshift(Se);
          if (se = Ge, Ae < j)
            st = we._segment1;
          else if (Ae > q)
            st = we._segment2;
          else {
            var mt = we.divideAtTime(Ae, !0);
            H && te.push(we, mt), st = mt._segment1;
            for (var Re = le.length - 1; Re >= 0; Re--) {
              var Fe = le[Re];
              Fe._time = (Fe._time - Ae) / (1 - Ae);
            }
          }
          Se._setSegment(st);
          var at = st._intersection, yt = Se._intersection;
          if (at) {
            L(at, yt);
            for (var bt = at; bt; )
              L(bt._intersection, at), bt = bt._next;
          } else
            st._intersection = yt;
        }
        return C || E(te), N || B;
      }
      function G(B, z, C, N, j) {
        var q = Array.isArray(z) ? z : z[C ? "hor" : "ver"], H = C ? 1 : 0, te = H ^ 1, ae = [B.x, B.y], le = ae[H], me = ae[te], se = 1e-9, de = 1e-6, ve = le - se, we = le + se, Se = 0, Ae = 0, Ge = 0, Qe = 0, st = !1, mt = !1, Re = 1, Fe = [], at, yt;
        function bt(kt) {
          var fi = kt[te + 0], Ti = kt[te + 6];
          if (!(me < i(fi, Ti) || me > r(fi, Ti))) {
            var xi = kt[H + 0], tn = kt[H + 2], Hi = kt[H + 4], Zi = kt[H + 6];
            if (fi === Ti) {
              (xi < we && Zi > ve || Zi < we && xi > ve) && (st = !0);
              return;
            }
            var Xi = me === fi ? 0 : me === Ti || ve > r(xi, tn, Hi, Zi) || we < i(xi, tn, Hi, Zi) ? 1 : ze.solveCubic(kt, te, me, Fe, 0, 1) > 0 ? Fe[0] : 1, ji = Xi === 0 ? xi : Xi === 1 ? Zi : ze.getPoint(kt, Xi)[C ? "y" : "x"], Ki = fi > Ti ? 1 : -1, ln = at[te] > at[te + 6] ? 1 : -1, Fi = at[H + 6];
            return me !== fi ? (ji < ve ? Ge += Ki : ji > we ? Qe += Ki : st = !0, ji > le - de && ji < le + de && (Re /= 2)) : (Ki !== ln ? xi < ve ? Ge += Ki : xi > we && (Qe += Ki) : xi != Fi && (Fi < we && ji > we ? (Qe += Ki, st = !0) : Fi > ve && ji < ve && (Ge += Ki, st = !0)), Re /= 4), at = kt, !j && ji > ve && ji < we && ze.getTangent(kt, Xi)[C ? "x" : "y"] === 0 && G(B, z, !C, N, !0);
          }
        }
        function Rt(kt) {
          var fi = kt[te + 0], Ti = kt[te + 2], xi = kt[te + 4], tn = kt[te + 6];
          if (me <= r(fi, Ti, xi, tn) && me >= i(fi, Ti, xi, tn)) {
            for (var Hi = kt[H + 0], Zi = kt[H + 2], Xi = kt[H + 4], ji = kt[H + 6], Ki = ve > r(Hi, Zi, Xi, ji) || we < i(Hi, Zi, Xi, ji) ? [kt] : ze.getMonoCurves(kt, C), ln, Fi = 0, hn = Ki.length; Fi < hn; Fi++)
              if (ln = bt(Ki[Fi]))
                return ln;
          }
        }
        for (var Pt = 0, zt = q.length; Pt < zt; Pt++) {
          var Wt = q[Pt], Ft = Wt._path, Mi = Wt.getValues(), yi;
          if ((!Pt || q[Pt - 1]._path !== Ft) && (at = null, Ft._closed || (yt = ze.getValues(
            Ft.getLastCurve().getSegment2(),
            Wt.getSegment1(),
            null,
            !N
          ), yt[te] !== yt[te + 6] && (at = yt)), !at)) {
            at = Mi;
            for (var Ai = Ft.getLastCurve(); Ai && Ai !== Wt; ) {
              var pi = Ai.getValues();
              if (pi[te] !== pi[te + 6]) {
                at = pi;
                break;
              }
              Ai = Ai.getPrevious();
            }
          }
          if (yi = Rt(Mi))
            return yi;
          if (Pt + 1 === zt || q[Pt + 1]._path !== Ft) {
            if (yt && (yi = Rt(yt)))
              return yi;
            st && !Ge && !Qe && (Ge = Qe = Ft.isClockwise(N) ^ C ? 1 : -1), Se += Ge, Ae += Qe, Ge = Qe = 0, st && (mt = !0, st = !1), yt = null;
          }
        }
        return Se = s(Se), Ae = s(Ae), {
          winding: r(Se, Ae),
          windingL: Se,
          windingR: Ae,
          quality: Re,
          onPath: mt
        };
      }
      function O(B, z, C, N, j) {
        var q = [], H = B, te = 0, ae;
        do {
          var le = B.getCurve();
          if (le) {
            var me = le.getLength();
            q.push({ segment: B, curve: le, length: me }), te += me;
          }
          B = B.getNext();
        } while (B && !B._intersection && B !== H);
        for (var se = [0.5, 0.25, 0.75], ae = { winding: 0, quality: -1 }, de = 1e-3, ve = 1 - de, we = 0; we < se.length && ae.quality < 0.5; we++)
          for (var me = te * se[we], Se = 0, Ae = q.length; Se < Ae; Se++) {
            var Ge = q[Se], Qe = Ge.length;
            if (me <= Qe) {
              var le = Ge.curve, st = le._path, mt = st._parent, Re = mt instanceof It ? mt : st, Fe = I.clamp(le.getTimeAt(me), de, ve), at = le.getPointAtTime(Fe), yt = s(le.getTangentAtTime(Fe).y) < Math.SQRT1_2, bt = null;
              if (j.subtract && C) {
                var Rt = Re === z ? C : z, Pt = Rt._getWinding(at, yt, !0);
                if (Re === z && Pt.winding || Re === C && !Pt.winding) {
                  if (Pt.quality < 1)
                    continue;
                  bt = { winding: 0, quality: 1 };
                }
              }
              bt = bt || G(
                at,
                N[st._id][le.getIndex()],
                yt,
                !0
              ), bt.quality > ae.quality && (ae = bt);
              break;
            }
            me -= Qe;
          }
        for (var Se = q.length - 1; Se >= 0; Se--)
          q[Se].segment._winding = ae;
      }
      function Y(B, z) {
        var C = [], N;
        function j(zt) {
          var Wt;
          return !!(zt && !zt._visited && (!z || z[(Wt = zt._winding || {}).winding] && !(z.unite && Wt.winding === 2 && Wt.windingL && Wt.windingR)));
        }
        function q(zt) {
          if (zt) {
            for (var Wt = 0, Ft = N.length; Wt < Ft; Wt++)
              if (zt === N[Wt])
                return !0;
          }
          return !1;
        }
        function H(zt) {
          for (var Wt = zt._segments, Ft = 0, Mi = Wt.length; Ft < Mi; Ft++)
            Wt[Ft]._visited = !0;
        }
        function te(zt, Wt) {
          var Ft = zt._intersection, Mi = Ft, yi = [];
          Wt && (N = [zt]);
          function Ai(pi, kt) {
            for (; pi && pi !== kt; ) {
              var fi = pi._segment, Ti = fi && fi._path;
              if (Ti) {
                var xi = fi.getNext() || Ti.getFirstSegment(), tn = xi._intersection;
                fi !== zt && (q(fi) || q(xi) || xi && j(fi) && (j(xi) || tn && j(tn._segment))) && yi.push(fi), Wt && N.push(fi);
              }
              pi = pi._next;
            }
          }
          if (Ft) {
            for (Ai(Ft); Ft && Ft._previous; )
              Ft = Ft._previous;
            Ai(Ft, Mi);
          }
          return yi;
        }
        B.sort(function(zt, Wt) {
          var Ft = zt._intersection, Mi = Wt._intersection, yi = !!(Ft && Ft._overlap), Ai = !!(Mi && Mi._overlap), pi = zt._path, kt = Wt._path;
          return yi ^ Ai ? yi ? 1 : -1 : !Ft ^ !Mi ? Ft ? 1 : -1 : pi !== kt ? pi._id - kt._id : zt._index - Wt._index;
        });
        for (var ae = 0, le = B.length; ae < le; ae++) {
          var me = B[ae], se = j(me), de = null, ve = !1, we = !0, Se = [], Ae, Ge, Qe;
          if (se && me._path._overlapsOnly) {
            var st = me._path, mt = me._intersection._segment._path;
            st.compare(mt) && (st.getArea() && C.push(st.clone(!1)), H(st), H(mt), se = !1);
          }
          for (; se; ) {
            var Re = !de, Fe = te(me, Re), at = Fe.shift(), ve = !Re && (q(me) || q(at)), yt = !ve && at;
            if (Re && (de = new $e(X.NO_INSERT), Ae = null), ve) {
              (me.isFirst() || me.isLast()) && (we = me._path._closed), me._visited = !0;
              break;
            }
            if (yt && Ae && (Se.push(Ae), Ae = null), Ae || (yt && Fe.push(me), Ae = {
              start: de._segments.length,
              crossings: Fe,
              visited: Ge = [],
              handleIn: Qe
            }), yt && (me = at), !j(me)) {
              de.removeSegments(Ae.start);
              for (var bt = 0, Rt = Ge.length; bt < Rt; bt++)
                Ge[bt]._visited = !1;
              Ge.length = 0;
              do
                me = Ae && Ae.crossings.shift(), (!me || !me._path) && (me = null, Ae = Se.pop(), Ae && (Ge = Ae.visited, Qe = Ae.handleIn));
              while (Ae && !j(me));
              if (!me)
                break;
            }
            var Pt = me.getNext();
            de.add(new ce(
              me._point,
              Qe,
              Pt && me._handleOut
            )), me._visited = !0, Ge.push(me), me = Pt || me._path.getFirstSegment(), Qe = Pt && Pt._handleIn;
          }
          ve && (we && (de.getFirstSegment().setHandleIn(Qe), de.setClosed(we)), de.getArea() !== 0 && C.push(de));
        }
        return C;
      }
      return {
        _getWinding: function(B, z, C) {
          return G(B, this.getCurves(), z, C);
        },
        unite: function(B, z) {
          return y(this, B, "unite", z);
        },
        intersect: function(B, z) {
          return y(this, B, "intersect", z);
        },
        subtract: function(B, z) {
          return y(this, B, "subtract", z);
        },
        exclude: function(B, z) {
          return y(this, B, "exclude", z);
        },
        divide: function(B, z) {
          return z && (z.trace == !1 || z.stroke) ? S(this, B, "divide") : p([
            this.subtract(B, z),
            this.intersect(B, z)
          ], !0, this, B, z);
        },
        resolveCrossings: function() {
          var B = this._children, z = B || [this];
          function C(Ae, Ge) {
            var Qe = Ae && Ae._intersection;
            return Qe && Qe._overlap && Qe._path === Ge;
          }
          var N = !1, j = !1, q = this.getIntersections(null, function(Ae) {
            return Ae.hasOverlap() && (N = !0) || Ae.isCrossing() && (j = !0);
          }), H = N && j && [];
          if (q = ht.expand(q), N)
            for (var te = T(q, function(Ae) {
              return Ae.hasOverlap();
            }, H), ae = te.length - 1; ae >= 0; ae--) {
              var le = te[ae], me = le._path, se = le._segment, de = se.getPrevious(), ve = se.getNext();
              C(de, me) && C(ve, me) && (se.remove(), de._handleOut._set(0, 0), ve._handleIn._set(0, 0), de !== se && !de.getCurve().hasLength() && (ve._handleIn.set(de._handleIn), de.remove()));
            }
          j && (T(q, N && function(Ae) {
            var Ge = Ae.getCurve(), Qe = Ae.getSegment(), st = Ae._intersection, mt = st._curve, Re = st._segment;
            if (Ge && mt && Ge._path && mt._path)
              return !0;
            Qe && (Qe._intersection = null), Re && (Re._intersection = null);
          }, H), H && E(H), z = Y(o.each(z, function(Ae) {
            o.push(this, Ae._segments);
          }, [])));
          var we = z.length, Se;
          return we > 1 && B ? (z !== B && this.setChildren(z), Se = this) : we === 1 && !B && (z[0] !== this && this.setSegments(z[0].removeSegments()), Se = this), Se || (Se = new It(X.NO_INSERT), Se.addChildren(z), Se = Se.reduce(), Se.copyAttributes(this), this.replaceWith(Se)), Se;
        },
        reorient: function(B, z) {
          var C = this._children;
          return C && C.length ? this.setChildren(A(
            this.removeChildren(),
            function(N) {
              return !!(B ? N : N & 1);
            },
            z
          )) : z !== t && this.setClockwise(z), this;
        },
        getInteriorPoint: function() {
          var B = this.getBounds(), z = B.getCenter(!0);
          if (!this.contains(z)) {
            for (var C = this.getCurves(), N = z.y, j = [], q = [], H = 0, te = C.length; H < te; H++) {
              var ae = C[H].getValues(), le = ae[1], me = ae[3], se = ae[5], de = ae[7];
              if (N >= i(le, me, se, de) && N <= r(le, me, se, de))
                for (var ve = ze.getMonoCurves(ae), we = 0, Se = ve.length; we < Se; we++) {
                  var Ae = ve[we], Ge = Ae[1], Qe = Ae[7];
                  if (Ge !== Qe && (N >= Ge && N <= Qe || N >= Qe && N <= Ge)) {
                    var st = N === Ge ? Ae[0] : N === Qe ? Ae[6] : ze.solveCubic(Ae, 1, N, q, 0, 1) === 1 ? ze.getPoint(Ae, q[0]).x : (Ae[0] + Ae[6]) / 2;
                    j.push(st);
                  }
                }
            }
            j.length > 1 && (j.sort(function(mt, Re) {
              return mt - Re;
            }), z.x = (j[0] + j[1]) / 2);
          }
          return z;
        }
      };
    }());
    var rt = o.extend(
      {
        _class: "PathFlattener",
        initialize: function(i, r, s, l, u) {
          var d = [], p = [], m = 0, y = 1 / (s || 32), S = i._segments, L = S[0], E;
          function A(Y, B) {
            var z = ze.getValues(Y, B, u);
            d.push(z), T(z, Y._index, 0, 1);
          }
          function T(Y, B, z, C) {
            if (C - z > y && !(l && ze.isStraight(Y)) && !ze.isFlatEnough(Y, r || 0.25)) {
              var N = ze.subdivide(Y, 0.5), j = (z + C) / 2;
              T(N[0], B, z, j), T(N[1], B, j, C);
            } else {
              var q = Y[6] - Y[0], H = Y[7] - Y[1], te = Math.sqrt(q * q + H * H);
              te > 0 && (m += te, p.push({
                offset: m,
                curve: Y,
                index: B,
                time: C
              }));
            }
          }
          for (var G = 1, O = S.length; G < O; G++)
            E = S[G], A(L, E), L = E;
          i._closed && A(E || L, S[0]), this.curves = d, this.parts = p, this.length = m, this.index = 0;
        },
        _get: function(i) {
          for (var r = this.parts, s = r.length, l, u = this.index; l = u, !(!u || r[--u].offset < i); )
            ;
          for (; l < s; l++) {
            var d = r[l];
            if (d.offset >= i) {
              this.index = l;
              var p = r[l - 1], m = p && p.index === d.index ? p.time : 0, y = p ? p.offset : 0;
              return {
                index: d.index,
                time: m + (d.time - m) * (i - y) / (d.offset - y)
              };
            }
          }
          return {
            index: r[s - 1].index,
            time: 1
          };
        },
        drawPart: function(i, r, s) {
          for (var l = this._get(r), u = this._get(s), d = l.index, p = u.index; d <= p; d++) {
            var m = ze.getPart(
              this.curves[d],
              d === l.index ? l.time : 0,
              d === u.index ? u.time : 1
            );
            d === l.index && i.moveTo(m[0], m[1]), i.bezierCurveTo.apply(i, m.slice(2));
          }
        }
      },
      o.each(
        ze._evaluateMethods,
        function(i) {
          this[i + "At"] = function(r) {
            var s = this._get(r);
            return ze[i](this.curves[s.index], s.time);
          };
        },
        {}
      )
    ), it = o.extend({
      initialize: function(i) {
        for (var r = this.points = [], s = i._segments, l = i._closed, u = 0, d, p = s.length; u < p; u++) {
          var m = s[u].point;
          (!d || !d.equals(m)) && r.push(d = m.clone());
        }
        l && (r.unshift(r[r.length - 1]), r.push(r[1])), this.closed = l;
      },
      fit: function(i) {
        var r = this.points, s = r.length, l = null;
        return s > 0 && (l = [new ce(r[0])], s > 1 && (this.fitCubic(
          l,
          i,
          0,
          s - 1,
          r[1].subtract(r[0]),
          r[s - 2].subtract(r[s - 1])
        ), this.closed && (l.shift(), l.pop()))), l;
      },
      fitCubic: function(i, r, s, l, u, d) {
        var p = this.points;
        if (l - s === 1) {
          var m = p[s], y = p[l], S = m.getDistance(y) / 3;
          this.addCurve(i, [
            m,
            m.add(u.normalize(S)),
            y.add(d.normalize(S)),
            y
          ]);
          return;
        }
        for (var L = this.chordLengthParameterize(s, l), E = Math.max(r, r * r), A, T = !0, G = 0; G <= 4; G++) {
          var O = this.generateBezier(s, l, L, u, d), Y = this.findMaxError(s, l, O, L);
          if (Y.error < r && T) {
            this.addCurve(i, O);
            return;
          }
          if (A = Y.index, Y.error >= E)
            break;
          T = this.reparameterize(s, l, L, O), E = Y.error;
        }
        var B = p[A - 1].subtract(p[A + 1]);
        this.fitCubic(i, r, s, A, u, B), this.fitCubic(i, r, A, l, B.negate(), d);
      },
      addCurve: function(i, r) {
        var s = i[i.length - 1];
        s.setHandleOut(r[1].subtract(r[0])), i.push(new ce(r[3], r[2].subtract(r[3])));
      },
      generateBezier: function(i, r, s, l, u) {
        for (var d = 1e-12, p = Math.abs, m = this.points, y = m[i], S = m[r], L = [[0, 0], [0, 0]], E = [0, 0], A = 0, T = r - i + 1; A < T; A++) {
          var G = s[A], O = 1 - G, Y = 3 * G * O, B = O * O * O, z = Y * O, C = Y * G, N = G * G * G, j = l.normalize(z), q = u.normalize(C), H = m[i + A].subtract(y.multiply(B + z)).subtract(S.multiply(C + N));
          L[0][0] += j.dot(j), L[0][1] += j.dot(q), L[1][0] = L[0][1], L[1][1] += q.dot(q), E[0] += j.dot(H), E[1] += q.dot(H);
        }
        var te = L[0][0] * L[1][1] - L[1][0] * L[0][1], ae, le;
        if (p(te) > d) {
          var me = L[0][0] * E[1] - L[1][0] * E[0], se = E[0] * L[1][1] - E[1] * L[0][1];
          ae = se / te, le = me / te;
        } else {
          var de = L[0][0] + L[0][1], ve = L[1][0] + L[1][1];
          ae = le = p(de) > d ? E[0] / de : p(ve) > d ? E[1] / ve : 0;
        }
        var we = S.getDistance(y), Se = d * we, Ae, Ge;
        if (ae < Se || le < Se)
          ae = le = we / 3;
        else {
          var Qe = S.subtract(y);
          Ae = l.normalize(ae), Ge = u.normalize(le), Ae.dot(Qe) - Ge.dot(Qe) > we * we && (ae = le = we / 3, Ae = Ge = null);
        }
        return [
          y,
          y.add(Ae || l.normalize(ae)),
          S.add(Ge || u.normalize(le)),
          S
        ];
      },
      reparameterize: function(i, r, s, l) {
        for (var u = i; u <= r; u++)
          s[u - i] = this.findRoot(l, this.points[u], s[u - i]);
        for (var u = 1, d = s.length; u < d; u++)
          if (s[u] <= s[u - 1])
            return !1;
        return !0;
      },
      findRoot: function(i, r, s) {
        for (var l = [], u = [], d = 0; d <= 2; d++)
          l[d] = i[d + 1].subtract(i[d]).multiply(3);
        for (var d = 0; d <= 1; d++)
          u[d] = l[d + 1].subtract(l[d]).multiply(2);
        var p = this.evaluate(3, i, s), m = this.evaluate(2, l, s), y = this.evaluate(1, u, s), S = p.subtract(r), L = m.dot(m) + S.dot(y);
        return I.isMachineZero(L) ? s : s - S.dot(m) / L;
      },
      evaluate: function(i, r, s) {
        for (var l = r.slice(), u = 1; u <= i; u++)
          for (var d = 0; d <= i - u; d++)
            l[d] = l[d].multiply(1 - s).add(l[d + 1].multiply(s));
        return l[0];
      },
      chordLengthParameterize: function(i, r) {
        for (var s = [0], l = i + 1; l <= r; l++)
          s[l - i] = s[l - i - 1] + this.points[l].getDistance(this.points[l - 1]);
        for (var l = 1, u = r - i; l <= u; l++)
          s[l] /= s[u];
        return s;
      },
      findMaxError: function(i, r, s, l) {
        for (var u = Math.floor((r - i + 1) / 2), d = 0, p = i + 1; p < r; p++) {
          var m = this.evaluate(3, s, l[p - i]), y = m.subtract(this.points[p]), S = y.x * y.x + y.y * y.y;
          S >= d && (d = S, u = p);
        }
        return {
          error: d,
          index: u
        };
      }
    }), Xt = X.extend({
      _class: "TextItem",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _serializeFields: {
        content: null
      },
      _boundsOptions: { stroke: !1, handle: !1 },
      initialize: function(i) {
        this._content = "", this._lines = [];
        var r = i && o.isPlainObject(i) && i.x === t && i.y === t;
        this._initialize(r && i, !r && M.read(arguments));
      },
      _equals: function(i) {
        return this._content === i._content;
      },
      copyContent: function(i) {
        this.setContent(i._content);
      },
      getContent: function() {
        return this._content;
      },
      setContent: function(i) {
        this._content = "" + i, this._lines = this._content.split(/\r\n|\n|\r/mg), this._changed(521);
      },
      isEmpty: function() {
        return !this._content;
      },
      getCharacterStyle: "#getStyle",
      setCharacterStyle: "#setStyle",
      getParagraphStyle: "#getStyle",
      setParagraphStyle: "#setStyle"
    }), $t = Xt.extend({
      _class: "PointText",
      initialize: function() {
        Xt.apply(this, arguments);
      },
      getPoint: function() {
        var i = this._matrix.getTranslation();
        return new W(i.x, i.y, this, "setPoint");
      },
      setPoint: function() {
        var i = M.read(arguments);
        this.translate(i.subtract(this._matrix.getTranslation()));
      },
      _draw: function(i, r, s) {
        if (this._content) {
          this._setStyles(i, r, s);
          var l = this._lines, u = this._style, d = u.hasFill(), p = u.hasStroke(), m = u.getLeading(), y = i.shadowColor;
          i.font = u.getFontStyle(), i.textAlign = u.getJustification();
          for (var S = 0, L = l.length; S < L; S++) {
            i.shadowColor = y;
            var E = l[S];
            d && (i.fillText(E, 0, 0), i.shadowColor = "rgba(0,0,0,0)"), p && i.strokeText(E, 0, 0), i.translate(0, m);
          }
        }
      },
      _getBounds: function(i, r) {
        var s = this._style, l = this._lines, u = l.length, d = s.getJustification(), p = s.getLeading(), m = this.getView().getTextWidth(s.getFontStyle(), l), y = 0;
        d !== "left" && (y -= m / (d === "center" ? 2 : 1));
        var S = new D(
          y,
          u ? -0.75 * p : 0,
          m,
          u * p
        );
        return i ? i._transformBounds(S, S) : S;
      }
    }), Tt = o.extend(
      new function() {
        var i = {
          gray: ["gray"],
          rgb: ["red", "green", "blue"],
          hsb: ["hue", "saturation", "brightness"],
          hsl: ["hue", "saturation", "lightness"],
          gradient: ["gradient", "origin", "destination", "highlight"]
        }, r = {}, s = {
          transparent: [0, 0, 0, 0]
        }, l;
        function u(m) {
          var y = m.match(
            /^#([\da-f]{2})([\da-f]{2})([\da-f]{2})([\da-f]{2})?$/i
          ) || m.match(
            /^#([\da-f])([\da-f])([\da-f])([\da-f])?$/i
          ), S = "rgb", L;
          if (y) {
            var E = y[4] ? 4 : 3;
            L = new Array(E);
            for (var A = 0; A < E; A++) {
              var T = y[A + 1];
              L[A] = parseInt(T.length == 1 ? T + T : T, 16) / 255;
            }
          } else if (y = m.match(/^(rgb|hsl)a?\((.*)\)$/)) {
            S = y[1], L = y[2].trim().split(/[,\s]+/g);
            for (var G = S === "hsl", A = 0, O = Math.min(L.length, 4); A < O; A++) {
              var Y = L[A], T = parseFloat(Y);
              if (G)
                if (A === 0) {
                  var B = Y.match(/([a-z]*)$/)[1];
                  T *= {
                    turn: 360,
                    rad: 180 / Math.PI,
                    grad: 0.9
                  }[B] || 1;
                } else
                  A < 3 && (T /= 100);
              else
                A < 3 && (T /= /%$/.test(Y) ? 100 : 255);
              L[A] = T;
            }
          } else {
            var z = s[m];
            if (!z)
              if (n) {
                l || (l = ft.getContext(1, 1, {
                  willReadFrequently: !0
                }), l.globalCompositeOperation = "copy"), l.fillStyle = "rgba(0,0,0,0)", l.fillStyle = m, l.fillRect(0, 0, 1, 1);
                var C = l.getImageData(0, 0, 1, 1).data;
                z = s[m] = [
                  C[0] / 255,
                  C[1] / 255,
                  C[2] / 255
                ];
              } else
                z = [0, 0, 0];
            L = z.slice();
          }
          return [S, L];
        }
        var d = [
          [0, 3, 1],
          [2, 0, 1],
          [1, 0, 3],
          [1, 2, 0],
          [3, 1, 0],
          [0, 1, 2]
        ], p = {
          "rgb-hsb": function(m, y, S) {
            var L = Math.max(m, y, S), E = Math.min(m, y, S), A = L - E, T = A === 0 ? 0 : (L == m ? (y - S) / A + (y < S ? 6 : 0) : L == y ? (S - m) / A + 2 : (m - y) / A + 4) * 60;
            return [T, L === 0 ? 0 : A / L, L];
          },
          "hsb-rgb": function(m, y, S) {
            m = (m / 60 % 6 + 6) % 6;
            var E = Math.floor(m), L = m - E, E = d[E], A = [
              S,
              S * (1 - y),
              S * (1 - y * L),
              S * (1 - y * (1 - L))
            ];
            return [A[E[0]], A[E[1]], A[E[2]]];
          },
          "rgb-hsl": function(m, y, S) {
            var L = Math.max(m, y, S), E = Math.min(m, y, S), A = L - E, T = A === 0, G = T ? 0 : (L == m ? (y - S) / A + (y < S ? 6 : 0) : L == y ? (S - m) / A + 2 : (m - y) / A + 4) * 60, O = (L + E) / 2, Y = T ? 0 : O < 0.5 ? A / (L + E) : A / (2 - L - E);
            return [G, Y, O];
          },
          "hsl-rgb": function(m, y, S) {
            if (m = (m / 360 % 1 + 1) % 1, y === 0)
              return [S, S, S];
            for (var L = [m + 1 / 3, m, m - 1 / 3], E = S < 0.5 ? S * (1 + y) : S + y - S * y, A = 2 * S - E, T = [], G = 0; G < 3; G++) {
              var O = L[G];
              O < 0 && (O += 1), O > 1 && (O -= 1), T[G] = 6 * O < 1 ? A + (E - A) * 6 * O : 2 * O < 1 ? E : 3 * O < 2 ? A + (E - A) * (2 / 3 - O) * 6 : A;
            }
            return T;
          },
          "rgb-gray": function(m, y, S) {
            return [m * 0.2989 + y * 0.587 + S * 0.114];
          },
          "gray-rgb": function(m) {
            return [m, m, m];
          },
          "gray-hsb": function(m) {
            return [0, 0, m];
          },
          "gray-hsl": function(m) {
            return [0, 0, m];
          },
          "gradient-rgb": function() {
            return [];
          },
          "rgb-gradient": function() {
            return [];
          }
        };
        return o.each(i, function(m, y) {
          r[y] = [], o.each(m, function(S, L) {
            var E = o.capitalize(S), A = /^(hue|saturation)$/.test(S), T = r[y][L] = y === "gradient" ? S === "gradient" ? function(G) {
              var O = this._components[0];
              return G = Bi.read(
                Array.isArray(G) ? G : arguments,
                0,
                { readNull: !0 }
              ), O !== G && (O && O._removeOwner(this), G && G._addOwner(this)), G;
            } : function() {
              return M.read(arguments, 0, {
                readNull: S === "highlight",
                clone: !0
              });
            } : function(G) {
              return G == null || isNaN(G) ? 0 : +G;
            };
            this["get" + E] = function() {
              return this._type === y || A && /^hs[bl]$/.test(this._type) ? this._components[L] : this._convert(y)[L];
            }, this["set" + E] = function(G) {
              this._type !== y && !(A && /^hs[bl]$/.test(this._type)) && (this._components = this._convert(y), this._properties = i[y], this._type = y), this._components[L] = T.call(this, G), this._changed();
            };
          }, this);
        }, {
          _class: "Color",
          _readIndex: !0,
          initialize: function m(y) {
            var S = arguments, L = this.__read, E = 0, A, T, G, O;
            Array.isArray(y) && (S = y, y = S[0]);
            var Y = y != null && typeof y;
            if (Y === "string" && y in i && (A = y, y = S[1], Array.isArray(y) ? (T = y, G = S[2]) : (L && (E = 1), S = o.slice(S, 1), Y = typeof y)), !T) {
              if (O = Y === "number" ? S : Y === "object" && y.length != null ? y : null, O) {
                A || (A = O.length >= 3 ? "rgb" : "gray");
                var B = i[A].length;
                G = O[B], L && (E += O === arguments ? B + (G != null ? 1 : 0) : 1), O.length > B && (O = o.slice(O, 0, B));
              } else if (Y === "string") {
                var z = u(y);
                A = z[0], T = z[1], T.length === 4 && (G = T[3], T.length--);
              } else if (Y === "object")
                if (y.constructor === m) {
                  if (A = y._type, T = y._components.slice(), G = y._alpha, A === "gradient")
                    for (var C = 1, N = T.length; C < N; C++) {
                      var j = T[C];
                      j && (T[C] = j.clone());
                    }
                } else if (y.constructor === Bi)
                  A = "gradient", O = S;
                else {
                  A = "hue" in y ? "lightness" in y ? "hsl" : "hsb" : "gradient" in y || "stops" in y || "radial" in y ? "gradient" : "gray" in y ? "gray" : "rgb";
                  var q = i[A], H = r[A];
                  this._components = T = [];
                  for (var C = 0, N = q.length; C < N; C++) {
                    var te = y[q[C]];
                    te == null && !C && A === "gradient" && "stops" in y && (te = {
                      stops: y.stops,
                      radial: y.radial
                    }), te = H[C].call(this, te), te != null && (T[C] = te);
                  }
                  G = y.alpha;
                }
              L && A && (E = 1);
            }
            if (this._type = A || "rgb", !T) {
              this._components = T = [];
              for (var H = r[this._type], C = 0, N = H.length; C < N; C++) {
                var te = H[C].call(this, O && O[C]);
                te != null && (T[C] = te);
              }
            }
            return this._components = T, this._properties = i[this._type], this._alpha = G, L && (this.__read = E), this;
          },
          set: "#initialize",
          _serialize: function(m, y) {
            var S = this.getComponents();
            return o.serialize(
              /^(gray|rgb)$/.test(this._type) ? S : [this._type].concat(S),
              m,
              !0,
              y
            );
          },
          _changed: function() {
            this._canvasStyle = null, this._owner && (this._setter ? this._owner[this._setter](this) : this._owner._changed(129));
          },
          _convert: function(m) {
            var y;
            return this._type === m ? this._components.slice() : (y = p[this._type + "-" + m]) ? y.apply(this, this._components) : p["rgb-" + m].apply(
              this,
              p[this._type + "-rgb"].apply(
                this,
                this._components
              )
            );
          },
          convert: function(m) {
            return new Tt(m, this._convert(m), this._alpha);
          },
          getType: function() {
            return this._type;
          },
          setType: function(m) {
            this._components = this._convert(m), this._properties = i[m], this._type = m;
          },
          getComponents: function() {
            var m = this._components.slice();
            return this._alpha != null && m.push(this._alpha), m;
          },
          getAlpha: function() {
            return this._alpha != null ? this._alpha : 1;
          },
          setAlpha: function(m) {
            this._alpha = m == null ? null : Math.min(Math.max(m, 0), 1), this._changed();
          },
          hasAlpha: function() {
            return this._alpha != null;
          },
          equals: function(m) {
            var y = o.isPlainValue(m, !0) ? Tt.read(arguments) : m;
            return y === this || y && this._class === y._class && this._type === y._type && this.getAlpha() === y.getAlpha() && o.equals(this._components, y._components) || !1;
          },
          toString: function() {
            for (var m = this._properties, y = [], S = this._type === "gradient", L = k.instance, E = 0, A = m.length; E < A; E++) {
              var T = this._components[E];
              T != null && y.push(m[E] + ": " + (S ? T : L.number(T)));
            }
            return this._alpha != null && y.push("alpha: " + L.number(this._alpha)), "{ " + y.join(", ") + " }";
          },
          toCSS: function(m) {
            var y = this._convert("rgb"), S = m || this._alpha == null ? 1 : this._alpha;
            function L(E) {
              return Math.round((E < 0 ? 0 : E > 1 ? 1 : E) * 255);
            }
            return y = [
              L(y[0]),
              L(y[1]),
              L(y[2])
            ], S < 1 && y.push(S < 0 ? 0 : S), m ? "#" + ((1 << 24) + (y[0] << 16) + (y[1] << 8) + y[2]).toString(16).slice(1) : (y.length == 4 ? "rgba(" : "rgb(") + y.join(",") + ")";
          },
          toCanvasStyle: function(m, y) {
            if (this._canvasStyle)
              return this._canvasStyle;
            if (this._type !== "gradient")
              return this._canvasStyle = this.toCSS();
            var S = this._components, L = S[0], E = L._stops, A = S[1], T = S[2], G = S[3], O = y && y.inverted(), Y;
            if (O && (A = O._transformPoint(A), T = O._transformPoint(T), G && (G = O._transformPoint(G))), L._radial) {
              var B = T.getDistance(A);
              if (G) {
                var z = G.subtract(A);
                z.getLength() > B && (G = A.add(z.normalize(B - 0.1)));
              }
              var C = G || A;
              Y = m.createRadialGradient(
                C.x,
                C.y,
                0,
                A.x,
                A.y,
                B
              );
            } else
              Y = m.createLinearGradient(
                A.x,
                A.y,
                T.x,
                T.y
              );
            for (var N = 0, j = E.length; N < j; N++) {
              var q = E[N], H = q._offset;
              Y.addColorStop(
                H ?? N / (j - 1),
                q._color.toCanvasStyle()
              );
            }
            return this._canvasStyle = Y;
          },
          transform: function(m) {
            if (this._type === "gradient") {
              for (var y = this._components, S = 1, L = y.length; S < L; S++) {
                var E = y[S];
                m._transformPoint(E, E, !0);
              }
              this._changed();
            }
          },
          statics: {
            _types: i,
            random: function() {
              var m = Math.random;
              return new Tt(m(), m(), m());
            },
            _setOwner: function(m, y, S) {
              return m && (m._owner && y && m._owner !== y && (m = m.clone()), !m._owner ^ !y && (m._owner = y || null, m._setter = S || null)), m;
            }
          }
        });
      }(),
      new function() {
        var i = {
          add: function(r, s) {
            return r + s;
          },
          subtract: function(r, s) {
            return r - s;
          },
          multiply: function(r, s) {
            return r * s;
          },
          divide: function(r, s) {
            return r / s;
          }
        };
        return o.each(i, function(r, s) {
          this[s] = function(l) {
            l = Tt.read(arguments);
            for (var u = this._type, d = this._components, p = l._convert(u), m = 0, y = d.length; m < y; m++)
              p[m] = r(d[m], p[m]);
            return new Tt(
              u,
              p,
              this._alpha != null ? r(this._alpha, l.getAlpha()) : null
            );
          };
        }, {});
      }()
    ), Bi = o.extend({
      _class: "Gradient",
      initialize: function(i, r) {
        this._id = V.get(), i && o.isPlainObject(i) && (this.set(i), i = r = null), this._stops == null && this.setStops(i || ["white", "black"]), this._radial == null && this.setRadial(typeof r == "string" && r === "radial" || r || !1);
      },
      _serialize: function(i, r) {
        return r.add(this, function() {
          return o.serialize(
            [this._stops, this._radial],
            i,
            !0,
            r
          );
        });
      },
      _changed: function() {
        for (var i = 0, r = this._owners && this._owners.length; i < r; i++)
          this._owners[i]._changed();
      },
      _addOwner: function(i) {
        this._owners || (this._owners = []), this._owners.push(i);
      },
      _removeOwner: function(i) {
        var r = this._owners ? this._owners.indexOf(i) : -1;
        r != -1 && (this._owners.splice(r, 1), this._owners.length || (this._owners = t));
      },
      clone: function() {
        for (var i = [], r = 0, s = this._stops.length; r < s; r++)
          i[r] = this._stops[r].clone();
        return new Bi(i, this._radial);
      },
      getStops: function() {
        return this._stops;
      },
      setStops: function(i) {
        if (i.length < 2)
          throw new Error(
            "Gradient stop list needs to contain at least two stops."
          );
        var r = this._stops;
        if (r)
          for (var s = 0, l = r.length; s < l; s++)
            r[s]._owner = t;
        r = this._stops = en.readList(i, 0, { clone: !0 });
        for (var s = 0, l = r.length; s < l; s++)
          r[s]._owner = this;
        this._changed();
      },
      getRadial: function() {
        return this._radial;
      },
      setRadial: function(i) {
        this._radial = i, this._changed();
      },
      equals: function(i) {
        if (i === this)
          return !0;
        if (i && this._class === i._class) {
          var r = this._stops, s = i._stops, l = r.length;
          if (l === s.length) {
            for (var u = 0; u < l; u++)
              if (!r[u].equals(s[u]))
                return !1;
            return !0;
          }
        }
        return !1;
      }
    }), en = o.extend({
      _class: "GradientStop",
      initialize: function(i, r) {
        var s = i, l = r;
        typeof i == "object" && r === t && (Array.isArray(i) && typeof i[0] != "number" ? (s = i[0], l = i[1]) : ("color" in i || "offset" in i || "rampPoint" in i) && (s = i.color, l = i.offset || i.rampPoint || 0)), this.setColor(s), this.setOffset(l);
      },
      clone: function() {
        return new en(this._color.clone(), this._offset);
      },
      _serialize: function(i, r) {
        var s = this._color, l = this._offset;
        return o.serialize(
          l == null ? [s] : [s, l],
          i,
          !0,
          r
        );
      },
      _changed: function() {
        this._owner && this._owner._changed(129);
      },
      getOffset: function() {
        return this._offset;
      },
      setOffset: function(i) {
        this._offset = i, this._changed();
      },
      getRampPoint: "#getOffset",
      setRampPoint: "#setOffset",
      getColor: function() {
        return this._color;
      },
      setColor: function() {
        Tt._setOwner(this._color, null), this._color = Tt._setOwner(
          Tt.read(arguments, 0),
          this,
          "setColor"
        ), this._changed();
      },
      equals: function(i) {
        return i === this || i && this._class === i._class && this._color.equals(i._color) && this._offset == i._offset || !1;
      }
    }), oi = o.extend(new function() {
      var i = {
        fillColor: null,
        fillRule: "nonzero",
        strokeColor: null,
        strokeWidth: 1,
        strokeCap: "butt",
        strokeJoin: "miter",
        strokeScaling: !0,
        miterLimit: 10,
        dashOffset: 0,
        dashArray: [],
        shadowColor: null,
        shadowBlur: 0,
        shadowOffset: new M(),
        selectedColor: null
      }, r = o.set({}, i, {
        fontFamily: "sans-serif",
        fontWeight: "normal",
        fontSize: 12,
        leading: null,
        justification: "left"
      }), s = o.set({}, r, {
        fillColor: new Tt()
      }), l = {
        strokeWidth: 193,
        strokeCap: 193,
        strokeJoin: 193,
        strokeScaling: 201,
        miterLimit: 193,
        fontFamily: 9,
        fontWeight: 9,
        fontSize: 9,
        font: 9,
        leading: 9,
        justification: 9
      }, u = {
        beans: !0
      }, d = {
        _class: "Style",
        beans: !0,
        initialize: function(p, m, y) {
          this._values = {}, this._owner = m, this._project = m && m._project || y || Ve.project, this._defaults = !m || m instanceof Z ? r : m instanceof Xt ? s : i, p && this.set(p);
        }
      };
      return o.each(r, function(p, m) {
        var y = /Color$/.test(m), S = m === "shadowOffset", L = o.capitalize(m), E = l[m], A = "set" + L, T = "get" + L;
        d[A] = function(G) {
          var O = this._owner, Y = O && O._children, B = Y && Y.length > 0 && !(O instanceof It);
          if (B)
            for (var z = 0, C = Y.length; z < C; z++)
              Y[z]._style[A](G);
          if ((m === "selectedColor" || !B) && m in this._defaults) {
            var N = this._values[m];
            N !== G && (y && (N && (Tt._setOwner(N, null), N._canvasStyle = null), G && G.constructor === Tt && (G = Tt._setOwner(
              G,
              O,
              B && A
            ))), this._values[m] = G, O && O._changed(E || 129));
          }
        }, d[T] = function(G) {
          var O = this._owner, Y = O && O._children, B = Y && Y.length > 0 && !(O instanceof It), z;
          if (B && !G)
            for (var C = 0, N = Y.length; C < N; C++) {
              var j = Y[C]._style[T]();
              if (!C)
                z = j;
              else if (!o.equals(z, j))
                return t;
            }
          else if (m in this._defaults) {
            var z = this._values[m];
            if (z === t)
              z = this._defaults[m], z && z.clone && (z = z.clone());
            else {
              var q = y ? Tt : S ? M : null;
              q && !(z && z.constructor === q) && (this._values[m] = z = q.read(
                [z],
                0,
                { readNull: !0, clone: !0 }
              ));
            }
          }
          return z && y && (z = Tt._setOwner(z, O, B && A)), z;
        }, u[T] = function(G) {
          return this._style[T](G);
        }, u[A] = function(G) {
          this._style[A](G);
        };
      }), o.each({
        Font: "FontFamily",
        WindingRule: "FillRule"
      }, function(p, m) {
        var y = "get" + m, S = "set" + m;
        d[y] = u[y] = "#get" + p, d[S] = u[S] = "#set" + p;
      }), X.inject(u), d;
    }(), {
      set: function(i) {
        var r = i instanceof oi, s = r ? i._values : i;
        if (s) {
          for (var l in s)
            if (l in this._defaults) {
              var u = s[l];
              this[l] = u && r && u.clone ? u.clone() : u;
            }
        }
      },
      equals: function(i) {
        function r(s, l, u) {
          var d = s._values, p = l._values, m = l._defaults;
          for (var y in d) {
            var S = d[y], L = p[y];
            if (!(u && y in p) && !o.equals(
              S,
              L === t ? m[y] : L
            ))
              return !1;
          }
          return !0;
        }
        return i === this || i && this._class === i._class && r(this, i) && r(i, this, !0) || !1;
      },
      _dispose: function() {
        var i;
        i = this.getFillColor(), i && (i._canvasStyle = null), i = this.getStrokeColor(), i && (i._canvasStyle = null), i = this.getShadowColor(), i && (i._canvasStyle = null);
      },
      hasFill: function() {
        var i = this.getFillColor();
        return !!i && i.alpha > 0;
      },
      hasStroke: function() {
        var i = this.getStrokeColor();
        return !!i && i.alpha > 0 && this.getStrokeWidth() > 0;
      },
      hasShadow: function() {
        var i = this.getShadowColor();
        return !!i && i.alpha > 0 && (this.getShadowBlur() > 0 || !this.getShadowOffset().isZero());
      },
      getView: function() {
        return this._project._view;
      },
      getFontStyle: function() {
        var i = this.getFontSize();
        return this.getFontWeight() + " " + i + (/[a-z]/i.test(i + "") ? " " : "px ") + this.getFontFamily();
      },
      getFont: "#getFontFamily",
      setFont: "#setFontFamily",
      getLeading: function i() {
        var r = i.base.call(this), s = this.getFontSize();
        return /pt|em|%|px/.test(s) && (s = this.getView().getPixelSize(s)), r ?? s * 1.2;
      }
    }), Zt = new function() {
      function i(r, s, l, u) {
        for (var d = ["", "webkit", "moz", "Moz", "ms", "o"], p = s[0].toUpperCase() + s.substring(1), m = 0; m < 6; m++) {
          var y = d[m], S = y ? y + p : s;
          if (S in r) {
            if (l)
              r[S] = u;
            else
              return r[S];
            break;
          }
        }
      }
      return {
        getStyles: function(r) {
          var s = r && r.nodeType !== 9 ? r.ownerDocument : r, l = s && s.defaultView;
          return l && l.getComputedStyle(r, "");
        },
        getBounds: function(r, s) {
          var l = r.ownerDocument, u = l.body, d = l.documentElement, p;
          try {
            p = r.getBoundingClientRect();
          } catch {
            p = { left: 0, top: 0, width: 0, height: 0 };
          }
          var m = p.left - (d.clientLeft || u.clientLeft || 0), y = p.top - (d.clientTop || u.clientTop || 0);
          if (!s) {
            var S = l.defaultView;
            m += S.pageXOffset || d.scrollLeft || u.scrollLeft, y += S.pageYOffset || d.scrollTop || u.scrollTop;
          }
          return new D(m, y, p.width, p.height);
        },
        getViewportBounds: function(r) {
          var s = r.ownerDocument, l = s.defaultView, u = s.documentElement;
          return new D(
            0,
            0,
            l.innerWidth || u.clientWidth,
            l.innerHeight || u.clientHeight
          );
        },
        getOffset: function(r, s) {
          return Zt.getBounds(r, s).getPoint();
        },
        getSize: function(r) {
          return Zt.getBounds(r, !0).getSize();
        },
        isInvisible: function(r) {
          return Zt.getSize(r).equals(new U(0, 0));
        },
        isInView: function(r) {
          return !Zt.isInvisible(r) && Zt.getViewportBounds(r).intersects(
            Zt.getBounds(r, !0)
          );
        },
        isInserted: function(r) {
          return a.body.contains(r);
        },
        getPrefixed: function(r, s) {
          return r && i(r, s);
        },
        setPrefixed: function(r, s, l) {
          if (typeof s == "object")
            for (var u in s)
              i(r, u, !0, s[u]);
          else
            i(r, s, !0, l);
        }
      };
    }(), Jt = {
      add: function(i, r) {
        if (i)
          for (var s in r)
            for (var l = r[s], u = s.split(/[\s,]+/g), d = 0, p = u.length; d < p; d++) {
              var m = u[d], y = i === a && (m === "touchstart" || m === "touchmove") ? { passive: !1 } : !1;
              i.addEventListener(m, l, y);
            }
      },
      remove: function(i, r) {
        if (i)
          for (var s in r)
            for (var l = r[s], u = s.split(/[\s,]+/g), d = 0, p = u.length; d < p; d++)
              i.removeEventListener(u[d], l, !1);
      },
      getPoint: function(i) {
        var r = i.targetTouches ? i.targetTouches.length ? i.targetTouches[0] : i.changedTouches[0] : i;
        return new M(
          r.pageX || r.clientX + a.documentElement.scrollLeft,
          r.pageY || r.clientY + a.documentElement.scrollTop
        );
      },
      getTarget: function(i) {
        return i.target || i.srcElement;
      },
      getRelatedTarget: function(i) {
        return i.relatedTarget || i.toElement;
      },
      getOffset: function(i, r) {
        return Jt.getPoint(i).subtract(Zt.getOffset(
          r || Jt.getTarget(i)
        ));
      }
    };
    Jt.requestAnimationFrame = new function() {
      var i = Zt.getPrefixed(n, "requestAnimationFrame"), r = !1, s = [], l;
      function u() {
        var d = s;
        s = [];
        for (var p = 0, m = d.length; p < m; p++)
          d[p]();
        r = i && s.length, r && i(u);
      }
      return function(d) {
        s.push(d), i ? r || (i(u), r = !0) : l || (l = setInterval(u, 1e3 / 60));
      };
    }();
    var Qt = o.extend(
      h,
      {
        _class: "View",
        initialize: function i(r, s) {
          function l(E) {
            return s[E] || parseInt(s.getAttribute(E), 10);
          }
          function u() {
            var E = Zt.getSize(s);
            return E.isNaN() || E.isZero() ? new U(l("width"), l("height")) : E;
          }
          var d;
          if (n && s) {
            this._id = s.getAttribute("id"), this._id == null && s.setAttribute("id", this._id = "paper-view-" + i._id++), Jt.add(s, this._viewEvents);
            var p = "none";
            if (Zt.setPrefixed(s.style, {
              userDrag: p,
              userSelect: p,
              touchCallout: p,
              contentZooming: p,
              tapHighlightColor: "rgba(0,0,0,0)"
            }), f.hasAttribute(s, "resize")) {
              var m = this;
              Jt.add(n, this._windowEvents = {
                resize: function() {
                  m.setViewSize(u());
                }
              });
            }
            if (d = u(), f.hasAttribute(s, "stats") && typeof Stats < "u") {
              this._stats = new Stats();
              var y = this._stats.domElement, S = y.style, L = Zt.getOffset(s);
              S.position = "absolute", S.left = L.x + "px", S.top = L.y + "px", a.body.appendChild(y);
            }
          } else
            d = new U(s), s = null;
          this._project = r, this._scope = r._scope, this._element = s, this._pixelRatio || (this._pixelRatio = n && n.devicePixelRatio || 1), this._setElementSize(d.width, d.height), this._viewSize = d, i._views.push(this), i._viewsById[this._id] = this, (this._matrix = new J())._owner = this, i._focused || (i._focused = this), this._frameItems = {}, this._frameItemCount = 0, this._itemEvents = { native: {}, virtual: {} }, this._autoUpdate = !Ve.agent.node, this._needsUpdate = !1;
        },
        remove: function() {
          if (!this._project)
            return !1;
          Qt._focused === this && (Qt._focused = null), Qt._views.splice(Qt._views.indexOf(this), 1), delete Qt._viewsById[this._id];
          var i = this._project;
          return i._view === this && (i._view = null), Jt.remove(this._element, this._viewEvents), Jt.remove(n, this._windowEvents), this._element = this._project = null, this.off("frame"), this._animate = !1, this._frameItems = {}, !0;
        },
        _events: o.each(
          X._itemHandlers.concat(["onResize", "onKeyDown", "onKeyUp"]),
          function(i) {
            this[i] = {};
          },
          {
            onFrame: {
              install: function() {
                this.play();
              },
              uninstall: function() {
                this.pause();
              }
            }
          }
        ),
        _animate: !1,
        _time: 0,
        _count: 0,
        getAutoUpdate: function() {
          return this._autoUpdate;
        },
        setAutoUpdate: function(i) {
          this._autoUpdate = i, i && this.requestUpdate();
        },
        update: function() {
        },
        draw: function() {
          this.update();
        },
        requestUpdate: function() {
          if (!this._requested) {
            var i = this;
            Jt.requestAnimationFrame(function() {
              if (i._requested = !1, i._animate) {
                i.requestUpdate();
                var r = i._element;
                (!Zt.getPrefixed(a, "hidden") || f.getAttribute(r, "keepalive") === "true") && Zt.isInView(r) && i._handleFrame();
              }
              i._autoUpdate && i.update();
            }), this._requested = !0;
          }
        },
        play: function() {
          this._animate = !0, this.requestUpdate();
        },
        pause: function() {
          this._animate = !1;
        },
        _handleFrame: function() {
          Ve = this._scope;
          var i = Date.now() / 1e3, r = this._last ? i - this._last : 0;
          this._last = i, this.emit("frame", new o({
            delta: r,
            time: this._time += r,
            count: this._count++
          })), this._stats && this._stats.update();
        },
        _animateItem: function(i, r) {
          var s = this._frameItems;
          r ? (s[i._id] = {
            item: i,
            time: 0,
            count: 0
          }, ++this._frameItemCount === 1 && this.on("frame", this._handleFrameItems)) : (delete s[i._id], --this._frameItemCount === 0 && this.off("frame", this._handleFrameItems));
        },
        _handleFrameItems: function(i) {
          for (var r in this._frameItems) {
            var s = this._frameItems[r];
            s.item.emit("frame", new o(i, {
              time: s.time += i.delta,
              count: s.count++
            }));
          }
        },
        _changed: function() {
          this._project._changed(4097), this._bounds = this._decomposed = t;
        },
        getElement: function() {
          return this._element;
        },
        getPixelRatio: function() {
          return this._pixelRatio;
        },
        getResolution: function() {
          return this._pixelRatio * 72;
        },
        getViewSize: function() {
          var i = this._viewSize;
          return new Q(i.width, i.height, this, "setViewSize");
        },
        setViewSize: function() {
          var i = U.read(arguments), r = i.subtract(this._viewSize);
          r.isZero() || (this._setElementSize(i.width, i.height), this._viewSize.set(i), this._changed(), this.emit("resize", { size: i, delta: r }), this._autoUpdate && this.update());
        },
        _setElementSize: function(i, r) {
          var s = this._element;
          s && (s.width !== i && (s.width = i), s.height !== r && (s.height = r));
        },
        getBounds: function() {
          return this._bounds || (this._bounds = this._matrix.inverted()._transformBounds(
            new D(new M(), this._viewSize)
          )), this._bounds;
        },
        getSize: function() {
          return this.getBounds().getSize();
        },
        isVisible: function() {
          return Zt.isInView(this._element);
        },
        isInserted: function() {
          return Zt.isInserted(this._element);
        },
        getPixelSize: function(i) {
          var r = this._element, s;
          if (r) {
            var l = r.parentNode, u = a.createElement("div");
            u.style.fontSize = i, l.appendChild(u), s = parseFloat(Zt.getStyles(u).fontSize), l.removeChild(u);
          } else
            s = parseFloat(s);
          return s;
        },
        getTextWidth: function(i, r) {
          return 0;
        }
      },
      o.each(["rotate", "scale", "shear", "skew"], function(i) {
        var r = i === "rotate";
        this[i] = function() {
          var s = arguments, l = (r ? o : M).read(s), u = M.read(s, 0, { readNull: !0 });
          return this.transform(new J()[i](
            l,
            u || this.getCenter(!0)
          ));
        };
      }, {
        _decompose: function() {
          return this._decomposed || (this._decomposed = this._matrix.decompose());
        },
        translate: function() {
          var i = new J();
          return this.transform(i.translate.apply(i, arguments));
        },
        getCenter: function() {
          return this.getBounds().getCenter();
        },
        setCenter: function() {
          var i = M.read(arguments);
          this.translate(this.getCenter().subtract(i));
        },
        getZoom: function() {
          var i = this._decompose().scaling;
          return (i.x + i.y) / 2;
        },
        setZoom: function(i) {
          this.transform(new J().scale(
            i / this.getZoom(),
            this.getCenter()
          ));
        },
        getRotation: function() {
          return this._decompose().rotation;
        },
        setRotation: function(i) {
          var r = this.getRotation();
          r != null && i != null && this.rotate(i - r);
        },
        getScaling: function() {
          var i = this._decompose().scaling;
          return new W(i.x, i.y, this, "setScaling");
        },
        setScaling: function() {
          var i = this.getScaling(), r = M.read(arguments, 0, { clone: !0, readNull: !0 });
          i && r && this.scale(r.x / i.x, r.y / i.y);
        },
        getMatrix: function() {
          return this._matrix;
        },
        setMatrix: function() {
          var i = this._matrix;
          i.set.apply(i, arguments);
        },
        transform: function(i) {
          this._matrix.append(i);
        },
        scrollBy: function() {
          this.translate(M.read(arguments).negate());
        }
      }),
      {
        projectToView: function() {
          return this._matrix._transformPoint(M.read(arguments));
        },
        viewToProject: function() {
          return this._matrix._inverseTransform(M.read(arguments));
        },
        getEventPoint: function(i) {
          return this.viewToProject(Jt.getOffset(i, this._element));
        }
      },
      {
        statics: {
          _views: [],
          _viewsById: {},
          _id: 0,
          create: function(i, r) {
            a && typeof r == "string" && (r = a.getElementById(r));
            var s = n ? rn : Qt;
            return new s(i, r);
          }
        }
      },
      new function() {
        if (!n)
          return;
        var i, r, s = !1, l = !1;
        function u(se) {
          var de = Jt.getTarget(se);
          return de.getAttribute && Qt._viewsById[de.getAttribute("id")];
        }
        function d() {
          var se = Qt._focused;
          if (!se || !se.isVisible()) {
            for (var de = 0, ve = Qt._views.length; de < ve; de++)
              if ((se = Qt._views[de]).isVisible()) {
                Qt._focused = r = se;
                break;
              }
          }
        }
        function p(se, de, ve) {
          se._handleMouseEvent("mousemove", de, ve);
        }
        var m = n.navigator, y, S, L;
        m.pointerEnabled || m.msPointerEnabled ? (y = "pointerdown MSPointerDown", S = "pointermove MSPointerMove", L = "pointerup pointercancel MSPointerUp MSPointerCancel") : (y = "touchstart", S = "touchmove", L = "touchend touchcancel", "ontouchstart" in n && m.userAgent.match(
          /mobile|tablet|ip(ad|hone|od)|android|silk/i
        ) || (y += " mousedown", S += " mousemove", L += " mouseup"));
        var E = {}, A = {
          mouseout: function(se) {
            var de = Qt._focused, ve = Jt.getRelatedTarget(se);
            if (de && (!ve || ve.nodeName === "HTML")) {
              var we = Jt.getOffset(se, de._element), Se = we.x, Ae = Math.abs, Ge = Ae(Se), Qe = 1 << 25, st = Ge - Qe;
              we.x = Ae(st) < Ge ? st * (Se < 0 ? -1 : 1) : Se, p(de, se, de.viewToProject(we));
            }
          },
          scroll: d
        };
        E[y] = function(se) {
          var de = Qt._focused = u(se);
          s || (s = !0, de._handleMouseEvent("mousedown", se));
        }, A[S] = function(se) {
          var de = Qt._focused;
          if (!l) {
            var ve = u(se);
            ve ? de !== ve && (de && p(de, se), i || (i = de), de = Qt._focused = r = ve) : r && r === de && (i && !i.isInserted() && (i = null), de = Qt._focused = i, i = null, d());
          }
          de && p(de, se);
        }, A[y] = function() {
          l = !0;
        }, A[L] = function(se) {
          var de = Qt._focused;
          de && s && de._handleMouseEvent("mouseup", se), l = s = !1;
        }, Jt.add(a, A), Jt.add(n, {
          load: d
        });
        var T = !1, G = !1, O = {
          doubleclick: "click",
          mousedrag: "mousemove"
        }, Y = !1, B, z, C, N, j, q, H, te;
        function ae(se, de, ve, we, Se, Ae, Ge) {
          var Qe = !1, st;
          function mt(Re, Fe) {
            if (Re.responds(Fe)) {
              if (st || (st = new xt(
                Fe,
                we,
                Se,
                de || Re,
                Ae ? Se.subtract(Ae) : null
              )), Re.emit(Fe, st) && (T = !0, st.prevented && (G = !0), st.stopped))
                return Qe = !0;
            } else {
              var at = O[Fe];
              if (at)
                return mt(Re, at);
            }
          }
          for (; se && se !== Ge && !mt(se, ve); )
            se = se._parent;
          return Qe;
        }
        function le(se, de, ve, we, Se, Ae) {
          return se._project.removeOn(ve), G = T = !1, j && ae(
            j,
            null,
            ve,
            we,
            Se,
            Ae
          ) || de && de !== j && !de.isDescendant(j) && ae(de, null, ve === "mousedrag" ? "mousemove" : ve, we, Se, Ae, j) || ae(
            se,
            j || de || se,
            ve,
            we,
            Se,
            Ae
          );
        }
        var me = {
          mousedown: {
            mousedown: 1,
            mousedrag: 1,
            click: 1,
            doubleclick: 1
          },
          mouseup: {
            mouseup: 1,
            mousedrag: 1,
            click: 1,
            doubleclick: 1
          },
          mousemove: {
            mousedrag: 1,
            mousemove: 1,
            mouseenter: 1,
            mouseleave: 1
          }
        };
        return {
          _viewEvents: E,
          _handleMouseEvent: function(se, de, ve) {
            var we = this._itemEvents, Se = we.native[se], Ae = se === "mousemove", Ge = this._scope.tool, Qe = this;
            function st(Rt) {
              return we.virtual[Rt] || Qe.responds(Rt) || Ge && Ge.responds(Rt);
            }
            Ae && s && st("mousedrag") && (se = "mousedrag"), ve || (ve = this.getEventPoint(de));
            var mt = this.getBounds().contains(ve), Re = Se && mt && Qe._project.hitTest(ve, {
              tolerance: 0,
              fill: !0,
              stroke: !0
            }), Fe = Re && Re.item || null, at = !1, yt = {};
            if (yt[se.substr(5)] = !0, Se && Fe !== N && (N && ae(N, null, "mouseleave", de, ve), Fe && ae(Fe, null, "mouseenter", de, ve), N = Fe), Y ^ mt && (ae(
              this,
              null,
              mt ? "mouseenter" : "mouseleave",
              de,
              ve
            ), at = !0), (mt || yt.drag) && !ve.equals(z) && (le(
              this,
              Fe,
              Ae ? se : "mousemove",
              de,
              ve,
              z
            ), at = !0), Y = mt, yt.down && mt || yt.up && B) {
              if (le(this, Fe, se, de, ve, B), yt.down) {
                if (te = Fe === q && Date.now() - H < 300, C = q = Fe, !G && Fe) {
                  for (var bt = Fe; bt && !bt.responds("mousedrag"); )
                    bt = bt._parent;
                  bt && (j = Fe);
                }
                B = ve;
              } else
                yt.up && (!G && Fe === C && (H = Date.now(), le(this, Fe, te ? "doubleclick" : "click", de, ve, B), te = !1), C = j = null);
              Y = !1, at = !0;
            }
            z = ve, at && Ge && (T = Ge._handleMouseEvent(se, de, ve, yt) || T), de.cancelable !== !1 && (T && !yt.move || yt.down && st("mouseup")) && de.preventDefault();
          },
          _handleKeyEvent: function(se, de, ve, we) {
            var Se = this._scope, Ae = Se.tool, Ge;
            function Qe(st) {
              st.responds(se) && (Ve = Se, st.emit(se, Ge = Ge || new pe(se, de, ve, we)));
            }
            this.isVisible() && (Qe(this), Ae && Ae.responds(se) && Qe(Ae));
          },
          _countItemEvent: function(se, de) {
            var ve = this._itemEvents, we = ve.native, Se = ve.virtual;
            for (var Ae in me)
              we[Ae] = (we[Ae] || 0) + (me[Ae][se] || 0) * de;
            Se[se] = (Se[se] || 0) + de;
          },
          statics: {
            updateFocus: d,
            _resetState: function() {
              s = l = T = Y = !1, i = r = B = z = C = N = j = q = H = te = null;
            }
          }
        };
      }()
    ), rn = Qt.extend({
      _class: "CanvasView",
      initialize: function(i, r) {
        if (!(r instanceof n.HTMLCanvasElement)) {
          var s = U.read(arguments, 1);
          if (s.isZero())
            throw new Error(
              "Cannot create CanvasView with the provided argument: " + o.slice(arguments, 1)
            );
          r = ft.getCanvas(s);
        }
        var l = this._context = r.getContext("2d");
        if (l.save(), this._pixelRatio = 1, !/^off|false$/.test(f.getAttribute(r, "hidpi"))) {
          var u = n.devicePixelRatio || 1, d = Zt.getPrefixed(
            l,
            "backingStorePixelRatio"
          ) || 1;
          this._pixelRatio = u / d;
        }
        Qt.call(this, i, r), this._needsUpdate = !0;
      },
      remove: function i() {
        return this._context.restore(), i.base.call(this);
      },
      _setElementSize: function i(r, s) {
        var l = this._pixelRatio;
        if (i.base.call(this, r * l, s * l), l !== 1) {
          var u = this._element, d = this._context;
          if (!f.hasAttribute(u, "resize")) {
            var p = u.style;
            p.width = r + "px", p.height = s + "px";
          }
          d.restore(), d.save(), d.scale(l, l);
        }
      },
      getContext: function() {
        return this._context;
      },
      getPixelSize: function i(r) {
        var s = Ve.agent, l;
        if (s && s.firefox)
          l = i.base.call(this, r);
        else {
          var u = this._context, d = u.font;
          u.font = r + " serif", l = parseFloat(u.font), u.font = d;
        }
        return l;
      },
      getTextWidth: function(i, r) {
        var s = this._context, l = s.font, u = 0;
        s.font = i;
        for (var d = 0, p = r.length; d < p; d++)
          u = Math.max(u, s.measureText(r[d]).width);
        return s.font = l, u;
      },
      update: function() {
        if (!this._needsUpdate)
          return !1;
        var i = this._project, r = this._context, s = this._viewSize;
        return r.clearRect(0, 0, s.width + 1, s.height + 1), i && i.draw(r, this._matrix, this._pixelRatio), this._needsUpdate = !1, !0;
      }
    }), Gi = o.extend({
      _class: "Event",
      initialize: function(i) {
        this.event = i, this.type = i && i.type;
      },
      prevented: !1,
      stopped: !1,
      preventDefault: function() {
        this.prevented = !0, this.event.preventDefault();
      },
      stopPropagation: function() {
        this.stopped = !0, this.event.stopPropagation();
      },
      stop: function() {
        this.stopPropagation(), this.preventDefault();
      },
      getTimeStamp: function() {
        return this.event.timeStamp;
      },
      getModifiers: function() {
        return Lt.modifiers;
      }
    }), pe = Gi.extend({
      _class: "KeyEvent",
      initialize: function(i, r, s, l) {
        this.type = i, this.event = r, this.key = s, this.character = l;
      },
      toString: function() {
        return "{ type: '" + this.type + "', key: '" + this.key + "', character: '" + this.character + "', modifiers: " + this.getModifiers() + " }";
      }
    }), Lt = new function() {
      var i = {
        "	": "tab",
        " ": "space",
        "\b": "backspace",
        "": "delete",
        Spacebar: "space",
        Del: "delete",
        Win: "meta",
        Esc: "escape"
      }, r = {
        tab: "	",
        space: " ",
        enter: "\r"
      }, s = {}, l = {}, u, d, p = new o({
        shift: !1,
        control: !1,
        alt: !1,
        meta: !1,
        capsLock: !1,
        space: !1
      }).inject({
        option: {
          get: function() {
            return this.alt;
          }
        },
        command: {
          get: function() {
            var S = Ve && Ve.agent;
            return S && S.mac ? this.meta : this.control;
          }
        }
      });
      function m(S) {
        var L = S.key || S.keyIdentifier;
        return L = /^U\+/.test(L) ? String.fromCharCode(parseInt(L.substr(2), 16)) : /^Arrow[A-Z]/.test(L) ? L.substr(5) : L === "Unidentified" || L === t ? String.fromCharCode(S.keyCode) : L, i[L] || (L.length > 1 ? o.hyphenate(L) : L.toLowerCase());
      }
      function y(S, L, E, A) {
        var T = Qt._focused, G;
        if (s[L] = S, S ? l[L] = E : delete l[L], L.length > 1 && (G = o.camelize(L)) in p) {
          p[G] = S;
          var O = Ve && Ve.agent;
          if (G === "meta" && O && O.mac)
            if (S)
              u = {};
            else {
              for (var Y in u)
                Y in l && y(!1, Y, u[Y], A);
              u = null;
            }
        } else
          S && u && (u[L] = E);
        T && T._handleKeyEvent(
          S ? "keydown" : "keyup",
          A,
          L,
          E
        );
      }
      return Jt.add(a, {
        keydown: function(S) {
          var L = m(S), E = Ve && Ve.agent;
          L.length > 1 || E && E.chrome && (S.altKey || E.mac && S.metaKey || !E.mac && S.ctrlKey) ? y(
            !0,
            L,
            r[L] || (L.length > 1 ? "" : L),
            S
          ) : d = L;
        },
        keypress: function(S) {
          if (d) {
            var L = m(S), E = S.charCode, A = E >= 32 ? String.fromCharCode(E) : L.length > 1 ? "" : L;
            L !== d && (L = A.toLowerCase()), y(!0, L, A, S), d = null;
          }
        },
        keyup: function(S) {
          var L = m(S);
          L in l && y(!1, L, l[L], S);
        }
      }), Jt.add(n, {
        blur: function(S) {
          for (var L in l)
            y(!1, L, l[L], S);
        }
      }), {
        modifiers: p,
        isDown: function(S) {
          return !!s[S];
        }
      };
    }(), xt = Gi.extend({
      _class: "MouseEvent",
      initialize: function(i, r, s, l, u) {
        this.type = i, this.event = r, this.point = s, this.target = l, this.delta = u;
      },
      toString: function() {
        return "{ type: '" + this.type + "', point: " + this.point + ", target: " + this.target + (this.delta ? ", delta: " + this.delta : "") + ", modifiers: " + this.getModifiers() + " }";
      }
    }), Ne = Gi.extend({
      _class: "ToolEvent",
      _item: null,
      initialize: function(i, r, s) {
        this.tool = i, this.type = r, this.event = s;
      },
      _choosePoint: function(i, r) {
        return i || (r ? r.clone() : null);
      },
      getPoint: function() {
        return this._choosePoint(this._point, this.tool._point);
      },
      setPoint: function(i) {
        this._point = i;
      },
      getLastPoint: function() {
        return this._choosePoint(this._lastPoint, this.tool._lastPoint);
      },
      setLastPoint: function(i) {
        this._lastPoint = i;
      },
      getDownPoint: function() {
        return this._choosePoint(this._downPoint, this.tool._downPoint);
      },
      setDownPoint: function(i) {
        this._downPoint = i;
      },
      getMiddlePoint: function() {
        return !this._middlePoint && this.tool._lastPoint ? this.tool._point.add(this.tool._lastPoint).divide(2) : this._middlePoint;
      },
      setMiddlePoint: function(i) {
        this._middlePoint = i;
      },
      getDelta: function() {
        return !this._delta && this.tool._lastPoint ? this.tool._point.subtract(this.tool._lastPoint) : this._delta;
      },
      setDelta: function(i) {
        this._delta = i;
      },
      getCount: function() {
        return this.tool[/^mouse(down|up)$/.test(this.type) ? "_downCount" : "_moveCount"];
      },
      setCount: function(i) {
        this.tool[/^mouse(down|up)$/.test(this.type) ? "downCount" : "count"] = i;
      },
      getItem: function() {
        if (!this._item) {
          var i = this.tool._scope.project.hitTest(this.getPoint());
          if (i) {
            for (var r = i.item, s = r._parent; /^(Group|CompoundPath)$/.test(s._class); )
              r = s, s = s._parent;
            this._item = r;
          }
        }
        return this._item;
      },
      setItem: function(i) {
        this._item = i;
      },
      toString: function() {
        return "{ type: " + this.type + ", point: " + this.getPoint() + ", count: " + this.getCount() + ", modifiers: " + this.getModifiers() + " }";
      }
    }), Ie = v.extend({
      _class: "Tool",
      _list: "tools",
      _reference: "tool",
      _events: [
        "onMouseDown",
        "onMouseUp",
        "onMouseDrag",
        "onMouseMove",
        "onActivate",
        "onDeactivate",
        "onEditOptions",
        "onKeyDown",
        "onKeyUp"
      ],
      initialize: function(i) {
        v.call(this), this._moveCount = -1, this._downCount = -1, this.set(i);
      },
      getMinDistance: function() {
        return this._minDistance;
      },
      setMinDistance: function(i) {
        this._minDistance = i, i != null && this._maxDistance != null && i > this._maxDistance && (this._maxDistance = i);
      },
      getMaxDistance: function() {
        return this._maxDistance;
      },
      setMaxDistance: function(i) {
        this._maxDistance = i, this._minDistance != null && i != null && i < this._minDistance && (this._minDistance = i);
      },
      getFixedDistance: function() {
        return this._minDistance == this._maxDistance ? this._minDistance : null;
      },
      setFixedDistance: function(i) {
        this._minDistance = this._maxDistance = i;
      },
      _handleMouseEvent: function(i, r, s, l) {
        Ve = this._scope, l.drag && !this.responds(i) && (i = "mousemove");
        var u = l.move || l.drag, d = this.responds(i), p = !1, m = this;
        function y(L, E) {
          var A = s, T = u ? m._point : m._downPoint || A;
          if (u) {
            if (m._moveCount >= 0 && A.equals(T))
              return !1;
            if (T && (L != null || E != null)) {
              var G = A.subtract(T), O = G.getLength();
              if (O < (L || 0))
                return !1;
              E && (A = T.add(G.normalize(
                Math.min(O, E)
              )));
            }
            m._moveCount++;
          }
          return m._point = A, m._lastPoint = T || A, l.down && (m._moveCount = -1, m._downPoint = A, m._downCount++), !0;
        }
        function S() {
          d && (p = m.emit(i, new Ne(m, i, r)) || p);
        }
        if (l.down)
          y(), S();
        else if (l.up)
          y(null, this._maxDistance), S();
        else if (d)
          for (; y(this._minDistance, this._maxDistance); )
            S();
        return p;
      }
    }), et = o.extend(h, {
      _class: "Tween",
      statics: {
        easings: new o({
          linear: function(i) {
            return i;
          },
          easeInQuad: function(i) {
            return i * i;
          },
          easeOutQuad: function(i) {
            return i * (2 - i);
          },
          easeInOutQuad: function(i) {
            return i < 0.5 ? 2 * i * i : -1 + 2 * (2 - i) * i;
          },
          easeInCubic: function(i) {
            return i * i * i;
          },
          easeOutCubic: function(i) {
            return --i * i * i + 1;
          },
          easeInOutCubic: function(i) {
            return i < 0.5 ? 4 * i * i * i : (i - 1) * (2 * i - 2) * (2 * i - 2) + 1;
          },
          easeInQuart: function(i) {
            return i * i * i * i;
          },
          easeOutQuart: function(i) {
            return 1 - --i * i * i * i;
          },
          easeInOutQuart: function(i) {
            return i < 0.5 ? 8 * i * i * i * i : 1 - 8 * --i * i * i * i;
          },
          easeInQuint: function(i) {
            return i * i * i * i * i;
          },
          easeOutQuint: function(i) {
            return 1 + --i * i * i * i * i;
          },
          easeInOutQuint: function(i) {
            return i < 0.5 ? 16 * i * i * i * i * i : 1 + 16 * --i * i * i * i * i;
          }
        })
      },
      initialize: function i(r, s, l, u, d, p) {
        this.object = r;
        var m = typeof d, y = m === "function";
        this.type = y ? m : m === "string" ? d : "linear", this.easing = y ? d : i.easings[this.type], this.duration = u, this.running = !1, this._then = null, this._startTime = null;
        var S = s || l;
        this._keys = S ? Object.keys(S) : [], this._parsedKeys = this._parseKeys(this._keys), this._from = S && this._getState(s), this._to = S && this._getState(l), p !== !1 && this.start();
      },
      then: function(i) {
        return this._then = i, this;
      },
      start: function() {
        return this._startTime = null, this.running = !0, this;
      },
      stop: function() {
        return this.running = !1, this;
      },
      update: function(i) {
        if (this.running) {
          i >= 1 && (i = 1, this.running = !1);
          for (var r = this.easing(i), s = this._keys, l = function(L) {
            return typeof L == "function" ? L(r, i) : L;
          }, u = 0, d = s && s.length; u < d; u++) {
            var p = s[u], m = l(this._from[p]), y = l(this._to[p]), S = m && y && m.__add && y.__add ? y.__subtract(m).__multiply(r).__add(m) : (y - m) * r + m;
            this._setProperty(this._parsedKeys[p], S);
          }
          this.responds("update") && this.emit("update", new o({
            progress: i,
            factor: r
          })), !this.running && this._then && this._then(this.object);
        }
        return this;
      },
      _events: {
        onUpdate: {}
      },
      _handleFrame: function(i) {
        var r = this._startTime, s = r ? (i - r) / this.duration : 0;
        r || (this._startTime = i), this.update(s);
      },
      _getState: function(i) {
        for (var r = this._keys, s = {}, l = 0, u = r.length; l < u; l++) {
          var d = r[l], p = this._parsedKeys[d], m = this._getProperty(p), y;
          if (i) {
            var S = this._resolveValue(m, i[d]);
            this._setProperty(p, S), y = this._getProperty(p), y = y && y.clone ? y.clone() : y, this._setProperty(p, m);
          } else
            y = m && m.clone ? m.clone() : m;
          s[d] = y;
        }
        return s;
      },
      _resolveValue: function(i, r) {
        if (r) {
          if (Array.isArray(r) && r.length === 2) {
            var s = r[0];
            return s && s.match && s.match(/^[+\-\*\/]=/) ? this._calculate(i, s[0], r[1]) : r;
          } else if (typeof r == "string") {
            var l = r.match(/^[+\-*/]=(.*)/);
            if (l) {
              var u = JSON.parse(l[1].replace(
                /(['"])?([a-zA-Z0-9_]+)(['"])?:/g,
                '"$2": '
              ));
              return this._calculate(i, r[0], u);
            }
          }
        }
        return r;
      },
      _calculate: function(i, r, s) {
        return Ve.PaperScript.calculateBinary(i, r, s);
      },
      _parseKeys: function(i) {
        for (var r = {}, s = 0, l = i.length; s < l; s++) {
          var u = i[s], d = u.replace(/\.([^.]*)/g, "/$1").replace(/\[['"]?([^'"\]]*)['"]?\]/g, "/$1");
          r[u] = d.split("/");
        }
        return r;
      },
      _getProperty: function(i, r) {
        for (var s = this.object, l = 0, u = i.length - (r || 0); l < u && s; l++)
          s = s[i[l]];
        return s;
      },
      _setProperty: function(i, r) {
        var s = this._getProperty(i, 1);
        s && (s[i[i.length - 1]] = r);
      }
    }), Et = {
      request: function(i) {
        var r = new e.XMLHttpRequest();
        return r.open(
          (i.method || "get").toUpperCase(),
          i.url,
          o.pick(i.async, !0)
        ), i.mimeType && r.overrideMimeType(i.mimeType), r.onload = function() {
          var s = r.status;
          s === 0 || s === 200 ? i.onLoad && i.onLoad.call(r, r.responseText) : r.onerror();
        }, r.onerror = function() {
          var s = r.status, l = 'Could not load "' + i.url + '" (Status: ' + s + ")";
          if (i.onError)
            i.onError(l, s);
          else
            throw new Error(l);
        }, r.send(null);
      }
    }, ft = o.exports.CanvasProvider = {
      canvases: [],
      getCanvas: function(i, r, s) {
        if (!n)
          return null;
        var l, u = !0;
        typeof i == "object" && (r = i.height, i = i.width), this.canvases.length ? l = this.canvases.pop() : (l = a.createElement("canvas"), u = !1);
        var d = l.getContext("2d", s || {});
        if (!d)
          throw new Error("Canvas " + l + " is unable to provide a 2D context.");
        return l.width === i && l.height === r ? u && d.clearRect(0, 0, i + 1, r + 1) : (l.width = i, l.height = r), d.save(), l;
      },
      getContext: function(i, r, s) {
        var l = this.getCanvas(i, r, s);
        return l ? l.getContext("2d", s || {}) : null;
      },
      release: function(i) {
        var r = i && i.canvas ? i.canvas : i;
        r && r.getContext && (r.getContext("2d").restore(), this.canvases.push(r));
      }
    }, tt = new function() {
      var i = Math.min, r = Math.max, s = Math.abs, l, u, d, p, m, y, S, L, E, A, T;
      function G(j, q, H) {
        return 0.2989 * j + 0.587 * q + 0.114 * H;
      }
      function O(j, q, H, le) {
        var ae = le - G(j, q, H);
        E = j + ae, A = q + ae, T = H + ae;
        var le = G(E, A, T), me = i(E, A, T), se = r(E, A, T);
        if (me < 0) {
          var de = le - me;
          E = le + (E - le) * le / de, A = le + (A - le) * le / de, T = le + (T - le) * le / de;
        }
        if (se > 255) {
          var ve = 255 - le, we = se - le;
          E = le + (E - le) * ve / we, A = le + (A - le) * ve / we, T = le + (T - le) * ve / we;
        }
      }
      function Y(j, q, H) {
        return r(j, q, H) - i(j, q, H);
      }
      function B(j, q, H, te) {
        var ae = [j, q, H], le = r(j, q, H), me = i(j, q, H), se;
        me = me === j ? 0 : me === q ? 1 : 2, le = le === j ? 0 : le === q ? 1 : 2, se = i(me, le) === 0 ? r(me, le) === 1 ? 2 : 1 : 0, ae[le] > ae[me] ? (ae[se] = (ae[se] - ae[me]) * te / (ae[le] - ae[me]), ae[le] = te) : ae[se] = ae[le] = 0, ae[me] = 0, E = ae[0], A = ae[1], T = ae[2];
      }
      var z = {
        multiply: function() {
          E = m * l / 255, A = y * u / 255, T = S * d / 255;
        },
        screen: function() {
          E = m + l - m * l / 255, A = y + u - y * u / 255, T = S + d - S * d / 255;
        },
        overlay: function() {
          E = m < 128 ? 2 * m * l / 255 : 255 - 2 * (255 - m) * (255 - l) / 255, A = y < 128 ? 2 * y * u / 255 : 255 - 2 * (255 - y) * (255 - u) / 255, T = S < 128 ? 2 * S * d / 255 : 255 - 2 * (255 - S) * (255 - d) / 255;
        },
        "soft-light": function() {
          var j = l * m / 255;
          E = j + m * (255 - (255 - m) * (255 - l) / 255 - j) / 255, j = u * y / 255, A = j + y * (255 - (255 - y) * (255 - u) / 255 - j) / 255, j = d * S / 255, T = j + S * (255 - (255 - S) * (255 - d) / 255 - j) / 255;
        },
        "hard-light": function() {
          E = l < 128 ? 2 * l * m / 255 : 255 - 2 * (255 - l) * (255 - m) / 255, A = u < 128 ? 2 * u * y / 255 : 255 - 2 * (255 - u) * (255 - y) / 255, T = d < 128 ? 2 * d * S / 255 : 255 - 2 * (255 - d) * (255 - S) / 255;
        },
        "color-dodge": function() {
          E = m === 0 ? 0 : l === 255 ? 255 : i(255, 255 * m / (255 - l)), A = y === 0 ? 0 : u === 255 ? 255 : i(255, 255 * y / (255 - u)), T = S === 0 ? 0 : d === 255 ? 255 : i(255, 255 * S / (255 - d));
        },
        "color-burn": function() {
          E = m === 255 ? 255 : l === 0 ? 0 : r(0, 255 - (255 - m) * 255 / l), A = y === 255 ? 255 : u === 0 ? 0 : r(0, 255 - (255 - y) * 255 / u), T = S === 255 ? 255 : d === 0 ? 0 : r(0, 255 - (255 - S) * 255 / d);
        },
        darken: function() {
          E = m < l ? m : l, A = y < u ? y : u, T = S < d ? S : d;
        },
        lighten: function() {
          E = m > l ? m : l, A = y > u ? y : u, T = S > d ? S : d;
        },
        difference: function() {
          E = m - l, E < 0 && (E = -E), A = y - u, A < 0 && (A = -A), T = S - d, T < 0 && (T = -T);
        },
        exclusion: function() {
          E = m + l * (255 - m - m) / 255, A = y + u * (255 - y - y) / 255, T = S + d * (255 - S - S) / 255;
        },
        hue: function() {
          B(l, u, d, Y(m, y, S)), O(E, A, T, G(m, y, S));
        },
        saturation: function() {
          B(m, y, S, Y(l, u, d)), O(E, A, T, G(m, y, S));
        },
        luminosity: function() {
          O(m, y, S, G(l, u, d));
        },
        color: function() {
          O(l, u, d, G(m, y, S));
        },
        add: function() {
          E = i(m + l, 255), A = i(y + u, 255), T = i(S + d, 255);
        },
        subtract: function() {
          E = r(m - l, 0), A = r(y - u, 0), T = r(S - d, 0);
        },
        average: function() {
          E = (m + l) / 2, A = (y + u) / 2, T = (S + d) / 2;
        },
        negation: function() {
          E = 255 - s(255 - l - m), A = 255 - s(255 - u - y), T = 255 - s(255 - d - S);
        }
      }, C = this.nativeModes = o.each([
        "source-over",
        "source-in",
        "source-out",
        "source-atop",
        "destination-over",
        "destination-in",
        "destination-out",
        "destination-atop",
        "lighter",
        "darker",
        "copy",
        "xor"
      ], function(j) {
        this[j] = !0;
      }, {}), N = ft.getContext(1, 1, { willReadFrequently: !0 });
      N && (o.each(z, function(j, q) {
        var H = q === "darken", te = !1;
        N.save();
        try {
          N.fillStyle = H ? "#300" : "#a00", N.fillRect(0, 0, 1, 1), N.globalCompositeOperation = q, N.globalCompositeOperation === q && (N.fillStyle = H ? "#a00" : "#300", N.fillRect(0, 0, 1, 1), te = N.getImageData(0, 0, 1, 1).data[0] !== H ? 170 : 51);
        } catch {
        }
        N.restore(), C[q] = te;
      }), ft.release(N)), this.process = function(j, q, H, te, ae) {
        var le = q.canvas, me = j === "normal";
        if (me || C[j])
          H.save(), H.setTransform(1, 0, 0, 1, 0, 0), H.globalAlpha = te, me || (H.globalCompositeOperation = j), H.drawImage(le, ae.x, ae.y), H.restore();
        else {
          var se = z[j];
          if (!se)
            return;
          for (var de = H.getImageData(
            ae.x,
            ae.y,
            le.width,
            le.height
          ), ve = de.data, we = q.getImageData(
            0,
            0,
            le.width,
            le.height
          ).data, Se = 0, Ae = ve.length; Se < Ae; Se += 4) {
            l = we[Se], m = ve[Se], u = we[Se + 1], y = ve[Se + 1], d = we[Se + 2], S = ve[Se + 2], p = we[Se + 3], L = ve[Se + 3], se();
            var Ge = p * te / 255, Qe = 1 - Ge;
            ve[Se] = Ge * E + Qe * m, ve[Se + 1] = Ge * A + Qe * y, ve[Se + 2] = Ge * T + Qe * S, ve[Se + 3] = p * te + Qe * L;
          }
          H.putImageData(de, ae.x, ae.y);
        }
      };
    }(), _t = new function() {
      var i = "http://www.w3.org/2000/svg", r = "http://www.w3.org/2000/xmlns", s = "http://www.w3.org/1999/xlink", l = {
        href: s,
        xlink: r,
        xmlns: r + "/",
        "xmlns:xlink": r + "/"
      };
      function u(m, y, S) {
        return p(a.createElementNS(i, m), y, S);
      }
      function d(m, y) {
        var S = l[y], L = S ? m.getAttributeNS(S, y) : m.getAttribute(y);
        return L === "null" ? null : L;
      }
      function p(m, y, S) {
        for (var L in y) {
          var E = y[L], A = l[L];
          typeof E == "number" && S && (E = S.number(E)), A ? m.setAttributeNS(A, L, E) : m.setAttribute(L, E);
        }
        return m;
      }
      return {
        svg: i,
        xmlns: r,
        xlink: s,
        create: u,
        get: d,
        set: p
      };
    }(), Kt = o.each({
      fillColor: ["fill", "color"],
      fillRule: ["fill-rule", "string"],
      strokeColor: ["stroke", "color"],
      strokeWidth: ["stroke-width", "number"],
      strokeCap: ["stroke-linecap", "string"],
      strokeJoin: ["stroke-linejoin", "string"],
      strokeScaling: ["vector-effect", "lookup", {
        true: "none",
        false: "non-scaling-stroke"
      }, function(i, r) {
        return !r && (i instanceof Gt || i instanceof Oe || i instanceof Xt);
      }],
      miterLimit: ["stroke-miterlimit", "number"],
      dashArray: ["stroke-dasharray", "array"],
      dashOffset: ["stroke-dashoffset", "number"],
      fontFamily: ["font-family", "string"],
      fontWeight: ["font-weight", "string"],
      fontSize: ["font-size", "number"],
      justification: ["text-anchor", "lookup", {
        left: "start",
        center: "middle",
        right: "end"
      }],
      opacity: ["opacity", "number"],
      blendMode: ["mix-blend-mode", "style"]
    }, function(i, r) {
      var s = o.capitalize(r), l = i[2];
      this[r] = {
        type: i[1],
        property: r,
        attribute: i[0],
        toSVG: l,
        fromSVG: l && o.each(l, function(u, d) {
          this[u] = d;
        }, {}),
        exportFilter: i[3],
        get: "get" + s,
        set: "set" + s
      };
    }, {});
    new function() {
      var i;
      function r(z, C, N) {
        var j = new o(), q = z.getTranslation();
        if (C) {
          var H;
          z.isInvertible() ? (z = z._shiftless(), H = z._inverseTransform(q), q = null) : H = new M(), j[N ? "cx" : "x"] = H.x, j[N ? "cy" : "y"] = H.y;
        }
        if (!z.isIdentity()) {
          var te = z.decompose();
          if (te) {
            var ae = [], le = te.rotation, me = te.scaling, se = te.skewing;
            q && !q.isZero() && ae.push("translate(" + i.point(q) + ")"), le && ae.push("rotate(" + i.number(le) + ")"), (!I.isZero(me.x - 1) || !I.isZero(me.y - 1)) && ae.push("scale(" + i.point(me) + ")"), se.x && ae.push("skewX(" + i.number(se.x) + ")"), se.y && ae.push("skewY(" + i.number(se.y) + ")"), j.transform = ae.join(" ");
          } else
            j.transform = "matrix(" + z.getValues().join(",") + ")";
        }
        return j;
      }
      function s(z, C) {
        for (var N = r(z._matrix), j = z._children, q = _t.create("g", N, i), H = 0, te = j.length; H < te; H++) {
          var ae = j[H], le = Y(ae, C);
          if (le)
            if (ae.isClipMask()) {
              var me = _t.create("clipPath");
              me.appendChild(le), G(ae, me, "clip"), _t.set(q, {
                "clip-path": "url(#" + me.id + ")"
              });
            } else
              q.appendChild(le);
        }
        return q;
      }
      function l(z, C) {
        var N = r(z._matrix, !0), j = z.getSize(), q = z.getImage();
        return N.x -= j.width / 2, N.y -= j.height / 2, N.width = j.width, N.height = j.height, N.href = C.embedImages == !1 && q && q.src || z.toDataURL(), _t.create("image", N, i);
      }
      function u(z, C) {
        var N = C.matchShapes;
        if (N) {
          var j = z.toShape(!1);
          if (j)
            return d(j);
        }
        var q = z._segments, H = q.length, te, ae = r(z._matrix);
        if (N && H >= 2 && !z.hasHandles())
          if (H > 2) {
            te = z._closed ? "polygon" : "polyline";
            for (var le = [], me = 0; me < H; me++)
              le.push(i.point(q[me]._point));
            ae.points = le.join(" ");
          } else {
            te = "line";
            var se = q[0]._point, de = q[1]._point;
            ae.set({
              x1: se.x,
              y1: se.y,
              x2: de.x,
              y2: de.y
            });
          }
        else
          te = "path", ae.d = z.getPathData(null, C.precision);
        return _t.create(te, ae, i);
      }
      function d(z) {
        var C = z._type, N = z._radius, j = r(z._matrix, !0, C !== "rectangle");
        if (C === "rectangle") {
          C = "rect";
          var q = z._size, H = q.width, te = q.height;
          j.x -= H / 2, j.y -= te / 2, j.width = H, j.height = te, N.isZero() && (N = null);
        }
        return N && (C === "circle" ? j.r = N : (j.rx = N.width, j.ry = N.height)), _t.create(C, j, i);
      }
      function p(z, C) {
        var N = r(z._matrix), j = z.getPathData(null, C.precision);
        return j && (N.d = j), _t.create("path", N, i);
      }
      function m(z, C) {
        var N = r(z._matrix, !0), j = z._definition, q = T(j, "symbol"), H = j._item, te = H.getStrokeBounds();
        return q || (q = _t.create("symbol", {
          viewBox: i.rectangle(te)
        }), q.appendChild(Y(H, C)), G(j, q, "symbol")), N.href = "#" + q.id, N.x += te.x, N.y += te.y, N.width = te.width, N.height = te.height, N.overflow = "visible", _t.create("use", N, i);
      }
      function y(z) {
        var C = T(z, "color");
        if (!C) {
          var N = z.getGradient(), j = N._radial, q = z.getOrigin(), H = z.getDestination(), te;
          if (j) {
            te = {
              cx: q.x,
              cy: q.y,
              r: q.getDistance(H)
            };
            var ae = z.getHighlight();
            ae && (te.fx = ae.x, te.fy = ae.y);
          } else
            te = {
              x1: q.x,
              y1: q.y,
              x2: H.x,
              y2: H.y
            };
          te.gradientUnits = "userSpaceOnUse", C = _t.create((j ? "radial" : "linear") + "Gradient", te, i);
          for (var le = N._stops, me = 0, se = le.length; me < se; me++) {
            var de = le[me], ve = de._color, we = ve.getAlpha(), Se = de._offset;
            te = {
              offset: Se ?? me / (se - 1)
            }, ve && (te["stop-color"] = ve.toCSS(!0)), we < 1 && (te["stop-opacity"] = we), C.appendChild(
              _t.create("stop", te, i)
            );
          }
          G(z, C, "color");
        }
        return "url(#" + C.id + ")";
      }
      function S(z) {
        var C = _t.create(
          "text",
          r(z._matrix, !0),
          i
        );
        return C.textContent = z._content, C;
      }
      var L = {
        Group: s,
        Layer: s,
        Raster: l,
        Path: u,
        Shape: d,
        CompoundPath: p,
        SymbolItem: m,
        PointText: S
      };
      function E(z, C, N, j) {
        var q = {}, H = !j && z.getParent(), te = [];
        return z._name != null && (q.id = z._name), o.each(Kt, function(ae) {
          var le = ae.get, me = ae.type, se = z[le]();
          if (ae.exportFilter ? ae.exportFilter(z, se) : N.reduceAttributes == !1 || !H || !o.equals(H[le](), se)) {
            if (me === "color" && se != null) {
              var de = se.getAlpha();
              de < 1 && (q[ae.attribute + "-opacity"] = de);
            }
            me === "style" ? te.push(ae.attribute + ": " + se) : q[ae.attribute] = se == null ? "none" : me === "color" ? se.gradient ? y(se) : se.toCSS(!0) : me === "array" ? se.join(",") : me === "lookup" ? ae.toSVG[se] : se;
          }
        }), te.length && (q.style = te.join(";")), q.opacity === 1 && delete q.opacity, z._visible || (q.visibility = "hidden"), _t.set(C, q, i);
      }
      var A;
      function T(z, C) {
        return A || (A = { ids: {}, svgs: {} }), z && A.svgs[C + "-" + (z._id || z.__id || (z.__id = V.get("svg")))];
      }
      function G(z, C, N) {
        A || T();
        var j = A.ids[N] = (A.ids[N] || 0) + 1;
        C.id = N + "-" + j, A.svgs[N + "-" + (z._id || z.__id)] = C;
      }
      function O(z, C) {
        var N = z, j = null;
        if (A) {
          N = z.nodeName.toLowerCase() === "svg" && z;
          for (var q in A.svgs)
            j || (N || (N = _t.create("svg"), N.appendChild(z)), j = N.insertBefore(
              _t.create("defs"),
              N.firstChild
            )), j.appendChild(A.svgs[q]);
          A = null;
        }
        return C.asString ? new e.XMLSerializer().serializeToString(N) : N;
      }
      function Y(z, C, N) {
        var j = L[z._class], q = j && j(z, C);
        if (q) {
          var H = C.onExport;
          H && (q = H(z, q, C) || q);
          var te = JSON.stringify(z._data);
          te && te !== "{}" && te !== "null" && q.setAttribute("data-paper-data", te);
        }
        return q && E(z, q, C, N);
      }
      function B(z) {
        return z || (z = {}), i = new k(z.precision), z;
      }
      X.inject({
        exportSVG: function(z) {
          return z = B(z), O(Y(this, z, !0), z);
        }
      }), fe.inject({
        exportSVG: function(z) {
          z = B(z);
          var C = this._children, N = this.getView(), j = o.pick(z.bounds, "view"), q = z.matrix || j === "view" && N._matrix, H = q && J.read([q]), te = j === "view" ? new D([0, 0], N.getViewSize()) : j === "content" ? X._getBounds(C, H, { stroke: !0 }).rect : D.read([j], 0, { readNull: !0 }), ae = {
            version: "1.1",
            xmlns: _t.svg,
            "xmlns:xlink": _t.xlink
          };
          te && (ae.width = te.width, ae.height = te.height, (te.x || te.x === 0 || te.y || te.y === 0) && (ae.viewBox = i.rectangle(te)));
          var le = _t.create("svg", ae, i), me = le;
          H && !H.isIdentity() && (me = le.appendChild(_t.create(
            "g",
            r(H),
            i
          )));
          for (var se = 0, de = C.length; se < de; se++)
            me.appendChild(Y(C[se], z, !0));
          return O(le, z);
        }
      });
    }(), new function() {
      var i = {}, r;
      function s(C, N, j, q, H, te) {
        var ae = _t.get(C, N) || te, le = ae == null ? q ? null : j ? "" : 0 : j ? ae : parseFloat(ae);
        return /%\s*$/.test(ae) ? le / 100 * (H ? 1 : r[/x|^width/.test(N) ? "width" : "height"]) : le;
      }
      function l(C, N, j, q, H, te, ae) {
        return N = s(C, N || "x", !1, q, H, te), j = s(C, j || "y", !1, q, H, ae), q && (N == null || j == null) ? null : new M(N, j);
      }
      function u(C, N, j, q, H) {
        return N = s(C, N || "width", !1, q, H), j = s(C, j || "height", !1, q, H), q && (N == null || j == null) ? null : new U(N, j);
      }
      function d(C, N, j) {
        return C === "none" ? null : N === "number" ? parseFloat(C) : N === "array" ? C ? C.split(/[\s,]+/g).map(parseFloat) : [] : N === "color" ? Y(C) || C : N === "lookup" ? j[C] : C;
      }
      function p(C, N, j, q) {
        var H = C.childNodes, te = N === "clippath", ae = N === "defs", le = new Z(), me = le._project, se = me._currentStyle, de = [];
        if (!te && !ae && (le = O(le, C, q), me._currentStyle = le._style.clone()), q)
          for (var ve = C.querySelectorAll("defs"), we = 0, Se = ve.length; we < Se; we++)
            B(ve[we], j, !1);
        for (var we = 0, Se = H.length; we < Se; we++) {
          var Ae = H[we], Ge;
          Ae.nodeType === 1 && !/^defs$/i.test(Ae.nodeName) && (Ge = B(Ae, j, !1)) && !(Ge instanceof Te) && de.push(Ge);
        }
        return le.addChildren(de), te && (le = O(le.reduce(), C, q)), me._currentStyle = se, (te || ae) && (le.remove(), le = null), le;
      }
      function m(C, N) {
        for (var j = C.getAttribute("points").match(
          /[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g
        ), q = [], H = 0, te = j.length; H < te; H += 2)
          q.push(new M(
            parseFloat(j[H]),
            parseFloat(j[H + 1])
          ));
        var ae = new $e(q);
        return N === "polygon" && ae.closePath(), ae;
      }
      function y(C) {
        return Gt.create(C.getAttribute("d"));
      }
      function S(C, N) {
        var j = (s(C, "href", !0) || "").substring(1), q = N === "radialgradient", H;
        if (j)
          H = i[j].getGradient(), H._radial ^ q && (H = H.clone(), H._radial = q);
        else {
          for (var te = C.childNodes, ae = [], le = 0, me = te.length; le < me; le++) {
            var se = te[le];
            se.nodeType === 1 && ae.push(O(new en(), se));
          }
          H = new Bi(ae, q);
        }
        var de, ve, we, Se = s(C, "gradientUnits", !0) !== "userSpaceOnUse";
        q ? (de = l(
          C,
          "cx",
          "cy",
          !1,
          Se,
          "50%",
          "50%"
        ), ve = de.add(
          s(C, "r", !1, !1, Se, "50%"),
          0
        ), we = l(C, "fx", "fy", !0, Se)) : (de = l(
          C,
          "x1",
          "y1",
          !1,
          Se,
          "0%",
          "0%"
        ), ve = l(
          C,
          "x2",
          "y2",
          !1,
          Se,
          "100%",
          "0%"
        ));
        var Ae = O(
          new Tt(H, de, ve, we),
          C
        );
        return Ae._scaleToBounds = Se, null;
      }
      var L = {
        "#document": function(C, N, j, q) {
          for (var H = C.childNodes, te = 0, ae = H.length; te < ae; te++) {
            var le = H[te];
            if (le.nodeType === 1)
              return B(le, j, q);
          }
        },
        g: p,
        svg: p,
        clippath: p,
        polygon: m,
        polyline: m,
        path: y,
        lineargradient: S,
        radialgradient: S,
        image: function(C) {
          var N = new je(s(C, "href", !0));
          return N.on("load", function() {
            var j = u(C);
            this.setSize(j);
            var q = l(C).add(j.divide(2));
            this._matrix.append(new J().translate(q));
          }), N;
        },
        symbol: function(C, N, j, q) {
          return new Te(
            p(C, N, j, q),
            !0
          );
        },
        defs: p,
        use: function(C) {
          var N = (s(C, "href", !0) || "").substring(1), j = i[N], q = l(C);
          return j ? j instanceof Te ? j.place(q) : j.clone().translate(q) : null;
        },
        circle: function(C) {
          return new Oe.Circle(
            l(C, "cx", "cy"),
            s(C, "r")
          );
        },
        ellipse: function(C) {
          return new Oe.Ellipse({
            center: l(C, "cx", "cy"),
            radius: u(C, "rx", "ry")
          });
        },
        rect: function(C) {
          return new Oe.Rectangle(new D(
            l(C),
            u(C)
          ), u(C, "rx", "ry"));
        },
        line: function(C) {
          return new $e.Line(
            l(C, "x1", "y1"),
            l(C, "x2", "y2")
          );
        },
        text: function(C) {
          var N = new $t(l(C).add(
            l(C, "dx", "dy")
          ));
          return N.setContent(C.textContent.trim() || ""), N;
        },
        switch: p
      };
      function E(C, N, j, q) {
        if (C.transform) {
          for (var H = (q.getAttribute(j) || "").split(/\)\s*/g), te = new J(), ae = 0, le = H.length; ae < le; ae++) {
            var me = H[ae];
            if (!me)
              break;
            for (var se = me.split(/\(\s*/), de = se[0].trim(), ve = se[1].split(/[\s,]+/g), we = 0, Se = ve.length; we < Se; we++)
              ve[we] = parseFloat(ve[we]);
            switch (de) {
              case "matrix":
                te.append(
                  new J(ve[0], ve[1], ve[2], ve[3], ve[4], ve[5])
                );
                break;
              case "rotate":
                te.rotate(ve[0], ve[1] || 0, ve[2] || 0);
                break;
              case "translate":
                te.translate(ve[0], ve[1] || 0);
                break;
              case "scale":
                te.scale(ve);
                break;
              case "skewX":
                te.skew(ve[0], 0);
                break;
              case "skewY":
                te.skew(0, ve[0]);
                break;
            }
          }
          C.transform(te);
        }
      }
      function A(C, N, j) {
        var q = j === "fill-opacity" ? "getFillColor" : "getStrokeColor", H = C[q] && C[q]();
        H && H.setAlpha(parseFloat(N));
      }
      var T = o.set(o.each(Kt, function(C) {
        this[C.attribute] = function(N, j) {
          if (N[C.set] && (N[C.set](d(j, C.type, C.fromSVG)), C.type === "color")) {
            var q = N[C.get]();
            if (q && q._scaleToBounds) {
              var H = N.getBounds();
              q.transform(new J().translate(H.getPoint()).scale(H.getSize()));
            }
          }
        };
      }, {}), {
        id: function(C, N) {
          i[N] = C, C.setName && C.setName(N);
        },
        "clip-path": function(C, N) {
          var j = Y(N);
          if (j)
            if (j = j.clone(), j.setClipMask(!0), C instanceof Z)
              C.insertChild(0, j);
            else
              return new Z(j, C);
        },
        gradientTransform: E,
        transform: E,
        "fill-opacity": A,
        "stroke-opacity": A,
        visibility: function(C, N) {
          C.setVisible && C.setVisible(N === "visible");
        },
        display: function(C, N) {
          C.setVisible && C.setVisible(N !== null);
        },
        "stop-color": function(C, N) {
          C.setColor && C.setColor(N);
        },
        "stop-opacity": function(C, N) {
          C._color && C._color.setAlpha(parseFloat(N));
        },
        offset: function(C, N) {
          if (C.setOffset) {
            var j = N.match(/(.*)%$/);
            C.setOffset(j ? j[1] / 100 : parseFloat(N));
          }
        },
        viewBox: function(C, N, j, q, H) {
          var te = new D(d(N, "array")), ae = u(q, null, null, !0), le, me;
          if (C instanceof Z) {
            var se = ae ? ae.divide(te.getSize()) : 1, me = new J().scale(se).translate(te.getPoint().negate());
            le = C;
          } else
            C instanceof Te && (ae && te.setSize(ae), le = C._item);
          if (le) {
            if (G(q, "overflow", H) !== "visible") {
              var de = new Oe.Rectangle(te);
              de.setClipMask(!0), le.addChild(de);
            }
            me && le.transform(me);
          }
        }
      });
      function G(C, N, j) {
        var q = C.attributes[N], H = q && q.value;
        if (!H && C.style) {
          var te = o.camelize(N);
          H = C.style[te], !H && j.node[te] !== j.parent[te] && (H = j.node[te]);
        }
        return H ? H === "none" ? null : H : t;
      }
      function O(C, N, j) {
        var q = N.parentNode, H = {
          node: Zt.getStyles(N) || {},
          parent: !j && !/^defs$/i.test(q.tagName) && Zt.getStyles(q) || {}
        };
        return o.each(T, function(te, ae) {
          var le = G(N, ae, H);
          C = le !== t && te(C, le, ae, N, H) || C;
        }), C;
      }
      function Y(C) {
        var N = C && C.match(/\((?:["'#]*)([^"')]+)/), j = N && N[1], q = j && i[n ? j.replace(n.location.href.split("#")[0] + "#", "") : j];
        return q && q._scaleToBounds && (q = q.clone(), q._scaleToBounds = !0), q;
      }
      function B(C, N, j) {
        var q = C.nodeName.toLowerCase(), H = q !== "#document", te = a.body, ae, le, me;
        j && H && (r = Ve.getView().getSize(), r = u(C, null, null, !0) || r, ae = _t.create("svg", {
          style: "stroke-width: 1px; stroke-miterlimit: 10"
        }), le = C.parentNode, me = C.nextSibling, ae.appendChild(C), te.appendChild(ae));
        var se = Ve.settings, de = se.applyMatrix, ve = se.insertItems;
        se.applyMatrix = !1, se.insertItems = !1;
        var we = L[q], Se = we && we(C, q, N, j) || null;
        if (se.insertItems = ve, se.applyMatrix = de, Se) {
          H && !(Se instanceof Z) && (Se = O(Se, C, j));
          var Ae = N.onImport, Ge = H && C.getAttribute("data-paper-data");
          Ae && (Se = Ae(C, Se, N) || Se), N.expandShapes && Se instanceof Oe && (Se.remove(), Se = Se.toPath()), Ge && (Se._data = JSON.parse(Ge));
        }
        return ae && (te.removeChild(ae), le && (me ? le.insertBefore(C, me) : le.appendChild(C))), j && (i = {}, Se && o.pick(N.applyMatrix, de) && Se.matrix.apply(!0, !0)), Se;
      }
      function z(C, N, j) {
        if (!C)
          return null;
        N = typeof N == "function" ? { onLoad: N } : N || {};
        var q = Ve, H = null;
        function te(se) {
          try {
            var de = typeof se == "object" ? se : new e.DOMParser().parseFromString(
              se.trim(),
              "image/svg+xml"
            );
            if (!de.nodeName)
              throw de = null, new Error("Unsupported SVG source: " + C);
            Ve = q, H = B(de, N, !0), (!N || N.insert !== !1) && j._insertItem(t, H);
            var ve = N.onLoad;
            ve && ve(H, se);
          } catch (we) {
            ae(we);
          }
        }
        function ae(se, de) {
          var ve = N.onError;
          if (ve)
            ve(se, de);
          else
            throw new Error(se);
        }
        if (typeof C == "string" && !/^[\s\S]*</.test(C)) {
          var le = a.getElementById(C);
          le ? te(le) : Et.request({
            url: C,
            async: !0,
            onLoad: te,
            onError: ae
          });
        } else if (typeof File < "u" && C instanceof File) {
          var me = new FileReader();
          return me.onload = function() {
            te(me.result);
          }, me.onerror = function() {
            ae(me.error);
          }, me.readAsText(C);
        } else
          te(C);
        return H;
      }
      X.inject({
        importSVG: function(C, N) {
          return z(C, N, this);
        }
      }), fe.inject({
        importSVG: function(C, N) {
          return this.activate(), z(C, N, this);
        }
      });
    }(), o.exports.PaperScript = (function() {
      var i = this, r = i.acorn;
      if (!r && typeof Yy < "u")
        try {
          r = require("acorn");
        } catch {
        }
      if (!r) {
        var s, l;
        r = s = l = {}, function(O, Y) {
          if (typeof s == "object" && typeof l == "object")
            return Y(s);
          if (typeof t == "function" && t.amd)
            return t(["exports"], Y);
          Y(O.acorn || (O.acorn = {}));
        }(this, function(O) {
          O.version = "0.5.0";
          var Y, B, z, C;
          O.parse = function(ie, oe) {
            return B = String(ie), z = B.length, j(oe), _e(), $s(Y.program);
          };
          var N = O.defaultOptions = {
            ecmaVersion: 5,
            strictSemicolons: !1,
            allowTrailingCommas: !0,
            forbidReserved: !1,
            allowReturnOutsideFunction: !1,
            locations: !1,
            onComment: null,
            ranges: !1,
            program: null,
            sourceFile: null,
            directSourceFile: null
          };
          function j(ie) {
            Y = ie || {};
            for (var oe in N)
              Object.prototype.hasOwnProperty.call(Y, oe) || (Y[oe] = N[oe]);
            C = Y.sourceFile || null;
          }
          var q = O.getLineInfo = function(ie, oe) {
            for (var Me = 1, ke = 0; ; ) {
              P.lastIndex = ke;
              var lt = P.exec(ie);
              if (lt && lt.index < oe)
                ++Me, ke = lt.index + lt[0].length;
              else
                break;
            }
            return { line: Me, column: oe - ke };
          };
          O.tokenize = function(ie, oe) {
            B = String(ie), z = B.length, j(oe), _e();
            var Me = {};
            function ke(lt) {
              return Ge = ae, fn(lt), Me.start = te, Me.end = ae, Me.startLoc = le, Me.endLoc = me, Me.type = se, Me.value = de, Me;
            }
            return ke.jumpTo = function(lt, At) {
              if (H = lt, Y.locations) {
                we = 1, Se = P.lastIndex = 0;
                for (var wt; (wt = P.exec(B)) && wt.index < lt; )
                  ++we, Se = wt.index + wt[0].length;
              }
              ve = At, Je();
            }, ke;
          };
          var H, te, ae, le, me, se, de, ve, we, Se, Ae, Ge, Qe, st, mt, Re;
          function Fe(ie, oe) {
            var Me = q(B, ie);
            oe += " (" + Me.line + ":" + Me.column + ")";
            var ke = new SyntaxError(oe);
            throw ke.pos = ie, ke.loc = Me, ke.raisedAt = H, ke;
          }
          var at = [], yt = { type: "num" }, bt = { type: "regexp" }, Rt = { type: "string" }, Pt = { type: "name" }, zt = { type: "eof" }, Wt = { keyword: "break" }, Ft = { keyword: "case", beforeExpr: !0 }, Mi = { keyword: "catch" }, yi = { keyword: "continue" }, Ai = { keyword: "debugger" }, pi = { keyword: "default" }, kt = { keyword: "do", isLoop: !0 }, fi = { keyword: "else", beforeExpr: !0 }, Ti = { keyword: "finally" }, xi = { keyword: "for", isLoop: !0 }, tn = { keyword: "function" }, Hi = { keyword: "if" }, Zi = { keyword: "return", beforeExpr: !0 }, Xi = { keyword: "switch" }, ji = { keyword: "throw", beforeExpr: !0 }, Ki = { keyword: "try" }, ln = { keyword: "var" }, Fi = { keyword: "while", isLoop: !0 }, hn = { keyword: "with" }, kr = { keyword: "new", beforeExpr: !0 }, Er = { keyword: "this" }, Ir = { keyword: "null", atomValue: null }, Nn = { keyword: "true", atomValue: !0 }, Pr = { keyword: "false", atomValue: !1 }, Rn = { keyword: "in", binop: 7, beforeExpr: !0 }, qn = {
            break: Wt,
            case: Ft,
            catch: Mi,
            continue: yi,
            debugger: Ai,
            default: pi,
            do: kt,
            else: fi,
            finally: Ti,
            for: xi,
            function: tn,
            if: Hi,
            return: Zi,
            switch: Xi,
            throw: ji,
            try: Ki,
            var: ln,
            while: Fi,
            with: hn,
            null: Ir,
            true: Nn,
            false: Pr,
            new: kr,
            in: Rn,
            instanceof: { keyword: "instanceof", binop: 7, beforeExpr: !0 },
            this: Er,
            typeof: { keyword: "typeof", prefix: !0, beforeExpr: !0 },
            void: { keyword: "void", prefix: !0, beforeExpr: !0 },
            delete: { keyword: "delete", prefix: !0, beforeExpr: !0 }
          }, Dn = { type: "[", beforeExpr: !0 }, Mn = { type: "]" }, gn = { type: "{", beforeExpr: !0 }, yn = { type: "}" }, ri = { type: "(", beforeExpr: !0 }, Ji = { type: ")" }, cn = { type: ",", beforeExpr: !0 }, sn = { type: ";", beforeExpr: !0 }, zn = { type: ":", beforeExpr: !0 }, xr = { type: "." }, Or = { type: "?", beforeExpr: !0 }, fr = { binop: 10, beforeExpr: !0 }, g = { isAssign: !0, beforeExpr: !0 }, F = { isAssign: !0, beforeExpr: !0 }, ue = { postfix: !0, prefix: !0, isUpdate: !0 }, ye = { prefix: !0, beforeExpr: !0 }, Ee = { binop: 1, beforeExpr: !0 }, nt = { binop: 2, beforeExpr: !0 }, gt = { binop: 3, beforeExpr: !0 }, Yt = { binop: 4, beforeExpr: !0 }, qt = { binop: 5, beforeExpr: !0 }, li = { binop: 6, beforeExpr: !0 }, ni = { binop: 7, beforeExpr: !0 }, si = { binop: 8, beforeExpr: !0 }, xn = { binop: 9, prefix: !0, beforeExpr: !0 }, dr = { binop: 10, beforeExpr: !0 };
          O.tokTypes = {
            bracketL: Dn,
            bracketR: Mn,
            braceL: gn,
            braceR: yn,
            parenL: ri,
            parenR: Ji,
            comma: cn,
            semi: sn,
            colon: zn,
            dot: xr,
            question: Or,
            slash: fr,
            eq: g,
            name: Pt,
            eof: zt,
            num: yt,
            regexp: bt,
            string: Rt
          };
          for (var tr in qn)
            O.tokTypes["_" + tr] = qn[tr];
          function Fn(ie) {
            ie = ie.split(" ");
            var oe = "", Me = [];
            e:
              for (var ke = 0; ke < ie.length; ++ke) {
                for (var lt = 0; lt < Me.length; ++lt)
                  if (Me[lt][0].length == ie[ke].length) {
                    Me[lt].push(ie[ke]);
                    continue e;
                  }
                Me.push([ie[ke]]);
              }
            function At(Vt) {
              if (Vt.length == 1)
                return oe += "return str === " + JSON.stringify(Vt[0]) + ";";
              oe += "switch(str){";
              for (var Ei = 0; Ei < Vt.length; ++Ei)
                oe += "case " + JSON.stringify(Vt[Ei]) + ":";
              oe += "return true}return false;";
            }
            if (Me.length > 3) {
              Me.sort(function(Vt, Ei) {
                return Ei.length - Vt.length;
              }), oe += "switch(str.length){";
              for (var ke = 0; ke < Me.length; ++ke) {
                var wt = Me[ke];
                oe += "case " + wt[0].length + ":", At(wt);
              }
              oe += "}";
            } else
              At(ie);
            return new Function("str", oe);
          }
          var sr = Fn("abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile"), wr = Fn("class enum extends super const export import"), gs = Fn("implements interface let package private protected public static yield"), Nr = Fn("eval arguments"), pn = Fn("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this"), ps = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/, ir = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԧԱ-Ֆՙա-ևא-תװ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࢠࢢ-ࢬऄ-हऽॐक़-ॡॱ-ॷॹ-ॿঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-ళవ-హఽౘౙౠౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൠൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛰᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤜᥐ-ᥭᥰ-ᥴᦀ-ᦫᧁ-ᧇᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᳩ-ᳬᳮ-ᳱᳵᳶᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿌ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚗꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꞎꞐ-ꞓꞠ-Ɦꟸ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꪀ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", Ns = "̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ؚؠ-ىٲ-ۓۧ-ۨۻ-ۼܰ-݊ࠀ-ࠔࠛ-ࠣࠥ-ࠧࠩ-࠭ࡀ-ࡗࣤ-ࣾऀ-ःऺ-़ा-ॏ॑-ॗॢ-ॣ०-९ঁ-ঃ়া-ৄেৈৗয়-ৠਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢ-ૣ૦-૯ଁ-ଃ଼ା-ୄେୈୋ-୍ୖୗୟ-ୠ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఁ-ఃె-ైొ-్ౕౖౢ-ౣ౦-౯ಂಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢ-ೣ೦-೯ംഃെ-ൈൗൢ-ൣ൦-൯ංඃ්ා-ුූෘ-ෟෲෳิ-ฺเ-ๅ๐-๙ິ-ູ່-ໍ໐-໙༘༙༠-༩༹༵༷ཁ-ཇཱ-྄྆-྇ྍ-ྗྙ-ྼ࿆က-ဩ၀-၉ၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟ᜎ-ᜐᜠ-ᜰᝀ-ᝐᝲᝳក-ឲ៝០-៩᠋-᠍᠐-᠙ᤠ-ᤫᤰ-᤻ᥑ-ᥭᦰ-ᧀᧈ-ᧉ᧐-᧙ᨀ-ᨕᨠ-ᩓ᩠-᩿᩼-᪉᪐-᪙ᭆ-ᭋ᭐-᭙᭫-᭳᮰-᮹᯦-᯳ᰀ-ᰢ᱀-᱉ᱛ-ᱽ᳐-᳒ᴀ-ᶾḁ-ἕ‌‍‿⁀⁔⃐-⃥⃜⃡-⃰ⶁ-ⶖⷠ-ⷿ〡-〨゙゚Ꙁ-ꙭꙴ-꙽ꚟ꛰-꛱ꟸ-ꠀ꠆ꠋꠣ-ꠧꢀ-ꢁꢴ-꣄꣐-꣙ꣳ-ꣷ꤀-꤉ꤦ-꤭ꤰ-ꥅꦀ-ꦃ꦳-꧀ꨀ-ꨧꩀ-ꩁꩌ-ꩍ꩐-꩙ꩻꫠ-ꫩꫲ-ꫳꯀ-ꯡ꯬꯭꯰-꯹ﬠ-ﬨ︀-️︠-︦︳︴﹍-﹏０-９＿", ns = new RegExp("[" + ir + "]"), $n = new RegExp("[" + ir + Ns + "]"), w = /[\n\r\u2028\u2029]/, P = /\r\n|[\n\r\u2028\u2029]/g, K = O.isIdentifierStart = function(ie) {
            return ie < 65 ? ie === 36 : ie < 91 ? !0 : ie < 97 ? ie === 95 : ie < 123 ? !0 : ie >= 170 && ns.test(String.fromCharCode(ie));
          }, ne = O.isIdentifierChar = function(ie) {
            return ie < 48 ? ie === 36 : ie < 58 ? !0 : ie < 65 ? !1 : ie < 91 ? !0 : ie < 97 ? ie === 95 : ie < 123 ? !0 : ie >= 170 && $n.test(String.fromCharCode(ie));
          };
          function ge() {
            this.line = we, this.column = H - Se;
          }
          function _e() {
            we = 1, H = Se = 0, ve = !0, Je();
          }
          function be(ie, oe) {
            ae = H, Y.locations && (me = new ge()), se = ie, Je(), de = oe, ve = ie.beforeExpr;
          }
          function He() {
            var ie = Y.onComment && Y.locations && new ge(), oe = H, Me = B.indexOf("*/", H += 2);
            if (Me === -1 && Fe(H - 2, "Unterminated comment"), H = Me + 2, Y.locations) {
              P.lastIndex = oe;
              for (var ke; (ke = P.exec(B)) && ke.index < H; )
                ++we, Se = ke.index + ke[0].length;
            }
            Y.onComment && Y.onComment(
              !0,
              B.slice(oe + 2, Me),
              oe,
              H,
              ie,
              Y.locations && new ge()
            );
          }
          function De() {
            for (var ie = H, oe = Y.onComment && Y.locations && new ge(), Me = B.charCodeAt(H += 2); H < z && Me !== 10 && Me !== 13 && Me !== 8232 && Me !== 8233; )
              ++H, Me = B.charCodeAt(H);
            Y.onComment && Y.onComment(
              !1,
              B.slice(ie + 2, H),
              ie,
              H,
              oe,
              Y.locations && new ge()
            );
          }
          function Je() {
            for (; H < z; ) {
              var ie = B.charCodeAt(H);
              if (ie === 32)
                ++H;
              else if (ie === 13) {
                ++H;
                var oe = B.charCodeAt(H);
                oe === 10 && ++H, Y.locations && (++we, Se = H);
              } else if (ie === 10 || ie === 8232 || ie === 8233)
                ++H, Y.locations && (++we, Se = H);
              else if (ie > 8 && ie < 14)
                ++H;
              else if (ie === 47) {
                var oe = B.charCodeAt(H + 1);
                if (oe === 42)
                  He();
                else if (oe === 47)
                  De();
                else
                  break;
              } else if (ie === 160)
                ++H;
              else if (ie >= 5760 && ps.test(String.fromCharCode(ie)))
                ++H;
              else
                break;
            }
          }
          function Ct() {
            var ie = B.charCodeAt(H + 1);
            return ie >= 48 && ie <= 57 ? qi(!0) : (++H, be(xr));
          }
          function Bt() {
            var ie = B.charCodeAt(H + 1);
            return ve ? (++H, ki()) : ie === 61 ? mi(F, 2) : mi(fr, 1);
          }
          function dt() {
            var ie = B.charCodeAt(H + 1);
            return ie === 61 ? mi(F, 2) : mi(dr, 1);
          }
          function Ut(ie) {
            var oe = B.charCodeAt(H + 1);
            return oe === ie ? mi(ie === 124 ? Ee : nt, 2) : oe === 61 ? mi(F, 2) : mi(ie === 124 ? gt : qt, 1);
          }
          function ti() {
            var ie = B.charCodeAt(H + 1);
            return ie === 61 ? mi(F, 2) : mi(Yt, 1);
          }
          function wi(ie) {
            var oe = B.charCodeAt(H + 1);
            return oe === ie ? oe == 45 && B.charCodeAt(H + 2) == 62 && w.test(B.slice(Ge, H)) ? (H += 3, De(), Je(), fn()) : mi(ue, 2) : oe === 61 ? mi(F, 2) : mi(xn, 1);
          }
          function bi(ie) {
            var oe = B.charCodeAt(H + 1), Me = 1;
            return oe === ie ? (Me = ie === 62 && B.charCodeAt(H + 2) === 62 ? 3 : 2, B.charCodeAt(H + Me) === 61 ? mi(F, Me + 1) : mi(si, Me)) : oe == 33 && ie == 60 && B.charCodeAt(H + 2) == 45 && B.charCodeAt(H + 3) == 45 ? (H += 4, De(), Je(), fn()) : (oe === 61 && (Me = B.charCodeAt(H + 2) === 61 ? 3 : 2), mi(ni, Me));
          }
          function Cn(ie) {
            var oe = B.charCodeAt(H + 1);
            return oe === 61 ? mi(li, B.charCodeAt(H + 2) === 61 ? 3 : 2) : mi(ie === 61 ? g : ye, 1);
          }
          function mn(ie) {
            switch (ie) {
              case 46:
                return Ct();
              case 40:
                return ++H, be(ri);
              case 41:
                return ++H, be(Ji);
              case 59:
                return ++H, be(sn);
              case 44:
                return ++H, be(cn);
              case 91:
                return ++H, be(Dn);
              case 93:
                return ++H, be(Mn);
              case 123:
                return ++H, be(gn);
              case 125:
                return ++H, be(yn);
              case 58:
                return ++H, be(zn);
              case 63:
                return ++H, be(Or);
              case 48:
                var oe = B.charCodeAt(H + 1);
                if (oe === 120 || oe === 88)
                  return Oi();
              case 49:
              case 50:
              case 51:
              case 52:
              case 53:
              case 54:
              case 55:
              case 56:
              case 57:
                return qi(!1);
              case 34:
              case 39:
                return rs(ie);
              case 47:
                return Bt();
              case 37:
              case 42:
                return dt();
              case 124:
              case 38:
                return Ut(ie);
              case 94:
                return ti();
              case 43:
              case 45:
                return wi(ie);
              case 60:
              case 62:
                return bi(ie);
              case 61:
              case 33:
                return Cn(ie);
              case 126:
                return mi(ye, 1);
            }
            return !1;
          }
          function fn(ie) {
            if (ie ? H = te + 1 : te = H, Y.locations && (le = new ge()), ie)
              return ki();
            if (H >= z)
              return be(zt);
            var oe = B.charCodeAt(H);
            if (K(oe) || oe === 92)
              return Hn();
            var Me = mn(oe);
            if (Me === !1) {
              var ke = String.fromCharCode(oe);
              if (ke === "\\" || ns.test(ke))
                return Hn();
              Fe(H, "Unexpected character '" + ke + "'");
            }
            return Me;
          }
          function mi(ie, oe) {
            var Me = B.slice(H, H + oe);
            H += oe, be(ie, Me);
          }
          function ki() {
            for (var lt = "", ie, oe, Me = H; ; ) {
              H >= z && Fe(Me, "Unterminated regular expression");
              var ke = B.charAt(H);
              if (w.test(ke) && Fe(Me, "Unterminated regular expression"), ie)
                ie = !1;
              else {
                if (ke === "[")
                  oe = !0;
                else if (ke === "]" && oe)
                  oe = !1;
                else if (ke === "/" && !oe)
                  break;
                ie = ke === "\\";
              }
              ++H;
            }
            var lt = B.slice(Me, H);
            ++H;
            var At = gr();
            At && !/^[gmsiy]*$/.test(At) && Fe(Me, "Invalid regexp flag");
            try {
              var wt = new RegExp(lt, At);
            } catch (Vt) {
              Vt instanceof SyntaxError && Fe(Me, Vt.message), Fe(Vt);
            }
            return be(bt, wt);
          }
          function En(ie, oe) {
            for (var Me = H, ke = 0, lt = 0, At = oe ?? 1 / 0; lt < At; ++lt) {
              var wt = B.charCodeAt(H), Vt;
              if (wt >= 97 ? Vt = wt - 97 + 10 : wt >= 65 ? Vt = wt - 65 + 10 : wt >= 48 && wt <= 57 ? Vt = wt - 48 : Vt = 1 / 0, Vt >= ie)
                break;
              ++H, ke = ke * ie + Vt;
            }
            return H === Me || oe != null && H - Me !== oe ? null : ke;
          }
          function Oi() {
            H += 2;
            var ie = En(16);
            return ie == null && Fe(te + 2, "Expected hexadecimal number"), K(B.charCodeAt(H)) && Fe(H, "Identifier directly after number"), be(yt, ie);
          }
          function qi(ie) {
            var oe = H, Me = !1, ke = B.charCodeAt(H) === 48;
            !ie && En(10) === null && Fe(oe, "Invalid number"), B.charCodeAt(H) === 46 && (++H, En(10), Me = !0);
            var lt = B.charCodeAt(H);
            (lt === 69 || lt === 101) && (lt = B.charCodeAt(++H), (lt === 43 || lt === 45) && ++H, En(10) === null && Fe(oe, "Invalid number"), Me = !0), K(B.charCodeAt(H)) && Fe(H, "Identifier directly after number");
            var At = B.slice(oe, H), wt;
            return Me ? wt = parseFloat(At) : !ke || At.length === 1 ? wt = parseInt(At, 10) : /[89]/.test(At) || Re ? Fe(oe, "Invalid number") : wt = parseInt(At, 8), be(yt, wt);
          }
          function rs(ie) {
            H++;
            for (var oe = ""; ; ) {
              H >= z && Fe(te, "Unterminated string constant");
              var Me = B.charCodeAt(H);
              if (Me === ie)
                return ++H, be(Rt, oe);
              if (Me === 92) {
                Me = B.charCodeAt(++H);
                var ke = /^[0-7]+/.exec(B.slice(H, H + 3));
                for (ke && (ke = ke[0]); ke && parseInt(ke, 8) > 255; )
                  ke = ke.slice(0, -1);
                if (ke === "0" && (ke = null), ++H, ke)
                  Re && Fe(H - 2, "Octal literal in strict mode"), oe += String.fromCharCode(parseInt(ke, 8)), H += ke.length - 1;
                else
                  switch (Me) {
                    case 110:
                      oe += `
`;
                      break;
                    case 114:
                      oe += "\r";
                      break;
                    case 120:
                      oe += String.fromCharCode(ar(2));
                      break;
                    case 117:
                      oe += String.fromCharCode(ar(4));
                      break;
                    case 85:
                      oe += String.fromCharCode(ar(8));
                      break;
                    case 116:
                      oe += "	";
                      break;
                    case 98:
                      oe += "\b";
                      break;
                    case 118:
                      oe += "\v";
                      break;
                    case 102:
                      oe += "\f";
                      break;
                    case 48:
                      oe += "\0";
                      break;
                    case 13:
                      B.charCodeAt(H) === 10 && ++H;
                    case 10:
                      Y.locations && (Se = H, ++we);
                      break;
                    default:
                      oe += String.fromCharCode(Me);
                      break;
                  }
              } else
                (Me === 13 || Me === 10 || Me === 8232 || Me === 8233) && Fe(te, "Unterminated string constant"), oe += String.fromCharCode(Me), ++H;
            }
          }
          function ar(ie) {
            var oe = En(16, ie);
            return oe === null && Fe(te, "Bad character escape sequence"), oe;
          }
          var _n;
          function gr() {
            _n = !1;
            for (var ie, oe = !0, Me = H; ; ) {
              var ke = B.charCodeAt(H);
              if (ne(ke))
                _n && (ie += B.charAt(H)), ++H;
              else if (ke === 92) {
                _n || (ie = B.slice(Me, H)), _n = !0, B.charCodeAt(++H) != 117 && Fe(H, "Expecting Unicode escape sequence \\uXXXX"), ++H;
                var lt = ar(4), At = String.fromCharCode(lt);
                At || Fe(H - 1, "Invalid Unicode escape"), (oe ? K(lt) : ne(lt)) || Fe(H - 4, "Invalid Unicode escape"), ie += At;
              } else
                break;
              oe = !1;
            }
            return _n ? ie : B.slice(Me, H);
          }
          function Hn() {
            var ie = gr(), oe = Pt;
            return !_n && pn(ie) && (oe = qn[ie]), be(oe, ie);
          }
          function ei() {
            Ae = te, Ge = ae, Qe = me, fn();
          }
          function Xn(ie) {
            if (Re = ie, H = te, Y.locations)
              for (; H < Se; )
                Se = B.lastIndexOf(`
`, Se - 2) + 1, --we;
            Je(), fn();
          }
          function In() {
            this.type = null, this.start = te, this.end = null;
          }
          function Rr() {
            this.start = le, this.end = null, C !== null && (this.source = C);
          }
          function Si() {
            var ie = new In();
            return Y.locations && (ie.loc = new Rr()), Y.directSourceFile && (ie.sourceFile = Y.directSourceFile), Y.ranges && (ie.range = [te, 0]), ie;
          }
          function an(ie) {
            var oe = new In();
            return oe.start = ie.start, Y.locations && (oe.loc = new Rr(), oe.loc.start = ie.loc.start), Y.ranges && (oe.range = [ie.range[0], 0]), oe;
          }
          function jt(ie, oe) {
            return ie.type = oe, ie.end = Ge, Y.locations && (ie.loc.end = Qe), Y.ranges && (ie.range[1] = Ge), ie;
          }
          function Dr(ie) {
            return Y.ecmaVersion >= 5 && ie.type === "ExpressionStatement" && ie.expression.type === "Literal" && ie.expression.value === "use strict";
          }
          function hi(ie) {
            if (se === ie)
              return ei(), !0;
          }
          function Ni() {
            return !Y.strictSemicolons && (se === zt || se === yn || w.test(B.slice(Ge, te)));
          }
          function An() {
            !hi(sn) && !Ni() && dn();
          }
          function ui(ie) {
            se === ie ? ei() : dn();
          }
          function dn() {
            Fe(te, "Unexpected token");
          }
          function zr(ie) {
            ie.type !== "Identifier" && ie.type !== "MemberExpression" && Fe(ie.start, "Assigning to rvalue"), Re && ie.type === "Identifier" && Nr(ie.name) && Fe(ie.start, "Assigning to " + ie.name + " in strict mode");
          }
          function $s(ie) {
            Ae = Ge = H, Y.locations && (Qe = new ge()), st = Re = null, mt = [], fn();
            var oe = ie || Si(), Me = !0;
            for (ie || (oe.body = []); se !== zt; ) {
              var ke = un();
              oe.body.push(ke), Me && Dr(ke) && Xn(!0), Me = !1;
            }
            return jt(oe, "Program");
          }
          var jr = { kind: "loop" }, Kn = { kind: "switch" };
          function un() {
            (se === fr || se === F && de == "/=") && fn(!0);
            var ie = se, oe = Si();
            switch (ie) {
              case Wt:
              case yi:
                ei();
                var Me = ie === Wt;
                hi(sn) || Ni() ? oe.label = null : se !== Pt ? dn() : (oe.label = Ye(), An());
                for (var ke = 0; ke < mt.length; ++ke) {
                  var lt = mt[ke];
                  if ((oe.label == null || lt.name === oe.label.name) && (lt.kind != null && (Me || lt.kind === "loop") || oe.label && Me))
                    break;
                }
                return ke === mt.length && Fe(oe.start, "Unsyntactic " + ie.keyword), jt(oe, Me ? "BreakStatement" : "ContinueStatement");
              case Ai:
                return ei(), An(), jt(oe, "DebuggerStatement");
              case kt:
                return ei(), mt.push(jr), oe.body = un(), mt.pop(), ui(Fi), oe.test = Pn(), An(), jt(oe, "DoWhileStatement");
              case xi:
                if (ei(), mt.push(jr), ui(ri), se === sn)
                  return or(oe, null);
                if (se === ln) {
                  var At = Si();
                  return ei(), pr(At, !0), jt(At, "VariableDeclaration"), At.declarations.length === 1 && hi(Rn) ? jn(oe, At) : or(oe, At);
                }
                var At = Ui(!1, !0);
                return hi(Rn) ? (zr(At), jn(oe, At)) : or(oe, At);
              case tn:
                return ei(), Be(oe, !0);
              case Hi:
                return ei(), oe.test = Pn(), oe.consequent = un(), oe.alternate = hi(fi) ? un() : null, jt(oe, "IfStatement");
              case Zi:
                return !st && !Y.allowReturnOutsideFunction && Fe(te, "'return' outside of function"), ei(), hi(sn) || Ni() ? oe.argument = null : (oe.argument = Ui(), An()), jt(oe, "ReturnStatement");
              case Xi:
                ei(), oe.discriminant = Pn(), oe.cases = [], ui(gn), mt.push(Kn);
                for (var wt, Vt; se != yn; )
                  if (se === Ft || se === pi) {
                    var Ei = se === Ft;
                    wt && jt(wt, "SwitchCase"), oe.cases.push(wt = Si()), wt.consequent = [], ei(), Ei ? wt.test = Ui() : (Vt && Fe(Ae, "Multiple default clauses"), Vt = !0, wt.test = null), ui(zn);
                  } else
                    wt || dn(), wt.consequent.push(un());
                return wt && jt(wt, "SwitchCase"), ei(), mt.pop(), jt(oe, "SwitchStatement");
              case ji:
                return ei(), w.test(B.slice(Ge, te)) && Fe(Ge, "Illegal newline after throw"), oe.argument = Ui(), An(), jt(oe, "ThrowStatement");
              case Ki:
                if (ei(), oe.block = Jn(), oe.handler = null, se === Mi) {
                  var Qi = Si();
                  ei(), ui(ri), Qi.param = Ye(), Re && Nr(Qi.param.name) && Fe(Qi.param.start, "Binding " + Qi.param.name + " in strict mode"), ui(Ji), Qi.guard = null, Qi.body = Jn(), oe.handler = jt(Qi, "CatchClause");
                }
                return oe.guardedHandlers = at, oe.finalizer = hi(Ti) ? Jn() : null, !oe.handler && !oe.finalizer && Fe(oe.start, "Missing catch or finally clause"), jt(oe, "TryStatement");
              case ln:
                return ei(), pr(oe), An(), jt(oe, "VariableDeclaration");
              case Fi:
                return ei(), oe.test = Pn(), mt.push(jr), oe.body = un(), mt.pop(), jt(oe, "WhileStatement");
              case hn:
                return Re && Fe(te, "'with' in strict mode"), ei(), oe.object = Pn(), oe.body = un(), jt(oe, "WithStatement");
              case gn:
                return Jn();
              case sn:
                return ei(), jt(oe, "EmptyStatement");
              default:
                var vn = de, wn = Ui();
                if (ie === Pt && wn.type === "Identifier" && hi(zn)) {
                  for (var ke = 0; ke < mt.length; ++ke)
                    mt[ke].name === vn && Fe(wn.start, "Label '" + vn + "' is already declared");
                  var mr = se.isLoop ? "loop" : se === Xi ? "switch" : null;
                  return mt.push({ name: vn, kind: mr }), oe.body = un(), mt.pop(), oe.label = wn, jt(oe, "LabeledStatement");
                } else
                  return oe.expression = wn, An(), jt(oe, "ExpressionStatement");
            }
          }
          function Pn() {
            ui(ri);
            var ie = Ui();
            return ui(Ji), ie;
          }
          function Jn(ie) {
            var oe = Si(), Me = !0, ke = !1, lt;
            for (oe.body = [], ui(gn); !hi(yn); ) {
              var At = un();
              oe.body.push(At), Me && ie && Dr(At) && (lt = ke, Xn(ke = !0)), Me = !1;
            }
            return ke && !lt && Xn(!1), jt(oe, "BlockStatement");
          }
          function or(ie, oe) {
            return ie.init = oe, ui(sn), ie.test = se === sn ? null : Ui(), ui(sn), ie.update = se === Ji ? null : Ui(), ui(Ji), ie.body = un(), mt.pop(), jt(ie, "ForStatement");
          }
          function jn(ie, oe) {
            return ie.left = oe, ie.right = Ui(), ui(Ji), ie.body = un(), mt.pop(), jt(ie, "ForInStatement");
          }
          function pr(ie, oe) {
            for (ie.declarations = [], ie.kind = "var"; ; ) {
              var Me = Si();
              if (Me.id = Ye(), Re && Nr(Me.id.name) && Fe(Me.id.start, "Binding " + Me.id.name + " in strict mode"), Me.init = hi(g) ? Ui(!0, oe) : null, ie.declarations.push(jt(Me, "VariableDeclarator")), !hi(cn))
                break;
            }
            return ie;
          }
          function Ui(ie, oe) {
            var Me = ss(oe);
            if (!ie && se === cn) {
              var ke = an(Me);
              for (ke.expressions = [Me]; hi(cn); )
                ke.expressions.push(ss(oe));
              return jt(ke, "SequenceExpression");
            }
            return Me;
          }
          function ss(ie) {
            var oe = ms(ie);
            if (se.isAssign) {
              var Me = an(oe);
              return Me.operator = de, Me.left = oe, ei(), Me.right = ss(ie), zr(oe), jt(Me, "AssignmentExpression");
            }
            return oe;
          }
          function ms(ie) {
            var oe = Sr(ie);
            if (hi(Or)) {
              var Me = an(oe);
              return Me.test = oe, Me.consequent = Ui(!0), ui(zn), Me.alternate = Ui(!0, ie), jt(Me, "ConditionalExpression");
            }
            return oe;
          }
          function Sr(ie) {
            return Tn(Wr(), -1, ie);
          }
          function Tn(ie, oe, Me) {
            var ke = se.binop;
            if (ke != null && (!Me || se !== Rn) && ke > oe) {
              var lt = an(ie);
              lt.left = ie, lt.operator = de;
              var At = se;
              ei(), lt.right = Tn(Wr(), ke, Me);
              var wt = jt(lt, At === Ee || At === nt ? "LogicalExpression" : "BinaryExpression");
              return Tn(wt, oe, Me);
            }
            return ie;
          }
          function Wr() {
            if (se.prefix) {
              var ie = Si(), oe = se.isUpdate;
              return ie.operator = de, ie.prefix = !0, ve = !0, ei(), ie.argument = Wr(), oe ? zr(ie.argument) : Re && ie.operator === "delete" && ie.argument.type === "Identifier" && Fe(ie.start, "Deleting local variable in strict mode"), jt(ie, oe ? "UpdateExpression" : "UnaryExpression");
            }
            for (var Me = Ms(); se.postfix && !Ni(); ) {
              var ie = an(Me);
              ie.operator = de, ie.prefix = !1, ie.argument = Me, zr(Me), ei(), Me = jt(ie, "UpdateExpression");
            }
            return Me;
          }
          function Ms() {
            return lr(Pe());
          }
          function lr(ie, oe) {
            if (hi(xr)) {
              var Me = an(ie);
              return Me.object = ie, Me.property = Ye(!0), Me.computed = !1, lr(jt(Me, "MemberExpression"), oe);
            } else if (hi(Dn)) {
              var Me = an(ie);
              return Me.object = ie, Me.property = Ui(), Me.computed = !0, ui(Mn), lr(jt(Me, "MemberExpression"), oe);
            } else if (!oe && hi(ri)) {
              var Me = an(ie);
              return Me.callee = ie, Me.arguments = We(Ji, !1), lr(jt(Me, "CallExpression"), oe);
            } else
              return ie;
          }
          function Pe() {
            switch (se) {
              case Er:
                var ke = Si();
                return ei(), jt(ke, "ThisExpression");
              case Pt:
                return Ye();
              case yt:
              case Rt:
              case bt:
                var ke = Si();
                return ke.value = de, ke.raw = B.slice(te, ae), ei(), jt(ke, "Literal");
              case Ir:
              case Nn:
              case Pr:
                var ke = Si();
                return ke.value = se.atomValue, ke.raw = se.keyword, ei(), jt(ke, "Literal");
              case ri:
                var ie = le, oe = te;
                ei();
                var Me = Ui();
                return Me.start = oe, Me.end = ae, Y.locations && (Me.loc.start = ie, Me.loc.end = me), Y.ranges && (Me.range = [oe, ae]), ui(Ji), Me;
              case Dn:
                var ke = Si();
                return ei(), ke.elements = We(Mn, !0, !0), jt(ke, "ArrayExpression");
              case gn:
                return ct();
              case tn:
                var ke = Si();
                return ei(), Be(ke, !1);
              case kr:
                return Ke();
              default:
                dn();
            }
          }
          function Ke() {
            var ie = Si();
            return ei(), ie.callee = lr(Pe(), !0), hi(ri) ? ie.arguments = We(Ji, !1) : ie.arguments = at, jt(ie, "NewExpression");
          }
          function ct() {
            var ie = Si(), oe = !0, Me = !1;
            for (ie.properties = [], ei(); !hi(yn); ) {
              if (oe)
                oe = !1;
              else if (ui(cn), Y.allowTrailingCommas && hi(yn))
                break;
              var ke = { key: vt() }, lt = !1, At;
              if (hi(zn) ? (ke.value = Ui(!0), At = ke.kind = "init") : Y.ecmaVersion >= 5 && ke.key.type === "Identifier" && (ke.key.name === "get" || ke.key.name === "set") ? (lt = Me = !0, At = ke.kind = ke.key.name, ke.key = vt(), se !== ri && dn(), ke.value = Be(Si(), !1)) : dn(), ke.key.type === "Identifier" && (Re || Me))
                for (var wt = 0; wt < ie.properties.length; ++wt) {
                  var Vt = ie.properties[wt];
                  if (Vt.key.name === ke.key.name) {
                    var Ei = At == Vt.kind || lt && Vt.kind === "init" || At === "init" && (Vt.kind === "get" || Vt.kind === "set");
                    Ei && !Re && At === "init" && Vt.kind === "init" && (Ei = !1), Ei && Fe(ke.key.start, "Redefinition of property");
                  }
                }
              ie.properties.push(ke);
            }
            return jt(ie, "ObjectExpression");
          }
          function vt() {
            return se === yt || se === Rt ? Pe() : Ye(!0);
          }
          function Be(ie, oe) {
            se === Pt ? ie.id = Ye() : oe ? dn() : ie.id = null, ie.params = [];
            var Me = !0;
            for (ui(ri); !hi(Ji); )
              Me ? Me = !1 : ui(cn), ie.params.push(Ye());
            var ke = st, lt = mt;
            if (st = !0, mt = [], ie.body = Jn(!0), st = ke, mt = lt, Re || ie.body.body.length && Dr(ie.body.body[0]))
              for (var At = ie.id ? -1 : 0; At < ie.params.length; ++At) {
                var wt = At < 0 ? ie.id : ie.params[At];
                if ((gs(wt.name) || Nr(wt.name)) && Fe(wt.start, "Defining '" + wt.name + "' in strict mode"), At >= 0)
                  for (var Vt = 0; Vt < At; ++Vt)
                    wt.name === ie.params[Vt].name && Fe(wt.start, "Argument name clash in strict mode");
              }
            return jt(ie, oe ? "FunctionDeclaration" : "FunctionExpression");
          }
          function We(ie, oe, Me) {
            for (var ke = [], lt = !0; !hi(ie); ) {
              if (lt)
                lt = !1;
              else if (ui(cn), oe && Y.allowTrailingCommas && hi(ie))
                break;
              Me && se === cn ? ke.push(null) : ke.push(Ui(!0));
            }
            return ke;
          }
          function Ye(ie) {
            var oe = Si();
            return ie && Y.forbidReserved == "everywhere" && (ie = !1), se === Pt ? (!ie && (Y.forbidReserved && (Y.ecmaVersion === 3 ? sr : wr)(de) || Re && gs(de)) && B.slice(te, ae).indexOf("\\") == -1 && Fe(te, "The keyword '" + de + "' is reserved"), oe.name = de) : ie && se.keyword ? oe.name = se.keyword : dn(), ve = !1, ei(), jt(oe, "Identifier");
          }
        }), r.version || (r = null);
      }
      function u(O, Y) {
        return (i.acorn || r).parse(O, Y);
      }
      var d = {
        "+": "__add",
        "-": "__subtract",
        "*": "__multiply",
        "/": "__divide",
        "%": "__modulo",
        "==": "__equals",
        "!=": "__equals"
      }, p = {
        "-": "__negate",
        "+": "__self"
      }, m = o.each(
        ["add", "subtract", "multiply", "divide", "modulo", "equals", "negate"],
        function(O) {
          this["__" + O] = "#" + O;
        },
        {
          __self: function() {
            return this;
          }
        }
      );
      M.inject(m), U.inject(m), Tt.inject(m);
      function y(O, Y, B) {
        var z = d[Y];
        if (O && O[z]) {
          var C = O[z](B);
          return Y === "!=" ? !C : C;
        }
        switch (Y) {
          case "+":
            return O + B;
          case "-":
            return O - B;
          case "*":
            return O * B;
          case "/":
            return O / B;
          case "%":
            return O % B;
          case "==":
            return O == B;
          case "!=":
            return O != B;
        }
      }
      function S(O, Y) {
        var B = p[O];
        if (Y && Y[B])
          return Y[B]();
        switch (O) {
          case "+":
            return +Y;
          case "-":
            return -Y;
        }
      }
      function L(O, Y) {
        if (!O)
          return "";
        Y = Y || {};
        var B = [];
        function z(Re) {
          for (var Fe = 0, at = B.length; Fe < at; Fe++) {
            var yt = B[Fe];
            if (yt[0] >= Re)
              break;
            Re += yt[1];
          }
          return Re;
        }
        function C(Re) {
          return O.substring(
            z(Re.range[0]),
            z(Re.range[1])
          );
        }
        function N(Re, Fe) {
          return O.substring(
            z(Re.range[1]),
            z(Fe.range[0])
          );
        }
        function j(Re, Fe) {
          for (var at = z(Re.range[0]), yt = z(Re.range[1]), bt = 0, Rt = B.length - 1; Rt >= 0; Rt--)
            if (at > B[Rt][0]) {
              bt = Rt + 1;
              break;
            }
          B.splice(bt, 0, [at, Fe.length - yt + at]), O = O.substring(0, at) + Fe + O.substring(yt);
        }
        function q(Re, Fe) {
          switch (Re.type) {
            case "UnaryExpression":
              if (Re.operator in p && Re.argument.type !== "Literal") {
                var at = C(Re.argument);
                j(Re, '$__("' + Re.operator + '", ' + at + ")");
              }
              break;
            case "BinaryExpression":
              if (Re.operator in d && Re.left.type !== "Literal") {
                var yt = C(Re.left), bt = C(Re.right), Rt = N(Re.left, Re.right), Pt = Re.operator;
                j(Re, "__$__(" + yt + "," + Rt.replace(
                  new RegExp("\\" + Pt),
                  '"' + Pt + '"'
                ) + ", " + bt + ")");
              }
              break;
            case "UpdateExpression":
            case "AssignmentExpression":
              var zt = Fe && Fe.type;
              if (!(zt === "ForStatement" || zt === "BinaryExpression" && /^[=!<>]/.test(Fe.operator) || zt === "MemberExpression" && Fe.computed)) {
                if (Re.type === "UpdateExpression") {
                  var at = C(Re.argument), Wt = "__$__(" + at + ', "' + Re.operator[0] + '", 1)', Ft = at + " = " + Wt;
                  Re.prefix ? Ft = "(" + Ft + ")" : (zt === "AssignmentExpression" || zt === "VariableDeclarator" || zt === "BinaryExpression") && (C(Fe.left || Fe.id) === at && (Ft = Wt), Ft = at + "; " + Ft), j(Re, Ft);
                } else if (/^.=$/.test(Re.operator) && Re.left.type !== "Literal") {
                  var yt = C(Re.left), bt = C(Re.right), Wt = yt + " = __$__(" + yt + ', "' + Re.operator[0] + '", ' + bt + ")";
                  j(Re, /^\(.*\)$/.test(C(Re)) ? "(" + Wt + ")" : Wt);
                }
              }
              break;
          }
        }
        function H(Re) {
          switch (Re.type) {
            case "ExportDefaultDeclaration":
              j({
                range: [Re.start, Re.declaration.start]
              }, "module.exports = ");
              break;
            case "ExportNamedDeclaration":
              var Fe = Re.declaration, at = Re.specifiers;
              if (Fe) {
                var yt = Fe.declarations;
                yt && (yt.forEach(function(Rt) {
                  j(Rt, "module.exports." + C(Rt));
                }), j({
                  range: [
                    Re.start,
                    Fe.start + Fe.kind.length
                  ]
                }, ""));
              } else if (at) {
                var bt = at.map(function(Rt) {
                  var Pt = C(Rt);
                  return "module.exports." + Pt + " = " + Pt + "; ";
                }).join("");
                bt && j(Re, bt);
              }
              break;
          }
        }
        function te(Re, Fe, at) {
          if (Re) {
            for (var yt in Re)
              if (yt !== "range" && yt !== "loc") {
                var bt = Re[yt];
                if (Array.isArray(bt))
                  for (var Rt = 0, Pt = bt.length; Rt < Pt; Rt++)
                    te(bt[Rt], Re, at);
                else
                  bt && typeof bt == "object" && te(bt, Re, at);
              }
            at.operatorOverloading !== !1 && q(Re, Fe), at.moduleExports !== !1 && H(Re);
          }
        }
        function ae(Re) {
          var Fe = "", at = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
          for (Re = (Math.abs(Re) << 1) + (Re < 0 ? 1 : 0); Re || !Fe; ) {
            var yt = Re & 31;
            Re >>= 5, Re && (yt |= 32), Fe += at[yt];
          }
          return Fe;
        }
        var le = Y.url || "", me = Y.sourceMaps, se = Y.paperFeatures || {}, de = Y.source || O, ve = Y.offset || 0, we = Ve.agent, Se = we.versionNumber, Ae = !1, Ge = /\r\n|\n|\r/mg, Qe;
        if (me && (we.chrome && Se >= 30 || we.webkit && Se >= 537.76 || we.firefox && Se >= 23 || we.node)) {
          if (we.node)
            ve -= 2;
          else if (n && le && !n.location.href.indexOf(le)) {
            var st = a.getElementsByTagName("html")[0].innerHTML;
            ve = st.substr(0, st.indexOf(O) + 1).match(
              Ge
            ).length + 1;
          }
          Ae = ve > 0 && !(we.chrome && Se >= 36 || we.safari && Se >= 600 || we.firefox && Se >= 40 || we.node);
          var mt = ["AA" + ae(Ae ? 0 : ve) + "A"];
          mt.length = (O.match(Ge) || []).length + 1 + (Ae ? ve : 0), Qe = {
            version: 3,
            file: le,
            names: [],
            mappings: mt.join(";AACA"),
            sourceRoot: "",
            sources: [le],
            sourcesContent: [de]
          };
        }
        return (se.operatorOverloading !== !1 || se.moduleExports !== !1) && te(u(O, {
          ranges: !0,
          preserveParens: !0,
          sourceType: "module"
        }), null, se), Qe && (Ae && (O = new Array(ve + 1).join(`
`) + O), /^(inline|both)$/.test(me) && (O += `
//# sourceMappingURL=data:application/json;base64,` + e.btoa(unescape(encodeURIComponent(
          JSON.stringify(Qe)
        )))), O += `
//# sourceURL=` + (le || "paperscript")), {
          url: le,
          source: de,
          code: O,
          map: Qe
        };
      }
      function E(O, Y, B) {
        Ve = Y;
        var z = Y.getView(), C = /\btool\.\w+|\s+on(?:Key|Mouse)(?:Up|Down|Move|Drag)\b/.test(O) && !/\bnew\s+Tool\b/.test(O) ? new Ie() : null, N = C ? C._events : [], j = ["onFrame", "onResize"].concat(N), q = [], H = [], te, ae = typeof O == "object" ? O : L(O, B);
        O = ae.code;
        function le(Se, Ae) {
          for (var Ge in Se)
            (Ae || !/^_/.test(Ge)) && new RegExp("([\\b\\s\\W]|^)" + Ge.replace(/\$/g, "\\$") + "\\b").test(O) && (q.push(Ge), H.push(Se[Ge]));
        }
        le(
          { __$__: y, $__: S, paper: Y, tool: C },
          !0
        ), le(Y), O = "var module = { exports: {} }; " + O;
        var ve = o.each(j, function(Se) {
          new RegExp("\\s+" + Se + "\\b").test(O) && (q.push(Se), this.push("module.exports." + Se + " = " + Se + ";"));
        }, []).join(`
`);
        ve && (O += `
` + ve), O += `
return module.exports;`;
        var me = Ve.agent;
        if (a && (me.chrome || me.firefox && me.versionNumber < 40)) {
          var se = a.createElement("script"), de = a.head || a.getElementsByTagName("head")[0];
          me.firefox && (O = `
` + O), se.appendChild(a.createTextNode(
            "document.__paperscript__ = function(" + q + ") {" + O + `
}`
          )), de.appendChild(se), te = a.__paperscript__, delete a.__paperscript__, de.removeChild(se);
        } else
          te = Function(q, O);
        var ve = te && te.apply(Y, H), we = ve || {};
        return o.each(N, function(Se) {
          var Ae = we[Se];
          Ae && (C[Se] = Ae);
        }), z && (we.onResize && z.setOnResize(we.onResize), z.emit("resize", {
          size: z.size,
          delta: new M()
        }), we.onFrame && z.setOnFrame(we.onFrame), z.requestUpdate()), ve;
      }
      function A(O) {
        if (/^text\/(?:x-|)paperscript$/.test(O.type) && f.getAttribute(O, "ignore") !== "true") {
          var Y = f.getAttribute(O, "canvas"), B = a.getElementById(Y), z = O.src || O.getAttribute("data-src"), C = f.hasAttribute(O, "async"), N = "data-paper-scope";
          if (!B)
            throw new Error('Unable to find canvas with id "' + Y + '"');
          var j = f.get(B.getAttribute(N)) || new f().setup(B);
          return B.setAttribute(N, j._id), z ? Et.request({
            url: z,
            async: C,
            mimeType: "text/plain",
            onLoad: function(q) {
              E(q, j, z);
            }
          }) : E(O.innerHTML, j, O.baseURI), O.setAttribute("data-paper-ignore", "true"), j;
        }
      }
      function T() {
        o.each(
          a && a.getElementsByTagName("script"),
          A
        );
      }
      function G(O) {
        return O ? A(O) : T();
      }
      return n && (a.readyState === "complete" ? setTimeout(T) : Jt.add(n, { load: T })), {
        compile: L,
        execute: E,
        load: G,
        parse: u,
        calculateBinary: y,
        calculateUnary: S
      };
    }).call(this);
    var Ve = new (f.inject(o.exports, {
      Base: o,
      Numerical: I,
      Key: Lt,
      DomEvent: Jt,
      DomElement: Zt,
      document: a,
      window: n,
      Symbol: Te,
      PlacedSymbol: pt
    }))();
    return Ve.agent.node && _f(Ve), typeof t == "function" && t.amd ? t("paper", Ve) : b && (b.exports = Ve), Ve;
  }).call(Uy, typeof self == "object" ? self : null);
})(ad);
var Wy = ad.exports;
const vf = /* @__PURE__ */ Vy(Wy);
class Zy {
  constructor() {
    Ko(this, "_paperScope", new vf.PaperScope()), Ko(this, "_baseMaterial", null), Ko(this, "_borderMaterial", null), Ko(this, "transparentMaterial", null);
    const e = document.createElement("canvas");
    e.width = 1, e.height = 1, this._paperScope.setup(new vf.Size(1, 1));
  }
  async generatePreview3D(e, t) {
    if (!e.columns || isNaN(e.columns) || e.columns < 1 || e.rows < 1 || !e.rows || isNaN(e.rows))
      throw new Error("Invalid columns or rows value. Columns and rows must be greater than 0 and must be a number.");
    console.log("Generating 3D preview for resizable canvas...", e);
    const { textureWidth: n, textureHeight: a } = await this.prepareMaterials(e, t), o = e.shape === "ellipse" ? await this.generateEllipseMesh(e, t, n, a) : this.buildRectangleMeshGroups(e, t, n, a);
    if (!o)
      return null;
    const {
      bordersList: h,
      backsList: f,
      frontsList: v,
      texturedBordersList: x,
      texturedBacksList: k,
      texturedFrontsList: I
    } = o, V = new BABYLON.Mesh("groupMesh", t), M = BABYLON.Mesh.MergeMeshes(h, !0, !0, void 0, !1, !1), W = BABYLON.Mesh.MergeMeshes(f, !0, !0, void 0, !1, !1), U = BABYLON.Mesh.MergeMeshes(v, !0, !0, void 0, !1, !1), Q = BABYLON.Mesh.MergeMeshes(x, !0, !0, void 0, !1, !1), D = BABYLON.Mesh.MergeMeshes(k, !0, !0, void 0, !1, !1), ee = BABYLON.Mesh.MergeMeshes(I, !0, !0, void 0, !1, !1);
    if (!M || !W || !U || !Q || !D || !ee)
      return null;
    M.material = this.transparentMaterial, W.material = this.transparentMaterial, U.material = this.transparentMaterial, Q.material = this._borderMaterial, D.material = this._baseMaterial, ee.material = this._baseMaterial, M.parent = V, W.parent = V, U.parent = V, Q.parent = V, D.parent = V, ee.parent = V, M.name = "borders", W.name = "back", U.name = "front", Q.name = "texturedBorders", D.name = "texturedBack", ee.name = "texturedFront";
    const J = BABYLON.SceneSerializer.SerializeMesh(V, !1, !0);
    return V.dispose(), [...h, ...f, ...v, ...x, ...k, ...I].forEach(
      (he) => he && !he.isDisposed() && he.dispose()
    ), J;
  }
  // Common material preparation
  async prepareMaterials(e, t) {
    this._baseMaterial || (this._baseMaterial = new BABYLON.PBRMaterial("baseMaterial", t)), this._borderMaterial || (this._borderMaterial = new BABYLON.PBRMaterial("borderMaterial", t)), this.transparentMaterial || (this.transparentMaterial = new BABYLON.StandardMaterial("transparentMaterial", t)), this._baseMaterial.albedoColor = BABYLON.Color3.FromHexString(e.backgroundColor ?? "#FFFFFF"), this._baseMaterial.metallic = 0, this._baseMaterial.roughness = 0.5, this._borderMaterial.albedoColor = BABYLON.Color3.FromHexString(e.borderColor ?? e.backgroundColor ?? "#000000"), this._borderMaterial.metallic = 0, this._borderMaterial.roughness = 0.5, this.transparentMaterial.alpha = 0, this.transparentMaterial.backFaceCulling = !0, this.transparentMaterial.diffuseColor = BABYLON.Color3.FromHexString("#FF0000");
    let n, a;
    const o = (h) => {
      h && (h.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE, h.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE);
    };
    if (e.useCheckerTexture) {
      const h = new Image();
      h.src = "https://zakekecdn.blob.core.windows.net/cdn/Test/checker_texture.png", await new Promise((f, v) => {
        h.onload = () => f(null), h.onerror = (x) => v(x);
      }), n = h.width, a = h.height, this._baseMaterial.albedoTexture = new BABYLON.Texture(
        "https://zakekecdn.blob.core.windows.net/cdn/Test/checker_texture.png",
        t
      ), o(this._baseMaterial.albedoTexture), this._borderMaterial.albedoTexture = new BABYLON.Texture(
        "https://zakekecdn.blob.core.windows.net/cdn/Test/checker_texture.png",
        t
      ), o(this._borderMaterial.albedoTexture);
    } else if (e.backgroundUrl) {
      const h = new Image();
      h.src = e.backgroundUrl, await new Promise((f, v) => {
        h.onload = () => f(null), h.onerror = (x) => v(x);
      }), n = h.width, a = h.height, this._baseMaterial.albedoTexture = new BABYLON.Texture(e.backgroundUrl, t), o(this._baseMaterial.albedoTexture), this._baseMaterial.albedoColor = new BABYLON.Color3(1, 1, 1), e.borderColor || (this._borderMaterial.albedoTexture = new BABYLON.Texture(e.backgroundUrl, t), o(this._borderMaterial.albedoTexture), this._borderMaterial.albedoColor = new BABYLON.Color3(1, 1, 1));
    }
    return { textureWidth: n, textureHeight: a };
  }
  // Rectangle mesh groups builder (non-ellipse)
  buildRectangleMeshGroups(e, t, n, a) {
    const o = [], h = [], f = [], v = [], x = [], k = [];
    for (let I = 0; I < e.columns; I++)
      for (let V = 0; V < e.rows; V++) {
        const [M, W, U] = this.generateCanvasMesh(e, t, I, V, !1), [Q, D, ee] = this.generateCanvasMesh(e, t, I, V, !0, n, a);
        o.push(M), h.push(W), f.push(U), v.push(Q), x.push(D), k.push(ee);
      }
    return { bordersList: o, backsList: h, frontsList: f, texturedBordersList: v, texturedBacksList: x, texturedFrontsList: k };
  }
  // Procedural extruded ellipse (filled). Generates vertices, normals, uvs, indices manually.
  async generateEllipseMesh(e, t, n, a) {
    const o = e.width / 2, h = e.height / 2;
    let f;
    if (e.radiusResolution && e.radiusResolution > 1)
      f = Math.max(8, Math.round(e.radiusResolution));
    else {
      const s = e.radiusResolution && e.radiusResolution > 0 ? e.radiusResolution : 0.1;
      f = Math.max(32, Math.round(2 * Math.PI / s));
    }
    const v = e.depth, x = v / 2, k = -v / 2;
    let I = 1, V = 1, M = 0, W = 0;
    if (n && a) {
      const s = n / a, l = 2 * o / (2 * h);
      s > l ? (V = 1, I = l / s, M = (I - 1) / 2, W = 0) : (I = 1, V = s / l, M = 0, W = (V - 1) / 2);
    }
    const U = (s, l) => ({ u: s / (2 * o) + 0.5, v: l / (2 * h) + 0.5 }), Q = [], D = [], ee = [], J = [], he = (s, l, u, d, p) => {
      Q.push(s, l, u), D.push(0, 0, 1), ee.push(d, p);
    };
    let fe = U(0, 0);
    he(0, 0, x, fe.u, fe.v);
    for (let s = 0; s < f; s++) {
      const l = s / f * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h, p = U(u, d);
      he(u, d, x, p.u, p.v);
    }
    for (let s = 0; s < f; s++) {
      const l = 1 + s, u = 1 + (s + 1) % f;
      J.push(0, u, l);
    }
    const X = [], Z = [], qe = [], Oe = [], je = (s, l, u, d, p) => {
      X.push(s, l, u), Z.push(0, 0, -1), qe.push(d, p);
    };
    fe = U(0, 0), je(0, 0, k, fe.u, fe.v);
    for (let s = 0; s < f; s++) {
      const l = s / f * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h, p = U(u, d);
      je(u, d, k, p.u, p.v);
    }
    for (let s = 0; s < f; s++) {
      const l = 1 + s, u = 1 + (s + 1) % f;
      Oe.push(0, l, u);
    }
    const pt = [], Te = [], Ze = [], ce = [], ut = (s, l, u, d, p, m, y, S) => {
      pt.push(s, l, u), Te.push(d, p, m), Ze.push(y, S);
    };
    for (let s = 0; s < f; s++) {
      const l = s / f * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h;
      let p = u / o, m = d / h;
      const y = Math.hypot(p, m);
      y > 0 && (p /= y, m /= y);
      const S = s / f, L = S <= 0.5 ? S * 2 : (1 - S) * 2, E = 1, A = 1 - L;
      ut(u, d, k, p, m, 0, E, A);
    }
    for (let s = 0; s < f; s++) {
      const l = s / f * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h;
      let p = u / o, m = d / h;
      const y = Math.hypot(p, m);
      y > 0 && (p /= y, m /= y);
      const S = s / f, L = S <= 0.5 ? S * 2 : (1 - S) * 2, E = 0, A = 1 - L;
      ut(u, d, x, p, m, 0, E, A);
    }
    const ze = f;
    for (let s = 0; s < f; s++) {
      const l = s, u = (s + 1) % f, d = ze + s, p = ze + (s + 1) % f;
      ce.push(l, d, p), ce.push(l, p, u);
    }
    const ht = new BABYLON.Mesh("groupMeshEllipse", t), Gt = new BABYLON.Mesh("back", t), $e = new BABYLON.Mesh("front", t), It = new BABYLON.Mesh("borders", t), rt = new BABYLON.VertexData();
    rt.positions = Q, rt.normals = D, rt.uvs = ee, rt.indices = J, rt.applyToMesh(Gt);
    const it = new BABYLON.VertexData();
    it.positions = X, it.normals = Z, it.uvs = qe, it.indices = Oe, it.applyToMesh($e);
    const Xt = new BABYLON.VertexData();
    Xt.positions = pt, Xt.normals = Te, Xt.uvs = Ze, Xt.indices = ce, Xt.applyToMesh(It), this._baseMaterial || (this._baseMaterial = new BABYLON.PBRMaterial("ellipseBaseMat", t)), this._borderMaterial || (this._borderMaterial = new BABYLON.PBRMaterial("ellipseBorderMat", t)), Gt.material = this._baseMaterial, $e.material = this._baseMaterial, It.material = this._borderMaterial, Gt.parent = ht, $e.parent = ht, It.parent = ht;
    const $t = (s, l) => {
      let u = s / (2 * o) + 0.5, d = l / (2 * h) + 0.5;
      return u = u * I - M, d = d * V - W, { u, v: d };
    }, Tt = [], Bi = [], en = [], oi = [], Zt = (s, l, u, d, p) => {
      Tt.push(s, l, u), Bi.push(0, 0, -1), en.push(d, p);
    };
    let Jt = U(0, 0);
    Zt(0, 0, k, Jt.u, Jt.v);
    for (let s = 0; s < f; s++) {
      const l = s / f * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h, p = $t(u, d);
      Zt(u, d, k, p.u, p.v);
    }
    for (let s = 0; s < f; s++) {
      const l = 1 + s, u = 1 + (s + 1) % f;
      oi.push(0, l, u);
    }
    const Qt = [], rn = [], Gi = [], pe = [], Lt = (s, l, u, d, p) => {
      Qt.push(s, l, u), rn.push(0, 0, 1), Gi.push(d, p);
    };
    Jt = U(0, 0), Lt(0, 0, x, Jt.u, Jt.v);
    for (let s = 0; s < f; s++) {
      const l = s / f * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h, p = $t(u, d);
      Lt(u, d, x, p.u, p.v);
    }
    for (let s = 0; s < f; s++) {
      const l = 1 + s, u = 1 + (s + 1) % f;
      pe.push(0, u, l);
    }
    const xt = [], Ne = [], Ie = [], et = [], Et = (s, l, u, d, p, m, y, S) => {
      xt.push(s, l, u), Ne.push(d, p, m), Ie.push(y, S);
    };
    for (let s = 0; s < f; s++) {
      const l = s / f * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h;
      let p = u / o, m = d / h;
      const y = Math.hypot(p, m);
      y > 0 && (p /= y, m /= y);
      const S = s / f;
      Et(u, d, k, p, m, 0, S, 0);
    }
    for (let s = 0; s < f; s++) {
      const l = s / f * Math.PI * 2, u = Math.cos(l) * o, d = Math.sin(l) * h;
      let p = u / o, m = d / h;
      const y = Math.hypot(p, m);
      y > 0 && (p /= y, m /= y);
      const S = s / f;
      Et(u, d, x, p, m, 0, S, 1);
    }
    const ft = f;
    for (let s = 0; s < f; s++) {
      const l = s, u = (s + 1) % f, d = ft + s, p = ft + (s + 1) % f;
      et.push(l, d, p), et.push(l, p, u);
    }
    const tt = new BABYLON.Mesh("texturedBack", t), _t = new BABYLON.Mesh("texturedFront", t), Kt = new BABYLON.Mesh("texturedBorders", t), Ve = new BABYLON.VertexData();
    Ve.positions = Qt, Ve.normals = rn, Ve.uvs = Gi, Ve.indices = pe, Ve.applyToMesh(tt);
    const i = new BABYLON.VertexData();
    i.positions = Tt, i.normals = Bi, i.uvs = en, i.indices = oi, i.applyToMesh(_t);
    const r = new BABYLON.VertexData();
    return r.positions = xt, r.normals = Ne, r.uvs = Ie, r.indices = et, r.applyToMesh(Kt), tt.material = this._baseMaterial, _t.material = this._baseMaterial, Kt.material = this._borderMaterial, tt.parent = ht, _t.parent = ht, Kt.parent = ht, {
      bordersList: [It],
      backsList: [Gt],
      frontsList: [$e],
      texturedBordersList: [Kt],
      texturedBacksList: [tt],
      texturedFrontsList: [_t]
    };
  }
  generateCanvasMesh(e, t, n, a, o = !1, h, f) {
    const v = e.width / e.columns, x = e.height / e.rows, k = v * 0.1, I = BABYLON.MeshBuilder.CreateBox(
      "borders",
      {
        width: v,
        height: x,
        depth: e.depth
      },
      t
    ), V = BABYLON.MeshBuilder.CreatePlane(
      "front",
      {
        width: v,
        height: x
      },
      t
    ), M = BABYLON.MeshBuilder.CreatePlane(
      "back",
      {
        width: v,
        height: x
      },
      t
    );
    I.position = new BABYLON.Vector3(v / 2 + n * (v + k), x / 2 + a * (x + k)), V.position = new BABYLON.Vector3(v / 2 + n * (v + k), x / 2 + a * (x + k), -e.depth / 2), M.position = new BABYLON.Vector3(v / 2 + n * (v + k), x / 2 + a * (x + k), e.depth / 2), M.rotate(BABYLON.Axis.X, Math.PI, BABYLON.Space.WORLD), M.rotate(BABYLON.Axis.Z, Math.PI, BABYLON.Space.WORLD), I.material = this._borderMaterial, M.material = this._borderMaterial, V.material = this._baseMaterial;
    const W = I.getVerticesData(BABYLON.VertexBuffer.NormalKind), U = I.getVerticesData(BABYLON.VertexBuffer.UVKind), Q = V.getVerticesData(BABYLON.VertexBuffer.UVKind), D = M.getVerticesData(BABYLON.VertexBuffer.UVKind);
    e.borderRadius > 0 && console.warn("Mirror canvas effect will not work for border radius > 0"), e.borderRadius === 0 && (o && h && f ? this.applyTexturedUVMapping(
      e,
      I,
      V,
      M,
      U,
      Q,
      D,
      W,
      v,
      x,
      n,
      a,
      h,
      f
    ) : this.applyMirrorUVMapping(e, I, V, M, U, Q, D, W, v, x, n, a)), V.isVisible = !1, M.isVisible = !1;
    const ee = I.getVerticesData(BABYLON.VertexBuffer.PositionKind) ?? [], J = I.getVerticesData(BABYLON.VertexBuffer.NormalKind) ?? [], he = I.getVerticesData(BABYLON.VertexBuffer.UVKind) ?? [], fe = I.getIndices() ?? [];
    return ee.splice(0, 8 * 3), J.splice(0, 8 * 3), he.splice(0, 8 * 2), fe.splice(fe.length - 4 * 3, 4 * 3), I.updateVerticesData(BABYLON.VertexBuffer.PositionKind, ee), I.updateVerticesData(BABYLON.VertexBuffer.NormalKind, J), I.updateVerticesData(BABYLON.VertexBuffer.UVKind, he), I.updateIndices(fe), [I, M, V];
  }
  // This method generate a UV map that stretches with the mesh, the aspect ratio
  // is compensated in the MeshSide canvas matrix.
  applyMirrorUVMapping(e, t, n, a, o, h, f, v, x, k, I, V) {
    const M = e.depth / e.width, W = e.depth / e.height, U = Math.min(M, W), Q = x / e.width, D = k / e.height;
    for (var ee = 0; ee < o.length; ee += 2) {
      const fe = Math.round(v[ee / 2 * 3]), X = Math.round(v[ee / 2 * 3 + 1]), Z = Math.round(v[ee / 2 * 3 + 2]), qe = fe == -1 && X == 0 && Z == 0, Oe = fe == 1 && X == 0 && Z == 0, je = fe == 0 && X == 1 && Z == 0, pt = fe == 0 && X == -1 && Z == 0;
      if (qe) {
        var J = o[ee], he = o[ee + 1];
        o[ee] = he * U + Q * I, o[ee + 1] = J * D + D * V;
      }
      if (Oe) {
        var J = o[ee], he = o[ee + 1];
        o[ee] = he * U + (1 - U) - Q * (e.columns - 1 - I), o[ee + 1] = J * D + D * V;
      }
      if (pt) {
        var J = o[ee], he = o[ee + 1];
        o[ee] = he * Q + Q * I, o[ee + 1] = J * U + D * V;
      }
      if (je) {
        var J = o[ee], he = o[ee + 1];
        o[ee] = (-he + 1) * Q + Q * I, o[ee + 1] = (-J + 1) * U + (1 - U);
      }
    }
    t.setVerticesData(BABYLON.VertexBuffer.UVKind, o);
    for (var ee = 0; ee < h.length; ee += 2) {
      var J = h[ee], he = h[ee + 1];
      h[ee] = J * Q + Q * I, h[ee + 1] = he * D + D * V;
    }
    n.setVerticesData(BABYLON.VertexBuffer.UVKind, h);
    for (var ee = 0; ee < f.length; ee += 2) {
      var J = f[ee], he = f[ee + 1];
      f[ee] = J * Q + Q * (e.columns - 1 - I), f[ee + 1] = he * D + D * V;
    }
    a.setVerticesData(BABYLON.VertexBuffer.UVKind, f);
  }
  // This method generate a UV map that don't stretch with the mesh.
  applyTexturedUVMapping(e, t, n, a, o, h, f, v, x, k, I, V, M, W) {
    const U = M / W, Q = e.width / e.height;
    let D, ee, J, he;
    U > Q ? (ee = 1, D = Q / U, J = (D - 1) / 2, he = 0) : (D = 1, ee = U / Q, J = 0, he = (ee - 1) / 2);
    const fe = x / e.width, X = k / e.height, Z = e.depth / e.width * D, qe = e.depth / e.height * ee, Oe = Math.min(Z, qe);
    for (var je = 0; je < o.length; je += 2) {
      const Ze = Math.round(v[je / 2 * 3]), ce = Math.round(v[je / 2 * 3 + 1]), ut = Math.round(v[je / 2 * 3 + 2]), ze = Ze == -1 && ce == 0 && ut == 0, ht = Ze == 1 && ce == 0 && ut == 0, Gt = Ze == 0 && ce == 1 && ut == 0, $e = Ze == 0 && ce == -1 && ut == 0;
      if (ze) {
        var pt = o[je], Te = o[je + 1];
        o[je] = (Te * Oe + fe * I) * D - J, o[je + 1] = (pt * X + X * V) * ee - he;
      }
      if (ht) {
        var pt = o[je], Te = o[je + 1];
        o[je] = (Te * Oe + (1 - Oe) - fe * (e.columns - 1 - I)) * D - J, o[je + 1] = (pt * X + X * V) * ee - he;
      }
      if ($e) {
        var pt = o[je], Te = o[je + 1];
        o[je] = (Te * fe + fe * I) * D - J, o[je + 1] = (pt * Oe + X * V) * ee - he;
      }
      if (Gt) {
        var pt = o[je], Te = o[je + 1];
        o[je] = ((-Te + 1) * fe + fe * I) * D - J, o[je + 1] = ((-pt + 1) * Oe + (1 - Oe)) * ee - he;
      }
    }
    t.setVerticesData(BABYLON.VertexBuffer.UVKind, o);
    for (var je = 0; je < h.length; je += 2) {
      var pt = h[je], Te = h[je + 1];
      h[je] = (pt * fe + fe * I) * D - J, h[je + 1] = (Te * X + X * V) * ee - he;
    }
    n.setVerticesData(BABYLON.VertexBuffer.UVKind, h);
    for (var je = 0; je < f.length; je += 2) {
      var pt = f[je], Te = f[je + 1];
      f[je] = (pt * fe + fe * (e.columns - 1 - I)) * D - J, f[je + 1] = (Te * X + X * V) * ee - he;
    }
    a.setVerticesData(BABYLON.VertexBuffer.UVKind, f);
  }
}
function od(b, e) {
  return function() {
    return b.apply(e, arguments);
  };
}
const { toString: qy } = Object.prototype, { getPrototypeOf: Kh } = Object, { iterator: Ml, toStringTag: ld } = Symbol, Cl = ((b) => (e) => {
  const t = qy.call(e);
  return b[t] || (b[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), cs = (b) => (b = b.toLowerCase(), (e) => Cl(e) === b), Al = (b) => (e) => typeof e === b, { isArray: La } = Array, Aa = Al("undefined");
function ho(b) {
  return b !== null && !Aa(b) && b.constructor !== null && !Aa(b.constructor) && Br(b.constructor.isBuffer) && b.constructor.isBuffer(b);
}
const hd = cs("ArrayBuffer");
function $y(b) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(b) : e = b && b.buffer && hd(b.buffer), e;
}
const Xy = Al("string"), Br = Al("function"), ud = Al("number"), uo = (b) => b !== null && typeof b == "object", Ky = (b) => b === !0 || b === !1, rl = (b) => {
  if (Cl(b) !== "object")
    return !1;
  const e = Kh(b);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(ld in b) && !(Ml in b);
}, Jy = (b) => {
  if (!uo(b) || ho(b))
    return !1;
  try {
    return Object.keys(b).length === 0 && Object.getPrototypeOf(b) === Object.prototype;
  } catch {
    return !1;
  }
}, Qy = cs("Date"), eb = cs("File"), tb = cs("Blob"), ib = cs("FileList"), nb = (b) => uo(b) && Br(b.pipe), rb = (b) => {
  let e;
  return b && (typeof FormData == "function" && b instanceof FormData || Br(b.append) && ((e = Cl(b)) === "formdata" || // detect form-data instance
  e === "object" && Br(b.toString) && b.toString() === "[object FormData]"));
}, sb = cs("URLSearchParams"), [ab, ob, lb, hb] = ["ReadableStream", "Request", "Response", "Headers"].map(cs), ub = (b) => b.trim ? b.trim() : b.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function co(b, e, { allOwnKeys: t = !1 } = {}) {
  if (b === null || typeof b > "u")
    return;
  let n, a;
  if (typeof b != "object" && (b = [b]), La(b))
    for (n = 0, a = b.length; n < a; n++)
      e.call(null, b[n], n, b);
  else {
    if (ho(b))
      return;
    const o = t ? Object.getOwnPropertyNames(b) : Object.keys(b), h = o.length;
    let f;
    for (n = 0; n < h; n++)
      f = o[n], e.call(null, b[f], f, b);
  }
}
function cd(b, e) {
  if (ho(b))
    return null;
  e = e.toLowerCase();
  const t = Object.keys(b);
  let n = t.length, a;
  for (; n-- > 0; )
    if (a = t[n], e === a.toLowerCase())
      return a;
  return null;
}
const aa = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), fd = (b) => !Aa(b) && b !== aa;
function Rh() {
  const { caseless: b, skipUndefined: e } = fd(this) && this || {}, t = {}, n = (a, o) => {
    const h = b && cd(t, o) || o;
    rl(t[h]) && rl(a) ? t[h] = Rh(t[h], a) : rl(a) ? t[h] = Rh({}, a) : La(a) ? t[h] = a.slice() : (!e || !Aa(a)) && (t[h] = a);
  };
  for (let a = 0, o = arguments.length; a < o; a++)
    arguments[a] && co(arguments[a], n);
  return t;
}
const cb = (b, e, t, { allOwnKeys: n } = {}) => (co(e, (a, o) => {
  t && Br(a) ? b[o] = od(a, t) : b[o] = a;
}, { allOwnKeys: n }), b), fb = (b) => (b.charCodeAt(0) === 65279 && (b = b.slice(1)), b), db = (b, e, t, n) => {
  b.prototype = Object.create(e.prototype, n), b.prototype.constructor = b, Object.defineProperty(b, "super", {
    value: e.prototype
  }), t && Object.assign(b.prototype, t);
}, gb = (b, e, t, n) => {
  let a, o, h;
  const f = {};
  if (e = e || {}, b == null)
    return e;
  do {
    for (a = Object.getOwnPropertyNames(b), o = a.length; o-- > 0; )
      h = a[o], (!n || n(h, b, e)) && !f[h] && (e[h] = b[h], f[h] = !0);
    b = t !== !1 && Kh(b);
  } while (b && (!t || t(b, e)) && b !== Object.prototype);
  return e;
}, pb = (b, e, t) => {
  b = String(b), (t === void 0 || t > b.length) && (t = b.length), t -= e.length;
  const n = b.indexOf(e, t);
  return n !== -1 && n === t;
}, mb = (b) => {
  if (!b)
    return null;
  if (La(b))
    return b;
  let e = b.length;
  if (!ud(e))
    return null;
  const t = new Array(e);
  for (; e-- > 0; )
    t[e] = b[e];
  return t;
}, _b = ((b) => (e) => b && e instanceof b)(typeof Uint8Array < "u" && Kh(Uint8Array)), vb = (b, e) => {
  const n = (b && b[Ml]).call(b);
  let a;
  for (; (a = n.next()) && !a.done; ) {
    const o = a.value;
    e.call(b, o[0], o[1]);
  }
}, yb = (b, e) => {
  let t;
  const n = [];
  for (; (t = b.exec(e)) !== null; )
    n.push(t);
  return n;
}, bb = cs("HTMLFormElement"), xb = (b) => b.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, n, a) {
    return n.toUpperCase() + a;
  }
), yf = (({ hasOwnProperty: b }) => (e, t) => b.call(e, t))(Object.prototype), wb = cs("RegExp"), dd = (b, e) => {
  const t = Object.getOwnPropertyDescriptors(b), n = {};
  co(t, (a, o) => {
    let h;
    (h = e(a, o, b)) !== !1 && (n[o] = h || a);
  }), Object.defineProperties(b, n);
}, Sb = (b) => {
  dd(b, (e, t) => {
    if (Br(b) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const n = b[t];
    if (Br(n)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, Mb = (b, e) => {
  const t = {}, n = (a) => {
    a.forEach((o) => {
      t[o] = !0;
    });
  };
  return La(b) ? n(b) : n(String(b).split(e)), t;
}, Cb = () => {
}, Ab = (b, e) => b != null && Number.isFinite(b = +b) ? b : e;
function Tb(b) {
  return !!(b && Br(b.append) && b[ld] === "FormData" && b[Ml]);
}
const Lb = (b) => {
  const e = new Array(10), t = (n, a) => {
    if (uo(n)) {
      if (e.indexOf(n) >= 0)
        return;
      if (ho(n))
        return n;
      if (!("toJSON" in n)) {
        e[a] = n;
        const o = La(n) ? [] : {};
        return co(n, (h, f) => {
          const v = t(h, a + 1);
          !Aa(v) && (o[f] = v);
        }), e[a] = void 0, o;
      }
    }
    return n;
  };
  return t(b, 0);
}, Bb = cs("AsyncFunction"), kb = (b) => b && (uo(b) || Br(b)) && Br(b.then) && Br(b.catch), gd = ((b, e) => b ? setImmediate : e ? ((t, n) => (aa.addEventListener("message", ({ source: a, data: o }) => {
  a === aa && o === t && n.length && n.shift()();
}, !1), (a) => {
  n.push(a), aa.postMessage(t, "*");
}))(`axios@${Math.random()}`, []) : (t) => setTimeout(t))(
  typeof setImmediate == "function",
  Br(aa.postMessage)
), Eb = typeof queueMicrotask < "u" ? queueMicrotask.bind(aa) : typeof process < "u" && process.nextTick || gd, Ib = (b) => b != null && Br(b[Ml]), Mt = {
  isArray: La,
  isArrayBuffer: hd,
  isBuffer: ho,
  isFormData: rb,
  isArrayBufferView: $y,
  isString: Xy,
  isNumber: ud,
  isBoolean: Ky,
  isObject: uo,
  isPlainObject: rl,
  isEmptyObject: Jy,
  isReadableStream: ab,
  isRequest: ob,
  isResponse: lb,
  isHeaders: hb,
  isUndefined: Aa,
  isDate: Qy,
  isFile: eb,
  isBlob: tb,
  isRegExp: wb,
  isFunction: Br,
  isStream: nb,
  isURLSearchParams: sb,
  isTypedArray: _b,
  isFileList: ib,
  forEach: co,
  merge: Rh,
  extend: cb,
  trim: ub,
  stripBOM: fb,
  inherits: db,
  toFlatObject: gb,
  kindOf: Cl,
  kindOfTest: cs,
  endsWith: pb,
  toArray: mb,
  forEachEntry: vb,
  matchAll: yb,
  isHTMLForm: bb,
  hasOwnProperty: yf,
  hasOwnProp: yf,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: dd,
  freezeMethods: Sb,
  toObjectSet: Mb,
  toCamelCase: xb,
  noop: Cb,
  toFiniteNumber: Ab,
  findKey: cd,
  global: aa,
  isContextDefined: fd,
  isSpecCompliantForm: Tb,
  toJSONObject: Lb,
  isAsyncFn: Bb,
  isThenable: kb,
  setImmediate: gd,
  asap: Eb,
  isIterable: Ib
};
function Ri(b, e, t, n, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = b, this.name = "AxiosError", e && (this.code = e), t && (this.config = t), n && (this.request = n), a && (this.response = a, this.status = a.status ? a.status : null);
}
Mt.inherits(Ri, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: Mt.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const pd = Ri.prototype, md = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((b) => {
  md[b] = { value: b };
});
Object.defineProperties(Ri, md);
Object.defineProperty(pd, "isAxiosError", { value: !0 });
Ri.from = (b, e, t, n, a, o) => {
  const h = Object.create(pd);
  Mt.toFlatObject(b, h, function(k) {
    return k !== Error.prototype;
  }, (x) => x !== "isAxiosError");
  const f = b && b.message ? b.message : "Error", v = e == null && b ? b.code : e;
  return Ri.call(h, f, v, t, n, a), b && h.cause == null && Object.defineProperty(h, "cause", { value: b, configurable: !0 }), h.name = b && b.name || "Error", o && Object.assign(h, o), h;
};
const Pb = null;
function Dh(b) {
  return Mt.isPlainObject(b) || Mt.isArray(b);
}
function _d(b) {
  return Mt.endsWith(b, "[]") ? b.slice(0, -2) : b;
}
function bf(b, e, t) {
  return b ? b.concat(e).map(function(a, o) {
    return a = _d(a), !t && o ? "[" + a + "]" : a;
  }).join(t ? "." : "") : e;
}
function Ob(b) {
  return Mt.isArray(b) && !b.some(Dh);
}
const Nb = Mt.toFlatObject(Mt, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Tl(b, e, t) {
  if (!Mt.isObject(b))
    throw new TypeError("target must be an object");
  e = e || new FormData(), t = Mt.toFlatObject(t, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(U, Q) {
    return !Mt.isUndefined(Q[U]);
  });
  const n = t.metaTokens, a = t.visitor || k, o = t.dots, h = t.indexes, v = (t.Blob || typeof Blob < "u" && Blob) && Mt.isSpecCompliantForm(e);
  if (!Mt.isFunction(a))
    throw new TypeError("visitor must be a function");
  function x(W) {
    if (W === null)
      return "";
    if (Mt.isDate(W))
      return W.toISOString();
    if (Mt.isBoolean(W))
      return W.toString();
    if (!v && Mt.isBlob(W))
      throw new Ri("Blob is not supported. Use a Buffer instead.");
    return Mt.isArrayBuffer(W) || Mt.isTypedArray(W) ? v && typeof Blob == "function" ? new Blob([W]) : Buffer.from(W) : W;
  }
  function k(W, U, Q) {
    let D = W;
    if (W && !Q && typeof W == "object") {
      if (Mt.endsWith(U, "{}"))
        U = n ? U : U.slice(0, -2), W = JSON.stringify(W);
      else if (Mt.isArray(W) && Ob(W) || (Mt.isFileList(W) || Mt.endsWith(U, "[]")) && (D = Mt.toArray(W)))
        return U = _d(U), D.forEach(function(J, he) {
          !(Mt.isUndefined(J) || J === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            h === !0 ? bf([U], he, o) : h === null ? U : U + "[]",
            x(J)
          );
        }), !1;
    }
    return Dh(W) ? !0 : (e.append(bf(Q, U, o), x(W)), !1);
  }
  const I = [], V = Object.assign(Nb, {
    defaultVisitor: k,
    convertValue: x,
    isVisitable: Dh
  });
  function M(W, U) {
    if (!Mt.isUndefined(W)) {
      if (I.indexOf(W) !== -1)
        throw Error("Circular reference detected in " + U.join("."));
      I.push(W), Mt.forEach(W, function(D, ee) {
        (!(Mt.isUndefined(D) || D === null) && a.call(
          e,
          D,
          Mt.isString(ee) ? ee.trim() : ee,
          U,
          V
        )) === !0 && M(D, U ? U.concat(ee) : [ee]);
      }), I.pop();
    }
  }
  if (!Mt.isObject(b))
    throw new TypeError("data must be an object");
  return M(b), e;
}
function xf(b) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(b).replace(/[!'()~]|%20|%00/g, function(n) {
    return e[n];
  });
}
function Jh(b, e) {
  this._pairs = [], b && Tl(b, this, e);
}
const vd = Jh.prototype;
vd.append = function(e, t) {
  this._pairs.push([e, t]);
};
vd.toString = function(e) {
  const t = e ? function(n) {
    return e.call(this, n, xf);
  } : xf;
  return this._pairs.map(function(a) {
    return t(a[0]) + "=" + t(a[1]);
  }, "").join("&");
};
function Rb(b) {
  return encodeURIComponent(b).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function yd(b, e, t) {
  if (!e)
    return b;
  const n = t && t.encode || Rb;
  Mt.isFunction(t) && (t = {
    serialize: t
  });
  const a = t && t.serialize;
  let o;
  if (a ? o = a(e, t) : o = Mt.isURLSearchParams(e) ? e.toString() : new Jh(e, t).toString(n), o) {
    const h = b.indexOf("#");
    h !== -1 && (b = b.slice(0, h)), b += (b.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return b;
}
class Db {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, t, n) {
    return this.handlers.push({
      fulfilled: e,
      rejected: t,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    Mt.forEach(this.handlers, function(n) {
      n !== null && e(n);
    });
  }
}
const wf = Db, bd = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, zb = typeof URLSearchParams < "u" ? URLSearchParams : Jh, Fb = typeof FormData < "u" ? FormData : null, Ub = typeof Blob < "u" ? Blob : null, Vb = {
  isBrowser: !0,
  classes: {
    URLSearchParams: zb,
    FormData: Fb,
    Blob: Ub
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Qh = typeof window < "u" && typeof document < "u", zh = typeof navigator == "object" && navigator || void 0, Hb = Qh && (!zh || ["ReactNative", "NativeScript", "NS"].indexOf(zh.product) < 0), Yb = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), Gb = Qh && window.location.href || "http://localhost", jb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Qh,
  hasStandardBrowserEnv: Hb,
  hasStandardBrowserWebWorkerEnv: Yb,
  navigator: zh,
  origin: Gb
}, Symbol.toStringTag, { value: "Module" })), cr = {
  ...jb,
  ...Vb
};
function Wb(b, e) {
  return Tl(b, new cr.classes.URLSearchParams(), {
    visitor: function(t, n, a, o) {
      return cr.isNode && Mt.isBuffer(t) ? (this.append(n, t.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...e
  });
}
function Zb(b) {
  return Mt.matchAll(/\w+|\[(\w*)]/g, b).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function qb(b) {
  const e = {}, t = Object.keys(b);
  let n;
  const a = t.length;
  let o;
  for (n = 0; n < a; n++)
    o = t[n], e[o] = b[o];
  return e;
}
function xd(b) {
  function e(t, n, a, o) {
    let h = t[o++];
    if (h === "__proto__")
      return !0;
    const f = Number.isFinite(+h), v = o >= t.length;
    return h = !h && Mt.isArray(a) ? a.length : h, v ? (Mt.hasOwnProp(a, h) ? a[h] = [a[h], n] : a[h] = n, !f) : ((!a[h] || !Mt.isObject(a[h])) && (a[h] = []), e(t, n, a[h], o) && Mt.isArray(a[h]) && (a[h] = qb(a[h])), !f);
  }
  if (Mt.isFormData(b) && Mt.isFunction(b.entries)) {
    const t = {};
    return Mt.forEachEntry(b, (n, a) => {
      e(Zb(n), a, t, 0);
    }), t;
  }
  return null;
}
function $b(b, e, t) {
  if (Mt.isString(b))
    try {
      return (e || JSON.parse)(b), Mt.trim(b);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (t || JSON.stringify)(b);
}
const eu = {
  transitional: bd,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const n = t.getContentType() || "", a = n.indexOf("application/json") > -1, o = Mt.isObject(e);
    if (o && Mt.isHTMLForm(e) && (e = new FormData(e)), Mt.isFormData(e))
      return a ? JSON.stringify(xd(e)) : e;
    if (Mt.isArrayBuffer(e) || Mt.isBuffer(e) || Mt.isStream(e) || Mt.isFile(e) || Mt.isBlob(e) || Mt.isReadableStream(e))
      return e;
    if (Mt.isArrayBufferView(e))
      return e.buffer;
    if (Mt.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let f;
    if (o) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return Wb(e, this.formSerializer).toString();
      if ((f = Mt.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
        const v = this.env && this.env.FormData;
        return Tl(
          f ? { "files[]": e } : e,
          v && new v(),
          this.formSerializer
        );
      }
    }
    return o || a ? (t.setContentType("application/json", !1), $b(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || eu.transitional, n = t && t.forcedJSONParsing, a = this.responseType === "json";
    if (Mt.isResponse(e) || Mt.isReadableStream(e))
      return e;
    if (e && Mt.isString(e) && (n && !this.responseType || a)) {
      const h = !(t && t.silentJSONParsing) && a;
      try {
        return JSON.parse(e, this.parseReviver);
      } catch (f) {
        if (h)
          throw f.name === "SyntaxError" ? Ri.from(f, Ri.ERR_BAD_RESPONSE, this, null, this.response) : f;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: cr.classes.FormData,
    Blob: cr.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
Mt.forEach(["delete", "get", "head", "post", "put", "patch"], (b) => {
  eu.headers[b] = {};
});
const tu = eu, Xb = Mt.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Kb = (b) => {
  const e = {};
  let t, n, a;
  return b && b.split(`
`).forEach(function(h) {
    a = h.indexOf(":"), t = h.substring(0, a).trim().toLowerCase(), n = h.substring(a + 1).trim(), !(!t || e[t] && Xb[t]) && (t === "set-cookie" ? e[t] ? e[t].push(n) : e[t] = [n] : e[t] = e[t] ? e[t] + ", " + n : n);
  }), e;
}, Sf = Symbol("internals");
function Ga(b) {
  return b && String(b).trim().toLowerCase();
}
function sl(b) {
  return b === !1 || b == null ? b : Mt.isArray(b) ? b.map(sl) : String(b);
}
function Jb(b) {
  const e = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = t.exec(b); )
    e[n[1]] = n[2];
  return e;
}
const Qb = (b) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(b.trim());
function Ah(b, e, t, n, a) {
  if (Mt.isFunction(n))
    return n.call(this, e, t);
  if (a && (e = t), !!Mt.isString(e)) {
    if (Mt.isString(n))
      return e.indexOf(n) !== -1;
    if (Mt.isRegExp(n))
      return n.test(e);
  }
}
function ex(b) {
  return b.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, t, n) => t.toUpperCase() + n);
}
function tx(b, e) {
  const t = Mt.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(b, n + t, {
      value: function(a, o, h) {
        return this[n].call(this, e, a, o, h);
      },
      configurable: !0
    });
  });
}
class Ll {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, n) {
    const a = this;
    function o(f, v, x) {
      const k = Ga(v);
      if (!k)
        throw new Error("header name must be a non-empty string");
      const I = Mt.findKey(a, k);
      (!I || a[I] === void 0 || x === !0 || x === void 0 && a[I] !== !1) && (a[I || v] = sl(f));
    }
    const h = (f, v) => Mt.forEach(f, (x, k) => o(x, k, v));
    if (Mt.isPlainObject(e) || e instanceof this.constructor)
      h(e, t);
    else if (Mt.isString(e) && (e = e.trim()) && !Qb(e))
      h(Kb(e), t);
    else if (Mt.isObject(e) && Mt.isIterable(e)) {
      let f = {}, v, x;
      for (const k of e) {
        if (!Mt.isArray(k))
          throw TypeError("Object iterator must return a key-value pair");
        f[x = k[0]] = (v = f[x]) ? Mt.isArray(v) ? [...v, k[1]] : [v, k[1]] : k[1];
      }
      h(f, t);
    } else
      e != null && o(t, e, n);
    return this;
  }
  get(e, t) {
    if (e = Ga(e), e) {
      const n = Mt.findKey(this, e);
      if (n) {
        const a = this[n];
        if (!t)
          return a;
        if (t === !0)
          return Jb(a);
        if (Mt.isFunction(t))
          return t.call(this, a, n);
        if (Mt.isRegExp(t))
          return t.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = Ga(e), e) {
      const n = Mt.findKey(this, e);
      return !!(n && this[n] !== void 0 && (!t || Ah(this, this[n], n, t)));
    }
    return !1;
  }
  delete(e, t) {
    const n = this;
    let a = !1;
    function o(h) {
      if (h = Ga(h), h) {
        const f = Mt.findKey(n, h);
        f && (!t || Ah(n, n[f], f, t)) && (delete n[f], a = !0);
      }
    }
    return Mt.isArray(e) ? e.forEach(o) : o(e), a;
  }
  clear(e) {
    const t = Object.keys(this);
    let n = t.length, a = !1;
    for (; n--; ) {
      const o = t[n];
      (!e || Ah(this, this[o], o, e, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(e) {
    const t = this, n = {};
    return Mt.forEach(this, (a, o) => {
      const h = Mt.findKey(n, o);
      if (h) {
        t[h] = sl(a), delete t[o];
        return;
      }
      const f = e ? ex(o) : String(o).trim();
      f !== o && delete t[o], t[f] = sl(a), n[f] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return Mt.forEach(this, (n, a) => {
      n != null && n !== !1 && (t[a] = e && Mt.isArray(n) ? n.join(", ") : n);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    const n = new this(e);
    return t.forEach((a) => n.set(a)), n;
  }
  static accessor(e) {
    const n = (this[Sf] = this[Sf] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(h) {
      const f = Ga(h);
      n[f] || (tx(a, h), n[f] = !0);
    }
    return Mt.isArray(e) ? e.forEach(o) : o(e), this;
  }
}
Ll.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
Mt.reduceDescriptors(Ll.prototype, ({ value: b }, e) => {
  let t = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => b,
    set(n) {
      this[t] = n;
    }
  };
});
Mt.freezeMethods(Ll);
const us = Ll;
function Th(b, e) {
  const t = this || tu, n = e || t, a = us.from(n.headers);
  let o = n.data;
  return Mt.forEach(b, function(f) {
    o = f.call(t, o, a.normalize(), e ? e.status : void 0);
  }), a.normalize(), o;
}
function wd(b) {
  return !!(b && b.__CANCEL__);
}
function Ba(b, e, t) {
  Ri.call(this, b ?? "canceled", Ri.ERR_CANCELED, e, t), this.name = "CanceledError";
}
Mt.inherits(Ba, Ri, {
  __CANCEL__: !0
});
function Sd(b, e, t) {
  const n = t.config.validateStatus;
  !t.status || !n || n(t.status) ? b(t) : e(new Ri(
    "Request failed with status code " + t.status,
    [Ri.ERR_BAD_REQUEST, Ri.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
    t.config,
    t.request,
    t
  ));
}
function ix(b) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(b);
  return e && e[1] || "";
}
function nx(b, e) {
  b = b || 10;
  const t = new Array(b), n = new Array(b);
  let a = 0, o = 0, h;
  return e = e !== void 0 ? e : 1e3, function(v) {
    const x = Date.now(), k = n[o];
    h || (h = x), t[a] = v, n[a] = x;
    let I = o, V = 0;
    for (; I !== a; )
      V += t[I++], I = I % b;
    if (a = (a + 1) % b, a === o && (o = (o + 1) % b), x - h < e)
      return;
    const M = k && x - k;
    return M ? Math.round(V * 1e3 / M) : void 0;
  };
}
function rx(b, e) {
  let t = 0, n = 1e3 / e, a, o;
  const h = (x, k = Date.now()) => {
    t = k, a = null, o && (clearTimeout(o), o = null), b(...x);
  };
  return [(...x) => {
    const k = Date.now(), I = k - t;
    I >= n ? h(x, k) : (a = x, o || (o = setTimeout(() => {
      o = null, h(a);
    }, n - I)));
  }, () => a && h(a)];
}
const pl = (b, e, t = 3) => {
  let n = 0;
  const a = nx(50, 250);
  return rx((o) => {
    const h = o.loaded, f = o.lengthComputable ? o.total : void 0, v = h - n, x = a(v), k = h <= f;
    n = h;
    const I = {
      loaded: h,
      total: f,
      progress: f ? h / f : void 0,
      bytes: v,
      rate: x || void 0,
      estimated: x && f && k ? (f - h) / x : void 0,
      event: o,
      lengthComputable: f != null,
      [e ? "download" : "upload"]: !0
    };
    b(I);
  }, t);
}, Mf = (b, e) => {
  const t = b != null;
  return [(n) => e[0]({
    lengthComputable: t,
    total: b,
    loaded: n
  }), e[1]];
}, Cf = (b) => (...e) => Mt.asap(() => b(...e)), sx = cr.hasStandardBrowserEnv ? ((b, e) => (t) => (t = new URL(t, cr.origin), b.protocol === t.protocol && b.host === t.host && (e || b.port === t.port)))(
  new URL(cr.origin),
  cr.navigator && /(msie|trident)/i.test(cr.navigator.userAgent)
) : () => !0, ax = cr.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(b, e, t, n, a, o, h) {
      if (typeof document > "u")
        return;
      const f = [`${b}=${encodeURIComponent(e)}`];
      Mt.isNumber(t) && f.push(`expires=${new Date(t).toUTCString()}`), Mt.isString(n) && f.push(`path=${n}`), Mt.isString(a) && f.push(`domain=${a}`), o === !0 && f.push("secure"), Mt.isString(h) && f.push(`SameSite=${h}`), document.cookie = f.join("; ");
    },
    read(b) {
      if (typeof document > "u")
        return null;
      const e = document.cookie.match(new RegExp("(?:^|; )" + b + "=([^;]*)"));
      return e ? decodeURIComponent(e[1]) : null;
    },
    remove(b) {
      this.write(b, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function ox(b) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(b);
}
function lx(b, e) {
  return e ? b.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : b;
}
function Md(b, e, t) {
  let n = !ox(e);
  return b && (n || t == !1) ? lx(b, e) : e;
}
const Af = (b) => b instanceof us ? { ...b } : b;
function ha(b, e) {
  e = e || {};
  const t = {};
  function n(x, k, I, V) {
    return Mt.isPlainObject(x) && Mt.isPlainObject(k) ? Mt.merge.call({ caseless: V }, x, k) : Mt.isPlainObject(k) ? Mt.merge({}, k) : Mt.isArray(k) ? k.slice() : k;
  }
  function a(x, k, I, V) {
    if (Mt.isUndefined(k)) {
      if (!Mt.isUndefined(x))
        return n(void 0, x, I, V);
    } else
      return n(x, k, I, V);
  }
  function o(x, k) {
    if (!Mt.isUndefined(k))
      return n(void 0, k);
  }
  function h(x, k) {
    if (Mt.isUndefined(k)) {
      if (!Mt.isUndefined(x))
        return n(void 0, x);
    } else
      return n(void 0, k);
  }
  function f(x, k, I) {
    if (I in e)
      return n(x, k);
    if (I in b)
      return n(void 0, x);
  }
  const v = {
    url: o,
    method: o,
    data: o,
    baseURL: h,
    transformRequest: h,
    transformResponse: h,
    paramsSerializer: h,
    timeout: h,
    timeoutMessage: h,
    withCredentials: h,
    withXSRFToken: h,
    adapter: h,
    responseType: h,
    xsrfCookieName: h,
    xsrfHeaderName: h,
    onUploadProgress: h,
    onDownloadProgress: h,
    decompress: h,
    maxContentLength: h,
    maxBodyLength: h,
    beforeRedirect: h,
    transport: h,
    httpAgent: h,
    httpsAgent: h,
    cancelToken: h,
    socketPath: h,
    responseEncoding: h,
    validateStatus: f,
    headers: (x, k, I) => a(Af(x), Af(k), I, !0)
  };
  return Mt.forEach(Object.keys({ ...b, ...e }), function(k) {
    const I = v[k] || a, V = I(b[k], e[k], k);
    Mt.isUndefined(V) && I !== f || (t[k] = V);
  }), t;
}
const Cd = (b) => {
  const e = ha({}, b);
  let { data: t, withXSRFToken: n, xsrfHeaderName: a, xsrfCookieName: o, headers: h, auth: f } = e;
  if (e.headers = h = us.from(h), e.url = yd(Md(e.baseURL, e.url, e.allowAbsoluteUrls), b.params, b.paramsSerializer), f && h.set(
    "Authorization",
    "Basic " + btoa((f.username || "") + ":" + (f.password ? unescape(encodeURIComponent(f.password)) : ""))
  ), Mt.isFormData(t)) {
    if (cr.hasStandardBrowserEnv || cr.hasStandardBrowserWebWorkerEnv)
      h.setContentType(void 0);
    else if (Mt.isFunction(t.getHeaders)) {
      const v = t.getHeaders(), x = ["content-type", "content-length"];
      Object.entries(v).forEach(([k, I]) => {
        x.includes(k.toLowerCase()) && h.set(k, I);
      });
    }
  }
  if (cr.hasStandardBrowserEnv && (n && Mt.isFunction(n) && (n = n(e)), n || n !== !1 && sx(e.url))) {
    const v = a && o && ax.read(o);
    v && h.set(a, v);
  }
  return e;
}, hx = typeof XMLHttpRequest < "u", ux = hx && function(b) {
  return new Promise(function(t, n) {
    const a = Cd(b);
    let o = a.data;
    const h = us.from(a.headers).normalize();
    let { responseType: f, onUploadProgress: v, onDownloadProgress: x } = a, k, I, V, M, W;
    function U() {
      M && M(), W && W(), a.cancelToken && a.cancelToken.unsubscribe(k), a.signal && a.signal.removeEventListener("abort", k);
    }
    let Q = new XMLHttpRequest();
    Q.open(a.method.toUpperCase(), a.url, !0), Q.timeout = a.timeout;
    function D() {
      if (!Q)
        return;
      const J = us.from(
        "getAllResponseHeaders" in Q && Q.getAllResponseHeaders()
      ), fe = {
        data: !f || f === "text" || f === "json" ? Q.responseText : Q.response,
        status: Q.status,
        statusText: Q.statusText,
        headers: J,
        config: b,
        request: Q
      };
      Sd(function(Z) {
        t(Z), U();
      }, function(Z) {
        n(Z), U();
      }, fe), Q = null;
    }
    "onloadend" in Q ? Q.onloadend = D : Q.onreadystatechange = function() {
      !Q || Q.readyState !== 4 || Q.status === 0 && !(Q.responseURL && Q.responseURL.indexOf("file:") === 0) || setTimeout(D);
    }, Q.onabort = function() {
      Q && (n(new Ri("Request aborted", Ri.ECONNABORTED, b, Q)), Q = null);
    }, Q.onerror = function(he) {
      const fe = he && he.message ? he.message : "Network Error", X = new Ri(fe, Ri.ERR_NETWORK, b, Q);
      X.event = he || null, n(X), Q = null;
    }, Q.ontimeout = function() {
      let he = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const fe = a.transitional || bd;
      a.timeoutErrorMessage && (he = a.timeoutErrorMessage), n(new Ri(
        he,
        fe.clarifyTimeoutError ? Ri.ETIMEDOUT : Ri.ECONNABORTED,
        b,
        Q
      )), Q = null;
    }, o === void 0 && h.setContentType(null), "setRequestHeader" in Q && Mt.forEach(h.toJSON(), function(he, fe) {
      Q.setRequestHeader(fe, he);
    }), Mt.isUndefined(a.withCredentials) || (Q.withCredentials = !!a.withCredentials), f && f !== "json" && (Q.responseType = a.responseType), x && ([V, W] = pl(x, !0), Q.addEventListener("progress", V)), v && Q.upload && ([I, M] = pl(v), Q.upload.addEventListener("progress", I), Q.upload.addEventListener("loadend", M)), (a.cancelToken || a.signal) && (k = (J) => {
      Q && (n(!J || J.type ? new Ba(null, b, Q) : J), Q.abort(), Q = null);
    }, a.cancelToken && a.cancelToken.subscribe(k), a.signal && (a.signal.aborted ? k() : a.signal.addEventListener("abort", k)));
    const ee = ix(a.url);
    if (ee && cr.protocols.indexOf(ee) === -1) {
      n(new Ri("Unsupported protocol " + ee + ":", Ri.ERR_BAD_REQUEST, b));
      return;
    }
    Q.send(o || null);
  });
}, cx = (b, e) => {
  const { length: t } = b = b ? b.filter(Boolean) : [];
  if (e || t) {
    let n = new AbortController(), a;
    const o = function(x) {
      if (!a) {
        a = !0, f();
        const k = x instanceof Error ? x : this.reason;
        n.abort(k instanceof Ri ? k : new Ba(k instanceof Error ? k.message : k));
      }
    };
    let h = e && setTimeout(() => {
      h = null, o(new Ri(`timeout ${e} of ms exceeded`, Ri.ETIMEDOUT));
    }, e);
    const f = () => {
      b && (h && clearTimeout(h), h = null, b.forEach((x) => {
        x.unsubscribe ? x.unsubscribe(o) : x.removeEventListener("abort", o);
      }), b = null);
    };
    b.forEach((x) => x.addEventListener("abort", o));
    const { signal: v } = n;
    return v.unsubscribe = () => Mt.asap(f), v;
  }
}, fx = cx, dx = function* (b, e) {
  let t = b.byteLength;
  if (!e || t < e) {
    yield b;
    return;
  }
  let n = 0, a;
  for (; n < t; )
    a = n + e, yield b.slice(n, a), n = a;
}, gx = async function* (b, e) {
  for await (const t of px(b))
    yield* dx(t, e);
}, px = async function* (b) {
  if (b[Symbol.asyncIterator]) {
    yield* b;
    return;
  }
  const e = b.getReader();
  try {
    for (; ; ) {
      const { done: t, value: n } = await e.read();
      if (t)
        break;
      yield n;
    }
  } finally {
    await e.cancel();
  }
}, Tf = (b, e, t, n) => {
  const a = gx(b, e);
  let o = 0, h, f = (v) => {
    h || (h = !0, n && n(v));
  };
  return new ReadableStream({
    async pull(v) {
      try {
        const { done: x, value: k } = await a.next();
        if (x) {
          f(), v.close();
          return;
        }
        let I = k.byteLength;
        if (t) {
          let V = o += I;
          t(V);
        }
        v.enqueue(new Uint8Array(k));
      } catch (x) {
        throw f(x), x;
      }
    },
    cancel(v) {
      return f(v), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, Lf = 64 * 1024, { isFunction: Jo } = Mt, mx = (({ Request: b, Response: e }) => ({
  Request: b,
  Response: e
}))(Mt.global), {
  ReadableStream: Bf,
  TextEncoder: kf
} = Mt.global, Ef = (b, ...e) => {
  try {
    return !!b(...e);
  } catch {
    return !1;
  }
}, _x = (b) => {
  b = Mt.merge.call({
    skipUndefined: !0
  }, mx, b);
  const { fetch: e, Request: t, Response: n } = b, a = e ? Jo(e) : typeof fetch == "function", o = Jo(t), h = Jo(n);
  if (!a)
    return !1;
  const f = a && Jo(Bf), v = a && (typeof kf == "function" ? ((W) => (U) => W.encode(U))(new kf()) : async (W) => new Uint8Array(await new t(W).arrayBuffer())), x = o && f && Ef(() => {
    let W = !1;
    const U = new t(cr.origin, {
      body: new Bf(),
      method: "POST",
      get duplex() {
        return W = !0, "half";
      }
    }).headers.has("Content-Type");
    return W && !U;
  }), k = h && f && Ef(() => Mt.isReadableStream(new n("").body)), I = {
    stream: k && ((W) => W.body)
  };
  a && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((W) => {
    !I[W] && (I[W] = (U, Q) => {
      let D = U && U[W];
      if (D)
        return D.call(U);
      throw new Ri(`Response type '${W}' is not supported`, Ri.ERR_NOT_SUPPORT, Q);
    });
  });
  const V = async (W) => {
    if (W == null)
      return 0;
    if (Mt.isBlob(W))
      return W.size;
    if (Mt.isSpecCompliantForm(W))
      return (await new t(cr.origin, {
        method: "POST",
        body: W
      }).arrayBuffer()).byteLength;
    if (Mt.isArrayBufferView(W) || Mt.isArrayBuffer(W))
      return W.byteLength;
    if (Mt.isURLSearchParams(W) && (W = W + ""), Mt.isString(W))
      return (await v(W)).byteLength;
  }, M = async (W, U) => {
    const Q = Mt.toFiniteNumber(W.getContentLength());
    return Q ?? V(U);
  };
  return async (W) => {
    let {
      url: U,
      method: Q,
      data: D,
      signal: ee,
      cancelToken: J,
      timeout: he,
      onDownloadProgress: fe,
      onUploadProgress: X,
      responseType: Z,
      headers: qe,
      withCredentials: Oe = "same-origin",
      fetchOptions: je
    } = Cd(W), pt = e || fetch;
    Z = Z ? (Z + "").toLowerCase() : "text";
    let Te = fx([ee, J && J.toAbortSignal()], he), Ze = null;
    const ce = Te && Te.unsubscribe && (() => {
      Te.unsubscribe();
    });
    let ut;
    try {
      if (X && x && Q !== "get" && Q !== "head" && (ut = await M(qe, D)) !== 0) {
        let rt = new t(U, {
          method: "POST",
          body: D,
          duplex: "half"
        }), it;
        if (Mt.isFormData(D) && (it = rt.headers.get("content-type")) && qe.setContentType(it), rt.body) {
          const [Xt, $t] = Mf(
            ut,
            pl(Cf(X))
          );
          D = Tf(rt.body, Lf, Xt, $t);
        }
      }
      Mt.isString(Oe) || (Oe = Oe ? "include" : "omit");
      const ze = o && "credentials" in t.prototype, ht = {
        ...je,
        signal: Te,
        method: Q.toUpperCase(),
        headers: qe.normalize().toJSON(),
        body: D,
        duplex: "half",
        credentials: ze ? Oe : void 0
      };
      Ze = o && new t(U, ht);
      let Gt = await (o ? pt(Ze, je) : pt(U, ht));
      const $e = k && (Z === "stream" || Z === "response");
      if (k && (fe || $e && ce)) {
        const rt = {};
        ["status", "statusText", "headers"].forEach((Tt) => {
          rt[Tt] = Gt[Tt];
        });
        const it = Mt.toFiniteNumber(Gt.headers.get("content-length")), [Xt, $t] = fe && Mf(
          it,
          pl(Cf(fe), !0)
        ) || [];
        Gt = new n(
          Tf(Gt.body, Lf, Xt, () => {
            $t && $t(), ce && ce();
          }),
          rt
        );
      }
      Z = Z || "text";
      let It = await I[Mt.findKey(I, Z) || "text"](Gt, W);
      return !$e && ce && ce(), await new Promise((rt, it) => {
        Sd(rt, it, {
          data: It,
          headers: us.from(Gt.headers),
          status: Gt.status,
          statusText: Gt.statusText,
          config: W,
          request: Ze
        });
      });
    } catch (ze) {
      throw ce && ce(), ze && ze.name === "TypeError" && /Load failed|fetch/i.test(ze.message) ? Object.assign(
        new Ri("Network Error", Ri.ERR_NETWORK, W, Ze),
        {
          cause: ze.cause || ze
        }
      ) : Ri.from(ze, ze && ze.code, W, Ze);
    }
  };
}, vx = /* @__PURE__ */ new Map(), Ad = (b) => {
  let e = b && b.env || {};
  const { fetch: t, Request: n, Response: a } = e, o = [
    n,
    a,
    t
  ];
  let h = o.length, f = h, v, x, k = vx;
  for (; f--; )
    v = o[f], x = k.get(v), x === void 0 && k.set(v, x = f ? /* @__PURE__ */ new Map() : _x(e)), k = x;
  return x;
};
Ad();
const iu = {
  http: Pb,
  xhr: ux,
  fetch: {
    get: Ad
  }
};
Mt.forEach(iu, (b, e) => {
  if (b) {
    try {
      Object.defineProperty(b, "name", { value: e });
    } catch {
    }
    Object.defineProperty(b, "adapterName", { value: e });
  }
});
const If = (b) => `- ${b}`, yx = (b) => Mt.isFunction(b) || b === null || b === !1;
function bx(b, e) {
  b = Mt.isArray(b) ? b : [b];
  const { length: t } = b;
  let n, a;
  const o = {};
  for (let h = 0; h < t; h++) {
    n = b[h];
    let f;
    if (a = n, !yx(n) && (a = iu[(f = String(n)).toLowerCase()], a === void 0))
      throw new Ri(`Unknown adapter '${f}'`);
    if (a && (Mt.isFunction(a) || (a = a.get(e))))
      break;
    o[f || "#" + h] = a;
  }
  if (!a) {
    const h = Object.entries(o).map(
      ([v, x]) => `adapter ${v} ` + (x === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let f = t ? h.length > 1 ? `since :
` + h.map(If).join(`
`) : " " + If(h[0]) : "as no adapter specified";
    throw new Ri(
      "There is no suitable adapter to dispatch the request " + f,
      "ERR_NOT_SUPPORT"
    );
  }
  return a;
}
const Td = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: bx,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: iu
};
function Lh(b) {
  if (b.cancelToken && b.cancelToken.throwIfRequested(), b.signal && b.signal.aborted)
    throw new Ba(null, b);
}
function Pf(b) {
  return Lh(b), b.headers = us.from(b.headers), b.data = Th.call(
    b,
    b.transformRequest
  ), ["post", "put", "patch"].indexOf(b.method) !== -1 && b.headers.setContentType("application/x-www-form-urlencoded", !1), Td.getAdapter(b.adapter || tu.adapter, b)(b).then(function(n) {
    return Lh(b), n.data = Th.call(
      b,
      b.transformResponse,
      n
    ), n.headers = us.from(n.headers), n;
  }, function(n) {
    return wd(n) || (Lh(b), n && n.response && (n.response.data = Th.call(
      b,
      b.transformResponse,
      n.response
    ), n.response.headers = us.from(n.response.headers))), Promise.reject(n);
  });
}
const Ld = "1.13.2", Bl = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((b, e) => {
  Bl[b] = function(n) {
    return typeof n === b || "a" + (e < 1 ? "n " : " ") + b;
  };
});
const Of = {};
Bl.transitional = function(e, t, n) {
  function a(o, h) {
    return "[Axios v" + Ld + "] Transitional option '" + o + "'" + h + (n ? ". " + n : "");
  }
  return (o, h, f) => {
    if (e === !1)
      throw new Ri(
        a(h, " has been removed" + (t ? " in " + t : "")),
        Ri.ERR_DEPRECATED
      );
    return t && !Of[h] && (Of[h] = !0, console.warn(
      a(
        h,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(o, h, f) : !0;
  };
};
Bl.spelling = function(e) {
  return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
function xx(b, e, t) {
  if (typeof b != "object")
    throw new Ri("options must be an object", Ri.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(b);
  let a = n.length;
  for (; a-- > 0; ) {
    const o = n[a], h = e[o];
    if (h) {
      const f = b[o], v = f === void 0 || h(f, o, b);
      if (v !== !0)
        throw new Ri("option " + o + " must be " + v, Ri.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (t !== !0)
      throw new Ri("Unknown option " + o, Ri.ERR_BAD_OPTION);
  }
}
const al = {
  assertOptions: xx,
  validators: Bl
}, bs = al.validators;
class ml {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new wf(),
      response: new wf()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (n) {
      if (n instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? o && !String(n.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + o) : n.stack = o;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = ha(this.defaults, t);
    const { transitional: n, paramsSerializer: a, headers: o } = t;
    n !== void 0 && al.assertOptions(n, {
      silentJSONParsing: bs.transitional(bs.boolean),
      forcedJSONParsing: bs.transitional(bs.boolean),
      clarifyTimeoutError: bs.transitional(bs.boolean)
    }, !1), a != null && (Mt.isFunction(a) ? t.paramsSerializer = {
      serialize: a
    } : al.assertOptions(a, {
      encode: bs.function,
      serialize: bs.function
    }, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), al.assertOptions(t, {
      baseUrl: bs.spelling("baseURL"),
      withXsrfToken: bs.spelling("withXSRFToken")
    }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let h = o && Mt.merge(
      o.common,
      o[t.method]
    );
    o && Mt.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (W) => {
        delete o[W];
      }
    ), t.headers = us.concat(h, o);
    const f = [];
    let v = !0;
    this.interceptors.request.forEach(function(U) {
      typeof U.runWhen == "function" && U.runWhen(t) === !1 || (v = v && U.synchronous, f.unshift(U.fulfilled, U.rejected));
    });
    const x = [];
    this.interceptors.response.forEach(function(U) {
      x.push(U.fulfilled, U.rejected);
    });
    let k, I = 0, V;
    if (!v) {
      const W = [Pf.bind(this), void 0];
      for (W.unshift(...f), W.push(...x), V = W.length, k = Promise.resolve(t); I < V; )
        k = k.then(W[I++], W[I++]);
      return k;
    }
    V = f.length;
    let M = t;
    for (; I < V; ) {
      const W = f[I++], U = f[I++];
      try {
        M = W(M);
      } catch (Q) {
        U.call(this, Q);
        break;
      }
    }
    try {
      k = Pf.call(this, M);
    } catch (W) {
      return Promise.reject(W);
    }
    for (I = 0, V = x.length; I < V; )
      k = k.then(x[I++], x[I++]);
    return k;
  }
  getUri(e) {
    e = ha(this.defaults, e);
    const t = Md(e.baseURL, e.url, e.allowAbsoluteUrls);
    return yd(t, e.params, e.paramsSerializer);
  }
}
Mt.forEach(["delete", "get", "head", "options"], function(e) {
  ml.prototype[e] = function(t, n) {
    return this.request(ha(n || {}, {
      method: e,
      url: t,
      data: (n || {}).data
    }));
  };
});
Mt.forEach(["post", "put", "patch"], function(e) {
  function t(n) {
    return function(o, h, f) {
      return this.request(ha(f || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: h
      }));
    };
  }
  ml.prototype[e] = t(), ml.prototype[e + "Form"] = t(!0);
});
const ol = ml;
class nu {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(o) {
      t = o;
    });
    const n = this;
    this.promise.then((a) => {
      if (!n._listeners)
        return;
      let o = n._listeners.length;
      for (; o-- > 0; )
        n._listeners[o](a);
      n._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const h = new Promise((f) => {
        n.subscribe(f), o = f;
      }).then(a);
      return h.cancel = function() {
        n.unsubscribe(o);
      }, h;
    }, e(function(o, h, f) {
      n.reason || (n.reason = new Ba(o, h, f), t(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(e);
    t !== -1 && this._listeners.splice(t, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), t = (n) => {
      e.abort(n);
    };
    return this.subscribe(t), e.signal.unsubscribe = () => this.unsubscribe(t), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new nu(function(a) {
        e = a;
      }),
      cancel: e
    };
  }
}
const wx = nu;
function Sx(b) {
  return function(t) {
    return b.apply(null, t);
  };
}
function Mx(b) {
  return Mt.isObject(b) && b.isAxiosError === !0;
}
const Fh = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(Fh).forEach(([b, e]) => {
  Fh[e] = b;
});
const Cx = Fh;
function Bd(b) {
  const e = new ol(b), t = od(ol.prototype.request, e);
  return Mt.extend(t, ol.prototype, e, { allOwnKeys: !0 }), Mt.extend(t, e, null, { allOwnKeys: !0 }), t.create = function(a) {
    return Bd(ha(b, a));
  }, t;
}
const Gn = Bd(tu);
Gn.Axios = ol;
Gn.CanceledError = Ba;
Gn.CancelToken = wx;
Gn.isCancel = wd;
Gn.VERSION = Ld;
Gn.toFormData = Tl;
Gn.AxiosError = Ri;
Gn.Cancel = Gn.CanceledError;
Gn.all = function(e) {
  return Promise.all(e);
};
Gn.spread = Sx;
Gn.isAxiosError = Mx;
Gn.mergeConfig = ha;
Gn.AxiosHeaders = us;
Gn.formToJSON = (b) => xd(Mt.isHTMLForm(b) ? new FormData(b) : b);
Gn.getAdapter = Td.getAdapter;
Gn.HttpStatusCode = Cx;
Gn.default = Gn;
const Nf = Gn;
class Rf {
  constructor(e, t, n = !0) {
    this.tasksUrl = e, this.token = t, this.upload = async (a, o) => await this.uploadFileChunked(a, a.type, Zakeke.generateUUID(), o), this.uploadFileChunked = async (a, o, h, f, v) => {
      if (await this.resumableUpload(a, o, h, v) === "OK") {
        let k = await this.createTask(h, f);
        if (k !== -1) {
          let I = await this.getResultFromTask(k);
          if (I)
            return I.files;
        } else
          throw "Upload failed";
      }
      return null;
    }, this.resumableUpload = async (a, o, h, f) => new Promise((v, x) => {
      let k = new Resumable({
        target: Zakeke.config.baseApiUrl + "filechunks/upload",
        generateUniqueIdentifier: function() {
          return h;
        },
        maxFiles: 1,
        testChunks: !1,
        headers: this.headers,
        query: { resumableType: o },
        simultaneousUploads: 3
      });
      k.addFile(a), k.on("fileError", function(I, V) {
        v("KO"), console.error("fileError", I, V);
      }), k.on("error", function(I, V) {
        v("KO"), console.error("error", I, V);
      }), k.on("progress", function() {
        let I = k.progress() * 100;
        f && f(I);
      }), k.on("fileAdded", function(I, V) {
        k.upload();
      }), k.on("complete", function() {
        v("OK");
      });
    }), this.createTask = async (a, o) => {
      let h = { fileID: a, options: o }, f = await Nf.post(Zakeke.config.baseApiUrl + this.tasksUrl, h, { headers: this.headers });
      return f ? f.data.taskID : -1;
    }, this.getResultFromTask = async (a) => {
      let o = 0;
      for (; ; ) {
        try {
          let h = await Nf.get(
            Zakeke.config.baseApiUrl + this.tasksUrl + "/results/" + a,
            { headers: this.headers }
          );
          if (h && h.data.state === 2)
            return h.data;
          if (h && h.data.state === 3)
            return null;
        } catch {
          return null;
        }
        if (o++, o > 200)
          return null;
        await new Promise((h) => setTimeout(h, 1e3));
      }
    }, n ? this.headers = {
      Authorization: "Bearer " + this.token,
      "Accept-Language": "en-US"
    } : this.headers = {
      "X-Auth-Token": this.token,
      "Accept-Language": "en-US"
    };
  }
}
class ci {
}
ci.Environment = {
  //EnvironmentTextureName: "environmentSpecular.dds",
  EnvironmentTextureName: "environmentSpecular_0af79b7524dc4cd4825eae49c5d9e22fae220fd.env",
  GroundTextureCDNUrl: "https://cdn.zakeke.com/cdn/3d/assets/environments/backgroundGround9.png",
  SkyboxTextureCDNUrl: "https://cdn.zakeke.com/cdn/3d/assets/environments/backgroundSkybox.dds",
  //EnvironmentTextureCDNUrl: "https://zakekecdn.azureedge.net/cdn/3d/assets/environments/environmentSpecular.dds"
  //EnvironmentTextureCDNUrl: "https://cdn.zakeke.com/cdn/3d/assets/environments/environmentSpecular.dds"
  EnvironmentTextureCDNUrl: "https://zakekecdn.blob.core.windows.net/cdn/3d/assets/environments/environmentSpecular_0af79b7524dc4cd4825eae49c5d9e22fae220fd.env"
};
ci.TryonReferences = {
  RootUrl: "https://cdn.zakeke.com/cdn/3d/assets/tryon/references/",
  ReferenceGlassesFrameName: "Reference Glasses Frame",
  ReferenceGlassesFrameFileName: "Reference_Glasses_Frame_001.json",
  EyewearName: "glasses_VTO_Reference",
  EyewearURL: "Eyewear_VTO_Reference.babylon",
  EyewearDownloadableURL: "Eyewear_VTO_Reference.glb",
  ScarvesName: "scarves_VTO_Reference",
  ScarvesURL: "Scarves_VTO_Reference.babylon",
  ScarvesDownloadableURL: "Scarves_VTO_Reference.glb",
  EarringsName: "earrings_VTO_Reference",
  EarringsURL: "Earrings_VTO_Reference.babylon",
  EarringsDownloadableURL: "Earrings_VTO_Reference.glb",
  HeadwearName: "headwear_VTO_Reference",
  HeadwearURL: "Headwear_VTO_Reference.babylon",
  HeadwearDownloadableURL: "Headwear_VTO_Reference.glb",
  NecklaceName: "necklace_VTO_Reference",
  NecklaceURL: "Necklace_VTO_Reference.babylon",
  NecklaceDownloadableURL: "Necklace_VTO_Reference.glb",
  ShoeName: "foot_VTO_Reference",
  ShoeURL: "Foot_VTO_Reference.babylon",
  ShoeDownloadableURL: "Foot_VTO_Reference.glb"
};
ci.Shapes = {
  RootUrl: "https://cdn.zakeke.com/cdn/3d/assets/shapes/",
  RoundedCubeName: "Rounded Cube",
  RoundedCubeFileName: "rounded_cube.babylon",
  RoundedCylinderName: "Rounded Cylinder",
  RoundedCylinderFileName: "rounded_cylinder.babylon",
  MatBallName: "Mat Ball",
  MatBallFileName: "mat_ball.babylon",
  MaleHeadName: "Group48944",
  MaleHeadFileName: "DemoHead.babylon",
  FemaleHeadName: "Group12208",
  FemaleHeadFileName: "FemaleHead.babylon",
  PokemonBallName: "PokemonBall",
  PokemonBallFileName: "PokemonBall.babylon",
  ShaderBallName: "Elements",
  ShaderBallFileName: "ShaderBall.babylon",
  BootsFolder: "boots/",
  BootsName: "shoe",
  BootsFileName: "boots.incremental.babylon",
  SuzanneName: "Suzanne",
  SuzanneFileName: "suzanne.babylon",
  StepPyramidName: "Pyramid",
  StepPyramidFileName: "step-pyramid.babylon",
  TeapotName: "Teapot",
  TeapotFileName: "teapot.babylon",
  AlloyWheelName: "Wheel",
  AlloyWheelFolder: "alloy_wheel/",
  AlloyWheelFileName: "alloy_wheel.incremental.babylon"
};
class xs {
  /**
   * Checks for a matching suffix at the end of a string (for ES5 and lower)
   * @param str Source string
   * @param suffix Suffix to search for in the source string
   * @returns Boolean indicating whether the suffix was found (true) or not (false)
   */
  static EndsWith(e, t) {
    return e.indexOf(t, e.length - t.length) !== -1;
  }
  /**
   * Checks for a matching suffix at the beginning of a string (for ES5 and lower)
   * @param str Source string
   * @param suffix Suffix to search for in the source string
   * @returns Boolean indicating whether the suffix was found (true) or not (false)
   */
  static StartsWith(e, t) {
    return e.indexOf(t) === 0;
  }
  /**
   * Decodes a buffer into a string
   * @param buffer The buffer to decode
   * @returns The decoded string
   */
  static Decode(e) {
    if (typeof TextDecoder < "u")
      return new TextDecoder().decode(e);
    let t = "";
    for (let n = 0; n < e.byteLength; n++)
      t += String.fromCharCode(e[n]);
    return t;
  }
  /**
   * Encode a buffer to a base64 string
   * @param buffer defines the buffer to encode
   * @returns the encoded string
   */
  static EncodeArrayBufferToBase64(e) {
    for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", n = "", a, o, h, f, v, x, k, I = 0, V = ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : new Uint8Array(e); I < V.length; )
      a = V[I++], o = I < V.length ? V[I++] : Number.NaN, h = I < V.length ? V[I++] : Number.NaN, f = a >> 2, v = (a & 3) << 4 | o >> 4, x = (o & 15) << 2 | h >> 6, k = h & 63, isNaN(o) ? x = k = 64 : isNaN(h) && (k = 64), n += t.charAt(f) + t.charAt(v) + t.charAt(x) + t.charAt(k);
    return n;
  }
}
class Ax {
  constructor() {
    this._mesh = null, this._scene = null, this._facesOfVertices = null, this._meshVerticesPositions = null, this._meshVerticesNormals = null, this._meshIndices = null, this._meshPositions = null, this._meshFacesNormals = null, this._sharedFacesOfVertices = {};
  }
  dispose() {
  }
  resetDataModel() {
    this._facesOfVertices = null, this._meshVerticesPositions = null, this._meshVerticesNormals = null, this._meshIndices = null, this._meshPositions = null, this._meshFacesNormals = null, this._sharedFacesOfVertices = {};
  }
  prepareDataModel() {
    if (this.resetDataModel(), this._mesh && this._scene && (this._facesOfVertices = [], this._sharedFacesOfVertices = {}, this._meshVerticesPositions = this._mesh.getVerticesData(BABYLON.VertexBuffer.PositionKind), this._meshVerticesNormals = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind), this._meshIndices = this._mesh.getIndices(), this._meshPositions = [], this._meshFacesNormals = [], this._meshVerticesPositions && this._meshVerticesNormals && this._meshIndices)) {
      for (let e = 0; e < this._meshVerticesPositions.length; e += 3)
        this._meshPositions.push(new BABYLON.Vector3(this._meshVerticesPositions[e], this._meshVerticesPositions[e + 1], this._meshVerticesPositions[e + 2]));
      for (let e = 0; e < this._mesh.getTotalIndices() / 3; e++)
        this._computeFaceNormal(e);
      this._getFacesOfVertices();
    }
  }
  _getFaceVerticesIndex(e) {
    return this._meshIndices ? {
      v1: this._meshIndices[e * 3],
      v2: this._meshIndices[e * 3 + 1],
      v3: this._meshIndices[e * 3 + 2]
    } : null;
  }
  // La normale ad una faccia è calcolata come prodotto vettoriale (cross product)
  // tra i vettori che connettono gli spigoli
  _computeFaceNormal(e) {
    if (this._meshPositions && this._meshIndices && this._meshFacesNormals) {
      const t = this._getFaceVerticesIndex(e);
      if (t) {
        const n = this._meshPositions[t.v1].subtract(this._meshPositions[t.v2]), a = this._meshPositions[t.v3].subtract(this._meshPositions[t.v2]);
        this._meshFacesNormals[e] = BABYLON.Vector3.Normalize(BABYLON.Vector3.Cross(n, a));
      }
    }
  }
  _getPositionKey(e) {
    return `${e.x}_${e.y}_${e.z}`;
  }
  // Determina le facce di ogni vertice sia considerando vertici uguali ripetuti più volte (_facesOfVertices)
  // che quelle condivise da uno stesso vertice ripetuto (_sharedFacesOfVertices). Queste ultime saranno
  // quelle che verranno considerate per il calcolo della normale risultante da tutte le facce che hanno
  // un vertice come spigolo.
  _getFacesOfVertices() {
    if (this._mesh && this._meshPositions && this._meshIndices) {
      this._sharedFacesOfVertices = {}, this._facesOfVertices = [];
      for (let e = 0; e < this._meshPositions.length; e++) {
        this._facesOfVertices[e] = [];
        const t = this._meshPositions[e], n = this._getPositionKey(t);
        this._sharedFacesOfVertices.hasOwnProperty(n) || (this._sharedFacesOfVertices[n] = /* @__PURE__ */ new Set());
      }
      for (let e = 0; e < this._meshIndices.length; e++) {
        const t = this._meshIndices[e], n = e / 3 | 0;
        this._facesOfVertices[t].push(n);
        const a = this._meshPositions[t], o = this._getPositionKey(a);
        this._sharedFacesOfVertices.hasOwnProperty(o) && this._sharedFacesOfVertices[o].add(n);
      }
    }
  }
  expandMesh(e, t = 0.01) {
    if (e instanceof BABYLON.Mesh && (this._mesh = e, this._scene = e.getScene(), this.prepareDataModel(), this._meshPositions && this._meshVerticesPositions && this._meshVerticesNormals)) {
      for (let n = 0; n < this._meshPositions.length; n++) {
        const a = this._meshPositions[n], o = this._getVertexComputedNormal(n);
        if (o) {
          const h = o.scale(t);
          a.addInPlace(h), this._meshVerticesPositions[n * 3] = a.x, this._meshVerticesPositions[n * 3 + 1] = a.y, this._meshVerticesPositions[n * 3 + 2] = a.z;
        }
      }
      this._mesh.markVerticesDataAsUpdatable(BABYLON.VertexBuffer.PositionKind, !0), this._mesh.updateVerticesData(BABYLON.VertexBuffer.PositionKind, this._meshVerticesPositions), this._mesh.computeWorldMatrix(!0);
    }
  }
  _reComputeNormals() {
    const e = [];
    if (this._meshPositions && this._facesOfVertices) {
      for (let n = 0; n < this._meshPositions.length; n++) {
        const a = this._facesOfVertices[n];
        for (let o = 0; o < a.length; o++)
          e[a[o]] = !0;
      }
      let t;
      for (t in e)
        this._computeFaceNormal(t);
      for (t in e) {
        const n = this._getFaceVerticesIndex(t);
        n && (this._computeNormal(n.v1), this._computeNormal(n.v2), this._computeNormal(n.v3));
      }
    }
  }
  _getVertexComputedNormal(e) {
    let t = null;
    if (this._meshPositions && this._meshFacesNormals) {
      const n = this._meshPositions, a = this._meshFacesNormals, o = n[e], h = this._getPositionKey(o);
      if (this._sharedFacesOfVertices.hasOwnProperty(h)) {
        const f = this._sharedFacesOfVertices[h];
        t = BABYLON.Vector3.Zero(), f.forEach((v) => {
          const x = a[v];
          t && x && (t = t.add(x));
        }), t = BABYLON.Vector3.Normalize(t.scale(1 / f.size));
      }
    }
    return t;
  }
  _computeNormal(e) {
    const t = this._getVertexComputedNormal(e);
    t && this._meshVerticesNormals && (this._meshVerticesNormals[e * 3] = t.x, this._meshVerticesNormals[e * 3 + 1] = t.y, this._meshVerticesNormals[e * 3 + 2] = t.z);
  }
}
class Tx {
  static async convertGlbToUsdz(e) {
    return new Promise((t, n) => {
      let a = null;
      new THREE.GLTFLoader().load(e, async function(h) {
        h.scene.updateWorldMatrix(!0, !0);
        const v = await new THREE.USDZExporter().parse(h.scene);
        a = new Blob([v], { type: "model/vnd.usdz+zip" }), t(a);
      });
    });
  }
}
var ts = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ru(b) {
  return b && b.__esModule && Object.prototype.hasOwnProperty.call(b, "default") ? b.default : b;
}
function Lx(b) {
  if (b.__esModule)
    return b;
  var e = b.default;
  if (typeof e == "function") {
    var t = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else
    t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(b).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(b, n);
    Object.defineProperty(t, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return b[n];
      }
    });
  }), t;
}
function qa(b) {
  throw new Error('Could not dynamically require "' + b + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var kd = { exports: {} };
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/
(function(b, e) {
  (function(t) {
    b.exports = t();
  })(function() {
    return function t(n, a, o) {
      function h(x, k) {
        if (!a[x]) {
          if (!n[x]) {
            var I = typeof qa == "function" && qa;
            if (!k && I)
              return I(x, !0);
            if (f)
              return f(x, !0);
            var V = new Error("Cannot find module '" + x + "'");
            throw V.code = "MODULE_NOT_FOUND", V;
          }
          var M = a[x] = { exports: {} };
          n[x][0].call(M.exports, function(W) {
            var U = n[x][1][W];
            return h(U || W);
          }, M, M.exports, t, n, a, o);
        }
        return a[x].exports;
      }
      for (var f = typeof qa == "function" && qa, v = 0; v < o.length; v++)
        h(o[v]);
      return h;
    }({ 1: [function(t, n, a) {
      var o = t("./utils"), h = t("./support"), f = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      a.encode = function(v) {
        for (var x, k, I, V, M, W, U, Q = [], D = 0, ee = v.length, J = ee, he = o.getTypeOf(v) !== "string"; D < v.length; )
          J = ee - D, I = he ? (x = v[D++], k = D < ee ? v[D++] : 0, D < ee ? v[D++] : 0) : (x = v.charCodeAt(D++), k = D < ee ? v.charCodeAt(D++) : 0, D < ee ? v.charCodeAt(D++) : 0), V = x >> 2, M = (3 & x) << 4 | k >> 4, W = 1 < J ? (15 & k) << 2 | I >> 6 : 64, U = 2 < J ? 63 & I : 64, Q.push(f.charAt(V) + f.charAt(M) + f.charAt(W) + f.charAt(U));
        return Q.join("");
      }, a.decode = function(v) {
        var x, k, I, V, M, W, U = 0, Q = 0, D = "data:";
        if (v.substr(0, D.length) === D)
          throw new Error("Invalid base64 input, it looks like a data url.");
        var ee, J = 3 * (v = v.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
        if (v.charAt(v.length - 1) === f.charAt(64) && J--, v.charAt(v.length - 2) === f.charAt(64) && J--, J % 1 != 0)
          throw new Error("Invalid base64 input, bad content length.");
        for (ee = h.uint8array ? new Uint8Array(0 | J) : new Array(0 | J); U < v.length; )
          x = f.indexOf(v.charAt(U++)) << 2 | (V = f.indexOf(v.charAt(U++))) >> 4, k = (15 & V) << 4 | (M = f.indexOf(v.charAt(U++))) >> 2, I = (3 & M) << 6 | (W = f.indexOf(v.charAt(U++))), ee[Q++] = x, M !== 64 && (ee[Q++] = k), W !== 64 && (ee[Q++] = I);
        return ee;
      };
    }, { "./support": 30, "./utils": 32 }], 2: [function(t, n, a) {
      var o = t("./external"), h = t("./stream/DataWorker"), f = t("./stream/Crc32Probe"), v = t("./stream/DataLengthProbe");
      function x(k, I, V, M, W) {
        this.compressedSize = k, this.uncompressedSize = I, this.crc32 = V, this.compression = M, this.compressedContent = W;
      }
      x.prototype = { getContentWorker: function() {
        var k = new h(o.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new v("data_length")), I = this;
        return k.on("end", function() {
          if (this.streamInfo.data_length !== I.uncompressedSize)
            throw new Error("Bug : uncompressed data size mismatch");
        }), k;
      }, getCompressedWorker: function() {
        return new h(o.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
      } }, x.createWorkerFrom = function(k, I, V) {
        return k.pipe(new f()).pipe(new v("uncompressedSize")).pipe(I.compressWorker(V)).pipe(new v("compressedSize")).withStreamInfo("compression", I);
      }, n.exports = x;
    }, { "./external": 6, "./stream/Crc32Probe": 25, "./stream/DataLengthProbe": 26, "./stream/DataWorker": 27 }], 3: [function(t, n, a) {
      var o = t("./stream/GenericWorker");
      a.STORE = { magic: "\0\0", compressWorker: function() {
        return new o("STORE compression");
      }, uncompressWorker: function() {
        return new o("STORE decompression");
      } }, a.DEFLATE = t("./flate");
    }, { "./flate": 7, "./stream/GenericWorker": 28 }], 4: [function(t, n, a) {
      var o = t("./utils"), h = function() {
        for (var f, v = [], x = 0; x < 256; x++) {
          f = x;
          for (var k = 0; k < 8; k++)
            f = 1 & f ? 3988292384 ^ f >>> 1 : f >>> 1;
          v[x] = f;
        }
        return v;
      }();
      n.exports = function(f, v) {
        return f !== void 0 && f.length ? o.getTypeOf(f) !== "string" ? function(x, k, I, V) {
          var M = h, W = V + I;
          x ^= -1;
          for (var U = V; U < W; U++)
            x = x >>> 8 ^ M[255 & (x ^ k[U])];
          return -1 ^ x;
        }(0 | v, f, f.length, 0) : function(x, k, I, V) {
          var M = h, W = V + I;
          x ^= -1;
          for (var U = V; U < W; U++)
            x = x >>> 8 ^ M[255 & (x ^ k.charCodeAt(U))];
          return -1 ^ x;
        }(0 | v, f, f.length, 0) : 0;
      };
    }, { "./utils": 32 }], 5: [function(t, n, a) {
      a.base64 = !1, a.binary = !1, a.dir = !1, a.createFolders = !0, a.date = null, a.compression = null, a.compressionOptions = null, a.comment = null, a.unixPermissions = null, a.dosPermissions = null;
    }, {}], 6: [function(t, n, a) {
      var o = null;
      o = typeof Promise < "u" ? Promise : t("lie"), n.exports = { Promise: o };
    }, { lie: 37 }], 7: [function(t, n, a) {
      var o = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Uint32Array < "u", h = t("pako"), f = t("./utils"), v = t("./stream/GenericWorker"), x = o ? "uint8array" : "array";
      function k(I, V) {
        v.call(this, "FlateWorker/" + I), this._pako = null, this._pakoAction = I, this._pakoOptions = V, this.meta = {};
      }
      a.magic = "\b\0", f.inherits(k, v), k.prototype.processChunk = function(I) {
        this.meta = I.meta, this._pako === null && this._createPako(), this._pako.push(f.transformTo(x, I.data), !1);
      }, k.prototype.flush = function() {
        v.prototype.flush.call(this), this._pako === null && this._createPako(), this._pako.push([], !0);
      }, k.prototype.cleanUp = function() {
        v.prototype.cleanUp.call(this), this._pako = null;
      }, k.prototype._createPako = function() {
        this._pako = new h[this._pakoAction]({ raw: !0, level: this._pakoOptions.level || -1 });
        var I = this;
        this._pako.onData = function(V) {
          I.push({ data: V, meta: I.meta });
        };
      }, a.compressWorker = function(I) {
        return new k("Deflate", I);
      }, a.uncompressWorker = function() {
        return new k("Inflate", {});
      };
    }, { "./stream/GenericWorker": 28, "./utils": 32, pako: 38 }], 8: [function(t, n, a) {
      function o(M, W) {
        var U, Q = "";
        for (U = 0; U < W; U++)
          Q += String.fromCharCode(255 & M), M >>>= 8;
        return Q;
      }
      function h(M, W, U, Q, D, ee) {
        var J, he, fe = M.file, X = M.compression, Z = ee !== x.utf8encode, qe = f.transformTo("string", ee(fe.name)), Oe = f.transformTo("string", x.utf8encode(fe.name)), je = fe.comment, pt = f.transformTo("string", ee(je)), Te = f.transformTo("string", x.utf8encode(je)), Ze = Oe.length !== fe.name.length, ce = Te.length !== je.length, ut = "", ze = "", ht = "", Gt = fe.dir, $e = fe.date, It = { crc32: 0, compressedSize: 0, uncompressedSize: 0 };
        W && !U || (It.crc32 = M.crc32, It.compressedSize = M.compressedSize, It.uncompressedSize = M.uncompressedSize);
        var rt = 0;
        W && (rt |= 8), Z || !Ze && !ce || (rt |= 2048);
        var it = 0, Xt = 0;
        Gt && (it |= 16), D === "UNIX" ? (Xt = 798, it |= function(Tt, Bi) {
          var en = Tt;
          return Tt || (en = Bi ? 16893 : 33204), (65535 & en) << 16;
        }(fe.unixPermissions, Gt)) : (Xt = 20, it |= function(Tt) {
          return 63 & (Tt || 0);
        }(fe.dosPermissions)), J = $e.getUTCHours(), J <<= 6, J |= $e.getUTCMinutes(), J <<= 5, J |= $e.getUTCSeconds() / 2, he = $e.getUTCFullYear() - 1980, he <<= 4, he |= $e.getUTCMonth() + 1, he <<= 5, he |= $e.getUTCDate(), Ze && (ze = o(1, 1) + o(k(qe), 4) + Oe, ut += "up" + o(ze.length, 2) + ze), ce && (ht = o(1, 1) + o(k(pt), 4) + Te, ut += "uc" + o(ht.length, 2) + ht);
        var $t = "";
        return $t += `
\0`, $t += o(rt, 2), $t += X.magic, $t += o(J, 2), $t += o(he, 2), $t += o(It.crc32, 4), $t += o(It.compressedSize, 4), $t += o(It.uncompressedSize, 4), $t += o(qe.length, 2), $t += o(ut.length, 2), { fileRecord: I.LOCAL_FILE_HEADER + $t + qe + ut, dirRecord: I.CENTRAL_FILE_HEADER + o(Xt, 2) + $t + o(pt.length, 2) + "\0\0\0\0" + o(it, 4) + o(Q, 4) + qe + ut + pt };
      }
      var f = t("../utils"), v = t("../stream/GenericWorker"), x = t("../utf8"), k = t("../crc32"), I = t("../signature");
      function V(M, W, U, Q) {
        v.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = W, this.zipPlatform = U, this.encodeFileName = Q, this.streamFiles = M, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
      }
      f.inherits(V, v), V.prototype.push = function(M) {
        var W = M.meta.percent || 0, U = this.entriesCount, Q = this._sources.length;
        this.accumulate ? this.contentBuffer.push(M) : (this.bytesWritten += M.data.length, v.prototype.push.call(this, { data: M.data, meta: { currentFile: this.currentFile, percent: U ? (W + 100 * (U - Q - 1)) / U : 100 } }));
      }, V.prototype.openedSource = function(M) {
        this.currentSourceOffset = this.bytesWritten, this.currentFile = M.file.name;
        var W = this.streamFiles && !M.file.dir;
        if (W) {
          var U = h(M, W, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
          this.push({ data: U.fileRecord, meta: { percent: 0 } });
        } else
          this.accumulate = !0;
      }, V.prototype.closedSource = function(M) {
        this.accumulate = !1;
        var W = this.streamFiles && !M.file.dir, U = h(M, W, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        if (this.dirRecords.push(U.dirRecord), W)
          this.push({ data: function(Q) {
            return I.DATA_DESCRIPTOR + o(Q.crc32, 4) + o(Q.compressedSize, 4) + o(Q.uncompressedSize, 4);
          }(M), meta: { percent: 100 } });
        else
          for (this.push({ data: U.fileRecord, meta: { percent: 0 } }); this.contentBuffer.length; )
            this.push(this.contentBuffer.shift());
        this.currentFile = null;
      }, V.prototype.flush = function() {
        for (var M = this.bytesWritten, W = 0; W < this.dirRecords.length; W++)
          this.push({ data: this.dirRecords[W], meta: { percent: 100 } });
        var U = this.bytesWritten - M, Q = function(D, ee, J, he, fe) {
          var X = f.transformTo("string", fe(he));
          return I.CENTRAL_DIRECTORY_END + "\0\0\0\0" + o(D, 2) + o(D, 2) + o(ee, 4) + o(J, 4) + o(X.length, 2) + X;
        }(this.dirRecords.length, U, M, this.zipComment, this.encodeFileName);
        this.push({ data: Q, meta: { percent: 100 } });
      }, V.prototype.prepareNextSource = function() {
        this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
      }, V.prototype.registerPrevious = function(M) {
        this._sources.push(M);
        var W = this;
        return M.on("data", function(U) {
          W.processChunk(U);
        }), M.on("end", function() {
          W.closedSource(W.previous.streamInfo), W._sources.length ? W.prepareNextSource() : W.end();
        }), M.on("error", function(U) {
          W.error(U);
        }), this;
      }, V.prototype.resume = function() {
        return !!v.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
      }, V.prototype.error = function(M) {
        var W = this._sources;
        if (!v.prototype.error.call(this, M))
          return !1;
        for (var U = 0; U < W.length; U++)
          try {
            W[U].error(M);
          } catch {
          }
        return !0;
      }, V.prototype.lock = function() {
        v.prototype.lock.call(this);
        for (var M = this._sources, W = 0; W < M.length; W++)
          M[W].lock();
      }, n.exports = V;
    }, { "../crc32": 4, "../signature": 23, "../stream/GenericWorker": 28, "../utf8": 31, "../utils": 32 }], 9: [function(t, n, a) {
      var o = t("../compressions"), h = t("./ZipFileWorker");
      a.generateWorker = function(f, v, x) {
        var k = new h(v.streamFiles, x, v.platform, v.encodeFileName), I = 0;
        try {
          f.forEach(function(V, M) {
            I++;
            var W = function(ee, J) {
              var he = ee || J, fe = o[he];
              if (!fe)
                throw new Error(he + " is not a valid compression method !");
              return fe;
            }(M.options.compression, v.compression), U = M.options.compressionOptions || v.compressionOptions || {}, Q = M.dir, D = M.date;
            M._compressWorker(W, U).withStreamInfo("file", { name: V, dir: Q, date: D, comment: M.comment || "", unixPermissions: M.unixPermissions, dosPermissions: M.dosPermissions }).pipe(k);
          }), k.entriesCount = I;
        } catch (V) {
          k.error(V);
        }
        return k;
      };
    }, { "../compressions": 3, "./ZipFileWorker": 8 }], 10: [function(t, n, a) {
      function o() {
        if (!(this instanceof o))
          return new o();
        if (arguments.length)
          throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
        this.files = /* @__PURE__ */ Object.create(null), this.comment = null, this.root = "", this.clone = function() {
          var h = new o();
          for (var f in this)
            typeof this[f] != "function" && (h[f] = this[f]);
          return h;
        };
      }
      (o.prototype = t("./object")).loadAsync = t("./load"), o.support = t("./support"), o.defaults = t("./defaults"), o.version = "3.10.1", o.loadAsync = function(h, f) {
        return new o().loadAsync(h, f);
      }, o.external = t("./external"), n.exports = o;
    }, { "./defaults": 5, "./external": 6, "./load": 11, "./object": 15, "./support": 30 }], 11: [function(t, n, a) {
      var o = t("./utils"), h = t("./external"), f = t("./utf8"), v = t("./zipEntries"), x = t("./stream/Crc32Probe"), k = t("./nodejsUtils");
      function I(V) {
        return new h.Promise(function(M, W) {
          var U = V.decompressed.getContentWorker().pipe(new x());
          U.on("error", function(Q) {
            W(Q);
          }).on("end", function() {
            U.streamInfo.crc32 !== V.decompressed.crc32 ? W(new Error("Corrupted zip : CRC32 mismatch")) : M();
          }).resume();
        });
      }
      n.exports = function(V, M) {
        var W = this;
        return M = o.extend(M || {}, { base64: !1, checkCRC32: !1, optimizedBinaryString: !1, createFolders: !1, decodeFileName: f.utf8decode }), k.isNode && k.isStream(V) ? h.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : o.prepareContent("the loaded zip file", V, !0, M.optimizedBinaryString, M.base64).then(function(U) {
          var Q = new v(M);
          return Q.load(U), Q;
        }).then(function(U) {
          var Q = [h.Promise.resolve(U)], D = U.files;
          if (M.checkCRC32)
            for (var ee = 0; ee < D.length; ee++)
              Q.push(I(D[ee]));
          return h.Promise.all(Q);
        }).then(function(U) {
          for (var Q = U.shift(), D = Q.files, ee = 0; ee < D.length; ee++) {
            var J = D[ee], he = J.fileNameStr, fe = o.resolve(J.fileNameStr);
            W.file(fe, J.decompressed, { binary: !0, optimizedBinaryString: !0, date: J.date, dir: J.dir, comment: J.fileCommentStr.length ? J.fileCommentStr : null, unixPermissions: J.unixPermissions, dosPermissions: J.dosPermissions, createFolders: M.createFolders }), J.dir || (W.file(fe).unsafeOriginalName = he);
          }
          return Q.zipComment.length && (W.comment = Q.zipComment), W;
        });
      };
    }, { "./external": 6, "./nodejsUtils": 14, "./stream/Crc32Probe": 25, "./utf8": 31, "./utils": 32, "./zipEntries": 33 }], 12: [function(t, n, a) {
      var o = t("../utils"), h = t("../stream/GenericWorker");
      function f(v, x) {
        h.call(this, "Nodejs stream input adapter for " + v), this._upstreamEnded = !1, this._bindStream(x);
      }
      o.inherits(f, h), f.prototype._bindStream = function(v) {
        var x = this;
        (this._stream = v).pause(), v.on("data", function(k) {
          x.push({ data: k, meta: { percent: 0 } });
        }).on("error", function(k) {
          x.isPaused ? this.generatedError = k : x.error(k);
        }).on("end", function() {
          x.isPaused ? x._upstreamEnded = !0 : x.end();
        });
      }, f.prototype.pause = function() {
        return !!h.prototype.pause.call(this) && (this._stream.pause(), !0);
      }, f.prototype.resume = function() {
        return !!h.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
      }, n.exports = f;
    }, { "../stream/GenericWorker": 28, "../utils": 32 }], 13: [function(t, n, a) {
      var o = t("readable-stream").Readable;
      function h(f, v, x) {
        o.call(this, v), this._helper = f;
        var k = this;
        f.on("data", function(I, V) {
          k.push(I) || k._helper.pause(), x && x(V);
        }).on("error", function(I) {
          k.emit("error", I);
        }).on("end", function() {
          k.push(null);
        });
      }
      t("../utils").inherits(h, o), h.prototype._read = function() {
        this._helper.resume();
      }, n.exports = h;
    }, { "../utils": 32, "readable-stream": 16 }], 14: [function(t, n, a) {
      n.exports = { isNode: typeof Buffer < "u", newBufferFrom: function(o, h) {
        if (Buffer.from && Buffer.from !== Uint8Array.from)
          return Buffer.from(o, h);
        if (typeof o == "number")
          throw new Error('The "data" argument must not be a number');
        return new Buffer(o, h);
      }, allocBuffer: function(o) {
        if (Buffer.alloc)
          return Buffer.alloc(o);
        var h = new Buffer(o);
        return h.fill(0), h;
      }, isBuffer: function(o) {
        return Buffer.isBuffer(o);
      }, isStream: function(o) {
        return o && typeof o.on == "function" && typeof o.pause == "function" && typeof o.resume == "function";
      } };
    }, {}], 15: [function(t, n, a) {
      function o(fe, X, Z) {
        var qe, Oe = f.getTypeOf(X), je = f.extend(Z || {}, k);
        je.date = je.date || /* @__PURE__ */ new Date(), je.compression !== null && (je.compression = je.compression.toUpperCase()), typeof je.unixPermissions == "string" && (je.unixPermissions = parseInt(je.unixPermissions, 8)), je.unixPermissions && 16384 & je.unixPermissions && (je.dir = !0), je.dosPermissions && 16 & je.dosPermissions && (je.dir = !0), je.dir && (fe = D(fe)), je.createFolders && (qe = Q(fe)) && ee.call(this, qe, !0);
        var pt = Oe === "string" && je.binary === !1 && je.base64 === !1;
        Z && Z.binary !== void 0 || (je.binary = !pt), (X instanceof I && X.uncompressedSize === 0 || je.dir || !X || X.length === 0) && (je.base64 = !1, je.binary = !0, X = "", je.compression = "STORE", Oe = "string");
        var Te = null;
        Te = X instanceof I || X instanceof v ? X : W.isNode && W.isStream(X) ? new U(fe, X) : f.prepareContent(fe, X, je.binary, je.optimizedBinaryString, je.base64);
        var Ze = new V(fe, Te, je);
        this.files[fe] = Ze;
      }
      var h = t("./utf8"), f = t("./utils"), v = t("./stream/GenericWorker"), x = t("./stream/StreamHelper"), k = t("./defaults"), I = t("./compressedObject"), V = t("./zipObject"), M = t("./generate"), W = t("./nodejsUtils"), U = t("./nodejs/NodejsStreamInputAdapter"), Q = function(fe) {
        fe.slice(-1) === "/" && (fe = fe.substring(0, fe.length - 1));
        var X = fe.lastIndexOf("/");
        return 0 < X ? fe.substring(0, X) : "";
      }, D = function(fe) {
        return fe.slice(-1) !== "/" && (fe += "/"), fe;
      }, ee = function(fe, X) {
        return X = X !== void 0 ? X : k.createFolders, fe = D(fe), this.files[fe] || o.call(this, fe, null, { dir: !0, createFolders: X }), this.files[fe];
      };
      function J(fe) {
        return Object.prototype.toString.call(fe) === "[object RegExp]";
      }
      var he = { load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, forEach: function(fe) {
        var X, Z, qe;
        for (X in this.files)
          qe = this.files[X], (Z = X.slice(this.root.length, X.length)) && X.slice(0, this.root.length) === this.root && fe(Z, qe);
      }, filter: function(fe) {
        var X = [];
        return this.forEach(function(Z, qe) {
          fe(Z, qe) && X.push(qe);
        }), X;
      }, file: function(fe, X, Z) {
        if (arguments.length !== 1)
          return fe = this.root + fe, o.call(this, fe, X, Z), this;
        if (J(fe)) {
          var qe = fe;
          return this.filter(function(je, pt) {
            return !pt.dir && qe.test(je);
          });
        }
        var Oe = this.files[this.root + fe];
        return Oe && !Oe.dir ? Oe : null;
      }, folder: function(fe) {
        if (!fe)
          return this;
        if (J(fe))
          return this.filter(function(Oe, je) {
            return je.dir && fe.test(Oe);
          });
        var X = this.root + fe, Z = ee.call(this, X), qe = this.clone();
        return qe.root = Z.name, qe;
      }, remove: function(fe) {
        fe = this.root + fe;
        var X = this.files[fe];
        if (X || (fe.slice(-1) !== "/" && (fe += "/"), X = this.files[fe]), X && !X.dir)
          delete this.files[fe];
        else
          for (var Z = this.filter(function(Oe, je) {
            return je.name.slice(0, fe.length) === fe;
          }), qe = 0; qe < Z.length; qe++)
            delete this.files[Z[qe].name];
        return this;
      }, generate: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, generateInternalStream: function(fe) {
        var X, Z = {};
        try {
          if ((Z = f.extend(fe || {}, { streamFiles: !1, compression: "STORE", compressionOptions: null, type: "", platform: "DOS", comment: null, mimeType: "application/zip", encodeFileName: h.utf8encode })).type = Z.type.toLowerCase(), Z.compression = Z.compression.toUpperCase(), Z.type === "binarystring" && (Z.type = "string"), !Z.type)
            throw new Error("No output type specified.");
          f.checkSupport(Z.type), Z.platform !== "darwin" && Z.platform !== "freebsd" && Z.platform !== "linux" && Z.platform !== "sunos" || (Z.platform = "UNIX"), Z.platform === "win32" && (Z.platform = "DOS");
          var qe = Z.comment || this.comment || "";
          X = M.generateWorker(this, Z, qe);
        } catch (Oe) {
          (X = new v("error")).error(Oe);
        }
        return new x(X, Z.type || "string", Z.mimeType);
      }, generateAsync: function(fe, X) {
        return this.generateInternalStream(fe).accumulate(X);
      }, generateNodeStream: function(fe, X) {
        return (fe = fe || {}).type || (fe.type = "nodebuffer"), this.generateInternalStream(fe).toNodejsStream(X);
      } };
      n.exports = he;
    }, { "./compressedObject": 2, "./defaults": 5, "./generate": 9, "./nodejs/NodejsStreamInputAdapter": 12, "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31, "./utils": 32, "./zipObject": 35 }], 16: [function(t, n, a) {
      n.exports = t("stream");
    }, { stream: void 0 }], 17: [function(t, n, a) {
      var o = t("./DataReader");
      function h(f) {
        o.call(this, f);
        for (var v = 0; v < this.data.length; v++)
          f[v] = 255 & f[v];
      }
      t("../utils").inherits(h, o), h.prototype.byteAt = function(f) {
        return this.data[this.zero + f];
      }, h.prototype.lastIndexOfSignature = function(f) {
        for (var v = f.charCodeAt(0), x = f.charCodeAt(1), k = f.charCodeAt(2), I = f.charCodeAt(3), V = this.length - 4; 0 <= V; --V)
          if (this.data[V] === v && this.data[V + 1] === x && this.data[V + 2] === k && this.data[V + 3] === I)
            return V - this.zero;
        return -1;
      }, h.prototype.readAndCheckSignature = function(f) {
        var v = f.charCodeAt(0), x = f.charCodeAt(1), k = f.charCodeAt(2), I = f.charCodeAt(3), V = this.readData(4);
        return v === V[0] && x === V[1] && k === V[2] && I === V[3];
      }, h.prototype.readData = function(f) {
        if (this.checkOffset(f), f === 0)
          return [];
        var v = this.data.slice(this.zero + this.index, this.zero + this.index + f);
        return this.index += f, v;
      }, n.exports = h;
    }, { "../utils": 32, "./DataReader": 18 }], 18: [function(t, n, a) {
      var o = t("../utils");
      function h(f) {
        this.data = f, this.length = f.length, this.index = 0, this.zero = 0;
      }
      h.prototype = { checkOffset: function(f) {
        this.checkIndex(this.index + f);
      }, checkIndex: function(f) {
        if (this.length < this.zero + f || f < 0)
          throw new Error("End of data reached (data length = " + this.length + ", asked index = " + f + "). Corrupted zip ?");
      }, setIndex: function(f) {
        this.checkIndex(f), this.index = f;
      }, skip: function(f) {
        this.setIndex(this.index + f);
      }, byteAt: function() {
      }, readInt: function(f) {
        var v, x = 0;
        for (this.checkOffset(f), v = this.index + f - 1; v >= this.index; v--)
          x = (x << 8) + this.byteAt(v);
        return this.index += f, x;
      }, readString: function(f) {
        return o.transformTo("string", this.readData(f));
      }, readData: function() {
      }, lastIndexOfSignature: function() {
      }, readAndCheckSignature: function() {
      }, readDate: function() {
        var f = this.readInt(4);
        return new Date(Date.UTC(1980 + (f >> 25 & 127), (f >> 21 & 15) - 1, f >> 16 & 31, f >> 11 & 31, f >> 5 & 63, (31 & f) << 1));
      } }, n.exports = h;
    }, { "../utils": 32 }], 19: [function(t, n, a) {
      var o = t("./Uint8ArrayReader");
      function h(f) {
        o.call(this, f);
      }
      t("../utils").inherits(h, o), h.prototype.readData = function(f) {
        this.checkOffset(f);
        var v = this.data.slice(this.zero + this.index, this.zero + this.index + f);
        return this.index += f, v;
      }, n.exports = h;
    }, { "../utils": 32, "./Uint8ArrayReader": 21 }], 20: [function(t, n, a) {
      var o = t("./DataReader");
      function h(f) {
        o.call(this, f);
      }
      t("../utils").inherits(h, o), h.prototype.byteAt = function(f) {
        return this.data.charCodeAt(this.zero + f);
      }, h.prototype.lastIndexOfSignature = function(f) {
        return this.data.lastIndexOf(f) - this.zero;
      }, h.prototype.readAndCheckSignature = function(f) {
        return f === this.readData(4);
      }, h.prototype.readData = function(f) {
        this.checkOffset(f);
        var v = this.data.slice(this.zero + this.index, this.zero + this.index + f);
        return this.index += f, v;
      }, n.exports = h;
    }, { "../utils": 32, "./DataReader": 18 }], 21: [function(t, n, a) {
      var o = t("./ArrayReader");
      function h(f) {
        o.call(this, f);
      }
      t("../utils").inherits(h, o), h.prototype.readData = function(f) {
        if (this.checkOffset(f), f === 0)
          return new Uint8Array(0);
        var v = this.data.subarray(this.zero + this.index, this.zero + this.index + f);
        return this.index += f, v;
      }, n.exports = h;
    }, { "../utils": 32, "./ArrayReader": 17 }], 22: [function(t, n, a) {
      var o = t("../utils"), h = t("../support"), f = t("./ArrayReader"), v = t("./StringReader"), x = t("./NodeBufferReader"), k = t("./Uint8ArrayReader");
      n.exports = function(I) {
        var V = o.getTypeOf(I);
        return o.checkSupport(V), V !== "string" || h.uint8array ? V === "nodebuffer" ? new x(I) : h.uint8array ? new k(o.transformTo("uint8array", I)) : new f(o.transformTo("array", I)) : new v(I);
      };
    }, { "../support": 30, "../utils": 32, "./ArrayReader": 17, "./NodeBufferReader": 19, "./StringReader": 20, "./Uint8ArrayReader": 21 }], 23: [function(t, n, a) {
      a.LOCAL_FILE_HEADER = "PK", a.CENTRAL_FILE_HEADER = "PK", a.CENTRAL_DIRECTORY_END = "PK", a.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x07", a.ZIP64_CENTRAL_DIRECTORY_END = "PK", a.DATA_DESCRIPTOR = "PK\x07\b";
    }, {}], 24: [function(t, n, a) {
      var o = t("./GenericWorker"), h = t("../utils");
      function f(v) {
        o.call(this, "ConvertWorker to " + v), this.destType = v;
      }
      h.inherits(f, o), f.prototype.processChunk = function(v) {
        this.push({ data: h.transformTo(this.destType, v.data), meta: v.meta });
      }, n.exports = f;
    }, { "../utils": 32, "./GenericWorker": 28 }], 25: [function(t, n, a) {
      var o = t("./GenericWorker"), h = t("../crc32");
      function f() {
        o.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
      }
      t("../utils").inherits(f, o), f.prototype.processChunk = function(v) {
        this.streamInfo.crc32 = h(v.data, this.streamInfo.crc32 || 0), this.push(v);
      }, n.exports = f;
    }, { "../crc32": 4, "../utils": 32, "./GenericWorker": 28 }], 26: [function(t, n, a) {
      var o = t("../utils"), h = t("./GenericWorker");
      function f(v) {
        h.call(this, "DataLengthProbe for " + v), this.propName = v, this.withStreamInfo(v, 0);
      }
      o.inherits(f, h), f.prototype.processChunk = function(v) {
        if (v) {
          var x = this.streamInfo[this.propName] || 0;
          this.streamInfo[this.propName] = x + v.data.length;
        }
        h.prototype.processChunk.call(this, v);
      }, n.exports = f;
    }, { "../utils": 32, "./GenericWorker": 28 }], 27: [function(t, n, a) {
      var o = t("../utils"), h = t("./GenericWorker");
      function f(v) {
        h.call(this, "DataWorker");
        var x = this;
        this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, v.then(function(k) {
          x.dataIsReady = !0, x.data = k, x.max = k && k.length || 0, x.type = o.getTypeOf(k), x.isPaused || x._tickAndRepeat();
        }, function(k) {
          x.error(k);
        });
      }
      o.inherits(f, h), f.prototype.cleanUp = function() {
        h.prototype.cleanUp.call(this), this.data = null;
      }, f.prototype.resume = function() {
        return !!h.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, o.delay(this._tickAndRepeat, [], this)), !0);
      }, f.prototype._tickAndRepeat = function() {
        this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (o.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
      }, f.prototype._tick = function() {
        if (this.isPaused || this.isFinished)
          return !1;
        var v = null, x = Math.min(this.max, this.index + 16384);
        if (this.index >= this.max)
          return this.end();
        switch (this.type) {
          case "string":
            v = this.data.substring(this.index, x);
            break;
          case "uint8array":
            v = this.data.subarray(this.index, x);
            break;
          case "array":
          case "nodebuffer":
            v = this.data.slice(this.index, x);
        }
        return this.index = x, this.push({ data: v, meta: { percent: this.max ? this.index / this.max * 100 : 0 } });
      }, n.exports = f;
    }, { "../utils": 32, "./GenericWorker": 28 }], 28: [function(t, n, a) {
      function o(h) {
        this.name = h || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = { data: [], end: [], error: [] }, this.previous = null;
      }
      o.prototype = { push: function(h) {
        this.emit("data", h);
      }, end: function() {
        if (this.isFinished)
          return !1;
        this.flush();
        try {
          this.emit("end"), this.cleanUp(), this.isFinished = !0;
        } catch (h) {
          this.emit("error", h);
        }
        return !0;
      }, error: function(h) {
        return !this.isFinished && (this.isPaused ? this.generatedError = h : (this.isFinished = !0, this.emit("error", h), this.previous && this.previous.error(h), this.cleanUp()), !0);
      }, on: function(h, f) {
        return this._listeners[h].push(f), this;
      }, cleanUp: function() {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
      }, emit: function(h, f) {
        if (this._listeners[h])
          for (var v = 0; v < this._listeners[h].length; v++)
            this._listeners[h][v].call(this, f);
      }, pipe: function(h) {
        return h.registerPrevious(this);
      }, registerPrevious: function(h) {
        if (this.isLocked)
          throw new Error("The stream '" + this + "' has already been used.");
        this.streamInfo = h.streamInfo, this.mergeStreamInfo(), this.previous = h;
        var f = this;
        return h.on("data", function(v) {
          f.processChunk(v);
        }), h.on("end", function() {
          f.end();
        }), h.on("error", function(v) {
          f.error(v);
        }), this;
      }, pause: function() {
        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
      }, resume: function() {
        if (!this.isPaused || this.isFinished)
          return !1;
        var h = this.isPaused = !1;
        return this.generatedError && (this.error(this.generatedError), h = !0), this.previous && this.previous.resume(), !h;
      }, flush: function() {
      }, processChunk: function(h) {
        this.push(h);
      }, withStreamInfo: function(h, f) {
        return this.extraStreamInfo[h] = f, this.mergeStreamInfo(), this;
      }, mergeStreamInfo: function() {
        for (var h in this.extraStreamInfo)
          Object.prototype.hasOwnProperty.call(this.extraStreamInfo, h) && (this.streamInfo[h] = this.extraStreamInfo[h]);
      }, lock: function() {
        if (this.isLocked)
          throw new Error("The stream '" + this + "' has already been used.");
        this.isLocked = !0, this.previous && this.previous.lock();
      }, toString: function() {
        var h = "Worker " + this.name;
        return this.previous ? this.previous + " -> " + h : h;
      } }, n.exports = o;
    }, {}], 29: [function(t, n, a) {
      var o = t("../utils"), h = t("./ConvertWorker"), f = t("./GenericWorker"), v = t("../base64"), x = t("../support"), k = t("../external"), I = null;
      if (x.nodestream)
        try {
          I = t("../nodejs/NodejsStreamOutputAdapter");
        } catch {
        }
      function V(W, U) {
        return new k.Promise(function(Q, D) {
          var ee = [], J = W._internalType, he = W._outputType, fe = W._mimeType;
          W.on("data", function(X, Z) {
            ee.push(X), U && U(Z);
          }).on("error", function(X) {
            ee = [], D(X);
          }).on("end", function() {
            try {
              var X = function(Z, qe, Oe) {
                switch (Z) {
                  case "blob":
                    return o.newBlob(o.transformTo("arraybuffer", qe), Oe);
                  case "base64":
                    return v.encode(qe);
                  default:
                    return o.transformTo(Z, qe);
                }
              }(he, function(Z, qe) {
                var Oe, je = 0, pt = null, Te = 0;
                for (Oe = 0; Oe < qe.length; Oe++)
                  Te += qe[Oe].length;
                switch (Z) {
                  case "string":
                    return qe.join("");
                  case "array":
                    return Array.prototype.concat.apply([], qe);
                  case "uint8array":
                    for (pt = new Uint8Array(Te), Oe = 0; Oe < qe.length; Oe++)
                      pt.set(qe[Oe], je), je += qe[Oe].length;
                    return pt;
                  case "nodebuffer":
                    return Buffer.concat(qe);
                  default:
                    throw new Error("concat : unsupported type '" + Z + "'");
                }
              }(J, ee), fe);
              Q(X);
            } catch (Z) {
              D(Z);
            }
            ee = [];
          }).resume();
        });
      }
      function M(W, U, Q) {
        var D = U;
        switch (U) {
          case "blob":
          case "arraybuffer":
            D = "uint8array";
            break;
          case "base64":
            D = "string";
        }
        try {
          this._internalType = D, this._outputType = U, this._mimeType = Q, o.checkSupport(D), this._worker = W.pipe(new h(D)), W.lock();
        } catch (ee) {
          this._worker = new f("error"), this._worker.error(ee);
        }
      }
      M.prototype = { accumulate: function(W) {
        return V(this, W);
      }, on: function(W, U) {
        var Q = this;
        return W === "data" ? this._worker.on(W, function(D) {
          U.call(Q, D.data, D.meta);
        }) : this._worker.on(W, function() {
          o.delay(U, arguments, Q);
        }), this;
      }, resume: function() {
        return o.delay(this._worker.resume, [], this._worker), this;
      }, pause: function() {
        return this._worker.pause(), this;
      }, toNodejsStream: function(W) {
        if (o.checkSupport("nodestream"), this._outputType !== "nodebuffer")
          throw new Error(this._outputType + " is not supported by this method");
        return new I(this, { objectMode: this._outputType !== "nodebuffer" }, W);
      } }, n.exports = M;
    }, { "../base64": 1, "../external": 6, "../nodejs/NodejsStreamOutputAdapter": 13, "../support": 30, "../utils": 32, "./ConvertWorker": 24, "./GenericWorker": 28 }], 30: [function(t, n, a) {
      if (a.base64 = !0, a.array = !0, a.string = !0, a.arraybuffer = typeof ArrayBuffer < "u" && typeof Uint8Array < "u", a.nodebuffer = typeof Buffer < "u", a.uint8array = typeof Uint8Array < "u", typeof ArrayBuffer > "u")
        a.blob = !1;
      else {
        var o = new ArrayBuffer(0);
        try {
          a.blob = new Blob([o], { type: "application/zip" }).size === 0;
        } catch {
          try {
            var h = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            h.append(o), a.blob = h.getBlob("application/zip").size === 0;
          } catch {
            a.blob = !1;
          }
        }
      }
      try {
        a.nodestream = !!t("readable-stream").Readable;
      } catch {
        a.nodestream = !1;
      }
    }, { "readable-stream": 16 }], 31: [function(t, n, a) {
      for (var o = t("./utils"), h = t("./support"), f = t("./nodejsUtils"), v = t("./stream/GenericWorker"), x = new Array(256), k = 0; k < 256; k++)
        x[k] = 252 <= k ? 6 : 248 <= k ? 5 : 240 <= k ? 4 : 224 <= k ? 3 : 192 <= k ? 2 : 1;
      x[254] = x[254] = 1;
      function I() {
        v.call(this, "utf-8 decode"), this.leftOver = null;
      }
      function V() {
        v.call(this, "utf-8 encode");
      }
      a.utf8encode = function(M) {
        return h.nodebuffer ? f.newBufferFrom(M, "utf-8") : function(W) {
          var U, Q, D, ee, J, he = W.length, fe = 0;
          for (ee = 0; ee < he; ee++)
            (64512 & (Q = W.charCodeAt(ee))) == 55296 && ee + 1 < he && (64512 & (D = W.charCodeAt(ee + 1))) == 56320 && (Q = 65536 + (Q - 55296 << 10) + (D - 56320), ee++), fe += Q < 128 ? 1 : Q < 2048 ? 2 : Q < 65536 ? 3 : 4;
          for (U = h.uint8array ? new Uint8Array(fe) : new Array(fe), ee = J = 0; J < fe; ee++)
            (64512 & (Q = W.charCodeAt(ee))) == 55296 && ee + 1 < he && (64512 & (D = W.charCodeAt(ee + 1))) == 56320 && (Q = 65536 + (Q - 55296 << 10) + (D - 56320), ee++), Q < 128 ? U[J++] = Q : (Q < 2048 ? U[J++] = 192 | Q >>> 6 : (Q < 65536 ? U[J++] = 224 | Q >>> 12 : (U[J++] = 240 | Q >>> 18, U[J++] = 128 | Q >>> 12 & 63), U[J++] = 128 | Q >>> 6 & 63), U[J++] = 128 | 63 & Q);
          return U;
        }(M);
      }, a.utf8decode = function(M) {
        return h.nodebuffer ? o.transformTo("nodebuffer", M).toString("utf-8") : function(W) {
          var U, Q, D, ee, J = W.length, he = new Array(2 * J);
          for (U = Q = 0; U < J; )
            if ((D = W[U++]) < 128)
              he[Q++] = D;
            else if (4 < (ee = x[D]))
              he[Q++] = 65533, U += ee - 1;
            else {
              for (D &= ee === 2 ? 31 : ee === 3 ? 15 : 7; 1 < ee && U < J; )
                D = D << 6 | 63 & W[U++], ee--;
              1 < ee ? he[Q++] = 65533 : D < 65536 ? he[Q++] = D : (D -= 65536, he[Q++] = 55296 | D >> 10 & 1023, he[Q++] = 56320 | 1023 & D);
            }
          return he.length !== Q && (he.subarray ? he = he.subarray(0, Q) : he.length = Q), o.applyFromCharCode(he);
        }(M = o.transformTo(h.uint8array ? "uint8array" : "array", M));
      }, o.inherits(I, v), I.prototype.processChunk = function(M) {
        var W = o.transformTo(h.uint8array ? "uint8array" : "array", M.data);
        if (this.leftOver && this.leftOver.length) {
          if (h.uint8array) {
            var U = W;
            (W = new Uint8Array(U.length + this.leftOver.length)).set(this.leftOver, 0), W.set(U, this.leftOver.length);
          } else
            W = this.leftOver.concat(W);
          this.leftOver = null;
        }
        var Q = function(ee, J) {
          var he;
          for ((J = J || ee.length) > ee.length && (J = ee.length), he = J - 1; 0 <= he && (192 & ee[he]) == 128; )
            he--;
          return he < 0 || he === 0 ? J : he + x[ee[he]] > J ? he : J;
        }(W), D = W;
        Q !== W.length && (h.uint8array ? (D = W.subarray(0, Q), this.leftOver = W.subarray(Q, W.length)) : (D = W.slice(0, Q), this.leftOver = W.slice(Q, W.length))), this.push({ data: a.utf8decode(D), meta: M.meta });
      }, I.prototype.flush = function() {
        this.leftOver && this.leftOver.length && (this.push({ data: a.utf8decode(this.leftOver), meta: {} }), this.leftOver = null);
      }, a.Utf8DecodeWorker = I, o.inherits(V, v), V.prototype.processChunk = function(M) {
        this.push({ data: a.utf8encode(M.data), meta: M.meta });
      }, a.Utf8EncodeWorker = V;
    }, { "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./support": 30, "./utils": 32 }], 32: [function(t, n, a) {
      var o = t("./support"), h = t("./base64"), f = t("./nodejsUtils"), v = t("./external");
      function x(U) {
        return U;
      }
      function k(U, Q) {
        for (var D = 0; D < U.length; ++D)
          Q[D] = 255 & U.charCodeAt(D);
        return Q;
      }
      t("setimmediate"), a.newBlob = function(U, Q) {
        a.checkSupport("blob");
        try {
          return new Blob([U], { type: Q });
        } catch {
          try {
            var D = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            return D.append(U), D.getBlob(Q);
          } catch {
            throw new Error("Bug : can't construct the Blob.");
          }
        }
      };
      var I = { stringifyByChunk: function(U, Q, D) {
        var ee = [], J = 0, he = U.length;
        if (he <= D)
          return String.fromCharCode.apply(null, U);
        for (; J < he; )
          Q === "array" || Q === "nodebuffer" ? ee.push(String.fromCharCode.apply(null, U.slice(J, Math.min(J + D, he)))) : ee.push(String.fromCharCode.apply(null, U.subarray(J, Math.min(J + D, he)))), J += D;
        return ee.join("");
      }, stringifyByChar: function(U) {
        for (var Q = "", D = 0; D < U.length; D++)
          Q += String.fromCharCode(U[D]);
        return Q;
      }, applyCanBeUsed: { uint8array: function() {
        try {
          return o.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
        } catch {
          return !1;
        }
      }(), nodebuffer: function() {
        try {
          return o.nodebuffer && String.fromCharCode.apply(null, f.allocBuffer(1)).length === 1;
        } catch {
          return !1;
        }
      }() } };
      function V(U) {
        var Q = 65536, D = a.getTypeOf(U), ee = !0;
        if (D === "uint8array" ? ee = I.applyCanBeUsed.uint8array : D === "nodebuffer" && (ee = I.applyCanBeUsed.nodebuffer), ee)
          for (; 1 < Q; )
            try {
              return I.stringifyByChunk(U, D, Q);
            } catch {
              Q = Math.floor(Q / 2);
            }
        return I.stringifyByChar(U);
      }
      function M(U, Q) {
        for (var D = 0; D < U.length; D++)
          Q[D] = U[D];
        return Q;
      }
      a.applyFromCharCode = V;
      var W = {};
      W.string = { string: x, array: function(U) {
        return k(U, new Array(U.length));
      }, arraybuffer: function(U) {
        return W.string.uint8array(U).buffer;
      }, uint8array: function(U) {
        return k(U, new Uint8Array(U.length));
      }, nodebuffer: function(U) {
        return k(U, f.allocBuffer(U.length));
      } }, W.array = { string: V, array: x, arraybuffer: function(U) {
        return new Uint8Array(U).buffer;
      }, uint8array: function(U) {
        return new Uint8Array(U);
      }, nodebuffer: function(U) {
        return f.newBufferFrom(U);
      } }, W.arraybuffer = { string: function(U) {
        return V(new Uint8Array(U));
      }, array: function(U) {
        return M(new Uint8Array(U), new Array(U.byteLength));
      }, arraybuffer: x, uint8array: function(U) {
        return new Uint8Array(U);
      }, nodebuffer: function(U) {
        return f.newBufferFrom(new Uint8Array(U));
      } }, W.uint8array = { string: V, array: function(U) {
        return M(U, new Array(U.length));
      }, arraybuffer: function(U) {
        return U.buffer;
      }, uint8array: x, nodebuffer: function(U) {
        return f.newBufferFrom(U);
      } }, W.nodebuffer = { string: V, array: function(U) {
        return M(U, new Array(U.length));
      }, arraybuffer: function(U) {
        return W.nodebuffer.uint8array(U).buffer;
      }, uint8array: function(U) {
        return M(U, new Uint8Array(U.length));
      }, nodebuffer: x }, a.transformTo = function(U, Q) {
        if (Q = Q || "", !U)
          return Q;
        a.checkSupport(U);
        var D = a.getTypeOf(Q);
        return W[D][U](Q);
      }, a.resolve = function(U) {
        for (var Q = U.split("/"), D = [], ee = 0; ee < Q.length; ee++) {
          var J = Q[ee];
          J === "." || J === "" && ee !== 0 && ee !== Q.length - 1 || (J === ".." ? D.pop() : D.push(J));
        }
        return D.join("/");
      }, a.getTypeOf = function(U) {
        return typeof U == "string" ? "string" : Object.prototype.toString.call(U) === "[object Array]" ? "array" : o.nodebuffer && f.isBuffer(U) ? "nodebuffer" : o.uint8array && U instanceof Uint8Array ? "uint8array" : o.arraybuffer && U instanceof ArrayBuffer ? "arraybuffer" : void 0;
      }, a.checkSupport = function(U) {
        if (!o[U.toLowerCase()])
          throw new Error(U + " is not supported by this platform");
      }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(U) {
        var Q, D, ee = "";
        for (D = 0; D < (U || "").length; D++)
          ee += "\\x" + ((Q = U.charCodeAt(D)) < 16 ? "0" : "") + Q.toString(16).toUpperCase();
        return ee;
      }, a.delay = function(U, Q, D) {
        setImmediate(function() {
          U.apply(D || null, Q || []);
        });
      }, a.inherits = function(U, Q) {
        function D() {
        }
        D.prototype = Q.prototype, U.prototype = new D();
      }, a.extend = function() {
        var U, Q, D = {};
        for (U = 0; U < arguments.length; U++)
          for (Q in arguments[U])
            Object.prototype.hasOwnProperty.call(arguments[U], Q) && D[Q] === void 0 && (D[Q] = arguments[U][Q]);
        return D;
      }, a.prepareContent = function(U, Q, D, ee, J) {
        return v.Promise.resolve(Q).then(function(he) {
          return o.blob && (he instanceof Blob || ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(he)) !== -1) && typeof FileReader < "u" ? new v.Promise(function(fe, X) {
            var Z = new FileReader();
            Z.onload = function(qe) {
              fe(qe.target.result);
            }, Z.onerror = function(qe) {
              X(qe.target.error);
            }, Z.readAsArrayBuffer(he);
          }) : he;
        }).then(function(he) {
          var fe = a.getTypeOf(he);
          return fe ? (fe === "arraybuffer" ? he = a.transformTo("uint8array", he) : fe === "string" && (J ? he = h.decode(he) : D && ee !== !0 && (he = function(X) {
            return k(X, o.uint8array ? new Uint8Array(X.length) : new Array(X.length));
          }(he))), he) : v.Promise.reject(new Error("Can't read the data of '" + U + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
        });
      };
    }, { "./base64": 1, "./external": 6, "./nodejsUtils": 14, "./support": 30, setimmediate: 54 }], 33: [function(t, n, a) {
      var o = t("./reader/readerFor"), h = t("./utils"), f = t("./signature"), v = t("./zipEntry"), x = t("./support");
      function k(I) {
        this.files = [], this.loadOptions = I;
      }
      k.prototype = { checkSignature: function(I) {
        if (!this.reader.readAndCheckSignature(I)) {
          this.reader.index -= 4;
          var V = this.reader.readString(4);
          throw new Error("Corrupted zip or bug: unexpected signature (" + h.pretty(V) + ", expected " + h.pretty(I) + ")");
        }
      }, isSignature: function(I, V) {
        var M = this.reader.index;
        this.reader.setIndex(I);
        var W = this.reader.readString(4) === V;
        return this.reader.setIndex(M), W;
      }, readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
        var I = this.reader.readData(this.zipCommentLength), V = x.uint8array ? "uint8array" : "array", M = h.transformTo(V, I);
        this.zipComment = this.loadOptions.decodeFileName(M);
      }, readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
        for (var I, V, M, W = this.zip64EndOfCentralSize - 44; 0 < W; )
          I = this.reader.readInt(2), V = this.reader.readInt(4), M = this.reader.readData(V), this.zip64ExtensibleData[I] = { id: I, length: V, value: M };
      }, readBlockZip64EndOfCentralLocator: function() {
        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount)
          throw new Error("Multi-volumes zip are not supported");
      }, readLocalFiles: function() {
        var I, V;
        for (I = 0; I < this.files.length; I++)
          V = this.files[I], this.reader.setIndex(V.localHeaderOffset), this.checkSignature(f.LOCAL_FILE_HEADER), V.readLocalPart(this.reader), V.handleUTF8(), V.processAttributes();
      }, readCentralDir: function() {
        var I;
        for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(f.CENTRAL_FILE_HEADER); )
          (I = new v({ zip64: this.zip64 }, this.loadOptions)).readCentralPart(this.reader), this.files.push(I);
        if (this.centralDirRecords !== this.files.length && this.centralDirRecords !== 0 && this.files.length === 0)
          throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
      }, readEndOfCentral: function() {
        var I = this.reader.lastIndexOfSignature(f.CENTRAL_DIRECTORY_END);
        if (I < 0)
          throw this.isSignature(0, f.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
        this.reader.setIndex(I);
        var V = I;
        if (this.checkSignature(f.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === h.MAX_VALUE_16BITS || this.diskWithCentralDirStart === h.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === h.MAX_VALUE_16BITS || this.centralDirRecords === h.MAX_VALUE_16BITS || this.centralDirSize === h.MAX_VALUE_32BITS || this.centralDirOffset === h.MAX_VALUE_32BITS) {
          if (this.zip64 = !0, (I = this.reader.lastIndexOfSignature(f.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0)
            throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
          if (this.reader.setIndex(I), this.checkSignature(f.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, f.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(f.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0))
            throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
          this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(f.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
        }
        var M = this.centralDirOffset + this.centralDirSize;
        this.zip64 && (M += 20, M += 12 + this.zip64EndOfCentralSize);
        var W = V - M;
        if (0 < W)
          this.isSignature(V, f.CENTRAL_FILE_HEADER) || (this.reader.zero = W);
        else if (W < 0)
          throw new Error("Corrupted zip: missing " + Math.abs(W) + " bytes.");
      }, prepareReader: function(I) {
        this.reader = o(I);
      }, load: function(I) {
        this.prepareReader(I), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
      } }, n.exports = k;
    }, { "./reader/readerFor": 22, "./signature": 23, "./support": 30, "./utils": 32, "./zipEntry": 34 }], 34: [function(t, n, a) {
      var o = t("./reader/readerFor"), h = t("./utils"), f = t("./compressedObject"), v = t("./crc32"), x = t("./utf8"), k = t("./compressions"), I = t("./support");
      function V(M, W) {
        this.options = M, this.loadOptions = W;
      }
      V.prototype = { isEncrypted: function() {
        return (1 & this.bitFlag) == 1;
      }, useUTF8: function() {
        return (2048 & this.bitFlag) == 2048;
      }, readLocalPart: function(M) {
        var W, U;
        if (M.skip(22), this.fileNameLength = M.readInt(2), U = M.readInt(2), this.fileName = M.readData(this.fileNameLength), M.skip(U), this.compressedSize === -1 || this.uncompressedSize === -1)
          throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
        if ((W = function(Q) {
          for (var D in k)
            if (Object.prototype.hasOwnProperty.call(k, D) && k[D].magic === Q)
              return k[D];
          return null;
        }(this.compressionMethod)) === null)
          throw new Error("Corrupted zip : compression " + h.pretty(this.compressionMethod) + " unknown (inner file : " + h.transformTo("string", this.fileName) + ")");
        this.decompressed = new f(this.compressedSize, this.uncompressedSize, this.crc32, W, M.readData(this.compressedSize));
      }, readCentralPart: function(M) {
        this.versionMadeBy = M.readInt(2), M.skip(2), this.bitFlag = M.readInt(2), this.compressionMethod = M.readString(2), this.date = M.readDate(), this.crc32 = M.readInt(4), this.compressedSize = M.readInt(4), this.uncompressedSize = M.readInt(4);
        var W = M.readInt(2);
        if (this.extraFieldsLength = M.readInt(2), this.fileCommentLength = M.readInt(2), this.diskNumberStart = M.readInt(2), this.internalFileAttributes = M.readInt(2), this.externalFileAttributes = M.readInt(4), this.localHeaderOffset = M.readInt(4), this.isEncrypted())
          throw new Error("Encrypted zip are not supported");
        M.skip(W), this.readExtraFields(M), this.parseZIP64ExtraField(M), this.fileComment = M.readData(this.fileCommentLength);
      }, processAttributes: function() {
        this.unixPermissions = null, this.dosPermissions = null;
        var M = this.versionMadeBy >> 8;
        this.dir = !!(16 & this.externalFileAttributes), M == 0 && (this.dosPermissions = 63 & this.externalFileAttributes), M == 3 && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || this.fileNameStr.slice(-1) !== "/" || (this.dir = !0);
      }, parseZIP64ExtraField: function() {
        if (this.extraFields[1]) {
          var M = o(this.extraFields[1].value);
          this.uncompressedSize === h.MAX_VALUE_32BITS && (this.uncompressedSize = M.readInt(8)), this.compressedSize === h.MAX_VALUE_32BITS && (this.compressedSize = M.readInt(8)), this.localHeaderOffset === h.MAX_VALUE_32BITS && (this.localHeaderOffset = M.readInt(8)), this.diskNumberStart === h.MAX_VALUE_32BITS && (this.diskNumberStart = M.readInt(4));
        }
      }, readExtraFields: function(M) {
        var W, U, Q, D = M.index + this.extraFieldsLength;
        for (this.extraFields || (this.extraFields = {}); M.index + 4 < D; )
          W = M.readInt(2), U = M.readInt(2), Q = M.readData(U), this.extraFields[W] = { id: W, length: U, value: Q };
        M.setIndex(D);
      }, handleUTF8: function() {
        var M = I.uint8array ? "uint8array" : "array";
        if (this.useUTF8())
          this.fileNameStr = x.utf8decode(this.fileName), this.fileCommentStr = x.utf8decode(this.fileComment);
        else {
          var W = this.findExtraFieldUnicodePath();
          if (W !== null)
            this.fileNameStr = W;
          else {
            var U = h.transformTo(M, this.fileName);
            this.fileNameStr = this.loadOptions.decodeFileName(U);
          }
          var Q = this.findExtraFieldUnicodeComment();
          if (Q !== null)
            this.fileCommentStr = Q;
          else {
            var D = h.transformTo(M, this.fileComment);
            this.fileCommentStr = this.loadOptions.decodeFileName(D);
          }
        }
      }, findExtraFieldUnicodePath: function() {
        var M = this.extraFields[28789];
        if (M) {
          var W = o(M.value);
          return W.readInt(1) !== 1 || v(this.fileName) !== W.readInt(4) ? null : x.utf8decode(W.readData(M.length - 5));
        }
        return null;
      }, findExtraFieldUnicodeComment: function() {
        var M = this.extraFields[25461];
        if (M) {
          var W = o(M.value);
          return W.readInt(1) !== 1 || v(this.fileComment) !== W.readInt(4) ? null : x.utf8decode(W.readData(M.length - 5));
        }
        return null;
      } }, n.exports = V;
    }, { "./compressedObject": 2, "./compressions": 3, "./crc32": 4, "./reader/readerFor": 22, "./support": 30, "./utf8": 31, "./utils": 32 }], 35: [function(t, n, a) {
      function o(W, U, Q) {
        this.name = W, this.dir = Q.dir, this.date = Q.date, this.comment = Q.comment, this.unixPermissions = Q.unixPermissions, this.dosPermissions = Q.dosPermissions, this._data = U, this._dataBinary = Q.binary, this.options = { compression: Q.compression, compressionOptions: Q.compressionOptions };
      }
      var h = t("./stream/StreamHelper"), f = t("./stream/DataWorker"), v = t("./utf8"), x = t("./compressedObject"), k = t("./stream/GenericWorker");
      o.prototype = { internalStream: function(W) {
        var U = null, Q = "string";
        try {
          if (!W)
            throw new Error("No output type specified.");
          var D = (Q = W.toLowerCase()) === "string" || Q === "text";
          Q !== "binarystring" && Q !== "text" || (Q = "string"), U = this._decompressWorker();
          var ee = !this._dataBinary;
          ee && !D && (U = U.pipe(new v.Utf8EncodeWorker())), !ee && D && (U = U.pipe(new v.Utf8DecodeWorker()));
        } catch (J) {
          (U = new k("error")).error(J);
        }
        return new h(U, Q, "");
      }, async: function(W, U) {
        return this.internalStream(W).accumulate(U);
      }, nodeStream: function(W, U) {
        return this.internalStream(W || "nodebuffer").toNodejsStream(U);
      }, _compressWorker: function(W, U) {
        if (this._data instanceof x && this._data.compression.magic === W.magic)
          return this._data.getCompressedWorker();
        var Q = this._decompressWorker();
        return this._dataBinary || (Q = Q.pipe(new v.Utf8EncodeWorker())), x.createWorkerFrom(Q, W, U);
      }, _decompressWorker: function() {
        return this._data instanceof x ? this._data.getContentWorker() : this._data instanceof k ? this._data : new f(this._data);
      } };
      for (var I = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"], V = function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, M = 0; M < I.length; M++)
        o.prototype[I[M]] = V;
      n.exports = o;
    }, { "./compressedObject": 2, "./stream/DataWorker": 27, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31 }], 36: [function(t, n, a) {
      (function(o) {
        var h, f, v = o.MutationObserver || o.WebKitMutationObserver;
        if (v) {
          var x = 0, k = new v(W), I = o.document.createTextNode("");
          k.observe(I, { characterData: !0 }), h = function() {
            I.data = x = ++x % 2;
          };
        } else if (o.setImmediate || o.MessageChannel === void 0)
          h = "document" in o && "onreadystatechange" in o.document.createElement("script") ? function() {
            var U = o.document.createElement("script");
            U.onreadystatechange = function() {
              W(), U.onreadystatechange = null, U.parentNode.removeChild(U), U = null;
            }, o.document.documentElement.appendChild(U);
          } : function() {
            setTimeout(W, 0);
          };
        else {
          var V = new o.MessageChannel();
          V.port1.onmessage = W, h = function() {
            V.port2.postMessage(0);
          };
        }
        var M = [];
        function W() {
          var U, Q;
          f = !0;
          for (var D = M.length; D; ) {
            for (Q = M, M = [], U = -1; ++U < D; )
              Q[U]();
            D = M.length;
          }
          f = !1;
        }
        n.exports = function(U) {
          M.push(U) !== 1 || f || h();
        };
      }).call(this, typeof ts < "u" ? ts : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}], 37: [function(t, n, a) {
      var o = t("immediate");
      function h() {
      }
      var f = {}, v = ["REJECTED"], x = ["FULFILLED"], k = ["PENDING"];
      function I(D) {
        if (typeof D != "function")
          throw new TypeError("resolver must be a function");
        this.state = k, this.queue = [], this.outcome = void 0, D !== h && U(this, D);
      }
      function V(D, ee, J) {
        this.promise = D, typeof ee == "function" && (this.onFulfilled = ee, this.callFulfilled = this.otherCallFulfilled), typeof J == "function" && (this.onRejected = J, this.callRejected = this.otherCallRejected);
      }
      function M(D, ee, J) {
        o(function() {
          var he;
          try {
            he = ee(J);
          } catch (fe) {
            return f.reject(D, fe);
          }
          he === D ? f.reject(D, new TypeError("Cannot resolve promise with itself")) : f.resolve(D, he);
        });
      }
      function W(D) {
        var ee = D && D.then;
        if (D && (typeof D == "object" || typeof D == "function") && typeof ee == "function")
          return function() {
            ee.apply(D, arguments);
          };
      }
      function U(D, ee) {
        var J = !1;
        function he(Z) {
          J || (J = !0, f.reject(D, Z));
        }
        function fe(Z) {
          J || (J = !0, f.resolve(D, Z));
        }
        var X = Q(function() {
          ee(fe, he);
        });
        X.status === "error" && he(X.value);
      }
      function Q(D, ee) {
        var J = {};
        try {
          J.value = D(ee), J.status = "success";
        } catch (he) {
          J.status = "error", J.value = he;
        }
        return J;
      }
      (n.exports = I).prototype.finally = function(D) {
        if (typeof D != "function")
          return this;
        var ee = this.constructor;
        return this.then(function(J) {
          return ee.resolve(D()).then(function() {
            return J;
          });
        }, function(J) {
          return ee.resolve(D()).then(function() {
            throw J;
          });
        });
      }, I.prototype.catch = function(D) {
        return this.then(null, D);
      }, I.prototype.then = function(D, ee) {
        if (typeof D != "function" && this.state === x || typeof ee != "function" && this.state === v)
          return this;
        var J = new this.constructor(h);
        return this.state !== k ? M(J, this.state === x ? D : ee, this.outcome) : this.queue.push(new V(J, D, ee)), J;
      }, V.prototype.callFulfilled = function(D) {
        f.resolve(this.promise, D);
      }, V.prototype.otherCallFulfilled = function(D) {
        M(this.promise, this.onFulfilled, D);
      }, V.prototype.callRejected = function(D) {
        f.reject(this.promise, D);
      }, V.prototype.otherCallRejected = function(D) {
        M(this.promise, this.onRejected, D);
      }, f.resolve = function(D, ee) {
        var J = Q(W, ee);
        if (J.status === "error")
          return f.reject(D, J.value);
        var he = J.value;
        if (he)
          U(D, he);
        else {
          D.state = x, D.outcome = ee;
          for (var fe = -1, X = D.queue.length; ++fe < X; )
            D.queue[fe].callFulfilled(ee);
        }
        return D;
      }, f.reject = function(D, ee) {
        D.state = v, D.outcome = ee;
        for (var J = -1, he = D.queue.length; ++J < he; )
          D.queue[J].callRejected(ee);
        return D;
      }, I.resolve = function(D) {
        return D instanceof this ? D : f.resolve(new this(h), D);
      }, I.reject = function(D) {
        var ee = new this(h);
        return f.reject(ee, D);
      }, I.all = function(D) {
        var ee = this;
        if (Object.prototype.toString.call(D) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var J = D.length, he = !1;
        if (!J)
          return this.resolve([]);
        for (var fe = new Array(J), X = 0, Z = -1, qe = new this(h); ++Z < J; )
          Oe(D[Z], Z);
        return qe;
        function Oe(je, pt) {
          ee.resolve(je).then(function(Te) {
            fe[pt] = Te, ++X !== J || he || (he = !0, f.resolve(qe, fe));
          }, function(Te) {
            he || (he = !0, f.reject(qe, Te));
          });
        }
      }, I.race = function(D) {
        var ee = this;
        if (Object.prototype.toString.call(D) !== "[object Array]")
          return this.reject(new TypeError("must be an array"));
        var J = D.length, he = !1;
        if (!J)
          return this.resolve([]);
        for (var fe = -1, X = new this(h); ++fe < J; )
          Z = D[fe], ee.resolve(Z).then(function(qe) {
            he || (he = !0, f.resolve(X, qe));
          }, function(qe) {
            he || (he = !0, f.reject(X, qe));
          });
        var Z;
        return X;
      };
    }, { immediate: 36 }], 38: [function(t, n, a) {
      var o = {};
      (0, t("./lib/utils/common").assign)(o, t("./lib/deflate"), t("./lib/inflate"), t("./lib/zlib/constants")), n.exports = o;
    }, { "./lib/deflate": 39, "./lib/inflate": 40, "./lib/utils/common": 41, "./lib/zlib/constants": 44 }], 39: [function(t, n, a) {
      var o = t("./zlib/deflate"), h = t("./utils/common"), f = t("./utils/strings"), v = t("./zlib/messages"), x = t("./zlib/zstream"), k = Object.prototype.toString, I = 0, V = -1, M = 0, W = 8;
      function U(D) {
        if (!(this instanceof U))
          return new U(D);
        this.options = h.assign({ level: V, method: W, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: M, to: "" }, D || {});
        var ee = this.options;
        ee.raw && 0 < ee.windowBits ? ee.windowBits = -ee.windowBits : ee.gzip && 0 < ee.windowBits && ee.windowBits < 16 && (ee.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new x(), this.strm.avail_out = 0;
        var J = o.deflateInit2(this.strm, ee.level, ee.method, ee.windowBits, ee.memLevel, ee.strategy);
        if (J !== I)
          throw new Error(v[J]);
        if (ee.header && o.deflateSetHeader(this.strm, ee.header), ee.dictionary) {
          var he;
          if (he = typeof ee.dictionary == "string" ? f.string2buf(ee.dictionary) : k.call(ee.dictionary) === "[object ArrayBuffer]" ? new Uint8Array(ee.dictionary) : ee.dictionary, (J = o.deflateSetDictionary(this.strm, he)) !== I)
            throw new Error(v[J]);
          this._dict_set = !0;
        }
      }
      function Q(D, ee) {
        var J = new U(ee);
        if (J.push(D, !0), J.err)
          throw J.msg || v[J.err];
        return J.result;
      }
      U.prototype.push = function(D, ee) {
        var J, he, fe = this.strm, X = this.options.chunkSize;
        if (this.ended)
          return !1;
        he = ee === ~~ee ? ee : ee === !0 ? 4 : 0, typeof D == "string" ? fe.input = f.string2buf(D) : k.call(D) === "[object ArrayBuffer]" ? fe.input = new Uint8Array(D) : fe.input = D, fe.next_in = 0, fe.avail_in = fe.input.length;
        do {
          if (fe.avail_out === 0 && (fe.output = new h.Buf8(X), fe.next_out = 0, fe.avail_out = X), (J = o.deflate(fe, he)) !== 1 && J !== I)
            return this.onEnd(J), !(this.ended = !0);
          fe.avail_out !== 0 && (fe.avail_in !== 0 || he !== 4 && he !== 2) || (this.options.to === "string" ? this.onData(f.buf2binstring(h.shrinkBuf(fe.output, fe.next_out))) : this.onData(h.shrinkBuf(fe.output, fe.next_out)));
        } while ((0 < fe.avail_in || fe.avail_out === 0) && J !== 1);
        return he === 4 ? (J = o.deflateEnd(this.strm), this.onEnd(J), this.ended = !0, J === I) : he !== 2 || (this.onEnd(I), !(fe.avail_out = 0));
      }, U.prototype.onData = function(D) {
        this.chunks.push(D);
      }, U.prototype.onEnd = function(D) {
        D === I && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = h.flattenChunks(this.chunks)), this.chunks = [], this.err = D, this.msg = this.strm.msg;
      }, a.Deflate = U, a.deflate = Q, a.deflateRaw = function(D, ee) {
        return (ee = ee || {}).raw = !0, Q(D, ee);
      }, a.gzip = function(D, ee) {
        return (ee = ee || {}).gzip = !0, Q(D, ee);
      };
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/deflate": 46, "./zlib/messages": 51, "./zlib/zstream": 53 }], 40: [function(t, n, a) {
      var o = t("./zlib/inflate"), h = t("./utils/common"), f = t("./utils/strings"), v = t("./zlib/constants"), x = t("./zlib/messages"), k = t("./zlib/zstream"), I = t("./zlib/gzheader"), V = Object.prototype.toString;
      function M(U) {
        if (!(this instanceof M))
          return new M(U);
        this.options = h.assign({ chunkSize: 16384, windowBits: 0, to: "" }, U || {});
        var Q = this.options;
        Q.raw && 0 <= Q.windowBits && Q.windowBits < 16 && (Q.windowBits = -Q.windowBits, Q.windowBits === 0 && (Q.windowBits = -15)), !(0 <= Q.windowBits && Q.windowBits < 16) || U && U.windowBits || (Q.windowBits += 32), 15 < Q.windowBits && Q.windowBits < 48 && !(15 & Q.windowBits) && (Q.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new k(), this.strm.avail_out = 0;
        var D = o.inflateInit2(this.strm, Q.windowBits);
        if (D !== v.Z_OK)
          throw new Error(x[D]);
        this.header = new I(), o.inflateGetHeader(this.strm, this.header);
      }
      function W(U, Q) {
        var D = new M(Q);
        if (D.push(U, !0), D.err)
          throw D.msg || x[D.err];
        return D.result;
      }
      M.prototype.push = function(U, Q) {
        var D, ee, J, he, fe, X, Z = this.strm, qe = this.options.chunkSize, Oe = this.options.dictionary, je = !1;
        if (this.ended)
          return !1;
        ee = Q === ~~Q ? Q : Q === !0 ? v.Z_FINISH : v.Z_NO_FLUSH, typeof U == "string" ? Z.input = f.binstring2buf(U) : V.call(U) === "[object ArrayBuffer]" ? Z.input = new Uint8Array(U) : Z.input = U, Z.next_in = 0, Z.avail_in = Z.input.length;
        do {
          if (Z.avail_out === 0 && (Z.output = new h.Buf8(qe), Z.next_out = 0, Z.avail_out = qe), (D = o.inflate(Z, v.Z_NO_FLUSH)) === v.Z_NEED_DICT && Oe && (X = typeof Oe == "string" ? f.string2buf(Oe) : V.call(Oe) === "[object ArrayBuffer]" ? new Uint8Array(Oe) : Oe, D = o.inflateSetDictionary(this.strm, X)), D === v.Z_BUF_ERROR && je === !0 && (D = v.Z_OK, je = !1), D !== v.Z_STREAM_END && D !== v.Z_OK)
            return this.onEnd(D), !(this.ended = !0);
          Z.next_out && (Z.avail_out !== 0 && D !== v.Z_STREAM_END && (Z.avail_in !== 0 || ee !== v.Z_FINISH && ee !== v.Z_SYNC_FLUSH) || (this.options.to === "string" ? (J = f.utf8border(Z.output, Z.next_out), he = Z.next_out - J, fe = f.buf2string(Z.output, J), Z.next_out = he, Z.avail_out = qe - he, he && h.arraySet(Z.output, Z.output, J, he, 0), this.onData(fe)) : this.onData(h.shrinkBuf(Z.output, Z.next_out)))), Z.avail_in === 0 && Z.avail_out === 0 && (je = !0);
        } while ((0 < Z.avail_in || Z.avail_out === 0) && D !== v.Z_STREAM_END);
        return D === v.Z_STREAM_END && (ee = v.Z_FINISH), ee === v.Z_FINISH ? (D = o.inflateEnd(this.strm), this.onEnd(D), this.ended = !0, D === v.Z_OK) : ee !== v.Z_SYNC_FLUSH || (this.onEnd(v.Z_OK), !(Z.avail_out = 0));
      }, M.prototype.onData = function(U) {
        this.chunks.push(U);
      }, M.prototype.onEnd = function(U) {
        U === v.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = h.flattenChunks(this.chunks)), this.chunks = [], this.err = U, this.msg = this.strm.msg;
      }, a.Inflate = M, a.inflate = W, a.inflateRaw = function(U, Q) {
        return (Q = Q || {}).raw = !0, W(U, Q);
      }, a.ungzip = W;
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/constants": 44, "./zlib/gzheader": 47, "./zlib/inflate": 49, "./zlib/messages": 51, "./zlib/zstream": 53 }], 41: [function(t, n, a) {
      var o = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
      a.assign = function(v) {
        for (var x = Array.prototype.slice.call(arguments, 1); x.length; ) {
          var k = x.shift();
          if (k) {
            if (typeof k != "object")
              throw new TypeError(k + "must be non-object");
            for (var I in k)
              k.hasOwnProperty(I) && (v[I] = k[I]);
          }
        }
        return v;
      }, a.shrinkBuf = function(v, x) {
        return v.length === x ? v : v.subarray ? v.subarray(0, x) : (v.length = x, v);
      };
      var h = { arraySet: function(v, x, k, I, V) {
        if (x.subarray && v.subarray)
          v.set(x.subarray(k, k + I), V);
        else
          for (var M = 0; M < I; M++)
            v[V + M] = x[k + M];
      }, flattenChunks: function(v) {
        var x, k, I, V, M, W;
        for (x = I = 0, k = v.length; x < k; x++)
          I += v[x].length;
        for (W = new Uint8Array(I), x = V = 0, k = v.length; x < k; x++)
          M = v[x], W.set(M, V), V += M.length;
        return W;
      } }, f = { arraySet: function(v, x, k, I, V) {
        for (var M = 0; M < I; M++)
          v[V + M] = x[k + M];
      }, flattenChunks: function(v) {
        return [].concat.apply([], v);
      } };
      a.setTyped = function(v) {
        v ? (a.Buf8 = Uint8Array, a.Buf16 = Uint16Array, a.Buf32 = Int32Array, a.assign(a, h)) : (a.Buf8 = Array, a.Buf16 = Array, a.Buf32 = Array, a.assign(a, f));
      }, a.setTyped(o);
    }, {}], 42: [function(t, n, a) {
      var o = t("./common"), h = !0, f = !0;
      try {
        String.fromCharCode.apply(null, [0]);
      } catch {
        h = !1;
      }
      try {
        String.fromCharCode.apply(null, new Uint8Array(1));
      } catch {
        f = !1;
      }
      for (var v = new o.Buf8(256), x = 0; x < 256; x++)
        v[x] = 252 <= x ? 6 : 248 <= x ? 5 : 240 <= x ? 4 : 224 <= x ? 3 : 192 <= x ? 2 : 1;
      function k(I, V) {
        if (V < 65537 && (I.subarray && f || !I.subarray && h))
          return String.fromCharCode.apply(null, o.shrinkBuf(I, V));
        for (var M = "", W = 0; W < V; W++)
          M += String.fromCharCode(I[W]);
        return M;
      }
      v[254] = v[254] = 1, a.string2buf = function(I) {
        var V, M, W, U, Q, D = I.length, ee = 0;
        for (U = 0; U < D; U++)
          (64512 & (M = I.charCodeAt(U))) == 55296 && U + 1 < D && (64512 & (W = I.charCodeAt(U + 1))) == 56320 && (M = 65536 + (M - 55296 << 10) + (W - 56320), U++), ee += M < 128 ? 1 : M < 2048 ? 2 : M < 65536 ? 3 : 4;
        for (V = new o.Buf8(ee), U = Q = 0; Q < ee; U++)
          (64512 & (M = I.charCodeAt(U))) == 55296 && U + 1 < D && (64512 & (W = I.charCodeAt(U + 1))) == 56320 && (M = 65536 + (M - 55296 << 10) + (W - 56320), U++), M < 128 ? V[Q++] = M : (M < 2048 ? V[Q++] = 192 | M >>> 6 : (M < 65536 ? V[Q++] = 224 | M >>> 12 : (V[Q++] = 240 | M >>> 18, V[Q++] = 128 | M >>> 12 & 63), V[Q++] = 128 | M >>> 6 & 63), V[Q++] = 128 | 63 & M);
        return V;
      }, a.buf2binstring = function(I) {
        return k(I, I.length);
      }, a.binstring2buf = function(I) {
        for (var V = new o.Buf8(I.length), M = 0, W = V.length; M < W; M++)
          V[M] = I.charCodeAt(M);
        return V;
      }, a.buf2string = function(I, V) {
        var M, W, U, Q, D = V || I.length, ee = new Array(2 * D);
        for (M = W = 0; M < D; )
          if ((U = I[M++]) < 128)
            ee[W++] = U;
          else if (4 < (Q = v[U]))
            ee[W++] = 65533, M += Q - 1;
          else {
            for (U &= Q === 2 ? 31 : Q === 3 ? 15 : 7; 1 < Q && M < D; )
              U = U << 6 | 63 & I[M++], Q--;
            1 < Q ? ee[W++] = 65533 : U < 65536 ? ee[W++] = U : (U -= 65536, ee[W++] = 55296 | U >> 10 & 1023, ee[W++] = 56320 | 1023 & U);
          }
        return k(ee, W);
      }, a.utf8border = function(I, V) {
        var M;
        for ((V = V || I.length) > I.length && (V = I.length), M = V - 1; 0 <= M && (192 & I[M]) == 128; )
          M--;
        return M < 0 || M === 0 ? V : M + v[I[M]] > V ? M : V;
      };
    }, { "./common": 41 }], 43: [function(t, n, a) {
      n.exports = function(o, h, f, v) {
        for (var x = 65535 & o | 0, k = o >>> 16 & 65535 | 0, I = 0; f !== 0; ) {
          for (f -= I = 2e3 < f ? 2e3 : f; k = k + (x = x + h[v++] | 0) | 0, --I; )
            ;
          x %= 65521, k %= 65521;
        }
        return x | k << 16 | 0;
      };
    }, {}], 44: [function(t, n, a) {
      n.exports = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 };
    }, {}], 45: [function(t, n, a) {
      var o = function() {
        for (var h, f = [], v = 0; v < 256; v++) {
          h = v;
          for (var x = 0; x < 8; x++)
            h = 1 & h ? 3988292384 ^ h >>> 1 : h >>> 1;
          f[v] = h;
        }
        return f;
      }();
      n.exports = function(h, f, v, x) {
        var k = o, I = x + v;
        h ^= -1;
        for (var V = x; V < I; V++)
          h = h >>> 8 ^ k[255 & (h ^ f[V])];
        return -1 ^ h;
      };
    }, {}], 46: [function(t, n, a) {
      var o, h = t("../utils/common"), f = t("./trees"), v = t("./adler32"), x = t("./crc32"), k = t("./messages"), I = 0, V = 4, M = 0, W = -2, U = -1, Q = 4, D = 2, ee = 8, J = 9, he = 286, fe = 30, X = 19, Z = 2 * he + 1, qe = 15, Oe = 3, je = 258, pt = je + Oe + 1, Te = 42, Ze = 113, ce = 1, ut = 2, ze = 3, ht = 4;
      function Gt(pe, Lt) {
        return pe.msg = k[Lt], Lt;
      }
      function $e(pe) {
        return (pe << 1) - (4 < pe ? 9 : 0);
      }
      function It(pe) {
        for (var Lt = pe.length; 0 <= --Lt; )
          pe[Lt] = 0;
      }
      function rt(pe) {
        var Lt = pe.state, xt = Lt.pending;
        xt > pe.avail_out && (xt = pe.avail_out), xt !== 0 && (h.arraySet(pe.output, Lt.pending_buf, Lt.pending_out, xt, pe.next_out), pe.next_out += xt, Lt.pending_out += xt, pe.total_out += xt, pe.avail_out -= xt, Lt.pending -= xt, Lt.pending === 0 && (Lt.pending_out = 0));
      }
      function it(pe, Lt) {
        f._tr_flush_block(pe, 0 <= pe.block_start ? pe.block_start : -1, pe.strstart - pe.block_start, Lt), pe.block_start = pe.strstart, rt(pe.strm);
      }
      function Xt(pe, Lt) {
        pe.pending_buf[pe.pending++] = Lt;
      }
      function $t(pe, Lt) {
        pe.pending_buf[pe.pending++] = Lt >>> 8 & 255, pe.pending_buf[pe.pending++] = 255 & Lt;
      }
      function Tt(pe, Lt) {
        var xt, Ne, Ie = pe.max_chain_length, et = pe.strstart, Et = pe.prev_length, ft = pe.nice_match, tt = pe.strstart > pe.w_size - pt ? pe.strstart - (pe.w_size - pt) : 0, _t = pe.window, Kt = pe.w_mask, Ve = pe.prev, i = pe.strstart + je, r = _t[et + Et - 1], s = _t[et + Et];
        pe.prev_length >= pe.good_match && (Ie >>= 2), ft > pe.lookahead && (ft = pe.lookahead);
        do
          if (_t[(xt = Lt) + Et] === s && _t[xt + Et - 1] === r && _t[xt] === _t[et] && _t[++xt] === _t[et + 1]) {
            et += 2, xt++;
            do
              ;
            while (_t[++et] === _t[++xt] && _t[++et] === _t[++xt] && _t[++et] === _t[++xt] && _t[++et] === _t[++xt] && _t[++et] === _t[++xt] && _t[++et] === _t[++xt] && _t[++et] === _t[++xt] && _t[++et] === _t[++xt] && et < i);
            if (Ne = je - (i - et), et = i - je, Et < Ne) {
              if (pe.match_start = Lt, ft <= (Et = Ne))
                break;
              r = _t[et + Et - 1], s = _t[et + Et];
            }
          }
        while ((Lt = Ve[Lt & Kt]) > tt && --Ie != 0);
        return Et <= pe.lookahead ? Et : pe.lookahead;
      }
      function Bi(pe) {
        var Lt, xt, Ne, Ie, et, Et, ft, tt, _t, Kt, Ve = pe.w_size;
        do {
          if (Ie = pe.window_size - pe.lookahead - pe.strstart, pe.strstart >= Ve + (Ve - pt)) {
            for (h.arraySet(pe.window, pe.window, Ve, Ve, 0), pe.match_start -= Ve, pe.strstart -= Ve, pe.block_start -= Ve, Lt = xt = pe.hash_size; Ne = pe.head[--Lt], pe.head[Lt] = Ve <= Ne ? Ne - Ve : 0, --xt; )
              ;
            for (Lt = xt = Ve; Ne = pe.prev[--Lt], pe.prev[Lt] = Ve <= Ne ? Ne - Ve : 0, --xt; )
              ;
            Ie += Ve;
          }
          if (pe.strm.avail_in === 0)
            break;
          if (Et = pe.strm, ft = pe.window, tt = pe.strstart + pe.lookahead, _t = Ie, Kt = void 0, Kt = Et.avail_in, _t < Kt && (Kt = _t), xt = Kt === 0 ? 0 : (Et.avail_in -= Kt, h.arraySet(ft, Et.input, Et.next_in, Kt, tt), Et.state.wrap === 1 ? Et.adler = v(Et.adler, ft, Kt, tt) : Et.state.wrap === 2 && (Et.adler = x(Et.adler, ft, Kt, tt)), Et.next_in += Kt, Et.total_in += Kt, Kt), pe.lookahead += xt, pe.lookahead + pe.insert >= Oe)
            for (et = pe.strstart - pe.insert, pe.ins_h = pe.window[et], pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[et + 1]) & pe.hash_mask; pe.insert && (pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[et + Oe - 1]) & pe.hash_mask, pe.prev[et & pe.w_mask] = pe.head[pe.ins_h], pe.head[pe.ins_h] = et, et++, pe.insert--, !(pe.lookahead + pe.insert < Oe)); )
              ;
        } while (pe.lookahead < pt && pe.strm.avail_in !== 0);
      }
      function en(pe, Lt) {
        for (var xt, Ne; ; ) {
          if (pe.lookahead < pt) {
            if (Bi(pe), pe.lookahead < pt && Lt === I)
              return ce;
            if (pe.lookahead === 0)
              break;
          }
          if (xt = 0, pe.lookahead >= Oe && (pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[pe.strstart + Oe - 1]) & pe.hash_mask, xt = pe.prev[pe.strstart & pe.w_mask] = pe.head[pe.ins_h], pe.head[pe.ins_h] = pe.strstart), xt !== 0 && pe.strstart - xt <= pe.w_size - pt && (pe.match_length = Tt(pe, xt)), pe.match_length >= Oe)
            if (Ne = f._tr_tally(pe, pe.strstart - pe.match_start, pe.match_length - Oe), pe.lookahead -= pe.match_length, pe.match_length <= pe.max_lazy_match && pe.lookahead >= Oe) {
              for (pe.match_length--; pe.strstart++, pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[pe.strstart + Oe - 1]) & pe.hash_mask, xt = pe.prev[pe.strstart & pe.w_mask] = pe.head[pe.ins_h], pe.head[pe.ins_h] = pe.strstart, --pe.match_length != 0; )
                ;
              pe.strstart++;
            } else
              pe.strstart += pe.match_length, pe.match_length = 0, pe.ins_h = pe.window[pe.strstart], pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[pe.strstart + 1]) & pe.hash_mask;
          else
            Ne = f._tr_tally(pe, 0, pe.window[pe.strstart]), pe.lookahead--, pe.strstart++;
          if (Ne && (it(pe, !1), pe.strm.avail_out === 0))
            return ce;
        }
        return pe.insert = pe.strstart < Oe - 1 ? pe.strstart : Oe - 1, Lt === V ? (it(pe, !0), pe.strm.avail_out === 0 ? ze : ht) : pe.last_lit && (it(pe, !1), pe.strm.avail_out === 0) ? ce : ut;
      }
      function oi(pe, Lt) {
        for (var xt, Ne, Ie; ; ) {
          if (pe.lookahead < pt) {
            if (Bi(pe), pe.lookahead < pt && Lt === I)
              return ce;
            if (pe.lookahead === 0)
              break;
          }
          if (xt = 0, pe.lookahead >= Oe && (pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[pe.strstart + Oe - 1]) & pe.hash_mask, xt = pe.prev[pe.strstart & pe.w_mask] = pe.head[pe.ins_h], pe.head[pe.ins_h] = pe.strstart), pe.prev_length = pe.match_length, pe.prev_match = pe.match_start, pe.match_length = Oe - 1, xt !== 0 && pe.prev_length < pe.max_lazy_match && pe.strstart - xt <= pe.w_size - pt && (pe.match_length = Tt(pe, xt), pe.match_length <= 5 && (pe.strategy === 1 || pe.match_length === Oe && 4096 < pe.strstart - pe.match_start) && (pe.match_length = Oe - 1)), pe.prev_length >= Oe && pe.match_length <= pe.prev_length) {
            for (Ie = pe.strstart + pe.lookahead - Oe, Ne = f._tr_tally(pe, pe.strstart - 1 - pe.prev_match, pe.prev_length - Oe), pe.lookahead -= pe.prev_length - 1, pe.prev_length -= 2; ++pe.strstart <= Ie && (pe.ins_h = (pe.ins_h << pe.hash_shift ^ pe.window[pe.strstart + Oe - 1]) & pe.hash_mask, xt = pe.prev[pe.strstart & pe.w_mask] = pe.head[pe.ins_h], pe.head[pe.ins_h] = pe.strstart), --pe.prev_length != 0; )
              ;
            if (pe.match_available = 0, pe.match_length = Oe - 1, pe.strstart++, Ne && (it(pe, !1), pe.strm.avail_out === 0))
              return ce;
          } else if (pe.match_available) {
            if ((Ne = f._tr_tally(pe, 0, pe.window[pe.strstart - 1])) && it(pe, !1), pe.strstart++, pe.lookahead--, pe.strm.avail_out === 0)
              return ce;
          } else
            pe.match_available = 1, pe.strstart++, pe.lookahead--;
        }
        return pe.match_available && (Ne = f._tr_tally(pe, 0, pe.window[pe.strstart - 1]), pe.match_available = 0), pe.insert = pe.strstart < Oe - 1 ? pe.strstart : Oe - 1, Lt === V ? (it(pe, !0), pe.strm.avail_out === 0 ? ze : ht) : pe.last_lit && (it(pe, !1), pe.strm.avail_out === 0) ? ce : ut;
      }
      function Zt(pe, Lt, xt, Ne, Ie) {
        this.good_length = pe, this.max_lazy = Lt, this.nice_length = xt, this.max_chain = Ne, this.func = Ie;
      }
      function Jt() {
        this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = ee, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new h.Buf16(2 * Z), this.dyn_dtree = new h.Buf16(2 * (2 * fe + 1)), this.bl_tree = new h.Buf16(2 * (2 * X + 1)), It(this.dyn_ltree), It(this.dyn_dtree), It(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new h.Buf16(qe + 1), this.heap = new h.Buf16(2 * he + 1), It(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new h.Buf16(2 * he + 1), It(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
      }
      function Qt(pe) {
        var Lt;
        return pe && pe.state ? (pe.total_in = pe.total_out = 0, pe.data_type = D, (Lt = pe.state).pending = 0, Lt.pending_out = 0, Lt.wrap < 0 && (Lt.wrap = -Lt.wrap), Lt.status = Lt.wrap ? Te : Ze, pe.adler = Lt.wrap === 2 ? 0 : 1, Lt.last_flush = I, f._tr_init(Lt), M) : Gt(pe, W);
      }
      function rn(pe) {
        var Lt = Qt(pe);
        return Lt === M && function(xt) {
          xt.window_size = 2 * xt.w_size, It(xt.head), xt.max_lazy_match = o[xt.level].max_lazy, xt.good_match = o[xt.level].good_length, xt.nice_match = o[xt.level].nice_length, xt.max_chain_length = o[xt.level].max_chain, xt.strstart = 0, xt.block_start = 0, xt.lookahead = 0, xt.insert = 0, xt.match_length = xt.prev_length = Oe - 1, xt.match_available = 0, xt.ins_h = 0;
        }(pe.state), Lt;
      }
      function Gi(pe, Lt, xt, Ne, Ie, et) {
        if (!pe)
          return W;
        var Et = 1;
        if (Lt === U && (Lt = 6), Ne < 0 ? (Et = 0, Ne = -Ne) : 15 < Ne && (Et = 2, Ne -= 16), Ie < 1 || J < Ie || xt !== ee || Ne < 8 || 15 < Ne || Lt < 0 || 9 < Lt || et < 0 || Q < et)
          return Gt(pe, W);
        Ne === 8 && (Ne = 9);
        var ft = new Jt();
        return (pe.state = ft).strm = pe, ft.wrap = Et, ft.gzhead = null, ft.w_bits = Ne, ft.w_size = 1 << ft.w_bits, ft.w_mask = ft.w_size - 1, ft.hash_bits = Ie + 7, ft.hash_size = 1 << ft.hash_bits, ft.hash_mask = ft.hash_size - 1, ft.hash_shift = ~~((ft.hash_bits + Oe - 1) / Oe), ft.window = new h.Buf8(2 * ft.w_size), ft.head = new h.Buf16(ft.hash_size), ft.prev = new h.Buf16(ft.w_size), ft.lit_bufsize = 1 << Ie + 6, ft.pending_buf_size = 4 * ft.lit_bufsize, ft.pending_buf = new h.Buf8(ft.pending_buf_size), ft.d_buf = 1 * ft.lit_bufsize, ft.l_buf = 3 * ft.lit_bufsize, ft.level = Lt, ft.strategy = et, ft.method = xt, rn(pe);
      }
      o = [new Zt(0, 0, 0, 0, function(pe, Lt) {
        var xt = 65535;
        for (xt > pe.pending_buf_size - 5 && (xt = pe.pending_buf_size - 5); ; ) {
          if (pe.lookahead <= 1) {
            if (Bi(pe), pe.lookahead === 0 && Lt === I)
              return ce;
            if (pe.lookahead === 0)
              break;
          }
          pe.strstart += pe.lookahead, pe.lookahead = 0;
          var Ne = pe.block_start + xt;
          if ((pe.strstart === 0 || pe.strstart >= Ne) && (pe.lookahead = pe.strstart - Ne, pe.strstart = Ne, it(pe, !1), pe.strm.avail_out === 0) || pe.strstart - pe.block_start >= pe.w_size - pt && (it(pe, !1), pe.strm.avail_out === 0))
            return ce;
        }
        return pe.insert = 0, Lt === V ? (it(pe, !0), pe.strm.avail_out === 0 ? ze : ht) : (pe.strstart > pe.block_start && (it(pe, !1), pe.strm.avail_out), ce);
      }), new Zt(4, 4, 8, 4, en), new Zt(4, 5, 16, 8, en), new Zt(4, 6, 32, 32, en), new Zt(4, 4, 16, 16, oi), new Zt(8, 16, 32, 32, oi), new Zt(8, 16, 128, 128, oi), new Zt(8, 32, 128, 256, oi), new Zt(32, 128, 258, 1024, oi), new Zt(32, 258, 258, 4096, oi)], a.deflateInit = function(pe, Lt) {
        return Gi(pe, Lt, ee, 15, 8, 0);
      }, a.deflateInit2 = Gi, a.deflateReset = rn, a.deflateResetKeep = Qt, a.deflateSetHeader = function(pe, Lt) {
        return pe && pe.state ? pe.state.wrap !== 2 ? W : (pe.state.gzhead = Lt, M) : W;
      }, a.deflate = function(pe, Lt) {
        var xt, Ne, Ie, et;
        if (!pe || !pe.state || 5 < Lt || Lt < 0)
          return pe ? Gt(pe, W) : W;
        if (Ne = pe.state, !pe.output || !pe.input && pe.avail_in !== 0 || Ne.status === 666 && Lt !== V)
          return Gt(pe, pe.avail_out === 0 ? -5 : W);
        if (Ne.strm = pe, xt = Ne.last_flush, Ne.last_flush = Lt, Ne.status === Te)
          if (Ne.wrap === 2)
            pe.adler = 0, Xt(Ne, 31), Xt(Ne, 139), Xt(Ne, 8), Ne.gzhead ? (Xt(Ne, (Ne.gzhead.text ? 1 : 0) + (Ne.gzhead.hcrc ? 2 : 0) + (Ne.gzhead.extra ? 4 : 0) + (Ne.gzhead.name ? 8 : 0) + (Ne.gzhead.comment ? 16 : 0)), Xt(Ne, 255 & Ne.gzhead.time), Xt(Ne, Ne.gzhead.time >> 8 & 255), Xt(Ne, Ne.gzhead.time >> 16 & 255), Xt(Ne, Ne.gzhead.time >> 24 & 255), Xt(Ne, Ne.level === 9 ? 2 : 2 <= Ne.strategy || Ne.level < 2 ? 4 : 0), Xt(Ne, 255 & Ne.gzhead.os), Ne.gzhead.extra && Ne.gzhead.extra.length && (Xt(Ne, 255 & Ne.gzhead.extra.length), Xt(Ne, Ne.gzhead.extra.length >> 8 & 255)), Ne.gzhead.hcrc && (pe.adler = x(pe.adler, Ne.pending_buf, Ne.pending, 0)), Ne.gzindex = 0, Ne.status = 69) : (Xt(Ne, 0), Xt(Ne, 0), Xt(Ne, 0), Xt(Ne, 0), Xt(Ne, 0), Xt(Ne, Ne.level === 9 ? 2 : 2 <= Ne.strategy || Ne.level < 2 ? 4 : 0), Xt(Ne, 3), Ne.status = Ze);
          else {
            var Et = ee + (Ne.w_bits - 8 << 4) << 8;
            Et |= (2 <= Ne.strategy || Ne.level < 2 ? 0 : Ne.level < 6 ? 1 : Ne.level === 6 ? 2 : 3) << 6, Ne.strstart !== 0 && (Et |= 32), Et += 31 - Et % 31, Ne.status = Ze, $t(Ne, Et), Ne.strstart !== 0 && ($t(Ne, pe.adler >>> 16), $t(Ne, 65535 & pe.adler)), pe.adler = 1;
          }
        if (Ne.status === 69)
          if (Ne.gzhead.extra) {
            for (Ie = Ne.pending; Ne.gzindex < (65535 & Ne.gzhead.extra.length) && (Ne.pending !== Ne.pending_buf_size || (Ne.gzhead.hcrc && Ne.pending > Ie && (pe.adler = x(pe.adler, Ne.pending_buf, Ne.pending - Ie, Ie)), rt(pe), Ie = Ne.pending, Ne.pending !== Ne.pending_buf_size)); )
              Xt(Ne, 255 & Ne.gzhead.extra[Ne.gzindex]), Ne.gzindex++;
            Ne.gzhead.hcrc && Ne.pending > Ie && (pe.adler = x(pe.adler, Ne.pending_buf, Ne.pending - Ie, Ie)), Ne.gzindex === Ne.gzhead.extra.length && (Ne.gzindex = 0, Ne.status = 73);
          } else
            Ne.status = 73;
        if (Ne.status === 73)
          if (Ne.gzhead.name) {
            Ie = Ne.pending;
            do {
              if (Ne.pending === Ne.pending_buf_size && (Ne.gzhead.hcrc && Ne.pending > Ie && (pe.adler = x(pe.adler, Ne.pending_buf, Ne.pending - Ie, Ie)), rt(pe), Ie = Ne.pending, Ne.pending === Ne.pending_buf_size)) {
                et = 1;
                break;
              }
              et = Ne.gzindex < Ne.gzhead.name.length ? 255 & Ne.gzhead.name.charCodeAt(Ne.gzindex++) : 0, Xt(Ne, et);
            } while (et !== 0);
            Ne.gzhead.hcrc && Ne.pending > Ie && (pe.adler = x(pe.adler, Ne.pending_buf, Ne.pending - Ie, Ie)), et === 0 && (Ne.gzindex = 0, Ne.status = 91);
          } else
            Ne.status = 91;
        if (Ne.status === 91)
          if (Ne.gzhead.comment) {
            Ie = Ne.pending;
            do {
              if (Ne.pending === Ne.pending_buf_size && (Ne.gzhead.hcrc && Ne.pending > Ie && (pe.adler = x(pe.adler, Ne.pending_buf, Ne.pending - Ie, Ie)), rt(pe), Ie = Ne.pending, Ne.pending === Ne.pending_buf_size)) {
                et = 1;
                break;
              }
              et = Ne.gzindex < Ne.gzhead.comment.length ? 255 & Ne.gzhead.comment.charCodeAt(Ne.gzindex++) : 0, Xt(Ne, et);
            } while (et !== 0);
            Ne.gzhead.hcrc && Ne.pending > Ie && (pe.adler = x(pe.adler, Ne.pending_buf, Ne.pending - Ie, Ie)), et === 0 && (Ne.status = 103);
          } else
            Ne.status = 103;
        if (Ne.status === 103 && (Ne.gzhead.hcrc ? (Ne.pending + 2 > Ne.pending_buf_size && rt(pe), Ne.pending + 2 <= Ne.pending_buf_size && (Xt(Ne, 255 & pe.adler), Xt(Ne, pe.adler >> 8 & 255), pe.adler = 0, Ne.status = Ze)) : Ne.status = Ze), Ne.pending !== 0) {
          if (rt(pe), pe.avail_out === 0)
            return Ne.last_flush = -1, M;
        } else if (pe.avail_in === 0 && $e(Lt) <= $e(xt) && Lt !== V)
          return Gt(pe, -5);
        if (Ne.status === 666 && pe.avail_in !== 0)
          return Gt(pe, -5);
        if (pe.avail_in !== 0 || Ne.lookahead !== 0 || Lt !== I && Ne.status !== 666) {
          var ft = Ne.strategy === 2 ? function(tt, _t) {
            for (var Kt; ; ) {
              if (tt.lookahead === 0 && (Bi(tt), tt.lookahead === 0)) {
                if (_t === I)
                  return ce;
                break;
              }
              if (tt.match_length = 0, Kt = f._tr_tally(tt, 0, tt.window[tt.strstart]), tt.lookahead--, tt.strstart++, Kt && (it(tt, !1), tt.strm.avail_out === 0))
                return ce;
            }
            return tt.insert = 0, _t === V ? (it(tt, !0), tt.strm.avail_out === 0 ? ze : ht) : tt.last_lit && (it(tt, !1), tt.strm.avail_out === 0) ? ce : ut;
          }(Ne, Lt) : Ne.strategy === 3 ? function(tt, _t) {
            for (var Kt, Ve, i, r, s = tt.window; ; ) {
              if (tt.lookahead <= je) {
                if (Bi(tt), tt.lookahead <= je && _t === I)
                  return ce;
                if (tt.lookahead === 0)
                  break;
              }
              if (tt.match_length = 0, tt.lookahead >= Oe && 0 < tt.strstart && (Ve = s[i = tt.strstart - 1]) === s[++i] && Ve === s[++i] && Ve === s[++i]) {
                r = tt.strstart + je;
                do
                  ;
                while (Ve === s[++i] && Ve === s[++i] && Ve === s[++i] && Ve === s[++i] && Ve === s[++i] && Ve === s[++i] && Ve === s[++i] && Ve === s[++i] && i < r);
                tt.match_length = je - (r - i), tt.match_length > tt.lookahead && (tt.match_length = tt.lookahead);
              }
              if (tt.match_length >= Oe ? (Kt = f._tr_tally(tt, 1, tt.match_length - Oe), tt.lookahead -= tt.match_length, tt.strstart += tt.match_length, tt.match_length = 0) : (Kt = f._tr_tally(tt, 0, tt.window[tt.strstart]), tt.lookahead--, tt.strstart++), Kt && (it(tt, !1), tt.strm.avail_out === 0))
                return ce;
            }
            return tt.insert = 0, _t === V ? (it(tt, !0), tt.strm.avail_out === 0 ? ze : ht) : tt.last_lit && (it(tt, !1), tt.strm.avail_out === 0) ? ce : ut;
          }(Ne, Lt) : o[Ne.level].func(Ne, Lt);
          if (ft !== ze && ft !== ht || (Ne.status = 666), ft === ce || ft === ze)
            return pe.avail_out === 0 && (Ne.last_flush = -1), M;
          if (ft === ut && (Lt === 1 ? f._tr_align(Ne) : Lt !== 5 && (f._tr_stored_block(Ne, 0, 0, !1), Lt === 3 && (It(Ne.head), Ne.lookahead === 0 && (Ne.strstart = 0, Ne.block_start = 0, Ne.insert = 0))), rt(pe), pe.avail_out === 0))
            return Ne.last_flush = -1, M;
        }
        return Lt !== V ? M : Ne.wrap <= 0 ? 1 : (Ne.wrap === 2 ? (Xt(Ne, 255 & pe.adler), Xt(Ne, pe.adler >> 8 & 255), Xt(Ne, pe.adler >> 16 & 255), Xt(Ne, pe.adler >> 24 & 255), Xt(Ne, 255 & pe.total_in), Xt(Ne, pe.total_in >> 8 & 255), Xt(Ne, pe.total_in >> 16 & 255), Xt(Ne, pe.total_in >> 24 & 255)) : ($t(Ne, pe.adler >>> 16), $t(Ne, 65535 & pe.adler)), rt(pe), 0 < Ne.wrap && (Ne.wrap = -Ne.wrap), Ne.pending !== 0 ? M : 1);
      }, a.deflateEnd = function(pe) {
        var Lt;
        return pe && pe.state ? (Lt = pe.state.status) !== Te && Lt !== 69 && Lt !== 73 && Lt !== 91 && Lt !== 103 && Lt !== Ze && Lt !== 666 ? Gt(pe, W) : (pe.state = null, Lt === Ze ? Gt(pe, -3) : M) : W;
      }, a.deflateSetDictionary = function(pe, Lt) {
        var xt, Ne, Ie, et, Et, ft, tt, _t, Kt = Lt.length;
        if (!pe || !pe.state || (et = (xt = pe.state).wrap) === 2 || et === 1 && xt.status !== Te || xt.lookahead)
          return W;
        for (et === 1 && (pe.adler = v(pe.adler, Lt, Kt, 0)), xt.wrap = 0, Kt >= xt.w_size && (et === 0 && (It(xt.head), xt.strstart = 0, xt.block_start = 0, xt.insert = 0), _t = new h.Buf8(xt.w_size), h.arraySet(_t, Lt, Kt - xt.w_size, xt.w_size, 0), Lt = _t, Kt = xt.w_size), Et = pe.avail_in, ft = pe.next_in, tt = pe.input, pe.avail_in = Kt, pe.next_in = 0, pe.input = Lt, Bi(xt); xt.lookahead >= Oe; ) {
          for (Ne = xt.strstart, Ie = xt.lookahead - (Oe - 1); xt.ins_h = (xt.ins_h << xt.hash_shift ^ xt.window[Ne + Oe - 1]) & xt.hash_mask, xt.prev[Ne & xt.w_mask] = xt.head[xt.ins_h], xt.head[xt.ins_h] = Ne, Ne++, --Ie; )
            ;
          xt.strstart = Ne, xt.lookahead = Oe - 1, Bi(xt);
        }
        return xt.strstart += xt.lookahead, xt.block_start = xt.strstart, xt.insert = xt.lookahead, xt.lookahead = 0, xt.match_length = xt.prev_length = Oe - 1, xt.match_available = 0, pe.next_in = ft, pe.input = tt, pe.avail_in = Et, xt.wrap = et, M;
      }, a.deflateInfo = "pako deflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./messages": 51, "./trees": 52 }], 47: [function(t, n, a) {
      n.exports = function() {
        this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
      };
    }, {}], 48: [function(t, n, a) {
      n.exports = function(o, h) {
        var f, v, x, k, I, V, M, W, U, Q, D, ee, J, he, fe, X, Z, qe, Oe, je, pt, Te, Ze, ce, ut;
        f = o.state, v = o.next_in, ce = o.input, x = v + (o.avail_in - 5), k = o.next_out, ut = o.output, I = k - (h - o.avail_out), V = k + (o.avail_out - 257), M = f.dmax, W = f.wsize, U = f.whave, Q = f.wnext, D = f.window, ee = f.hold, J = f.bits, he = f.lencode, fe = f.distcode, X = (1 << f.lenbits) - 1, Z = (1 << f.distbits) - 1;
        e:
          do {
            J < 15 && (ee += ce[v++] << J, J += 8, ee += ce[v++] << J, J += 8), qe = he[ee & X];
            t:
              for (; ; ) {
                if (ee >>>= Oe = qe >>> 24, J -= Oe, (Oe = qe >>> 16 & 255) === 0)
                  ut[k++] = 65535 & qe;
                else {
                  if (!(16 & Oe)) {
                    if (!(64 & Oe)) {
                      qe = he[(65535 & qe) + (ee & (1 << Oe) - 1)];
                      continue t;
                    }
                    if (32 & Oe) {
                      f.mode = 12;
                      break e;
                    }
                    o.msg = "invalid literal/length code", f.mode = 30;
                    break e;
                  }
                  je = 65535 & qe, (Oe &= 15) && (J < Oe && (ee += ce[v++] << J, J += 8), je += ee & (1 << Oe) - 1, ee >>>= Oe, J -= Oe), J < 15 && (ee += ce[v++] << J, J += 8, ee += ce[v++] << J, J += 8), qe = fe[ee & Z];
                  i:
                    for (; ; ) {
                      if (ee >>>= Oe = qe >>> 24, J -= Oe, !(16 & (Oe = qe >>> 16 & 255))) {
                        if (!(64 & Oe)) {
                          qe = fe[(65535 & qe) + (ee & (1 << Oe) - 1)];
                          continue i;
                        }
                        o.msg = "invalid distance code", f.mode = 30;
                        break e;
                      }
                      if (pt = 65535 & qe, J < (Oe &= 15) && (ee += ce[v++] << J, (J += 8) < Oe && (ee += ce[v++] << J, J += 8)), M < (pt += ee & (1 << Oe) - 1)) {
                        o.msg = "invalid distance too far back", f.mode = 30;
                        break e;
                      }
                      if (ee >>>= Oe, J -= Oe, (Oe = k - I) < pt) {
                        if (U < (Oe = pt - Oe) && f.sane) {
                          o.msg = "invalid distance too far back", f.mode = 30;
                          break e;
                        }
                        if (Ze = D, (Te = 0) === Q) {
                          if (Te += W - Oe, Oe < je) {
                            for (je -= Oe; ut[k++] = D[Te++], --Oe; )
                              ;
                            Te = k - pt, Ze = ut;
                          }
                        } else if (Q < Oe) {
                          if (Te += W + Q - Oe, (Oe -= Q) < je) {
                            for (je -= Oe; ut[k++] = D[Te++], --Oe; )
                              ;
                            if (Te = 0, Q < je) {
                              for (je -= Oe = Q; ut[k++] = D[Te++], --Oe; )
                                ;
                              Te = k - pt, Ze = ut;
                            }
                          }
                        } else if (Te += Q - Oe, Oe < je) {
                          for (je -= Oe; ut[k++] = D[Te++], --Oe; )
                            ;
                          Te = k - pt, Ze = ut;
                        }
                        for (; 2 < je; )
                          ut[k++] = Ze[Te++], ut[k++] = Ze[Te++], ut[k++] = Ze[Te++], je -= 3;
                        je && (ut[k++] = Ze[Te++], 1 < je && (ut[k++] = Ze[Te++]));
                      } else {
                        for (Te = k - pt; ut[k++] = ut[Te++], ut[k++] = ut[Te++], ut[k++] = ut[Te++], 2 < (je -= 3); )
                          ;
                        je && (ut[k++] = ut[Te++], 1 < je && (ut[k++] = ut[Te++]));
                      }
                      break;
                    }
                }
                break;
              }
          } while (v < x && k < V);
        v -= je = J >> 3, ee &= (1 << (J -= je << 3)) - 1, o.next_in = v, o.next_out = k, o.avail_in = v < x ? x - v + 5 : 5 - (v - x), o.avail_out = k < V ? V - k + 257 : 257 - (k - V), f.hold = ee, f.bits = J;
      };
    }, {}], 49: [function(t, n, a) {
      var o = t("../utils/common"), h = t("./adler32"), f = t("./crc32"), v = t("./inffast"), x = t("./inftrees"), k = 1, I = 2, V = 0, M = -2, W = 1, U = 852, Q = 592;
      function D(Te) {
        return (Te >>> 24 & 255) + (Te >>> 8 & 65280) + ((65280 & Te) << 8) + ((255 & Te) << 24);
      }
      function ee() {
        this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new o.Buf16(320), this.work = new o.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
      }
      function J(Te) {
        var Ze;
        return Te && Te.state ? (Ze = Te.state, Te.total_in = Te.total_out = Ze.total = 0, Te.msg = "", Ze.wrap && (Te.adler = 1 & Ze.wrap), Ze.mode = W, Ze.last = 0, Ze.havedict = 0, Ze.dmax = 32768, Ze.head = null, Ze.hold = 0, Ze.bits = 0, Ze.lencode = Ze.lendyn = new o.Buf32(U), Ze.distcode = Ze.distdyn = new o.Buf32(Q), Ze.sane = 1, Ze.back = -1, V) : M;
      }
      function he(Te) {
        var Ze;
        return Te && Te.state ? ((Ze = Te.state).wsize = 0, Ze.whave = 0, Ze.wnext = 0, J(Te)) : M;
      }
      function fe(Te, Ze) {
        var ce, ut;
        return Te && Te.state ? (ut = Te.state, Ze < 0 ? (ce = 0, Ze = -Ze) : (ce = 1 + (Ze >> 4), Ze < 48 && (Ze &= 15)), Ze && (Ze < 8 || 15 < Ze) ? M : (ut.window !== null && ut.wbits !== Ze && (ut.window = null), ut.wrap = ce, ut.wbits = Ze, he(Te))) : M;
      }
      function X(Te, Ze) {
        var ce, ut;
        return Te ? (ut = new ee(), (Te.state = ut).window = null, (ce = fe(Te, Ze)) !== V && (Te.state = null), ce) : M;
      }
      var Z, qe, Oe = !0;
      function je(Te) {
        if (Oe) {
          var Ze;
          for (Z = new o.Buf32(512), qe = new o.Buf32(32), Ze = 0; Ze < 144; )
            Te.lens[Ze++] = 8;
          for (; Ze < 256; )
            Te.lens[Ze++] = 9;
          for (; Ze < 280; )
            Te.lens[Ze++] = 7;
          for (; Ze < 288; )
            Te.lens[Ze++] = 8;
          for (x(k, Te.lens, 0, 288, Z, 0, Te.work, { bits: 9 }), Ze = 0; Ze < 32; )
            Te.lens[Ze++] = 5;
          x(I, Te.lens, 0, 32, qe, 0, Te.work, { bits: 5 }), Oe = !1;
        }
        Te.lencode = Z, Te.lenbits = 9, Te.distcode = qe, Te.distbits = 5;
      }
      function pt(Te, Ze, ce, ut) {
        var ze, ht = Te.state;
        return ht.window === null && (ht.wsize = 1 << ht.wbits, ht.wnext = 0, ht.whave = 0, ht.window = new o.Buf8(ht.wsize)), ut >= ht.wsize ? (o.arraySet(ht.window, Ze, ce - ht.wsize, ht.wsize, 0), ht.wnext = 0, ht.whave = ht.wsize) : (ut < (ze = ht.wsize - ht.wnext) && (ze = ut), o.arraySet(ht.window, Ze, ce - ut, ze, ht.wnext), (ut -= ze) ? (o.arraySet(ht.window, Ze, ce - ut, ut, 0), ht.wnext = ut, ht.whave = ht.wsize) : (ht.wnext += ze, ht.wnext === ht.wsize && (ht.wnext = 0), ht.whave < ht.wsize && (ht.whave += ze))), 0;
      }
      a.inflateReset = he, a.inflateReset2 = fe, a.inflateResetKeep = J, a.inflateInit = function(Te) {
        return X(Te, 15);
      }, a.inflateInit2 = X, a.inflate = function(Te, Ze) {
        var ce, ut, ze, ht, Gt, $e, It, rt, it, Xt, $t, Tt, Bi, en, oi, Zt, Jt, Qt, rn, Gi, pe, Lt, xt, Ne, Ie = 0, et = new o.Buf8(4), Et = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
        if (!Te || !Te.state || !Te.output || !Te.input && Te.avail_in !== 0)
          return M;
        (ce = Te.state).mode === 12 && (ce.mode = 13), Gt = Te.next_out, ze = Te.output, It = Te.avail_out, ht = Te.next_in, ut = Te.input, $e = Te.avail_in, rt = ce.hold, it = ce.bits, Xt = $e, $t = It, Lt = V;
        e:
          for (; ; )
            switch (ce.mode) {
              case W:
                if (ce.wrap === 0) {
                  ce.mode = 13;
                  break;
                }
                for (; it < 16; ) {
                  if ($e === 0)
                    break e;
                  $e--, rt += ut[ht++] << it, it += 8;
                }
                if (2 & ce.wrap && rt === 35615) {
                  et[ce.check = 0] = 255 & rt, et[1] = rt >>> 8 & 255, ce.check = f(ce.check, et, 2, 0), it = rt = 0, ce.mode = 2;
                  break;
                }
                if (ce.flags = 0, ce.head && (ce.head.done = !1), !(1 & ce.wrap) || (((255 & rt) << 8) + (rt >> 8)) % 31) {
                  Te.msg = "incorrect header check", ce.mode = 30;
                  break;
                }
                if ((15 & rt) != 8) {
                  Te.msg = "unknown compression method", ce.mode = 30;
                  break;
                }
                if (it -= 4, pe = 8 + (15 & (rt >>>= 4)), ce.wbits === 0)
                  ce.wbits = pe;
                else if (pe > ce.wbits) {
                  Te.msg = "invalid window size", ce.mode = 30;
                  break;
                }
                ce.dmax = 1 << pe, Te.adler = ce.check = 1, ce.mode = 512 & rt ? 10 : 12, it = rt = 0;
                break;
              case 2:
                for (; it < 16; ) {
                  if ($e === 0)
                    break e;
                  $e--, rt += ut[ht++] << it, it += 8;
                }
                if (ce.flags = rt, (255 & ce.flags) != 8) {
                  Te.msg = "unknown compression method", ce.mode = 30;
                  break;
                }
                if (57344 & ce.flags) {
                  Te.msg = "unknown header flags set", ce.mode = 30;
                  break;
                }
                ce.head && (ce.head.text = rt >> 8 & 1), 512 & ce.flags && (et[0] = 255 & rt, et[1] = rt >>> 8 & 255, ce.check = f(ce.check, et, 2, 0)), it = rt = 0, ce.mode = 3;
              case 3:
                for (; it < 32; ) {
                  if ($e === 0)
                    break e;
                  $e--, rt += ut[ht++] << it, it += 8;
                }
                ce.head && (ce.head.time = rt), 512 & ce.flags && (et[0] = 255 & rt, et[1] = rt >>> 8 & 255, et[2] = rt >>> 16 & 255, et[3] = rt >>> 24 & 255, ce.check = f(ce.check, et, 4, 0)), it = rt = 0, ce.mode = 4;
              case 4:
                for (; it < 16; ) {
                  if ($e === 0)
                    break e;
                  $e--, rt += ut[ht++] << it, it += 8;
                }
                ce.head && (ce.head.xflags = 255 & rt, ce.head.os = rt >> 8), 512 & ce.flags && (et[0] = 255 & rt, et[1] = rt >>> 8 & 255, ce.check = f(ce.check, et, 2, 0)), it = rt = 0, ce.mode = 5;
              case 5:
                if (1024 & ce.flags) {
                  for (; it < 16; ) {
                    if ($e === 0)
                      break e;
                    $e--, rt += ut[ht++] << it, it += 8;
                  }
                  ce.length = rt, ce.head && (ce.head.extra_len = rt), 512 & ce.flags && (et[0] = 255 & rt, et[1] = rt >>> 8 & 255, ce.check = f(ce.check, et, 2, 0)), it = rt = 0;
                } else
                  ce.head && (ce.head.extra = null);
                ce.mode = 6;
              case 6:
                if (1024 & ce.flags && ($e < (Tt = ce.length) && (Tt = $e), Tt && (ce.head && (pe = ce.head.extra_len - ce.length, ce.head.extra || (ce.head.extra = new Array(ce.head.extra_len)), o.arraySet(ce.head.extra, ut, ht, Tt, pe)), 512 & ce.flags && (ce.check = f(ce.check, ut, Tt, ht)), $e -= Tt, ht += Tt, ce.length -= Tt), ce.length))
                  break e;
                ce.length = 0, ce.mode = 7;
              case 7:
                if (2048 & ce.flags) {
                  if ($e === 0)
                    break e;
                  for (Tt = 0; pe = ut[ht + Tt++], ce.head && pe && ce.length < 65536 && (ce.head.name += String.fromCharCode(pe)), pe && Tt < $e; )
                    ;
                  if (512 & ce.flags && (ce.check = f(ce.check, ut, Tt, ht)), $e -= Tt, ht += Tt, pe)
                    break e;
                } else
                  ce.head && (ce.head.name = null);
                ce.length = 0, ce.mode = 8;
              case 8:
                if (4096 & ce.flags) {
                  if ($e === 0)
                    break e;
                  for (Tt = 0; pe = ut[ht + Tt++], ce.head && pe && ce.length < 65536 && (ce.head.comment += String.fromCharCode(pe)), pe && Tt < $e; )
                    ;
                  if (512 & ce.flags && (ce.check = f(ce.check, ut, Tt, ht)), $e -= Tt, ht += Tt, pe)
                    break e;
                } else
                  ce.head && (ce.head.comment = null);
                ce.mode = 9;
              case 9:
                if (512 & ce.flags) {
                  for (; it < 16; ) {
                    if ($e === 0)
                      break e;
                    $e--, rt += ut[ht++] << it, it += 8;
                  }
                  if (rt !== (65535 & ce.check)) {
                    Te.msg = "header crc mismatch", ce.mode = 30;
                    break;
                  }
                  it = rt = 0;
                }
                ce.head && (ce.head.hcrc = ce.flags >> 9 & 1, ce.head.done = !0), Te.adler = ce.check = 0, ce.mode = 12;
                break;
              case 10:
                for (; it < 32; ) {
                  if ($e === 0)
                    break e;
                  $e--, rt += ut[ht++] << it, it += 8;
                }
                Te.adler = ce.check = D(rt), it = rt = 0, ce.mode = 11;
              case 11:
                if (ce.havedict === 0)
                  return Te.next_out = Gt, Te.avail_out = It, Te.next_in = ht, Te.avail_in = $e, ce.hold = rt, ce.bits = it, 2;
                Te.adler = ce.check = 1, ce.mode = 12;
              case 12:
                if (Ze === 5 || Ze === 6)
                  break e;
              case 13:
                if (ce.last) {
                  rt >>>= 7 & it, it -= 7 & it, ce.mode = 27;
                  break;
                }
                for (; it < 3; ) {
                  if ($e === 0)
                    break e;
                  $e--, rt += ut[ht++] << it, it += 8;
                }
                switch (ce.last = 1 & rt, it -= 1, 3 & (rt >>>= 1)) {
                  case 0:
                    ce.mode = 14;
                    break;
                  case 1:
                    if (je(ce), ce.mode = 20, Ze !== 6)
                      break;
                    rt >>>= 2, it -= 2;
                    break e;
                  case 2:
                    ce.mode = 17;
                    break;
                  case 3:
                    Te.msg = "invalid block type", ce.mode = 30;
                }
                rt >>>= 2, it -= 2;
                break;
              case 14:
                for (rt >>>= 7 & it, it -= 7 & it; it < 32; ) {
                  if ($e === 0)
                    break e;
                  $e--, rt += ut[ht++] << it, it += 8;
                }
                if ((65535 & rt) != (rt >>> 16 ^ 65535)) {
                  Te.msg = "invalid stored block lengths", ce.mode = 30;
                  break;
                }
                if (ce.length = 65535 & rt, it = rt = 0, ce.mode = 15, Ze === 6)
                  break e;
              case 15:
                ce.mode = 16;
              case 16:
                if (Tt = ce.length) {
                  if ($e < Tt && (Tt = $e), It < Tt && (Tt = It), Tt === 0)
                    break e;
                  o.arraySet(ze, ut, ht, Tt, Gt), $e -= Tt, ht += Tt, It -= Tt, Gt += Tt, ce.length -= Tt;
                  break;
                }
                ce.mode = 12;
                break;
              case 17:
                for (; it < 14; ) {
                  if ($e === 0)
                    break e;
                  $e--, rt += ut[ht++] << it, it += 8;
                }
                if (ce.nlen = 257 + (31 & rt), rt >>>= 5, it -= 5, ce.ndist = 1 + (31 & rt), rt >>>= 5, it -= 5, ce.ncode = 4 + (15 & rt), rt >>>= 4, it -= 4, 286 < ce.nlen || 30 < ce.ndist) {
                  Te.msg = "too many length or distance symbols", ce.mode = 30;
                  break;
                }
                ce.have = 0, ce.mode = 18;
              case 18:
                for (; ce.have < ce.ncode; ) {
                  for (; it < 3; ) {
                    if ($e === 0)
                      break e;
                    $e--, rt += ut[ht++] << it, it += 8;
                  }
                  ce.lens[Et[ce.have++]] = 7 & rt, rt >>>= 3, it -= 3;
                }
                for (; ce.have < 19; )
                  ce.lens[Et[ce.have++]] = 0;
                if (ce.lencode = ce.lendyn, ce.lenbits = 7, xt = { bits: ce.lenbits }, Lt = x(0, ce.lens, 0, 19, ce.lencode, 0, ce.work, xt), ce.lenbits = xt.bits, Lt) {
                  Te.msg = "invalid code lengths set", ce.mode = 30;
                  break;
                }
                ce.have = 0, ce.mode = 19;
              case 19:
                for (; ce.have < ce.nlen + ce.ndist; ) {
                  for (; Zt = (Ie = ce.lencode[rt & (1 << ce.lenbits) - 1]) >>> 16 & 255, Jt = 65535 & Ie, !((oi = Ie >>> 24) <= it); ) {
                    if ($e === 0)
                      break e;
                    $e--, rt += ut[ht++] << it, it += 8;
                  }
                  if (Jt < 16)
                    rt >>>= oi, it -= oi, ce.lens[ce.have++] = Jt;
                  else {
                    if (Jt === 16) {
                      for (Ne = oi + 2; it < Ne; ) {
                        if ($e === 0)
                          break e;
                        $e--, rt += ut[ht++] << it, it += 8;
                      }
                      if (rt >>>= oi, it -= oi, ce.have === 0) {
                        Te.msg = "invalid bit length repeat", ce.mode = 30;
                        break;
                      }
                      pe = ce.lens[ce.have - 1], Tt = 3 + (3 & rt), rt >>>= 2, it -= 2;
                    } else if (Jt === 17) {
                      for (Ne = oi + 3; it < Ne; ) {
                        if ($e === 0)
                          break e;
                        $e--, rt += ut[ht++] << it, it += 8;
                      }
                      it -= oi, pe = 0, Tt = 3 + (7 & (rt >>>= oi)), rt >>>= 3, it -= 3;
                    } else {
                      for (Ne = oi + 7; it < Ne; ) {
                        if ($e === 0)
                          break e;
                        $e--, rt += ut[ht++] << it, it += 8;
                      }
                      it -= oi, pe = 0, Tt = 11 + (127 & (rt >>>= oi)), rt >>>= 7, it -= 7;
                    }
                    if (ce.have + Tt > ce.nlen + ce.ndist) {
                      Te.msg = "invalid bit length repeat", ce.mode = 30;
                      break;
                    }
                    for (; Tt--; )
                      ce.lens[ce.have++] = pe;
                  }
                }
                if (ce.mode === 30)
                  break;
                if (ce.lens[256] === 0) {
                  Te.msg = "invalid code -- missing end-of-block", ce.mode = 30;
                  break;
                }
                if (ce.lenbits = 9, xt = { bits: ce.lenbits }, Lt = x(k, ce.lens, 0, ce.nlen, ce.lencode, 0, ce.work, xt), ce.lenbits = xt.bits, Lt) {
                  Te.msg = "invalid literal/lengths set", ce.mode = 30;
                  break;
                }
                if (ce.distbits = 6, ce.distcode = ce.distdyn, xt = { bits: ce.distbits }, Lt = x(I, ce.lens, ce.nlen, ce.ndist, ce.distcode, 0, ce.work, xt), ce.distbits = xt.bits, Lt) {
                  Te.msg = "invalid distances set", ce.mode = 30;
                  break;
                }
                if (ce.mode = 20, Ze === 6)
                  break e;
              case 20:
                ce.mode = 21;
              case 21:
                if (6 <= $e && 258 <= It) {
                  Te.next_out = Gt, Te.avail_out = It, Te.next_in = ht, Te.avail_in = $e, ce.hold = rt, ce.bits = it, v(Te, $t), Gt = Te.next_out, ze = Te.output, It = Te.avail_out, ht = Te.next_in, ut = Te.input, $e = Te.avail_in, rt = ce.hold, it = ce.bits, ce.mode === 12 && (ce.back = -1);
                  break;
                }
                for (ce.back = 0; Zt = (Ie = ce.lencode[rt & (1 << ce.lenbits) - 1]) >>> 16 & 255, Jt = 65535 & Ie, !((oi = Ie >>> 24) <= it); ) {
                  if ($e === 0)
                    break e;
                  $e--, rt += ut[ht++] << it, it += 8;
                }
                if (Zt && !(240 & Zt)) {
                  for (Qt = oi, rn = Zt, Gi = Jt; Zt = (Ie = ce.lencode[Gi + ((rt & (1 << Qt + rn) - 1) >> Qt)]) >>> 16 & 255, Jt = 65535 & Ie, !(Qt + (oi = Ie >>> 24) <= it); ) {
                    if ($e === 0)
                      break e;
                    $e--, rt += ut[ht++] << it, it += 8;
                  }
                  rt >>>= Qt, it -= Qt, ce.back += Qt;
                }
                if (rt >>>= oi, it -= oi, ce.back += oi, ce.length = Jt, Zt === 0) {
                  ce.mode = 26;
                  break;
                }
                if (32 & Zt) {
                  ce.back = -1, ce.mode = 12;
                  break;
                }
                if (64 & Zt) {
                  Te.msg = "invalid literal/length code", ce.mode = 30;
                  break;
                }
                ce.extra = 15 & Zt, ce.mode = 22;
              case 22:
                if (ce.extra) {
                  for (Ne = ce.extra; it < Ne; ) {
                    if ($e === 0)
                      break e;
                    $e--, rt += ut[ht++] << it, it += 8;
                  }
                  ce.length += rt & (1 << ce.extra) - 1, rt >>>= ce.extra, it -= ce.extra, ce.back += ce.extra;
                }
                ce.was = ce.length, ce.mode = 23;
              case 23:
                for (; Zt = (Ie = ce.distcode[rt & (1 << ce.distbits) - 1]) >>> 16 & 255, Jt = 65535 & Ie, !((oi = Ie >>> 24) <= it); ) {
                  if ($e === 0)
                    break e;
                  $e--, rt += ut[ht++] << it, it += 8;
                }
                if (!(240 & Zt)) {
                  for (Qt = oi, rn = Zt, Gi = Jt; Zt = (Ie = ce.distcode[Gi + ((rt & (1 << Qt + rn) - 1) >> Qt)]) >>> 16 & 255, Jt = 65535 & Ie, !(Qt + (oi = Ie >>> 24) <= it); ) {
                    if ($e === 0)
                      break e;
                    $e--, rt += ut[ht++] << it, it += 8;
                  }
                  rt >>>= Qt, it -= Qt, ce.back += Qt;
                }
                if (rt >>>= oi, it -= oi, ce.back += oi, 64 & Zt) {
                  Te.msg = "invalid distance code", ce.mode = 30;
                  break;
                }
                ce.offset = Jt, ce.extra = 15 & Zt, ce.mode = 24;
              case 24:
                if (ce.extra) {
                  for (Ne = ce.extra; it < Ne; ) {
                    if ($e === 0)
                      break e;
                    $e--, rt += ut[ht++] << it, it += 8;
                  }
                  ce.offset += rt & (1 << ce.extra) - 1, rt >>>= ce.extra, it -= ce.extra, ce.back += ce.extra;
                }
                if (ce.offset > ce.dmax) {
                  Te.msg = "invalid distance too far back", ce.mode = 30;
                  break;
                }
                ce.mode = 25;
              case 25:
                if (It === 0)
                  break e;
                if (Tt = $t - It, ce.offset > Tt) {
                  if ((Tt = ce.offset - Tt) > ce.whave && ce.sane) {
                    Te.msg = "invalid distance too far back", ce.mode = 30;
                    break;
                  }
                  Bi = Tt > ce.wnext ? (Tt -= ce.wnext, ce.wsize - Tt) : ce.wnext - Tt, Tt > ce.length && (Tt = ce.length), en = ce.window;
                } else
                  en = ze, Bi = Gt - ce.offset, Tt = ce.length;
                for (It < Tt && (Tt = It), It -= Tt, ce.length -= Tt; ze[Gt++] = en[Bi++], --Tt; )
                  ;
                ce.length === 0 && (ce.mode = 21);
                break;
              case 26:
                if (It === 0)
                  break e;
                ze[Gt++] = ce.length, It--, ce.mode = 21;
                break;
              case 27:
                if (ce.wrap) {
                  for (; it < 32; ) {
                    if ($e === 0)
                      break e;
                    $e--, rt |= ut[ht++] << it, it += 8;
                  }
                  if ($t -= It, Te.total_out += $t, ce.total += $t, $t && (Te.adler = ce.check = ce.flags ? f(ce.check, ze, $t, Gt - $t) : h(ce.check, ze, $t, Gt - $t)), $t = It, (ce.flags ? rt : D(rt)) !== ce.check) {
                    Te.msg = "incorrect data check", ce.mode = 30;
                    break;
                  }
                  it = rt = 0;
                }
                ce.mode = 28;
              case 28:
                if (ce.wrap && ce.flags) {
                  for (; it < 32; ) {
                    if ($e === 0)
                      break e;
                    $e--, rt += ut[ht++] << it, it += 8;
                  }
                  if (rt !== (4294967295 & ce.total)) {
                    Te.msg = "incorrect length check", ce.mode = 30;
                    break;
                  }
                  it = rt = 0;
                }
                ce.mode = 29;
              case 29:
                Lt = 1;
                break e;
              case 30:
                Lt = -3;
                break e;
              case 31:
                return -4;
              case 32:
              default:
                return M;
            }
        return Te.next_out = Gt, Te.avail_out = It, Te.next_in = ht, Te.avail_in = $e, ce.hold = rt, ce.bits = it, (ce.wsize || $t !== Te.avail_out && ce.mode < 30 && (ce.mode < 27 || Ze !== 4)) && pt(Te, Te.output, Te.next_out, $t - Te.avail_out) ? (ce.mode = 31, -4) : (Xt -= Te.avail_in, $t -= Te.avail_out, Te.total_in += Xt, Te.total_out += $t, ce.total += $t, ce.wrap && $t && (Te.adler = ce.check = ce.flags ? f(ce.check, ze, $t, Te.next_out - $t) : h(ce.check, ze, $t, Te.next_out - $t)), Te.data_type = ce.bits + (ce.last ? 64 : 0) + (ce.mode === 12 ? 128 : 0) + (ce.mode === 20 || ce.mode === 15 ? 256 : 0), (Xt == 0 && $t === 0 || Ze === 4) && Lt === V && (Lt = -5), Lt);
      }, a.inflateEnd = function(Te) {
        if (!Te || !Te.state)
          return M;
        var Ze = Te.state;
        return Ze.window && (Ze.window = null), Te.state = null, V;
      }, a.inflateGetHeader = function(Te, Ze) {
        var ce;
        return Te && Te.state && 2 & (ce = Te.state).wrap ? ((ce.head = Ze).done = !1, V) : M;
      }, a.inflateSetDictionary = function(Te, Ze) {
        var ce, ut = Ze.length;
        return Te && Te.state ? (ce = Te.state).wrap !== 0 && ce.mode !== 11 ? M : ce.mode === 11 && h(1, Ze, ut, 0) !== ce.check ? -3 : pt(Te, Ze, ut, ut) ? (ce.mode = 31, -4) : (ce.havedict = 1, V) : M;
      }, a.inflateInfo = "pako inflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./inffast": 48, "./inftrees": 50 }], 50: [function(t, n, a) {
      var o = t("../utils/common"), h = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0], f = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78], v = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0], x = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
      n.exports = function(k, I, V, M, W, U, Q, D) {
        var ee, J, he, fe, X, Z, qe, Oe, je, pt = D.bits, Te = 0, Ze = 0, ce = 0, ut = 0, ze = 0, ht = 0, Gt = 0, $e = 0, It = 0, rt = 0, it = null, Xt = 0, $t = new o.Buf16(16), Tt = new o.Buf16(16), Bi = null, en = 0;
        for (Te = 0; Te <= 15; Te++)
          $t[Te] = 0;
        for (Ze = 0; Ze < M; Ze++)
          $t[I[V + Ze]]++;
        for (ze = pt, ut = 15; 1 <= ut && $t[ut] === 0; ut--)
          ;
        if (ut < ze && (ze = ut), ut === 0)
          return W[U++] = 20971520, W[U++] = 20971520, D.bits = 1, 0;
        for (ce = 1; ce < ut && $t[ce] === 0; ce++)
          ;
        for (ze < ce && (ze = ce), Te = $e = 1; Te <= 15; Te++)
          if ($e <<= 1, ($e -= $t[Te]) < 0)
            return -1;
        if (0 < $e && (k === 0 || ut !== 1))
          return -1;
        for (Tt[1] = 0, Te = 1; Te < 15; Te++)
          Tt[Te + 1] = Tt[Te] + $t[Te];
        for (Ze = 0; Ze < M; Ze++)
          I[V + Ze] !== 0 && (Q[Tt[I[V + Ze]]++] = Ze);
        if (Z = k === 0 ? (it = Bi = Q, 19) : k === 1 ? (it = h, Xt -= 257, Bi = f, en -= 257, 256) : (it = v, Bi = x, -1), Te = ce, X = U, Gt = Ze = rt = 0, he = -1, fe = (It = 1 << (ht = ze)) - 1, k === 1 && 852 < It || k === 2 && 592 < It)
          return 1;
        for (; ; ) {
          for (qe = Te - Gt, je = Q[Ze] < Z ? (Oe = 0, Q[Ze]) : Q[Ze] > Z ? (Oe = Bi[en + Q[Ze]], it[Xt + Q[Ze]]) : (Oe = 96, 0), ee = 1 << Te - Gt, ce = J = 1 << ht; W[X + (rt >> Gt) + (J -= ee)] = qe << 24 | Oe << 16 | je | 0, J !== 0; )
            ;
          for (ee = 1 << Te - 1; rt & ee; )
            ee >>= 1;
          if (ee !== 0 ? (rt &= ee - 1, rt += ee) : rt = 0, Ze++, --$t[Te] == 0) {
            if (Te === ut)
              break;
            Te = I[V + Q[Ze]];
          }
          if (ze < Te && (rt & fe) !== he) {
            for (Gt === 0 && (Gt = ze), X += ce, $e = 1 << (ht = Te - Gt); ht + Gt < ut && !(($e -= $t[ht + Gt]) <= 0); )
              ht++, $e <<= 1;
            if (It += 1 << ht, k === 1 && 852 < It || k === 2 && 592 < It)
              return 1;
            W[he = rt & fe] = ze << 24 | ht << 16 | X - U | 0;
          }
        }
        return rt !== 0 && (W[X + rt] = Te - Gt << 24 | 64 << 16 | 0), D.bits = ze, 0;
      };
    }, { "../utils/common": 41 }], 51: [function(t, n, a) {
      n.exports = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" };
    }, {}], 52: [function(t, n, a) {
      var o = t("../utils/common"), h = 0, f = 1;
      function v(Ie) {
        for (var et = Ie.length; 0 <= --et; )
          Ie[et] = 0;
      }
      var x = 0, k = 29, I = 256, V = I + 1 + k, M = 30, W = 19, U = 2 * V + 1, Q = 15, D = 16, ee = 7, J = 256, he = 16, fe = 17, X = 18, Z = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0], qe = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13], Oe = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7], je = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], pt = new Array(2 * (V + 2));
      v(pt);
      var Te = new Array(2 * M);
      v(Te);
      var Ze = new Array(512);
      v(Ze);
      var ce = new Array(256);
      v(ce);
      var ut = new Array(k);
      v(ut);
      var ze, ht, Gt, $e = new Array(M);
      function It(Ie, et, Et, ft, tt) {
        this.static_tree = Ie, this.extra_bits = et, this.extra_base = Et, this.elems = ft, this.max_length = tt, this.has_stree = Ie && Ie.length;
      }
      function rt(Ie, et) {
        this.dyn_tree = Ie, this.max_code = 0, this.stat_desc = et;
      }
      function it(Ie) {
        return Ie < 256 ? Ze[Ie] : Ze[256 + (Ie >>> 7)];
      }
      function Xt(Ie, et) {
        Ie.pending_buf[Ie.pending++] = 255 & et, Ie.pending_buf[Ie.pending++] = et >>> 8 & 255;
      }
      function $t(Ie, et, Et) {
        Ie.bi_valid > D - Et ? (Ie.bi_buf |= et << Ie.bi_valid & 65535, Xt(Ie, Ie.bi_buf), Ie.bi_buf = et >> D - Ie.bi_valid, Ie.bi_valid += Et - D) : (Ie.bi_buf |= et << Ie.bi_valid & 65535, Ie.bi_valid += Et);
      }
      function Tt(Ie, et, Et) {
        $t(Ie, Et[2 * et], Et[2 * et + 1]);
      }
      function Bi(Ie, et) {
        for (var Et = 0; Et |= 1 & Ie, Ie >>>= 1, Et <<= 1, 0 < --et; )
          ;
        return Et >>> 1;
      }
      function en(Ie, et, Et) {
        var ft, tt, _t = new Array(Q + 1), Kt = 0;
        for (ft = 1; ft <= Q; ft++)
          _t[ft] = Kt = Kt + Et[ft - 1] << 1;
        for (tt = 0; tt <= et; tt++) {
          var Ve = Ie[2 * tt + 1];
          Ve !== 0 && (Ie[2 * tt] = Bi(_t[Ve]++, Ve));
        }
      }
      function oi(Ie) {
        var et;
        for (et = 0; et < V; et++)
          Ie.dyn_ltree[2 * et] = 0;
        for (et = 0; et < M; et++)
          Ie.dyn_dtree[2 * et] = 0;
        for (et = 0; et < W; et++)
          Ie.bl_tree[2 * et] = 0;
        Ie.dyn_ltree[2 * J] = 1, Ie.opt_len = Ie.static_len = 0, Ie.last_lit = Ie.matches = 0;
      }
      function Zt(Ie) {
        8 < Ie.bi_valid ? Xt(Ie, Ie.bi_buf) : 0 < Ie.bi_valid && (Ie.pending_buf[Ie.pending++] = Ie.bi_buf), Ie.bi_buf = 0, Ie.bi_valid = 0;
      }
      function Jt(Ie, et, Et, ft) {
        var tt = 2 * et, _t = 2 * Et;
        return Ie[tt] < Ie[_t] || Ie[tt] === Ie[_t] && ft[et] <= ft[Et];
      }
      function Qt(Ie, et, Et) {
        for (var ft = Ie.heap[Et], tt = Et << 1; tt <= Ie.heap_len && (tt < Ie.heap_len && Jt(et, Ie.heap[tt + 1], Ie.heap[tt], Ie.depth) && tt++, !Jt(et, ft, Ie.heap[tt], Ie.depth)); )
          Ie.heap[Et] = Ie.heap[tt], Et = tt, tt <<= 1;
        Ie.heap[Et] = ft;
      }
      function rn(Ie, et, Et) {
        var ft, tt, _t, Kt, Ve = 0;
        if (Ie.last_lit !== 0)
          for (; ft = Ie.pending_buf[Ie.d_buf + 2 * Ve] << 8 | Ie.pending_buf[Ie.d_buf + 2 * Ve + 1], tt = Ie.pending_buf[Ie.l_buf + Ve], Ve++, ft === 0 ? Tt(Ie, tt, et) : (Tt(Ie, (_t = ce[tt]) + I + 1, et), (Kt = Z[_t]) !== 0 && $t(Ie, tt -= ut[_t], Kt), Tt(Ie, _t = it(--ft), Et), (Kt = qe[_t]) !== 0 && $t(Ie, ft -= $e[_t], Kt)), Ve < Ie.last_lit; )
            ;
        Tt(Ie, J, et);
      }
      function Gi(Ie, et) {
        var Et, ft, tt, _t = et.dyn_tree, Kt = et.stat_desc.static_tree, Ve = et.stat_desc.has_stree, i = et.stat_desc.elems, r = -1;
        for (Ie.heap_len = 0, Ie.heap_max = U, Et = 0; Et < i; Et++)
          _t[2 * Et] !== 0 ? (Ie.heap[++Ie.heap_len] = r = Et, Ie.depth[Et] = 0) : _t[2 * Et + 1] = 0;
        for (; Ie.heap_len < 2; )
          _t[2 * (tt = Ie.heap[++Ie.heap_len] = r < 2 ? ++r : 0)] = 1, Ie.depth[tt] = 0, Ie.opt_len--, Ve && (Ie.static_len -= Kt[2 * tt + 1]);
        for (et.max_code = r, Et = Ie.heap_len >> 1; 1 <= Et; Et--)
          Qt(Ie, _t, Et);
        for (tt = i; Et = Ie.heap[1], Ie.heap[1] = Ie.heap[Ie.heap_len--], Qt(Ie, _t, 1), ft = Ie.heap[1], Ie.heap[--Ie.heap_max] = Et, Ie.heap[--Ie.heap_max] = ft, _t[2 * tt] = _t[2 * Et] + _t[2 * ft], Ie.depth[tt] = (Ie.depth[Et] >= Ie.depth[ft] ? Ie.depth[Et] : Ie.depth[ft]) + 1, _t[2 * Et + 1] = _t[2 * ft + 1] = tt, Ie.heap[1] = tt++, Qt(Ie, _t, 1), 2 <= Ie.heap_len; )
          ;
        Ie.heap[--Ie.heap_max] = Ie.heap[1], function(s, l) {
          var u, d, p, m, y, S, L = l.dyn_tree, E = l.max_code, A = l.stat_desc.static_tree, T = l.stat_desc.has_stree, G = l.stat_desc.extra_bits, O = l.stat_desc.extra_base, Y = l.stat_desc.max_length, B = 0;
          for (m = 0; m <= Q; m++)
            s.bl_count[m] = 0;
          for (L[2 * s.heap[s.heap_max] + 1] = 0, u = s.heap_max + 1; u < U; u++)
            Y < (m = L[2 * L[2 * (d = s.heap[u]) + 1] + 1] + 1) && (m = Y, B++), L[2 * d + 1] = m, E < d || (s.bl_count[m]++, y = 0, O <= d && (y = G[d - O]), S = L[2 * d], s.opt_len += S * (m + y), T && (s.static_len += S * (A[2 * d + 1] + y)));
          if (B !== 0) {
            do {
              for (m = Y - 1; s.bl_count[m] === 0; )
                m--;
              s.bl_count[m]--, s.bl_count[m + 1] += 2, s.bl_count[Y]--, B -= 2;
            } while (0 < B);
            for (m = Y; m !== 0; m--)
              for (d = s.bl_count[m]; d !== 0; )
                E < (p = s.heap[--u]) || (L[2 * p + 1] !== m && (s.opt_len += (m - L[2 * p + 1]) * L[2 * p], L[2 * p + 1] = m), d--);
          }
        }(Ie, et), en(_t, r, Ie.bl_count);
      }
      function pe(Ie, et, Et) {
        var ft, tt, _t = -1, Kt = et[1], Ve = 0, i = 7, r = 4;
        for (Kt === 0 && (i = 138, r = 3), et[2 * (Et + 1) + 1] = 65535, ft = 0; ft <= Et; ft++)
          tt = Kt, Kt = et[2 * (ft + 1) + 1], ++Ve < i && tt === Kt || (Ve < r ? Ie.bl_tree[2 * tt] += Ve : tt !== 0 ? (tt !== _t && Ie.bl_tree[2 * tt]++, Ie.bl_tree[2 * he]++) : Ve <= 10 ? Ie.bl_tree[2 * fe]++ : Ie.bl_tree[2 * X]++, _t = tt, r = (Ve = 0) === Kt ? (i = 138, 3) : tt === Kt ? (i = 6, 3) : (i = 7, 4));
      }
      function Lt(Ie, et, Et) {
        var ft, tt, _t = -1, Kt = et[1], Ve = 0, i = 7, r = 4;
        for (Kt === 0 && (i = 138, r = 3), ft = 0; ft <= Et; ft++)
          if (tt = Kt, Kt = et[2 * (ft + 1) + 1], !(++Ve < i && tt === Kt)) {
            if (Ve < r)
              for (; Tt(Ie, tt, Ie.bl_tree), --Ve != 0; )
                ;
            else
              tt !== 0 ? (tt !== _t && (Tt(Ie, tt, Ie.bl_tree), Ve--), Tt(Ie, he, Ie.bl_tree), $t(Ie, Ve - 3, 2)) : Ve <= 10 ? (Tt(Ie, fe, Ie.bl_tree), $t(Ie, Ve - 3, 3)) : (Tt(Ie, X, Ie.bl_tree), $t(Ie, Ve - 11, 7));
            _t = tt, r = (Ve = 0) === Kt ? (i = 138, 3) : tt === Kt ? (i = 6, 3) : (i = 7, 4);
          }
      }
      v($e);
      var xt = !1;
      function Ne(Ie, et, Et, ft) {
        $t(Ie, (x << 1) + (ft ? 1 : 0), 3), function(tt, _t, Kt, Ve) {
          Zt(tt), Ve && (Xt(tt, Kt), Xt(tt, ~Kt)), o.arraySet(tt.pending_buf, tt.window, _t, Kt, tt.pending), tt.pending += Kt;
        }(Ie, et, Et, !0);
      }
      a._tr_init = function(Ie) {
        xt || (function() {
          var et, Et, ft, tt, _t, Kt = new Array(Q + 1);
          for (tt = ft = 0; tt < k - 1; tt++)
            for (ut[tt] = ft, et = 0; et < 1 << Z[tt]; et++)
              ce[ft++] = tt;
          for (ce[ft - 1] = tt, tt = _t = 0; tt < 16; tt++)
            for ($e[tt] = _t, et = 0; et < 1 << qe[tt]; et++)
              Ze[_t++] = tt;
          for (_t >>= 7; tt < M; tt++)
            for ($e[tt] = _t << 7, et = 0; et < 1 << qe[tt] - 7; et++)
              Ze[256 + _t++] = tt;
          for (Et = 0; Et <= Q; Et++)
            Kt[Et] = 0;
          for (et = 0; et <= 143; )
            pt[2 * et + 1] = 8, et++, Kt[8]++;
          for (; et <= 255; )
            pt[2 * et + 1] = 9, et++, Kt[9]++;
          for (; et <= 279; )
            pt[2 * et + 1] = 7, et++, Kt[7]++;
          for (; et <= 287; )
            pt[2 * et + 1] = 8, et++, Kt[8]++;
          for (en(pt, V + 1, Kt), et = 0; et < M; et++)
            Te[2 * et + 1] = 5, Te[2 * et] = Bi(et, 5);
          ze = new It(pt, Z, I + 1, V, Q), ht = new It(Te, qe, 0, M, Q), Gt = new It(new Array(0), Oe, 0, W, ee);
        }(), xt = !0), Ie.l_desc = new rt(Ie.dyn_ltree, ze), Ie.d_desc = new rt(Ie.dyn_dtree, ht), Ie.bl_desc = new rt(Ie.bl_tree, Gt), Ie.bi_buf = 0, Ie.bi_valid = 0, oi(Ie);
      }, a._tr_stored_block = Ne, a._tr_flush_block = function(Ie, et, Et, ft) {
        var tt, _t, Kt = 0;
        0 < Ie.level ? (Ie.strm.data_type === 2 && (Ie.strm.data_type = function(Ve) {
          var i, r = 4093624447;
          for (i = 0; i <= 31; i++, r >>>= 1)
            if (1 & r && Ve.dyn_ltree[2 * i] !== 0)
              return h;
          if (Ve.dyn_ltree[18] !== 0 || Ve.dyn_ltree[20] !== 0 || Ve.dyn_ltree[26] !== 0)
            return f;
          for (i = 32; i < I; i++)
            if (Ve.dyn_ltree[2 * i] !== 0)
              return f;
          return h;
        }(Ie)), Gi(Ie, Ie.l_desc), Gi(Ie, Ie.d_desc), Kt = function(Ve) {
          var i;
          for (pe(Ve, Ve.dyn_ltree, Ve.l_desc.max_code), pe(Ve, Ve.dyn_dtree, Ve.d_desc.max_code), Gi(Ve, Ve.bl_desc), i = W - 1; 3 <= i && Ve.bl_tree[2 * je[i] + 1] === 0; i--)
            ;
          return Ve.opt_len += 3 * (i + 1) + 5 + 5 + 4, i;
        }(Ie), tt = Ie.opt_len + 3 + 7 >>> 3, (_t = Ie.static_len + 3 + 7 >>> 3) <= tt && (tt = _t)) : tt = _t = Et + 5, Et + 4 <= tt && et !== -1 ? Ne(Ie, et, Et, ft) : Ie.strategy === 4 || _t === tt ? ($t(Ie, 2 + (ft ? 1 : 0), 3), rn(Ie, pt, Te)) : ($t(Ie, 4 + (ft ? 1 : 0), 3), function(Ve, i, r, s) {
          var l;
          for ($t(Ve, i - 257, 5), $t(Ve, r - 1, 5), $t(Ve, s - 4, 4), l = 0; l < s; l++)
            $t(Ve, Ve.bl_tree[2 * je[l] + 1], 3);
          Lt(Ve, Ve.dyn_ltree, i - 1), Lt(Ve, Ve.dyn_dtree, r - 1);
        }(Ie, Ie.l_desc.max_code + 1, Ie.d_desc.max_code + 1, Kt + 1), rn(Ie, Ie.dyn_ltree, Ie.dyn_dtree)), oi(Ie), ft && Zt(Ie);
      }, a._tr_tally = function(Ie, et, Et) {
        return Ie.pending_buf[Ie.d_buf + 2 * Ie.last_lit] = et >>> 8 & 255, Ie.pending_buf[Ie.d_buf + 2 * Ie.last_lit + 1] = 255 & et, Ie.pending_buf[Ie.l_buf + Ie.last_lit] = 255 & Et, Ie.last_lit++, et === 0 ? Ie.dyn_ltree[2 * Et]++ : (Ie.matches++, et--, Ie.dyn_ltree[2 * (ce[Et] + I + 1)]++, Ie.dyn_dtree[2 * it(et)]++), Ie.last_lit === Ie.lit_bufsize - 1;
      }, a._tr_align = function(Ie) {
        $t(Ie, 2, 3), Tt(Ie, J, pt), function(et) {
          et.bi_valid === 16 ? (Xt(et, et.bi_buf), et.bi_buf = 0, et.bi_valid = 0) : 8 <= et.bi_valid && (et.pending_buf[et.pending++] = 255 & et.bi_buf, et.bi_buf >>= 8, et.bi_valid -= 8);
        }(Ie);
      };
    }, { "../utils/common": 41 }], 53: [function(t, n, a) {
      n.exports = function() {
        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
      };
    }, {}], 54: [function(t, n, a) {
      (function(o) {
        (function(h, f) {
          if (!h.setImmediate) {
            var v, x, k, I, V = 1, M = {}, W = !1, U = h.document, Q = Object.getPrototypeOf && Object.getPrototypeOf(h);
            Q = Q && Q.setTimeout ? Q : h, v = {}.toString.call(h.process) === "[object process]" ? function(he) {
              process.nextTick(function() {
                ee(he);
              });
            } : function() {
              if (h.postMessage && !h.importScripts) {
                var he = !0, fe = h.onmessage;
                return h.onmessage = function() {
                  he = !1;
                }, h.postMessage("", "*"), h.onmessage = fe, he;
              }
            }() ? (I = "setImmediate$" + Math.random() + "$", h.addEventListener ? h.addEventListener("message", J, !1) : h.attachEvent("onmessage", J), function(he) {
              h.postMessage(I + he, "*");
            }) : h.MessageChannel ? ((k = new MessageChannel()).port1.onmessage = function(he) {
              ee(he.data);
            }, function(he) {
              k.port2.postMessage(he);
            }) : U && "onreadystatechange" in U.createElement("script") ? (x = U.documentElement, function(he) {
              var fe = U.createElement("script");
              fe.onreadystatechange = function() {
                ee(he), fe.onreadystatechange = null, x.removeChild(fe), fe = null;
              }, x.appendChild(fe);
            }) : function(he) {
              setTimeout(ee, 0, he);
            }, Q.setImmediate = function(he) {
              typeof he != "function" && (he = new Function("" + he));
              for (var fe = new Array(arguments.length - 1), X = 0; X < fe.length; X++)
                fe[X] = arguments[X + 1];
              var Z = { callback: he, args: fe };
              return M[V] = Z, v(V), V++;
            }, Q.clearImmediate = D;
          }
          function D(he) {
            delete M[he];
          }
          function ee(he) {
            if (W)
              setTimeout(ee, 0, he);
            else {
              var fe = M[he];
              if (fe) {
                W = !0;
                try {
                  (function(X) {
                    var Z = X.callback, qe = X.args;
                    switch (qe.length) {
                      case 0:
                        Z();
                        break;
                      case 1:
                        Z(qe[0]);
                        break;
                      case 2:
                        Z(qe[0], qe[1]);
                        break;
                      case 3:
                        Z(qe[0], qe[1], qe[2]);
                        break;
                      default:
                        Z.apply(f, qe);
                    }
                  })(fe);
                } finally {
                  D(he), W = !1;
                }
              }
            }
          }
          function J(he) {
            he.source === h && typeof he.data == "string" && he.data.indexOf(I) === 0 && ee(+he.data.slice(I.length));
          }
        })(typeof self > "u" ? o === void 0 ? this : o : self);
      }).call(this, typeof ts < "u" ? ts : typeof self < "u" ? self : typeof window < "u" ? window : {});
    }, {}] }, {}, [10])(10);
  });
})(kd);
var Bx = kd.exports;
const Df = /* @__PURE__ */ ru(Bx), Ed = class Sn {
  constructor(e) {
    this._hemiLight = null, this._pointLight = null, this._onPrePointerObservableObserver = null, this._isPointerDown = !1, this._radiusScale = 0.85, this._positionScale = 0.5, this._limitLowerRadius = !0, this._zoomEnabled = !0, this._minZoomPerc = null, this._maxZoomPerc = null, this._cameraZoom = null, this._minZObserver = null, this._cameraPivot = null, this._resizableCanvas3DGenerator = new Zy(), this.parentNode = null, this.enableShadows = !1, this.areShadowVisible = !0, this.setInitialZoomToBoundingBox = !0, this.changeRotationDirection = !1, this.initialZoomToBBInertiaDamping = 0.68, this._initialZoomToBBModelSizeRadius = 0.7, this.initialZoomToBBScrollZoomEnabled = !0, this.initialZoomToBBScrollLowerLimit = 2, this.initialZoomToBBScrollUpperLimit = 2, this.animateIntro = !1, this._defHemiLightID = "f90aba65-3b60-44ac-87f4-1b6441aee44b", this._defPointLightID = "b6491635-c471-45a4-bbb8-3f08556e5b3c", this._targetAnimationID = "6225769c-0113-4236-ab17-c39d24013de4", this._radiusAnimationID = "6f946c2f-af8d-46ab-9bea-9e22dedc4e9d", this._alphaAnimationID = "10713520-fe06-4cbf-bc6a-bab881d516e6", this._betaAnimationID = "6096ba34-852a-4423-bab3-dc97c1a9268f", this._dummyMaterialID = "081796b8-0908-44dc-a38a-d786b14cA6fc", this._loadingMaterials = {}, this._authorizationToken = null, this.getVTOMeshes = () => {
      const t = [
        "vto_reference",
        "ground",
        "shadowGround",
        "shadow",
        "skybox",
        "environment",
        "axes",
        "grid",
        "boundingbox",
        "highlight",
        "EditControl",
        "guideCtl",
        "bxAxis",
        "byAxis",
        "bzAxis",
        "xAxis",
        "yAxis",
        "zAxis",
        "pALL",
        "pXZ",
        "pZY",
        "pYX",
        "pickPlanes",
        "tarnsCtl",
        "X",
        "Y",
        "Z",
        "XZ",
        "ZY",
        "YX",
        "ALL",
        "tEndX",
        "tEndY",
        "tEndZ",
        "XZ",
        "ZY",
        "YX",
        "tEndAll"
      ], n = (f) => t.filter((v) => f.toLowerCase() === v.toLowerCase()).length > 0, a = (f) => f.toLowerCase().includes("vto_reference"), o = this._scene.meshes.filter((f) => a(f.name)), h = this._scene.meshes.filter((f) => !n(f.name) && !a(f.name));
      return {
        tryonReferencesModels: o,
        userMeshes: h
      };
    }, this._loadedMeshes = [], this._isLoading = !1, this._lastVisibilityStates = /* @__PURE__ */ new Map(), this._scene = e, this._engine = e.getEngine(), this._camera = e.activeCamera, this._canvas = e.getEngine().getRenderingCanvas(), this.init();
  }
  get initialZoomToBBModelSizeRadius() {
    return console.log("Getting initialZoomToBBModelSizeRadius: ", this._initialZoomToBBModelSizeRadius), this._initialZoomToBBModelSizeRadius;
  }
  set initialZoomToBBModelSizeRadius(e) {
    console.log("Setting initialZoomToBBModelSizeRadius to: ", e), this._initialZoomToBBModelSizeRadius = e;
  }
  get camera() {
    return this._camera;
  }
  /**
   * Imposta il token di autorizzazione per le chiamate API
   * @param token Il token di autorizzazione
   */
  setAuthorizationToken(e) {
    this._authorizationToken = e;
  }
  /**
   * Ottiene il token di autorizzazione attualmente impostato
   * @returns Il token di autorizzazione o null se non impostato
   */
  getAuthorizationToken() {
    return this._authorizationToken;
  }
  static checkAllMaterialTextureReady(e) {
    const t = e.getActiveTextures();
    for (let n = 0; n < t.length; n++) {
      const a = t[n];
      if (a.isReady())
        a instanceof BABYLON.ProceduralTexture && a.getEffect();
      else
        return !1;
    }
    return !0;
  }
  removeDefaultBackground(e) {
    e && (this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0));
  }
  setUpSceneToneMapping(e) {
    var h, f, v, x;
    const t = (h = e == null ? void 0 : e.getCameraConfig()) == null ? void 0 : h.get("toneMappingEnabled");
    t != null && (this._scene.imageProcessingConfiguration.toneMappingEnabled = t);
    const n = (f = e == null ? void 0 : e.getCameraConfig()) == null ? void 0 : f.get("toneMappingType");
    n != null && (this._scene.imageProcessingConfiguration.toneMappingType = n);
    const a = (v = e == null ? void 0 : e.getGeneralConfig()) == null ? void 0 : v.get("exposure"), o = (x = e == null ? void 0 : e.getGeneralConfig()) == null ? void 0 : x.get("contrast");
    o && (this._scene.imageProcessingConfiguration.contrast = o), a && (this._scene.imageProcessingConfiguration.exposure = a);
  }
  cleanUnusedMaterialsMappings(e) {
    if (!e)
      return;
    const t = e.get("materialMappings"), n = this.getAllMaterials().filter((o) => t.find((h) => h.get("sceneMaterialID") === o.id)), a = new Zakeke.SceneMaterialMappings();
    for (const o of t.toArray()) {
      const h = o.get("sceneMaterialID");
      n.find((f) => f.id === h) ? a.push(o) : e.removeMappingForSceneMaterial(h);
    }
    e.set("materialMappings", a);
  }
  static whenAllMaterialTexturesAreReady(e) {
    return new Promise((t, n) => {
      if (this.checkAllMaterialTextureReady(e))
        t();
      else {
        let a = setInterval(() => {
          this.checkAllMaterialTextureReady(e) && (clearInterval(a), t());
        }, 5);
      }
    });
  }
  static whenTextureIsReadyAsync(e) {
    return new Promise((t, n) => {
      if (e.isReady())
        t();
      else {
        let a = setInterval(() => {
          e.isReady() && (clearInterval(a), e instanceof BABYLON.ProceduralTexture && e.getEffect(), t());
        }, 5);
      }
    });
  }
  static whenMeshMaterialIsReady(e) {
    return new Promise((t, n) => {
      let a = setInterval(() => {
        (!e.material || e.material.isReady(e)) && (clearInterval(a), t());
      }, 5);
    });
  }
  static whenMaterialIsReadyForSubMeshAsync(e, t, n) {
    return new Promise((a, o) => {
      if (e.isReadyForSubMesh(t, n))
        Logger.info(`Material ${e.name} ready`), a();
      else {
        Logger.info(`Material ${e.name} NOT ready`);
        let h = setInterval(() => {
          e.isReadyForSubMesh(t, n) && (!t.material || t.material != e || t.material.isReady(t)) && (Logger.info(`Material ${e.name} ready`), clearInterval(h), a());
        }, 5);
      }
    });
  }
  static getMeshGeometry(e) {
    if (e.geometry)
      return e.geometry;
    const n = e.getScene().getGeometries();
    for (let a = 0; a < n.length; a++) {
      const o = n[a];
      if (o.meshes.find((h) => h === e))
        return o;
    }
    return null;
  }
  static checkMeshIsReady(e) {
    if (e instanceof BABYLON.Mesh) {
      if (e._checkDelayState(), e.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED)
        return !1;
      if (!e.geometry) {
        const n = e.getScene().getGeometries();
        for (let a = 0; a < n.length; a++) {
          const o = n[a];
          if (o.meshes.find((h) => h === e) && !o.isReady())
            return !1;
        }
      }
      if (e.geometry && !e.geometry.isReady())
        return !1;
      for (let t = 0; t < e.getChildMeshes().length; t++) {
        const n = e.getChildMeshes()[t];
        if (!this.checkMeshIsReady(n))
          return !1;
      }
    }
    return e.isReady(!0);
  }
  static checkAllMeshesAreReady(e) {
    let t = !0;
    for (let n = 0; n < e.length; n++)
      this.checkMeshIsReady(e[n]) || (t = !1);
    return t;
  }
  static whenAllMeshesAreReadyAsync(e) {
    return new Promise((t, n) => {
      if (this.checkAllMeshesAreReady(e))
        t();
      else {
        let a = setInterval(() => {
          this.checkAllMeshesAreReady(e) && (clearInterval(a), t());
        }, 5);
      }
    });
  }
  static async whenAllVisibleMeshesAreReadyAsync(e) {
    await this.whenAllMeshesAreReadyAsync(e);
  }
  static whenMeshIsReadyAsync(e) {
    return new Promise((t, n) => {
      if (this.checkMeshIsReady(e))
        t();
      else {
        let a = setInterval(() => {
          this.checkMeshIsReady(e) && (clearInterval(a), t());
        }, 100);
      }
    });
  }
  static visibleMeshesRequireDelayedLoading(e) {
    const t = e.meshes.filter((n) => n.isVisible);
    for (let n = 0; n < t.length; n++)
      if (this.meshRequiresDelayedLoading(t[n]))
        return !0;
    return !1;
  }
  static meshRequiresDelayedLoading(e) {
    if (e instanceof BABYLON.Mesh) {
      if (e.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED || e.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_LOADING)
        return !0;
      const t = Sn.getMeshGeometry(e);
      if (t && (t.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_LOADING || t.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED))
        return !0;
    }
    return !1;
  }
  materialRequiresDelayedLoading(e) {
    return this._scene.getMaterialByID(e) ? !1 : !!(this._scene.metadata && this._scene.metadata.delayedMaterials && this._scene.metadata.delayedMaterials.hasOwnProperty(e) || this._scene.metadata && this._scene.metadata.offloadedMaterials && this._scene.metadata.offloadedMaterials.hasOwnProperty(e));
  }
  /**
   * Recupera il token di autenticazione con strategia di fallback
   * @returns Il token di autenticazione o null se non trovato
   */
  getAuthToken() {
    if (this._authorizationToken && this._authorizationToken.trim() !== "")
      return this._authorizationToken;
    if (window.token && typeof window.token == "string" && window.token.trim() !== "")
      return window.token;
    try {
      console.log("strategia cookie");
      const e = document.cookie.split(";");
      for (let t of e) {
        const [n, a] = t.trim().split("=");
        if (n === "zakeke_token" && a && a.trim() !== "")
          return decodeURIComponent(a);
      }
    } catch (e) {
      console.warn("Error accessing cookies for zakeke_token:", e);
    }
    try {
      if (this._scene && this._scene.metadata && this._scene.metadata.viewer) {
        const e = this._scene.metadata.viewer;
        if (e._authorizationToken && typeof e._authorizationToken == "string" && e._authorizationToken.trim() !== "")
          return e._authorizationToken;
      }
      if (window.sceneEditor && window.sceneEditor._authorizationToken) {
        const e = window.sceneEditor._authorizationToken;
        if (e && typeof e == "string" && e.trim() !== "")
          return e;
      }
      if (window.sceneViewer && window.sceneViewer._authorizationToken) {
        const e = window.sceneViewer._authorizationToken;
        if (e && typeof e == "string" && e.trim() !== "")
          return e;
      }
    } catch (e) {
      console.warn("Error accessing viewer/editor token:", e);
    }
    if (typeof MPlaza < "u" && MPlaza.UserIdentity)
      try {
        if (window.userIdentity && typeof window.userIdentity.get == "function") {
          const e = window.userIdentity.get("token");
          if (e && typeof e == "string" && e.trim() !== "")
            return e;
        }
      } catch (e) {
        console.warn("Error accessing MPlaza.UserIdentity token:", e);
      }
    if (this._scene.metadata && this._scene.metadata.authToken) {
      const e = this._scene.metadata.authToken;
      if (e && typeof e == "string" && e.trim() !== "")
        return e;
    }
    if (typeof Zakeke < "u" && Zakeke.config)
      try {
        const e = Zakeke.config;
        if (e.authToken && typeof e.authToken == "string" && e.authToken.trim() !== "")
          return e.authToken;
        if (e.token && typeof e.token == "string" && e.token.trim() !== "")
          return e.token;
      } catch (e) {
        console.warn("Error accessing Zakeke.config token:", e);
      }
    try {
      const e = localStorage.getItem("authToken") || localStorage.getItem("token") || localStorage.getItem("zakeke_token");
      if (e && e.trim() !== "")
        return e;
    } catch (e) {
      console.warn("Error accessing localStorage token:", e);
    }
    try {
      const e = sessionStorage.getItem("authToken") || sessionStorage.getItem("token") || sessionStorage.getItem("zakeke_token");
      if (e && e.trim() !== "")
        return e;
    } catch (e) {
      console.warn("Error accessing sessionStorage token:", e);
    }
    return console.warn("No authentication token found in any fallback strategy"), null;
  }
  init() {
    this._onPrePointerObservableObserver = this._scene.onPrePointerObservable.add((e) => {
      if (e.type === BABYLON.PointerEventTypes.POINTERDOWN) {
        this._isPointerDown = !0;
        return;
      }
      e.type === BABYLON.PointerEventTypes.POINTERUP && (this._isPointerDown = !1);
    });
  }
  dispose() {
    this._scene && this._onPrePointerObservableObserver && this._scene.onPrePointerObservable.remove(this._onPrePointerObservableObserver), this._camera && this._minZObserver && (this._camera.onAfterCheckInputsObservable.remove(this._minZObserver), this._minZObserver = null);
  }
  switchFullScreen(e) {
    document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement ? this.quitFullscreen(e || this._canvas) : this.launchFullscreen(e || this._canvas), this._canvas && (this._canvas.width = document.body.clientWidth, this._canvas.height = document.body.clientHeight, this.adjustCamera(void 0, !0, !0, !1));
  }
  quitFullscreen(e) {
    let t = document.exitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen || document.mozCancelFullScreen;
    t && t.call(document);
  }
  launchFullscreen(e) {
    let t = e.requestFullscreen || e.webkitRequestFullscreen || e.msRequestFullscreen || e.mozRequestFullScreen;
    t && t.call(e);
  }
  getMeshHierarchySize(e) {
    let t = e.getHierarchyBoundingVectors(!0);
    return t.max.subtract(t.min);
  }
  getMeshHierarchyCenter(e) {
    const t = e.getHierarchyBoundingVectors(!0), n = t.max.subtract(t.min);
    return t.min.add(n.scale(0.5));
  }
  getSceneBoundingInfo() {
    if (!this._scene)
      return null;
    const e = this.getWorldExtends();
    return e ? new BABYLON.BoundingInfo(e.min, e.max) : null;
  }
  setupShadows(e) {
    var fe, X, Z, qe, Oe, je, pt, Te, Ze, ce, ut, ze, ht, Gt, $e, It, rt;
    if (!e)
      return;
    const t = (fe = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : fe.get("enableShadows");
    t != null && (this.enableShadows = t), this.areShadowVisible || (this.enableShadows = !1);
    const n = (X = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : X.get("shadowMapSize"), a = (Z = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Z.get("contactHardeningUVRatio"), o = (qe = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : qe.get("useContactHardeningShadow"), h = (Oe = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Oe.get("useBlurCloseExponentialShadowMap"), f = (je = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : je.get("usePercentageCloserFiltering"), v = (pt = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : pt.get("usePoissonSampling"), x = (Te = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Te.get("useKernelBlur"), k = (Ze = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Ze.get("blurBoxOffset"), I = (ce = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ce.get("blurScale"), V = (ut = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ut.get("blurKernel"), M = (ze = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ze.get("depthScale"), W = (ht = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ht.get("shadowDarkness"), U = (Gt = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Gt.get("shadowMinZ"), Q = ($e = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : $e.get("shadowMaxZ");
    if (!this.enableShadows) {
      const it = (It = this._scene) == null ? void 0 : It.getMeshByName("shadowGround");
      it && it.dispose();
      const Xt = (rt = this._scene) == null ? void 0 : rt.getMaterialByName("shadowMaterial");
      Xt && Xt.dispose();
      const $t = this._scene.getLightByName("shadowDirectionalLight");
      $t && $t.dispose();
      return;
    }
    if (!this._scene)
      throw new Error("Scene is not defined");
    const D = this._scene.getLightByName("shadowDirectionalLight"), ee = new BABYLON.Vector3(0, -2, 0), J = D ?? new BABYLON.DirectionalLight("shadowDirectionalLight", ee, this._scene);
    J.intensity = 0, J.shadowMinZ = U ?? void 0, J.shadowMaxZ = Q ?? void 0, Sn._shadowGenerator = new BABYLON.ShadowGenerator(Number(n), J), Sn._shadowGenerator.usePoissonSampling = !!v, Sn._shadowGenerator.usePercentageCloserFiltering = !!f, Sn._shadowGenerator.useBlurCloseExponentialShadowMap = !!h, Sn._shadowGenerator.useKernelBlur = !!x, Sn._shadowGenerator.blurBoxOffset = Number(k), Sn._shadowGenerator.blurScale = Number(I), Sn._shadowGenerator.blurKernel = Number(V), Sn._shadowGenerator.depthScale = Number(M), Sn._shadowGenerator.setDarkness(Number(W)), Sn._shadowGenerator.useContactHardeningShadow = !!o, Sn._shadowGenerator.contactHardeningLightSizeUVRatio = Number(a), Sn._shadowGenerator.transparencyShadow = !0, Sn._shadowGenerator.enableSoftTransparentShadow = !0;
    const he = Sn._shadowGenerator.getShadowMap();
    this._scene.meshes.forEach((it) => {
      var Xt;
      (Xt = he == null ? void 0 : he.renderList) == null || Xt.push(it);
    }), this.createGroundFromBoundingBox(e);
  }
  setShadowsVisibility(e) {
    Sn._shadowGenerator && (this.areShadowVisible = e);
  }
  pauseAllAnimations() {
    var e;
    this._scene && ((e = this._scene.animationGroups) == null || e.forEach((t) => t.pause()));
  }
  /**
   * Deprecated (keeping only for backwards-compat), use pauseAllAnimations instead or _scene
   * directly
   */
  stopAllAnimations() {
    this.pauseAllAnimations();
  }
  hasAnimations() {
    return this._scene ? this._scene.animationGroups.length > 0 : !1;
  }
  playAnimations() {
    this._scene && this.hasAnimations() && this._scene.animationGroups[0].play();
  }
  setupAnimations(e) {
    var v;
    const t = e == null ? void 0 : e.getAnimationsConfig(), n = !!(t != null && t.get("runAtStart")), a = !!(t != null && t.get("loop")), o = (t == null ? void 0 : t.get("speed")) || 1, h = (v = this._scene) == null ? void 0 : v.animationGroups, f = h && this._scene.animationGroups.length > 0;
    if (h && h.forEach((x) => {
      x.stop(), x.reset();
    }), n && f) {
      const x = h[0];
      x.start(a, o, x.from, x.to, !1);
    }
  }
  createGroundFromBoundingBox(e) {
    var M, W, U, Q, D, ee, J, he, fe;
    if (!e)
      return;
    const t = (M = this._scene) == null ? void 0 : M.getMeshByName("shadowGround");
    t && t.dispose();
    const n = (W = this._scene) == null ? void 0 : W.getMaterialByName("shadowMaterial");
    n && n.dispose();
    const a = (U = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : U.get("enableShadows");
    if (a != null && (this.enableShadows = a), !this.enableShadows) {
      console.log("Shadows are not enabled");
      return;
    }
    const o = this.getSceneBoundingInfo();
    if (!o || !o.boundingBox) {
      console.error("Cannot create ground: No bounding box information available.");
      return;
    }
    const h = (Q = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : Q.get("shadowHexColor"), f = (D = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : D.get("groundSizeMultiplierWidth"), v = (ee = e == null ? void 0 : e.getShadowsConfig()) == null ? void 0 : ee.get("groundSizeMultiplierLength"), x = o.boundingBox.minimumWorld, I = o.boundingBox.maximumWorld.subtract(x), V = x.add(I.scale(0.5));
    if (this._scene !== null) {
      const X = BABYLON.MeshBuilder.CreateGround(
        "shadowGround",
        {
          width: I.x * Number(f),
          height: I.z * Number(v)
        },
        this._scene
      );
      X.position = new BABYLON.Vector3(V.x, x.y, V.z), X.rotation.y = Math.PI;
      const Z = new BABYLON.ShadowOnlyMaterial("bbmat", this._scene);
      X.material = Z, X.receiveShadows = !0, X.material.shadowColor = BABYLON.Color3.FromHexString(
        String(h)
      ), X.metadata = { AR: !1, isRealMesh: !1 };
      const qe = (J = Sn._shadowGenerator) == null ? void 0 : J.getShadowMap();
      Sn._shadowGenerator && qe ? ((he = qe.renderList) == null || he.push(X), X.receiveShadows = !0) : console.error("Failed to add ground mesh to shadow map render list.");
    } else
      console.error("Cannot create ground: Scene is null.");
    console.log("Shadow ground created"), (fe = this._scene) == null || fe.render();
  }
  userIsMoving() {
    return !this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera) ? !1 : this._camera.inertialAlphaOffset !== 0 || this._camera.inertialBetaOffset !== 0 || this._camera.inertialRadiusOffset !== 0 || this._camera.inertialPanningX !== 0 || this._camera.inertialPanningY !== 0 || this._isPointerDown;
  }
  cameraIsMoving() {
    return !this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera) ? !1 : this._camera.inertialAlphaOffset !== 0 || this._camera.inertialBetaOffset !== 0 || this._camera.inertialRadiusOffset !== 0 || this._camera.inertialPanningX !== 0 || this._camera.inertialPanningY !== 0;
  }
  cameraLimitsReached() {
    return !this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera) ? !1 : this._camera.lowerRadiusLimit !== void 0 && this._camera.lowerRadiusLimit !== null && this._camera.radius === this._camera.lowerRadiusLimit || this._camera.upperRadiusLimit !== void 0 && this._camera.upperRadiusLimit !== null && this._camera.radius === this._camera.upperRadiusLimit;
  }
  restoreCameraState() {
    this._camera && this._camera.restoreState();
  }
  isTextureWithUrl(e) {
    return e && (e instanceof BABYLON.Texture || e instanceof BABYLON.CubeTexture || e instanceof BABYLON.HDRCubeTexture || e instanceof BABYLON.ColorGradingTexture || e instanceof BABYLON.EquiRectangularCubeTexture);
  }
  getTextureUrl(e) {
    if (e && (e instanceof BABYLON.Texture || e instanceof BABYLON.CubeTexture || e instanceof BABYLON.HDRCubeTexture || e instanceof BABYLON.ColorGradingTexture || e instanceof BABYLON.EquiRectangularCubeTexture)) {
      let t = e.url;
      if (e.getInternalTexture) {
        const n = e.getInternalTexture();
        n && n.url && (t = n.url);
      }
      return t;
    }
    return null;
  }
  isEditControl(e) {
    return e && (e.name == "EditoControl" || e.metadata && e.metadata.isEditControl);
  }
  isRealMesh(e) {
    return !(this.isEditControl(e) || e.metadata && (e.metadata.boundingBox || e.metadata.isAxis || e.metadata.isGround || e.metadata.isEnvironmentNode || e.metadata.hasOwnProperty("isRealMesh") && !e.metadata.isRealMesh));
  }
  meshFineTuningSettings(e) {
    return e.metadata && e.metadata.hasOwnProperty("tryOnFineTuningSettings") && e.metadata.tryOnFineTuningSettings ? e.metadata.tryOnFineTuningSettings : null;
  }
  meshHasParent(e, t) {
    if (this._scene) {
      let n = this._scene.getMeshById(e);
      if (n)
        for (; n.parent; ) {
          if (n.parent.id === t)
            return !0;
          n = n.parent;
        }
    }
    return !1;
  }
  countSceneMeshes() {
    let e = 0;
    return this._scene && this._scene.meshes.forEach((t) => {
      this.isRealMesh(t) && e++;
    }), e;
  }
  sceneHasRealMeshes() {
    for (let e = 0; e < this._scene.meshes.length; e++)
      if (this.isRealMesh(this._scene.meshes[e]))
        return !0;
    return !1;
  }
  getSceneMeshes() {
    const e = [];
    return this._scene && this._scene.meshes.forEach((t) => {
      this.isRealMesh(t) && e.push(t);
    }), e;
  }
  getSceneMeshesByName(e) {
    let t = [];
    if (this._scene) {
      const a = function(o) {
        return o.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      };
      if (e) {
        var n = new RegExp(a(e).replace(/\\\*/g, ".*"), "i");
        for (let o = 0; o < this._scene.meshes.length; o++) {
          const h = this._scene.meshes[o];
          this.isRealMesh(h) && h.name && n.test(h.name) && t.push(h);
        }
      }
    }
    return t;
  }
  isVisibleMesh(e) {
    return this.isRealMesh(e) && e.isVisible;
  }
  getVisibleMeshes() {
    const e = [];
    return this._scene.meshes.forEach((t) => {
      this.isVisibleMesh(t) && e.push(t);
    }), e;
  }
  getInvisibleMeshes() {
    const e = [];
    return this._scene.meshes.forEach((t) => {
      this.isRealMesh(t) && !t.isVisible && e.push(t);
    }), e;
  }
  getSubMesh(e, t) {
    return e.subMeshes && e.subMeshes.length > 0 && t >= 0 && t < e.subMeshes.length ? e.subMeshes[t] : null;
  }
  getMeshHierarchy(e) {
    const t = [];
    let n = this._scene.getMeshById(e);
    if (!n)
      return t;
    let a = (o) => {
      t.push(o);
      let h = o.getChildMeshes(!0);
      for (let f = 0; f < h.length; f++)
        a(h[f]);
    };
    return a(n), t;
  }
  getTryOnMeshHierarchy(e) {
    const t = [];
    let n = this._scene.getMeshById(e);
    if (!n)
      return t;
    let a = (o) => {
      t.push(o);
      let h = o.getChildMeshes(!0);
      for (const f of h)
        (this.isVisibleCanvasMesh(f) || this.isVisibleTryOnMesh(f)) && a(f);
    };
    return a(n), t;
  }
  isVisibleCanvasMesh(e) {
    return this.isCanvasMesh(e) && e.isVisible;
  }
  isCanvasMesh(e) {
    return !e || !e.metadata ? !1 : e.metadata.hasOwnProperty("iscanvasMesh") && typeof e.metadata.iscanvasMesh == "boolean" ? e.metadata.iscanvasMesh : !1;
  }
  isAREnabledForMesh(e) {
    return e ? !e.metadata || e.metadata.AR === void 0 || e.metadata.AR === null || typeof e.metadata.AR != "boolean" ? !0 : e.metadata.AR : !1;
  }
  isTryOnEnabledForMesh(e) {
    return e ? !e.metadata || e.metadata.TryOn === void 0 || e.metadata.TryOn === null || typeof e.metadata.TryOn != "boolean" ? !0 : e.metadata.TryOn : !1;
  }
  isVisibleTryOnMesh(e) {
    return this.isTryOnEnabledForMesh(e) && this.isVisibleMesh(e);
  }
  getMeshesForAR() {
    const e = [];
    return this._scene && this._scene.meshes.forEach((t) => {
      (this.isRealMesh(t) || this.isCanvasMesh(t)) && t.isVisible && this.isAREnabledForMesh(t) && e.push(t);
    }), e;
  }
  checkMaterialsForAR() {
    const e = this.getMeshesMaterials(this.getMeshesForAR());
    for (let t = 0; t < e.length; t++) {
      const n = e[t];
      if (!(n instanceof BABYLON.PBRMaterial) && !(n instanceof BABYLON.PBRMetallicRoughnessMaterial) && !(n instanceof BABYLON.StandardMaterial))
        return !1;
    }
    return !0;
  }
  getMeshesMaterials(e) {
    const t = [], n = [];
    for (let a = 0; a < e.length; a++) {
      let o = e[a];
      if (o.material)
        if (o.material instanceof BABYLON.MultiMaterial)
          for (let h = 0; h < o.material.subMaterials.length; h++) {
            let f = o.material.subMaterials[h];
            f && t.indexOf(f.id) === -1 && (n.push(f), t.push(f.id));
          }
        else
          t.indexOf(o.material.id) === -1 && (n.push(o.material), t.push(o.material.id));
    }
    return n;
  }
  getMeshMaterials(e) {
    const t = [];
    if (e && e.material)
      if (e.material instanceof BABYLON.MultiMaterial)
        for (let n = 0; n < e.material.subMaterials.length; n++) {
          let a = e.material.subMaterials[n];
          a && t.push(a);
        }
      else
        t.push(e.material);
    return t;
  }
  getHiddenMeshTotalVertices() {
    return this.getTotalVertices((e) => !e.isVisible);
  }
  getTotalVertices(e) {
    let t = 0;
    return this._scene && this._scene.meshes.forEach((n) => {
      this.isRealMesh(n) && (e && !e(n) || (t += n.getTotalVertices()));
    }), t;
  }
  getHiddenMeshTotalIndices() {
    return this.getTotalIndices((e) => !e.isVisible);
  }
  getTotalIndices(e) {
    let t = 0;
    return this._scene && this._scene.meshes.forEach((n) => {
      this.isRealMesh(n) && (e && !e(n) || (t += n.getTotalIndices()));
    }), t;
  }
  getAllMaterials() {
    const e = [];
    return this._scene && this._scene.materials.forEach((t) => {
      t.metadata && (t.metadata.isRealMaterial !== void 0 && !t.metadata.isRealMaterial || t.metadata.isEnvironmentNode !== void 0 && t.metadata.isEnvironmentNode) || t.id !== "groundMaterial" && t.id !== "default material" && e.push(t);
    }), e;
  }
  getMeshesUsingMaterial(e) {
    const t = [], n = this.getSceneMeshes();
    for (let a = 0; a < n.length; a++) {
      const o = n[a];
      this.isMeshUsingMaterial(o, e) && t.push(o);
    }
    return t;
  }
  isMeshUsingMaterial(e, t) {
    if (e.material) {
      if (e.material.id === t)
        return !0;
      if (e.material instanceof BABYLON.MultiMaterial)
        for (let n = 0; n < e.material.subMaterials.length; n++) {
          const a = e.material.subMaterials[n];
          if (a && a.id === t)
            return !0;
        }
    }
    return !1;
  }
  getAllUnusedMaterials() {
    const e = this.getAllMaterials(), t = [];
    for (let n = 0; n < e.length; n++) {
      const a = e[n];
      this.getMeshesUsingMaterial(a.id).length === 0 && t.push(a);
    }
    return t;
  }
  async getSceneScreenshotAsync(e, t) {
    if (!this._camera)
      return "";
    let n = { width: e, height: t };
    return await BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, n, "image/png");
  }
  containsPBRMaterials() {
    if (this._scene) {
      for (let e = 0; e < this._scene.materials.length; e++)
        if (this._scene.materials[e] instanceof BABYLON.PBRBaseMaterial)
          return !0;
    }
    return !1;
  }
  getMeshesForTryOn() {
    const e = [];
    return this._scene && this._scene.meshes.forEach((t) => {
      (this.isRealMesh(t) || this.isCanvasMesh(t)) && t.isVisible && this.isTryOnEnabledForMesh(t) && e.push(t);
    }), e;
  }
  setupLights() {
    this._hemiLight = null, this._pointLight = null;
    let e = null, t = null;
    this._scene.lights.forEach((n) => {
      n instanceof BABYLON.HemisphericLight && (e === null && (e = n), n.id === this._defHemiLightID && (this._hemiLight = n)), n instanceof BABYLON.PointLight && (t === null && (t = n), n.id === this._defPointLightID && (this._pointLight = n));
    }), this._hemiLight === null && (e !== null ? this._hemiLight = e : (this._hemiLight = new BABYLON.HemisphericLight(
      "Default Hemispheric Light",
      BABYLON.Vector3.Up(),
      this._scene
    ), this._hemiLight.intensity = 0.5), this._hemiLight && (this._hemiLight.id = this._defHemiLightID)), this._pointLight === null && (t !== null ? this._pointLight = t : (this._pointLight = new BABYLON.PointLight(
      "Default Point Light",
      new BABYLON.Vector3(0, 5, 0),
      this._scene
    ), this._pointLight.intensity = 0.5), this._pointLight && (this._pointLight.id = this._defPointLightID));
  }
  setUpCustomLights(e) {
    Object.entries(e).forEach((t) => {
      const n = t[0], a = t[1].position, o = t[1].general.intensity, h = t[1].general.visible, f = {
        position: a,
        intensity: o,
        visible: h
      };
      this.createOrUpdateLight(n, f);
    });
  }
  createOrUpdateLight(e, t) {
    const n = this._scene.getLightByName(e);
    if (n && (this._scene.removeLight(n), n.dispose()), !t.visible)
      return;
    const a = new BABYLON.Vector3(t.position.x, t.position.y, t.position.z);
    let o;
    e.match(/directional/i) ? (o = new BABYLON.DirectionalLight(e, a, this._scene), o.intensity = t.intensity, o.id = Zakeke.generateUUID()) : e.match(/pointLight/i) ? (o = new BABYLON.PointLight(e, a, this._scene), o.intensity = t.intensity, o.id = Zakeke.generateUUID()) : e.match(/hemisphere/i) && (o = new BABYLON.HemisphericLight(e, a, this._scene), o.intensity = t.intensity, o.id = Zakeke.generateUUID());
  }
  getDefaultHemisphericLight() {
    return this._hemiLight;
  }
  getDefaultPointLight() {
    return this._pointLight;
  }
  isDefaultLight(e) {
    return e.id == this._defHemiLightID || e.id == this._defPointLightID;
  }
  setUpCameraByOptions(e) {
    if (e && this._scene) {
      let t = this._scene.cameras.find((n) => n instanceof BABYLON.ArcRotateCamera);
      e && t instanceof BABYLON.ArcRotateCamera && (t.beta = e.beta ?? t.beta, t.alpha = e.alpha ?? t.alpha, t.fov = e.fov ?? t.fov);
    }
  }
  setupCamera() {
    if (this._scene) {
      let e = this._scene.cameras.find((t) => t instanceof BABYLON.ArcRotateCamera);
      e ? this._camera = e : (this._camera = new BABYLON.ArcRotateCamera("camera1", 0, 0, 0, BABYLON.Vector3.Zero(), this._scene), this._camera.setPosition(new BABYLON.Vector3(0, 3, -8))), this.setupCameraLimits(), this._canvas && this._camera.attachControl(this._canvas, !1);
    }
  }
  setCameraRadiusParameters(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      this._camera.lowerRadiusLimit = e * (this._zoomEnabled ? 0.01 : 1), this._camera.upperRadiusLimit = e * (this._zoomEnabled ? 3 : 1), this._camera.wheelPrecision = 100 / e, this._camera.pinchPrecision = 100 / e, this._camera.minZ = e * 0.01, this._camera.maxZ = e * 1e3, this._camera.speed = e * 0.2, this._camera.wheelDeltaPercentage = 0.01, this._camera.pinchDeltaPercentage = 6e-4, this._camera.panningSensibility = 0, this._camera.wheelPrecision = 100 / e, this._camera.panningAxis = BABYLON.Vector3.Zero(), this._camera.panningInertia = 0;
      const t = this._camera.inputs.attached.pointers;
      t && (t.multiTouchPanning = !1, t.multiTouchPanAndZoom = !1), this._camera.radius = e, this._minZObserver || (this._minZObserver = this._camera.onAfterCheckInputsObservable.add(() => {
        this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.minZ = Math.max(0.01, this._camera.radius * 0.01));
      }));
    }
  }
  removeCameraLimits() {
    this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.lowerRadiusLimit = null, this._camera.upperRadiusLimit = null, this._camera.minZ = 1, this._camera.maxZ = 1e4);
  }
  getWorldExtends() {
    return this._scene ? this._scene.getWorldExtends((e) => this.isRealMesh(e) && e.isVisible) : null;
  }
  getCameraWorldExtends() {
    let e = null;
    if (this._scene) {
      let t = this._cameraPivot;
      if (!t)
        for (let n = 0; n < this._scene.meshes.length; n++) {
          const a = this._scene.meshes[n];
          if (a.metadata && a.metadata.isCameraPivot !== void 0 && a.metadata.isCameraPivot) {
            t = a;
            break;
          }
        }
      t && (e = this._scene.getWorldExtends((n) => n === t || this.meshHasParent(n.id, t.id)));
    }
    return e || (e = this.getWorldExtends()), e;
  }
  /**
   * Configura i parametri di input touch della camera (panning, pinch-to-zoom, observer minZ).
   * NON dipende da worldExtends, quindi funziona sempre anche se le mesh sono appena
   * diventate visibili (es. dopo Show Object action) e i world extends non sono ancora validi.
   */
  configureCameraTouchInput() {
    if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
      return;
    this._camera.panningSensibility = 0, this._camera.panningAxis = BABYLON.Vector3.Zero(), this._camera.panningInertia = 0, this._camera.pinchDeltaPercentage = 6e-4, this._camera.wheelDeltaPercentage = 0.01;
    const e = this._camera.inputs.attached.pointers;
    e && (e.multiTouchPanning = !1, e.multiTouchPanAndZoom = !1), this._minZObserver || (this._minZObserver = this._camera.onAfterCheckInputsObservable.add(() => {
      this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.minZ = Math.max(0.01, this._camera.radius * 0.01));
    }));
  }
  setupCameraLimits(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      if (e == null) {
        let n = this.getCameraWorldExtends();
        n && (e = n);
      }
      if (!e)
        return;
      const t = e.max.subtract(e.min);
      if (isFinite(t.length())) {
        this.removeCameraLimits();
        const n = this.calculateCameraRadius(e);
        if (this.setCameraRadiusParameters(n), this._limitLowerRadius && this._scene.meshes.length && this._zoomEnabled) {
          this._camera.useFramingBehavior = !0;
          const a = this._camera.getBehaviorByName("Framing");
          a && a instanceof BABYLON.FramingBehavior && (a.elevationReturnTime = -1, this._minZoomPerc !== null && this._minZoomPerc !== void 0 && this._minZoomPerc > 0 && (this._camera.lowerRadiusLimit = n * this._minZoomPerc), this._maxZoomPerc !== null && this._maxZoomPerc !== void 0 && this._maxZoomPerc > 0 && (this._camera.upperRadiusLimit = n * this._maxZoomPerc));
        }
      }
    }
  }
  adjustCamera(e, t = !0, n = !0, a = !0, o = !1) {
    if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
      return;
    let h = this.getCameraWorldExtends();
    if (!h)
      return;
    const f = h.max.subtract(h.min);
    if (!isFinite(f.length()))
      return;
    const v = h.min.add(f.scale(0.5));
    this.removeCameraLimits();
    const x = this.calculateCameraRadius(h);
    let k = this._camera.alpha;
    t || (k = -(Math.PI / 2), e && e === "gltf" && (k += Math.PI));
    let I = this._camera.beta;
    n || (I = Math.PI / 2 - 0.3);
    let V = v.clone(), M = h.min.y, W = h.max.y, U = M + (W - M) * this._positionScale;
    if (V.y = U, !a)
      this._camera.alpha = k, this._camera.beta = I, this._camera.radius = x, this._camera.target = V, this.setupCameraLimits(h);
    else {
      if (o) {
        const Q = this.calculateCameraRadius(h);
        this._camera.radius = Q;
      }
      this.animateCameraToFinalParamters(k, I, x, V, 2, () => {
        this.setupCameraLimits(h);
      });
    }
  }
  normalizeAngleOfView(e, t) {
    const n = BABYLON.Vector3.Zero(), a = new BABYLON.ArcRotateCamera("ghostCamera", e, t, 1, n, this._scene), o = a.position;
    return a.dispose(), this.computeCameraAngleOfView(n, o);
  }
  computeCameraAngleOfView(e, t) {
    const n = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, e, this._scene);
    n.setPosition(t);
    const a = n.alpha, o = n.beta;
    return n.dispose(), {
      alpha: a,
      beta: o
    };
  }
  moveCamera(e, t) {
    var n = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, e, this._scene);
    n.setPosition(t);
    var a = n.alpha, o = n.beta, h = n.radius;
    n.dispose(), this.moveCameraToFinalParameters(a, o, h, e), this.configureCameraTouchInput();
  }
  animateCamera(e, t, n, a) {
    var o = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, e, this._scene);
    o.setPosition(t);
    var h = o.alpha, f = o.beta, v = o.radius;
    o.dispose(), this.configureCameraTouchInput(), this.animateCameraToFinalParamters(h, f, v, e, n, a);
  }
  // riporta angle nel range -180, + 180
  wrapPi(e) {
    if (Math.abs(e) > Math.PI) {
      var t = 2 * Math.PI, n = Math.floor((e + Math.PI) * (1 / t));
      e -= n * t;
    }
    return e;
  }
  wrap2Pi(e) {
    let t = e % (Math.PI * 2);
    return t < 0 && (t += Math.PI * 2), t;
  }
  zoomIn() {
    this.zoom(0.85);
  }
  zoomOut() {
    this.zoom(1.15);
  }
  zoom(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      let n = this._camera.radius, a = this._camera.lowerRadiusLimit !== null && this._camera.lowerRadiusLimit !== void 0 ? this._camera.lowerRadiusLimit : 0, o = Math.max(0, a), h = Number.MAX_VALUE;
      this._camera.upperRadiusLimit != null && (h = this._camera.upperRadiusLimit);
      var t = Math.max(o, Math.min(h, n * e));
      t !== n && this.animateCameraToFinalParamters(
        this._camera.alpha,
        this._camera.beta,
        t,
        this._camera.target,
        0.5
      );
    }
  }
  moveCameraToFinalParameters(e, t, n, a) {
    !this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera) || (this._camera.target = a, this._camera.alpha = e, this._camera.beta = t, this._camera.radius = n);
  }
  animateCameraToFinalParamters(e, t, n, a, o, h) {
    if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
      return;
    let f = this._camera.radius, v = () => {
      if (this._camera) {
        this._scene.stopAnimation(this._camera);
        for (let Te = 0; Te < this._camera.animations.length; Te++)
          this._camera.animations[Te], this._camera.animations.splice(Te--, 1);
      }
    };
    v();
    let x = this._camera.alpha;
    !this._camera.lowerAlphaLimit && !this._camera.upperAlphaLimit && (x = this.wrap2Pi(this._camera.alpha));
    let k = this._camera.beta;
    !this._camera.lowerBetaLimit && !this._camera.upperBetaLimit && (k = this.wrap2Pi(this._camera.beta));
    let I = isFinite(e) ? this.wrapPi(e) : x;
    Math.abs(x - I) > Math.PI && (I += Math.PI * 2);
    let V = isFinite(t) ? this.wrapPi(t) : k;
    Math.abs(k - V) > Math.PI && (V += Math.PI * 2);
    let M = 2;
    o && typeof o == "number" && o > 0 && (M = o);
    let W = 60, U = Math.floor(M * W), ee = this._camera.target.subtract(a).length() / this._camera.radius, J = [], he = new BABYLON.CubicEase();
    he.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
    let fe = null;
    this._camera.target !== a && (ee >= 5e-3 ? (fe = new BABYLON.Animation(
      "camTargetAnimation",
      "target",
      W,
      BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    ), J = [
      {
        frame: 0,
        value: this._camera.target
      },
      {
        frame: U,
        value: a
      }
    ], fe.setKeys(J), fe.setEasingFunction(he)) : this._camera.target = a);
    let X = null;
    x !== I && (X = new BABYLON.Animation(
      "camAlphaAnimation",
      "alpha",
      W,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    ), J = [
      {
        frame: 0,
        value: x
      },
      {
        frame: U,
        value: I
      }
    ], X.setKeys(J), X.setEasingFunction(he));
    let Z = null;
    k !== V && (Z = new BABYLON.Animation(
      "camBetaAnimation",
      "beta",
      W,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    ), J = [
      {
        frame: 0,
        value: k
      },
      {
        frame: U,
        value: V
      }
    ], Z.setKeys(J), Z.setEasingFunction(he));
    let qe = Math.abs(this._camera.radius - n) / this._camera.radius, Oe = null;
    this._camera.radius !== n && (qe >= 5e-3 ? (Oe = new BABYLON.Animation(
      "camRadiusAnimation",
      "radius",
      W,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
    ), J = [
      {
        frame: 0,
        value: f
      },
      {
        frame: U,
        value: n
      }
    ], Oe.setKeys(J), Oe.setEasingFunction(he)) : this._camera.radius = n);
    let je = this._camera.animations.length;
    if (fe && this._camera.animations.push(fe), X && this._camera.animations.push(X), Z && this._camera.animations.push(Z), Oe && this._camera.animations.push(Oe), this._camera.animations.length > je) {
      var pt = this._scene.beginAnimation(this._camera, 0, U, !1, 1);
      pt.onAnimationEnd = () => {
        v(), this.setupShaderMaterialsCameraPosition(), h && h();
      };
    } else
      h && h();
  }
  //Returns the frustum slope based on the canvas ratio and camera FOV
  //returns The frustum slope represented as a Vector2 with X and Y slopes
  getFrustumSlope() {
    let e = this._camera;
    if (!e)
      return BABYLON.Vector2.Zero();
    let n = this._engine.getAspectRatio(e), a = Math.tan(e.fov / 2), o = a * n;
    return new BABYLON.Vector2(o, a);
  }
  calculateCameraRadius(e) {
    if (e == null) {
      let n = this.getCameraWorldExtends();
      n && (e = n);
    }
    if (!e)
      return 1;
    var t = this.calculateLowerRadiusFromModelBoundingSphere(e.min, e.max);
    return isFinite(t) || (t = 1), t + (this._cameraZoom ?? 0);
  }
  // Calculates the lowest radius for the camera based on the bounding box of the mesh.
  calculateLowerRadiusFromModelBoundingSphere(e, t) {
    const a = t.subtract(e).length(), o = this.getFrustumSlope(), h = a * 0.5, f = this._radiusScale, v = h * f, x = v * Math.sqrt(1 + 1 / (o.x * o.x)), k = v * Math.sqrt(1 + 1 / (o.y * o.y));
    let I = Math.max(x, k);
    var V = this._camera;
    return !V || !(V instanceof BABYLON.ArcRotateCamera) ? 0 : (V.upperRadiusLimit && (I = I > V.upperRadiusLimit ? V.upperRadiusLimit : I), I);
  }
  getWorldCenter(e) {
    if (e == null) {
      let a = this.getCameraWorldExtends();
      a && (e = a);
    }
    if (!e)
      return null;
    let t = e.max.subtract(e.min);
    return isFinite(t.length()) ? e.min.add(t.scale(0.5)) : null;
  }
  getCameraWorldCenter(e) {
    if (e == null) {
      let a = this.getCameraWorldExtends();
      a && (e = a);
    }
    if (!e)
      return null;
    let t = e.max.subtract(e.min);
    return isFinite(t.length()) ? e.min.add(t.scale(0.5)) : null;
  }
  getCameraRadius(e) {
    if (e == null) {
      let a = this.getCameraWorldExtends();
      a && (e = a);
    }
    if (!e)
      return null;
    let t = e.max.subtract(e.min);
    return isFinite(t.length()) ? this.calculateCameraRadius(e) : null;
  }
  setCameraLimitLowerRadius(e, t = !1) {
    if (this._limitLowerRadius = e, this.setupCameraLimits(), t && this._camera && this._camera instanceof BABYLON.ArcRotateCamera && this.sceneHasRealMeshes()) {
      let n = this._camera.target.clone(), a = this.getCameraWorldExtends();
      if (a) {
        let o = a.min.y, h = a.max.y, f = o + (h - o) * this._positionScale;
        n.y = f, this.animateCameraToFinalParamters(
          this._camera.alpha,
          this._camera.beta,
          this._camera.radius,
          n,
          0.5
        );
      }
    }
  }
  setCameraPositionScale(e, t = !1) {
    if (this._positionScale = e, t && this._camera && this._camera instanceof BABYLON.ArcRotateCamera && this.sceneHasRealMeshes()) {
      var n = this._camera.target.clone(), a = this.getCameraWorldExtends();
      if (a) {
        var o = a.min.y, h = a.max.y, f = o + (h - o) * this._positionScale;
        n.y = f, this.animateCameraToFinalParamters(
          this._camera.alpha,
          this._camera.beta,
          this._camera.radius,
          n,
          0.5
        );
      }
    }
  }
  setCameraPositionFOV(e) {
    this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.fov = e);
  }
  getCameraPivot() {
    return this._cameraPivot;
  }
  setCameraPivot(e) {
    this._cameraPivot = e, this.adjustCamera(void 0, !0, !0, !0);
  }
  setZoomEnabled(e) {
    this._zoomEnabled = e, this.adjustCamera(void 0, !0, !0, !0);
  }
  setMinZoomPerc(e) {
    const t = e ?? null;
    t !== this._minZoomPerc && (this._minZoomPerc = t, this.adjustCamera(void 0, !0, !0, !1));
  }
  setMaxZoomPerc(e) {
    const t = e ?? null;
    t !== this._maxZoomPerc && (this._maxZoomPerc = t, this.adjustCamera(void 0, !0, !0, !1));
  }
  setCameraZoom(e) {
    e != null && this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._cameraZoom = -(e / 10), this.adjustCamera(void 0, !0, !0, !1));
  }
  setCameraAlphaLimits(e, t) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const n = this.normalizeAngleOfView(this._camera.alpha, this._camera.beta).alpha;
      this.setCameraLowerAlphaLimit(e), this.setCameraUpperAlphaLimit(t), this._camera.alpha = n;
    }
  }
  setCameraLowerAlphaLimit(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
      if (e == null)
        this._camera.lowerAlphaLimit = null;
      else {
        let t = this.normalizeAngleOfView(e, this._camera.beta).alpha;
        this._camera.upperAlphaLimit && t > this._camera.upperAlphaLimit && (this._camera.upperAlphaLimit += Math.PI * 2), this._camera.lowerAlphaLimit = t;
      }
  }
  setCameraUpperAlphaLimit(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
      if (e == null)
        this._camera.upperAlphaLimit = null;
      else {
        let t = this.normalizeAngleOfView(e, this._camera.beta).alpha;
        this._camera.lowerAlphaLimit && t < this._camera.lowerAlphaLimit && (t += Math.PI * 2), this._camera.upperAlphaLimit = t;
      }
  }
  setCameraLowerBetaLimit(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
      if (e == null)
        this._camera.lowerBetaLimit = 0.01;
      else {
        let t = this.normalizeAngleOfView(this._camera.alpha, e).beta;
        this._camera.upperBetaLimit && t > this._camera.upperBetaLimit && (this._camera.upperBetaLimit += Math.PI * 2), this._camera.lowerBetaLimit = t;
      }
  }
  setCameraUpperBetaLimit(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
      if (e == null)
        this._camera.upperBetaLimit = Math.PI - 0.01;
      else {
        let t = this.normalizeAngleOfView(this._camera.alpha, e).beta;
        this._camera.lowerBetaLimit && t < this._camera.lowerBetaLimit && (this._camera.lowerBetaLimit -= Math.PI * 2), this._camera.upperBetaLimit = t;
      }
  }
  setCameraBetaLimits(e, t) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const n = this.normalizeAngleOfView(this._camera.alpha, this._camera.beta).beta;
      this.setCameraLowerBetaLimit(e), this.setCameraUpperBetaLimit(t), this._camera.beta = n;
    }
  }
  zoomOnMesh(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      this._camera.useFramingBehavior = !0;
      const t = this._camera.getBehaviorByName("Framing");
      t && t instanceof BABYLON.FramingBehavior && (t.framingTime = 0, t.elevationReturnTime = -1, t.radiusScale = this._radiusScale, t.positionScale = this._positionScale, t.zoomOnMeshHierarchy(e));
    }
  }
  async takeScreenshotAsync(e, t) {
    if (!this._camera)
      return "";
    const n = { width: e, height: t };
    return await BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, n, "image/png");
  }
  async takeContentScreenshotAsync(e, t, n) {
    if (!this._camera)
      return "";
    var a = this._scene.clearColor.clone();
    this._scene.clearColor = n || new BABYLON.Color4(0, 0, 0, 0), this._scene.render();
    let o = { width: e, height: t };
    const h = BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, o, "image/png");
    this._scene.render(), this._scene.getEngine().endFrame();
    const f = await h;
    return this._scene.clearColor = a, f;
  }
  async takeMaterialScreenshotAsync(e, t, n) {
    let a = this._scene.getMaterialByID(e);
    if (!a)
      return "";
    let o = this.getVisibleMeshes();
    for (let V = 0; V < o.length; V++) {
      var h = o[V];
      h.isVisible = !1;
    }
    let f = this._scene.clearColor.clone();
    this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0);
    let v = BABYLON.Mesh.CreateSphere("temp_sphere", 32, 2, this._scene);
    v.material = a;
    let x = new BABYLON.ArcRotateCamera("temp_camera", 0, 0, 0, BABYLON.Vector3.Zero(), this._scene);
    x.setPosition(new BABYLON.Vector3(0, 0, -4)), this._scene.activeCamera = x, this._scene.render();
    let k = { width: t, height: n }, I = await BABYLON.Tools.CreateScreenshotAsync(this._engine, x, k, "image/png");
    this._scene.clearColor = f, v.dispose();
    for (let V = 0; V < o.length; V++) {
      var h = o[V];
      h.isVisible = !0;
    }
    return this._scene.activeCamera = this._camera, x.dispose(), I;
  }
  getScenePBRMaterials() {
    const e = [];
    return this._scene && this._scene.materials.forEach((t) => {
      t instanceof BABYLON.PBRBaseMaterial && e.push(t);
    }), e;
  }
  resetPBRMaterialsImageProcessingConfiguration() {
    var e = this.getScenePBRMaterials();
    e.forEach((t) => {
      this.adjustPBRMaterialImageProcessingConfiguration(t);
    });
  }
  adjustPBRMaterialImageProcessingConfiguration(e) {
    e instanceof BABYLON.PBRMaterial && e.imageProcessingConfiguration && (e.imageProcessingConfiguration.colorGradingWithGreenDepth = !1, e.imageProcessingConfiguration.colorGradingBGR = !1, e.imageProcessingConfiguration.exposure = 1, e.imageProcessingConfiguration.toneMappingEnabled = !1, e.imageProcessingConfiguration.contrast = 1);
  }
  animateMeshToFinalParameters(e, t, n, a, o, h = 2, f) {
    if (this._scene && e) {
      e.id;
      const k = () => {
        this._scene.stopAnimation(e);
        for (let he = 0; he < e.animations.length; he++)
          e.animations.splice(he--, 1);
      };
      k();
      const I = h, V = 60, M = Math.floor(I * V);
      let W, U = null;
      e.position !== t && (U = new BABYLON.Animation(
        "positionAnimation",
        "position",
        V,
        BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
        BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
      ), W = [
        {
          frame: 0,
          value: e.position
        },
        {
          frame: M,
          value: t
        }
      ], U.setKeys(W));
      let Q = null, D = null;
      if (e.rotationQuaternion == null) {
        var v;
        n != null ? v = n.clone() : v = a.toEulerAngles().clone(), e.rotation != v && (Q = new BABYLON.Animation(
          "eulerAnimation",
          "rotation",
          V,
          BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
          BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
        ), W = [
          {
            frame: 0,
            value: e.rotation
          },
          {
            frame: M,
            value: v
          }
        ], Q.setKeys(W));
      } else {
        let he;
        a != null ? he = a.clone() : (he = BABYLON.Quaternion.Identity(), he.copyFrom(BABYLON.Quaternion.RotationYawPitchRoll(n.y, n.x, n.z))), D = new BABYLON.Animation(
          "quaternionAnimation",
          "rotationQuaternion",
          V,
          BABYLON.Animation.ANIMATIONTYPE_QUATERNION,
          BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
        ), W = [
          {
            frame: 0,
            value: e.rotationQuaternion
          },
          {
            frame: M,
            value: he
          }
        ], D.setKeys(W);
      }
      let ee = null;
      e.scaling !== o && (ee = new BABYLON.Animation(
        "scalingAnimation",
        "scaling",
        V,
        BABYLON.Animation.ANIMATIONTYPE_VECTOR3,
        BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
      ), W = [
        {
          frame: 0,
          value: e.scaling
        },
        {
          frame: M,
          value: o
        }
      ], ee.setKeys(W));
      let J = e.animations.length;
      if (U && e.animations.push(U), Q && e.animations.push(Q), D && e.animations.push(D), ee && e.animations.push(ee), e.animations.length > J) {
        var x = this._scene.beginAnimation(e, 0, M, !1, 1);
        x.onAnimationEnd = () => {
          k(), f && f();
        };
      }
    }
  }
  getMaterialsUsingTexture(e) {
    var t = this.getTextureMaterialsMap();
    return this._scene.materials.forEach((n) => {
      var a = this.getTexturesForMaterial(n);
      a.forEach((o) => {
        t.hasOwnProperty(o.uid) || (t[o.uid] = []), t[o.uid].push(n);
      });
    }), t.hasOwnProperty(e.uid) ? t[e.uid] : [];
  }
  getTextureMaterialsMap() {
    let e = {};
    return this._scene && this._scene.materials.forEach((t) => {
      var n = this.getTexturesForMaterial(t);
      n.forEach((a) => {
        e.hasOwnProperty(a.uid) || (e[a.uid] = []), e[a.uid].push(t);
      });
    }), e;
  }
  // Recupera tutte le texture di un materiale
  getTexturesForMaterial(e) {
    return e.getActiveTextures();
  }
  getTexturesExclusivelyForMaterial(e) {
    let t = this.getTexturesForMaterial(e), n = this.getTextureMaterialsMap();
    for (var a = 0; a < t.length; a++) {
      let h = t[a];
      var o = n.hasOwnProperty(h.uid) ? n[h.uid] : [];
      o.length > 1 && t.splice(a--, 1);
    }
    return t;
  }
  getStandardMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getPBRBaseSimpleMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getPBRMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getPBRMetallicRoughnessMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getPBRSpecularGlossinessMaterialTextures(e) {
    return e.getActiveTextures();
  }
  getNewPBRMaterialTextures(e) {
    return e.getActiveTextures();
  }
  createMeshesFromSubMeshes(e) {
    let t = e.getChildMeshes(!0);
    for (let o = 0; o < t.length; o++)
      this.createMeshesFromSubMeshes(t[o]);
    let n = [];
    if (e.subMeshes && e.subMeshes.length > 0)
      for (let o = 0; o < e.subMeshes.length; o++) {
        let h = this.createMeshFromSubMesh(e, o);
        h && n.push(h);
      }
    let a = new BABYLON.VertexData();
    a.positions = [], a.indices = [], a.normals = [], a.uvs = [], a.uvs2 = [], a.applyToMesh(e, !0), e.subMeshes = [], e.material = null, n.forEach((o) => {
      o.parent = e;
    });
  }
  createMeshFromSubMesh(e, t, n) {
    let a = null, o = e.subMeshes[t], h = e.getVerticesData(BABYLON.VertexBuffer.PositionKind), f = e.getVerticesData(BABYLON.VertexBuffer.NormalKind), v = e.getIndices();
    if (h && f && v) {
      let k = h.slice(
        3 * o.verticesStart,
        3 * (o.verticesStart + o.verticesCount)
      ), I = f.slice(
        3 * o.verticesStart,
        3 * (o.verticesStart + o.verticesCount)
      ), V = v.slice(o.indexStart, o.indexStart + o.indexCount), M = null;
      if (e.isVerticesDataPresent(BABYLON.VertexBuffer.UVKind)) {
        let Q = e.getVerticesData(BABYLON.VertexBuffer.UVKind);
        Q && (M = Q.slice(2 * o.verticesStart, 2 * (o.verticesStart + o.verticesCount)));
      }
      var x = null;
      if (e.isVerticesDataPresent(BABYLON.VertexBuffer.UV2Kind)) {
        let Q = e.getVerticesData(BABYLON.VertexBuffer.UV2Kind);
        Q && (x = Q.slice(
          2 * o.verticesStart,
          2 * (o.verticesStart + o.verticesCount)
        ));
      }
      for (let Q = 0; Q < V.length; Q++)
        V[Q] -= o.verticesStart;
      let W = new BABYLON.Mesh(n || e.name + "_part_" + o._id, this._scene), U = new BABYLON.VertexData();
      U.positions = k, U.normals = I, U.indices = V, M && (U.uvs = M), x && (U.uvs2 = x), U.applyToMesh(W), e.material && (W.material = e.material instanceof BABYLON.MultiMaterial ? e.material.subMaterials[o.materialIndex] : e.material);
    }
    return a;
  }
  getNextIncrementalName(e) {
    let t = e;
    if (e) {
      let f;
      for (var n = 0; this._scene.getMeshByName(t); ) {
        if (!f) {
          f = e;
          var a = e.lastIndexOf("_");
          if (a > 0) {
            var o = e.substring(a + 1), h = parseInt(o);
            h.toString() === o && (f = e.substring(0, a));
          }
        }
        n++, t = f + "_" + n;
      }
    }
    return t;
  }
  createBox(e, t) {
    let n = t || "Box";
    n = this.getNextIncrementalName(n);
    let a = BABYLON.Mesh.CreateBox(n, 5, this._scene);
    return a.id = Zakeke.generateUUID(), e && (a.parent = e), a;
  }
  createBoundingBox(e, t) {
    let n = t || "BoundingBox";
    n = this.getNextIncrementalName(n);
    const a = e ? e.getHierarchyBoundingVectors() : this.getWorldExtends();
    if (!a)
      return this.createBox(e, t);
    const o = a.min, h = a.max, f = new BABYLON.BoundingInfo(o, h), v = h.subtract(o);
    if (!isFinite(v.length()))
      return this.createBox(e, t);
    const x = h.x - o.x, k = h.y - o.y, I = h.z - o.z, V = BABYLON.VertexData.CreateBox({ width: x, height: k, depth: I }), M = new BABYLON.Mesh(n, this._scene);
    return V.applyToMesh(M), M.position.copyFrom(f.boundingBox.centerWorld), M.refreshBoundingInfo(), e && e.parent && (M.parent = e.parent), M;
  }
  createSphere(e, t) {
    let n = t || "Sphere";
    n = this.getNextIncrementalName(n);
    const a = BABYLON.Mesh.CreateSphere(n, 30, 5, this._scene);
    return a.id = Zakeke.generateUUID(), e && (a.parent = e), a;
  }
  createPlane(e, t) {
    let n = t || "Plane";
    n = this.getNextIncrementalName(n);
    const a = BABYLON.Mesh.CreatePlane(n, 10, this._scene);
    return a.id = Zakeke.generateUUID(), e && (a.parent = e), a;
  }
  createDisc(e, t) {
    let n = t || "Disc";
    n = this.getNextIncrementalName(n);
    const a = BABYLON.MeshBuilder.CreateDisc(n, { tessellation: 70 }, this._scene);
    return a.id = Zakeke.generateUUID(), e && (a.parent = e), a;
  }
  createCylinder(e, t) {
    let n = t || "Cylinder";
    n = this.getNextIncrementalName(n);
    const a = BABYLON.Mesh.CreateCylinder(n, 6, 6, 6, 30, 1, this._scene, !1);
    return a.id = Zakeke.generateUUID(), e && (a.parent = e), a;
  }
  createTorus(e, t) {
    let n = t || "Torus";
    n = this.getNextIncrementalName(n);
    const a = BABYLON.Mesh.CreateTorus(n, 8, 1, 50, this._scene, !1);
    return a.id = Zakeke.generateUUID(), e && (a.parent = e), a;
  }
  createKnot(e, t) {
    let n = t || "Knot";
    n = this.getNextIncrementalName(n);
    const a = BABYLON.Mesh.CreateTorusKnot(n, 2, 0.5, 128, 64, 2, 3, this._scene);
    return a.id = Zakeke.generateUUID(), e && (a.parent = e), a;
  }
  createRibbon(e, t) {
    let n = t || "Ribbon";
    n = this.getNextIncrementalName(n);
    const a = function(v) {
      for (var x = [], k = -10; k < 10; k++)
        x.push(new BABYLON.Vector3(v, k, Math.sin(v / 3) * 5 * Math.exp(-(k - v) * (k - v) / 60) + k / 3));
      return x;
    };
    for (var o = [], h = 0; h < 20; h++)
      o[h] = a(h);
    const f = BABYLON.Mesh.CreateRibbon("ribbon", o, !1, !1, 0, this._scene);
    return f.id = Zakeke.generateUUID(), e && (f.parent = e), f;
  }
  async createRoundedCubeAsync(e, t, n) {
    const a = ci.Shapes.RoundedCubeName, o = ci.Shapes.RootUrl, h = ci.Shapes.RoundedCubeFileName;
    let f = t || "Rounded Cube";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(a, o, h, e, f, n);
  }
  async createRoundedCylinderAsync(e, t, n) {
    const a = ci.Shapes.RoundedCylinderName, o = ci.Shapes.RootUrl, h = ci.Shapes.RoundedCylinderFileName;
    let f = t || "Rounded Cylinder";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(a, o, h, e, f, n);
  }
  async createMatBallAsync(e, t, n) {
    const a = ci.Shapes.MatBallName, o = ci.Shapes.RootUrl, h = ci.Shapes.MatBallFileName;
    let f = t || "Mat Ball";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(a, o, h, e, f, n);
  }
  async createMaleHeadAsync(e, t, n) {
    const a = ci.Shapes.MaleHeadName, o = ci.Shapes.RootUrl, h = ci.Shapes.MaleHeadFileName;
    let f = t || "Male Head";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(a, o, h, e, f, n);
  }
  async createFemaleHeadAsync(e, t, n) {
    const a = ci.Shapes.FemaleHeadName, o = ci.Shapes.RootUrl, h = ci.Shapes.FemaleHeadFileName;
    let f = t || "Female Head";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(a, o, h, e, f, n);
  }
  async createPokemonBallAsync(e, t, n) {
    const a = ci.Shapes.PokemonBallName, o = ci.Shapes.RootUrl, h = ci.Shapes.PokemonBallFileName;
    let f = t || "Pokemon Ball";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(a, o, h, e, f, n);
  }
  async createShaderBallAsync(e, t, n) {
    const a = ci.Shapes.ShaderBallName, o = ci.Shapes.RootUrl, h = ci.Shapes.ShaderBallFileName;
    let f = t || "Shader Ball";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(a, o, h, e, f, n);
  }
  async createBootsAsync(e, t, n) {
    const a = ci.Shapes.BootsName, o = ci.Shapes.RootUrl, h = ci.Shapes.BootsFolder, f = ci.Shapes.BootsFileName;
    let v = t || "Boots";
    return v = this.getNextIncrementalName(v), await this.importPrimitiveShapeAsync(a, o + h, f, e, v, n);
  }
  async createSuzanneAsync(e, t, n) {
    const a = ci.Shapes.SuzanneName, o = ci.Shapes.RootUrl, h = ci.Shapes.SuzanneFileName;
    let f = t || "Suzanne";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(a, o, h, e, f, n);
  }
  async createStepPyramidAsync(e, t, n) {
    const a = ci.Shapes.StepPyramidName, o = ci.Shapes.RootUrl, h = ci.Shapes.StepPyramidFileName;
    let f = t || "Step Pyramid";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(a, o, h, e, f, n);
  }
  async createTeapotAsync(e, t, n) {
    const a = ci.Shapes.TeapotName, o = ci.Shapes.RootUrl, h = ci.Shapes.TeapotFileName;
    let f = t || "Teapot";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(a, o, h, e, f, n);
  }
  async createAlloyWheelAsync(e, t, n) {
    const a = ci.Shapes.AlloyWheelName, o = ci.Shapes.RootUrl, h = ci.Shapes.AlloyWheelFolder, f = ci.Shapes.AlloyWheelFileName;
    let v = t || "Wheel";
    return v = this.getNextIncrementalName(v), await this.importPrimitiveShapeAsync(a, o + h, f, e, v, n);
  }
  async createTryonReferenceGlassesFrameAsync(e, t, n) {
    const a = ci.TryonReferences.ReferenceGlassesFrameName, o = ci.TryonReferences.RootUrl, h = ci.TryonReferences.ReferenceGlassesFrameFileName;
    let f = t || "Reference Glasses Frame";
    return f = this.getNextIncrementalName(f), await this.importPrimitiveShapeAsync(a, o, h, e, f, n);
  }
  async createTryOnReferenceModelsAsync(e, t, n, a) {
    return await this.importPrimitiveShapeAsync(
      "",
      ci.TryonReferences.RootUrl,
      n,
      e,
      t,
      a,
      !0
    );
  }
  async importPrimitiveShapeAsync(e, t, n, a, o, h, f = !1) {
    let v = [], x = await BABYLON.SceneLoader.ImportMeshAsync(e, t, n, this._scene, h);
    if (x && x.meshes) {
      v = x.meshes;
      for (let k = 0; k < v.length; k++) {
        let I = v[k];
        if (I.name === "__root__") {
          let V = I.getChildMeshes();
          for (let M = 0; M < V.length; M++) {
            let W = V[M];
            W.parent = null;
          }
          I.dispose(), v.splice(k--, 1);
          continue;
        }
        I.id = Zakeke.generateUUID(), a && (I.parent = a);
      }
    }
    return v;
  }
  setTryOnReferenceVisible(e) {
    const { tryonReferencesModels: t } = this.getVTOMeshes();
    t.forEach((n) => {
      n.isVisible = e;
    });
  }
  setTryOnReferenceEnabled(e) {
    const { tryonReferencesModels: t } = this.getVTOMeshes();
    t.forEach((n) => {
      n.setEnabled(e);
    });
  }
  isTryOnReferenceVisible() {
    const { tryonReferencesModels: e } = this.getVTOMeshes();
    return e.length > 0 && e[0].isVisible;
  }
  transformEntireScene(e, t, n, a) {
    var h;
    const o = (h = this._scene) == null ? void 0 : h.meshes;
    o == null || o.forEach((f) => {
      f.parent == null && f.setParent(a);
    }), e && (a.position = new BABYLON.Vector3(e.x, e.y, e.z)), t && (a.rotation = new BABYLON.Vector3(t.x, t.y, t.z)), n && (a.scaling = new BABYLON.Vector3(n.x, n.y, n.z)), o == null || o.forEach((f) => {
      f.parent == a && f.setParent(null);
    });
  }
  scaleSceneToTryonReferenceModels(e) {
    this.setSceneScalePercentageForVTO(100, e), this.setScenePositionPercentageForVTO(0, 0, 0, e);
  }
  getSceneScalingPercentageForVTO() {
    const { userMeshes: e, tryonReferencesModels: t } = this.getVTOMeshes();
    if (t.length === 0 || e.length === 0)
      return 100;
    const n = this._scene.getWorldExtends((M) => t.includes(M)), a = this._scene.getWorldExtends((M) => e.includes(M)), o = n.max.x - n.min.x, h = n.max.y - n.min.y, f = n.max.z - n.min.z, v = a.max.x - a.min.x, x = a.max.y - a.min.y, k = a.max.z - a.min.z;
    return 1 / Math.min(
      o / v,
      h / x,
      f / k
    ) * 100;
  }
  setSceneScalePercentageForVTO(e, t) {
    const { userMeshes: n, tryonReferencesModels: a } = this.getVTOMeshes();
    if (a.length === 0 || n.length === 0)
      return;
    const o = this._scene.getWorldExtends((D) => a.includes(D)), h = this._scene.getWorldExtends((D) => n.includes(D)), f = o.max.x - o.min.x, v = o.max.y - o.min.y, x = o.max.z - o.min.z, k = h.max.x - h.min.x, I = h.max.y - h.min.y, V = h.max.z - h.min.z, M = Math.min(
      f / k,
      v / I,
      x / V
    ), { x: W, y: U, z: Q } = this.getScenePositionPercentageForVTO();
    n.filter((D) => !D.parent).forEach((D) => {
      D.scaling.scaleInPlace(M), D.scaling.scaleInPlace(e / 100), t === "shoes" && D.scaling.scaleInPlace(1.3);
    }), this.setScenePositionPercentageForVTO(W, U, Q);
  }
  getScenePositionPercentageForVTO() {
    const { userMeshes: e, tryonReferencesModels: t } = this.getVTOMeshes();
    if (t.length === 0 || e.length === 0)
      return { x: 0, y: 0, z: 0 };
    const n = this._scene.getWorldExtends((v) => t.includes(v)), a = this._scene.getWorldExtends((v) => e.includes(v)), o = n.max.add(n.min).scale(0.5), f = a.max.add(a.min).scale(0.5).subtract(o);
    return {
      x: f.x / (n.max.x - n.min.x) * 100,
      y: f.y / (n.max.y - n.min.y) * 100,
      z: f.z / (n.max.z - n.min.z) * 100
    };
  }
  setScenePositionPercentageForVTO(e, t, n, a) {
    const { userMeshes: o, tryonReferencesModels: h } = this.getVTOMeshes();
    if (h.length === 0 || o.length === 0)
      return;
    const f = this._scene.getWorldExtends((M) => h.includes(M)), v = this._scene.getWorldExtends((M) => o.includes(M)), x = f.max.add(f.min).scale(0.5), k = v.max.add(v.min).scale(0.5), I = x.subtract(k), V = new BABYLON.Vector3(
      e / 100 * (f.max.x - f.min.x),
      t / 100 * (f.max.y - f.min.y),
      n / 100 * (f.max.z - f.min.z)
    );
    o.filter((M) => !M.parent).forEach((M) => {
      M.position.addInPlace(I), M.position.addInPlace(V), a === "shoes" && (console.log("shoes down and scale up to 0.3"), M.position.y = 0);
    });
  }
  getSceneRotationForVTO() {
    var h;
    const { userMeshes: e, tryonReferencesModels: t } = this.getVTOMeshes();
    if (t.length === 0 || e.length === 0)
      return { x: 0, y: 0, z: 0 };
    const n = e.filter((f) => !f.parent)[0], a = ((h = n.rotationQuaternion) == null ? void 0 : h.toEulerAngles()) ?? n.rotation, o = {
      x: a.x / Math.PI * 180,
      y: a.y / Math.PI * 180,
      z: a.z / Math.PI * 180
    };
    return o.x = o.x < 0 ? 360 + o.x : o.x, o.y = o.y < 0 ? 360 + o.y : o.y, o.z = o.z < 0 ? 360 + o.z : o.z, o;
  }
  setSceneRotationForVTO(e, t, n) {
    const { userMeshes: a, tryonReferencesModels: o } = this.getVTOMeshes();
    if (o.length === 0 || a.length === 0)
      return;
    const h = new BABYLON.Vector3(e / 180 * Math.PI, t / 180 * Math.PI, n / 180 * Math.PI);
    a.filter((f) => !f.parent).forEach((f) => {
      f.rotation = h;
    });
  }
  setVTOReferenceVisible(e) {
    const { tryonReferencesModels: t } = this.getVTOMeshes();
    t.forEach((n) => {
      n.isVisible = e;
    });
  }
  replaceTransformNodeWithMesh(e) {
    let t = null;
    if (this._scene) {
      const n = e.parent, a = e.getChildren();
      t = new BABYLON.Mesh(e.name, this._scene, n), t.id = Zakeke.generateUUID(), t.scaling = e.scaling.clone(), t.position = e.position.clone(), t.rotation = e.rotation.clone(), e.rotationQuaternion && (t.rotationQuaternion = e.rotationQuaternion.clone()), a.forEach((o) => o.parent = t), e.dispose(), e.animations.forEach((o) => {
        t.animations.push(o.clone());
      }), this._scene.animationGroups.forEach((o) => {
        o.targetedAnimations.forEach((h) => {
          h.target === e && (h.target = t);
        });
      }), this._scene.skeletons.forEach((o) => {
        o.bones.forEach((h) => {
          h.getTransformNode() === e && h.linkTransformNode(t);
        });
      });
    }
    return t;
  }
  // import 3d model from a remote url
  async importMeshesFromUrlAsync(e, t, n, a, o, h) {
    let f;
    BABYLON.GLTFFileLoader.IncrementalLoading = !1, BABYLON.SceneLoader.OnPluginActivatedObservable.add((W) => {
      f = W.name;
    });
    let v = [];
    const x = await BABYLON.SceneLoader.ImportMeshAsync(
      "",
      e,
      void 0,
      this._scene,
      n,
      o
    );
    x && (x.meshes.forEach((W) => {
      W.id = Zakeke.generateUUID(), v.push(W), this.getMeshMaterials(W).forEach((Q) => Q.id = Zakeke.generateUUID());
    }), x.transformNodes.forEach((W) => {
      W.id = Zakeke.generateUUID();
      const U = this.replaceTransformNodeWithMesh(W);
      U && v.push(U);
    }), x.geometries.forEach((W) => W.id = Zakeke.generateUUID()));
    let k = BABYLON.Tools.GetFilename(e), I = k, V = k.lastIndexOf(".");
    V !== -1 && (I = k.substr(0, V));
    const M = v.filter((W) => !W.parent);
    if (M.length > 1 || M.length === 1 && M[0].name !== "__root__") {
      const W = new BABYLON.Mesh(I, this._scene);
      W.id = Zakeke.generateUUID(), W.metadata = {
        isRealMesh: !0,
        isGroup: !0
      }, v.push(W), M.forEach((U) => {
        U.setParent(W);
      }), f === "obj" && (W.scaling = new BABYLON.Vector3(-W.scaling.x, W.scaling.y, W.scaling.z), W.rotation = new BABYLON.Vector3(0, Math.PI, 0));
    } else if (M.length === 1) {
      const W = M[0];
      if (W.name === "__root__") {
        let Q = BABYLON.Tools.GetFilename(e), D = k.lastIndexOf(".");
        D !== -1 && (Q = k.substring(0, D)), W.name = Q, f === "obj" && (W.scaling = new BABYLON.Vector3(-W.scaling.x, W.scaling.y, -W.scaling.z), W.rotation = new BABYLON.Vector3(0, Math.PI, 0));
      }
      if (["gltf", "glb", "obj"].includes(f)) {
        W.name += "_transforms", W.metadata = {
          isGltfTransformNode: !0
        };
        const Q = new BABYLON.Mesh(I, this._scene);
        Q.id = Zakeke.generateUUID(), Q.metadata = {
          isRealMesh: !0,
          isGroup: !0
        }, v.push(Q), W.parent = Q;
      }
    }
    if (!h && f === "gltf" || f === "glb") {
      const W = [];
      v.forEach((U) => {
        if (U instanceof BABYLON.Mesh) {
          const D = BABYLON.VertexData.ExtractFromMesh(U), ee = ["uvs", "uvs2", "uvs3", "uvs4", "uvs5", "uvs6"];
          for (const J of ee)
            if (D && D[J] && D[J].length > 0)
              for (let he = 0; he < D[J].length; he += 2)
                D[J][he + 1] = 1 - D[J][he + 1];
          D.applyToMesh(U);
        }
        this.getMeshMaterials(U).forEach((D) => {
          W.includes(D) || W.push(D);
        });
      }), W.forEach((U) => {
        U.getActiveTextures().forEach((Q) => {
          Q instanceof BABYLON.Texture && (Q.vScale *= -1);
        });
      });
    }
    return this.adjustCamera(f, !1, !1, a, !0), this.setupShaderMaterialsCameraPosition(), v;
  }
  setupShaderMaterialsCameraPosition() {
    if (this._scene)
      for (let t = 0; t < this._scene.materials.length; t++) {
        var e = this._scene.materials[t];
        this.setupShaderMaterialCameraPosition(e);
      }
  }
  setupShaderMaterialCameraPosition(e) {
    if (this._scene && e && e instanceof BABYLON.ShaderMaterial) {
      const t = this._scene.activeCamera;
      t && e.setVector3("cameraPosition", t.position);
    }
  }
  getSceneCmScalingFactor(e = null, t = null) {
    let n = null;
    if (this._scene) {
      let o = null;
      for (let h = 0; h < this._scene.meshes.length; h++) {
        var a = this._scene.meshes[h];
        if (a.metadata && a.metadata.sizecm) {
          o = a;
          break;
        }
      }
      if (e && t && (o = t), o) {
        const h = o.getHierarchyBoundingVectors(), f = h.min, v = h.max, x = v.subtract(f);
        if (isFinite(x.length())) {
          const k = v.x - f.x, I = v.y - f.y, V = v.z - f.z, M = e || o.metadata.sizecm;
          return M.width !== void 0 && typeof M.width == "number" && !isNaN(M.width) && k !== 0 ? n = M.width / k : M.height !== void 0 && typeof M.height == "number" && !isNaN(M.height) && I !== 0 ? n = M.height / I : M.depth !== void 0 && typeof M.depth == "number" && !isNaN(M.depth) && V !== 0 && (n = M.depth / V), n;
        }
      }
    }
    return n;
  }
  async exportSceneToUsdzAsync(e, t, n, a, o = null, h = null, f = !0) {
    const v = this.getMeshesForAR();
    let x = e || "scene";
    return x = x.replace(/[^a-z0-9]/gi, "_").toLowerCase(), await this.exportMeshesToARAsync(
      x,
      t,
      v,
      n,
      a,
      "usdz",
      o,
      h,
      f
    );
  }
  async exportMeshToUsdzAsync(e, t, n = null, a = null, o = !0) {
    const h = this.getMeshHierarchy(t.id);
    let f = t.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
    return await this.exportMeshesToARAsync(
      f,
      e,
      h,
      void 0,
      void 0,
      "usdz",
      n,
      a,
      o
    );
  }
  async exportSceneToRemoteGlTFAsync(e, t, n, a, o = null, h = null, f = !0) {
    const v = this.getMeshesForAR();
    let x = e || "scene";
    return x = x.replace(/[^a-z0-9]/gi, "_").toLowerCase(), await this.exportMeshesToARAsync(
      x,
      t,
      v,
      n,
      a,
      "glTF",
      o,
      h,
      f
    );
  }
  async exportMeshToRemoteGlTFAsync(e, t, n = null, a = null, o = !0) {
    const h = this.getMeshHierarchy(t.id);
    let f = t.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
    return await this.exportMeshesToARAsync(
      f,
      e,
      h,
      void 0,
      void 0,
      "glTF",
      n,
      a,
      o
    );
  }
  async exportSceneToRemoteGLBAsync(e, t, n, a, o = null, h = null, f = !0) {
    const v = this.getMeshesForAR();
    let x = e || "scene";
    return x = x.replace(/[^a-z0-9]/gi, "_").toLowerCase(), await this.exportMeshesToARAsync(
      x,
      t,
      v,
      n,
      a,
      "glb",
      o,
      h,
      f
    );
  }
  async exportMeshToRemoteGLBAsync(e, t, n = null, a = null, o = !0) {
    const h = this.getMeshHierarchy(t.id);
    let f = t.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
    return await this.exportMeshesToARAsync(
      f,
      e,
      h,
      void 0,
      void 0,
      "glb",
      n,
      a,
      o
    );
  }
  async exportSceneToARMultiformatAsync(e, t, n = ["usdz", "glb", "png"], a, o, h = null, f = null, v = !0) {
    const x = this.getMeshesForAR();
    let k = e || "scene";
    return k = k.replace(/[^a-z0-9]/gi, "_").toLowerCase(), await this.exportMeshesToARMultiformatAsync(
      k,
      t,
      x,
      n,
      h,
      f,
      v,
      a,
      o
    );
  }
  async exportMeshToARMultiformatAsync(e, t, n = ["usdz", "glb", "png"], a = null, o = null, h = !0, f, v) {
    const x = this.getMeshHierarchy(t.id);
    let k = t.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
    return await this.exportMeshesToARMultiformatAsync(
      k,
      e,
      x,
      n,
      a,
      o,
      h,
      f,
      v
    );
  }
  convertGltfTransformNodes(e) {
    const t = [];
    return e.filter((n) => n.metadata && n.metadata.isGltfTransformNode).forEach((n) => {
      const a = new BABYLON.TransformNode(n.name + "-transform-node", this._scene);
      a.scaling.z = -1;
      const o = new BABYLON.Quaternion();
      o.set(0, 1, 0, 0), a.rotationQuaternion = o, t.push([n, n.parent, a]), n.setParent(a);
    }), t;
  }
  restoreGltfTransformNodes(e) {
    e.forEach(([t, n, a]) => {
      t.setParent(n), a.dispose();
    });
  }
  async getGltfBlobForARExport(e, t, n) {
    var v;
    const a = this.convertGltfTransformNodes(n);
    (v = this._scene) == null || v.render();
    const o = {
      meshes: n,
      materials: this.getMeshesMaterials(n),
      transformNodes: this._scene.transformNodes,
      lights: void 0,
      exportTextureUrls: t != null,
      rootUrl: t,
      shouldExportNode: (x) => {
        for (let k = 0; k < n.length; k++)
          if (n[k] === x)
            return !0;
        return !1;
      }
    }, h = await BABYLON.GLTF2Export.GLTFAsync(this._scene, e, o);
    if (h) {
      const x = new Df(), k = h.serverImages && h.glTFFiles.hasOwnProperty("TextureUrls.txt") ? h.serverImages : [];
      for (var f in h.glTFFiles)
        if (k.indexOf(f) === -1) {
          let V = h.glTFFiles[f];
          xs.EndsWith(f, ".gltf") || xs.EndsWith(f, ".bin") ? x.file(f, V, {
            compression: "DEFLATE",
            compressionOptions: {
              level: 9
              // force a compression and a compression level for this file
            }
          }) : x.file(f, V, {
            compression: "STORE"
            // no compression
          });
        }
      this.restoreGltfTransformNodes(a), this._scene.render();
      let I = await x.generateAsync({ type: "blob" });
      if (I)
        return I = I, I.lastModifiedDate = /* @__PURE__ */ new Date(), I.name = "arobj.zip", I;
    }
    return null;
  }
  async exportMeshToGLBBlob(e, t) {
    const n = this.getTryOnMeshHierarchy(t), a = this.convertGltfTransformNodes(n), o = {
      meshes: n,
      materials: this.getMeshesMaterials(n),
      transformNodes: void 0,
      lights: void 0,
      exportTextureUrls: e != null,
      rootUrl: e,
      shouldExportNode: (v) => {
        for (let x = 0; x < n.length; x++)
          if (n[x] === v)
            return !0;
        return !1;
      }
    }, h = await BABYLON.GLTF2Export.GLBAsync(this._scene, "model", o).catch((v) => (console.error(v), null));
    let f = null;
    if (h && h.glTFFiles) {
      for (let v in h.glTFFiles)
        if (xs.EndsWith(v, ".glb")) {
          const x = new pf(), k = await h.glTFFiles[v].arrayBuffer(), I = x.readBinary(k);
          I.getRoot().listNodes().filter((W) => W.getParent() === null || W.getParent() instanceof io).forEach((W) => {
          });
          const M = x.writeBinary(I);
          f = new Blob([M], { type: "model/gltf-binary" });
        }
    }
    return this.restoreGltfTransformNodes(a), f;
  }
  async exportMeshesToARAsync(e, t, n, a, o, h = "usdz", f = null, v = null, x = !0) {
    let k = "";
    if (console.log("sono in exportMeshesToARAsync ==> window token ", window.token), a && o && Zakeke.config) {
      const I = Zakeke.config.baseApiUrl + "artasks/cachedresults/" + a + "/" + o + "/" + h;
      try {
        k = await jQuery.ajax({
          url: I,
          cache: !1,
          contentType: !1,
          processData: !1,
          type: "GET"
        });
      } catch {
        k = "";
      }
    }
    if (!k) {
      console.log("sono in !cachedArFile  ==> window token ", window.token);
      const I = this.getAuthToken();
      if (!I)
        return console.error("No authentication token available"), "";
      let V = this.getSceneCmScalingFactor(f, v);
      const M = await this.getGltfBlobForARExport(e, t, n);
      if (M) {
        const W = {
          flipTextures: !0,
          formats: [h]
        };
        a && (W.sceneID = a), o && (W.sceneCode = o), V && (W.scale = V);
        let U = !0;
        window.isOwin != null && (U = window.isOwin);
        const D = await new Rf("artasks", I, U).upload(M, W);
        D && D.length > 0 && (k = D[0].arFileUrl);
      }
    }
    return k;
  }
  async exportMeshesToARMultiformatAsync(e, t, n, a = ["usdz", "glb", "png"], o = null, h = null, f = !0, v, x) {
    let k = [], I = [];
    if (v && x && Zakeke.config)
      for (let V = 0; V < a.length; V++) {
        const M = a[V], W = Zakeke.config.baseApiUrl + "artasks/cachedresults/" + v + "/" + x + "/" + M;
        try {
          const U = await jQuery.ajax({
            url: W,
            cache: !1,
            contentType: !1,
            processData: !1,
            type: "GET"
          });
          U && I.push({ format: M, arFileUrl: U });
        } catch {
        }
        k = I;
      }
    if (I.length !== a.length) {
      const V = this.getAuthToken();
      if (console.log(
        "sono in cachedArFiles.length !== formats.length  ==> provo a recuperare il token con getAuthToken ",
        V
      ), !V)
        return console.error("No authentication token available"), k;
      const M = this.getSceneCmScalingFactor(o, h), W = I.map((D) => D.format), U = a.filter((D) => !W.includes(D)), Q = await this.getGltfBlobForARExport(e, t, n);
      if (Q) {
        const D = {
          flipTextures: !0,
          formats: U
          // Escludo i formati cachati
        };
        v && (D.sceneID = v), x && (D.sceneCode = x), M && (D.scale = M);
        let ee = !0;
        window.isOwin !== void 0 && (ee = window.isOwin);
        const he = await new Rf("artasks", V, ee).upload(Q, D);
        if (he && he.length > 0)
          for (const fe of he)
            fe && fe.arFileUrl && k.push({ format: fe.format, arFileUrl: fe.arFileUrl });
      }
    }
    return k;
  }
  // Metodi per esportazione on-the-fly client side
  async exportSceneToLocalGlTFBlobsAsync() {
    const e = Zakeke.generateUUID(), t = this.getSceneToGltfExportOptions(), n = await BABYLON.GLTF2Export.GLTFAsync(this._scene, e, t);
    let a = [];
    for (let o in n.glTFFiles)
      a.push(n.glTFFiles[o]);
    return a;
  }
  async exportSceneToLocalGlTFUrlsAsync() {
    const e = [], t = Zakeke.generateUUID(), n = this.getSceneToGltfExportOptions(), a = await BABYLON.GLTF2Export.GLTFAsync(this._scene, t, n);
    if (a)
      for (let h in a.glTFFiles) {
        var o = a.glTFFiles[h];
        e.push(this.getGltfFileUrl(h, o));
      }
    return e;
  }
  async downloadSceneLocalGltfAsync() {
    const e = Zakeke.generateUUID(), t = this.getSceneToGltfExportOptions(), n = await BABYLON.GLTF2Export.GLTFAsync(this._scene, e, t);
    n && n.downloadFiles();
  }
  async exportSceneToLocalGLBBlobAsync() {
    const e = await this.getSceneLocalGLBBlobInfoAsync();
    return e ? e.blob : null;
  }
  async exportSceneToLocalGLBBase64Async() {
    let e = null;
    const t = await this.getSceneLocalGLBBlobInfoAsync();
    if (t && t.blob instanceof Blob) {
      let n = new FileReader();
      n.readAsDataURL(t.blob), n.onloadend = () => {
        let a = n.result;
        typeof a == "string" && (e = a);
      };
    }
    return e;
  }
  async exportSceneToLocalGLBUrlAsync() {
    let e = null;
    const t = await this.getSceneLocalGLBBlobInfoAsync();
    return t && t.name && t.blob instanceof Blob && (e = this.getGltfFileUrl(t.name, t.blob)), e;
  }
  async downloadSceneLocalGLBAsync() {
    var n;
    (n = this._scene) == null || n.meshes.forEach((a) => {
      a.isVisible = !0;
    });
    const e = await this.getSceneLocalGLBBlobInfoAsync();
    if (e && e.name && e.blob instanceof Blob) {
      let a = this.getGltfFileUrl(e.name, e.blob);
      var t = document.createElement("a");
      document.body.appendChild(t), t.setAttribute("type", "hidden"), t.download = e.name, t.href = a, t.click(), document.body.removeChild(t), URL.revokeObjectURL(a);
    }
  }
  async getSceneLocalGLBBlobInfoAsync(e = null, t = null) {
    let n = {
      name: null,
      blob: null
    };
    const a = Zakeke.generateUUID(), o = this.getSceneToGltfExportOptions();
    let h = await BABYLON.GLTF2Export.GLBAsync(this._scene, a, o).catch((f) => (console.error(f), null));
    if (h && h.glTFFiles) {
      for (let f in h.glTFFiles)
        if (xs.EndsWith(f, ".glb")) {
          let v = this.getSceneCmScalingFactor(), x = 1;
          v && (x = v / 100);
          const k = BABYLON.Quaternion.RotationAxis(BABYLON.Axis.Y, 2 * Math.PI), I = new pf(), V = await h.glTFFiles[f].arrayBuffer(), M = I.readBinary(V), W = M.getRoot().listNodes().filter((J) => J.getParent() === null || J.getParent() instanceof io), U = [0, 1, 0, 0], Q = W.every((J) => {
            const he = J.getRotation();
            return U.length === he.length && U.every((fe, X) => fe === he[X]);
          });
          W.forEach((J) => {
            J.setScale([x, x, x]), Q && J.setRotation([k.x, k.y, k.z, k.w]);
          });
          const D = I.writeBinary(M), ee = new Blob([D], { type: "model/gltf-binary" });
          n.name = f, n.blob = ee;
          break;
        }
    }
    return n;
  }
  // -----------------------------------------------------------------------
  // Metodi per exportazione della scena in USDZ su client (on-the-fly)
  async exportSceneToLocalUSDZBlobAsync() {
    const e = await this.getSceneLocalUSDZBlobInfoAsync();
    return e ? e.blob : null;
  }
  async exportSceneToLocalUSDZBase64Async() {
    let e = null;
    const t = await this.getSceneLocalUSDZBlobInfoAsync();
    if (t && t.blob instanceof Blob) {
      let n = new FileReader();
      n.readAsDataURL(t.blob), n.onloadend = () => {
        let a = n.result;
        typeof a == "string" && (e = a);
      };
    }
    return e;
  }
  async exportSceneToLocalUSDZUrlAsync() {
    let e = null;
    const t = await this.getSceneLocalUSDZBlobInfoAsync();
    return t && t.name && t.blob instanceof Blob && (e = this.getUsdzFileUrl(t.name, t.blob)), e;
  }
  async downloadSceneLocalUSDZAsync() {
    const e = await this.getSceneLocalUSDZBlobInfoAsync();
    if (e && e.name && e.blob instanceof Blob) {
      let n = this.getUsdzFileUrl(e.name, e.blob);
      var t = document.createElement("a");
      document.body.appendChild(t), t.setAttribute("type", "hidden"), t.download = e.name, t.href = n, t.click(), document.body.removeChild(t), URL.revokeObjectURL(n);
    }
  }
  async getSceneLocalUSDZBlobInfoAsync() {
    let e = {
      name: null,
      blob: null
    };
    const t = await this.getSceneLocalGLBBlobInfoAsync();
    if (t && t.name && t.blob && t.blob instanceof Blob) {
      const n = this.getGltfFileUrl(t.name, t.blob), a = await Tx.convertGlbToUsdz(n);
      e.name = t.name.replace(".glb", ".usdz"), e.blob = a;
    }
    return e;
  }
  // -----------------------------------------------------------------------
  getSceneToGltfExportOptions() {
    var e = this.getMeshesForAR(), t = {
      meshes: e,
      materials: this.getMeshesMaterials(e),
      transformNodes: void 0,
      lights: void 0,
      exportTextureUrls: !1,
      rootUrl: null,
      shouldExportNode: (n) => {
        for (var a = 0; a < e.length; a++)
          if (e[a] === n)
            return !0;
        return !1;
      }
    };
    return t;
  }
  getGltfFileUrl(e, t) {
    var n = void 0;
    return xs.EndsWith(e, ".glb") ? n = { type: "model/gltf-binary" } : xs.EndsWith(e, ".bin") ? n = { type: "application/octet-stream" } : xs.EndsWith(e, ".gltf") ? n = { type: "model/gltf+json" } : xs.EndsWith(e, ".jpeg") ? n = { type: "image/jpeg" } : xs.EndsWith(e, ".png") && (n = { type: "image/png" }), window.URL.createObjectURL(new Blob([t], n));
  }
  getUsdzFileUrl(e, t) {
    var n = { type: "model/vnd.usdz+zip" };
    return window.URL.createObjectURL(new Blob([t], n));
  }
  exportSceneToBabylon() {
    const e = BABYLON.SceneSerializer.Serialize(this._scene);
    return JSON.stringify(e);
  }
  exportVisibleMeshesToBabylon() {
    const e = this.getVisibleMeshes(), t = BABYLON.SceneSerializer.SerializeMesh(e, !1, !1);
    return JSON.stringify(t);
  }
  downloadImageFromBase64(e, t, n) {
    var a = document.createElement("a");
    a.href = e, a.download = t, a.click(), a.remove();
  }
  getStandardMaterialTextureType(e, t) {
    return e.diffuseTexture === t ? "diffuse" : e.emissiveTexture === t ? "emissive" : e.ambientTexture === t ? "ambient" : e.lightmapTexture === t ? "lightmap" : e.opacityTexture === t ? "opacity" : e.specularTexture === t ? "specular" : e.reflectionTexture === t ? "reflection" : e.refractionTexture === t ? "refraction" : e.bumpTexture === t ? "bump" : null;
  }
  getPBRMetallicRoughnessMaterialTextureType(e, t) {
    return e.environmentTexture === t ? "environment" : e.normalTexture === t ? "normal" : e.emissiveTexture === t ? "emissive" : e.occlusionTexture === t ? "occlusion" : e.baseTexture === t ? "base" : e.metallicRoughnessTexture === t ? "metallicRoughness" : null;
  }
  getPBRSpecularGlossinessMaterialTextureType(e, t) {
    return e.environmentTexture === t ? "environment" : e.normalTexture === t ? "normal" : e.emissiveTexture === t ? "emissive" : e.occlusionTexture === t ? "occlusion" : e.diffuseTexture === t ? "diffuse" : e.specularGlossinessTexture === t ? "specularGlossiness" : null;
  }
  getPBRMaterialTextureType(e, t) {
    if (e.cameraColorGradingTexture === t)
      return "cameraColorGrading";
    if (e.albedoTexture === t)
      return "albedo";
    if (e.ambientTexture === t)
      return "ambient";
    if (e.opacityTexture === t)
      return "opacity";
    if (e.reflectionTexture === t)
      return "reflection";
    if (e.emissiveTexture === t)
      return "emissive";
    if (e.reflectivityTexture === t)
      return "reflectivity";
    if (e.metallicTexture === t)
      return "metallic";
    if (e.microSurfaceTexture === t)
      return "microSurface";
    if (e.bumpTexture === t)
      return "bump";
    if (e.lightmapTexture === t)
      return "lightmap";
    if (e.refractionTexture === t)
      return "refraction";
    if (e.clearCoat) {
      if (e.clearCoat.texture === t)
        return "clearCoat";
      if (e.clearCoat.bumpTexture === t)
        return "clearCoat_bump";
      if (e.clearCoat.tintTexture === t)
        return "clearCoat_tint";
      if (e.clearCoat.textureRoughness === t)
        return "clearCoat_textureRoughness";
      if (e.clearCoat.texture === t)
        return "clearCoat_texture";
    }
    if (e.anisotropy && e.anisotropy.texture === t)
      return "anisotropy_texture";
    if (e.sheen) {
      if (e.sheen.texture === t)
        return "sheen_texture";
      if (e.sheen.textureRoughness === t)
        return "sheen_textureRoughness";
    }
    if (e.subSurface) {
      if (e.subSurface.thicknessTexture === t)
        return "subSurface_thickness";
      if (e.subSurface.refractionIntensityTexture === t)
        return "subSurface_refractionIntensity";
      if (e.subSurface.translucencyIntensityTexture === t)
        return "subSurface_translucencyIntensity";
    }
    return null;
  }
  getZakekePBRMaterialTextureType(e, t) {
    return e.albedoTexture === t ? "albedo" : e.bumpTexture === t ? "bump" : e.reflectionTexture === t ? "reflection" : e.matCapReflectionTexture === t ? "matCapReflection" : e.reflectivityTexture === t ? "reflectivity" : e.microsurfaceTexture === t ? "microsurface" : e.ambientTexture === t ? "ambient" : e.aoTexture === t ? "ao" : e.opacityTexture === t ? "opacity" : null;
  }
  getMaterialTextureType(e, t) {
    return e instanceof BABYLON.StandardMaterial ? this.getStandardMaterialTextureType(e, t) : e instanceof BABYLON.PBRMetallicRoughnessMaterial ? this.getPBRMetallicRoughnessMaterialTextureType(e, t) : e instanceof BABYLON.PBRSpecularGlossinessMaterial ? this.getPBRSpecularGlossinessMaterialTextureType(e, t) : e instanceof BABYLON.PBRMaterial ? this.getPBRMaterialTextureType(e, t) : e instanceof Zakeke.PBRMaterial ? this.getZakekePBRMaterialTextureType(e, t) : null;
  }
  getMaterialTexture(e, t) {
    if (e instanceof BABYLON.StandardMaterial)
      switch (t) {
        case "diffuse":
          return e.diffuseTexture;
        case "emissive":
          return e.emissiveTexture;
        case "ambient":
          return e.ambientTexture;
        case "lightmap":
          return e.lightmapTexture;
        case "opacity":
          return e.opacityTexture;
        case "specular":
          return e.specularTexture;
        case "reflection":
          return e.reflectionTexture;
        case "refraction":
          return e.refractionTexture;
        case "bump":
          return e.bumpTexture;
      }
    else if (e instanceof BABYLON.PBRMetallicRoughnessMaterial)
      switch (t) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "base":
        case "metallicRoughness":
          return e[`${t}Texture`];
      }
    else if (e instanceof BABYLON.PBRSpecularGlossinessMaterial)
      switch (t) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "diffuse":
        case "specularGlossiness":
          return e[`${t}Texture`];
      }
    else if (e instanceof BABYLON.PBRMaterial)
      switch (t) {
        case "cameraColorGrading":
          return e.cameraColorGradingTexture;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
          return e[`${t}Texture`];
        case "refraction":
          return e.refractionTexture;
        case "environmentBRDF":
          return e.environmentBRDFTexture;
        case "clearCoat_texture":
          return e.clearCoat.texture;
        case "clearCoat_bump":
          return e.clearCoat.bumpTexture;
        case "clearCoat_tint":
          return e.clearCoat.tintTexture;
        case "clearCoat_textureRoughness":
          return e.clearCoat.textureRoughness;
        case "anisotropy_texture":
          return e.anisotropy.texture;
        case "sheen_texture":
          return e.sheen.texture;
        case "sheen_textureRoughness":
          return e.sheen.textureRoughness;
        case "subSurface_thickness":
          return e.subSurface.thicknessTexture;
        case "subSurface_translucencyIntensity":
          return e.subSurface.translucencyIntensityTexture;
        case "subSurface_refractionIntensity":
          return e.subSurface.refractionIntensityTexture;
      }
    else if (e instanceof Zakeke.PBRMaterial)
      switch (t) {
        case "albedo":
          return e.albedoTexture;
        case "bump":
          return e.bumpTexture;
        case "reflection":
          return e.reflectionTexture;
        case "matCapReflection":
          return e.matCapReflectionTexture;
        case "reflectivity":
          return e.reflectivityTexture;
        case "microsurface":
          return e.microsurfaceTexture;
        case "ambient":
          return e.ambientTexture;
        case "ao":
          return e.aoTexture;
        case "opacity":
          return e.opacityTexture;
      }
    return null;
  }
  applyTexture(e, t, n) {
    if (e && n == "lightmap" && (e.coordinatesIndex = 1, (t instanceof BABYLON.StandardMaterial || t instanceof BABYLON.PBRMaterial || t instanceof BABYLON.PBRBaseSimpleMaterial) && (t.useLightmapAsShadowmap = !0)), t instanceof BABYLON.StandardMaterial)
      switch (n) {
        case "diffuse":
          t.diffuseTexture = e;
          break;
        case "emissive":
          t.emissiveTexture = e;
          break;
        case "ambient":
          t.ambientTexture = e;
          break;
        case "lightmap":
          t.lightmapTexture = e;
          break;
        case "opacity":
          t.opacityTexture = e;
          break;
        case "specular":
          t.specularTexture = e;
          break;
        case "reflection":
          t.reflectionTexture = e;
          break;
        case "refraction":
          t.refractionTexture = e;
          break;
        case "bump":
          t.bumpTexture = e;
          break;
      }
    else if (t instanceof BABYLON.PBRMetallicRoughnessMaterial)
      switch (n) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "base":
        case "metallicRoughness":
          t[`${n}Texture`] = e;
          break;
      }
    else if (t instanceof BABYLON.PBRSpecularGlossinessMaterial)
      switch (n) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "diffuse":
        case "specularGlossiness":
          t[`${n}Texture`] = e;
          break;
      }
    else if (t instanceof BABYLON.PBRMaterial)
      switch (n) {
        case "cameraColorGrading":
          t.cameraColorGradingTexture = e;
          break;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
          t[`${n}Texture`] = e;
          break;
        case "refraction":
          t.refractionTexture = e;
          break;
        case "environmentBRDF":
          t.environmentBRDFTexture = e;
          break;
        case "clearCoat_texture":
          t.clearCoat.texture = e;
          break;
        case "clearCoat_bump":
          t.clearCoat.bumpTexture = e;
          break;
        case "clearCoat_tint":
          t.clearCoat.tintTexture = e;
          break;
        case "clearCoat_textureRoughness":
          t.clearCoat.textureRoughness = e;
          break;
        case "anisotropy_texture":
          t.anisotropy.texture = e;
          break;
        case "sheen_texture":
          t.sheen.texture = e;
          break;
        case "sheen_textureRoughness":
          t.sheen.textureRoughness = e;
          break;
        case "subSurface_thickness":
          t.subSurface.thicknessTexture = e;
          break;
        case "subSurface_translucencyIntensity":
          t.subSurface.translucencyIntensityTexture = e;
          break;
        case "subSurface_refractionIntensity":
          t.subSurface.refractionIntensityTexture = e;
          break;
      }
    else if (t instanceof BABYLON.ShaderMaterial)
      e && e instanceof BABYLON.Texture ? t.setTexture(n, e) : t.removeTexture(n);
    else if (t instanceof Zakeke.PBRMaterial)
      switch (n) {
        case "albedo":
          t.albedoTexture = e;
          break;
        case "bump":
          t.bumpTexture = e;
          break;
        case "reflection":
          t.reflectionTexture = e;
          break;
        case "matCapReflection":
          t.matCapReflectionTexture = e;
          break;
        case "reflectivity":
          t.reflectivityTexture = e;
          break;
        case "microsurface":
          t.microsurfaceTexture = e;
          break;
        case "ambient":
          t.ambientTexture = e;
          break;
        case "ao":
          t.aoTexture = e;
          break;
        case "opacity":
          t.opacityTexture = e;
          break;
      }
  }
  applyTextureOnSerializedMaterial(e, t, n, a) {
    if (e && n == "lightmap" && (e.coordinatesIndex = 1, (a === "BABYLON.StandardMaterial" || a === "BABYLON.PBRMaterial" || a === "BABYLON.PBRBaseSimpleMaterial") && (t.useLightmapAsShadowmap = !0)), a === "BABYLON.StandardMaterial")
      t[`${n}Texture`] = e;
    else if (a === "BABYLON.PBRMetallicRoughnessMaterial")
      t[`${n}Texture`] = e;
    else if (a === "BABYLON.PBRSpecularGlossinessMaterial")
      t[`${n}Texture`] = e;
    else if (a === "BABYLON.PBRMaterial")
      switch (n) {
        case "cameraColorGrading":
          t.cameraColorGradingTexture = e;
          break;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
        case "refraction":
          t[`${n}Texture`] = e;
          break;
        case "environmentBRDF":
          t.environmentBRDFTexture = e;
          break;
        case "clearCoat_texture":
          t.clearCoat.texture = e;
          break;
        case "clearCoat_bump":
          t.clearCoat.bumpTexture = e;
          break;
        case "clearCoat_tint":
          t.clearCoat.tintTexture = e;
          break;
        case "clearCoat_textureRoughness":
          t.clearCoat.textureRoughness = e;
          break;
        case "anisotropy_texture":
          t.anisotropy.texture = e;
          break;
        case "sheen_texture":
          t.sheen.texture = e;
          break;
        case "sheen_textureRoughness":
          t.sheen.textureRoughness = e;
          break;
        case "subSurface_thickness":
          t.subSurface.thicknessTexture = e;
          break;
        case "subSurface_translucencyIntensity":
          t.subSurface.translucencyIntensityTexture = e;
          break;
        case "subSurface_refractionIntensity":
          t.subSurface.refractionIntensityTexture = e;
          break;
      }
    else
      a === "Zakeke.PBRMaterial" && (t[`${n}Texture`] = e);
  }
  getSerializedMaterialTexture(e, t, n) {
    if (n === "BABYLON.StandardMaterial")
      return e[`${t}Texture`];
    if (n === "BABYLON.PBRMetallicRoughnessMaterial")
      return e[`${t}Texture`];
    if (n === "BABYLON.PBRSpecularGlossinessMaterial")
      return e[`${t}Texture`];
    if (n === "BABYLON.PBRMaterial")
      switch (t) {
        case "cameraColorGrading":
          return e.cameraColorGradingTexture;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
        case "refraction":
          return e[`${t}Texture`];
        case "environmentBRDF":
          return e.environmentBRDFTexture;
        case "clearCoat_texture":
          return e.clearCoat.texture;
        case "clearCoat_bump":
          return e.clearCoat.bumpTexture;
        case "clearCoat_tint":
          return e.clearCoat.tintTexture;
        case "clearCoat_textureRoughness":
          return e.clearCoat.textureRoughness;
        case "anisotropy_texture":
          return e.anisotropy.texture;
        case "sheen_texture":
          return e.sheen.texture;
        case "sheen_textureRoughness":
          return e.sheen.textureRoughness;
        case "subSurface_thickness":
          return e.subSurface.thicknessTexture;
        case "subSurface_translucencyIntensity":
          return e.subSurface.translucencyIntensityTexture;
        case "subSurface_refractionIntensity":
          return e.subSurface.refractionIntensityTexture;
      }
    else if (n === "Zakeke.PBRMaterial")
      return e[`${t}Texture`];
    return null;
  }
  getMaterialTypeName(e) {
    return e instanceof BABYLON.StandardMaterial ? "BABYLON.StandardMaterial" : e instanceof BABYLON.PBRMetallicRoughnessMaterial ? "BABYLON.PBRMetallicRoughnessMaterial" : e instanceof BABYLON.PBRSpecularGlossinessMaterial ? "BABYLON.PBRSpecularGlossinessMaterial" : e instanceof BABYLON.PBRMaterial ? "BABYLON.PBRMaterial" : e instanceof BABYLON.ShaderMaterial ? "BABYLON.ShaderMaterial" : e instanceof Zakeke.PBRMaterial ? "Zakeke.PBRMaterial" : "BABYLON.StandardMaterial";
  }
  async exportMeshToBabylon(e) {
    const t = this.getMeshHierarchy(e.id);
    return await this.exportMeshesToBabylon(t);
  }
  async exportMeshesToBabylon(e) {
    const t = this.getMeshesMaterials(e), n = e.map((o) => ({ id: o.id, doNotSerialize: o.doNotSerialize })), a = t.map((o) => ({ id: o.id, doNotSerialize: o.doNotSerialize }));
    e.forEach((o) => o.doNotSerialize = !1), t.forEach((o) => o.doNotSerialize = !1);
    try {
      const o = {};
      for (let v = 0; v < t.length; v++) {
        const x = t[v], k = x.id, I = this.getMaterialDynamicTextures(x);
        if (I.length > 0) {
          o[k] = {
            materialType: this.getMaterialTypeName(x),
            textures: []
          };
          for (let V = 0; V < I.length; V++) {
            const M = I[V], W = Zakeke.generateUUID(), U = this.getMaterialTextureType(x, M), Q = await this.exportTextureToBase64Async(M, "image/png");
            if (U && Q) {
              const D = {
                id: W,
                type: U,
                base64String: Q,
                isProcedural: M instanceof BABYLON.ProceduralTexture
              };
              o[k].textures.push(D);
            }
          }
        }
      }
      const h = BABYLON.SceneSerializer.SerializeMesh(e, !1, !1);
      for (const v of h.materials) {
        const x = Object.getOwnPropertyNames(v).filter(
          (I) => I.slice(-7) === "Texture" && typeof v[I] == "object"
        ), k = v.id;
        if (o.hasOwnProperty(k)) {
          const I = o[k], V = I.materialType, M = I.textures;
          for (const W of M) {
            const U = this.getSerializedMaterialTexture(
              v,
              W.type,
              I.materialType
            );
            if (U) {
              if (W.isProcedural) {
                const Q = new BABYLON.Texture(
                  W.base64String,
                  this._scene,
                  void 0,
                  void 0,
                  void 0,
                  void 0
                );
                await Sn.whenTextureIsReadyAsync(Q), Q.uScale = U.uScale, Q.vScale = U.vScale, Q.uOffset = U.uOffset, Q.vOffset = U.vOffset, Q.uAng = U.uAng, Q.vAng = U.vAng, Q.level = U.level, Q.coordinatesIndex = U.coordinatesIndex, Q.coordinatesMode = U.coordinatesMode, Q.wrapU = U.wrapU, Q.wrapV = U.wrapV;
                const D = Q.serialize();
                D.url = W.base64String, D.name = "prcedural texture", this.applyTextureOnSerializedMaterial(
                  D,
                  v,
                  W.type,
                  V
                ), Q.dispose();
              }
            } else
              U.url = W.base64String, U.name = "dynamic texture";
          }
        }
      }
      let f = JSON.stringify(h);
      return e.forEach((v) => {
        var x;
        return v.doNotSerialize = (x = n.find((k) => k.id === v.id)) == null ? void 0 : x.doNotSerialize;
      }), t.forEach(
        (v) => v.doNotSerialize = a.find((x) => x.id === v.id).doNotSerialize
      ), f;
    } finally {
      e.forEach((o) => {
        var h;
        return o.doNotSerialize = (h = n.find((f) => f.id === o.id)) == null ? void 0 : h.doNotSerialize;
      }), t.forEach(
        (o) => o.doNotSerialize = a.find((h) => h.id === o.id).doNotSerialize
      );
    }
  }
  async exportMeshesForTyOnToBabylon() {
    const e = this.getMeshesForTryOn();
    return await this.exportMeshesToBabylon(e);
  }
  downloadBlob(e) {
    const t = URL.createObjectURL(e), n = document.createElement("a");
    n.download = "mesh.json", n.href = t, n.click(), URL.revokeObjectURL(t);
  }
  async downloadMeshBabylonAsync(e) {
    const t = await this.exportMeshToBabylon(e);
    if (t) {
      const n = new Blob([t], { type: "application/json" });
      this.downloadBlob(n);
    }
  }
  async downloadMeshesBabylonAsync(e) {
    const t = await this.exportMeshesToBabylon(e);
    if (t) {
      const n = new Blob([t], { type: "application/json" });
      this.downloadBlob(n);
    }
  }
  async loadAllDelayedMaterialFromZip(e, t, n) {
    console.log("Loading delayed materials from zip");
    const a = e + `materials_${t}.zip`, h = await (await fetch(a)).blob(), f = new File([h], "materials.zip", { type: "application/zip" }), v = new Df();
    await v.loadAsync(f);
    const x = v.file(/\.json$/) || [], k = [], I = [];
    if (x.length === 0)
      throw console.warn("No material files found in the zip archive."), new Error("No material files found in the zip archive.");
    for (const [V, M] of x.entries()) {
      const W = M.name.match(/material_\d+_(.*)\.json/);
      if (!W)
        continue;
      const U = W[1].replace(/_/g, "-");
      I.push(
        new Promise(async (Q, D) => {
          console.log("Loading material: " + U);
          try {
            const ee = await M.async("string"), J = JSON.parse(ee), he = BABYLON.Material.Parse(J, this._scene, e);
            he ? (he.metadata = he.metadata || {}, he.metadata.fromZip = !0, k.push(he), await (n == null ? void 0 : n(V + 1, x.length)), Q(he)) : D(new Error("Failed to parse material " + U));
          } catch (ee) {
            D(ee);
          }
        })
      );
    }
    return await Promise.all(I), k;
  }
  // In case loadAllDelayedMaterialAsync failed, we can cleanup all temporary materials.
  // They're recognized by the metadata property `fromZip` set to true.
  async cleanupAllTemporaryMaterialsAsync() {
    try {
      const e = this._scene.materials.filter((t) => {
        var n;
        return (n = t.metadata) == null ? void 0 : n.fromZip;
      });
      console.log("Cleaning up temporary materials loaded from zip, found:", e.length), e.forEach((t) => {
        t.dispose(!1, !0);
      });
    } catch (e) {
      console.warn("Error during cleanup of temporary materials:", e);
    }
  }
  async loadAllDelayedMaterialsAsync(e, t) {
    let n = [];
    if (this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials) {
      var a = {};
      for (var o in this._scene.metadata.delayedMaterials)
        a[o] = {
          name: this._scene.metadata.delayedMaterials[o].name,
          file: this._scene.metadata.delayedMaterials[o].file
        };
      n = await this.loadMaterialsAsync(e, a, t);
    }
    return n;
  }
  async loadDelayedMaterialsAsync(e, t) {
    let n = [];
    if (this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials) {
      for (var a = {}, o = 0; o < t.length; o++)
        this._scene.metadata.delayedMaterials.hasOwnProperty(t[o]) && (a[t[o]] = {
          name: this._scene.metadata.delayedMaterials[t[o]].name,
          file: this._scene.metadata.delayedMaterials[t[o]].file
        });
      n = await this.loadMaterialsAsync(e, a);
    }
    return n;
  }
  async loadDelayedMaterialAsync(e, t) {
    if (this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials) {
      var n = {};
      if (this._scene.metadata.delayedMaterials.hasOwnProperty(t)) {
        n[t] = {
          name: this._scene.metadata.delayedMaterials[t].name,
          file: this._scene.metadata.delayedMaterials[t].file
        };
        let a = await this.loadMaterialsAsync(e, n);
        if (a.length > 0)
          return a[0];
      }
    }
    return null;
  }
  async loadMaterialsAsync(e, t, n) {
    const a = [];
    let o = [];
    for (let f in t) {
      const v = this._scene.getMaterialByID(f);
      if (v)
        a.push(v);
      else {
        const x = t[f];
        o.push(this.loadMaterialInternalAsync(f, e, x.file));
      }
    }
    const h = await Promise.all(o);
    for (let f = 0; f < h.length; f++) {
      const v = h[f], x = JSON.parse(v), k = BABYLON.Material.Parse(x, this._scene, e);
      k && (console.debug("Waiting for material ready: " + k.id + " - " + k.name), this._scene.useDelayedTextureLoading || await Sn.whenAllMaterialTexturesAreReady(k), Logger.info("Material ready: " + k.id + " - " + k.name), a.push(k), await (n == null ? void 0 : n(f + 1, h.length)));
    }
    return this.setupShaderMaterialsCameraPosition(), a;
  }
  loadMaterialInternalAsync(e, t, n) {
    if (Logger.info("Loading delayed material: " + e), this._loadingMaterials.hasOwnProperty(e))
      return this._loadingMaterials[e];
    let a = xs.EndsWith(t, "/") ? "" : "/";
    var o = t + a + n;
    let h = new Promise((f, v) => {
      BABYLON.Tools.LoadFile(
        o,
        (x) => {
          Logger.info("Loaded delayed material: " + e), f(x), delete this._loadingMaterials[e];
        },
        void 0,
        void 0,
        !1,
        (x, k) => {
          v(k), delete this._loadingMaterials[e];
        }
      );
    });
    return this._loadingMaterials[e] = h, h;
  }
  showMesh(e) {
    this.showHideMesh(e, !0);
  }
  hideMesh(e) {
    this.showHideMesh(e, !1);
  }
  showHideMesh(e, t) {
    var n = (o, h) => {
      o.isVisible = h;
      var f = o.getChildMeshes(!0);
      f && f.forEach((v) => {
        n(v, h);
      });
    }, a = this._scene.getMeshById(e);
    a && n(a, t);
  }
  changeMaterialColor(e, t, n) {
    for (let a = 0; a < this._scene.meshes.length && this._scene.meshes[a].material !== e; a++)
      ;
    t && e[t] !== void 0 && (e[t] = n);
  }
  applyMaterialByName(e, t) {
    if (this._scene) {
      let n = this._scene.getMaterialByName(e);
      n && this.applyMaterial(n, t);
    }
  }
  applyMaterial(e, t) {
    var n = (a) => {
      if (a.subMeshes && a.subMeshes.length > 0 && a.material && a.material instanceof BABYLON.MultiMaterial)
        for (let h = 0; h < a.subMeshes.length; h++) {
          let f = a.subMeshes[h];
          this.applyMaterialToSubMesh(e, a, f);
        }
      else
        a.material = e;
      var o = a.getChildMeshes(!0);
      o && o.forEach((h) => {
        n(h);
      });
    };
    t && n(t);
  }
  applyMaterialToSubMeshByName(e, t, n) {
    var a = this._scene.getMaterialByName(e);
    a && this.applyMaterialToSubMesh(a, t, n);
  }
  applyMaterialToSubMesh(e, t, n) {
    const a = n.materialIndex, o = t || n.getMesh();
    o.material instanceof BABYLON.MultiMaterial && a >= 0 && a < o.material.subMaterials.length && (o.material.subMaterials[a] = e);
  }
  getSubMeshMaterial(e, t) {
    const n = t.materialIndex, a = e || t.getMesh();
    return a.material instanceof BABYLON.MultiMaterial && n >= 0 && n < a.material.subMaterials.length ? a.material.subMaterials[n] : null;
  }
  async prefetchTexturesFormMeshAsync(e) {
    e.material && await this.prefetchTexturesForMaterialAsync(e.material);
    var t = e.getChildMeshes(!0);
    for (let n = 0; n < t.length; n++) {
      let a = t[n];
      a.material && await this.prefetchTexturesForMaterialAsync(a.material);
    }
  }
  async prefetchTexturesForMaterialAsync(e) {
    if (e) {
      var t = this.getTexturesForMaterial(e);
      for (let n = 0; n < t.length; n++)
        await Sn.whenTextureIsReadyAsync(t[n]);
    }
  }
  checkDelayState(e) {
    e instanceof BABYLON.Mesh && e._checkDelayState();
    var t = e.getChildMeshes(!0);
    t.forEach((n) => this.checkDelayState(n));
  }
  // Crea una nuova mesh data da una minima espansione di quella passata in input
  // in modo che ne costituisca un rivestimento
  createEnvelopeMesh(e) {
    let t = 0.01;
    const n = e.getHierarchyBoundingVectors();
    if (n) {
      const o = n.min, h = n.max;
      t = new BABYLON.BoundingInfo(o, h).boundingSphere.radius * 5e-3;
    }
    const a = this.cloneMesh(e.id, !0, !0);
    return a && a instanceof BABYLON.Mesh && this.expandMesh(a, t), a;
  }
  expandMesh(e, t) {
    const n = new Ax();
    if (e && e instanceof BABYLON.Mesh) {
      n.expandMesh(e, t);
      const a = e.getChildMeshes();
      for (const o of a)
        o instanceof BABYLON.Mesh && n.expandMesh(o, t);
    }
  }
  cloneMesh(e, t = !1, n = !1) {
    let a = null;
    if (this._scene) {
      const o = this._scene.getMeshById(e);
      if (o) {
        const h = this.getNextIncrementalName(o.name);
        if (a = o.clone(h, o.parent), a) {
          a.id = Zakeke.generateUUID(), t && this.duplicateGeometry(o, a, n);
          const f = a.getChildMeshes();
          for (const v of f) {
            const x = this._scene.getMeshById(v.id);
            v.id = Zakeke.generateUUID();
            const k = v.parent ? v.parent.name : null;
            if (k) {
              const I = v.name.indexOf(k + ".") + k.length + 1;
              v.name = v.name.substr(I);
            }
            x && t && this.duplicateGeometry(x, v, n);
          }
        }
      }
    }
    return a;
  }
  duplicateGeometry(e, t, n = !1) {
    if (e instanceof BABYLON.Mesh && t instanceof BABYLON.Mesh) {
      const a = BABYLON.VertexData.ExtractFromMesh(e, !0, !0);
      return new BABYLON.Geometry(
        Zakeke.generateUUID(),
        t.getScene(),
        a,
        n,
        t
      );
    }
    return null;
  }
  // Material metadata
  getSceneMaterialMetadata(e) {
    return this._scene && this._scene.metadata && this._scene.metadata.materialsMetadata && this._scene.metadata.materialsMetadata.hasOwnProperty(e) ? this._scene.metadata.materialsMetadata[e] : null;
  }
  getOrCreateSceneMaterialMetadata(e) {
    let t = this.getSceneMaterialMetadata(e);
    return t || (t = {}, this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.materialsMetadata || (this._scene.metadata.materialsMetadata = {}), this._scene.metadata.materialsMetadata[e] = t), t;
  }
  removeSceneMaterialMetadata(e) {
    this._scene.metadata && this._scene.metadata.materialsMetadata && this._scene.metadata.materialsMetadata.hasOwnProperty(e) && delete this._scene.metadata.materialsMetadata[e];
  }
  offloadAllUnusedMaterials() {
    this.getAllUnusedMaterials().forEach((t) => this.offloadMaterial(t.id));
  }
  // Salva la serializzazione del materiale e lo rimuove dalla scena (eliminando anche le relative texture).
  // Lo scopo è quello di liberare la memoria occupata dalle texture
  offloadMaterial(e) {
    const t = this._scene.getMaterialByID(e);
    t && t.id !== "default material" && this.getMeshesUsingMaterial(e).length === 0 && (Logger.info("Offloading material: " + t.id + " - " + t.name), this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.offloadedMaterials || (this._scene.metadata.offloadedMaterials = {}), this._scene.metadata.offloadedMaterials[e] = this.getOffloadedMaterialInfo(t), Logger.info("Disposing material: " + e), t.dispose(!1, !0));
  }
  getOffloadedMaterialInfo(e) {
    return { name: e.name, data: e.serialize() };
  }
  // Il materiale restituito dalla versione sincrona potrebbe non essere pronto per l'applicazione alla mesh
  loadAllOffloadedMaterials(e) {
    let t = [];
    return this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials && (t = this.loadOffloadedMaterials(e, this._scene.metadata.offloadedMaterials)), t;
  }
  loadOffloadedMaterialsByIDs(e, t) {
    let n = [];
    if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const a = {};
      for (let o = 0; o < t.length; o++)
        this._scene.metadata.offloadedMaterials.hasOwnProperty(t[o]) && (a[t[o]] = {
          name: this._scene.metadata.offloadedMaterials[t[o]].name,
          data: this._scene.metadata.offloadedMaterials[t[o]].data
        });
      n = this.loadOffloadedMaterials(e, a);
    }
    return n;
  }
  loadOffloadedMaterial(e, t) {
    if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const n = {};
      if (this._scene.metadata.offloadedMaterials.hasOwnProperty(t)) {
        n[t] = {
          name: this._scene.metadata.offloadedMaterials[t].name,
          data: this._scene.metadata.offloadedMaterials[t].data
        };
        const a = this.loadOffloadedMaterials(e, n);
        if (a.length > 0)
          return a[0];
      }
    }
    return null;
  }
  loadOffloadedMaterials(e, t) {
    const n = [];
    for (const a in t) {
      const o = t[a], h = this.loadOffloadedMaterialInternal(a, o.name, e, o.data);
      h && n.push(h);
    }
    return n;
  }
  // Il nome viene passato solo ai fini del log
  loadOffloadedMaterialInternal(e, t, n, a) {
    const o = this._scene.getMaterialByID(e);
    if (o)
      return o;
    const h = t ? ` - ${t}` : "";
    return Logger.info("Loading offloaded material: " + e + h), BABYLON.Material.Parse(a, this._scene, n);
  }
  // Nella versione asincrona si aspetta che tutte le texture del materiale caricato siano pronte
  async loadAllOffloadedMaterialsAsync(e) {
    let t = [];
    return this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials && (t = await this.loadOffloadedMaterialsAsync(e, this._scene.metadata.offloadedMaterials)), t;
  }
  async loadOffloadedMaterialsByIDsAsync(e, t) {
    let n = [];
    if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const a = {};
      for (let o = 0; o < t.length; o++)
        this._scene.metadata.offloadedMaterials.hasOwnProperty(t[o]) && (a[t[o]] = {
          name: this._scene.metadata.offloadedMaterials[t[o]].name,
          data: this._scene.metadata.offloadedMaterials[t[o]].data
        });
      n = await this.loadOffloadedMaterialsAsync(e, a);
    }
    return n;
  }
  async loadOffloadedMaterialAsync(e, t) {
    if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const n = {};
      if (this._scene.metadata.offloadedMaterials.hasOwnProperty(t)) {
        n[t] = {
          name: this._scene.metadata.offloadedMaterials[t].name,
          data: this._scene.metadata.offloadedMaterials[t].data
        };
        const a = await this.loadOffloadedMaterialsAsync(e, n);
        if (a.length > 0)
          return a[0];
      }
    }
    return null;
  }
  async loadOffloadedMaterialsAsync(e, t) {
    const n = [], a = [];
    for (const h in t) {
      const f = t[h];
      a.push(this.loadOffloadedMaterialInternalAsync(h, f.name, e, f.data));
    }
    return (await Promise.all(a)).forEach((h) => {
      h && n.push(h);
    }), n;
  }
  // Il nome viene passato solo ai fini del log
  async loadOffloadedMaterialInternalAsync(e, t, n, a) {
    const o = this._scene.getMaterialByID(e);
    if (o)
      return o;
    const h = t ? ` - ${t}` : "";
    Logger.info("Loading offloaded material: " + e + h);
    const f = BABYLON.Material.Parse(a, this._scene, n);
    return f ? (Logger.info("Waiting for material ready: " + e + h), await Sn.whenAllMaterialTexturesAreReady(f), Logger.info("Material ready: " + e + h)) : Logger.info("No material was created from offloaded material: " + e + h), f;
  }
  loadTextureFiles(e, t) {
    if (e)
      for (let n = 0; n < t.length; n++) {
        const a = t[n], o = /^(?:\/|[a-z]+:\/\/)/.test(a);
        let h = a;
        o || (h = e + a);
        const f = h.lastIndexOf("."), v = f > -1 ? h.substring(f).toLowerCase() : "";
        v === ".dds" || v === ".env" || v === ".hdr" ? BABYLON.Tools.LoadFile(h, () => {
        }) : (v === ".png" || v === ".jpg") && BABYLON.Tools.LoadImage(
          h,
          (W) => {
          },
          function() {
          },
          null
        );
      }
  }
  // Recupera il materiale specificato, eventualmente caricandolo da remoto (delayed) oppure dalla cache (offloaded)
  async getOrLoadMaterialAsync(e, t) {
    let n = this._scene.getMaterialByID(e);
    return !n && this._scene.metadata && (this._scene.metadata.offloadedMaterials && this._scene.metadata.offloadedMaterials.hasOwnProperty(e) ? n = await this.loadOffloadedMaterialAsync(t, e) : this._scene.metadata.delayedMaterials && this._scene.metadata.delayedMaterials.hasOwnProperty(e) && (n = await this.loadDelayedMaterialAsync(t, e))), n;
  }
  getOrCreateDummyMaterial() {
    let e = this._scene.getMaterialByID(this._dummyMaterialID);
    return e || (e = new BABYLON.StandardMaterial("Dummy Material", this._scene), e.id = this._dummyMaterialID, e.metadata = { isRealMaterial: !1 }), e;
  }
  isDummyMaterial(e) {
    return e.id === this._dummyMaterialID;
  }
  meshHasDummyMaterial(e, t) {
    var n;
    if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
      for (let a = 0; a < e.subMeshes.length; a++) {
        const h = e.subMeshes[a].materialIndex;
        if (e.material.subMaterials[h] && ((n = e.material.subMaterials[h]) == null ? void 0 : n.id) === this._dummyMaterialID)
          return !0;
      }
    else if (e.material && e.material.id === this._dummyMaterialID)
      return !0;
    if (t) {
      const a = e.getChildMeshes(!0);
      for (const o of a)
        if (this.meshHasDummyMaterial(o, !0))
          return !0;
    }
    return !1;
  }
  getMeshDelayedMaterialIDs(e) {
    var n;
    const t = [];
    if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
      for (let a = 0; a < e.subMeshes.length; a++) {
        const h = e.subMeshes[a].materialIndex;
        if (e.material.subMaterials[h] && ((n = e.material.subMaterials[h]) == null ? void 0 : n.id) === this._dummyMaterialID) {
          const f = `${e.id}_${h}`;
          if (this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(f)) {
            const v = this._scene.metadata.originalMeshMaterials[f];
            this._scene.metadata.delayedMaterials.hasOwnProperty(v) && t.indexOf(v) === -1 && t.push(v);
          }
        }
      }
    else if (e.material && e.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.delayedMaterials && this._scene.metadata.originalMeshMaterials.hasOwnProperty(e.id)) {
      const a = this._scene.metadata.originalMeshMaterials[e.id];
      this._scene.metadata.delayedMaterials.hasOwnProperty(a) && t.indexOf(a) === -1 && t.push(a);
    }
    return e.getChildMeshes().forEach(
      (a) => Array.prototype.push.apply(t, this.getMeshDelayedMaterialIDs(a))
    ), t;
  }
  getMeshOffloadedMaterialIDs(e) {
    var n;
    const t = [];
    if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
      for (let a = 0; a < e.subMeshes.length; a++) {
        const h = e.subMeshes[a].materialIndex;
        if (e.material.subMaterials[h] && ((n = e.material.subMaterials[h]) == null ? void 0 : n.id) === this._dummyMaterialID) {
          const f = `${e.id}_${h}`;
          if (this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(f)) {
            const v = this._scene.metadata.originalMeshMaterials[f];
            this._scene.metadata.offloadedMaterials.hasOwnProperty(v) && t.indexOf(v) === -1 && t.push(v);
          }
        }
      }
    else if (e.material && e.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.offloadedMaterials && this._scene.metadata.originalMeshMaterials.hasOwnProperty(e.id)) {
      const a = this._scene.metadata.originalMeshMaterials[e.id];
      this._scene.metadata.offloadedMaterials.hasOwnProperty(a) && t.indexOf(a) === -1 && t.push(a);
    }
    return e.getChildMeshes().forEach(
      (a) => Array.prototype.push.apply(t, this.getMeshOffloadedMaterialIDs(a))
    ), t;
  }
  setDummyMaterialToInvisibleMeshes() {
    this.getInvisibleMeshes().forEach((t) => {
      this.setMeshDummyMaterial(t, !1);
    });
  }
  setMeshDummyMaterial(e, t) {
    this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.originalMeshMaterials || (this._scene.metadata.originalMeshMaterials = {});
    const n = this.getOrCreateDummyMaterial();
    if (e.material)
      if (e.subMeshes && e.subMeshes.length > 0 && e.material instanceof BABYLON.MultiMaterial)
        for (let a = 0; a < e.subMeshes.length; a++) {
          const h = e.subMeshes[a].materialIndex, f = e.material.subMaterials[h];
          if (f && !this.isDummyMaterial(f)) {
            const v = `${e.id}_${h}`;
            this._scene.metadata.originalMeshMaterials[v] = f.id, e.material.subMaterials[h] = n;
          }
        }
      else
        e.material && !this.isDummyMaterial(e.material) && (this._scene.metadata.originalMeshMaterials[e.id] = e.material.id, e.material = n);
    t && e.getChildMeshes().forEach((a) => this.setMeshDummyMaterial(a, !0));
  }
  // Il metodo è sincrono perché mi aspetto che tutti i materiali originali siano già presenti nella scena
  unsetAllDummyMaterials() {
    for (let e = 0; e < this._scene.meshes.length; e++)
      this.unsetMeshDummyMaterial(this._scene.meshes[e], !1);
  }
  // Il metodo è asincrono perché ci sia aspetta che non tutti i materiali siano presenti nella scena, in qual caso verranno caricati
  async unsetAllDummyMaterialsAsync(e) {
    for (let t = 0; t < this._scene.meshes.length; t++)
      await this.unsetMeshDummyMaterialAsync(this._scene.meshes[t], e, !1);
  }
  // Il metodo è sincrono perché mi aspetto che i materiali originali siano tutti gà presenti nella scena
  unsetMeshDummyMaterial(e, t) {
    var n;
    if (this._scene.metadata && this._scene.metadata.originalMeshMaterials) {
      if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
        for (let a = 0; a < e.subMeshes.length; a++) {
          const h = e.subMeshes[a].materialIndex;
          if (e.material.subMaterials[h] && ((n = e.material.subMaterials[h]) == null ? void 0 : n.id) === this._dummyMaterialID) {
            const f = `${e.id}_${h}`;
            if (this._scene.metadata.originalMeshMaterials.hasOwnProperty(f)) {
              const v = this._scene.metadata.originalMeshMaterials[f], x = this._scene.getMaterialByID(v);
              x && (e.material.subMaterials[h] = x, delete this._scene.metadata.originalMeshMaterials[f]);
            }
          }
        }
      else if (e.material && e.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(e.id)) {
        const a = this._scene.metadata.originalMeshMaterials[e.id], o = this._scene.getMaterialByID(a);
        o && (e.material = o, delete this._scene.metadata.originalMeshMaterials[e.id]);
      }
      t && e.getChildMeshes().forEach((a) => this.unsetMeshDummyMaterial(a, !0));
    }
  }
  // Il metodo è asincrono perché ci si aspetta che non tutti i materiali siano presenti sulla scena, nel qual caso verranno caricati
  async unsetMeshDummyMaterialAsync(e, t, n) {
    var a;
    if (this._scene.metadata && this._scene.metadata.originalMeshMaterials) {
      if (e.subMeshes && e.subMeshes.length > 0 && e.material && e.material instanceof BABYLON.MultiMaterial)
        for (let o = 0; o < e.subMeshes.length; o++) {
          const f = e.subMeshes[o].materialIndex;
          if (e.material.subMaterials[f] && ((a = e.material.subMaterials[f]) == null ? void 0 : a.id) === this._dummyMaterialID) {
            const v = `${e.id}_${f}`;
            if (this._scene.metadata.originalMeshMaterials.hasOwnProperty(v)) {
              const x = this._scene.metadata.originalMeshMaterials[v], k = await this.getOrLoadMaterialAsync(x, t);
              e.material.subMaterials[f] = k, delete this._scene.metadata.originalMeshMaterials[v];
            }
          }
        }
      else if (e.material && e.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(e.id)) {
        const o = this._scene.metadata.originalMeshMaterials[e.id], h = await this.getOrLoadMaterialAsync(o, t);
        e.material = h, delete this._scene.metadata.originalMeshMaterials[e.id];
      }
      if (n) {
        const o = e.getChildMeshes();
        for (const h of o)
          await this.unsetMeshDummyMaterialAsync(h, t, !0);
      }
    }
  }
  async reloadAllLoadingErrorTexturesAsync(e) {
    for (const t of this._scene.textures)
      await this.reloadLoadingErrorTextureAsync(e, t);
  }
  async reloadMaterialLoadingErrorTexturesAsync(e, t) {
    for (const n of t.getActiveTextures())
      await this.reloadLoadingErrorTextureAsync(e, n);
  }
  reloadLoadingErrorTextureAsync(e, t) {
    if (t instanceof BABYLON.Texture && t.url) {
      const a = t.getInternalTexture();
      if (t.loadingError || a && a.loadingError) {
        const o = t.url, h = /^(?:\/|[a-z]+:\/\/)/.test(t.url);
        var n = t.url;
        return h || (n = e + t.url), new Promise((f, v) => {
          t.updateURL(
            n,
            null,
            () => {
              t.url = o, f();
            },
            void 0,
            () => {
              t.url = o, v();
            }
          );
        });
      }
    }
    return Promise.resolve();
  }
  isTextureLoadingError(e) {
    if (e.loadingError)
      return !0;
    const t = e.getInternalTexture();
    return t !== null && t.loadingError;
  }
  materialHasLoadingErrorTextues(e) {
    return e.getActiveTextures().some((t) => this.isTextureLoadingError(t));
  }
  // A dynamic texture is a procedural texture or a texture created from a Blob
  getMaterialDynamicTextures(e) {
    return e.getActiveTextures().filter(
      (n) => n instanceof BABYLON.ProceduralTexture || n instanceof BABYLON.Texture && n.url && n.url.indexOf("blob:") !== -1
    );
  }
  exportTextureToBase64Async(e, t = "image/png", n = !1) {
    return Promise.resolve().then(async () => {
      const a = await this.getPixelsFromTexture(e);
      if (!a)
        return null;
      const o = e.getSize();
      if (e.mimeType)
        switch (e.mimeType) {
          case "image/jpeg":
            t = "image/jpeg";
            break;
          case "image/png":
            t = "image/png";
            break;
        }
      return this.createBase64FromCanvasAsync(a, o.width, o.height, t, n);
    });
  }
  createBase64FromCanvasAsync(e, t, n, a, o = !1) {
    return new Promise(async (h, f) => {
      const v = BABYLON.Constants.TEXTURETYPE_UNSIGNED_INT, x = this._scene, k = x.getEngine(), I = k.createRawTexture(
        e,
        t,
        n,
        BABYLON.Constants.TEXTUREFORMAT_RGBA,
        !1,
        o,
        BABYLON.Texture.NEAREST_SAMPLINGMODE,
        null,
        v
      );
      await BABYLON.TextureTools.ApplyPostProcess(
        "pass",
        I,
        x,
        v,
        BABYLON.Constants.TEXTURE_NEAREST_SAMPLINGMODE,
        BABYLON.Constants.TEXTUREFORMAT_RGBA
      );
      const V = await k._readTexturePixels(I, t, n), M = await BABYLON.Tools.DumpDataAsync(
        t,
        n,
        V,
        a,
        void 0,
        !0,
        !1
      );
      h(M);
    });
  }
  getPixelsFromTexture(e) {
    return e.textureType === BABYLON.Constants.TEXTURETYPE_UNSIGNED_INT, e.readPixels();
  }
  comparePBRMaterials(e, t) {
    (e.albedoColor && !t.albedoColor || !e.albedoColor && t.albedoColor || e.albedoColor && t.albedoColor && !e.albedoColor.equals(t.albedoColor)) && console.log("albedoColor"), e.allowShaderHotSwapping !== t.allowShaderHotSwapping && console.log("allowShaderHotSwapping"), e.alphaCutOff !== t.alphaCutOff && console.log("alphaCutOff"), (e.ambientColor && !t.ambientColor || !e.ambientColor && t.ambientColor || e.ambientColor && t.ambientColor && !e.ambientColor.equals(t.ambientColor)) && console.log("ambientColor"), e.ambientTextureStrength !== t.ambientTextureStrength && console.log("ambientTextureStrength"), this.compareAnisotropy(e.anisotropy, t.anisotropy), this.compareBRDF(e.brdf, t.brdf), this.compareClearCoat(e.clearCoat, t.clearCoat), e.depthFunction !== t.depthFunction && console.log("depthFunction"), this.compareDetailMap(e.detailMap, t.detailMap), e.directIntensity !== t.directIntensity && console.log("directIntensity"), e.disableBumpMap !== t.disableBumpMap && console.log("disableBumpMap"), e.disableColorWrite !== t.disableColorWrite && console.log("disableColorWrite"), e.disableDepthWrite !== t.disableDepthWrite && console.log("disableDepthWrite"), e.disableLighting !== t.disableLighting && console.log("disableLighting"), (e.emissiveColor && !t.emissiveColor || !e.emissiveColor && t.emissiveColor || e.emissiveColor && t.emissiveColor && !e.emissiveColor.equals(t.emissiveColor)) && console.log("emissiveColor"), e.emissiveIntensity !== t.emissiveIntensity && console.log("emissiveIntensity"), e.enableSpecularAntiAliasing !== t.enableSpecularAntiAliasing && console.log("enableSpecularAntiAliasing"), e.environmentIntensity !== t.environmentIntensity && console.log("environmentIntensity"), e.forceAlphaTest !== t.forceAlphaTest && console.log("forceAlphaTest"), e.forceDepthWrite !== t.forceDepthWrite && console.log("forceDepthWrite"), e.forceIrradianceInFragment !== t.forceIrradianceInFragment && console.log("forceIrradianceInFragment"), e.forceNormalForward !== t.forceNormalForward && console.log("forceNormalForward"), e.invertNormalMapX !== t.invertNormalMapX && console.log("invertNormalMapX"), e.invertNormalMapY !== t.invertNormalMapY && console.log("invertNormalMapY"), e.maxSimultaneousLights !== t.maxSimultaneousLights && console.log("maxSimultaneousLights"), e.metallic !== t.metallic && console.log("metallic"), e.metallicF0Factor !== t.metallicF0Factor && console.log("metallicF0Factor"), (e.metallicReflectanceColor && !t.metallicReflectanceColor || !e.metallicReflectanceColor && t.metallicReflectanceColor || e.metallicReflectanceColor && t.metallicReflectanceColor && !e.metallicReflectanceColor.equals(t.metallicReflectanceColor)) && console.log("metallicReflectanceColor"), e.microSurface !== t.microSurface && console.log("microSurface"), e.parallaxScaleBias !== t.parallaxScaleBias && console.log("parallaxScaleBias"), e.pointSize !== t.pointSize && console.log("pointSize"), this.comparePrePassConfiguration(e.prePassConfiguration, t.prePassConfiguration), (e.reflectionColor && !t.reflectionColor || !e.reflectionColor && t.reflectionColor || e.reflectionColor && t.reflectionColor && !e.reflectionColor.equals(t.reflectionColor)) && console.log("reflectionColor"), (e.reflectivityColor && !t.reflectivityColor || !e.reflectivityColor && t.reflectivityColor || e.reflectivityColor && t.reflectivityColor && !e.reflectivityColor.equals(t.reflectivityColor)) && console.log("reflectivityColor"), e.roughness !== t.roughness && console.log("roughness"), e.separateCullingPass !== t.separateCullingPass && console.log("separateCullingPass"), this.compareSheen(e.sheen, t.sheen), e.sideOrientation !== t.sideOrientation && console.log("sideOrientation"), e.specularIntensity !== t.specularIntensity && console.log("specularIntensity"), this.compareSubSurface(e.subSurface, t.subSurface), e.twoSidedLighting !== t.twoSidedLighting && console.log("twoSidedLighting"), e.unlit !== t.unlit && console.log("unlit"), e.useAlphaFresnel !== t.useAlphaFresnel && console.log("useAlphaFresnel"), e.useAlphaFromAlbedoTexture !== t.useAlphaFromAlbedoTexture && console.log("useAlphaFromAlbedoTexture"), e.useAmbientInGrayScale !== t.useAmbientInGrayScale && console.log("useAmbientInGrayScale"), e.useAmbientOcclusionFromMetallicTextureRed !== t.useAmbientOcclusionFromMetallicTextureRed && console.log("useAmbientOcclusionFromMetallicTextureRed"), e.useAutoMicroSurfaceFromReflectivityMap !== t.useAutoMicroSurfaceFromReflectivityMap && console.log("useAutoMicroSurfaceFromReflectivityMap"), e.useHorizonOcclusion !== t.useHorizonOcclusion && console.log("useHorizonOcclusion"), e.useLightmapAsShadowmap !== t.useLightmapAsShadowmap && console.log("useLightmapAsShadowmap"), e.useLinearAlphaFresnel !== t.useLinearAlphaFresnel && console.log("useLinearAlphaFresnel"), e.useMetallnessFromMetallicTextureBlue !== t.useMetallnessFromMetallicTextureBlue && console.log("useMetallnessFromMetallicTextureBlue"), e.useMicroSurfaceFromReflectivityMapAlpha !== t.useMicroSurfaceFromReflectivityMapAlpha && console.log("useMicroSurfaceFromReflectivityMapAlpha"), e.useObjectSpaceNormalMap !== t.useObjectSpaceNormalMap && console.log("useObjectSpaceNormalMap"), e.useOnlyMetallicFromMetallicReflectanceTexture !== t.useOnlyMetallicFromMetallicReflectanceTexture && console.log("useOnlyMetallicFromMetallicReflectanceTexture"), e.useParallax !== t.useParallax && console.log("useParallax"), e.useParallaxOcclusion !== t.useParallaxOcclusion && console.log("useParallaxOcclusion"), e.useRadianceOcclusion !== t.useRadianceOcclusion && console.log("useRadianceOcclusion"), e.useRadianceOverAlpha !== t.useRadianceOverAlpha && console.log("useRadianceOverAlpha"), e.useRoughnessFromMetallicTextureAlpha !== t.useRoughnessFromMetallicTextureAlpha && console.log("useRoughnessFromMetallicTextureAlpha"), e.useRoughnessFromMetallicTextureGreen !== t.useRoughnessFromMetallicTextureGreen && console.log("useRoughnessFromMetallicTextureGreen"), e.useSpecularOverAlpha !== t.useSpecularOverAlpha && console.log("useSpecularOverAlpha"), e.zOffset !== t.zOffset && console.log("zOffset"), e.zOffsetUnits !== t.zOffsetUnits && console.log("zOffsetUnits"), e.alpha !== t.alpha && console.log("alpha"), e.alphaMode !== t.alphaMode && console.log("alphaMode"), e.backFaceCulling !== t.backFaceCulling && console.log("backFaceCulling"), this.compareCameraCurve("", e.cameraColorCurves, t.cameraColorCurves), e.cameraColorCurvesEnabled !== t.cameraColorCurvesEnabled && console.log("cameraColorCurvesEnabled"), e.cameraColorGradingEnabled !== t.cameraColorGradingEnabled && console.log("cameraColorGradingEnabled"), e.cameraContrast !== t.cameraContrast && console.log("cameraContrast"), e.cameraExposure !== t.cameraExposure && console.log("cameraExposure"), e.cameraToneMappingEnabled !== t.cameraToneMappingEnabled && console.log("cameraToneMappingEnabled"), e.canRenderToMRT !== t.canRenderToMRT && console.log("canRenderToMRT"), e.cullBackFaces !== t.cullBackFaces && console.log("cullBackFaces"), e.fillMode !== t.fillMode && console.log("fillMode"), e.fogEnabled !== t.fogEnabled && console.log("fogEnabled"), e.hasRenderTargetTextures !== t.hasRenderTargetTextures && console.log("hasRenderTargetTextures"), this.compareImageProcessingConfiguration(e.imageProcessingConfiguration, t.imageProcessingConfiguration), e.indexOfRefraction !== t.indexOfRefraction && console.log("indexOfRefraction"), e.invertRefractionY !== t.invertRefractionY && console.log("invertRefractionY"), e.isFrozen !== t.isFrozen && console.log("isFrozen"), e.isPrePassCapable !== t.isPrePassCapable && console.log("isPrePassCapable"), e.linkRefractionWithTransparency !== t.linkRefractionWithTransparency && console.log("linkRefractionWithTransparency"), e.needDepthPrePass !== t.needDepthPrePass && console.log("needDepthPrePass"), e.realTimeFiltering !== t.realTimeFiltering && console.log("realTimeFiltering"), e.realTimeFilteringQuality !== t.realTimeFilteringQuality && console.log("realTimeFilteringQuality"), e.transparencyMode !== t.transparencyMode && console.log("transparencyMode"), e.useGLTFLightFalloff !== t.useGLTFLightFalloff && console.log("useGLTFLightFalloff"), e.useLogarithmicDepth !== t.useLogarithmicDepth && console.log("useLogarithmicDepth"), e.usePhysicalLightFalloff !== t.usePhysicalLightFalloff && console.log("usePhysicalLightFalloff"), this.compareTexture("albedo", e.albedoTexture, t.albedoTexture), this.compareTexture("emissive", e.emissiveTexture, t.emissiveTexture);
  }
  compareAnisotropy(e, t) {
    const n = "anisotropy";
    (e.direction && !t.direction || !e.direction && t.direction || e.direction && t.direction && !e.direction.equals(t.direction)) && console.log(n + " - direction"), e.intensity !== t.intensity && console.log(n + " - intensity"), e.isEnabled !== t.isEnabled && console.log(n + " - isEnabled");
  }
  compareBRDF(e, t) {
    const n = "brdf";
    e.useEnergyConservation !== t.useEnergyConservation && console.log(n + " - useEnergyConservation"), e.useSmithVisibilityHeightCorrelated !== t.useSmithVisibilityHeightCorrelated && console.log(n + " - useSmithVisibilityHeightCorrelated"), e.useSpecularGlossinessInputEnergyConservation !== t.useSpecularGlossinessInputEnergyConservation && console.log(n + " - useSpecularGlossinessInputEnergyConservation"), e.useSphericalHarmonics !== t.useSphericalHarmonics && console.log(n + " - useSphericalHarmonics");
  }
  compareClearCoat(e, t) {
    const n = "clearCoat";
    e.indexOfRefraction !== t.indexOfRefraction && console.log(n + " - indexOfRefraction"), e.intensity !== t.intensity && console.log(n + " - intensity"), e.isEnabled !== t.isEnabled && console.log(n + " - isEnabled"), e.isTintEnabled !== t.isTintEnabled && console.log(n + " - isTintEnabled"), e.roughness !== t.roughness && console.log(n + " - roughness"), (e.tintColor && !t.tintColor || !e.tintColor && t.tintColor || e.tintColor && t.tintColor && !e.tintColor.equals(t.tintColor)) && console.log(n + " - tintColor"), e.tintColorAtDistance !== t.tintColorAtDistance && console.log(n + " - tintColorAtDistance"), e.tintThickness !== t.tintThickness && console.log(n + " - tintThickness"), e.useRoughnessFromMainTexture != t.useRoughnessFromMainTexture && console.log(n + " - useRoughnessFromMainTexture");
  }
  compareDetailMap(e, t) {
    const n = "detailMap";
    e.bumpLevel !== t.bumpLevel && console.log(n + " - bumpLevel"), e.diffuseBlendLevel !== t.diffuseBlendLevel && console.log(n + " - diffuseBlendLevel"), e.isEnabled !== t.isEnabled && console.log(n + " - isEnabled"), e.normalBlendMethod !== t.normalBlendMethod && console.log(n + " - normalBlendMethod"), e.roughnessBlendLevel !== t.roughnessBlendLevel && console.log(n + " - roughnessBlendLevel");
  }
  comparePrePassConfiguration(e, t) {
    const n = "PrePassConfiguration";
    (e.currentViewProjection && !t.currentViewProjection || !e.currentViewProjection && t.currentViewProjection || e.currentViewProjection && t.currentViewProjection && !e.currentViewProjection.equals(t.currentViewProjection)) && console.log(n + " - currentViewProjection"), (e.previousViewProjection && !t.previousViewProjection || !e.previousViewProjection && t.previousViewProjection || e.previousViewProjection && t.previousViewProjection && !e.previousViewProjection.equals(t.previousViewProjection)) && console.log(n + " - previousViewProjection");
  }
  compareSheen(e, t) {
    const n = "Sheen";
    e.albedoScaling !== t.albedoScaling && console.log(n + " - albedoScaling"), (e.color && !t.color || !e.color && t.color || e.color && t.color && !e.color.equals(t.color)) && console.log(n + " - color"), e.intensity !== t.intensity && console.log(n + " - intensity"), e.isEnabled !== t.isEnabled && console.log(n + " - isEnabled"), e.linkSheenWithAlbedo !== t.linkSheenWithAlbedo && console.log(n + " - linkSheenWithAlbedo"), e.roughness !== t.roughness && console.log(n + " - roughness"), e.useRoughnessFromMainTexture !== t.useRoughnessFromMainTexture && console.log(n + " - useRoughnessFromMainTexture");
  }
  compareSubSurface(e, t) {
    const n = "SubSurface";
    (e.diffusionDistance && !t.diffusionDistance || !e.diffusionDistance && t.diffusionDistance || e.diffusionDistance && t.diffusionDistance && !e.diffusionDistance.equals(t.diffusionDistance)) && console.log(n + " - diffusionDistance"), e.indexOfRefraction !== t.indexOfRefraction && console.log(n + " - indexOfRefraction"), e.invertRefractionY !== t.invertRefractionY && console.log(n + " - invertRefractionY"), e.isRefractionEnabled !== t.isRefractionEnabled && console.log(n + " - isRefractionEnabled"), e.isScatteringEnabled !== t.isScatteringEnabled && console.log(n + " - isScatteringEnabled"), e.isTranslucencyEnabled !== t.isTranslucencyEnabled && console.log(n + " - isTranslucencyEnabled"), e.linkRefractionWithTransparency !== t.linkRefractionWithTransparency && console.log(n + " - linkRefractionWithTransparency"), e.maximumThickness !== t.maximumThickness && console.log(n + " - maximumThickness"), e.minimumThickness !== t.minimumThickness && console.log(n + " - minimumThickness"), e.refractionIntensity !== t.refractionIntensity && console.log(n + " - refractionIntensity"), (e.tintColor && !t.tintColor || !e.tintColor && t.tintColor || e.tintColor && t.tintColor && !e.tintColor.equals(t.tintColor)) && console.log(n + " - tintColor"), e.tintColorAtDistance !== t.tintColorAtDistance && console.log(n + " - tintColorAtDistance"), e.translucencyIntensity !== t.translucencyIntensity && console.log(n + " - translucencyIntensity"), e.useAlbedoToTintRefraction !== t.useAlbedoToTintRefraction && console.log(n + " - useAlbedoToTintRefraction"), e.useAlbedoToTintTranslucency !== t.useAlbedoToTintTranslucency && console.log(n + " - useAlbedoToTintTranslucency"), e.useGltfStyleTextures !== t.useGltfStyleTextures && console.log(n + " - useGltfStyleTextures"), e.useMaskFromThicknessTexture !== t.useMaskFromThicknessTexture && console.log(n + " - useMaskFromThicknessTexture"), e.useThicknessAsDepth !== t.useThicknessAsDepth && console.log(n + " - useThicknessAsDepth");
  }
  compareCameraCurve(e, t, n) {
    if ((t === null && n !== null || t !== null && n === null) && console.log("cameraColorCurves"), t && n) {
      const a = e ? e + " - cameraColorCurves" : "cameraColorCurves";
      t.globalDensity !== n.globalDensity && console.log(a + " - globalDensity"), t.globalExposure !== n.globalExposure && console.log(a + "- globalExposure"), t.globalHue !== n.globalHue && console.log(a + " - globalHue"), t.globalSaturation !== n.globalSaturation && console.log(a + " - globalSaturation"), t.highlightsDensity !== n.highlightsDensity && console.log(a + " - highlightsDensity"), t.highlightsExposure !== n.highlightsExposure && console.log(a + " - highlightsExposure"), t.highlightsHue !== n.highlightsHue && console.log(a + " - highlightsHue"), t.highlightsSaturation !== n.highlightsSaturation && console.log(a + " - highlightsSaturation"), t.midtonesDensity !== n.midtonesDensity && console.log(a + " - midtonesDensity"), t.midtonesExposure !== n.midtonesExposure && console.log(a + " - midtonesExposure"), t.midtonesHue !== n.midtonesHue && console.log(a + " - midtonesHue"), t.midtonesSaturation !== n.midtonesSaturation && console.log(a + " - midtonesSaturation"), t.shadowsDensity !== n.shadowsDensity && console.log(a + " - shadowsDensity"), t.shadowsExposure !== n.shadowsExposure && console.log(a + " - shadowsExposure"), t.shadowsHue !== n.shadowsHue && console.log(a + " - shadowsHue"), t.shadowsSaturation !== n.shadowsSaturation && console.log(a + " - shadowsSaturation");
    }
  }
  compareImageProcessingConfiguration(e, t) {
    const n = "imageProcessingConfiguration";
    this.compareCameraCurve(n, e.colorCurves, t.colorCurves), e.vignetteCameraFov !== t.vignetteCameraFov && console.log(n + " - vignetteCameraFov"), e.vignetteCentreX !== t.vignetteCentreX && console.log(n + " - vignetteCentreX"), e.vignetteCentreY !== t.vignetteCentreY && console.log(n + " - vignetteCentreY"), (e.vignetteColor && !t.vignetteColor || !e.vignetteColor && t.vignetteColor || e.vignetteColor && t.vignetteColor && !e.vignetteColor.equals(t.vignetteColor)) && console.log(n + " - vignetteColor"), e.vignetteStretch !== t.vignetteStretch && console.log(n + " - vignetteStretch"), e.vignetteWeight !== t.vignetteWeight && console.log(n + " - vignetteWeight"), e.applyByPostProcess !== t.applyByPostProcess && console.log(n + " - applyByPostProcess"), e.colorCurvesEnabled !== t.colorCurvesEnabled && console.log(n + " - colorCurvesEnabled"), e.colorGradingBGR !== t.colorGradingBGR && console.log(n + " - colorGradingBGR"), e.colorGradingEnabled !== t.colorGradingEnabled && console.log(n + " - colorGradingEnabled"), e.colorGradingWithGreenDepth !== t.colorGradingWithGreenDepth && console.log(n + " - colorGradingWithGreenDepth"), e.contrast !== t.contrast && console.log(n + " - contrast"), e.exposure !== t.exposure && console.log(n + " - exposure"), e.isEnabled !== t.isEnabled && console.log(n + " - isEnabled"), e.toneMappingEnabled !== t.toneMappingEnabled && console.log(n + " - toneMappingEnabled"), e.toneMappingType !== t.toneMappingType && console.log(n + " - toneMappingType"), e.vignetteBlendMode !== t.vignetteBlendMode && console.log(n + " - vignetteBlendMode"), e.vignetteEnabled !== t.vignetteEnabled && console.log(n + " - vignetteEnabled");
  }
  compareTexture(e, t, n) {
    if (t && !n || !t && n) {
      console.log(e);
      return;
    }
    if (t instanceof BABYLON.Texture && !(n instanceof BABYLON.Texture) || n instanceof BABYLON.Texture && !(t instanceof BABYLON.Texture)) {
      console.log(e);
      return;
    }
    t && n && (t.anisotropicFilteringLevel !== n.anisotropicFilteringLevel && console.log(e + " - anisotropicFilteringLevel"), t instanceof BABYLON.Texture && n instanceof BABYLON.Texture && (t.homogeneousRotationInUVTransform !== n.homogeneousRotationInUVTransform && console.log(e + " - homogeneousRotationInUVTransform"), t.uAng !== n.uAng && console.log(e + " - uAng"), t.uOffset !== n.uOffset && console.log(e + " - uOffset"), t.uRotationCenter !== n.uRotationCenter && console.log(e + " - uRotationCenterSearch"), t.uScale !== n.uScale && console.log(e + " - uScale"), t.vAng !== n.vAng && console.log(e + " - vAng"), t.vOffset !== n.vOffset && console.log(e + " - vOffset"), t.vRotationCenter !== n.vRotationCenter && console.log(e + " - vRotationCenterSearch"), t.vScale !== n.vScale && console.log(e + " - vScale"), t.wAng !== n.wAng && console.log(e + " - wAng"), t.wRotationCenter !== n.wRotationCenter && console.log(e + " - wRotationCenterSearch"), t.invertY !== n.invertY && console.log(e + " - invertY"), t.mimeType !== n.mimeType && console.log(e + " - mimeType")), t.invertZ !== n.invertZ && console.log(e + " - invertZ"), t.isRenderTarget !== n.isRenderTarget && console.log(e + " - isRenderTarget"), t.level !== n.level && console.log(e + " - level"), t.wrapR !== n.wrapR && console.log(e + " - wrapR"), t.canRescale !== n.canRescale && console.log(e + " - canRescale"), t.coordinatesIndex !== n.coordinatesIndex && console.log(e + " - coordinatesIndex"), t.coordinatesMode !== n.coordinatesMode && console.log(e + " - coordinatesMode"), t.gammaSpace !== n.gammaSpace && console.log(e + " - gammaSpace"), t.getAlphaFromRGB !== n.getAlphaFromRGB && console.log(e + " - getAlphaFromRGB"), t.hasAlpha !== n.hasAlpha && console.log(e + "- hasAlpha"), t.is2DArray !== n.is2DArray && console.log(e + " - is2DArray"), t.is3D !== n.is3D && console.log(e + " - is3D"), t.isBlocking !== n.isBlocking && console.log(e + " - isBlocking"), t.isCube !== n.isCube && console.log(e + " - isCube"), t.isRGBD !== n.isRGBD && console.log(e + " - isRGBD"), t.linearSpecularLOD !== n.linearSpecularLOD && console.log(e + " - linearSpecularLOD"), t.lodGenerationOffset !== n.lodGenerationOffset && console.log(e + " - lodGenerationOffset"), t.lodGenerationScale !== n.lodGenerationScale && console.log(e + " - lodGenerationScale"), t.noMipmap !== n.noMipmap && console.log(e + " - noMipmap"), t.samplingMode !== n.samplingMode && console.log(e + " - samplingMode"), t.textureFormat !== n.textureFormat && console.log(e + " - textureFormat"), t.textureType !== n.textureType && console.log(e + " - textureType"), t.wrapU !== n.wrapU && console.log(e + " - wrapU"), t.wrapV !== n.wrapV && console.log(e + " - wrapV"));
  }
  async showResizableCanvas(e, t, n, a, o, h, f, v, x, k, I, V) {
    if (!this._isLoading) {
      if (this._isLoading = !0, this._scene) {
        this.clearResizableMeshes();
        const M = await this._resizableCanvas3DGenerator.generatePreview3D(
          {
            width: e,
            height: t,
            depth: n,
            borderRadius: a,
            radiusResolution: 0.1,
            type: o,
            borderColor: h,
            columns: f,
            rows: v,
            useCheckerTexture: !1,
            backgroundUrl: I,
            backgroundColor: k,
            shape: V
          },
          this._scene
        ), W = await BABYLON.SceneLoader.ImportMeshAsync(
          "",
          "",
          "data:" + JSON.stringify(M)
        );
        this._loadedMeshes.push(...W.meshes);
        const U = W.meshes[0], Q = 2 / Math.max(e, t);
        if (U.scaling.scaleInPlace(Q), U.position.z = 0, U.rotate(BABYLON.Axis.Y, Math.PI, BABYLON.Space.LOCAL), this.camera && this.camera instanceof BABYLON.ArcRotateCamera && this.camera.setPosition(new BABYLON.Vector3(0, 1, 4)), !this._scene.lights.find((J) => J.name === "resizableLight")) {
          console.log("Creating light...");
          const J = new BABYLON.HemisphericLight(
            "resizableLight",
            new BABYLON.Vector3(0.1, 1, 0.1),
            this._scene
          );
          J.groundColor = new BABYLON.Color3(0.6, 0.6, 0.6), J.intensity = 1;
          const he = this.getDefaultHemisphericLight();
          he && this._scene.removeLight(he);
        }
        const ee = W.meshes.find((J) => !J.parent);
        return ee.metadata = {
          isResizable: !0,
          AR: !0,
          sizecm: {
            height: t / x
          }
        }, this._isLoading = !1, W.meshes;
      }
      return this._isLoading = !1, null;
    }
  }
  /**
   * Remove all meshes from the scene
   */
  clearResizableMeshes() {
    this._scene.meshes.filter((e) => {
      var t;
      return (t = e.metadata) == null ? void 0 : t.isResizable;
    }).forEach((e) => e.dispose());
  }
  switchMode(e) {
    var a;
    console.log("Switch 3D mode", e);
    const t = this._scene.lights.find((o) => o.name === "resizableLight"), n = this.getDefaultHemisphericLight();
    e === "resizable" ? this._lastVisibilityStates.size === 0 && ((a = this._scene) == null || a.meshes.forEach((o) => {
      (!o.metadata || !o.metadata.isResizable) && (this._lastVisibilityStates.set(o, o.isVisible), o.isVisible = !1);
    })) : (t && (t.dispose(), this._scene.removeLight(t)), n && this._scene.addLight(n), this._lastVisibilityStates.forEach((o, h) => h.isVisible = o), this._lastVisibilityStates.clear(), this.clearResizableMeshes());
  }
  async rotate(e, t, n) {
    return new Promise((a) => {
      if (this._scene) {
        console.log(`Rotating scene on axis ${t} by ${e} degrees`);
        const o = e * Math.PI / 180;
        this._scene.meshes.filter((h) => !h.parent).forEach((h) => {
          if (!n)
            h.rotate(t, o, BABYLON.Space.WORLD), a();
          else {
            const f = h.rotationQuaternion ?? h.rotation.toQuaternion(), v = BABYLON.Quaternion.RotationAxis(t, o).multiply(
              f
            ), x = BABYLON.Animation.CreateAndStartAnimation(
              h.id + "rotation",
              h,
              "rotationQuaternion",
              60,
              20,
              f,
              v,
              BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT,
              void 0,
              () => {
                x == null || x.stop(), a();
              }
            );
          }
        });
      }
    });
  }
  // ===== CAMERA ROTATION METHODS =====
  /**
   * Ruota la camera a sinistra di un angolo specificato.
   * @param degrees Angolo in gradi (default: 5)
   * @param animate Se true, anima il movimento (default: true)
   */
  rotateCameraLeft(e = 5, t = !0) {
    this.rotateCameraHorizontal(-e, t);
  }
  /**
   * Ruota la camera a destra di un angolo specificato.
   * @param degrees Angolo in gradi (default: 5)
   * @param animate Se true, anima il movimento (default: true)
   */
  rotateCameraRight(e = 5, t = !0) {
    this.rotateCameraHorizontal(e, t);
  }
  /**
   * Ruota la camera verso l'alto di un angolo specificato.
   * @param degrees Angolo in gradi (default: 5)
   * @param animate Se true, anima il movimento (default: true)
   */
  rotateCameraUp(e = 5, t = !0) {
    this.rotateCameraVertical(-e, t);
  }
  /**
   * Ruota la camera verso il basso di un angolo specificato.
   * @param degrees Angolo in gradi (default: 5)
   * @param animate Se true, anima il movimento (default: true)
   */
  rotateCameraDown(e = 5, t = !0) {
    this.rotateCameraVertical(e, t);
  }
  /**
   * Ruota la camera orizzontalmente (attorno all'asse Y).
   * @param degrees Angolo in gradi (positivo = destra, negativo = sinistra)
   * @param animate Se true, anima il movimento
   */
  rotateCameraHorizontal(e, t = !0) {
    if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
      return;
    const n = e * Math.PI / 180;
    let a = this._camera.alpha + n;
    this._camera.lowerAlphaLimit !== null && this._camera.lowerAlphaLimit !== void 0 && (a = Math.max(this._camera.lowerAlphaLimit, a)), this._camera.upperAlphaLimit !== null && this._camera.upperAlphaLimit !== void 0 && (a = Math.min(this._camera.upperAlphaLimit, a)), t ? this.animateCameraToFinalParamters(
      a,
      this._camera.beta,
      this._camera.radius,
      this._camera.target,
      0.3
    ) : this._camera.alpha = a;
  }
  /**
   * Ruota la camera verticalmente (attorno all'asse orizzontale).
   * @param degrees Angolo in gradi (positivo = giù, negativo = su)
   * @param animate Se true, anima il movimento
   */
  rotateCameraVertical(e, t = !0) {
    if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
      return;
    const n = e * Math.PI / 180;
    let a = this._camera.beta + n;
    a = Math.max(0.1, Math.min(Math.PI - 0.1, a)), this._camera.lowerBetaLimit !== null && this._camera.lowerBetaLimit !== void 0 && (a = Math.max(this._camera.lowerBetaLimit, a)), this._camera.upperBetaLimit !== null && this._camera.upperBetaLimit !== void 0 && (a = Math.min(this._camera.upperBetaLimit, a)), t ? this.animateCameraToFinalParamters(
      this._camera.alpha,
      a,
      this._camera.radius,
      this._camera.target,
      0.3
    ) : this._camera.beta = a;
  }
};
Ed._shadowGenerator = null;
let di = Ed;
class Ws extends BABYLON.ProceduralTexture {
  constructor(e, t, n, a, o, h, f) {
    super(e, t, n, a, h, f), this._initializing = !1, this._baseTexture = o, this.updateShaderUniforms();
  }
  get initializing() {
    return this._initializing;
  }
  get baseTexture() {
    return this._baseTexture;
  }
  set baseTexture(e) {
    this._baseTexture = e, this.updateShaderUniforms();
  }
  isReadyAsync() {
    return di.whenTextureIsReadyAsync(this);
  }
  dispose() {
    super.dispose(), this._baseTexture && this._baseTexture.dispose();
  }
  beginInit() {
    this._initializing = !0;
  }
  endInit() {
    this._initializing = !1, this.updateShaderUniforms();
  }
  updateShaderUniforms() {
    this._initializing || this.setBaseTextureUniform();
  }
  setBaseTextureUniform() {
    this.setTexture("uSampler", this._baseTexture);
  }
}
const su = class Id extends Ws {
  constructor(e, t, n, a, o, h) {
    super(e, t, Id.FRAGMENT_SHADER, n, a, o, h), this._blur = 1 / 512, this.updateShaderUniforms();
  }
  //@BABYLON.serialize()
  get blur() {
    return this._blur / (1 / 7e3);
  }
  set blur(e) {
    this._blur = 1 / 7e3 * e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), this.initializing)
      return;
    const e = this._blur != null ? this._blur : 1 / 512;
    this.setFloat("blur", e);
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  //public serialize(): any {
  //    var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
  //    serializationObject.customType = BlurXProceduralTexture.CUSTOM_TYPE;
  //    return serializationObject;
  //}
  //public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): BlurXProceduralTexture {
  //    var texture = BABYLON.SerializationHelper.Parse(() => new BlurXProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
  //    return texture;
  //}
};
su.FRAGMENT_SHADER = "zakeke_BlurXProceduralTexture";
su.CUSTOM_TYPE = "Zakeke.BlurXProceduralTexture";
let no = su;
const kx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "varying vec4 vColor;",
  "uniform float blur;",
  "uniform sampler2D uSampler;",
  "void main(void) {",
  "   vec4 sum = vec4(0.0);",
  "   sum += texture2D(uSampler, vec2(vUV.x - 4.0*blur, vUV.y)) * 0.05;",
  "   sum += texture2D(uSampler, vec2(vUV.x - 3.0*blur, vUV.y)) * 0.09;",
  "   sum += texture2D(uSampler, vec2(vUV.x - 2.0*blur, vUV.y)) * 0.12;",
  "   sum += texture2D(uSampler, vec2(vUV.x - blur, vUV.y)) * 0.15;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y)) * 0.16;",
  "   sum += texture2D(uSampler, vec2(vUV.x + blur, vUV.y)) * 0.15;",
  "   sum += texture2D(uSampler, vec2(vUV.x + 2.0*blur, vUV.y)) * 0.12;",
  "   sum += texture2D(uSampler, vec2(vUV.x + 3.0*blur, vUV.y)) * 0.09;",
  "   sum += texture2D(uSampler, vec2(vUV.x + 4.0*blur, vUV.y)) * 0.05;",
  "   gl_FragColor = sum;",
  "}"
], Ex = kx.join(`
`);
BABYLON.Effect.ShadersStore[`${no.FRAGMENT_SHADER}PixelShader`] = Ex;
const au = class Pd extends Ws {
  constructor(e, t, n, a, o, h) {
    super(e, t, Pd.FRAGMENT_SHADER, n, a, o, h), this._blur = 1 / 512, this.updateShaderUniforms();
  }
  get blur() {
    return this._blur / (1 / 7e3);
  }
  set blur(e) {
    this._blur = 1 / 7e3 * e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), this.initializing)
      return;
    const e = this._blur != null ? this._blur : 1 / 512;
    this.setFloat("blur", e);
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  //public serialize(): any {
  //    var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
  //    serializationObject.customType = BlurYProceduralTexture.CUSTOM_TYPE;
  //    return serializationObject;
  //}
  //public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): BlurYProceduralTexture {
  //    var texture = BABYLON.SerializationHelper.Parse(() => new BlurYProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
  //    return texture;
  //}
};
au.FRAGMENT_SHADER = "zakeke_BlurYProceduralTexture";
au.CUSTOM_TYPE = "Zakeke.BlurYProceduralTexture";
let ro = au;
const Ix = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "varying vec4 vColor;",
  "uniform float blur;",
  "uniform sampler2D uSampler;",
  "void main(void) {",
  "   vec4 sum = vec4(0.0);",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 4.0*blur)) * 0.05;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 3.0*blur)) * 0.09;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 2.0*blur)) * 0.12;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - blur)) * 0.15;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y)) * 0.16;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + blur)) * 0.15;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 2.0*blur)) * 0.12;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 3.0*blur)) * 0.09;",
  "   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 4.0*blur)) * 0.05;",
  "   gl_FragColor = sum;",
  "}"
], Px = Ix.join(`
`);
BABYLON.Effect.ShadersStore[`${ro.FRAGMENT_SHADER}PixelShader`] = Px;
const ou = class Od extends Ws {
  constructor(e, t, n, a, o, h) {
    super(e, t, Od.FRAGMENT_SHADER, n, a, o, h), this._foreColor = new BABYLON.Vector3(1, 1, 1), this._backColor = new BABYLON.Vector3(0, 0, 0), this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsVector3()
  get foreColor() {
    return this._foreColor;
  }
  set foreColor(e) {
    this._foreColor = e, this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsVector3()
  get backColor() {
    return this._backColor;
  }
  set backColor(e) {
    this._backColor = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), this.initializing)
      return;
    const e = this._foreColor || new BABYLON.Vector3(1, 1, 1), t = this._backColor || new BABYLON.Vector3(0, 0, 0);
    this.setVector3("foreColor", e), this.setVector3("backColor", t);
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
  * Resize the texture to new value.
  * @param size Define the new size the texture should have
  * @param generateMipMaps Define whether the new texture should create mip maps
  */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  /*
      public serialize(): any {
          var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
          serializationObject.customType = ForegroundBackgroundProceduralTexture.CUSTOM_TYPE;
          return serializationObject;
      }
  
      public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): ForegroundBackgroundProceduralTexture {
          var texture = BABYLON.SerializationHelper.Parse(() => new ForegroundBackgroundProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
          return texture;
      }
      */
};
ou.FRAGMENT_SHADER = "zakeke_ForegroundBackgroundProceduralTexture";
ou.CUSTOM_TYPE = "Zakeke.ForegroundBackgroundProceduralTexture";
let so = ou;
const Ox = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform vec3 foreColor;",
  "uniform vec3 backColor;",
  "void main(void) {",
  "   // background color",
  "   vec4 background = vec4(backColor.xyz, 1);",
  "   vec4 foreground = vec4(foreColor.xyz, 1);",
  "   // texel",
  "	vec4 t0 = texture2D(uSampler, vUV.xy);",
  "   // change in white",
  "   t0 = vec4(foreground.xyz, t0.a);",
  "   gl_FragColor = mix(background, t0, t0.a);",
  "}"
], Nx = Ox.join(`
`);
BABYLON.Effect.ShadersStore[`${so.FRAGMENT_SHADER}PixelShader`] = Nx;
const lu = class Nd extends Ws {
  constructor(e, t, n, a, o, h) {
    super(e, t, Nd.FRAGMENT_SHADER, n, a, o, h), this._offset = new BABYLON.Vector2(0, 0), this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsVector2()
  get offset() {
    return this._offset;
  }
  set offset(e) {
    this._offset = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), this.initializing)
      return;
    const e = this.getRenderSize(), t = this._offset || new BABYLON.Vector2();
    this.setVector2("offset", new BABYLON.Vector2(t.x / e, t.y / e));
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
  * Resize the texture to new value.
  * @param size Define the new size the texture should have
  * @param generateMipMaps Define whether the new texture should create mip maps
  */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  /*
      public serialize(): any {
          var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
          serializationObject.customType = MoveProceduralTexture.CUSTOM_TYPE;
          return serializationObject;
      }
  
      public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): MoveProceduralTexture {
          var texture = BABYLON.SerializationHelper.Parse(() => new MoveProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
          return texture;
      }
      */
};
lu.FRAGMENT_SHADER = "zakeke_MoveProceduralTexture";
lu.CUSTOM_TYPE = "Zakeke.MoveProceduralTexture";
let hu = lu;
const Rx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform vec2 offset;",
  "void main(void) {",
  "   // translated texel",
  "   gl_FragColor = texture2D(uSampler, vec2(vUV.x - offset.x, vUV.y + offset.y));",
  //'   gl_FragColor = texture2D(uSampler, vUV.xy - offset);',
  "}"
], Dx = Rx.join(`
`);
BABYLON.Effect.ShadersStore[`${hu.FRAGMENT_SHADER}PixelShader`] = Dx;
const uu = class Rd extends Ws {
  constructor(e, t, n, a, o, h, f) {
    super(e, t, Rd.FRAGMENT_SHADER, n, a, h, f), this._blendTexture = o, this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsTexture()
  get blendTexture() {
    return this._blendTexture;
  }
  set blendTexture(e) {
    this._blendTexture = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose(), this._blendTexture && this._blendTexture.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), !this.initializing) {
      var e = new BABYLON.Vector2(1, 1);
      this.baseTexture && (e = new BABYLON.Vector2(this.baseTexture.uScale, this.baseTexture.vScale)), this.setVector2("uSamplerScale", e), this.setTexture("uBlendSampler", this._blendTexture);
      var t = new BABYLON.Vector2(1, 1);
      this._blendTexture && (t = new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale)), this.setVector2("uBlendScale", t);
    }
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
};
uu.FRAGMENT_SHADER = "zakeke_MultiplyProceduralTexture";
uu.CUSTOM_TYPE = "Zakeke.MultiplyProceduralTexture";
let Qa = uu;
const zx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform sampler2D uBlendSampler;",
  "uniform vec2 uSamplerScale;",
  "uniform vec2 uBlendScale;",
  "void main(void) {",
  "	vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);",
  "	vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);",
  "   gl_FragColor = base * blend;",
  "}"
], Fx = zx.join(`
`);
BABYLON.Effect.ShadersStore[`${Qa.FRAGMENT_SHADER}PixelShader`] = Fx;
const cu = class Dd extends Ws {
  constructor(e, t, n, a, o, h) {
    super(e, t, Dd.FRAGMENT_SHADER, n, a, o, h), this._bias = 50, this._invertR = !1, this._invertG = !1, this._bevel = !1, this._intensity = 0.5, this.updateShaderUniforms();
  }
  get bias() {
    return this._bias == null ? 50 : this._bias;
  }
  set bias(e) {
    this._bias = e, this.updateShaderUniforms();
  }
  get invertR() {
    return this._invertR == null ? !1 : this._invertR;
  }
  set invertR(e) {
    this._invertR = e, this.updateShaderUniforms();
  }
  get invertG() {
    return this._invertG == null ? !1 : this._invertG;
  }
  set invertG(e) {
    this._invertG = e, this.updateShaderUniforms();
  }
  get bevel() {
    return this._bevel == null ? !1 : this._bevel;
  }
  set bevel(e) {
    this._bevel = e, this.updateShaderUniforms();
  }
  get intensity() {
    return this._intensity == null ? 0.5 : this._intensity;
  }
  set intensity(e) {
    this._intensity = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), !this.initializing) {
      var e = this.getRenderSize(), t = e < 1024 ? e * 2 : e;
      this.setFloat("size", e), this.setVector2("u_textureSize", new BABYLON.Vector2(e, e)), this.setVector3("dimensions", new BABYLON.Vector3(t, t, 0)), this.setFloat("bias", this.bias), this.setFloat("invertR", this.invertR ? -1 : 1), this.setFloat("invertG", this.invertG ? -1 : 1), this.setFloat("bevel", this.bevel ? 1 : 0), this.setFloat("intensity", this.intensity);
    }
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
};
cu.FRAGMENT_SHADER = "zakeke_normalMapProceduralTexture";
cu.CUSTOM_TYPE = "Zakeke.NormalMapProceduralTexture";
let zd = cu;
const Ux = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform vec3 dimensions;",
  "uniform sampler2D uSampler;",
  "uniform vec2 u_textureSize;",
  "uniform float bias;",
  "uniform float invertR;",
  "uniform float invertG;",
  "uniform float bevel;",
  "uniform float intensity;",
  "void main(void) {",
  "   vec2 step = vec2(1.0, 1.0) / dimensions.xy;",
  "   vec4 black = vec4(0, 0, 0, 1);",
  "	vec4 bk = vec4(1, 1, 1, 1);",
  "	vec4 t0 = texture2D(uSampler, vUV.xy + vec2(0.0, 0.0));",
  "	vec4 t1 = texture2D(uSampler, vUV.xy + vec2(step.x, 0.0));",
  "	vec4 t2 = texture2D(uSampler, vUV.xy + vec2(-step.x, 0.0));",
  "	vec4 t3 = texture2D(uSampler, vUV.xy + vec2(0.0, step.y));",
  "	vec4 t4 = texture2D(uSampler, vUV.xy + vec2(0.0, -step.y));",
  "   if (bevel != 0.0) ",
  "   {",
  "      t0 = vec4(0, 0, 0, t0.a);",
  "      t1 = vec4(0, 0, 0, t1.a);",
  "      t2 = vec4(0, 0, 0, t2.a);",
  "      t3 = vec4(0, 0, 0, t3.a);",
  "      t4 = vec4(0, 0, 0, t4.a);",
  "   }",
  "	t0 = mix(bk, t0, t0.a);",
  "	t1 = mix(bk, t1, t1.a);",
  "	t2 = mix(bk, t2, t2.a);",
  "	t3 = mix(bk, t3, t3.a);",
  "	t4 = mix(bk, t4, t4.a);",
  "	float d0 = abs(t0.r);",
  "	float d1 = abs(t1.r);",
  "	float d2 = abs(t2.r);",
  "	float d3 = abs(t3.r);",
  "	float d4 = abs(t4.r);",
  "	float dx = ((d2 - d0) + (d0 - d1)) * intensity;",
  "	float dy = ((d4 - d0) + (d0 - d3)) * intensity;",
  "	vec4 normal = vec4(normalize(vec3(dx * invertR, dy * invertG, 1.0 - ((bias - 0.1) / 100.0))), 1.0);",
  "	gl_FragColor = vec4(normal.xyz * 0.5 + 0.5, 1.0);",
  "}"
], Vx = Ux.join(`
`);
BABYLON.Effect.ShadersStore[`${zd.FRAGMENT_SHADER}PixelShader`] = Vx;
const fu = class Fd extends Ws {
  constructor(e, t, n, a, o, h, f) {
    super(e, t, Fd.FRAGMENT_SHADER, n, a, h, f), this._opacity = 1, this.updateShaderUniforms();
  }
  get opacity() {
    return this._opacity == null ? 1 : this._opacity;
  }
  set opacity(e) {
    this._opacity = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose();
  }
  updateShaderUniforms() {
    super.updateShaderUniforms(), !this.initializing && this.setFloat("opacity", this.opacity);
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
};
fu.FRAGMENT_SHADER = "zakeke_OpacityProceduralTexture";
fu.CUSTOM_TYPE = "Zakeke.OpacityProceduralTexture";
let Hx = fu;
const Yx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform float opacity;",
  "void main(void) {",
  "	vec4 color = texture2D(uSampler, vUV.xy);",
  "   color.a = opacity;",
  "   gl_FragColor = color;",
  "}"
], Gx = Yx.join(`
`);
BABYLON.Effect.ShadersStore[`${Hx.FRAGMENT_SHADER}PixelShader`] = Gx;
const du = class Ud extends Ws {
  constructor(e, t, n, a, o, h, f) {
    super(e, t, Ud.FRAGMENT_SHADER, n, a, h, f), this._blendTexture = o, this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsTexture()
  get blendTexture() {
    return this._blendTexture;
  }
  set blendTexture(e) {
    this._blendTexture = e, this.updateShaderUniforms();
  }
  dispose() {
    super.dispose(), this._blendTexture && this._blendTexture.dispose();
  }
  updateShaderUniforms() {
    if (super.updateShaderUniforms(), !this.initializing) {
      var e = new BABYLON.Vector2(1, 1);
      this.baseTexture && (e = new BABYLON.Vector2(this.baseTexture.uScale, this.baseTexture.vScale)), this.setVector2("uSamplerScale", e), this.setTexture("uBlendSampler", this._blendTexture);
      var t = new BABYLON.Vector2(1, 1);
      this._blendTexture && (t = new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale)), this.setVector2("uBlendScale", t);
    }
  }
  /**
  * Render the texture to its associated render target.
  * @param useCameraPostProcess Define if camera post process should be applied to the texture
  */
  render(e) {
    super.render(e);
  }
  /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
};
du.FRAGMENT_SHADER = "zakeke_OverlayProceduralTexture";
du.CUSTOM_TYPE = "Zakeke.OverlayProceduralTexture";
let ll = du;
var jx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform sampler2D uBlendSampler;",
  "uniform vec2 uSamplerScale;",
  "uniform vec2 uBlendScale;",
  "float BlendOverlayf(float base, float blend)",
  "{",
  "   return (base < 0.5 ? (2.0 * base * blend) : (1.0 - 2.0 * (1.0 - base) * (1.0 - blend)));",
  "}",
  "vec4 BlendOverlay(vec4 base, vec4 blend)",
  "{",
  "   return vec4(BlendOverlayf(base.r, blend.r), BlendOverlayf(base.g, blend.g), BlendOverlayf(base.b, blend.b), BlendOverlayf(base.a, blend.a));",
  "}",
  "void main(void) {",
  "	vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);",
  "	vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);",
  "   gl_FragColor = BlendOverlay(base, blend);",
  "}"
], Wx = jx.join(`
`);
BABYLON.Effect.ShadersStore[`${ll.FRAGMENT_SHADER}PixelShader`] = Wx;
const gu = class hl extends BABYLON.ProceduralTexture {
  constructor(e, t, n = null, a, o) {
    super(e, t, hl.FRAGMENT_SHADER, n, a, o), this._baseTexture = null, this._blendTexture = null, this.updateShaderUniforms();
  }
  dispose() {
    this._baseTexture && this._baseTexture.dispose(), this._blendTexture && this._blendTexture.dispose();
  }
  updateShaderUniforms() {
    this._baseTexture ? (this.setTexture("uSampler", this._baseTexture), this.setInt("hasSampler", 1), this.setVector2("uSamplerScale", new BABYLON.Vector2(this._baseTexture.uScale, this._baseTexture.vScale))) : (this.setInt("hasSampler", 0), this.setVector2("uSamplerScale", new BABYLON.Vector2(1, 1))), this._blendTexture ? (this.setTexture("uBlendSampler", this._blendTexture), this.setInt("hasBlend", 1), this.setVector2("uBlendScale", new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale))) : (this.setInt("hasBlend", 0), this.setVector2("uBlendScale", new BABYLON.Vector2(1, 1))), this.setFloat("size", this.getRenderSize());
  }
  render(e) {
    super.render(e);
  }
  resize(e, t) {
    super.resize(e, t), this.updateShaderUniforms();
  }
  isReady() {
    return this._baseTexture && !this._baseTexture.isReady() || this._blendTexture && !this._blendTexture.isReady() ? !1 : super.isReady();
  }
  //@BABYLON.serializeAsTexture()
  get baseTexture() {
    return this._baseTexture;
  }
  set baseTexture(e) {
    this._baseTexture = e, this.updateShaderUniforms();
  }
  //@BABYLON.serializeAsTexture()
  get blendTexture() {
    return this._blendTexture;
  }
  set blendTexture(e) {
    this._blendTexture = e, this.updateShaderUniforms();
  }
  /**
   * Serializes this normal map procedural texture
   * @returns a serialized normal map procedural texture object
   */
  serialize() {
    var e = BABYLON.SerializationHelper.Serialize(this, super.serialize());
    return e.customType = hl.CUSTOM_TYPE, this.baseTexture ? e.baseTexture = this.baseTexture.serialize() : e.baseTexture = null, this.blendTexture ? e.blendTexture = this.blendTexture.serialize() : e.blendTexture = null, e;
  }
  /**
   * Creates a Normal Map Procedural Texture from parsed normal map procedural texture data
   * @param parsedTexture defines parsed texture data
   * @param scene defines the current scene
   * @param rootUrl defines the root URL containing normal map procedural texture information
   * @returns a parsed Normal Map Procedural Texture
   */
  static Parse(e, t, n) {
    var a = BABYLON.SerializationHelper.Parse(
      () => new hl(
        e.name,
        e._size,
        t,
        void 0,
        e._generateMipMaps
      ),
      e,
      t,
      n
    );
    return e.baseTexture && (a.baseTexture = BABYLON.Texture.Parse(e.baseTexture, t, n)), e.blendTexture && (a.blendTexture = BABYLON.Texture.Parse(e.blendTexture, t, n)), a;
  }
};
gu.FRAGMENT_SHADER = "zakeke_BlendProceduralTexture";
gu.CUSTOM_TYPE = "Zakeke.BlendProceduralTexture";
let Vd = gu;
var Zx = [
  "precision mediump float;",
  "varying vec2 vUV;",
  "uniform sampler2D uSampler;",
  "uniform sampler2D uBlendSampler;",
  "uniform vec2 uSamplerScale;",
  "uniform vec2 uBlendScale;",
  "uniform bool hasSampler;",
  "uniform bool hasBlend;",
  "float BlendOverlayf(float base, float blend)",
  "{",
  "   return (base < 0.5 ? (2.0 * base * blend) : (1.0 - 2.0 * (1.0 - base) * (1.0 - blend)));",
  "}",
  "vec4 BlendOverlay(vec4 base, vec4 blend)",
  "{",
  "   return vec4(BlendOverlayf(base.r, blend.r), BlendOverlayf(base.g, blend.g), BlendOverlayf(base.b, blend.b), BlendOverlayf(base.a, blend.a));",
  "}",
  "void main(void) {",
  "   if (!hasSampler && !hasBlend)",
  "   {",
  "       gl_FragColor = vec4(1.0, 1.0, 1.0, 1.0);",
  "       return;",
  "   }",
  "   if (hasSampler && !hasBlend)",
  "   {",
  "       gl_FragColor = texture2D(uSampler, vUV.xy*uSamplerScale);",
  "       return;",
  "   }",
  "   if (!hasSampler && hasBlend)",
  "   {",
  "       gl_FragColor = texture2D(uBlendSampler, vUV.xy*uBlendScale);",
  "       return;",
  "   }",
  "   vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);",
  "   vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);",
  "   gl_FragColor = BlendOverlay(base, blend);",
  "}"
], qx = Zx.join(`
`);
BABYLON.Effect.ShadersStore[`${Vd.FRAGMENT_SHADER}PixelShader`] = qx;
BABYLON.RegisterClass("Zakeke.BlendProceduralTexture", Vd);
class Hd {
  constructor() {
  }
  getSubmeshIdx(e) {
    let t = e.lastIndexOf("-");
    if (t != -1) {
      e = e.substring(0, t);
      let n = Number(e.substring(t + 1));
      if (n && !isNaN(n))
        return n;
    }
    return null;
  }
  getRegExp(e, t) {
    if ((t & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
      let n = e.lastIndexOf("-");
      n != -1 && (e = e.substring(0, n), Number(e.substring(n + 1)));
    }
    return new RegExp(this.escapeRegExp(e).replace(/\\\*/g, ".*"), "i");
  }
  getElements(e, t, n, a, o) {
    const h = [], f = a.split(";");
    for (let v = 0; v < f.length; v++) {
      const x = f[v];
      let k = x, I = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
        const V = this.getMeshes(e, t, n, I, k);
        Array.prototype.push.apply(h, V);
      }
      if ((o & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        let V = this.getSubmeshIdx(k);
        if (V) {
          const M = this.getSubMeshes(e, t, n, I, k, V);
          Array.prototype.push.apply(h, M);
        }
      }
      if ((o & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        const V = this.getMaterials(e, t, n, I, k);
        Array.prototype.push.apply(h, V);
      }
      if ((o & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
        const V = this.getLights(e, t, n, I, k);
        Array.prototype.push.apply(h, V);
      }
      if ((o & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
        const V = this.getCameras(e, t, n, I, k);
        Array.prototype.push.apply(h, V);
      }
      if ((o & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
        const V = this.getCameraLocations(e, t, n, I);
        Array.prototype.push.apply(h, V);
      }
    }
    return h;
  }
  getMeshElements(e, t, n, a, o) {
    const h = [], f = a.split(";");
    for (let v = 0; v < f.length; v++) {
      const x = f[v];
      let k = x, I = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
        const V = this.getMeshes(e, t, n, I, k);
        Array.prototype.push.apply(h, V);
      }
    }
    return h;
  }
  getSubMeshElements(e, t, n, a, o) {
    const h = [], f = a.split(";");
    for (let v = 0; v < f.length; v++) {
      const x = f[v];
      let k = x, I = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        let V = this.getSubmeshIdx(k);
        if (V) {
          const M = this.getSubMeshes(e, t, n, I, k, V);
          Array.prototype.push.apply(h, M);
        }
      }
    }
    return h;
  }
  getMaterialElements(e, t, n, a, o) {
    const h = [], f = a.split(";");
    for (let v = 0; v < f.length; v++) {
      const x = f[v];
      let k = x, I = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        const V = this.getMaterials(e, t, n, I, k);
        Array.prototype.push.apply(h, V);
      }
    }
    return h;
  }
  getLightElements(e, t, n, a, o) {
    const h = [], f = a.split(";");
    for (let v = 0; v < f.length; v++) {
      const x = f[v];
      let k = x, I = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
        const V = this.getLights(e, t, n, I, k);
        Array.prototype.push.apply(h, V);
      }
    }
    return h;
  }
  getCameraElements(e, t, n, a, o) {
    const h = [], f = a.split(";");
    for (let v = 0; v < f.length; v++) {
      const x = f[v];
      let k = x, I = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
        const V = this.getCameras(e, t, n, I, k);
        Array.prototype.push.apply(h, V);
      }
    }
    return h;
  }
  getCameraLocationElements(e, t, n, a, o) {
    const h = [], f = a.split(";");
    for (let v = 0; v < f.length; v++) {
      const x = f[v];
      let k = this.getRegExp(x, o);
      if ((o & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
        const I = this.getCameraLocations(e, t, n, k);
        Array.prototype.push.apply(h, I);
      }
    }
    return h;
  }
  getOffloadedElementIDs(e, t, n, a, o) {
    const h = [], f = a.split(";");
    for (let I = 0; I < f.length; I++) {
      const V = f[I];
      let M = V;
      if ((o & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        var v = V.lastIndexOf("-");
        v != -1 && (M = V.substring(0, v), Number(V.substring(v + 1)));
      }
      var x = new RegExp(this.escapeRegExp(M).replace(/\\\*/g, ".*"), "i");
      if ((o & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        var k = this.getOffloadedMaterialIDs(e, t, n, x, M);
        Array.prototype.push.apply(h, k);
      }
    }
    return h;
  }
  getDelayedElementIDs(e, t, n, a, o) {
    const h = [], f = a.split(";");
    for (let I = 0; I < f.length; I++) {
      const V = f[I];
      let M = V;
      if ((o & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        var v = V.lastIndexOf("-");
        v != -1 && (M = V.substring(0, v), Number(V.substring(v + 1)));
      }
      var x = new RegExp(this.escapeRegExp(M).replace(/\\\*/g, ".*"), "i");
      if ((o & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        var k = this.getDelayedMaterialIDs(e, t, n, x, M);
        Array.prototype.push.apply(h, k);
      }
    }
    return h;
  }
  getMeshes(e, t, n, a, o) {
    const h = [];
    if (t && t instanceof BABYLON.Scene)
      for (let f = 0; f < t.meshes.length; f++) {
        const v = t.meshes[f];
        (v.name && a.test(v.name) || v.id && v.id == o) && this.verifyFilter(v.id, n) && h.push(v);
      }
    return h;
  }
  getSubMeshes(e, t, n, a, o, h) {
    const f = [];
    if (t && t instanceof BABYLON.Scene)
      for (let v = 0; v < t.meshes.length; v++) {
        const x = t.meshes[v];
        (x.name && a.test(x.name) || x.id && x.id == o) && this.verifyFilter(x.id, n) && h < x.subMeshes.length && h >= 0 && f.push(x.subMeshes[h]);
      }
    return f;
  }
  getMaterials(e, t, n, a, o) {
    const h = [];
    if (t && t instanceof BABYLON.Scene)
      for (let f = 0; f < t.materials.length; f++) {
        const v = t.materials[f];
        (v.name && a.test(v.name) || v.id && v.id == o || v.metadata && !v.metadata.isRealMaterial && v.metadata.originalMaterialID == o) && this.verifyFilter(v.id, n) && h.push(v);
      }
    return h;
  }
  getOffloadedMaterialIDs(e, t, n, a, o) {
    const h = [];
    if (t && t instanceof BABYLON.Scene && t.metadata && t.metadata.offloadedMaterials)
      for (let f in t.metadata.offloadedMaterials) {
        const v = t.metadata.offloadedMaterials[f];
        (v.name && a.test(v.name) || f && f == o) && this.verifyFilter(f, n) && h.push(f);
      }
    return h;
  }
  getDelayedMaterialIDs(e, t, n, a, o) {
    const h = [];
    if (t && t instanceof BABYLON.Scene && t.metadata && t.metadata.delayedMaterials)
      for (let f in t.metadata.delayedMaterials) {
        const v = t.metadata.delayedMaterials[f];
        (v.name && a.test(v.name) || f && f == o) && this.verifyFilter(f, n) && h.push(f);
      }
    return h;
  }
  getLights(e, t, n, a, o) {
    const h = [];
    if (t && t instanceof BABYLON.Scene)
      for (let f = 0; f < t.lights.length; f++) {
        const v = t.lights[f];
        (v.name && a.test(v.name) || v.id && v.id == o) && this.verifyFilter(v.id, n) && h.push(v);
      }
    return h;
  }
  getCameras(e, t, n, a, o) {
    const h = [];
    if (t && t instanceof BABYLON.Scene)
      for (let f = 0; f < t.cameras.length; f++) {
        const v = t.cameras[f];
        (v.name && a.test(v.name) || v.id && v.id == o) && this.verifyFilter(v.id, n) && h.push(v);
      }
    return h;
  }
  getCameraLocations(e, t, n, a) {
    var o = [];
    if (e && e instanceof Zakeke.Scene)
      for (var h = 0; h < e.get("cameraLocations").length; h++) {
        var f = e.get("cameraLocations").at(h), v = f.getLocationID(), x = f.get("name");
        (x && a.test(x) || v && a.test(v)) && this.verifyFilter(v, n) && o.push(f);
      }
    return o;
  }
  getYesNoElements(e, t, n, a, o) {
    const h = { yes: [], no: [] }, f = a.split(";");
    for (let v = 0; v < f.length; v++) {
      const x = f[v];
      let k = x, I = 0;
      if ((o & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        let M = x.lastIndexOf("-");
        if (M != -1) {
          k = x.substring(0, M);
          let W = Number(x.substring(M + 1));
          W && !isNaN(W) && (I = W);
        }
      }
      const V = new RegExp(this.escapeRegExp(k).replace(/\\\*/g, ".*"), "i");
      if ((o & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
        const M = this.getYesNoMeshes(e, t, n, V);
        Array.prototype.push.apply(h.yes, M.yes), Array.prototype.push.apply(h.no, M.no);
      }
      if ((o & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        const M = this.getYesNoSubMeshes(e, t, n, V, I);
        Array.prototype.push.apply(h.yes, M.yes), Array.prototype.push.apply(h.no, M.no);
      }
      if ((o & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
        const M = this.getYesNoMaterials(e, t, n, V);
        Array.prototype.push.apply(h.yes, M.yes), Array.prototype.push.apply(h.no, M.no);
      }
      if ((o & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
        const M = this.getYesNoLights(e, t, n, V);
        Array.prototype.push.apply(h.yes, M.yes), Array.prototype.push.apply(h.no, M.no);
      }
      if ((o & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
        const M = this.getYesNoCameras(e, t, n, V);
        Array.prototype.push.apply(h.yes, M.yes), Array.prototype.push.apply(h.no, M.no);
      }
      if ((o & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
        const M = this.getYesNoCameraLocations(e, t, n, V);
        Array.prototype.push.apply(h.yes, M.yes), Array.prototype.push.apply(h.no, M.no);
      }
    }
    return h;
  }
  getYesNoMeshes(e, t, n, a) {
    const o = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let h = 0; h < t.meshes.length; h++) {
        let f = t.meshes[h], v = o.no;
        (f.name && a.test(f.name) || f.id && a.test(f.id)) && this.verifyFilter(f.id, n) && (v = o.yes), v.push(f);
      }
    return o;
  }
  getYesNoSubMeshes(e, t, n, a, o) {
    const h = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let f = 0; f < t.meshes.length; f++) {
        let v = t.meshes[f];
        if ((v.name && a.test(v.name) || v.id && a.test(v.id)) && this.verifyFilter(v.id, n) && v.subMeshes)
          for (let x = 0; x < v.subMeshes.length; x++)
            x == o ? h.yes.push(v.subMeshes[x]) : h.no.push(v.subMeshes[x]);
      }
    return h;
  }
  getYesNoMaterials(e, t, n, a) {
    const o = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let h = 0; h < t.materials.length; h++) {
        let f = t.materials[h];
        (f.name && a.test(f.name) || f.id && a.test(f.id)) && this.verifyFilter(f.id, n) ? o.yes.push(f) : o.no.push(f);
      }
    return o;
  }
  getYesNoLights(e, t, n, a) {
    const o = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let h = 0; h < t.lights.length; h++) {
        let f = t.lights[h];
        (f.name && a.test(f.name) || f.id && a.test(f.id)) && this.verifyFilter(f.id, n) ? o.yes.push(f) : o.no.push(f);
      }
    return o;
  }
  getYesNoCameras(e, t, n, a) {
    const o = { yes: [], no: [] };
    if (t && t instanceof BABYLON.Scene)
      for (let h = 0; h < t.cameras.length; h++) {
        let f = t.cameras[h];
        (f.name && a.test(f.name) || f.id && a.test(f.id)) && this.verifyFilter(f.id, n) ? o.yes.push(f) : o.no.push(f);
      }
    return o;
  }
  getYesNoCameraLocations(e, t, n, a) {
    const o = { yes: [], no: [] };
    if (e && e instanceof Zakeke.Scene)
      for (let h = 0; h < e.get("cameraLocations").length; h++) {
        let f = e.get("cameraLocations").at(h), v = f.getLocationID(), x = f.get("name");
        (x && a.test(x) || v && a.test(v)) && this.verifyFilter(v, n) ? o.yes.push(f) : o.no.push(f);
      }
    return o;
  }
  escapeRegExp(e) {
    return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  verifyFilter(e, t) {
    return !t || t.length == 0 ? !0 : t.indexOf(e) !== -1;
  }
}
class $x {
  constructor(e, t, n) {
    this._zkModel = null, this._sceneHelper = null, this._deviceType = MPlaza.DeviceType.All, this._meshDesignRefreshRequiredListeners = [], this._beginAssetsLoadingListeners = [], this._endAssetsLoadingListeners = [], this._useMaterialOffloading = !1, this._prefetchMeshes = !0, this._prefetchMaterials = !0, Logger.info("[SceneActionExecutor] Constructor called"), this._zkScene = e, this._scene = t, this._sceneHelper = new di(t), this._elementSelector = new Hd(), n && (this._zkModel = n), Logger.info(`[SceneActionExecutor] Initialized successfully | Device type: ${this._deviceType}`);
  }
  get deviceType() {
    return this._deviceType;
  }
  set deviceType(e) {
    this._deviceType != e && (this._deviceType = e);
  }
  get useMaterialOffloading() {
    return this._useMaterialOffloading;
  }
  set useMaterialOffloading(e) {
    this._useMaterialOffloading != e && (this._useMaterialOffloading = e);
  }
  get prefetchMeshes() {
    return this._prefetchMeshes;
  }
  set prefetchMeshes(e) {
    this._prefetchMeshes !== e && (this._prefetchMeshes = e);
  }
  get prefetchMaterials() {
    return this._prefetchMaterials;
  }
  set prefetchMaterials(e) {
    this._prefetchMaterials !== e && (this._prefetchMaterials = e);
  }
  dispose() {
    this._sceneHelper && (this._sceneHelper.dispose(), this._sceneHelper = null);
  }
  // -------------------------------------------------------
  // Events
  // -------------------------------------------------------
  addMeshDesignRefreshRequiredListeners(e) {
    this._meshDesignRefreshRequiredListeners.push(e);
  }
  fireMeshDesignRefreshRequiredEvent(e, t) {
    const n = { meshes: e, effect: t };
    for (let a = 0; a < this._meshDesignRefreshRequiredListeners.length; ++a)
      this._meshDesignRefreshRequiredListeners[a](n);
  }
  addBeginAssetsLoadingListener(e) {
    this._beginAssetsLoadingListeners.push(e);
  }
  fireBeginAssetsLoadingEvent() {
    for (let e = 0; e < this._beginAssetsLoadingListeners.length; ++e)
      this._beginAssetsLoadingListeners[e]();
  }
  addEndAssetsLoadingListener(e) {
    this._endAssetsLoadingListeners.push(e);
  }
  fireEndAssetsLoadingEvent() {
    for (let e = 0; e < this._endAssetsLoadingListeners.length; ++e)
      this._endAssetsLoadingListeners[e]();
  }
  // -------------------------------------------------------
  // Actions Helpers Methods
  // -------------------------------------------------------
  isActionForDevice(e) {
    const t = e.get("deviceTypes");
    return Logger.info(`[IsActionForDevice] Checking device compatibility | DeviceType from action: ${t} | Current device: ${this._deviceType}`), t === MPlaza.DeviceType.Any || t === MPlaza.DeviceType.All ? (Logger.info("[IsActionForDevice] ✓ Action is for Any/All devices"), !0) : (t & this._deviceType) === this._deviceType ? (Logger.info("[IsActionForDevice] ✓ Action matches current device"), !0) : (Logger.warn("[IsActionForDevice] ❌ Action not compatible with current device"), !1);
  }
  // ad una mesh vengono associati dei dati aggiuntivi che servono per l'utilizzo dei filtri.
  // Un filtro consente di creare un contesto di mesh da associare ad una opzione di un attributo.
  // Quando si utilizza un'azione di tipo filtro, verranno visualizzate solo le mesh specificate dal filtro.
  // Per esempio, per un orologio potrei avere un attributo "modello" con le opzioni "classico", "moderno", "sportivo".
  // Selezionando un modello, potrebbe essere utile attivare solo le mesh che hanno a che fare con il
  // modello selezionato. Questo consentirebbe di specificare azioni su altre opzioni indipendentemente dal modello.
  // Ad esempio potrei avere un altro attributo "vetro" con le opzioni "zaffiro" e "normale" con le azioni
  // che visualizzano il vetro nel materiale selezionato, diverso per modello.
  // Un filtro è relativo ad un attributo, così da permettere la definizione di contesti più restrittivi
  // andando a cumulare filtri relativi ad attributi diversi.
  // Inizializza la struttura dati associata ad una mesh
  setupMeshData(e) {
    e.data || (e.data = {
      filters: {},
      toShow: e.isVisible
    });
  }
  // Imposta il filtro legato ad un attributo (da un'azione filtro)
  async setMeshFilterAsync(e, t, n) {
    this.setupMeshData(e), e.data.filters[t] = n, await this.chekMeshVisibilityAsync(e);
  }
  // Richiede la visibilità di una mesh (da un'azione show/hide)
  async setMeshVisibilityAsync(e, t) {
    this.setupMeshData(e), e.data.toShow = t, await this.chekMeshVisibilityAsync(e);
  }
  // Determina se dopo l'applicazione di un filtro o una richiesta di visibilità
  // la mesh debba essere mostrata o nascosta. Il risultato andrà ad agire sulla
  // effettiva visibilità della mesh, secondo l'espressione booleana:
  // mesh.isVisible = F1 && F2 && ... && Fn && toShow
  async chekMeshVisibilityAsync(e) {
    let t = null;
    if (e && e.data && (t = e.data.toShow, t))
      for (const n in e.data.filters)
        t = t && e.data.filters[n];
    if (t !== null && this._sceneHelper) {
      if (t) {
        const n = this._zkScene.get("rootUrl");
        n && await this._sceneHelper.unsetMeshDummyMaterialAsync(e, n, !0), await di.whenMeshIsReadyAsync(e);
      }
      this._sceneHelper.showHideMesh(e.id, t);
    }
  }
  getMeshByID(e) {
    return this._scene.getMeshByID(e);
  }
  getMaterialByID(e) {
    return this._scene.getMaterialByID(e);
  }
  setCameraLocation(e) {
    const t = this._zkScene.getCameraLocation(e);
    if (t) {
      const n = new BABYLON.Vector3(
        t.get("px"),
        t.get("py"),
        t.get("pz")
      ), a = new BABYLON.Vector3(
        t.get("tx"),
        t.get("ty"),
        t.get("tz")
      );
      this._sceneHelper && this._sceneHelper.animateCamera(a, n, 0.5);
    }
  }
  adjustCamera(e) {
    this._sceneHelper && (e !== void 0 && typeof e == "boolean" ? this._sceneHelper.adjustCamera(void 0, void 0, void 0, e) : this._sceneHelper.adjustCamera());
  }
  zoomIn() {
    this._sceneHelper && this._sceneHelper.zoomIn();
  }
  zoomOut() {
    this._sceneHelper && this._sceneHelper.zoomOut();
  }
  zoom(e) {
    this._sceneHelper && this._sceneHelper.zoom(e);
  }
  setCameraPivot(e) {
    if (this._sceneHelper) {
      const t = e ? this._scene.getMeshByID(e) : null;
      this._sceneHelper.setCameraPivot(t);
    }
  }
  setCameraZoomEnabled(e) {
    this._sceneHelper && this._sceneHelper.setZoomEnabled(e);
  }
  async setMeshMaterial(e, t) {
    if (this._sceneHelper) {
      await di.whenAllMaterialTexturesAreReady(e);
      const n = t.material;
      Logger.info(
        `Setting material to mesh | mesh: ${t.id} - ${t.name} | material: ${e.id} - ${e.name}`
      ), this._sceneHelper.applyMaterial(e, t), this._useMaterialOffloading && n && this._sceneHelper.offloadMaterial(n.id);
    }
  }
  async setSubmeshMaterial(e, t, n) {
    if (this._sceneHelper) {
      await di.whenAllMaterialTexturesAreReady(e);
      const a = this._sceneHelper.getSubMeshMaterial(t, n);
      this._sceneHelper.applyMaterialToSubMesh(e, t, n), this._useMaterialOffloading && a && this._sceneHelper.offloadMaterial(a.id);
    }
  }
  getMaterialFromActionValue(e) {
    if (this._elementSelector) {
      const t = e.get("value");
      if (t != null && t != null) {
        let n = this._scene.getMaterialByID(t);
        return n || (n = this._scene.getMaterialByName(t)), n;
      }
    }
    return null;
  }
  getDelayedMaterialIDFromAction(e) {
    if (this._zkScene && this._scene && this._elementSelector && e && e instanceof MPlaza.AttributeSceneAction && this._scene.metadata && this._scene.metadata.delayedMaterials) {
      const t = e.get("value");
      if (t != null && t != null) {
        if (this._scene.metadata.delayedMaterials.hasOwnProperty(t))
          return t;
        for (let n in this._scene.metadata.delayedMaterials)
          if (this._scene.metadata.delayedMaterials[n].name === t)
            return n;
      }
    }
    return null;
  }
  async checkDelayedMaterial(e) {
    let t = this.getMaterialByID(e);
    if (!t && this._sceneHelper) {
      const n = this._zkScene.get("rootUrl");
      n != null && n != null && (t = await this._sceneHelper.loadDelayedMaterialAsync(n, e));
    }
    return t;
  }
  getOffloadedMaterialIDFromAction(e) {
    if (this._zkScene && this._scene && this._elementSelector && e && e instanceof MPlaza.AttributeSceneAction && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
      const t = e.get("value");
      if (t != null) {
        if (this._scene.metadata.offloadedMaterials.hasOwnProperty(t))
          return t;
        for (let n in this._scene.metadata.offloadedMaterials)
          if (this._scene.metadata.offloadedMaterials[n].name === t)
            return n;
      }
    }
    return null;
  }
  async checkOffloadedMaterialAsync(e) {
    let t = this.getMaterialByID(e);
    if (!t && this._sceneHelper) {
      const n = this._zkScene.get("rootUrl");
      n != null && (t = await this._sceneHelper.loadOffloadedMaterialAsync(n, e));
    }
    return t;
  }
  // Recupera il materiale specificato nel valore di un'azione, eventualmente caricandolo da remoto (delayed) oppure dalla cache (offloaded)
  async getDeepMaterialFromActionValueAsync(e) {
    let t = this.getMaterialFromActionValue(e);
    if (!t && this._sceneHelper) {
      const n = this._zkScene.get("rootUrl");
      if (n != null) {
        let a = this.getOffloadedMaterialIDFromAction(e);
        a ? (Logger.info("Requesting offloaded material - id: ", a), t = await this._sceneHelper.loadOffloadedMaterialAsync(n, a), Logger.info("Obtained offloaded material - id: ", a)) : (a = this.getDelayedMaterialIDFromAction(e), a && (Logger.info("Requesting delayed material - id: ", a), t = await this._sceneHelper.loadDelayedMaterialAsync(n, a), Logger.info("Obtained delayed material - id: ", a)));
      }
    }
    return t;
  }
  scriptRequiresDelayedLoading(e) {
    for (let t = 0; t < e.length; t++) {
      const n = e[t];
      if (this.actionsRequireDelayedLoading(n.actions))
        return !0;
    }
    return !1;
  }
  actionsRequireDelayedLoading(e) {
    for (let t = 0; t < e.length; t++)
      if (this.actionRequiresDelayedLoading(e[t]))
        return !0;
    return !1;
  }
  actionRequiresDelayedLoading(e) {
    if (this._sceneHelper && e.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && e.get("value") === "show") {
      const t = e.get("selector");
      if (t != null) {
        const n = this._elementSelector.getElements(
          this._zkScene,
          this._scene,
          null,
          t,
          MPlaza.SceneElementType.Mesh
        );
        for (let a = 0; a < n.length; a++) {
          const o = n[a];
          if (o instanceof BABYLON.AbstractMesh && !o.isVisible) {
            const h = this._sceneHelper.getMeshDelayedMaterialIDs(o), f = this._sceneHelper.getMeshOffloadedMaterialIDs(o);
            if (h.length > 0 || f.length > 0 || di.meshRequiresDelayedLoading(o))
              return !0;
          }
        }
      }
    }
    if ((e.get("actionTypeID") === MPlaza.SceneActionType.SetMeshMaterial || e.get("actionTypeID") === MPlaza.SceneActionType.SetSubMeshMaterial || e.get("actionTypeID") === MPlaza.SceneActionType.SetMaterialColor || e.get("actionTypeID") === MPlaza.SceneActionType.SetMeshDesignMaterial) && !this.getMaterialFromActionValue(e) && (this.getDelayedMaterialIDFromAction(e) || this.getOffloadedMaterialIDFromAction(e)))
      return !0;
    if (e.get("actionTypeID") === MPlaza.SceneActionType.SetMaterialColor) {
      const t = e.get("selector");
      if (t != null) {
        const n = this._elementSelector.getDelayedElementIDs(
          this._zkScene,
          this._scene,
          null,
          t,
          MPlaza.SceneElementType.Material
        ), a = this._elementSelector.getOffloadedElementIDs(
          this._zkScene,
          this._scene,
          null,
          t,
          MPlaza.SceneElementType.Material
        );
        if (n.length > 0 || a.length > 0)
          return !0;
      }
    }
    return !1;
  }
  async getAllMaterialElementsAsync(e) {
    const t = [];
    if (this._zkScene && this._scene && this._sceneHelper && this._elementSelector) {
      const n = this._elementSelector.getMaterialElements(
        this._zkScene,
        this._scene,
        null,
        e,
        MPlaza.SceneElementType.Material
      );
      Array.prototype.push.apply(t, n);
      const a = n.map((v) => v.id), o = this._elementSelector.getDelayedElementIDs(
        this._zkScene,
        this._scene,
        null,
        e,
        MPlaza.SceneElementType.Material
      ), h = this._elementSelector.getOffloadedElementIDs(
        this._zkScene,
        this._scene,
        null,
        e,
        MPlaza.SceneElementType.Material
      ), f = this._zkScene.get("rootUrl");
      if (f != null) {
        const v = [];
        if (o.forEach((k) => {
          a.indexOf(k) === -1 && v.push(k);
        }), v.length > 0) {
          const k = await this._sceneHelper.loadDelayedMaterialsAsync(
            f,
            v
          );
          Array.prototype.push.apply(t, k);
        }
        const x = [];
        if (h.forEach((k) => {
          a.indexOf(k) === -1 && x.push(k);
        }), x.length > 0) {
          const k = await this._sceneHelper.loadOffloadedMaterialsByIDsAsync(
            f,
            x
          );
          Array.prototype.push.apply(t, k);
        }
      }
    }
    return t;
  }
  // Uno script è un array di oggetti ognuno dei quali rappresenta le azioni da eseguire
  // conseguentemente alla selezione di un valore per un attributo
  // si suppone che le azioni siano già ordinate per ordine di esecuzione
  // script: [{attributeID, selectedValue, actions}]
  async executeScriptAsync(e) {
    Logger.info("[ExecuteScript] ========== SCRIPT EXECUTION START =========="), Logger.info(`[ExecuteScript] Script length: ${e.length} script actions`);
    const t = this.scriptRequiresDelayedLoading(e);
    Logger.info(`[ExecuteScript] Requires delayed loading: ${t}`), t && this.fireBeginAssetsLoadingEvent();
    for (let n = 0; n < e.length; n++) {
      const a = e[n];
      Logger.info(`[ExecuteScript] >>> Processing script action ${n + 1}/${e.length} | AttributeID: ${a.attributeID} | Value: ${a.selectedValue} | Actions: ${a.actions.length}`), await this.executeActionsAsync(
        a.attributeID,
        a.selectedValue,
        a.actions,
        !1
      );
    }
    t && this.fireEndAssetsLoadingEvent(), Logger.info("[ExecuteScript] ========== SCRIPT EXECUTION COMPLETED ==========");
  }
  async executeActionsAsync(e, t, n, a = !0) {
    if (Logger.info("[ExecuteActions] ========== STARTING ACTIONS EXECUTION =========="), Logger.info(`[ExecuteActions] AttributeID: ${e} | SelectedValue: ${t} | Actions count: ${n.length}`), n.length > 0) {
      const o = this.actionsRequireDelayedLoading(n);
      a && o && this.fireBeginAssetsLoadingEvent(), await this.checkActionsAssetsAreReadyAsync(n);
      for (let h = 0; h < n.length; h++) {
        const f = n[h];
        Logger.info(`[ExecuteActions] >>> Processing action ${h + 1}/${n.length} | Type: ${f.get("actionTypeID")} | Selector: '${f.get("selector")}'`), await this.executeActionAsync(e, t, f);
      }
      a && o && this.fireEndAssetsLoadingEvent(), Logger.info("[ExecuteActions] ========== ACTIONS EXECUTION COMPLETED ==========");
    }
  }
  // Esegue una singola azione generata dalla selezione di un attributo
  // action: MPlaza.AttributeSceneAction
  async executeActionAsync(e, t, n) {
    if (!this.isActionForDevice(n)) {
      Logger.info(`[ExecuteAction] ❌ Action not for device | ActionType: ${n.get("actionTypeID")} | DeviceType: ${this._deviceType}`);
      return;
    }
    const a = n.get("actionTypeID"), o = n.get("selector"), h = n.get("value"), f = n.get("propertyName");
    if (Logger.info("[ExecuteAction] ========== EXECUTING ACTION =========="), Logger.info(`[ExecuteAction] AttributeID: ${e} | SelectedValue: ${t}`), Logger.info(`[ExecuteAction] ActionTypeID: ${a} | Selector: '${o}' | Value: '${h}'`), Logger.info(`[ExecuteAction] PropertyName: '${f}'`), console.log(`🔥 EXECUTING ACTION ${a} - ${o} - ${h}`), n) {
      switch (a) {
        case MPlaza.SceneActionType.Filter:
          await this.executeFilterActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.ShowHideMesh:
          await this.executeShowHideActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetMeshMaterial:
          await this.executeSetMeshMaterialActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetSubMeshMaterial:
          await this.executeSetSubMeshMaterialActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetMaterialColor:
          await this.executeSetMaterialColorActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetCameraLocation:
          await this.executeSetCameraLocationActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.AdjustCamera:
          await this.executeAdjustCameraActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetCameraPivot:
          await this.executeSetCameraPivotActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.ResetCameraPivot:
          await this.executeResetCameraPivotActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.EnableDiableZoom:
          await this.executeEnableDisableZoomActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetMeshDesignMaterial:
          await this.executeSetMeshDesignMaterialActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetMeshDesignEffect:
          await this.executeSetMeshDesignEffectActionAsync(e, t, n);
          break;
        case MPlaza.SceneActionType.SetMaterialParameter:
          console.log(`🎯 MATCHED SetMaterialParameter case! Type: ${a}`), console.warn(`🎯 MATCHED SetMaterialParameter case! Type: ${a}`), Logger.info(`[ExecuteAction] ✓ CALLING SetMaterialParameter action | Type: ${a}`), await this.executeSetMaterialParameterActionAsync(e, t, n);
          break;
      }
      Logger.info(`[ExecuteAction] ✓ Action execution completed | ActionType: ${a}`);
    } else
      Logger.warn("[ExecuteAction] ❌ No action provided to execute");
  }
  async executeFilterActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && e !== null && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const a = n.get("selector");
      if (a != null) {
        const o = this._elementSelector.getYesNoElements(
          this._zkScene,
          this._scene,
          null,
          a,
          MPlaza.SceneElementType.Mesh
        ), h = n.get("value") === "enable";
        for (let f = 0; f < o.yes.length; f++)
          await this.setMeshFilterAsync(o.yes[f], e, h);
        for (let f = 0; f < o.no.length; f++)
          await this.setMeshFilterAsync(o.yes[f], e, !h);
      }
    }
  }
  async executeShowHideActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const a = n.get("selector");
      if (a != null) {
        const o = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          a,
          MPlaza.SceneElementType.Mesh
        ), h = n.get("value") === "show";
        for (let f = 0; f < o.length; f++)
          await this.setMeshVisibilityAsync(o[f], h);
      }
    }
  }
  async executeSetMeshMaterialActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const a = n.get("selector");
      if (a != null) {
        const o = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          a,
          MPlaza.SceneElementType.Mesh
        ), h = await this.getDeepMaterialFromActionValueAsync(n);
        if (h)
          for (let f = 0; f < o.length; f++)
            await this.setMeshMaterial(h, o[f]);
      }
    }
  }
  async executeSetSubMeshMaterialActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const a = n.get("selector");
      if (a != null) {
        const o = this._elementSelector.getSubMeshElements(
          this._zkScene,
          this._scene,
          null,
          a,
          MPlaza.SceneElementType.SubMesh
        ), h = await this.getDeepMaterialFromActionValueAsync(n);
        if (h)
          for (let f = 0; f < o.length; f++)
            await this.setSubmeshMaterial(h, null, o[f]);
      }
    }
  }
  async executeSetMaterialColorActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const a = n.get("selector");
      if (a != null) {
        Logger.info(`[SetMaterialColor] Start | selector: '${a}'`);
        const o = await this.getAllMaterialElementsAsync(a);
        Logger.info(`[SetMaterialColor] Found ${o.length} material(s)`);
        const h = n.get("propertyName");
        let f = n.get("value");
        if (h && f) {
          if (Logger.info(`[SetMaterialColor] PropertyName: '${h}' | Original value: '${f}'`), t) {
            const x = f;
            f = f.replace(/%value%/g, t), x !== f && Logger.info(
              `[SetMaterialColor] Replaced %value% with '${t}' | Result: '${f}'`
            );
          }
          const v = BABYLON.Color3.FromHexString(f);
          Logger.info(`[SetMaterialColor] Applying color ${f} to ${o.length} material(s)`);
          for (let x = 0; x < o.length; x++)
            Logger.info(
              `[SetMaterialColor] Applying to material '${o[x].id}' - property '${h}'`
            ), this._sceneHelper.changeMaterialColor(
              o[x],
              h,
              v
            );
          Logger.info("[SetMaterialColor] Completed successfully");
        } else
          Logger.warn(
            `[SetMaterialColor] Missing propertyName or value | propertyName: ${h} | value: ${f}`
          );
      } else
        Logger.warn("[SetMaterialColor] No selector specified");
    }
  }
  async executeSetCameraLocationActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const a = n.get("value");
      let o = null;
      if (a)
        for (let h = 0; h < this._zkScene.get("cameraLocations").length; h++) {
          const f = this._zkScene.get("cameraLocations").at(h);
          if (f.get("locationID") === a || f.get("name") === a) {
            o = f;
            break;
          }
        }
      o !== null && this.setCameraLocation(o.get("locationID"));
    }
  }
  async executeAdjustCameraActionAsync(e, t, n) {
    this.isActionForDevice(n) && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction && this._sceneHelper.adjustCamera();
  }
  async executeSetCameraPivotActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const a = n.get("value");
      let o = null;
      if (a)
        for (let h = 0; h < this._scene.meshes.length; h++) {
          const f = this._scene.meshes[h];
          if (f.id === a || f.name === a) {
            o = f;
            break;
          }
        }
      o && this.setCameraPivot(o.id);
    }
  }
  async executeResetCameraPivotActionAsync(e, t, n) {
    this.isActionForDevice(n) && this.setCameraPivot(null);
  }
  async executeEnableDisableZoomActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const a = n.get("value") === "enable";
      this.setCameraZoomEnabled(a);
    }
  }
  async executeSetMeshDesignMaterialActionAsync(e, t, n) {
    if (this._zkScene && this._scene && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const a = n.get("selector");
      if (a != null && a != null) {
        const o = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          a,
          MPlaza.SceneElementType.Mesh
        ), h = await this.getDeepMaterialFromActionValueAsync(n);
        if (h) {
          for (let f = 0; f < o.length; f++) {
            const v = o[f];
            v.metadata = v.metadata || {}, v.metadata.designMaterialID = h.id;
          }
          this.fireMeshDesignRefreshRequiredEvent(o, null);
        }
      }
    }
  }
  async executeSetMeshDesignEffectActionAsync(e, t, n) {
    if (this.isActionForDevice(n) && this._zkScene && this._scene && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      const a = n.get("selector");
      if (a != null && a != null) {
        let o = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          a,
          MPlaza.SceneElementType.Mesh
        ), h = n.get("value"), f = null;
        if (h != null && h != null && this._zkModel)
          for (let x = 0; x < this._zkModel.get("scenes").length; x++) {
            const k = this._zkModel.get("scenes").at(x);
            if (k.get("isDefault")) {
              const I = k.get("meshDesignEffects");
              if (I)
                for (let V = 0; V < I.length; V++) {
                  const M = I.at(V);
                  if (M.get("effectID") === h || M.get("name") === h) {
                    f = M;
                    break;
                  }
                }
            }
            if (f)
              break;
          }
        let v = null;
        if (f) {
          const x = f.get("materialID");
          x && (v = await this.checkOffloadedMaterialAsync(x), v || (v = await this.checkDelayedMaterial(x)));
        }
        this.fireMeshDesignRefreshRequiredEvent(o, f);
      }
    }
  }
  async executeSetMaterialParameterActionAsync(e, t, n) {
    if (console.log(">>>>>>> SET MATERIAL PARAMETER ACTION CALLED! <<<<<<<"), console.warn(">>>>>>> SET MATERIAL PARAMETER ACTION CALLED! <<<<<<<"), console.error(">>>>>>> SET MATERIAL PARAMETER ACTION CALLED! <<<<<<<"), Logger.info("[SetMaterialParameter] >>>>>>>>>> METHOD CALLED <<<<<<<<<<"), Logger.info(`[SetMaterialParameter] Input parameters - AttributeID: ${e} | SelectedValue: ${t}`), !this.isActionForDevice(n)) {
      Logger.warn("[SetMaterialParameter] ❌ Action not for device, exiting");
      return;
    }
    if (Logger.info("[SetMaterialParameter] ========== START =========="), Logger.info(`[SetMaterialParameter] AttributeID: ${e} | SelectedValue: ${t}`), this._zkScene && this._scene && this._elementSelector && n && n instanceof MPlaza.AttributeSceneAction) {
      console.log("🔍 All dependencies OK, proceeding...");
      const a = n.get("selector");
      if (console.log(`🎯 Material selector: '${a}'`), Logger.info(`[SetMaterialParameter] Selector expression: '${a}'`), a == null) {
        console.error("❌ No selector found!"), Logger.warn("[SetMaterialParameter] ❌ Action has no selector (material)");
        return;
      }
      const o = this._elementSelector.getMaterialElements(
        this._zkScene,
        this._scene,
        null,
        a,
        MPlaza.SceneElementType.Material
      );
      if (console.log(`📦 Found ${o.length} materials for selector`), Logger.info(`[SetMaterialParameter] Found ${o.length} material(s) matching selector`), !o || o.length === 0) {
        console.error(`❌ NO MATERIALS FOUND for selector: '${a}'`), Logger.warn(`[SetMaterialParameter] ❌ No materials found for selector '${a}'`);
        return;
      }
      o.forEach((v, x) => {
        console.log(`📋 Material[${x}]: id='${v.id}' name='${v.name}' type='${v.getClassName()}'`), Logger.info(`[SetMaterialParameter]   Material[${x}]: id='${v.id}' name='${v.name}'`), x === 0 && this.analyzeMaterialStructure(v);
      });
      const h = n.get("propertyName"), f = n.get("value");
      if (console.log("🎨 Property details:"), console.log(`   PropertyPath: '${h}'`), console.log(`   PropertyValue: '${f}'`), Logger.info(`[SetMaterialParameter] PropertyPath (dot notation): '${h}'`), Logger.info(`[SetMaterialParameter] PropertyValue: '${f}'`), !h) {
        console.error("❌ NO PROPERTY NAME found in action"), Logger.warn("[SetMaterialParameter] ❌ No propertyName found in action");
        return;
      }
      console.log(`🚀 Starting to apply property to ${o.length} material(s)...`), Logger.info(`[SetMaterialParameter] Applying property to ${o.length} material(s)...`);
      for (let v = 0; v < o.length; v++) {
        const x = o[v];
        console.log(`🔧 Processing material[${v}]: '${x.id}' (${x.getClassName()})`), Logger.info(`[SetMaterialParameter] >>> Processing material[${v}]: '${x.id}'`), this.applyMaterialProperty(x, h, f);
      }
      console.log("✅ SetMaterialParameter completed successfully!"), Logger.info("[SetMaterialParameter] ========== COMPLETED ==========");
    } else
      Logger.warn("[SetMaterialParameter] ❌ Missing required dependencies (_zkScene, _scene, _elementSelector)");
  }
  // Helper method per analizzare la struttura di un materiale
  analyzeMaterialStructure(e) {
    console.log(`🔍 Material Analysis for: ${e.id} (${e.getClassName()})`);
    const t = e, n = [], a = {};
    for (const o in t)
      if (t.hasOwnProperty(o)) {
        const h = t[o];
        if (h && typeof h == "object" && h.constructor && h.constructor.name && h.constructor.name !== "Color3" && h.constructor.name !== "Vector3" && h.constructor.name !== "Texture" && !Array.isArray(h)) {
          const f = [];
          for (const v in h)
            h.hasOwnProperty(v) && f.push(v);
          f.length > 0 && (a[o] = f);
        }
        (typeof h == "string" || typeof h == "number" || typeof h == "boolean" || h && h.constructor && (h.constructor.name === "Color3" || h.constructor.name === "Vector3")) && n.push(`${o} (${typeof h}${h.constructor ? " - " + h.constructor.name : ""})`);
      }
    console.log(`📋 Direct Properties (${n.length}):`, n.slice(0, 10)), console.log("🏗️ Nested Properties:", a);
  }
  applyMaterialProperty(e, t, n) {
    try {
      const a = this.normalizePropertyPath(t);
      console.log("🔨 ApplyMaterialProperty START"), console.log(`   Material: '${e.id}' (${e.getClassName()})`), console.log(`   Path (original): '${t}'`), console.log(`   Path (normalized): '${a}'`), console.log(`   Value: '${n}' (${typeof n})`), Logger.info(
        `[ApplyMaterialProperty] Start | Material: '${e.id}' | Path: '${t}' → '${a}' | Value: '${n}'`
      ), this.ensureSubPropertyEnabled(e, a);
      const o = this.resolveMaterialPropertyPath(e, a);
      if (!o) {
        console.error(`❌ Cannot resolve property path '${a}' on material '${e.id}'`), Logger.error(`[ApplyMaterialProperty] ❌ Cannot resolve property path '${a}' on material '${e.id}'`);
        return;
      }
      if (console.log(`✅ Resolved path: ${o.description}`), Logger.info(`[ApplyMaterialProperty] ✅ Resolved path: ${o.description}`), this.isTextureProperty(a)) {
        console.log("🖼️ TEXTURE property detected"), Logger.info("[ApplyMaterialProperty] ✓ Detected TEXTURE property");
        try {
          console.log("🖼️ Calling applyTextureProperty..."), Logger.info(`[ApplyMaterialProperty] Calling applyTextureProperty with path: '${a}' and value: '${n}'`), this.applyTextureProperty(e, a, n), console.log("🖼️ applyTextureProperty completed"), Logger.info("[ApplyMaterialProperty] ✓ Texture property applied successfully");
        } catch (h) {
          console.error("❌ Error in applyTextureProperty:", h), Logger.error("[ApplyMaterialProperty] ❌ Error in applyTextureProperty:", h);
        }
        return;
      }
      if (typeof n == "string" && n.startsWith("#")) {
        console.log("🎨 COLOR property detected (hex format)"), Logger.info("[ApplyMaterialProperty] ✓ Detected COLOR property (hex format)"), this.applySmartColorProperty(e, o, n), Logger.info("[ApplyMaterialProperty] ✓ Color property applied successfully");
        return;
      }
      console.log("⚙️ STANDARD property detected"), Logger.info("[ApplyMaterialProperty] ✓ Detected STANDARD property (boolean/number/string)"), this.applySmartStandardProperty(e, o, n), Logger.info("[ApplyMaterialProperty] ✓ Standard property applied successfully");
    } catch (a) {
      Logger.error(
        `[ApplyMaterialProperty] ❌ Error applying property '${t}' to material '${e.id}'`,
        a
      );
    }
  }
  /**
   * Normalizza il propertyPath per correggere casi malformati e inconsistenze
   * Es: "clearcoat.clearCoat_bumpTexture" → "clearCoat_bumpTexture"
   * Es: "anisotropic.anisotropy.texture" → "anisotropy.texture"
   * Es: "subsurface.tintColor" → "subSurface.tintColor"
   */
  normalizePropertyPath(e) {
    console.log(`🔧 [NormalizePropertyPath] Input: '${e}'`);
    const t = {
      subsurface: "subSurface",
      anisotropic: "anisotropy"
    };
    let n = e;
    for (const [a, o] of Object.entries(t)) {
      const h = new RegExp(`\\b${a}\\b`, "gi");
      n = n.replace(h, o);
    }
    if (n !== e && console.log(`🔧 [NormalizePropertyPath] Fixed property names: '${e}' → '${n}'`), n.includes(".")) {
      const a = n.split(".");
      if (a.length === 3 && a[0].toLowerCase() === a[1].toLowerCase())
        n = a[1] + "." + a[2], console.log(`🔧 [NormalizePropertyPath] Removed duplicate prefix: '${e}' → '${n}'`);
      else if (a.length === 2) {
        const o = a[0].toLowerCase();
        a[1].toLowerCase().startsWith(o + "_") && (n = a[1], console.log(`🔧 [NormalizePropertyPath] Fixed malformed underscore path: '${e}' → '${n}'`));
      }
    }
    return n !== e && Logger.info(`[NormalizePropertyPath] Normalized: '${e}' → '${n}'`), n;
  }
  /**
   * Abilita automaticamente le sotto-proprietà (clearCoat, sheen, subSurface, anisotropy) 
   * quando si sta per applicare una texture o proprietà su di esse
   */
  ensureSubPropertyEnabled(e, t) {
    const n = e;
    t.toLowerCase().includes("clearcoat") && (n.clearCoat.isEnabled || (n.clearCoat.isEnabled = !0, Logger.info(`[EnsureSubPropertyEnabled] ✅ Enabled clearCoat for material '${e.id}'`), console.log(`✅ Enabled clearCoat for material '${e.id}'`))), t.toLowerCase().includes("sheen") && (n.sheen.isEnabled || (n.sheen.isEnabled = !0, Logger.info(`[EnsureSubPropertyEnabled] ✅ Enabled sheen for material '${e.id}'`), console.log(`✅ Enabled sheen for material '${e.id}'`))), t.toLowerCase().includes("subsurface") && (n.subSurface.isEnabled || (n.subSurface.isEnabled = !0, Logger.info(`[EnsureSubPropertyEnabled] ✅ Enabled subSurface for material '${e.id}'`), console.log(`✅ Enabled subSurface for material '${e.id}'`))), t.toLowerCase().includes("anisotropy") && (n.anisotropy.isEnabled || (n.anisotropy.isEnabled = !0, Logger.info(`[EnsureSubPropertyEnabled] ✅ Enabled anisotropy for material '${e.id}'`), console.log(`✅ Enabled anisotropy for material '${e.id}'`)));
  }
  isTextureProperty(e) {
    return e.endsWith("Texture") || e.includes("_texture") || e.includes("TextureRoughnessTexture") || e.includes("bumpTexture") || e.includes("tintTexture");
  }
  applyTextureProperty(e, t, n) {
    console.log(`🖼️ [ApplyTextureProperty] ENTRY - Material: '${e.id}' | Path: '${t}' | URL: '${n}'`), Logger.info(`[ApplyTextureProperty] ENTRY - Material: '${e.id}' | Path: '${t}' | URL: '${n}'`);
    try {
      Logger.info(
        `[ApplyTextureProperty] Material: '${e.id}' | Path: '${t}' | URL: '${n}'`
      ), this.ensureSubPropertyEnabled(e, t), Logger.info(`[ApplyTextureProperty] Step 2: 🚩 Loading texture from URL: '${n}'`), Logger.info("[ApplyTextureProperty] 🔄 Step 2: Converting propertyPath to textureType..."), console.log(`[ApplyTextureProperty] 🔄 Step 2: Converting propertyPath '${t}' to textureType...`);
      const a = this.convertPropertyPathToTextureType(t);
      if (Logger.info(`[ApplyTextureProperty] Step 2: 🛠️ Converting propertyPath '${t}' to textureType '${a}'`), !a) {
        Logger.warn(`[ApplyTextureProperty] ❌ Step 2 FAILED: Could not convert propertyPath '${t}' to texture type`), console.error("[ApplyTextureProperty] ❌ Step 2 FAILED: Could not convert propertyPath");
        return;
      }
      if (Logger.info(`[ApplyTextureProperty] ✅ Step 2 SUCCESS: textureType = '${a}'`), console.log(`[ApplyTextureProperty] ✅ Step 2 SUCCESS: textureType = '${a}'`), Logger.info("[ApplyTextureProperty] 🚦 About to proceed to Step 3..."), console.log("[ApplyTextureProperty] 🚦 About to proceed to Step 3..."), Logger.info("[ApplyTextureProperty] 🔍 Step 3: Checking SceneHelper availability..."), console.log("[ApplyTextureProperty] 🔍 Step 3: SceneHelper check:", {
        hasSceneHelper: !!this._sceneHelper,
        sceneHelperType: typeof this._sceneHelper,
        sceneHelperValue: this._sceneHelper
      }), !this._sceneHelper) {
        Logger.warn("[ApplyTextureProperty] ❌ Step 3 FAILED: SceneHelper not available, trying to recreate..."), console.error("[ApplyTextureProperty] ❌ Step 3 FAILED: SceneHelper not available");
        try {
          this._sceneHelper = new di(this._scene), Logger.info("[ApplyTextureProperty] ✅ SceneHelper recreated successfully"), console.log("[ApplyTextureProperty] ✅ SceneHelper recreated successfully");
        } catch (h) {
          Logger.error("[ApplyTextureProperty] ❌ Failed to recreate SceneHelper:", h), console.error("[ApplyTextureProperty] ❌ Failed to recreate SceneHelper:", h);
          return;
        }
      }
      Logger.info("[ApplyTextureProperty] ✅ Step 3 SUCCESS: SceneHelper is available"), console.log("[ApplyTextureProperty] ✅ Step 3 SUCCESS: SceneHelper is available"), Logger.info("[ApplyTextureProperty] 🏗️ Step 4: Creating BABYLON.Texture object..."), console.log("[ApplyTextureProperty] 🏗️ Step 4: Creating BABYLON.Texture with params:", {
        url: n,
        noMipMap: !1,
        invertY: !0,
        samplingMode: "TRILINEAR"
      });
      const o = new BABYLON.Texture(
        n,
        this._scene,
        !1,
        // noMipMap: false (genera mipmaps come nel backoffice)
        !0,
        // invertY: true (default nel backoffice)
        BABYLON.Texture.TRILINEAR_SAMPLINGMODE,
        // sampling mode
        () => {
          Logger.info("[ApplyTextureProperty] 🔥 Texture onLoad callback fired!"), console.log("[ApplyTextureProperty] 🔥 Texture onLoad callback fired!"), this._scene.render();
        },
        (h) => {
          Logger.warn(`[ApplyTextureProperty] ❌ Texture onError callback fired: ${h}`), console.error("[ApplyTextureProperty] ❌ Texture onError callback fired:", h);
        }
      );
      Logger.info("[ApplyTextureProperty] ✅ Step 5: Texture object created"), console.log("[ApplyTextureProperty] ✅ Step 5: Texture object created:", o), Logger.info("[ApplyTextureProperty] 📝 Step 6: Setting texture metadata..."), console.log("[ApplyTextureProperty] 📝 Step 6: Setting texture metadata..."), o.metadata = { fileUrl: n }, o.name = t, Logger.info("[ApplyTextureProperty] ✅ Step 6: Metadata set"), console.log(`[ApplyTextureProperty] ✅ Step 6: Metadata set - name: '${t}', fileUrl: '${n}'`), Logger.info("[ApplyTextureProperty] ⏳ Step 7: Calling SceneHelper.whenTextureIsReadyAsync()..."), console.log("[ApplyTextureProperty] ⏳ Step 7: Calling SceneHelper.whenTextureIsReadyAsync()..."), console.log("[ApplyTextureProperty] Texture object:", o), console.log("[ApplyTextureProperty] Texture.isReady():", o.isReady ? o.isReady() : "isReady() not available"), console.log("[ApplyTextureProperty] SceneHelper.whenTextureIsReadyAsync exists?", typeof di.whenTextureIsReadyAsync), di.whenTextureIsReadyAsync(o).then(() => {
        var f, v, x, k, I, V;
        Logger.info("[ApplyTextureProperty] 🎉 Step 8: Texture is ready! Applying now..."), console.log("[ApplyTextureProperty] 🎉 Step 8: Texture is ready! Applying now..."), Logger.info("[ApplyTextureProperty] 🔧 Step 9: Calling SceneHelper.applyTexture()..."), console.log("[ApplyTextureProperty] 🔧 Step 9: Parameters - texture:", o, "material:", e, "type:", a), this._sceneHelper.applyTexture(o, e, a), Logger.info("[ApplyTextureProperty] ✅ Step 10: Applied texture via SceneHelper"), console.log("[ApplyTextureProperty] ✅ Step 10: Applied texture via SceneHelper"), Logger.info("[ApplyTextureProperty] 🔄 Step 11: Calling markMaterialDirty()..."), console.log("[ApplyTextureProperty] 🔄 Step 11: Calling markMaterialDirty()..."), this.markMaterialDirty(e), Logger.info("[ApplyTextureProperty] ✅ Step 12: markMaterialDirty() completed"), console.log("[ApplyTextureProperty] ✅ Step 12: markMaterialDirty() completed"), Logger.info("[ApplyTextureProperty] 🎨 Step 13: Calling scene.render()..."), console.log("[ApplyTextureProperty] 🎨 Step 13: Calling scene.render()..."), this._scene.render(), Logger.info("[ApplyTextureProperty] ✅ Step 14: scene.render() completed"), console.log("[ApplyTextureProperty] ✅ Step 14: scene.render() completed");
        const h = e;
        Logger.info("[ApplyTextureProperty] 📊 Step 15: Checking material state..."), console.log(`[DEBUG] 🎨 Step 15: Stato materiale '${e.id}' dopo applicazione texture:`), console.log("  - albedoTexture:", h.albedoTexture), console.log("  - albedoColor:", h.albedoColor), console.log("  - texture.isReady():", (v = (f = h.albedoTexture) == null ? void 0 : f.isReady) == null ? void 0 : v.call(f)), console.log("  - material.isReady():", (x = h.isReady) == null ? void 0 : x.call(h)), console.log("  - material.alpha:", h.alpha), console.log("  - material.disableLighting:", h.disableLighting), Logger.info(`[DEBUG] albedoTexture: ${h.albedoTexture ? "SET ✅" : "NULL ❌"}`), Logger.info(`[DEBUG] albedoColor: ${h.albedoColor}`), Logger.info(`[DEBUG] texture.isReady: ${(I = (k = h.albedoTexture) == null ? void 0 : k.isReady) == null ? void 0 : I.call(k)}`), Logger.info(`[DEBUG] material.isReady: ${(V = h.isReady) == null ? void 0 : V.call(h)}`), Logger.info("[ApplyTextureProperty] 🏁 TEXTURE APPLICATION COMPLETE!"), console.log("[ApplyTextureProperty] 🏁 TEXTURE APPLICATION COMPLETE!");
      }).catch((h) => {
        Logger.error("[ApplyTextureProperty] ❌ ERROR in Step 8 - Promise rejected:", h), console.error("[ApplyTextureProperty] ❌ ERROR in Step 8 - Promise rejected:", h), console.error("[ApplyTextureProperty] Error stack:", h == null ? void 0 : h.stack);
      });
    } catch (a) {
      Logger.error(
        `[ApplyTextureProperty] ❌ Error applying texture property '${t}' to material '${e.id}'`,
        a
      );
    }
  }
  /**
   * Converte un property path (es: "albedoTexture", "albedo.albedoTexture", "clearCoat_textureRoughnessTexture") 
   * in texture type per SceneHelper (es: "albedo", "clearCoat_textureRoughness")
   */
  convertPropertyPathToTextureType(e) {
    if (console.log(`[convertPropertyPathToTextureType] 🔄 Input: '${e}'`), Logger.info(`[convertPropertyPathToTextureType] Input: '${e}'`), e.includes(".")) {
      console.log("[convertPropertyPathToTextureType] 📍 Detected DOT notation");
      const a = e.split("."), o = a[0], h = a[1];
      console.log(`[convertPropertyPathToTextureType]   Base: '${o}', Texture: '${h}'`);
      let f = h;
      f.endsWith("Texture") && (f = f.substring(0, f.length - 7));
      const v = o;
      return console.log(`[convertPropertyPathToTextureType] ✅ Dot notation result: '${v}'`), Logger.info(`[convertPropertyPathToTextureType] Converted dot notation '${e}' → '${v}'`), v;
    }
    if (e.includes("_")) {
      console.log("[convertPropertyPathToTextureType] 🔗 Detected UNDERSCORE notation");
      let a = e;
      return a.endsWith("Texture") && (a = a.substring(0, a.length - 7)), console.log(`[convertPropertyPathToTextureType] ✅ Underscore notation result: '${a}'`), Logger.info(`[convertPropertyPathToTextureType] Converted underscore notation '${e}' → '${a}'`), a;
    }
    console.log("[convertPropertyPathToTextureType] 🗺️ Using DIRECT mapping");
    const n = {
      albedoTexture: "albedo",
      bumpTexture: "bump",
      metallicTexture: "metallic",
      reflectivityTexture: "reflectivity",
      emissiveTexture: "emissive",
      opacityTexture: "opacity",
      ambientTexture: "ambient",
      microsurfaceTexture: "microSurface",
      reflectionTexture: "reflection",
      matCapReflectionTexture: "matCapReflection",
      aoTexture: "ao"
    }[e] || null;
    return n ? (console.log(`[convertPropertyPathToTextureType] ✅ Direct mapping result: '${n}'`), Logger.info(`[convertPropertyPathToTextureType] Converted via direct mapping '${e}' → '${n}'`)) : (console.error(`[convertPropertyPathToTextureType] ❌ No mapping found for '${e}'`), Logger.warn(`[convertPropertyPathToTextureType] No mapping found for '${e}'`)), n;
  }
  /**
   * Fallback alla logica precedente per texture non mappabili
   */
  applyTexturePropertyFallback(e, t, n) {
    Logger.info(`[ApplyTexturePropertyFallback] Using direct assignment for '${t}'`);
    const a = e;
    t === "albedoTexture" ? (a.albedoTexture = n, this.markMaterialDirty(a), Logger.info(`[ApplyTexturePropertyFallback] ✓ Set albedoTexture for material '${e.id}'`)) : t === "bumpTexture" ? (a.bumpTexture = n, this.markMaterialDirty(a), Logger.info(`[ApplyTexturePropertyFallback] ✓ Set bumpTexture for material '${e.id}'`)) : Logger.warn(
      `[ApplyTexturePropertyFallback] ❌ Unknown texture property: ${t} for material '${e.id}'`
    );
  }
  removeTextureProperty(e, t) {
    Logger.info(`[RemoveTextureProperty] Material: '${e.id}' | Path: '${t}'`);
    const n = e;
    t === "clearCoat_textureRoughnessTexture" ? n.clearCoat && (n.clearCoat.texture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed clearCoat.texture for material '${e.id}'`)) : t === "clearCoat_bumpTexture" ? n.clearCoat && (n.clearCoat.bumpTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed clearCoat.bumpTexture for material '${e.id}'`)) : t === "clearCoat_tintTexture" ? n.clearCoat && (n.clearCoat.tintTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed clearCoat.tintTexture for material '${e.id}'`)) : t === "subSurface_thicknessTexture" ? n.subSurface && (n.subSurface.thicknessTexture = null, Logger.info(
      `[RemoveTextureProperty] ✓ Removed subSurface.thicknessTexture for material '${e.id}'`
    )) : t === "subSurface_tint_tintColorTexture" ? n.subSurface && (n.subSurface.tintColorTexture = null, Logger.info(
      `[RemoveTextureProperty] ✓ Removed subSurface.tintColorTexture for material '${e.id}'`
    )) : t === "subSurface_refractionTexture" ? n.subSurface && (n.subSurface.refractionTexture = null, Logger.info(
      `[RemoveTextureProperty] ✓ Removed subSurface.refractionTexture for material '${e.id}'`
    )) : t === "albedoTexture" ? (n.albedoTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed albedoTexture for material '${e.id}'`)) : t === "bumpTexture" ? (n.bumpTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed bumpTexture for material '${e.id}'`)) : t === "metallicTexture" ? (n.metallicTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed metallicTexture for material '${e.id}'`)) : t === "reflectivityTexture" ? (n.reflectivityTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed reflectivityTexture for material '${e.id}'`)) : t === "emissiveTexture" ? (n.emissiveTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed emissiveTexture for material '${e.id}'`)) : t === "opacityTexture" ? (n.opacityTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed opacityTexture for material '${e.id}'`)) : t === "ambientTexture" ? (n.ambientTexture = null, Logger.info(`[RemoveTextureProperty] ✓ Removed ambientTexture for material '${e.id}'`)) : Logger.warn(`[RemoveTextureProperty] ❌ Unknown texture property: ${t}`);
  }
  applyColorProperty(e, t, n) {
    try {
      console.log("🎨 ApplyColorProperty START"), console.log(`   Material: '${e.id}'`), console.log(`   Path: '${t}'`), console.log(`   Hex: '${n}'`), Logger.info(
        `[ApplyColorProperty] Material: '${e.id}' | Path: '${t}' | Hex: '${n}'`
      );
      const a = BABYLON.Color3.FromHexString(n);
      console.log(`🌈 Converted to Color3: R=${a.r.toFixed(3)}, G=${a.g.toFixed(3)}, B=${a.b.toFixed(3)}`), Logger.info(
        `[ApplyColorProperty] Converted to Color3: R=${a.r.toFixed(3)}, G=${a.g.toFixed(
          3
        )}, B=${a.b.toFixed(3)}`
      );
      const o = t.split(".");
      if (console.log(`📍 Path parts: [${o.join(" → ")}]`), Logger.info(`[ApplyColorProperty] Path parts: [${o.join(" → ")}]`), o.length === 2 && o[0] === "albedo") {
        const x = o[1];
        if (console.log(`🔍 Checking for direct property: '${x}'`), e.hasOwnProperty(x)) {
          console.log(`🔄 Smart fix: Found direct property '${x}' instead of '${t}'`), Logger.info(`[ApplyColorProperty] Smart fix: Using direct property '${x}' instead of nested path`);
          const k = e[x];
          e[x] = a, console.log(`✅ Applied color directly to '${x}'!`), console.log(`   Old value: ${k}`), console.log(`   New value: ${n} (Color3)`), Logger.info(`[ApplyColorProperty] ✓ Set direct property '${x}' | Old: ${k} | New: ${n}`);
          return;
        } else
          console.log(`⚠️ Direct property '${x}' not found, trying nested path...`);
      }
      let h = e;
      for (let x = 0; x < o.length - 1; x++) {
        const k = o[x];
        if (console.log(`🔍 Checking property: '${k}' on ${h.constructor.name}`), h[k] === void 0 || h[k] === null) {
          console.error(`❌ Property '${k}' does not exist on material '${e.id}'`), Logger.warn(
            `[ApplyColorProperty] ❌ Property path '${t}' is invalid: '${k}' does not exist on material '${e.id}'`
          );
          return;
        }
        console.log(`✅ Found property: '${k}'`), Logger.info(`[ApplyColorProperty] Navigating: ${k}`), h = h[k];
      }
      const f = o[o.length - 1], v = h[f];
      console.log(`🎯 Setting final property: '${f}'`), console.log(`   Old value: ${v}`), console.log(`   New value: ${n} (Color3)`), h[f] = a, console.log("✅ Color property applied successfully!"), Logger.info(
        `[ApplyColorProperty] ✓ Set color property '${t}' to material '${e.id}' | Old: ${v} | New: ${n}`
      );
    } catch (a) {
      Logger.error(
        `[ApplyColorProperty] ❌ Error applying color property '${t}' to material '${e.id}'`,
        a
      );
    }
  }
  applyStandardProperty(e, t, n) {
    try {
      Logger.info(
        `[ApplyStandardProperty] Material: '${e.id}' | Path: '${t}' | Value: '${n}' | Type: ${typeof n}`
      );
      const a = t.split(".");
      if (Logger.info(`[ApplyStandardProperty] Path parts: [${a.join(" → ")}]`), a.length === 2 && a[0] === "albedo") {
        const x = a[1];
        if (e.hasOwnProperty(x)) {
          Logger.info(`[ApplyStandardProperty] Smart fix: Using direct property '${x}' instead of nested path`);
          const k = e[x];
          let I = n;
          if (typeof k == "boolean")
            I = n === "true" || n === !0;
          else if (typeof k == "number") {
            if (I = parseFloat(n), isNaN(I)) {
              Logger.warn(`[ApplyStandardProperty] ❌ Cannot convert '${n}' to number for property '${t}'`);
              return;
            }
          } else
            typeof k == "string" && (I = String(n));
          e[x] = I, Logger.info(`[ApplyStandardProperty] ✓ Set direct property '${x}' | Old: ${k} | New: ${I}`);
          return;
        }
      }
      let o = e;
      for (let x = 0; x < a.length - 1; x++) {
        const k = a[x];
        if (o[k] === void 0 || o[k] === null) {
          Logger.warn(
            `[ApplyStandardProperty] ❌ Property path '${t}' is invalid: '${k}' does not exist on material '${e.id}'`
          );
          return;
        }
        Logger.info(`[ApplyStandardProperty] Navigating: ${k}`), o = o[k];
      }
      const h = a[a.length - 1], f = o[h];
      Logger.info(
        `[ApplyStandardProperty] Final property: '${h}' | Old value: '${f}' | Old type: ${typeof f}`
      );
      let v = n;
      if (typeof f == "boolean")
        v = n === "true" || n === !0, Logger.info(
          `[ApplyStandardProperty] Type conversion: String → Boolean | "${n}" → ${v}`
        );
      else if (typeof f == "number") {
        if (v = parseFloat(n), isNaN(v)) {
          Logger.warn(
            `[ApplyStandardProperty] ❌ Cannot convert '${n}' to number for property '${t}'`
          );
          return;
        }
        Logger.info(
          `[ApplyStandardProperty] Type conversion: String → Number | "${n}" → ${v}`
        );
      } else if (typeof f == "string")
        v = String(n), Logger.info(
          `[ApplyStandardProperty] Type conversion: String → String | "${n}" → "${v}"`
        );
      else if (f instanceof BABYLON.Color3)
        if (typeof n == "string" && n.startsWith("#"))
          v = BABYLON.Color3.FromHexString(n), Logger.info(`[ApplyStandardProperty] Type conversion: Hex → Color3 | "${n}" → Color3`);
        else {
          Logger.warn(
            `[ApplyStandardProperty] ❌ Expected hex color for property '${t}', got: ${n}`
          );
          return;
        }
      else
        Logger.info("[ApplyStandardProperty] No type conversion needed, using value as-is");
      o[h] = v, Logger.info(
        `[ApplyStandardProperty] ✓ Set property '${t}' to material '${e.id}' | Old: ${f} | New: ${v}`
      );
    } catch (a) {
      Logger.error(
        `[ApplyStandardProperty] ❌ Error applying standard property '${t}' to material '${e.id}'`,
        a
      );
    }
  }
  async prefetchMeshesForUnselectedOptionsAsync(e) {
    if (this._zkScene && this._scene && this._elementSelector && this._sceneHelper && this._prefetchMeshes)
      for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n && n instanceof MPlaza.AttributeSceneAction && n.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && n.get("value") == "show") {
          const a = n.get("selector");
          if (a != null && a != null) {
            const o = this._elementSelector.getElements(
              this._zkScene,
              this._scene,
              null,
              a,
              MPlaza.SceneElementType.Mesh
            );
            for (let h = 0; h < o.length; h++) {
              const f = o[h];
              if (f instanceof BABYLON.AbstractMesh && !f.isVisible) {
                this._sceneHelper.checkDelayState(f);
                const v = f.material;
                v && await this._sceneHelper.prefetchTexturesForMaterialAsync(v);
              }
            }
          }
        }
      }
  }
  async checkActionsAssetsAreReadyAsync(e) {
    if (this._zkScene && this._scene && this._elementSelector && this._sceneHelper) {
      for (let t = 0; t < e.length; t++) {
        const n = e[t], a = [];
        if (n && n instanceof MPlaza.AttributeSceneAction && n.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && n.get("value") === "show") {
          const o = n.get("selector");
          if (o != null) {
            const h = this._elementSelector.getElements(
              this._zkScene,
              this._scene,
              null,
              o,
              MPlaza.SceneElementType.Mesh
            );
            for (let f = 0; f < h.length; f++) {
              const v = h[f];
              if (v instanceof BABYLON.AbstractMesh && !v.isVisible) {
                const x = this._zkScene.get("rootUrl");
                if (x) {
                  const k = this._sceneHelper.getMeshDelayedMaterialIDs(v), I = this._sceneHelper.getMeshOffloadedMaterialIDs(v);
                  k.length > 0 && await this._sceneHelper.loadDelayedMaterialsAsync(
                    x,
                    k
                  ), I.length > 0 && await this._sceneHelper.loadOffloadedMaterialsByIDsAsync(
                    x,
                    I
                  );
                }
                a.push(v);
              }
            }
          }
        }
        await di.whenAllMeshesAreReadyAsync(a);
      }
      for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n && n instanceof MPlaza.AttributeSceneAction) {
          if (n.get("actionTypeID") === MPlaza.SceneActionType.SetMeshMaterial || n.get("actionTypeID") === MPlaza.SceneActionType.SetSubMeshMaterial) {
            let a = this.getMaterialFromActionValue(n);
            a || (a = await this.getDeepMaterialFromActionValueAsync(n));
          }
          if (n.get("actionTypeID") === MPlaza.SceneActionType.SetMaterialColor) {
            const a = n.get("selector");
            a != null && await this.getAllMaterialElementsAsync(a);
          }
        }
      }
    }
  }
  async prefetchDataForUnselectedOptionsAsync(e) {
  }
  // Nuovo metodo per risolvere dinamicamente i path delle proprietà basandosi sulla struttura reale del materiale
  resolveMaterialPropertyPath(e, t) {
    try {
      if (console.log(`🔍 Resolving property path: '${t}' on ${e.getClassName()}`), t.includes("_")) {
        const o = t.split("_"), h = o[0], f = o.slice(1).join("_");
        console.log(`🔗 Underscore notation detected: subProperty='${h}', finalProperty='${f}'`);
        const v = e;
        if (v[h] !== void 0 && v[h] !== null) {
          const x = v[h];
          if (x[f] !== void 0)
            return console.log(`✅ Found underscore notation property: material.${h}.${f}`), {
              target: x,
              property: f,
              description: `Underscore notation: material.${h}.${f}`
            };
          console.warn(`⚠️ Property '${f}' not found in material.${h}`);
        } else
          console.warn(`⚠️ Sub-property '${h}' not found on material`);
      }
      const n = t.split("."), a = n[n.length - 1];
      if (n.length === 1 && e[a] !== void 0)
        return console.log(`✅ Found direct property: ${a}`), {
          target: e,
          property: a,
          description: `Direct property: material.${a}`
        };
      if (n.length > 1) {
        let o = e;
        for (let h = 0; h < n.length - 1; h++) {
          const f = n[h];
          if (o[f] !== void 0 && o[f] !== null)
            o = o[f];
          else {
            o = null;
            break;
          }
        }
        if (o && o[a] !== void 0)
          return console.log(`✅ Found nested property: ${t}`), {
            target: o,
            property: a,
            description: `Nested property: material.${t}`
          };
        if (e[a] !== void 0)
          return console.log(`✅ Found direct property as fallback: ${a} (from ${t})`), {
            target: e,
            property: a,
            description: `Direct property (fallback): material.${a} (requested: ${t})`
          };
      }
      return console.error(`❌ Property '${t}' not found on material`), null;
    } catch (n) {
      return console.error(`❌ Error resolving property path '${t}':`, n), null;
    }
  }
  applySmartColorProperty(e, t, n) {
    try {
      console.log("🎨 ApplySmartColorProperty START"), console.log(`   ${t.description}`), console.log(`   Hex: '${n}'`);
      const a = BABYLON.Color3.FromHexString(n);
      console.log(`🌈 Converted to Color3: R=${a.r.toFixed(3)}, G=${a.g.toFixed(3)}, B=${a.b.toFixed(3)}`);
      const o = t.target[t.property];
      console.log(`   Old value: ${o}`), t.target[t.property] = a, console.log("✅ Smart color property applied successfully!"), Logger.info(`[ApplySmartColorProperty] ✓ Set ${t.description} | Old: ${o} | New: ${n}`);
    } catch (a) {
      console.error("❌ Error in applySmartColorProperty:", a), Logger.error(`[ApplySmartColorProperty] ❌ Error: ${a}`);
    }
  }
  applySmartStandardProperty(e, t, n) {
    try {
      console.log("⚙️ ApplySmartStandardProperty START"), console.log(`   ${t.description}`), console.log(`   Value: '${n}' (${typeof n})`);
      const a = t.target[t.property];
      console.log(`   Old value: '${a}' (${typeof a})`);
      let o = n;
      if (typeof a == "boolean")
        o = n === "true" || n === !0, console.log(`🔄 Type conversion: String → Boolean | "${n}" → ${o}`);
      else if (typeof a == "number") {
        if (o = parseFloat(n), isNaN(o)) {
          console.error(`❌ Cannot convert '${n}' to number`);
          return;
        }
        console.log(`🔄 Type conversion: String → Number | "${n}" → ${o}`);
      } else if (typeof a == "string")
        o = String(n), console.log(`🔄 Type conversion: String → String | "${n}" → "${o}"`);
      else if (a instanceof BABYLON.Color3)
        if (typeof n == "string" && n.startsWith("#"))
          o = BABYLON.Color3.FromHexString(n), console.log(`🔄 Type conversion: Hex → Color3 | "${n}" → Color3`);
        else {
          console.error(`❌ Expected hex color, got: ${n}`);
          return;
        }
      t.target[t.property] = o, console.log("✅ Smart standard property applied successfully!"), Logger.info(`[ApplySmartStandardProperty] ✓ Set ${t.description} | Old: ${a} | New: ${o}`);
    } catch (a) {
      console.error("❌ Error in applySmartStandardProperty:", a), Logger.error(`[ApplySmartStandardProperty] ❌ Error: ${a}`);
    }
  }
  /**
   * Forza il refresh del materiale dopo l'assegnazione di texture
   */
  markMaterialDirty(e) {
    try {
      typeof e.markDirty == "function" ? (e.markDirty(), Logger.info(`[MarkMaterialDirty] ✓ Called material.markDirty() for '${e.id}'`)) : typeof e._markAllSubMeshesAsTexturesDirty == "function" ? (e._markAllSubMeshesAsTexturesDirty(), Logger.info(`[MarkMaterialDirty] ✓ Called _markAllSubMeshesAsTexturesDirty() for '${e.id}'`)) : (this._scene.markAllMaterialsAsDirty(BABYLON.Material.TextureDirtyFlag), Logger.info("[MarkMaterialDirty] ✓ Marked all materials as texture dirty for scene"));
    } catch (t) {
      Logger.warn(`[MarkMaterialDirty] ⚠️ Could not mark material '${e.id}' as dirty: ${t}`);
    }
  }
}
class Xx {
  constructor() {
    this._zkScene = null, this._scene = null, this._sceneHelper = null, this._meshLocationCache = {}, this._cameraAnimationCompletedListeners = [], this._meshAnimationCompletedListeners = [], this._beforeSaveMeshLocationListeners = [], this._afterSaveMeshLocationListeners = [];
  }
  dispose() {
    for (; this._cameraAnimationCompletedListeners.length > 0; )
      this._cameraAnimationCompletedListeners.pop();
    for (; this._meshAnimationCompletedListeners.length > 0; )
      this._meshAnimationCompletedListeners.pop();
    for (; this._beforeSaveMeshLocationListeners.length > 0; )
      this._beforeSaveMeshLocationListeners.pop();
    for (; this._afterSaveMeshLocationListeners.length > 0; )
      this._afterSaveMeshLocationListeners.pop();
    this.disposeSceneHelper();
  }
  setScene(e) {
    this._scene = e, this.resetSceneHelper(), this.resetCache();
  }
  setModel(e) {
    this._zkScene = e, this.resetCache();
  }
  setModelAndScene(e, t) {
    this._zkScene = e, this._scene = t, this.resetSceneHelper(), this.resetCache();
  }
  resetCache() {
    this._meshLocationCache = {};
  }
  invalidateCache(e) {
    this._meshLocationCache && delete this._meshLocationCache[e];
  }
  disposeSceneHelper() {
    this._sceneHelper && (this._sceneHelper.dispose(), this._sceneHelper = null);
  }
  resetSceneHelper() {
    this.disposeSceneHelper(), this._scene && (this._sceneHelper = new di(this._scene));
  }
  clearMeshLocations() {
    if (this._zkScene) {
      const e = this._zkScene.get("meshLocations");
      for (; e.length > 0; )
        e.remove(e.at(0));
    }
  }
  async setMeshLocationByID(e) {
    if (this._zkScene && this._scene) {
      const t = this._zkScene.getMeshLocation(e);
      t && await this.setMeshLocation(t);
    }
  }
  async setMeshLocation(e) {
    if (this._zkScene && this._scene && this._sceneHelper) {
      let x, k = !0;
      if (e) {
        let I = e.get("locationID");
        if (k = e.get("adjustCamera"), this._meshLocationCache.hasOwnProperty(I))
          x = this._meshLocationCache[I];
        else {
          let V = e.get("data"), M = null;
          if (typeof V == "string") {
            let W = window.atob(V), U = W.length, Q = new Uint8Array(U);
            for (let ee = 0; ee < U; ee++)
              Q[ee] = W.charCodeAt(ee);
            let D = Q.buffer;
            M = new Uint8Array(D);
          } else
            Object.prototype.toString.call(V) === "[object Array]" && (M = Uint8Array.from(V));
          if (M != null) {
            let W = LZString.decompressFromUint8Array(M);
            if (x = JSON.parse(W), x) {
              for (var t in x) {
                var n = x[t];
                n.p && (n.p = new BABYLON.Vector3(n.p.x, n.p.y, n.p.z)), n.rE && (n.rE = new BABYLON.Vector3(n.rE.x, n.rE.y, n.rE.z)), n.rQ && (n.rQ = new BABYLON.Quaternion(n.rQ.x, n.rQ.y, n.rQ.z, n.rQ.w)), n.s && (n.s = new BABYLON.Vector3(n.s.x, n.s.y, n.s.z));
              }
              this._meshLocationCache[I] = x;
            }
          }
        }
      }
      if (x) {
        const I = [];
        if (k && x.hasOwnProperty("wemin") && x.hasOwnProperty("wemax")) {
          var a = {
            min: new BABYLON.Vector3(x.wemin.x, x.wemin.y, x.wemin.z),
            max: new BABYLON.Vector3(x.wemax.x, x.wemax.y, x.wemax.z)
          };
          let V = this._sceneHelper.camera;
          if (V && V instanceof BABYLON.ArcRotateCamera) {
            V.upperRadiusLimit = null;
            var o = this._sceneHelper.calculateCameraRadius(a), h = this._sceneHelper.getWorldCenter(a);
            h && (this._sceneHelper.setCameraRadiusParameters(o), I.push(new Promise((M) => {
              V && V instanceof BABYLON.ArcRotateCamera && this._sceneHelper.animateCameraToFinalParamters(V.alpha, V.beta, o, h, 1, () => {
                this._sceneHelper && (this._sceneHelper.setupCameraLimits(a), this.fireCameraAnimationCompletedEvent(), M());
              });
            })));
          }
        }
        for (var f = 0; f < this._scene.meshes.length; f++) {
          var v = this._scene.meshes[f], t = v.id;
          if (x.hasOwnProperty(t)) {
            var n = x[t];
            I.push(new Promise((W) => {
              this._sceneHelper.animateMeshToFinalParameters(v, n.p, n.rE, n.rQ, n.s, 1, () => {
                this.fireMeshAnimationCompletedEvent(), W();
              });
            }));
          }
        }
        await Promise.all(I);
      }
    }
  }
  saveMeshLocation(e) {
    if (this._zkScene && this._scene) {
      var t = new Zakeke.SceneMeshLocation();
      t.set("name", e), this.updateMeshLocation(t), this._zkScene.get("meshLocations").push(t);
    }
  }
  saveExplodedMeshLocation() {
    if (this._zkScene && this._scene) {
      var e = this._zkScene.getOrCreateExplodedMeshLocation();
      this.updateMeshLocation(e);
    }
  }
  saveCollapsedMeshLocation() {
    if (this._zkScene && this._scene) {
      var e = this._zkScene.getOrCreateCollapsedMeshLocation();
      this.updateMeshLocation(e);
    }
  }
  updateMeshLocation(e) {
    if (this.fireBeforeSaveMeshLocationEvent(), this._scene && this._sceneHelper) {
      var t = this.getMeshPRSs(), n = this._sceneHelper.getWorldExtends();
      if (n) {
        let f = {
          x: n.min.x,
          y: n.min.y,
          z: n.min.z
        }, v = {
          x: n.max.x,
          y: n.max.y,
          z: n.max.z
        };
        t.wemin = f, t.wemax = v;
      }
      var a = JSON.stringify(t);
      let o = LZString.compressToUint8Array(a), h = [].slice.call(o);
      e.set("data", h), this.invalidateCache(e.get("locationID"));
    }
    this.fireAfterSaveMeshLocationEvent();
  }
  getMeshPRSs() {
    let e = {
      wemin: void 0,
      wemax: void 0
    };
    if (this._scene && this._sceneHelper)
      for (let t = 0; t < this._scene.meshes.length; t++) {
        const n = this._scene.meshes[t];
        if (this._sceneHelper.isRealMesh(n)) {
          let a = n.id, o = {
            p: void 0,
            rQ: void 0,
            rE: void 0,
            s: void 0
          }, h = {
            x: n.position.x,
            y: n.position.y,
            z: n.position.z
          };
          if (o.p = h, n.rotationQuaternion == null) {
            o.rQ = null;
            let v = {
              x: n.rotation.x,
              y: n.rotation.y,
              z: n.rotation.z
            };
            o.rE = v;
          } else {
            let v = {
              w: n.rotationQuaternion.w,
              x: n.rotationQuaternion.x,
              y: n.rotationQuaternion.y,
              z: n.rotationQuaternion.z
            };
            o.rQ = v, o.rE = null;
          }
          let f = {
            x: n.scaling.x,
            y: n.scaling.y,
            z: n.scaling.z
          };
          o.s = f, e[a] = o;
        }
      }
    return e;
  }
  async explodeMeshes() {
    if (this._zkScene) {
      let e = this._zkScene.getFirstExplodedMeshLocation();
      e && await this.setMeshLocation(e);
    }
  }
  async collapseMeshes() {
    if (this._zkScene) {
      let e = this._zkScene.getFirstCollapsedMeshLocation();
      e && await this.setMeshLocation(e);
    }
  }
  // Events
  fireCameraAnimationCompletedEvent() {
    for (let e = 0; e < this._cameraAnimationCompletedListeners.length; ++e)
      this._cameraAnimationCompletedListeners[e]();
  }
  addCameraAnimationCompletedListener(e) {
    this._cameraAnimationCompletedListeners.push(e);
  }
  fireMeshAnimationCompletedEvent() {
    for (let e = 0; e < this._meshAnimationCompletedListeners.length; ++e)
      this._meshAnimationCompletedListeners[e]();
  }
  addMeshAnimationCompletedListener(e) {
    this._meshAnimationCompletedListeners.push(e);
  }
  fireBeforeSaveMeshLocationEvent() {
    for (let e = 0; e < this._beforeSaveMeshLocationListeners.length; ++e)
      this._beforeSaveMeshLocationListeners[e]();
  }
  addBeforeSaveMeshLocationListener(e) {
    this._beforeSaveMeshLocationListeners.push(e);
  }
  fireAfterSaveMeshLocationEvent() {
    for (let e = 0; e < this._afterSaveMeshLocationListeners.length; ++e)
      this._afterSaveMeshLocationListeners[e]();
  }
  addAfterSaveMeshLocationListener(e) {
    this._afterSaveMeshLocationListeners.push(e);
  }
}
class Kx {
  constructor(e, t) {
    this._glowLayer = null, this._zkScene = e, this._scene = t, this._sceneHelper = new di(this._scene), this._glowLayer = this._scene.getGlowLayerByName("glow");
  }
  get enabled() {
    const e = this.getGlowConfig();
    return e && e.get("enabled") != null && typeof e.get("enabled") == "boolean" && e.get("enabled"), !1;
  }
  set enabled(e) {
    var t = this.getOrCreateGlowConfig();
    t && t.set("enabled", e), this.update();
  }
  get intensity() {
    const e = this.getGlowConfig();
    return e && e.get("intensity") != null && typeof e.get("intensity") == "number" && e.get("intensity"), 1;
  }
  set intensity(e) {
    var t = this.getOrCreateGlowConfig();
    t && t.set("intensity", e), this.update();
  }
  get blurSize() {
    const e = this.getGlowConfig();
    return e && e.get("blurSize") != null && typeof e.get("blurSize") == "number" && e.get("blurSize"), 1;
  }
  set blurSize(e) {
    var t = this.getOrCreateGlowConfig();
    t && t.set("blurSize", e), this.update();
  }
  dispose() {
    this.destroyGlowLayer();
  }
  destroyGlowLayer() {
    this._glowLayer && (this._glowLayer.dispose(), this._glowLayer = null);
  }
  createOrUpdateGlowLayer(e, t) {
    this._glowLayer || (this._glowLayer = new BABYLON.GlowLayer("glow", this._scene)), this._glowLayer && (this._glowLayer.intensity = e, this._glowLayer.blurKernelSize = t);
  }
  update() {
    if (this._scene) {
      var e = this.getGlowConfig();
      if (e) {
        const t = this.enabled, n = this.intensity, a = this.blurSize;
        t ? this.createOrUpdateGlowLayer(n, a) : this.destroyGlowLayer();
      } else
        this.destroyGlowLayer();
    }
  }
  turnOffGlow() {
    this.destroyGlowLayer();
  }
  turnOnGlow() {
    this.update();
  }
  sanityCheck() {
    return this._scene && this._scene instanceof BABYLON.Scene && this._zkScene && this._zkScene instanceof Zakeke.Scene && this._zkScene.get("config") != null && this._zkScene.get("config") != null && this._zkScene.get("config") instanceof Zakeke.SceneConfig;
  }
  isGlowEnabledForMesh(e) {
    return e ? e.metadata && e.metadata.enableGlow : !1;
  }
  // La possibilità di abilitare solo alcune mesh al glow viene disabilitata
  // perché c'è il problema che l'effetto glow è visibile attraverso le mesh
  // per cui il glow è diabilitato
  enableGlowForMesh(e) {
  }
  disableGlowForMesh(e) {
  }
  getGlowConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getGlowConfig();
      if (e)
        return e;
    }
    return null;
  }
  getOrCreateGlowConfig() {
    return this.sanityCheck() ? this._zkScene.getOrCreateGlowConfig() : null;
  }
}
class pu {
  /**
   * Constructor
   * @param workers Array of workers to use for actions
   */
  constructor(e) {
    this._pendingActions = new Array(), this._workerInfos = e.map((t) => ({
      worker: t,
      active: !1
    }));
  }
  /**
   * Terminates all workers and clears any pending actions.
   */
  dispose() {
    for (const e of this._workerInfos)
      e.worker.terminate();
    delete this._workerInfos, delete this._pendingActions;
  }
  /**
   * Pushes an action to the worker pool. If all the workers are active, the action will be
   * pended until a worker has completed its action.
   * @param action The action to perform. Call onComplete when the action is complete.
   */
  push(e) {
    for (const t of this._workerInfos)
      if (!t.active) {
        this._execute(t, e);
        return;
      }
    this._pendingActions.push(e);
  }
  _execute(e, t) {
    e.active = !0, t(e.worker, () => {
      e.active = !1;
      const n = this._pendingActions.shift();
      n && this._execute(e, n);
    });
  }
}
function Yd(b) {
  return typeof importScripts == "function" ? (importScripts(b), Promise.resolve()) : new Promise((e, t) => {
    BABYLON.Tools.LoadScript(b, () => {
      e();
    }, (n) => {
      t(new Error(n));
    });
  });
}
function Gd(b) {
  if (b.length == 0)
    return Promise.resolve();
  let e = [];
  for (let t = 0; t < b.length; t++)
    e.push(Yd(b[t]));
  return new Promise((t) => {
    Promise.all(e).then(() => t());
  });
}
function jd(b, e, t) {
  return new MakeIncremental().getSceneIncrementalFiles(b, e, t);
}
function Jx() {
  let b;
  onmessage = (e) => {
    const t = e.data;
    switch (t.id) {
      case "init": {
        const n = t.urls;
        b = Gd(n), postMessage("done");
        break;
      }
      case "makeIncremental": {
        if (!b)
          throw new Error("Worker not initialized");
        b.then(() => {
          const n = t.sceneJson, a = t.version, o = t.options, h = jd(n, a, o);
          postMessage({ id: "result", files: h }), postMessage("done");
        });
        break;
      }
    }
  };
}
function Qx(b) {
  return typeof document != "object" || typeof b != "string" ? b : BABYLON.Tools.GetAbsoluteUrl(b);
}
const _l = class ba {
  static GetDefaultNumWorkers() {
    return typeof navigator != "object" || !navigator.hardwareConcurrency ? 1 : Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 2);
  }
  /**
   * Default instance for the incremental file maker
   */
  static get Default() {
    return ba._Default || (ba._Default = new ba([])), ba._Default;
  }
  /**
   * Constructor
   * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
  */
  constructor(e, t = ba.DefaultNumWorkers) {
    const n = e.map((a) => Qx(a));
    if (t && typeof Worker == "function") {
      const a = `${Yd}${Gd}${jd}(${Jx})()`, o = URL.createObjectURL(new Blob([a], { type: "application/javascript" })), h = new Array(t);
      for (let f = 0; f < h.length; f++)
        h[f] = new Promise((v, x) => {
          const k = new Worker(o), I = (M) => {
            k.removeEventListener("error", I), k.removeEventListener("message", V), x(M);
          }, V = (M) => {
            M.data === "done" && (k.removeEventListener("error", I), k.removeEventListener("message", V), v(k));
          };
          k.addEventListener("error", I), k.addEventListener("message", V), k.postMessage({
            id: "init",
            urls: n
          });
        });
      this._workerPoolPromise = Promise.all(h).then((f) => new pu(f));
    }
  }
  dispose() {
  }
  /**
   * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
   * @returns a promise that resolves when ready
   */
  whenReadyAsync() {
    return this._workerPoolPromise ? this._workerPoolPromise.then(() => {
    }) : Promise.resolve();
  }
  getIncrementalFilesAsync(e, t, n) {
    if (this._workerPoolPromise)
      return this._workerPoolPromise.then((a) => new Promise((o, h) => {
        a.push((f, v) => {
          let x = [];
          const k = (V) => {
            f.removeEventListener("error", k), f.removeEventListener("message", I), h(V), v();
          }, I = (V) => {
            V.data === "done" ? (f.removeEventListener("error", k), f.removeEventListener("message", I), o(x), v()) : V.data.id === "result" && (x = V.data.files);
          };
          f.addEventListener("error", k), f.addEventListener("message", I), f.postMessage({ id: "makeIncremental", sceneJson: e, version: t, options: n });
        });
      }));
    throw new Error("Incremental file worker is not available");
  }
};
_l.DefaultNumWorkers = _l.GetDefaultNumWorkers();
_l._Default = null;
let ew = _l;
var Wd = { exports: {} };
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
(function(b) {
  (function(e, t) {
    b.exports = e.document ? t(e, !0) : function(n) {
      if (!n.document)
        throw new Error("jQuery requires a window with a document");
      return t(n);
    };
  })(typeof window < "u" ? window : ts, function(e, t) {
    var n = [], a = Object.getPrototypeOf, o = n.slice, h = n.flat ? function(w) {
      return n.flat.call(w);
    } : function(w) {
      return n.concat.apply([], w);
    }, f = n.push, v = n.indexOf, x = {}, k = x.toString, I = x.hasOwnProperty, V = I.toString, M = V.call(Object), W = {}, U = function(P) {
      return typeof P == "function" && typeof P.nodeType != "number" && typeof P.item != "function";
    }, Q = function(P) {
      return P != null && P === P.window;
    }, D = e.document, ee = {
      type: !0,
      src: !0,
      nonce: !0,
      noModule: !0
    };
    function J(w, P, K) {
      K = K || D;
      var ne, ge, _e = K.createElement("script");
      if (_e.text = w, P)
        for (ne in ee)
          ge = P[ne] || P.getAttribute && P.getAttribute(ne), ge && _e.setAttribute(ne, ge);
      K.head.appendChild(_e).parentNode.removeChild(_e);
    }
    function he(w) {
      return w == null ? w + "" : typeof w == "object" || typeof w == "function" ? x[k.call(w)] || "object" : typeof w;
    }
    var fe = "3.7.1", X = /HTML$/i, Z = function(w, P) {
      return new Z.fn.init(w, P);
    };
    Z.fn = Z.prototype = {
      // The current version of jQuery being used
      jquery: fe,
      constructor: Z,
      // The default length of a jQuery object is 0
      length: 0,
      toArray: function() {
        return o.call(this);
      },
      // Get the Nth element in the matched element set OR
      // Get the whole matched element set as a clean array
      get: function(w) {
        return w == null ? o.call(this) : w < 0 ? this[w + this.length] : this[w];
      },
      // Take an array of elements and push it onto the stack
      // (returning the new matched element set)
      pushStack: function(w) {
        var P = Z.merge(this.constructor(), w);
        return P.prevObject = this, P;
      },
      // Execute a callback for every element in the matched set.
      each: function(w) {
        return Z.each(this, w);
      },
      map: function(w) {
        return this.pushStack(Z.map(this, function(P, K) {
          return w.call(P, K, P);
        }));
      },
      slice: function() {
        return this.pushStack(o.apply(this, arguments));
      },
      first: function() {
        return this.eq(0);
      },
      last: function() {
        return this.eq(-1);
      },
      even: function() {
        return this.pushStack(Z.grep(this, function(w, P) {
          return (P + 1) % 2;
        }));
      },
      odd: function() {
        return this.pushStack(Z.grep(this, function(w, P) {
          return P % 2;
        }));
      },
      eq: function(w) {
        var P = this.length, K = +w + (w < 0 ? P : 0);
        return this.pushStack(K >= 0 && K < P ? [this[K]] : []);
      },
      end: function() {
        return this.prevObject || this.constructor();
      },
      // For internal use only.
      // Behaves like an Array's method, not like a jQuery method.
      push: f,
      sort: n.sort,
      splice: n.splice
    }, Z.extend = Z.fn.extend = function() {
      var w, P, K, ne, ge, _e, be = arguments[0] || {}, He = 1, De = arguments.length, Je = !1;
      for (typeof be == "boolean" && (Je = be, be = arguments[He] || {}, He++), typeof be != "object" && !U(be) && (be = {}), He === De && (be = this, He--); He < De; He++)
        if ((w = arguments[He]) != null)
          for (P in w)
            ne = w[P], !(P === "__proto__" || be === ne) && (Je && ne && (Z.isPlainObject(ne) || (ge = Array.isArray(ne))) ? (K = be[P], ge && !Array.isArray(K) ? _e = [] : !ge && !Z.isPlainObject(K) ? _e = {} : _e = K, ge = !1, be[P] = Z.extend(Je, _e, ne)) : ne !== void 0 && (be[P] = ne));
      return be;
    }, Z.extend({
      // Unique for each copy of jQuery on the page
      expando: "jQuery" + (fe + Math.random()).replace(/\D/g, ""),
      // Assume jQuery is ready without the ready module
      isReady: !0,
      error: function(w) {
        throw new Error(w);
      },
      noop: function() {
      },
      isPlainObject: function(w) {
        var P, K;
        return !w || k.call(w) !== "[object Object]" ? !1 : (P = a(w), P ? (K = I.call(P, "constructor") && P.constructor, typeof K == "function" && V.call(K) === M) : !0);
      },
      isEmptyObject: function(w) {
        var P;
        for (P in w)
          return !1;
        return !0;
      },
      // Evaluates a script in a provided context; falls back to the global one
      // if not specified.
      globalEval: function(w, P, K) {
        J(w, { nonce: P && P.nonce }, K);
      },
      each: function(w, P) {
        var K, ne = 0;
        if (qe(w))
          for (K = w.length; ne < K && P.call(w[ne], ne, w[ne]) !== !1; ne++)
            ;
        else
          for (ne in w)
            if (P.call(w[ne], ne, w[ne]) === !1)
              break;
        return w;
      },
      // Retrieve the text value of an array of DOM nodes
      text: function(w) {
        var P, K = "", ne = 0, ge = w.nodeType;
        if (!ge)
          for (; P = w[ne++]; )
            K += Z.text(P);
        return ge === 1 || ge === 11 ? w.textContent : ge === 9 ? w.documentElement.textContent : ge === 3 || ge === 4 ? w.nodeValue : K;
      },
      // results is for internal usage only
      makeArray: function(w, P) {
        var K = P || [];
        return w != null && (qe(Object(w)) ? Z.merge(
          K,
          typeof w == "string" ? [w] : w
        ) : f.call(K, w)), K;
      },
      inArray: function(w, P, K) {
        return P == null ? -1 : v.call(P, w, K);
      },
      isXMLDoc: function(w) {
        var P = w && w.namespaceURI, K = w && (w.ownerDocument || w).documentElement;
        return !X.test(P || K && K.nodeName || "HTML");
      },
      // Support: Android <=4.0 only, PhantomJS 1 only
      // push.apply(_, arraylike) throws on ancient WebKit
      merge: function(w, P) {
        for (var K = +P.length, ne = 0, ge = w.length; ne < K; ne++)
          w[ge++] = P[ne];
        return w.length = ge, w;
      },
      grep: function(w, P, K) {
        for (var ne, ge = [], _e = 0, be = w.length, He = !K; _e < be; _e++)
          ne = !P(w[_e], _e), ne !== He && ge.push(w[_e]);
        return ge;
      },
      // arg is for internal usage only
      map: function(w, P, K) {
        var ne, ge, _e = 0, be = [];
        if (qe(w))
          for (ne = w.length; _e < ne; _e++)
            ge = P(w[_e], _e, K), ge != null && be.push(ge);
        else
          for (_e in w)
            ge = P(w[_e], _e, K), ge != null && be.push(ge);
        return h(be);
      },
      // A global GUID counter for objects
      guid: 1,
      // jQuery.support is not used in Core but other projects attach their
      // properties to it so it needs to exist.
      support: W
    }), typeof Symbol == "function" && (Z.fn[Symbol.iterator] = n[Symbol.iterator]), Z.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),
      function(w, P) {
        x["[object " + P + "]"] = P.toLowerCase();
      }
    );
    function qe(w) {
      var P = !!w && "length" in w && w.length, K = he(w);
      return U(w) || Q(w) ? !1 : K === "array" || P === 0 || typeof P == "number" && P > 0 && P - 1 in w;
    }
    function Oe(w, P) {
      return w.nodeName && w.nodeName.toLowerCase() === P.toLowerCase();
    }
    var je = n.pop, pt = n.sort, Te = n.splice, Ze = "[\\x20\\t\\r\\n\\f]", ce = new RegExp(
      "^" + Ze + "+|((?:^|[^\\\\])(?:\\\\.)*)" + Ze + "+$",
      "g"
    );
    Z.contains = function(w, P) {
      var K = P && P.parentNode;
      return w === K || !!(K && K.nodeType === 1 && // Support: IE 9 - 11+
      // IE doesn't have `contains` on SVG.
      (w.contains ? w.contains(K) : w.compareDocumentPosition && w.compareDocumentPosition(K) & 16));
    };
    var ut = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function ze(w, P) {
      return P ? w === "\0" ? "�" : w.slice(0, -1) + "\\" + w.charCodeAt(w.length - 1).toString(16) + " " : "\\" + w;
    }
    Z.escapeSelector = function(w) {
      return (w + "").replace(ut, ze);
    };
    var ht = D, Gt = f;
    (function() {
      var w, P, K, ne, ge, _e = Gt, be, He, De, Je, Ct, Bt = Z.expando, dt = 0, Ut = 0, ti = An(), wi = An(), bi = An(), Cn = An(), mn = function(Pe, Ke) {
        return Pe === Ke && (ge = !0), 0;
      }, fn = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", mi = "(?:\\\\[\\da-fA-F]{1,6}" + Ze + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", ki = "\\[" + Ze + "*(" + mi + ")(?:" + Ze + // Operator (capture 2)
      "*([*^$|!~]?=)" + Ze + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
      `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + mi + "))|)" + Ze + "*\\]", En = ":(" + mi + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + ki + ")*)|.*)\\)|)", Oi = new RegExp(Ze + "+", "g"), qi = new RegExp("^" + Ze + "*," + Ze + "*"), rs = new RegExp("^" + Ze + "*([>+~]|" + Ze + ")" + Ze + "*"), ar = new RegExp(Ze + "|>"), _n = new RegExp(En), gr = new RegExp("^" + mi + "$"), Hn = {
        ID: new RegExp("^#(" + mi + ")"),
        CLASS: new RegExp("^\\.(" + mi + ")"),
        TAG: new RegExp("^(" + mi + "|[*])"),
        ATTR: new RegExp("^" + ki),
        PSEUDO: new RegExp("^" + En),
        CHILD: new RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + Ze + "*(even|odd|(([+-]|)(\\d*)n|)" + Ze + "*(?:([+-]|)" + Ze + "*(\\d+)|))" + Ze + "*\\)|)",
          "i"
        ),
        bool: new RegExp("^(?:" + fn + ")$", "i"),
        // For use in libraries implementing .is()
        // We use this for POS matching in `select`
        needsContext: new RegExp("^" + Ze + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + Ze + "*((?:-\\d)?\\d*)" + Ze + "*\\)|)(?=[^-]|$)", "i")
      }, ei = /^(?:input|select|textarea|button)$/i, Xn = /^h\d$/i, In = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, Rr = /[+~]/, Si = new RegExp("\\\\[\\da-fA-F]{1,6}" + Ze + "?|\\\\([^\\r\\n\\f])", "g"), an = function(Pe, Ke) {
        var ct = "0x" + Pe.slice(1) - 65536;
        return Ke || (ct < 0 ? String.fromCharCode(ct + 65536) : String.fromCharCode(ct >> 10 | 55296, ct & 1023 | 56320));
      }, jt = function() {
        Pn();
      }, Dr = pr(
        function(Pe) {
          return Pe.disabled === !0 && Oe(Pe, "fieldset");
        },
        { dir: "parentNode", next: "legend" }
      );
      function hi() {
        try {
          return be.activeElement;
        } catch {
        }
      }
      try {
        _e.apply(
          n = o.call(ht.childNodes),
          ht.childNodes
        ), n[ht.childNodes.length].nodeType;
      } catch {
        _e = {
          apply: function(Ke, ct) {
            Gt.apply(Ke, o.call(ct));
          },
          call: function(Ke) {
            Gt.apply(Ke, o.call(arguments, 1));
          }
        };
      }
      function Ni(Pe, Ke, ct, vt) {
        var Be, We, Ye, ie, oe, Me, ke, lt = Ke && Ke.ownerDocument, At = Ke ? Ke.nodeType : 9;
        if (ct = ct || [], typeof Pe != "string" || !Pe || At !== 1 && At !== 9 && At !== 11)
          return ct;
        if (!vt && (Pn(Ke), Ke = Ke || be, De)) {
          if (At !== 11 && (oe = In.exec(Pe)))
            if (Be = oe[1]) {
              if (At === 9)
                if (Ye = Ke.getElementById(Be)) {
                  if (Ye.id === Be)
                    return _e.call(ct, Ye), ct;
                } else
                  return ct;
              else if (lt && (Ye = lt.getElementById(Be)) && Ni.contains(Ke, Ye) && Ye.id === Be)
                return _e.call(ct, Ye), ct;
            } else {
              if (oe[2])
                return _e.apply(ct, Ke.getElementsByTagName(Pe)), ct;
              if ((Be = oe[3]) && Ke.getElementsByClassName)
                return _e.apply(ct, Ke.getElementsByClassName(Be)), ct;
            }
          if (!Cn[Pe + " "] && (!Je || !Je.test(Pe))) {
            if (ke = Pe, lt = Ke, At === 1 && (ar.test(Pe) || rs.test(Pe))) {
              for (lt = Rr.test(Pe) && un(Ke.parentNode) || Ke, (lt != Ke || !W.scope) && ((ie = Ke.getAttribute("id")) ? ie = Z.escapeSelector(ie) : Ke.setAttribute("id", ie = Bt)), Me = or(Pe), We = Me.length; We--; )
                Me[We] = (ie ? "#" + ie : ":scope") + " " + jn(Me[We]);
              ke = Me.join(",");
            }
            try {
              return _e.apply(
                ct,
                lt.querySelectorAll(ke)
              ), ct;
            } catch {
              Cn(Pe, !0);
            } finally {
              ie === Bt && Ke.removeAttribute("id");
            }
          }
        }
        return lr(Pe.replace(ce, "$1"), Ke, ct, vt);
      }
      function An() {
        var Pe = [];
        function Ke(ct, vt) {
          return Pe.push(ct + " ") > P.cacheLength && delete Ke[Pe.shift()], Ke[ct + " "] = vt;
        }
        return Ke;
      }
      function ui(Pe) {
        return Pe[Bt] = !0, Pe;
      }
      function dn(Pe) {
        var Ke = be.createElement("fieldset");
        try {
          return !!Pe(Ke);
        } catch {
          return !1;
        } finally {
          Ke.parentNode && Ke.parentNode.removeChild(Ke), Ke = null;
        }
      }
      function zr(Pe) {
        return function(Ke) {
          return Oe(Ke, "input") && Ke.type === Pe;
        };
      }
      function $s(Pe) {
        return function(Ke) {
          return (Oe(Ke, "input") || Oe(Ke, "button")) && Ke.type === Pe;
        };
      }
      function jr(Pe) {
        return function(Ke) {
          return "form" in Ke ? Ke.parentNode && Ke.disabled === !1 ? "label" in Ke ? "label" in Ke.parentNode ? Ke.parentNode.disabled === Pe : Ke.disabled === Pe : Ke.isDisabled === Pe || // Where there is no isDisabled, check manually
          Ke.isDisabled !== !Pe && Dr(Ke) === Pe : Ke.disabled === Pe : "label" in Ke ? Ke.disabled === Pe : !1;
        };
      }
      function Kn(Pe) {
        return ui(function(Ke) {
          return Ke = +Ke, ui(function(ct, vt) {
            for (var Be, We = Pe([], ct.length, Ke), Ye = We.length; Ye--; )
              ct[Be = We[Ye]] && (ct[Be] = !(vt[Be] = ct[Be]));
          });
        });
      }
      function un(Pe) {
        return Pe && typeof Pe.getElementsByTagName < "u" && Pe;
      }
      function Pn(Pe) {
        var Ke, ct = Pe ? Pe.ownerDocument || Pe : ht;
        return ct == be || ct.nodeType !== 9 || !ct.documentElement || (be = ct, He = be.documentElement, De = !Z.isXMLDoc(be), Ct = He.matches || He.webkitMatchesSelector || He.msMatchesSelector, He.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        ht != be && (Ke = be.defaultView) && Ke.top !== Ke && Ke.addEventListener("unload", jt), W.getById = dn(function(vt) {
          return He.appendChild(vt).id = Z.expando, !be.getElementsByName || !be.getElementsByName(Z.expando).length;
        }), W.disconnectedMatch = dn(function(vt) {
          return Ct.call(vt, "*");
        }), W.scope = dn(function() {
          return be.querySelectorAll(":scope");
        }), W.cssHas = dn(function() {
          try {
            return be.querySelector(":has(*,:jqfake)"), !1;
          } catch {
            return !0;
          }
        }), W.getById ? (P.filter.ID = function(vt) {
          var Be = vt.replace(Si, an);
          return function(We) {
            return We.getAttribute("id") === Be;
          };
        }, P.find.ID = function(vt, Be) {
          if (typeof Be.getElementById < "u" && De) {
            var We = Be.getElementById(vt);
            return We ? [We] : [];
          }
        }) : (P.filter.ID = function(vt) {
          var Be = vt.replace(Si, an);
          return function(We) {
            var Ye = typeof We.getAttributeNode < "u" && We.getAttributeNode("id");
            return Ye && Ye.value === Be;
          };
        }, P.find.ID = function(vt, Be) {
          if (typeof Be.getElementById < "u" && De) {
            var We, Ye, ie, oe = Be.getElementById(vt);
            if (oe) {
              if (We = oe.getAttributeNode("id"), We && We.value === vt)
                return [oe];
              for (ie = Be.getElementsByName(vt), Ye = 0; oe = ie[Ye++]; )
                if (We = oe.getAttributeNode("id"), We && We.value === vt)
                  return [oe];
            }
            return [];
          }
        }), P.find.TAG = function(vt, Be) {
          return typeof Be.getElementsByTagName < "u" ? Be.getElementsByTagName(vt) : Be.querySelectorAll(vt);
        }, P.find.CLASS = function(vt, Be) {
          if (typeof Be.getElementsByClassName < "u" && De)
            return Be.getElementsByClassName(vt);
        }, Je = [], dn(function(vt) {
          var Be;
          He.appendChild(vt).innerHTML = "<a id='" + Bt + "' href='' disabled='disabled'></a><select id='" + Bt + "-\r\\' disabled='disabled'><option selected=''></option></select>", vt.querySelectorAll("[selected]").length || Je.push("\\[" + Ze + "*(?:value|" + fn + ")"), vt.querySelectorAll("[id~=" + Bt + "-]").length || Je.push("~="), vt.querySelectorAll("a#" + Bt + "+*").length || Je.push(".#.+[+~]"), vt.querySelectorAll(":checked").length || Je.push(":checked"), Be = be.createElement("input"), Be.setAttribute("type", "hidden"), vt.appendChild(Be).setAttribute("name", "D"), He.appendChild(vt).disabled = !0, vt.querySelectorAll(":disabled").length !== 2 && Je.push(":enabled", ":disabled"), Be = be.createElement("input"), Be.setAttribute("name", ""), vt.appendChild(Be), vt.querySelectorAll("[name='']").length || Je.push("\\[" + Ze + "*name" + Ze + "*=" + Ze + `*(?:''|"")`);
        }), W.cssHas || Je.push(":has"), Je = Je.length && new RegExp(Je.join("|")), mn = function(vt, Be) {
          if (vt === Be)
            return ge = !0, 0;
          var We = !vt.compareDocumentPosition - !Be.compareDocumentPosition;
          return We || (We = (vt.ownerDocument || vt) == (Be.ownerDocument || Be) ? vt.compareDocumentPosition(Be) : (
            // Otherwise we know they are disconnected
            1
          ), We & 1 || !W.sortDetached && Be.compareDocumentPosition(vt) === We ? vt === be || vt.ownerDocument == ht && Ni.contains(ht, vt) ? -1 : Be === be || Be.ownerDocument == ht && Ni.contains(ht, Be) ? 1 : ne ? v.call(ne, vt) - v.call(ne, Be) : 0 : We & 4 ? -1 : 1);
        }), be;
      }
      Ni.matches = function(Pe, Ke) {
        return Ni(Pe, null, null, Ke);
      }, Ni.matchesSelector = function(Pe, Ke) {
        if (Pn(Pe), De && !Cn[Ke + " "] && (!Je || !Je.test(Ke)))
          try {
            var ct = Ct.call(Pe, Ke);
            if (ct || W.disconnectedMatch || // As well, disconnected nodes are said to be in a document
            // fragment in IE 9
            Pe.document && Pe.document.nodeType !== 11)
              return ct;
          } catch {
            Cn(Ke, !0);
          }
        return Ni(Ke, be, null, [Pe]).length > 0;
      }, Ni.contains = function(Pe, Ke) {
        return (Pe.ownerDocument || Pe) != be && Pn(Pe), Z.contains(Pe, Ke);
      }, Ni.attr = function(Pe, Ke) {
        (Pe.ownerDocument || Pe) != be && Pn(Pe);
        var ct = P.attrHandle[Ke.toLowerCase()], vt = ct && I.call(P.attrHandle, Ke.toLowerCase()) ? ct(Pe, Ke, !De) : void 0;
        return vt !== void 0 ? vt : Pe.getAttribute(Ke);
      }, Ni.error = function(Pe) {
        throw new Error("Syntax error, unrecognized expression: " + Pe);
      }, Z.uniqueSort = function(Pe) {
        var Ke, ct = [], vt = 0, Be = 0;
        if (ge = !W.sortStable, ne = !W.sortStable && o.call(Pe, 0), pt.call(Pe, mn), ge) {
          for (; Ke = Pe[Be++]; )
            Ke === Pe[Be] && (vt = ct.push(Be));
          for (; vt--; )
            Te.call(Pe, ct[vt], 1);
        }
        return ne = null, Pe;
      }, Z.fn.uniqueSort = function() {
        return this.pushStack(Z.uniqueSort(o.apply(this)));
      }, P = Z.expr = {
        // Can be adjusted by the user
        cacheLength: 50,
        createPseudo: ui,
        match: Hn,
        attrHandle: {},
        find: {},
        relative: {
          ">": { dir: "parentNode", first: !0 },
          " ": { dir: "parentNode" },
          "+": { dir: "previousSibling", first: !0 },
          "~": { dir: "previousSibling" }
        },
        preFilter: {
          ATTR: function(Pe) {
            return Pe[1] = Pe[1].replace(Si, an), Pe[3] = (Pe[3] || Pe[4] || Pe[5] || "").replace(Si, an), Pe[2] === "~=" && (Pe[3] = " " + Pe[3] + " "), Pe.slice(0, 4);
          },
          CHILD: function(Pe) {
            return Pe[1] = Pe[1].toLowerCase(), Pe[1].slice(0, 3) === "nth" ? (Pe[3] || Ni.error(Pe[0]), Pe[4] = +(Pe[4] ? Pe[5] + (Pe[6] || 1) : 2 * (Pe[3] === "even" || Pe[3] === "odd")), Pe[5] = +(Pe[7] + Pe[8] || Pe[3] === "odd")) : Pe[3] && Ni.error(Pe[0]), Pe;
          },
          PSEUDO: function(Pe) {
            var Ke, ct = !Pe[6] && Pe[2];
            return Hn.CHILD.test(Pe[0]) ? null : (Pe[3] ? Pe[2] = Pe[4] || Pe[5] || "" : ct && _n.test(ct) && // Get excess from tokenize (recursively)
            (Ke = or(ct, !0)) && // advance to the next closing parenthesis
            (Ke = ct.indexOf(")", ct.length - Ke) - ct.length) && (Pe[0] = Pe[0].slice(0, Ke), Pe[2] = ct.slice(0, Ke)), Pe.slice(0, 3));
          }
        },
        filter: {
          TAG: function(Pe) {
            var Ke = Pe.replace(Si, an).toLowerCase();
            return Pe === "*" ? function() {
              return !0;
            } : function(ct) {
              return Oe(ct, Ke);
            };
          },
          CLASS: function(Pe) {
            var Ke = ti[Pe + " "];
            return Ke || (Ke = new RegExp("(^|" + Ze + ")" + Pe + "(" + Ze + "|$)")) && ti(Pe, function(ct) {
              return Ke.test(
                typeof ct.className == "string" && ct.className || typeof ct.getAttribute < "u" && ct.getAttribute("class") || ""
              );
            });
          },
          ATTR: function(Pe, Ke, ct) {
            return function(vt) {
              var Be = Ni.attr(vt, Pe);
              return Be == null ? Ke === "!=" : Ke ? (Be += "", Ke === "=" ? Be === ct : Ke === "!=" ? Be !== ct : Ke === "^=" ? ct && Be.indexOf(ct) === 0 : Ke === "*=" ? ct && Be.indexOf(ct) > -1 : Ke === "$=" ? ct && Be.slice(-ct.length) === ct : Ke === "~=" ? (" " + Be.replace(Oi, " ") + " ").indexOf(ct) > -1 : Ke === "|=" ? Be === ct || Be.slice(0, ct.length + 1) === ct + "-" : !1) : !0;
            };
          },
          CHILD: function(Pe, Ke, ct, vt, Be) {
            var We = Pe.slice(0, 3) !== "nth", Ye = Pe.slice(-4) !== "last", ie = Ke === "of-type";
            return vt === 1 && Be === 0 ? (
              // Shortcut for :nth-*(n)
              function(oe) {
                return !!oe.parentNode;
              }
            ) : function(oe, Me, ke) {
              var lt, At, wt, Vt, Ei, Qi = We !== Ye ? "nextSibling" : "previousSibling", vn = oe.parentNode, wn = ie && oe.nodeName.toLowerCase(), mr = !ke && !ie, Li = !1;
              if (vn) {
                if (We) {
                  for (; Qi; ) {
                    for (wt = oe; wt = wt[Qi]; )
                      if (ie ? Oe(wt, wn) : wt.nodeType === 1)
                        return !1;
                    Ei = Qi = Pe === "only" && !Ei && "nextSibling";
                  }
                  return !0;
                }
                if (Ei = [Ye ? vn.firstChild : vn.lastChild], Ye && mr) {
                  for (At = vn[Bt] || (vn[Bt] = {}), lt = At[Pe] || [], Vt = lt[0] === dt && lt[1], Li = Vt && lt[2], wt = Vt && vn.childNodes[Vt]; wt = ++Vt && wt && wt[Qi] || // Fallback to seeking `elem` from the start
                  (Li = Vt = 0) || Ei.pop(); )
                    if (wt.nodeType === 1 && ++Li && wt === oe) {
                      At[Pe] = [dt, Vt, Li];
                      break;
                    }
                } else if (mr && (At = oe[Bt] || (oe[Bt] = {}), lt = At[Pe] || [], Vt = lt[0] === dt && lt[1], Li = Vt), Li === !1)
                  for (; (wt = ++Vt && wt && wt[Qi] || (Li = Vt = 0) || Ei.pop()) && !((ie ? Oe(wt, wn) : wt.nodeType === 1) && ++Li && (mr && (At = wt[Bt] || (wt[Bt] = {}), At[Pe] = [dt, Li]), wt === oe)); )
                    ;
                return Li -= Be, Li === vt || Li % vt === 0 && Li / vt >= 0;
              }
            };
          },
          PSEUDO: function(Pe, Ke) {
            var ct, vt = P.pseudos[Pe] || P.setFilters[Pe.toLowerCase()] || Ni.error("unsupported pseudo: " + Pe);
            return vt[Bt] ? vt(Ke) : vt.length > 1 ? (ct = [Pe, Pe, "", Ke], P.setFilters.hasOwnProperty(Pe.toLowerCase()) ? ui(function(Be, We) {
              for (var Ye, ie = vt(Be, Ke), oe = ie.length; oe--; )
                Ye = v.call(Be, ie[oe]), Be[Ye] = !(We[Ye] = ie[oe]);
            }) : function(Be) {
              return vt(Be, 0, ct);
            }) : vt;
          }
        },
        pseudos: {
          // Potentially complex pseudos
          not: ui(function(Pe) {
            var Ke = [], ct = [], vt = Ms(Pe.replace(ce, "$1"));
            return vt[Bt] ? ui(function(Be, We, Ye, ie) {
              for (var oe, Me = vt(Be, null, ie, []), ke = Be.length; ke--; )
                (oe = Me[ke]) && (Be[ke] = !(We[ke] = oe));
            }) : function(Be, We, Ye) {
              return Ke[0] = Be, vt(Ke, null, Ye, ct), Ke[0] = null, !ct.pop();
            };
          }),
          has: ui(function(Pe) {
            return function(Ke) {
              return Ni(Pe, Ke).length > 0;
            };
          }),
          contains: ui(function(Pe) {
            return Pe = Pe.replace(Si, an), function(Ke) {
              return (Ke.textContent || Z.text(Ke)).indexOf(Pe) > -1;
            };
          }),
          // "Whether an element is represented by a :lang() selector
          // is based solely on the element's language value
          // being equal to the identifier C,
          // or beginning with the identifier C immediately followed by "-".
          // The matching of C against the element's language value is performed case-insensitively.
          // The identifier C does not have to be a valid language name."
          // https://www.w3.org/TR/selectors/#lang-pseudo
          lang: ui(function(Pe) {
            return gr.test(Pe || "") || Ni.error("unsupported lang: " + Pe), Pe = Pe.replace(Si, an).toLowerCase(), function(Ke) {
              var ct;
              do
                if (ct = De ? Ke.lang : Ke.getAttribute("xml:lang") || Ke.getAttribute("lang"))
                  return ct = ct.toLowerCase(), ct === Pe || ct.indexOf(Pe + "-") === 0;
              while ((Ke = Ke.parentNode) && Ke.nodeType === 1);
              return !1;
            };
          }),
          // Miscellaneous
          target: function(Pe) {
            var Ke = e.location && e.location.hash;
            return Ke && Ke.slice(1) === Pe.id;
          },
          root: function(Pe) {
            return Pe === He;
          },
          focus: function(Pe) {
            return Pe === hi() && be.hasFocus() && !!(Pe.type || Pe.href || ~Pe.tabIndex);
          },
          // Boolean properties
          enabled: jr(!1),
          disabled: jr(!0),
          checked: function(Pe) {
            return Oe(Pe, "input") && !!Pe.checked || Oe(Pe, "option") && !!Pe.selected;
          },
          selected: function(Pe) {
            return Pe.parentNode && Pe.parentNode.selectedIndex, Pe.selected === !0;
          },
          // Contents
          empty: function(Pe) {
            for (Pe = Pe.firstChild; Pe; Pe = Pe.nextSibling)
              if (Pe.nodeType < 6)
                return !1;
            return !0;
          },
          parent: function(Pe) {
            return !P.pseudos.empty(Pe);
          },
          // Element/input types
          header: function(Pe) {
            return Xn.test(Pe.nodeName);
          },
          input: function(Pe) {
            return ei.test(Pe.nodeName);
          },
          button: function(Pe) {
            return Oe(Pe, "input") && Pe.type === "button" || Oe(Pe, "button");
          },
          text: function(Pe) {
            var Ke;
            return Oe(Pe, "input") && Pe.type === "text" && // Support: IE <10 only
            // New HTML5 attribute values (e.g., "search") appear
            // with elem.type === "text"
            ((Ke = Pe.getAttribute("type")) == null || Ke.toLowerCase() === "text");
          },
          // Position-in-collection
          first: Kn(function() {
            return [0];
          }),
          last: Kn(function(Pe, Ke) {
            return [Ke - 1];
          }),
          eq: Kn(function(Pe, Ke, ct) {
            return [ct < 0 ? ct + Ke : ct];
          }),
          even: Kn(function(Pe, Ke) {
            for (var ct = 0; ct < Ke; ct += 2)
              Pe.push(ct);
            return Pe;
          }),
          odd: Kn(function(Pe, Ke) {
            for (var ct = 1; ct < Ke; ct += 2)
              Pe.push(ct);
            return Pe;
          }),
          lt: Kn(function(Pe, Ke, ct) {
            var vt;
            for (ct < 0 ? vt = ct + Ke : ct > Ke ? vt = Ke : vt = ct; --vt >= 0; )
              Pe.push(vt);
            return Pe;
          }),
          gt: Kn(function(Pe, Ke, ct) {
            for (var vt = ct < 0 ? ct + Ke : ct; ++vt < Ke; )
              Pe.push(vt);
            return Pe;
          })
        }
      }, P.pseudos.nth = P.pseudos.eq;
      for (w in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 })
        P.pseudos[w] = zr(w);
      for (w in { submit: !0, reset: !0 })
        P.pseudos[w] = $s(w);
      function Jn() {
      }
      Jn.prototype = P.filters = P.pseudos, P.setFilters = new Jn();
      function or(Pe, Ke) {
        var ct, vt, Be, We, Ye, ie, oe, Me = wi[Pe + " "];
        if (Me)
          return Ke ? 0 : Me.slice(0);
        for (Ye = Pe, ie = [], oe = P.preFilter; Ye; ) {
          (!ct || (vt = qi.exec(Ye))) && (vt && (Ye = Ye.slice(vt[0].length) || Ye), ie.push(Be = [])), ct = !1, (vt = rs.exec(Ye)) && (ct = vt.shift(), Be.push({
            value: ct,
            // Cast descendant combinators to space
            type: vt[0].replace(ce, " ")
          }), Ye = Ye.slice(ct.length));
          for (We in P.filter)
            (vt = Hn[We].exec(Ye)) && (!oe[We] || (vt = oe[We](vt))) && (ct = vt.shift(), Be.push({
              value: ct,
              type: We,
              matches: vt
            }), Ye = Ye.slice(ct.length));
          if (!ct)
            break;
        }
        return Ke ? Ye.length : Ye ? Ni.error(Pe) : (
          // Cache the tokens
          wi(Pe, ie).slice(0)
        );
      }
      function jn(Pe) {
        for (var Ke = 0, ct = Pe.length, vt = ""; Ke < ct; Ke++)
          vt += Pe[Ke].value;
        return vt;
      }
      function pr(Pe, Ke, ct) {
        var vt = Ke.dir, Be = Ke.next, We = Be || vt, Ye = ct && We === "parentNode", ie = Ut++;
        return Ke.first ? (
          // Check against closest ancestor/preceding element
          function(oe, Me, ke) {
            for (; oe = oe[vt]; )
              if (oe.nodeType === 1 || Ye)
                return Pe(oe, Me, ke);
            return !1;
          }
        ) : (
          // Check against all ancestor/preceding elements
          function(oe, Me, ke) {
            var lt, At, wt = [dt, ie];
            if (ke) {
              for (; oe = oe[vt]; )
                if ((oe.nodeType === 1 || Ye) && Pe(oe, Me, ke))
                  return !0;
            } else
              for (; oe = oe[vt]; )
                if (oe.nodeType === 1 || Ye)
                  if (At = oe[Bt] || (oe[Bt] = {}), Be && Oe(oe, Be))
                    oe = oe[vt] || oe;
                  else {
                    if ((lt = At[We]) && lt[0] === dt && lt[1] === ie)
                      return wt[2] = lt[2];
                    if (At[We] = wt, wt[2] = Pe(oe, Me, ke))
                      return !0;
                  }
            return !1;
          }
        );
      }
      function Ui(Pe) {
        return Pe.length > 1 ? function(Ke, ct, vt) {
          for (var Be = Pe.length; Be--; )
            if (!Pe[Be](Ke, ct, vt))
              return !1;
          return !0;
        } : Pe[0];
      }
      function ss(Pe, Ke, ct) {
        for (var vt = 0, Be = Ke.length; vt < Be; vt++)
          Ni(Pe, Ke[vt], ct);
        return ct;
      }
      function ms(Pe, Ke, ct, vt, Be) {
        for (var We, Ye = [], ie = 0, oe = Pe.length, Me = Ke != null; ie < oe; ie++)
          (We = Pe[ie]) && (!ct || ct(We, vt, Be)) && (Ye.push(We), Me && Ke.push(ie));
        return Ye;
      }
      function Sr(Pe, Ke, ct, vt, Be, We) {
        return vt && !vt[Bt] && (vt = Sr(vt)), Be && !Be[Bt] && (Be = Sr(Be, We)), ui(function(Ye, ie, oe, Me) {
          var ke, lt, At, wt, Vt = [], Ei = [], Qi = ie.length, vn = Ye || ss(
            Ke || "*",
            oe.nodeType ? [oe] : oe,
            []
          ), wn = Pe && (Ye || !Ke) ? ms(vn, Vt, Pe, oe, Me) : vn;
          if (ct ? (wt = Be || (Ye ? Pe : Qi || vt) ? (
            // ...intermediate processing is necessary
            []
          ) : (
            // ...otherwise use results directly
            ie
          ), ct(wn, wt, oe, Me)) : wt = wn, vt)
            for (ke = ms(wt, Ei), vt(ke, [], oe, Me), lt = ke.length; lt--; )
              (At = ke[lt]) && (wt[Ei[lt]] = !(wn[Ei[lt]] = At));
          if (Ye) {
            if (Be || Pe) {
              if (Be) {
                for (ke = [], lt = wt.length; lt--; )
                  (At = wt[lt]) && ke.push(wn[lt] = At);
                Be(null, wt = [], ke, Me);
              }
              for (lt = wt.length; lt--; )
                (At = wt[lt]) && (ke = Be ? v.call(Ye, At) : Vt[lt]) > -1 && (Ye[ke] = !(ie[ke] = At));
            }
          } else
            wt = ms(
              wt === ie ? wt.splice(Qi, wt.length) : wt
            ), Be ? Be(null, ie, wt, Me) : _e.apply(ie, wt);
        });
      }
      function Tn(Pe) {
        for (var Ke, ct, vt, Be = Pe.length, We = P.relative[Pe[0].type], Ye = We || P.relative[" "], ie = We ? 1 : 0, oe = pr(function(lt) {
          return lt === Ke;
        }, Ye, !0), Me = pr(function(lt) {
          return v.call(Ke, lt) > -1;
        }, Ye, !0), ke = [function(lt, At, wt) {
          var Vt = !We && (wt || At != K) || ((Ke = At).nodeType ? oe(lt, At, wt) : Me(lt, At, wt));
          return Ke = null, Vt;
        }]; ie < Be; ie++)
          if (ct = P.relative[Pe[ie].type])
            ke = [pr(Ui(ke), ct)];
          else {
            if (ct = P.filter[Pe[ie].type].apply(null, Pe[ie].matches), ct[Bt]) {
              for (vt = ++ie; vt < Be && !P.relative[Pe[vt].type]; vt++)
                ;
              return Sr(
                ie > 1 && Ui(ke),
                ie > 1 && jn(
                  // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                  Pe.slice(0, ie - 1).concat({ value: Pe[ie - 2].type === " " ? "*" : "" })
                ).replace(ce, "$1"),
                ct,
                ie < vt && Tn(Pe.slice(ie, vt)),
                vt < Be && Tn(Pe = Pe.slice(vt)),
                vt < Be && jn(Pe)
              );
            }
            ke.push(ct);
          }
        return Ui(ke);
      }
      function Wr(Pe, Ke) {
        var ct = Ke.length > 0, vt = Pe.length > 0, Be = function(We, Ye, ie, oe, Me) {
          var ke, lt, At, wt = 0, Vt = "0", Ei = We && [], Qi = [], vn = K, wn = We || vt && P.find.TAG("*", Me), mr = dt += vn == null ? 1 : Math.random() || 0.1, Li = wn.length;
          for (Me && (K = Ye == be || Ye || Me); Vt !== Li && (ke = wn[Vt]) != null; Vt++) {
            if (vt && ke) {
              for (lt = 0, !Ye && ke.ownerDocument != be && (Pn(ke), ie = !De); At = Pe[lt++]; )
                if (At(ke, Ye || be, ie)) {
                  _e.call(oe, ke);
                  break;
                }
              Me && (dt = mr);
            }
            ct && ((ke = !At && ke) && wt--, We && Ei.push(ke));
          }
          if (wt += Vt, ct && Vt !== wt) {
            for (lt = 0; At = Ke[lt++]; )
              At(Ei, Qi, Ye, ie);
            if (We) {
              if (wt > 0)
                for (; Vt--; )
                  Ei[Vt] || Qi[Vt] || (Qi[Vt] = je.call(oe));
              Qi = ms(Qi);
            }
            _e.apply(oe, Qi), Me && !We && Qi.length > 0 && wt + Ke.length > 1 && Z.uniqueSort(oe);
          }
          return Me && (dt = mr, K = vn), Ei;
        };
        return ct ? ui(Be) : Be;
      }
      function Ms(Pe, Ke) {
        var ct, vt = [], Be = [], We = bi[Pe + " "];
        if (!We) {
          for (Ke || (Ke = or(Pe)), ct = Ke.length; ct--; )
            We = Tn(Ke[ct]), We[Bt] ? vt.push(We) : Be.push(We);
          We = bi(
            Pe,
            Wr(Be, vt)
          ), We.selector = Pe;
        }
        return We;
      }
      function lr(Pe, Ke, ct, vt) {
        var Be, We, Ye, ie, oe, Me = typeof Pe == "function" && Pe, ke = !vt && or(Pe = Me.selector || Pe);
        if (ct = ct || [], ke.length === 1) {
          if (We = ke[0] = ke[0].slice(0), We.length > 2 && (Ye = We[0]).type === "ID" && Ke.nodeType === 9 && De && P.relative[We[1].type]) {
            if (Ke = (P.find.ID(
              Ye.matches[0].replace(Si, an),
              Ke
            ) || [])[0], Ke)
              Me && (Ke = Ke.parentNode);
            else
              return ct;
            Pe = Pe.slice(We.shift().value.length);
          }
          for (Be = Hn.needsContext.test(Pe) ? 0 : We.length; Be-- && (Ye = We[Be], !P.relative[ie = Ye.type]); )
            if ((oe = P.find[ie]) && (vt = oe(
              Ye.matches[0].replace(Si, an),
              Rr.test(We[0].type) && un(Ke.parentNode) || Ke
            ))) {
              if (We.splice(Be, 1), Pe = vt.length && jn(We), !Pe)
                return _e.apply(ct, vt), ct;
              break;
            }
        }
        return (Me || Ms(Pe, ke))(
          vt,
          Ke,
          !De,
          ct,
          !Ke || Rr.test(Pe) && un(Ke.parentNode) || Ke
        ), ct;
      }
      W.sortStable = Bt.split("").sort(mn).join("") === Bt, Pn(), W.sortDetached = dn(function(Pe) {
        return Pe.compareDocumentPosition(be.createElement("fieldset")) & 1;
      }), Z.find = Ni, Z.expr[":"] = Z.expr.pseudos, Z.unique = Z.uniqueSort, Ni.compile = Ms, Ni.select = lr, Ni.setDocument = Pn, Ni.tokenize = or, Ni.escape = Z.escapeSelector, Ni.getText = Z.text, Ni.isXML = Z.isXMLDoc, Ni.selectors = Z.expr, Ni.support = Z.support, Ni.uniqueSort = Z.uniqueSort;
    })();
    var $e = function(w, P, K) {
      for (var ne = [], ge = K !== void 0; (w = w[P]) && w.nodeType !== 9; )
        if (w.nodeType === 1) {
          if (ge && Z(w).is(K))
            break;
          ne.push(w);
        }
      return ne;
    }, It = function(w, P) {
      for (var K = []; w; w = w.nextSibling)
        w.nodeType === 1 && w !== P && K.push(w);
      return K;
    }, rt = Z.expr.match.needsContext, it = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function Xt(w, P, K) {
      return U(P) ? Z.grep(w, function(ne, ge) {
        return !!P.call(ne, ge, ne) !== K;
      }) : P.nodeType ? Z.grep(w, function(ne) {
        return ne === P !== K;
      }) : typeof P != "string" ? Z.grep(w, function(ne) {
        return v.call(P, ne) > -1 !== K;
      }) : Z.filter(P, w, K);
    }
    Z.filter = function(w, P, K) {
      var ne = P[0];
      return K && (w = ":not(" + w + ")"), P.length === 1 && ne.nodeType === 1 ? Z.find.matchesSelector(ne, w) ? [ne] : [] : Z.find.matches(w, Z.grep(P, function(ge) {
        return ge.nodeType === 1;
      }));
    }, Z.fn.extend({
      find: function(w) {
        var P, K, ne = this.length, ge = this;
        if (typeof w != "string")
          return this.pushStack(Z(w).filter(function() {
            for (P = 0; P < ne; P++)
              if (Z.contains(ge[P], this))
                return !0;
          }));
        for (K = this.pushStack([]), P = 0; P < ne; P++)
          Z.find(w, ge[P], K);
        return ne > 1 ? Z.uniqueSort(K) : K;
      },
      filter: function(w) {
        return this.pushStack(Xt(this, w || [], !1));
      },
      not: function(w) {
        return this.pushStack(Xt(this, w || [], !0));
      },
      is: function(w) {
        return !!Xt(
          this,
          // If this is a positional/relative selector, check membership in the returned set
          // so $("p:first").is("p:last") won't return true for a doc with two "p".
          typeof w == "string" && rt.test(w) ? Z(w) : w || [],
          !1
        ).length;
      }
    });
    var $t, Tt = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, Bi = Z.fn.init = function(w, P, K) {
      var ne, ge;
      if (!w)
        return this;
      if (K = K || $t, typeof w == "string")
        if (w[0] === "<" && w[w.length - 1] === ">" && w.length >= 3 ? ne = [null, w, null] : ne = Tt.exec(w), ne && (ne[1] || !P))
          if (ne[1]) {
            if (P = P instanceof Z ? P[0] : P, Z.merge(this, Z.parseHTML(
              ne[1],
              P && P.nodeType ? P.ownerDocument || P : D,
              !0
            )), it.test(ne[1]) && Z.isPlainObject(P))
              for (ne in P)
                U(this[ne]) ? this[ne](P[ne]) : this.attr(ne, P[ne]);
            return this;
          } else
            return ge = D.getElementById(ne[2]), ge && (this[0] = ge, this.length = 1), this;
        else
          return !P || P.jquery ? (P || K).find(w) : this.constructor(P).find(w);
      else {
        if (w.nodeType)
          return this[0] = w, this.length = 1, this;
        if (U(w))
          return K.ready !== void 0 ? K.ready(w) : (
            // Execute immediately if ready is not present
            w(Z)
          );
      }
      return Z.makeArray(w, this);
    };
    Bi.prototype = Z.fn, $t = Z(D);
    var en = /^(?:parents|prev(?:Until|All))/, oi = {
      children: !0,
      contents: !0,
      next: !0,
      prev: !0
    };
    Z.fn.extend({
      has: function(w) {
        var P = Z(w, this), K = P.length;
        return this.filter(function() {
          for (var ne = 0; ne < K; ne++)
            if (Z.contains(this, P[ne]))
              return !0;
        });
      },
      closest: function(w, P) {
        var K, ne = 0, ge = this.length, _e = [], be = typeof w != "string" && Z(w);
        if (!rt.test(w)) {
          for (; ne < ge; ne++)
            for (K = this[ne]; K && K !== P; K = K.parentNode)
              if (K.nodeType < 11 && (be ? be.index(K) > -1 : (
                // Don't pass non-elements to jQuery#find
                K.nodeType === 1 && Z.find.matchesSelector(K, w)
              ))) {
                _e.push(K);
                break;
              }
        }
        return this.pushStack(_e.length > 1 ? Z.uniqueSort(_e) : _e);
      },
      // Determine the position of an element within the set
      index: function(w) {
        return w ? typeof w == "string" ? v.call(Z(w), this[0]) : v.call(
          this,
          // If it receives a jQuery object, the first element is used
          w.jquery ? w[0] : w
        ) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
      },
      add: function(w, P) {
        return this.pushStack(
          Z.uniqueSort(
            Z.merge(this.get(), Z(w, P))
          )
        );
      },
      addBack: function(w) {
        return this.add(
          w == null ? this.prevObject : this.prevObject.filter(w)
        );
      }
    });
    function Zt(w, P) {
      for (; (w = w[P]) && w.nodeType !== 1; )
        ;
      return w;
    }
    Z.each({
      parent: function(w) {
        var P = w.parentNode;
        return P && P.nodeType !== 11 ? P : null;
      },
      parents: function(w) {
        return $e(w, "parentNode");
      },
      parentsUntil: function(w, P, K) {
        return $e(w, "parentNode", K);
      },
      next: function(w) {
        return Zt(w, "nextSibling");
      },
      prev: function(w) {
        return Zt(w, "previousSibling");
      },
      nextAll: function(w) {
        return $e(w, "nextSibling");
      },
      prevAll: function(w) {
        return $e(w, "previousSibling");
      },
      nextUntil: function(w, P, K) {
        return $e(w, "nextSibling", K);
      },
      prevUntil: function(w, P, K) {
        return $e(w, "previousSibling", K);
      },
      siblings: function(w) {
        return It((w.parentNode || {}).firstChild, w);
      },
      children: function(w) {
        return It(w.firstChild);
      },
      contents: function(w) {
        return w.contentDocument != null && // Support: IE 11+
        // <object> elements with no `data` attribute has an object
        // `contentDocument` with a `null` prototype.
        a(w.contentDocument) ? w.contentDocument : (Oe(w, "template") && (w = w.content || w), Z.merge([], w.childNodes));
      }
    }, function(w, P) {
      Z.fn[w] = function(K, ne) {
        var ge = Z.map(this, P, K);
        return w.slice(-5) !== "Until" && (ne = K), ne && typeof ne == "string" && (ge = Z.filter(ne, ge)), this.length > 1 && (oi[w] || Z.uniqueSort(ge), en.test(w) && ge.reverse()), this.pushStack(ge);
      };
    });
    var Jt = /[^\x20\t\r\n\f]+/g;
    function Qt(w) {
      var P = {};
      return Z.each(w.match(Jt) || [], function(K, ne) {
        P[ne] = !0;
      }), P;
    }
    Z.Callbacks = function(w) {
      w = typeof w == "string" ? Qt(w) : Z.extend({}, w);
      var P, K, ne, ge, _e = [], be = [], He = -1, De = function() {
        for (ge = ge || w.once, ne = P = !0; be.length; He = -1)
          for (K = be.shift(); ++He < _e.length; )
            _e[He].apply(K[0], K[1]) === !1 && w.stopOnFalse && (He = _e.length, K = !1);
        w.memory || (K = !1), P = !1, ge && (K ? _e = [] : _e = "");
      }, Je = {
        // Add a callback or a collection of callbacks to the list
        add: function() {
          return _e && (K && !P && (He = _e.length - 1, be.push(K)), function Ct(Bt) {
            Z.each(Bt, function(dt, Ut) {
              U(Ut) ? (!w.unique || !Je.has(Ut)) && _e.push(Ut) : Ut && Ut.length && he(Ut) !== "string" && Ct(Ut);
            });
          }(arguments), K && !P && De()), this;
        },
        // Remove a callback from the list
        remove: function() {
          return Z.each(arguments, function(Ct, Bt) {
            for (var dt; (dt = Z.inArray(Bt, _e, dt)) > -1; )
              _e.splice(dt, 1), dt <= He && He--;
          }), this;
        },
        // Check if a given callback is in the list.
        // If no argument is given, return whether or not list has callbacks attached.
        has: function(Ct) {
          return Ct ? Z.inArray(Ct, _e) > -1 : _e.length > 0;
        },
        // Remove all callbacks from the list
        empty: function() {
          return _e && (_e = []), this;
        },
        // Disable .fire and .add
        // Abort any current/pending executions
        // Clear all callbacks and values
        disable: function() {
          return ge = be = [], _e = K = "", this;
        },
        disabled: function() {
          return !_e;
        },
        // Disable .fire
        // Also disable .add unless we have memory (since it would have no effect)
        // Abort any pending executions
        lock: function() {
          return ge = be = [], !K && !P && (_e = K = ""), this;
        },
        locked: function() {
          return !!ge;
        },
        // Call all callbacks with the given context and arguments
        fireWith: function(Ct, Bt) {
          return ge || (Bt = Bt || [], Bt = [Ct, Bt.slice ? Bt.slice() : Bt], be.push(Bt), P || De()), this;
        },
        // Call all the callbacks with the given arguments
        fire: function() {
          return Je.fireWith(this, arguments), this;
        },
        // To know if the callbacks have already been called at least once
        fired: function() {
          return !!ne;
        }
      };
      return Je;
    };
    function rn(w) {
      return w;
    }
    function Gi(w) {
      throw w;
    }
    function pe(w, P, K, ne) {
      var ge;
      try {
        w && U(ge = w.promise) ? ge.call(w).done(P).fail(K) : w && U(ge = w.then) ? ge.call(w, P, K) : P.apply(void 0, [w].slice(ne));
      } catch (_e) {
        K.apply(void 0, [_e]);
      }
    }
    Z.extend({
      Deferred: function(w) {
        var P = [
          // action, add listener, callbacks,
          // ... .then handlers, argument index, [final state]
          [
            "notify",
            "progress",
            Z.Callbacks("memory"),
            Z.Callbacks("memory"),
            2
          ],
          [
            "resolve",
            "done",
            Z.Callbacks("once memory"),
            Z.Callbacks("once memory"),
            0,
            "resolved"
          ],
          [
            "reject",
            "fail",
            Z.Callbacks("once memory"),
            Z.Callbacks("once memory"),
            1,
            "rejected"
          ]
        ], K = "pending", ne = {
          state: function() {
            return K;
          },
          always: function() {
            return ge.done(arguments).fail(arguments), this;
          },
          catch: function(_e) {
            return ne.then(null, _e);
          },
          // Keep pipe for back-compat
          pipe: function() {
            var _e = arguments;
            return Z.Deferred(function(be) {
              Z.each(P, function(He, De) {
                var Je = U(_e[De[4]]) && _e[De[4]];
                ge[De[1]](function() {
                  var Ct = Je && Je.apply(this, arguments);
                  Ct && U(Ct.promise) ? Ct.promise().progress(be.notify).done(be.resolve).fail(be.reject) : be[De[0] + "With"](
                    this,
                    Je ? [Ct] : arguments
                  );
                });
              }), _e = null;
            }).promise();
          },
          then: function(_e, be, He) {
            var De = 0;
            function Je(Ct, Bt, dt, Ut) {
              return function() {
                var ti = this, wi = arguments, bi = function() {
                  var mn, fn;
                  if (!(Ct < De)) {
                    if (mn = dt.apply(ti, wi), mn === Bt.promise())
                      throw new TypeError("Thenable self-resolution");
                    fn = mn && // Support: Promises/A+ section 2.3.4
                    // https://promisesaplus.com/#point-64
                    // Only check objects and functions for thenability
                    (typeof mn == "object" || typeof mn == "function") && mn.then, U(fn) ? Ut ? fn.call(
                      mn,
                      Je(De, Bt, rn, Ut),
                      Je(De, Bt, Gi, Ut)
                    ) : (De++, fn.call(
                      mn,
                      Je(De, Bt, rn, Ut),
                      Je(De, Bt, Gi, Ut),
                      Je(
                        De,
                        Bt,
                        rn,
                        Bt.notifyWith
                      )
                    )) : (dt !== rn && (ti = void 0, wi = [mn]), (Ut || Bt.resolveWith)(ti, wi));
                  }
                }, Cn = Ut ? bi : function() {
                  try {
                    bi();
                  } catch (mn) {
                    Z.Deferred.exceptionHook && Z.Deferred.exceptionHook(
                      mn,
                      Cn.error
                    ), Ct + 1 >= De && (dt !== Gi && (ti = void 0, wi = [mn]), Bt.rejectWith(ti, wi));
                  }
                };
                Ct ? Cn() : (Z.Deferred.getErrorHook ? Cn.error = Z.Deferred.getErrorHook() : Z.Deferred.getStackHook && (Cn.error = Z.Deferred.getStackHook()), e.setTimeout(Cn));
              };
            }
            return Z.Deferred(function(Ct) {
              P[0][3].add(
                Je(
                  0,
                  Ct,
                  U(He) ? He : rn,
                  Ct.notifyWith
                )
              ), P[1][3].add(
                Je(
                  0,
                  Ct,
                  U(_e) ? _e : rn
                )
              ), P[2][3].add(
                Je(
                  0,
                  Ct,
                  U(be) ? be : Gi
                )
              );
            }).promise();
          },
          // Get a promise for this deferred
          // If obj is provided, the promise aspect is added to the object
          promise: function(_e) {
            return _e != null ? Z.extend(_e, ne) : ne;
          }
        }, ge = {};
        return Z.each(P, function(_e, be) {
          var He = be[2], De = be[5];
          ne[be[1]] = He.add, De && He.add(
            function() {
              K = De;
            },
            // rejected_callbacks.disable
            // fulfilled_callbacks.disable
            P[3 - _e][2].disable,
            // rejected_handlers.disable
            // fulfilled_handlers.disable
            P[3 - _e][3].disable,
            // progress_callbacks.lock
            P[0][2].lock,
            // progress_handlers.lock
            P[0][3].lock
          ), He.add(be[3].fire), ge[be[0]] = function() {
            return ge[be[0] + "With"](this === ge ? void 0 : this, arguments), this;
          }, ge[be[0] + "With"] = He.fireWith;
        }), ne.promise(ge), w && w.call(ge, ge), ge;
      },
      // Deferred helper
      when: function(w) {
        var P = arguments.length, K = P, ne = Array(K), ge = o.call(arguments), _e = Z.Deferred(), be = function(He) {
          return function(De) {
            ne[He] = this, ge[He] = arguments.length > 1 ? o.call(arguments) : De, --P || _e.resolveWith(ne, ge);
          };
        };
        if (P <= 1 && (pe(
          w,
          _e.done(be(K)).resolve,
          _e.reject,
          !P
        ), _e.state() === "pending" || U(ge[K] && ge[K].then)))
          return _e.then();
        for (; K--; )
          pe(ge[K], be(K), _e.reject);
        return _e.promise();
      }
    });
    var Lt = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    Z.Deferred.exceptionHook = function(w, P) {
      e.console && e.console.warn && w && Lt.test(w.name) && e.console.warn(
        "jQuery.Deferred exception: " + w.message,
        w.stack,
        P
      );
    }, Z.readyException = function(w) {
      e.setTimeout(function() {
        throw w;
      });
    };
    var xt = Z.Deferred();
    Z.fn.ready = function(w) {
      return xt.then(w).catch(function(P) {
        Z.readyException(P);
      }), this;
    }, Z.extend({
      // Is the DOM ready to be used? Set to true once it occurs.
      isReady: !1,
      // A counter to track how many items to wait for before
      // the ready event fires. See trac-6781
      readyWait: 1,
      // Handle when the DOM is ready
      ready: function(w) {
        (w === !0 ? --Z.readyWait : Z.isReady) || (Z.isReady = !0, !(w !== !0 && --Z.readyWait > 0) && xt.resolveWith(D, [Z]));
      }
    }), Z.ready.then = xt.then;
    function Ne() {
      D.removeEventListener("DOMContentLoaded", Ne), e.removeEventListener("load", Ne), Z.ready();
    }
    D.readyState === "complete" || D.readyState !== "loading" && !D.documentElement.doScroll ? e.setTimeout(Z.ready) : (D.addEventListener("DOMContentLoaded", Ne), e.addEventListener("load", Ne));
    var Ie = function(w, P, K, ne, ge, _e, be) {
      var He = 0, De = w.length, Je = K == null;
      if (he(K) === "object") {
        ge = !0;
        for (He in K)
          Ie(w, P, He, K[He], !0, _e, be);
      } else if (ne !== void 0 && (ge = !0, U(ne) || (be = !0), Je && (be ? (P.call(w, ne), P = null) : (Je = P, P = function(Ct, Bt, dt) {
        return Je.call(Z(Ct), dt);
      })), P))
        for (; He < De; He++)
          P(
            w[He],
            K,
            be ? ne : ne.call(w[He], He, P(w[He], K))
          );
      return ge ? w : Je ? P.call(w) : De ? P(w[0], K) : _e;
    }, et = /^-ms-/, Et = /-([a-z])/g;
    function ft(w, P) {
      return P.toUpperCase();
    }
    function tt(w) {
      return w.replace(et, "ms-").replace(Et, ft);
    }
    var _t = function(w) {
      return w.nodeType === 1 || w.nodeType === 9 || !+w.nodeType;
    };
    function Kt() {
      this.expando = Z.expando + Kt.uid++;
    }
    Kt.uid = 1, Kt.prototype = {
      cache: function(w) {
        var P = w[this.expando];
        return P || (P = {}, _t(w) && (w.nodeType ? w[this.expando] = P : Object.defineProperty(w, this.expando, {
          value: P,
          configurable: !0
        }))), P;
      },
      set: function(w, P, K) {
        var ne, ge = this.cache(w);
        if (typeof P == "string")
          ge[tt(P)] = K;
        else
          for (ne in P)
            ge[tt(ne)] = P[ne];
        return ge;
      },
      get: function(w, P) {
        return P === void 0 ? this.cache(w) : (
          // Always use camelCase key (gh-2257)
          w[this.expando] && w[this.expando][tt(P)]
        );
      },
      access: function(w, P, K) {
        return P === void 0 || P && typeof P == "string" && K === void 0 ? this.get(w, P) : (this.set(w, P, K), K !== void 0 ? K : P);
      },
      remove: function(w, P) {
        var K, ne = w[this.expando];
        if (ne !== void 0) {
          if (P !== void 0)
            for (Array.isArray(P) ? P = P.map(tt) : (P = tt(P), P = P in ne ? [P] : P.match(Jt) || []), K = P.length; K--; )
              delete ne[P[K]];
          (P === void 0 || Z.isEmptyObject(ne)) && (w.nodeType ? w[this.expando] = void 0 : delete w[this.expando]);
        }
      },
      hasData: function(w) {
        var P = w[this.expando];
        return P !== void 0 && !Z.isEmptyObject(P);
      }
    };
    var Ve = new Kt(), i = new Kt(), r = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, s = /[A-Z]/g;
    function l(w) {
      return w === "true" ? !0 : w === "false" ? !1 : w === "null" ? null : w === +w + "" ? +w : r.test(w) ? JSON.parse(w) : w;
    }
    function u(w, P, K) {
      var ne;
      if (K === void 0 && w.nodeType === 1)
        if (ne = "data-" + P.replace(s, "-$&").toLowerCase(), K = w.getAttribute(ne), typeof K == "string") {
          try {
            K = l(K);
          } catch {
          }
          i.set(w, P, K);
        } else
          K = void 0;
      return K;
    }
    Z.extend({
      hasData: function(w) {
        return i.hasData(w) || Ve.hasData(w);
      },
      data: function(w, P, K) {
        return i.access(w, P, K);
      },
      removeData: function(w, P) {
        i.remove(w, P);
      },
      // TODO: Now that all calls to _data and _removeData have been replaced
      // with direct calls to dataPriv methods, these can be deprecated.
      _data: function(w, P, K) {
        return Ve.access(w, P, K);
      },
      _removeData: function(w, P) {
        Ve.remove(w, P);
      }
    }), Z.fn.extend({
      data: function(w, P) {
        var K, ne, ge, _e = this[0], be = _e && _e.attributes;
        if (w === void 0) {
          if (this.length && (ge = i.get(_e), _e.nodeType === 1 && !Ve.get(_e, "hasDataAttrs"))) {
            for (K = be.length; K--; )
              be[K] && (ne = be[K].name, ne.indexOf("data-") === 0 && (ne = tt(ne.slice(5)), u(_e, ne, ge[ne])));
            Ve.set(_e, "hasDataAttrs", !0);
          }
          return ge;
        }
        return typeof w == "object" ? this.each(function() {
          i.set(this, w);
        }) : Ie(this, function(He) {
          var De;
          if (_e && He === void 0)
            return De = i.get(_e, w), De !== void 0 || (De = u(_e, w), De !== void 0) ? De : void 0;
          this.each(function() {
            i.set(this, w, He);
          });
        }, null, P, arguments.length > 1, null, !0);
      },
      removeData: function(w) {
        return this.each(function() {
          i.remove(this, w);
        });
      }
    }), Z.extend({
      queue: function(w, P, K) {
        var ne;
        if (w)
          return P = (P || "fx") + "queue", ne = Ve.get(w, P), K && (!ne || Array.isArray(K) ? ne = Ve.access(w, P, Z.makeArray(K)) : ne.push(K)), ne || [];
      },
      dequeue: function(w, P) {
        P = P || "fx";
        var K = Z.queue(w, P), ne = K.length, ge = K.shift(), _e = Z._queueHooks(w, P), be = function() {
          Z.dequeue(w, P);
        };
        ge === "inprogress" && (ge = K.shift(), ne--), ge && (P === "fx" && K.unshift("inprogress"), delete _e.stop, ge.call(w, be, _e)), !ne && _e && _e.empty.fire();
      },
      // Not public - generate a queueHooks object, or return the current one
      _queueHooks: function(w, P) {
        var K = P + "queueHooks";
        return Ve.get(w, K) || Ve.access(w, K, {
          empty: Z.Callbacks("once memory").add(function() {
            Ve.remove(w, [P + "queue", K]);
          })
        });
      }
    }), Z.fn.extend({
      queue: function(w, P) {
        var K = 2;
        return typeof w != "string" && (P = w, w = "fx", K--), arguments.length < K ? Z.queue(this[0], w) : P === void 0 ? this : this.each(function() {
          var ne = Z.queue(this, w, P);
          Z._queueHooks(this, w), w === "fx" && ne[0] !== "inprogress" && Z.dequeue(this, w);
        });
      },
      dequeue: function(w) {
        return this.each(function() {
          Z.dequeue(this, w);
        });
      },
      clearQueue: function(w) {
        return this.queue(w || "fx", []);
      },
      // Get a promise resolved when queues of a certain type
      // are emptied (fx is the type by default)
      promise: function(w, P) {
        var K, ne = 1, ge = Z.Deferred(), _e = this, be = this.length, He = function() {
          --ne || ge.resolveWith(_e, [_e]);
        };
        for (typeof w != "string" && (P = w, w = void 0), w = w || "fx"; be--; )
          K = Ve.get(_e[be], w + "queueHooks"), K && K.empty && (ne++, K.empty.add(He));
        return He(), ge.promise(P);
      }
    });
    var d = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, p = new RegExp("^(?:([+-])=|)(" + d + ")([a-z%]*)$", "i"), m = ["Top", "Right", "Bottom", "Left"], y = D.documentElement, S = function(w) {
      return Z.contains(w.ownerDocument, w);
    }, L = { composed: !0 };
    y.getRootNode && (S = function(w) {
      return Z.contains(w.ownerDocument, w) || w.getRootNode(L) === w.ownerDocument;
    });
    var E = function(w, P) {
      return w = P || w, w.style.display === "none" || w.style.display === "" && // Otherwise, check computed style
      // Support: Firefox <=43 - 45
      // Disconnected elements can have computed display: none, so first confirm that elem is
      // in the document.
      S(w) && Z.css(w, "display") === "none";
    };
    function A(w, P, K, ne) {
      var ge, _e, be = 20, He = ne ? function() {
        return ne.cur();
      } : function() {
        return Z.css(w, P, "");
      }, De = He(), Je = K && K[3] || (Z.cssNumber[P] ? "" : "px"), Ct = w.nodeType && (Z.cssNumber[P] || Je !== "px" && +De) && p.exec(Z.css(w, P));
      if (Ct && Ct[3] !== Je) {
        for (De = De / 2, Je = Je || Ct[3], Ct = +De || 1; be--; )
          Z.style(w, P, Ct + Je), (1 - _e) * (1 - (_e = He() / De || 0.5)) <= 0 && (be = 0), Ct = Ct / _e;
        Ct = Ct * 2, Z.style(w, P, Ct + Je), K = K || [];
      }
      return K && (Ct = +Ct || +De || 0, ge = K[1] ? Ct + (K[1] + 1) * K[2] : +K[2], ne && (ne.unit = Je, ne.start = Ct, ne.end = ge)), ge;
    }
    var T = {};
    function G(w) {
      var P, K = w.ownerDocument, ne = w.nodeName, ge = T[ne];
      return ge || (P = K.body.appendChild(K.createElement(ne)), ge = Z.css(P, "display"), P.parentNode.removeChild(P), ge === "none" && (ge = "block"), T[ne] = ge, ge);
    }
    function O(w, P) {
      for (var K, ne, ge = [], _e = 0, be = w.length; _e < be; _e++)
        ne = w[_e], ne.style && (K = ne.style.display, P ? (K === "none" && (ge[_e] = Ve.get(ne, "display") || null, ge[_e] || (ne.style.display = "")), ne.style.display === "" && E(ne) && (ge[_e] = G(ne))) : K !== "none" && (ge[_e] = "none", Ve.set(ne, "display", K)));
      for (_e = 0; _e < be; _e++)
        ge[_e] != null && (w[_e].style.display = ge[_e]);
      return w;
    }
    Z.fn.extend({
      show: function() {
        return O(this, !0);
      },
      hide: function() {
        return O(this);
      },
      toggle: function(w) {
        return typeof w == "boolean" ? w ? this.show() : this.hide() : this.each(function() {
          E(this) ? Z(this).show() : Z(this).hide();
        });
      }
    });
    var Y = /^(?:checkbox|radio)$/i, B = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i, z = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
      var w = D.createDocumentFragment(), P = w.appendChild(D.createElement("div")), K = D.createElement("input");
      K.setAttribute("type", "radio"), K.setAttribute("checked", "checked"), K.setAttribute("name", "t"), P.appendChild(K), W.checkClone = P.cloneNode(!0).cloneNode(!0).lastChild.checked, P.innerHTML = "<textarea>x</textarea>", W.noCloneChecked = !!P.cloneNode(!0).lastChild.defaultValue, P.innerHTML = "<option></option>", W.option = !!P.lastChild;
    })();
    var C = {
      // XHTML parsers do not magically insert elements in the
      // same way that tag soup parsers do. So we cannot shorten
      // this by omitting <tbody> or other required elements.
      thead: [1, "<table>", "</table>"],
      col: [2, "<table><colgroup>", "</colgroup></table>"],
      tr: [2, "<table><tbody>", "</tbody></table>"],
      td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
      _default: [0, "", ""]
    };
    C.tbody = C.tfoot = C.colgroup = C.caption = C.thead, C.th = C.td, W.option || (C.optgroup = C.option = [1, "<select multiple='multiple'>", "</select>"]);
    function N(w, P) {
      var K;
      return typeof w.getElementsByTagName < "u" ? K = w.getElementsByTagName(P || "*") : typeof w.querySelectorAll < "u" ? K = w.querySelectorAll(P || "*") : K = [], P === void 0 || P && Oe(w, P) ? Z.merge([w], K) : K;
    }
    function j(w, P) {
      for (var K = 0, ne = w.length; K < ne; K++)
        Ve.set(
          w[K],
          "globalEval",
          !P || Ve.get(P[K], "globalEval")
        );
    }
    var q = /<|&#?\w+;/;
    function H(w, P, K, ne, ge) {
      for (var _e, be, He, De, Je, Ct, Bt = P.createDocumentFragment(), dt = [], Ut = 0, ti = w.length; Ut < ti; Ut++)
        if (_e = w[Ut], _e || _e === 0)
          if (he(_e) === "object")
            Z.merge(dt, _e.nodeType ? [_e] : _e);
          else if (!q.test(_e))
            dt.push(P.createTextNode(_e));
          else {
            for (be = be || Bt.appendChild(P.createElement("div")), He = (B.exec(_e) || ["", ""])[1].toLowerCase(), De = C[He] || C._default, be.innerHTML = De[1] + Z.htmlPrefilter(_e) + De[2], Ct = De[0]; Ct--; )
              be = be.lastChild;
            Z.merge(dt, be.childNodes), be = Bt.firstChild, be.textContent = "";
          }
      for (Bt.textContent = "", Ut = 0; _e = dt[Ut++]; ) {
        if (ne && Z.inArray(_e, ne) > -1) {
          ge && ge.push(_e);
          continue;
        }
        if (Je = S(_e), be = N(Bt.appendChild(_e), "script"), Je && j(be), K)
          for (Ct = 0; _e = be[Ct++]; )
            z.test(_e.type || "") && K.push(_e);
      }
      return Bt;
    }
    var te = /^([^.]*)(?:\.(.+)|)/;
    function ae() {
      return !0;
    }
    function le() {
      return !1;
    }
    function me(w, P, K, ne, ge, _e) {
      var be, He;
      if (typeof P == "object") {
        typeof K != "string" && (ne = ne || K, K = void 0);
        for (He in P)
          me(w, He, K, ne, P[He], _e);
        return w;
      }
      if (ne == null && ge == null ? (ge = K, ne = K = void 0) : ge == null && (typeof K == "string" ? (ge = ne, ne = void 0) : (ge = ne, ne = K, K = void 0)), ge === !1)
        ge = le;
      else if (!ge)
        return w;
      return _e === 1 && (be = ge, ge = function(De) {
        return Z().off(De), be.apply(this, arguments);
      }, ge.guid = be.guid || (be.guid = Z.guid++)), w.each(function() {
        Z.event.add(this, P, ge, ne, K);
      });
    }
    Z.event = {
      global: {},
      add: function(w, P, K, ne, ge) {
        var _e, be, He, De, Je, Ct, Bt, dt, Ut, ti, wi, bi = Ve.get(w);
        if (_t(w))
          for (K.handler && (_e = K, K = _e.handler, ge = _e.selector), ge && Z.find.matchesSelector(y, ge), K.guid || (K.guid = Z.guid++), (De = bi.events) || (De = bi.events = /* @__PURE__ */ Object.create(null)), (be = bi.handle) || (be = bi.handle = function(Cn) {
            return typeof Z < "u" && Z.event.triggered !== Cn.type ? Z.event.dispatch.apply(w, arguments) : void 0;
          }), P = (P || "").match(Jt) || [""], Je = P.length; Je--; )
            He = te.exec(P[Je]) || [], Ut = wi = He[1], ti = (He[2] || "").split(".").sort(), Ut && (Bt = Z.event.special[Ut] || {}, Ut = (ge ? Bt.delegateType : Bt.bindType) || Ut, Bt = Z.event.special[Ut] || {}, Ct = Z.extend({
              type: Ut,
              origType: wi,
              data: ne,
              handler: K,
              guid: K.guid,
              selector: ge,
              needsContext: ge && Z.expr.match.needsContext.test(ge),
              namespace: ti.join(".")
            }, _e), (dt = De[Ut]) || (dt = De[Ut] = [], dt.delegateCount = 0, (!Bt.setup || Bt.setup.call(w, ne, ti, be) === !1) && w.addEventListener && w.addEventListener(Ut, be)), Bt.add && (Bt.add.call(w, Ct), Ct.handler.guid || (Ct.handler.guid = K.guid)), ge ? dt.splice(dt.delegateCount++, 0, Ct) : dt.push(Ct), Z.event.global[Ut] = !0);
      },
      // Detach an event or set of events from an element
      remove: function(w, P, K, ne, ge) {
        var _e, be, He, De, Je, Ct, Bt, dt, Ut, ti, wi, bi = Ve.hasData(w) && Ve.get(w);
        if (!(!bi || !(De = bi.events))) {
          for (P = (P || "").match(Jt) || [""], Je = P.length; Je--; ) {
            if (He = te.exec(P[Je]) || [], Ut = wi = He[1], ti = (He[2] || "").split(".").sort(), !Ut) {
              for (Ut in De)
                Z.event.remove(w, Ut + P[Je], K, ne, !0);
              continue;
            }
            for (Bt = Z.event.special[Ut] || {}, Ut = (ne ? Bt.delegateType : Bt.bindType) || Ut, dt = De[Ut] || [], He = He[2] && new RegExp("(^|\\.)" + ti.join("\\.(?:.*\\.|)") + "(\\.|$)"), be = _e = dt.length; _e--; )
              Ct = dt[_e], (ge || wi === Ct.origType) && (!K || K.guid === Ct.guid) && (!He || He.test(Ct.namespace)) && (!ne || ne === Ct.selector || ne === "**" && Ct.selector) && (dt.splice(_e, 1), Ct.selector && dt.delegateCount--, Bt.remove && Bt.remove.call(w, Ct));
            be && !dt.length && ((!Bt.teardown || Bt.teardown.call(w, ti, bi.handle) === !1) && Z.removeEvent(w, Ut, bi.handle), delete De[Ut]);
          }
          Z.isEmptyObject(De) && Ve.remove(w, "handle events");
        }
      },
      dispatch: function(w) {
        var P, K, ne, ge, _e, be, He = new Array(arguments.length), De = Z.event.fix(w), Je = (Ve.get(this, "events") || /* @__PURE__ */ Object.create(null))[De.type] || [], Ct = Z.event.special[De.type] || {};
        for (He[0] = De, P = 1; P < arguments.length; P++)
          He[P] = arguments[P];
        if (De.delegateTarget = this, !(Ct.preDispatch && Ct.preDispatch.call(this, De) === !1)) {
          for (be = Z.event.handlers.call(this, De, Je), P = 0; (ge = be[P++]) && !De.isPropagationStopped(); )
            for (De.currentTarget = ge.elem, K = 0; (_e = ge.handlers[K++]) && !De.isImmediatePropagationStopped(); )
              (!De.rnamespace || _e.namespace === !1 || De.rnamespace.test(_e.namespace)) && (De.handleObj = _e, De.data = _e.data, ne = ((Z.event.special[_e.origType] || {}).handle || _e.handler).apply(ge.elem, He), ne !== void 0 && (De.result = ne) === !1 && (De.preventDefault(), De.stopPropagation()));
          return Ct.postDispatch && Ct.postDispatch.call(this, De), De.result;
        }
      },
      handlers: function(w, P) {
        var K, ne, ge, _e, be, He = [], De = P.delegateCount, Je = w.target;
        if (De && // Support: IE <=9
        // Black-hole SVG <use> instance trees (trac-13180)
        Je.nodeType && // Support: Firefox <=42
        // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
        // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
        // Support: IE 11 only
        // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
        !(w.type === "click" && w.button >= 1)) {
          for (; Je !== this; Je = Je.parentNode || this)
            if (Je.nodeType === 1 && !(w.type === "click" && Je.disabled === !0)) {
              for (_e = [], be = {}, K = 0; K < De; K++)
                ne = P[K], ge = ne.selector + " ", be[ge] === void 0 && (be[ge] = ne.needsContext ? Z(ge, this).index(Je) > -1 : Z.find(ge, this, null, [Je]).length), be[ge] && _e.push(ne);
              _e.length && He.push({ elem: Je, handlers: _e });
            }
        }
        return Je = this, De < P.length && He.push({ elem: Je, handlers: P.slice(De) }), He;
      },
      addProp: function(w, P) {
        Object.defineProperty(Z.Event.prototype, w, {
          enumerable: !0,
          configurable: !0,
          get: U(P) ? function() {
            if (this.originalEvent)
              return P(this.originalEvent);
          } : function() {
            if (this.originalEvent)
              return this.originalEvent[w];
          },
          set: function(K) {
            Object.defineProperty(this, w, {
              enumerable: !0,
              configurable: !0,
              writable: !0,
              value: K
            });
          }
        });
      },
      fix: function(w) {
        return w[Z.expando] ? w : new Z.Event(w);
      },
      special: {
        load: {
          // Prevent triggered image.load events from bubbling to window.load
          noBubble: !0
        },
        click: {
          // Utilize native event to ensure correct state for checkable inputs
          setup: function(w) {
            var P = this || w;
            return Y.test(P.type) && P.click && Oe(P, "input") && se(P, "click", !0), !1;
          },
          trigger: function(w) {
            var P = this || w;
            return Y.test(P.type) && P.click && Oe(P, "input") && se(P, "click"), !0;
          },
          // For cross-browser consistency, suppress native .click() on links
          // Also prevent it if we're currently inside a leveraged native-event stack
          _default: function(w) {
            var P = w.target;
            return Y.test(P.type) && P.click && Oe(P, "input") && Ve.get(P, "click") || Oe(P, "a");
          }
        },
        beforeunload: {
          postDispatch: function(w) {
            w.result !== void 0 && w.originalEvent && (w.originalEvent.returnValue = w.result);
          }
        }
      }
    };
    function se(w, P, K) {
      if (!K) {
        Ve.get(w, P) === void 0 && Z.event.add(w, P, ae);
        return;
      }
      Ve.set(w, P, !1), Z.event.add(w, P, {
        namespace: !1,
        handler: function(ne) {
          var ge, _e = Ve.get(this, P);
          if (ne.isTrigger & 1 && this[P]) {
            if (_e)
              (Z.event.special[P] || {}).delegateType && ne.stopPropagation();
            else if (_e = o.call(arguments), Ve.set(this, P, _e), this[P](), ge = Ve.get(this, P), Ve.set(this, P, !1), _e !== ge)
              return ne.stopImmediatePropagation(), ne.preventDefault(), ge;
          } else
            _e && (Ve.set(this, P, Z.event.trigger(
              _e[0],
              _e.slice(1),
              this
            )), ne.stopPropagation(), ne.isImmediatePropagationStopped = ae);
        }
      });
    }
    Z.removeEvent = function(w, P, K) {
      w.removeEventListener && w.removeEventListener(P, K);
    }, Z.Event = function(w, P) {
      if (!(this instanceof Z.Event))
        return new Z.Event(w, P);
      w && w.type ? (this.originalEvent = w, this.type = w.type, this.isDefaultPrevented = w.defaultPrevented || w.defaultPrevented === void 0 && // Support: Android <=2.3 only
      w.returnValue === !1 ? ae : le, this.target = w.target && w.target.nodeType === 3 ? w.target.parentNode : w.target, this.currentTarget = w.currentTarget, this.relatedTarget = w.relatedTarget) : this.type = w, P && Z.extend(this, P), this.timeStamp = w && w.timeStamp || Date.now(), this[Z.expando] = !0;
    }, Z.Event.prototype = {
      constructor: Z.Event,
      isDefaultPrevented: le,
      isPropagationStopped: le,
      isImmediatePropagationStopped: le,
      isSimulated: !1,
      preventDefault: function() {
        var w = this.originalEvent;
        this.isDefaultPrevented = ae, w && !this.isSimulated && w.preventDefault();
      },
      stopPropagation: function() {
        var w = this.originalEvent;
        this.isPropagationStopped = ae, w && !this.isSimulated && w.stopPropagation();
      },
      stopImmediatePropagation: function() {
        var w = this.originalEvent;
        this.isImmediatePropagationStopped = ae, w && !this.isSimulated && w.stopImmediatePropagation(), this.stopPropagation();
      }
    }, Z.each({
      altKey: !0,
      bubbles: !0,
      cancelable: !0,
      changedTouches: !0,
      ctrlKey: !0,
      detail: !0,
      eventPhase: !0,
      metaKey: !0,
      pageX: !0,
      pageY: !0,
      shiftKey: !0,
      view: !0,
      char: !0,
      code: !0,
      charCode: !0,
      key: !0,
      keyCode: !0,
      button: !0,
      buttons: !0,
      clientX: !0,
      clientY: !0,
      offsetX: !0,
      offsetY: !0,
      pointerId: !0,
      pointerType: !0,
      screenX: !0,
      screenY: !0,
      targetTouches: !0,
      toElement: !0,
      touches: !0,
      which: !0
    }, Z.event.addProp), Z.each({ focus: "focusin", blur: "focusout" }, function(w, P) {
      function K(ne) {
        if (D.documentMode) {
          var ge = Ve.get(this, "handle"), _e = Z.event.fix(ne);
          _e.type = ne.type === "focusin" ? "focus" : "blur", _e.isSimulated = !0, ge(ne), _e.target === _e.currentTarget && ge(_e);
        } else
          Z.event.simulate(
            P,
            ne.target,
            Z.event.fix(ne)
          );
      }
      Z.event.special[w] = {
        // Utilize native event if possible so blur/focus sequence is correct
        setup: function() {
          var ne;
          if (se(this, w, !0), D.documentMode)
            ne = Ve.get(this, P), ne || this.addEventListener(P, K), Ve.set(this, P, (ne || 0) + 1);
          else
            return !1;
        },
        trigger: function() {
          return se(this, w), !0;
        },
        teardown: function() {
          var ne;
          if (D.documentMode)
            ne = Ve.get(this, P) - 1, ne ? Ve.set(this, P, ne) : (this.removeEventListener(P, K), Ve.remove(this, P));
          else
            return !1;
        },
        // Suppress native focus or blur if we're currently inside
        // a leveraged native-event stack
        _default: function(ne) {
          return Ve.get(ne.target, w);
        },
        delegateType: P
      }, Z.event.special[P] = {
        setup: function() {
          var ne = this.ownerDocument || this.document || this, ge = D.documentMode ? this : ne, _e = Ve.get(ge, P);
          _e || (D.documentMode ? this.addEventListener(P, K) : ne.addEventListener(w, K, !0)), Ve.set(ge, P, (_e || 0) + 1);
        },
        teardown: function() {
          var ne = this.ownerDocument || this.document || this, ge = D.documentMode ? this : ne, _e = Ve.get(ge, P) - 1;
          _e ? Ve.set(ge, P, _e) : (D.documentMode ? this.removeEventListener(P, K) : ne.removeEventListener(w, K, !0), Ve.remove(ge, P));
        }
      };
    }), Z.each({
      mouseenter: "mouseover",
      mouseleave: "mouseout",
      pointerenter: "pointerover",
      pointerleave: "pointerout"
    }, function(w, P) {
      Z.event.special[w] = {
        delegateType: P,
        bindType: P,
        handle: function(K) {
          var ne, ge = this, _e = K.relatedTarget, be = K.handleObj;
          return (!_e || _e !== ge && !Z.contains(ge, _e)) && (K.type = be.origType, ne = be.handler.apply(this, arguments), K.type = P), ne;
        }
      };
    }), Z.fn.extend({
      on: function(w, P, K, ne) {
        return me(this, w, P, K, ne);
      },
      one: function(w, P, K, ne) {
        return me(this, w, P, K, ne, 1);
      },
      off: function(w, P, K) {
        var ne, ge;
        if (w && w.preventDefault && w.handleObj)
          return ne = w.handleObj, Z(w.delegateTarget).off(
            ne.namespace ? ne.origType + "." + ne.namespace : ne.origType,
            ne.selector,
            ne.handler
          ), this;
        if (typeof w == "object") {
          for (ge in w)
            this.off(ge, P, w[ge]);
          return this;
        }
        return (P === !1 || typeof P == "function") && (K = P, P = void 0), K === !1 && (K = le), this.each(function() {
          Z.event.remove(this, w, K, P);
        });
      }
    });
    var de = /<script|<style|<link/i, ve = /checked\s*(?:[^=]|=\s*.checked.)/i, we = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    function Se(w, P) {
      return Oe(w, "table") && Oe(P.nodeType !== 11 ? P : P.firstChild, "tr") && Z(w).children("tbody")[0] || w;
    }
    function Ae(w) {
      return w.type = (w.getAttribute("type") !== null) + "/" + w.type, w;
    }
    function Ge(w) {
      return (w.type || "").slice(0, 5) === "true/" ? w.type = w.type.slice(5) : w.removeAttribute("type"), w;
    }
    function Qe(w, P) {
      var K, ne, ge, _e, be, He, De;
      if (P.nodeType === 1) {
        if (Ve.hasData(w) && (_e = Ve.get(w), De = _e.events, De)) {
          Ve.remove(P, "handle events");
          for (ge in De)
            for (K = 0, ne = De[ge].length; K < ne; K++)
              Z.event.add(P, ge, De[ge][K]);
        }
        i.hasData(w) && (be = i.access(w), He = Z.extend({}, be), i.set(P, He));
      }
    }
    function st(w, P) {
      var K = P.nodeName.toLowerCase();
      K === "input" && Y.test(w.type) ? P.checked = w.checked : (K === "input" || K === "textarea") && (P.defaultValue = w.defaultValue);
    }
    function mt(w, P, K, ne) {
      P = h(P);
      var ge, _e, be, He, De, Je, Ct = 0, Bt = w.length, dt = Bt - 1, Ut = P[0], ti = U(Ut);
      if (ti || Bt > 1 && typeof Ut == "string" && !W.checkClone && ve.test(Ut))
        return w.each(function(wi) {
          var bi = w.eq(wi);
          ti && (P[0] = Ut.call(this, wi, bi.html())), mt(bi, P, K, ne);
        });
      if (Bt && (ge = H(P, w[0].ownerDocument, !1, w, ne), _e = ge.firstChild, ge.childNodes.length === 1 && (ge = _e), _e || ne)) {
        for (be = Z.map(N(ge, "script"), Ae), He = be.length; Ct < Bt; Ct++)
          De = ge, Ct !== dt && (De = Z.clone(De, !0, !0), He && Z.merge(be, N(De, "script"))), K.call(w[Ct], De, Ct);
        if (He)
          for (Je = be[be.length - 1].ownerDocument, Z.map(be, Ge), Ct = 0; Ct < He; Ct++)
            De = be[Ct], z.test(De.type || "") && !Ve.access(De, "globalEval") && Z.contains(Je, De) && (De.src && (De.type || "").toLowerCase() !== "module" ? Z._evalUrl && !De.noModule && Z._evalUrl(De.src, {
              nonce: De.nonce || De.getAttribute("nonce")
            }, Je) : J(De.textContent.replace(we, ""), De, Je));
      }
      return w;
    }
    function Re(w, P, K) {
      for (var ne, ge = P ? Z.filter(P, w) : w, _e = 0; (ne = ge[_e]) != null; _e++)
        !K && ne.nodeType === 1 && Z.cleanData(N(ne)), ne.parentNode && (K && S(ne) && j(N(ne, "script")), ne.parentNode.removeChild(ne));
      return w;
    }
    Z.extend({
      htmlPrefilter: function(w) {
        return w;
      },
      clone: function(w, P, K) {
        var ne, ge, _e, be, He = w.cloneNode(!0), De = S(w);
        if (!W.noCloneChecked && (w.nodeType === 1 || w.nodeType === 11) && !Z.isXMLDoc(w))
          for (be = N(He), _e = N(w), ne = 0, ge = _e.length; ne < ge; ne++)
            st(_e[ne], be[ne]);
        if (P)
          if (K)
            for (_e = _e || N(w), be = be || N(He), ne = 0, ge = _e.length; ne < ge; ne++)
              Qe(_e[ne], be[ne]);
          else
            Qe(w, He);
        return be = N(He, "script"), be.length > 0 && j(be, !De && N(w, "script")), He;
      },
      cleanData: function(w) {
        for (var P, K, ne, ge = Z.event.special, _e = 0; (K = w[_e]) !== void 0; _e++)
          if (_t(K)) {
            if (P = K[Ve.expando]) {
              if (P.events)
                for (ne in P.events)
                  ge[ne] ? Z.event.remove(K, ne) : Z.removeEvent(K, ne, P.handle);
              K[Ve.expando] = void 0;
            }
            K[i.expando] && (K[i.expando] = void 0);
          }
      }
    }), Z.fn.extend({
      detach: function(w) {
        return Re(this, w, !0);
      },
      remove: function(w) {
        return Re(this, w);
      },
      text: function(w) {
        return Ie(this, function(P) {
          return P === void 0 ? Z.text(this) : this.empty().each(function() {
            (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) && (this.textContent = P);
          });
        }, null, w, arguments.length);
      },
      append: function() {
        return mt(this, arguments, function(w) {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            var P = Se(this, w);
            P.appendChild(w);
          }
        });
      },
      prepend: function() {
        return mt(this, arguments, function(w) {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            var P = Se(this, w);
            P.insertBefore(w, P.firstChild);
          }
        });
      },
      before: function() {
        return mt(this, arguments, function(w) {
          this.parentNode && this.parentNode.insertBefore(w, this);
        });
      },
      after: function() {
        return mt(this, arguments, function(w) {
          this.parentNode && this.parentNode.insertBefore(w, this.nextSibling);
        });
      },
      empty: function() {
        for (var w, P = 0; (w = this[P]) != null; P++)
          w.nodeType === 1 && (Z.cleanData(N(w, !1)), w.textContent = "");
        return this;
      },
      clone: function(w, P) {
        return w = w ?? !1, P = P ?? w, this.map(function() {
          return Z.clone(this, w, P);
        });
      },
      html: function(w) {
        return Ie(this, function(P) {
          var K = this[0] || {}, ne = 0, ge = this.length;
          if (P === void 0 && K.nodeType === 1)
            return K.innerHTML;
          if (typeof P == "string" && !de.test(P) && !C[(B.exec(P) || ["", ""])[1].toLowerCase()]) {
            P = Z.htmlPrefilter(P);
            try {
              for (; ne < ge; ne++)
                K = this[ne] || {}, K.nodeType === 1 && (Z.cleanData(N(K, !1)), K.innerHTML = P);
              K = 0;
            } catch {
            }
          }
          K && this.empty().append(P);
        }, null, w, arguments.length);
      },
      replaceWith: function() {
        var w = [];
        return mt(this, arguments, function(P) {
          var K = this.parentNode;
          Z.inArray(this, w) < 0 && (Z.cleanData(N(this)), K && K.replaceChild(P, this));
        }, w);
      }
    }), Z.each({
      appendTo: "append",
      prependTo: "prepend",
      insertBefore: "before",
      insertAfter: "after",
      replaceAll: "replaceWith"
    }, function(w, P) {
      Z.fn[w] = function(K) {
        for (var ne, ge = [], _e = Z(K), be = _e.length - 1, He = 0; He <= be; He++)
          ne = He === be ? this : this.clone(!0), Z(_e[He])[P](ne), f.apply(ge, ne.get());
        return this.pushStack(ge);
      };
    });
    var Fe = new RegExp("^(" + d + ")(?!px)[a-z%]+$", "i"), at = /^--/, yt = function(w) {
      var P = w.ownerDocument.defaultView;
      return (!P || !P.opener) && (P = e), P.getComputedStyle(w);
    }, bt = function(w, P, K) {
      var ne, ge, _e = {};
      for (ge in P)
        _e[ge] = w.style[ge], w.style[ge] = P[ge];
      ne = K.call(w);
      for (ge in P)
        w.style[ge] = _e[ge];
      return ne;
    }, Rt = new RegExp(m.join("|"), "i");
    (function() {
      function w() {
        if (Je) {
          De.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", Je.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", y.appendChild(De).appendChild(Je);
          var Ct = e.getComputedStyle(Je);
          K = Ct.top !== "1%", He = P(Ct.marginLeft) === 12, Je.style.right = "60%", _e = P(Ct.right) === 36, ne = P(Ct.width) === 36, Je.style.position = "absolute", ge = P(Je.offsetWidth / 3) === 12, y.removeChild(De), Je = null;
        }
      }
      function P(Ct) {
        return Math.round(parseFloat(Ct));
      }
      var K, ne, ge, _e, be, He, De = D.createElement("div"), Je = D.createElement("div");
      Je.style && (Je.style.backgroundClip = "content-box", Je.cloneNode(!0).style.backgroundClip = "", W.clearCloneStyle = Je.style.backgroundClip === "content-box", Z.extend(W, {
        boxSizingReliable: function() {
          return w(), ne;
        },
        pixelBoxStyles: function() {
          return w(), _e;
        },
        pixelPosition: function() {
          return w(), K;
        },
        reliableMarginLeft: function() {
          return w(), He;
        },
        scrollboxSize: function() {
          return w(), ge;
        },
        // Support: IE 9 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Behavior in IE 9 is more subtle than in newer versions & it passes
        // some versions of this test; make sure not to make it pass there!
        //
        // Support: Firefox 70+
        // Only Firefox includes border widths
        // in computed dimensions. (gh-4529)
        reliableTrDimensions: function() {
          var Ct, Bt, dt, Ut;
          return be == null && (Ct = D.createElement("table"), Bt = D.createElement("tr"), dt = D.createElement("div"), Ct.style.cssText = "position:absolute;left:-11111px;border-collapse:separate", Bt.style.cssText = "box-sizing:content-box;border:1px solid", Bt.style.height = "1px", dt.style.height = "9px", dt.style.display = "block", y.appendChild(Ct).appendChild(Bt).appendChild(dt), Ut = e.getComputedStyle(Bt), be = parseInt(Ut.height, 10) + parseInt(Ut.borderTopWidth, 10) + parseInt(Ut.borderBottomWidth, 10) === Bt.offsetHeight, y.removeChild(Ct)), be;
        }
      }));
    })();
    function Pt(w, P, K) {
      var ne, ge, _e, be, He = at.test(P), De = w.style;
      return K = K || yt(w), K && (be = K.getPropertyValue(P) || K[P], He && be && (be = be.replace(ce, "$1") || void 0), be === "" && !S(w) && (be = Z.style(w, P)), !W.pixelBoxStyles() && Fe.test(be) && Rt.test(P) && (ne = De.width, ge = De.minWidth, _e = De.maxWidth, De.minWidth = De.maxWidth = De.width = be, be = K.width, De.width = ne, De.minWidth = ge, De.maxWidth = _e)), be !== void 0 ? (
        // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        be + ""
      ) : be;
    }
    function zt(w, P) {
      return {
        get: function() {
          if (w()) {
            delete this.get;
            return;
          }
          return (this.get = P).apply(this, arguments);
        }
      };
    }
    var Wt = ["Webkit", "Moz", "ms"], Ft = D.createElement("div").style, Mi = {};
    function yi(w) {
      for (var P = w[0].toUpperCase() + w.slice(1), K = Wt.length; K--; )
        if (w = Wt[K] + P, w in Ft)
          return w;
    }
    function Ai(w) {
      var P = Z.cssProps[w] || Mi[w];
      return P || (w in Ft ? w : Mi[w] = yi(w) || w);
    }
    var pi = /^(none|table(?!-c[ea]).+)/, kt = { position: "absolute", visibility: "hidden", display: "block" }, fi = {
      letterSpacing: "0",
      fontWeight: "400"
    };
    function Ti(w, P, K) {
      var ne = p.exec(P);
      return ne ? (
        // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, ne[2] - (K || 0)) + (ne[3] || "px")
      ) : P;
    }
    function xi(w, P, K, ne, ge, _e) {
      var be = P === "width" ? 1 : 0, He = 0, De = 0, Je = 0;
      if (K === (ne ? "border" : "content"))
        return 0;
      for (; be < 4; be += 2)
        K === "margin" && (Je += Z.css(w, K + m[be], !0, ge)), ne ? (K === "content" && (De -= Z.css(w, "padding" + m[be], !0, ge)), K !== "margin" && (De -= Z.css(w, "border" + m[be] + "Width", !0, ge))) : (De += Z.css(w, "padding" + m[be], !0, ge), K !== "padding" ? De += Z.css(w, "border" + m[be] + "Width", !0, ge) : He += Z.css(w, "border" + m[be] + "Width", !0, ge));
      return !ne && _e >= 0 && (De += Math.max(0, Math.ceil(
        w["offset" + P[0].toUpperCase() + P.slice(1)] - _e - De - He - 0.5
        // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
        // Use an explicit zero to avoid NaN (gh-3964)
      )) || 0), De + Je;
    }
    function tn(w, P, K) {
      var ne = yt(w), ge = !W.boxSizingReliable() || K, _e = ge && Z.css(w, "boxSizing", !1, ne) === "border-box", be = _e, He = Pt(w, P, ne), De = "offset" + P[0].toUpperCase() + P.slice(1);
      if (Fe.test(He)) {
        if (!K)
          return He;
        He = "auto";
      }
      return (!W.boxSizingReliable() && _e || // Support: IE 10 - 11+, Edge 15 - 18+
      // IE/Edge misreport `getComputedStyle` of table rows with width/height
      // set in CSS while `offset*` properties report correct values.
      // Interestingly, in some cases IE 9 doesn't suffer from this issue.
      !W.reliableTrDimensions() && Oe(w, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
      // This happens for inline elements with no explicit setting (gh-3571)
      He === "auto" || // Support: Android <=4.1 - 4.3 only
      // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
      !parseFloat(He) && Z.css(w, "display", !1, ne) === "inline") && // Make sure the element is visible & connected
      w.getClientRects().length && (_e = Z.css(w, "boxSizing", !1, ne) === "border-box", be = De in w, be && (He = w[De])), He = parseFloat(He) || 0, He + xi(
        w,
        P,
        K || (_e ? "border" : "content"),
        be,
        ne,
        // Provide the current computed size to request scroll gutter calculation (gh-3589)
        He
      ) + "px";
    }
    Z.extend({
      // Add in style property hooks for overriding the default
      // behavior of getting and setting a style property
      cssHooks: {
        opacity: {
          get: function(w, P) {
            if (P) {
              var K = Pt(w, "opacity");
              return K === "" ? "1" : K;
            }
          }
        }
      },
      // Don't automatically add "px" to these possibly-unitless properties
      cssNumber: {
        animationIterationCount: !0,
        aspectRatio: !0,
        borderImageSlice: !0,
        columnCount: !0,
        flexGrow: !0,
        flexShrink: !0,
        fontWeight: !0,
        gridArea: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnStart: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowStart: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        scale: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        // SVG-related
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0
      },
      // Add in properties whose names you wish to fix before
      // setting or getting the value
      cssProps: {},
      // Get and set the style property on a DOM Node
      style: function(w, P, K, ne) {
        if (!(!w || w.nodeType === 3 || w.nodeType === 8 || !w.style)) {
          var ge, _e, be, He = tt(P), De = at.test(P), Je = w.style;
          if (De || (P = Ai(He)), be = Z.cssHooks[P] || Z.cssHooks[He], K !== void 0) {
            if (_e = typeof K, _e === "string" && (ge = p.exec(K)) && ge[1] && (K = A(w, P, ge), _e = "number"), K == null || K !== K)
              return;
            _e === "number" && !De && (K += ge && ge[3] || (Z.cssNumber[He] ? "" : "px")), !W.clearCloneStyle && K === "" && P.indexOf("background") === 0 && (Je[P] = "inherit"), (!be || !("set" in be) || (K = be.set(w, K, ne)) !== void 0) && (De ? Je.setProperty(P, K) : Je[P] = K);
          } else
            return be && "get" in be && (ge = be.get(w, !1, ne)) !== void 0 ? ge : Je[P];
        }
      },
      css: function(w, P, K, ne) {
        var ge, _e, be, He = tt(P), De = at.test(P);
        return De || (P = Ai(He)), be = Z.cssHooks[P] || Z.cssHooks[He], be && "get" in be && (ge = be.get(w, !0, K)), ge === void 0 && (ge = Pt(w, P, ne)), ge === "normal" && P in fi && (ge = fi[P]), K === "" || K ? (_e = parseFloat(ge), K === !0 || isFinite(_e) ? _e || 0 : ge) : ge;
      }
    }), Z.each(["height", "width"], function(w, P) {
      Z.cssHooks[P] = {
        get: function(K, ne, ge) {
          if (ne)
            return pi.test(Z.css(K, "display")) && // Support: Safari 8+
            // Table columns in Safari have non-zero offsetWidth & zero
            // getBoundingClientRect().width unless display is changed.
            // Support: IE <=11 only
            // Running getBoundingClientRect on a disconnected node
            // in IE throws an error.
            (!K.getClientRects().length || !K.getBoundingClientRect().width) ? bt(K, kt, function() {
              return tn(K, P, ge);
            }) : tn(K, P, ge);
        },
        set: function(K, ne, ge) {
          var _e, be = yt(K), He = !W.scrollboxSize() && be.position === "absolute", De = He || ge, Je = De && Z.css(K, "boxSizing", !1, be) === "border-box", Ct = ge ? xi(
            K,
            P,
            ge,
            Je,
            be
          ) : 0;
          return Je && He && (Ct -= Math.ceil(
            K["offset" + P[0].toUpperCase() + P.slice(1)] - parseFloat(be[P]) - xi(K, P, "border", !1, be) - 0.5
          )), Ct && (_e = p.exec(ne)) && (_e[3] || "px") !== "px" && (K.style[P] = ne, ne = Z.css(K, P)), Ti(K, ne, Ct);
        }
      };
    }), Z.cssHooks.marginLeft = zt(
      W.reliableMarginLeft,
      function(w, P) {
        if (P)
          return (parseFloat(Pt(w, "marginLeft")) || w.getBoundingClientRect().left - bt(w, { marginLeft: 0 }, function() {
            return w.getBoundingClientRect().left;
          })) + "px";
      }
    ), Z.each({
      margin: "",
      padding: "",
      border: "Width"
    }, function(w, P) {
      Z.cssHooks[w + P] = {
        expand: function(K) {
          for (var ne = 0, ge = {}, _e = typeof K == "string" ? K.split(" ") : [K]; ne < 4; ne++)
            ge[w + m[ne] + P] = _e[ne] || _e[ne - 2] || _e[0];
          return ge;
        }
      }, w !== "margin" && (Z.cssHooks[w + P].set = Ti);
    }), Z.fn.extend({
      css: function(w, P) {
        return Ie(this, function(K, ne, ge) {
          var _e, be, He = {}, De = 0;
          if (Array.isArray(ne)) {
            for (_e = yt(K), be = ne.length; De < be; De++)
              He[ne[De]] = Z.css(K, ne[De], !1, _e);
            return He;
          }
          return ge !== void 0 ? Z.style(K, ne, ge) : Z.css(K, ne);
        }, w, P, arguments.length > 1);
      }
    });
    function Hi(w, P, K, ne, ge) {
      return new Hi.prototype.init(w, P, K, ne, ge);
    }
    Z.Tween = Hi, Hi.prototype = {
      constructor: Hi,
      init: function(w, P, K, ne, ge, _e) {
        this.elem = w, this.prop = K, this.easing = ge || Z.easing._default, this.options = P, this.start = this.now = this.cur(), this.end = ne, this.unit = _e || (Z.cssNumber[K] ? "" : "px");
      },
      cur: function() {
        var w = Hi.propHooks[this.prop];
        return w && w.get ? w.get(this) : Hi.propHooks._default.get(this);
      },
      run: function(w) {
        var P, K = Hi.propHooks[this.prop];
        return this.options.duration ? this.pos = P = Z.easing[this.easing](
          w,
          this.options.duration * w,
          0,
          1,
          this.options.duration
        ) : this.pos = P = w, this.now = (this.end - this.start) * P + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), K && K.set ? K.set(this) : Hi.propHooks._default.set(this), this;
      }
    }, Hi.prototype.init.prototype = Hi.prototype, Hi.propHooks = {
      _default: {
        get: function(w) {
          var P;
          return w.elem.nodeType !== 1 || w.elem[w.prop] != null && w.elem.style[w.prop] == null ? w.elem[w.prop] : (P = Z.css(w.elem, w.prop, ""), !P || P === "auto" ? 0 : P);
        },
        set: function(w) {
          Z.fx.step[w.prop] ? Z.fx.step[w.prop](w) : w.elem.nodeType === 1 && (Z.cssHooks[w.prop] || w.elem.style[Ai(w.prop)] != null) ? Z.style(w.elem, w.prop, w.now + w.unit) : w.elem[w.prop] = w.now;
        }
      }
    }, Hi.propHooks.scrollTop = Hi.propHooks.scrollLeft = {
      set: function(w) {
        w.elem.nodeType && w.elem.parentNode && (w.elem[w.prop] = w.now);
      }
    }, Z.easing = {
      linear: function(w) {
        return w;
      },
      swing: function(w) {
        return 0.5 - Math.cos(w * Math.PI) / 2;
      },
      _default: "swing"
    }, Z.fx = Hi.prototype.init, Z.fx.step = {};
    var Zi, Xi, ji = /^(?:toggle|show|hide)$/, Ki = /queueHooks$/;
    function ln() {
      Xi && (D.hidden === !1 && e.requestAnimationFrame ? e.requestAnimationFrame(ln) : e.setTimeout(ln, Z.fx.interval), Z.fx.tick());
    }
    function Fi() {
      return e.setTimeout(function() {
        Zi = void 0;
      }), Zi = Date.now();
    }
    function hn(w, P) {
      var K, ne = 0, ge = { height: w };
      for (P = P ? 1 : 0; ne < 4; ne += 2 - P)
        K = m[ne], ge["margin" + K] = ge["padding" + K] = w;
      return P && (ge.opacity = ge.width = w), ge;
    }
    function kr(w, P, K) {
      for (var ne, ge = (Nn.tweeners[P] || []).concat(Nn.tweeners["*"]), _e = 0, be = ge.length; _e < be; _e++)
        if (ne = ge[_e].call(K, P, w))
          return ne;
    }
    function Er(w, P, K) {
      var ne, ge, _e, be, He, De, Je, Ct, Bt = "width" in P || "height" in P, dt = this, Ut = {}, ti = w.style, wi = w.nodeType && E(w), bi = Ve.get(w, "fxshow");
      K.queue || (be = Z._queueHooks(w, "fx"), be.unqueued == null && (be.unqueued = 0, He = be.empty.fire, be.empty.fire = function() {
        be.unqueued || He();
      }), be.unqueued++, dt.always(function() {
        dt.always(function() {
          be.unqueued--, Z.queue(w, "fx").length || be.empty.fire();
        });
      }));
      for (ne in P)
        if (ge = P[ne], ji.test(ge)) {
          if (delete P[ne], _e = _e || ge === "toggle", ge === (wi ? "hide" : "show"))
            if (ge === "show" && bi && bi[ne] !== void 0)
              wi = !0;
            else
              continue;
          Ut[ne] = bi && bi[ne] || Z.style(w, ne);
        }
      if (De = !Z.isEmptyObject(P), !(!De && Z.isEmptyObject(Ut))) {
        Bt && w.nodeType === 1 && (K.overflow = [ti.overflow, ti.overflowX, ti.overflowY], Je = bi && bi.display, Je == null && (Je = Ve.get(w, "display")), Ct = Z.css(w, "display"), Ct === "none" && (Je ? Ct = Je : (O([w], !0), Je = w.style.display || Je, Ct = Z.css(w, "display"), O([w]))), (Ct === "inline" || Ct === "inline-block" && Je != null) && Z.css(w, "float") === "none" && (De || (dt.done(function() {
          ti.display = Je;
        }), Je == null && (Ct = ti.display, Je = Ct === "none" ? "" : Ct)), ti.display = "inline-block")), K.overflow && (ti.overflow = "hidden", dt.always(function() {
          ti.overflow = K.overflow[0], ti.overflowX = K.overflow[1], ti.overflowY = K.overflow[2];
        })), De = !1;
        for (ne in Ut)
          De || (bi ? "hidden" in bi && (wi = bi.hidden) : bi = Ve.access(w, "fxshow", { display: Je }), _e && (bi.hidden = !wi), wi && O([w], !0), dt.done(function() {
            wi || O([w]), Ve.remove(w, "fxshow");
            for (ne in Ut)
              Z.style(w, ne, Ut[ne]);
          })), De = kr(wi ? bi[ne] : 0, ne, dt), ne in bi || (bi[ne] = De.start, wi && (De.end = De.start, De.start = 0));
      }
    }
    function Ir(w, P) {
      var K, ne, ge, _e, be;
      for (K in w)
        if (ne = tt(K), ge = P[ne], _e = w[K], Array.isArray(_e) && (ge = _e[1], _e = w[K] = _e[0]), K !== ne && (w[ne] = _e, delete w[K]), be = Z.cssHooks[ne], be && "expand" in be) {
          _e = be.expand(_e), delete w[ne];
          for (K in _e)
            K in w || (w[K] = _e[K], P[K] = ge);
        } else
          P[ne] = ge;
    }
    function Nn(w, P, K) {
      var ne, ge, _e = 0, be = Nn.prefilters.length, He = Z.Deferred().always(function() {
        delete De.elem;
      }), De = function() {
        if (ge)
          return !1;
        for (var Bt = Zi || Fi(), dt = Math.max(0, Je.startTime + Je.duration - Bt), Ut = dt / Je.duration || 0, ti = 1 - Ut, wi = 0, bi = Je.tweens.length; wi < bi; wi++)
          Je.tweens[wi].run(ti);
        return He.notifyWith(w, [Je, ti, dt]), ti < 1 && bi ? dt : (bi || He.notifyWith(w, [Je, 1, 0]), He.resolveWith(w, [Je]), !1);
      }, Je = He.promise({
        elem: w,
        props: Z.extend({}, P),
        opts: Z.extend(!0, {
          specialEasing: {},
          easing: Z.easing._default
        }, K),
        originalProperties: P,
        originalOptions: K,
        startTime: Zi || Fi(),
        duration: K.duration,
        tweens: [],
        createTween: function(Bt, dt) {
          var Ut = Z.Tween(
            w,
            Je.opts,
            Bt,
            dt,
            Je.opts.specialEasing[Bt] || Je.opts.easing
          );
          return Je.tweens.push(Ut), Ut;
        },
        stop: function(Bt) {
          var dt = 0, Ut = Bt ? Je.tweens.length : 0;
          if (ge)
            return this;
          for (ge = !0; dt < Ut; dt++)
            Je.tweens[dt].run(1);
          return Bt ? (He.notifyWith(w, [Je, 1, 0]), He.resolveWith(w, [Je, Bt])) : He.rejectWith(w, [Je, Bt]), this;
        }
      }), Ct = Je.props;
      for (Ir(Ct, Je.opts.specialEasing); _e < be; _e++)
        if (ne = Nn.prefilters[_e].call(Je, w, Ct, Je.opts), ne)
          return U(ne.stop) && (Z._queueHooks(Je.elem, Je.opts.queue).stop = ne.stop.bind(ne)), ne;
      return Z.map(Ct, kr, Je), U(Je.opts.start) && Je.opts.start.call(w, Je), Je.progress(Je.opts.progress).done(Je.opts.done, Je.opts.complete).fail(Je.opts.fail).always(Je.opts.always), Z.fx.timer(
        Z.extend(De, {
          elem: w,
          anim: Je,
          queue: Je.opts.queue
        })
      ), Je;
    }
    Z.Animation = Z.extend(Nn, {
      tweeners: {
        "*": [function(w, P) {
          var K = this.createTween(w, P);
          return A(K.elem, w, p.exec(P), K), K;
        }]
      },
      tweener: function(w, P) {
        U(w) ? (P = w, w = ["*"]) : w = w.match(Jt);
        for (var K, ne = 0, ge = w.length; ne < ge; ne++)
          K = w[ne], Nn.tweeners[K] = Nn.tweeners[K] || [], Nn.tweeners[K].unshift(P);
      },
      prefilters: [Er],
      prefilter: function(w, P) {
        P ? Nn.prefilters.unshift(w) : Nn.prefilters.push(w);
      }
    }), Z.speed = function(w, P, K) {
      var ne = w && typeof w == "object" ? Z.extend({}, w) : {
        complete: K || !K && P || U(w) && w,
        duration: w,
        easing: K && P || P && !U(P) && P
      };
      return Z.fx.off ? ne.duration = 0 : typeof ne.duration != "number" && (ne.duration in Z.fx.speeds ? ne.duration = Z.fx.speeds[ne.duration] : ne.duration = Z.fx.speeds._default), (ne.queue == null || ne.queue === !0) && (ne.queue = "fx"), ne.old = ne.complete, ne.complete = function() {
        U(ne.old) && ne.old.call(this), ne.queue && Z.dequeue(this, ne.queue);
      }, ne;
    }, Z.fn.extend({
      fadeTo: function(w, P, K, ne) {
        return this.filter(E).css("opacity", 0).show().end().animate({ opacity: P }, w, K, ne);
      },
      animate: function(w, P, K, ne) {
        var ge = Z.isEmptyObject(w), _e = Z.speed(P, K, ne), be = function() {
          var He = Nn(this, Z.extend({}, w), _e);
          (ge || Ve.get(this, "finish")) && He.stop(!0);
        };
        return be.finish = be, ge || _e.queue === !1 ? this.each(be) : this.queue(_e.queue, be);
      },
      stop: function(w, P, K) {
        var ne = function(ge) {
          var _e = ge.stop;
          delete ge.stop, _e(K);
        };
        return typeof w != "string" && (K = P, P = w, w = void 0), P && this.queue(w || "fx", []), this.each(function() {
          var ge = !0, _e = w != null && w + "queueHooks", be = Z.timers, He = Ve.get(this);
          if (_e)
            He[_e] && He[_e].stop && ne(He[_e]);
          else
            for (_e in He)
              He[_e] && He[_e].stop && Ki.test(_e) && ne(He[_e]);
          for (_e = be.length; _e--; )
            be[_e].elem === this && (w == null || be[_e].queue === w) && (be[_e].anim.stop(K), ge = !1, be.splice(_e, 1));
          (ge || !K) && Z.dequeue(this, w);
        });
      },
      finish: function(w) {
        return w !== !1 && (w = w || "fx"), this.each(function() {
          var P, K = Ve.get(this), ne = K[w + "queue"], ge = K[w + "queueHooks"], _e = Z.timers, be = ne ? ne.length : 0;
          for (K.finish = !0, Z.queue(this, w, []), ge && ge.stop && ge.stop.call(this, !0), P = _e.length; P--; )
            _e[P].elem === this && _e[P].queue === w && (_e[P].anim.stop(!0), _e.splice(P, 1));
          for (P = 0; P < be; P++)
            ne[P] && ne[P].finish && ne[P].finish.call(this);
          delete K.finish;
        });
      }
    }), Z.each(["toggle", "show", "hide"], function(w, P) {
      var K = Z.fn[P];
      Z.fn[P] = function(ne, ge, _e) {
        return ne == null || typeof ne == "boolean" ? K.apply(this, arguments) : this.animate(hn(P, !0), ne, ge, _e);
      };
    }), Z.each({
      slideDown: hn("show"),
      slideUp: hn("hide"),
      slideToggle: hn("toggle"),
      fadeIn: { opacity: "show" },
      fadeOut: { opacity: "hide" },
      fadeToggle: { opacity: "toggle" }
    }, function(w, P) {
      Z.fn[w] = function(K, ne, ge) {
        return this.animate(P, K, ne, ge);
      };
    }), Z.timers = [], Z.fx.tick = function() {
      var w, P = 0, K = Z.timers;
      for (Zi = Date.now(); P < K.length; P++)
        w = K[P], !w() && K[P] === w && K.splice(P--, 1);
      K.length || Z.fx.stop(), Zi = void 0;
    }, Z.fx.timer = function(w) {
      Z.timers.push(w), Z.fx.start();
    }, Z.fx.interval = 13, Z.fx.start = function() {
      Xi || (Xi = !0, ln());
    }, Z.fx.stop = function() {
      Xi = null;
    }, Z.fx.speeds = {
      slow: 600,
      fast: 200,
      // Default speed
      _default: 400
    }, Z.fn.delay = function(w, P) {
      return w = Z.fx && Z.fx.speeds[w] || w, P = P || "fx", this.queue(P, function(K, ne) {
        var ge = e.setTimeout(K, w);
        ne.stop = function() {
          e.clearTimeout(ge);
        };
      });
    }, function() {
      var w = D.createElement("input"), P = D.createElement("select"), K = P.appendChild(D.createElement("option"));
      w.type = "checkbox", W.checkOn = w.value !== "", W.optSelected = K.selected, w = D.createElement("input"), w.value = "t", w.type = "radio", W.radioValue = w.value === "t";
    }();
    var Pr, Rn = Z.expr.attrHandle;
    Z.fn.extend({
      attr: function(w, P) {
        return Ie(this, Z.attr, w, P, arguments.length > 1);
      },
      removeAttr: function(w) {
        return this.each(function() {
          Z.removeAttr(this, w);
        });
      }
    }), Z.extend({
      attr: function(w, P, K) {
        var ne, ge, _e = w.nodeType;
        if (!(_e === 3 || _e === 8 || _e === 2)) {
          if (typeof w.getAttribute > "u")
            return Z.prop(w, P, K);
          if ((_e !== 1 || !Z.isXMLDoc(w)) && (ge = Z.attrHooks[P.toLowerCase()] || (Z.expr.match.bool.test(P) ? Pr : void 0)), K !== void 0) {
            if (K === null) {
              Z.removeAttr(w, P);
              return;
            }
            return ge && "set" in ge && (ne = ge.set(w, K, P)) !== void 0 ? ne : (w.setAttribute(P, K + ""), K);
          }
          return ge && "get" in ge && (ne = ge.get(w, P)) !== null ? ne : (ne = Z.find.attr(w, P), ne ?? void 0);
        }
      },
      attrHooks: {
        type: {
          set: function(w, P) {
            if (!W.radioValue && P === "radio" && Oe(w, "input")) {
              var K = w.value;
              return w.setAttribute("type", P), K && (w.value = K), P;
            }
          }
        }
      },
      removeAttr: function(w, P) {
        var K, ne = 0, ge = P && P.match(Jt);
        if (ge && w.nodeType === 1)
          for (; K = ge[ne++]; )
            w.removeAttribute(K);
      }
    }), Pr = {
      set: function(w, P, K) {
        return P === !1 ? Z.removeAttr(w, K) : w.setAttribute(K, K), K;
      }
    }, Z.each(Z.expr.match.bool.source.match(/\w+/g), function(w, P) {
      var K = Rn[P] || Z.find.attr;
      Rn[P] = function(ne, ge, _e) {
        var be, He, De = ge.toLowerCase();
        return _e || (He = Rn[De], Rn[De] = be, be = K(ne, ge, _e) != null ? De : null, Rn[De] = He), be;
      };
    });
    var qn = /^(?:input|select|textarea|button)$/i, Dn = /^(?:a|area)$/i;
    Z.fn.extend({
      prop: function(w, P) {
        return Ie(this, Z.prop, w, P, arguments.length > 1);
      },
      removeProp: function(w) {
        return this.each(function() {
          delete this[Z.propFix[w] || w];
        });
      }
    }), Z.extend({
      prop: function(w, P, K) {
        var ne, ge, _e = w.nodeType;
        if (!(_e === 3 || _e === 8 || _e === 2))
          return (_e !== 1 || !Z.isXMLDoc(w)) && (P = Z.propFix[P] || P, ge = Z.propHooks[P]), K !== void 0 ? ge && "set" in ge && (ne = ge.set(w, K, P)) !== void 0 ? ne : w[P] = K : ge && "get" in ge && (ne = ge.get(w, P)) !== null ? ne : w[P];
      },
      propHooks: {
        tabIndex: {
          get: function(w) {
            var P = Z.find.attr(w, "tabindex");
            return P ? parseInt(P, 10) : qn.test(w.nodeName) || Dn.test(w.nodeName) && w.href ? 0 : -1;
          }
        }
      },
      propFix: {
        for: "htmlFor",
        class: "className"
      }
    }), W.optSelected || (Z.propHooks.selected = {
      get: function(w) {
        var P = w.parentNode;
        return P && P.parentNode && P.parentNode.selectedIndex, null;
      },
      set: function(w) {
        var P = w.parentNode;
        P && (P.selectedIndex, P.parentNode && P.parentNode.selectedIndex);
      }
    }), Z.each([
      "tabIndex",
      "readOnly",
      "maxLength",
      "cellSpacing",
      "cellPadding",
      "rowSpan",
      "colSpan",
      "useMap",
      "frameBorder",
      "contentEditable"
    ], function() {
      Z.propFix[this.toLowerCase()] = this;
    });
    function Mn(w) {
      var P = w.match(Jt) || [];
      return P.join(" ");
    }
    function gn(w) {
      return w.getAttribute && w.getAttribute("class") || "";
    }
    function yn(w) {
      return Array.isArray(w) ? w : typeof w == "string" ? w.match(Jt) || [] : [];
    }
    Z.fn.extend({
      addClass: function(w) {
        var P, K, ne, ge, _e, be;
        return U(w) ? this.each(function(He) {
          Z(this).addClass(w.call(this, He, gn(this)));
        }) : (P = yn(w), P.length ? this.each(function() {
          if (ne = gn(this), K = this.nodeType === 1 && " " + Mn(ne) + " ", K) {
            for (_e = 0; _e < P.length; _e++)
              ge = P[_e], K.indexOf(" " + ge + " ") < 0 && (K += ge + " ");
            be = Mn(K), ne !== be && this.setAttribute("class", be);
          }
        }) : this);
      },
      removeClass: function(w) {
        var P, K, ne, ge, _e, be;
        return U(w) ? this.each(function(He) {
          Z(this).removeClass(w.call(this, He, gn(this)));
        }) : arguments.length ? (P = yn(w), P.length ? this.each(function() {
          if (ne = gn(this), K = this.nodeType === 1 && " " + Mn(ne) + " ", K) {
            for (_e = 0; _e < P.length; _e++)
              for (ge = P[_e]; K.indexOf(" " + ge + " ") > -1; )
                K = K.replace(" " + ge + " ", " ");
            be = Mn(K), ne !== be && this.setAttribute("class", be);
          }
        }) : this) : this.attr("class", "");
      },
      toggleClass: function(w, P) {
        var K, ne, ge, _e, be = typeof w, He = be === "string" || Array.isArray(w);
        return U(w) ? this.each(function(De) {
          Z(this).toggleClass(
            w.call(this, De, gn(this), P),
            P
          );
        }) : typeof P == "boolean" && He ? P ? this.addClass(w) : this.removeClass(w) : (K = yn(w), this.each(function() {
          if (He)
            for (_e = Z(this), ge = 0; ge < K.length; ge++)
              ne = K[ge], _e.hasClass(ne) ? _e.removeClass(ne) : _e.addClass(ne);
          else
            (w === void 0 || be === "boolean") && (ne = gn(this), ne && Ve.set(this, "__className__", ne), this.setAttribute && this.setAttribute(
              "class",
              ne || w === !1 ? "" : Ve.get(this, "__className__") || ""
            ));
        }));
      },
      hasClass: function(w) {
        var P, K, ne = 0;
        for (P = " " + w + " "; K = this[ne++]; )
          if (K.nodeType === 1 && (" " + Mn(gn(K)) + " ").indexOf(P) > -1)
            return !0;
        return !1;
      }
    });
    var ri = /\r/g;
    Z.fn.extend({
      val: function(w) {
        var P, K, ne, ge = this[0];
        return arguments.length ? (ne = U(w), this.each(function(_e) {
          var be;
          this.nodeType === 1 && (ne ? be = w.call(this, _e, Z(this).val()) : be = w, be == null ? be = "" : typeof be == "number" ? be += "" : Array.isArray(be) && (be = Z.map(be, function(He) {
            return He == null ? "" : He + "";
          })), P = Z.valHooks[this.type] || Z.valHooks[this.nodeName.toLowerCase()], (!P || !("set" in P) || P.set(this, be, "value") === void 0) && (this.value = be));
        })) : ge ? (P = Z.valHooks[ge.type] || Z.valHooks[ge.nodeName.toLowerCase()], P && "get" in P && (K = P.get(ge, "value")) !== void 0 ? K : (K = ge.value, typeof K == "string" ? K.replace(ri, "") : K ?? "")) : void 0;
      }
    }), Z.extend({
      valHooks: {
        option: {
          get: function(w) {
            var P = Z.find.attr(w, "value");
            return P ?? // Support: IE <=10 - 11 only
            // option.text throws exceptions (trac-14686, trac-14858)
            // Strip and collapse whitespace
            // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
            Mn(Z.text(w));
          }
        },
        select: {
          get: function(w) {
            var P, K, ne, ge = w.options, _e = w.selectedIndex, be = w.type === "select-one", He = be ? null : [], De = be ? _e + 1 : ge.length;
            for (_e < 0 ? ne = De : ne = be ? _e : 0; ne < De; ne++)
              if (K = ge[ne], (K.selected || ne === _e) && // Don't return options that are disabled or in a disabled optgroup
              !K.disabled && (!K.parentNode.disabled || !Oe(K.parentNode, "optgroup"))) {
                if (P = Z(K).val(), be)
                  return P;
                He.push(P);
              }
            return He;
          },
          set: function(w, P) {
            for (var K, ne, ge = w.options, _e = Z.makeArray(P), be = ge.length; be--; )
              ne = ge[be], (ne.selected = Z.inArray(Z.valHooks.option.get(ne), _e) > -1) && (K = !0);
            return K || (w.selectedIndex = -1), _e;
          }
        }
      }
    }), Z.each(["radio", "checkbox"], function() {
      Z.valHooks[this] = {
        set: function(w, P) {
          if (Array.isArray(P))
            return w.checked = Z.inArray(Z(w).val(), P) > -1;
        }
      }, W.checkOn || (Z.valHooks[this].get = function(w) {
        return w.getAttribute("value") === null ? "on" : w.value;
      });
    });
    var Ji = e.location, cn = { guid: Date.now() }, sn = /\?/;
    Z.parseXML = function(w) {
      var P, K;
      if (!w || typeof w != "string")
        return null;
      try {
        P = new e.DOMParser().parseFromString(w, "text/xml");
      } catch {
      }
      return K = P && P.getElementsByTagName("parsererror")[0], (!P || K) && Z.error("Invalid XML: " + (K ? Z.map(K.childNodes, function(ne) {
        return ne.textContent;
      }).join(`
`) : w)), P;
    };
    var zn = /^(?:focusinfocus|focusoutblur)$/, xr = function(w) {
      w.stopPropagation();
    };
    Z.extend(Z.event, {
      trigger: function(w, P, K, ne) {
        var ge, _e, be, He, De, Je, Ct, Bt, dt = [K || D], Ut = I.call(w, "type") ? w.type : w, ti = I.call(w, "namespace") ? w.namespace.split(".") : [];
        if (_e = Bt = be = K = K || D, !(K.nodeType === 3 || K.nodeType === 8) && !zn.test(Ut + Z.event.triggered) && (Ut.indexOf(".") > -1 && (ti = Ut.split("."), Ut = ti.shift(), ti.sort()), De = Ut.indexOf(":") < 0 && "on" + Ut, w = w[Z.expando] ? w : new Z.Event(Ut, typeof w == "object" && w), w.isTrigger = ne ? 2 : 3, w.namespace = ti.join("."), w.rnamespace = w.namespace ? new RegExp("(^|\\.)" + ti.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, w.result = void 0, w.target || (w.target = K), P = P == null ? [w] : Z.makeArray(P, [w]), Ct = Z.event.special[Ut] || {}, !(!ne && Ct.trigger && Ct.trigger.apply(K, P) === !1))) {
          if (!ne && !Ct.noBubble && !Q(K)) {
            for (He = Ct.delegateType || Ut, zn.test(He + Ut) || (_e = _e.parentNode); _e; _e = _e.parentNode)
              dt.push(_e), be = _e;
            be === (K.ownerDocument || D) && dt.push(be.defaultView || be.parentWindow || e);
          }
          for (ge = 0; (_e = dt[ge++]) && !w.isPropagationStopped(); )
            Bt = _e, w.type = ge > 1 ? He : Ct.bindType || Ut, Je = (Ve.get(_e, "events") || /* @__PURE__ */ Object.create(null))[w.type] && Ve.get(_e, "handle"), Je && Je.apply(_e, P), Je = De && _e[De], Je && Je.apply && _t(_e) && (w.result = Je.apply(_e, P), w.result === !1 && w.preventDefault());
          return w.type = Ut, !ne && !w.isDefaultPrevented() && (!Ct._default || Ct._default.apply(dt.pop(), P) === !1) && _t(K) && De && U(K[Ut]) && !Q(K) && (be = K[De], be && (K[De] = null), Z.event.triggered = Ut, w.isPropagationStopped() && Bt.addEventListener(Ut, xr), K[Ut](), w.isPropagationStopped() && Bt.removeEventListener(Ut, xr), Z.event.triggered = void 0, be && (K[De] = be)), w.result;
        }
      },
      // Piggyback on a donor event to simulate a different one
      // Used only for `focus(in | out)` events
      simulate: function(w, P, K) {
        var ne = Z.extend(
          new Z.Event(),
          K,
          {
            type: w,
            isSimulated: !0
          }
        );
        Z.event.trigger(ne, null, P);
      }
    }), Z.fn.extend({
      trigger: function(w, P) {
        return this.each(function() {
          Z.event.trigger(w, P, this);
        });
      },
      triggerHandler: function(w, P) {
        var K = this[0];
        if (K)
          return Z.event.trigger(w, P, K, !0);
      }
    });
    var Or = /\[\]$/, fr = /\r?\n/g, g = /^(?:submit|button|image|reset|file)$/i, F = /^(?:input|select|textarea|keygen)/i;
    function ue(w, P, K, ne) {
      var ge;
      if (Array.isArray(P))
        Z.each(P, function(_e, be) {
          K || Or.test(w) ? ne(w, be) : ue(
            w + "[" + (typeof be == "object" && be != null ? _e : "") + "]",
            be,
            K,
            ne
          );
        });
      else if (!K && he(P) === "object")
        for (ge in P)
          ue(w + "[" + ge + "]", P[ge], K, ne);
      else
        ne(w, P);
    }
    Z.param = function(w, P) {
      var K, ne = [], ge = function(_e, be) {
        var He = U(be) ? be() : be;
        ne[ne.length] = encodeURIComponent(_e) + "=" + encodeURIComponent(He ?? "");
      };
      if (w == null)
        return "";
      if (Array.isArray(w) || w.jquery && !Z.isPlainObject(w))
        Z.each(w, function() {
          ge(this.name, this.value);
        });
      else
        for (K in w)
          ue(K, w[K], P, ge);
      return ne.join("&");
    }, Z.fn.extend({
      serialize: function() {
        return Z.param(this.serializeArray());
      },
      serializeArray: function() {
        return this.map(function() {
          var w = Z.prop(this, "elements");
          return w ? Z.makeArray(w) : this;
        }).filter(function() {
          var w = this.type;
          return this.name && !Z(this).is(":disabled") && F.test(this.nodeName) && !g.test(w) && (this.checked || !Y.test(w));
        }).map(function(w, P) {
          var K = Z(this).val();
          return K == null ? null : Array.isArray(K) ? Z.map(K, function(ne) {
            return { name: P.name, value: ne.replace(fr, `\r
`) };
          }) : { name: P.name, value: K.replace(fr, `\r
`) };
        }).get();
      }
    });
    var ye = /%20/g, Ee = /#.*$/, nt = /([?&])_=[^&]*/, gt = /^(.*?):[ \t]*([^\r\n]*)$/mg, Yt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, qt = /^(?:GET|HEAD)$/, li = /^\/\//, ni = {}, si = {}, xn = "*/".concat("*"), dr = D.createElement("a");
    dr.href = Ji.href;
    function tr(w) {
      return function(P, K) {
        typeof P != "string" && (K = P, P = "*");
        var ne, ge = 0, _e = P.toLowerCase().match(Jt) || [];
        if (U(K))
          for (; ne = _e[ge++]; )
            ne[0] === "+" ? (ne = ne.slice(1) || "*", (w[ne] = w[ne] || []).unshift(K)) : (w[ne] = w[ne] || []).push(K);
      };
    }
    function Fn(w, P, K, ne) {
      var ge = {}, _e = w === si;
      function be(He) {
        var De;
        return ge[He] = !0, Z.each(w[He] || [], function(Je, Ct) {
          var Bt = Ct(P, K, ne);
          if (typeof Bt == "string" && !_e && !ge[Bt])
            return P.dataTypes.unshift(Bt), be(Bt), !1;
          if (_e)
            return !(De = Bt);
        }), De;
      }
      return be(P.dataTypes[0]) || !ge["*"] && be("*");
    }
    function sr(w, P) {
      var K, ne, ge = Z.ajaxSettings.flatOptions || {};
      for (K in P)
        P[K] !== void 0 && ((ge[K] ? w : ne || (ne = {}))[K] = P[K]);
      return ne && Z.extend(!0, w, ne), w;
    }
    function wr(w, P, K) {
      for (var ne, ge, _e, be, He = w.contents, De = w.dataTypes; De[0] === "*"; )
        De.shift(), ne === void 0 && (ne = w.mimeType || P.getResponseHeader("Content-Type"));
      if (ne) {
        for (ge in He)
          if (He[ge] && He[ge].test(ne)) {
            De.unshift(ge);
            break;
          }
      }
      if (De[0] in K)
        _e = De[0];
      else {
        for (ge in K) {
          if (!De[0] || w.converters[ge + " " + De[0]]) {
            _e = ge;
            break;
          }
          be || (be = ge);
        }
        _e = _e || be;
      }
      if (_e)
        return _e !== De[0] && De.unshift(_e), K[_e];
    }
    function gs(w, P, K, ne) {
      var ge, _e, be, He, De, Je = {}, Ct = w.dataTypes.slice();
      if (Ct[1])
        for (be in w.converters)
          Je[be.toLowerCase()] = w.converters[be];
      for (_e = Ct.shift(); _e; )
        if (w.responseFields[_e] && (K[w.responseFields[_e]] = P), !De && ne && w.dataFilter && (P = w.dataFilter(P, w.dataType)), De = _e, _e = Ct.shift(), _e) {
          if (_e === "*")
            _e = De;
          else if (De !== "*" && De !== _e) {
            if (be = Je[De + " " + _e] || Je["* " + _e], !be) {
              for (ge in Je)
                if (He = ge.split(" "), He[1] === _e && (be = Je[De + " " + He[0]] || Je["* " + He[0]], be)) {
                  be === !0 ? be = Je[ge] : Je[ge] !== !0 && (_e = He[0], Ct.unshift(He[1]));
                  break;
                }
            }
            if (be !== !0)
              if (be && w.throws)
                P = be(P);
              else
                try {
                  P = be(P);
                } catch (Bt) {
                  return {
                    state: "parsererror",
                    error: be ? Bt : "No conversion from " + De + " to " + _e
                  };
                }
          }
        }
      return { state: "success", data: P };
    }
    Z.extend({
      // Counter for holding the number of active queries
      active: 0,
      // Last-Modified header cache for next request
      lastModified: {},
      etag: {},
      ajaxSettings: {
        url: Ji.href,
        type: "GET",
        isLocal: Yt.test(Ji.protocol),
        global: !0,
        processData: !0,
        async: !0,
        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
        /*
        timeout: 0,
        data: null,
        dataType: null,
        username: null,
        password: null,
        cache: null,
        throws: false,
        traditional: false,
        headers: {},
        */
        accepts: {
          "*": xn,
          text: "text/plain",
          html: "text/html",
          xml: "application/xml, text/xml",
          json: "application/json, text/javascript"
        },
        contents: {
          xml: /\bxml\b/,
          html: /\bhtml/,
          json: /\bjson\b/
        },
        responseFields: {
          xml: "responseXML",
          text: "responseText",
          json: "responseJSON"
        },
        // Data converters
        // Keys separate source (or catchall "*") and destination types with a single space
        converters: {
          // Convert anything to text
          "* text": String,
          // Text to html (true = no transformation)
          "text html": !0,
          // Evaluate text as a json expression
          "text json": JSON.parse,
          // Parse text as xml
          "text xml": Z.parseXML
        },
        // For options that shouldn't be deep extended:
        // you can add your own custom options here if
        // and when you create one that shouldn't be
        // deep extended (see ajaxExtend)
        flatOptions: {
          url: !0,
          context: !0
        }
      },
      // Creates a full fledged settings object into target
      // with both ajaxSettings and settings fields.
      // If target is omitted, writes into ajaxSettings.
      ajaxSetup: function(w, P) {
        return P ? (
          // Building a settings object
          sr(sr(w, Z.ajaxSettings), P)
        ) : (
          // Extending ajaxSettings
          sr(Z.ajaxSettings, w)
        );
      },
      ajaxPrefilter: tr(ni),
      ajaxTransport: tr(si),
      // Main method
      ajax: function(w, P) {
        typeof w == "object" && (P = w, w = void 0), P = P || {};
        var K, ne, ge, _e, be, He, De, Je, Ct, Bt, dt = Z.ajaxSetup({}, P), Ut = dt.context || dt, ti = dt.context && (Ut.nodeType || Ut.jquery) ? Z(Ut) : Z.event, wi = Z.Deferred(), bi = Z.Callbacks("once memory"), Cn = dt.statusCode || {}, mn = {}, fn = {}, mi = "canceled", ki = {
          readyState: 0,
          // Builds headers hashtable if needed
          getResponseHeader: function(Oi) {
            var qi;
            if (De) {
              if (!_e)
                for (_e = {}; qi = gt.exec(ge); )
                  _e[qi[1].toLowerCase() + " "] = (_e[qi[1].toLowerCase() + " "] || []).concat(qi[2]);
              qi = _e[Oi.toLowerCase() + " "];
            }
            return qi == null ? null : qi.join(", ");
          },
          // Raw string
          getAllResponseHeaders: function() {
            return De ? ge : null;
          },
          // Caches the header
          setRequestHeader: function(Oi, qi) {
            return De == null && (Oi = fn[Oi.toLowerCase()] = fn[Oi.toLowerCase()] || Oi, mn[Oi] = qi), this;
          },
          // Overrides response content-type header
          overrideMimeType: function(Oi) {
            return De == null && (dt.mimeType = Oi), this;
          },
          // Status-dependent callbacks
          statusCode: function(Oi) {
            var qi;
            if (Oi)
              if (De)
                ki.always(Oi[ki.status]);
              else
                for (qi in Oi)
                  Cn[qi] = [Cn[qi], Oi[qi]];
            return this;
          },
          // Cancel the request
          abort: function(Oi) {
            var qi = Oi || mi;
            return K && K.abort(qi), En(0, qi), this;
          }
        };
        if (wi.promise(ki), dt.url = ((w || dt.url || Ji.href) + "").replace(li, Ji.protocol + "//"), dt.type = P.method || P.type || dt.method || dt.type, dt.dataTypes = (dt.dataType || "*").toLowerCase().match(Jt) || [""], dt.crossDomain == null) {
          He = D.createElement("a");
          try {
            He.href = dt.url, He.href = He.href, dt.crossDomain = dr.protocol + "//" + dr.host != He.protocol + "//" + He.host;
          } catch {
            dt.crossDomain = !0;
          }
        }
        if (dt.data && dt.processData && typeof dt.data != "string" && (dt.data = Z.param(dt.data, dt.traditional)), Fn(ni, dt, P, ki), De)
          return ki;
        Je = Z.event && dt.global, Je && Z.active++ === 0 && Z.event.trigger("ajaxStart"), dt.type = dt.type.toUpperCase(), dt.hasContent = !qt.test(dt.type), ne = dt.url.replace(Ee, ""), dt.hasContent ? dt.data && dt.processData && (dt.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && (dt.data = dt.data.replace(ye, "+")) : (Bt = dt.url.slice(ne.length), dt.data && (dt.processData || typeof dt.data == "string") && (ne += (sn.test(ne) ? "&" : "?") + dt.data, delete dt.data), dt.cache === !1 && (ne = ne.replace(nt, "$1"), Bt = (sn.test(ne) ? "&" : "?") + "_=" + cn.guid++ + Bt), dt.url = ne + Bt), dt.ifModified && (Z.lastModified[ne] && ki.setRequestHeader("If-Modified-Since", Z.lastModified[ne]), Z.etag[ne] && ki.setRequestHeader("If-None-Match", Z.etag[ne])), (dt.data && dt.hasContent && dt.contentType !== !1 || P.contentType) && ki.setRequestHeader("Content-Type", dt.contentType), ki.setRequestHeader(
          "Accept",
          dt.dataTypes[0] && dt.accepts[dt.dataTypes[0]] ? dt.accepts[dt.dataTypes[0]] + (dt.dataTypes[0] !== "*" ? ", " + xn + "; q=0.01" : "") : dt.accepts["*"]
        );
        for (Ct in dt.headers)
          ki.setRequestHeader(Ct, dt.headers[Ct]);
        if (dt.beforeSend && (dt.beforeSend.call(Ut, ki, dt) === !1 || De))
          return ki.abort();
        if (mi = "abort", bi.add(dt.complete), ki.done(dt.success), ki.fail(dt.error), K = Fn(si, dt, P, ki), !K)
          En(-1, "No Transport");
        else {
          if (ki.readyState = 1, Je && ti.trigger("ajaxSend", [ki, dt]), De)
            return ki;
          dt.async && dt.timeout > 0 && (be = e.setTimeout(function() {
            ki.abort("timeout");
          }, dt.timeout));
          try {
            De = !1, K.send(mn, En);
          } catch (Oi) {
            if (De)
              throw Oi;
            En(-1, Oi);
          }
        }
        function En(Oi, qi, rs, ar) {
          var _n, gr, Hn, ei, Xn, In = qi;
          De || (De = !0, be && e.clearTimeout(be), K = void 0, ge = ar || "", ki.readyState = Oi > 0 ? 4 : 0, _n = Oi >= 200 && Oi < 300 || Oi === 304, rs && (ei = wr(dt, ki, rs)), !_n && Z.inArray("script", dt.dataTypes) > -1 && Z.inArray("json", dt.dataTypes) < 0 && (dt.converters["text script"] = function() {
          }), ei = gs(dt, ei, ki, _n), _n ? (dt.ifModified && (Xn = ki.getResponseHeader("Last-Modified"), Xn && (Z.lastModified[ne] = Xn), Xn = ki.getResponseHeader("etag"), Xn && (Z.etag[ne] = Xn)), Oi === 204 || dt.type === "HEAD" ? In = "nocontent" : Oi === 304 ? In = "notmodified" : (In = ei.state, gr = ei.data, Hn = ei.error, _n = !Hn)) : (Hn = In, (Oi || !In) && (In = "error", Oi < 0 && (Oi = 0))), ki.status = Oi, ki.statusText = (qi || In) + "", _n ? wi.resolveWith(Ut, [gr, In, ki]) : wi.rejectWith(Ut, [ki, In, Hn]), ki.statusCode(Cn), Cn = void 0, Je && ti.trigger(
            _n ? "ajaxSuccess" : "ajaxError",
            [ki, dt, _n ? gr : Hn]
          ), bi.fireWith(Ut, [ki, In]), Je && (ti.trigger("ajaxComplete", [ki, dt]), --Z.active || Z.event.trigger("ajaxStop")));
        }
        return ki;
      },
      getJSON: function(w, P, K) {
        return Z.get(w, P, K, "json");
      },
      getScript: function(w, P) {
        return Z.get(w, void 0, P, "script");
      }
    }), Z.each(["get", "post"], function(w, P) {
      Z[P] = function(K, ne, ge, _e) {
        return U(ne) && (_e = _e || ge, ge = ne, ne = void 0), Z.ajax(Z.extend({
          url: K,
          type: P,
          dataType: _e,
          data: ne,
          success: ge
        }, Z.isPlainObject(K) && K));
      };
    }), Z.ajaxPrefilter(function(w) {
      var P;
      for (P in w.headers)
        P.toLowerCase() === "content-type" && (w.contentType = w.headers[P] || "");
    }), Z._evalUrl = function(w, P, K) {
      return Z.ajax({
        url: w,
        // Make this explicit, since user can override this through ajaxSetup (trac-11264)
        type: "GET",
        dataType: "script",
        cache: !0,
        async: !1,
        global: !1,
        // Only evaluate the response if it is successful (gh-4126)
        // dataFilter is not invoked for failure responses, so using it instead
        // of the default converter is kludgy but it works.
        converters: {
          "text script": function() {
          }
        },
        dataFilter: function(ne) {
          Z.globalEval(ne, P, K);
        }
      });
    }, Z.fn.extend({
      wrapAll: function(w) {
        var P;
        return this[0] && (U(w) && (w = w.call(this[0])), P = Z(w, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && P.insertBefore(this[0]), P.map(function() {
          for (var K = this; K.firstElementChild; )
            K = K.firstElementChild;
          return K;
        }).append(this)), this;
      },
      wrapInner: function(w) {
        return U(w) ? this.each(function(P) {
          Z(this).wrapInner(w.call(this, P));
        }) : this.each(function() {
          var P = Z(this), K = P.contents();
          K.length ? K.wrapAll(w) : P.append(w);
        });
      },
      wrap: function(w) {
        var P = U(w);
        return this.each(function(K) {
          Z(this).wrapAll(P ? w.call(this, K) : w);
        });
      },
      unwrap: function(w) {
        return this.parent(w).not("body").each(function() {
          Z(this).replaceWith(this.childNodes);
        }), this;
      }
    }), Z.expr.pseudos.hidden = function(w) {
      return !Z.expr.pseudos.visible(w);
    }, Z.expr.pseudos.visible = function(w) {
      return !!(w.offsetWidth || w.offsetHeight || w.getClientRects().length);
    }, Z.ajaxSettings.xhr = function() {
      try {
        return new e.XMLHttpRequest();
      } catch {
      }
    };
    var Nr = {
      // File protocol always yields status code 0, assume 200
      0: 200,
      // Support: IE <=9 only
      // trac-1450: sometimes IE returns 1223 when it should be 204
      1223: 204
    }, pn = Z.ajaxSettings.xhr();
    W.cors = !!pn && "withCredentials" in pn, W.ajax = pn = !!pn, Z.ajaxTransport(function(w) {
      var P, K;
      if (W.cors || pn && !w.crossDomain)
        return {
          send: function(ne, ge) {
            var _e, be = w.xhr();
            if (be.open(
              w.type,
              w.url,
              w.async,
              w.username,
              w.password
            ), w.xhrFields)
              for (_e in w.xhrFields)
                be[_e] = w.xhrFields[_e];
            w.mimeType && be.overrideMimeType && be.overrideMimeType(w.mimeType), !w.crossDomain && !ne["X-Requested-With"] && (ne["X-Requested-With"] = "XMLHttpRequest");
            for (_e in ne)
              be.setRequestHeader(_e, ne[_e]);
            P = function(He) {
              return function() {
                P && (P = K = be.onload = be.onerror = be.onabort = be.ontimeout = be.onreadystatechange = null, He === "abort" ? be.abort() : He === "error" ? typeof be.status != "number" ? ge(0, "error") : ge(
                  // File: protocol always yields status 0; see trac-8605, trac-14207
                  be.status,
                  be.statusText
                ) : ge(
                  Nr[be.status] || be.status,
                  be.statusText,
                  // Support: IE <=9 only
                  // IE9 has no XHR2 but throws on binary (trac-11426)
                  // For XHR2 non-text, let the caller handle it (gh-2498)
                  (be.responseType || "text") !== "text" || typeof be.responseText != "string" ? { binary: be.response } : { text: be.responseText },
                  be.getAllResponseHeaders()
                ));
              };
            }, be.onload = P(), K = be.onerror = be.ontimeout = P("error"), be.onabort !== void 0 ? be.onabort = K : be.onreadystatechange = function() {
              be.readyState === 4 && e.setTimeout(function() {
                P && K();
              });
            }, P = P("abort");
            try {
              be.send(w.hasContent && w.data || null);
            } catch (He) {
              if (P)
                throw He;
            }
          },
          abort: function() {
            P && P();
          }
        };
    }), Z.ajaxPrefilter(function(w) {
      w.crossDomain && (w.contents.script = !1);
    }), Z.ajaxSetup({
      accepts: {
        script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
      },
      contents: {
        script: /\b(?:java|ecma)script\b/
      },
      converters: {
        "text script": function(w) {
          return Z.globalEval(w), w;
        }
      }
    }), Z.ajaxPrefilter("script", function(w) {
      w.cache === void 0 && (w.cache = !1), w.crossDomain && (w.type = "GET");
    }), Z.ajaxTransport("script", function(w) {
      if (w.crossDomain || w.scriptAttrs) {
        var P, K;
        return {
          send: function(ne, ge) {
            P = Z("<script>").attr(w.scriptAttrs || {}).prop({ charset: w.scriptCharset, src: w.url }).on("load error", K = function(_e) {
              P.remove(), K = null, _e && ge(_e.type === "error" ? 404 : 200, _e.type);
            }), D.head.appendChild(P[0]);
          },
          abort: function() {
            K && K();
          }
        };
      }
    });
    var ps = [], ir = /(=)\?(?=&|$)|\?\?/;
    Z.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function() {
        var w = ps.pop() || Z.expando + "_" + cn.guid++;
        return this[w] = !0, w;
      }
    }), Z.ajaxPrefilter("json jsonp", function(w, P, K) {
      var ne, ge, _e, be = w.jsonp !== !1 && (ir.test(w.url) ? "url" : typeof w.data == "string" && (w.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && ir.test(w.data) && "data");
      if (be || w.dataTypes[0] === "jsonp")
        return ne = w.jsonpCallback = U(w.jsonpCallback) ? w.jsonpCallback() : w.jsonpCallback, be ? w[be] = w[be].replace(ir, "$1" + ne) : w.jsonp !== !1 && (w.url += (sn.test(w.url) ? "&" : "?") + w.jsonp + "=" + ne), w.converters["script json"] = function() {
          return _e || Z.error(ne + " was not called"), _e[0];
        }, w.dataTypes[0] = "json", ge = e[ne], e[ne] = function() {
          _e = arguments;
        }, K.always(function() {
          ge === void 0 ? Z(e).removeProp(ne) : e[ne] = ge, w[ne] && (w.jsonpCallback = P.jsonpCallback, ps.push(ne)), _e && U(ge) && ge(_e[0]), _e = ge = void 0;
        }), "script";
    }), W.createHTMLDocument = function() {
      var w = D.implementation.createHTMLDocument("").body;
      return w.innerHTML = "<form></form><form></form>", w.childNodes.length === 2;
    }(), Z.parseHTML = function(w, P, K) {
      if (typeof w != "string")
        return [];
      typeof P == "boolean" && (K = P, P = !1);
      var ne, ge, _e;
      return P || (W.createHTMLDocument ? (P = D.implementation.createHTMLDocument(""), ne = P.createElement("base"), ne.href = D.location.href, P.head.appendChild(ne)) : P = D), ge = it.exec(w), _e = !K && [], ge ? [P.createElement(ge[1])] : (ge = H([w], P, _e), _e && _e.length && Z(_e).remove(), Z.merge([], ge.childNodes));
    }, Z.fn.load = function(w, P, K) {
      var ne, ge, _e, be = this, He = w.indexOf(" ");
      return He > -1 && (ne = Mn(w.slice(He)), w = w.slice(0, He)), U(P) ? (K = P, P = void 0) : P && typeof P == "object" && (ge = "POST"), be.length > 0 && Z.ajax({
        url: w,
        // If "type" variable is undefined, then "GET" method will be used.
        // Make value of this field explicit since
        // user can override it through ajaxSetup method
        type: ge || "GET",
        dataType: "html",
        data: P
      }).done(function(De) {
        _e = arguments, be.html(ne ? (
          // If a selector was specified, locate the right elements in a dummy div
          // Exclude scripts to avoid IE 'Permission Denied' errors
          Z("<div>").append(Z.parseHTML(De)).find(ne)
        ) : (
          // Otherwise use the full result
          De
        ));
      }).always(K && function(De, Je) {
        be.each(function() {
          K.apply(this, _e || [De.responseText, Je, De]);
        });
      }), this;
    }, Z.expr.pseudos.animated = function(w) {
      return Z.grep(Z.timers, function(P) {
        return w === P.elem;
      }).length;
    }, Z.offset = {
      setOffset: function(w, P, K) {
        var ne, ge, _e, be, He, De, Je, Ct = Z.css(w, "position"), Bt = Z(w), dt = {};
        Ct === "static" && (w.style.position = "relative"), He = Bt.offset(), _e = Z.css(w, "top"), De = Z.css(w, "left"), Je = (Ct === "absolute" || Ct === "fixed") && (_e + De).indexOf("auto") > -1, Je ? (ne = Bt.position(), be = ne.top, ge = ne.left) : (be = parseFloat(_e) || 0, ge = parseFloat(De) || 0), U(P) && (P = P.call(w, K, Z.extend({}, He))), P.top != null && (dt.top = P.top - He.top + be), P.left != null && (dt.left = P.left - He.left + ge), "using" in P ? P.using.call(w, dt) : Bt.css(dt);
      }
    }, Z.fn.extend({
      // offset() relates an element's border box to the document origin
      offset: function(w) {
        if (arguments.length)
          return w === void 0 ? this : this.each(function(ge) {
            Z.offset.setOffset(this, w, ge);
          });
        var P, K, ne = this[0];
        if (ne)
          return ne.getClientRects().length ? (P = ne.getBoundingClientRect(), K = ne.ownerDocument.defaultView, {
            top: P.top + K.pageYOffset,
            left: P.left + K.pageXOffset
          }) : { top: 0, left: 0 };
      },
      // position() relates an element's margin box to its offset parent's padding box
      // This corresponds to the behavior of CSS absolute positioning
      position: function() {
        if (this[0]) {
          var w, P, K, ne = this[0], ge = { top: 0, left: 0 };
          if (Z.css(ne, "position") === "fixed")
            P = ne.getBoundingClientRect();
          else {
            for (P = this.offset(), K = ne.ownerDocument, w = ne.offsetParent || K.documentElement; w && (w === K.body || w === K.documentElement) && Z.css(w, "position") === "static"; )
              w = w.parentNode;
            w && w !== ne && w.nodeType === 1 && (ge = Z(w).offset(), ge.top += Z.css(w, "borderTopWidth", !0), ge.left += Z.css(w, "borderLeftWidth", !0));
          }
          return {
            top: P.top - ge.top - Z.css(ne, "marginTop", !0),
            left: P.left - ge.left - Z.css(ne, "marginLeft", !0)
          };
        }
      },
      // This method will return documentElement in the following cases:
      // 1) For the element inside the iframe without offsetParent, this method will return
      //    documentElement of the parent window
      // 2) For the hidden or detached element
      // 3) For body or html element, i.e. in case of the html node - it will return itself
      //
      // but those exceptions were never presented as a real life use-cases
      // and might be considered as more preferable results.
      //
      // This logic, however, is not guaranteed and can change at any point in the future
      offsetParent: function() {
        return this.map(function() {
          for (var w = this.offsetParent; w && Z.css(w, "position") === "static"; )
            w = w.offsetParent;
          return w || y;
        });
      }
    }), Z.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function(w, P) {
      var K = P === "pageYOffset";
      Z.fn[w] = function(ne) {
        return Ie(this, function(ge, _e, be) {
          var He;
          if (Q(ge) ? He = ge : ge.nodeType === 9 && (He = ge.defaultView), be === void 0)
            return He ? He[P] : ge[_e];
          He ? He.scrollTo(
            K ? He.pageXOffset : be,
            K ? be : He.pageYOffset
          ) : ge[_e] = be;
        }, w, ne, arguments.length);
      };
    }), Z.each(["top", "left"], function(w, P) {
      Z.cssHooks[P] = zt(
        W.pixelPosition,
        function(K, ne) {
          if (ne)
            return ne = Pt(K, P), Fe.test(ne) ? Z(K).position()[P] + "px" : ne;
        }
      );
    }), Z.each({ Height: "height", Width: "width" }, function(w, P) {
      Z.each({
        padding: "inner" + w,
        content: P,
        "": "outer" + w
      }, function(K, ne) {
        Z.fn[ne] = function(ge, _e) {
          var be = arguments.length && (K || typeof ge != "boolean"), He = K || (ge === !0 || _e === !0 ? "margin" : "border");
          return Ie(this, function(De, Je, Ct) {
            var Bt;
            return Q(De) ? ne.indexOf("outer") === 0 ? De["inner" + w] : De.document.documentElement["client" + w] : De.nodeType === 9 ? (Bt = De.documentElement, Math.max(
              De.body["scroll" + w],
              Bt["scroll" + w],
              De.body["offset" + w],
              Bt["offset" + w],
              Bt["client" + w]
            )) : Ct === void 0 ? (
              // Get width or height on the element, requesting but not forcing parseFloat
              Z.css(De, Je, He)
            ) : (
              // Set width or height on the element
              Z.style(De, Je, Ct, He)
            );
          }, P, be ? ge : void 0, be);
        };
      });
    }), Z.each([
      "ajaxStart",
      "ajaxStop",
      "ajaxComplete",
      "ajaxError",
      "ajaxSuccess",
      "ajaxSend"
    ], function(w, P) {
      Z.fn[P] = function(K) {
        return this.on(P, K);
      };
    }), Z.fn.extend({
      bind: function(w, P, K) {
        return this.on(w, null, P, K);
      },
      unbind: function(w, P) {
        return this.off(w, null, P);
      },
      delegate: function(w, P, K, ne) {
        return this.on(P, w, K, ne);
      },
      undelegate: function(w, P, K) {
        return arguments.length === 1 ? this.off(w, "**") : this.off(P, w || "**", K);
      },
      hover: function(w, P) {
        return this.on("mouseenter", w).on("mouseleave", P || w);
      }
    }), Z.each(
      "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),
      function(w, P) {
        Z.fn[P] = function(K, ne) {
          return arguments.length > 0 ? this.on(P, null, K, ne) : this.trigger(P);
        };
      }
    );
    var Ns = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    Z.proxy = function(w, P) {
      var K, ne, ge;
      if (typeof P == "string" && (K = w[P], P = w, w = K), !!U(w))
        return ne = o.call(arguments, 2), ge = function() {
          return w.apply(P || this, ne.concat(o.call(arguments)));
        }, ge.guid = w.guid = w.guid || Z.guid++, ge;
    }, Z.holdReady = function(w) {
      w ? Z.readyWait++ : Z.ready(!0);
    }, Z.isArray = Array.isArray, Z.parseJSON = JSON.parse, Z.nodeName = Oe, Z.isFunction = U, Z.isWindow = Q, Z.camelCase = tt, Z.type = he, Z.now = Date.now, Z.isNumeric = function(w) {
      var P = Z.type(w);
      return (P === "number" || P === "string") && // parseFloat NaNs numeric-cast false positives ("")
      // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
      // subtraction forces infinities to NaN
      !isNaN(w - parseFloat(w));
    }, Z.trim = function(w) {
      return w == null ? "" : (w + "").replace(Ns, "$1");
    };
    var ns = e.jQuery, $n = e.$;
    return Z.noConflict = function(w) {
      return e.$ === Z && (e.$ = $n), w && e.jQuery === Z && (e.jQuery = ns), Z;
    }, typeof t > "u" && (e.jQuery = e.$ = Z), Z;
  });
})(Wd);
var tw = Wd.exports;
const ua = /* @__PURE__ */ ru(tw);
function c1() {
  const b = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, e = window.devicePixelRatio || 1, t = {
    width: window.screen.width * e,
    height: window.screen.height * e
  };
  return !!(b && t.width === 1125 && t.height === 2436);
}
function f1() {
  return /android/i.test(navigator.userAgent);
}
function d1() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
}
function iw() {
  const b = navigator.userAgent || navigator.vendor || self.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
    b
  ) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
    b.substr(0, 4)
  );
}
function g1() {
  const b = document.compatMode === "CSS1Compat";
  return {
    l: window.pageXOffset || (b ? document.documentElement.scrollLeft : document.body.scrollLeft),
    t: window.pageYOffset || (b ? document.documentElement.scrollTop : document.body.scrollTop),
    w: window.innerWidth || (b ? document.documentElement.clientWidth : document.body.clientWidth),
    h: window.innerHeight || (b ? document.documentElement.clientHeight : document.body.clientHeight)
  };
}
function p1(b, e, t) {
  var n = (b * 299 + e * 587 + t * 114) / 1e3;
  return n >= 128 ? "black" : "white";
}
function m1(b) {
  var e = parseInt(b.substr(0, 2), 16), t = parseInt(b.substr(2, 2), 16), n = parseInt(b.substr(4, 2), 16), a = (e * 299 + t * 587 + n * 114) / 1e3;
  return a >= 128 ? "black" : "white";
}
function ra(b, e) {
  return typeof e > "u" || typeof e === null ? !1 : function(n, a) {
    let o = a !== a, h;
    return !o && typeof Array.prototype.indexOf == "function" ? (h = Array.prototype.indexOf, h.call(n, a) > -1) : (h = function(f, v) {
      var x = -1, k = -1;
      for (x = 0; x < f.length; x++) {
        var I = f[x];
        if (o && I !== I || I === v) {
          k = x;
          break;
        }
      }
      return k;
    }, h(n, a) > -1);
  }(b, e);
}
function nw(b) {
  b = String(b).replace(/[^0-9a-f]/gi, ""), b.length < 6 && (b = b[0] + b[0] + b[1] + b[1] + b[2] + b[2]);
  var e = parseInt(b.substr(0 * 2, 2), 16), t = parseInt(b.substr(1 * 2, 2), 16), n = parseInt(b.substr(2 * 2, 2), 16), a = Math.sqrt(e * e * 0.241 + t * t * 0.691 + n * n * 0.068);
  return a;
}
function rw(b) {
  return nw(b) < 130;
}
function sw(b, e = 0) {
  b = String(b).replace(/[^0-9a-f]/gi, ""), b.length < 6 && (b = b[0] + b[0] + b[1] + b[1] + b[2] + b[2]), e = e || 0;
  var t = "#", n, a;
  for (a = 0; a < 3; a++)
    n = parseInt(b.substr(a * 2, 2), 16), n = Math.round(Math.min(Math.max(0, n + n * e), 255)).toString(16), t += ("00" + n).substr(n.length);
  return t;
}
function aw(b, e, t, n) {
  var a = new Image(), o = ua("<canvas>"), h = o[0], f = h.getContext("2d");
  a.crossOrigin = "anonymous", a.onload = function() {
    if (o.attr({ width: a.width, height: a.height }), f = h.getContext("2d"), f) {
      f.drawImage(a, 0, 0);
      let v = Zd(h, a.width, a.height, e, t);
      n && n(v);
    } else
      alert("Get a real browser!");
  }, a.src = b;
}
async function Uh(b) {
  return new Promise((e, t) => {
    const n = new Image(), a = ua("<canvas>");
    let o = a[0], h = o.getContext("2d");
    n.crossOrigin = "anonymous", n.onload = function() {
      if (a.attr({ width: n.width, height: n.height }), h = o.getContext("2d"), h) {
        h.drawImage(n, 0, 0);
        let f = ow(o);
        e(f);
      } else
        t(new Error("HTML5 Canvas not supported"));
    }, n.src = b;
  });
}
function ow(b) {
  const e = b.getContext("2d");
  if (!e)
    return null;
  const t = b.width, n = b.height, o = e.getImageData(0, 0, b.width, b.height).data, h = (Q, D) => o[(t * D + Q) * 4 + 3], f = (Q) => Q < 10, v = (Q) => {
    const D = Q ? 1 : -1;
    for (var ee = Q ? 0 : n - 1; Q ? ee < n : ee > -1; ee += D)
      for (var J = 0; J < t; J++)
        if (!f(h(J, ee)))
          return ee;
    return null;
  }, x = (Q) => {
    const D = Q ? 1 : -1;
    for (var ee = Q ? 0 : t - 1; Q ? ee < t : ee > -1; ee += D)
      for (var J = 0; J < n; J++)
        if (!f(h(ee, J)))
          return ee;
    return null;
  }, k = v(!0), I = v(!1), V = x(!0), M = x(!1);
  if (k != null && I != null && V != null && M != null) {
    const Q = M - V + 1, D = I - k + 1, J = ua("<canvas>").attr({ width: Q, height: D })[0];
    var W = J.getContext("2d");
    if (!W)
      return null;
    W.drawImage(b, V, k, Q, D, 0, 0, Q, D), W.getImageData(0, 0, J.width, J.height);
    var U = J.toDataURL();
    return U;
  } else
    return null;
}
async function _1(b, e, t) {
  return new Promise((n, a) => {
    const o = new Image(), h = ua("<canvas>");
    let f = h[0], v = f.getContext("2d");
    o.crossOrigin = "anonymous", o.onload = function() {
      if (h.attr({ width: o.width, height: o.height }), v = f.getContext("2d"), v) {
        v.drawImage(o, 0, 0);
        let x = Zd(f, o.width, o.height, e, t);
        n(x);
      } else
        a(new Error("HTML5 Canvas not supported"));
    }, o.src = b;
  });
}
function Zd(b, e, t, n, a) {
  const o = b.getContext("2d");
  if (!o)
    return null;
  const f = o.getImageData(0, 0, b.width, b.height).data, v = (ee, J) => f[(e * J + ee) * 4 + 3], x = (ee) => ee === 0, k = (ee) => {
    const J = ee ? 1 : -1;
    for (var he = ee ? 0 : t - 1; ee ? he < t : he > -1; he += J)
      for (var fe = 0; fe < e; fe++)
        if (!x(v(fe, he)))
          return he;
    return null;
  }, I = (ee) => {
    const J = ee ? 1 : -1;
    for (var he = ee ? 0 : e - 1; ee ? he < e : he > -1; he += J)
      for (var fe = 0; fe < t; fe++)
        if (!x(v(he, fe)))
          return he;
    return null;
  }, V = k(!0), M = k(!1), W = I(!0), U = I(!1);
  if (V != null && M != null && W != null && U != null) {
    const ee = U - W, J = M - V, he = n, fe = a, X = he / ee, Z = fe / J;
    let qe = ee * X, Oe = J * X;
    Oe > fe && (qe = ee * Z, Oe = J * Z);
    const pt = ua("<canvas>").attr({ width: he, height: fe })[0];
    var Q = pt.getContext("2d");
    if (!Q)
      return null;
    Q.drawImage(
      b,
      W,
      V,
      ee,
      J,
      (he - qe) / 2,
      (fe - Oe) / 2,
      qe,
      Oe
    ), Q.getImageData(0, 0, pt.width, pt.height);
    var D = pt.toDataURL();
    return D;
  } else
    return null;
}
async function lw(b, e, t, n) {
  return new Promise((a) => {
    const o = new Image();
    o.crossOrigin = "anonymous", o.onload = function() {
      let f = ua("<canvas>")[0], v = f.getContext("2d");
      if (v) {
        f.width = e, f.height = t;
        const x = Math.min(e / o.width, t / o.height), k = o.width * x, I = o.height * x;
        v.drawImage(
          o,
          0,
          0,
          o.width,
          o.height,
          (e - k + n) / 2,
          (t - I + n) / 2,
          k - n,
          I - n
        );
        const V = f.toDataURL();
        a(V);
      }
    }, o.src = b;
  });
}
function v1(b, e, t) {
  var n = ua("<canvas>");
  n.attr({ width: e, height: t });
  var a = n[0], o = a.getContext("2d");
  if (o) {
    o.fillStyle = b, o.fillRect(0, 0, e, t);
    var h = a.toDataURL();
    return h;
  } else
    return null;
}
function y1(b, e) {
  return b ? b.match(new RegExp(".[^]{1," + e + "}", "g")) : null;
}
function b1(b) {
  let e = 0, t, n;
  if (b.length === 0)
    return e;
  for (t = 0; t < b.length; t++)
    n = b.charCodeAt(t), e = (e << 5) - e + n, e |= 0;
  return e;
}
function x1(b) {
  var e = document.createElement("a");
  return e.href = b, e.href;
}
function qd(b) {
  for (var e = atob(b.split(",")[1]), t = b.split(",")[0].split(":")[1].split(";")[0], n = new ArrayBuffer(e.length), a = new Uint8Array(n), o = 0; o < e.length; o++)
    a[o] = e.charCodeAt(o);
  var h = new Blob([n], { type: t });
  return h;
}
function w1(b, e) {
  if (typeof b != "number" && b < 1)
    throw new RangeError("Length must be a positive integer!");
  e === void 0 && (e = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ");
  let t = "";
  const n = e.length;
  for (var a = 0; a < b; a++)
    t += e.charAt(Math.floor(Math.random() * n));
  return t;
}
async function S1(b, e) {
  return new Promise((t) => {
    const n = new Uint8Array(b), a = new Blob([n], { type: e }), h = (window.URL || window.webkitURL).createObjectURL(a), f = new Image();
    f.src = h, f.onload = async () => {
      const v = document.createElement("canvas"), x = v.getContext("2d");
      v.width = f.width, v.height = f.height, x.translate(0, f.height), x.scale(1, -1), x.drawImage(f, 0, 0), v.toBlob((k) => {
        const I = new FileReader();
        I.addEventListener("loadend", () => {
          const V = I.result;
          t(V);
        }), I.readAsArrayBuffer(k);
      }, e);
    };
  });
}
function Qo(b) {
  return b instanceof BABYLON.PBRMaterial;
}
function M1() {
  const b = new URL(window.location.href);
  return new URLSearchParams(b.search);
}
class hw {
  constructor() {
    this.previewFiles = {};
  }
  downloadFiles() {
    function e(t, n) {
      return t.toLowerCase().indexOf(n, t.length - n.length) !== -1;
    }
    for (let t in this.previewFiles) {
      let n = null;
      const a = this.previewFiles[t];
      if (typeof a == "string" ? n = qd(a) : n = a, n) {
        let o = null;
        if (e(t, ".jpeg") || e(t, ".jpg") ? o = { type: "image/jpeg" } : e(t, ".png") && (o = { type: "image/png" }), o) {
          let h = document.createElement("a");
          document.body.appendChild(h), h.setAttribute("type", "hidden"), h.download = t, h.href = window.URL.createObjectURL(new Blob([n], o)), h.click();
        }
      }
    }
  }
}
class ao {
  static async getPreviewsAsync(e, t, n, a, o = !0) {
    await e.whenReadyAsync();
    const h = new uw(e, t, n, a), f = await h.getPreviewsAsync(o);
    return h.dispose(), f;
  }
  static async downloadPreviewsAsync(e, t, n, a) {
    (await ao.getPreviewsAsync(e, t, n, a)).downloadFiles();
  }
}
class uw {
  constructor(e, t, n, a) {
    this._width = 256, this._height = 256, this._crop = !1, this._materials = [], this._localEngine = null, this._hostingScene = null, this._hostingSceneHelper = null, this._hostingMesh = null, this._scene = e, this._rootUrl = t, this._materialIDs = n, this._options = a || {}, this.setupPreviewSize(), this._options.crop != null && (this._crop = this._options.crop), this.readMaterials();
  }
  dispose() {
    this.disposeHostingScene(), this.disposeLocalEngine();
  }
  getLocalEngine() {
    if (!this._localEngine) {
      const e = document.createElement("canvas");
      e.id = "MaterialPreviewCanvas", e.width = 1024, e.height = 1024, this._localEngine = new BABYLON.Engine(e, !0, {
        premultipliedAlpha: !1,
        preserveDrawingBuffer: !0
      }), this._localEngine.setSize(this._width, this._height);
    }
    return this._localEngine;
  }
  disposeLocalEngine() {
    this._localEngine && this._localEngine.dispose();
  }
  disposeHostingScene() {
    this._hostingSceneHelper && (this._hostingSceneHelper.dispose(), this._hostingSceneHelper = null), this._hostingScene && (this._hostingScene.dispose(), this._hostingScene = null);
  }
  setupPreviewSize() {
    let e = this._options;
    e.width != null && e.height == null ? (this._width = e.width, this._height = e.width) : e.width == null && e.height != null ? (this._width = e.height, this._height = e.height) : e.width != null && e.height != null && (this._width = e.width, this._height = e.height);
  }
  readMaterials() {
    this._materialIDs.forEach((e) => {
      const t = this._scene.getMaterialByID(e);
      t && this._materials.push(t);
    });
  }
  async downloadPreviewsAsync() {
    (await this.getPreviewsAsync()).downloadFiles();
  }
  async getPreviewsAsync(e = !0) {
    const t = this.getLocalEngine();
    this._hostingScene = new BABYLON.Scene(t), this._hostingSceneHelper = new di(this._hostingScene), this._hostingSceneHelper.setupCamera();
    const n = this._hostingScene.activeCamera;
    return n && (/firefox/i.test(navigator.userAgent) || new BABYLON.PassPostProcess("scale_pass", 4, n, BABYLON.Texture.BILINEAR_SAMPLINGMODE), new BABYLON.PassPostProcess("scale_pass", 2, n, BABYLON.Texture.BILINEAR_SAMPLINGMODE), new BABYLON.PassPostProcess("scale_pass", 1, n, BABYLON.Texture.BILINEAR_SAMPLINGMODE)), new Promise((a) => {
      const o = new BABYLON.CubeTexture(
        ci.Environment.EnvironmentTextureCDNUrl,
        this._hostingScene,
        null,
        !1,
        null,
        async () => {
          if (!this._hostingScene || !this._hostingSceneHelper)
            return;
          this._hostingScene.environmentTexture = o, this._hostingSceneHelper.setupLights(), this._hostingMesh = this._hostingSceneHelper.createSphere(null), this._hostingSceneHelper.adjustCamera(void 0, void 0, void 0, !1);
          const h = new hw();
          for (let f = 0; f < this._materials.length; f++) {
            const v = this._materials[f];
            await this.createMaterialPreviewFileAsync(v, h, e);
          }
          this.disposeHostingScene(), this.disposeLocalEngine(), a(h);
        },
        null,
        void 0,
        !0,
        void 0,
        !0
      );
    });
  }
  async createMaterialPreviewFileAsync(e, t, n = !0) {
    if (this._hostingScene && this._hostingSceneHelper && this._hostingMesh) {
      const a = e.serialize(), o = BABYLON.Material.Parse(a, this._hostingScene, this._rootUrl);
      if (o) {
        this._hostingMesh.material = o, await di.whenMeshMaterialIsReady(this._hostingMesh), this._hostingScene.render();
        let h = await this._hostingSceneHelper.takeContentScreenshotAsync(this._width, this._height);
        if (this._crop) {
          const x = await Uh(h);
          x && (h = x);
        }
        let f = o.name.replace(/[^a-z0-9]/gi, "_").toLowerCase();
        f = this.getNextIncrementalName(f, ".png", t) + ".png", Logger.info("preview: " + f);
        let v = h;
        n && (v = qd(h)), t.previewFiles[f] = v;
      }
    }
  }
  getNextIncrementalName(e, t, n) {
    let a = e;
    if (e) {
      let v, x = 0;
      for (; n.previewFiles.hasOwnProperty(a + t); ) {
        if (!v) {
          v = e;
          var o = e.lastIndexOf("_");
          if (o > 0) {
            var h = e.substring(o + 1), f = parseInt(h);
            f.toString() === h && (v = e.substring(0, o));
          }
        }
        x++, a = v + "_" + x;
      }
    }
    return a;
  }
}
class cw {
  constructor(e, t, n, a) {
    this._bias = 50, this._invertR = !1, this._invertG = !1, this._preBlurEnabled = !1, this._preBlur = 3, this._postBlurEnabled = !1, this._postBlur = 3, this._bevel = !0, this._intensity = 0.5, this._activeTextures = [], this._preBlurXTexture = null, this._preBlurYTexture = null, this._normalMapTexture = null, this._postBlurXTexture = null, this._postBlurYTexture = null, this._baseTexture = e, this._size = t, this._scene = a, this.init(n);
  }
  init(e) {
    for (this._bias = e.get("bias"), this._invertR = e.get("invertR"), this._invertG = e.get("invertG"), this._bevel = e.get("bevel"), this._intensity = e.get("intensity"), this._preBlurEnabled = e.get("preBlurEnabled"), this._preBlur = e.get("preBlur"), this._postBlurEnabled = e.get("postBlurEnabled"), this._postBlur = e.get("postBlur"); this._activeTextures.length > 0; )
      this._activeTextures.pop();
    this.updateTextures();
  }
  updateTextures() {
    let e = this.updatePreBlurTexture();
    e = this.updateNormalmapTexture(e), e = this.updatePostBlurTexture(e);
  }
  updatePreBlurTexture() {
    let e = this._baseTexture;
    return this._preBlurEnabled && (this._preBlurXTexture ? this._preBlurXTexture.baseTexture = this._baseTexture : this._preBlurXTexture = new no("preBlurX", this._size, this._scene, this._baseTexture, void 0, !1), this._preBlurXTexture.beginInit(), this._preBlurXTexture.blur = this._preBlur, this._preBlurXTexture.refreshRate = 0, this._preBlurXTexture.endInit(), this._activeTextures.push(this._preBlurXTexture), this._preBlurYTexture ? this._preBlurYTexture.baseTexture = this._preBlurXTexture : this._preBlurYTexture = new ro("preBlurY", this._size, this._scene, this._preBlurXTexture, void 0, !1), this._preBlurYTexture.beginInit(), this._preBlurYTexture.blur = this._preBlur, this._preBlurYTexture.refreshRate = 0, this._preBlurYTexture.endInit(), this._activeTextures.push(this._preBlurYTexture), e = this._preBlurYTexture), e;
  }
  updateNormalmapTexture(e) {
    return this._normalMapTexture ? this._normalMapTexture.baseTexture = e : this._normalMapTexture = new zd("procNormal", this._size, this._scene, e, void 0, !1), this._normalMapTexture.beginInit(), this._normalMapTexture.bias = this._bias, this._normalMapTexture.invertR = this._invertR, this._normalMapTexture.invertG = this._invertG, this._normalMapTexture.bevel = this._bevel, this._normalMapTexture.intensity = this._intensity, this._normalMapTexture.refreshRate = 0, this._normalMapTexture.endInit(), this._activeTextures.push(this._normalMapTexture), this._normalMapTexture;
  }
  updatePostBlurTexture(e) {
    let t = e;
    return this._postBlurEnabled && (this._postBlurXTexture ? this._postBlurXTexture.baseTexture = e : this._postBlurXTexture = new no("postBlurX", this._size, this._scene, e, void 0, !1), this._postBlurXTexture && (this._postBlurXTexture.beginInit(), this._postBlurXTexture.blur = this._postBlur, this._postBlurXTexture.refreshRate = 0, this._postBlurXTexture.endInit(), this._activeTextures.push(this._postBlurXTexture), this._postBlurYTexture ? this._postBlurYTexture.baseTexture = this._postBlurXTexture : this._postBlurYTexture = new ro("postBlurY", this._size, this._scene, this._postBlurXTexture, void 0, !1), this._postBlurYTexture && (this._postBlurYTexture.beginInit(), this._postBlurYTexture.blur = this._postBlur, this._postBlurYTexture.refreshRate = 0, this._postBlurYTexture.endInit(), this._activeTextures.push(this._postBlurYTexture), t = this._postBlurYTexture))), t;
  }
  dispose() {
    this._preBlurXTexture && (this._preBlurXTexture.dispose(), this._preBlurXTexture = null), this._preBlurYTexture && (this._preBlurYTexture.dispose(), this._preBlurYTexture = null), this._normalMapTexture && (this._normalMapTexture.dispose(), this._normalMapTexture = null), this._postBlurXTexture && (this._postBlurXTexture.dispose(), this._postBlurXTexture = null), this._postBlurYTexture && (this._postBlurYTexture.dispose(), this._postBlurYTexture = null);
  }
  async getNormalMapTextureAsync(e, t) {
    return await this.updateAsync(e, t), this._activeTextures.length > 0 ? this._activeTextures[this._activeTextures.length - 1] : null;
  }
  async updateAsync(e, t) {
    if (this.init(t), this._activeTextures.length > 0) {
      this._activeTextures[0].baseTexture = e;
      for (var n = 0; n < this._activeTextures.length; n++)
        await this._activeTextures[n].isReadyAsync(), this._activeTextures[n].render();
    }
  }
}
class fw {
  constructor(e, t, n, a) {
    this._baseTexture = e, this._size = t, this._scene = a, this._mask = new so("mask", this._size, this._scene, this._baseTexture), this._mask.backColor = new BABYLON.Vector3(0, 0, 0), this._mask.foreColor = new BABYLON.Vector3(1, 1, 1), this._mask.refreshRate = 0, this._shadow = new so("shadow", this._size, this._scene, this._baseTexture), this._shadow.backColor = new BABYLON.Vector3(0.1, 0.1, 0.1), this._shadow.foreColor = new BABYLON.Vector3(1, 1, 1), this._shadow.refreshRate = 0, this._shadowBlurX = new no("shadow_blurX", this._size, this._scene, this._shadow), this._shadowBlurX.blur = 5, this._shadowBlurX.refreshRate = 0, this._shadowBlurY = new ro("shadow_blurY", this._size, this._scene, this._shadowBlurX), this._shadowBlurY.blur = 5, this._shadowBlurY.refreshRate = 0, this._shadowMove = new hu("shadow_move", this._size, this._scene, this._shadowBlurY), this._shadowMove.offset = new BABYLON.Vector2(2.5, 2.5), this._shadowMove.refreshRate = 0, this._lightmap = new Qa("lightmap", this._size, this._scene, this._shadowMove, this._mask), this._lightmap.refreshRate = 0, this.updateParameters(n);
  }
  updateParameters(e) {
    if (e) {
      let t = new BABYLON.Vector3(0, 0, 0);
      if (e.get("color")) {
        const x = BABYLON.Color3.FromHexString(e.get("color"));
        t = new BABYLON.Vector3(x.r, x.g, x.b);
      }
      this._shadow.backColor = t;
      let n = 1, a = 135;
      e.get("angle") !== void 0 && e.get("angle") !== null && (a = e.get("angle")), e.get("distance") != null && e.get("distance") !== null && (n = e.get("distance"));
      let o = a * Math.PI / 180;
      o = this.wrapPi(o);
      const h = Math.cos(o) * n, f = Math.sin(o) * n;
      this._shadowMove.offset = new BABYLON.Vector2(-h, f);
      let v = 5;
      e.get("size") !== void 0 && e.get("size") !== null && (v = Math.max(0, Math.min(100, e.get("size")))), this._shadowBlurX.blur = v, this._shadowBlurY.blur = v;
    }
  }
  // riporta angle nel range -180, + 180
  wrapPi(e) {
    if (Math.abs(e) > Math.PI) {
      var t = 2 * Math.PI, n = Math.floor((e + Math.PI) * (1 / t));
      e -= n * t;
    }
    return e;
  }
  dispose() {
    this._mask.dispose(), this._shadow.dispose(), this._shadowBlurX.dispose(), this._shadowBlurY.dispose(), this._shadowMove.dispose(), this._lightmap.dispose();
  }
  async getInnerShadowTextureAsync(e) {
    return await this.updateAsync(e), this._lightmap;
  }
  async updateAsync(e, t) {
    this.updateParameters(t), this._baseTexture = e, await di.whenTextureIsReadyAsync(this._baseTexture), this._mask.baseTexture = this._baseTexture, await this._mask.isReadyAsync(), this._mask.render(), this._shadow.baseTexture = this._baseTexture, await this._shadow.isReadyAsync(), this._shadow.render(), await this._shadowBlurX.isReadyAsync(), this._shadowBlurX.render(), await this._shadowBlurY.isReadyAsync(), this._shadowBlurY.render(), await this._shadowMove.isReadyAsync(), this._shadowMove.render(), await this._lightmap.isReadyAsync(), this._lightmap.render();
  }
  //private whenTextureIsReadyAsync(texture: BABYLON.Texture): Promise<void> {
  //    return new Promise<void>((resolve, reject) => {
  //        if (texture.isReady())
  //            resolve();
  //        else {
  //            let t = setInterval(() => {
  //                if (texture.isReady()) {
  //                    clearInterval(t);
  //                    resolve();
  //                }
  //            }, 5);
  //        }
  //    });
  //}
}
class dw {
  constructor(e, t, n, a) {
    this._size = t, this._baseTexture = e, this._scene = a, this._shadow = new so("shadow", this._size, this._scene, this._baseTexture), this._shadow.backColor = new BABYLON.Vector3(1, 1, 1), this._shadow.foreColor = new BABYLON.Vector3(0.2, 0.2, 0.2), this._shadow.refreshRate = 0, this._shadowBlurX = new no("shadow_blurX", this._size, this._scene, this._shadow), this._shadowBlurX.blur = 15, this._shadowBlurX.refreshRate = 0, this._shadowBlurY = new ro("shadow_blurY", this._size, this._scene, this._shadowBlurX), this._shadowBlurY.blur = 15, this._shadowBlurY.refreshRate = 0, this._shadowMove = new hu("shadow_move", this._size, this._scene, this._shadowBlurY), this._shadowMove.offset = new BABYLON.Vector2(2.5, 2.5), this._shadowMove.refreshRate = 0, this.updateParameters(n);
  }
  updateParameters(e) {
    if (e) {
      var t = new BABYLON.Vector3(0, 0, 0);
      if (e.get("color")) {
        var n = BABYLON.Color3.FromHexString(e.get("color"));
        t = new BABYLON.Vector3(n.r, n.g, n.b);
      }
      this._shadow.foreColor = t;
      let a = 1, o = 135;
      e.get("angle") !== void 0 && e.get("angle") !== null && (o = e.get("angle")), e.get("distance") != null && e.get("distance") !== null && (a = e.get("distance"));
      let h = o * Math.PI / 180;
      h = this.wrapPi(h);
      const f = Math.cos(h) * a, v = Math.sin(h) * a;
      this._shadowMove.offset = new BABYLON.Vector2(-f, v);
      let x = 5;
      e.get("size") !== void 0 && e.get("size") !== null && (x = Math.max(0, Math.min(100, e.get("size")))), this._shadowBlurX.blur = x, this._shadowBlurY.blur = x;
    }
  }
  wrapPi(e) {
    if (Math.abs(e) > Math.PI) {
      var t = 2 * Math.PI, n = Math.floor((e + Math.PI) * (1 / t));
      e -= n * t;
    }
    return e;
  }
  dispose() {
    this._shadow.dispose(), this._shadowBlurX.dispose(), this._shadowBlurY.dispose(), this._shadowMove.dispose();
  }
  async getOuterShadowTextureAsync(e) {
    return await this.updateAsync(e), this._shadowMove;
  }
  async updateAsync(e, t) {
    this.updateParameters(t), this._baseTexture = e, await di.whenTextureIsReadyAsync(this._baseTexture), this._shadow.baseTexture = this._baseTexture, await this._shadow.isReadyAsync(), this._shadow.render(), await this._shadowBlurX.isReadyAsync(), this._shadowBlurX.render(), await this._shadowBlurY.isReadyAsync(), this._shadowBlurY.render(), await this._shadowMove.isReadyAsync(), this._shadowMove.render();
  }
  //private whenTextureIsReadyAsync(texture: BABYLON.Texture): Promise<void> {
  //    return new Promise<void>((resolve, reject) => {
  //        if (texture.isReady())
  //            resolve();
  //        else {
  //            let t = setInterval(() => {
  //                if (texture.isReady()) {
  //                    clearInterval(t);
  //                    resolve();
  //                }
  //            }, 5);
  //        }
  //    });
  //}
}
globalThis && globalThis.__awaiter;
globalThis && globalThis.__generator;
function Bh(b, e, t) {
  e === void 0 && (e = 50), t === void 0 && (t = {
    isImmediate: !1
  });
  var n;
  return function() {
    for (var a = [], o = 0; o < arguments.length; o++)
      a[o] = arguments[o];
    var h = this, f = function() {
      n = void 0, t.isImmediate || b.apply(h, a);
    }, v = t.isImmediate && n === void 0;
    n !== void 0 && clearTimeout(n), n = setTimeout(f, e), v && b.apply(h, a);
  };
}
const zf = /android/i.test(navigator.userAgent), Ff = /iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1, $d = class Ss {
  constructor(e, t, n, a, o, h, f, v = !0, x, k = 0) {
    this._subMesh = null, this._isRefreshing = !1, this._showDesign = !0, this._viewRotation = 0, this._designTextureResolution = 1024, this._effect = null, this._meshSide = null, this._side = null, this._isDisposed = !1, this._baseWidth = Ss.DEFAULT_SIZE, this._baseHeight = Ss.DEFAULT_SIZE, this._textureWidth = Ss.DEFAULT_SIZE, this._textureHeight = Ss.DEFAULT_SIZE, this._coordinatesIndex = 0, this._currentVisibliity = !0, this._canvasMesh = null, this._originalCanvasMeshPosition = null, this._originalCanvasMeshScaling = null, this._normalmapMaterial = null, this._originalMaterial = null, this._blankDataUrl = null, this._innerCanvasMesh = null, this._outerCanvasMesh = null, this._ownDynamicMaterial = !1, this._dynamicMaterial = null, this._dynamicTexture = null, this._normalmapTexture = null, this._dynamicOpacityTexture = null, this._ownOldDynamicMaterial = !1, this._oldDynamicMaterial = null, this._originalDiffuseTexture = null, this._combinedDiffuseTexture = null, this._originalMeshNormalmapTexture = null, this._originalDesignNormalmapTexture = null, this._meshCombinedNormalmapTexture = null, this._designCombinedNormalmapTexture = null, this._originalMeshLightmapTexture = null, this._originalDesignLightmapTexture = null, this._meshCombinedLightmapTexture = null, this._designCombinedLightmapTexture = null, this._innerShadowTexture = null, this._outerShadowTexture = null, this._context = null, this._canvas = null, this._canvasID = Zakeke.generateUUID(), this._customizer = null, this._renderingNeededListeners = [], this._proceduralNormalMap = null, this._innerShadowGenerator = null, this._outerShadowGenerator = null, this._debouncedUpdateDynamicTexture = null, this._originalViewMatrixValues = null, this._grids = [], this._lastUpdateTextureWasDynamic = !0, this.isFirstRender = !0, this._scene = e, this._sceneHelper = new di(e), this._zkScene = t, this._mesh = n, this._subMesh = a, this._zkModel = o, this._zkDesign = h, this._grids = f, this._showDesign = v, this._viewRotation = k, x && (this._effect = x);
  }
  get showDesign() {
    return this._showDesign;
  }
  set showDesign(e) {
    this._showDesign != e && (this._showDesign = e);
  }
  get rotation() {
    return this._viewRotation;
  }
  set rotation(e) {
    this._viewRotation != e && (this._viewRotation = e);
  }
  get side() {
    return this._side;
  }
  // Temporary until we can access internal matrix (speak with Matteo)
  getInternalCustomizer() {
    return this._customizer;
  }
  // Factory method for async object creation and initialization
  static async createMeshDesignManagerAsync(e, t, n, a, o, h, f, v = !0, x, k = 0) {
    console.log("[MeshDesignManager.createMeshDesignManagerAsync] START", { meshId: n == null ? void 0 : n.id });
    const I = new Ss(
      e,
      t,
      n,
      a,
      o,
      h,
      f,
      v,
      x,
      k
    );
    return await I.initAsync(), console.log("[MeshDesignManager.createMeshDesignManagerAsync] END", { meshId: n == null ? void 0 : n.id }), I;
  }
  async initAsync() {
    console.log("[MeshDesignManager.initAsync] START");
    const e = this._zkScene.get("rootUrl");
    e && await this._sceneHelper.unsetMeshDummyMaterialAsync(this._mesh, e, !0), this.setupMeshSide(), this.setupTextureSize(), this.checkDefaultEffect(), this.refreshModelSide(), await this.setupClonedObjectsAsync(), await this.setupCanvasAsync(), await this.setupDynamicMaterialAsync(), await this.refreshAsync(), console.log("[MeshDesignManager.initAsync] END");
  }
  isForMesh(e, t) {
    return !e || !this._mesh || e.id !== this._mesh.id ? !1 : !this._subMesh && !t ? !0 : !this._subMesh || !t ? !1 : t.materialIndex === this._subMesh.materialIndex;
  }
  getMeshID() {
    return this._mesh ? this._mesh.id : null;
  }
  getSubMeshIdx() {
    return this._subMesh ? this._subMesh.materialIndex : 0;
  }
  getMaterialIDForDesign() {
    let e;
    return this._effect && this._effect.get("materialID") ? e = this._effect.get("materialID") : this._mesh && this._mesh.metadata && this._mesh.metadata.designMaterialID ? e = this._mesh.metadata.designMaterialID : this._meshSide && this._meshSide.get("materialID") && (e = this._meshSide.get("materialID")), e;
  }
  getDesignConfig() {
    let e;
    return this._effect && this._effect.get("config") ? e = this._effect.get("config") : this._meshSide && this._meshSide.get("config") && (e = this._meshSide.get("config")), e || (e = new MPlaza.MeshDesignConfig()), e;
  }
  dispose() {
    this._isDisposed = !0, this._customizer && (this._customizer.clearMemoryForIOS(), this._customizer = null), this.disposeOuterInnerCanvasMeshes(), this._canvasMesh && (this._canvasMesh.dispose(), this._canvasMesh = null, this._originalCanvasMeshPosition = null, this._originalCanvasMeshScaling = null), this.disposeDynamicMaterial(), this._dynamicOpacityTexture && (this._dynamicOpacityTexture.dispose(), this._dynamicOpacityTexture = null), this._dynamicTexture && (this._dynamicTexture.dispose(), this._dynamicTexture = null), this._renderingNeededListeners = [], $("#" + this._canvasID).remove(), this.restoreOrignalMaterial(), this.disposeNormalmapMaterial(), this._proceduralNormalMap && (this._proceduralNormalMap.dispose(), this._proceduralNormalMap = null), this._innerShadowGenerator && (this._innerShadowGenerator.dispose(), this._innerShadowGenerator = null), this._combinedDiffuseTexture && (this._combinedDiffuseTexture.dispose(), this._combinedDiffuseTexture = null), this._meshCombinedNormalmapTexture && (this._meshCombinedNormalmapTexture.dispose(), this._meshCombinedNormalmapTexture = null), this._designCombinedNormalmapTexture && (this._designCombinedNormalmapTexture.dispose(), this._designCombinedNormalmapTexture = null), this._meshCombinedLightmapTexture && (this._meshCombinedLightmapTexture.dispose(), this._meshCombinedLightmapTexture = null), this._designCombinedLightmapTexture && (this._designCombinedLightmapTexture.dispose(), this._designCombinedLightmapTexture = null);
  }
  disposeOuterInnerCanvasMeshes() {
    this._innerCanvasMesh && (this._innerCanvasMesh.dispose(), this._innerCanvasMesh = null), this._outerCanvasMesh && (this._outerCanvasMesh.dispose(), this._outerCanvasMesh = null);
  }
  disposeNormalmapMaterial() {
    this._normalmapMaterial && this._originalMaterial && this._normalmapMaterial.id !== this._originalMaterial.id && this._sceneHelper.getMeshesUsingMaterial(this._normalmapMaterial.id).length == 0 && (this._normalmapMaterial.dispose(), this._normalmapMaterial = null), this._originalMeshNormalmapTexture = null, this._originalMeshLightmapTexture = null;
  }
  disposeDynamicMaterial() {
    this._ownDynamicMaterial && this._dynamicMaterial && this._dynamicMaterial.dispose(), this._dynamicMaterial = null, this._originalDesignNormalmapTexture = null, this._originalDesignLightmapTexture = null;
  }
  disposeOldDynamicMaterial() {
    this._ownOldDynamicMaterial && this._oldDynamicMaterial && this._dynamicMaterial && this._oldDynamicMaterial != this._dynamicMaterial && this._oldDynamicMaterial.dispose(), this._oldDynamicMaterial = null;
  }
  createCanvasMeshClone(e) {
    if (this._canvasMesh) {
      const t = this._canvasMesh.clone(e + " - clone outer", null);
      if (t)
        return t.id = Zakeke.generateUUID(), this._canvasMesh.metadata && this._canvasMesh.metadata.AR !== void 0 && this._canvasMesh.metadata.AR !== null && (t.metadata || (t.metadata = {}), t.metadata.AR = this._canvasMesh.metadata.AR), t;
    }
    return null;
  }
  expandCanvasMesh(e) {
    if (!this._mesh || !this._canvasMesh)
      return;
    this.disposeOuterInnerCanvasMeshes();
    const t = this.getMeshHierarchySize(this._mesh), n = this.getMeshHierarchySize(this._canvasMesh);
    if (!t.equals(n))
      return;
    let a = 4e-3;
    e && (a += e);
    const o = 0.2;
    if (this._outerCanvasMesh = this.createCanvasMeshClone(this._mesh.name + " outer clone"), this._canvasMesh.isVisible = !1, this._outerCanvasMesh)
      if (Math.abs(t.x) <= 0.01 || Math.abs(t.y) <= 0.01 || Math.abs(t.z) <= 0.01) {
        const x = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind), k = BABYLON.Vector3.FromArray(
          x,
          0
        ).normalize();
        this._outerCanvasMesh.position = this._outerCanvasMesh.position.add(k.scale(o));
      } else {
        const x = [...this._canvasMesh.getVerticesData(BABYLON.VertexBuffer.PositionKind)], k = [...this._canvasMesh.getVerticesData(BABYLON.VertexBuffer.NormalKind)];
        for (var h = 0; h < x.length; h += 3) {
          const M = new BABYLON.Vector3(k[h], k[h + 1], k[h + 2]), W = new BABYLON.Vector3(
            x[h] + M.x * a,
            x[h + 1] + M.y * a,
            x[h + 2] + M.z * a
          );
          x[h] = W.x, x[h + 1] = W.y, x[h + 2] = W.z;
        }
        const I = BABYLON.VertexData.ExtractFromMesh(this._canvasMesh, !0, !0);
        I.positions = x;
        const V = new BABYLON.Geometry(this._canvasMesh.name + " outer geometry", this._scene);
        I.applyToGeometry(V), V.applyToMesh(this._outerCanvasMesh), this._scene.render();
      }
  }
  // Nel caso in cui la mesh non sia un piano, espande la mesh clone in modo che
  // racchiuda quella originale e che eviti il problema z- fighting.
  // Nel caso in cui si tratti di un piano (o di un disco o equivalenti), la mesh clone verrà solo
  // spostata leggermente nella direzione della normale al piano
  // Tale possibilità verrà sfruttata soprattutto in fase di esportazione in altro formato che non preveda
  // proprietà simili al zOffset di Babylon JS
  expandCanvasMesh_old() {
    if (!this._mesh || !this._canvasMesh)
      return;
    const e = 0.01, t = 1 + e, n = this.getMeshHierarchySize(this._mesh), a = this.getMeshHierarchySize(this._canvasMesh);
    if (!n.equals(a))
      return;
    const o = 0.1;
    if (Math.abs(n.x) <= o || Math.abs(n.y) <= o || Math.abs(n.z) <= o) {
      let f = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind), v = BABYLON.Vector3.FromArray(
        f,
        0
      ).normalize();
      this._canvasMesh.position = this._canvasMesh.position.add(v.scale(e));
    } else {
      let f = this._canvasMesh.scaling;
      f = f.multiplyByFloats(t, t, t), this._canvasMesh.scaling = f;
      let v = this.getMeshHierarchyCenter(this._mesh), x = this.getMeshHierarchyCenter(this._canvasMesh);
      const k = v.subtract(x);
      k.equals(BABYLON.Vector3.Zero()) || this._canvasMesh.position.addInPlace(k);
    }
  }
  contractCanvasMesh() {
    this._canvasMesh && (this._canvasMesh.isVisible = !0), this.disposeOuterInnerCanvasMeshes();
  }
  // Riporta la mesh clone allo stato originale, continuando a sfruttare unicamente la proprietà
  // zOffset per superare il problema dello z-fighting
  contractCanvasMesh_old() {
    if (!this._mesh || !this._canvasMesh || !this._originalCanvasMeshScaling || !this._originalCanvasMeshPosition)
      return;
    this._canvasMesh.scaling = this._originalCanvasMeshScaling, this._canvasMesh.position = this._originalCanvasMeshPosition;
    const e = this.getMeshHierarchyCenter(this._mesh), t = this.getMeshHierarchyCenter(this._canvasMesh), n = e.subtract(t);
    n.equals(BABYLON.Vector3.Zero()) || this._canvasMesh.position.addInPlace(n);
  }
  setupMeshSide() {
    if (this._meshSide = null, this._coordinatesIndex = 0, this._zkModel && this._mesh && this._mesh.id)
      for (let n = 0; n < this._zkModel.get("scenes").length; n++) {
        var e = this._zkModel.get("scenes").at(n);
        if (e.get("isDefault"))
          for (let a = 0; a < e.get("meshSides").length; a++) {
            var t = e.get("meshSides").at(a);
            if (t.get("meshID") == this._mesh.id) {
              this._meshSide = t, this._meshSide.get("uvChannel") >= 0 && (this._coordinatesIndex = this._meshSide.get("uvChannel"));
              return;
            }
          }
      }
  }
  setupTextureSize() {
    this._meshSide && (!zf && !Ff ? (this._baseWidth = this._meshSide.getOrCreateConfig().getDesktopTextureResolutionWidth() ?? Ss.DEFAULT_SIZE, this._baseHeight = this._meshSide.getOrCreateConfig().getDesktopTextureResolutionHeight() ?? Ss.DEFAULT_SIZE) : zf ? (this._baseWidth = this._meshSide.getOrCreateConfig().getMobileTextureResolutionWidth() ?? Ss.DEFAULT_SIZE, this._baseHeight = this._meshSide.getOrCreateConfig().getMobileTextureResolutionHeight() ?? Ss.DEFAULT_SIZE) : Ff && (this._baseWidth = 512, this._baseHeight = 512)), console.log("Texture size: " + this._baseWidth + "x" + this._baseHeight);
  }
  checkDefaultEffect() {
    if (!this._effect && this._meshSide) {
      var e = this._meshSide.getParentModel();
      if (e && e instanceof MPlaza.ModelScene) {
        let t = this.getMeshID();
        if (t) {
          let n = e.getDefaultDesignEffect(t, this.getSubMeshIdx());
          n && (this._effect = n);
        }
      }
    }
  }
  getAllSides() {
    const e = [];
    return this._zkModel.get("colors").each((t) => {
      t.get("sides").each((n) => {
        e.find((a) => a.get("sideID") == n.get("sideID")) || e.push(n);
      });
    }), e;
  }
  // Recupera il lato del modello corrispondente alla mesh in input
  // Del lato abbiamo solo sideID, mentre per il modello i lati sono per colore. Recuperiamo il colorID
  // in base agli elementi del design, considerando buono il primo colore con elementi grafici
  refreshModelSide() {
    if (this._side = null, this._meshSide && this._zkDesign) {
      const e = this._meshSide.get("sideID"), t = this._meshSide.tempID;
      let n = null;
      if (n = this.getAllSides().find(function(a) {
        return a.get("sideID") == e;
      }) || null, n) {
        let a = null;
        for (const o of this._zkDesign.get("designItems").models)
          if (a = o, a.isOnSide(n)) {
            const h = a && a.get("areas").length > 0 ? a.get("areas").at(0).get("colorID") : null;
            h && this._zkModel.get("colors").each(function(f) {
              f.get("colorID") == h && f.get("sides").each(function(v) {
                (v.tempID ? v.tempID == t : v.get("sideID") == e) && (n = v);
              });
            });
            break;
          }
        this._side = n;
      }
    }
  }
  async setupClonedObjectsAsync() {
    if (this._side) {
      for (var e = 0; e < this._scene.meshes.length; e++) {
        let t = this._scene.meshes[e];
        if (t && t.metadata && t.metadata.originalMeshID && t.metadata.originalMeshID == this._mesh.id) {
          this._canvasMesh = t, this._canvasMesh.isVisible = this._currentVisibliity, this._normalmapMaterial = this._mesh.material, this._originalMeshNormalmapTexture = this.getMaterialNormalmap(this._normalmapMaterial), this._originalMeshLightmapTexture = this.getMaterialLightmap(this._normalmapMaterial);
          break;
        }
      }
      if (!this._canvasMesh) {
        let t = this._mesh.name + " - clone";
        this._canvasMesh = this._mesh.clone(t, null), this._canvasMesh && (this._canvasMesh.id = Zakeke.generateUUID(), this._canvasMesh.isVisible = this._currentVisibliity, this._canvasMesh.doNotSerialize = !0, this._canvasMesh.isPickable = !1, this._canvasMesh.metadata = {}, this._canvasMesh.metadata.originalMeshID = this._mesh.id, this._canvasMesh.metadata.isRealMesh = !1, this._canvasMesh.metadata.iscanvasMesh = !0, this._mesh.metadata && this._mesh.metadata.AR !== void 0 && this._mesh.metadata.AR !== null && (this._canvasMesh.metadata.AR = this._mesh.metadata.AR));
      }
      this._canvasMesh && (this._originalCanvasMeshPosition = this._canvasMesh.position, this._originalCanvasMeshScaling = this._canvasMesh.scaling), this._normalmapMaterial || await this.setupNormalmapMaterialAsync();
    }
  }
  // Prepara il materiale per la normalmap da applicare alla mesh originale
  // posizionata sotto quella su cui è apposto il design.
  // Tale materiale viene utilizzato anche per l'eventuale lightmap di dropshadow (outer shadow)
  // quindi il nome andrebbe cambiato
  async setupNormalmapMaterialAsync() {
    this.disposeNormalmapMaterial(), this._originalMaterial = this._mesh.material;
    let e = Zakeke.generateUUID(), t = "normalmapMaterial - " + e;
    this._originalMaterial ? (t = this._originalMaterial.name + " - normalmap", this._normalmapMaterial = await this.cloneMaterialAsync(this._originalMaterial, t)) : this._normalmapMaterial = new BABYLON.StandardMaterial(t, this._scene), this._normalmapMaterial && (this._normalmapMaterial.id = e, this._normalmapMaterial.doNotSerialize = !0, this._normalmapMaterial.metadata = {}, this._originalMaterial ? this._normalmapMaterial.metadata.originalMaterialID = this._originalMaterial.id : this._normalmapMaterial.metadata.originalMaterialID = null, this._normalmapMaterial.metadata.isRealMaterial = !1, this._originalMeshNormalmapTexture = this.getMaterialNormalmap(this._normalmapMaterial), this._originalMeshLightmapTexture = this.getMaterialLightmap(this._normalmapMaterial));
  }
  // private getOriginalTexture(): BABYLON.Texture | null {
  //     if (this._originalMaterial) {
  //         var propertyName = this.getMaterialDiffuseTexturePropertyName(this._originalMaterial);
  //         if (!this._originalMaterial[propertyName])
  //             return null;
  //         return this._originalMaterial[propertyName];
  //     }
  //     return null;
  // }
  getMaterialDiffuseTexturePropertyName(e) {
    return e instanceof BABYLON.StandardMaterial ? "diffuseTexture" : e instanceof BABYLON.PBRMetallicRoughnessMaterial ? "baseTexture" : e instanceof BABYLON.PBRSpecularGlossinessMaterial ? "diffuseTexture" : e instanceof BABYLON.PBRMaterial || e instanceof Zakeke.PBRMaterial ? "albedoTexture" : "diffuseTexture";
  }
  getMaterialOpacityTexturePropertyName(e) {
    return e instanceof BABYLON.StandardMaterial ? "opacityTexture" : e instanceof BABYLON.PBRMetallicRoughnessMaterial || e instanceof BABYLON.PBRSpecularGlossinessMaterial ? null : (e instanceof BABYLON.PBRMaterial || e instanceof Zakeke.PBRMaterial, "opacityTexture");
  }
  getMaterialNormalmapTexturePropertyName(e) {
    return e instanceof BABYLON.StandardMaterial ? "bumpTexture" : e instanceof BABYLON.PBRMetallicRoughnessMaterial || e instanceof BABYLON.PBRSpecularGlossinessMaterial ? "normalTexture" : (e instanceof BABYLON.PBRMaterial || e instanceof Zakeke.PBRMaterial, "bumpTexture");
  }
  getMaterialLightmapTexturePropertyName(e) {
    return e instanceof BABYLON.StandardMaterial ? "ambientTexture" : e instanceof BABYLON.PBRMetallicRoughnessMaterial || e instanceof BABYLON.PBRSpecularGlossinessMaterial ? "occlusionTexture" : e instanceof BABYLON.PBRMaterial ? "ambientTexture" : e instanceof Zakeke.PBRMaterial ? "aoTexture" : "lightmapTexture";
  }
  getMaterialDiffuse(e) {
    let t = this.getMaterialDiffuseTexturePropertyName(e);
    return e[t];
  }
  getMaterialNormalmap(e) {
    if (!e)
      return null;
    let t = this.getMaterialNormalmapTexturePropertyName(e);
    return e[t];
  }
  getMaterialLightmap(e) {
    if (!e)
      return null;
    let t = this.getMaterialLightmapTexturePropertyName(e);
    return e[t];
  }
  getMaterialOpacity(e) {
    if (!e)
      return null;
    let t = this.getMaterialOpacityTexturePropertyName(e);
    return t ? e[t] : null;
  }
  setMaterialLightmap(e, t) {
    if (e) {
      var n = this.getMaterialLightmapTexturePropertyName(e);
      n && (e[n] = t, e instanceof Zakeke.PBRMaterial && (e.useAOTextureAsLightmap = !0));
    }
  }
  setTextureWrapping(e) {
    e && (e.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE, e.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE);
  }
  async setupCanvasAsync() {
    if (this._side && this._canvasMesh && this._meshSide && !this._isRefreshing) {
      this._isRefreshing = !0;
      var e = this._baseWidth;
      this._meshSide.get("percWidth") > 0 && (e *= this._meshSide.get("percWidth"));
      var t = this._baseHeight;
      this._meshSide.get("percHeight") > 0 && (t *= this._meshSide.get("percHeight")), this._textureWidth = e, this._textureHeight = t;
      var n = $("<canvas>", { id: this._canvasID }).attr({ width: e, height: t });
      this._canvas = n[0], this._context = this._canvas.getContext("2d"), this._context && (this._context.imageSmoothingQuality = "high", this._context.imageSmoothingEnabled = !0, this._customizer = new MPlaza.Customizer(!0, !1, this._canvas, !0), this._blankDataUrl = this._canvas.toDataURL(), this._customizer.showSideImage = !1, this._customizer.model = this._zkModel, this._customizer.fitToScreenMargin = this._zkScene.getFitToScreenMargin(), this._customizer.setGrids(this._grids), this._customizer.setDesign(this._zkDesign), await new Promise(async (a) => {
        var o, h;
        await ((o = this._customizer) == null ? void 0 : o.setSide(this._side)), (h = this._customizer) == null || h.refresh({ boundsToAreas: !0 }, async () => {
          if (this._customizer) {
            if (this._meshSide) {
              let f = this._meshSide.get("matrix");
              if (f) {
                const v = JSON.parse(f);
                let x = new this._customizer.paper.Matrix(v);
                this._customizer.paper.view.matrix = x, this._customizer.paper.view.update();
              }
            }
            await this.updateDynamicTextureAsync(), this._customizer.addItemCreatedListener(async () => {
              await this.updateDynamicTextureAsync(), this.fireRenderingNeededEvent();
            }), this._customizer.addItemChangedListener(async () => {
              await this.updateDynamicTextureAsync(), this.fireRenderingNeededEvent();
            }), this._customizer.addItemRemovedListener(async () => {
              await this.updateDynamicTextureAsync(), this.fireRenderingNeededEvent();
            }), this._customizer.addImageLoadedListener(async () => {
              await this.updateDynamicTextureAsync(), this.fireRenderingNeededEvent();
            });
          }
          a();
        });
      }));
    }
    this._isRefreshing = !1;
  }
  setCustomizerGrids(e) {
    var t;
    this._grids = e, (t = this._customizer) == null || t.setGrids(e);
  }
  // Ripristino il materiale originale sulla mesh, a meno che non sia stato già cambiato
  restoreOrignalMaterial() {
    this._mesh && this._originalMaterial && this._mesh.material && this._normalmapMaterial && this._mesh.material.id === this._normalmapMaterial.id && (this._mesh.material = this._originalMaterial);
  }
  getMeshesUsingMaterial(e) {
    for (var t = [], n = this._scene.meshes, a = 0; a < n.length; a++) {
      var o = n[a];
      if (o.material) {
        if (o.material.id == e)
          t.push(o);
        else if (o.material instanceof BABYLON.MultiMaterial)
          for (var h = 0; h < o.material.subMaterials.length; h++) {
            let f = o.material.subMaterials[h];
            if (f != null && f.id === e) {
              t.push(o);
              break;
            }
          }
      }
    }
    return t;
  }
  async checkNormalmapMaterialAsync() {
    this._mesh && this._normalmapMaterial && (!this._mesh.material || this._mesh.material.id !== this._normalmapMaterial.id) && await this.setupNormalmapMaterialAsync();
  }
  // Se il materiale associato alla mesh è cambiato lo ricrea
  async checkDynamicMaterialAsync() {
    let e = this.getMaterialIDForDesign();
    e && this._side && this._canvasMesh && this._meshSide && this._dynamicMaterial && this._dynamicMaterial.id != e && await this.setupDynamicMaterialAsync();
  }
  async setupDynamicMaterialAsync() {
    if (this._side && this._canvasMesh && this._meshSide) {
      this._ownOldDynamicMaterial = this._ownDynamicMaterial, this._oldDynamicMaterial = this._dynamicMaterial;
      var e = this.getMaterialIDForDesign();
      if (e) {
        this._zkScene.get("rootUrl") && await this._sceneHelper.loadDelayedMaterialAsync(this._zkScene.get("rootUrl"), e);
        let t = this._scene.getMaterialById(e);
        t && (this._dynamicMaterial = await this.cloneMaterialAsync(t, t.name + " - clone"), this._ownDynamicMaterial = !0);
      }
      if (!this._dynamicMaterial) {
        if (this._mesh.material && this._mesh.material instanceof BABYLON.PBRBaseMaterial) {
          const t = new BABYLON.PBRMaterial(
            "dynamicMaterial",
            this._scene
          );
          t.enableSpecularAntiAliasing = !0, t.backFaceCulling = !1, t.albedoColor = BABYLON.Color3.White(), t.reflectivityColor = BABYLON.Color3.Black(), t.transparencyMode = this._zkScene.getDefaultDesignMaterialTransparencyMode(), t.useAlphaFromAlbedoTexture = !0, this._mesh.material.subSurface.indexOfRefraction != null && (t.subSurface.indexOfRefraction = this._mesh.material.subSurface.indexOfRefraction), Qo(this._mesh.material) && this._mesh.material.roughness != null && (t.roughness = this._mesh.material.roughness), Qo(this._mesh.material) && this._mesh.material.metallic != null && (t.metallic = this._mesh.material.metallic), Qo(this._mesh.material) && this._mesh.material.reflectionTexture != null && (t.reflectionTexture = this._mesh.material.reflectionTexture), Qo(this._mesh.material) && this._mesh.material.microSurface != null && (t.microSurface = this._mesh.material.microSurface), this._dynamicMaterial = t;
        } else
          this._dynamicMaterial = new BABYLON.StandardMaterial("dynamicMaterial", this._scene), this._dynamicMaterial.backFaceCulling = !1, this._dynamicMaterial.specularColor = BABYLON.Color3.Black(), this._dynamicMaterial.ambientColor = BABYLON.Color3.White(), this._dynamicMaterial.diffuseColor = BABYLON.Color3.White();
        this._dynamicMaterial.id = Zakeke.generateUUID(), this._ownDynamicMaterial = !0;
      }
      this._dynamicMaterial.zOffset = -1, this._dynamicMaterial.metadata = { isRealMaterial: !1 }, this._dynamicMaterial.doNotSerialize = this._ownDynamicMaterial, this._originalDiffuseTexture = this.getMaterialDiffuse(this._dynamicMaterial), this._originalDesignNormalmapTexture = this.getMaterialNormalmap(this._dynamicMaterial), this._originalDesignLightmapTexture = this.getMaterialLightmap(this._dynamicMaterial);
    }
  }
  /*
      private whenTextureIsReadyAsync(texture: BABYLON.BaseTexture): Promise<void> {
          return new Promise<void>((resolve, reject) => {
  
              let t = setInterval(() => {
                  if (texture.isReady()) {
                      clearInterval(t);
                      if (texture instanceof BABYLON.ProceduralTexture)
                          texture.getEffect();
                      resolve();
                  }
              }, 5);
  
          });
      }
      */
  async cloneMaterialAsync(e, t) {
    if (e) {
      var n = e.getActiveTextures();
      n.forEach(async (o) => {
        await di.whenTextureIsReadyAsync(o);
      });
      var a = t || e.name + " - clone";
      if (e instanceof BABYLON.ShaderMaterial) {
        const o = this._zkScene.get("rootUrl");
        if (!o)
          return null;
        let h = e.serialize();
        return BABYLON.Material.Parse(h, this._scene, o);
      } else
        return e.clone(a);
    }
    return null;
  }
  getMeshHierarchySize(e) {
    let t = e.getHierarchyBoundingVectors(!0);
    return t.max.subtract(t.min);
  }
  getMeshHierarchyCenter(e) {
    let t = e.getHierarchyBoundingVectors(!0), n = t.max.subtract(t.min);
    return t.min.add(n.scale(0.5));
  }
  async refreshAsync(e) {
    var t, n;
    console.log("[MeshDesignManager.refreshAsync] START", { meshId: (t = this._mesh) == null ? void 0 : t.id, isRefreshing: this._isRefreshing }), !this._isRefreshing && (this._isRefreshing = !0, typeof e < "u" && (this._effect = e), await this.checkDynamicMaterialAsync(), await this.checkNormalmapMaterialAsync(), this.refreshModelSide(), await new Promise(async (a) => {
      var o, h, f;
      if (this._meshSide && this.side && this._customizer) {
        if (await ((o = this._customizer) == null ? void 0 : o.setSide(this.side)), await ((h = this._customizer) == null ? void 0 : h.updateGrids()), (f = this._customizer) == null || f.adaptZoomToSideAreas(!1), this._meshSide && this._customizer) {
          let v = this._meshSide.get("matrix");
          if (v) {
            const x = JSON.parse(v);
            let k = new this._customizer.paper.Matrix(x);
            if (this._customizer.paper.view.matrix = k, this._customizer.paper.view.rotation += -this._viewRotation, this._textureWidth !== 1024) {
              const I = 1024 / this._textureWidth;
              let V = new paper.Matrix();
              V = V.scale(1 / I, 1 / I);
              const M = k.prepend(V);
              this._customizer.paper.view.matrix = M;
            }
          } else
            this._customizer.paper.view.rotation = -this._viewRotation;
          this._customizer.paper.view.update();
        }
        await this.updateDynamicTextureAsync(), a();
      } else
        a();
    }), this._isRefreshing = !1, console.log("[MeshDesignManager.refreshAsync] END", { meshId: (n = this._mesh) == null ? void 0 : n.id }));
  }
  async updateDynamicTextureAsync() {
    var e;
    if (console.log("[MeshDesignManager.updateDynamicTextureAsync] START", { meshId: (e = this._mesh) == null ? void 0 : e.id, isFirstRender: this.isFirstRender }), this.isFirstRender) {
      console.log("[MeshDesignManager.updateDynamicTextureAsync] First render..."), await this.updateDynamicTextureInternalAsync(), this.isFirstRender = !1, console.log("[MeshDesignManager.updateDynamicTextureAsync] END (first render)");
      return;
    }
    this._debouncedUpdateDynamicTexture || (this._debouncedUpdateDynamicTexture = Bh(this.updateDynamicTextureInternalAsync, 10)), this._debouncedUpdateDynamicTexture(), console.log("[MeshDesignManager.updateDynamicTextureAsync] END (debounced)");
  }
  async updateDynamicTextureInternalAsync(e = !0) {
    var Z, qe;
    if (console.log("[MeshDesignManager.updateDynamicTextureInternalAsync] START", { meshId: (Z = this._mesh) == null ? void 0 : Z.id, dynamic: e }), Logger.info("updateDynamicTextureInternal"), !this._side || !this._meshSide || !this._canvas || !this._canvasMesh || !this._dynamicMaterial)
      return;
    const t = this.getDesignConfig(), n = this._lastUpdateTextureWasDynamic != e;
    this._lastUpdateTextureWasDynamic = e, await this.checkDynamicMaterialAsync(), await this.checkNormalmapMaterialAsync();
    let a = t.getDiffuseEnabled(), o = t.getDiffuseBlendMode(), h = t.getDiffuseLevel();
    o !== "normal" && o !== "multiply" && o !== "overlay" && (o = "normal");
    const f = t.getOpacityEnabled();
    t.getOrCreateOpacityConfig();
    const v = t.getNormalmapEnabled(), x = t.getOrCreateNormalmapConfig(), k = t.getInnerShadowEnabled(), I = t.getOrCreateInnerShadowConfig(), V = t.getOuterShadowEnabled(), M = t.getOrCreateOuterShadowConfig();
    let W = "diffuseTexture";
    const U = this._meshSide.get("materialTexture");
    U ? W = U : W = this.getMaterialDiffuseTexturePropertyName(this._dynamicMaterial);
    let Q = this.getMaterialOpacityTexturePropertyName(this._dynamicMaterial), D = this._dynamicTexture;
    n && D && (D.dispose(), this._dynamicTexture = null);
    let ee = this._canvas.toDataURL(), J = ee == this._blankDataUrl, he = this.dataURItoBlob(ee), X = (window.URL || window.webkitURL).createObjectURL(he);
    this._dynamicTexture || (e ? (this._dynamicTexture = new BABYLON.DynamicTexture("dynamicTexture", this._canvas, this._scene), this._dynamicTexture.hasAlpha = !0) : (this._dynamicTexture = new BABYLON.Texture(X, this._scene), this._dynamicTexture.hasAlpha = !0)), e ? this._dynamicTexture.update() : await di.whenTextureIsReadyAsync(this._dynamicTexture), !J && this._dynamicTexture && (v && await this.updateNormalmapTextureAsync(x), k && await this.updateInnerShadowTextureAsync(I), V && await this.updateOuterShadowTextureAsync(M), f && await this.updateOpacityTextureAsync(), this._originalDiffuseTexture && a && o !== "normal" && await this.combineDiffuseTexturesAsync(o, h), this._showDesign && (a && W && (o === "normal" || !this._originalDiffuseTexture || !this._combinedDiffuseTexture ? (this._dynamicTexture.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(this._dynamicTexture), this._dynamicMaterial[W] = this._dynamicTexture) : this._combinedDiffuseTexture && (this._combinedDiffuseTexture.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(this._combinedDiffuseTexture), this._dynamicMaterial[W] = this._combinedDiffuseTexture), this._dynamicMaterial[W].hasAlpha = !1, this._dynamicMaterial[W].hasAlpha = !0), !a && W && !this.compareTextures(
      this._dynamicMaterial[W],
      this._originalDiffuseTexture
    ) && (this._dynamicMaterial[W] = this._originalDiffuseTexture), f && Q && this._dynamicOpacityTexture && (this._dynamicOpacityTexture.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(this._dynamicOpacityTexture), this._dynamicMaterial instanceof BABYLON.ShaderMaterial ? this._dynamicMaterial.setTexture(
      Q,
      this._dynamicOpacityTexture
    ) : this._dynamicMaterial[Q] = this._dynamicOpacityTexture), !f && Q && (this._dynamicMaterial[Q] = null), this._canvasMesh.material !== this._dynamicMaterial && (this._canvasMesh.material = this._dynamicMaterial), v && this._normalmapTexture ? await this.setNormalmapTextureAsync(x) : (this.resetMeshNormalmapTexture(), this.resetDesignNormalmapTexture()), k && this._innerShadowTexture ? await this.setInnerShadowTextureAsync(I) : this.removeInnerShadowTexture(), V && this._outerShadowTexture ? await this.setOuterShadowTextureAsync(M) : this.removeOuterShadowTexture(), this.disposeOldDynamicMaterial(), this._canvasMesh.isVisible = this._currentVisibliity && t.getShowDesign())), J && (this._canvasMesh.isVisible = !1), this.fireRenderingNeededEvent(), console.log("[MeshDesignManager.updateDynamicTextureInternalAsync] END", { meshId: (qe = this._mesh) == null ? void 0 : qe.id });
  }
  resetDynamicTextures() {
    if (this._dynamicMaterial) {
      let e = "diffuseTexture";
      const t = this._meshSide ? this._meshSide.get("materialTexture") : null;
      t ? e = t : e = this.getMaterialDiffuseTexturePropertyName(this._dynamicMaterial), e && !this.compareTextures(
        this._dynamicMaterial[e],
        this._originalDiffuseTexture
      ) && (this._dynamicMaterial[e] = this._originalDiffuseTexture || new BABYLON.Texture(this._blankDataUrl, this._scene), this._dynamicMaterial[e].hasAlpha = !1, this._dynamicMaterial[e].hasAlpha = !0), this.resetDesignNormalmapTexture();
      let n = this.getMaterialOpacityTexturePropertyName(this._dynamicMaterial);
      n && (this._dynamicMaterial[n] = null), this.removeInnerShadowTexture();
    }
    this._normalmapMaterial && (this.resetMeshNormalmapTexture(), this.removeOuterShadowTexture());
  }
  async updateOpacityTextureAsync() {
    this._dynamicTexture && (await di.whenTextureIsReadyAsync(this._dynamicTexture), this._dynamicOpacityTexture || (this._dynamicOpacityTexture = new so(
      "dynamicOpacity",
      this._textureWidth,
      this._scene,
      this._dynamicTexture
    ), this._dynamicOpacityTexture.backColor = new BABYLON.Vector3(0, 0, 0), this._dynamicOpacityTexture.foreColor = new BABYLON.Vector3(1, 1, 1), this._dynamicOpacityTexture.refreshRate = 0, this._dynamicOpacityTexture.getAlphaFromRGB = !0), this._dynamicOpacityTexture && (this._dynamicOpacityTexture.baseTexture = this._dynamicTexture, await di.whenTextureIsReadyAsync(this._dynamicOpacityTexture), this._dynamicOpacityTexture.render()));
  }
  async combineDiffuseTexturesAsync(e, t) {
    if (!this._originalDiffuseTexture || !this._dynamicTexture)
      return;
    await di.whenTextureIsReadyAsync(this._originalDiffuseTexture), await di.whenTextureIsReadyAsync(this._dynamicTexture);
    const n = t === 0 ? this._dynamicTexture : this._originalDiffuseTexture, a = t === 0 ? this._originalDiffuseTexture : this._dynamicTexture;
    this._combinedDiffuseTexture || (e == "multiply" ? this._combinedDiffuseTexture = new Qa(
      "multiplyDiffuse",
      this._textureWidth,
      this._scene,
      n,
      a
    ) : this._combinedDiffuseTexture = new ll(
      "overlayDiffuse",
      this._textureWidth,
      this._scene,
      n,
      a
    ), this._combinedDiffuseTexture.refreshRate = 0), this._combinedDiffuseTexture && (this._combinedDiffuseTexture.baseTexture = n, this._combinedDiffuseTexture.blendTexture = a, await di.whenTextureIsReadyAsync(this._combinedDiffuseTexture), this._combinedDiffuseTexture.render());
  }
  // NORMAL MAP
  async updateNormalmapTextureAsync(e) {
    this._dynamicTexture && (await di.whenTextureIsReadyAsync(this._dynamicTexture), this._proceduralNormalMap || (this._proceduralNormalMap = new cw(
      this._dynamicTexture,
      this._textureWidth,
      e,
      this._scene
    )), this._normalmapTexture = await this._proceduralNormalMap.getNormalMapTextureAsync(
      this._dynamicTexture,
      e
    ), this._normalmapTexture && (this._normalmapTexture.coordinatesIndex = this._coordinatesIndex));
  }
  // Aggiorna i materiali con la normalmapTexture
  // La complicazione principale qui è che le normalmap eventualmente devono essere combinate con quelle preesistenti
  // sul materiale. Inoltre, essendo i materiali clonati (per non modificare quelli originari) è necessario controllare
  // che le texture siano pronte
  async setNormalmapTextureAsync(e) {
    var a;
    let t = this._normalmapTexture, n = this._normalmapTexture;
    if (e.get("showOnMesh") && this._originalMeshNormalmapTexture && this._normalmapTexture && (await this.combineMeshNormalmapTexturesAsync(), this._meshCombinedNormalmapTexture && (t = this._meshCombinedNormalmapTexture)), e.get("showOnDesign") && this._originalDesignNormalmapTexture && this._normalmapTexture && (await this.combineDesignNormalmapTexturesAsync(), this._designCombinedNormalmapTexture && (n = this._designCombinedNormalmapTexture)), this._normalmapMaterial && t) {
      t.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(t);
      const o = this.getMaterialNormalmapTexturePropertyName(this._normalmapMaterial);
      e.get("showOnMesh") ? this._normalmapMaterial[o] = t : this.resetMeshNormalmapTexture(), this._mesh.material !== this._normalmapMaterial && (this._mesh.material = this._normalmapMaterial, this._mesh.metadata || (this._mesh.metadata = {}), this._mesh.metadata.originalNormalmapMaterialID = (a = this._originalMaterial) == null ? void 0 : a.id);
    }
    if (this._dynamicMaterial && n) {
      n.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(n);
      const o = this.getMaterialNormalmapTexturePropertyName(this._dynamicMaterial);
      e.get("showOnDesign") ? this._dynamicMaterial[o] = n : this.resetDesignNormalmapTexture();
    }
  }
  async combineMeshNormalmapTexturesAsync() {
    !this._originalMeshNormalmapTexture || !this._normalmapTexture || (await di.whenTextureIsReadyAsync(this._originalMeshNormalmapTexture), await di.whenTextureIsReadyAsync(this._normalmapTexture), this._meshCombinedNormalmapTexture || (this._meshCombinedNormalmapTexture = new ll(
      "overlayMeshNormal",
      this._textureWidth,
      this._scene,
      this._originalMeshNormalmapTexture,
      this._normalmapTexture
    ), this._meshCombinedNormalmapTexture.refreshRate = 0), this._meshCombinedNormalmapTexture && (this._meshCombinedNormalmapTexture.baseTexture = this._originalMeshNormalmapTexture, this._meshCombinedNormalmapTexture.blendTexture = this._normalmapTexture, await di.whenTextureIsReadyAsync(this._meshCombinedNormalmapTexture), this._meshCombinedNormalmapTexture.render()));
  }
  resetMeshNormalmapTexture() {
    if (this._normalmapMaterial) {
      const e = this.getMaterialNormalmapTexturePropertyName(this._normalmapMaterial);
      this.compareTextures(
        this._normalmapMaterial[e],
        this._originalMeshNormalmapTexture
      ) || (this._originalMeshNormalmapTexture ? this._normalmapMaterial[e] = this._originalMeshNormalmapTexture : this._normalmapMaterial[e] = null);
    }
  }
  resetDesignNormalmapTexture() {
    if (this._dynamicMaterial) {
      const e = this.getMaterialNormalmapTexturePropertyName(this._dynamicMaterial);
      this.compareTextures(
        this._dynamicMaterial[e],
        this._originalDesignNormalmapTexture
      ) || (this._originalDesignNormalmapTexture ? this._dynamicMaterial[e] = this._originalDesignNormalmapTexture : this._dynamicMaterial[e] = null);
    }
  }
  async combineDesignNormalmapTexturesAsync() {
    !this._originalDesignNormalmapTexture || !this._normalmapTexture || (await di.whenTextureIsReadyAsync(this._originalDesignNormalmapTexture), await di.whenTextureIsReadyAsync(this._normalmapTexture), this._designCombinedNormalmapTexture || (this._designCombinedNormalmapTexture = new ll(
      "overlayDesignNormal",
      this._textureWidth,
      this._scene,
      this._originalDesignNormalmapTexture,
      this._normalmapTexture
    ), this._designCombinedNormalmapTexture.refreshRate = 0), this._designCombinedNormalmapTexture && (this._designCombinedNormalmapTexture.baseTexture = this._originalDesignNormalmapTexture, this._designCombinedNormalmapTexture.blendTexture = this._normalmapTexture, await di.whenTextureIsReadyAsync(this._designCombinedNormalmapTexture), this._designCombinedNormalmapTexture.render()));
  }
  // INNER SHADOW
  async updateInnerShadowTextureAsync(e) {
    this._dynamicTexture && (await di.whenTextureIsReadyAsync(this._dynamicTexture), this._innerShadowGenerator ? await this._innerShadowGenerator.updateAsync(this._dynamicTexture, e) : (this._innerShadowGenerator = new fw(
      this._dynamicTexture,
      this._textureWidth,
      e,
      this._scene
    ), this._innerShadowTexture = await this._innerShadowGenerator.getInnerShadowTextureAsync(
      this._dynamicTexture
    ), this._innerShadowTexture.coordinatesIndex = this._coordinatesIndex));
  }
  async setInnerShadowTextureAsync(e) {
    let t = this._innerShadowTexture;
    this._originalDesignLightmapTexture && this._innerShadowTexture && (await this.combineDesignLightmapTexturesAsync(), this._designCombinedLightmapTexture && (t = this._designCombinedLightmapTexture)), t && (t.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(t), this.setMaterialLightmap(this._dynamicMaterial, t));
  }
  async combineDesignLightmapTexturesAsync() {
    !this._originalDesignLightmapTexture || !this._innerShadowTexture || (await di.whenTextureIsReadyAsync(this._originalDesignLightmapTexture), await di.whenTextureIsReadyAsync(this._innerShadowTexture), this._designCombinedLightmapTexture || (this._designCombinedLightmapTexture = new Qa(
      "overlayDesignLightmaps",
      this._textureWidth,
      this._scene,
      this._originalDesignLightmapTexture,
      this._innerShadowTexture
    ), this._designCombinedLightmapTexture.refreshRate = 0), this._designCombinedLightmapTexture && (this._designCombinedLightmapTexture.baseTexture = this._originalDesignLightmapTexture, this._designCombinedLightmapTexture.blendTexture = this._innerShadowTexture, await di.whenTextureIsReadyAsync(this._designCombinedLightmapTexture), this._designCombinedLightmapTexture.render()));
  }
  removeInnerShadowTexture() {
    if (this._dynamicMaterial) {
      let e = this.getMaterialLightmap(this._dynamicMaterial), t = this._originalDesignLightmapTexture;
      this.compareTextures(e, t) || this.setMaterialLightmap(this._dynamicMaterial, t);
    }
  }
  // OUTER SHADOW
  async updateOuterShadowTextureAsync(e) {
    this._dynamicTexture && (await di.whenTextureIsReadyAsync(this._dynamicTexture), this._outerShadowGenerator ? await this._outerShadowGenerator.updateAsync(this._dynamicTexture, e) : (this._outerShadowGenerator = new dw(
      this._dynamicTexture,
      this._textureWidth,
      e,
      this._scene
    ), this._outerShadowTexture = await this._outerShadowGenerator.getOuterShadowTextureAsync(
      this._dynamicTexture
    ), this._outerShadowTexture.coordinatesIndex = this._coordinatesIndex));
  }
  async setOuterShadowTextureAsync(e) {
    let t = this._outerShadowTexture;
    this._originalMeshLightmapTexture && this._outerShadowTexture && (await this.combineMeshLightmapTexturesAsync(), this._meshCombinedLightmapTexture && (t = this._meshCombinedLightmapTexture)), t && (t.coordinatesIndex = this._coordinatesIndex, this.setTextureWrapping(t), this.setMaterialLightmap(this._normalmapMaterial, t), this._mesh.material !== this._normalmapMaterial && (this._mesh.material = this._normalmapMaterial));
  }
  async combineMeshLightmapTexturesAsync() {
    !this._originalMeshLightmapTexture || !this._outerShadowTexture || this._isDisposed || (await di.whenTextureIsReadyAsync(this._originalMeshLightmapTexture), await di.whenTextureIsReadyAsync(this._outerShadowTexture), this._meshCombinedLightmapTexture || (this._meshCombinedLightmapTexture = new Qa(
      "overlayMeshLightmap",
      this._textureWidth,
      this._scene,
      this._originalMeshLightmapTexture,
      this._outerShadowTexture
    ), this._meshCombinedLightmapTexture.refreshRate = 0), this._meshCombinedLightmapTexture && (this._meshCombinedLightmapTexture.baseTexture = this._originalMeshLightmapTexture, this._meshCombinedLightmapTexture.blendTexture = this._outerShadowTexture, await di.whenTextureIsReadyAsync(this._meshCombinedLightmapTexture), this._meshCombinedLightmapTexture.render()));
  }
  removeOuterShadowTexture() {
    if (this._normalmapMaterial) {
      const e = this.getMaterialLightmap(this._normalmapMaterial), t = this._originalMeshLightmapTexture;
      this.compareTextures(e, t) || this.setMaterialLightmap(this._normalmapMaterial, t);
    }
  }
  compareTextures(e, t) {
    return typeof e > "u" && typeof t > "u" || e === null && t === null ? !0 : !e || !t ? !1 : e === t;
  }
  dataURItoBlob(e) {
    let t = atob(e.split(",")[1]), n = e.split(",")[0].split(":")[1].split(";")[0], a = new ArrayBuffer(t.length), o = new Uint8Array(a);
    for (let f = 0; f < t.length; f++)
      o[f] = t.charCodeAt(f);
    return new Blob([a], { type: n });
  }
  downloadImage(e, t) {
    let n = this.dataURItoBlob(e), a = window.URL.createObjectURL(n), o = t || "image.png", h = document.createElement("a");
    h.download = o, h.innerHTML = "Download File", h.href = a, h.onclick = (f) => {
      document.body.removeChild(h);
    }, h.style.display = "none", h.setAttribute("type", "hidden"), document.body.appendChild(h), h.click();
  }
  setDesignMeshVisibility(e) {
    this._currentVisibliity = e, this._canvasMesh && (this._canvasMesh.isVisible = e);
  }
  getItemsInfo() {
    return this._customizer ? this._customizer.getItemsInfo() : [];
  }
  removeItem(e) {
    this._customizer && this._customizer.removeItemByGuid(e);
  }
  addItemText(e) {
    this._customizer && this._customizer.addTextElement(null, e, !1);
  }
  setItemText(e, t) {
    this._customizer && this._customizer.modifyTextElementContentByGuid(e, t);
  }
  /**
   * Get font weights from font variations
   * Returns array of {style, weight} for available font faces
   */
  getFontWeights(e) {
    let t = e.faces.map((V) => V.variation), n = t.filter((V) => V.startsWith("i")).map((V) => parseInt(V.charAt(V.length - 1)) * 100), a = t.filter((V) => V.startsWith("n")).map((V) => parseInt(V.charAt(V.length - 1)) * 100), o = a.filter((V) => V <= 500).sort((V, M) => M - V)[0], h = n.filter((V) => V <= 500).sort((V, M) => M - V)[0], f = a.filter((V) => V == 700), v = (f.length ? f : a.filter((V) => V > 500)).sort((V, M) => V - M)[0], x = n.filter((V) => V == v);
    x = x.length ? x : n.filter((V) => V == 700);
    let k = (x.length ? x : n.filter((V) => V > 500)).sort((V, M) => V - M)[0];
    const I = [];
    return o && I.push({ style: "normal", weight: o }), v && I.push({ style: "normal", weight: v }), h && I.push({ style: "italic", weight: h }), k && I.push({ style: "italic", weight: k }), I;
  }
  setItemBold(e, t, n) {
    var a, o;
    if (this._customizer) {
      let h = this._customizer.findItemByGuid(e);
      if (h) {
        let x = this._customizer.getTextItemInfo(h).fontWeight.split(" ").includes("italic") ? "italic" : "normal";
        const k = this.getFontWeights(n);
        let I;
        if (x === "italic") {
          const V = k.filter((M) => M.style === "italic");
          if (t) {
            const M = V.filter((W) => W.weight > 500).sort((W, U) => W.weight - U.weight)[0];
            I = M == null ? void 0 : M.weight;
          } else {
            const M = V.filter((W) => W.weight <= 500).sort((W, U) => U.weight - W.weight)[0];
            I = M == null ? void 0 : M.weight;
          }
          if (I === void 0) {
            const M = k.filter((W) => W.style === "normal");
            if (t) {
              const W = M.filter((U) => U.weight > 500).sort((U, Q) => U.weight - Q.weight)[0];
              I = (W == null ? void 0 : W.weight) || ((a = M[0]) == null ? void 0 : a.weight);
            } else {
              const W = M.filter((U) => U.weight <= 500).sort((U, Q) => Q.weight - U.weight)[0];
              I = (W == null ? void 0 : W.weight) || ((o = M[0]) == null ? void 0 : o.weight);
            }
            x = "normal";
          }
        } else {
          const V = k.filter((M) => M.style === "normal");
          if (t) {
            const M = V.filter((W) => W.weight > 500).sort((W, U) => W.weight - U.weight)[0];
            I = M == null ? void 0 : M.weight;
          } else {
            const M = V.filter((W) => W.weight <= 500).sort((W, U) => U.weight - W.weight)[0];
            I = M == null ? void 0 : M.weight;
          }
          I === void 0 && V.length > 0 && (I = V[0].weight);
        }
        if (I !== void 0) {
          let V = x === "italic" ? `italic ${I}` : I.toString();
          this._customizer.modifyTextElementFontWeight(h, V);
        }
      }
    }
  }
  setItemItalic(e, t, n) {
    var a, o;
    if (this._customizer) {
      let h = this._customizer.findItemByGuid(e);
      if (h) {
        let v = this._customizer.getTextItemInfo(h).fontWeight.split(" "), x = !1;
        for (let V of v) {
          let M = parseInt(V);
          if (!isNaN(M)) {
            x = M > 500;
            break;
          }
        }
        const k = this.getFontWeights(n);
        let I;
        if (t) {
          const V = k.filter((M) => M.style === "italic");
          if (x) {
            const M = V.filter((W) => W.weight > 500).sort((W, U) => W.weight - U.weight)[0];
            I = M == null ? void 0 : M.weight;
          } else {
            const M = V.filter((W) => W.weight <= 500).sort((W, U) => U.weight - W.weight)[0];
            I = M == null ? void 0 : M.weight;
          }
          if (I === void 0) {
            const M = k.filter((W) => W.style === "normal");
            if (x) {
              const W = M.filter((U) => U.weight > 500).sort((U, Q) => U.weight - Q.weight)[0];
              I = (W == null ? void 0 : W.weight) || ((a = M[0]) == null ? void 0 : a.weight);
            } else {
              const W = M.filter((U) => U.weight <= 500).sort((U, Q) => Q.weight - U.weight)[0];
              I = (W == null ? void 0 : W.weight) || ((o = M[0]) == null ? void 0 : o.weight);
            }
            t = !1;
          }
        } else {
          const V = k.filter((M) => M.style === "normal");
          if (x) {
            const M = V.filter((W) => W.weight > 500).sort((W, U) => W.weight - U.weight)[0];
            I = M == null ? void 0 : M.weight;
          } else {
            const M = V.filter((W) => W.weight <= 500).sort((W, U) => U.weight - W.weight)[0];
            I = M == null ? void 0 : M.weight;
          }
          I === void 0 && V.length > 0 && (I = V[0].weight);
        }
        if (I !== void 0) {
          let V = t ? `italic ${I}` : I.toString();
          this._customizer.modifyTextElementFontWeight(h, V);
        }
      }
    }
  }
  setItemColor(e, t) {
    this._customizer && this._customizer.modifyTextElementFillColorByGuid(e, t);
  }
  setItemFontFamily(e, t) {
    this._customizer && this._customizer.modifyTextElementFontFamilyByGuid(e, t);
  }
  setItemFontWeight(e, t, n) {
    if (!this._customizer)
      return;
    if (n) {
      const h = this.getFontWeights(n).map((f) => f.weight);
      h.length > 0 && (t = h.reduce(
        (f, v) => Math.abs(v - t) < Math.abs(f - t) ? v : f
      ));
    }
    let a = this._customizer.findItemByGuid(e);
    if (a) {
      let v = (this._customizer.getTextItemInfo(a).fontWeight.split(" ").includes("italic") ? "italic" : "normal") === "italic" ? `italic ${t}` : t.toString();
      this._customizer.modifyTextElementFontWeight(a, v);
    }
  }
  async addItemImage(e) {
    return this._customizer ? await this._customizer.insertImageById(e) : null;
  }
  async setItemImage(e, t) {
    this._customizer && await this._customizer.replaceImageByGuid(e, t);
  }
  setItemTextOnPath(e, t) {
    if (this._customizer) {
      let n = this._customizer.findItemByGuid(e);
      t ? this._customizer.convertToTextOnPath(n) : this._customizer.convertToTextArea(n);
    }
  }
  removeItemImage(e) {
    this._customizer && this._customizer.removeImageByGuid(e);
  }
  async setItemSize(e, t, n) {
    this._customizer && await this._customizer.setItemSize(e, t, n);
  }
  setItemConstraints(e, t) {
    this._customizer && this._customizer.setItemConstraints(e, t);
  }
  setDesignPrintingMethod(e) {
    this._customizer && this._side && this._customizer.setDesignPrintingMethod(e, this._side.get("sideID"));
  }
  containsItem(e) {
    if (this._customizer) {
      const t = this._customizer.findItemByGuid(e);
      return t != null && t != null;
    }
    return !1;
  }
  // -------------------------------------------------------------
  // Events
  // -------------------------------------------------------------
  addNotifyMessageListener(e) {
    if (this._customizer) {
      const t = this._customizer;
      let n = Bh(
        (a, o, h, f, v, x, k, I, V) => {
          e(
            t.side.getSideID(),
            a,
            o,
            h,
            f,
            v,
            I.requiredWidth,
            I.requiredHeight,
            V
          );
        },
        50
      );
      t.addNotifyMessageListeners(n);
    }
  }
  addRemoveMessageListener(e) {
    if (this._customizer) {
      const t = this._customizer;
      let n = Bh((a) => {
        e(t.side.getSideID(), a);
      }, 50);
      t.addRemoveMessageListeners(n);
    }
  }
  setEventMessages(e) {
    this._customizer && this._customizer.setCustomizedMessages(e);
  }
  fireRenderingNeededEvent() {
    for (let e = 0; e < this._renderingNeededListeners.length; ++e)
      this._renderingNeededListeners[e]();
  }
  addRenderingNeededListener(e) {
    this._renderingNeededListeners.push(e);
  }
  // -------------------------------------------------------------
  // Design view transformation
  // -------------------------------------------------------------
  translateDesignView(e, t) {
    if (this._meshSide && this._customizer) {
      let h = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values);
      var n = JSON.parse(h), a = this._customizer.getTranslatedMatrixValues(n, e, t), o = JSON.stringify(a);
      this._meshSide.set("matrix", o);
    }
  }
  rotateDesignView(e, t, n) {
    if (this._meshSide && this._customizer) {
      var a = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values), o = JSON.parse(a), h = this._customizer.getRotatedMatrixValues(o, e, t, n), f = JSON.stringify(h);
      this._meshSide.set("matrix", f);
    }
  }
  scaleDesignView(e, t, n, a) {
    if (this._meshSide && this._customizer) {
      var o = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values), h = JSON.parse(o), f = this._customizer.getScaledMatrixValues(h, e, t, n, a), v = JSON.stringify(f);
      this._meshSide.set("matrix", v);
    }
  }
  async setDesignViewTextureUVChannelAsync(e) {
    this._meshSide && (this._meshSide.set("uvChannel", e), await this.updateDynamicTextureAsync());
  }
  async setDesignViewFormFactorAsync(e, t) {
    this._meshSide && (this._meshSide.set("percWidth", e), this._meshSide.set("percHeight", t), await this.refreshAsync());
  }
  async changeToDynamicTexture() {
    await this.updateDynamicTextureInternalAsync(!0);
  }
  async changeToRasterizedTexture() {
    await this.updateDynamicTextureInternalAsync(!1);
  }
  moveItemUp(e) {
    console.log("MeshDesignManager.moveItemUp", e), this._customizer && this._customizer.moveItemUp(e);
  }
  moveItemDown(e) {
    console.log("MeshDesignManager.moveItemDown", e), this._customizer && this._customizer.moveItemDown(e);
  }
};
$d.DEFAULT_SIZE = 1024;
let Xd = $d;
class gw {
  constructor(e, t, n, a, o = !0) {
    this._rotation = 0, this._grids = [], this._meshDesignManagers = [], this._renderingNeededListeners = [], this._designNotifyMessageListeners = [], this._designRemoveMessageListeners = [], this._designEventMessages = [], this._meshDesignManagersRefreshing = /* @__PURE__ */ new Set(), this._scene = e, this._zkScene = t, this._zkModel = n, this._zkDesign = a, this._showDesign = o, this.init();
  }
  get showDesign() {
    return this._showDesign;
  }
  set showDesign(e) {
    this._showDesign != e && (this._showDesign = e, this._meshDesignManagers.forEach((t) => t.showDesign = e));
  }
  get rotation() {
    return this._rotation;
  }
  set rotation(e) {
    this._rotation != e && (this._rotation = e, this._meshDesignManagers.forEach((t) => t.rotation = e));
  }
  dispose() {
    this._meshDesignManagers.forEach((e) => e.dispose());
  }
  init() {
  }
  isForModels(e, t, n) {
    return this._scene == e && this._zkModel == t && this._zkDesign == n;
  }
  getDefaultModelScene() {
    if (this._zkModel) {
      let e = this._zkModel.get("scenes").findWhere({ isDefault: !0 });
      if (e)
        return e;
    }
    return null;
  }
  getModelSceneMeshSide(e, t = 0) {
    if (this._scene && this._zkModel) {
      const n = this.getDefaultModelScene();
      if (n)
        for (let a = 0; a < n.get("meshSides").length; a++) {
          let o = n.get("meshSides").at(a);
          if (o.get("meshID") == e && o.get("subMeshID") == t)
            return o;
        }
    }
    return null;
  }
  async refreshAsync() {
    if (console.log("[SceneDesignManager.refreshAsync] START"), this._scene && this._zkModel && this._zkDesign) {
      const e = this.getDefaultModelScene();
      if (e) {
        let t = null, n = null, a = null;
        for (let o = 0; o < this._meshDesignManagers.length; o++) {
          t = this._meshDesignManagers[o];
          let h = !1;
          for (let v = 0; v < e.get("meshSides").length; v++)
            if (a = e.get("meshSides").at(v), a.get("meshID") == t.getMeshID() && a.get("subMeshID") == t.getSubMeshIdx()) {
              h = !0;
              break;
            }
          let f = !0;
          if (h) {
            let v = t.getMeshID();
            v && (n = this._scene.getMeshByID(v), n && (f = n.isVisible));
          }
          (!h || !f) && (t.dispose(), this._meshDesignManagers.splice(o--, 1));
        }
        for (let o = 0; o < e.get("meshSides").length; o++) {
          a = e.get("meshSides").at(o);
          const h = a.get("meshID"), f = a.get("subMeshID");
          h && await this.refreshMeshDesignAsync(h, f);
        }
      }
    }
    console.log("[SceneDesignManager.refreshAsync] END");
  }
  isValidEffectForMesh(e, t, n) {
    if (n && n instanceof MPlaza.ModelSceneMeshDesignEffect) {
      const a = n.getParentModel();
      if (a && a instanceof MPlaza.ModelScene)
        return a.isEffectForMesh(e, t, n.get("effectID"));
    }
    return !1;
  }
  async refreshMeshDesignAsync(e, t = 0, n) {
    const a = this._scene.getMeshByID(e);
    console.log("[SceneDesignManager.refreshMeshDesignAsync] START", { meshID: e, submeshID: t });
    let o = n;
    if (n && !this.isValidEffectForMesh(e, t, n) && (o = void 0), a && a.isVisible) {
      let h = null;
      a.subMeshes && a.subMeshes.length > 0 && t >= 0 && t < a.subMeshes.length && (h = a.subMeshes[t]);
      let f = this.getMeshDesignMananger(a, h);
      if (f)
        f.showDesign = this._showDesign, f.rotation = this._rotation, await f.refreshAsync(o);
      else {
        f = await Xd.createMeshDesignManagerAsync(
          this._scene,
          this._zkScene,
          a,
          h,
          this._zkModel,
          this._zkDesign,
          this._grids,
          this._showDesign,
          o,
          this.rotation
        ), f.addRenderingNeededListener(() => this.fireRenderingNeededEvent()), f.setEventMessages(this._designEventMessages);
        for (let v of this._designNotifyMessageListeners)
          f.addNotifyMessageListener(v);
        for (let v of this._designRemoveMessageListeners)
          f.addRemoveMessageListener(v);
        this._meshDesignManagers.push(f);
      }
    }
    console.log("[SceneDesignManager.refreshMeshDesignAsync] END", { meshID: e, submeshID: t });
  }
  getMeshDesignMananger(e, t) {
    for (let n = 0; n < this._meshDesignManagers.length; n++) {
      const a = this._meshDesignManagers[n];
      if (a.isForMesh(e, t))
        return a;
    }
    return null;
  }
  clearMeshDesignManagers() {
    this._meshDesignManagers = [];
  }
  setCustomizerGrids(e) {
    this._grids = e, this._meshDesignManagers.forEach((t) => t.setCustomizerGrids(e));
  }
  getItemsInfo(e) {
    let t = [];
    for (let n = 0; n < this._meshDesignManagers.length; n++) {
      const o = this._meshDesignManagers[n].getItemsInfo();
      for (let h = 0; h < o.length; h++) {
        const f = o[h];
        let v = !1;
        for (let x = 0; x < t.length; x++)
          if (t[x].itemGuid == f.itemGuid) {
            v = !0;
            break;
          }
        v || t.push(f);
      }
    }
    if (e) {
      const n = e.getItemsInfo();
      for (let a = 0; a < n.length; a++) {
        const o = n[a];
        let h = !1;
        for (let f = 0; f < t.length; f++)
          if (t[f].itemGuid == o.itemGuid) {
            h = !0;
            break;
          }
        h || t.push(o);
      }
    }
    return t;
  }
  async execOnMeshManagersContainingItem(e, t) {
    for (const n of this._meshDesignManagers)
      n.containsItem(e) && await t(n);
  }
  removeItem(e) {
    this.execOnMeshManagersContainingItem(e, async (t) => t.removeItem(e));
  }
  moveItemUp(e) {
    console.log("sceneDesignManager moveItemUp", e), this.execOnMeshManagersContainingItem(e, async (t) => t.moveItemUp(e));
  }
  moveItemDown(e) {
    console.log("sceneDesignManager moveItemDown", e), this.execOnMeshManagersContainingItem(e, async (t) => t.moveItemDown(e));
  }
  addItemText(e, t) {
    let n = this._meshDesignManagers.find((a) => a.side != null && a.side.get("sideID") === t);
    n && n.addItemText(e);
  }
  async addItemImage(e, t) {
    let n = this._meshDesignManagers.find((a) => a.side != null && a.side.get("sideID") === t);
    return n ? await n.addItemImage(e) : null;
  }
  setItemText(e, t) {
    this.execOnMeshManagersContainingItem(e, async (n) => n.setItemText(e, t));
  }
  setItemItalic(e, t, n) {
    this.execOnMeshManagersContainingItem(e, async (a) => a.setItemItalic(e, t, n));
  }
  setItemBold(e, t, n) {
    this.execOnMeshManagersContainingItem(e, async (a) => a.setItemBold(e, t, n));
  }
  setItemColor(e, t) {
    this.execOnMeshManagersContainingItem(e, async (n) => n.setItemColor(e, t));
  }
  setItemFontFamily(e, t) {
    this.execOnMeshManagersContainingItem(e, async (n) => n.setItemFontFamily(e, t));
  }
  async setItemImage(e, t) {
    await this.execOnMeshManagersContainingItem(e, async (n) => n.setItemImage(e, t));
  }
  async setItemSize(e, t, n) {
    await this.execOnMeshManagersContainingItem(e, async (a) => a.setItemSize(e, t, n));
  }
  setItemConstraints(e, t) {
    this.execOnMeshManagersContainingItem(e, async (n) => n.setItemConstraints(e, t));
  }
  setItemTextOnPath(e, t, n) {
    const a = this._meshDesignManagers.find(
      (o) => o.side != null && o.side.get("sideID") === t
    );
    a && a.setItemTextOnPath(e, n);
  }
  removeItemImage(e) {
    this.execOnMeshManagersContainingItem(e, async (t) => t.removeItemImage(e));
  }
  setDesignVisibility(e, t) {
    const n = this._scene.getMeshByID(e);
    if (n) {
      const a = this.getMeshDesignMananger(n, n.subMeshes.length > 0 ? n.subMeshes[0] : null);
      a && a.setDesignMeshVisibility(t);
    }
  }
  setDesignPrintingMethod(e, t) {
    let n = this._meshDesignManagers.find((a) => a.side != null && a.side.get("sideID") === t);
    n && n.setDesignPrintingMethod(e);
  }
  getDesignItemsJson() {
    let e = "";
    for (let t = 0; t < this._zkDesign.get("designItems").length; t++)
      e && (e += `
`), e += this._zkDesign.get("designItems").at(t).get("json");
    return e;
  }
  getDesignID() {
    return this._zkDesign.getDesignID();
  }
  // -------------------------------------------------------------
  // Events
  // -------------------------------------------------------------
  fireRenderingNeededEvent() {
    for (let e = 0; e < this._renderingNeededListeners.length; ++e)
      this._renderingNeededListeners[e]();
  }
  addRenderingNeededListener(e) {
    this._renderingNeededListeners.push(e);
  }
  addNotifyMessageListener(e) {
    this._designNotifyMessageListeners.push(e);
    for (let t of this._meshDesignManagers)
      t.addNotifyMessageListener(e);
  }
  addRemoveMessageListener(e) {
    this._designRemoveMessageListeners.push(e);
    for (let t of this._meshDesignManagers)
      t.addRemoveMessageListener(e);
  }
  setEventMessages(e) {
    this._designEventMessages = e;
    for (let t of this._meshDesignManagers)
      t.setEventMessages(e);
  }
  // -------------------------------------------------------------
  // Design view transformation
  // -------------------------------------------------------------
  translateDesignView(e, t, n, a) {
    const o = this.getMeshDesignMananger(e, t);
    o && o.translateDesignView(n, a);
  }
  rotateDesignView(e, t, n, a, o) {
    const h = this.getMeshDesignMananger(e, t);
    h && h.rotateDesignView(n, a, o);
  }
  scaleDesignView(e, t, n, a, o, h) {
    const f = this.getMeshDesignMananger(e, t);
    f && f.scaleDesignView(n, a, o, h);
  }
  async setDesignViewTextureUVChannelAsync(e, t, n) {
    const a = this.getMeshDesignMananger(e, t);
    a && await a.setDesignViewTextureUVChannelAsync(n);
  }
  async setDesignViewFormFactorAsync(e, t, n, a) {
    const o = this.getMeshDesignMananger(e, t);
    o && await o.setDesignViewFormFactorAsync(n, a);
  }
  // -------------------------------------------------------------
  // Mesh - Side connection
  // -------------------------------------------------------------
  async connectMeshToModelSideAsync(e, t, n) {
    let a = this.getModelSceneMeshSide(e, t);
    if (!a && this._scene && this._zkModel) {
      let o = this._scene.getMeshByID(e);
      if (o && o.subMeshes && o.subMeshes.length > 0 && t >= 0 && t < o.subMeshes.length) {
        o.subMeshes[t];
        let h = this.getDefaultModelScene();
        h && (a = new MPlaza.ModelSceneMeshSide(), a.set("meshID", e), a.set("subMeshID", t), a.set("sideID", n), h.get("meshSides").add(a), await this.refreshAsync());
      }
    }
  }
  expandCanvasMeshes(e) {
    console.log("expandRatio ", e), this._meshDesignManagers.forEach((t) => t.expandCanvasMesh(e));
  }
  contractCanvasMeshes() {
    this._meshDesignManagers.forEach((e) => e.contractCanvasMesh());
  }
  async changeToRasterizedTextures() {
    for (const e of this._meshDesignManagers)
      await e.changeToRasterizedTexture();
    console.log("All tasks for rasterized textures completed.");
  }
  async changeToDynamicTextures() {
    for (const e of this._meshDesignManagers)
      await e.changeToDynamicTexture();
    console.log("All dynamic textures changes completed.");
  }
}
const Jr = "base_model";
class C1 {
  constructor(e, t, n) {
    this._zkModel = e, this._zkScene = t, this._scene = n, this._sceneHelper = new di(n);
  }
  /**
   * Replace the product model, used when discarding changes
   * @param newModel The new model to replace the current one
   */
  replaceModel(e) {
    this._zkModel = e;
  }
  getOrCreateMaterialsForVariant(e) {
    const t = this.getVariantMeshes(e), n = [];
    return t.forEach((a) => {
      const o = this._scene.getMeshById(a);
      o && o.getChildMeshes().forEach((h) => n.push(h));
    }), this.hasVariantCustomModel(e) ? this.getMaterialsForMeshes(n) : (this.getMaterialsForMeshes(n).forEach((o) => {
      this.isSceneMaterialForVariant(o) || this.setVariableMaterialID(o.id);
    }), this.getVariantMaterials(e));
  }
  // restituisce tutti materiali della scena per cui è possibile specificare se sono
  // variabili o meno in base alle varianti del prodotto. Da tale elenco verranno esclusi
  // tutti i materiali che sono stati già clonati per rappresentare la variazione.
  // verranno esclusi anche tutti i materiali che comunque sono stati marcati (metadata)
  // come materiali creati ad hoc per una preview di prodotto (isForPreview = true)
  // e verranno esclusi tutti i materiali non assegnati a nessuna mesh.
  // Verranno considerati quindi tutti i materiali non clonati assegnati ad almeno una mesh (direttamente
  // o indirettamente)
  getPossibleVariableMaterials() {
    const e = this._sceneHelper.getAllMaterials(), t = [];
    for (let n = 0; n < e.length; n++) {
      const a = e[n], o = this.getMeshesUsingMaterial(a.id), h = this.isSceneMaterialForVariant(a);
      o.length > 0 && !h && t.push(a);
    }
    return t;
  }
  // Restituisce l'elenco dei materiali della scena già selezionati come variabili
  getVariableMaterials() {
    const e = [], t = this._zkModel.getPreview3D();
    if (t) {
      const n = t.getVariantsAttributeOptions();
      if (n)
        for (let a = 0; a < n.get("variableMaterials").length; a++) {
          let o = n.get("variableMaterials").at(a).get("materialID"), h = this._scene.getMaterialById(o);
          h && e.push(h);
        }
    }
    return e;
  }
  getVariableMaterialsSelection() {
    const t = this.getVariableMaterials().map((o) => o.id);
    return this.getPossibleVariableMaterials().map((o) => ({
      id: o.id,
      name: o.name,
      selected: t.indexOf(o.id) != -1
    }));
  }
  getVariantMaterialsWithOriginal(e) {
    const t = [], n = this._zkModel.getPreview3D();
    if (n && e && e instanceof MPlaza.Color) {
      const a = this.getVariantID(e), o = n.getVariantsAttributeOptions();
      if (o) {
        const h = o.getVariantOption(a);
        if (h)
          for (let f = 0; f < h.get("materials").length; f++) {
            const v = h.get("materials").at(f), x = v.get("optionMaterialID"), k = this._scene.getMaterialById(x), I = v.get("variableMaterialID"), V = this._scene.getMaterialById(I);
            k && V && t.push({ material: k, variableMaterial: V });
          }
      }
    }
    return t;
  }
  // Per tutti i materiali impostati come variabili, verifica che questi materiali esistano ancora.
  // Se un materiale esiste, aggiorna l'indicazione delle mesh alle quali è impostato e le azioni per opzione.
  // Se un materiale non esiste, lo elimina tra i materiali variabili.
  updateVariableMaterials() {
    const e = this._zkModel.getPreview3D();
    if (e) {
      const t = e.getVariantsAttributeOptions();
      if (t) {
        const n = [], a = [];
        for (let o = 0; o < t.get("variableMaterials").length; o++) {
          const f = t.get("variableMaterials").at(o).get("materialID");
          this._scene.getMaterialById(f) ? n.push(f) : a.push(f);
        }
        n.forEach((o) => this.setVariableMaterialID(o)), a.forEach((o) => this.unsetVariableMaterialID(o));
      }
    }
  }
  // Imposta un materiale come NON variabile per variante. Questo significa che vanno eliminate
  // tutte le eventuali azioni relative al materiale ed eventualmente le opzioni
  unsetVariableMaterialID(e) {
    const t = this._zkModel.getPreview3D();
    if (t) {
      const n = t.getVariantsAttributeOptions();
      if (n) {
        const a = this._zkModel.getAttributeByGuid(n.get("attributeGuid")), o = n.get("variableMaterials").getVariableMaterial(e);
        if (o) {
          const f = this._scene.getMaterialById(e);
          if (f)
            for (let v = 0; v < o.get("meshes").length; v++) {
              const x = this._scene.getMeshById(o.get("meshes")[v]);
              x && this._sceneHelper.applyMaterial(f, x);
            }
        }
        n.removeVariableMaterial(e);
        const h = [];
        for (let f = 0; f < n.get("variantOptions").length; f++) {
          const v = n.get("variantOptions").at(f);
          let x = null;
          a && (x = a.getOptionByGuid(v.get("optionGuid")));
          const k = [];
          for (let I = 0; I < v.get("materials").length; I++) {
            const V = v.get("materials").at(I);
            if (V.get("variableMaterialID") === e) {
              for (let M = 0; M < V.get("actions").length; M++) {
                const W = V.get("actions").at(M);
                if (x) {
                  const U = x.get("actions").getActionByGuid(W.get("actionGuid"));
                  U && x.get("actions").remove(U);
                }
              }
              this.deleteSceneMaterial(V.get("optionMaterialID")), k.push(V);
            }
          }
          v.get("materials").remove(k), v.get("materials").length === 0 && h.push(v);
        }
        for (let f = 0; f < h.length; f++)
          this.removeVariantOption(n, h[f]);
      }
    }
  }
  // Imposta un materiale come variabile. Vengono generati i materiali cloni per le varie opzioni
  // e create le azioni di trasformazione della scena che impostano il materiale sulle varie mesh
  setVariableMaterialID(e) {
    const t = this._scene.getMaterialById(e);
    if (t) {
      const n = this.getMeshesUsingMaterial(t.id), a = n.map((v) => v.id), h = this._zkModel.getOrCreatePreview3D().getOrCreateVariantsAttributeOptions();
      h.setVariableMaterial(e, a);
      const f = [];
      for (let v = 0; v < this._zkModel.get("colors").length; v++) {
        const x = this._zkModel.get("colors").at(v), k = this.getVariantID(x);
        f.push(k), this.checkVariantOption(h, t, n, x);
      }
      for (let v = 0; v < h.get("variantOptions").length; v++) {
        const x = h.get("variantOptions").at(v);
        f.indexOf(x.get("variantID")) === -1 && this.removeVariantOption(h, x);
      }
    }
  }
  getVariantAttribute() {
    const e = this._zkModel.getPreview3D();
    if (!e)
      return null;
    const t = e.getVariantsAttributeOptions();
    if (!t)
      return null;
    let n = null;
    return t.get("attributeGuid") && (n = this._zkModel.getAttributeByGuid(t.get("attributeGuid"))), n || (n = this._zkModel.get("attributes").getAttributeByCode("variants_attribute")), n;
  }
  checkVariantOption(e, t, n, a) {
    const o = this.getVariantID(a);
    let h = e.get("variantOptions").getVariantOption(o);
    h || (h = this.createVariantOption(e, a)), this.checkVariantOptionMaterial(e, h, t, n, a);
  }
  createVariantOption(e, t) {
    const n = this.getVariantID(t), a = this.getOrCreateVariantAttribute(e), o = this.getOrCreateVariantAttributeOption(e, t, a), h = new MPlaza.VariantOption();
    return h.set("variantID", n), h.set("optionGuid", o.get("optionGuid")), e.get("variantOptions").push(h), h;
  }
  removeVariantOption(e, t) {
    const n = this._zkModel.getAttributeByGuid(e.get("attributeGuid"));
    if (n) {
      const a = n.getOptionByGuid(t.get("optionGuid"));
      a && n.get("options").remove(a);
    }
    for (let a = 0; a < t.get("materials").length; a++) {
      const h = t.get("materials").at(a).get("optionMaterialID");
      this.deleteSceneMaterial(h);
    }
    e.get("variantOptions").remove(t);
  }
  getOrCreateVariantAttribute(e) {
    let t = this.getVariantAttribute();
    if (!t) {
      for (let n = 0; n < e.get("variantOptions").length; n++)
        this.removeVariantOption(
          e,
          e.get("variantOptions").at(n)
        );
      t = new MPlaza.Attribute(), t.set("attributeGuid", MPlaza.generateUUID()), t.set("name", "Variants attribute"), t.set("attributeCode", "variants_attribute"), t.set("attributeTypeID", MPlaza.AttributeType.Options), this._zkModel.get("attributes").push(t);
    }
    return e.set("attributeGuid", t.get("attributeGuid")), t;
  }
  getOrCreateVariantAttributeOption(e, t, n) {
    const a = this.getVariantID(t);
    let o = n.getOptionByCode(a);
    return o || (o = new MPlaza.AttributeOption(), o.set("optionCode", a), o.set("name", t.get("name")), n.get("options").push(o)), o;
  }
  getVariantID(e) {
    return `${e.getModelID()}_${e.getColorID()}`;
  }
  checkVariantOptionMaterial(e, t, n, a, o) {
    const h = this.getVariantID(o);
    let f = null;
    for (let v = 0; v < t.get("materials").length; v++) {
      const x = t.get("materials").at(v);
      if (x.get("variableMaterialID") === n.id) {
        f = x;
        break;
      }
    }
    if (!f) {
      let v = this.getSceneMaterialForVariant(h, n.id);
      if (!v) {
        const x = `${n.name} - ${o.get("name")}`;
        v = this.cloneSceneMaterial(n.id, void 0, x), v && this.setupSceneMaterialForVariant(v, h, n.id);
      }
      v && (f = new MPlaza.VariantOptionMaterial(), f.set("optionMaterialID", v.id), f.set("variableMaterialID", n.id), t.get("materials").push(f));
    }
    f && this.checkVariantOptionActions(
      e,
      t,
      f,
      n,
      a,
      o
    );
  }
  // Una materiale creato per una variante viene marcato con dei metadati. Questo significa che i materiali creati in altro modo
  // e con i materiali giusti verrano riconosciuti e utilizzati per le azioni delle opzioni
  setupSceneMaterialForVariant(e, t, n) {
    const a = this.getOrCreateSceneMaterialMetadata(e.id);
    a.isForPreview = !0, a.autoCreate = !0, a.variantID = t, a.variableMaterialID = n;
  }
  getSceneMaterialForVariant(e, t) {
    const n = this._sceneHelper.getAllMaterials();
    for (let a = 0; a < n.length; a++) {
      const o = n[a], h = this.getSceneMaterialMetadata(o.id);
      if (h && h.isForPreview && h.variantID === e && h.variableMaterialID === t)
        return n[a];
    }
    return null;
  }
  isSceneMaterialForVariant(e) {
    if (!e)
      return !1;
    const t = this.getSceneMaterialMetadata(e.id);
    return t && t.isForPreview;
  }
  canDeleteSceneMaterialForVariant(e) {
    if (!e)
      return !1;
    const t = this.getSceneMaterialMetadata(e.id);
    return !t || t.isForPreview === void 0 || t.isForPreview === null || t.autoCreate === void 0 || t.autoCreate === null ? !0 : t.isForPreview && t.autoCreate;
  }
  getSceneMaterialMetadata(e) {
    return this._sceneHelper.getSceneMaterialMetadata(e);
  }
  getOrCreateSceneMaterialMetadata(e) {
    return this._sceneHelper.getOrCreateSceneMaterialMetadata(e);
  }
  removeSceneMaterialMetadata(e) {
    this._sceneHelper.removeSceneMaterialMetadata(e);
  }
  // Clona un materiale
  cloneSceneMaterial(e, t, n) {
    let a = this._scene.getMaterialById(e), o = null;
    if (a) {
      const h = n || `${a.name} - clone`;
      if (o = a.clone(h), o) {
        const f = t || MPlaza.generateUUID();
        o.id = f;
        const v = this._zkScene.getMappingForSceneMaterial(a.id);
        if (v) {
          const x = v.get("libraryMaterialID");
          this._zkScene.mapLibraryMaterial(x, o.id);
          const k = this._sceneHelper.getTexturesForMaterial(o), I = this._sceneHelper.getTexturesForMaterial(o);
          for (let V = 0; V < I.length; V++) {
            const M = I[V], W = k[V];
            M.materialMapping = W.materialMapping;
          }
        }
      }
    }
    return o;
  }
  deleteSceneMaterial(e) {
    const t = this._scene.getMaterialByID(e);
    if (t && this.canDeleteSceneMaterialForVariant(t)) {
      this.removeSceneMaterialMetadata(e);
      const n = this._zkScene.getLibraryShaderMaterialIDForSceneMaterial(e);
      n && this._zkScene.unregisterShaderMaterial(n), this._zkScene.removeMappingForSceneMaterial(t.id);
      const a = this._sceneHelper.getTexturesExclusivelyForMaterial(t);
      t.dispose();
      for (let o = 0; o < a.length; o++)
        a[o].dispose();
    }
  }
  checkVariantOptionActions(e, t, n, a, o, h) {
    let f = [];
    o.forEach((I) => f.push(I.id));
    let v = this.getOrCreateVariantAttribute(e), x = this.getOrCreateVariantAttributeOption(e, h, v);
    for (let I = 0; I < o.length; I++) {
      let V = o[I], M = n.get("actions").getActionForMesh(V.id);
      if (!M) {
        let W = new MPlaza.AttributeSceneAction();
        W.set("name", ""), W.set("actionTypeID", MPlaza.SceneActionType.SetMeshMaterial), W.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh), W.set("selector", V.id), W.set("value", n.get("optionMaterialID")), x.get("actions").push(W), M = new MPlaza.VariantOptionMaterialAction(), M.set("actionGuid", W.get("actionGuid")), M.set("meshID", V.id), n.get("actions").push(M);
      }
    }
    let k = [];
    for (let I = 0; I < n.get("actions").length; I++) {
      let V = n.get("actions").at(I);
      if (f.indexOf(V.get("meshID")) === -1) {
        let M = x.getActionByGuid(V.get("actionGuid"));
        M && x.get("actions").remove(M), k.push(V);
      }
    }
    n.get("actions").remove(k);
  }
  isMaterialReal(e) {
    var a, o;
    const t = ((a = e.metadata) == null ? void 0 : a.isRealMaterial) !== !1 && e.id !== "default material", n = ((o = e.metadata) == null ? void 0 : o.isDesignMaterial) === !0;
    return t && !n;
  }
  getVariantMaterials(e) {
    let t = [];
    const n = this._zkModel.getPreview3D();
    if (n && e && e instanceof MPlaza.Color) {
      const a = this.getVariantID(e), o = n.getVariantsAttributeOptions();
      if (o) {
        const h = o.getVariantOption(a);
        if (h)
          for (let f = 0; f < h.get("materials").length; f++) {
            const x = h.get("materials").at(f).get("optionMaterialID"), k = this._scene.getMaterialById(x);
            k && this.isMaterialReal(k) && t.push(k);
          }
      }
    }
    return t;
  }
  getSelectedAttributeOption(e) {
    let t = {
      attributeID: null,
      attributeGuid: null,
      optionID: null,
      optionGuid: null
    };
    const n = this._zkModel.getPreview3D();
    if (n && e && e instanceof MPlaza.Color) {
      const a = this.getVariantID(e), o = n.getVariantsAttributeOptions();
      if (o && o.get("attributeGuid")) {
        const h = this._zkModel.getAttributeByGuid(o.get("attributeGuid"));
        if (h) {
          const f = o.getVariantOption(a);
          if (f) {
            const v = h.getOptionByGuid(f.get("optionGuid"));
            v && (t.attributeID = h.get("attributeID"), t.attributeGuid = h.get("attributeGuid"), t.optionID = v.get("optionID"), t.optionGuid = v.get("optionGuid"));
          }
        }
      }
    }
    return t;
  }
  resetOriginaMaterialsOnMeshes() {
    const e = this._zkModel.getPreview3D();
    if (e) {
      const t = e.getVariantsAttributeOptions();
      if (t)
        for (let n = 0; n < t.get("variableMaterials").length; n++) {
          const a = t.get("variableMaterials").at(n), o = a.get("materialID"), h = a.get("meshes"), f = this._scene.getMaterialByID(o);
          if (f)
            for (let v = 0; v < h.length; v++) {
              const x = this._scene.getMeshById(a.get("meshes")[v]);
              x && this._sceneHelper.applyMaterial(f, x);
            }
        }
    }
  }
  // Una mesh usa un materiale se sulla mesh è impostato direttamente quel materiale o se sulla mesh è
  // attualmente impostato un materiale creato ad hoc per la preview 3D e che deriva dal materiale in oggetto (clone)
  getMeshesUsingMaterial(e) {
    const t = [], n = this._sceneHelper.getSceneMeshes();
    for (let a = 0; a < n.length; a++) {
      const o = n[a];
      if (this._sceneHelper.isMeshUsingMaterial(o, e))
        t.push(o);
      else {
        const h = this._sceneHelper.getMeshMaterials(o);
        for (let f = 0; f < h.length; f++) {
          const v = h[f], x = this.getSceneMaterialMetadata(v.id);
          if (x && x.isForPreview && x.variableMaterialID && x.variableMaterialID === e) {
            t.push(o);
            break;
          }
        }
      }
    }
    return t;
  }
  getMaterialsForMeshes(e) {
    const t = e.map((a) => typeof a == "string" ? this._scene.getMeshById(a) : a), n = [];
    for (let a = 0; a < t.length; a++) {
      const o = t[a];
      if (o) {
        const h = this._sceneHelper.getMeshMaterials(o);
        for (let f = 0; f < h.length; f++) {
          const v = h[f];
          n.indexOf(v) === -1 && this.isMaterialReal(v) && n.push(v);
        }
      }
    }
    return n;
  }
  // Restituisce l'elenco delle mesh associate ad una variante
  // Se la variante non ha mesh associate, restituisce le mesh base
  getVariantMeshes(e) {
    const t = this._zkModel.getPreview3D();
    if (!t)
      return [Jr];
    const n = t == null ? void 0 : t.getVariantsAttributeOptions();
    if (!n)
      return [Jr];
    const a = this.getVariantID(e), o = n.get("variantOptions").getVariantOption(a);
    if (!o)
      return [Jr];
    const h = o.get("meshes");
    return h.length > 0 ? h : [Jr];
  }
  /**
   * Given a mesh, returns the variant it is associated with.
   * If the mesh is not associated with any variant, it returns null, which would be the base mesh.
   * It is used for AR, to know which variant was used for the measurement.
   * @param meshID The ID of the mesh to get the variant for.
   * @returns The variant associated with the mesh, or null if the mesh is not associated with any variant.
   */
  getVariantByMeshID(e) {
    const t = this._zkModel.getPreview3D();
    if (!t)
      return null;
    const n = t.getVariantsAttributeOptions();
    if (!n)
      return null;
    for (let a = 0; a < this._zkModel.get("colors").length; a++) {
      const o = this._zkModel.get("colors").at(a), h = this.getVariantID(o), f = n.getVariantOption(h);
      if (f && f.get("meshes").indexOf(e) !== -1)
        return o;
    }
    return null;
  }
  /**
   * Check if a variant has custom meshes associated with it.
   * @param modelColor  The color of the variant to check.
   * @returns True if the variant has custom meshes, false otherwise.
   */
  hasVariantCustomModel(e) {
    const t = this.getVariantMeshes(e);
    return !(t.length === 1 && t[0] === Jr);
  }
  /**
   * Set the meshes associated with a variant.
   * @param modelColor The color of the variant to set meshes for.
   * @param meshIDs The list of mesh IDs to set as variant meshes.
   */
  setVariantMeshes(e, t) {
    const a = this._zkModel.getOrCreatePreview3D().getOrCreateVariantsAttributeOptions(), o = this.getVariantID(e);
    let h = a.get("variantOptions").getVariantOption(o);
    h || (h = this.createVariantOption(a, e)), h.set("meshes", t), this.refreshOptionsShowHideVariantModels();
  }
  /**
   * Remove all meshes associated with a variant.
   * @param modelColor The color of the variant to remove meshes from.
   */
  removeVariantMeshes(e) {
    const n = this._zkModel.getOrCreatePreview3D().getOrCreateVariantsAttributeOptions(), a = this.getVariantID(e);
    let o = n.get("variantOptions").getVariantOption(a);
    if (o) {
      const h = o.get("meshes");
      for (const f of h) {
        const v = this._scene.getMeshById(f);
        v == null || v.dispose(!1, !0);
      }
      o.set("meshes", []);
    }
    this.updateVariableMaterials(), this.refreshOptionsShowHideVariantModels();
  }
  /**
   * Set the current base meshes for the scene.
   * @param meshIDs The list of mesh IDs to set as base meshes.
   */
  setBaseMeshes(e) {
    let t = this._scene.getMeshById(Jr);
    t || (t = new BABYLON.Mesh(Jr, this._scene), t.id = Jr);
    for (const n of e) {
      const a = this._scene.getMeshById(n);
      a && a.setParent(t);
    }
  }
  /**
   * Remove current base meshes from the scene.
   */
  removeBaseMeshes() {
    const e = this._scene.getMeshById(Jr);
    if (e) {
      const t = e.getChildMeshes(!0);
      for (const n of t)
        n.setParent(null);
    }
  }
  /**
   * Upgrade an old preview 3D scene to the new base mesh system.
   */
  upgradeToBaseMeshes() {
    this._scene.getMeshById(Jr) !== null || this.setBaseMeshes(
      this._scene.meshes.filter((t) => !t.parent && t.id !== Jr).map((t) => t.id) ?? []
    );
  }
  /**
   * This method will create or update all options by setting the correct show/hide actions
   * to show the base model or the variant model.
   */
  refreshOptionsShowHideVariantModels() {
    const t = this._zkModel.getOrCreatePreview3D().getOrCreateVariantsAttributeOptions(), n = this.getOrCreateVariantAttribute(t);
    for (let a = 0; a < this._zkModel.get("colors").length; a++) {
      const o = this._zkModel.get("colors").at(a), h = this.getVariantID(o);
      let f = t.get("variantOptions").getVariantOption(h);
      f || (f = this.createVariantOption(t, o));
      const v = this.getOrCreateVariantAttributeOption(t, o, n);
      let x = v.get("actions").find(
        (k) => k.get("selector") === "*" && k.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh
      );
      x || (x = new MPlaza.AttributeSceneAction(), x.set("name", ""), x.set("actionTypeID", MPlaza.SceneActionType.ShowHideMesh), x.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh), x.set("selector", "*"), x.set("value", "hide"), v.get("actions").push(x));
      for (let k = 0; k < v.get("actions").length; k++) {
        const I = v.get("actions").at(k);
        I.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && I.get("selector") !== "*" && (v.get("actions").remove(I), k--);
      }
      if ((f == null ? void 0 : f.get("meshes").length) === 0) {
        const k = new MPlaza.AttributeSceneAction();
        k.set("name", ""), k.set("actionTypeID", MPlaza.SceneActionType.ShowHideMesh), k.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh), k.set("selector", Jr), k.set("value", "show"), v.get("actions").push(k);
      } else
        for (const k of f.get("meshes")) {
          const I = new MPlaza.AttributeSceneAction();
          I.set("name", ""), I.set("actionTypeID", MPlaza.SceneActionType.ShowHideMesh), I.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh), I.set("selector", k), I.set("value", "show"), v.get("actions").push(I);
        }
    }
  }
  // Design materials
  setDesignMaterialForVariantEnabled(e, t) {
    var f;
    const n = this.hasVariantCustomModel(e) ? e.get("colorID") : null, a = this._zkModel.get("scenes").at(0).get("meshSides").filter((v) => v.get("colorID") === n), o = (f = a.at(0)) == null ? void 0 : f.get("materialID");
    let h = o ? this._scene.getMaterialById(o) : null;
    t || (a.forEach((v) => {
      v.set("materialID", null);
    }), h && (a.some(
      (x) => x.get("materialID") === h.id
    ) || h.dispose())), t && !h && (h = new BABYLON.PBRMaterial("Design material", this._scene), h.id = Zakeke.generateUUID(), h.zOffset = -1, h.metallic = 0.5, h.roughness = 0.2, a.forEach((v) => {
      v.set("materialID", h.id);
    }));
  }
  getDesignMaterialForVariant(e) {
    const t = this.hasVariantCustomModel(e) ? e.get("colorID") : null, n = this._zkModel.get("scenes").at(0).get("meshSides").find((o) => o.get("colorID") === t), a = n ? n.get("materialID") : null;
    return a ? this._scene.getMaterialById(a) : null;
  }
}
function Kd(b) {
  return typeof importScripts == "function" ? (importScripts(b), Promise.resolve()) : new Promise((e, t) => {
    BABYLON.Tools.LoadScript(b, () => {
      e();
    }, (n) => {
      t(new Error(n));
    });
  });
}
function pw(b) {
  return new Promise((e, t) => {
    BABYLON.Tools.LoadFile(b, (n) => {
      e(n);
    }, void 0, void 0, !0, (n, a) => {
      t(a);
    });
  });
}
function Vh(b, e, t) {
  const n = e && b || t;
  if (n)
    return Kd(n).then(() => new Promise((a) => {
      DracoDecoderModule({ wasmBinary: e }).then((o) => {
        a({ module: o });
      });
    }));
}
function Hh(b, e, t, n, a) {
  const o = new b.DecoderBuffer();
  o.Init(e, e.byteLength);
  const h = new b.Decoder();
  let f, v;
  try {
    const k = h.GetEncodedGeometryType(o);
    switch (k) {
      case b.TRIANGULAR_MESH:
        f = new b.Mesh(), v = h.DecodeBufferToMesh(o, f);
        break;
      case b.POINT_CLOUD:
        f = new b.PointCloud(), v = h.DecodeBufferToPointCloud(o, f);
        break;
      default:
        throw new Error(`Invalid geometry type ${k}`);
    }
    if (!v.ok() || !f.ptr)
      throw new Error(v.error_msg());
    const I = f.num_points();
    if (k === b.TRIANGULAR_MESH) {
      const M = f.num_faces(), W = new b.DracoInt32Array();
      try {
        const U = new Uint32Array(M * 3);
        for (let Q = 0; Q < M; Q++) {
          h.GetFaceFromMesh(f, Q, W);
          const D = Q * 3;
          U[D + 0] = W.GetValue(0), U[D + 1] = W.GetValue(1), U[D + 2] = W.GetValue(2);
        }
        n(U);
      } finally {
        b.destroy(W);
      }
    }
    const V = (M, W) => {
      const U = new b.DracoFloat32Array();
      try {
        h.GetAttributeFloatForAllPoints(f, W, U);
        const Q = new Float32Array(I * W.num_components());
        for (let D = 0; D < Q.length; D++)
          Q[D] = U.GetValue(D);
        a(M, Q);
      } finally {
        b.destroy(U);
      }
    };
    if (t)
      for (const M in t) {
        const W = t[M], U = h.GetAttributeByUniqueId(f, W);
        V(M, U);
      }
    else {
      const M = {
        position: "POSITION",
        normal: "NORMAL",
        color: "COLOR",
        uv: "TEX_COORD",
        uv2: "TEX_COORD",
        uv3: "TEX_COORD",
        uv4: "TEX_COORD",
        uv5: "TEX_COORD",
        uv6: "TEX_COORD"
      }, W = /^uv(\d+)$/;
      for (const U in M) {
        const Q = U.match(W);
        let D = -1;
        if (Q && Q.length > 1) {
          var x = parseInt(Q[1], 10);
          const ee = h.GetAttributeId(f, b.TEX_COORD);
          ee !== -1 && (D = ee + x - 1);
        } else
          D = h.GetAttributeId(f, b[M[U]]);
        if (D !== -1) {
          const ee = h.GetAttributeByUniqueId(f, D);
          ee && ee.size() > 0 && V(U, ee);
        }
      }
    }
  } finally {
    f && b.destroy(f), b.destroy(h), b.destroy(o);
  }
}
function mw() {
  let b;
  onmessage = (e) => {
    const t = e.data;
    switch (t.id) {
      case "init": {
        const n = t.decoder;
        b = Vh(n.wasmUrl, n.wasmBinary, n.fallbackUrl), postMessage("done");
        break;
      }
      case "decodeMesh": {
        if (!b)
          throw new Error("Draco decoder module is not available");
        b.then((n) => {
          Hh(n.module, t.dataView, t.attributes, (a) => {
            postMessage({ id: "indices", value: a }, [a.buffer]);
          }, (a, o) => {
            postMessage({ id: a, value: o }, [o.buffer]);
          }), postMessage("done");
        });
        break;
      }
    }
  };
}
function kh(b) {
  return typeof document != "object" || typeof b != "string" ? b : BABYLON.Tools.GetAbsoluteUrl(b);
}
const oo = class Hs {
  /**
   * Returns true if the decoder configuration is available.
   */
  static get DecoderAvailable() {
    const e = Hs.Configuration.decoder;
    return !!(e.wasmUrl && e.wasmBinaryUrl && typeof WebAssembly == "object" || e.fallbackUrl);
  }
  static GetDefaultNumWorkers() {
    return typeof navigator != "object" || !navigator.hardwareConcurrency ? 1 : Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 1);
  }
  /**
   * Default instance for the draco compression object.
   */
  static get Default() {
    return Hs._Default || (Hs._Default = new Hs()), Hs._Default;
  }
  /**
   * Constructor
   * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
   */
  constructor(e = Hs.DefaultNumWorkers) {
    const t = Hs.Configuration.decoder, n = t.wasmUrl && t.wasmBinaryUrl && typeof WebAssembly == "object" ? pw(kh(t.wasmBinaryUrl)) : Promise.resolve(void 0);
    e && typeof Worker == "function" ? this._workerPoolPromise = n.then((a) => {
      const o = `${Kd}${Vh}${Hh}(${mw})()`, h = URL.createObjectURL(new Blob([o], { type: "application/javascript" })), f = new Array(e);
      for (let v = 0; v < f.length; v++)
        f[v] = new Promise((x, k) => {
          const I = new Worker(h), V = (W) => {
            I.removeEventListener("error", V), I.removeEventListener("message", M), k(W);
          }, M = (W) => {
            W.data === "done" && (I.removeEventListener("error", V), I.removeEventListener("message", M), x(I));
          };
          I.addEventListener("error", V), I.addEventListener("message", M), I.postMessage({
            id: "init",
            decoder: {
              wasmUrl: kh(t.wasmUrl),
              wasmBinary: a,
              fallbackUrl: kh(t.fallbackUrl)
            }
          });
        });
      return Promise.all(f).then((v) => new pu(v));
    }) : this._decoderModulePromise = n.then((a) => Vh(t.wasmUrl, a, t.fallbackUrl));
  }
  /**
   * Stop all async operations and release resources.
   */
  dispose() {
  }
  /**
   * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
   * @returns a promise that resolves when ready
   */
  whenReadyAsync() {
    return this._workerPoolPromise ? this._workerPoolPromise.then(() => {
    }) : this._decoderModulePromise ? this._decoderModulePromise.then(() => {
    }) : Promise.resolve();
  }
  /**
    * Decode Draco compressed mesh data to vertex data.
    * @param data The ArrayBuffer or ArrayBufferView for the Draco compression data
    * @param attributes A map of attributes from vertex buffer kinds to Draco unique ids
    * @returns A promise that resolves with the decoded vertex data
    */
  decodeMeshAsync(e, t) {
    const n = e instanceof ArrayBuffer ? new Uint8Array(e) : e;
    if (this._workerPoolPromise)
      return this._workerPoolPromise.then((a) => new Promise((o, h) => {
        a.push((f, v) => {
          const x = new BABYLON.VertexData(), k = (M) => {
            f.removeEventListener("error", k), f.removeEventListener("message", I), h(M), v();
          }, I = (M) => {
            M.data === "done" ? (f.removeEventListener("error", k), f.removeEventListener("message", I), o(x), v()) : M.data.id === "indices" ? x.indices = M.data.value : x.set(M.data.value, M.data.id);
          };
          f.addEventListener("error", k), f.addEventListener("message", I);
          const V = new Uint8Array(n.byteLength);
          V.set(new Uint8Array(n.buffer, n.byteOffset, n.byteLength)), f.postMessage({ id: "decodeMesh", dataView: V, attributes: t }, [V.buffer]);
        });
      }));
    if (this._decoderModulePromise)
      return this._decoderModulePromise.then((a) => {
        const o = new BABYLON.VertexData();
        return Hh(a.module, n, t, (h) => {
          o.indices = h;
        }, (h, f) => {
          o.set(f, h);
        }), o;
      });
    throw new Error("Draco decoder module is not available");
  }
};
oo.Configuration = {
  decoder: {
    //wasmUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_wasm_wrapper.js"),
    //wasmBinaryUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_decoder.wasm"),
    //fallbackUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_decoder.js")
    /*
    wasmUrl: "https://preview.babylonjs.com/draco_wasm_wrapper_gltf.js",
    wasmBinaryUrl: "https://preview.babylonjs.com/draco_decoder_gltf.wasm",
    fallbackUrl: "https://preview.babylonjs.com/draco_decoder_gltf.js"
    */
    wasmUrl: "https://cdn.zakeke.com/cdn/Scripts/draco/1.3.4/rev.1/draco_wasm_wrapper.js",
    wasmBinaryUrl: "https://cdn.zakeke.com/cdn/Scripts/draco/1.3.4/rev.1/draco_decoder.wasm",
    fallbackUrl: "https://cdn.zakeke.com/cdn/Scripts/draco/1.3.4/rev.1/draco_decoder.js"
  }
};
oo.DefaultNumWorkers = oo.GetDefaultNumWorkers();
oo._Default = null;
let _w = oo;
class Jd {
  constructor(e, t, n = !1) {
    this._originalSceneClearColor = null, this._originalCameraAutoRotate = null, this._environmentHelper = null, this._shadowLight = null, this._isHologram = !1, this._zkScene = e, this._scene = t, this._sceneHelper = new di(this._scene), this._isHologram = n;
  }
  get scene() {
    return this._scene;
  }
  get isHologram() {
    return this._isHologram;
  }
  set isHologram(e) {
    this._isHologram = e, this.update();
  }
  dispose() {
    this._shadowLight && this._shadowLight.dispose(), this._environmentHelper && (this._environmentHelper.dispose(), this._environmentHelper = null), this.removeOldSkybox();
  }
  update() {
    this.configureScene(), this.configureCamera(), this.configureSkybox();
  }
  configureSkybox() {
    this.removeOldSkybox(), this._isHologram || this.createSkybox();
  }
  removeOldSkybox() {
    const e = this.getSkyboxMesh(), t = this.getSkyboxMaterial();
    e && e.dispose(), t && t.dispose();
  }
  createSkybox() {
    var n, a;
    this.getGeneralConfig();
    const e = this.getEnvironmentConfig(), t = this.getSkyboxConfig();
    if (t && t.get("createSkybox") != null && t.get("createSkybox")) {
      e && e.get("sizeAuto") != null && e.get("sizeAuto") != null && typeof e.get("sizeAuto") == "boolean" && e.get("sizeAuto");
      let o = null;
      t.get("size") != null && typeof t.get("size") == "number" && (o = t.get("size"));
      let h = null;
      t.get("texture") != null && typeof t.get("texture") == "string" && (h = t.get("texture"));
      let f = 0;
      t.get("blur") > 0 && (f = t.get("blur"));
      let v = null;
      t.get("extensions") != null && t.get("extensions") != null && Object.prototype.toString.call(t.get("extensions")) === "[object Array]" && ((n = t.get("extensions")) == null ? void 0 : n.length) === 6 && (v = t.get("extensions"));
      let x = null;
      if (t.get("files") != null && t.get("files") != null && Object.prototype.toString.call(t.get("files")) === "[object Array]" && ((a = t.get("files")) == null ? void 0 : a.length) === 6 && (x = t.get("files")), h) {
        let k = null;
        if (h.endsWith(".dds") ? k = BABYLON.CubeTexture.CreateFromPrefilteredData(h, this._scene) : h.endsWith(".hdr") ? k = new BABYLON.HDRCubeTexture(h, this._scene, 256, !1, !0, !1, !0) : h.endsWith(".env") ? k = new BABYLON.CubeTexture(
          h,
          this._scene,
          null,
          !1,
          null,
          void 0,
          null,
          void 0,
          !0,
          void 0,
          !0
        ) : h.endsWith(".basis") ? k = BABYLON.CubeTexture.CreateFromPrefilteredData(h, this._scene) : v && x ? k = new BABYLON.CubeTexture(h, this._scene, v, !1, x, void 0) : k = BABYLON.CubeTexture.CreateFromPrefilteredData(h, this._scene), k) {
          let I = 1e3;
          o != null && o > 0 ? I = o : I = (this._scene.activeCamera.maxZ - this._scene.activeCamera.minZ) / 2;
          const V = this._scene.createDefaultSkybox(k, !0, I, f, !1);
          if (V) {
            V.metadata = { isSkyboxMesh: !0, isRealMesh: !1 }, V.doNotSerialize = !0;
            const M = V.material;
            M && (M.metadata = { isSkyboxMaterial: !0, isRealMaterial: !1 }, M.doNotSerialize = !0);
          }
        }
      }
    }
  }
  getSkyboxMesh() {
    return this._scene.meshes.find((t) => t.metadata && t.metadata.isSkyboxMesh) || null;
  }
  getSkyboxMaterial() {
    let e = this._scene.materials.find((t) => t.metadata && t.metadata.isSkyboxMaterial);
    return e || null;
  }
  getSkyboxTexture() {
    const e = this.getSkyboxMaterial();
    return e ? e.reflectionTexture : null;
  }
  update_OLD() {
    this.configureScene(), this.configureCamera(), this.configureEnvironment();
  }
  configureScene() {
    if (this._scene) {
      if (this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0), this._originalSceneClearColor = this._scene.clearColor.clone(), this._isHologram) {
        this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 1);
        return;
      }
      var e = this.getGeneralConfig();
      if (e) {
        let t = null;
        e.get("backgroundAlpha") != null && e.get("backgroundAlpha") != null && typeof e.get("backgroundAlpha") == "number" && (t = e.get("backgroundAlpha"));
        let n = null;
        if (e.get("backgroundColor") != null && typeof e.get("backgroundColor") == "string" && this.isValidHexColor(e.get("backgroundColor")) && (n = e.get("backgroundColor")), t || n) {
          this._originalSceneClearColor = this._scene.clearColor;
          let a = this._scene.clearColor;
          if (n != null) {
            let o = BABYLON.Color3.FromHexString(n);
            a.r = o.r, a.g = o.g, a.b = o.b;
          }
          t != null && (a.a = t);
        }
      }
    }
  }
  configureEnvironment() {
    if (this._environmentHelper && (this._environmentHelper.dispose(), this._environmentHelper = null), this._shadowLight && (this._shadowLight.dispose(), this._shadowLight = null), this._sceneHelper.countSceneMeshes() != 0) {
      var e = this.buildEnvironmentHelperOptions();
      if (e) {
        this._environmentHelper = this._scene.createDefaultEnvironment(e);
        const t = this.getEnvironmentSceneNodes();
        for (let n = 0; n < t.length; n++) {
          const a = t[n];
          a && (this.setDoNotSerialize(a), a.metadata || (a.metadata = {}), a.metadata.isEnvironmentNode = !0, a instanceof BABYLON.AbstractMesh && (a.isPickable = !1, a.metadata.isRealMesh = !1), a instanceof BABYLON.Material && (a.metadata.isRealMaterial = !1));
        }
      }
    }
  }
  buildEnvironmentHelperOptions() {
    let e = null;
    const t = this.getGeneralConfig(), n = this.getEnvironmentConfig(), a = this.getSkyboxConfig(), o = this.getGroundConfig(), h = this.getCameraConfig();
    let f = null;
    t && t.get("environmentTexture") != null && t.get("environmentTexture") != null && (f = t.get("environmentTexture"));
    let v = null;
    h && h.get("contrast") != null && typeof h.get("contrast") == "number" && (v = h.get("contrast"));
    let x = null;
    h && h.get("exposure") != null && typeof h.get("exposure") == "number" && (x = h.get("exposure"));
    let k = null;
    h && h.get("toneMappingEnabled") != null && typeof h.get("toneMappingEnabled") == "boolean" && (k = h.get("toneMappingEnabled"));
    let I = null;
    n && n.get("sizeAuto") != null && n.get("sizeAuto") != null && typeof n.get("sizeAuto") == "boolean" && (I = n.get("sizeAuto"));
    let V = null;
    n && n.get("mainColor") != null && typeof n.get("mainColor") == "string" && this.isValidHexColor(n.get("mainColor")) && (V = n.get("mainColor"));
    let M = null;
    o && o.get("size") != null && typeof o.get("size") == "number" && (M = o.get("size"));
    let W = null;
    o && o.get("color") != null && typeof o.get("color") == "string" && this.isValidHexColor(o.get("color")) && (W = o.get("color"));
    let U = null;
    o && o.get("enableShadow") != null && typeof o.get("enableShadow") == "boolean" && (U = o.get("enableShadow"));
    let Q = null;
    o && o.get("shadowLevel") != null && typeof o.get("shadowLevel") == "number" && (Q = o.get("shadowLevel"));
    let D = null;
    o && o.get("enableMirror") != null && typeof o.get("enableMirror") == "boolean" && (D = o.get("enableMirror"));
    let ee = null;
    o && o.get("texture") != null && typeof o.get("texture") == "string" && (ee = o.get("texture"));
    let J = null;
    o && o.get("opacity") != null && typeof o.get("opacity") == "number" && (J = o.get("opacity"));
    let he = null;
    o && o.get("mirrorBlurKernel") != null && typeof o.get("mirrorBlurKernel") == "number" && (he = o.get("mirrorBlurKernel"));
    let fe = null;
    a && a.get("size") != null && typeof a.get("size") == "number" && (fe = a.get("size"));
    let X = null;
    a && a.get("color") != null && typeof a.get("color") == "string" && this.isValidHexColor(a.get("color")) && (X = a.get("color"));
    let Z = null;
    a && a.get("texture") != null && typeof a.get("texture") == "string" && (Z = a.get("texture"));
    let qe = f != null || v != null || x != null || k;
    return (a || o || qe) && (e = e || {
      createSkybox: a && a.get("createSkybox"),
      createGround: o && o.get("createGround")
    }, e.setupImageProcessing = !1, f != null && (e.environmentTexture = f), (e.createSkybox || e.createGround) && (I != null && (e.sizeAuto = I), V != null && (e.mainColor = BABYLON.Color3.FromHexString(V)), e.createGround && (!e.sizeAuto && M != null && (e.groundSize = M), !e.mainColor && W != null && (e.groundColor = BABYLON.Color3.FromHexString(W)), U != null && (e.enableGroundShadow = U), e.enableGroundShadow && this.createShadowLight(), Q != null && (e.groundShadowLevel = Q), D != null && (e.enableGroundMirror = D), ee != null && (e.groundTexture = ee), J != null && (e.groundOpacity = J), e.enableGroundMirror && he != null && (e.groundMirrorBlurKernel = he)), e.createSkybox && (!e.sizeAuto && fe != null && (e.skyboxSize = fe), !e.mainColor && X != null && (e.skyboxColor = BABYLON.Color3.FromHexString(X)), Z != null && (e.skyboxTexture = Z)), h && (v != null && (e.cameraContrast = v), x != null && (e.cameraExposure = x), k != null && (e.toneMappingEnabled = k)))), e && (!e.environmentTexture && !this._scene.environmentTexture && (e.environmentTexture = ci.Environment.EnvironmentTextureCDNUrl), e.createGround != null && e.createGround && !e.groundTexture && (e.groundTexture = ci.Environment.GroundTextureCDNUrl), e.createSkybox != null && e.createSkybox && !e.skyboxTexture && (e.skyboxTexture = ci.Environment.SkyboxTextureCDNUrl)), e;
  }
  createShadowLight() {
    if (this._shadowLight && (this._shadowLight.dispose(), this._shadowLight = null), this._scene && this._sceneHelper) {
      var e = this._sceneHelper.getSceneBoundingInfo();
      if (e && e.boundingBox) {
        const n = e.boundingBox.vectorsWorld, a = Number(n[1].x - n[0].x), o = Number(n[1].y - n[0].y), h = Number(n[1].z - n[0].z), f = e.boundingBox.centerWorld;
        e.boundingBox.maximumWorld;
        const v = f.x + a * 2.67, x = f.y + o * 4.5, k = f.z + h * 1, I = new BABYLON.Vector3(v, x, k);
        let M = f.subtract(I);
        M = BABYLON.Vector3.Normalize(M), M = new BABYLON.Vector3(-2, -3, 1), this._shadowLight = new BABYLON.DirectionalLight("shadowLight", M, this._scene), this._shadowLight.position = I, this._shadowLight.intensity = 0.1;
        var t = new BABYLON.ShadowGenerator(512, this._shadowLight);
        t.useBlurExponentialShadowMap = !0, t.useKernelBlur = !0, t.usePercentageCloserFiltering = !0, t.blurKernel = 32;
        for (let W = 0; W < this._scene.meshes.length; W++) {
          const U = this._scene.meshes[W];
          !this.isEnvironmentNode(U) && this._sceneHelper.isRealMesh(U) && (U.receiveShadows = !1, t.addShadowCaster(U));
        }
      }
    }
  }
  configureCamera() {
    if (!this._scene || !this._scene.activeCamera || !(this._scene.activeCamera instanceof BABYLON.ArcRotateCamera))
      return;
    const e = this.getCameraConfig();
    if (e) {
      const t = this._scene.activeCamera;
      this._originalCameraAutoRotate = t.useAutoRotationBehavior;
      let n = e.get("autoRotate");
      t.useAutoRotationBehavior = n != null && n;
      let a = t.getBehaviorByName("AutoRotation"), o = Number(e.get("rotationSpeed")), h = e.get("changeRotationDirection");
      if (n && o) {
        let f = h ? -1 : 1;
        a.idleRotationSpeed = o * f;
      }
    }
  }
  sanityCheck() {
    return this._scene && this._scene instanceof BABYLON.Scene && this._zkScene && this._zkScene instanceof Zakeke.Scene && this._zkScene.get("config") != null && this._zkScene.get("config") != null && this._zkScene.get("config") instanceof Zakeke.SceneConfig;
  }
  getSceneConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getSceneConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getGeneralConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getGeneralConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getEnvironmentConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getEnvironmentConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getSkyboxConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getSkyboxConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getGroundConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getGroundConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  getCameraConfig() {
    if (this.sanityCheck()) {
      let e = this._zkScene.getCameraConfig();
      if (e != null && e != null)
        return e;
    }
    return null;
  }
  isValidHexColor(e) {
    return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(e);
  }
  getEnvironmentSceneNodes() {
    const e = [];
    return this._environmentHelper && (this._environmentHelper.rootMesh && e.push(this._environmentHelper.rootMesh), this._environmentHelper.skybox && e.push(this._environmentHelper.skybox), this._environmentHelper.skyboxMaterial && e.push(this._environmentHelper.skyboxMaterial), this._environmentHelper.skyboxTexture && e.push(this._environmentHelper.skyboxTexture), this._environmentHelper.ground && e.push(this._environmentHelper.ground), this._environmentHelper.groundMaterial && e.push(this._environmentHelper.groundMaterial), this._environmentHelper.groundTexture && e.push(this._environmentHelper.groundTexture), this._environmentHelper.groundMirror && e.push(this._environmentHelper.groundMirror), this._shadowLight && e.push(this._shadowLight)), e;
  }
  isEnvironmentNode(e) {
    const t = this.getEnvironmentSceneNodes();
    for (let n = 0; n < t.length; n++)
      if (e == t[n])
        return !0;
    return !1;
  }
  setDoNotSerialize(e) {
    (e instanceof BABYLON.AbstractMesh || e instanceof BABYLON.Material || e instanceof BABYLON.Light) && (e.doNotSerialize = !0);
  }
  reset() {
    this._scene && (this._originalSceneClearColor && (this._scene.clearColor = this._originalSceneClearColor), this._originalCameraAutoRotate != null && this._scene.activeCamera && this._scene.activeCamera instanceof BABYLON.ArcRotateCamera && (this._scene.activeCamera.useAutoRotationBehavior = this._originalCameraAutoRotate), this._environmentHelper && this._environmentHelper.updateOptions({}));
  }
}
function Qd(b) {
  return typeof importScripts == "function" ? (importScripts(b), Promise.resolve()) : new Promise((e, t) => {
    BABYLON.Tools.LoadScript(
      b,
      () => {
        e();
      },
      (n) => {
        t(new Error(n));
      }
    );
  });
}
function eg(b) {
  if (b.length == 0)
    return Promise.resolve();
  let e = [];
  for (let t = 0; t < b.length; t++)
    e.push(Qd(b[t]));
  return new Promise((t) => {
    Promise.all(e).then(() => t());
  });
}
function tg(b, e) {
  return b ? b.match(new RegExp(".[^]{1," + e + "}", "g")) : null;
}
function ig(b, e, t) {
  let n = "scene_" + e + ".babylon", a = b;
  const o = [];
  if (a.length <= 5e6) {
    let f = !1;
    a.length > 180 && a.length <= 1e6 && (a = LZString.compressToUint8Array(a), n = "compressed_" + n, f = !0);
    let v = null;
    if (!f)
      v = new Blob([a], { type: "text/plain" });
    else {
      let x = a.buffer;
      v = new Blob([x]);
    }
    v && o.push({
      name: n,
      blob: v
    });
  } else {
    let f = tg(a, 8e5);
    if (f)
      for (let v = 0; v < f.length; v++) {
        let x = f[v], k = n + "_part_" + v, I = !1;
        x.length > 180 && (x = LZString.compressToUint8Array(x), k = "compressed_" + k, I = !0);
        let V = null;
        if (!I)
          V = new Blob([x], { type: "text/plain" });
        else {
          var h = x.buffer;
          V = new Blob([h]);
        }
        V && o.push({
          name: k,
          blob: V
        }), t(v / f.length * 100);
      }
  }
  return o;
}
function vw(b) {
  return typeof document != "object" || typeof b != "string" ? b : BABYLON.Tools.GetAbsoluteUrl(b);
}
function yw() {
  let b;
  onmessage = (e) => {
    const t = e.data;
    switch (t.id) {
      case "init": {
        const n = t.urls;
        b = eg(n), postMessage("done");
        break;
      }
      case "makeBlobs": {
        if (!b)
          throw new Error("Worker not initialized");
        b.then(() => {
          const n = t.json, a = t.version, o = ig(n, a, (h) => {
            postMessage({ id: "progress", perc: h });
          });
          postMessage({ id: "result", blobInfos: o }), postMessage("done");
        });
        break;
      }
    }
  };
}
const vl = class xa {
  static GetDefaultNumWorkers() {
    return typeof navigator != "object" || !navigator.hardwareConcurrency ? 1 : Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 2);
  }
  /**
   * Default instance for the draco compression object.
   */
  static get Default() {
    return xa._Default || (xa._Default = new xa([])), xa._Default;
  }
  /**
   * Constructor
   * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
   */
  constructor(e, t = xa.DefaultNumWorkers) {
    const n = e.map((a) => vw(a));
    if (t && typeof Worker == "function") {
      const a = `${Qd}${eg}${tg}${ig}(${yw})()`, o = URL.createObjectURL(new Blob([a], { type: "application/javascript" })), h = new Array(t);
      for (let f = 0; f < h.length; f++)
        h[f] = new Promise((v, x) => {
          const k = new Worker(o), I = (M) => {
            k.removeEventListener("error", I), k.removeEventListener("message", V), x(M);
          }, V = (M) => {
            M.data === "done" && (k.removeEventListener("error", I), k.removeEventListener("message", V), v(k));
          };
          k.addEventListener("error", I), k.addEventListener("message", V), k.postMessage({
            id: "init",
            urls: n
          });
        });
      this._workerPoolPromise = Promise.all(h).then((f) => new pu(f));
    }
  }
  dispose() {
  }
  /**
   * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
   * @returns a promise that resolves when ready
   */
  whenReadyAsync() {
    return this._workerPoolPromise ? this._workerPoolPromise.then(() => {
    }) : Promise.resolve();
  }
  getSceneBlobsAsync(e, t, n) {
    if (this._workerPoolPromise)
      return this._workerPoolPromise.then((a) => new Promise((o, h) => {
        a.push((f, v) => {
          let x = [];
          const k = (V) => {
            f.removeEventListener("error", k), f.removeEventListener("message", I), h(V), v();
          }, I = (V) => {
            V.data === "done" ? (f.removeEventListener("error", k), f.removeEventListener("message", I), o(x), v()) : V.data.id === "progress" ? n(V.data.perc) : V.data.id === "result" && (x = V.data.blobInfos);
          };
          f.addEventListener("error", k), f.addEventListener("message", I), f.postMessage({ id: "makeBlobs", json: e, version: t });
        });
      }));
    throw new Error("SceneToBlob worker is not available");
  }
};
vl.DefaultNumWorkers = vl.GetDefaultNumWorkers();
vl._Default = null;
let bw = vl;
class kl {
  static openSceneViewer(e, t, n = !0, a = null) {
    if (this._fallbackInvoked)
      return;
    const o = self.location.toString(), h = new URL(o), f = new URL(e), v = new URLSearchParams(f.search);
    if (h.hash = this._noArViewerSigil, v.set("mode", "ar_preferred"), v.has("disable_occlusion") || v.set("disable_occlusion", "true"), n || v.set("resizable", "false"), a && a.toLowerCase() === "wall" && v.set("enable_vertical_placement", "true"), v.has("sound")) {
      const I = new URL(v.get("sound"), o);
      v.set("sound", I.toString());
    }
    if (v.has("link")) {
      const I = new URL(v.get("link"), o);
      v.set("link", I.toString());
    }
    const x = `intent://arvr.google.com/scene-viewer/1.0?${v.toString() + "&file=" + encodeURIComponent(
      f.toString()
    )}#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(h.toString())};end;`;
    console.log(x);
    const k = () => {
      self.location.hash === this._noArViewerSigil && !this._fallbackInvoked && (this._fallbackInvoked = !0, t && t(), self.history.back());
    };
    self.addEventListener("hashchange", k, { once: !0 }), this._anchor.setAttribute("href", x), this._anchor.setAttribute("target", "_blank"), document.body.appendChild(this._anchor), this._anchor.click();
  }
}
kl._anchor = document.createElement("a");
kl._linkOrTitle = /(link|title)(=|&)|(\?|&)(link|title)$/;
kl._noArViewerSigil = "#model-viewer-no-ar-fallback";
kl._fallbackInvoked = !1;
class xw {
  constructor(e, t, n) {
    this._meshesInfoPoints = {}, this._infoPoints = [], this._imageUrls = [], this._currentIdx = 0, this._imagePanel = null, this._loadingText = null, this._image = null, this._closeImageButton = null, this._moveNextImageButton = null, this._movePrevImageButton = null, this._isOnMoveNextButton = !1, this._isOnMovePrevButton = !1, this._lastCameraPosition = null, this.onBeforeShowImages = null, this.onAfterShowImages = null, this._infoPointsShown = !0, this._canShowInfoPointsContent = !0, this._infoPointPickedListeners = [], this._infoPointContentShownListeners = [], this._infoPointContentHiddenListeners = [], this._renderingNeededListeners = [], this.CLOSE_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-close' style='fill:§color§'%3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/g%3E%3C/svg%3E", this.CHEVRON_LEFT_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-chevron-left'%3E%3Cpath fill='§color§' d='M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z' /%3E%3C/g%3E%3C/svg%3E", this.CHEVRON_RIGHT_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-chevron-right'%3E%3Cpath fill='§color§' d='M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z' /%3E%3C/g%3E%3C/svg%3E", this._zkScene = e, this._scene = t, this._sceneHelper = new di(t), this._style = {}, this.setDefaultStyle(), n && this.setStyle(n), this._rootContainer = BABYLON.GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI", !0, this._scene);
  }
  get infoPointsShown() {
    return this._infoPointsShown;
  }
  get canShowInfoPointsContent() {
    return this._canShowInfoPointsContent;
  }
  set canShowInfoPointsContent(e) {
    this._canShowInfoPointsContent = e, this.hideImages();
  }
  dispose() {
    this._renderingNeededListeners = [], this._rootContainer.dispose();
  }
  setDefaultStyle() {
    this._style.infoPointsStyle = {
      borderColor: "#ffffff",
      innerPointColor: "#ffffff",
      color: "#a01c20",
      highlightColor: "#bb2025"
    }, this._style.imagePanelStyle = {
      backgroundColor: this._scene.clearColor.toHexString(),
      loadingTextColor: "#ffffff",
      buttonsBorderColor: "#a01c20",
      buttonsColor: "#a01c20",
      buttonsBorderHighlightColor: "#bb2025",
      buttonsHighlightColor: "#bb2025",
      buttonsIconColor: "white"
    };
  }
  setStyle(e) {
    e ? (e.infoPointsStyle && (this._style.infoPointsStyle || (this._style.infoPointsStyle = {}), e.infoPointsStyle.borderColor && (this._style.infoPointsStyle.borderColor = e.infoPointsStyle.borderColor), e.infoPointsStyle.innerPointColor && (this._style.infoPointsStyle.innerPointColor = e.infoPointsStyle.innerPointColor), e.infoPointsStyle.color && (this._style.infoPointsStyle.color = e.infoPointsStyle.color), e.infoPointsStyle.highlightColor && (this._style.infoPointsStyle.highlightColor = e.infoPointsStyle.highlightColor)), e.imagePanelStyle && (this._style.imagePanelStyle || (this._style.imagePanelStyle = {}), e.imagePanelStyle.backgroundColor && (this._style.imagePanelStyle.backgroundColor = e.imagePanelStyle.backgroundColor), e.imagePanelStyle.loadingTextColor && (this._style.imagePanelStyle.loadingTextColor = e.imagePanelStyle.loadingTextColor), e.imagePanelStyle.buttonsBorderColor && (this._style.imagePanelStyle.buttonsBorderColor = e.imagePanelStyle.buttonsBorderColor), e.imagePanelStyle.buttonsColor && (this._style.imagePanelStyle.buttonsColor = e.imagePanelStyle.buttonsColor), e.imagePanelStyle.buttonsBorderHighlightColor && (this._style.imagePanelStyle.buttonsBorderHighlightColor = e.imagePanelStyle.buttonsBorderHighlightColor), e.imagePanelStyle.buttonsHighlightColor && (this._style.imagePanelStyle.buttonsHighlightColor = e.imagePanelStyle.buttonsHighlightColor), e.imagePanelStyle.buttonsIconColor && (this._style.imagePanelStyle.buttonsIconColor = e.imagePanelStyle.buttonsIconColor))) : this.setDefaultStyle();
  }
  applyStyle(e) {
    this.setStyle(e), this.refresh();
  }
  showInfoPoints() {
    this.hideImages(), this.getAllInfoPoints().forEach((e) => e.isVisible = !0), this._infoPointsShown = !0, this.fireRenderingNeededEvent();
  }
  hideInfoPoints() {
    this.hideImages(), this.getAllInfoPoints().forEach((e) => e.isVisible = !1), this._infoPointsShown = !1, this.fireRenderingNeededEvent();
  }
  refresh() {
    this.hideImages(), this.refreshInfoPoints(), this.updateGuiElementsStyle(), this.fireRenderingNeededEvent();
  }
  getAllInfoPoints() {
    const e = [];
    for (const t in this._meshesInfoPoints)
      e.push(this._meshesInfoPoints[t]);
    return e;
  }
  refreshInfoPoints() {
    for (let e = 0; e < this._scene.meshes.length; e++) {
      const t = this._scene.meshes[e], n = t.metadata && t.metadata.showInfoPoints && (t.isVisible || t.metadata.forceShowInfoPoints), a = t.material, o = a ? this.getMaterialPhotoUrls(a) : [];
      if (n && o.length > 0) {
        const h = this.getOrCreateMeshInfoPoint(t);
        this.updateInfoPointUrls(h, o);
      } else
        this.removeMeshInfoPoints(t);
    }
  }
  removeMeshInfoPoints(e) {
    this._meshesInfoPoints.hasOwnProperty(e.id) && (this._meshesInfoPoints[e.id].dispose(), delete this._meshesInfoPoints[e.id]);
  }
  getOrCreateMeshInfoPoint(e) {
    if (this._meshesInfoPoints.hasOwnProperty(e.id))
      return this._meshesInfoPoints[e.id];
    const t = this.createMeshInfoPoint(e);
    return this._meshesInfoPoints[e.id] = t, t;
  }
  updateInfoPointUrls(e, t) {
    e.metadata || (e.metadata = {}), e.metadata.urls = t;
  }
  createMeshInfoPoint(e) {
    var a, o, h, f;
    const t = new BABYLON.GUI.Ellipse("infoPoint");
    t.width = "29px", t.height = "29px", t.color = ((a = this._style.infoPointsStyle) == null ? void 0 : a.borderColor) || "#dddddd", t.thickness = 4, t.background = ((o = this._style.infoPointsStyle) == null ? void 0 : o.color) || "#a01c20", t.alpha = 1, t.onPointerEnterObservable.add((v) => {
      var x;
      t.background = ((x = this._style.infoPointsStyle) == null ? void 0 : x.highlightColor) || "#bb2025", this.fireRenderingNeededEvent();
    }), t.onPointerOutObservable.add((v) => {
      var x;
      t.background = ((x = this._style.infoPointsStyle) == null ? void 0 : x.color) || "#a01c20", this.fireRenderingNeededEvent();
    }), this._rootContainer.addControl(t);
    const n = new BABYLON.GUI.Ellipse("innerPoint");
    return n.width = 0.29, n.height = 0.29, n.color = ((h = this._style.infoPointsStyle) == null ? void 0 : h.innerPointColor) || "White", n.thickness = 0, n.background = ((f = this._style.infoPointsStyle) == null ? void 0 : f.innerPointColor) || "White", t.addControl(n), t.linkWithMesh(e), t.linkOffsetY = 0, t.shadowBlur = 6, t.shadowOffsetX = 2, t.shadowOffsetY = 2, t.isPointerBlocker = !0, t.hoverCursor = "pointer", t.onPointerClickObservable.add((v) => {
      if (t.metadata && t.metadata.urls) {
        const x = {
          meshID: e.id,
          materialID: e.material ? e.material.id : null,
          materialPhotoUrl: t.metadata.urls
        };
        this.fireInfoPointPickedEvent(x), this.showImages(t.metadata.urls);
      }
      this.fireRenderingNeededEvent();
    }), t;
  }
  getMaterialInfoPoint(e) {
    for (let t = 0; t < this._infoPoints.length; t++) {
      const n = this._infoPoints[t];
      if (n.metadata && n.metadata.materialID && n.metadata.materialID === e)
        return n;
    }
    return null;
  }
  getMaterialPhotoUrls(e) {
    return this._zkScene.get("materialPhotos").getMaterialPhotoUrls(e.id);
  }
  getOrCreateImagePanel() {
    return this._imagePanel || this.createImagePanel(), this._imagePanel;
  }
  createImagePanel() {
    var t;
    const e = new BABYLON.GUI.Rectangle("imagePanel");
    return e.background = ((t = this._style.imagePanelStyle) == null ? void 0 : t.backgroundColor) || this._scene.clearColor.toHexString(), e.width = 1, e.height = 1, e.zIndex = 1e4, e.isVisible = !1, this._imagePanel = e, this._rootContainer.addControl(e), this.addCloseButton(e), this.addMoveNextImageButton(e), this.addMovePrevImageButton(e), e;
  }
  addCloseButton(e) {
    var o, h, f;
    const t = new BABYLON.GUI.StackPanel("closePanel");
    t.height = "48px", t.width = "48px", t.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT, t.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_TOP, t.isVertical = !1, t.zIndex = 10003, e.addControl(t);
    const n = new BABYLON.GUI.Rectangle("closeRect");
    n.width = "24px", n.height = "24px", n.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, n.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT, n.background = ((o = this._style.imagePanelStyle) == null ? void 0 : o.buttonsColor) || "#a01c20", n.color = ((h = this._style.imagePanelStyle) == null ? void 0 : h.buttonsBorderColor) || "#a01c20", n.isPointerBlocker = !0, n.hoverCursor = "pointer", n.onPointerEnterObservable.add((v) => {
      var x, k;
      n.background = ((x = this._style.imagePanelStyle) == null ? void 0 : x.buttonsHighlightColor) || "#bb2025", n.color = ((k = this._style.imagePanelStyle) == null ? void 0 : k.buttonsBorderHighlightColor) || "#bb2025", this.fireRenderingNeededEvent();
    }), n.onPointerOutObservable.add((v) => {
      var x, k;
      n.background = ((x = this._style.imagePanelStyle) == null ? void 0 : x.buttonsColor) || "#a01c20", n.color = ((k = this._style.imagePanelStyle) == null ? void 0 : k.buttonsBorderColor) || "#a01c20", this.fireRenderingNeededEvent();
    }), n.onPointerClickObservable.add((v) => {
      this.hideImages(), this.fireRenderingNeededEvent();
    }), t.addControl(n);
    const a = new BABYLON.GUI.Image("close", this.getCloseSvg(((f = this._style.imagePanelStyle) == null ? void 0 : f.buttonsIconColor) || "white"));
    a.width = 1, a.height = 1, a.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, n.addControl(a), this._closeImageButton = t;
  }
  addMoveNextImageButton(e) {
    var o, h, f;
    const t = new BABYLON.GUI.StackPanel("rightPanel");
    t.width = "48px", t.height = "48px", t.paddingRight = "24px", t.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT, t.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, t.isVertical = !1, t.zIndex = 10003, t.alpha = 0.3, t.isVisible = !1, e.addControl(t);
    const n = new BABYLON.GUI.Rectangle("rightRect");
    n.width = "24px", n.height = "48px", n.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, n.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT, n.background = ((o = this._style.imagePanelStyle) == null ? void 0 : o.buttonsColor) || "#a01c20", n.color = ((h = this._style.imagePanelStyle) == null ? void 0 : h.buttonsBorderColor) || "#a01c20", n.isPointerBlocker = !0, n.hoverCursor = "pointer", n.onPointerEnterObservable.add((v) => {
      var x, k;
      this._isOnMoveNextButton = !0, n.background = ((x = this._style.imagePanelStyle) == null ? void 0 : x.buttonsHighlightColor) || "#bb2025", n.color = ((k = this._style.imagePanelStyle) == null ? void 0 : k.buttonsBorderHighlightColor) || "#bb2025", this.updateMoveNextImageButton(), this.fireRenderingNeededEvent();
    }), n.onPointerOutObservable.add((v) => {
      var x, k;
      this._isOnMoveNextButton = !1, n.background = ((x = this._style.imagePanelStyle) == null ? void 0 : x.buttonsColor) || "#a01c20", n.color = ((k = this._style.imagePanelStyle) == null ? void 0 : k.buttonsBorderColor) || "#a01c20", this.updateMoveNextImageButton(), this.fireRenderingNeededEvent();
    }), n.onPointerClickObservable.add((v) => {
      this.moveNextImage(), this.fireRenderingNeededEvent();
    }), t.addControl(n);
    const a = new BABYLON.GUI.Image("move-next", this.getChevronRightSvg(((f = this._style.imagePanelStyle) == null ? void 0 : f.buttonsIconColor) || "white"));
    a.width = 1, a.height = 1, a.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, a.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, n.addControl(a), this._moveNextImageButton = t;
  }
  addMovePrevImageButton(e) {
    var o, h, f;
    const t = new BABYLON.GUI.StackPanel("leftPanel");
    t.width = "48px", t.height = "48px", t.paddingLeft = "24px", t.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT, t.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, t.isVertical = !1, t.alpha = 0.3, t.zIndex = 10003, t.isVisible = !1, e.addControl(t);
    const n = new BABYLON.GUI.Rectangle("leftRect");
    n.width = "24px", n.height = "48px", n.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, n.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT, n.background = ((o = this._style.imagePanelStyle) == null ? void 0 : o.buttonsColor) || "#a01c20", n.color = ((h = this._style.imagePanelStyle) == null ? void 0 : h.buttonsBorderColor) || "#a01c20", n.isPointerBlocker = !0, n.hoverCursor = "pointer", n.onPointerEnterObservable.add((v) => {
      var x, k;
      this._isOnMovePrevButton = !0, n.background = ((x = this._style.imagePanelStyle) == null ? void 0 : x.buttonsHighlightColor) || "#bb2025", n.color = ((k = this._style.imagePanelStyle) == null ? void 0 : k.buttonsBorderHighlightColor) || "#bb2025", this.updateMovePrevImageButton(), this.fireRenderingNeededEvent();
    }), n.onPointerOutObservable.add((v) => {
      var x, k;
      this._isOnMovePrevButton = !1, n.background = ((x = this._style.imagePanelStyle) == null ? void 0 : x.buttonsColor) || "#a01c20", n.color = ((k = this._style.imagePanelStyle) == null ? void 0 : k.buttonsBorderColor) || "#a01c20", this.updateMovePrevImageButton(), this.fireRenderingNeededEvent();
    }), n.onPointerClickObservable.add((v) => {
      this.movePrevImage(), this.fireRenderingNeededEvent();
    }), t.addControl(n);
    const a = new BABYLON.GUI.Image("move-prev", this.getChevronLeftSvg(((f = this._style.imagePanelStyle) == null ? void 0 : f.buttonsIconColor) || "white"));
    a.width = 1, a.height = 1, a.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, a.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER, n.addControl(a), this._movePrevImageButton = t;
  }
  updateMoveNextImageButton() {
    this._moveNextImageButton && (this._imageUrls.length <= 1 ? this._moveNextImageButton.isVisible = !1 : (this._moveNextImageButton.isVisible = !0, this._moveNextImageButton.alpha = this.canMoveNextImage() ? this._isOnMoveNextButton ? 1 : 0.3 : 0.1));
  }
  updateMovePrevImageButton() {
    this._movePrevImageButton && (this._imageUrls.length <= 1 ? this._movePrevImageButton.isVisible = !1 : (this._movePrevImageButton.isVisible = !0, this._movePrevImageButton.alpha = this.canMovePrevImage() ? this._isOnMovePrevButton ? 1 : 0.3 : 0.1));
  }
  showImages(e) {
    this._canShowInfoPointsContent && (this._currentIdx = 0, this._imageUrls = e, this._isOnMoveNextButton = !1, this._isOnMovePrevButton = !1, this.getOrCreateImagePanel(), this._imagePanel && (this.onBeforeShowImages && this.onBeforeShowImages(), this.updateMoveNextImageButton(), this.updateMovePrevImageButton(), this._imagePanel.isVisible = !0, this.showCurrentImage(), this.fireInfoPointContentShownEvent()), this.fireRenderingNeededEvent());
  }
  moveNextImage() {
    this.canMoveNextImage() && (this._currentIdx++, this.showCurrentImage(), this.updateMoveNextImageButton(), this.updateMovePrevImageButton(), this.fireRenderingNeededEvent());
  }
  movePrevImage() {
    this.canMovePrevImage() && (this._currentIdx--, this.showCurrentImage(), this.updateMoveNextImageButton(), this.updateMovePrevImageButton(), this.fireRenderingNeededEvent());
  }
  showCurrentImage() {
    this._currentIdx >= 0 && this._currentIdx < this._imageUrls.length && this.showImage(this._imageUrls[this._currentIdx]);
  }
  canMoveNextImage() {
    return this._imageUrls.length > 0 && this._currentIdx < this._imageUrls.length - 1;
  }
  canMovePrevImage() {
    return this._imageUrls.length > 0 && this._currentIdx > 0;
  }
  hideImages() {
    this._imagePanel && (this._imagePanel.isVisible = !1, this.onAfterShowImages && this.onAfterShowImages(), this.fireInfoPointContentHiddenEvent(), this.fireRenderingNeededEvent());
  }
  showImage(e) {
    if (this._imagePanel) {
      this._image && (this._imagePanel.removeControl(this._image), this._image.isVisible = !1, this._image.dispose(), this._image = null), this.showLoadingText();
      const t = new BABYLON.GUI.Image("but", e);
      t.width = 1, t.height = 1, t.isVisible = !0, t.zIndex = 10002, t.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, t.onImageLoadedObservable.add((n) => {
        this.hideLoadingText();
      }), this._imagePanel.addControl(t), this._image = t, this.fireRenderingNeededEvent();
    }
  }
  /**
   * Update info points visibility and return true if at least one info point has been updated.
   * 
   * @return {boolean} Return true if any info point has been updated.
   */
  updateInfoPointsVisibility() {
    let e = !1;
    if (this._scene.activeCamera && (!this._lastCameraPosition || !this._lastCameraPosition.equals(this._scene.activeCamera.position))) {
      this._lastCameraPosition = this._scene.activeCamera.position.clone();
      for (const t in this._meshesInfoPoints) {
        const n = this._scene.getMeshByID(t);
        n && (this.updateMeshInfoPointVisibility(n, this._meshesInfoPoints[t]), e = !0);
      }
    }
    return e;
  }
  drawRay(e, t) {
    let n = t.subtract(e);
    n = n.normalize();
    const a = t.subtract(e).length() * 2, o = new BABYLON.Ray(e, n, a);
    BABYLON.RayHelper.CreateAndShow(o, this._scene, new BABYLON.Color3(1, 1, 0.1));
  }
  updateMeshInfoPointVisibility(e, t) {
    if (this._scene.activeCamera) {
      const n = this._sceneHelper.getMeshHierarchyCenter(e), a = this._scene.activeCamera.position;
      let o = n.subtract(a);
      o = o.normalize();
      const h = n.subtract(a).length() * 2, f = new BABYLON.Ray(a, o, h), v = this._scene.pickWithRay(f);
      v && v.pickedMesh && (t.alpha = v.pickedMesh === e ? 1 : 0.2);
    }
  }
  getCloseSvg(e) {
    return this.getSvg(this.CLOSE_SVG, e);
  }
  getChevronLeftSvg(e) {
    return this.getSvg(this.CHEVRON_LEFT_SVG, e);
  }
  getChevronRightSvg(e) {
    return this.getSvg(this.CHEVRON_RIGHT_SVG, e);
  }
  getSvg(e, t) {
    return e.replace("§color§", encodeURIComponent(t));
  }
  // -------------------------------------------------------------
  // Events 
  // -------------------------------------------------------------
  // picked
  fireInfoPointPickedEvent(e) {
    for (let t = 0; t < this._infoPointPickedListeners.length; t++)
      this._infoPointPickedListeners[t](e);
  }
  addInfoPointPickedListener(e) {
    this._infoPointPickedListeners.push(e);
  }
  addInfoPointPickedListenerRange(e) {
    this._infoPointPickedListeners.push(...e);
  }
  // Content shown
  fireInfoPointContentShownEvent() {
    for (let e = 0; e < this._infoPointContentShownListeners.length; e++)
      this._infoPointContentShownListeners[e]();
  }
  addInfoPointContentShownListener(e) {
    this._infoPointContentShownListeners.push(e);
  }
  addInfoPointContentShownListenerRange(e) {
    this._infoPointContentShownListeners.push(...e);
  }
  // content hidden
  fireInfoPointContentHiddenEvent() {
    for (let e = 0; e < this._infoPointContentHiddenListeners.length; e++)
      this._infoPointContentHiddenListeners[e]();
  }
  addInfoPointContentHiddenListener(e) {
    this._infoPointContentHiddenListeners.push(e);
  }
  addInfoPointContentHiddenListenerRange(e) {
    this._infoPointContentHiddenListeners.push(...e);
  }
  // Rendering Needed
  fireRenderingNeededEvent() {
    for (let e = 0; e < this._renderingNeededListeners.length; ++e)
      this._renderingNeededListeners[e]();
  }
  addRenderingNeededListener(e) {
    this._renderingNeededListeners.push(e);
  }
  showLoadingText() {
    var e;
    if (this._loadingText) {
      this._loadingText.isVisible = !0;
      return;
    }
    this._imagePanel && (this._loadingText = new BABYLON.GUI.TextBlock("loading"), this._loadingText.text = "Loading...", this._loadingText.left = 0.5, this._loadingText.top = 0.7, this._loadingText.zIndex = 10001, this._loadingText.color = ((e = this._style.imagePanelStyle) == null ? void 0 : e.loadingTextColor) || "white", this._imagePanel.addControl(this._loadingText), this.fireRenderingNeededEvent());
  }
  hideLoadingText() {
    this._loadingText && (this._loadingText.isVisible = !1), this.fireRenderingNeededEvent();
  }
  updateGuiElementsStyle() {
    this.updateMeshInfoPointsStyle(), this.updateImagePanelStyle(), this.fireRenderingNeededEvent();
  }
  updateMeshInfoPointsStyle() {
    this.getAllInfoPoints().forEach((e) => {
      var n, a, o;
      e.color = ((n = this._style.infoPointsStyle) == null ? void 0 : n.borderColor) || "#dddddd", e.background = ((a = this._style.infoPointsStyle) == null ? void 0 : a.color) || "#a01c20";
      const t = e.getChildByName("innerPoint");
      t && t instanceof BABYLON.GUI.Container && (t.background = ((o = this._style.infoPointsStyle) == null ? void 0 : o.innerPointColor) || "White");
    });
  }
  updateImagePanelStyle() {
    var e, t, n, a, o, h, f, v;
    if (this._imagePanel) {
      this._imagePanel.background = ((e = this._style.imagePanelStyle) == null ? void 0 : e.backgroundColor) || this._scene.clearColor.toHexString();
      const x = this._imagePanel.getChildByName("closePanel");
      if (x && x instanceof BABYLON.GUI.Container) {
        const V = x.getChildByName("closeRect");
        V && V instanceof BABYLON.GUI.Container && (V.background = ((t = this._style.imagePanelStyle) == null ? void 0 : t.buttonsColor) || "#a01c20", V.color = ((n = this._style.imagePanelStyle) == null ? void 0 : n.buttonsBorderColor) || "#a01c20");
      }
      const k = this._imagePanel.getChildByName("rightPanel");
      if (k && k instanceof BABYLON.GUI.Container) {
        const V = k.getChildByName("rightRect");
        V && V instanceof BABYLON.GUI.Container && (V.background = ((a = this._style.imagePanelStyle) == null ? void 0 : a.buttonsColor) || "#a01c20", V.color = ((o = this._style.imagePanelStyle) == null ? void 0 : o.buttonsBorderColor) || "#a01c20");
      }
      const I = this._imagePanel.getChildByName("leftPanel");
      if (I && I instanceof BABYLON.GUI.Container) {
        const V = I.getChildByName("leftRect");
        V && V instanceof BABYLON.GUI.Container && (V.background = ((h = this._style.imagePanelStyle) == null ? void 0 : h.buttonsColor) || "#a01c20", V.color = ((f = this._style.imagePanelStyle) == null ? void 0 : f.buttonsBorderColor) || "#a01c20");
      }
      this._loadingText && (this._loadingText.color = ((v = this._style.imagePanelStyle) == null ? void 0 : v.loadingTextColor) || "white");
    }
  }
}
var ng = /* @__PURE__ */ ((b) => (b[b.NotSelected = 0] = "NotSelected", b[b.Eyewear = 1] = "Eyewear", b[b.Scarves = 2] = "Scarves", b[b.Earrings = 3] = "Earrings", b[b.Headwear = 4] = "Headwear", b[b.Necklace = 5] = "Necklace", b[b.Shoes = 6] = "Shoes", b[b.Watches = 7] = "Watches", b[b.Bracelet = 8] = "Bracelet", b))(ng || {}), rg = /* @__PURE__ */ ((b) => (b[b.NotSelected = 0] = "NotSelected", b[b.Mazing = 1] = "Mazing", b[b.Banuba = 2] = "Banuba", b[b.DeepAR = 3] = "DeepAR", b))(rg || {}), Os = /* @__PURE__ */ ((b) => (b.VirtualTryOn = "try_on", b.GlassPupillaryDistanceTool = "pd", b.StyleButton = "styleButton", b.MandatoryPupillaryDistance = "mandatoryPD", b))(Os || {}), ww = /* @__PURE__ */ ((b) => (b.Neutral = "neutral.hdr", b.Light = "light.hdr", b.Bright = "bright.hdr", b.Studio = "studio.hdr", b.Court = "court.hdr", b))(ww || {}), Sw = /* @__PURE__ */ ((b) => (b.ViewProduct = "VIEW_PRODUCT", b.ViewArProdutc = "VIEW_AR_PRODUCT", b))(Sw || {}), Mw = (
  /** @class */
  function() {
    function b(e) {
      var t = this;
      if (this._axisRoot = null, this._axes = [], this._sceneEditor = e, !e.engine)
        throw Error("LightsLayer requires a valid Babylon JS 3D Engine");
      var n = e.engine;
      if (!e.scene)
        throw Error("LightsLayer requires a valid Babylon JS 3D Scene");
      this._editorScene = e.scene, this._scene = new BABYLON.Scene(n), this._scene.autoClear = !1, this._scene.postProcessesEnabled = !1, this._sceneEditor.addPreUpdateListener(function() {
        return t.onPreUpdate();
      }), this._sceneEditor.addPostUpdateListener(function() {
        return t.onPostUpdate();
      }), this.createAxes();
    }
    return b.prototype.dispose = function() {
      this._scene && (this._scene.dispose(), delete this._scene);
    }, b.prototype.onPreUpdate = function() {
      if (this._scene) {
        var e = this._editorScene.activeCamera;
        if (e && (this._scene.activeCamera = e, this._axisRoot)) {
          var t = BABYLON.Vector3.Distance(e.position, this._axisRoot.position) * 0.03;
          this._axisRoot.scaling = new BABYLON.Vector3(t, t, t), this._axisRoot.computeWorldMatrix(!0);
        }
      }
    }, b.prototype.onPostUpdate = function() {
    }, b.prototype.createAxes = function() {
      var e = this, t = 10, n = this._scene, a = new BABYLON.Mesh("axisRoot", n);
      a.isVisible = this._sceneEditor.canShowAxes();
      var o = function(V, M, W) {
        var U = new BABYLON.DynamicTexture("DynamicTexture", 50, n, !0);
        U.hasAlpha = !0, U.drawText(V, 5, 40, "bold 36px Arial", M, "transparent", !0);
        var Q = BABYLON.MeshBuilder.CreatePlane("TextPlane", { size: W, updatable: !0 }, n), D = new BABYLON.StandardMaterial("TextPlaneMaterial", n);
        return D.metadata = { isRealMaterial: !1 }, D.backFaceCulling = !1, D.specularColor = new BABYLON.Color3(0, 0, 0), D.diffuseTexture = U, Q.material = D, Q.metadata = { isRealMesh: !1, isAxis: !0 }, Q.parent = a, Q.isVisible = e._sceneEditor.canShowAxes(), Q;
      }, h = BABYLON.Mesh.CreateLines("axisX", [
        BABYLON.Vector3.Zero(),
        new BABYLON.Vector3(t, 0, 0),
        new BABYLON.Vector3(t * 0.95, 0.05 * t, 0),
        new BABYLON.Vector3(t, 0, 0),
        new BABYLON.Vector3(t * 0.95, -0.05 * t, 0)
      ], n);
      h.metadata = { isRealMesh: !1, isAxis: !0 }, h.color = new BABYLON.Color3(1, 0, 0), h.parent = a, h.isVisible = this._sceneEditor.canShowAxes();
      var f = o("X", "red", t / 10);
      f.position = new BABYLON.Vector3(0.9 * t, -0.05 * t, 0);
      var v = BABYLON.Mesh.CreateLines("axisY", [
        BABYLON.Vector3.Zero(),
        new BABYLON.Vector3(0, t, 0),
        new BABYLON.Vector3(-0.05 * t, t * 0.95, 0),
        new BABYLON.Vector3(0, t, 0),
        new BABYLON.Vector3(0.05 * t, t * 0.95, 0)
      ], n);
      v.metadata = { isRealMesh: !1, isAxis: !0 }, v.color = new BABYLON.Color3(0, 1, 0), v.parent = a, v.isVisible = this._sceneEditor.canShowAxes();
      var x = o("Y", "green", t / 10);
      x.position = new BABYLON.Vector3(0, 0.9 * t, -0.05 * t);
      var k = BABYLON.Mesh.CreateLines("axisZ", [
        BABYLON.Vector3.Zero(),
        new BABYLON.Vector3(0, 0, t),
        new BABYLON.Vector3(0, -0.05 * t, t * 0.95),
        new BABYLON.Vector3(0, 0, t),
        new BABYLON.Vector3(0, 0.05 * t, t * 0.95)
      ], n);
      k.metadata = { isRealMesh: !1, isAxis: !0 }, k.color = new BABYLON.Color3(0, 0, 1), k.parent = a, k.isVisible = this._sceneEditor.canShowAxes();
      var I = o("Z", "blue", t / 10);
      I.position = new BABYLON.Vector3(0, 0.05 * t, 0.9 * t), this._axisRoot = a, this._axes.push(a, h, v, k, f, x, I);
    }, b.prototype.refresh = function() {
      for (var e = 0; e < this._axes.length; e++) {
        var t = this._axes[e];
        t.isVisible = this._sceneEditor.canShowAxes();
      }
    }, b.prototype.render = function() {
      this._scene && this._scene.activeCamera && this._scene.render();
    }, b.prototype.getScene = function() {
      return this._scene;
    }, b;
  }()
), Cw = (
  /** @class */
  function() {
    function b(e) {
      var t = this;
      if (this._lightMeshes = [], this._lightSelectedListeners = [], this._sceneEditor = e, !e.engine)
        throw Error("LightsLayer requires a valid Babylon JS 3D Engine");
      var n = e.engine;
      if (!e.scene)
        throw Error("LightsLayer requires a valid Babylon JS 3D Scene");
      this._editorScene = e.scene, this._scene = new BABYLON.Scene(n), this._scene.autoClear = !1, this._scene.postProcessesEnabled = !1, this._scene.onPointerDown = this.onPointerDown, this._sceneEditorPreUpdate = function() {
        return t.onPreUpdate();
      }, this._sceneEditorPostUpdate = function() {
        return t.onPostUpdate();
      }, this._sceneEditor.addPreUpdateListener(this._sceneEditorPreUpdate), this._sceneEditor.addPostUpdateListener(this._sceneEditorPostUpdate);
    }
    return b.prototype.dispose = function() {
      this._sceneEditor && (this._sceneEditor.removePreUpdateListener(this._sceneEditorPreUpdate), this._sceneEditor.removePostUpdateListener(this._sceneEditorPostUpdate)), this._scene && (this._scene.dispose(), delete this._scene);
    }, b.prototype.onPreUpdate = function() {
      this._scene.activeCamera = this._editorScene.activeCamera;
    }, b.prototype.onPostUpdate = function() {
      this._scene.getEngine();
      for (var e = 0; e < this._lightMeshes.length; e++) {
        var t = this._lightMeshes[e], n = this._editorScene.getLightByID(t.id);
        n && this.configureLightMesh(t, n);
      }
    }, b.prototype.onPointerDown = function(e, t, n) {
      if (t.hit && t.pickedMesh) {
        var a = { name: t.pickedMesh.name, id: t.pickedMesh.id };
        this.fireLightSelectedEvent(a);
      }
    }, b.prototype.refresh = function() {
      this.updateLightMeshes();
    }, b.prototype.updateLightMeshes = function() {
      if (this._scene && this._sceneEditor) {
        for (var e = 0; e < this._editorScene.lights.length; e++) {
          var t = this._editorScene.lights[e], n = this._scene.getMeshByID(t.id);
          n ? this.configureLightMesh(n, t) : this._lightMeshes.push(this.createLightMesh(t));
        }
        for (var e = 0; e < this._lightMeshes.length; e++) {
          var n = this._lightMeshes[e], t = this._editorScene.getLightByID(n.id);
          t || (n.dispose(), this._lightMeshes.splice(e--, 1));
        }
      }
    }, b.prototype.createLightMesh = function(e) {
      var t = new BABYLON.Texture(b._lightTexture, this._scene);
      t.hasAlpha = !0;
      var n = new BABYLON.StandardMaterial("LightMeshMaterial_" + e.id, this._scene);
      n.emissiveColor = BABYLON.Color3.White(), n.useAlphaFromDiffuseTexture = !0, n.disableDepthWrite = !1, n.diffuseTexture = t;
      var a = BABYLON.Mesh.CreatePlane(e.name, 1, this._scene);
      return a.id = e.id, a.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL, a.material = n, this.configureLightMesh(a, e), a;
    }, b.prototype.clearLightMeshes = function() {
      if (this._scene)
        for (; this._lightMeshes.length > 0; ) {
          var e = this._lightMeshes.pop();
          e && e.dispose();
        }
    }, b.prototype.configureLightMesh = function(e, t) {
      var n = this._editorScene.activeCamera;
      if (n && e && t) {
        e.position = t.getAbsolutePosition();
        var a = BABYLON.Vector3.Distance(n.position, e.position) * 0.03;
        e.scaling = new BABYLON.Vector3(a, a, a), e.computeWorldMatrix(!0), e.isVisible = this._sceneEditor.canShowLights();
      }
    }, b.prototype.render = function() {
      this._scene && this._scene.render();
    }, b.prototype.getScene = function() {
      return this._scene;
    }, b.prototype.fireLightSelectedEvent = function(e) {
      for (var t = 0; t < this._lightSelectedListeners.length; ++t)
        this._lightSelectedListeners[t](e);
    }, b.prototype.addLightSelectedListener = function(e) {
      this._lightSelectedListeners.push(e);
    }, b._lightTexture = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALkAAAC5CAMAAABDc25uAAAC/VBMVEUAAAD6ggT5kgH6igH3nA78nwD8ogD8pQD8owD8nQD8oQD9qgD8pgD8pAD8pQD8qwD8qQD8pwD8mAD8qQD8qwD8pwD9qgD8qAH8pgD8pwD8qAD8qAD8qAH8qQD8qQD8qQD8qAD8qgD5lED9qgL6lzb6lTn6mDL6nyP6nSj6ohvMyL/5my/8qQX6pBb8pg78pwn9lCVzc3OnoZabmJC1trXBs5e/v7r1sFuoq6mwvczp6uK1t7qZl5SxsKqqo5fltnWcmJDZwZfiq1qtn4Ocl4/NpVeprana4+y7wsMAAAC+rou3nnSIiIjPmTrWqFEgICAODg4LCwsAAAAAAAAAAAD+vQP+wwb+ugL+wAT+yQP+xwb/+uf+7Qb+6Qf/+N3+5An/9tP/9Ln/9c3/7rL+6Gr/6IH+71z/85IBAQH+3lT+zgf+8gX+xAH/rAH/5Ij//O/f3dr/9LH/6Hn+4nX+72r/32X/7pn+7mL+6VL+2Qj+9ID+9mz+9mL+42z+3gn/8sb/9KD/3kz/9MD/76j/53L+6Frv7urm5eLa2db+twL///7//fb/99j/9Jn/9sb+71f/65L+91j+4EPj4d7+6WL++E793Tvr6ub/5Hz+3VvLzMz+2kT/9Kv/66f/9Ib+0ir+0wf/5GL+1jP/64v+5Ur+60XV1dPAwcH/77v+41v++kL+ziD/5FH+3jH/84z++Df/6Jj/7p/+8E/+8Dv6mzf9tg3z8u7Fx8f/7oLQ0dD/8sr/5ZH7pSf+5zr/9Kf+80X+5xb9sBT5lj3/34H+9Xj+7DD+xyv++Bj+9Q/+yA/+8yL++yL+9HL+1lL+5i/7oC/8qh/+vxL+73r+3ST+8RfZ1c3+7nP+/jP+zRT/6KD+4yS7vLz+4BfT0Mn+1j3+6SP/z3D/uSf/3W//12D+yzX+8Az/8MHHw7quqqHPzMTDvbP+xCD/1xj/zGK2sab+zj/Qxa7+0kn9sxmwsK7/1Hn/yFK9t6f49/W9ua/f0rTs38H06M0gIB9jYl8/Pj1icJHzAAAAVXRSTlMAAgUDCAsPFxIJDU8fFBpWSiMGRVkpUywdJS81Mjs+QThd/mPk8Natupv+yGyNf3T7/v77/v7dw3v86LEe1TXBzMKvnFNJZPxH0bXFUh5uakItgH0Y/skKLQAAHplJREFUeNrEl81OGlEYhtvSWhXtVEqnaqv8yG/48WromJAQhH1J0wvAwIpCegWyZ2kT2CAxYUjcNQNLtkrcuGhMegF9v+8cOUhrVX7sewZSKdBnnr7nm/HJdHlKsdmeIY7nyNILZJmzgGOBDsoLyhK9w+F49sxms+FjT3D8nzxV2A4JvUy0C4uU1WH4R7zMZ7BE+IAHPX36v8Df4F4CN1Mz8svxrCKMz/qv2f8LueJ2OGBbyJbQr5B1ZGX4RK+8RJhempfiHx1eccM3WNg1QRPsyhqysbYhskZZWVmhEyD7VJwXzM7o4H4kdCWcayJaIrAZGqxvkXcjwY94lfAVPEpD3h9XO2OzcKo3t4RtQzWowby5+QF5L0N/3txkftCTeqo92Nk71R3e586uwKVw6CZuxgY1oEHsdru3tra2ZbYQtxtnwPiAZ/PMvgx20v4o6PQ/ywPl+fMX5Ht1FbqpJOT6A6CB7HK9QV6LvKG4XDgD4IMe8FQbyc6VeZwxIxuOwSb6zTUBN2MTtIuQ7YguY0fwEuNvAR7sKD2XZpH36qO0HV/OO5OEM/dNbBINZE1zjkXTcAJMz/BCPLOTdmK3zVc7g9toZ0I4F2XITdhMzaBg93h2RDxOTacXJD3BMzvQadCQdm7MPMvOTeFLjxJO3Kwb2MB1AnFnNx4OhiKBQMDn8+E5EgzH4lGPRmcFepiHePautPOQsSnp86k4wDEJZVHgW3Dr7HonHg5FfF6zXq9bVotiWfW6afp9kWAs6iT5il1Whqb7Et2JzavrYhjytR7CZVGIGzURuqOxYADQVqvbbhhG4jqG0Wh3W1bd64+E4x4dJ2gHPHdGaYd1UfZ5gcO4bIoQ7mbfVANPPOgzTavbNgT03t7HHvJxb28vYRB+qd2qm4CPUu1ReNe2+z3XfdgYh+j63Iwvi6ZAOAouuD3aTjjiNa12gxD3Lq/OPlXzmUoKqaSbtaPO+aDH+I2uZfpDcU2Hd+xVVEa2XaKLG/e5GFfg7zYxUIRvcAe89S41ZG9w1s/nvv6ZVPb4xyVOy2i3ID7uFOysfYO1MzpfTmdODnDem9wUbjiE6+zb57XaRsLYuzpulr/enmT2yynUN7p1bySOSaPbof09tAv0BaDPfJtChDQ+BEfDIRz9jgXADd2DTob5yreF/jJXPe8ZiVK37g9FdU1oZ/R1KrssDDzNwfjiEFwIj4a8ddqUP/vlMejb6Ctnl2Bvmb4w6q4z+qbcp8r6LMEdI+CbsilOZ9hvtog7S7Jz9wngkx2wNyxvZNeuicYAXXWdJ8wMr0A8DleH4GgKGg7hDaN0Ct/AvnfIOzZr1/TH0BiFLiaMGOuznIc8VRQ4mhIPeLuG0eskv5aTDwrY81esPYQrk/01o2+g64uLy7iJEfcBM+zKTXCnHvObbaM0uAD3g4OT7fQMo+WN7Nhpn45Yn13V5e4cN+4MU1MSX3LlZIoXjvuE34iV+9oclBJt07drZ+sSfYa7dNiVxdVX68q4M+i1SkavCu5JU06eM3oc1iX6OqPTjSPIp+8K/6pMuxPg76RxT8jbSpRO8+VU5QGsFSyVSrLcwd1Y3R8X1mmu01jHb6cObvrMuoJLPua4640w3kLF07nKVEnljhICHROG0DcIfdiX6bsidydushhc8wAcxq8qyfSUqeT6vaH1bTfQqeo81aeVDnJZ8pei5AB3amEC/5lOZTKZtFr3TObGSrJ1X5Ssb4tdugp0JX1q5eiKKLnu0WNeC1Vpppogb8r1wPCHmvScPMZgNwM7ui5n4zqPxmk3KStfWlpGV7jktDu1uN8yjMtaqjkeZvo2tnCMM48mn0l+oQkTcWo6dums+oKPCuWiK+5t2p3RAM3xfio/mm9i3R3x5tE0Kz9Kia43yH1xi74sqL5MBy6Ui5I7I952ovQrlb/g5MdyK3IBK18AteKWX5FunpYSLW/suuor6/J6RNKnajlGOa5B3BWddmcXY6WZvximcFF4ePCpYdJ93H/VfVR1F+bLmujLNE1XynmuUFe0XSp5L5upjaZQK+wX9kdS4KfxxS/X9gv0fv7UddJnVPWQxtLlJlVNn7gsdNlfgfItviOPmI1E6axZU9mnhYMfBSb+d/ittIa5uEBfutQXzBdsUjkZ+Uo6+WBRymmuxKgrg1otO8y+OD5nmeozP/6Z7Ge8/3P2RpqfDNkX2qRK+hTk3HJsT1au0VzBP9HJZ1UAgQMLx90R75NrJLWf6AvNFxrqLH1BNn3yy6dULrZnkObKAMarWNkiDkYX4IeK71Ae4wuHZMchv4C/6+LYMBIt/y5tUiWdB+Pk+1Mqd5FynwXlZ7WqSLFavM4hjsPDIta/U6TFTxx8BQcaBiVcSkO6br9u+sR1ATnfsUjl3PKgCeWncPQn+gk/Dk8OT07w+PtiYnpGFLhI7UxIt0vpGIyT7lF1+aTBopSXzrPVPtYo/feT4kHx5ODkPjkoYuEjI9h9Oo4uhXQxXtZGpE+zP+UsD6PlRuJTti/yvf9d5UCsuyLfp4JvEclelUh6VOeZzoNxsj0KcBuXRe3PnYBloCz9/hHC6EP2A4mO4w5wxa3A+QurHVhpm0GuywexR1GXCcnlvRaNRJrlZhdX6R/VI5XfrJlLaxNRFMdBceEDgi5cKPjAN74+zaQx6xgJhFmYJyZZCM1SkoCBBEGJj4VWpAwKwgguUgQhg9pF0Y2LqTsX0m/g//zvnNxpNbaT+js3behkbn4M555zZ1qtYpB7EttTNWFYllC++Xhst/Dp/Bldo/NWFyYLLrkkC7sQbj1fv8FlCb/5qi3RVfEduFcjd6UL765V/7EgF/2qXHRNl/nM98BcNuaHcQ8n6/P6uXcOtizusk+6llsSSajKGVN8w7cAT9jfvOYaZbqwusxlzs5vk+USSqKz8MGPEVPfqT0/+MqK+xJkOXTAu7OyRlldcC/NXXrybDmibQiVBXstJAvMf/m+KzyxvJLxasfgs12eEuE+ccly6QvMTbqcOG6bUVJz1sQozSVZUtfPIlmchQ2KG3nXyqv7Q4Afs6A32OJN/PFPR9LlQtSMuEtPXNG5QHXPopVFirkT+O4YX3NTArxVHkpgbAc+ZsEEnMd1OekHXBlUl9NMFyb6HBVdd1s2zS8gWUDgjsHNsWhTXeVhdOftne14+xBj6o1hGIwFmDvOZ+wA0Iw00fcnNWcfOqBpLs/jLn+SeTPr7nhguDmw6rBehde23nwhhMibc2FOMXeY6Jc2JfqR5Oa6TzQN9ArSnObj0iDiNljFiLOyuqLcaTD4nqxixMHJZEBKAzFnXWSim4q+bx+LS6IbOW5acM/P1p/CQ5bPGTEPxiXD7dJtIgLWOsYE2owVYv1V24CJImCecaSNplK6X9QlmticfeiYPKw4imou4mIelgyLYG1xLWKCMcGY0misMCYx8Kk4i6REMCvMWdG5ROftReygtrRwgdJ8oxSGYavVovcWd1UmEwR/6ytmr9pq3mph0lL4M5OJlih7Ec0TF/So92tpYR+i+S+YizrJkbUymJRJo9yYDY5OWSzn1nKgRahegTmX6LXI/NA811zL+aHD0kGj0gLxzA98A1BvUM6V1Rqh6s1NIfCYlcd5NKd7BYTDjzSPdVH5PyP6f1Jzs2th75e9+TuH5kuViNEop+pKs9ysNf8FDtesuGE0qhjCII35pbhcOngwbo5rnmSB0lzL+dGUFEWaf1yvVIYiTu4Ltfu1CJhhzNZmKDyXs9B9PfxVhDr7/1Et6MZ87y7MsWv5TPFiOqgMhecxc0O+mc/j1Wzme02EDNJk4IAcr+G1Rfz56DlnrCyp+UWaHzOtKKk5V2h0D3rSmqfTxceRudAm+XZe6eV7s+n0cDiv4DRBphkaPsKcBf1iCuan1Jw3F0nMj1hz3FZY86XhsCBY804n3yE9E0pffyk4SHhCeypeIMONbDGdnpqf3I35AWuOR7hiDvViNoC58BLU2+16vd7pYBDP6/X7Xv9P8Eev53lex+sQOQUnyxwFw/ojiP8f8xnZUnw8NOJG3eApfRn9v8OjpO7VCSaI1INC8HX35naF0lxXaIbm2eJScNdgzaFC4tYvJDDkHb3pTuiu5tFkhe/Z7CZzXaG7ry1qnr3xvfCAX/Y04hnwnnnee8tvUu2mxWkgjAO4eBIFPfh+0/Ud8eNYbWjYszX5AL0UPHrtIZceUgJeHIKg9maxFdJXqEoKhlC2BOxpc8on8P88M9OJrXqI/13o7uxs/Tk7mcxL3u7l81vzs/dUGb+if53fq/tC1KX8uR5brleQI5DTufPFG2Y838nFq2632+m86ii3zh77L3bUQ13A3yh4p4O3e3XSrFuWkj8wdyIpr3T3JznminQP1fJ6wHKOkX+mDwoh/0lnudR3KEwXdZZjEND30Op3f8y4eIOL5Zi3AK7kotv1vA7lzWDAhA9vPuzyTuWHiv7+w7tdFenuDKTb63rdoGnkX55gxgW5fAagmtzMcq88+PhsJ28GkCMDb9AZyJTd2v7W0DVeZfBhoONxqMm13MwVzSy3+tL/Es3Pd/J6cuJpOocof2zwsj2CXLk1vENvQQmaps31/FxvilZazZ3TqzleE5k2bwovpHihIkSRYkfjcfjuBz6Cccjo5c+fIeg/luNsvJQNH1EGMvwmXpCU5LQmqryaQ2gFfd6soGkd6hh502f6MlxSmBL6fhSRL/PhzeTrws/G/EWUjcNxFr1b+iG7URUJZby8WZJ/fXxJys2eaIX9Fj2gY4KOYbEk7wXh7/Qw44yjH3E2hjda8GuWLhayYA59NkYVP6IsWc72IG6W5M8wKJamimjzqjtFJKdLlAeX2mxGciQPJV0GEpiEiOfz+SI+zfwFkp6eio38IhPzxXye+gK14h2c3XEY95R8BrnDSyIaWiDnHfTqu3NmCV0j+UzKe3kYx2mcpikEm80mEkWWQkd0fO4FBfyTTVacbmSWKSUmOMsBZ/nBAvpsFTlvW6hLFPuKDuRJYkl5L4+RlEKQeVwUAri/2FU5V2K4ciMtlmPASmbcze/fvnCh2o6o6S7yEr2K2aK6/7M8kXJD37A8LdCc8xUBJ/NJOfytpIuiiCHnKHrek/KE5bWn6OZmpkhyjHPVdv71gy2XHn58iilRIkSi5K1cydPNEJLvo2K9ktFkY5flw++j/nC1QfWUolocckQIgd7iFEfqDnpzt/Nf/RyXOzpG9KPCITnoSt7K15QhZ5WMRvlK03/HTycTLl2PRjP4ZdaUVovoBFfyT3fvmB2uqmcWfC8q7Yne+8RyprMckfI1yfO+CxZlqjNRr6vpiuX4zyUr4wZcywUFcO4sZjTnbl5BXj5u4W2up05tJhA/0fI202X6bn843SKr7XQ/2+kWn9/d/lrLyU7uFsN9ag8HnQWTFj0moptXPVU03eXWZRpdjr45NUv4CNPxr4LeJvnxcGjbNddtAchh7kv+RFTZ8Wv32XBrD6n+8XrdbnOTIz4Ha38aWdSYWP0kF3QzdeHVBc6gsQyFnOm60dvtY4697bluc9tosPIlZfpSh4oaU1SwtrYt67cRlmu4sGpO/+iR7iz6rOU/n1gw16gz8ylBkGu5pjfarvvUblBeHoaKHfxRtNzA8yCQcsdxcO5PTa47S8UnFkA3z0Kpc4uvjmNJ+CHdtp+5r9tMPHRTsf3afX3cKLW5hiN+gM5i9b88MOe46vD8DMmrjS7mGr324KioOyKQ8WKmG3nDct0eEQ/tXIS/yfPGfmeJvYDz07cci59vUY9aoLNUfmSR5DRf5GuUj1y40WeBpod73QX9uAbigV0VNF23bjoLy/PQU/IT4dT58RZ9fVbsLGZ04WtUP+FCPb1u+SfEDjwkL9PtNrqD3bAN3rApv2g5l9AmoigMC4KCohEMKoqP+KiV+gJRcCGC7hTctWbiG42QMAlojI+FSn0sCoLBhSSoBBMFJQoqEcQqiEGhi9FGRaJIjCa4qSFU0r3/OXOvdzKzm4x/s5CZjP3m9NxzX+fcfrj5XqvJYXAoR+zVHJwFXm7J45qmIov7REuUV3BWEZbRi0GtUGVdh659BLpy9KDZBE3svTZRTDxgBf/2ELM5qErK6hp5uV+1z26y/sQIQAbG2Wa+ohYS4BAm7h+V0fcKf7BYnT4sDpohi8nBTeCSvKJr3afOOY3+Ly034O9dWsaqBX4V1kgADl3/JtH3naG4yLLZm67oaL+CnLnviKUW/s+yIa0s0qFVSHRdzIWneARg9XT/OjTSEWCzxGLRO2IncjjE0Dlgkmzc5CyxcwL82zssbslFIlZBD3lncpBbUhal0X3USLOGIGeB4uVX09NNuzoFdPp7MPirry/vkCzgRi6kPWWTs5erwZb7BHTaRBc5UWaRhT+wrOd1MHqD0dW66OnTd9+9AjkcXbfQWsi5DewD9ru7p09bl0KZHMuh75dbA4u9fbr3dJluCU9fu+IFjD4odUewA/7l92/kLgTqVH9s6Nubl8AW4IP4CBnVkPYHIxaO5Sopd7LsP7tKhxYprqIk5w+MLhfRBx+odfSrT1qY2396dcCO/erT1x8/WtjZsK74C+xBw6hoA8W+AO0O2UzeDbkzeT5AQb2QMSJq00WhRyYmIk+eYIn0jRIWQJ88wQ2DuBlcoEdYRianaS+WohpKVojMMMv+CLz74hZpdI6MFNSrmYhQB/kDANIOVqdwxcArETlLcfM+ywiaZ+8cvyPhX4F3mT4vuiMumntaiYgtuojYX2RdvTwxMXH5qkPi+mUhfgSPkjKZrDaA5smpIVYv75pcJC5O4UpFMzIGaOSVTWZIhA5wqaOwbYZ3Ozt1H38LXBXgkp03cKuaxoUKIh+XRyyiF/KAXIwBRCNdFqCgfkNt6ZIEeYYQncrQCymTk/AkgWdGtDLqoPwyHXemJxV/Ct1abkGNtO91fzSTFOQdOQDNiSbtp3M2AH/4X/WJifu0Ya52zCECT3IoXwcvt3ZCakbhSdGfKnEJBCioFzh34XZSgAOdVG82b4O1Q3ifZh1vINAZHs9RtklOo1DuAzhFROu43ANye40L+wtNj3Kcl0IMkAA/VQfkCTY3JIx/IomLpxQ3g5N+3giRrwT8ombOi0JF5xTD1kh7irp2I5Fknb19RIohT9iF10meOKJ0+2yS3joRGdEwuF0rTS7rzmRg8c5fVPlcIEBBHegyL4p+TIHyyBFw1Vl4rSMn+JrUWalkAukV0T9LV/r+Nc+pshhnklfkHBk7ShaXoZGWtVAk/Q9Ekv1ssmpCTYg8SHLjI+ATyYqObr9nWcA3fbFsnmzy7rpPZ+mCtSf1mY1UCxlp0+yXpD7/bNbaJSQIiyxtpNy28QI/P19S4ifSAA9RKPcFposBi3e+4hwzqp6UGulTLNgDnVIX8RGqtVMnbUq1m4qcvotHwsmKRs2z1x+wVstxOqtn4Gqtjla8ZCNdhulRSNO1ahrsELEfx0+tVhpOdXAPl2q145+PQ0xNSofh4yEO5X4xYFHN02ty1Uil0XkNI6TlEmFmPy70E87RbpdKcVKp1G7DV+i6SmfFAzc0PMqhnHc/RQWRKn7y9ugZVVdsGh3D3QH8fr2SjHOGcVpk6qbbrJpUO/1BYuNLUDyRZXBunmzyubQtxL7ipclVfJGNVA1fRgEQQmBP58NpU4TXvnXw4PnDj4bD4RLUblO+9/EwQTN3PFIhcG6efjK5i/mEq0aqjL66j40OhkImng9Lpdv39uy5cuHiyTxKEYAOcqV8/iwZHNLKxT5ERDlgmWrrPb11dR7uKqNzd6SH2OzZZDyVl+SH9+w5eIjIGb1dktjx4eFENcrgAzpNhGwm9/4wMefwRXl6aIANiISdZPxRCqjhMNn8IGyeAjnF8zjXU8TzqXziBrgZfIAHLMrkM6zHE3juLtyT2j0dEJK9EEkAPhUvCW9JpZi8hCKYVOrRcBrTH5ObntExYPHLTgi+otLkPJfN6IvY0zGb1gldsEezg2fzw8O/iPzYY6CbRU6wfiKTq2hW8HKxN8CdkIspnOvuqHN2BHKFDhWyjS/79x+8cPMxivqo96/VB3OFqMRmbpCPwssx1FJjRFfr/O7DC6akA6YUejBWO//8cPj2g2vXqrnCWDmma0KSG+DBYg95OZt8novlOHfoVqOvfP1UDyp2wEd1kJ+/dekatsajmh4cig1EBbYEDwax87nG51de7oiInvuLzeg8ZESyUQc7yJ+fv3h88OHv3xWkfuyOBUGtuAEOobTPL0zu3IfzXvaOlEa7fcV+gEh2Xde1oJNch4AtuCFsUPjEUMvFDr/78KJGL1wdHZTs4Bsp5Bp28pZRbRRGiN7kxvfRPkWxtprve2tyZ22XbfRC1V1cI0UaeTtu1BOGnZxKeerGeGMkaHKLqiG7yV2Qu47pvHfUWxRnhpYbRp3Uctg8Y/Ado1Xuh1SNGQcWN17uftdLefqc6VTeRezlccMYhwwHeQPXIbo/Rtxc7zyLTN7N1orLmnS1+DKL6gHo2NPGeIs17vDzt7gj7rXKu0mjK1bPtkwoxDmc/1edK14YA8zy97xgmretBqv11kGOO1Im+Yse32wearkYl3fv6eQvdETk4t7i0G789I+9NTUWa1+5cujZg4cfgU7kY423UgAfGkLlbd/sRewr0stdBBZX7sJGl/6ycM3rF4ABfHmMVY41v3yJ16vZCpkcfSiuizvAHsI3R5euWiKPPIPJXZC7HwLIFa/5dNbvthXvR58ye3+ZFLOpLMTmxpG/619vnLUAccUcak1z0Qu5Dy/WM/QWLdi+s7eI04mBReoHYKf4jGKIsUfXr+/ZuGXhAnVUm6uQ6H5yJPyF0Ofu2rBzzcrl64t0IPQQsTtF0HQ89Pr1y/u2btq8Y744sNX9cpz7yRHvNfIJtH+rO5sdpaEwDJ8oOmriwoWJf0sZFTczbakg/8OA//9eBEuuAhpddkHSC2ivQBoSL8INq6ZraBcNCUnBwZn4ntOWgoJjYlLPvKvZzdOP93u/0y7Od+t2VRRfHDy4t5ve28MN3HgAqi+h6N/fvn0F9F5692GlJufz+efXcHEoAw9KnhA50CO/MPRb1+qiIIxLzw8ODu7dv797N53eW1c6fXf34cNHFYZtWFK+foPdeBp5JRGzxN9eLi8vLN5pUPLxVJJkuVarVPAEj1ZVAXJNzmiQaRiWlZcbN1auJUbJkyNHMkZ3LVOGmiuC3PPmc8swtcFA15XHK3pCpegDgFPyfOnOzs0QHLmSkMtjvwTReAnoV153F74ogNyfu6NRxrF1pa12e53+bNbvdHrdrtpWdH2wJG9cRnOGF7Yn5pX1C11p1aHaYnHkr5IPhyF6BN5WlCW5UdrZucHAL+CklYBXtt7jfuWVvDg6Opp4478jt0pXL8aLCZIEj9FTtE1B8HxB0b+7nncqOdB97zpBHIa7T5Le8xMvWoBjSMMCOdC/T9zTa+5npcLV1PoqiCS1tueHNOAXgEOTCSNn4CAHeq8H8qhDNSOb9a18jqTADY//0+34/74y50KKNKbfl+hQxhkqYc0Zd0AOdDebnSPQC+R8yJ10xeOqAx3lI69EwZ9E4NlQPh7BHsI5jBzoIx8Fp5OoTMI1M8mTr68QI+WqJwiIFneyKmfIPIOq07LrGXC7pknznFDs8/9xcRv91yAgr6rjvoMhGmdLPIlgF9qiQ1rvUTD9C4QAPPGCr6MzkUNx+Kk/ErbkeU9V7JHrZmz4nE0ikCe6bG573UlO7KK4Doq+iVwd2jbOA/G5BeT/nzuAz4ntWafTUVzP35TnKjV6PEMlkHPBDTXF+axPW5G64rRJJI1LRcKLUnUxA3S0YnuQyfyBHOjSeGrJZcKN6qLb64TDUnNshEuULSxclpPImI4ly5KeEm50OBY8Rw0O4ixC8H5BD+lqMPhRcSpWcLSoxFHNm31HFDzXGYAvsLMF0RckTQc48NuKZk3BbSIVn/LRnqzkjz/1XSFIxYwDt4RO78DnHTZEA25TA7jMT4MSUlWDPPfnUbawBg0nUbetm5ZkmeEkknMpwo2q7Rk49fnGPMcIZa7Xozwv8WMWUl3m+dz9nbytrkwidGmB8KPDurM1z5nN4zy3xiWOkoWQojjq9VHdZZ6H4PFXC0Y+oLmYIzypKIqeHee5Zmo2y/Ow3Ah0hcalhUFk8EWeqgqC4I1sHaIRYoR5bqA3KTYeCEaZ0mA0moQr1ZHma3kefuaCWQK3aAYbTCZfcQ6V2StRnOfxu3944gp/DJMzs1D00t99neMOHE1aB7qboWb5lTx4hVbbmiZzdEpcZc8VSmCHU2AUGomfg+15s9mso+raVC7wyc1Ubv04OT7e3xemeGNWVJxYcCQX9/ePT05+tN4SnvWhFesH1Ir1nnCtc89aW/TsPOFbb7eBfyS8681m8HeEf73Z36CzAE7IU9lYk6kVOJv4W5VqFkrSNJJUfUnOkFLFl80cVfPlWal3pHPFcvkQKhd5T8PE9RMPum6Sc/ZY0gAAAABJRU5ErkJggg==", b;
  }()
);
class Aw {
  /**
   * Create a new EventState
   * @param mask defines the mask associated with this state
   * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
   * @param target defines the original target of the state
   * @param currentTarget defines the current target of the state
   */
  constructor(e, t = !1, n, a) {
    this.skipNextObservers = !1, this.mask = 0, this.initalize(e, t, n, a);
  }
  /**
   * Initialize the current event state
   * @param mask defines the mask associated with this state
   * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
   * @param target defines the original target of the state
   * @param currentTarget defines the current target of the state
   * @returns the current event state
   */
  initalize(e, t = !1, n, a) {
    return this.mask = e, this.skipNextObservers = t, this.target = n, this.currentTarget = a, this;
  }
}
class Tw {
  /**
   * Creates a new observer
   * @param callback defines the callback to call when the observer is notified
   * @param mask defines the mask of the observer (used to filter notifications)
   * @param scope defines the current scope used to restore the JS context
   */
  constructor(e, t, n = null) {
    this.callback = e, this.mask = t, this.scope = n, this._willBeUnregistered = !1, this.unregisterOnNextCall = !1;
  }
}
class sg {
  constructor() {
    this._observers = null, this._observables = null;
  }
  /**
   * Release associated resources
   */
  dispose() {
    if (this._observers && this._observables)
      for (var e = 0; e < this._observers.length; e++)
        this._observables[e].remove(this._observers[e]);
    this._observers = null, this._observables = null;
  }
  /**
   * Raise a callback when one of the observable will notify
   * @param observables defines a list of observables to watch
   * @param callback defines the callback to call on notification
   * @param mask defines the mask used to filter notifications
   * @param scope defines the current scope used to restore the JS context
   * @returns the new MultiObserver
   */
  static Watch(e, t, n = 0, a = null) {
    let o = new sg();
    o._observers = new Array(), o._observables = e;
    for (var h of e) {
      let f = h.add(t, n, !1, a);
      f && o._observers.push(f);
    }
    return o;
  }
}
class ag {
  /**
   * Creates a new observable
   * @param onObserverAdded defines a callback to call when a new observer is added
   */
  constructor(e) {
    this._observers = new Array(), this._onObserverAdded = null, this._eventState = new Aw(0), e && (this._onObserverAdded = e);
  }
  /**
   * Gets the list of observers
   */
  get observers() {
    return this._observers;
  }
  /**
   * Create a new Observer with the specified callback
   * @param callback the callback that will be executed for that Observer
   * @param mask the mask used to filter observers
   * @param insertFirst if true the callback will be inserted at the first position, hence executed before the others ones. If false (default behavior) the callback will be inserted at the last position, executed after all the others already present.
   * @param scope optional scope for the callback to be called from
   * @param unregisterOnFirstCall defines if the observer as to be unregistered after the next notification
   * @returns the new observer created for the callback
   */
  add(e, t = 0, n = !1, a = null, o = !1) {
    if (!e)
      return null;
    var h = new Tw(e, t, a);
    return h.unregisterOnNextCall = o, n ? this._observers.unshift(h) : this._observers.push(h), this._onObserverAdded && this._onObserverAdded(h), h;
  }
  /**
   * Create a new Observer with the specified callback and unregisters after the next notification
   * @param callback the callback that will be executed for that Observer
   * @returns the new observer created for the callback
   */
  addOnce(e) {
    return this.add(e, void 0, void 0, void 0, !0);
  }
  /**
   * Remove an Observer from the Observable object
   * @param observer the instance of the Observer to remove
   * @returns false if it doesn't belong to this Observable
   */
  remove(e) {
    if (!e)
      return !1;
    var t = this._observers.indexOf(e);
    return t !== -1 ? (this._deferUnregister(e), !0) : !1;
  }
  /**
   * Remove a callback from the Observable object
   * @param callback the callback to remove
   * @param scope optional scope. If used only the callbacks with this scope will be removed
   * @returns false if it doesn't belong to this Observable
  */
  removeCallback(e, t) {
    for (var n = 0; n < this._observers.length; n++) {
      const a = this._observers[n];
      if (!a._willBeUnregistered && a.callback === e && (!t || t === a.scope))
        return this._deferUnregister(a), !0;
    }
    return !1;
  }
  _deferUnregister(e) {
    e.unregisterOnNextCall = !1, e._willBeUnregistered = !0, setTimeout(() => {
      this._remove(e);
    }, 0);
  }
  // This should only be called when not iterating over _observers to avoid callback skipping.
  // Removes an observer from the _observer Array.
  _remove(e) {
    if (!e)
      return !1;
    var t = this._observers.indexOf(e);
    return t !== -1 ? (this._observers.splice(t, 1), !0) : !1;
  }
  /**
   * Moves the observable to the top of the observer list making it get called first when notified
   * @param observer the observer to move
   */
  makeObserverTopPriority(e) {
    this._remove(e), this._observers.unshift(e);
  }
  /**
   * Moves the observable to the bottom of the observer list making it get called last when notified
   * @param observer the observer to move
   */
  makeObserverBottomPriority(e) {
    this._remove(e), this._observers.push(e);
  }
  /**
   * Notify all Observers by calling their respective callback with the given data
   * Will return true if all observers were executed, false if an observer set skipNextObservers to true, then prevent the subsequent ones to execute
   * @param eventData defines the data to send to all observers
   * @param mask defines the mask of the current notification (observers with incompatible mask (ie mask & observer.mask === 0) will not be notified)
   * @param target defines the original target of the state
   * @param currentTarget defines the current target of the state
   * @returns false if the complete observer chain was not processed (because one observer set the skipNextObservers to true)
   */
  notifyObservers(e, t = 0, n, a) {
    if (!this._observers.length)
      return !0;
    let o = this._eventState;
    o.mask = t, o.target = n, o.currentTarget = a, o.skipNextObservers = !1, o.lastReturnValue = e;
    for (var h of this._observers)
      if (!h._willBeUnregistered && (h.mask & t && (h.scope ? o.lastReturnValue = h.callback.apply(h.scope, [e, o]) : o.lastReturnValue = h.callback(e, o), h.unregisterOnNextCall && this._deferUnregister(h)), o.skipNextObservers))
        return !1;
    return !0;
  }
  /**
   * Calling this will execute each callback, expecting it to be a promise or return a value.
   * If at any point in the chain one function fails, the promise will fail and the execution will not continue.
   * This is useful when a chain of events (sometimes async events) is needed to initialize a certain object
   * and it is crucial that all callbacks will be executed.
   * The order of the callbacks is kept, callbacks are not executed parallel.
   *
   * @param eventData The data to be sent to each callback
   * @param mask is used to filter observers defaults to 0
   * @param target defines the callback target (see EventState)
   * @param currentTarget defines he current object in the bubbling phase
   * @returns {Promise<T>} will return a Promise than resolves when all callbacks executed successfully.
   */
  notifyObserversWithPromise(e, t = 0, n, a) {
    let o = Promise.resolve(e);
    if (!this._observers.length)
      return o;
    let h = this._eventState;
    return h.mask = t, h.target = n, h.currentTarget = a, h.skipNextObservers = !1, this._observers.forEach((f) => {
      h.skipNextObservers || f._willBeUnregistered || f.mask & t && (f.scope ? o = o.then((v) => (h.lastReturnValue = v, f.callback.apply(f.scope, [e, h]))) : o = o.then((v) => (h.lastReturnValue = v, f.callback(e, h))), f.unregisterOnNextCall && this._deferUnregister(f));
    }), o.then(() => e);
  }
  /**
   * Notify a specific observer
   * @param observer defines the observer to notify
   * @param eventData defines the data to be sent to each callback
   * @param mask is used to filter observers defaults to 0
   */
  notifyObserver(e, t, n = 0) {
    let a = this._eventState;
    a.mask = n, a.skipNextObservers = !1, e.callback(t, a);
  }
  /**
   * Gets a boolean indicating if the observable has at least one observer
   * @returns true is the Observable has at least one Observer registered
   */
  hasObservers() {
    return this._observers.length > 0;
  }
  /**
  * Clear the list of observers
  */
  clear() {
    this._observers = new Array(), this._onObserverAdded = null;
  }
  /**
   * Clone the current observable
   * @returns a new observable
   */
  clone() {
    var e = new ag();
    return e._observers = this._observers.slice(0), e;
  }
  /**
   * Does this observable handles observer registered with a given mask
   * @param mask defines the mask to be tested
   * @return whether or not one observer registered with the given mask is handeled
  **/
  hasSpecificMask(e = 0) {
    for (var t of this._observers)
      if (t.mask & e || t.mask === e)
        return !0;
    return !1;
  }
}
class Uf {
  /**
   * Creates a new Database
  */
  constructor() {
    this._idbFactory = typeof window < "u" ? window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB : indexedDB, this._db = null, this._hasReachedQuota = !1, this._isSupported = !0;
  }
  openAsync() {
    return new Promise((e, t) => this.open(e, t));
  }
  /**
   * Open the database and make it available
   * @param successCallback defines the callback to call on success
   * @param errorCallback defines the callback to call on error
   */
  open(e, t) {
    const n = () => {
      this._isSupported = !1, t && t();
    };
    if (!this._idbFactory)
      this._isSupported = !1, t && t();
    else if (this._db)
      e && e();
    else {
      this._hasReachedQuota = !1, this._isSupported = !0;
      const a = this._idbFactory.open("zakeke", 1);
      a.onerror = () => {
        n();
      }, a.onblocked = () => {
        Logger.info("IDB request blocked. Please reload the page."), n();
      }, a.onsuccess = () => {
        this._db = a.result, e();
      }, a.onupgradeneeded = (o) => {
        if (this._db = o.target.result, this._db)
          try {
            this._db.createObjectStore("files", { keyPath: "fileId" });
          } catch (h) {
            Logger.info("Error while creating object stores. Exception: " + h.message), n();
          }
      };
    }
  }
  loadFileAsync(e) {
    return new Promise((t, n) => {
      if (this._isSupported && this._db) {
        const a = "files";
        let o;
        const h = this._db.transaction([a]);
        h.oncomplete = () => {
          t(o ? o.data : null);
        }, h.onabort = () => {
          t(null);
        };
        const f = h.objectStore(a).get(e);
        f.onsuccess = (v) => {
          o = v.target.result;
        }, f.onerror = () => {
          Logger.info("Error loading file " + e + " from DB."), t(null);
        };
      } else
        Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open."), n("IndexedDB not supported or Db is not open");
    });
  }
  saveFileAsync(e, t) {
    return new Promise((n, a) => {
      if (this._isSupported) {
        const o = "files";
        if (!this._hasReachedQuota && this._db) {
          const h = this._db.transaction([o], "readwrite");
          h.onabort = (x) => {
            const k = x.srcElement.error;
            k && k.name === "QuotaExceededError" && (this._hasReachedQuota = !0, a("Quota Exceeded"));
          }, h.oncomplete = () => {
            Logger.info("File saved successfully"), n();
          };
          const f = { fileId: e, data: t }, v = h.objectStore(o).put(f);
          v.onsuccess = () => {
          }, v.onerror = () => {
            Logger.info("Error in DB add file request in Zakeke3D.Database."), a("Error in DB add file request");
          };
        } else {
          const h = this._hasReachedQuota ? "Quota has been reached" : "Database closed";
          a(h);
        }
      } else
        Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open."), a("IndexedDB not supported or Db is not open");
    });
  }
  deleteFileAsync(e) {
    return new Promise((t, n) => {
      if (this._isSupported && this._db) {
        const a = "files", o = this._db.transaction([a]);
        o.oncomplete = () => {
          t();
        }, o.onabort = () => {
          n("aborted cancellation");
        };
        const h = o.objectStore(a).get(e);
        h.onerror = () => {
          Logger.info("Error deleting file " + e + " from DB."), n("Error deleting file from DB");
        };
      } else
        Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open."), n("IndexedDB not supported or Db is not open");
    });
  }
}
var yl = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
yl.exports;
(function(b, e) {
  (function() {
    var t, n = "4.17.21", a = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", h = "Expected a function", f = "Invalid `variable` option passed into `_.template`", v = "__lodash_hash_undefined__", x = 500, k = "__lodash_placeholder__", I = 1, V = 2, M = 4, W = 1, U = 2, Q = 1, D = 2, ee = 4, J = 8, he = 16, fe = 32, X = 64, Z = 128, qe = 256, Oe = 512, je = 30, pt = "...", Te = 800, Ze = 16, ce = 1, ut = 2, ze = 3, ht = 1 / 0, Gt = 9007199254740991, $e = 17976931348623157e292, It = 0 / 0, rt = 4294967295, it = rt - 1, Xt = rt >>> 1, $t = [
      ["ary", Z],
      ["bind", Q],
      ["bindKey", D],
      ["curry", J],
      ["curryRight", he],
      ["flip", Oe],
      ["partial", fe],
      ["partialRight", X],
      ["rearg", qe]
    ], Tt = "[object Arguments]", Bi = "[object Array]", en = "[object AsyncFunction]", oi = "[object Boolean]", Zt = "[object Date]", Jt = "[object DOMException]", Qt = "[object Error]", rn = "[object Function]", Gi = "[object GeneratorFunction]", pe = "[object Map]", Lt = "[object Number]", xt = "[object Null]", Ne = "[object Object]", Ie = "[object Promise]", et = "[object Proxy]", Et = "[object RegExp]", ft = "[object Set]", tt = "[object String]", _t = "[object Symbol]", Kt = "[object Undefined]", Ve = "[object WeakMap]", i = "[object WeakSet]", r = "[object ArrayBuffer]", s = "[object DataView]", l = "[object Float32Array]", u = "[object Float64Array]", d = "[object Int8Array]", p = "[object Int16Array]", m = "[object Int32Array]", y = "[object Uint8Array]", S = "[object Uint8ClampedArray]", L = "[object Uint16Array]", E = "[object Uint32Array]", A = /\b__p \+= '';/g, T = /\b(__p \+=) '' \+/g, G = /(__e\(.*?\)|\b__t\)) \+\n'';/g, O = /&(?:amp|lt|gt|quot|#39);/g, Y = /[&<>"']/g, B = RegExp(O.source), z = RegExp(Y.source), C = /<%-([\s\S]+?)%>/g, N = /<%([\s\S]+?)%>/g, j = /<%=([\s\S]+?)%>/g, q = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, H = /^\w*$/, te = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ae = /[\\^$.*+?()[\]{}|]/g, le = RegExp(ae.source), me = /^\s+/, se = /\s/, de = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, ve = /\{\n\/\* \[wrapped with (.+)\] \*/, we = /,? & /, Se = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Ae = /[()=,{}\[\]\/\s]/, Ge = /\\(\\)?/g, Qe = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, st = /\w*$/, mt = /^[-+]0x[0-9a-f]+$/i, Re = /^0b[01]+$/i, Fe = /^\[object .+?Constructor\]$/, at = /^0o[0-7]+$/i, yt = /^(?:0|[1-9]\d*)$/, bt = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Rt = /($^)/, Pt = /['\n\r\u2028\u2029\\]/g, zt = "\\ud800-\\udfff", Wt = "\\u0300-\\u036f", Ft = "\\ufe20-\\ufe2f", Mi = "\\u20d0-\\u20ff", yi = Wt + Ft + Mi, Ai = "\\u2700-\\u27bf", pi = "a-z\\xdf-\\xf6\\xf8-\\xff", kt = "\\xac\\xb1\\xd7\\xf7", fi = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Ti = "\\u2000-\\u206f", xi = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", tn = "A-Z\\xc0-\\xd6\\xd8-\\xde", Hi = "\\ufe0e\\ufe0f", Zi = kt + fi + Ti + xi, Xi = "['’]", ji = "[" + zt + "]", Ki = "[" + Zi + "]", ln = "[" + yi + "]", Fi = "\\d+", hn = "[" + Ai + "]", kr = "[" + pi + "]", Er = "[^" + zt + Zi + Fi + Ai + pi + tn + "]", Ir = "\\ud83c[\\udffb-\\udfff]", Nn = "(?:" + ln + "|" + Ir + ")", Pr = "[^" + zt + "]", Rn = "(?:\\ud83c[\\udde6-\\uddff]){2}", qn = "[\\ud800-\\udbff][\\udc00-\\udfff]", Dn = "[" + tn + "]", Mn = "\\u200d", gn = "(?:" + kr + "|" + Er + ")", yn = "(?:" + Dn + "|" + Er + ")", ri = "(?:" + Xi + "(?:d|ll|m|re|s|t|ve))?", Ji = "(?:" + Xi + "(?:D|LL|M|RE|S|T|VE))?", cn = Nn + "?", sn = "[" + Hi + "]?", zn = "(?:" + Mn + "(?:" + [Pr, Rn, qn].join("|") + ")" + sn + cn + ")*", xr = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Or = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", fr = sn + cn + zn, g = "(?:" + [hn, Rn, qn].join("|") + ")" + fr, F = "(?:" + [Pr + ln + "?", ln, Rn, qn, ji].join("|") + ")", ue = RegExp(Xi, "g"), ye = RegExp(ln, "g"), Ee = RegExp(Ir + "(?=" + Ir + ")|" + F + fr, "g"), nt = RegExp([
      Dn + "?" + kr + "+" + ri + "(?=" + [Ki, Dn, "$"].join("|") + ")",
      yn + "+" + Ji + "(?=" + [Ki, Dn + gn, "$"].join("|") + ")",
      Dn + "?" + gn + "+" + ri,
      Dn + "+" + Ji,
      Or,
      xr,
      Fi,
      g
    ].join("|"), "g"), gt = RegExp("[" + Mn + zt + yi + Hi + "]"), Yt = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, qt = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], li = -1, ni = {};
    ni[l] = ni[u] = ni[d] = ni[p] = ni[m] = ni[y] = ni[S] = ni[L] = ni[E] = !0, ni[Tt] = ni[Bi] = ni[r] = ni[oi] = ni[s] = ni[Zt] = ni[Qt] = ni[rn] = ni[pe] = ni[Lt] = ni[Ne] = ni[Et] = ni[ft] = ni[tt] = ni[Ve] = !1;
    var si = {};
    si[Tt] = si[Bi] = si[r] = si[s] = si[oi] = si[Zt] = si[l] = si[u] = si[d] = si[p] = si[m] = si[pe] = si[Lt] = si[Ne] = si[Et] = si[ft] = si[tt] = si[_t] = si[y] = si[S] = si[L] = si[E] = !0, si[Qt] = si[rn] = si[Ve] = !1;
    var xn = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, dr = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, tr = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Fn = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, sr = parseFloat, wr = parseInt, gs = typeof ts == "object" && ts && ts.Object === Object && ts, Nr = typeof self == "object" && self && self.Object === Object && self, pn = gs || Nr || Function("return this")(), ps = e && !e.nodeType && e, ir = ps && !0 && b && !b.nodeType && b, Ns = ir && ir.exports === ps, ns = Ns && gs.process, $n = function() {
      try {
        var Be = ir && ir.require && ir.require("util").types;
        return Be || ns && ns.binding && ns.binding("util");
      } catch {
      }
    }(), w = $n && $n.isArrayBuffer, P = $n && $n.isDate, K = $n && $n.isMap, ne = $n && $n.isRegExp, ge = $n && $n.isSet, _e = $n && $n.isTypedArray;
    function be(Be, We, Ye) {
      switch (Ye.length) {
        case 0:
          return Be.call(We);
        case 1:
          return Be.call(We, Ye[0]);
        case 2:
          return Be.call(We, Ye[0], Ye[1]);
        case 3:
          return Be.call(We, Ye[0], Ye[1], Ye[2]);
      }
      return Be.apply(We, Ye);
    }
    function He(Be, We, Ye, ie) {
      for (var oe = -1, Me = Be == null ? 0 : Be.length; ++oe < Me; ) {
        var ke = Be[oe];
        We(ie, ke, Ye(ke), Be);
      }
      return ie;
    }
    function De(Be, We) {
      for (var Ye = -1, ie = Be == null ? 0 : Be.length; ++Ye < ie && We(Be[Ye], Ye, Be) !== !1; )
        ;
      return Be;
    }
    function Je(Be, We) {
      for (var Ye = Be == null ? 0 : Be.length; Ye-- && We(Be[Ye], Ye, Be) !== !1; )
        ;
      return Be;
    }
    function Ct(Be, We) {
      for (var Ye = -1, ie = Be == null ? 0 : Be.length; ++Ye < ie; )
        if (!We(Be[Ye], Ye, Be))
          return !1;
      return !0;
    }
    function Bt(Be, We) {
      for (var Ye = -1, ie = Be == null ? 0 : Be.length, oe = 0, Me = []; ++Ye < ie; ) {
        var ke = Be[Ye];
        We(ke, Ye, Be) && (Me[oe++] = ke);
      }
      return Me;
    }
    function dt(Be, We) {
      var Ye = Be == null ? 0 : Be.length;
      return !!Ye && qi(Be, We, 0) > -1;
    }
    function Ut(Be, We, Ye) {
      for (var ie = -1, oe = Be == null ? 0 : Be.length; ++ie < oe; )
        if (Ye(We, Be[ie]))
          return !0;
      return !1;
    }
    function ti(Be, We) {
      for (var Ye = -1, ie = Be == null ? 0 : Be.length, oe = Array(ie); ++Ye < ie; )
        oe[Ye] = We(Be[Ye], Ye, Be);
      return oe;
    }
    function wi(Be, We) {
      for (var Ye = -1, ie = We.length, oe = Be.length; ++Ye < ie; )
        Be[oe + Ye] = We[Ye];
      return Be;
    }
    function bi(Be, We, Ye, ie) {
      var oe = -1, Me = Be == null ? 0 : Be.length;
      for (ie && Me && (Ye = Be[++oe]); ++oe < Me; )
        Ye = We(Ye, Be[oe], oe, Be);
      return Ye;
    }
    function Cn(Be, We, Ye, ie) {
      var oe = Be == null ? 0 : Be.length;
      for (ie && oe && (Ye = Be[--oe]); oe--; )
        Ye = We(Ye, Be[oe], oe, Be);
      return Ye;
    }
    function mn(Be, We) {
      for (var Ye = -1, ie = Be == null ? 0 : Be.length; ++Ye < ie; )
        if (We(Be[Ye], Ye, Be))
          return !0;
      return !1;
    }
    var fn = gr("length");
    function mi(Be) {
      return Be.split("");
    }
    function ki(Be) {
      return Be.match(Se) || [];
    }
    function En(Be, We, Ye) {
      var ie;
      return Ye(Be, function(oe, Me, ke) {
        if (We(oe, Me, ke))
          return ie = Me, !1;
      }), ie;
    }
    function Oi(Be, We, Ye, ie) {
      for (var oe = Be.length, Me = Ye + (ie ? 1 : -1); ie ? Me-- : ++Me < oe; )
        if (We(Be[Me], Me, Be))
          return Me;
      return -1;
    }
    function qi(Be, We, Ye) {
      return We === We ? ss(Be, We, Ye) : Oi(Be, ar, Ye);
    }
    function rs(Be, We, Ye, ie) {
      for (var oe = Ye - 1, Me = Be.length; ++oe < Me; )
        if (ie(Be[oe], We))
          return oe;
      return -1;
    }
    function ar(Be) {
      return Be !== Be;
    }
    function _n(Be, We) {
      var Ye = Be == null ? 0 : Be.length;
      return Ye ? In(Be, We) / Ye : It;
    }
    function gr(Be) {
      return function(We) {
        return We == null ? t : We[Be];
      };
    }
    function Hn(Be) {
      return function(We) {
        return Be == null ? t : Be[We];
      };
    }
    function ei(Be, We, Ye, ie, oe) {
      return oe(Be, function(Me, ke, lt) {
        Ye = ie ? (ie = !1, Me) : We(Ye, Me, ke, lt);
      }), Ye;
    }
    function Xn(Be, We) {
      var Ye = Be.length;
      for (Be.sort(We); Ye--; )
        Be[Ye] = Be[Ye].value;
      return Be;
    }
    function In(Be, We) {
      for (var Ye, ie = -1, oe = Be.length; ++ie < oe; ) {
        var Me = We(Be[ie]);
        Me !== t && (Ye = Ye === t ? Me : Ye + Me);
      }
      return Ye;
    }
    function Rr(Be, We) {
      for (var Ye = -1, ie = Array(Be); ++Ye < Be; )
        ie[Ye] = We(Ye);
      return ie;
    }
    function Si(Be, We) {
      return ti(We, function(Ye) {
        return [Ye, Be[Ye]];
      });
    }
    function an(Be) {
      return Be && Be.slice(0, Wr(Be) + 1).replace(me, "");
    }
    function jt(Be) {
      return function(We) {
        return Be(We);
      };
    }
    function Dr(Be, We) {
      return ti(We, function(Ye) {
        return Be[Ye];
      });
    }
    function hi(Be, We) {
      return Be.has(We);
    }
    function Ni(Be, We) {
      for (var Ye = -1, ie = Be.length; ++Ye < ie && qi(We, Be[Ye], 0) > -1; )
        ;
      return Ye;
    }
    function An(Be, We) {
      for (var Ye = Be.length; Ye-- && qi(We, Be[Ye], 0) > -1; )
        ;
      return Ye;
    }
    function ui(Be, We) {
      for (var Ye = Be.length, ie = 0; Ye--; )
        Be[Ye] === We && ++ie;
      return ie;
    }
    var dn = Hn(xn), zr = Hn(dr);
    function $s(Be) {
      return "\\" + Fn[Be];
    }
    function jr(Be, We) {
      return Be == null ? t : Be[We];
    }
    function Kn(Be) {
      return gt.test(Be);
    }
    function un(Be) {
      return Yt.test(Be);
    }
    function Pn(Be) {
      for (var We, Ye = []; !(We = Be.next()).done; )
        Ye.push(We.value);
      return Ye;
    }
    function Jn(Be) {
      var We = -1, Ye = Array(Be.size);
      return Be.forEach(function(ie, oe) {
        Ye[++We] = [oe, ie];
      }), Ye;
    }
    function or(Be, We) {
      return function(Ye) {
        return Be(We(Ye));
      };
    }
    function jn(Be, We) {
      for (var Ye = -1, ie = Be.length, oe = 0, Me = []; ++Ye < ie; ) {
        var ke = Be[Ye];
        (ke === We || ke === k) && (Be[Ye] = k, Me[oe++] = Ye);
      }
      return Me;
    }
    function pr(Be) {
      var We = -1, Ye = Array(Be.size);
      return Be.forEach(function(ie) {
        Ye[++We] = ie;
      }), Ye;
    }
    function Ui(Be) {
      var We = -1, Ye = Array(Be.size);
      return Be.forEach(function(ie) {
        Ye[++We] = [ie, ie];
      }), Ye;
    }
    function ss(Be, We, Ye) {
      for (var ie = Ye - 1, oe = Be.length; ++ie < oe; )
        if (Be[ie] === We)
          return ie;
      return -1;
    }
    function ms(Be, We, Ye) {
      for (var ie = Ye + 1; ie--; )
        if (Be[ie] === We)
          return ie;
      return ie;
    }
    function Sr(Be) {
      return Kn(Be) ? lr(Be) : fn(Be);
    }
    function Tn(Be) {
      return Kn(Be) ? Pe(Be) : mi(Be);
    }
    function Wr(Be) {
      for (var We = Be.length; We-- && se.test(Be.charAt(We)); )
        ;
      return We;
    }
    var Ms = Hn(tr);
    function lr(Be) {
      for (var We = Ee.lastIndex = 0; Ee.test(Be); )
        ++We;
      return We;
    }
    function Pe(Be) {
      return Be.match(Ee) || [];
    }
    function Ke(Be) {
      return Be.match(nt) || [];
    }
    var ct = function Be(We) {
      We = We == null ? pn : vt.defaults(pn.Object(), We, vt.pick(pn, qt));
      var Ye = We.Array, ie = We.Date, oe = We.Error, Me = We.Function, ke = We.Math, lt = We.Object, At = We.RegExp, wt = We.String, Vt = We.TypeError, Ei = Ye.prototype, Qi = Me.prototype, vn = lt.prototype, wn = We["__core-js_shared__"], mr = Qi.toString, Li = vn.hasOwnProperty, _g = 0, bu = function() {
        var c = /[^.]+$/.exec(wn && wn.keys && wn.keys.IE_PROTO || "");
        return c ? "Symbol(src)_1." + c : "";
      }(), fo = vn.toString, vg = mr.call(lt), yg = pn._, bg = At(
        "^" + mr.call(Li).replace(ae, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), go = Ns ? We.Buffer : t, Rs = We.Symbol, po = We.Uint8Array, xu = go ? go.allocUnsafe : t, mo = or(lt.getPrototypeOf, lt), wu = lt.create, Su = vn.propertyIsEnumerable, _o = Ei.splice, Mu = Rs ? Rs.isConcatSpreadable : t, ka = Rs ? Rs.iterator : t, Xs = Rs ? Rs.toStringTag : t, vo = function() {
        try {
          var c = ta(lt, "defineProperty");
          return c({}, "", {}), c;
        } catch {
        }
      }(), xg = We.clearTimeout !== pn.clearTimeout && We.clearTimeout, wg = ie && ie.now !== pn.Date.now && ie.now, Sg = We.setTimeout !== pn.setTimeout && We.setTimeout, yo = ke.ceil, bo = ke.floor, El = lt.getOwnPropertySymbols, Mg = go ? go.isBuffer : t, Cu = We.isFinite, Cg = Ei.join, Ag = or(lt.keys, lt), Wn = ke.max, hr = ke.min, Tg = ie.now, Lg = We.parseInt, Au = ke.random, Bg = Ei.reverse, Il = ta(We, "DataView"), Ea = ta(We, "Map"), Pl = ta(We, "Promise"), fa = ta(We, "Set"), Ia = ta(We, "WeakMap"), Pa = ta(lt, "create"), xo = Ia && new Ia(), da = {}, kg = ia(Il), Eg = ia(Ea), Ig = ia(Pl), Pg = ia(fa), Og = ia(Ia), wo = Rs ? Rs.prototype : t, Oa = wo ? wo.valueOf : t, Tu = wo ? wo.toString : t;
      function Ce(c) {
        if (On(c) && !Ii(c) && !(c instanceof Wi)) {
          if (c instanceof Zr)
            return c;
          if (Li.call(c, "__wrapped__"))
            return Lc(c);
        }
        return new Zr(c);
      }
      var ga = function() {
        function c() {
        }
        return function(_) {
          if (!Ln(_))
            return {};
          if (wu)
            return wu(_);
          c.prototype = _;
          var R = new c();
          return c.prototype = t, R;
        };
      }();
      function So() {
      }
      function Zr(c, _) {
        this.__wrapped__ = c, this.__actions__ = [], this.__chain__ = !!_, this.__index__ = 0, this.__values__ = t;
      }
      Ce.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: C,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: N,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: j,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: Ce
        }
      }, Ce.prototype = So.prototype, Ce.prototype.constructor = Ce, Zr.prototype = ga(So.prototype), Zr.prototype.constructor = Zr;
      function Wi(c) {
        this.__wrapped__ = c, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = rt, this.__views__ = [];
      }
      function Ng() {
        var c = new Wi(this.__wrapped__);
        return c.__actions__ = Mr(this.__actions__), c.__dir__ = this.__dir__, c.__filtered__ = this.__filtered__, c.__iteratees__ = Mr(this.__iteratees__), c.__takeCount__ = this.__takeCount__, c.__views__ = Mr(this.__views__), c;
      }
      function Rg() {
        if (this.__filtered__) {
          var c = new Wi(this);
          c.__dir__ = -1, c.__filtered__ = !0;
        } else
          c = this.clone(), c.__dir__ *= -1;
        return c;
      }
      function Dg() {
        var c = this.__wrapped__.value(), _ = this.__dir__, R = Ii(c), re = _ < 0, xe = R ? c.length : 0, Le = $p(0, xe, this.__views__), Ue = Le.start, Xe = Le.end, ot = Xe - Ue, Ot = re ? Xe : Ue - 1, Nt = this.__iteratees__, Ht = Nt.length, ii = 0, ai = hr(ot, this.__takeCount__);
        if (!R || !re && xe == ot && ai == ot)
          return Ku(c, this.__actions__);
        var _i = [];
        e:
          for (; ot-- && ii < ai; ) {
            Ot += _;
            for (var zi = -1, vi = c[Ot]; ++zi < Ht; ) {
              var Yi = Nt[zi], $i = Yi.iteratee, Vr = Yi.type, yr = $i(vi);
              if (Vr == ut)
                vi = yr;
              else if (!yr) {
                if (Vr == ce)
                  continue e;
                break e;
              }
            }
            _i[ii++] = vi;
          }
        return _i;
      }
      Wi.prototype = ga(So.prototype), Wi.prototype.constructor = Wi;
      function Ks(c) {
        var _ = -1, R = c == null ? 0 : c.length;
        for (this.clear(); ++_ < R; ) {
          var re = c[_];
          this.set(re[0], re[1]);
        }
      }
      function zg() {
        this.__data__ = Pa ? Pa(null) : {}, this.size = 0;
      }
      function Fg(c) {
        var _ = this.has(c) && delete this.__data__[c];
        return this.size -= _ ? 1 : 0, _;
      }
      function Ug(c) {
        var _ = this.__data__;
        if (Pa) {
          var R = _[c];
          return R === v ? t : R;
        }
        return Li.call(_, c) ? _[c] : t;
      }
      function Vg(c) {
        var _ = this.__data__;
        return Pa ? _[c] !== t : Li.call(_, c);
      }
      function Hg(c, _) {
        var R = this.__data__;
        return this.size += this.has(c) ? 0 : 1, R[c] = Pa && _ === t ? v : _, this;
      }
      Ks.prototype.clear = zg, Ks.prototype.delete = Fg, Ks.prototype.get = Ug, Ks.prototype.has = Vg, Ks.prototype.set = Hg;
      function Cs(c) {
        var _ = -1, R = c == null ? 0 : c.length;
        for (this.clear(); ++_ < R; ) {
          var re = c[_];
          this.set(re[0], re[1]);
        }
      }
      function Yg() {
        this.__data__ = [], this.size = 0;
      }
      function Gg(c) {
        var _ = this.__data__, R = Mo(_, c);
        if (R < 0)
          return !1;
        var re = _.length - 1;
        return R == re ? _.pop() : _o.call(_, R, 1), --this.size, !0;
      }
      function jg(c) {
        var _ = this.__data__, R = Mo(_, c);
        return R < 0 ? t : _[R][1];
      }
      function Wg(c) {
        return Mo(this.__data__, c) > -1;
      }
      function Zg(c, _) {
        var R = this.__data__, re = Mo(R, c);
        return re < 0 ? (++this.size, R.push([c, _])) : R[re][1] = _, this;
      }
      Cs.prototype.clear = Yg, Cs.prototype.delete = Gg, Cs.prototype.get = jg, Cs.prototype.has = Wg, Cs.prototype.set = Zg;
      function As(c) {
        var _ = -1, R = c == null ? 0 : c.length;
        for (this.clear(); ++_ < R; ) {
          var re = c[_];
          this.set(re[0], re[1]);
        }
      }
      function qg() {
        this.size = 0, this.__data__ = {
          hash: new Ks(),
          map: new (Ea || Cs)(),
          string: new Ks()
        };
      }
      function $g(c) {
        var _ = Ro(this, c).delete(c);
        return this.size -= _ ? 1 : 0, _;
      }
      function Xg(c) {
        return Ro(this, c).get(c);
      }
      function Kg(c) {
        return Ro(this, c).has(c);
      }
      function Jg(c, _) {
        var R = Ro(this, c), re = R.size;
        return R.set(c, _), this.size += R.size == re ? 0 : 1, this;
      }
      As.prototype.clear = qg, As.prototype.delete = $g, As.prototype.get = Xg, As.prototype.has = Kg, As.prototype.set = Jg;
      function Js(c) {
        var _ = -1, R = c == null ? 0 : c.length;
        for (this.__data__ = new As(); ++_ < R; )
          this.add(c[_]);
      }
      function Qg(c) {
        return this.__data__.set(c, v), this;
      }
      function ep(c) {
        return this.__data__.has(c);
      }
      Js.prototype.add = Js.prototype.push = Qg, Js.prototype.has = ep;
      function as(c) {
        var _ = this.__data__ = new Cs(c);
        this.size = _.size;
      }
      function tp() {
        this.__data__ = new Cs(), this.size = 0;
      }
      function ip(c) {
        var _ = this.__data__, R = _.delete(c);
        return this.size = _.size, R;
      }
      function np(c) {
        return this.__data__.get(c);
      }
      function rp(c) {
        return this.__data__.has(c);
      }
      function sp(c, _) {
        var R = this.__data__;
        if (R instanceof Cs) {
          var re = R.__data__;
          if (!Ea || re.length < a - 1)
            return re.push([c, _]), this.size = ++R.size, this;
          R = this.__data__ = new As(re);
        }
        return R.set(c, _), this.size = R.size, this;
      }
      as.prototype.clear = tp, as.prototype.delete = ip, as.prototype.get = np, as.prototype.has = rp, as.prototype.set = sp;
      function Lu(c, _) {
        var R = Ii(c), re = !R && na(c), xe = !R && !re && Vs(c), Le = !R && !re && !xe && va(c), Ue = R || re || xe || Le, Xe = Ue ? Rr(c.length, wt) : [], ot = Xe.length;
        for (var Ot in c)
          (_ || Li.call(c, Ot)) && !(Ue && // Safari 9 has enumerable `arguments.length` in strict mode.
          (Ot == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          xe && (Ot == "offset" || Ot == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          Le && (Ot == "buffer" || Ot == "byteLength" || Ot == "byteOffset") || // Skip index properties.
          ks(Ot, ot))) && Xe.push(Ot);
        return Xe;
      }
      function Bu(c) {
        var _ = c.length;
        return _ ? c[Gl(0, _ - 1)] : t;
      }
      function ap(c, _) {
        return Do(Mr(c), Qs(_, 0, c.length));
      }
      function op(c) {
        return Do(Mr(c));
      }
      function Ol(c, _, R) {
        (R !== t && !os(c[_], R) || R === t && !(_ in c)) && Ts(c, _, R);
      }
      function Na(c, _, R) {
        var re = c[_];
        (!(Li.call(c, _) && os(re, R)) || R === t && !(_ in c)) && Ts(c, _, R);
      }
      function Mo(c, _) {
        for (var R = c.length; R--; )
          if (os(c[R][0], _))
            return R;
        return -1;
      }
      function lp(c, _, R, re) {
        return Ds(c, function(xe, Le, Ue) {
          _(re, xe, R(xe), Ue);
        }), re;
      }
      function ku(c, _) {
        return c && vs(_, Qn(_), c);
      }
      function hp(c, _) {
        return c && vs(_, Ar(_), c);
      }
      function Ts(c, _, R) {
        _ == "__proto__" && vo ? vo(c, _, {
          configurable: !0,
          enumerable: !0,
          value: R,
          writable: !0
        }) : c[_] = R;
      }
      function Nl(c, _) {
        for (var R = -1, re = _.length, xe = Ye(re), Le = c == null; ++R < re; )
          xe[R] = Le ? t : ph(c, _[R]);
        return xe;
      }
      function Qs(c, _, R) {
        return c === c && (R !== t && (c = c <= R ? c : R), _ !== t && (c = c >= _ ? c : _)), c;
      }
      function qr(c, _, R, re, xe, Le) {
        var Ue, Xe = _ & I, ot = _ & V, Ot = _ & M;
        if (R && (Ue = xe ? R(c, re, xe, Le) : R(c)), Ue !== t)
          return Ue;
        if (!Ln(c))
          return c;
        var Nt = Ii(c);
        if (Nt) {
          if (Ue = Kp(c), !Xe)
            return Mr(c, Ue);
        } else {
          var Ht = ur(c), ii = Ht == rn || Ht == Gi;
          if (Vs(c))
            return ec(c, Xe);
          if (Ht == Ne || Ht == Tt || ii && !xe) {
            if (Ue = ot || ii ? {} : yc(c), !Xe)
              return ot ? Up(c, hp(Ue, c)) : Fp(c, ku(Ue, c));
          } else {
            if (!si[Ht])
              return xe ? c : {};
            Ue = Jp(c, Ht, Xe);
          }
        }
        Le || (Le = new as());
        var ai = Le.get(c);
        if (ai)
          return ai;
        Le.set(c, Ue), qc(c) ? c.forEach(function(vi) {
          Ue.add(qr(vi, _, R, vi, c, Le));
        }) : Wc(c) && c.forEach(function(vi, Yi) {
          Ue.set(Yi, qr(vi, _, R, Yi, c, Le));
        });
        var _i = Ot ? ot ? th : eh : ot ? Ar : Qn, zi = Nt ? t : _i(c);
        return De(zi || c, function(vi, Yi) {
          zi && (Yi = vi, vi = c[Yi]), Na(Ue, Yi, qr(vi, _, R, Yi, c, Le));
        }), Ue;
      }
      function up(c) {
        var _ = Qn(c);
        return function(R) {
          return Eu(R, c, _);
        };
      }
      function Eu(c, _, R) {
        var re = R.length;
        if (c == null)
          return !re;
        for (c = lt(c); re--; ) {
          var xe = R[re], Le = _[xe], Ue = c[xe];
          if (Ue === t && !(xe in c) || !Le(Ue))
            return !1;
        }
        return !0;
      }
      function Iu(c, _, R) {
        if (typeof c != "function")
          throw new Vt(h);
        return Ha(function() {
          c.apply(t, R);
        }, _);
      }
      function Ra(c, _, R, re) {
        var xe = -1, Le = dt, Ue = !0, Xe = c.length, ot = [], Ot = _.length;
        if (!Xe)
          return ot;
        R && (_ = ti(_, jt(R))), re ? (Le = Ut, Ue = !1) : _.length >= a && (Le = hi, Ue = !1, _ = new Js(_));
        e:
          for (; ++xe < Xe; ) {
            var Nt = c[xe], Ht = R == null ? Nt : R(Nt);
            if (Nt = re || Nt !== 0 ? Nt : 0, Ue && Ht === Ht) {
              for (var ii = Ot; ii--; )
                if (_[ii] === Ht)
                  continue e;
              ot.push(Nt);
            } else
              Le(_, Ht, re) || ot.push(Nt);
          }
        return ot;
      }
      var Ds = sc(_s), Pu = sc(Dl, !0);
      function cp(c, _) {
        var R = !0;
        return Ds(c, function(re, xe, Le) {
          return R = !!_(re, xe, Le), R;
        }), R;
      }
      function Co(c, _, R) {
        for (var re = -1, xe = c.length; ++re < xe; ) {
          var Le = c[re], Ue = _(Le);
          if (Ue != null && (Xe === t ? Ue === Ue && !Ur(Ue) : R(Ue, Xe)))
            var Xe = Ue, ot = Le;
        }
        return ot;
      }
      function fp(c, _, R, re) {
        var xe = c.length;
        for (R = Di(R), R < 0 && (R = -R > xe ? 0 : xe + R), re = re === t || re > xe ? xe : Di(re), re < 0 && (re += xe), re = R > re ? 0 : Xc(re); R < re; )
          c[R++] = _;
        return c;
      }
      function Ou(c, _) {
        var R = [];
        return Ds(c, function(re, xe, Le) {
          _(re, xe, Le) && R.push(re);
        }), R;
      }
      function nr(c, _, R, re, xe) {
        var Le = -1, Ue = c.length;
        for (R || (R = em), xe || (xe = []); ++Le < Ue; ) {
          var Xe = c[Le];
          _ > 0 && R(Xe) ? _ > 1 ? nr(Xe, _ - 1, R, re, xe) : wi(xe, Xe) : re || (xe[xe.length] = Xe);
        }
        return xe;
      }
      var Rl = ac(), Nu = ac(!0);
      function _s(c, _) {
        return c && Rl(c, _, Qn);
      }
      function Dl(c, _) {
        return c && Nu(c, _, Qn);
      }
      function Ao(c, _) {
        return Bt(_, function(R) {
          return Es(c[R]);
        });
      }
      function ea(c, _) {
        _ = Fs(_, c);
        for (var R = 0, re = _.length; c != null && R < re; )
          c = c[ys(_[R++])];
        return R && R == re ? c : t;
      }
      function Ru(c, _, R) {
        var re = _(c);
        return Ii(c) ? re : wi(re, R(c));
      }
      function _r(c) {
        return c == null ? c === t ? Kt : xt : Xs && Xs in lt(c) ? qp(c) : om(c);
      }
      function zl(c, _) {
        return c > _;
      }
      function dp(c, _) {
        return c != null && Li.call(c, _);
      }
      function gp(c, _) {
        return c != null && _ in lt(c);
      }
      function pp(c, _, R) {
        return c >= hr(_, R) && c < Wn(_, R);
      }
      function Fl(c, _, R) {
        for (var re = R ? Ut : dt, xe = c[0].length, Le = c.length, Ue = Le, Xe = Ye(Le), ot = 1 / 0, Ot = []; Ue--; ) {
          var Nt = c[Ue];
          Ue && _ && (Nt = ti(Nt, jt(_))), ot = hr(Nt.length, ot), Xe[Ue] = !R && (_ || xe >= 120 && Nt.length >= 120) ? new Js(Ue && Nt) : t;
        }
        Nt = c[0];
        var Ht = -1, ii = Xe[0];
        e:
          for (; ++Ht < xe && Ot.length < ot; ) {
            var ai = Nt[Ht], _i = _ ? _(ai) : ai;
            if (ai = R || ai !== 0 ? ai : 0, !(ii ? hi(ii, _i) : re(Ot, _i, R))) {
              for (Ue = Le; --Ue; ) {
                var zi = Xe[Ue];
                if (!(zi ? hi(zi, _i) : re(c[Ue], _i, R)))
                  continue e;
              }
              ii && ii.push(_i), Ot.push(ai);
            }
          }
        return Ot;
      }
      function mp(c, _, R, re) {
        return _s(c, function(xe, Le, Ue) {
          _(re, R(xe), Le, Ue);
        }), re;
      }
      function Da(c, _, R) {
        _ = Fs(_, c), c = Sc(c, _);
        var re = c == null ? c : c[ys(Xr(_))];
        return re == null ? t : be(re, c, R);
      }
      function Du(c) {
        return On(c) && _r(c) == Tt;
      }
      function _p(c) {
        return On(c) && _r(c) == r;
      }
      function vp(c) {
        return On(c) && _r(c) == Zt;
      }
      function za(c, _, R, re, xe) {
        return c === _ ? !0 : c == null || _ == null || !On(c) && !On(_) ? c !== c && _ !== _ : yp(c, _, R, re, za, xe);
      }
      function yp(c, _, R, re, xe, Le) {
        var Ue = Ii(c), Xe = Ii(_), ot = Ue ? Bi : ur(c), Ot = Xe ? Bi : ur(_);
        ot = ot == Tt ? Ne : ot, Ot = Ot == Tt ? Ne : Ot;
        var Nt = ot == Ne, Ht = Ot == Ne, ii = ot == Ot;
        if (ii && Vs(c)) {
          if (!Vs(_))
            return !1;
          Ue = !0, Nt = !1;
        }
        if (ii && !Nt)
          return Le || (Le = new as()), Ue || va(c) ? mc(c, _, R, re, xe, Le) : Wp(c, _, ot, R, re, xe, Le);
        if (!(R & W)) {
          var ai = Nt && Li.call(c, "__wrapped__"), _i = Ht && Li.call(_, "__wrapped__");
          if (ai || _i) {
            var zi = ai ? c.value() : c, vi = _i ? _.value() : _;
            return Le || (Le = new as()), xe(zi, vi, R, re, Le);
          }
        }
        return ii ? (Le || (Le = new as()), Zp(c, _, R, re, xe, Le)) : !1;
      }
      function bp(c) {
        return On(c) && ur(c) == pe;
      }
      function Ul(c, _, R, re) {
        var xe = R.length, Le = xe, Ue = !re;
        if (c == null)
          return !Le;
        for (c = lt(c); xe--; ) {
          var Xe = R[xe];
          if (Ue && Xe[2] ? Xe[1] !== c[Xe[0]] : !(Xe[0] in c))
            return !1;
        }
        for (; ++xe < Le; ) {
          Xe = R[xe];
          var ot = Xe[0], Ot = c[ot], Nt = Xe[1];
          if (Ue && Xe[2]) {
            if (Ot === t && !(ot in c))
              return !1;
          } else {
            var Ht = new as();
            if (re)
              var ii = re(Ot, Nt, ot, c, _, Ht);
            if (!(ii === t ? za(Nt, Ot, W | U, re, Ht) : ii))
              return !1;
          }
        }
        return !0;
      }
      function zu(c) {
        if (!Ln(c) || im(c))
          return !1;
        var _ = Es(c) ? bg : Fe;
        return _.test(ia(c));
      }
      function xp(c) {
        return On(c) && _r(c) == Et;
      }
      function wp(c) {
        return On(c) && ur(c) == ft;
      }
      function Sp(c) {
        return On(c) && Yo(c.length) && !!ni[_r(c)];
      }
      function Fu(c) {
        return typeof c == "function" ? c : c == null ? Tr : typeof c == "object" ? Ii(c) ? Hu(c[0], c[1]) : Vu(c) : lf(c);
      }
      function Vl(c) {
        if (!Va(c))
          return Ag(c);
        var _ = [];
        for (var R in lt(c))
          Li.call(c, R) && R != "constructor" && _.push(R);
        return _;
      }
      function Mp(c) {
        if (!Ln(c))
          return am(c);
        var _ = Va(c), R = [];
        for (var re in c)
          re == "constructor" && (_ || !Li.call(c, re)) || R.push(re);
        return R;
      }
      function Hl(c, _) {
        return c < _;
      }
      function Uu(c, _) {
        var R = -1, re = Cr(c) ? Ye(c.length) : [];
        return Ds(c, function(xe, Le, Ue) {
          re[++R] = _(xe, Le, Ue);
        }), re;
      }
      function Vu(c) {
        var _ = nh(c);
        return _.length == 1 && _[0][2] ? xc(_[0][0], _[0][1]) : function(R) {
          return R === c || Ul(R, c, _);
        };
      }
      function Hu(c, _) {
        return sh(c) && bc(_) ? xc(ys(c), _) : function(R) {
          var re = ph(R, c);
          return re === t && re === _ ? mh(R, c) : za(_, re, W | U);
        };
      }
      function To(c, _, R, re, xe) {
        c !== _ && Rl(_, function(Le, Ue) {
          if (xe || (xe = new as()), Ln(Le))
            Cp(c, _, Ue, R, To, re, xe);
          else {
            var Xe = re ? re(oh(c, Ue), Le, Ue + "", c, _, xe) : t;
            Xe === t && (Xe = Le), Ol(c, Ue, Xe);
          }
        }, Ar);
      }
      function Cp(c, _, R, re, xe, Le, Ue) {
        var Xe = oh(c, R), ot = oh(_, R), Ot = Ue.get(ot);
        if (Ot) {
          Ol(c, R, Ot);
          return;
        }
        var Nt = Le ? Le(Xe, ot, R + "", c, _, Ue) : t, Ht = Nt === t;
        if (Ht) {
          var ii = Ii(ot), ai = !ii && Vs(ot), _i = !ii && !ai && va(ot);
          Nt = ot, ii || ai || _i ? Ii(Xe) ? Nt = Xe : Un(Xe) ? Nt = Mr(Xe) : ai ? (Ht = !1, Nt = ec(ot, !0)) : _i ? (Ht = !1, Nt = tc(ot, !0)) : Nt = [] : Ya(ot) || na(ot) ? (Nt = Xe, na(Xe) ? Nt = Kc(Xe) : (!Ln(Xe) || Es(Xe)) && (Nt = yc(ot))) : Ht = !1;
        }
        Ht && (Ue.set(ot, Nt), xe(Nt, ot, re, Le, Ue), Ue.delete(ot)), Ol(c, R, Nt);
      }
      function Yu(c, _) {
        var R = c.length;
        if (R)
          return _ += _ < 0 ? R : 0, ks(_, R) ? c[_] : t;
      }
      function Gu(c, _, R) {
        _.length ? _ = ti(_, function(Le) {
          return Ii(Le) ? function(Ue) {
            return ea(Ue, Le.length === 1 ? Le[0] : Le);
          } : Le;
        }) : _ = [Tr];
        var re = -1;
        _ = ti(_, jt(gi()));
        var xe = Uu(c, function(Le, Ue, Xe) {
          var ot = ti(_, function(Ot) {
            return Ot(Le);
          });
          return { criteria: ot, index: ++re, value: Le };
        });
        return Xn(xe, function(Le, Ue) {
          return zp(Le, Ue, R);
        });
      }
      function Ap(c, _) {
        return ju(c, _, function(R, re) {
          return mh(c, re);
        });
      }
      function ju(c, _, R) {
        for (var re = -1, xe = _.length, Le = {}; ++re < xe; ) {
          var Ue = _[re], Xe = ea(c, Ue);
          R(Xe, Ue) && Fa(Le, Fs(Ue, c), Xe);
        }
        return Le;
      }
      function Tp(c) {
        return function(_) {
          return ea(_, c);
        };
      }
      function Yl(c, _, R, re) {
        var xe = re ? rs : qi, Le = -1, Ue = _.length, Xe = c;
        for (c === _ && (_ = Mr(_)), R && (Xe = ti(c, jt(R))); ++Le < Ue; )
          for (var ot = 0, Ot = _[Le], Nt = R ? R(Ot) : Ot; (ot = xe(Xe, Nt, ot, re)) > -1; )
            Xe !== c && _o.call(Xe, ot, 1), _o.call(c, ot, 1);
        return c;
      }
      function Wu(c, _) {
        for (var R = c ? _.length : 0, re = R - 1; R--; ) {
          var xe = _[R];
          if (R == re || xe !== Le) {
            var Le = xe;
            ks(xe) ? _o.call(c, xe, 1) : Zl(c, xe);
          }
        }
        return c;
      }
      function Gl(c, _) {
        return c + bo(Au() * (_ - c + 1));
      }
      function Lp(c, _, R, re) {
        for (var xe = -1, Le = Wn(yo((_ - c) / (R || 1)), 0), Ue = Ye(Le); Le--; )
          Ue[re ? Le : ++xe] = c, c += R;
        return Ue;
      }
      function jl(c, _) {
        var R = "";
        if (!c || _ < 1 || _ > Gt)
          return R;
        do
          _ % 2 && (R += c), _ = bo(_ / 2), _ && (c += c);
        while (_);
        return R;
      }
      function Vi(c, _) {
        return lh(wc(c, _, Tr), c + "");
      }
      function Bp(c) {
        return Bu(ya(c));
      }
      function kp(c, _) {
        var R = ya(c);
        return Do(R, Qs(_, 0, R.length));
      }
      function Fa(c, _, R, re) {
        if (!Ln(c))
          return c;
        _ = Fs(_, c);
        for (var xe = -1, Le = _.length, Ue = Le - 1, Xe = c; Xe != null && ++xe < Le; ) {
          var ot = ys(_[xe]), Ot = R;
          if (ot === "__proto__" || ot === "constructor" || ot === "prototype")
            return c;
          if (xe != Ue) {
            var Nt = Xe[ot];
            Ot = re ? re(Nt, ot, Xe) : t, Ot === t && (Ot = Ln(Nt) ? Nt : ks(_[xe + 1]) ? [] : {});
          }
          Na(Xe, ot, Ot), Xe = Xe[ot];
        }
        return c;
      }
      var Zu = xo ? function(c, _) {
        return xo.set(c, _), c;
      } : Tr, Ep = vo ? function(c, _) {
        return vo(c, "toString", {
          configurable: !0,
          enumerable: !1,
          value: vh(_),
          writable: !0
        });
      } : Tr;
      function Ip(c) {
        return Do(ya(c));
      }
      function $r(c, _, R) {
        var re = -1, xe = c.length;
        _ < 0 && (_ = -_ > xe ? 0 : xe + _), R = R > xe ? xe : R, R < 0 && (R += xe), xe = _ > R ? 0 : R - _ >>> 0, _ >>>= 0;
        for (var Le = Ye(xe); ++re < xe; )
          Le[re] = c[re + _];
        return Le;
      }
      function Pp(c, _) {
        var R;
        return Ds(c, function(re, xe, Le) {
          return R = _(re, xe, Le), !R;
        }), !!R;
      }
      function Lo(c, _, R) {
        var re = 0, xe = c == null ? re : c.length;
        if (typeof _ == "number" && _ === _ && xe <= Xt) {
          for (; re < xe; ) {
            var Le = re + xe >>> 1, Ue = c[Le];
            Ue !== null && !Ur(Ue) && (R ? Ue <= _ : Ue < _) ? re = Le + 1 : xe = Le;
          }
          return xe;
        }
        return Wl(c, _, Tr, R);
      }
      function Wl(c, _, R, re) {
        var xe = 0, Le = c == null ? 0 : c.length;
        if (Le === 0)
          return 0;
        _ = R(_);
        for (var Ue = _ !== _, Xe = _ === null, ot = Ur(_), Ot = _ === t; xe < Le; ) {
          var Nt = bo((xe + Le) / 2), Ht = R(c[Nt]), ii = Ht !== t, ai = Ht === null, _i = Ht === Ht, zi = Ur(Ht);
          if (Ue)
            var vi = re || _i;
          else
            Ot ? vi = _i && (re || ii) : Xe ? vi = _i && ii && (re || !ai) : ot ? vi = _i && ii && !ai && (re || !zi) : ai || zi ? vi = !1 : vi = re ? Ht <= _ : Ht < _;
          vi ? xe = Nt + 1 : Le = Nt;
        }
        return hr(Le, it);
      }
      function qu(c, _) {
        for (var R = -1, re = c.length, xe = 0, Le = []; ++R < re; ) {
          var Ue = c[R], Xe = _ ? _(Ue) : Ue;
          if (!R || !os(Xe, ot)) {
            var ot = Xe;
            Le[xe++] = Ue === 0 ? 0 : Ue;
          }
        }
        return Le;
      }
      function $u(c) {
        return typeof c == "number" ? c : Ur(c) ? It : +c;
      }
      function Fr(c) {
        if (typeof c == "string")
          return c;
        if (Ii(c))
          return ti(c, Fr) + "";
        if (Ur(c))
          return Tu ? Tu.call(c) : "";
        var _ = c + "";
        return _ == "0" && 1 / c == -ht ? "-0" : _;
      }
      function zs(c, _, R) {
        var re = -1, xe = dt, Le = c.length, Ue = !0, Xe = [], ot = Xe;
        if (R)
          Ue = !1, xe = Ut;
        else if (Le >= a) {
          var Ot = _ ? null : Gp(c);
          if (Ot)
            return pr(Ot);
          Ue = !1, xe = hi, ot = new Js();
        } else
          ot = _ ? [] : Xe;
        e:
          for (; ++re < Le; ) {
            var Nt = c[re], Ht = _ ? _(Nt) : Nt;
            if (Nt = R || Nt !== 0 ? Nt : 0, Ue && Ht === Ht) {
              for (var ii = ot.length; ii--; )
                if (ot[ii] === Ht)
                  continue e;
              _ && ot.push(Ht), Xe.push(Nt);
            } else
              xe(ot, Ht, R) || (ot !== Xe && ot.push(Ht), Xe.push(Nt));
          }
        return Xe;
      }
      function Zl(c, _) {
        return _ = Fs(_, c), c = Sc(c, _), c == null || delete c[ys(Xr(_))];
      }
      function Xu(c, _, R, re) {
        return Fa(c, _, R(ea(c, _)), re);
      }
      function Bo(c, _, R, re) {
        for (var xe = c.length, Le = re ? xe : -1; (re ? Le-- : ++Le < xe) && _(c[Le], Le, c); )
          ;
        return R ? $r(c, re ? 0 : Le, re ? Le + 1 : xe) : $r(c, re ? Le + 1 : 0, re ? xe : Le);
      }
      function Ku(c, _) {
        var R = c;
        return R instanceof Wi && (R = R.value()), bi(_, function(re, xe) {
          return xe.func.apply(xe.thisArg, wi([re], xe.args));
        }, R);
      }
      function ql(c, _, R) {
        var re = c.length;
        if (re < 2)
          return re ? zs(c[0]) : [];
        for (var xe = -1, Le = Ye(re); ++xe < re; )
          for (var Ue = c[xe], Xe = -1; ++Xe < re; )
            Xe != xe && (Le[xe] = Ra(Le[xe] || Ue, c[Xe], _, R));
        return zs(nr(Le, 1), _, R);
      }
      function Ju(c, _, R) {
        for (var re = -1, xe = c.length, Le = _.length, Ue = {}; ++re < xe; ) {
          var Xe = re < Le ? _[re] : t;
          R(Ue, c[re], Xe);
        }
        return Ue;
      }
      function $l(c) {
        return Un(c) ? c : [];
      }
      function Xl(c) {
        return typeof c == "function" ? c : Tr;
      }
      function Fs(c, _) {
        return Ii(c) ? c : sh(c, _) ? [c] : Tc(on(c));
      }
      var Op = Vi;
      function Us(c, _, R) {
        var re = c.length;
        return R = R === t ? re : R, !_ && R >= re ? c : $r(c, _, R);
      }
      var Qu = xg || function(c) {
        return pn.clearTimeout(c);
      };
      function ec(c, _) {
        if (_)
          return c.slice();
        var R = c.length, re = xu ? xu(R) : new c.constructor(R);
        return c.copy(re), re;
      }
      function Kl(c) {
        var _ = new c.constructor(c.byteLength);
        return new po(_).set(new po(c)), _;
      }
      function Np(c, _) {
        var R = _ ? Kl(c.buffer) : c.buffer;
        return new c.constructor(R, c.byteOffset, c.byteLength);
      }
      function Rp(c) {
        var _ = new c.constructor(c.source, st.exec(c));
        return _.lastIndex = c.lastIndex, _;
      }
      function Dp(c) {
        return Oa ? lt(Oa.call(c)) : {};
      }
      function tc(c, _) {
        var R = _ ? Kl(c.buffer) : c.buffer;
        return new c.constructor(R, c.byteOffset, c.length);
      }
      function ic(c, _) {
        if (c !== _) {
          var R = c !== t, re = c === null, xe = c === c, Le = Ur(c), Ue = _ !== t, Xe = _ === null, ot = _ === _, Ot = Ur(_);
          if (!Xe && !Ot && !Le && c > _ || Le && Ue && ot && !Xe && !Ot || re && Ue && ot || !R && ot || !xe)
            return 1;
          if (!re && !Le && !Ot && c < _ || Ot && R && xe && !re && !Le || Xe && R && xe || !Ue && xe || !ot)
            return -1;
        }
        return 0;
      }
      function zp(c, _, R) {
        for (var re = -1, xe = c.criteria, Le = _.criteria, Ue = xe.length, Xe = R.length; ++re < Ue; ) {
          var ot = ic(xe[re], Le[re]);
          if (ot) {
            if (re >= Xe)
              return ot;
            var Ot = R[re];
            return ot * (Ot == "desc" ? -1 : 1);
          }
        }
        return c.index - _.index;
      }
      function nc(c, _, R, re) {
        for (var xe = -1, Le = c.length, Ue = R.length, Xe = -1, ot = _.length, Ot = Wn(Le - Ue, 0), Nt = Ye(ot + Ot), Ht = !re; ++Xe < ot; )
          Nt[Xe] = _[Xe];
        for (; ++xe < Ue; )
          (Ht || xe < Le) && (Nt[R[xe]] = c[xe]);
        for (; Ot--; )
          Nt[Xe++] = c[xe++];
        return Nt;
      }
      function rc(c, _, R, re) {
        for (var xe = -1, Le = c.length, Ue = -1, Xe = R.length, ot = -1, Ot = _.length, Nt = Wn(Le - Xe, 0), Ht = Ye(Nt + Ot), ii = !re; ++xe < Nt; )
          Ht[xe] = c[xe];
        for (var ai = xe; ++ot < Ot; )
          Ht[ai + ot] = _[ot];
        for (; ++Ue < Xe; )
          (ii || xe < Le) && (Ht[ai + R[Ue]] = c[xe++]);
        return Ht;
      }
      function Mr(c, _) {
        var R = -1, re = c.length;
        for (_ || (_ = Ye(re)); ++R < re; )
          _[R] = c[R];
        return _;
      }
      function vs(c, _, R, re) {
        var xe = !R;
        R || (R = {});
        for (var Le = -1, Ue = _.length; ++Le < Ue; ) {
          var Xe = _[Le], ot = re ? re(R[Xe], c[Xe], Xe, R, c) : t;
          ot === t && (ot = c[Xe]), xe ? Ts(R, Xe, ot) : Na(R, Xe, ot);
        }
        return R;
      }
      function Fp(c, _) {
        return vs(c, rh(c), _);
      }
      function Up(c, _) {
        return vs(c, _c(c), _);
      }
      function ko(c, _) {
        return function(R, re) {
          var xe = Ii(R) ? He : lp, Le = _ ? _() : {};
          return xe(R, c, gi(re, 2), Le);
        };
      }
      function pa(c) {
        return Vi(function(_, R) {
          var re = -1, xe = R.length, Le = xe > 1 ? R[xe - 1] : t, Ue = xe > 2 ? R[2] : t;
          for (Le = c.length > 3 && typeof Le == "function" ? (xe--, Le) : t, Ue && vr(R[0], R[1], Ue) && (Le = xe < 3 ? t : Le, xe = 1), _ = lt(_); ++re < xe; ) {
            var Xe = R[re];
            Xe && c(_, Xe, re, Le);
          }
          return _;
        });
      }
      function sc(c, _) {
        return function(R, re) {
          if (R == null)
            return R;
          if (!Cr(R))
            return c(R, re);
          for (var xe = R.length, Le = _ ? xe : -1, Ue = lt(R); (_ ? Le-- : ++Le < xe) && re(Ue[Le], Le, Ue) !== !1; )
            ;
          return R;
        };
      }
      function ac(c) {
        return function(_, R, re) {
          for (var xe = -1, Le = lt(_), Ue = re(_), Xe = Ue.length; Xe--; ) {
            var ot = Ue[c ? Xe : ++xe];
            if (R(Le[ot], ot, Le) === !1)
              break;
          }
          return _;
        };
      }
      function Vp(c, _, R) {
        var re = _ & Q, xe = Ua(c);
        function Le() {
          var Ue = this && this !== pn && this instanceof Le ? xe : c;
          return Ue.apply(re ? R : this, arguments);
        }
        return Le;
      }
      function oc(c) {
        return function(_) {
          _ = on(_);
          var R = Kn(_) ? Tn(_) : t, re = R ? R[0] : _.charAt(0), xe = R ? Us(R, 1).join("") : _.slice(1);
          return re[c]() + xe;
        };
      }
      function ma(c) {
        return function(_) {
          return bi(af(sf(_).replace(ue, "")), c, "");
        };
      }
      function Ua(c) {
        return function() {
          var _ = arguments;
          switch (_.length) {
            case 0:
              return new c();
            case 1:
              return new c(_[0]);
            case 2:
              return new c(_[0], _[1]);
            case 3:
              return new c(_[0], _[1], _[2]);
            case 4:
              return new c(_[0], _[1], _[2], _[3]);
            case 5:
              return new c(_[0], _[1], _[2], _[3], _[4]);
            case 6:
              return new c(_[0], _[1], _[2], _[3], _[4], _[5]);
            case 7:
              return new c(_[0], _[1], _[2], _[3], _[4], _[5], _[6]);
          }
          var R = ga(c.prototype), re = c.apply(R, _);
          return Ln(re) ? re : R;
        };
      }
      function Hp(c, _, R) {
        var re = Ua(c);
        function xe() {
          for (var Le = arguments.length, Ue = Ye(Le), Xe = Le, ot = _a(xe); Xe--; )
            Ue[Xe] = arguments[Xe];
          var Ot = Le < 3 && Ue[0] !== ot && Ue[Le - 1] !== ot ? [] : jn(Ue, ot);
          if (Le -= Ot.length, Le < R)
            return fc(
              c,
              _,
              Eo,
              xe.placeholder,
              t,
              Ue,
              Ot,
              t,
              t,
              R - Le
            );
          var Nt = this && this !== pn && this instanceof xe ? re : c;
          return be(Nt, this, Ue);
        }
        return xe;
      }
      function lc(c) {
        return function(_, R, re) {
          var xe = lt(_);
          if (!Cr(_)) {
            var Le = gi(R, 3);
            _ = Qn(_), R = function(Xe) {
              return Le(xe[Xe], Xe, xe);
            };
          }
          var Ue = c(_, R, re);
          return Ue > -1 ? xe[Le ? _[Ue] : Ue] : t;
        };
      }
      function hc(c) {
        return Bs(function(_) {
          var R = _.length, re = R, xe = Zr.prototype.thru;
          for (c && _.reverse(); re--; ) {
            var Le = _[re];
            if (typeof Le != "function")
              throw new Vt(h);
            if (xe && !Ue && No(Le) == "wrapper")
              var Ue = new Zr([], !0);
          }
          for (re = Ue ? re : R; ++re < R; ) {
            Le = _[re];
            var Xe = No(Le), ot = Xe == "wrapper" ? ih(Le) : t;
            ot && ah(ot[0]) && ot[1] == (Z | J | fe | qe) && !ot[4].length && ot[9] == 1 ? Ue = Ue[No(ot[0])].apply(Ue, ot[3]) : Ue = Le.length == 1 && ah(Le) ? Ue[Xe]() : Ue.thru(Le);
          }
          return function() {
            var Ot = arguments, Nt = Ot[0];
            if (Ue && Ot.length == 1 && Ii(Nt))
              return Ue.plant(Nt).value();
            for (var Ht = 0, ii = R ? _[Ht].apply(this, Ot) : Nt; ++Ht < R; )
              ii = _[Ht].call(this, ii);
            return ii;
          };
        });
      }
      function Eo(c, _, R, re, xe, Le, Ue, Xe, ot, Ot) {
        var Nt = _ & Z, Ht = _ & Q, ii = _ & D, ai = _ & (J | he), _i = _ & Oe, zi = ii ? t : Ua(c);
        function vi() {
          for (var Yi = arguments.length, $i = Ye(Yi), Vr = Yi; Vr--; )
            $i[Vr] = arguments[Vr];
          if (ai)
            var yr = _a(vi), Hr = ui($i, yr);
          if (re && ($i = nc($i, re, xe, ai)), Le && ($i = rc($i, Le, Ue, ai)), Yi -= Hr, ai && Yi < Ot) {
            var Vn = jn($i, yr);
            return fc(
              c,
              _,
              Eo,
              vi.placeholder,
              R,
              $i,
              Vn,
              Xe,
              ot,
              Ot - Yi
            );
          }
          var ls = Ht ? R : this, Ps = ii ? ls[c] : c;
          return Yi = $i.length, Xe ? $i = lm($i, Xe) : _i && Yi > 1 && $i.reverse(), Nt && ot < Yi && ($i.length = ot), this && this !== pn && this instanceof vi && (Ps = zi || Ua(Ps)), Ps.apply(ls, $i);
        }
        return vi;
      }
      function uc(c, _) {
        return function(R, re) {
          return mp(R, c, _(re), {});
        };
      }
      function Io(c, _) {
        return function(R, re) {
          var xe;
          if (R === t && re === t)
            return _;
          if (R !== t && (xe = R), re !== t) {
            if (xe === t)
              return re;
            typeof R == "string" || typeof re == "string" ? (R = Fr(R), re = Fr(re)) : (R = $u(R), re = $u(re)), xe = c(R, re);
          }
          return xe;
        };
      }
      function Jl(c) {
        return Bs(function(_) {
          return _ = ti(_, jt(gi())), Vi(function(R) {
            var re = this;
            return c(_, function(xe) {
              return be(xe, re, R);
            });
          });
        });
      }
      function Po(c, _) {
        _ = _ === t ? " " : Fr(_);
        var R = _.length;
        if (R < 2)
          return R ? jl(_, c) : _;
        var re = jl(_, yo(c / Sr(_)));
        return Kn(_) ? Us(Tn(re), 0, c).join("") : re.slice(0, c);
      }
      function Yp(c, _, R, re) {
        var xe = _ & Q, Le = Ua(c);
        function Ue() {
          for (var Xe = -1, ot = arguments.length, Ot = -1, Nt = re.length, Ht = Ye(Nt + ot), ii = this && this !== pn && this instanceof Ue ? Le : c; ++Ot < Nt; )
            Ht[Ot] = re[Ot];
          for (; ot--; )
            Ht[Ot++] = arguments[++Xe];
          return be(ii, xe ? R : this, Ht);
        }
        return Ue;
      }
      function cc(c) {
        return function(_, R, re) {
          return re && typeof re != "number" && vr(_, R, re) && (R = re = t), _ = Is(_), R === t ? (R = _, _ = 0) : R = Is(R), re = re === t ? _ < R ? 1 : -1 : Is(re), Lp(_, R, re, c);
        };
      }
      function Oo(c) {
        return function(_, R) {
          return typeof _ == "string" && typeof R == "string" || (_ = Kr(_), R = Kr(R)), c(_, R);
        };
      }
      function fc(c, _, R, re, xe, Le, Ue, Xe, ot, Ot) {
        var Nt = _ & J, Ht = Nt ? Ue : t, ii = Nt ? t : Ue, ai = Nt ? Le : t, _i = Nt ? t : Le;
        _ |= Nt ? fe : X, _ &= ~(Nt ? X : fe), _ & ee || (_ &= ~(Q | D));
        var zi = [
          c,
          _,
          xe,
          ai,
          Ht,
          _i,
          ii,
          Xe,
          ot,
          Ot
        ], vi = R.apply(t, zi);
        return ah(c) && Mc(vi, zi), vi.placeholder = re, Cc(vi, c, _);
      }
      function Ql(c) {
        var _ = ke[c];
        return function(R, re) {
          if (R = Kr(R), re = re == null ? 0 : hr(Di(re), 292), re && Cu(R)) {
            var xe = (on(R) + "e").split("e"), Le = _(xe[0] + "e" + (+xe[1] + re));
            return xe = (on(Le) + "e").split("e"), +(xe[0] + "e" + (+xe[1] - re));
          }
          return _(R);
        };
      }
      var Gp = fa && 1 / pr(new fa([, -0]))[1] == ht ? function(c) {
        return new fa(c);
      } : xh;
      function dc(c) {
        return function(_) {
          var R = ur(_);
          return R == pe ? Jn(_) : R == ft ? Ui(_) : Si(_, c(_));
        };
      }
      function Ls(c, _, R, re, xe, Le, Ue, Xe) {
        var ot = _ & D;
        if (!ot && typeof c != "function")
          throw new Vt(h);
        var Ot = re ? re.length : 0;
        if (Ot || (_ &= ~(fe | X), re = xe = t), Ue = Ue === t ? Ue : Wn(Di(Ue), 0), Xe = Xe === t ? Xe : Di(Xe), Ot -= xe ? xe.length : 0, _ & X) {
          var Nt = re, Ht = xe;
          re = xe = t;
        }
        var ii = ot ? t : ih(c), ai = [
          c,
          _,
          R,
          re,
          xe,
          Nt,
          Ht,
          Le,
          Ue,
          Xe
        ];
        if (ii && sm(ai, ii), c = ai[0], _ = ai[1], R = ai[2], re = ai[3], xe = ai[4], Xe = ai[9] = ai[9] === t ? ot ? 0 : c.length : Wn(ai[9] - Ot, 0), !Xe && _ & (J | he) && (_ &= ~(J | he)), !_ || _ == Q)
          var _i = Vp(c, _, R);
        else
          _ == J || _ == he ? _i = Hp(c, _, Xe) : (_ == fe || _ == (Q | fe)) && !xe.length ? _i = Yp(c, _, R, re) : _i = Eo.apply(t, ai);
        var zi = ii ? Zu : Mc;
        return Cc(zi(_i, ai), c, _);
      }
      function gc(c, _, R, re) {
        return c === t || os(c, vn[R]) && !Li.call(re, R) ? _ : c;
      }
      function pc(c, _, R, re, xe, Le) {
        return Ln(c) && Ln(_) && (Le.set(_, c), To(c, _, t, pc, Le), Le.delete(_)), c;
      }
      function jp(c) {
        return Ya(c) ? t : c;
      }
      function mc(c, _, R, re, xe, Le) {
        var Ue = R & W, Xe = c.length, ot = _.length;
        if (Xe != ot && !(Ue && ot > Xe))
          return !1;
        var Ot = Le.get(c), Nt = Le.get(_);
        if (Ot && Nt)
          return Ot == _ && Nt == c;
        var Ht = -1, ii = !0, ai = R & U ? new Js() : t;
        for (Le.set(c, _), Le.set(_, c); ++Ht < Xe; ) {
          var _i = c[Ht], zi = _[Ht];
          if (re)
            var vi = Ue ? re(zi, _i, Ht, _, c, Le) : re(_i, zi, Ht, c, _, Le);
          if (vi !== t) {
            if (vi)
              continue;
            ii = !1;
            break;
          }
          if (ai) {
            if (!mn(_, function(Yi, $i) {
              if (!hi(ai, $i) && (_i === Yi || xe(_i, Yi, R, re, Le)))
                return ai.push($i);
            })) {
              ii = !1;
              break;
            }
          } else if (!(_i === zi || xe(_i, zi, R, re, Le))) {
            ii = !1;
            break;
          }
        }
        return Le.delete(c), Le.delete(_), ii;
      }
      function Wp(c, _, R, re, xe, Le, Ue) {
        switch (R) {
          case s:
            if (c.byteLength != _.byteLength || c.byteOffset != _.byteOffset)
              return !1;
            c = c.buffer, _ = _.buffer;
          case r:
            return !(c.byteLength != _.byteLength || !Le(new po(c), new po(_)));
          case oi:
          case Zt:
          case Lt:
            return os(+c, +_);
          case Qt:
            return c.name == _.name && c.message == _.message;
          case Et:
          case tt:
            return c == _ + "";
          case pe:
            var Xe = Jn;
          case ft:
            var ot = re & W;
            if (Xe || (Xe = pr), c.size != _.size && !ot)
              return !1;
            var Ot = Ue.get(c);
            if (Ot)
              return Ot == _;
            re |= U, Ue.set(c, _);
            var Nt = mc(Xe(c), Xe(_), re, xe, Le, Ue);
            return Ue.delete(c), Nt;
          case _t:
            if (Oa)
              return Oa.call(c) == Oa.call(_);
        }
        return !1;
      }
      function Zp(c, _, R, re, xe, Le) {
        var Ue = R & W, Xe = eh(c), ot = Xe.length, Ot = eh(_), Nt = Ot.length;
        if (ot != Nt && !Ue)
          return !1;
        for (var Ht = ot; Ht--; ) {
          var ii = Xe[Ht];
          if (!(Ue ? ii in _ : Li.call(_, ii)))
            return !1;
        }
        var ai = Le.get(c), _i = Le.get(_);
        if (ai && _i)
          return ai == _ && _i == c;
        var zi = !0;
        Le.set(c, _), Le.set(_, c);
        for (var vi = Ue; ++Ht < ot; ) {
          ii = Xe[Ht];
          var Yi = c[ii], $i = _[ii];
          if (re)
            var Vr = Ue ? re($i, Yi, ii, _, c, Le) : re(Yi, $i, ii, c, _, Le);
          if (!(Vr === t ? Yi === $i || xe(Yi, $i, R, re, Le) : Vr)) {
            zi = !1;
            break;
          }
          vi || (vi = ii == "constructor");
        }
        if (zi && !vi) {
          var yr = c.constructor, Hr = _.constructor;
          yr != Hr && "constructor" in c && "constructor" in _ && !(typeof yr == "function" && yr instanceof yr && typeof Hr == "function" && Hr instanceof Hr) && (zi = !1);
        }
        return Le.delete(c), Le.delete(_), zi;
      }
      function Bs(c) {
        return lh(wc(c, t, Ec), c + "");
      }
      function eh(c) {
        return Ru(c, Qn, rh);
      }
      function th(c) {
        return Ru(c, Ar, _c);
      }
      var ih = xo ? function(c) {
        return xo.get(c);
      } : xh;
      function No(c) {
        for (var _ = c.name + "", R = da[_], re = Li.call(da, _) ? R.length : 0; re--; ) {
          var xe = R[re], Le = xe.func;
          if (Le == null || Le == c)
            return xe.name;
        }
        return _;
      }
      function _a(c) {
        var _ = Li.call(Ce, "placeholder") ? Ce : c;
        return _.placeholder;
      }
      function gi() {
        var c = Ce.iteratee || yh;
        return c = c === yh ? Fu : c, arguments.length ? c(arguments[0], arguments[1]) : c;
      }
      function Ro(c, _) {
        var R = c.__data__;
        return tm(_) ? R[typeof _ == "string" ? "string" : "hash"] : R.map;
      }
      function nh(c) {
        for (var _ = Qn(c), R = _.length; R--; ) {
          var re = _[R], xe = c[re];
          _[R] = [re, xe, bc(xe)];
        }
        return _;
      }
      function ta(c, _) {
        var R = jr(c, _);
        return zu(R) ? R : t;
      }
      function qp(c) {
        var _ = Li.call(c, Xs), R = c[Xs];
        try {
          c[Xs] = t;
          var re = !0;
        } catch {
        }
        var xe = fo.call(c);
        return re && (_ ? c[Xs] = R : delete c[Xs]), xe;
      }
      var rh = El ? function(c) {
        return c == null ? [] : (c = lt(c), Bt(El(c), function(_) {
          return Su.call(c, _);
        }));
      } : wh, _c = El ? function(c) {
        for (var _ = []; c; )
          wi(_, rh(c)), c = mo(c);
        return _;
      } : wh, ur = _r;
      (Il && ur(new Il(new ArrayBuffer(1))) != s || Ea && ur(new Ea()) != pe || Pl && ur(Pl.resolve()) != Ie || fa && ur(new fa()) != ft || Ia && ur(new Ia()) != Ve) && (ur = function(c) {
        var _ = _r(c), R = _ == Ne ? c.constructor : t, re = R ? ia(R) : "";
        if (re)
          switch (re) {
            case kg:
              return s;
            case Eg:
              return pe;
            case Ig:
              return Ie;
            case Pg:
              return ft;
            case Og:
              return Ve;
          }
        return _;
      });
      function $p(c, _, R) {
        for (var re = -1, xe = R.length; ++re < xe; ) {
          var Le = R[re], Ue = Le.size;
          switch (Le.type) {
            case "drop":
              c += Ue;
              break;
            case "dropRight":
              _ -= Ue;
              break;
            case "take":
              _ = hr(_, c + Ue);
              break;
            case "takeRight":
              c = Wn(c, _ - Ue);
              break;
          }
        }
        return { start: c, end: _ };
      }
      function Xp(c) {
        var _ = c.match(ve);
        return _ ? _[1].split(we) : [];
      }
      function vc(c, _, R) {
        _ = Fs(_, c);
        for (var re = -1, xe = _.length, Le = !1; ++re < xe; ) {
          var Ue = ys(_[re]);
          if (!(Le = c != null && R(c, Ue)))
            break;
          c = c[Ue];
        }
        return Le || ++re != xe ? Le : (xe = c == null ? 0 : c.length, !!xe && Yo(xe) && ks(Ue, xe) && (Ii(c) || na(c)));
      }
      function Kp(c) {
        var _ = c.length, R = new c.constructor(_);
        return _ && typeof c[0] == "string" && Li.call(c, "index") && (R.index = c.index, R.input = c.input), R;
      }
      function yc(c) {
        return typeof c.constructor == "function" && !Va(c) ? ga(mo(c)) : {};
      }
      function Jp(c, _, R) {
        var re = c.constructor;
        switch (_) {
          case r:
            return Kl(c);
          case oi:
          case Zt:
            return new re(+c);
          case s:
            return Np(c, R);
          case l:
          case u:
          case d:
          case p:
          case m:
          case y:
          case S:
          case L:
          case E:
            return tc(c, R);
          case pe:
            return new re();
          case Lt:
          case tt:
            return new re(c);
          case Et:
            return Rp(c);
          case ft:
            return new re();
          case _t:
            return Dp(c);
        }
      }
      function Qp(c, _) {
        var R = _.length;
        if (!R)
          return c;
        var re = R - 1;
        return _[re] = (R > 1 ? "& " : "") + _[re], _ = _.join(R > 2 ? ", " : " "), c.replace(de, `{
/* [wrapped with ` + _ + `] */
`);
      }
      function em(c) {
        return Ii(c) || na(c) || !!(Mu && c && c[Mu]);
      }
      function ks(c, _) {
        var R = typeof c;
        return _ = _ ?? Gt, !!_ && (R == "number" || R != "symbol" && yt.test(c)) && c > -1 && c % 1 == 0 && c < _;
      }
      function vr(c, _, R) {
        if (!Ln(R))
          return !1;
        var re = typeof _;
        return (re == "number" ? Cr(R) && ks(_, R.length) : re == "string" && _ in R) ? os(R[_], c) : !1;
      }
      function sh(c, _) {
        if (Ii(c))
          return !1;
        var R = typeof c;
        return R == "number" || R == "symbol" || R == "boolean" || c == null || Ur(c) ? !0 : H.test(c) || !q.test(c) || _ != null && c in lt(_);
      }
      function tm(c) {
        var _ = typeof c;
        return _ == "string" || _ == "number" || _ == "symbol" || _ == "boolean" ? c !== "__proto__" : c === null;
      }
      function ah(c) {
        var _ = No(c), R = Ce[_];
        if (typeof R != "function" || !(_ in Wi.prototype))
          return !1;
        if (c === R)
          return !0;
        var re = ih(R);
        return !!re && c === re[0];
      }
      function im(c) {
        return !!bu && bu in c;
      }
      var nm = wn ? Es : Sh;
      function Va(c) {
        var _ = c && c.constructor, R = typeof _ == "function" && _.prototype || vn;
        return c === R;
      }
      function bc(c) {
        return c === c && !Ln(c);
      }
      function xc(c, _) {
        return function(R) {
          return R == null ? !1 : R[c] === _ && (_ !== t || c in lt(R));
        };
      }
      function rm(c) {
        var _ = Vo(c, function(re) {
          return R.size === x && R.clear(), re;
        }), R = _.cache;
        return _;
      }
      function sm(c, _) {
        var R = c[1], re = _[1], xe = R | re, Le = xe < (Q | D | Z), Ue = re == Z && R == J || re == Z && R == qe && c[7].length <= _[8] || re == (Z | qe) && _[7].length <= _[8] && R == J;
        if (!(Le || Ue))
          return c;
        re & Q && (c[2] = _[2], xe |= R & Q ? 0 : ee);
        var Xe = _[3];
        if (Xe) {
          var ot = c[3];
          c[3] = ot ? nc(ot, Xe, _[4]) : Xe, c[4] = ot ? jn(c[3], k) : _[4];
        }
        return Xe = _[5], Xe && (ot = c[5], c[5] = ot ? rc(ot, Xe, _[6]) : Xe, c[6] = ot ? jn(c[5], k) : _[6]), Xe = _[7], Xe && (c[7] = Xe), re & Z && (c[8] = c[8] == null ? _[8] : hr(c[8], _[8])), c[9] == null && (c[9] = _[9]), c[0] = _[0], c[1] = xe, c;
      }
      function am(c) {
        var _ = [];
        if (c != null)
          for (var R in lt(c))
            _.push(R);
        return _;
      }
      function om(c) {
        return fo.call(c);
      }
      function wc(c, _, R) {
        return _ = Wn(_ === t ? c.length - 1 : _, 0), function() {
          for (var re = arguments, xe = -1, Le = Wn(re.length - _, 0), Ue = Ye(Le); ++xe < Le; )
            Ue[xe] = re[_ + xe];
          xe = -1;
          for (var Xe = Ye(_ + 1); ++xe < _; )
            Xe[xe] = re[xe];
          return Xe[_] = R(Ue), be(c, this, Xe);
        };
      }
      function Sc(c, _) {
        return _.length < 2 ? c : ea(c, $r(_, 0, -1));
      }
      function lm(c, _) {
        for (var R = c.length, re = hr(_.length, R), xe = Mr(c); re--; ) {
          var Le = _[re];
          c[re] = ks(Le, R) ? xe[Le] : t;
        }
        return c;
      }
      function oh(c, _) {
        if (!(_ === "constructor" && typeof c[_] == "function") && _ != "__proto__")
          return c[_];
      }
      var Mc = Ac(Zu), Ha = Sg || function(c, _) {
        return pn.setTimeout(c, _);
      }, lh = Ac(Ep);
      function Cc(c, _, R) {
        var re = _ + "";
        return lh(c, Qp(re, hm(Xp(re), R)));
      }
      function Ac(c) {
        var _ = 0, R = 0;
        return function() {
          var re = Tg(), xe = Ze - (re - R);
          if (R = re, xe > 0) {
            if (++_ >= Te)
              return arguments[0];
          } else
            _ = 0;
          return c.apply(t, arguments);
        };
      }
      function Do(c, _) {
        var R = -1, re = c.length, xe = re - 1;
        for (_ = _ === t ? re : _; ++R < _; ) {
          var Le = Gl(R, xe), Ue = c[Le];
          c[Le] = c[R], c[R] = Ue;
        }
        return c.length = _, c;
      }
      var Tc = rm(function(c) {
        var _ = [];
        return c.charCodeAt(0) === 46 && _.push(""), c.replace(te, function(R, re, xe, Le) {
          _.push(xe ? Le.replace(Ge, "$1") : re || R);
        }), _;
      });
      function ys(c) {
        if (typeof c == "string" || Ur(c))
          return c;
        var _ = c + "";
        return _ == "0" && 1 / c == -ht ? "-0" : _;
      }
      function ia(c) {
        if (c != null) {
          try {
            return mr.call(c);
          } catch {
          }
          try {
            return c + "";
          } catch {
          }
        }
        return "";
      }
      function hm(c, _) {
        return De($t, function(R) {
          var re = "_." + R[0];
          _ & R[1] && !dt(c, re) && c.push(re);
        }), c.sort();
      }
      function Lc(c) {
        if (c instanceof Wi)
          return c.clone();
        var _ = new Zr(c.__wrapped__, c.__chain__);
        return _.__actions__ = Mr(c.__actions__), _.__index__ = c.__index__, _.__values__ = c.__values__, _;
      }
      function um(c, _, R) {
        (R ? vr(c, _, R) : _ === t) ? _ = 1 : _ = Wn(Di(_), 0);
        var re = c == null ? 0 : c.length;
        if (!re || _ < 1)
          return [];
        for (var xe = 0, Le = 0, Ue = Ye(yo(re / _)); xe < re; )
          Ue[Le++] = $r(c, xe, xe += _);
        return Ue;
      }
      function cm(c) {
        for (var _ = -1, R = c == null ? 0 : c.length, re = 0, xe = []; ++_ < R; ) {
          var Le = c[_];
          Le && (xe[re++] = Le);
        }
        return xe;
      }
      function fm() {
        var c = arguments.length;
        if (!c)
          return [];
        for (var _ = Ye(c - 1), R = arguments[0], re = c; re--; )
          _[re - 1] = arguments[re];
        return wi(Ii(R) ? Mr(R) : [R], nr(_, 1));
      }
      var dm = Vi(function(c, _) {
        return Un(c) ? Ra(c, nr(_, 1, Un, !0)) : [];
      }), gm = Vi(function(c, _) {
        var R = Xr(_);
        return Un(R) && (R = t), Un(c) ? Ra(c, nr(_, 1, Un, !0), gi(R, 2)) : [];
      }), pm = Vi(function(c, _) {
        var R = Xr(_);
        return Un(R) && (R = t), Un(c) ? Ra(c, nr(_, 1, Un, !0), t, R) : [];
      });
      function mm(c, _, R) {
        var re = c == null ? 0 : c.length;
        return re ? (_ = R || _ === t ? 1 : Di(_), $r(c, _ < 0 ? 0 : _, re)) : [];
      }
      function _m(c, _, R) {
        var re = c == null ? 0 : c.length;
        return re ? (_ = R || _ === t ? 1 : Di(_), _ = re - _, $r(c, 0, _ < 0 ? 0 : _)) : [];
      }
      function vm(c, _) {
        return c && c.length ? Bo(c, gi(_, 3), !0, !0) : [];
      }
      function ym(c, _) {
        return c && c.length ? Bo(c, gi(_, 3), !0) : [];
      }
      function bm(c, _, R, re) {
        var xe = c == null ? 0 : c.length;
        return xe ? (R && typeof R != "number" && vr(c, _, R) && (R = 0, re = xe), fp(c, _, R, re)) : [];
      }
      function Bc(c, _, R) {
        var re = c == null ? 0 : c.length;
        if (!re)
          return -1;
        var xe = R == null ? 0 : Di(R);
        return xe < 0 && (xe = Wn(re + xe, 0)), Oi(c, gi(_, 3), xe);
      }
      function kc(c, _, R) {
        var re = c == null ? 0 : c.length;
        if (!re)
          return -1;
        var xe = re - 1;
        return R !== t && (xe = Di(R), xe = R < 0 ? Wn(re + xe, 0) : hr(xe, re - 1)), Oi(c, gi(_, 3), xe, !0);
      }
      function Ec(c) {
        var _ = c == null ? 0 : c.length;
        return _ ? nr(c, 1) : [];
      }
      function xm(c) {
        var _ = c == null ? 0 : c.length;
        return _ ? nr(c, ht) : [];
      }
      function wm(c, _) {
        var R = c == null ? 0 : c.length;
        return R ? (_ = _ === t ? 1 : Di(_), nr(c, _)) : [];
      }
      function Sm(c) {
        for (var _ = -1, R = c == null ? 0 : c.length, re = {}; ++_ < R; ) {
          var xe = c[_];
          re[xe[0]] = xe[1];
        }
        return re;
      }
      function Ic(c) {
        return c && c.length ? c[0] : t;
      }
      function Mm(c, _, R) {
        var re = c == null ? 0 : c.length;
        if (!re)
          return -1;
        var xe = R == null ? 0 : Di(R);
        return xe < 0 && (xe = Wn(re + xe, 0)), qi(c, _, xe);
      }
      function Cm(c) {
        var _ = c == null ? 0 : c.length;
        return _ ? $r(c, 0, -1) : [];
      }
      var Am = Vi(function(c) {
        var _ = ti(c, $l);
        return _.length && _[0] === c[0] ? Fl(_) : [];
      }), Tm = Vi(function(c) {
        var _ = Xr(c), R = ti(c, $l);
        return _ === Xr(R) ? _ = t : R.pop(), R.length && R[0] === c[0] ? Fl(R, gi(_, 2)) : [];
      }), Lm = Vi(function(c) {
        var _ = Xr(c), R = ti(c, $l);
        return _ = typeof _ == "function" ? _ : t, _ && R.pop(), R.length && R[0] === c[0] ? Fl(R, t, _) : [];
      });
      function Bm(c, _) {
        return c == null ? "" : Cg.call(c, _);
      }
      function Xr(c) {
        var _ = c == null ? 0 : c.length;
        return _ ? c[_ - 1] : t;
      }
      function km(c, _, R) {
        var re = c == null ? 0 : c.length;
        if (!re)
          return -1;
        var xe = re;
        return R !== t && (xe = Di(R), xe = xe < 0 ? Wn(re + xe, 0) : hr(xe, re - 1)), _ === _ ? ms(c, _, xe) : Oi(c, ar, xe, !0);
      }
      function Em(c, _) {
        return c && c.length ? Yu(c, Di(_)) : t;
      }
      var Im = Vi(Pc);
      function Pc(c, _) {
        return c && c.length && _ && _.length ? Yl(c, _) : c;
      }
      function Pm(c, _, R) {
        return c && c.length && _ && _.length ? Yl(c, _, gi(R, 2)) : c;
      }
      function Om(c, _, R) {
        return c && c.length && _ && _.length ? Yl(c, _, t, R) : c;
      }
      var Nm = Bs(function(c, _) {
        var R = c == null ? 0 : c.length, re = Nl(c, _);
        return Wu(c, ti(_, function(xe) {
          return ks(xe, R) ? +xe : xe;
        }).sort(ic)), re;
      });
      function Rm(c, _) {
        var R = [];
        if (!(c && c.length))
          return R;
        var re = -1, xe = [], Le = c.length;
        for (_ = gi(_, 3); ++re < Le; ) {
          var Ue = c[re];
          _(Ue, re, c) && (R.push(Ue), xe.push(re));
        }
        return Wu(c, xe), R;
      }
      function hh(c) {
        return c == null ? c : Bg.call(c);
      }
      function Dm(c, _, R) {
        var re = c == null ? 0 : c.length;
        return re ? (R && typeof R != "number" && vr(c, _, R) ? (_ = 0, R = re) : (_ = _ == null ? 0 : Di(_), R = R === t ? re : Di(R)), $r(c, _, R)) : [];
      }
      function zm(c, _) {
        return Lo(c, _);
      }
      function Fm(c, _, R) {
        return Wl(c, _, gi(R, 2));
      }
      function Um(c, _) {
        var R = c == null ? 0 : c.length;
        if (R) {
          var re = Lo(c, _);
          if (re < R && os(c[re], _))
            return re;
        }
        return -1;
      }
      function Vm(c, _) {
        return Lo(c, _, !0);
      }
      function Hm(c, _, R) {
        return Wl(c, _, gi(R, 2), !0);
      }
      function Ym(c, _) {
        var R = c == null ? 0 : c.length;
        if (R) {
          var re = Lo(c, _, !0) - 1;
          if (os(c[re], _))
            return re;
        }
        return -1;
      }
      function Gm(c) {
        return c && c.length ? qu(c) : [];
      }
      function jm(c, _) {
        return c && c.length ? qu(c, gi(_, 2)) : [];
      }
      function Wm(c) {
        var _ = c == null ? 0 : c.length;
        return _ ? $r(c, 1, _) : [];
      }
      function Zm(c, _, R) {
        return c && c.length ? (_ = R || _ === t ? 1 : Di(_), $r(c, 0, _ < 0 ? 0 : _)) : [];
      }
      function qm(c, _, R) {
        var re = c == null ? 0 : c.length;
        return re ? (_ = R || _ === t ? 1 : Di(_), _ = re - _, $r(c, _ < 0 ? 0 : _, re)) : [];
      }
      function $m(c, _) {
        return c && c.length ? Bo(c, gi(_, 3), !1, !0) : [];
      }
      function Xm(c, _) {
        return c && c.length ? Bo(c, gi(_, 3)) : [];
      }
      var Km = Vi(function(c) {
        return zs(nr(c, 1, Un, !0));
      }), Jm = Vi(function(c) {
        var _ = Xr(c);
        return Un(_) && (_ = t), zs(nr(c, 1, Un, !0), gi(_, 2));
      }), Qm = Vi(function(c) {
        var _ = Xr(c);
        return _ = typeof _ == "function" ? _ : t, zs(nr(c, 1, Un, !0), t, _);
      });
      function e_(c) {
        return c && c.length ? zs(c) : [];
      }
      function t_(c, _) {
        return c && c.length ? zs(c, gi(_, 2)) : [];
      }
      function i_(c, _) {
        return _ = typeof _ == "function" ? _ : t, c && c.length ? zs(c, t, _) : [];
      }
      function uh(c) {
        if (!(c && c.length))
          return [];
        var _ = 0;
        return c = Bt(c, function(R) {
          if (Un(R))
            return _ = Wn(R.length, _), !0;
        }), Rr(_, function(R) {
          return ti(c, gr(R));
        });
      }
      function Oc(c, _) {
        if (!(c && c.length))
          return [];
        var R = uh(c);
        return _ == null ? R : ti(R, function(re) {
          return be(_, t, re);
        });
      }
      var n_ = Vi(function(c, _) {
        return Un(c) ? Ra(c, _) : [];
      }), r_ = Vi(function(c) {
        return ql(Bt(c, Un));
      }), s_ = Vi(function(c) {
        var _ = Xr(c);
        return Un(_) && (_ = t), ql(Bt(c, Un), gi(_, 2));
      }), a_ = Vi(function(c) {
        var _ = Xr(c);
        return _ = typeof _ == "function" ? _ : t, ql(Bt(c, Un), t, _);
      }), o_ = Vi(uh);
      function l_(c, _) {
        return Ju(c || [], _ || [], Na);
      }
      function h_(c, _) {
        return Ju(c || [], _ || [], Fa);
      }
      var u_ = Vi(function(c) {
        var _ = c.length, R = _ > 1 ? c[_ - 1] : t;
        return R = typeof R == "function" ? (c.pop(), R) : t, Oc(c, R);
      });
      function Nc(c) {
        var _ = Ce(c);
        return _.__chain__ = !0, _;
      }
      function c_(c, _) {
        return _(c), c;
      }
      function zo(c, _) {
        return _(c);
      }
      var f_ = Bs(function(c) {
        var _ = c.length, R = _ ? c[0] : 0, re = this.__wrapped__, xe = function(Le) {
          return Nl(Le, c);
        };
        return _ > 1 || this.__actions__.length || !(re instanceof Wi) || !ks(R) ? this.thru(xe) : (re = re.slice(R, +R + (_ ? 1 : 0)), re.__actions__.push({
          func: zo,
          args: [xe],
          thisArg: t
        }), new Zr(re, this.__chain__).thru(function(Le) {
          return _ && !Le.length && Le.push(t), Le;
        }));
      });
      function d_() {
        return Nc(this);
      }
      function g_() {
        return new Zr(this.value(), this.__chain__);
      }
      function p_() {
        this.__values__ === t && (this.__values__ = $c(this.value()));
        var c = this.__index__ >= this.__values__.length, _ = c ? t : this.__values__[this.__index__++];
        return { done: c, value: _ };
      }
      function m_() {
        return this;
      }
      function __(c) {
        for (var _, R = this; R instanceof So; ) {
          var re = Lc(R);
          re.__index__ = 0, re.__values__ = t, _ ? xe.__wrapped__ = re : _ = re;
          var xe = re;
          R = R.__wrapped__;
        }
        return xe.__wrapped__ = c, _;
      }
      function v_() {
        var c = this.__wrapped__;
        if (c instanceof Wi) {
          var _ = c;
          return this.__actions__.length && (_ = new Wi(this)), _ = _.reverse(), _.__actions__.push({
            func: zo,
            args: [hh],
            thisArg: t
          }), new Zr(_, this.__chain__);
        }
        return this.thru(hh);
      }
      function y_() {
        return Ku(this.__wrapped__, this.__actions__);
      }
      var b_ = ko(function(c, _, R) {
        Li.call(c, R) ? ++c[R] : Ts(c, R, 1);
      });
      function x_(c, _, R) {
        var re = Ii(c) ? Ct : cp;
        return R && vr(c, _, R) && (_ = t), re(c, gi(_, 3));
      }
      function w_(c, _) {
        var R = Ii(c) ? Bt : Ou;
        return R(c, gi(_, 3));
      }
      var S_ = lc(Bc), M_ = lc(kc);
      function C_(c, _) {
        return nr(Fo(c, _), 1);
      }
      function A_(c, _) {
        return nr(Fo(c, _), ht);
      }
      function T_(c, _, R) {
        return R = R === t ? 1 : Di(R), nr(Fo(c, _), R);
      }
      function Rc(c, _) {
        var R = Ii(c) ? De : Ds;
        return R(c, gi(_, 3));
      }
      function Dc(c, _) {
        var R = Ii(c) ? Je : Pu;
        return R(c, gi(_, 3));
      }
      var L_ = ko(function(c, _, R) {
        Li.call(c, R) ? c[R].push(_) : Ts(c, R, [_]);
      });
      function B_(c, _, R, re) {
        c = Cr(c) ? c : ya(c), R = R && !re ? Di(R) : 0;
        var xe = c.length;
        return R < 0 && (R = Wn(xe + R, 0)), Go(c) ? R <= xe && c.indexOf(_, R) > -1 : !!xe && qi(c, _, R) > -1;
      }
      var k_ = Vi(function(c, _, R) {
        var re = -1, xe = typeof _ == "function", Le = Cr(c) ? Ye(c.length) : [];
        return Ds(c, function(Ue) {
          Le[++re] = xe ? be(_, Ue, R) : Da(Ue, _, R);
        }), Le;
      }), E_ = ko(function(c, _, R) {
        Ts(c, R, _);
      });
      function Fo(c, _) {
        var R = Ii(c) ? ti : Uu;
        return R(c, gi(_, 3));
      }
      function I_(c, _, R, re) {
        return c == null ? [] : (Ii(_) || (_ = _ == null ? [] : [_]), R = re ? t : R, Ii(R) || (R = R == null ? [] : [R]), Gu(c, _, R));
      }
      var P_ = ko(function(c, _, R) {
        c[R ? 0 : 1].push(_);
      }, function() {
        return [[], []];
      });
      function O_(c, _, R) {
        var re = Ii(c) ? bi : ei, xe = arguments.length < 3;
        return re(c, gi(_, 4), R, xe, Ds);
      }
      function N_(c, _, R) {
        var re = Ii(c) ? Cn : ei, xe = arguments.length < 3;
        return re(c, gi(_, 4), R, xe, Pu);
      }
      function R_(c, _) {
        var R = Ii(c) ? Bt : Ou;
        return R(c, Ho(gi(_, 3)));
      }
      function D_(c) {
        var _ = Ii(c) ? Bu : Bp;
        return _(c);
      }
      function z_(c, _, R) {
        (R ? vr(c, _, R) : _ === t) ? _ = 1 : _ = Di(_);
        var re = Ii(c) ? ap : kp;
        return re(c, _);
      }
      function F_(c) {
        var _ = Ii(c) ? op : Ip;
        return _(c);
      }
      function U_(c) {
        if (c == null)
          return 0;
        if (Cr(c))
          return Go(c) ? Sr(c) : c.length;
        var _ = ur(c);
        return _ == pe || _ == ft ? c.size : Vl(c).length;
      }
      function V_(c, _, R) {
        var re = Ii(c) ? mn : Pp;
        return R && vr(c, _, R) && (_ = t), re(c, gi(_, 3));
      }
      var H_ = Vi(function(c, _) {
        if (c == null)
          return [];
        var R = _.length;
        return R > 1 && vr(c, _[0], _[1]) ? _ = [] : R > 2 && vr(_[0], _[1], _[2]) && (_ = [_[0]]), Gu(c, nr(_, 1), []);
      }), Uo = wg || function() {
        return pn.Date.now();
      };
      function Y_(c, _) {
        if (typeof _ != "function")
          throw new Vt(h);
        return c = Di(c), function() {
          if (--c < 1)
            return _.apply(this, arguments);
        };
      }
      function zc(c, _, R) {
        return _ = R ? t : _, _ = c && _ == null ? c.length : _, Ls(c, Z, t, t, t, t, _);
      }
      function Fc(c, _) {
        var R;
        if (typeof _ != "function")
          throw new Vt(h);
        return c = Di(c), function() {
          return --c > 0 && (R = _.apply(this, arguments)), c <= 1 && (_ = t), R;
        };
      }
      var ch = Vi(function(c, _, R) {
        var re = Q;
        if (R.length) {
          var xe = jn(R, _a(ch));
          re |= fe;
        }
        return Ls(c, re, _, R, xe);
      }), Uc = Vi(function(c, _, R) {
        var re = Q | D;
        if (R.length) {
          var xe = jn(R, _a(Uc));
          re |= fe;
        }
        return Ls(_, re, c, R, xe);
      });
      function Vc(c, _, R) {
        _ = R ? t : _;
        var re = Ls(c, J, t, t, t, t, t, _);
        return re.placeholder = Vc.placeholder, re;
      }
      function Hc(c, _, R) {
        _ = R ? t : _;
        var re = Ls(c, he, t, t, t, t, t, _);
        return re.placeholder = Hc.placeholder, re;
      }
      function Yc(c, _, R) {
        var re, xe, Le, Ue, Xe, ot, Ot = 0, Nt = !1, Ht = !1, ii = !0;
        if (typeof c != "function")
          throw new Vt(h);
        _ = Kr(_) || 0, Ln(R) && (Nt = !!R.leading, Ht = "maxWait" in R, Le = Ht ? Wn(Kr(R.maxWait) || 0, _) : Le, ii = "trailing" in R ? !!R.trailing : ii);
        function ai(Vn) {
          var ls = re, Ps = xe;
          return re = xe = t, Ot = Vn, Ue = c.apply(Ps, ls), Ue;
        }
        function _i(Vn) {
          return Ot = Vn, Xe = Ha(Yi, _), Nt ? ai(Vn) : Ue;
        }
        function zi(Vn) {
          var ls = Vn - ot, Ps = Vn - Ot, hf = _ - ls;
          return Ht ? hr(hf, Le - Ps) : hf;
        }
        function vi(Vn) {
          var ls = Vn - ot, Ps = Vn - Ot;
          return ot === t || ls >= _ || ls < 0 || Ht && Ps >= Le;
        }
        function Yi() {
          var Vn = Uo();
          if (vi(Vn))
            return $i(Vn);
          Xe = Ha(Yi, zi(Vn));
        }
        function $i(Vn) {
          return Xe = t, ii && re ? ai(Vn) : (re = xe = t, Ue);
        }
        function Vr() {
          Xe !== t && Qu(Xe), Ot = 0, re = ot = xe = Xe = t;
        }
        function yr() {
          return Xe === t ? Ue : $i(Uo());
        }
        function Hr() {
          var Vn = Uo(), ls = vi(Vn);
          if (re = arguments, xe = this, ot = Vn, ls) {
            if (Xe === t)
              return _i(ot);
            if (Ht)
              return Qu(Xe), Xe = Ha(Yi, _), ai(ot);
          }
          return Xe === t && (Xe = Ha(Yi, _)), Ue;
        }
        return Hr.cancel = Vr, Hr.flush = yr, Hr;
      }
      var G_ = Vi(function(c, _) {
        return Iu(c, 1, _);
      }), j_ = Vi(function(c, _, R) {
        return Iu(c, Kr(_) || 0, R);
      });
      function W_(c) {
        return Ls(c, Oe);
      }
      function Vo(c, _) {
        if (typeof c != "function" || _ != null && typeof _ != "function")
          throw new Vt(h);
        var R = function() {
          var re = arguments, xe = _ ? _.apply(this, re) : re[0], Le = R.cache;
          if (Le.has(xe))
            return Le.get(xe);
          var Ue = c.apply(this, re);
          return R.cache = Le.set(xe, Ue) || Le, Ue;
        };
        return R.cache = new (Vo.Cache || As)(), R;
      }
      Vo.Cache = As;
      function Ho(c) {
        if (typeof c != "function")
          throw new Vt(h);
        return function() {
          var _ = arguments;
          switch (_.length) {
            case 0:
              return !c.call(this);
            case 1:
              return !c.call(this, _[0]);
            case 2:
              return !c.call(this, _[0], _[1]);
            case 3:
              return !c.call(this, _[0], _[1], _[2]);
          }
          return !c.apply(this, _);
        };
      }
      function Z_(c) {
        return Fc(2, c);
      }
      var q_ = Op(function(c, _) {
        _ = _.length == 1 && Ii(_[0]) ? ti(_[0], jt(gi())) : ti(nr(_, 1), jt(gi()));
        var R = _.length;
        return Vi(function(re) {
          for (var xe = -1, Le = hr(re.length, R); ++xe < Le; )
            re[xe] = _[xe].call(this, re[xe]);
          return be(c, this, re);
        });
      }), fh = Vi(function(c, _) {
        var R = jn(_, _a(fh));
        return Ls(c, fe, t, _, R);
      }), Gc = Vi(function(c, _) {
        var R = jn(_, _a(Gc));
        return Ls(c, X, t, _, R);
      }), $_ = Bs(function(c, _) {
        return Ls(c, qe, t, t, t, _);
      });
      function X_(c, _) {
        if (typeof c != "function")
          throw new Vt(h);
        return _ = _ === t ? _ : Di(_), Vi(c, _);
      }
      function K_(c, _) {
        if (typeof c != "function")
          throw new Vt(h);
        return _ = _ == null ? 0 : Wn(Di(_), 0), Vi(function(R) {
          var re = R[_], xe = Us(R, 0, _);
          return re && wi(xe, re), be(c, this, xe);
        });
      }
      function J_(c, _, R) {
        var re = !0, xe = !0;
        if (typeof c != "function")
          throw new Vt(h);
        return Ln(R) && (re = "leading" in R ? !!R.leading : re, xe = "trailing" in R ? !!R.trailing : xe), Yc(c, _, {
          leading: re,
          maxWait: _,
          trailing: xe
        });
      }
      function Q_(c) {
        return zc(c, 1);
      }
      function e0(c, _) {
        return fh(Xl(_), c);
      }
      function t0() {
        if (!arguments.length)
          return [];
        var c = arguments[0];
        return Ii(c) ? c : [c];
      }
      function i0(c) {
        return qr(c, M);
      }
      function n0(c, _) {
        return _ = typeof _ == "function" ? _ : t, qr(c, M, _);
      }
      function r0(c) {
        return qr(c, I | M);
      }
      function s0(c, _) {
        return _ = typeof _ == "function" ? _ : t, qr(c, I | M, _);
      }
      function a0(c, _) {
        return _ == null || Eu(c, _, Qn(_));
      }
      function os(c, _) {
        return c === _ || c !== c && _ !== _;
      }
      var o0 = Oo(zl), l0 = Oo(function(c, _) {
        return c >= _;
      }), na = Du(function() {
        return arguments;
      }()) ? Du : function(c) {
        return On(c) && Li.call(c, "callee") && !Su.call(c, "callee");
      }, Ii = Ye.isArray, h0 = w ? jt(w) : _p;
      function Cr(c) {
        return c != null && Yo(c.length) && !Es(c);
      }
      function Un(c) {
        return On(c) && Cr(c);
      }
      function u0(c) {
        return c === !0 || c === !1 || On(c) && _r(c) == oi;
      }
      var Vs = Mg || Sh, c0 = P ? jt(P) : vp;
      function f0(c) {
        return On(c) && c.nodeType === 1 && !Ya(c);
      }
      function d0(c) {
        if (c == null)
          return !0;
        if (Cr(c) && (Ii(c) || typeof c == "string" || typeof c.splice == "function" || Vs(c) || va(c) || na(c)))
          return !c.length;
        var _ = ur(c);
        if (_ == pe || _ == ft)
          return !c.size;
        if (Va(c))
          return !Vl(c).length;
        for (var R in c)
          if (Li.call(c, R))
            return !1;
        return !0;
      }
      function g0(c, _) {
        return za(c, _);
      }
      function p0(c, _, R) {
        R = typeof R == "function" ? R : t;
        var re = R ? R(c, _) : t;
        return re === t ? za(c, _, t, R) : !!re;
      }
      function dh(c) {
        if (!On(c))
          return !1;
        var _ = _r(c);
        return _ == Qt || _ == Jt || typeof c.message == "string" && typeof c.name == "string" && !Ya(c);
      }
      function m0(c) {
        return typeof c == "number" && Cu(c);
      }
      function Es(c) {
        if (!Ln(c))
          return !1;
        var _ = _r(c);
        return _ == rn || _ == Gi || _ == en || _ == et;
      }
      function jc(c) {
        return typeof c == "number" && c == Di(c);
      }
      function Yo(c) {
        return typeof c == "number" && c > -1 && c % 1 == 0 && c <= Gt;
      }
      function Ln(c) {
        var _ = typeof c;
        return c != null && (_ == "object" || _ == "function");
      }
      function On(c) {
        return c != null && typeof c == "object";
      }
      var Wc = K ? jt(K) : bp;
      function _0(c, _) {
        return c === _ || Ul(c, _, nh(_));
      }
      function v0(c, _, R) {
        return R = typeof R == "function" ? R : t, Ul(c, _, nh(_), R);
      }
      function y0(c) {
        return Zc(c) && c != +c;
      }
      function b0(c) {
        if (nm(c))
          throw new oe(o);
        return zu(c);
      }
      function x0(c) {
        return c === null;
      }
      function w0(c) {
        return c == null;
      }
      function Zc(c) {
        return typeof c == "number" || On(c) && _r(c) == Lt;
      }
      function Ya(c) {
        if (!On(c) || _r(c) != Ne)
          return !1;
        var _ = mo(c);
        if (_ === null)
          return !0;
        var R = Li.call(_, "constructor") && _.constructor;
        return typeof R == "function" && R instanceof R && mr.call(R) == vg;
      }
      var gh = ne ? jt(ne) : xp;
      function S0(c) {
        return jc(c) && c >= -Gt && c <= Gt;
      }
      var qc = ge ? jt(ge) : wp;
      function Go(c) {
        return typeof c == "string" || !Ii(c) && On(c) && _r(c) == tt;
      }
      function Ur(c) {
        return typeof c == "symbol" || On(c) && _r(c) == _t;
      }
      var va = _e ? jt(_e) : Sp;
      function M0(c) {
        return c === t;
      }
      function C0(c) {
        return On(c) && ur(c) == Ve;
      }
      function A0(c) {
        return On(c) && _r(c) == i;
      }
      var T0 = Oo(Hl), L0 = Oo(function(c, _) {
        return c <= _;
      });
      function $c(c) {
        if (!c)
          return [];
        if (Cr(c))
          return Go(c) ? Tn(c) : Mr(c);
        if (ka && c[ka])
          return Pn(c[ka]());
        var _ = ur(c), R = _ == pe ? Jn : _ == ft ? pr : ya;
        return R(c);
      }
      function Is(c) {
        if (!c)
          return c === 0 ? c : 0;
        if (c = Kr(c), c === ht || c === -ht) {
          var _ = c < 0 ? -1 : 1;
          return _ * $e;
        }
        return c === c ? c : 0;
      }
      function Di(c) {
        var _ = Is(c), R = _ % 1;
        return _ === _ ? R ? _ - R : _ : 0;
      }
      function Xc(c) {
        return c ? Qs(Di(c), 0, rt) : 0;
      }
      function Kr(c) {
        if (typeof c == "number")
          return c;
        if (Ur(c))
          return It;
        if (Ln(c)) {
          var _ = typeof c.valueOf == "function" ? c.valueOf() : c;
          c = Ln(_) ? _ + "" : _;
        }
        if (typeof c != "string")
          return c === 0 ? c : +c;
        c = an(c);
        var R = Re.test(c);
        return R || at.test(c) ? wr(c.slice(2), R ? 2 : 8) : mt.test(c) ? It : +c;
      }
      function Kc(c) {
        return vs(c, Ar(c));
      }
      function B0(c) {
        return c ? Qs(Di(c), -Gt, Gt) : c === 0 ? c : 0;
      }
      function on(c) {
        return c == null ? "" : Fr(c);
      }
      var k0 = pa(function(c, _) {
        if (Va(_) || Cr(_)) {
          vs(_, Qn(_), c);
          return;
        }
        for (var R in _)
          Li.call(_, R) && Na(c, R, _[R]);
      }), Jc = pa(function(c, _) {
        vs(_, Ar(_), c);
      }), jo = pa(function(c, _, R, re) {
        vs(_, Ar(_), c, re);
      }), E0 = pa(function(c, _, R, re) {
        vs(_, Qn(_), c, re);
      }), I0 = Bs(Nl);
      function P0(c, _) {
        var R = ga(c);
        return _ == null ? R : ku(R, _);
      }
      var O0 = Vi(function(c, _) {
        c = lt(c);
        var R = -1, re = _.length, xe = re > 2 ? _[2] : t;
        for (xe && vr(_[0], _[1], xe) && (re = 1); ++R < re; )
          for (var Le = _[R], Ue = Ar(Le), Xe = -1, ot = Ue.length; ++Xe < ot; ) {
            var Ot = Ue[Xe], Nt = c[Ot];
            (Nt === t || os(Nt, vn[Ot]) && !Li.call(c, Ot)) && (c[Ot] = Le[Ot]);
          }
        return c;
      }), N0 = Vi(function(c) {
        return c.push(t, pc), be(Qc, t, c);
      });
      function R0(c, _) {
        return En(c, gi(_, 3), _s);
      }
      function D0(c, _) {
        return En(c, gi(_, 3), Dl);
      }
      function z0(c, _) {
        return c == null ? c : Rl(c, gi(_, 3), Ar);
      }
      function F0(c, _) {
        return c == null ? c : Nu(c, gi(_, 3), Ar);
      }
      function U0(c, _) {
        return c && _s(c, gi(_, 3));
      }
      function V0(c, _) {
        return c && Dl(c, gi(_, 3));
      }
      function H0(c) {
        return c == null ? [] : Ao(c, Qn(c));
      }
      function Y0(c) {
        return c == null ? [] : Ao(c, Ar(c));
      }
      function ph(c, _, R) {
        var re = c == null ? t : ea(c, _);
        return re === t ? R : re;
      }
      function G0(c, _) {
        return c != null && vc(c, _, dp);
      }
      function mh(c, _) {
        return c != null && vc(c, _, gp);
      }
      var j0 = uc(function(c, _, R) {
        _ != null && typeof _.toString != "function" && (_ = fo.call(_)), c[_] = R;
      }, vh(Tr)), W0 = uc(function(c, _, R) {
        _ != null && typeof _.toString != "function" && (_ = fo.call(_)), Li.call(c, _) ? c[_].push(R) : c[_] = [R];
      }, gi), Z0 = Vi(Da);
      function Qn(c) {
        return Cr(c) ? Lu(c) : Vl(c);
      }
      function Ar(c) {
        return Cr(c) ? Lu(c, !0) : Mp(c);
      }
      function q0(c, _) {
        var R = {};
        return _ = gi(_, 3), _s(c, function(re, xe, Le) {
          Ts(R, _(re, xe, Le), re);
        }), R;
      }
      function $0(c, _) {
        var R = {};
        return _ = gi(_, 3), _s(c, function(re, xe, Le) {
          Ts(R, xe, _(re, xe, Le));
        }), R;
      }
      var X0 = pa(function(c, _, R) {
        To(c, _, R);
      }), Qc = pa(function(c, _, R, re) {
        To(c, _, R, re);
      }), K0 = Bs(function(c, _) {
        var R = {};
        if (c == null)
          return R;
        var re = !1;
        _ = ti(_, function(Le) {
          return Le = Fs(Le, c), re || (re = Le.length > 1), Le;
        }), vs(c, th(c), R), re && (R = qr(R, I | V | M, jp));
        for (var xe = _.length; xe--; )
          Zl(R, _[xe]);
        return R;
      });
      function J0(c, _) {
        return ef(c, Ho(gi(_)));
      }
      var Q0 = Bs(function(c, _) {
        return c == null ? {} : Ap(c, _);
      });
      function ef(c, _) {
        if (c == null)
          return {};
        var R = ti(th(c), function(re) {
          return [re];
        });
        return _ = gi(_), ju(c, R, function(re, xe) {
          return _(re, xe[0]);
        });
      }
      function ev(c, _, R) {
        _ = Fs(_, c);
        var re = -1, xe = _.length;
        for (xe || (xe = 1, c = t); ++re < xe; ) {
          var Le = c == null ? t : c[ys(_[re])];
          Le === t && (re = xe, Le = R), c = Es(Le) ? Le.call(c) : Le;
        }
        return c;
      }
      function tv(c, _, R) {
        return c == null ? c : Fa(c, _, R);
      }
      function iv(c, _, R, re) {
        return re = typeof re == "function" ? re : t, c == null ? c : Fa(c, _, R, re);
      }
      var tf = dc(Qn), nf = dc(Ar);
      function nv(c, _, R) {
        var re = Ii(c), xe = re || Vs(c) || va(c);
        if (_ = gi(_, 4), R == null) {
          var Le = c && c.constructor;
          xe ? R = re ? new Le() : [] : Ln(c) ? R = Es(Le) ? ga(mo(c)) : {} : R = {};
        }
        return (xe ? De : _s)(c, function(Ue, Xe, ot) {
          return _(R, Ue, Xe, ot);
        }), R;
      }
      function rv(c, _) {
        return c == null ? !0 : Zl(c, _);
      }
      function sv(c, _, R) {
        return c == null ? c : Xu(c, _, Xl(R));
      }
      function av(c, _, R, re) {
        return re = typeof re == "function" ? re : t, c == null ? c : Xu(c, _, Xl(R), re);
      }
      function ya(c) {
        return c == null ? [] : Dr(c, Qn(c));
      }
      function ov(c) {
        return c == null ? [] : Dr(c, Ar(c));
      }
      function lv(c, _, R) {
        return R === t && (R = _, _ = t), R !== t && (R = Kr(R), R = R === R ? R : 0), _ !== t && (_ = Kr(_), _ = _ === _ ? _ : 0), Qs(Kr(c), _, R);
      }
      function hv(c, _, R) {
        return _ = Is(_), R === t ? (R = _, _ = 0) : R = Is(R), c = Kr(c), pp(c, _, R);
      }
      function uv(c, _, R) {
        if (R && typeof R != "boolean" && vr(c, _, R) && (_ = R = t), R === t && (typeof _ == "boolean" ? (R = _, _ = t) : typeof c == "boolean" && (R = c, c = t)), c === t && _ === t ? (c = 0, _ = 1) : (c = Is(c), _ === t ? (_ = c, c = 0) : _ = Is(_)), c > _) {
          var re = c;
          c = _, _ = re;
        }
        if (R || c % 1 || _ % 1) {
          var xe = Au();
          return hr(c + xe * (_ - c + sr("1e-" + ((xe + "").length - 1))), _);
        }
        return Gl(c, _);
      }
      var cv = ma(function(c, _, R) {
        return _ = _.toLowerCase(), c + (R ? rf(_) : _);
      });
      function rf(c) {
        return _h(on(c).toLowerCase());
      }
      function sf(c) {
        return c = on(c), c && c.replace(bt, dn).replace(ye, "");
      }
      function fv(c, _, R) {
        c = on(c), _ = Fr(_);
        var re = c.length;
        R = R === t ? re : Qs(Di(R), 0, re);
        var xe = R;
        return R -= _.length, R >= 0 && c.slice(R, xe) == _;
      }
      function dv(c) {
        return c = on(c), c && z.test(c) ? c.replace(Y, zr) : c;
      }
      function gv(c) {
        return c = on(c), c && le.test(c) ? c.replace(ae, "\\$&") : c;
      }
      var pv = ma(function(c, _, R) {
        return c + (R ? "-" : "") + _.toLowerCase();
      }), mv = ma(function(c, _, R) {
        return c + (R ? " " : "") + _.toLowerCase();
      }), _v = oc("toLowerCase");
      function vv(c, _, R) {
        c = on(c), _ = Di(_);
        var re = _ ? Sr(c) : 0;
        if (!_ || re >= _)
          return c;
        var xe = (_ - re) / 2;
        return Po(bo(xe), R) + c + Po(yo(xe), R);
      }
      function yv(c, _, R) {
        c = on(c), _ = Di(_);
        var re = _ ? Sr(c) : 0;
        return _ && re < _ ? c + Po(_ - re, R) : c;
      }
      function bv(c, _, R) {
        c = on(c), _ = Di(_);
        var re = _ ? Sr(c) : 0;
        return _ && re < _ ? Po(_ - re, R) + c : c;
      }
      function xv(c, _, R) {
        return R || _ == null ? _ = 0 : _ && (_ = +_), Lg(on(c).replace(me, ""), _ || 0);
      }
      function wv(c, _, R) {
        return (R ? vr(c, _, R) : _ === t) ? _ = 1 : _ = Di(_), jl(on(c), _);
      }
      function Sv() {
        var c = arguments, _ = on(c[0]);
        return c.length < 3 ? _ : _.replace(c[1], c[2]);
      }
      var Mv = ma(function(c, _, R) {
        return c + (R ? "_" : "") + _.toLowerCase();
      });
      function Cv(c, _, R) {
        return R && typeof R != "number" && vr(c, _, R) && (_ = R = t), R = R === t ? rt : R >>> 0, R ? (c = on(c), c && (typeof _ == "string" || _ != null && !gh(_)) && (_ = Fr(_), !_ && Kn(c)) ? Us(Tn(c), 0, R) : c.split(_, R)) : [];
      }
      var Av = ma(function(c, _, R) {
        return c + (R ? " " : "") + _h(_);
      });
      function Tv(c, _, R) {
        return c = on(c), R = R == null ? 0 : Qs(Di(R), 0, c.length), _ = Fr(_), c.slice(R, R + _.length) == _;
      }
      function Lv(c, _, R) {
        var re = Ce.templateSettings;
        R && vr(c, _, R) && (_ = t), c = on(c), _ = jo({}, _, re, gc);
        var xe = jo({}, _.imports, re.imports, gc), Le = Qn(xe), Ue = Dr(xe, Le), Xe, ot, Ot = 0, Nt = _.interpolate || Rt, Ht = "__p += '", ii = At(
          (_.escape || Rt).source + "|" + Nt.source + "|" + (Nt === j ? Qe : Rt).source + "|" + (_.evaluate || Rt).source + "|$",
          "g"
        ), ai = "//# sourceURL=" + (Li.call(_, "sourceURL") ? (_.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++li + "]") + `
`;
        c.replace(ii, function(vi, Yi, $i, Vr, yr, Hr) {
          return $i || ($i = Vr), Ht += c.slice(Ot, Hr).replace(Pt, $s), Yi && (Xe = !0, Ht += `' +
__e(` + Yi + `) +
'`), yr && (ot = !0, Ht += `';
` + yr + `;
__p += '`), $i && (Ht += `' +
((__t = (` + $i + `)) == null ? '' : __t) +
'`), Ot = Hr + vi.length, vi;
        }), Ht += `';
`;
        var _i = Li.call(_, "variable") && _.variable;
        if (!_i)
          Ht = `with (obj) {
` + Ht + `
}
`;
        else if (Ae.test(_i))
          throw new oe(f);
        Ht = (ot ? Ht.replace(A, "") : Ht).replace(T, "$1").replace(G, "$1;"), Ht = "function(" + (_i || "obj") + `) {
` + (_i ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (Xe ? ", __e = _.escape" : "") + (ot ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Ht + `return __p
}`;
        var zi = of(function() {
          return Me(Le, ai + "return " + Ht).apply(t, Ue);
        });
        if (zi.source = Ht, dh(zi))
          throw zi;
        return zi;
      }
      function Bv(c) {
        return on(c).toLowerCase();
      }
      function kv(c) {
        return on(c).toUpperCase();
      }
      function Ev(c, _, R) {
        if (c = on(c), c && (R || _ === t))
          return an(c);
        if (!c || !(_ = Fr(_)))
          return c;
        var re = Tn(c), xe = Tn(_), Le = Ni(re, xe), Ue = An(re, xe) + 1;
        return Us(re, Le, Ue).join("");
      }
      function Iv(c, _, R) {
        if (c = on(c), c && (R || _ === t))
          return c.slice(0, Wr(c) + 1);
        if (!c || !(_ = Fr(_)))
          return c;
        var re = Tn(c), xe = An(re, Tn(_)) + 1;
        return Us(re, 0, xe).join("");
      }
      function Pv(c, _, R) {
        if (c = on(c), c && (R || _ === t))
          return c.replace(me, "");
        if (!c || !(_ = Fr(_)))
          return c;
        var re = Tn(c), xe = Ni(re, Tn(_));
        return Us(re, xe).join("");
      }
      function Ov(c, _) {
        var R = je, re = pt;
        if (Ln(_)) {
          var xe = "separator" in _ ? _.separator : xe;
          R = "length" in _ ? Di(_.length) : R, re = "omission" in _ ? Fr(_.omission) : re;
        }
        c = on(c);
        var Le = c.length;
        if (Kn(c)) {
          var Ue = Tn(c);
          Le = Ue.length;
        }
        if (R >= Le)
          return c;
        var Xe = R - Sr(re);
        if (Xe < 1)
          return re;
        var ot = Ue ? Us(Ue, 0, Xe).join("") : c.slice(0, Xe);
        if (xe === t)
          return ot + re;
        if (Ue && (Xe += ot.length - Xe), gh(xe)) {
          if (c.slice(Xe).search(xe)) {
            var Ot, Nt = ot;
            for (xe.global || (xe = At(xe.source, on(st.exec(xe)) + "g")), xe.lastIndex = 0; Ot = xe.exec(Nt); )
              var Ht = Ot.index;
            ot = ot.slice(0, Ht === t ? Xe : Ht);
          }
        } else if (c.indexOf(Fr(xe), Xe) != Xe) {
          var ii = ot.lastIndexOf(xe);
          ii > -1 && (ot = ot.slice(0, ii));
        }
        return ot + re;
      }
      function Nv(c) {
        return c = on(c), c && B.test(c) ? c.replace(O, Ms) : c;
      }
      var Rv = ma(function(c, _, R) {
        return c + (R ? " " : "") + _.toUpperCase();
      }), _h = oc("toUpperCase");
      function af(c, _, R) {
        return c = on(c), _ = R ? t : _, _ === t ? un(c) ? Ke(c) : ki(c) : c.match(_) || [];
      }
      var of = Vi(function(c, _) {
        try {
          return be(c, t, _);
        } catch (R) {
          return dh(R) ? R : new oe(R);
        }
      }), Dv = Bs(function(c, _) {
        return De(_, function(R) {
          R = ys(R), Ts(c, R, ch(c[R], c));
        }), c;
      });
      function zv(c) {
        var _ = c == null ? 0 : c.length, R = gi();
        return c = _ ? ti(c, function(re) {
          if (typeof re[1] != "function")
            throw new Vt(h);
          return [R(re[0]), re[1]];
        }) : [], Vi(function(re) {
          for (var xe = -1; ++xe < _; ) {
            var Le = c[xe];
            if (be(Le[0], this, re))
              return be(Le[1], this, re);
          }
        });
      }
      function Fv(c) {
        return up(qr(c, I));
      }
      function vh(c) {
        return function() {
          return c;
        };
      }
      function Uv(c, _) {
        return c == null || c !== c ? _ : c;
      }
      var Vv = hc(), Hv = hc(!0);
      function Tr(c) {
        return c;
      }
      function yh(c) {
        return Fu(typeof c == "function" ? c : qr(c, I));
      }
      function Yv(c) {
        return Vu(qr(c, I));
      }
      function Gv(c, _) {
        return Hu(c, qr(_, I));
      }
      var jv = Vi(function(c, _) {
        return function(R) {
          return Da(R, c, _);
        };
      }), Wv = Vi(function(c, _) {
        return function(R) {
          return Da(c, R, _);
        };
      });
      function bh(c, _, R) {
        var re = Qn(_), xe = Ao(_, re);
        R == null && !(Ln(_) && (xe.length || !re.length)) && (R = _, _ = c, c = this, xe = Ao(_, Qn(_)));
        var Le = !(Ln(R) && "chain" in R) || !!R.chain, Ue = Es(c);
        return De(xe, function(Xe) {
          var ot = _[Xe];
          c[Xe] = ot, Ue && (c.prototype[Xe] = function() {
            var Ot = this.__chain__;
            if (Le || Ot) {
              var Nt = c(this.__wrapped__), Ht = Nt.__actions__ = Mr(this.__actions__);
              return Ht.push({ func: ot, args: arguments, thisArg: c }), Nt.__chain__ = Ot, Nt;
            }
            return ot.apply(c, wi([this.value()], arguments));
          });
        }), c;
      }
      function Zv() {
        return pn._ === this && (pn._ = yg), this;
      }
      function xh() {
      }
      function qv(c) {
        return c = Di(c), Vi(function(_) {
          return Yu(_, c);
        });
      }
      var $v = Jl(ti), Xv = Jl(Ct), Kv = Jl(mn);
      function lf(c) {
        return sh(c) ? gr(ys(c)) : Tp(c);
      }
      function Jv(c) {
        return function(_) {
          return c == null ? t : ea(c, _);
        };
      }
      var Qv = cc(), ey = cc(!0);
      function wh() {
        return [];
      }
      function Sh() {
        return !1;
      }
      function ty() {
        return {};
      }
      function iy() {
        return "";
      }
      function ny() {
        return !0;
      }
      function ry(c, _) {
        if (c = Di(c), c < 1 || c > Gt)
          return [];
        var R = rt, re = hr(c, rt);
        _ = gi(_), c -= rt;
        for (var xe = Rr(re, _); ++R < c; )
          _(R);
        return xe;
      }
      function sy(c) {
        return Ii(c) ? ti(c, ys) : Ur(c) ? [c] : Mr(Tc(on(c)));
      }
      function ay(c) {
        var _ = ++_g;
        return on(c) + _;
      }
      var oy = Io(function(c, _) {
        return c + _;
      }, 0), ly = Ql("ceil"), hy = Io(function(c, _) {
        return c / _;
      }, 1), uy = Ql("floor");
      function cy(c) {
        return c && c.length ? Co(c, Tr, zl) : t;
      }
      function fy(c, _) {
        return c && c.length ? Co(c, gi(_, 2), zl) : t;
      }
      function dy(c) {
        return _n(c, Tr);
      }
      function gy(c, _) {
        return _n(c, gi(_, 2));
      }
      function py(c) {
        return c && c.length ? Co(c, Tr, Hl) : t;
      }
      function my(c, _) {
        return c && c.length ? Co(c, gi(_, 2), Hl) : t;
      }
      var _y = Io(function(c, _) {
        return c * _;
      }, 1), vy = Ql("round"), yy = Io(function(c, _) {
        return c - _;
      }, 0);
      function by(c) {
        return c && c.length ? In(c, Tr) : 0;
      }
      function xy(c, _) {
        return c && c.length ? In(c, gi(_, 2)) : 0;
      }
      return Ce.after = Y_, Ce.ary = zc, Ce.assign = k0, Ce.assignIn = Jc, Ce.assignInWith = jo, Ce.assignWith = E0, Ce.at = I0, Ce.before = Fc, Ce.bind = ch, Ce.bindAll = Dv, Ce.bindKey = Uc, Ce.castArray = t0, Ce.chain = Nc, Ce.chunk = um, Ce.compact = cm, Ce.concat = fm, Ce.cond = zv, Ce.conforms = Fv, Ce.constant = vh, Ce.countBy = b_, Ce.create = P0, Ce.curry = Vc, Ce.curryRight = Hc, Ce.debounce = Yc, Ce.defaults = O0, Ce.defaultsDeep = N0, Ce.defer = G_, Ce.delay = j_, Ce.difference = dm, Ce.differenceBy = gm, Ce.differenceWith = pm, Ce.drop = mm, Ce.dropRight = _m, Ce.dropRightWhile = vm, Ce.dropWhile = ym, Ce.fill = bm, Ce.filter = w_, Ce.flatMap = C_, Ce.flatMapDeep = A_, Ce.flatMapDepth = T_, Ce.flatten = Ec, Ce.flattenDeep = xm, Ce.flattenDepth = wm, Ce.flip = W_, Ce.flow = Vv, Ce.flowRight = Hv, Ce.fromPairs = Sm, Ce.functions = H0, Ce.functionsIn = Y0, Ce.groupBy = L_, Ce.initial = Cm, Ce.intersection = Am, Ce.intersectionBy = Tm, Ce.intersectionWith = Lm, Ce.invert = j0, Ce.invertBy = W0, Ce.invokeMap = k_, Ce.iteratee = yh, Ce.keyBy = E_, Ce.keys = Qn, Ce.keysIn = Ar, Ce.map = Fo, Ce.mapKeys = q0, Ce.mapValues = $0, Ce.matches = Yv, Ce.matchesProperty = Gv, Ce.memoize = Vo, Ce.merge = X0, Ce.mergeWith = Qc, Ce.method = jv, Ce.methodOf = Wv, Ce.mixin = bh, Ce.negate = Ho, Ce.nthArg = qv, Ce.omit = K0, Ce.omitBy = J0, Ce.once = Z_, Ce.orderBy = I_, Ce.over = $v, Ce.overArgs = q_, Ce.overEvery = Xv, Ce.overSome = Kv, Ce.partial = fh, Ce.partialRight = Gc, Ce.partition = P_, Ce.pick = Q0, Ce.pickBy = ef, Ce.property = lf, Ce.propertyOf = Jv, Ce.pull = Im, Ce.pullAll = Pc, Ce.pullAllBy = Pm, Ce.pullAllWith = Om, Ce.pullAt = Nm, Ce.range = Qv, Ce.rangeRight = ey, Ce.rearg = $_, Ce.reject = R_, Ce.remove = Rm, Ce.rest = X_, Ce.reverse = hh, Ce.sampleSize = z_, Ce.set = tv, Ce.setWith = iv, Ce.shuffle = F_, Ce.slice = Dm, Ce.sortBy = H_, Ce.sortedUniq = Gm, Ce.sortedUniqBy = jm, Ce.split = Cv, Ce.spread = K_, Ce.tail = Wm, Ce.take = Zm, Ce.takeRight = qm, Ce.takeRightWhile = $m, Ce.takeWhile = Xm, Ce.tap = c_, Ce.throttle = J_, Ce.thru = zo, Ce.toArray = $c, Ce.toPairs = tf, Ce.toPairsIn = nf, Ce.toPath = sy, Ce.toPlainObject = Kc, Ce.transform = nv, Ce.unary = Q_, Ce.union = Km, Ce.unionBy = Jm, Ce.unionWith = Qm, Ce.uniq = e_, Ce.uniqBy = t_, Ce.uniqWith = i_, Ce.unset = rv, Ce.unzip = uh, Ce.unzipWith = Oc, Ce.update = sv, Ce.updateWith = av, Ce.values = ya, Ce.valuesIn = ov, Ce.without = n_, Ce.words = af, Ce.wrap = e0, Ce.xor = r_, Ce.xorBy = s_, Ce.xorWith = a_, Ce.zip = o_, Ce.zipObject = l_, Ce.zipObjectDeep = h_, Ce.zipWith = u_, Ce.entries = tf, Ce.entriesIn = nf, Ce.extend = Jc, Ce.extendWith = jo, bh(Ce, Ce), Ce.add = oy, Ce.attempt = of, Ce.camelCase = cv, Ce.capitalize = rf, Ce.ceil = ly, Ce.clamp = lv, Ce.clone = i0, Ce.cloneDeep = r0, Ce.cloneDeepWith = s0, Ce.cloneWith = n0, Ce.conformsTo = a0, Ce.deburr = sf, Ce.defaultTo = Uv, Ce.divide = hy, Ce.endsWith = fv, Ce.eq = os, Ce.escape = dv, Ce.escapeRegExp = gv, Ce.every = x_, Ce.find = S_, Ce.findIndex = Bc, Ce.findKey = R0, Ce.findLast = M_, Ce.findLastIndex = kc, Ce.findLastKey = D0, Ce.floor = uy, Ce.forEach = Rc, Ce.forEachRight = Dc, Ce.forIn = z0, Ce.forInRight = F0, Ce.forOwn = U0, Ce.forOwnRight = V0, Ce.get = ph, Ce.gt = o0, Ce.gte = l0, Ce.has = G0, Ce.hasIn = mh, Ce.head = Ic, Ce.identity = Tr, Ce.includes = B_, Ce.indexOf = Mm, Ce.inRange = hv, Ce.invoke = Z0, Ce.isArguments = na, Ce.isArray = Ii, Ce.isArrayBuffer = h0, Ce.isArrayLike = Cr, Ce.isArrayLikeObject = Un, Ce.isBoolean = u0, Ce.isBuffer = Vs, Ce.isDate = c0, Ce.isElement = f0, Ce.isEmpty = d0, Ce.isEqual = g0, Ce.isEqualWith = p0, Ce.isError = dh, Ce.isFinite = m0, Ce.isFunction = Es, Ce.isInteger = jc, Ce.isLength = Yo, Ce.isMap = Wc, Ce.isMatch = _0, Ce.isMatchWith = v0, Ce.isNaN = y0, Ce.isNative = b0, Ce.isNil = w0, Ce.isNull = x0, Ce.isNumber = Zc, Ce.isObject = Ln, Ce.isObjectLike = On, Ce.isPlainObject = Ya, Ce.isRegExp = gh, Ce.isSafeInteger = S0, Ce.isSet = qc, Ce.isString = Go, Ce.isSymbol = Ur, Ce.isTypedArray = va, Ce.isUndefined = M0, Ce.isWeakMap = C0, Ce.isWeakSet = A0, Ce.join = Bm, Ce.kebabCase = pv, Ce.last = Xr, Ce.lastIndexOf = km, Ce.lowerCase = mv, Ce.lowerFirst = _v, Ce.lt = T0, Ce.lte = L0, Ce.max = cy, Ce.maxBy = fy, Ce.mean = dy, Ce.meanBy = gy, Ce.min = py, Ce.minBy = my, Ce.stubArray = wh, Ce.stubFalse = Sh, Ce.stubObject = ty, Ce.stubString = iy, Ce.stubTrue = ny, Ce.multiply = _y, Ce.nth = Em, Ce.noConflict = Zv, Ce.noop = xh, Ce.now = Uo, Ce.pad = vv, Ce.padEnd = yv, Ce.padStart = bv, Ce.parseInt = xv, Ce.random = uv, Ce.reduce = O_, Ce.reduceRight = N_, Ce.repeat = wv, Ce.replace = Sv, Ce.result = ev, Ce.round = vy, Ce.runInContext = Be, Ce.sample = D_, Ce.size = U_, Ce.snakeCase = Mv, Ce.some = V_, Ce.sortedIndex = zm, Ce.sortedIndexBy = Fm, Ce.sortedIndexOf = Um, Ce.sortedLastIndex = Vm, Ce.sortedLastIndexBy = Hm, Ce.sortedLastIndexOf = Ym, Ce.startCase = Av, Ce.startsWith = Tv, Ce.subtract = yy, Ce.sum = by, Ce.sumBy = xy, Ce.template = Lv, Ce.times = ry, Ce.toFinite = Is, Ce.toInteger = Di, Ce.toLength = Xc, Ce.toLower = Bv, Ce.toNumber = Kr, Ce.toSafeInteger = B0, Ce.toString = on, Ce.toUpper = kv, Ce.trim = Ev, Ce.trimEnd = Iv, Ce.trimStart = Pv, Ce.truncate = Ov, Ce.unescape = Nv, Ce.uniqueId = ay, Ce.upperCase = Rv, Ce.upperFirst = _h, Ce.each = Rc, Ce.eachRight = Dc, Ce.first = Ic, bh(Ce, function() {
        var c = {};
        return _s(Ce, function(_, R) {
          Li.call(Ce.prototype, R) || (c[R] = _);
        }), c;
      }(), { chain: !1 }), Ce.VERSION = n, De(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(c) {
        Ce[c].placeholder = Ce;
      }), De(["drop", "take"], function(c, _) {
        Wi.prototype[c] = function(R) {
          R = R === t ? 1 : Wn(Di(R), 0);
          var re = this.__filtered__ && !_ ? new Wi(this) : this.clone();
          return re.__filtered__ ? re.__takeCount__ = hr(R, re.__takeCount__) : re.__views__.push({
            size: hr(R, rt),
            type: c + (re.__dir__ < 0 ? "Right" : "")
          }), re;
        }, Wi.prototype[c + "Right"] = function(R) {
          return this.reverse()[c](R).reverse();
        };
      }), De(["filter", "map", "takeWhile"], function(c, _) {
        var R = _ + 1, re = R == ce || R == ze;
        Wi.prototype[c] = function(xe) {
          var Le = this.clone();
          return Le.__iteratees__.push({
            iteratee: gi(xe, 3),
            type: R
          }), Le.__filtered__ = Le.__filtered__ || re, Le;
        };
      }), De(["head", "last"], function(c, _) {
        var R = "take" + (_ ? "Right" : "");
        Wi.prototype[c] = function() {
          return this[R](1).value()[0];
        };
      }), De(["initial", "tail"], function(c, _) {
        var R = "drop" + (_ ? "" : "Right");
        Wi.prototype[c] = function() {
          return this.__filtered__ ? new Wi(this) : this[R](1);
        };
      }), Wi.prototype.compact = function() {
        return this.filter(Tr);
      }, Wi.prototype.find = function(c) {
        return this.filter(c).head();
      }, Wi.prototype.findLast = function(c) {
        return this.reverse().find(c);
      }, Wi.prototype.invokeMap = Vi(function(c, _) {
        return typeof c == "function" ? new Wi(this) : this.map(function(R) {
          return Da(R, c, _);
        });
      }), Wi.prototype.reject = function(c) {
        return this.filter(Ho(gi(c)));
      }, Wi.prototype.slice = function(c, _) {
        c = Di(c);
        var R = this;
        return R.__filtered__ && (c > 0 || _ < 0) ? new Wi(R) : (c < 0 ? R = R.takeRight(-c) : c && (R = R.drop(c)), _ !== t && (_ = Di(_), R = _ < 0 ? R.dropRight(-_) : R.take(_ - c)), R);
      }, Wi.prototype.takeRightWhile = function(c) {
        return this.reverse().takeWhile(c).reverse();
      }, Wi.prototype.toArray = function() {
        return this.take(rt);
      }, _s(Wi.prototype, function(c, _) {
        var R = /^(?:filter|find|map|reject)|While$/.test(_), re = /^(?:head|last)$/.test(_), xe = Ce[re ? "take" + (_ == "last" ? "Right" : "") : _], Le = re || /^find/.test(_);
        xe && (Ce.prototype[_] = function() {
          var Ue = this.__wrapped__, Xe = re ? [1] : arguments, ot = Ue instanceof Wi, Ot = Xe[0], Nt = ot || Ii(Ue), Ht = function(Yi) {
            var $i = xe.apply(Ce, wi([Yi], Xe));
            return re && ii ? $i[0] : $i;
          };
          Nt && R && typeof Ot == "function" && Ot.length != 1 && (ot = Nt = !1);
          var ii = this.__chain__, ai = !!this.__actions__.length, _i = Le && !ii, zi = ot && !ai;
          if (!Le && Nt) {
            Ue = zi ? Ue : new Wi(this);
            var vi = c.apply(Ue, Xe);
            return vi.__actions__.push({ func: zo, args: [Ht], thisArg: t }), new Zr(vi, ii);
          }
          return _i && zi ? c.apply(this, Xe) : (vi = this.thru(Ht), _i ? re ? vi.value()[0] : vi.value() : vi);
        });
      }), De(["pop", "push", "shift", "sort", "splice", "unshift"], function(c) {
        var _ = Ei[c], R = /^(?:push|sort|unshift)$/.test(c) ? "tap" : "thru", re = /^(?:pop|shift)$/.test(c);
        Ce.prototype[c] = function() {
          var xe = arguments;
          if (re && !this.__chain__) {
            var Le = this.value();
            return _.apply(Ii(Le) ? Le : [], xe);
          }
          return this[R](function(Ue) {
            return _.apply(Ii(Ue) ? Ue : [], xe);
          });
        };
      }), _s(Wi.prototype, function(c, _) {
        var R = Ce[_];
        if (R) {
          var re = R.name + "";
          Li.call(da, re) || (da[re] = []), da[re].push({ name: _, func: R });
        }
      }), da[Eo(t, D).name] = [{
        name: "wrapper",
        func: t
      }], Wi.prototype.clone = Ng, Wi.prototype.reverse = Rg, Wi.prototype.value = Dg, Ce.prototype.at = f_, Ce.prototype.chain = d_, Ce.prototype.commit = g_, Ce.prototype.next = p_, Ce.prototype.plant = __, Ce.prototype.reverse = v_, Ce.prototype.toJSON = Ce.prototype.valueOf = Ce.prototype.value = y_, Ce.prototype.first = Ce.prototype.head, ka && (Ce.prototype[ka] = m_), Ce;
    }, vt = ct();
    ir ? ((ir.exports = vt)._ = vt, ps._ = vt) : pn._ = vt;
  }).call(ts);
})(yl, yl.exports);
var Lw = yl.exports, og = { exports: {} };
const Bw = {}, kw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Bw
}, Symbol.toStringTag, { value: "Module" })), Vf = /* @__PURE__ */ Lx(kw);
var el = { exports: {} }, Hf;
function Ew() {
  return Hf || (Hf = 1, function(b, e) {
    (function(t, n) {
      n(e);
    })(ts, function(t) {
      var n = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 7, 9, 32, 4, 318, 1, 80, 3, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 68, 8, 2, 0, 3, 0, 2, 3, 2, 4, 2, 0, 15, 1, 83, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 7, 19, 58, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 343, 9, 54, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 10, 5350, 0, 7, 14, 11465, 27, 2343, 9, 87, 9, 39, 4, 60, 6, 26, 9, 535, 9, 470, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4178, 9, 519, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 245, 1, 2, 9, 726, 6, 110, 6, 6, 9, 4759, 9, 787719, 239], a = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 4, 51, 13, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 39, 27, 10, 22, 251, 41, 7, 1, 17, 2, 60, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 31, 9, 2, 0, 3, 0, 2, 37, 2, 0, 26, 0, 2, 0, 45, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 200, 32, 32, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 26, 3994, 6, 582, 6842, 29, 1763, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 433, 44, 212, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 42, 9, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 229, 29, 3, 0, 496, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 16, 621, 2467, 541, 1507, 4938, 6, 4191], o = "‌‍·̀-ͯ·҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛ࢗ-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯ૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯ೳഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯ඁ-ඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-໎໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟፩-፱ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍᠏-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-᧚ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽ᪿ-ᫎᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿‌‍‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯・꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱ꣿ-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿･", h = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲊᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ℘-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ゛-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꟍꟐꟑꟓꟕ-Ƛꟲ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", f = {
        3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
        5: "class enum extends super const export import",
        6: "enum",
        strict: "implements interface let package private protected public static yield",
        strictBind: "eval arguments"
      }, v = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this", x = {
        5: v,
        "5module": v + " export import",
        6: v + " const class extends export import super"
      }, k = /^in(stanceof)?$/, I = new RegExp("[" + h + "]"), V = new RegExp("[" + h + o + "]");
      function M(g, F) {
        for (var ue = 65536, ye = 0; ye < F.length; ye += 2) {
          if (ue += F[ye], ue > g)
            return !1;
          if (ue += F[ye + 1], ue >= g)
            return !0;
        }
        return !1;
      }
      function W(g, F) {
        return g < 65 ? g === 36 : g < 91 ? !0 : g < 97 ? g === 95 : g < 123 ? !0 : g <= 65535 ? g >= 170 && I.test(String.fromCharCode(g)) : F === !1 ? !1 : M(g, a);
      }
      function U(g, F) {
        return g < 48 ? g === 36 : g < 58 ? !0 : g < 65 ? !1 : g < 91 ? !0 : g < 97 ? g === 95 : g < 123 ? !0 : g <= 65535 ? g >= 170 && V.test(String.fromCharCode(g)) : F === !1 ? !1 : M(g, a) || M(g, n);
      }
      var Q = function(F, ue) {
        ue === void 0 && (ue = {}), this.label = F, this.keyword = ue.keyword, this.beforeExpr = !!ue.beforeExpr, this.startsExpr = !!ue.startsExpr, this.isLoop = !!ue.isLoop, this.isAssign = !!ue.isAssign, this.prefix = !!ue.prefix, this.postfix = !!ue.postfix, this.binop = ue.binop || null, this.updateContext = null;
      };
      function D(g, F) {
        return new Q(g, { beforeExpr: !0, binop: F });
      }
      var ee = { beforeExpr: !0 }, J = { startsExpr: !0 }, he = {};
      function fe(g, F) {
        return F === void 0 && (F = {}), F.keyword = g, he[g] = new Q(g, F);
      }
      var X = {
        num: new Q("num", J),
        regexp: new Q("regexp", J),
        string: new Q("string", J),
        name: new Q("name", J),
        privateId: new Q("privateId", J),
        eof: new Q("eof"),
        // Punctuation token types.
        bracketL: new Q("[", { beforeExpr: !0, startsExpr: !0 }),
        bracketR: new Q("]"),
        braceL: new Q("{", { beforeExpr: !0, startsExpr: !0 }),
        braceR: new Q("}"),
        parenL: new Q("(", { beforeExpr: !0, startsExpr: !0 }),
        parenR: new Q(")"),
        comma: new Q(",", ee),
        semi: new Q(";", ee),
        colon: new Q(":", ee),
        dot: new Q("."),
        question: new Q("?", ee),
        questionDot: new Q("?."),
        arrow: new Q("=>", ee),
        template: new Q("template"),
        invalidTemplate: new Q("invalidTemplate"),
        ellipsis: new Q("...", ee),
        backQuote: new Q("`", J),
        dollarBraceL: new Q("${", { beforeExpr: !0, startsExpr: !0 }),
        // Operators. These carry several kinds of properties to help the
        // parser use them properly (the presence of these properties is
        // what categorizes them as operators).
        //
        // `binop`, when present, specifies that this operator is a binary
        // operator, and will refer to its precedence.
        //
        // `prefix` and `postfix` mark the operator as a prefix or postfix
        // unary operator.
        //
        // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
        // binary operators with a very low precedence, that should result
        // in AssignmentExpression nodes.
        eq: new Q("=", { beforeExpr: !0, isAssign: !0 }),
        assign: new Q("_=", { beforeExpr: !0, isAssign: !0 }),
        incDec: new Q("++/--", { prefix: !0, postfix: !0, startsExpr: !0 }),
        prefix: new Q("!/~", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        logicalOR: D("||", 1),
        logicalAND: D("&&", 2),
        bitwiseOR: D("|", 3),
        bitwiseXOR: D("^", 4),
        bitwiseAND: D("&", 5),
        equality: D("==/!=/===/!==", 6),
        relational: D("</>/<=/>=", 7),
        bitShift: D("<</>>/>>>", 8),
        plusMin: new Q("+/-", { beforeExpr: !0, binop: 9, prefix: !0, startsExpr: !0 }),
        modulo: D("%", 10),
        star: D("*", 10),
        slash: D("/", 10),
        starstar: new Q("**", { beforeExpr: !0 }),
        coalesce: D("??", 1),
        // Keyword token types.
        _break: fe("break"),
        _case: fe("case", ee),
        _catch: fe("catch"),
        _continue: fe("continue"),
        _debugger: fe("debugger"),
        _default: fe("default", ee),
        _do: fe("do", { isLoop: !0, beforeExpr: !0 }),
        _else: fe("else", ee),
        _finally: fe("finally"),
        _for: fe("for", { isLoop: !0 }),
        _function: fe("function", J),
        _if: fe("if"),
        _return: fe("return", ee),
        _switch: fe("switch"),
        _throw: fe("throw", ee),
        _try: fe("try"),
        _var: fe("var"),
        _const: fe("const"),
        _while: fe("while", { isLoop: !0 }),
        _with: fe("with"),
        _new: fe("new", { beforeExpr: !0, startsExpr: !0 }),
        _this: fe("this", J),
        _super: fe("super", J),
        _class: fe("class", J),
        _extends: fe("extends", ee),
        _export: fe("export"),
        _import: fe("import", J),
        _null: fe("null", J),
        _true: fe("true", J),
        _false: fe("false", J),
        _in: fe("in", { beforeExpr: !0, binop: 7 }),
        _instanceof: fe("instanceof", { beforeExpr: !0, binop: 7 }),
        _typeof: fe("typeof", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        _void: fe("void", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
        _delete: fe("delete", { beforeExpr: !0, prefix: !0, startsExpr: !0 })
      }, Z = /\r\n?|\n|\u2028|\u2029/, qe = new RegExp(Z.source, "g");
      function Oe(g) {
        return g === 10 || g === 13 || g === 8232 || g === 8233;
      }
      function je(g, F, ue) {
        ue === void 0 && (ue = g.length);
        for (var ye = F; ye < ue; ye++) {
          var Ee = g.charCodeAt(ye);
          if (Oe(Ee))
            return ye < ue - 1 && Ee === 13 && g.charCodeAt(ye + 1) === 10 ? ye + 2 : ye + 1;
        }
        return -1;
      }
      var pt = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Te = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, Ze = Object.prototype, ce = Ze.hasOwnProperty, ut = Ze.toString, ze = Object.hasOwn || function(g, F) {
        return ce.call(g, F);
      }, ht = Array.isArray || function(g) {
        return ut.call(g) === "[object Array]";
      }, Gt = /* @__PURE__ */ Object.create(null);
      function $e(g) {
        return Gt[g] || (Gt[g] = new RegExp("^(?:" + g.replace(/ /g, "|") + ")$"));
      }
      function It(g) {
        return g <= 65535 ? String.fromCharCode(g) : (g -= 65536, String.fromCharCode((g >> 10) + 55296, (g & 1023) + 56320));
      }
      var rt = /(?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, it = function(F, ue) {
        this.line = F, this.column = ue;
      };
      it.prototype.offset = function(F) {
        return new it(this.line, this.column + F);
      };
      var Xt = function(F, ue, ye) {
        this.start = ue, this.end = ye, F.sourceFile !== null && (this.source = F.sourceFile);
      };
      function $t(g, F) {
        for (var ue = 1, ye = 0; ; ) {
          var Ee = je(g, ye, F);
          if (Ee < 0)
            return new it(ue, F - ye);
          ++ue, ye = Ee;
        }
      }
      var Tt = {
        // `ecmaVersion` indicates the ECMAScript version to parse. Must be
        // either 3, 5, 6 (or 2015), 7 (2016), 8 (2017), 9 (2018), 10
        // (2019), 11 (2020), 12 (2021), 13 (2022), 14 (2023), or `"latest"`
        // (the latest version the library supports). This influences
        // support for strict mode, the set of reserved words, and support
        // for new syntax features.
        ecmaVersion: null,
        // `sourceType` indicates the mode the code should be parsed in.
        // Can be either `"script"` or `"module"`. This influences global
        // strict mode and parsing of `import` and `export` declarations.
        sourceType: "script",
        // `onInsertedSemicolon` can be a callback that will be called when
        // a semicolon is automatically inserted. It will be passed the
        // position of the inserted semicolon as an offset, and if
        // `locations` is enabled, it is given the location as a `{line,
        // column}` object as second argument.
        onInsertedSemicolon: null,
        // `onTrailingComma` is similar to `onInsertedSemicolon`, but for
        // trailing commas.
        onTrailingComma: null,
        // By default, reserved words are only enforced if ecmaVersion >= 5.
        // Set `allowReserved` to a boolean value to explicitly turn this on
        // an off. When this option has the value "never", reserved words
        // and keywords can also not be used as property names.
        allowReserved: null,
        // When enabled, a return at the top level is not considered an
        // error.
        allowReturnOutsideFunction: !1,
        // When enabled, import/export statements are not constrained to
        // appearing at the top of the program, and an import.meta expression
        // in a script isn't considered an error.
        allowImportExportEverywhere: !1,
        // By default, await identifiers are allowed to appear at the top-level scope only if ecmaVersion >= 2022.
        // When enabled, await identifiers are allowed to appear at the top-level scope,
        // but they are still not allowed in non-async functions.
        allowAwaitOutsideFunction: null,
        // When enabled, super identifiers are not constrained to
        // appearing in methods and do not raise an error when they appear elsewhere.
        allowSuperOutsideMethod: null,
        // When enabled, hashbang directive in the beginning of file is
        // allowed and treated as a line comment. Enabled by default when
        // `ecmaVersion` >= 2023.
        allowHashBang: !1,
        // By default, the parser will verify that private properties are
        // only used in places where they are valid and have been declared.
        // Set this to false to turn such checks off.
        checkPrivateFields: !0,
        // When `locations` is on, `loc` properties holding objects with
        // `start` and `end` properties in `{line, column}` form (with
        // line being 1-based and column 0-based) will be attached to the
        // nodes.
        locations: !1,
        // A function can be passed as `onToken` option, which will
        // cause Acorn to call that function with object in the same
        // format as tokens returned from `tokenizer().getToken()`. Note
        // that you are not allowed to call the parser from the
        // callback—that will corrupt its internal state.
        onToken: null,
        // A function can be passed as `onComment` option, which will
        // cause Acorn to call that function with `(block, text, start,
        // end)` parameters whenever a comment is skipped. `block` is a
        // boolean indicating whether this is a block (`/* */`) comment,
        // `text` is the content of the comment, and `start` and `end` are
        // character offsets that denote the start and end of the comment.
        // When the `locations` option is on, two more parameters are
        // passed, the full `{line, column}` locations of the start and
        // end of the comments. Note that you are not allowed to call the
        // parser from the callback—that will corrupt its internal state.
        // When this option has an array as value, objects representing the
        // comments are pushed to it.
        onComment: null,
        // Nodes have their start and end characters offsets recorded in
        // `start` and `end` properties (directly on the node, rather than
        // the `loc` object, which holds line/column data. To also add a
        // [semi-standardized][range] `range` property holding a `[start,
        // end]` array with the same numbers, set the `ranges` option to
        // `true`.
        //
        // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
        ranges: !1,
        // It is possible to parse multiple files into a single AST by
        // passing the tree produced by parsing the first file as
        // `program` option in subsequent parses. This will add the
        // toplevel forms of the parsed file to the `Program` (top) node
        // of an existing parse tree.
        program: null,
        // When `locations` is on, you can pass this to record the source
        // file in every node's `loc` object.
        sourceFile: null,
        // This value, if given, is stored in every node, whether
        // `locations` is on or off.
        directSourceFile: null,
        // When enabled, parenthesized expressions are represented by
        // (non-standard) ParenthesizedExpression nodes
        preserveParens: !1
      }, Bi = !1;
      function en(g) {
        var F = {};
        for (var ue in Tt)
          F[ue] = g && ze(g, ue) ? g[ue] : Tt[ue];
        if (F.ecmaVersion === "latest" ? F.ecmaVersion = 1e8 : F.ecmaVersion == null ? (!Bi && typeof console == "object" && console.warn && (Bi = !0, console.warn(`Since Acorn 8.0.0, options.ecmaVersion is required.
Defaulting to 2020, but this will stop working in the future.`)), F.ecmaVersion = 11) : F.ecmaVersion >= 2015 && (F.ecmaVersion -= 2009), F.allowReserved == null && (F.allowReserved = F.ecmaVersion < 5), (!g || g.allowHashBang == null) && (F.allowHashBang = F.ecmaVersion >= 14), ht(F.onToken)) {
          var ye = F.onToken;
          F.onToken = function(Ee) {
            return ye.push(Ee);
          };
        }
        return ht(F.onComment) && (F.onComment = oi(F, F.onComment)), F;
      }
      function oi(g, F) {
        return function(ue, ye, Ee, nt, gt, Yt) {
          var qt = {
            type: ue ? "Block" : "Line",
            value: ye,
            start: Ee,
            end: nt
          };
          g.locations && (qt.loc = new Xt(this, gt, Yt)), g.ranges && (qt.range = [Ee, nt]), F.push(qt);
        };
      }
      var Zt = 1, Jt = 2, Qt = 4, rn = 8, Gi = 16, pe = 32, Lt = 64, xt = 128, Ne = 256, Ie = 512, et = Zt | Jt | Ne;
      function Et(g, F) {
        return Jt | (g ? Qt : 0) | (F ? rn : 0);
      }
      var ft = 0, tt = 1, _t = 2, Kt = 3, Ve = 4, i = 5, r = function(F, ue, ye) {
        this.options = F = en(F), this.sourceFile = F.sourceFile, this.keywords = $e(x[F.ecmaVersion >= 6 ? 6 : F.sourceType === "module" ? "5module" : 5]);
        var Ee = "";
        F.allowReserved !== !0 && (Ee = f[F.ecmaVersion >= 6 ? 6 : F.ecmaVersion === 5 ? 5 : 3], F.sourceType === "module" && (Ee += " await")), this.reservedWords = $e(Ee);
        var nt = (Ee ? Ee + " " : "") + f.strict;
        this.reservedWordsStrict = $e(nt), this.reservedWordsStrictBind = $e(nt + " " + f.strictBind), this.input = String(ue), this.containsEsc = !1, ye ? (this.pos = ye, this.lineStart = this.input.lastIndexOf(`
`, ye - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(Z).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = X.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = !0, this.inModule = F.sourceType === "module", this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.potentialArrowInForAwait = !1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = /* @__PURE__ */ Object.create(null), this.pos === 0 && F.allowHashBang && this.input.slice(0, 2) === "#!" && this.skipLineComment(2), this.scopeStack = [], this.enterScope(Zt), this.regexpState = null, this.privateNameStack = [];
      }, s = { inFunction: { configurable: !0 }, inGenerator: { configurable: !0 }, inAsync: { configurable: !0 }, canAwait: { configurable: !0 }, allowSuper: { configurable: !0 }, allowDirectSuper: { configurable: !0 }, treatFunctionsAsVar: { configurable: !0 }, allowNewDotTarget: { configurable: !0 }, inClassStaticBlock: { configurable: !0 } };
      r.prototype.parse = function() {
        var F = this.options.program || this.startNode();
        return this.nextToken(), this.parseTopLevel(F);
      }, s.inFunction.get = function() {
        return (this.currentVarScope().flags & Jt) > 0;
      }, s.inGenerator.get = function() {
        return (this.currentVarScope().flags & rn) > 0;
      }, s.inAsync.get = function() {
        return (this.currentVarScope().flags & Qt) > 0;
      }, s.canAwait.get = function() {
        for (var g = this.scopeStack.length - 1; g >= 0; g--) {
          var F = this.scopeStack[g], ue = F.flags;
          if (ue & (Ne | Ie))
            return !1;
          if (ue & Jt)
            return (ue & Qt) > 0;
        }
        return this.inModule && this.options.ecmaVersion >= 13 || this.options.allowAwaitOutsideFunction;
      }, s.allowSuper.get = function() {
        var g = this.currentThisScope(), F = g.flags;
        return (F & Lt) > 0 || this.options.allowSuperOutsideMethod;
      }, s.allowDirectSuper.get = function() {
        return (this.currentThisScope().flags & xt) > 0;
      }, s.treatFunctionsAsVar.get = function() {
        return this.treatFunctionsAsVarInScope(this.currentScope());
      }, s.allowNewDotTarget.get = function() {
        for (var g = this.scopeStack.length - 1; g >= 0; g--) {
          var F = this.scopeStack[g], ue = F.flags;
          if (ue & (Ne | Ie) || ue & Jt && !(ue & Gi))
            return !0;
        }
        return !1;
      }, s.inClassStaticBlock.get = function() {
        return (this.currentVarScope().flags & Ne) > 0;
      }, r.extend = function() {
        for (var F = [], ue = arguments.length; ue--; )
          F[ue] = arguments[ue];
        for (var ye = this, Ee = 0; Ee < F.length; Ee++)
          ye = F[Ee](ye);
        return ye;
      }, r.parse = function(F, ue) {
        return new this(ue, F).parse();
      }, r.parseExpressionAt = function(F, ue, ye) {
        var Ee = new this(ye, F, ue);
        return Ee.nextToken(), Ee.parseExpression();
      }, r.tokenizer = function(F, ue) {
        return new this(ue, F);
      }, Object.defineProperties(r.prototype, s);
      var l = r.prototype, u = /^(?:'((?:\\[^]|[^'\\])*?)'|"((?:\\[^]|[^"\\])*?)")/;
      l.strictDirective = function(g) {
        if (this.options.ecmaVersion < 5)
          return !1;
        for (; ; ) {
          Te.lastIndex = g, g += Te.exec(this.input)[0].length;
          var F = u.exec(this.input.slice(g));
          if (!F)
            return !1;
          if ((F[1] || F[2]) === "use strict") {
            Te.lastIndex = g + F[0].length;
            var ue = Te.exec(this.input), ye = ue.index + ue[0].length, Ee = this.input.charAt(ye);
            return Ee === ";" || Ee === "}" || Z.test(ue[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(Ee) || Ee === "!" && this.input.charAt(ye + 1) === "=");
          }
          g += F[0].length, Te.lastIndex = g, g += Te.exec(this.input)[0].length, this.input[g] === ";" && g++;
        }
      }, l.eat = function(g) {
        return this.type === g ? (this.next(), !0) : !1;
      }, l.isContextual = function(g) {
        return this.type === X.name && this.value === g && !this.containsEsc;
      }, l.eatContextual = function(g) {
        return this.isContextual(g) ? (this.next(), !0) : !1;
      }, l.expectContextual = function(g) {
        this.eatContextual(g) || this.unexpected();
      }, l.canInsertSemicolon = function() {
        return this.type === X.eof || this.type === X.braceR || Z.test(this.input.slice(this.lastTokEnd, this.start));
      }, l.insertSemicolon = function() {
        if (this.canInsertSemicolon())
          return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), !0;
      }, l.semicolon = function() {
        !this.eat(X.semi) && !this.insertSemicolon() && this.unexpected();
      }, l.afterTrailingComma = function(g, F) {
        if (this.type === g)
          return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), F || this.next(), !0;
      }, l.expect = function(g) {
        this.eat(g) || this.unexpected();
      }, l.unexpected = function(g) {
        this.raise(g ?? this.start, "Unexpected token");
      };
      var d = function() {
        this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
      };
      l.checkPatternErrors = function(g, F) {
        if (g) {
          g.trailingComma > -1 && this.raiseRecoverable(g.trailingComma, "Comma is not permitted after the rest element");
          var ue = F ? g.parenthesizedAssign : g.parenthesizedBind;
          ue > -1 && this.raiseRecoverable(ue, F ? "Assigning to rvalue" : "Parenthesized pattern");
        }
      }, l.checkExpressionErrors = function(g, F) {
        if (!g)
          return !1;
        var ue = g.shorthandAssign, ye = g.doubleProto;
        if (!F)
          return ue >= 0 || ye >= 0;
        ue >= 0 && this.raise(ue, "Shorthand property assignments are valid only in destructuring patterns"), ye >= 0 && this.raiseRecoverable(ye, "Redefinition of __proto__ property");
      }, l.checkYieldAwaitInDefaultParams = function() {
        this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
      }, l.isSimpleAssignTarget = function(g) {
        return g.type === "ParenthesizedExpression" ? this.isSimpleAssignTarget(g.expression) : g.type === "Identifier" || g.type === "MemberExpression";
      };
      var p = r.prototype;
      p.parseTopLevel = function(g) {
        var F = /* @__PURE__ */ Object.create(null);
        for (g.body || (g.body = []); this.type !== X.eof; ) {
          var ue = this.parseStatement(null, !0, F);
          g.body.push(ue);
        }
        if (this.inModule)
          for (var ye = 0, Ee = Object.keys(this.undefinedExports); ye < Ee.length; ye += 1) {
            var nt = Ee[ye];
            this.raiseRecoverable(this.undefinedExports[nt].start, "Export '" + nt + "' is not defined");
          }
        return this.adaptDirectivePrologue(g.body), this.next(), g.sourceType = this.options.sourceType, this.finishNode(g, "Program");
      };
      var m = { kind: "loop" }, y = { kind: "switch" };
      p.isLet = function(g) {
        if (this.options.ecmaVersion < 6 || !this.isContextual("let"))
          return !1;
        Te.lastIndex = this.pos;
        var F = Te.exec(this.input), ue = this.pos + F[0].length, ye = this.input.charCodeAt(ue);
        if (ye === 91 || ye === 92)
          return !0;
        if (g)
          return !1;
        if (ye === 123 || ye > 55295 && ye < 56320)
          return !0;
        if (W(ye, !0)) {
          for (var Ee = ue + 1; U(ye = this.input.charCodeAt(Ee), !0); )
            ++Ee;
          if (ye === 92 || ye > 55295 && ye < 56320)
            return !0;
          var nt = this.input.slice(ue, Ee);
          if (!k.test(nt))
            return !0;
        }
        return !1;
      }, p.isAsyncFunction = function() {
        if (this.options.ecmaVersion < 8 || !this.isContextual("async"))
          return !1;
        Te.lastIndex = this.pos;
        var g = Te.exec(this.input), F = this.pos + g[0].length, ue;
        return !Z.test(this.input.slice(this.pos, F)) && this.input.slice(F, F + 8) === "function" && (F + 8 === this.input.length || !(U(ue = this.input.charCodeAt(F + 8)) || ue > 55295 && ue < 56320));
      }, p.isUsingKeyword = function(g, F) {
        if (this.options.ecmaVersion < 17 || !this.isContextual(g ? "await" : "using"))
          return !1;
        Te.lastIndex = this.pos;
        var ue = Te.exec(this.input), ye = this.pos + ue[0].length;
        if (Z.test(this.input.slice(this.pos, ye)))
          return !1;
        if (g) {
          var Ee = ye + 5, nt;
          if (this.input.slice(ye, Ee) !== "using" || Ee === this.input.length || U(nt = this.input.charCodeAt(Ee)) || nt > 55295 && nt < 56320)
            return !1;
          Te.lastIndex = Ee;
          var gt = Te.exec(this.input);
          if (gt && Z.test(this.input.slice(Ee, Ee + gt[0].length)))
            return !1;
        }
        if (F) {
          var Yt = ye + 2, qt;
          if (this.input.slice(ye, Yt) === "of" && (Yt === this.input.length || !U(qt = this.input.charCodeAt(Yt)) && !(qt > 55295 && qt < 56320)))
            return !1;
        }
        var li = this.input.charCodeAt(ye);
        return W(li, !0) || li === 92;
      }, p.isAwaitUsing = function(g) {
        return this.isUsingKeyword(!0, g);
      }, p.isUsing = function(g) {
        return this.isUsingKeyword(!1, g);
      }, p.parseStatement = function(g, F, ue) {
        var ye = this.type, Ee = this.startNode(), nt;
        switch (this.isLet(g) && (ye = X._var, nt = "let"), ye) {
          case X._break:
          case X._continue:
            return this.parseBreakContinueStatement(Ee, ye.keyword);
          case X._debugger:
            return this.parseDebuggerStatement(Ee);
          case X._do:
            return this.parseDoStatement(Ee);
          case X._for:
            return this.parseForStatement(Ee);
          case X._function:
            return g && (this.strict || g !== "if" && g !== "label") && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(Ee, !1, !g);
          case X._class:
            return g && this.unexpected(), this.parseClass(Ee, !0);
          case X._if:
            return this.parseIfStatement(Ee);
          case X._return:
            return this.parseReturnStatement(Ee);
          case X._switch:
            return this.parseSwitchStatement(Ee);
          case X._throw:
            return this.parseThrowStatement(Ee);
          case X._try:
            return this.parseTryStatement(Ee);
          case X._const:
          case X._var:
            return nt = nt || this.value, g && nt !== "var" && this.unexpected(), this.parseVarStatement(Ee, nt);
          case X._while:
            return this.parseWhileStatement(Ee);
          case X._with:
            return this.parseWithStatement(Ee);
          case X.braceL:
            return this.parseBlock(!0, Ee);
          case X.semi:
            return this.parseEmptyStatement(Ee);
          case X._export:
          case X._import:
            if (this.options.ecmaVersion > 10 && ye === X._import) {
              Te.lastIndex = this.pos;
              var gt = Te.exec(this.input), Yt = this.pos + gt[0].length, qt = this.input.charCodeAt(Yt);
              if (qt === 40 || qt === 46)
                return this.parseExpressionStatement(Ee, this.parseExpression());
            }
            return this.options.allowImportExportEverywhere || (F || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), ye === X._import ? this.parseImport(Ee) : this.parseExport(Ee, ue);
          default:
            if (this.isAsyncFunction())
              return g && this.unexpected(), this.next(), this.parseFunctionStatement(Ee, !0, !g);
            var li = this.isAwaitUsing(!1) ? "await using" : this.isUsing(!1) ? "using" : null;
            if (li)
              return F && this.options.sourceType === "script" && this.raise(this.start, "Using declaration cannot appear in the top level when source type is `script`"), li === "await using" && (this.canAwait || this.raise(this.start, "Await using cannot appear outside of async function"), this.next()), this.next(), this.parseVar(Ee, !1, li), this.semicolon(), this.finishNode(Ee, "VariableDeclaration");
            var ni = this.value, si = this.parseExpression();
            return ye === X.name && si.type === "Identifier" && this.eat(X.colon) ? this.parseLabeledStatement(Ee, ni, si, g) : this.parseExpressionStatement(Ee, si);
        }
      }, p.parseBreakContinueStatement = function(g, F) {
        var ue = F === "break";
        this.next(), this.eat(X.semi) || this.insertSemicolon() ? g.label = null : this.type !== X.name ? this.unexpected() : (g.label = this.parseIdent(), this.semicolon());
        for (var ye = 0; ye < this.labels.length; ++ye) {
          var Ee = this.labels[ye];
          if ((g.label == null || Ee.name === g.label.name) && (Ee.kind != null && (ue || Ee.kind === "loop") || g.label && ue))
            break;
        }
        return ye === this.labels.length && this.raise(g.start, "Unsyntactic " + F), this.finishNode(g, ue ? "BreakStatement" : "ContinueStatement");
      }, p.parseDebuggerStatement = function(g) {
        return this.next(), this.semicolon(), this.finishNode(g, "DebuggerStatement");
      }, p.parseDoStatement = function(g) {
        return this.next(), this.labels.push(m), g.body = this.parseStatement("do"), this.labels.pop(), this.expect(X._while), g.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(X.semi) : this.semicolon(), this.finishNode(g, "DoWhileStatement");
      }, p.parseForStatement = function(g) {
        this.next();
        var F = this.options.ecmaVersion >= 9 && this.canAwait && this.eatContextual("await") ? this.lastTokStart : -1;
        if (this.labels.push(m), this.enterScope(0), this.expect(X.parenL), this.type === X.semi)
          return F > -1 && this.unexpected(F), this.parseFor(g, null);
        var ue = this.isLet();
        if (this.type === X._var || this.type === X._const || ue) {
          var ye = this.startNode(), Ee = ue ? "let" : this.value;
          return this.next(), this.parseVar(ye, !0, Ee), this.finishNode(ye, "VariableDeclaration"), this.parseForAfterInit(g, ye, F);
        }
        var nt = this.isContextual("let"), gt = !1, Yt = this.isUsing(!0) ? "using" : this.isAwaitUsing(!0) ? "await using" : null;
        if (Yt) {
          var qt = this.startNode();
          return this.next(), Yt === "await using" && this.next(), this.parseVar(qt, !0, Yt), this.finishNode(qt, "VariableDeclaration"), this.parseForAfterInit(g, qt, F);
        }
        var li = this.containsEsc, ni = new d(), si = this.start, xn = F > -1 ? this.parseExprSubscripts(ni, "await") : this.parseExpression(!0, ni);
        return this.type === X._in || (gt = this.options.ecmaVersion >= 6 && this.isContextual("of")) ? (F > -1 ? (this.type === X._in && this.unexpected(F), g.await = !0) : gt && this.options.ecmaVersion >= 8 && (xn.start === si && !li && xn.type === "Identifier" && xn.name === "async" ? this.unexpected() : this.options.ecmaVersion >= 9 && (g.await = !1)), nt && gt && this.raise(xn.start, "The left-hand side of a for-of loop may not start with 'let'."), this.toAssignable(xn, !1, ni), this.checkLValPattern(xn), this.parseForIn(g, xn)) : (this.checkExpressionErrors(ni, !0), F > -1 && this.unexpected(F), this.parseFor(g, xn));
      }, p.parseForAfterInit = function(g, F, ue) {
        return (this.type === X._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && F.declarations.length === 1 ? (this.options.ecmaVersion >= 9 && (this.type === X._in ? ue > -1 && this.unexpected(ue) : g.await = ue > -1), this.parseForIn(g, F)) : (ue > -1 && this.unexpected(ue), this.parseFor(g, F));
      }, p.parseFunctionStatement = function(g, F, ue) {
        return this.next(), this.parseFunction(g, L | (ue ? 0 : E), !1, F);
      }, p.parseIfStatement = function(g) {
        return this.next(), g.test = this.parseParenExpression(), g.consequent = this.parseStatement("if"), g.alternate = this.eat(X._else) ? this.parseStatement("if") : null, this.finishNode(g, "IfStatement");
      }, p.parseReturnStatement = function(g) {
        return !this.inFunction && !this.options.allowReturnOutsideFunction && this.raise(this.start, "'return' outside of function"), this.next(), this.eat(X.semi) || this.insertSemicolon() ? g.argument = null : (g.argument = this.parseExpression(), this.semicolon()), this.finishNode(g, "ReturnStatement");
      }, p.parseSwitchStatement = function(g) {
        this.next(), g.discriminant = this.parseParenExpression(), g.cases = [], this.expect(X.braceL), this.labels.push(y), this.enterScope(0);
        for (var F, ue = !1; this.type !== X.braceR; )
          if (this.type === X._case || this.type === X._default) {
            var ye = this.type === X._case;
            F && this.finishNode(F, "SwitchCase"), g.cases.push(F = this.startNode()), F.consequent = [], this.next(), ye ? F.test = this.parseExpression() : (ue && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), ue = !0, F.test = null), this.expect(X.colon);
          } else
            F || this.unexpected(), F.consequent.push(this.parseStatement(null));
        return this.exitScope(), F && this.finishNode(F, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(g, "SwitchStatement");
      }, p.parseThrowStatement = function(g) {
        return this.next(), Z.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), g.argument = this.parseExpression(), this.semicolon(), this.finishNode(g, "ThrowStatement");
      };
      var S = [];
      p.parseCatchClauseParam = function() {
        var g = this.parseBindingAtom(), F = g.type === "Identifier";
        return this.enterScope(F ? pe : 0), this.checkLValPattern(g, F ? Ve : _t), this.expect(X.parenR), g;
      }, p.parseTryStatement = function(g) {
        if (this.next(), g.block = this.parseBlock(), g.handler = null, this.type === X._catch) {
          var F = this.startNode();
          this.next(), this.eat(X.parenL) ? F.param = this.parseCatchClauseParam() : (this.options.ecmaVersion < 10 && this.unexpected(), F.param = null, this.enterScope(0)), F.body = this.parseBlock(!1), this.exitScope(), g.handler = this.finishNode(F, "CatchClause");
        }
        return g.finalizer = this.eat(X._finally) ? this.parseBlock() : null, !g.handler && !g.finalizer && this.raise(g.start, "Missing catch or finally clause"), this.finishNode(g, "TryStatement");
      }, p.parseVarStatement = function(g, F, ue) {
        return this.next(), this.parseVar(g, !1, F, ue), this.semicolon(), this.finishNode(g, "VariableDeclaration");
      }, p.parseWhileStatement = function(g) {
        return this.next(), g.test = this.parseParenExpression(), this.labels.push(m), g.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(g, "WhileStatement");
      }, p.parseWithStatement = function(g) {
        return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), g.object = this.parseParenExpression(), g.body = this.parseStatement("with"), this.finishNode(g, "WithStatement");
      }, p.parseEmptyStatement = function(g) {
        return this.next(), this.finishNode(g, "EmptyStatement");
      }, p.parseLabeledStatement = function(g, F, ue, ye) {
        for (var Ee = 0, nt = this.labels; Ee < nt.length; Ee += 1) {
          var gt = nt[Ee];
          gt.name === F && this.raise(ue.start, "Label '" + F + "' is already declared");
        }
        for (var Yt = this.type.isLoop ? "loop" : this.type === X._switch ? "switch" : null, qt = this.labels.length - 1; qt >= 0; qt--) {
          var li = this.labels[qt];
          if (li.statementStart === g.start)
            li.statementStart = this.start, li.kind = Yt;
          else
            break;
        }
        return this.labels.push({ name: F, kind: Yt, statementStart: this.start }), g.body = this.parseStatement(ye ? ye.indexOf("label") === -1 ? ye + "label" : ye : "label"), this.labels.pop(), g.label = ue, this.finishNode(g, "LabeledStatement");
      }, p.parseExpressionStatement = function(g, F) {
        return g.expression = F, this.semicolon(), this.finishNode(g, "ExpressionStatement");
      }, p.parseBlock = function(g, F, ue) {
        for (g === void 0 && (g = !0), F === void 0 && (F = this.startNode()), F.body = [], this.expect(X.braceL), g && this.enterScope(0); this.type !== X.braceR; ) {
          var ye = this.parseStatement(null);
          F.body.push(ye);
        }
        return ue && (this.strict = !1), this.next(), g && this.exitScope(), this.finishNode(F, "BlockStatement");
      }, p.parseFor = function(g, F) {
        return g.init = F, this.expect(X.semi), g.test = this.type === X.semi ? null : this.parseExpression(), this.expect(X.semi), g.update = this.type === X.parenR ? null : this.parseExpression(), this.expect(X.parenR), g.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(g, "ForStatement");
      }, p.parseForIn = function(g, F) {
        var ue = this.type === X._in;
        return this.next(), F.type === "VariableDeclaration" && F.declarations[0].init != null && (!ue || this.options.ecmaVersion < 8 || this.strict || F.kind !== "var" || F.declarations[0].id.type !== "Identifier") && this.raise(
          F.start,
          (ue ? "for-in" : "for-of") + " loop variable declaration may not have an initializer"
        ), g.left = F, g.right = ue ? this.parseExpression() : this.parseMaybeAssign(), this.expect(X.parenR), g.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(g, ue ? "ForInStatement" : "ForOfStatement");
      }, p.parseVar = function(g, F, ue, ye) {
        for (g.declarations = [], g.kind = ue; ; ) {
          var Ee = this.startNode();
          if (this.parseVarId(Ee, ue), this.eat(X.eq) ? Ee.init = this.parseMaybeAssign(F) : !ye && ue === "const" && !(this.type === X._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) ? this.unexpected() : !ye && (ue === "using" || ue === "await using") && this.options.ecmaVersion >= 17 && this.type !== X._in && !this.isContextual("of") ? this.raise(this.lastTokEnd, "Missing initializer in " + ue + " declaration") : !ye && Ee.id.type !== "Identifier" && !(F && (this.type === X._in || this.isContextual("of"))) ? this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : Ee.init = null, g.declarations.push(this.finishNode(Ee, "VariableDeclarator")), !this.eat(X.comma))
            break;
        }
        return g;
      }, p.parseVarId = function(g, F) {
        g.id = F === "using" || F === "await using" ? this.parseIdent() : this.parseBindingAtom(), this.checkLValPattern(g.id, F === "var" ? tt : _t, !1);
      };
      var L = 1, E = 2, A = 4;
      p.parseFunction = function(g, F, ue, ye, Ee) {
        this.initFunction(g), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !ye) && (this.type === X.star && F & E && this.unexpected(), g.generator = this.eat(X.star)), this.options.ecmaVersion >= 8 && (g.async = !!ye), F & L && (g.id = F & A && this.type !== X.name ? null : this.parseIdent(), g.id && !(F & E) && this.checkLValSimple(g.id, this.strict || g.generator || g.async ? this.treatFunctionsAsVar ? tt : _t : Kt));
        var nt = this.yieldPos, gt = this.awaitPos, Yt = this.awaitIdentPos;
        return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(Et(g.async, g.generator)), F & L || (g.id = this.type === X.name ? this.parseIdent() : null), this.parseFunctionParams(g), this.parseFunctionBody(g, ue, !1, Ee), this.yieldPos = nt, this.awaitPos = gt, this.awaitIdentPos = Yt, this.finishNode(g, F & L ? "FunctionDeclaration" : "FunctionExpression");
      }, p.parseFunctionParams = function(g) {
        this.expect(X.parenL), g.params = this.parseBindingList(X.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
      }, p.parseClass = function(g, F) {
        this.next();
        var ue = this.strict;
        this.strict = !0, this.parseClassId(g, F), this.parseClassSuper(g);
        var ye = this.enterClassBody(), Ee = this.startNode(), nt = !1;
        for (Ee.body = [], this.expect(X.braceL); this.type !== X.braceR; ) {
          var gt = this.parseClassElement(g.superClass !== null);
          gt && (Ee.body.push(gt), gt.type === "MethodDefinition" && gt.kind === "constructor" ? (nt && this.raiseRecoverable(gt.start, "Duplicate constructor in the same class"), nt = !0) : gt.key && gt.key.type === "PrivateIdentifier" && T(ye, gt) && this.raiseRecoverable(gt.key.start, "Identifier '#" + gt.key.name + "' has already been declared"));
        }
        return this.strict = ue, this.next(), g.body = this.finishNode(Ee, "ClassBody"), this.exitClassBody(), this.finishNode(g, F ? "ClassDeclaration" : "ClassExpression");
      }, p.parseClassElement = function(g) {
        if (this.eat(X.semi))
          return null;
        var F = this.options.ecmaVersion, ue = this.startNode(), ye = "", Ee = !1, nt = !1, gt = "method", Yt = !1;
        if (this.eatContextual("static")) {
          if (F >= 13 && this.eat(X.braceL))
            return this.parseClassStaticBlock(ue), ue;
          this.isClassElementNameStart() || this.type === X.star ? Yt = !0 : ye = "static";
        }
        if (ue.static = Yt, !ye && F >= 8 && this.eatContextual("async") && ((this.isClassElementNameStart() || this.type === X.star) && !this.canInsertSemicolon() ? nt = !0 : ye = "async"), !ye && (F >= 9 || !nt) && this.eat(X.star) && (Ee = !0), !ye && !nt && !Ee) {
          var qt = this.value;
          (this.eatContextual("get") || this.eatContextual("set")) && (this.isClassElementNameStart() ? gt = qt : ye = qt);
        }
        if (ye ? (ue.computed = !1, ue.key = this.startNodeAt(this.lastTokStart, this.lastTokStartLoc), ue.key.name = ye, this.finishNode(ue.key, "Identifier")) : this.parseClassElementName(ue), F < 13 || this.type === X.parenL || gt !== "method" || Ee || nt) {
          var li = !ue.static && G(ue, "constructor"), ni = li && g;
          li && gt !== "method" && this.raise(ue.key.start, "Constructor can't have get/set modifier"), ue.kind = li ? "constructor" : gt, this.parseClassMethod(ue, Ee, nt, ni);
        } else
          this.parseClassField(ue);
        return ue;
      }, p.isClassElementNameStart = function() {
        return this.type === X.name || this.type === X.privateId || this.type === X.num || this.type === X.string || this.type === X.bracketL || this.type.keyword;
      }, p.parseClassElementName = function(g) {
        this.type === X.privateId ? (this.value === "constructor" && this.raise(this.start, "Classes can't have an element named '#constructor'"), g.computed = !1, g.key = this.parsePrivateIdent()) : this.parsePropertyName(g);
      }, p.parseClassMethod = function(g, F, ue, ye) {
        var Ee = g.key;
        g.kind === "constructor" ? (F && this.raise(Ee.start, "Constructor can't be a generator"), ue && this.raise(Ee.start, "Constructor can't be an async method")) : g.static && G(g, "prototype") && this.raise(Ee.start, "Classes may not have a static property named prototype");
        var nt = g.value = this.parseMethod(F, ue, ye);
        return g.kind === "get" && nt.params.length !== 0 && this.raiseRecoverable(nt.start, "getter should have no params"), g.kind === "set" && nt.params.length !== 1 && this.raiseRecoverable(nt.start, "setter should have exactly one param"), g.kind === "set" && nt.params[0].type === "RestElement" && this.raiseRecoverable(nt.params[0].start, "Setter cannot use rest params"), this.finishNode(g, "MethodDefinition");
      }, p.parseClassField = function(g) {
        return G(g, "constructor") ? this.raise(g.key.start, "Classes can't have a field named 'constructor'") : g.static && G(g, "prototype") && this.raise(g.key.start, "Classes can't have a static field named 'prototype'"), this.eat(X.eq) ? (this.enterScope(Ie | Lt), g.value = this.parseMaybeAssign(), this.exitScope()) : g.value = null, this.semicolon(), this.finishNode(g, "PropertyDefinition");
      }, p.parseClassStaticBlock = function(g) {
        g.body = [];
        var F = this.labels;
        for (this.labels = [], this.enterScope(Ne | Lt); this.type !== X.braceR; ) {
          var ue = this.parseStatement(null);
          g.body.push(ue);
        }
        return this.next(), this.exitScope(), this.labels = F, this.finishNode(g, "StaticBlock");
      }, p.parseClassId = function(g, F) {
        this.type === X.name ? (g.id = this.parseIdent(), F && this.checkLValSimple(g.id, _t, !1)) : (F === !0 && this.unexpected(), g.id = null);
      }, p.parseClassSuper = function(g) {
        g.superClass = this.eat(X._extends) ? this.parseExprSubscripts(null, !1) : null;
      }, p.enterClassBody = function() {
        var g = { declared: /* @__PURE__ */ Object.create(null), used: [] };
        return this.privateNameStack.push(g), g.declared;
      }, p.exitClassBody = function() {
        var g = this.privateNameStack.pop(), F = g.declared, ue = g.used;
        if (this.options.checkPrivateFields)
          for (var ye = this.privateNameStack.length, Ee = ye === 0 ? null : this.privateNameStack[ye - 1], nt = 0; nt < ue.length; ++nt) {
            var gt = ue[nt];
            ze(F, gt.name) || (Ee ? Ee.used.push(gt) : this.raiseRecoverable(gt.start, "Private field '#" + gt.name + "' must be declared in an enclosing class"));
          }
      };
      function T(g, F) {
        var ue = F.key.name, ye = g[ue], Ee = "true";
        return F.type === "MethodDefinition" && (F.kind === "get" || F.kind === "set") && (Ee = (F.static ? "s" : "i") + F.kind), ye === "iget" && Ee === "iset" || ye === "iset" && Ee === "iget" || ye === "sget" && Ee === "sset" || ye === "sset" && Ee === "sget" ? (g[ue] = "true", !1) : ye ? !0 : (g[ue] = Ee, !1);
      }
      function G(g, F) {
        var ue = g.computed, ye = g.key;
        return !ue && (ye.type === "Identifier" && ye.name === F || ye.type === "Literal" && ye.value === F);
      }
      p.parseExportAllDeclaration = function(g, F) {
        return this.options.ecmaVersion >= 11 && (this.eatContextual("as") ? (g.exported = this.parseModuleExportName(), this.checkExport(F, g.exported, this.lastTokStart)) : g.exported = null), this.expectContextual("from"), this.type !== X.string && this.unexpected(), g.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (g.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(g, "ExportAllDeclaration");
      }, p.parseExport = function(g, F) {
        if (this.next(), this.eat(X.star))
          return this.parseExportAllDeclaration(g, F);
        if (this.eat(X._default))
          return this.checkExport(F, "default", this.lastTokStart), g.declaration = this.parseExportDefaultDeclaration(), this.finishNode(g, "ExportDefaultDeclaration");
        if (this.shouldParseExportStatement())
          g.declaration = this.parseExportDeclaration(g), g.declaration.type === "VariableDeclaration" ? this.checkVariableExport(F, g.declaration.declarations) : this.checkExport(F, g.declaration.id, g.declaration.id.start), g.specifiers = [], g.source = null, this.options.ecmaVersion >= 16 && (g.attributes = []);
        else {
          if (g.declaration = null, g.specifiers = this.parseExportSpecifiers(F), this.eatContextual("from"))
            this.type !== X.string && this.unexpected(), g.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (g.attributes = this.parseWithClause());
          else {
            for (var ue = 0, ye = g.specifiers; ue < ye.length; ue += 1) {
              var Ee = ye[ue];
              this.checkUnreserved(Ee.local), this.checkLocalExport(Ee.local), Ee.local.type === "Literal" && this.raise(Ee.local.start, "A string literal cannot be used as an exported binding without `from`.");
            }
            g.source = null, this.options.ecmaVersion >= 16 && (g.attributes = []);
          }
          this.semicolon();
        }
        return this.finishNode(g, "ExportNamedDeclaration");
      }, p.parseExportDeclaration = function(g) {
        return this.parseStatement(null);
      }, p.parseExportDefaultDeclaration = function() {
        var g;
        if (this.type === X._function || (g = this.isAsyncFunction())) {
          var F = this.startNode();
          return this.next(), g && this.next(), this.parseFunction(F, L | A, !1, g);
        } else if (this.type === X._class) {
          var ue = this.startNode();
          return this.parseClass(ue, "nullableID");
        } else {
          var ye = this.parseMaybeAssign();
          return this.semicolon(), ye;
        }
      }, p.checkExport = function(g, F, ue) {
        g && (typeof F != "string" && (F = F.type === "Identifier" ? F.name : F.value), ze(g, F) && this.raiseRecoverable(ue, "Duplicate export '" + F + "'"), g[F] = !0);
      }, p.checkPatternExport = function(g, F) {
        var ue = F.type;
        if (ue === "Identifier")
          this.checkExport(g, F, F.start);
        else if (ue === "ObjectPattern")
          for (var ye = 0, Ee = F.properties; ye < Ee.length; ye += 1) {
            var nt = Ee[ye];
            this.checkPatternExport(g, nt);
          }
        else if (ue === "ArrayPattern")
          for (var gt = 0, Yt = F.elements; gt < Yt.length; gt += 1) {
            var qt = Yt[gt];
            qt && this.checkPatternExport(g, qt);
          }
        else
          ue === "Property" ? this.checkPatternExport(g, F.value) : ue === "AssignmentPattern" ? this.checkPatternExport(g, F.left) : ue === "RestElement" && this.checkPatternExport(g, F.argument);
      }, p.checkVariableExport = function(g, F) {
        if (g)
          for (var ue = 0, ye = F; ue < ye.length; ue += 1) {
            var Ee = ye[ue];
            this.checkPatternExport(g, Ee.id);
          }
      }, p.shouldParseExportStatement = function() {
        return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
      }, p.parseExportSpecifier = function(g) {
        var F = this.startNode();
        return F.local = this.parseModuleExportName(), F.exported = this.eatContextual("as") ? this.parseModuleExportName() : F.local, this.checkExport(
          g,
          F.exported,
          F.exported.start
        ), this.finishNode(F, "ExportSpecifier");
      }, p.parseExportSpecifiers = function(g) {
        var F = [], ue = !0;
        for (this.expect(X.braceL); !this.eat(X.braceR); ) {
          if (ue)
            ue = !1;
          else if (this.expect(X.comma), this.afterTrailingComma(X.braceR))
            break;
          F.push(this.parseExportSpecifier(g));
        }
        return F;
      }, p.parseImport = function(g) {
        return this.next(), this.type === X.string ? (g.specifiers = S, g.source = this.parseExprAtom()) : (g.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), g.source = this.type === X.string ? this.parseExprAtom() : this.unexpected()), this.options.ecmaVersion >= 16 && (g.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(g, "ImportDeclaration");
      }, p.parseImportSpecifier = function() {
        var g = this.startNode();
        return g.imported = this.parseModuleExportName(), this.eatContextual("as") ? g.local = this.parseIdent() : (this.checkUnreserved(g.imported), g.local = g.imported), this.checkLValSimple(g.local, _t), this.finishNode(g, "ImportSpecifier");
      }, p.parseImportDefaultSpecifier = function() {
        var g = this.startNode();
        return g.local = this.parseIdent(), this.checkLValSimple(g.local, _t), this.finishNode(g, "ImportDefaultSpecifier");
      }, p.parseImportNamespaceSpecifier = function() {
        var g = this.startNode();
        return this.next(), this.expectContextual("as"), g.local = this.parseIdent(), this.checkLValSimple(g.local, _t), this.finishNode(g, "ImportNamespaceSpecifier");
      }, p.parseImportSpecifiers = function() {
        var g = [], F = !0;
        if (this.type === X.name && (g.push(this.parseImportDefaultSpecifier()), !this.eat(X.comma)))
          return g;
        if (this.type === X.star)
          return g.push(this.parseImportNamespaceSpecifier()), g;
        for (this.expect(X.braceL); !this.eat(X.braceR); ) {
          if (F)
            F = !1;
          else if (this.expect(X.comma), this.afterTrailingComma(X.braceR))
            break;
          g.push(this.parseImportSpecifier());
        }
        return g;
      }, p.parseWithClause = function() {
        var g = [];
        if (!this.eat(X._with))
          return g;
        this.expect(X.braceL);
        for (var F = {}, ue = !0; !this.eat(X.braceR); ) {
          if (ue)
            ue = !1;
          else if (this.expect(X.comma), this.afterTrailingComma(X.braceR))
            break;
          var ye = this.parseImportAttribute(), Ee = ye.key.type === "Identifier" ? ye.key.name : ye.key.value;
          ze(F, Ee) && this.raiseRecoverable(ye.key.start, "Duplicate attribute key '" + Ee + "'"), F[Ee] = !0, g.push(ye);
        }
        return g;
      }, p.parseImportAttribute = function() {
        var g = this.startNode();
        return g.key = this.type === X.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never"), this.expect(X.colon), this.type !== X.string && this.unexpected(), g.value = this.parseExprAtom(), this.finishNode(g, "ImportAttribute");
      }, p.parseModuleExportName = function() {
        if (this.options.ecmaVersion >= 13 && this.type === X.string) {
          var g = this.parseLiteral(this.value);
          return rt.test(g.value) && this.raise(g.start, "An export name cannot include a lone surrogate."), g;
        }
        return this.parseIdent(!0);
      }, p.adaptDirectivePrologue = function(g) {
        for (var F = 0; F < g.length && this.isDirectiveCandidate(g[F]); ++F)
          g[F].directive = g[F].expression.raw.slice(1, -1);
      }, p.isDirectiveCandidate = function(g) {
        return this.options.ecmaVersion >= 5 && g.type === "ExpressionStatement" && g.expression.type === "Literal" && typeof g.expression.value == "string" && // Reject parenthesized strings.
        (this.input[g.start] === '"' || this.input[g.start] === "'");
      };
      var O = r.prototype;
      O.toAssignable = function(g, F, ue) {
        if (this.options.ecmaVersion >= 6 && g)
          switch (g.type) {
            case "Identifier":
              this.inAsync && g.name === "await" && this.raise(g.start, "Cannot use 'await' as identifier inside an async function");
              break;
            case "ObjectPattern":
            case "ArrayPattern":
            case "AssignmentPattern":
            case "RestElement":
              break;
            case "ObjectExpression":
              g.type = "ObjectPattern", ue && this.checkPatternErrors(ue, !0);
              for (var ye = 0, Ee = g.properties; ye < Ee.length; ye += 1) {
                var nt = Ee[ye];
                this.toAssignable(nt, F), nt.type === "RestElement" && (nt.argument.type === "ArrayPattern" || nt.argument.type === "ObjectPattern") && this.raise(nt.argument.start, "Unexpected token");
              }
              break;
            case "Property":
              g.kind !== "init" && this.raise(g.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(g.value, F);
              break;
            case "ArrayExpression":
              g.type = "ArrayPattern", ue && this.checkPatternErrors(ue, !0), this.toAssignableList(g.elements, F);
              break;
            case "SpreadElement":
              g.type = "RestElement", this.toAssignable(g.argument, F), g.argument.type === "AssignmentPattern" && this.raise(g.argument.start, "Rest elements cannot have a default value");
              break;
            case "AssignmentExpression":
              g.operator !== "=" && this.raise(g.left.end, "Only '=' operator can be used for specifying default value."), g.type = "AssignmentPattern", delete g.operator, this.toAssignable(g.left, F);
              break;
            case "ParenthesizedExpression":
              this.toAssignable(g.expression, F, ue);
              break;
            case "ChainExpression":
              this.raiseRecoverable(g.start, "Optional chaining cannot appear in left-hand side");
              break;
            case "MemberExpression":
              if (!F)
                break;
            default:
              this.raise(g.start, "Assigning to rvalue");
          }
        else
          ue && this.checkPatternErrors(ue, !0);
        return g;
      }, O.toAssignableList = function(g, F) {
        for (var ue = g.length, ye = 0; ye < ue; ye++) {
          var Ee = g[ye];
          Ee && this.toAssignable(Ee, F);
        }
        if (ue) {
          var nt = g[ue - 1];
          this.options.ecmaVersion === 6 && F && nt && nt.type === "RestElement" && nt.argument.type !== "Identifier" && this.unexpected(nt.argument.start);
        }
        return g;
      }, O.parseSpread = function(g) {
        var F = this.startNode();
        return this.next(), F.argument = this.parseMaybeAssign(!1, g), this.finishNode(F, "SpreadElement");
      }, O.parseRestBinding = function() {
        var g = this.startNode();
        return this.next(), this.options.ecmaVersion === 6 && this.type !== X.name && this.unexpected(), g.argument = this.parseBindingAtom(), this.finishNode(g, "RestElement");
      }, O.parseBindingAtom = function() {
        if (this.options.ecmaVersion >= 6)
          switch (this.type) {
            case X.bracketL:
              var g = this.startNode();
              return this.next(), g.elements = this.parseBindingList(X.bracketR, !0, !0), this.finishNode(g, "ArrayPattern");
            case X.braceL:
              return this.parseObj(!0);
          }
        return this.parseIdent();
      }, O.parseBindingList = function(g, F, ue, ye) {
        for (var Ee = [], nt = !0; !this.eat(g); )
          if (nt ? nt = !1 : this.expect(X.comma), F && this.type === X.comma)
            Ee.push(null);
          else {
            if (ue && this.afterTrailingComma(g))
              break;
            if (this.type === X.ellipsis) {
              var gt = this.parseRestBinding();
              this.parseBindingListItem(gt), Ee.push(gt), this.type === X.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.expect(g);
              break;
            } else
              Ee.push(this.parseAssignableListItem(ye));
          }
        return Ee;
      }, O.parseAssignableListItem = function(g) {
        var F = this.parseMaybeDefault(this.start, this.startLoc);
        return this.parseBindingListItem(F), F;
      }, O.parseBindingListItem = function(g) {
        return g;
      }, O.parseMaybeDefault = function(g, F, ue) {
        if (ue = ue || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(X.eq))
          return ue;
        var ye = this.startNodeAt(g, F);
        return ye.left = ue, ye.right = this.parseMaybeAssign(), this.finishNode(ye, "AssignmentPattern");
      }, O.checkLValSimple = function(g, F, ue) {
        F === void 0 && (F = ft);
        var ye = F !== ft;
        switch (g.type) {
          case "Identifier":
            this.strict && this.reservedWordsStrictBind.test(g.name) && this.raiseRecoverable(g.start, (ye ? "Binding " : "Assigning to ") + g.name + " in strict mode"), ye && (F === _t && g.name === "let" && this.raiseRecoverable(g.start, "let is disallowed as a lexically bound name"), ue && (ze(ue, g.name) && this.raiseRecoverable(g.start, "Argument name clash"), ue[g.name] = !0), F !== i && this.declareName(g.name, F, g.start));
            break;
          case "ChainExpression":
            this.raiseRecoverable(g.start, "Optional chaining cannot appear in left-hand side");
            break;
          case "MemberExpression":
            ye && this.raiseRecoverable(g.start, "Binding member expression");
            break;
          case "ParenthesizedExpression":
            return ye && this.raiseRecoverable(g.start, "Binding parenthesized expression"), this.checkLValSimple(g.expression, F, ue);
          default:
            this.raise(g.start, (ye ? "Binding" : "Assigning to") + " rvalue");
        }
      }, O.checkLValPattern = function(g, F, ue) {
        switch (F === void 0 && (F = ft), g.type) {
          case "ObjectPattern":
            for (var ye = 0, Ee = g.properties; ye < Ee.length; ye += 1) {
              var nt = Ee[ye];
              this.checkLValInnerPattern(nt, F, ue);
            }
            break;
          case "ArrayPattern":
            for (var gt = 0, Yt = g.elements; gt < Yt.length; gt += 1) {
              var qt = Yt[gt];
              qt && this.checkLValInnerPattern(qt, F, ue);
            }
            break;
          default:
            this.checkLValSimple(g, F, ue);
        }
      }, O.checkLValInnerPattern = function(g, F, ue) {
        switch (F === void 0 && (F = ft), g.type) {
          case "Property":
            this.checkLValInnerPattern(g.value, F, ue);
            break;
          case "AssignmentPattern":
            this.checkLValPattern(g.left, F, ue);
            break;
          case "RestElement":
            this.checkLValPattern(g.argument, F, ue);
            break;
          default:
            this.checkLValPattern(g, F, ue);
        }
      };
      var Y = function(F, ue, ye, Ee, nt) {
        this.token = F, this.isExpr = !!ue, this.preserveSpace = !!ye, this.override = Ee, this.generator = !!nt;
      }, B = {
        b_stat: new Y("{", !1),
        b_expr: new Y("{", !0),
        b_tmpl: new Y("${", !1),
        p_stat: new Y("(", !1),
        p_expr: new Y("(", !0),
        q_tmpl: new Y("`", !0, !0, function(g) {
          return g.tryReadTemplateToken();
        }),
        f_stat: new Y("function", !1),
        f_expr: new Y("function", !0),
        f_expr_gen: new Y("function", !0, !1, null, !0),
        f_gen: new Y("function", !1, !1, null, !0)
      }, z = r.prototype;
      z.initialContext = function() {
        return [B.b_stat];
      }, z.curContext = function() {
        return this.context[this.context.length - 1];
      }, z.braceIsBlock = function(g) {
        var F = this.curContext();
        return F === B.f_expr || F === B.f_stat ? !0 : g === X.colon && (F === B.b_stat || F === B.b_expr) ? !F.isExpr : g === X._return || g === X.name && this.exprAllowed ? Z.test(this.input.slice(this.lastTokEnd, this.start)) : g === X._else || g === X.semi || g === X.eof || g === X.parenR || g === X.arrow ? !0 : g === X.braceL ? F === B.b_stat : g === X._var || g === X._const || g === X.name ? !1 : !this.exprAllowed;
      }, z.inGeneratorContext = function() {
        for (var g = this.context.length - 1; g >= 1; g--) {
          var F = this.context[g];
          if (F.token === "function")
            return F.generator;
        }
        return !1;
      }, z.updateContext = function(g) {
        var F, ue = this.type;
        ue.keyword && g === X.dot ? this.exprAllowed = !1 : (F = ue.updateContext) ? F.call(this, g) : this.exprAllowed = ue.beforeExpr;
      }, z.overrideContext = function(g) {
        this.curContext() !== g && (this.context[this.context.length - 1] = g);
      }, X.parenR.updateContext = X.braceR.updateContext = function() {
        if (this.context.length === 1) {
          this.exprAllowed = !0;
          return;
        }
        var g = this.context.pop();
        g === B.b_stat && this.curContext().token === "function" && (g = this.context.pop()), this.exprAllowed = !g.isExpr;
      }, X.braceL.updateContext = function(g) {
        this.context.push(this.braceIsBlock(g) ? B.b_stat : B.b_expr), this.exprAllowed = !0;
      }, X.dollarBraceL.updateContext = function() {
        this.context.push(B.b_tmpl), this.exprAllowed = !0;
      }, X.parenL.updateContext = function(g) {
        var F = g === X._if || g === X._for || g === X._with || g === X._while;
        this.context.push(F ? B.p_stat : B.p_expr), this.exprAllowed = !0;
      }, X.incDec.updateContext = function() {
      }, X._function.updateContext = X._class.updateContext = function(g) {
        g.beforeExpr && g !== X._else && !(g === X.semi && this.curContext() !== B.p_stat) && !(g === X._return && Z.test(this.input.slice(this.lastTokEnd, this.start))) && !((g === X.colon || g === X.braceL) && this.curContext() === B.b_stat) ? this.context.push(B.f_expr) : this.context.push(B.f_stat), this.exprAllowed = !1;
      }, X.colon.updateContext = function() {
        this.curContext().token === "function" && this.context.pop(), this.exprAllowed = !0;
      }, X.backQuote.updateContext = function() {
        this.curContext() === B.q_tmpl ? this.context.pop() : this.context.push(B.q_tmpl), this.exprAllowed = !1;
      }, X.star.updateContext = function(g) {
        if (g === X._function) {
          var F = this.context.length - 1;
          this.context[F] === B.f_expr ? this.context[F] = B.f_expr_gen : this.context[F] = B.f_gen;
        }
        this.exprAllowed = !0;
      }, X.name.updateContext = function(g) {
        var F = !1;
        this.options.ecmaVersion >= 6 && g !== X.dot && (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) && (F = !0), this.exprAllowed = F;
      };
      var C = r.prototype;
      C.checkPropClash = function(g, F, ue) {
        if (!(this.options.ecmaVersion >= 9 && g.type === "SpreadElement") && !(this.options.ecmaVersion >= 6 && (g.computed || g.method || g.shorthand))) {
          var ye = g.key, Ee;
          switch (ye.type) {
            case "Identifier":
              Ee = ye.name;
              break;
            case "Literal":
              Ee = String(ye.value);
              break;
            default:
              return;
          }
          var nt = g.kind;
          if (this.options.ecmaVersion >= 6) {
            Ee === "__proto__" && nt === "init" && (F.proto && (ue ? ue.doubleProto < 0 && (ue.doubleProto = ye.start) : this.raiseRecoverable(ye.start, "Redefinition of __proto__ property")), F.proto = !0);
            return;
          }
          Ee = "$" + Ee;
          var gt = F[Ee];
          if (gt) {
            var Yt;
            nt === "init" ? Yt = this.strict && gt.init || gt.get || gt.set : Yt = gt.init || gt[nt], Yt && this.raiseRecoverable(ye.start, "Redefinition of property");
          } else
            gt = F[Ee] = {
              init: !1,
              get: !1,
              set: !1
            };
          gt[nt] = !0;
        }
      }, C.parseExpression = function(g, F) {
        var ue = this.start, ye = this.startLoc, Ee = this.parseMaybeAssign(g, F);
        if (this.type === X.comma) {
          var nt = this.startNodeAt(ue, ye);
          for (nt.expressions = [Ee]; this.eat(X.comma); )
            nt.expressions.push(this.parseMaybeAssign(g, F));
          return this.finishNode(nt, "SequenceExpression");
        }
        return Ee;
      }, C.parseMaybeAssign = function(g, F, ue) {
        if (this.isContextual("yield")) {
          if (this.inGenerator)
            return this.parseYield(g);
          this.exprAllowed = !1;
        }
        var ye = !1, Ee = -1, nt = -1, gt = -1;
        F ? (Ee = F.parenthesizedAssign, nt = F.trailingComma, gt = F.doubleProto, F.parenthesizedAssign = F.trailingComma = -1) : (F = new d(), ye = !0);
        var Yt = this.start, qt = this.startLoc;
        (this.type === X.parenL || this.type === X.name) && (this.potentialArrowAt = this.start, this.potentialArrowInForAwait = g === "await");
        var li = this.parseMaybeConditional(g, F);
        if (ue && (li = ue.call(this, li, Yt, qt)), this.type.isAssign) {
          var ni = this.startNodeAt(Yt, qt);
          return ni.operator = this.value, this.type === X.eq && (li = this.toAssignable(li, !1, F)), ye || (F.parenthesizedAssign = F.trailingComma = F.doubleProto = -1), F.shorthandAssign >= li.start && (F.shorthandAssign = -1), this.type === X.eq ? this.checkLValPattern(li) : this.checkLValSimple(li), ni.left = li, this.next(), ni.right = this.parseMaybeAssign(g), gt > -1 && (F.doubleProto = gt), this.finishNode(ni, "AssignmentExpression");
        } else
          ye && this.checkExpressionErrors(F, !0);
        return Ee > -1 && (F.parenthesizedAssign = Ee), nt > -1 && (F.trailingComma = nt), li;
      }, C.parseMaybeConditional = function(g, F) {
        var ue = this.start, ye = this.startLoc, Ee = this.parseExprOps(g, F);
        if (this.checkExpressionErrors(F))
          return Ee;
        if (this.eat(X.question)) {
          var nt = this.startNodeAt(ue, ye);
          return nt.test = Ee, nt.consequent = this.parseMaybeAssign(), this.expect(X.colon), nt.alternate = this.parseMaybeAssign(g), this.finishNode(nt, "ConditionalExpression");
        }
        return Ee;
      }, C.parseExprOps = function(g, F) {
        var ue = this.start, ye = this.startLoc, Ee = this.parseMaybeUnary(F, !1, !1, g);
        return this.checkExpressionErrors(F) || Ee.start === ue && Ee.type === "ArrowFunctionExpression" ? Ee : this.parseExprOp(Ee, ue, ye, -1, g);
      }, C.parseExprOp = function(g, F, ue, ye, Ee) {
        var nt = this.type.binop;
        if (nt != null && (!Ee || this.type !== X._in) && nt > ye) {
          var gt = this.type === X.logicalOR || this.type === X.logicalAND, Yt = this.type === X.coalesce;
          Yt && (nt = X.logicalAND.binop);
          var qt = this.value;
          this.next();
          var li = this.start, ni = this.startLoc, si = this.parseExprOp(this.parseMaybeUnary(null, !1, !1, Ee), li, ni, nt, Ee), xn = this.buildBinary(F, ue, g, si, qt, gt || Yt);
          return (gt && this.type === X.coalesce || Yt && (this.type === X.logicalOR || this.type === X.logicalAND)) && this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses"), this.parseExprOp(xn, F, ue, ye, Ee);
        }
        return g;
      }, C.buildBinary = function(g, F, ue, ye, Ee, nt) {
        ye.type === "PrivateIdentifier" && this.raise(ye.start, "Private identifier can only be left side of binary expression");
        var gt = this.startNodeAt(g, F);
        return gt.left = ue, gt.operator = Ee, gt.right = ye, this.finishNode(gt, nt ? "LogicalExpression" : "BinaryExpression");
      }, C.parseMaybeUnary = function(g, F, ue, ye) {
        var Ee = this.start, nt = this.startLoc, gt;
        if (this.isContextual("await") && this.canAwait)
          gt = this.parseAwait(ye), F = !0;
        else if (this.type.prefix) {
          var Yt = this.startNode(), qt = this.type === X.incDec;
          Yt.operator = this.value, Yt.prefix = !0, this.next(), Yt.argument = this.parseMaybeUnary(null, !0, qt, ye), this.checkExpressionErrors(g, !0), qt ? this.checkLValSimple(Yt.argument) : this.strict && Yt.operator === "delete" && N(Yt.argument) ? this.raiseRecoverable(Yt.start, "Deleting local variable in strict mode") : Yt.operator === "delete" && j(Yt.argument) ? this.raiseRecoverable(Yt.start, "Private fields can not be deleted") : F = !0, gt = this.finishNode(Yt, qt ? "UpdateExpression" : "UnaryExpression");
        } else if (!F && this.type === X.privateId)
          (ye || this.privateNameStack.length === 0) && this.options.checkPrivateFields && this.unexpected(), gt = this.parsePrivateIdent(), this.type !== X._in && this.unexpected();
        else {
          if (gt = this.parseExprSubscripts(g, ye), this.checkExpressionErrors(g))
            return gt;
          for (; this.type.postfix && !this.canInsertSemicolon(); ) {
            var li = this.startNodeAt(Ee, nt);
            li.operator = this.value, li.prefix = !1, li.argument = gt, this.checkLValSimple(gt), this.next(), gt = this.finishNode(li, "UpdateExpression");
          }
        }
        if (!ue && this.eat(X.starstar))
          if (F)
            this.unexpected(this.lastTokStart);
          else
            return this.buildBinary(Ee, nt, gt, this.parseMaybeUnary(null, !1, !1, ye), "**", !1);
        else
          return gt;
      };
      function N(g) {
        return g.type === "Identifier" || g.type === "ParenthesizedExpression" && N(g.expression);
      }
      function j(g) {
        return g.type === "MemberExpression" && g.property.type === "PrivateIdentifier" || g.type === "ChainExpression" && j(g.expression) || g.type === "ParenthesizedExpression" && j(g.expression);
      }
      C.parseExprSubscripts = function(g, F) {
        var ue = this.start, ye = this.startLoc, Ee = this.parseExprAtom(g, F);
        if (Ee.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")")
          return Ee;
        var nt = this.parseSubscripts(Ee, ue, ye, !1, F);
        return g && nt.type === "MemberExpression" && (g.parenthesizedAssign >= nt.start && (g.parenthesizedAssign = -1), g.parenthesizedBind >= nt.start && (g.parenthesizedBind = -1), g.trailingComma >= nt.start && (g.trailingComma = -1)), nt;
      }, C.parseSubscripts = function(g, F, ue, ye, Ee) {
        for (var nt = this.options.ecmaVersion >= 8 && g.type === "Identifier" && g.name === "async" && this.lastTokEnd === g.end && !this.canInsertSemicolon() && g.end - g.start === 5 && this.potentialArrowAt === g.start, gt = !1; ; ) {
          var Yt = this.parseSubscript(g, F, ue, ye, nt, gt, Ee);
          if (Yt.optional && (gt = !0), Yt === g || Yt.type === "ArrowFunctionExpression") {
            if (gt) {
              var qt = this.startNodeAt(F, ue);
              qt.expression = Yt, Yt = this.finishNode(qt, "ChainExpression");
            }
            return Yt;
          }
          g = Yt;
        }
      }, C.shouldParseAsyncArrow = function() {
        return !this.canInsertSemicolon() && this.eat(X.arrow);
      }, C.parseSubscriptAsyncArrow = function(g, F, ue, ye) {
        return this.parseArrowExpression(this.startNodeAt(g, F), ue, !0, ye);
      }, C.parseSubscript = function(g, F, ue, ye, Ee, nt, gt) {
        var Yt = this.options.ecmaVersion >= 11, qt = Yt && this.eat(X.questionDot);
        ye && qt && this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions");
        var li = this.eat(X.bracketL);
        if (li || qt && this.type !== X.parenL && this.type !== X.backQuote || this.eat(X.dot)) {
          var ni = this.startNodeAt(F, ue);
          ni.object = g, li ? (ni.property = this.parseExpression(), this.expect(X.bracketR)) : this.type === X.privateId && g.type !== "Super" ? ni.property = this.parsePrivateIdent() : ni.property = this.parseIdent(this.options.allowReserved !== "never"), ni.computed = !!li, Yt && (ni.optional = qt), g = this.finishNode(ni, "MemberExpression");
        } else if (!ye && this.eat(X.parenL)) {
          var si = new d(), xn = this.yieldPos, dr = this.awaitPos, tr = this.awaitIdentPos;
          this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
          var Fn = this.parseExprList(X.parenR, this.options.ecmaVersion >= 8, !1, si);
          if (Ee && !qt && this.shouldParseAsyncArrow())
            return this.checkPatternErrors(si, !1), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = xn, this.awaitPos = dr, this.awaitIdentPos = tr, this.parseSubscriptAsyncArrow(F, ue, Fn, gt);
          this.checkExpressionErrors(si, !0), this.yieldPos = xn || this.yieldPos, this.awaitPos = dr || this.awaitPos, this.awaitIdentPos = tr || this.awaitIdentPos;
          var sr = this.startNodeAt(F, ue);
          sr.callee = g, sr.arguments = Fn, Yt && (sr.optional = qt), g = this.finishNode(sr, "CallExpression");
        } else if (this.type === X.backQuote) {
          (qt || nt) && this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
          var wr = this.startNodeAt(F, ue);
          wr.tag = g, wr.quasi = this.parseTemplate({ isTagged: !0 }), g = this.finishNode(wr, "TaggedTemplateExpression");
        }
        return g;
      }, C.parseExprAtom = function(g, F, ue) {
        this.type === X.slash && this.readRegexp();
        var ye, Ee = this.potentialArrowAt === this.start;
        switch (this.type) {
          case X._super:
            return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), ye = this.startNode(), this.next(), this.type === X.parenL && !this.allowDirectSuper && this.raise(ye.start, "super() call outside constructor of a subclass"), this.type !== X.dot && this.type !== X.bracketL && this.type !== X.parenL && this.unexpected(), this.finishNode(ye, "Super");
          case X._this:
            return ye = this.startNode(), this.next(), this.finishNode(ye, "ThisExpression");
          case X.name:
            var nt = this.start, gt = this.startLoc, Yt = this.containsEsc, qt = this.parseIdent(!1);
            if (this.options.ecmaVersion >= 8 && !Yt && qt.name === "async" && !this.canInsertSemicolon() && this.eat(X._function))
              return this.overrideContext(B.f_expr), this.parseFunction(this.startNodeAt(nt, gt), 0, !1, !0, F);
            if (Ee && !this.canInsertSemicolon()) {
              if (this.eat(X.arrow))
                return this.parseArrowExpression(this.startNodeAt(nt, gt), [qt], !1, F);
              if (this.options.ecmaVersion >= 8 && qt.name === "async" && this.type === X.name && !Yt && (!this.potentialArrowInForAwait || this.value !== "of" || this.containsEsc))
                return qt = this.parseIdent(!1), (this.canInsertSemicolon() || !this.eat(X.arrow)) && this.unexpected(), this.parseArrowExpression(this.startNodeAt(nt, gt), [qt], !0, F);
            }
            return qt;
          case X.regexp:
            var li = this.value;
            return ye = this.parseLiteral(li.value), ye.regex = { pattern: li.pattern, flags: li.flags }, ye;
          case X.num:
          case X.string:
            return this.parseLiteral(this.value);
          case X._null:
          case X._true:
          case X._false:
            return ye = this.startNode(), ye.value = this.type === X._null ? null : this.type === X._true, ye.raw = this.type.keyword, this.next(), this.finishNode(ye, "Literal");
          case X.parenL:
            var ni = this.start, si = this.parseParenAndDistinguishExpression(Ee, F);
            return g && (g.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(si) && (g.parenthesizedAssign = ni), g.parenthesizedBind < 0 && (g.parenthesizedBind = ni)), si;
          case X.bracketL:
            return ye = this.startNode(), this.next(), ye.elements = this.parseExprList(X.bracketR, !0, !0, g), this.finishNode(ye, "ArrayExpression");
          case X.braceL:
            return this.overrideContext(B.b_expr), this.parseObj(!1, g);
          case X._function:
            return ye = this.startNode(), this.next(), this.parseFunction(ye, 0);
          case X._class:
            return this.parseClass(this.startNode(), !1);
          case X._new:
            return this.parseNew();
          case X.backQuote:
            return this.parseTemplate();
          case X._import:
            return this.options.ecmaVersion >= 11 ? this.parseExprImport(ue) : this.unexpected();
          default:
            return this.parseExprAtomDefault();
        }
      }, C.parseExprAtomDefault = function() {
        this.unexpected();
      }, C.parseExprImport = function(g) {
        var F = this.startNode();
        if (this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword import"), this.next(), this.type === X.parenL && !g)
          return this.parseDynamicImport(F);
        if (this.type === X.dot) {
          var ue = this.startNodeAt(F.start, F.loc && F.loc.start);
          return ue.name = "import", F.meta = this.finishNode(ue, "Identifier"), this.parseImportMeta(F);
        } else
          this.unexpected();
      }, C.parseDynamicImport = function(g) {
        if (this.next(), g.source = this.parseMaybeAssign(), this.options.ecmaVersion >= 16)
          this.eat(X.parenR) ? g.options = null : (this.expect(X.comma), this.afterTrailingComma(X.parenR) ? g.options = null : (g.options = this.parseMaybeAssign(), this.eat(X.parenR) || (this.expect(X.comma), this.afterTrailingComma(X.parenR) || this.unexpected())));
        else if (!this.eat(X.parenR)) {
          var F = this.start;
          this.eat(X.comma) && this.eat(X.parenR) ? this.raiseRecoverable(F, "Trailing comma is not allowed in import()") : this.unexpected(F);
        }
        return this.finishNode(g, "ImportExpression");
      }, C.parseImportMeta = function(g) {
        this.next();
        var F = this.containsEsc;
        return g.property = this.parseIdent(!0), g.property.name !== "meta" && this.raiseRecoverable(g.property.start, "The only valid meta property for import is 'import.meta'"), F && this.raiseRecoverable(g.start, "'import.meta' must not contain escaped characters"), this.options.sourceType !== "module" && !this.options.allowImportExportEverywhere && this.raiseRecoverable(g.start, "Cannot use 'import.meta' outside a module"), this.finishNode(g, "MetaProperty");
      }, C.parseLiteral = function(g) {
        var F = this.startNode();
        return F.value = g, F.raw = this.input.slice(this.start, this.end), F.raw.charCodeAt(F.raw.length - 1) === 110 && (F.bigint = F.value != null ? F.value.toString() : F.raw.slice(0, -1).replace(/_/g, "")), this.next(), this.finishNode(F, "Literal");
      }, C.parseParenExpression = function() {
        this.expect(X.parenL);
        var g = this.parseExpression();
        return this.expect(X.parenR), g;
      }, C.shouldParseArrow = function(g) {
        return !this.canInsertSemicolon();
      }, C.parseParenAndDistinguishExpression = function(g, F) {
        var ue = this.start, ye = this.startLoc, Ee, nt = this.options.ecmaVersion >= 8;
        if (this.options.ecmaVersion >= 6) {
          this.next();
          var gt = this.start, Yt = this.startLoc, qt = [], li = !0, ni = !1, si = new d(), xn = this.yieldPos, dr = this.awaitPos, tr;
          for (this.yieldPos = 0, this.awaitPos = 0; this.type !== X.parenR; )
            if (li ? li = !1 : this.expect(X.comma), nt && this.afterTrailingComma(X.parenR, !0)) {
              ni = !0;
              break;
            } else if (this.type === X.ellipsis) {
              tr = this.start, qt.push(this.parseParenItem(this.parseRestBinding())), this.type === X.comma && this.raiseRecoverable(
                this.start,
                "Comma is not permitted after the rest element"
              );
              break;
            } else
              qt.push(this.parseMaybeAssign(!1, si, this.parseParenItem));
          var Fn = this.lastTokEnd, sr = this.lastTokEndLoc;
          if (this.expect(X.parenR), g && this.shouldParseArrow(qt) && this.eat(X.arrow))
            return this.checkPatternErrors(si, !1), this.checkYieldAwaitInDefaultParams(), this.yieldPos = xn, this.awaitPos = dr, this.parseParenArrowList(ue, ye, qt, F);
          (!qt.length || ni) && this.unexpected(this.lastTokStart), tr && this.unexpected(tr), this.checkExpressionErrors(si, !0), this.yieldPos = xn || this.yieldPos, this.awaitPos = dr || this.awaitPos, qt.length > 1 ? (Ee = this.startNodeAt(gt, Yt), Ee.expressions = qt, this.finishNodeAt(Ee, "SequenceExpression", Fn, sr)) : Ee = qt[0];
        } else
          Ee = this.parseParenExpression();
        if (this.options.preserveParens) {
          var wr = this.startNodeAt(ue, ye);
          return wr.expression = Ee, this.finishNode(wr, "ParenthesizedExpression");
        } else
          return Ee;
      }, C.parseParenItem = function(g) {
        return g;
      }, C.parseParenArrowList = function(g, F, ue, ye) {
        return this.parseArrowExpression(this.startNodeAt(g, F), ue, !1, ye);
      };
      var q = [];
      C.parseNew = function() {
        this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword new");
        var g = this.startNode();
        if (this.next(), this.options.ecmaVersion >= 6 && this.type === X.dot) {
          var F = this.startNodeAt(g.start, g.loc && g.loc.start);
          F.name = "new", g.meta = this.finishNode(F, "Identifier"), this.next();
          var ue = this.containsEsc;
          return g.property = this.parseIdent(!0), g.property.name !== "target" && this.raiseRecoverable(g.property.start, "The only valid meta property for new is 'new.target'"), ue && this.raiseRecoverable(g.start, "'new.target' must not contain escaped characters"), this.allowNewDotTarget || this.raiseRecoverable(g.start, "'new.target' can only be used in functions and class static block"), this.finishNode(g, "MetaProperty");
        }
        var ye = this.start, Ee = this.startLoc;
        return g.callee = this.parseSubscripts(this.parseExprAtom(null, !1, !0), ye, Ee, !0, !1), this.eat(X.parenL) ? g.arguments = this.parseExprList(X.parenR, this.options.ecmaVersion >= 8, !1) : g.arguments = q, this.finishNode(g, "NewExpression");
      }, C.parseTemplateElement = function(g) {
        var F = g.isTagged, ue = this.startNode();
        return this.type === X.invalidTemplate ? (F || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), ue.value = {
          raw: this.value.replace(/\r\n?/g, `
`),
          cooked: null
        }) : ue.value = {
          raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, `
`),
          cooked: this.value
        }, this.next(), ue.tail = this.type === X.backQuote, this.finishNode(ue, "TemplateElement");
      }, C.parseTemplate = function(g) {
        g === void 0 && (g = {});
        var F = g.isTagged;
        F === void 0 && (F = !1);
        var ue = this.startNode();
        this.next(), ue.expressions = [];
        var ye = this.parseTemplateElement({ isTagged: F });
        for (ue.quasis = [ye]; !ye.tail; )
          this.type === X.eof && this.raise(this.pos, "Unterminated template literal"), this.expect(X.dollarBraceL), ue.expressions.push(this.parseExpression()), this.expect(X.braceR), ue.quasis.push(ye = this.parseTemplateElement({ isTagged: F }));
        return this.next(), this.finishNode(ue, "TemplateLiteral");
      }, C.isAsyncProp = function(g) {
        return !g.computed && g.key.type === "Identifier" && g.key.name === "async" && (this.type === X.name || this.type === X.num || this.type === X.string || this.type === X.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === X.star) && !Z.test(this.input.slice(this.lastTokEnd, this.start));
      }, C.parseObj = function(g, F) {
        var ue = this.startNode(), ye = !0, Ee = {};
        for (ue.properties = [], this.next(); !this.eat(X.braceR); ) {
          if (ye)
            ye = !1;
          else if (this.expect(X.comma), this.options.ecmaVersion >= 5 && this.afterTrailingComma(X.braceR))
            break;
          var nt = this.parseProperty(g, F);
          g || this.checkPropClash(nt, Ee, F), ue.properties.push(nt);
        }
        return this.finishNode(ue, g ? "ObjectPattern" : "ObjectExpression");
      }, C.parseProperty = function(g, F) {
        var ue = this.startNode(), ye, Ee, nt, gt;
        if (this.options.ecmaVersion >= 9 && this.eat(X.ellipsis))
          return g ? (ue.argument = this.parseIdent(!1), this.type === X.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.finishNode(ue, "RestElement")) : (ue.argument = this.parseMaybeAssign(!1, F), this.type === X.comma && F && F.trailingComma < 0 && (F.trailingComma = this.start), this.finishNode(ue, "SpreadElement"));
        this.options.ecmaVersion >= 6 && (ue.method = !1, ue.shorthand = !1, (g || F) && (nt = this.start, gt = this.startLoc), g || (ye = this.eat(X.star)));
        var Yt = this.containsEsc;
        return this.parsePropertyName(ue), !g && !Yt && this.options.ecmaVersion >= 8 && !ye && this.isAsyncProp(ue) ? (Ee = !0, ye = this.options.ecmaVersion >= 9 && this.eat(X.star), this.parsePropertyName(ue)) : Ee = !1, this.parsePropertyValue(ue, g, ye, Ee, nt, gt, F, Yt), this.finishNode(ue, "Property");
      }, C.parseGetterSetter = function(g) {
        var F = g.key.name;
        this.parsePropertyName(g), g.value = this.parseMethod(!1), g.kind = F;
        var ue = g.kind === "get" ? 0 : 1;
        if (g.value.params.length !== ue) {
          var ye = g.value.start;
          g.kind === "get" ? this.raiseRecoverable(ye, "getter should have no params") : this.raiseRecoverable(ye, "setter should have exactly one param");
        } else
          g.kind === "set" && g.value.params[0].type === "RestElement" && this.raiseRecoverable(g.value.params[0].start, "Setter cannot use rest params");
      }, C.parsePropertyValue = function(g, F, ue, ye, Ee, nt, gt, Yt) {
        (ue || ye) && this.type === X.colon && this.unexpected(), this.eat(X.colon) ? (g.value = F ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(!1, gt), g.kind = "init") : this.options.ecmaVersion >= 6 && this.type === X.parenL ? (F && this.unexpected(), g.method = !0, g.value = this.parseMethod(ue, ye), g.kind = "init") : !F && !Yt && this.options.ecmaVersion >= 5 && !g.computed && g.key.type === "Identifier" && (g.key.name === "get" || g.key.name === "set") && this.type !== X.comma && this.type !== X.braceR && this.type !== X.eq ? ((ue || ye) && this.unexpected(), this.parseGetterSetter(g)) : this.options.ecmaVersion >= 6 && !g.computed && g.key.type === "Identifier" ? ((ue || ye) && this.unexpected(), this.checkUnreserved(g.key), g.key.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = Ee), F ? g.value = this.parseMaybeDefault(Ee, nt, this.copyNode(g.key)) : this.type === X.eq && gt ? (gt.shorthandAssign < 0 && (gt.shorthandAssign = this.start), g.value = this.parseMaybeDefault(Ee, nt, this.copyNode(g.key))) : g.value = this.copyNode(g.key), g.kind = "init", g.shorthand = !0) : this.unexpected();
      }, C.parsePropertyName = function(g) {
        if (this.options.ecmaVersion >= 6) {
          if (this.eat(X.bracketL))
            return g.computed = !0, g.key = this.parseMaybeAssign(), this.expect(X.bracketR), g.key;
          g.computed = !1;
        }
        return g.key = this.type === X.num || this.type === X.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
      }, C.initFunction = function(g) {
        g.id = null, this.options.ecmaVersion >= 6 && (g.generator = g.expression = !1), this.options.ecmaVersion >= 8 && (g.async = !1);
      }, C.parseMethod = function(g, F, ue) {
        var ye = this.startNode(), Ee = this.yieldPos, nt = this.awaitPos, gt = this.awaitIdentPos;
        return this.initFunction(ye), this.options.ecmaVersion >= 6 && (ye.generator = g), this.options.ecmaVersion >= 8 && (ye.async = !!F), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(Et(F, ye.generator) | Lt | (ue ? xt : 0)), this.expect(X.parenL), ye.params = this.parseBindingList(X.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(ye, !1, !0, !1), this.yieldPos = Ee, this.awaitPos = nt, this.awaitIdentPos = gt, this.finishNode(ye, "FunctionExpression");
      }, C.parseArrowExpression = function(g, F, ue, ye) {
        var Ee = this.yieldPos, nt = this.awaitPos, gt = this.awaitIdentPos;
        return this.enterScope(Et(ue, !1) | Gi), this.initFunction(g), this.options.ecmaVersion >= 8 && (g.async = !!ue), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, g.params = this.toAssignableList(F, !0), this.parseFunctionBody(g, !0, !1, ye), this.yieldPos = Ee, this.awaitPos = nt, this.awaitIdentPos = gt, this.finishNode(g, "ArrowFunctionExpression");
      }, C.parseFunctionBody = function(g, F, ue, ye) {
        var Ee = F && this.type !== X.braceL, nt = this.strict, gt = !1;
        if (Ee)
          g.body = this.parseMaybeAssign(ye), g.expression = !0, this.checkParams(g, !1);
        else {
          var Yt = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(g.params);
          (!nt || Yt) && (gt = this.strictDirective(this.end), gt && Yt && this.raiseRecoverable(g.start, "Illegal 'use strict' directive in function with non-simple parameter list"));
          var qt = this.labels;
          this.labels = [], gt && (this.strict = !0), this.checkParams(g, !nt && !gt && !F && !ue && this.isSimpleParamList(g.params)), this.strict && g.id && this.checkLValSimple(g.id, i), g.body = this.parseBlock(!1, void 0, gt && !nt), g.expression = !1, this.adaptDirectivePrologue(g.body.body), this.labels = qt;
        }
        this.exitScope();
      }, C.isSimpleParamList = function(g) {
        for (var F = 0, ue = g; F < ue.length; F += 1) {
          var ye = ue[F];
          if (ye.type !== "Identifier")
            return !1;
        }
        return !0;
      }, C.checkParams = function(g, F) {
        for (var ue = /* @__PURE__ */ Object.create(null), ye = 0, Ee = g.params; ye < Ee.length; ye += 1) {
          var nt = Ee[ye];
          this.checkLValInnerPattern(nt, tt, F ? null : ue);
        }
      }, C.parseExprList = function(g, F, ue, ye) {
        for (var Ee = [], nt = !0; !this.eat(g); ) {
          if (nt)
            nt = !1;
          else if (this.expect(X.comma), F && this.afterTrailingComma(g))
            break;
          var gt = void 0;
          ue && this.type === X.comma ? gt = null : this.type === X.ellipsis ? (gt = this.parseSpread(ye), ye && this.type === X.comma && ye.trailingComma < 0 && (ye.trailingComma = this.start)) : gt = this.parseMaybeAssign(!1, ye), Ee.push(gt);
        }
        return Ee;
      }, C.checkUnreserved = function(g) {
        var F = g.start, ue = g.end, ye = g.name;
        if (this.inGenerator && ye === "yield" && this.raiseRecoverable(F, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && ye === "await" && this.raiseRecoverable(F, "Cannot use 'await' as identifier inside an async function"), !(this.currentThisScope().flags & et) && ye === "arguments" && this.raiseRecoverable(F, "Cannot use 'arguments' in class field initializer"), this.inClassStaticBlock && (ye === "arguments" || ye === "await") && this.raise(F, "Cannot use " + ye + " in class static initialization block"), this.keywords.test(ye) && this.raise(F, "Unexpected keyword '" + ye + "'"), !(this.options.ecmaVersion < 6 && this.input.slice(F, ue).indexOf("\\") !== -1)) {
          var Ee = this.strict ? this.reservedWordsStrict : this.reservedWords;
          Ee.test(ye) && (!this.inAsync && ye === "await" && this.raiseRecoverable(F, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(F, "The keyword '" + ye + "' is reserved"));
        }
      }, C.parseIdent = function(g) {
        var F = this.parseIdentNode();
        return this.next(!!g), this.finishNode(F, "Identifier"), g || (this.checkUnreserved(F), F.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = F.start)), F;
      }, C.parseIdentNode = function() {
        var g = this.startNode();
        return this.type === X.name ? g.name = this.value : this.type.keyword ? (g.name = this.type.keyword, (g.name === "class" || g.name === "function") && (this.lastTokEnd !== this.lastTokStart + 1 || this.input.charCodeAt(this.lastTokStart) !== 46) && this.context.pop(), this.type = X.name) : this.unexpected(), g;
      }, C.parsePrivateIdent = function() {
        var g = this.startNode();
        return this.type === X.privateId ? g.name = this.value : this.unexpected(), this.next(), this.finishNode(g, "PrivateIdentifier"), this.options.checkPrivateFields && (this.privateNameStack.length === 0 ? this.raise(g.start, "Private field '#" + g.name + "' must be declared in an enclosing class") : this.privateNameStack[this.privateNameStack.length - 1].used.push(g)), g;
      }, C.parseYield = function(g) {
        this.yieldPos || (this.yieldPos = this.start);
        var F = this.startNode();
        return this.next(), this.type === X.semi || this.canInsertSemicolon() || this.type !== X.star && !this.type.startsExpr ? (F.delegate = !1, F.argument = null) : (F.delegate = this.eat(X.star), F.argument = this.parseMaybeAssign(g)), this.finishNode(F, "YieldExpression");
      }, C.parseAwait = function(g) {
        this.awaitPos || (this.awaitPos = this.start);
        var F = this.startNode();
        return this.next(), F.argument = this.parseMaybeUnary(null, !0, !1, g), this.finishNode(F, "AwaitExpression");
      };
      var H = r.prototype;
      H.raise = function(g, F) {
        var ue = $t(this.input, g);
        F += " (" + ue.line + ":" + ue.column + ")", this.sourceFile && (F += " in " + this.sourceFile);
        var ye = new SyntaxError(F);
        throw ye.pos = g, ye.loc = ue, ye.raisedAt = this.pos, ye;
      }, H.raiseRecoverable = H.raise, H.curPosition = function() {
        if (this.options.locations)
          return new it(this.curLine, this.pos - this.lineStart);
      };
      var te = r.prototype, ae = function(F) {
        this.flags = F, this.var = [], this.lexical = [], this.functions = [];
      };
      te.enterScope = function(g) {
        this.scopeStack.push(new ae(g));
      }, te.exitScope = function() {
        this.scopeStack.pop();
      }, te.treatFunctionsAsVarInScope = function(g) {
        return g.flags & Jt || !this.inModule && g.flags & Zt;
      }, te.declareName = function(g, F, ue) {
        var ye = !1;
        if (F === _t) {
          var Ee = this.currentScope();
          ye = Ee.lexical.indexOf(g) > -1 || Ee.functions.indexOf(g) > -1 || Ee.var.indexOf(g) > -1, Ee.lexical.push(g), this.inModule && Ee.flags & Zt && delete this.undefinedExports[g];
        } else if (F === Ve) {
          var nt = this.currentScope();
          nt.lexical.push(g);
        } else if (F === Kt) {
          var gt = this.currentScope();
          this.treatFunctionsAsVar ? ye = gt.lexical.indexOf(g) > -1 : ye = gt.lexical.indexOf(g) > -1 || gt.var.indexOf(g) > -1, gt.functions.push(g);
        } else
          for (var Yt = this.scopeStack.length - 1; Yt >= 0; --Yt) {
            var qt = this.scopeStack[Yt];
            if (qt.lexical.indexOf(g) > -1 && !(qt.flags & pe && qt.lexical[0] === g) || !this.treatFunctionsAsVarInScope(qt) && qt.functions.indexOf(g) > -1) {
              ye = !0;
              break;
            }
            if (qt.var.push(g), this.inModule && qt.flags & Zt && delete this.undefinedExports[g], qt.flags & et)
              break;
          }
        ye && this.raiseRecoverable(ue, "Identifier '" + g + "' has already been declared");
      }, te.checkLocalExport = function(g) {
        this.scopeStack[0].lexical.indexOf(g.name) === -1 && this.scopeStack[0].var.indexOf(g.name) === -1 && (this.undefinedExports[g.name] = g);
      }, te.currentScope = function() {
        return this.scopeStack[this.scopeStack.length - 1];
      }, te.currentVarScope = function() {
        for (var g = this.scopeStack.length - 1; ; g--) {
          var F = this.scopeStack[g];
          if (F.flags & (et | Ie | Ne))
            return F;
        }
      }, te.currentThisScope = function() {
        for (var g = this.scopeStack.length - 1; ; g--) {
          var F = this.scopeStack[g];
          if (F.flags & (et | Ie | Ne) && !(F.flags & Gi))
            return F;
        }
      };
      var le = function(F, ue, ye) {
        this.type = "", this.start = ue, this.end = 0, F.options.locations && (this.loc = new Xt(F, ye)), F.options.directSourceFile && (this.sourceFile = F.options.directSourceFile), F.options.ranges && (this.range = [ue, 0]);
      }, me = r.prototype;
      me.startNode = function() {
        return new le(this, this.start, this.startLoc);
      }, me.startNodeAt = function(g, F) {
        return new le(this, g, F);
      };
      function se(g, F, ue, ye) {
        return g.type = F, g.end = ue, this.options.locations && (g.loc.end = ye), this.options.ranges && (g.range[1] = ue), g;
      }
      me.finishNode = function(g, F) {
        return se.call(this, g, F, this.lastTokEnd, this.lastTokEndLoc);
      }, me.finishNodeAt = function(g, F, ue, ye) {
        return se.call(this, g, F, ue, ye);
      }, me.copyNode = function(g) {
        var F = new le(this, g.start, this.startLoc);
        for (var ue in g)
          F[ue] = g[ue];
        return F;
      };
      var de = "Gara Garay Gukh Gurung_Khema Hrkt Katakana_Or_Hiragana Kawi Kirat_Rai Krai Nag_Mundari Nagm Ol_Onal Onao Sunu Sunuwar Todhri Todr Tulu_Tigalari Tutg Unknown Zzzz", ve = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS", we = ve + " Extended_Pictographic", Se = we, Ae = Se + " EBase EComp EMod EPres ExtPict", Ge = Ae, Qe = Ge, st = {
        9: ve,
        10: we,
        11: Se,
        12: Ae,
        13: Ge,
        14: Qe
      }, mt = "Basic_Emoji Emoji_Keycap_Sequence RGI_Emoji_Modifier_Sequence RGI_Emoji_Flag_Sequence RGI_Emoji_Tag_Sequence RGI_Emoji_ZWJ_Sequence RGI_Emoji", Re = {
        9: "",
        10: "",
        11: "",
        12: "",
        13: "",
        14: mt
      }, Fe = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu", at = "Adlam Adlm Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb", yt = at + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd", bt = yt + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho", Rt = bt + " Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi", Pt = Rt + " Cypro_Minoan Cpmn Old_Uyghur Ougr Tangsa Tnsa Toto Vithkuqi Vith", zt = Pt + " " + de, Wt = {
        9: at,
        10: yt,
        11: bt,
        12: Rt,
        13: Pt,
        14: zt
      }, Ft = {};
      function Mi(g) {
        var F = Ft[g] = {
          binary: $e(st[g] + " " + Fe),
          binaryOfStrings: $e(Re[g]),
          nonBinary: {
            General_Category: $e(Fe),
            Script: $e(Wt[g])
          }
        };
        F.nonBinary.Script_Extensions = F.nonBinary.Script, F.nonBinary.gc = F.nonBinary.General_Category, F.nonBinary.sc = F.nonBinary.Script, F.nonBinary.scx = F.nonBinary.Script_Extensions;
      }
      for (var yi = 0, Ai = [9, 10, 11, 12, 13, 14]; yi < Ai.length; yi += 1) {
        var pi = Ai[yi];
        Mi(pi);
      }
      var kt = r.prototype, fi = function(F, ue) {
        this.parent = F, this.base = ue || this;
      };
      fi.prototype.separatedFrom = function(F) {
        for (var ue = this; ue; ue = ue.parent)
          for (var ye = F; ye; ye = ye.parent)
            if (ue.base === ye.base && ue !== ye)
              return !0;
        return !1;
      }, fi.prototype.sibling = function() {
        return new fi(this.parent, this.base);
      };
      var Ti = function(F) {
        this.parser = F, this.validFlags = "gim" + (F.options.ecmaVersion >= 6 ? "uy" : "") + (F.options.ecmaVersion >= 9 ? "s" : "") + (F.options.ecmaVersion >= 13 ? "d" : "") + (F.options.ecmaVersion >= 15 ? "v" : ""), this.unicodeProperties = Ft[F.options.ecmaVersion >= 14 ? 14 : F.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = !1, this.switchV = !1, this.switchN = !1, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = !1, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = /* @__PURE__ */ Object.create(null), this.backReferenceNames = [], this.branchID = null;
      };
      Ti.prototype.reset = function(F, ue, ye) {
        var Ee = ye.indexOf("v") !== -1, nt = ye.indexOf("u") !== -1;
        this.start = F | 0, this.source = ue + "", this.flags = ye, Ee && this.parser.options.ecmaVersion >= 15 ? (this.switchU = !0, this.switchV = !0, this.switchN = !0) : (this.switchU = nt && this.parser.options.ecmaVersion >= 6, this.switchV = !1, this.switchN = nt && this.parser.options.ecmaVersion >= 9);
      }, Ti.prototype.raise = function(F) {
        this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + F);
      }, Ti.prototype.at = function(F, ue) {
        ue === void 0 && (ue = !1);
        var ye = this.source, Ee = ye.length;
        if (F >= Ee)
          return -1;
        var nt = ye.charCodeAt(F);
        if (!(ue || this.switchU) || nt <= 55295 || nt >= 57344 || F + 1 >= Ee)
          return nt;
        var gt = ye.charCodeAt(F + 1);
        return gt >= 56320 && gt <= 57343 ? (nt << 10) + gt - 56613888 : nt;
      }, Ti.prototype.nextIndex = function(F, ue) {
        ue === void 0 && (ue = !1);
        var ye = this.source, Ee = ye.length;
        if (F >= Ee)
          return Ee;
        var nt = ye.charCodeAt(F), gt;
        return !(ue || this.switchU) || nt <= 55295 || nt >= 57344 || F + 1 >= Ee || (gt = ye.charCodeAt(F + 1)) < 56320 || gt > 57343 ? F + 1 : F + 2;
      }, Ti.prototype.current = function(F) {
        return F === void 0 && (F = !1), this.at(this.pos, F);
      }, Ti.prototype.lookahead = function(F) {
        return F === void 0 && (F = !1), this.at(this.nextIndex(this.pos, F), F);
      }, Ti.prototype.advance = function(F) {
        F === void 0 && (F = !1), this.pos = this.nextIndex(this.pos, F);
      }, Ti.prototype.eat = function(F, ue) {
        return ue === void 0 && (ue = !1), this.current(ue) === F ? (this.advance(ue), !0) : !1;
      }, Ti.prototype.eatChars = function(F, ue) {
        ue === void 0 && (ue = !1);
        for (var ye = this.pos, Ee = 0, nt = F; Ee < nt.length; Ee += 1) {
          var gt = nt[Ee], Yt = this.at(ye, ue);
          if (Yt === -1 || Yt !== gt)
            return !1;
          ye = this.nextIndex(ye, ue);
        }
        return this.pos = ye, !0;
      }, kt.validateRegExpFlags = function(g) {
        for (var F = g.validFlags, ue = g.flags, ye = !1, Ee = !1, nt = 0; nt < ue.length; nt++) {
          var gt = ue.charAt(nt);
          F.indexOf(gt) === -1 && this.raise(g.start, "Invalid regular expression flag"), ue.indexOf(gt, nt + 1) > -1 && this.raise(g.start, "Duplicate regular expression flag"), gt === "u" && (ye = !0), gt === "v" && (Ee = !0);
        }
        this.options.ecmaVersion >= 15 && ye && Ee && this.raise(g.start, "Invalid regular expression flag");
      };
      function xi(g) {
        for (var F in g)
          return !0;
        return !1;
      }
      kt.validateRegExpPattern = function(g) {
        this.regexp_pattern(g), !g.switchN && this.options.ecmaVersion >= 9 && xi(g.groupNames) && (g.switchN = !0, this.regexp_pattern(g));
      }, kt.regexp_pattern = function(g) {
        g.pos = 0, g.lastIntValue = 0, g.lastStringValue = "", g.lastAssertionIsQuantifiable = !1, g.numCapturingParens = 0, g.maxBackReference = 0, g.groupNames = /* @__PURE__ */ Object.create(null), g.backReferenceNames.length = 0, g.branchID = null, this.regexp_disjunction(g), g.pos !== g.source.length && (g.eat(
          41
          /* ) */
        ) && g.raise("Unmatched ')'"), (g.eat(
          93
          /* ] */
        ) || g.eat(
          125
          /* } */
        )) && g.raise("Lone quantifier brackets")), g.maxBackReference > g.numCapturingParens && g.raise("Invalid escape");
        for (var F = 0, ue = g.backReferenceNames; F < ue.length; F += 1) {
          var ye = ue[F];
          g.groupNames[ye] || g.raise("Invalid named capture referenced");
        }
      }, kt.regexp_disjunction = function(g) {
        var F = this.options.ecmaVersion >= 16;
        for (F && (g.branchID = new fi(g.branchID, null)), this.regexp_alternative(g); g.eat(
          124
          /* | */
        ); )
          F && (g.branchID = g.branchID.sibling()), this.regexp_alternative(g);
        F && (g.branchID = g.branchID.parent), this.regexp_eatQuantifier(g, !0) && g.raise("Nothing to repeat"), g.eat(
          123
          /* { */
        ) && g.raise("Lone quantifier brackets");
      }, kt.regexp_alternative = function(g) {
        for (; g.pos < g.source.length && this.regexp_eatTerm(g); )
          ;
      }, kt.regexp_eatTerm = function(g) {
        return this.regexp_eatAssertion(g) ? (g.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(g) && g.switchU && g.raise("Invalid quantifier"), !0) : (g.switchU ? this.regexp_eatAtom(g) : this.regexp_eatExtendedAtom(g)) ? (this.regexp_eatQuantifier(g), !0) : !1;
      }, kt.regexp_eatAssertion = function(g) {
        var F = g.pos;
        if (g.lastAssertionIsQuantifiable = !1, g.eat(
          94
          /* ^ */
        ) || g.eat(
          36
          /* $ */
        ))
          return !0;
        if (g.eat(
          92
          /* \ */
        )) {
          if (g.eat(
            66
            /* B */
          ) || g.eat(
            98
            /* b */
          ))
            return !0;
          g.pos = F;
        }
        if (g.eat(
          40
          /* ( */
        ) && g.eat(
          63
          /* ? */
        )) {
          var ue = !1;
          if (this.options.ecmaVersion >= 9 && (ue = g.eat(
            60
            /* < */
          )), g.eat(
            61
            /* = */
          ) || g.eat(
            33
            /* ! */
          ))
            return this.regexp_disjunction(g), g.eat(
              41
              /* ) */
            ) || g.raise("Unterminated group"), g.lastAssertionIsQuantifiable = !ue, !0;
        }
        return g.pos = F, !1;
      }, kt.regexp_eatQuantifier = function(g, F) {
        return F === void 0 && (F = !1), this.regexp_eatQuantifierPrefix(g, F) ? (g.eat(
          63
          /* ? */
        ), !0) : !1;
      }, kt.regexp_eatQuantifierPrefix = function(g, F) {
        return g.eat(
          42
          /* * */
        ) || g.eat(
          43
          /* + */
        ) || g.eat(
          63
          /* ? */
        ) || this.regexp_eatBracedQuantifier(g, F);
      }, kt.regexp_eatBracedQuantifier = function(g, F) {
        var ue = g.pos;
        if (g.eat(
          123
          /* { */
        )) {
          var ye = 0, Ee = -1;
          if (this.regexp_eatDecimalDigits(g) && (ye = g.lastIntValue, g.eat(
            44
            /* , */
          ) && this.regexp_eatDecimalDigits(g) && (Ee = g.lastIntValue), g.eat(
            125
            /* } */
          )))
            return Ee !== -1 && Ee < ye && !F && g.raise("numbers out of order in {} quantifier"), !0;
          g.switchU && !F && g.raise("Incomplete quantifier"), g.pos = ue;
        }
        return !1;
      }, kt.regexp_eatAtom = function(g) {
        return this.regexp_eatPatternCharacters(g) || g.eat(
          46
          /* . */
        ) || this.regexp_eatReverseSolidusAtomEscape(g) || this.regexp_eatCharacterClass(g) || this.regexp_eatUncapturingGroup(g) || this.regexp_eatCapturingGroup(g);
      }, kt.regexp_eatReverseSolidusAtomEscape = function(g) {
        var F = g.pos;
        if (g.eat(
          92
          /* \ */
        )) {
          if (this.regexp_eatAtomEscape(g))
            return !0;
          g.pos = F;
        }
        return !1;
      }, kt.regexp_eatUncapturingGroup = function(g) {
        var F = g.pos;
        if (g.eat(
          40
          /* ( */
        )) {
          if (g.eat(
            63
            /* ? */
          )) {
            if (this.options.ecmaVersion >= 16) {
              var ue = this.regexp_eatModifiers(g), ye = g.eat(
                45
                /* - */
              );
              if (ue || ye) {
                for (var Ee = 0; Ee < ue.length; Ee++) {
                  var nt = ue.charAt(Ee);
                  ue.indexOf(nt, Ee + 1) > -1 && g.raise("Duplicate regular expression modifiers");
                }
                if (ye) {
                  var gt = this.regexp_eatModifiers(g);
                  !ue && !gt && g.current() === 58 && g.raise("Invalid regular expression modifiers");
                  for (var Yt = 0; Yt < gt.length; Yt++) {
                    var qt = gt.charAt(Yt);
                    (gt.indexOf(qt, Yt + 1) > -1 || ue.indexOf(qt) > -1) && g.raise("Duplicate regular expression modifiers");
                  }
                }
              }
            }
            if (g.eat(
              58
              /* : */
            )) {
              if (this.regexp_disjunction(g), g.eat(
                41
                /* ) */
              ))
                return !0;
              g.raise("Unterminated group");
            }
          }
          g.pos = F;
        }
        return !1;
      }, kt.regexp_eatCapturingGroup = function(g) {
        if (g.eat(
          40
          /* ( */
        )) {
          if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(g) : g.current() === 63 && g.raise("Invalid group"), this.regexp_disjunction(g), g.eat(
            41
            /* ) */
          ))
            return g.numCapturingParens += 1, !0;
          g.raise("Unterminated group");
        }
        return !1;
      }, kt.regexp_eatModifiers = function(g) {
        for (var F = "", ue = 0; (ue = g.current()) !== -1 && tn(ue); )
          F += It(ue), g.advance();
        return F;
      };
      function tn(g) {
        return g === 105 || g === 109 || g === 115;
      }
      kt.regexp_eatExtendedAtom = function(g) {
        return g.eat(
          46
          /* . */
        ) || this.regexp_eatReverseSolidusAtomEscape(g) || this.regexp_eatCharacterClass(g) || this.regexp_eatUncapturingGroup(g) || this.regexp_eatCapturingGroup(g) || this.regexp_eatInvalidBracedQuantifier(g) || this.regexp_eatExtendedPatternCharacter(g);
      }, kt.regexp_eatInvalidBracedQuantifier = function(g) {
        return this.regexp_eatBracedQuantifier(g, !0) && g.raise("Nothing to repeat"), !1;
      }, kt.regexp_eatSyntaxCharacter = function(g) {
        var F = g.current();
        return Hi(F) ? (g.lastIntValue = F, g.advance(), !0) : !1;
      };
      function Hi(g) {
        return g === 36 || g >= 40 && g <= 43 || g === 46 || g === 63 || g >= 91 && g <= 94 || g >= 123 && g <= 125;
      }
      kt.regexp_eatPatternCharacters = function(g) {
        for (var F = g.pos, ue = 0; (ue = g.current()) !== -1 && !Hi(ue); )
          g.advance();
        return g.pos !== F;
      }, kt.regexp_eatExtendedPatternCharacter = function(g) {
        var F = g.current();
        return F !== -1 && F !== 36 && !(F >= 40 && F <= 43) && F !== 46 && F !== 63 && F !== 91 && F !== 94 && F !== 124 ? (g.advance(), !0) : !1;
      }, kt.regexp_groupSpecifier = function(g) {
        if (g.eat(
          63
          /* ? */
        )) {
          this.regexp_eatGroupName(g) || g.raise("Invalid group");
          var F = this.options.ecmaVersion >= 16, ue = g.groupNames[g.lastStringValue];
          if (ue)
            if (F)
              for (var ye = 0, Ee = ue; ye < Ee.length; ye += 1) {
                var nt = Ee[ye];
                nt.separatedFrom(g.branchID) || g.raise("Duplicate capture group name");
              }
            else
              g.raise("Duplicate capture group name");
          F ? (ue || (g.groupNames[g.lastStringValue] = [])).push(g.branchID) : g.groupNames[g.lastStringValue] = !0;
        }
      }, kt.regexp_eatGroupName = function(g) {
        if (g.lastStringValue = "", g.eat(
          60
          /* < */
        )) {
          if (this.regexp_eatRegExpIdentifierName(g) && g.eat(
            62
            /* > */
          ))
            return !0;
          g.raise("Invalid capture group name");
        }
        return !1;
      }, kt.regexp_eatRegExpIdentifierName = function(g) {
        if (g.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(g)) {
          for (g.lastStringValue += It(g.lastIntValue); this.regexp_eatRegExpIdentifierPart(g); )
            g.lastStringValue += It(g.lastIntValue);
          return !0;
        }
        return !1;
      }, kt.regexp_eatRegExpIdentifierStart = function(g) {
        var F = g.pos, ue = this.options.ecmaVersion >= 11, ye = g.current(ue);
        return g.advance(ue), ye === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(g, ue) && (ye = g.lastIntValue), Zi(ye) ? (g.lastIntValue = ye, !0) : (g.pos = F, !1);
      };
      function Zi(g) {
        return W(g, !0) || g === 36 || g === 95;
      }
      kt.regexp_eatRegExpIdentifierPart = function(g) {
        var F = g.pos, ue = this.options.ecmaVersion >= 11, ye = g.current(ue);
        return g.advance(ue), ye === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(g, ue) && (ye = g.lastIntValue), Xi(ye) ? (g.lastIntValue = ye, !0) : (g.pos = F, !1);
      };
      function Xi(g) {
        return U(g, !0) || g === 36 || g === 95 || g === 8204 || g === 8205;
      }
      kt.regexp_eatAtomEscape = function(g) {
        return this.regexp_eatBackReference(g) || this.regexp_eatCharacterClassEscape(g) || this.regexp_eatCharacterEscape(g) || g.switchN && this.regexp_eatKGroupName(g) ? !0 : (g.switchU && (g.current() === 99 && g.raise("Invalid unicode escape"), g.raise("Invalid escape")), !1);
      }, kt.regexp_eatBackReference = function(g) {
        var F = g.pos;
        if (this.regexp_eatDecimalEscape(g)) {
          var ue = g.lastIntValue;
          if (g.switchU)
            return ue > g.maxBackReference && (g.maxBackReference = ue), !0;
          if (ue <= g.numCapturingParens)
            return !0;
          g.pos = F;
        }
        return !1;
      }, kt.regexp_eatKGroupName = function(g) {
        if (g.eat(
          107
          /* k */
        )) {
          if (this.regexp_eatGroupName(g))
            return g.backReferenceNames.push(g.lastStringValue), !0;
          g.raise("Invalid named reference");
        }
        return !1;
      }, kt.regexp_eatCharacterEscape = function(g) {
        return this.regexp_eatControlEscape(g) || this.regexp_eatCControlLetter(g) || this.regexp_eatZero(g) || this.regexp_eatHexEscapeSequence(g) || this.regexp_eatRegExpUnicodeEscapeSequence(g, !1) || !g.switchU && this.regexp_eatLegacyOctalEscapeSequence(g) || this.regexp_eatIdentityEscape(g);
      }, kt.regexp_eatCControlLetter = function(g) {
        var F = g.pos;
        if (g.eat(
          99
          /* c */
        )) {
          if (this.regexp_eatControlLetter(g))
            return !0;
          g.pos = F;
        }
        return !1;
      }, kt.regexp_eatZero = function(g) {
        return g.current() === 48 && !qn(g.lookahead()) ? (g.lastIntValue = 0, g.advance(), !0) : !1;
      }, kt.regexp_eatControlEscape = function(g) {
        var F = g.current();
        return F === 116 ? (g.lastIntValue = 9, g.advance(), !0) : F === 110 ? (g.lastIntValue = 10, g.advance(), !0) : F === 118 ? (g.lastIntValue = 11, g.advance(), !0) : F === 102 ? (g.lastIntValue = 12, g.advance(), !0) : F === 114 ? (g.lastIntValue = 13, g.advance(), !0) : !1;
      }, kt.regexp_eatControlLetter = function(g) {
        var F = g.current();
        return ji(F) ? (g.lastIntValue = F % 32, g.advance(), !0) : !1;
      };
      function ji(g) {
        return g >= 65 && g <= 90 || g >= 97 && g <= 122;
      }
      kt.regexp_eatRegExpUnicodeEscapeSequence = function(g, F) {
        F === void 0 && (F = !1);
        var ue = g.pos, ye = F || g.switchU;
        if (g.eat(
          117
          /* u */
        )) {
          if (this.regexp_eatFixedHexDigits(g, 4)) {
            var Ee = g.lastIntValue;
            if (ye && Ee >= 55296 && Ee <= 56319) {
              var nt = g.pos;
              if (g.eat(
                92
                /* \ */
              ) && g.eat(
                117
                /* u */
              ) && this.regexp_eatFixedHexDigits(g, 4)) {
                var gt = g.lastIntValue;
                if (gt >= 56320 && gt <= 57343)
                  return g.lastIntValue = (Ee - 55296) * 1024 + (gt - 56320) + 65536, !0;
              }
              g.pos = nt, g.lastIntValue = Ee;
            }
            return !0;
          }
          if (ye && g.eat(
            123
            /* { */
          ) && this.regexp_eatHexDigits(g) && g.eat(
            125
            /* } */
          ) && Ki(g.lastIntValue))
            return !0;
          ye && g.raise("Invalid unicode escape"), g.pos = ue;
        }
        return !1;
      };
      function Ki(g) {
        return g >= 0 && g <= 1114111;
      }
      kt.regexp_eatIdentityEscape = function(g) {
        if (g.switchU)
          return this.regexp_eatSyntaxCharacter(g) ? !0 : g.eat(
            47
            /* / */
          ) ? (g.lastIntValue = 47, !0) : !1;
        var F = g.current();
        return F !== 99 && (!g.switchN || F !== 107) ? (g.lastIntValue = F, g.advance(), !0) : !1;
      }, kt.regexp_eatDecimalEscape = function(g) {
        g.lastIntValue = 0;
        var F = g.current();
        if (F >= 49 && F <= 57) {
          do
            g.lastIntValue = 10 * g.lastIntValue + (F - 48), g.advance();
          while ((F = g.current()) >= 48 && F <= 57);
          return !0;
        }
        return !1;
      };
      var ln = 0, Fi = 1, hn = 2;
      kt.regexp_eatCharacterClassEscape = function(g) {
        var F = g.current();
        if (kr(F))
          return g.lastIntValue = -1, g.advance(), Fi;
        var ue = !1;
        if (g.switchU && this.options.ecmaVersion >= 9 && ((ue = F === 80) || F === 112)) {
          g.lastIntValue = -1, g.advance();
          var ye;
          if (g.eat(
            123
            /* { */
          ) && (ye = this.regexp_eatUnicodePropertyValueExpression(g)) && g.eat(
            125
            /* } */
          ))
            return ue && ye === hn && g.raise("Invalid property name"), ye;
          g.raise("Invalid property name");
        }
        return ln;
      };
      function kr(g) {
        return g === 100 || g === 68 || g === 115 || g === 83 || g === 119 || g === 87;
      }
      kt.regexp_eatUnicodePropertyValueExpression = function(g) {
        var F = g.pos;
        if (this.regexp_eatUnicodePropertyName(g) && g.eat(
          61
          /* = */
        )) {
          var ue = g.lastStringValue;
          if (this.regexp_eatUnicodePropertyValue(g)) {
            var ye = g.lastStringValue;
            return this.regexp_validateUnicodePropertyNameAndValue(g, ue, ye), Fi;
          }
        }
        if (g.pos = F, this.regexp_eatLoneUnicodePropertyNameOrValue(g)) {
          var Ee = g.lastStringValue;
          return this.regexp_validateUnicodePropertyNameOrValue(g, Ee);
        }
        return ln;
      }, kt.regexp_validateUnicodePropertyNameAndValue = function(g, F, ue) {
        ze(g.unicodeProperties.nonBinary, F) || g.raise("Invalid property name"), g.unicodeProperties.nonBinary[F].test(ue) || g.raise("Invalid property value");
      }, kt.regexp_validateUnicodePropertyNameOrValue = function(g, F) {
        if (g.unicodeProperties.binary.test(F))
          return Fi;
        if (g.switchV && g.unicodeProperties.binaryOfStrings.test(F))
          return hn;
        g.raise("Invalid property name");
      }, kt.regexp_eatUnicodePropertyName = function(g) {
        var F = 0;
        for (g.lastStringValue = ""; Er(F = g.current()); )
          g.lastStringValue += It(F), g.advance();
        return g.lastStringValue !== "";
      };
      function Er(g) {
        return ji(g) || g === 95;
      }
      kt.regexp_eatUnicodePropertyValue = function(g) {
        var F = 0;
        for (g.lastStringValue = ""; Ir(F = g.current()); )
          g.lastStringValue += It(F), g.advance();
        return g.lastStringValue !== "";
      };
      function Ir(g) {
        return Er(g) || qn(g);
      }
      kt.regexp_eatLoneUnicodePropertyNameOrValue = function(g) {
        return this.regexp_eatUnicodePropertyValue(g);
      }, kt.regexp_eatCharacterClass = function(g) {
        if (g.eat(
          91
          /* [ */
        )) {
          var F = g.eat(
            94
            /* ^ */
          ), ue = this.regexp_classContents(g);
          return g.eat(
            93
            /* ] */
          ) || g.raise("Unterminated character class"), F && ue === hn && g.raise("Negated character class may contain strings"), !0;
        }
        return !1;
      }, kt.regexp_classContents = function(g) {
        return g.current() === 93 ? Fi : g.switchV ? this.regexp_classSetExpression(g) : (this.regexp_nonEmptyClassRanges(g), Fi);
      }, kt.regexp_nonEmptyClassRanges = function(g) {
        for (; this.regexp_eatClassAtom(g); ) {
          var F = g.lastIntValue;
          if (g.eat(
            45
            /* - */
          ) && this.regexp_eatClassAtom(g)) {
            var ue = g.lastIntValue;
            g.switchU && (F === -1 || ue === -1) && g.raise("Invalid character class"), F !== -1 && ue !== -1 && F > ue && g.raise("Range out of order in character class");
          }
        }
      }, kt.regexp_eatClassAtom = function(g) {
        var F = g.pos;
        if (g.eat(
          92
          /* \ */
        )) {
          if (this.regexp_eatClassEscape(g))
            return !0;
          if (g.switchU) {
            var ue = g.current();
            (ue === 99 || gn(ue)) && g.raise("Invalid class escape"), g.raise("Invalid escape");
          }
          g.pos = F;
        }
        var ye = g.current();
        return ye !== 93 ? (g.lastIntValue = ye, g.advance(), !0) : !1;
      }, kt.regexp_eatClassEscape = function(g) {
        var F = g.pos;
        if (g.eat(
          98
          /* b */
        ))
          return g.lastIntValue = 8, !0;
        if (g.switchU && g.eat(
          45
          /* - */
        ))
          return g.lastIntValue = 45, !0;
        if (!g.switchU && g.eat(
          99
          /* c */
        )) {
          if (this.regexp_eatClassControlLetter(g))
            return !0;
          g.pos = F;
        }
        return this.regexp_eatCharacterClassEscape(g) || this.regexp_eatCharacterEscape(g);
      }, kt.regexp_classSetExpression = function(g) {
        var F = Fi, ue;
        if (!this.regexp_eatClassSetRange(g))
          if (ue = this.regexp_eatClassSetOperand(g)) {
            ue === hn && (F = hn);
            for (var ye = g.pos; g.eatChars(
              [38, 38]
              /* && */
            ); ) {
              if (g.current() !== 38 && (ue = this.regexp_eatClassSetOperand(g))) {
                ue !== hn && (F = Fi);
                continue;
              }
              g.raise("Invalid character in character class");
            }
            if (ye !== g.pos)
              return F;
            for (; g.eatChars(
              [45, 45]
              /* -- */
            ); )
              this.regexp_eatClassSetOperand(g) || g.raise("Invalid character in character class");
            if (ye !== g.pos)
              return F;
          } else
            g.raise("Invalid character in character class");
        for (; ; )
          if (!this.regexp_eatClassSetRange(g)) {
            if (ue = this.regexp_eatClassSetOperand(g), !ue)
              return F;
            ue === hn && (F = hn);
          }
      }, kt.regexp_eatClassSetRange = function(g) {
        var F = g.pos;
        if (this.regexp_eatClassSetCharacter(g)) {
          var ue = g.lastIntValue;
          if (g.eat(
            45
            /* - */
          ) && this.regexp_eatClassSetCharacter(g)) {
            var ye = g.lastIntValue;
            return ue !== -1 && ye !== -1 && ue > ye && g.raise("Range out of order in character class"), !0;
          }
          g.pos = F;
        }
        return !1;
      }, kt.regexp_eatClassSetOperand = function(g) {
        return this.regexp_eatClassSetCharacter(g) ? Fi : this.regexp_eatClassStringDisjunction(g) || this.regexp_eatNestedClass(g);
      }, kt.regexp_eatNestedClass = function(g) {
        var F = g.pos;
        if (g.eat(
          91
          /* [ */
        )) {
          var ue = g.eat(
            94
            /* ^ */
          ), ye = this.regexp_classContents(g);
          if (g.eat(
            93
            /* ] */
          ))
            return ue && ye === hn && g.raise("Negated character class may contain strings"), ye;
          g.pos = F;
        }
        if (g.eat(
          92
          /* \ */
        )) {
          var Ee = this.regexp_eatCharacterClassEscape(g);
          if (Ee)
            return Ee;
          g.pos = F;
        }
        return null;
      }, kt.regexp_eatClassStringDisjunction = function(g) {
        var F = g.pos;
        if (g.eatChars(
          [92, 113]
          /* \q */
        )) {
          if (g.eat(
            123
            /* { */
          )) {
            var ue = this.regexp_classStringDisjunctionContents(g);
            if (g.eat(
              125
              /* } */
            ))
              return ue;
          } else
            g.raise("Invalid escape");
          g.pos = F;
        }
        return null;
      }, kt.regexp_classStringDisjunctionContents = function(g) {
        for (var F = this.regexp_classString(g); g.eat(
          124
          /* | */
        ); )
          this.regexp_classString(g) === hn && (F = hn);
        return F;
      }, kt.regexp_classString = function(g) {
        for (var F = 0; this.regexp_eatClassSetCharacter(g); )
          F++;
        return F === 1 ? Fi : hn;
      }, kt.regexp_eatClassSetCharacter = function(g) {
        var F = g.pos;
        if (g.eat(
          92
          /* \ */
        ))
          return this.regexp_eatCharacterEscape(g) || this.regexp_eatClassSetReservedPunctuator(g) ? !0 : g.eat(
            98
            /* b */
          ) ? (g.lastIntValue = 8, !0) : (g.pos = F, !1);
        var ue = g.current();
        return ue < 0 || ue === g.lookahead() && Nn(ue) || Pr(ue) ? !1 : (g.advance(), g.lastIntValue = ue, !0);
      };
      function Nn(g) {
        return g === 33 || g >= 35 && g <= 38 || g >= 42 && g <= 44 || g === 46 || g >= 58 && g <= 64 || g === 94 || g === 96 || g === 126;
      }
      function Pr(g) {
        return g === 40 || g === 41 || g === 45 || g === 47 || g >= 91 && g <= 93 || g >= 123 && g <= 125;
      }
      kt.regexp_eatClassSetReservedPunctuator = function(g) {
        var F = g.current();
        return Rn(F) ? (g.lastIntValue = F, g.advance(), !0) : !1;
      };
      function Rn(g) {
        return g === 33 || g === 35 || g === 37 || g === 38 || g === 44 || g === 45 || g >= 58 && g <= 62 || g === 64 || g === 96 || g === 126;
      }
      kt.regexp_eatClassControlLetter = function(g) {
        var F = g.current();
        return qn(F) || F === 95 ? (g.lastIntValue = F % 32, g.advance(), !0) : !1;
      }, kt.regexp_eatHexEscapeSequence = function(g) {
        var F = g.pos;
        if (g.eat(
          120
          /* x */
        )) {
          if (this.regexp_eatFixedHexDigits(g, 2))
            return !0;
          g.switchU && g.raise("Invalid escape"), g.pos = F;
        }
        return !1;
      }, kt.regexp_eatDecimalDigits = function(g) {
        var F = g.pos, ue = 0;
        for (g.lastIntValue = 0; qn(ue = g.current()); )
          g.lastIntValue = 10 * g.lastIntValue + (ue - 48), g.advance();
        return g.pos !== F;
      };
      function qn(g) {
        return g >= 48 && g <= 57;
      }
      kt.regexp_eatHexDigits = function(g) {
        var F = g.pos, ue = 0;
        for (g.lastIntValue = 0; Dn(ue = g.current()); )
          g.lastIntValue = 16 * g.lastIntValue + Mn(ue), g.advance();
        return g.pos !== F;
      };
      function Dn(g) {
        return g >= 48 && g <= 57 || g >= 65 && g <= 70 || g >= 97 && g <= 102;
      }
      function Mn(g) {
        return g >= 65 && g <= 70 ? 10 + (g - 65) : g >= 97 && g <= 102 ? 10 + (g - 97) : g - 48;
      }
      kt.regexp_eatLegacyOctalEscapeSequence = function(g) {
        if (this.regexp_eatOctalDigit(g)) {
          var F = g.lastIntValue;
          if (this.regexp_eatOctalDigit(g)) {
            var ue = g.lastIntValue;
            F <= 3 && this.regexp_eatOctalDigit(g) ? g.lastIntValue = F * 64 + ue * 8 + g.lastIntValue : g.lastIntValue = F * 8 + ue;
          } else
            g.lastIntValue = F;
          return !0;
        }
        return !1;
      }, kt.regexp_eatOctalDigit = function(g) {
        var F = g.current();
        return gn(F) ? (g.lastIntValue = F - 48, g.advance(), !0) : (g.lastIntValue = 0, !1);
      };
      function gn(g) {
        return g >= 48 && g <= 55;
      }
      kt.regexp_eatFixedHexDigits = function(g, F) {
        var ue = g.pos;
        g.lastIntValue = 0;
        for (var ye = 0; ye < F; ++ye) {
          var Ee = g.current();
          if (!Dn(Ee))
            return g.pos = ue, !1;
          g.lastIntValue = 16 * g.lastIntValue + Mn(Ee), g.advance();
        }
        return !0;
      };
      var yn = function(F) {
        this.type = F.type, this.value = F.value, this.start = F.start, this.end = F.end, F.options.locations && (this.loc = new Xt(F, F.startLoc, F.endLoc)), F.options.ranges && (this.range = [F.start, F.end]);
      }, ri = r.prototype;
      ri.next = function(g) {
        !g && this.type.keyword && this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword), this.options.onToken && this.options.onToken(new yn(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
      }, ri.getToken = function() {
        return this.next(), new yn(this);
      }, typeof Symbol < "u" && (ri[Symbol.iterator] = function() {
        var g = this;
        return {
          next: function() {
            var F = g.getToken();
            return {
              done: F.type === X.eof,
              value: F
            };
          }
        };
      }), ri.nextToken = function() {
        var g = this.curContext();
        if ((!g || !g.preserveSpace) && this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length)
          return this.finishToken(X.eof);
        if (g.override)
          return g.override(this);
        this.readToken(this.fullCharCodeAtPos());
      }, ri.readToken = function(g) {
        return W(g, this.options.ecmaVersion >= 6) || g === 92 ? this.readWord() : this.getTokenFromCode(g);
      }, ri.fullCharCodeAtPos = function() {
        var g = this.input.charCodeAt(this.pos);
        if (g <= 55295 || g >= 56320)
          return g;
        var F = this.input.charCodeAt(this.pos + 1);
        return F <= 56319 || F >= 57344 ? g : (g << 10) + F - 56613888;
      }, ri.skipBlockComment = function() {
        var g = this.options.onComment && this.curPosition(), F = this.pos, ue = this.input.indexOf("*/", this.pos += 2);
        if (ue === -1 && this.raise(this.pos - 2, "Unterminated comment"), this.pos = ue + 2, this.options.locations)
          for (var ye = void 0, Ee = F; (ye = je(this.input, Ee, this.pos)) > -1; )
            ++this.curLine, Ee = this.lineStart = ye;
        this.options.onComment && this.options.onComment(
          !0,
          this.input.slice(F + 2, ue),
          F,
          this.pos,
          g,
          this.curPosition()
        );
      }, ri.skipLineComment = function(g) {
        for (var F = this.pos, ue = this.options.onComment && this.curPosition(), ye = this.input.charCodeAt(this.pos += g); this.pos < this.input.length && !Oe(ye); )
          ye = this.input.charCodeAt(++this.pos);
        this.options.onComment && this.options.onComment(
          !1,
          this.input.slice(F + g, this.pos),
          F,
          this.pos,
          ue,
          this.curPosition()
        );
      }, ri.skipSpace = function() {
        e:
          for (; this.pos < this.input.length; ) {
            var g = this.input.charCodeAt(this.pos);
            switch (g) {
              case 32:
              case 160:
                ++this.pos;
                break;
              case 13:
                this.input.charCodeAt(this.pos + 1) === 10 && ++this.pos;
              case 10:
              case 8232:
              case 8233:
                ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
                break;
              case 47:
                switch (this.input.charCodeAt(this.pos + 1)) {
                  case 42:
                    this.skipBlockComment();
                    break;
                  case 47:
                    this.skipLineComment(2);
                    break;
                  default:
                    break e;
                }
                break;
              default:
                if (g > 8 && g < 14 || g >= 5760 && pt.test(String.fromCharCode(g)))
                  ++this.pos;
                else
                  break e;
            }
          }
      }, ri.finishToken = function(g, F) {
        this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
        var ue = this.type;
        this.type = g, this.value = F, this.updateContext(ue);
      }, ri.readToken_dot = function() {
        var g = this.input.charCodeAt(this.pos + 1);
        if (g >= 48 && g <= 57)
          return this.readNumber(!0);
        var F = this.input.charCodeAt(this.pos + 2);
        return this.options.ecmaVersion >= 6 && g === 46 && F === 46 ? (this.pos += 3, this.finishToken(X.ellipsis)) : (++this.pos, this.finishToken(X.dot));
      }, ri.readToken_slash = function() {
        var g = this.input.charCodeAt(this.pos + 1);
        return this.exprAllowed ? (++this.pos, this.readRegexp()) : g === 61 ? this.finishOp(X.assign, 2) : this.finishOp(X.slash, 1);
      }, ri.readToken_mult_modulo_exp = function(g) {
        var F = this.input.charCodeAt(this.pos + 1), ue = 1, ye = g === 42 ? X.star : X.modulo;
        return this.options.ecmaVersion >= 7 && g === 42 && F === 42 && (++ue, ye = X.starstar, F = this.input.charCodeAt(this.pos + 2)), F === 61 ? this.finishOp(X.assign, ue + 1) : this.finishOp(ye, ue);
      }, ri.readToken_pipe_amp = function(g) {
        var F = this.input.charCodeAt(this.pos + 1);
        if (F === g) {
          if (this.options.ecmaVersion >= 12) {
            var ue = this.input.charCodeAt(this.pos + 2);
            if (ue === 61)
              return this.finishOp(X.assign, 3);
          }
          return this.finishOp(g === 124 ? X.logicalOR : X.logicalAND, 2);
        }
        return F === 61 ? this.finishOp(X.assign, 2) : this.finishOp(g === 124 ? X.bitwiseOR : X.bitwiseAND, 1);
      }, ri.readToken_caret = function() {
        var g = this.input.charCodeAt(this.pos + 1);
        return g === 61 ? this.finishOp(X.assign, 2) : this.finishOp(X.bitwiseXOR, 1);
      }, ri.readToken_plus_min = function(g) {
        var F = this.input.charCodeAt(this.pos + 1);
        return F === g ? F === 45 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 62 && (this.lastTokEnd === 0 || Z.test(this.input.slice(this.lastTokEnd, this.pos))) ? (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : this.finishOp(X.incDec, 2) : F === 61 ? this.finishOp(X.assign, 2) : this.finishOp(X.plusMin, 1);
      }, ri.readToken_lt_gt = function(g) {
        var F = this.input.charCodeAt(this.pos + 1), ue = 1;
        return F === g ? (ue = g === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2, this.input.charCodeAt(this.pos + ue) === 61 ? this.finishOp(X.assign, ue + 1) : this.finishOp(X.bitShift, ue)) : F === 33 && g === 60 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 45 && this.input.charCodeAt(this.pos + 3) === 45 ? (this.skipLineComment(4), this.skipSpace(), this.nextToken()) : (F === 61 && (ue = 2), this.finishOp(X.relational, ue));
      }, ri.readToken_eq_excl = function(g) {
        var F = this.input.charCodeAt(this.pos + 1);
        return F === 61 ? this.finishOp(X.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2) : g === 61 && F === 62 && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(X.arrow)) : this.finishOp(g === 61 ? X.eq : X.prefix, 1);
      }, ri.readToken_question = function() {
        var g = this.options.ecmaVersion;
        if (g >= 11) {
          var F = this.input.charCodeAt(this.pos + 1);
          if (F === 46) {
            var ue = this.input.charCodeAt(this.pos + 2);
            if (ue < 48 || ue > 57)
              return this.finishOp(X.questionDot, 2);
          }
          if (F === 63) {
            if (g >= 12) {
              var ye = this.input.charCodeAt(this.pos + 2);
              if (ye === 61)
                return this.finishOp(X.assign, 3);
            }
            return this.finishOp(X.coalesce, 2);
          }
        }
        return this.finishOp(X.question, 1);
      }, ri.readToken_numberSign = function() {
        var g = this.options.ecmaVersion, F = 35;
        if (g >= 13 && (++this.pos, F = this.fullCharCodeAtPos(), W(F, !0) || F === 92))
          return this.finishToken(X.privateId, this.readWord1());
        this.raise(this.pos, "Unexpected character '" + It(F) + "'");
      }, ri.getTokenFromCode = function(g) {
        switch (g) {
          case 46:
            return this.readToken_dot();
          case 40:
            return ++this.pos, this.finishToken(X.parenL);
          case 41:
            return ++this.pos, this.finishToken(X.parenR);
          case 59:
            return ++this.pos, this.finishToken(X.semi);
          case 44:
            return ++this.pos, this.finishToken(X.comma);
          case 91:
            return ++this.pos, this.finishToken(X.bracketL);
          case 93:
            return ++this.pos, this.finishToken(X.bracketR);
          case 123:
            return ++this.pos, this.finishToken(X.braceL);
          case 125:
            return ++this.pos, this.finishToken(X.braceR);
          case 58:
            return ++this.pos, this.finishToken(X.colon);
          case 96:
            if (this.options.ecmaVersion < 6)
              break;
            return ++this.pos, this.finishToken(X.backQuote);
          case 48:
            var F = this.input.charCodeAt(this.pos + 1);
            if (F === 120 || F === 88)
              return this.readRadixNumber(16);
            if (this.options.ecmaVersion >= 6) {
              if (F === 111 || F === 79)
                return this.readRadixNumber(8);
              if (F === 98 || F === 66)
                return this.readRadixNumber(2);
            }
          case 49:
          case 50:
          case 51:
          case 52:
          case 53:
          case 54:
          case 55:
          case 56:
          case 57:
            return this.readNumber(!1);
          case 34:
          case 39:
            return this.readString(g);
          case 47:
            return this.readToken_slash();
          case 37:
          case 42:
            return this.readToken_mult_modulo_exp(g);
          case 124:
          case 38:
            return this.readToken_pipe_amp(g);
          case 94:
            return this.readToken_caret();
          case 43:
          case 45:
            return this.readToken_plus_min(g);
          case 60:
          case 62:
            return this.readToken_lt_gt(g);
          case 61:
          case 33:
            return this.readToken_eq_excl(g);
          case 63:
            return this.readToken_question();
          case 126:
            return this.finishOp(X.prefix, 1);
          case 35:
            return this.readToken_numberSign();
        }
        this.raise(this.pos, "Unexpected character '" + It(g) + "'");
      }, ri.finishOp = function(g, F) {
        var ue = this.input.slice(this.pos, this.pos + F);
        return this.pos += F, this.finishToken(g, ue);
      }, ri.readRegexp = function() {
        for (var g, F, ue = this.pos; ; ) {
          this.pos >= this.input.length && this.raise(ue, "Unterminated regular expression");
          var ye = this.input.charAt(this.pos);
          if (Z.test(ye) && this.raise(ue, "Unterminated regular expression"), g)
            g = !1;
          else {
            if (ye === "[")
              F = !0;
            else if (ye === "]" && F)
              F = !1;
            else if (ye === "/" && !F)
              break;
            g = ye === "\\";
          }
          ++this.pos;
        }
        var Ee = this.input.slice(ue, this.pos);
        ++this.pos;
        var nt = this.pos, gt = this.readWord1();
        this.containsEsc && this.unexpected(nt);
        var Yt = this.regexpState || (this.regexpState = new Ti(this));
        Yt.reset(ue, Ee, gt), this.validateRegExpFlags(Yt), this.validateRegExpPattern(Yt);
        var qt = null;
        try {
          qt = new RegExp(Ee, gt);
        } catch {
        }
        return this.finishToken(X.regexp, { pattern: Ee, flags: gt, value: qt });
      }, ri.readInt = function(g, F, ue) {
        for (var ye = this.options.ecmaVersion >= 12 && F === void 0, Ee = ue && this.input.charCodeAt(this.pos) === 48, nt = this.pos, gt = 0, Yt = 0, qt = 0, li = F ?? 1 / 0; qt < li; ++qt, ++this.pos) {
          var ni = this.input.charCodeAt(this.pos), si = void 0;
          if (ye && ni === 95) {
            Ee && this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals"), Yt === 95 && this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore"), qt === 0 && this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits"), Yt = ni;
            continue;
          }
          if (ni >= 97 ? si = ni - 97 + 10 : ni >= 65 ? si = ni - 65 + 10 : ni >= 48 && ni <= 57 ? si = ni - 48 : si = 1 / 0, si >= g)
            break;
          Yt = ni, gt = gt * g + si;
        }
        return ye && Yt === 95 && this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits"), this.pos === nt || F != null && this.pos - nt !== F ? null : gt;
      };
      function Ji(g, F) {
        return F ? parseInt(g, 8) : parseFloat(g.replace(/_/g, ""));
      }
      function cn(g) {
        return typeof BigInt != "function" ? null : BigInt(g.replace(/_/g, ""));
      }
      ri.readRadixNumber = function(g) {
        var F = this.pos;
        this.pos += 2;
        var ue = this.readInt(g);
        return ue == null && this.raise(this.start + 2, "Expected number in radix " + g), this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110 ? (ue = cn(this.input.slice(F, this.pos)), ++this.pos) : W(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(X.num, ue);
      }, ri.readNumber = function(g) {
        var F = this.pos;
        !g && this.readInt(10, void 0, !0) === null && this.raise(F, "Invalid number");
        var ue = this.pos - F >= 2 && this.input.charCodeAt(F) === 48;
        ue && this.strict && this.raise(F, "Invalid number");
        var ye = this.input.charCodeAt(this.pos);
        if (!ue && !g && this.options.ecmaVersion >= 11 && ye === 110) {
          var Ee = cn(this.input.slice(F, this.pos));
          return ++this.pos, W(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(X.num, Ee);
        }
        ue && /[89]/.test(this.input.slice(F, this.pos)) && (ue = !1), ye === 46 && !ue && (++this.pos, this.readInt(10), ye = this.input.charCodeAt(this.pos)), (ye === 69 || ye === 101) && !ue && (ye = this.input.charCodeAt(++this.pos), (ye === 43 || ye === 45) && ++this.pos, this.readInt(10) === null && this.raise(F, "Invalid number")), W(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
        var nt = Ji(this.input.slice(F, this.pos), ue);
        return this.finishToken(X.num, nt);
      }, ri.readCodePoint = function() {
        var g = this.input.charCodeAt(this.pos), F;
        if (g === 123) {
          this.options.ecmaVersion < 6 && this.unexpected();
          var ue = ++this.pos;
          F = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, F > 1114111 && this.invalidStringToken(ue, "Code point out of bounds");
        } else
          F = this.readHexChar(4);
        return F;
      }, ri.readString = function(g) {
        for (var F = "", ue = ++this.pos; ; ) {
          this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
          var ye = this.input.charCodeAt(this.pos);
          if (ye === g)
            break;
          ye === 92 ? (F += this.input.slice(ue, this.pos), F += this.readEscapedChar(!1), ue = this.pos) : ye === 8232 || ye === 8233 ? (this.options.ecmaVersion < 10 && this.raise(this.start, "Unterminated string constant"), ++this.pos, this.options.locations && (this.curLine++, this.lineStart = this.pos)) : (Oe(ye) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
        }
        return F += this.input.slice(ue, this.pos++), this.finishToken(X.string, F);
      };
      var sn = {};
      ri.tryReadTemplateToken = function() {
        this.inTemplateElement = !0;
        try {
          this.readTmplToken();
        } catch (g) {
          if (g === sn)
            this.readInvalidTemplateToken();
          else
            throw g;
        }
        this.inTemplateElement = !1;
      }, ri.invalidStringToken = function(g, F) {
        if (this.inTemplateElement && this.options.ecmaVersion >= 9)
          throw sn;
        this.raise(g, F);
      }, ri.readTmplToken = function() {
        for (var g = "", F = this.pos; ; ) {
          this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
          var ue = this.input.charCodeAt(this.pos);
          if (ue === 96 || ue === 36 && this.input.charCodeAt(this.pos + 1) === 123)
            return this.pos === this.start && (this.type === X.template || this.type === X.invalidTemplate) ? ue === 36 ? (this.pos += 2, this.finishToken(X.dollarBraceL)) : (++this.pos, this.finishToken(X.backQuote)) : (g += this.input.slice(F, this.pos), this.finishToken(X.template, g));
          if (ue === 92)
            g += this.input.slice(F, this.pos), g += this.readEscapedChar(!0), F = this.pos;
          else if (Oe(ue)) {
            switch (g += this.input.slice(F, this.pos), ++this.pos, ue) {
              case 13:
                this.input.charCodeAt(this.pos) === 10 && ++this.pos;
              case 10:
                g += `
`;
                break;
              default:
                g += String.fromCharCode(ue);
                break;
            }
            this.options.locations && (++this.curLine, this.lineStart = this.pos), F = this.pos;
          } else
            ++this.pos;
        }
      }, ri.readInvalidTemplateToken = function() {
        for (; this.pos < this.input.length; this.pos++)
          switch (this.input[this.pos]) {
            case "\\":
              ++this.pos;
              break;
            case "$":
              if (this.input[this.pos + 1] !== "{")
                break;
            case "`":
              return this.finishToken(X.invalidTemplate, this.input.slice(this.start, this.pos));
            case "\r":
              this.input[this.pos + 1] === `
` && ++this.pos;
            case `
`:
            case "\u2028":
            case "\u2029":
              ++this.curLine, this.lineStart = this.pos + 1;
              break;
          }
        this.raise(this.start, "Unterminated template");
      }, ri.readEscapedChar = function(g) {
        var F = this.input.charCodeAt(++this.pos);
        switch (++this.pos, F) {
          case 110:
            return `
`;
          case 114:
            return "\r";
          case 120:
            return String.fromCharCode(this.readHexChar(2));
          case 117:
            return It(this.readCodePoint());
          case 116:
            return "	";
          case 98:
            return "\b";
          case 118:
            return "\v";
          case 102:
            return "\f";
          case 13:
            this.input.charCodeAt(this.pos) === 10 && ++this.pos;
          case 10:
            return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
          case 56:
          case 57:
            if (this.strict && this.invalidStringToken(
              this.pos - 1,
              "Invalid escape sequence"
            ), g) {
              var ue = this.pos - 1;
              this.invalidStringToken(
                ue,
                "Invalid escape sequence in template string"
              );
            }
          default:
            if (F >= 48 && F <= 55) {
              var ye = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], Ee = parseInt(ye, 8);
              return Ee > 255 && (ye = ye.slice(0, -1), Ee = parseInt(ye, 8)), this.pos += ye.length - 1, F = this.input.charCodeAt(this.pos), (ye !== "0" || F === 56 || F === 57) && (this.strict || g) && this.invalidStringToken(
                this.pos - 1 - ye.length,
                g ? "Octal literal in template string" : "Octal literal in strict mode"
              ), String.fromCharCode(Ee);
            }
            return Oe(F) ? (this.options.locations && (this.lineStart = this.pos, ++this.curLine), "") : String.fromCharCode(F);
        }
      }, ri.readHexChar = function(g) {
        var F = this.pos, ue = this.readInt(16, g);
        return ue === null && this.invalidStringToken(F, "Bad character escape sequence"), ue;
      }, ri.readWord1 = function() {
        this.containsEsc = !1;
        for (var g = "", F = !0, ue = this.pos, ye = this.options.ecmaVersion >= 6; this.pos < this.input.length; ) {
          var Ee = this.fullCharCodeAtPos();
          if (U(Ee, ye))
            this.pos += Ee <= 65535 ? 1 : 2;
          else if (Ee === 92) {
            this.containsEsc = !0, g += this.input.slice(ue, this.pos);
            var nt = this.pos;
            this.input.charCodeAt(++this.pos) !== 117 && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
            var gt = this.readCodePoint();
            (F ? W : U)(gt, ye) || this.invalidStringToken(nt, "Invalid Unicode escape"), g += It(gt), ue = this.pos;
          } else
            break;
          F = !1;
        }
        return g + this.input.slice(ue, this.pos);
      }, ri.readWord = function() {
        var g = this.readWord1(), F = X.name;
        return this.keywords.test(g) && (F = he[g]), this.finishToken(F, g);
      };
      var zn = "8.15.0";
      r.acorn = {
        Parser: r,
        version: zn,
        defaultOptions: Tt,
        Position: it,
        SourceLocation: Xt,
        getLineInfo: $t,
        Node: le,
        TokenType: Q,
        tokTypes: X,
        keywordTypes: he,
        TokContext: Y,
        tokContexts: B,
        isIdentifierChar: U,
        isIdentifierStart: W,
        Token: yn,
        isNewLine: Oe,
        lineBreak: Z,
        lineBreakG: qe,
        nonASCIIwhitespace: pt
      };
      function xr(g, F) {
        return r.parse(g, F);
      }
      function Or(g, F, ue) {
        return r.parseExpressionAt(g, F, ue);
      }
      function fr(g, F) {
        return r.tokenizer(g, F);
      }
      t.Node = le, t.Parser = r, t.Position = it, t.SourceLocation = Xt, t.TokContext = Y, t.Token = yn, t.TokenType = Q, t.defaultOptions = Tt, t.getLineInfo = $t, t.isIdentifierChar = U, t.isIdentifierStart = W, t.isNewLine = Oe, t.keywordTypes = he, t.lineBreak = Z, t.lineBreakG = qe, t.nonASCIIwhitespace = pt, t.parse = xr, t.parseExpressionAt = Or, t.tokContexts = B, t.tokTypes = X, t.tokenizer = fr, t.version = zn;
    });
  }(el, el.exports)), el.exports;
}
/*!
 * Paper.js v0.12.18 - The Swiss Army Knife of Vector Graphics Scripting.
 * http://paperjs.org/
 *
 * Copyright (c) 2011 - 2020, Jürg Lehni & Jonathan Puckey
 * http://juerglehni.com/ & https://puckey.studio/
 *
 * Distributed under the MIT license. See LICENSE file for details.
 *
 * All rights reserved.
 *
 * Date: Wed Jul 17 14:57:24 2024 +0200
 *
 ***
 *
 * Straps.js - Class inheritance library with support for bean-style accessors
 *
 * Copyright (c) 2006 - 2020 Jürg Lehni
 * http://juerglehni.com/
 *
 * Distributed under the MIT license.
 *
 ***
 *
 * Acorn.js
 * https://marijnhaverbeke.nl/acorn/
 *
 * Acorn is a tiny, fast JavaScript parser written in JavaScript,
 * created by Marijn Haverbeke and released under an MIT license.
 *
 */
(function(b) {
  (function(e, t) {
    e = e || Vf;
    var n = e.window, a = e.document, o = new function() {
      var i = /^(statics|enumerable|beans|preserve)$/, r = [], s = r.slice, l = Object.create, u = Object.getOwnPropertyDescriptor, d = Object.defineProperty, p = r.forEach || function(A, T) {
        for (var G = 0, O = this.length; G < O; G++)
          A.call(T, this[G], G, this);
      }, m = function(A, T) {
        for (var G in this)
          this.hasOwnProperty(G) && A.call(T, this[G], G, this);
      }, y = Object.assign || function(A) {
        for (var T = 1, G = arguments.length; T < G; T++) {
          var O = arguments[T];
          for (var Y in O)
            O.hasOwnProperty(Y) && (A[Y] = O[Y]);
        }
        return A;
      }, S = function(A, T, G) {
        if (A) {
          var O = u(A, "length");
          (O && typeof O.value == "number" ? p : m).call(A, T, G = G || A);
        }
        return G;
      };
      function L(A, T, G, O, Y) {
        var B = {};
        function z(H, te) {
          te = te || (te = u(T, H)) && (te.get ? te : te.value), typeof te == "string" && te[0] === "#" && (te = A[te.substring(1)] || te);
          var ae = typeof te == "function", le = te, me = Y || ae && !te.base ? te && te.get ? H in A : A[H] : null, se;
          (!Y || !me) && (ae && me && (te.base = me), ae && O !== !1 && (se = H.match(/^([gs]et|is)(([A-Z])(.*))$/)) && (B[se[3].toLowerCase() + se[4]] = se[2]), (!le || ae || !le.get || typeof le.get != "function" || !E.isPlainObject(le)) && (le = { value: le, writable: !0 }), (u(A, H) || { configurable: !0 }).configurable && (le.configurable = !0, le.enumerable = G ?? !se), d(A, H, le));
        }
        if (T) {
          for (var C in T)
            T.hasOwnProperty(C) && !i.test(C) && z(C);
          for (var C in B) {
            var N = B[C], j = A["set" + N], q = A["get" + N] || j && A["is" + N];
            q && (O === !0 || q.length === 0) && z(C, { get: q, set: j });
          }
        }
        return A;
      }
      function E() {
        for (var A = 0, T = arguments.length; A < T; A++) {
          var G = arguments[A];
          G && y(this, G);
        }
        return this;
      }
      return L(E, {
        inject: function(A) {
          if (A) {
            var T = A.statics === !0 ? A : A.statics, G = A.beans, O = A.preserve;
            T !== A && L(this.prototype, A, A.enumerable, G, O), L(this, T, null, G, O);
          }
          for (var Y = 1, B = arguments.length; Y < B; Y++)
            this.inject(arguments[Y]);
          return this;
        },
        extend: function() {
          for (var A = this, T, G, O = 0, Y, B = arguments.length; O < B && !(T && G); O++)
            Y = arguments[O], T = T || Y.initialize, G = G || Y.prototype;
          return T = T || function() {
            A.apply(this, arguments);
          }, G = T.prototype = G || l(this.prototype), d(
            G,
            "constructor",
            { value: T, writable: !0, configurable: !0 }
          ), L(T, this), arguments.length && this.inject.apply(T, arguments), T.base = A, T;
        }
      }).inject({
        enumerable: !1,
        initialize: E,
        set: E,
        inject: function() {
          for (var A = 0, T = arguments.length; A < T; A++) {
            var G = arguments[A];
            G && L(this, G, G.enumerable, G.beans, G.preserve);
          }
          return this;
        },
        extend: function() {
          var A = l(this);
          return A.inject.apply(A, arguments);
        },
        each: function(A, T) {
          return S(this, A, T);
        },
        clone: function() {
          return new this.constructor(this);
        },
        statics: {
          set: y,
          each: S,
          create: l,
          define: d,
          describe: u,
          clone: function(A) {
            return y(new A.constructor(), A);
          },
          isPlainObject: function(A) {
            var T = A != null && A.constructor;
            return T && (T === Object || T === E || T.name === "Object");
          },
          pick: function(A, T) {
            return A !== t ? A : T;
          },
          slice: function(A, T, G) {
            return s.call(A, T, G);
          }
        }
      });
    }();
    b.exports = o, o.inject({
      enumerable: !1,
      toString: function() {
        return this._id != null ? (this._class || "Object") + (this._name ? " '" + this._name + "'" : " @" + this._id) : "{ " + o.each(this, function(i, r) {
          if (!/^_/.test(r)) {
            var s = typeof i;
            this.push(r + ": " + (s === "number" ? k.instance.number(i) : s === "string" ? "'" + i + "'" : i));
          }
        }, []).join(", ") + " }";
      },
      getClassName: function() {
        return this._class || "";
      },
      importJSON: function(i) {
        return o.importJSON(i, this);
      },
      exportJSON: function(i) {
        return o.exportJSON(this, i);
      },
      toJSON: function() {
        return o.serialize(this);
      },
      set: function(i, r) {
        return i && o.filter(this, i, r, this._prioritize), this;
      }
    }, {
      beans: !1,
      statics: {
        exports: {},
        extend: function i() {
          var r = i.base.apply(this, arguments), s = r.prototype._class;
          return s && !o.exports[s] && (o.exports[s] = r), r;
        },
        equals: function(i, r) {
          if (i === r)
            return !0;
          if (i && i.equals)
            return i.equals(r);
          if (r && r.equals)
            return r.equals(i);
          if (i && r && typeof i == "object" && typeof r == "object") {
            if (Array.isArray(i) && Array.isArray(r)) {
              var s = i.length;
              if (s !== r.length)
                return !1;
              for (; s--; )
                if (!o.equals(i[s], r[s]))
                  return !1;
            } else {
              var l = Object.keys(i), s = l.length;
              if (s !== Object.keys(r).length)
                return !1;
              for (; s--; ) {
                var u = l[s];
                if (!(r.hasOwnProperty(u) && o.equals(i[u], r[u])))
                  return !1;
              }
            }
            return !0;
          }
          return !1;
        },
        read: function(i, r, s, l) {
          if (this === o) {
            var u = this.peek(i, r);
            return i.__index++, u;
          }
          var d = this.prototype, p = d._readIndex, m = r || p && i.__index || 0, y = i.length, S = i[m];
          if (l = l || y - m, S instanceof this || s && s.readNull && S == null && l <= 1)
            return p && (i.__index = m + 1), S && s && s.clone ? S.clone() : S;
          if (S = o.create(d), p && (S.__read = !0), S = S.initialize.apply(S, m > 0 || m + l < y ? o.slice(i, m, m + l) : i) || S, p) {
            i.__index = m + S.__read;
            var L = S.__filtered;
            L && (i.__filtered = L, S.__filtered = t), S.__read = t;
          }
          return S;
        },
        peek: function(i, r) {
          return i[i.__index = r || i.__index || 0];
        },
        remain: function(i) {
          return i.length - (i.__index || 0);
        },
        readList: function(i, r, s, l) {
          for (var u = [], d, p = r || 0, m = l ? p + l : i.length, y = p; y < m; y++)
            u.push(Array.isArray(d = i[y]) ? this.read(d, 0, s) : this.read(i, y, s, 1));
          return u;
        },
        readNamed: function(i, r, s, l, u) {
          var d = this.getNamed(i, r), p = d !== t;
          if (p) {
            var m = i.__filtered;
            if (!m) {
              var y = this.getSource(i);
              m = i.__filtered = o.create(y), m.__unfiltered = y;
            }
            m[r] = t;
          }
          return this.read(p ? [d] : i, s, l, u);
        },
        readSupported: function(i, r) {
          var s = this.getSource(i), l = this, u = !1;
          return s && Object.keys(s).forEach(function(d) {
            if (d in r) {
              var p = l.readNamed(i, d);
              p !== t && (r[d] = p), u = !0;
            }
          }), u;
        },
        getSource: function(i) {
          var r = i.__source;
          if (r === t) {
            var s = i.length === 1 && i[0];
            r = i.__source = s && o.isPlainObject(s) ? s : null;
          }
          return r;
        },
        getNamed: function(i, r) {
          var s = this.getSource(i);
          if (s)
            return r ? s[r] : i.__filtered || s;
        },
        hasNamed: function(i, r) {
          return !!this.getNamed(i, r);
        },
        filter: function(i, r, s, l) {
          var u;
          function d(L) {
            if (!(s && L in s) && !(u && L in u)) {
              var E = r[L];
              E !== t && (i[L] = E);
            }
          }
          if (l) {
            for (var p = {}, m = 0, y, S = l.length; m < S; m++)
              (y = l[m]) in r && (d(y), p[y] = !0);
            u = p;
          }
          return Object.keys(r.__unfiltered || r).forEach(d), i;
        },
        isPlainValue: function(i, r) {
          return o.isPlainObject(i) || Array.isArray(i) || r && typeof i == "string";
        },
        serialize: function(i, r, s, l) {
          r = r || {};
          var u = !l, d;
          if (u && (r.formatter = new k(r.precision), l = {
            length: 0,
            definitions: {},
            references: {},
            add: function(E, A) {
              var T = "#" + E._id, G = this.references[T];
              if (!G) {
                this.length++;
                var O = A.call(E), Y = E._class;
                Y && O[0] !== Y && O.unshift(Y), this.definitions[T] = O, G = this.references[T] = [T];
              }
              return G;
            }
          }), i && i._serialize) {
            d = i._serialize(r, l);
            var p = i._class;
            p && !i._compactSerialize && (u || !s) && d[0] !== p && d.unshift(p);
          } else if (Array.isArray(i)) {
            d = [];
            for (var m = 0, y = i.length; m < y; m++)
              d[m] = o.serialize(i[m], r, s, l);
          } else if (o.isPlainObject(i)) {
            d = {};
            for (var S = Object.keys(i), m = 0, y = S.length; m < y; m++) {
              var L = S[m];
              d[L] = o.serialize(
                i[L],
                r,
                s,
                l
              );
            }
          } else
            typeof i == "number" ? d = r.formatter.number(i, r.precision) : d = i;
          return u && l.length > 0 ? [["dictionary", l.definitions], d] : d;
        },
        deserialize: function(i, r, s, l, u) {
          var d = i, p = !s, m = p && i && i.length && i[0][0] === "dictionary";
          if (s = s || {}, Array.isArray(i)) {
            var y = i[0], S = y === "dictionary";
            if (i.length == 1 && /^#/.test(y))
              return s.dictionary[y];
            y = o.exports[y], d = [];
            for (var L = y ? 1 : 0, E = i.length; L < E; L++)
              d.push(o.deserialize(
                i[L],
                r,
                s,
                S,
                m
              ));
            if (y) {
              var A = d;
              r ? d = r(y, A, p || u) : d = new y(A);
            }
          } else if (o.isPlainObject(i)) {
            d = {}, l && (s.dictionary = d);
            for (var T in i)
              d[T] = o.deserialize(i[T], r, s);
          }
          return m ? d[1] : d;
        },
        exportJSON: function(i, r) {
          var s = o.serialize(i, r);
          return r && r.asString == !1 ? s : JSON.stringify(s);
        },
        importJSON: function(i, r) {
          return o.deserialize(
            typeof i == "string" ? JSON.parse(i) : i,
            function(s, l, u) {
              var d = u && r && r.constructor === s, p = d ? r : o.create(s.prototype);
              if (l.length === 1 && p instanceof X && (d || !(p instanceof qe))) {
                var m = l[0];
                o.isPlainObject(m) && (m.insert = !1, d && (l = l.concat([X.INSERT])));
              }
              return (d ? p.set : s).apply(p, l), d && (r = null), p;
            }
          );
        },
        push: function(i, r) {
          var s = r.length;
          if (s < 4096)
            i.push.apply(i, r);
          else {
            var l = i.length;
            i.length += s;
            for (var u = 0; u < s; u++)
              i[l + u] = r[u];
          }
          return i;
        },
        splice: function(i, r, s, l) {
          var u = r && r.length, d = s === t;
          s = d ? i.length : s, s > i.length && (s = i.length);
          for (var p = 0; p < u; p++)
            r[p]._index = s + p;
          if (d)
            return o.push(i, r), [];
          var m = [s, l];
          r && o.push(m, r);
          for (var y = i.splice.apply(i, m), p = 0, S = y.length; p < S; p++)
            y[p]._index = t;
          for (var p = s + u, S = i.length; p < S; p++)
            i[p]._index = p;
          return y;
        },
        capitalize: function(i) {
          return i.replace(/\b[a-z]/g, function(r) {
            return r.toUpperCase();
          });
        },
        camelize: function(i) {
          return i.replace(/-(.)/g, function(r, s) {
            return s.toUpperCase();
          });
        },
        hyphenate: function(i) {
          return i.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        }
      }
    });
    var h = {
      on: function(i, r) {
        if (typeof i != "string")
          o.each(i, function(d, p) {
            this.on(p, d);
          }, this);
        else {
          var s = this._eventTypes, l = s && s[i], u = this._callbacks = this._callbacks || {};
          u = u[i] = u[i] || [], u.indexOf(r) === -1 && (u.push(r), l && l.install && u.length === 1 && l.install.call(this, i));
        }
        return this;
      },
      off: function(i, r) {
        if (typeof i != "string") {
          o.each(i, function(p, m) {
            this.off(m, p);
          }, this);
          return;
        }
        var s = this._eventTypes, l = s && s[i], u = this._callbacks && this._callbacks[i], d;
        return u && (!r || (d = u.indexOf(r)) !== -1 && u.length === 1 ? (l && l.uninstall && l.uninstall.call(this, i), delete this._callbacks[i]) : d !== -1 && u.splice(d, 1)), this;
      },
      once: function(i, r) {
        return this.on(i, function s() {
          r.apply(this, arguments), this.off(i, s);
        });
      },
      emit: function(i, r) {
        var s = this._callbacks && this._callbacks[i];
        if (!s)
          return !1;
        var l = o.slice(arguments, 1), u = r && r.target && !r.currentTarget;
        s = s.slice(), u && (r.currentTarget = this);
        for (var d = 0, p = s.length; d < p; d++)
          if (s[d].apply(this, l) == !1) {
            r && r.stop && r.stop();
            break;
          }
        return u && delete r.currentTarget, !0;
      },
      responds: function(i) {
        return !!(this._callbacks && this._callbacks[i]);
      },
      attach: "#on",
      detach: "#off",
      fire: "#emit",
      _installEvents: function(i) {
        var r = this._eventTypes, s = this._callbacks, l = i ? "install" : "uninstall";
        if (r) {
          for (var u in s)
            if (s[u].length > 0) {
              var d = r[u], p = d && d[l];
              p && p.call(this, u);
            }
        }
      },
      statics: {
        inject: function i(r) {
          var s = r._events;
          if (s) {
            var l = {};
            o.each(s, function(u, d) {
              var p = typeof u == "string", m = p ? u : d, y = o.capitalize(m), S = m.substring(2).toLowerCase();
              l[S] = p ? {} : u, m = "_" + m, r["get" + y] = function() {
                return this[m];
              }, r["set" + y] = function(L) {
                var E = this[m];
                E && this.off(S, E), L && this.on(S, L), this[m] = L;
              };
            }), r._eventTypes = l;
          }
          return i.base.apply(this, arguments);
        }
      }
    }, f = o.extend({
      _class: "PaperScope",
      initialize: function i() {
        Ve = this, this.settings = new o({
          applyMatrix: !0,
          insertItems: !0,
          handleSize: 4,
          hitTolerance: 0
        }), this.project = null, this.projects = [], this.tools = [], this._id = i._id++, i._scopes[this._id] = this;
        var r = i.prototype;
        if (!this.support) {
          var s = ft.getContext(1, 1) || {};
          r.support = {
            nativeDash: "setLineDash" in s || "mozDash" in s,
            nativeBlendModes: tt.nativeModes
          }, ft.release(s);
        }
        if (!this.agent) {
          var l = e.navigator.userAgent.toLowerCase(), u = (/(darwin|win|mac|linux|freebsd|sunos)/.exec(l) || [])[0], d = u === "darwin" ? "mac" : u, p = r.agent = r.browser = { platform: d };
          d && (p[d] = !0), l.replace(
            /(opera|chrome|safari|webkit|firefox|msie|trident|atom|node|jsdom)\/?\s*([.\d]+)(?:.*version\/([.\d]+))?(?:.*rv\:v?([.\d]+))?/g,
            function(m, y, S, L, E) {
              if (!p.chrome) {
                var A = y === "opera" ? L : /^(node|trident)$/.test(y) ? E : S;
                p.version = A, p.versionNumber = parseFloat(A), y = { trident: "msie", jsdom: "node" }[y] || y, p.name = y, p[y] = !0;
              }
            }
          ), p.chrome && delete p.webkit, p.atom && delete p.chrome;
        }
      },
      version: "0.12.18",
      getView: function() {
        var i = this.project;
        return i && i._view;
      },
      getPaper: function() {
        return this;
      },
      execute: function(i, r) {
        var s = Ve.PaperScript.execute(i, this, r);
        return Qt.updateFocus(), s;
      },
      install: function(i) {
        var r = this;
        o.each(["project", "view", "tool"], function(l) {
          o.define(i, l, {
            configurable: !0,
            get: function() {
              return r[l];
            }
          });
        });
        for (var s in this)
          !/^_/.test(s) && this[s] && (i[s] = this[s]);
      },
      setup: function(i) {
        return Ve = this, this.project = new fe(i), this;
      },
      createCanvas: function(i, r) {
        return ft.getCanvas(i, r);
      },
      activate: function() {
        Ve = this;
      },
      clear: function() {
        for (var i = this.projects, r = this.tools, s = i.length - 1; s >= 0; s--)
          i[s].remove();
        for (var s = r.length - 1; s >= 0; s--)
          r[s].remove();
      },
      remove: function() {
        this.clear(), delete f._scopes[this._id];
      },
      statics: new function() {
        function i(r) {
          return r += "Attribute", function(s, l) {
            return s[r](l) || s[r]("data-paper-" + l);
          };
        }
        return {
          _scopes: {},
          _id: 0,
          get: function(r) {
            return this._scopes[r] || null;
          },
          getAttribute: i("get"),
          hasAttribute: i("has")
        };
      }()
    }), v = o.extend(h, {
      initialize: function(i) {
        this._scope = Ve, this._index = this._scope[this._list].push(this) - 1, (i || !this._scope[this._reference]) && this.activate();
      },
      activate: function() {
        if (!this._scope)
          return !1;
        var i = this._scope[this._reference];
        return i && i !== this && i.emit("deactivate"), this._scope[this._reference] = this, this.emit("activate", i), !0;
      },
      isActive: function() {
        return this._scope[this._reference] === this;
      },
      remove: function() {
        return this._index == null ? !1 : (o.splice(this._scope[this._list], null, this._index, 1), this._scope[this._reference] == this && (this._scope[this._reference] = null), this._scope = null, !0);
      },
      getView: function() {
        return this._scope.getView();
      }
    }), x = {
      findItemBoundsCollisions: function(i, r, s) {
        function l(p) {
          for (var m = new Array(p.length), y = 0; y < p.length; y++) {
            var S = p[y].getBounds();
            m[y] = [S.left, S.top, S.right, S.bottom];
          }
          return m;
        }
        var u = l(i), d = !r || r === i ? u : l(r);
        return this.findBoundsCollisions(u, d, s || 0);
      },
      findCurveBoundsCollisions: function(i, r, s, l) {
        function u(A) {
          for (var T = Math.min, G = Math.max, O = new Array(A.length), Y = 0; Y < A.length; Y++) {
            var B = A[Y];
            O[Y] = [
              T(B[0], B[2], B[4], B[6]),
              T(B[1], B[3], B[5], B[7]),
              G(B[0], B[2], B[4], B[6]),
              G(B[1], B[3], B[5], B[7])
            ];
          }
          return O;
        }
        var d = u(i), p = !r || r === i ? d : u(r);
        if (l) {
          for (var m = this.findBoundsCollisions(
            d,
            p,
            s || 0,
            !1,
            !0
          ), y = this.findBoundsCollisions(
            d,
            p,
            s || 0,
            !0,
            !0
          ), S = [], L = 0, E = m.length; L < E; L++)
            S[L] = { hor: m[L], ver: y[L] };
          return S;
        }
        return this.findBoundsCollisions(d, p, s || 0);
      },
      findBoundsCollisions: function(i, r, s, l, u) {
        var d = !r || i === r, p = d ? i : i.concat(r), m = i.length, y = p.length;
        function S(Qe, st, mt) {
          for (var Re = 0, Fe = Qe.length; Re < Fe; ) {
            var at = Fe + Re >>> 1;
            p[Qe[at]][st] < mt ? Re = at + 1 : Fe = at;
          }
          return Re - 1;
        }
        for (var L = l ? 1 : 0, E = L + 2, A = l ? 0 : 1, T = A + 2, G = new Array(y), O = 0; O < y; O++)
          G[O] = O;
        G.sort(function(Qe, st) {
          return p[Qe][L] - p[st][L];
        });
        for (var Y = [], B = new Array(m), O = 0; O < y; O++) {
          var z = G[O], C = p[z], N = d ? z : z - m, j = z < m, q = d || !j, H = j ? [] : null;
          if (Y.length) {
            var te = S(
              Y,
              E,
              C[L] - s
            ) + 1;
            if (Y.splice(0, te), d && u) {
              H = H.concat(Y);
              for (var ae = 0; ae < Y.length; ae++) {
                var le = Y[ae];
                B[le].push(N);
              }
            } else
              for (var me = C[T], se = C[A], ae = 0; ae < Y.length; ae++) {
                var le = Y[ae], de = p[le], ve = le < m, we = d || le >= m;
                (u || (j && we || q && ve) && me >= de[A] - s && se <= de[T] + s) && (j && we && H.push(
                  d ? le : le - m
                ), q && ve && B[le].push(N));
              }
          }
          if (j && (i === r && H.push(z), B[z] = H), Y.length) {
            var Se = C[E], Ae = S(Y, E, Se);
            Y.splice(Ae + 1, 0, z);
          } else
            Y.push(z);
        }
        for (var O = 0; O < B.length; O++) {
          var Ge = B[O];
          Ge && Ge.sort(function(st, mt) {
            return st - mt;
          });
        }
        return B;
      }
    }, k = o.extend({
      initialize: function(i) {
        this.precision = o.pick(i, 5), this.multiplier = Math.pow(10, this.precision);
      },
      number: function(i) {
        return this.precision < 16 ? Math.round(i * this.multiplier) / this.multiplier : i;
      },
      pair: function(i, r, s) {
        return this.number(i) + (s || ",") + this.number(r);
      },
      point: function(i, r) {
        return this.number(i.x) + (r || ",") + this.number(i.y);
      },
      size: function(i, r) {
        return this.number(i.width) + (r || ",") + this.number(i.height);
      },
      rectangle: function(i, r) {
        return this.point(i, r) + (r || ",") + this.size(i, r);
      }
    });
    k.instance = new k();
    var I = new function() {
      var i = [
        [0.5773502691896257],
        [0, 0.7745966692414834],
        [0.33998104358485626, 0.8611363115940526],
        [0, 0.5384693101056831, 0.906179845938664],
        [0.2386191860831969, 0.6612093864662645, 0.932469514203152],
        [0, 0.4058451513773972, 0.7415311855993945, 0.9491079123427585],
        [0.1834346424956498, 0.525532409916329, 0.7966664774136267, 0.9602898564975363],
        [0, 0.3242534234038089, 0.6133714327005904, 0.8360311073266358, 0.9681602395076261],
        [0.14887433898163122, 0.4333953941292472, 0.6794095682990244, 0.8650633666889845, 0.9739065285171717],
        [0, 0.26954315595234496, 0.5190961292068118, 0.7301520055740494, 0.8870625997680953, 0.978228658146057],
        [0.1252334085114689, 0.3678314989981802, 0.5873179542866175, 0.7699026741943047, 0.9041172563704749, 0.9815606342467192],
        [0, 0.2304583159551348, 0.44849275103644687, 0.6423493394403402, 0.8015780907333099, 0.9175983992229779, 0.9841830547185881],
        [0.10805494870734367, 0.31911236892788974, 0.5152486363581541, 0.6872929048116855, 0.827201315069765, 0.9284348836635735, 0.9862838086968123],
        [0, 0.20119409399743451, 0.3941513470775634, 0.5709721726085388, 0.7244177313601701, 0.8482065834104272, 0.937273392400706, 0.9879925180204854],
        [0.09501250983763744, 0.2816035507792589, 0.45801677765722737, 0.6178762444026438, 0.755404408355003, 0.8656312023878318, 0.9445750230732326, 0.9894009349916499]
      ], r = [
        [1],
        [0.8888888888888888, 0.5555555555555556],
        [0.6521451548625461, 0.34785484513745385],
        [0.5688888888888889, 0.47862867049936647, 0.23692688505618908],
        [0.46791393457269104, 0.3607615730481386, 0.17132449237917036],
        [0.4179591836734694, 0.3818300505051189, 0.27970539148927664, 0.1294849661688697],
        [0.362683783378362, 0.31370664587788727, 0.22238103445337448, 0.10122853629037626],
        [0.3302393550012598, 0.31234707704000286, 0.26061069640293544, 0.1806481606948574, 0.08127438836157441],
        [0.29552422471475287, 0.26926671930999635, 0.21908636251598204, 0.1494513491505806, 0.06667134430868814],
        [0.2729250867779006, 0.26280454451024665, 0.23319376459199048, 0.18629021092773426, 0.1255803694649046, 0.05566856711617366],
        [0.24914704581340277, 0.2334925365383548, 0.20316742672306592, 0.16007832854334622, 0.10693932599531843, 0.04717533638651183],
        [0.2325515532308739, 0.22628318026289723, 0.2078160475368885, 0.17814598076194574, 0.13887351021978725, 0.09212149983772845, 0.04048400476531588],
        [0.2152638534631578, 0.2051984637212956, 0.18553839747793782, 0.15720316715819355, 0.12151857068790319, 0.08015808715976021, 0.03511946033175186],
        [0.2025782419255613, 0.19843148532711158, 0.1861610000155622, 0.16626920581699392, 0.13957067792615432, 0.10715922046717194, 0.07036604748810812, 0.03075324199611727],
        [0.1894506104550685, 0.18260341504492358, 0.16915651939500254, 0.14959598881657674, 0.12462897125553388, 0.09515851168249279, 0.062253523938647894, 0.027152459411754096]
      ], s = Math.abs, l = Math.sqrt, u = Math.pow, d = Math.log2 || function(E) {
        return Math.log(E) * Math.LOG2E;
      }, p = 1e-12, m = 112e-18;
      function y(E, A, T) {
        return E < A ? A : E > T ? T : E;
      }
      function S(E, A, T) {
        function G(te) {
          var ae = te * 134217729, le = te - ae, me = le + ae, se = te - me;
          return [me, se];
        }
        var O = A * A - E * T, Y = A * A + E * T;
        if (s(O) * 3 < Y) {
          var B = G(E), z = G(A), C = G(T), N = A * A, j = z[0] * z[0] - N + 2 * z[0] * z[1] + z[1] * z[1], q = E * T, H = B[0] * C[0] - q + B[0] * C[1] + B[1] * C[0] + B[1] * C[1];
          O = N - q + (j - H);
        }
        return O;
      }
      function L() {
        var E = Math.max.apply(Math, arguments);
        return E && (E < 1e-8 || E > 1e8) ? u(2, -Math.round(d(E))) : 0;
      }
      return {
        EPSILON: p,
        MACHINE_EPSILON: m,
        CURVETIME_EPSILON: 1e-8,
        GEOMETRIC_EPSILON: 1e-7,
        TRIGONOMETRIC_EPSILON: 1e-8,
        ANGULAR_EPSILON: 1e-5,
        KAPPA: 4 * (l(2) - 1) / 3,
        isZero: function(E) {
          return E >= -p && E <= p;
        },
        isMachineZero: function(E) {
          return E >= -m && E <= m;
        },
        clamp: y,
        integrate: function(E, A, T, G) {
          for (var O = i[G - 2], Y = r[G - 2], B = (T - A) * 0.5, z = B + A, C = 0, N = G + 1 >> 1, j = G & 1 ? Y[C++] * E(z) : 0; C < N; ) {
            var q = B * O[C];
            j += Y[C++] * (E(z + q) + E(z - q));
          }
          return B * j;
        },
        findRoot: function(E, A, T, G, O, Y, B) {
          for (var z = 0; z < Y; z++) {
            var C = E(T), N = C / A(T), j = T - N;
            if (s(N) < B) {
              T = j;
              break;
            }
            C > 0 ? (O = T, T = j <= G ? (G + O) * 0.5 : j) : (G = T, T = j >= O ? (G + O) * 0.5 : j);
          }
          return y(T, G, O);
        },
        solveQuadratic: function(E, A, T, G, O, Y) {
          var B, z = 1 / 0;
          if (s(E) < p) {
            if (s(A) < p)
              return s(T) < p ? -1 : 0;
            B = -T / A;
          } else {
            A *= -0.5;
            var C = S(E, A, T);
            if (C && s(C) < m) {
              var N = L(s(E), s(A), s(T));
              N && (E *= N, A *= N, T *= N, C = S(E, A, T));
            }
            if (C >= -m) {
              var j = C < 0 ? 0 : l(C), q = A + (A < 0 ? -j : j);
              q === 0 ? (B = T / E, z = -B) : (B = q / E, z = T / q);
            }
          }
          var H = 0, te = O == null, ae = O - p, le = Y + p;
          return isFinite(B) && (te || B > ae && B < le) && (G[H++] = te ? B : y(B, O, Y)), z !== B && isFinite(z) && (te || z > ae && z < le) && (G[H++] = te ? z : y(z, O, Y)), H;
        },
        solveCubic: function(E, A, T, G, O, Y, B) {
          var z = L(s(E), s(A), s(T), s(G)), C, N, j, q, H;
          z && (E *= z, A *= z, T *= z, G *= z);
          function te(Ae) {
            C = Ae;
            var Ge = E * C;
            N = Ge + A, j = N * C + T, q = (Ge + N) * C + j, H = j * C + G;
          }
          if (s(E) < p)
            E = A, N = T, j = G, C = 1 / 0;
          else if (s(G) < p)
            N = A, j = T, C = 0;
          else {
            te(-(A / E) / 3);
            var ae = H / E, le = u(s(ae), 1 / 3), me = ae < 0 ? -1 : 1, se = -q / E, de = se > 0 ? 1.324717957244746 * Math.max(le, l(se)) : le, ve = C - me * de;
            if (ve !== C) {
              do
                te(ve), ve = q === 0 ? C : C - H / q / (1 + m);
              while (me * ve > me * C);
              s(E) * C * C > s(G / C) && (j = -G / C, N = (j - T) / C);
            }
          }
          var we = I.solveQuadratic(E, N, j, O, Y, B), Se = Y == null;
          return isFinite(C) && (we === 0 || we > 0 && C !== O[0] && C !== O[1]) && (Se || C > Y - p && C < B + p) && (O[we++] = Se ? C : y(C, Y, B)), we;
        }
      };
    }(), V = {
      _id: 1,
      _pools: {},
      get: function(i) {
        if (i) {
          var r = this._pools[i];
          return r || (r = this._pools[i] = { _id: 1 }), r._id++;
        } else
          return this._id++;
      }
    }, M = o.extend({
      _class: "Point",
      _readIndex: !0,
      initialize: function(r, s) {
        var l = typeof r, u = this.__read, d = 0;
        if (l === "number") {
          var p = typeof s == "number";
          this._set(r, p ? s : r), u && (d = p ? 2 : 1);
        } else if (l === "undefined" || r === null)
          this._set(0, 0), u && (d = r === null ? 1 : 0);
        else {
          var m = l === "string" ? r.split(/[\s,]+/) || [] : r;
          d = 1, Array.isArray(m) ? this._set(+m[0], +(m.length > 1 ? m[1] : m[0])) : "x" in m ? this._set(m.x || 0, m.y || 0) : "width" in m ? this._set(m.width || 0, m.height || 0) : "angle" in m ? (this._set(m.length || 0, 0), this.setAngle(m.angle || 0)) : (this._set(0, 0), d = 0);
        }
        return u && (this.__read = d), this;
      },
      set: "#initialize",
      _set: function(i, r) {
        return this.x = i, this.y = r, this;
      },
      equals: function(i) {
        return this === i || i && (this.x === i.x && this.y === i.y || Array.isArray(i) && this.x === i[0] && this.y === i[1]) || !1;
      },
      clone: function() {
        return new M(this.x, this.y);
      },
      toString: function() {
        var i = k.instance;
        return "{ x: " + i.number(this.x) + ", y: " + i.number(this.y) + " }";
      },
      _serialize: function(i) {
        var r = i.formatter;
        return [r.number(this.x), r.number(this.y)];
      },
      getLength: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
      },
      setLength: function(i) {
        if (this.isZero()) {
          var r = this._angle || 0;
          this._set(
            Math.cos(r) * i,
            Math.sin(r) * i
          );
        } else {
          var s = i / this.getLength();
          I.isZero(s) && this.getAngle(), this._set(
            this.x * s,
            this.y * s
          );
        }
      },
      getAngle: function() {
        return this.getAngleInRadians.apply(this, arguments) * 180 / Math.PI;
      },
      setAngle: function(i) {
        this.setAngleInRadians.call(this, i * Math.PI / 180);
      },
      getAngleInDegrees: "#getAngle",
      setAngleInDegrees: "#setAngle",
      getAngleInRadians: function() {
        if (arguments.length) {
          var i = M.read(arguments), r = this.getLength() * i.getLength();
          if (I.isZero(r))
            return NaN;
          var s = this.dot(i) / r;
          return Math.acos(s < -1 ? -1 : s > 1 ? 1 : s);
        } else
          return this.isZero() ? this._angle || 0 : this._angle = Math.atan2(this.y, this.x);
      },
      setAngleInRadians: function(i) {
        if (this._angle = i, !this.isZero()) {
          var r = this.getLength();
          this._set(
            Math.cos(i) * r,
            Math.sin(i) * r
          );
        }
      },
      getQuadrant: function() {
        return this.x >= 0 ? this.y >= 0 ? 1 : 4 : this.y >= 0 ? 2 : 3;
      }
    }, {
      beans: !1,
      getDirectedAngle: function() {
        var i = M.read(arguments);
        return Math.atan2(this.cross(i), this.dot(i)) * 180 / Math.PI;
      },
      getDistance: function() {
        var i = arguments, r = M.read(i), s = r.x - this.x, l = r.y - this.y, u = s * s + l * l, d = o.read(i);
        return d ? u : Math.sqrt(u);
      },
      normalize: function(i) {
        i === t && (i = 1);
        var r = this.getLength(), s = r !== 0 ? i / r : 0, l = new M(this.x * s, this.y * s);
        return s >= 0 && (l._angle = this._angle), l;
      },
      rotate: function(i, r) {
        if (i === 0)
          return this.clone();
        i = i * Math.PI / 180;
        var s = r ? this.subtract(r) : this, l = Math.sin(i), u = Math.cos(i);
        return s = new M(
          s.x * u - s.y * l,
          s.x * l + s.y * u
        ), r ? s.add(r) : s;
      },
      transform: function(i) {
        return i ? i._transformPoint(this) : this;
      },
      add: function() {
        var i = M.read(arguments);
        return new M(this.x + i.x, this.y + i.y);
      },
      subtract: function() {
        var i = M.read(arguments);
        return new M(this.x - i.x, this.y - i.y);
      },
      multiply: function() {
        var i = M.read(arguments);
        return new M(this.x * i.x, this.y * i.y);
      },
      divide: function() {
        var i = M.read(arguments);
        return new M(this.x / i.x, this.y / i.y);
      },
      modulo: function() {
        var i = M.read(arguments);
        return new M(this.x % i.x, this.y % i.y);
      },
      negate: function() {
        return new M(-this.x, -this.y);
      },
      isInside: function() {
        return D.read(arguments).contains(this);
      },
      isClose: function() {
        var i = arguments, r = M.read(i), s = o.read(i);
        return this.getDistance(r) <= s;
      },
      isCollinear: function() {
        var i = M.read(arguments);
        return M.isCollinear(this.x, this.y, i.x, i.y);
      },
      isColinear: "#isCollinear",
      isOrthogonal: function() {
        var i = M.read(arguments);
        return M.isOrthogonal(this.x, this.y, i.x, i.y);
      },
      isZero: function() {
        var i = I.isZero;
        return i(this.x) && i(this.y);
      },
      isNaN: function() {
        return isNaN(this.x) || isNaN(this.y);
      },
      isInQuadrant: function(i) {
        return this.x * (i > 1 && i < 4 ? -1 : 1) >= 0 && this.y * (i > 2 ? -1 : 1) >= 0;
      },
      dot: function() {
        var i = M.read(arguments);
        return this.x * i.x + this.y * i.y;
      },
      cross: function() {
        var i = M.read(arguments);
        return this.x * i.y - this.y * i.x;
      },
      project: function() {
        var i = M.read(arguments), r = i.isZero() ? 0 : this.dot(i) / i.dot(i);
        return new M(
          i.x * r,
          i.y * r
        );
      },
      statics: {
        min: function() {
          var i = arguments, r = M.read(i), s = M.read(i);
          return new M(
            Math.min(r.x, s.x),
            Math.min(r.y, s.y)
          );
        },
        max: function() {
          var i = arguments, r = M.read(i), s = M.read(i);
          return new M(
            Math.max(r.x, s.x),
            Math.max(r.y, s.y)
          );
        },
        random: function() {
          return new M(Math.random(), Math.random());
        },
        isCollinear: function(i, r, s, l) {
          return Math.abs(i * l - r * s) <= Math.sqrt((i * i + r * r) * (s * s + l * l)) * 1e-8;
        },
        isOrthogonal: function(i, r, s, l) {
          return Math.abs(i * s + r * l) <= Math.sqrt((i * i + r * r) * (s * s + l * l)) * 1e-8;
        }
      }
    }, o.each(["round", "ceil", "floor", "abs"], function(i) {
      var r = Math[i];
      this[i] = function() {
        return new M(r(this.x), r(this.y));
      };
    }, {})), W = M.extend({
      initialize: function(r, s, l, u) {
        this._x = r, this._y = s, this._owner = l, this._setter = u;
      },
      _set: function(i, r, s) {
        return this._x = i, this._y = r, s || this._owner[this._setter](this), this;
      },
      getX: function() {
        return this._x;
      },
      setX: function(i) {
        this._x = i, this._owner[this._setter](this);
      },
      getY: function() {
        return this._y;
      },
      setY: function(i) {
        this._y = i, this._owner[this._setter](this);
      },
      isSelected: function() {
        return !!(this._owner._selection & this._getSelection());
      },
      setSelected: function(i) {
        this._owner._changeSelection(this._getSelection(), i);
      },
      _getSelection: function() {
        return this._setter === "setPosition" ? 4 : 0;
      }
    }), U = o.extend({
      _class: "Size",
      _readIndex: !0,
      initialize: function(r, s) {
        var l = typeof r, u = this.__read, d = 0;
        if (l === "number") {
          var p = typeof s == "number";
          this._set(r, p ? s : r), u && (d = p ? 2 : 1);
        } else if (l === "undefined" || r === null)
          this._set(0, 0), u && (d = r === null ? 1 : 0);
        else {
          var m = l === "string" ? r.split(/[\s,]+/) || [] : r;
          d = 1, Array.isArray(m) ? this._set(+m[0], +(m.length > 1 ? m[1] : m[0])) : "width" in m ? this._set(m.width || 0, m.height || 0) : "x" in m ? this._set(m.x || 0, m.y || 0) : (this._set(0, 0), d = 0);
        }
        return u && (this.__read = d), this;
      },
      set: "#initialize",
      _set: function(i, r) {
        return this.width = i, this.height = r, this;
      },
      equals: function(i) {
        return i === this || i && (this.width === i.width && this.height === i.height || Array.isArray(i) && this.width === i[0] && this.height === i[1]) || !1;
      },
      clone: function() {
        return new U(this.width, this.height);
      },
      toString: function() {
        var i = k.instance;
        return "{ width: " + i.number(this.width) + ", height: " + i.number(this.height) + " }";
      },
      _serialize: function(i) {
        var r = i.formatter;
        return [
          r.number(this.width),
          r.number(this.height)
        ];
      },
      add: function() {
        var i = U.read(arguments);
        return new U(this.width + i.width, this.height + i.height);
      },
      subtract: function() {
        var i = U.read(arguments);
        return new U(this.width - i.width, this.height - i.height);
      },
      multiply: function() {
        var i = U.read(arguments);
        return new U(this.width * i.width, this.height * i.height);
      },
      divide: function() {
        var i = U.read(arguments);
        return new U(this.width / i.width, this.height / i.height);
      },
      modulo: function() {
        var i = U.read(arguments);
        return new U(this.width % i.width, this.height % i.height);
      },
      negate: function() {
        return new U(-this.width, -this.height);
      },
      isZero: function() {
        var i = I.isZero;
        return i(this.width) && i(this.height);
      },
      isNaN: function() {
        return isNaN(this.width) || isNaN(this.height);
      },
      statics: {
        min: function(i, r) {
          return new U(
            Math.min(i.width, r.width),
            Math.min(i.height, r.height)
          );
        },
        max: function(i, r) {
          return new U(
            Math.max(i.width, r.width),
            Math.max(i.height, r.height)
          );
        },
        random: function() {
          return new U(Math.random(), Math.random());
        }
      }
    }, o.each(["round", "ceil", "floor", "abs"], function(i) {
      var r = Math[i];
      this[i] = function() {
        return new U(r(this.width), r(this.height));
      };
    }, {})), Q = U.extend({
      initialize: function(r, s, l, u) {
        this._width = r, this._height = s, this._owner = l, this._setter = u;
      },
      _set: function(i, r, s) {
        return this._width = i, this._height = r, s || this._owner[this._setter](this), this;
      },
      getWidth: function() {
        return this._width;
      },
      setWidth: function(i) {
        this._width = i, this._owner[this._setter](this);
      },
      getHeight: function() {
        return this._height;
      },
      setHeight: function(i) {
        this._height = i, this._owner[this._setter](this);
      }
    }), D = o.extend({
      _class: "Rectangle",
      _readIndex: !0,
      beans: !0,
      initialize: function(r, s, l, u) {
        var d = arguments, p = typeof r, m;
        if (p === "number" ? (this._set(r, s, l, u), m = 4) : p === "undefined" || r === null ? (this._set(0, 0, 0, 0), m = r === null ? 1 : 0) : d.length === 1 && (Array.isArray(r) ? (this._set.apply(this, r), m = 1) : r.x !== t || r.width !== t ? (this._set(
          r.x || 0,
          r.y || 0,
          r.width || 0,
          r.height || 0
        ), m = 1) : r.from === t && r.to === t && (this._set(0, 0, 0, 0), o.readSupported(d, this) && (m = 1))), m === t) {
          var y = M.readNamed(d, "from"), S = o.peek(d), L = y.x, E = y.y, A, T;
          if (S && S.x !== t || o.hasNamed(d, "to")) {
            var G = M.readNamed(d, "to");
            A = G.x - L, T = G.y - E, A < 0 && (L = G.x, A = -A), T < 0 && (E = G.y, T = -T);
          } else {
            var O = U.read(d);
            A = O.width, T = O.height;
          }
          this._set(L, E, A, T), m = d.__index;
        }
        var Y = d.__filtered;
        return Y && (this.__filtered = Y), this.__read && (this.__read = m), this;
      },
      set: "#initialize",
      _set: function(i, r, s, l) {
        return this.x = i, this.y = r, this.width = s, this.height = l, this;
      },
      clone: function() {
        return new D(this.x, this.y, this.width, this.height);
      },
      equals: function(i) {
        var r = o.isPlainValue(i) ? D.read(arguments) : i;
        return r === this || r && this.x === r.x && this.y === r.y && this.width === r.width && this.height === r.height || !1;
      },
      toString: function() {
        var i = k.instance;
        return "{ x: " + i.number(this.x) + ", y: " + i.number(this.y) + ", width: " + i.number(this.width) + ", height: " + i.number(this.height) + " }";
      },
      _serialize: function(i) {
        var r = i.formatter;
        return [
          r.number(this.x),
          r.number(this.y),
          r.number(this.width),
          r.number(this.height)
        ];
      },
      getPoint: function(i) {
        var r = i ? M : W;
        return new r(this.x, this.y, this, "setPoint");
      },
      setPoint: function() {
        var i = M.read(arguments);
        this.x = i.x, this.y = i.y;
      },
      getSize: function(i) {
        var r = i ? U : Q;
        return new r(this.width, this.height, this, "setSize");
      },
      _fw: 1,
      _fh: 1,
      setSize: function() {
        var i = U.read(arguments), r = this._sx, s = this._sy, l = i.width, u = i.height;
        r && (this.x += (this.width - l) * r), s && (this.y += (this.height - u) * s), this.width = l, this.height = u, this._fw = this._fh = 1;
      },
      getLeft: function() {
        return this.x;
      },
      setLeft: function(i) {
        if (!this._fw) {
          var r = i - this.x;
          this.width -= this._sx === 0.5 ? r * 2 : r;
        }
        this.x = i, this._sx = this._fw = 0;
      },
      getTop: function() {
        return this.y;
      },
      setTop: function(i) {
        if (!this._fh) {
          var r = i - this.y;
          this.height -= this._sy === 0.5 ? r * 2 : r;
        }
        this.y = i, this._sy = this._fh = 0;
      },
      getRight: function() {
        return this.x + this.width;
      },
      setRight: function(i) {
        if (!this._fw) {
          var r = i - this.x;
          this.width = this._sx === 0.5 ? r * 2 : r;
        }
        this.x = i - this.width, this._sx = 1, this._fw = 0;
      },
      getBottom: function() {
        return this.y + this.height;
      },
      setBottom: function(i) {
        if (!this._fh) {
          var r = i - this.y;
          this.height = this._sy === 0.5 ? r * 2 : r;
        }
        this.y = i - this.height, this._sy = 1, this._fh = 0;
      },
      getCenterX: function() {
        return this.x + this.width / 2;
      },
      setCenterX: function(i) {
        this._fw || this._sx === 0.5 ? this.x = i - this.width / 2 : (this._sx && (this.x += (i - this.x) * 2 * this._sx), this.width = (i - this.x) * 2), this._sx = 0.5, this._fw = 0;
      },
      getCenterY: function() {
        return this.y + this.height / 2;
      },
      setCenterY: function(i) {
        this._fh || this._sy === 0.5 ? this.y = i - this.height / 2 : (this._sy && (this.y += (i - this.y) * 2 * this._sy), this.height = (i - this.y) * 2), this._sy = 0.5, this._fh = 0;
      },
      getCenter: function(i) {
        var r = i ? M : W;
        return new r(this.getCenterX(), this.getCenterY(), this, "setCenter");
      },
      setCenter: function() {
        var i = M.read(arguments);
        return this.setCenterX(i.x), this.setCenterY(i.y), this;
      },
      getArea: function() {
        return this.width * this.height;
      },
      isEmpty: function() {
        return this.width === 0 || this.height === 0;
      },
      contains: function(i) {
        return i && i.width !== t || (Array.isArray(i) ? i : arguments).length === 4 ? this._containsRectangle(D.read(arguments)) : this._containsPoint(M.read(arguments));
      },
      _containsPoint: function(i) {
        var r = i.x, s = i.y;
        return r >= this.x && s >= this.y && r <= this.x + this.width && s <= this.y + this.height;
      },
      _containsRectangle: function(i) {
        var r = i.x, s = i.y;
        return r >= this.x && s >= this.y && r + i.width <= this.x + this.width && s + i.height <= this.y + this.height;
      },
      intersects: function() {
        var i = D.read(arguments), r = o.read(arguments) || 0;
        return i.x + i.width > this.x - r && i.y + i.height > this.y - r && i.x < this.x + this.width + r && i.y < this.y + this.height + r;
      },
      intersect: function() {
        var i = D.read(arguments), r = Math.max(this.x, i.x), s = Math.max(this.y, i.y), l = Math.min(this.x + this.width, i.x + i.width), u = Math.min(this.y + this.height, i.y + i.height);
        return new D(r, s, l - r, u - s);
      },
      unite: function() {
        var i = D.read(arguments), r = Math.min(this.x, i.x), s = Math.min(this.y, i.y), l = Math.max(this.x + this.width, i.x + i.width), u = Math.max(this.y + this.height, i.y + i.height);
        return new D(r, s, l - r, u - s);
      },
      include: function() {
        var i = M.read(arguments), r = Math.min(this.x, i.x), s = Math.min(this.y, i.y), l = Math.max(this.x + this.width, i.x), u = Math.max(this.y + this.height, i.y);
        return new D(r, s, l - r, u - s);
      },
      expand: function() {
        var i = U.read(arguments), r = i.width, s = i.height;
        return new D(
          this.x - r / 2,
          this.y - s / 2,
          this.width + r,
          this.height + s
        );
      },
      scale: function(i, r) {
        return this.expand(
          this.width * i - this.width,
          this.height * (r === t ? i : r) - this.height
        );
      }
    }, o.each(
      [
        ["Top", "Left"],
        ["Top", "Right"],
        ["Bottom", "Left"],
        ["Bottom", "Right"],
        ["Left", "Center"],
        ["Top", "Center"],
        ["Right", "Center"],
        ["Bottom", "Center"]
      ],
      function(i, r) {
        var s = i.join(""), l = /^[RL]/.test(s);
        r >= 4 && (i[1] += l ? "Y" : "X");
        var u = i[l ? 0 : 1], d = i[l ? 1 : 0], p = "get" + u, m = "get" + d, y = "set" + u, S = "set" + d, L = "get" + s, E = "set" + s;
        this[L] = function(A) {
          var T = A ? M : W;
          return new T(this[p](), this[m](), this, E);
        }, this[E] = function() {
          var A = M.read(arguments);
          this[y](A.x), this[S](A.y);
        };
      },
      {
        beans: !0
      }
    )), ee = D.extend(
      {
        initialize: function(r, s, l, u, d, p) {
          this._set(r, s, l, u, !0), this._owner = d, this._setter = p;
        },
        _set: function(i, r, s, l, u) {
          return this._x = i, this._y = r, this._width = s, this._height = l, u || this._owner[this._setter](this), this;
        }
      },
      new function() {
        var i = D.prototype;
        return o.each(
          ["x", "y", "width", "height"],
          function(r) {
            var s = o.capitalize(r), l = "_" + r;
            this["get" + s] = function() {
              return this[l];
            }, this["set" + s] = function(u) {
              this[l] = u, this._dontNotify || this._owner[this._setter](this);
            };
          },
          o.each(
            [
              "Point",
              "Size",
              "Center",
              "Left",
              "Top",
              "Right",
              "Bottom",
              "CenterX",
              "CenterY",
              "TopLeft",
              "TopRight",
              "BottomLeft",
              "BottomRight",
              "LeftCenter",
              "TopCenter",
              "RightCenter",
              "BottomCenter"
            ],
            function(r) {
              var s = "set" + r;
              this[s] = function() {
                this._dontNotify = !0, i[s].apply(this, arguments), this._dontNotify = !1, this._owner[this._setter](this);
              };
            },
            {
              isSelected: function() {
                return !!(this._owner._selection & 2);
              },
              setSelected: function(r) {
                var s = this._owner;
                s._changeSelection && s._changeSelection(2, r);
              }
            }
          )
        );
      }()
    ), J = o.extend({
      _class: "Matrix",
      initialize: function i(r, s) {
        var l = arguments, u = l.length, d = !0;
        if (u >= 6 ? this._set.apply(this, l) : u === 1 || u === 2 ? r instanceof i ? this._set(
          r._a,
          r._b,
          r._c,
          r._d,
          r._tx,
          r._ty,
          s
        ) : Array.isArray(r) ? this._set.apply(
          this,
          s ? r.concat([s]) : r
        ) : d = !1 : u ? d = !1 : this.reset(), !d)
          throw new Error("Unsupported matrix parameters");
        return this;
      },
      set: "#initialize",
      _set: function(i, r, s, l, u, d, p) {
        return this._a = i, this._b = r, this._c = s, this._d = l, this._tx = u, this._ty = d, p || this._changed(), this;
      },
      _serialize: function(i, r) {
        return o.serialize(this.getValues(), i, !0, r);
      },
      _changed: function() {
        var i = this._owner;
        i && (i._applyMatrix ? i.transform(null, !0) : i._changed(25));
      },
      clone: function() {
        return new J(
          this._a,
          this._b,
          this._c,
          this._d,
          this._tx,
          this._ty
        );
      },
      equals: function(i) {
        return i === this || i && this._a === i._a && this._b === i._b && this._c === i._c && this._d === i._d && this._tx === i._tx && this._ty === i._ty;
      },
      toString: function() {
        var i = k.instance;
        return "[[" + [
          i.number(this._a),
          i.number(this._c),
          i.number(this._tx)
        ].join(", ") + "], [" + [
          i.number(this._b),
          i.number(this._d),
          i.number(this._ty)
        ].join(", ") + "]]";
      },
      reset: function(i) {
        return this._a = this._d = 1, this._b = this._c = this._tx = this._ty = 0, i || this._changed(), this;
      },
      apply: function(i, r) {
        var s = this._owner;
        return s ? (s.transform(null, o.pick(i, !0), r), this.isIdentity()) : !1;
      },
      translate: function() {
        var i = M.read(arguments), r = i.x, s = i.y;
        return this._tx += r * this._a + s * this._c, this._ty += r * this._b + s * this._d, this._changed(), this;
      },
      scale: function() {
        var i = arguments, r = M.read(i), s = M.read(i, 0, { readNull: !0 });
        return s && this.translate(s), this._a *= r.x, this._b *= r.x, this._c *= r.y, this._d *= r.y, s && this.translate(s.negate()), this._changed(), this;
      },
      rotate: function(i) {
        i *= Math.PI / 180;
        var r = M.read(arguments, 1), s = r.x, l = r.y, u = Math.cos(i), d = Math.sin(i), p = s - s * u + l * d, m = l - s * d - l * u, y = this._a, S = this._b, L = this._c, E = this._d;
        return this._a = u * y + d * L, this._b = u * S + d * E, this._c = -d * y + u * L, this._d = -d * S + u * E, this._tx += p * y + m * L, this._ty += p * S + m * E, this._changed(), this;
      },
      shear: function() {
        var i = arguments, r = M.read(i), s = M.read(i, 0, { readNull: !0 });
        s && this.translate(s);
        var l = this._a, u = this._b;
        return this._a += r.y * this._c, this._b += r.y * this._d, this._c += r.x * l, this._d += r.x * u, s && this.translate(s.negate()), this._changed(), this;
      },
      skew: function() {
        var i = arguments, r = M.read(i), s = M.read(i, 0, { readNull: !0 }), l = Math.PI / 180, u = new M(
          Math.tan(r.x * l),
          Math.tan(r.y * l)
        );
        return this.shear(u, s);
      },
      append: function(i, r) {
        if (i) {
          var s = this._a, l = this._b, u = this._c, d = this._d, p = i._a, m = i._c, y = i._b, S = i._d, L = i._tx, E = i._ty;
          this._a = p * s + y * u, this._c = m * s + S * u, this._b = p * l + y * d, this._d = m * l + S * d, this._tx += L * s + E * u, this._ty += L * l + E * d, r || this._changed();
        }
        return this;
      },
      prepend: function(i, r) {
        if (i) {
          var s = this._a, l = this._b, u = this._c, d = this._d, p = this._tx, m = this._ty, y = i._a, S = i._c, L = i._b, E = i._d, A = i._tx, T = i._ty;
          this._a = y * s + S * l, this._c = y * u + S * d, this._b = L * s + E * l, this._d = L * u + E * d, this._tx = y * p + S * m + A, this._ty = L * p + E * m + T, r || this._changed();
        }
        return this;
      },
      appended: function(i) {
        return this.clone().append(i);
      },
      prepended: function(i) {
        return this.clone().prepend(i);
      },
      invert: function() {
        var i = this._a, r = this._b, s = this._c, l = this._d, u = this._tx, d = this._ty, p = i * l - r * s, m = null;
        return p && !isNaN(p) && isFinite(u) && isFinite(d) && (this._a = l / p, this._b = -r / p, this._c = -s / p, this._d = i / p, this._tx = (s * d - l * u) / p, this._ty = (r * u - i * d) / p, m = this), m;
      },
      inverted: function() {
        return this.clone().invert();
      },
      concatenate: "#append",
      preConcatenate: "#prepend",
      chain: "#appended",
      _shiftless: function() {
        return new J(this._a, this._b, this._c, this._d, 0, 0);
      },
      _orNullIfIdentity: function() {
        return this.isIdentity() ? null : this;
      },
      isIdentity: function() {
        return this._a === 1 && this._b === 0 && this._c === 0 && this._d === 1 && this._tx === 0 && this._ty === 0;
      },
      isInvertible: function() {
        var i = this._a * this._d - this._c * this._b;
        return i && !isNaN(i) && isFinite(this._tx) && isFinite(this._ty);
      },
      isSingular: function() {
        return !this.isInvertible();
      },
      transform: function(i, r, s) {
        return arguments.length < 3 ? this._transformPoint(M.read(arguments)) : this._transformCoordinates(i, r, s);
      },
      _transformPoint: function(i, r, s) {
        var l = i.x, u = i.y;
        return r || (r = new M()), r._set(
          l * this._a + u * this._c + this._tx,
          l * this._b + u * this._d + this._ty,
          s
        );
      },
      _transformCoordinates: function(i, r, s) {
        for (var l = 0, u = 2 * s; l < u; l += 2) {
          var d = i[l], p = i[l + 1];
          r[l] = d * this._a + p * this._c + this._tx, r[l + 1] = d * this._b + p * this._d + this._ty;
        }
        return r;
      },
      _transformCorners: function(i) {
        var r = i.x, s = i.y, l = r + i.width, u = s + i.height, d = [r, s, l, s, l, u, r, u];
        return this._transformCoordinates(d, d, 4);
      },
      _transformBounds: function(i, r, s) {
        for (var l = this._transformCorners(i), u = l.slice(0, 2), d = u.slice(), p = 2; p < 8; p++) {
          var m = l[p], y = p & 1;
          m < u[y] ? u[y] = m : m > d[y] && (d[y] = m);
        }
        return r || (r = new D()), r._set(
          u[0],
          u[1],
          d[0] - u[0],
          d[1] - u[1],
          s
        );
      },
      inverseTransform: function() {
        return this._inverseTransform(M.read(arguments));
      },
      _inverseTransform: function(i, r, s) {
        var l = this._a, u = this._b, d = this._c, p = this._d, m = this._tx, y = this._ty, S = l * p - u * d, L = null;
        if (S && !isNaN(S) && isFinite(m) && isFinite(y)) {
          var E = i.x - this._tx, A = i.y - this._ty;
          r || (r = new M()), L = r._set(
            (E * p - A * d) / S,
            (A * l - E * u) / S,
            s
          );
        }
        return L;
      },
      decompose: function() {
        var i = this._a, r = this._b, s = this._c, l = this._d, u = i * l - r * s, d = Math.sqrt, p = Math.atan2, m = 180 / Math.PI, y, S, L;
        if (i !== 0 || r !== 0) {
          var E = d(i * i + r * r);
          y = Math.acos(i / E) * (r > 0 ? 1 : -1), S = [E, u / E], L = [p(i * s + r * l, E * E), 0];
        } else if (s !== 0 || l !== 0) {
          var A = d(s * s + l * l);
          y = Math.asin(s / A) * (l > 0 ? 1 : -1), S = [u / A, A], L = [0, p(i * s + r * l, A * A)];
        } else
          y = 0, L = S = [0, 0];
        return {
          translation: this.getTranslation(),
          rotation: y * m,
          scaling: new M(S),
          skewing: new M(L[0] * m, L[1] * m)
        };
      },
      getValues: function() {
        return [this._a, this._b, this._c, this._d, this._tx, this._ty];
      },
      getTranslation: function() {
        return new M(this._tx, this._ty);
      },
      getScaling: function() {
        return this.decompose().scaling;
      },
      getRotation: function() {
        return this.decompose().rotation;
      },
      applyToContext: function(i) {
        this.isIdentity() || i.transform(
          this._a,
          this._b,
          this._c,
          this._d,
          this._tx,
          this._ty
        );
      }
    }, o.each(["a", "b", "c", "d", "tx", "ty"], function(i) {
      var r = o.capitalize(i), s = "_" + i;
      this["get" + r] = function() {
        return this[s];
      }, this["set" + r] = function(l) {
        this[s] = l, this._changed();
      };
    }, {})), he = o.extend({
      _class: "Line",
      initialize: function(r, s, l, u, d) {
        var p = !1;
        arguments.length >= 4 ? (this._px = r, this._py = s, this._vx = l, this._vy = u, p = d) : (this._px = r.x, this._py = r.y, this._vx = s.x, this._vy = s.y, p = l), p || (this._vx -= this._px, this._vy -= this._py);
      },
      getPoint: function() {
        return new M(this._px, this._py);
      },
      getVector: function() {
        return new M(this._vx, this._vy);
      },
      getLength: function() {
        return this.getVector().getLength();
      },
      intersect: function(i, r) {
        return he.intersect(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i._px,
          i._py,
          i._vx,
          i._vy,
          !0,
          r
        );
      },
      getSide: function(i, r) {
        return he.getSide(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i.x,
          i.y,
          !0,
          r
        );
      },
      getDistance: function(i) {
        return Math.abs(this.getSignedDistance(i));
      },
      getSignedDistance: function(i) {
        return he.getSignedDistance(
          this._px,
          this._py,
          this._vx,
          this._vy,
          i.x,
          i.y,
          !0
        );
      },
      isCollinear: function(i) {
        return M.isCollinear(this._vx, this._vy, i._vx, i._vy);
      },
      isOrthogonal: function(i) {
        return M.isOrthogonal(this._vx, this._vy, i._vx, i._vy);
      },
      statics: {
        intersect: function(i, r, s, l, u, d, p, m, y, S) {
          y || (s -= i, l -= r, p -= u, m -= d);
          var L = s * m - l * p;
          if (!I.isMachineZero(L)) {
            var E = i - u, A = r - d, T = (p * A - m * E) / L, G = (s * A - l * E) / L, O = 1e-12, Y = -O, B = 1 + O;
            if (S || Y < T && T < B && Y < G && G < B)
              return S || (T = T <= 0 ? 0 : T >= 1 ? 1 : T), new M(
                i + T * s,
                r + T * l
              );
          }
        },
        getSide: function(i, r, s, l, u, d, p, m) {
          p || (s -= i, l -= r);
          var y = u - i, S = d - r, L = y * l - S * s;
          return !m && I.isMachineZero(L) && (L = (y * s + y * s) / (s * s + l * l), L >= 0 && L <= 1 && (L = 0)), L < 0 ? -1 : L > 0 ? 1 : 0;
        },
        getSignedDistance: function(i, r, s, l, u, d, p) {
          return p || (s -= i, l -= r), s === 0 ? l > 0 ? u - i : i - u : l === 0 ? s < 0 ? d - r : r - d : ((u - i) * l - (d - r) * s) / (l > s ? l * Math.sqrt(1 + s * s / (l * l)) : s * Math.sqrt(1 + l * l / (s * s)));
        },
        getDistance: function(i, r, s, l, u, d, p) {
          return Math.abs(
            he.getSignedDistance(i, r, s, l, u, d, p)
          );
        }
      }
    }), fe = v.extend({
      _class: "Project",
      _list: "projects",
      _reference: "project",
      _compactSerialize: !0,
      initialize: function(r) {
        v.call(this, !0), this._children = [], this._namedChildren = {}, this._activeLayer = null, this._currentStyle = new oi(null, null, this), this._view = Qt.create(
          this,
          r || ft.getCanvas(1, 1)
        ), this._selectionItems = {}, this._selectionCount = 0, this._updateVersion = 0;
      },
      _serialize: function(i, r) {
        return o.serialize(this._children, i, !0, r);
      },
      _changed: function(i, r) {
        if (i & 1) {
          var s = this._view;
          s && (s._needsUpdate = !0, !s._requested && s._autoUpdate && s.requestUpdate());
        }
        var l = this._changes;
        if (l && r) {
          var u = this._changesById, d = r._id, p = u[d];
          p ? p.flags |= i : l.push(u[d] = { item: r, flags: i });
        }
      },
      clear: function() {
        for (var i = this._children, r = i.length - 1; r >= 0; r--)
          i[r].remove();
      },
      isEmpty: function() {
        return !this._children.length;
      },
      remove: function i() {
        return i.base.call(this) ? (this._view && this._view.remove(), !0) : !1;
      },
      getView: function() {
        return this._view;
      },
      getCurrentStyle: function() {
        return this._currentStyle;
      },
      setCurrentStyle: function(i) {
        this._currentStyle.set(i);
      },
      getIndex: function() {
        return this._index;
      },
      getOptions: function() {
        return this._scope.settings;
      },
      getLayers: function() {
        return this._children;
      },
      getActiveLayer: function() {
        return this._activeLayer || new qe({ project: this, insert: !0 });
      },
      getSymbolDefinitions: function() {
        var i = [], r = {};
        return this.getItems({
          class: pt,
          match: function(s) {
            var l = s._definition, u = l._id;
            return r[u] || (r[u] = !0, i.push(l)), !1;
          }
        }), i;
      },
      getSymbols: "getSymbolDefinitions",
      getSelectedItems: function() {
        var i = this._selectionItems, r = [];
        for (var s in i) {
          var l = i[s], u = l._selection;
          u & 1 && l.isInserted() ? r.push(l) : u || this._updateSelection(l);
        }
        return r;
      },
      _updateSelection: function(i) {
        var r = i._id, s = this._selectionItems;
        i._selection ? s[r] !== i && (this._selectionCount++, s[r] = i) : s[r] === i && (this._selectionCount--, delete s[r]);
      },
      selectAll: function() {
        for (var i = this._children, r = 0, s = i.length; r < s; r++)
          i[r].setFullySelected(!0);
      },
      deselectAll: function() {
        var i = this._selectionItems;
        for (var r in i)
          i[r].setFullySelected(!1);
      },
      addLayer: function(i) {
        return this.insertLayer(t, i);
      },
      insertLayer: function(i, r) {
        if (r instanceof qe) {
          r._remove(!1, !0), o.splice(this._children, [r], i, 0), r._setProject(this, !0);
          var s = r._name;
          s && r.setName(s), this._changes && r._changed(5), this._activeLayer || (this._activeLayer = r);
        } else
          r = null;
        return r;
      },
      _insertItem: function(i, r, s) {
        return r = this.insertLayer(i, r) || (this._activeLayer || this._insertItem(
          t,
          new qe(X.NO_INSERT),
          !0
        )).insertChild(i, r), s && r.activate && r.activate(), r;
      },
      getItems: function(i) {
        return X._getItems(this, i);
      },
      getItem: function(i) {
        return X._getItems(this, i, null, null, !0)[0] || null;
      },
      importJSON: function(i) {
        this.activate();
        var r = this._activeLayer;
        return o.importJSON(i, r && r.isEmpty() && r);
      },
      removeOn: function(i) {
        var r = this._removeSets;
        if (r) {
          i === "mouseup" && (r.mousedrag = null);
          var s = r[i];
          if (s) {
            for (var l in s) {
              var u = s[l];
              for (var d in r) {
                var p = r[d];
                p && p != s && delete p[u._id];
              }
              u.remove();
            }
            r[i] = null;
          }
        }
      },
      draw: function(i, r, s) {
        this._updateVersion++, i.save(), r.applyToContext(i);
        for (var l = this._children, u = new o({
          offset: new M(0, 0),
          pixelRatio: s,
          viewMatrix: r.isIdentity() ? null : r,
          matrices: [new J()],
          updateMatrix: !0
        }), d = 0, p = l.length; d < p; d++)
          l[d].draw(i, u);
        if (i.restore(), this._selectionCount > 0) {
          i.save(), i.strokeWidth = 1;
          var m = this._selectionItems, y = this._scope.settings.handleSize, S = this._updateVersion;
          for (var L in m)
            m[L]._drawSelection(i, r, y, m, S);
          i.restore();
        }
      }
    }), X = o.extend(
      h,
      {
        statics: {
          extend: function i(r) {
            return r._serializeFields && (r._serializeFields = o.set(
              {},
              this.prototype._serializeFields,
              r._serializeFields
            )), i.base.apply(this, arguments);
          },
          INSERT: { insert: !0 },
          NO_INSERT: { insert: !1 }
        },
        _class: "Item",
        _name: null,
        _applyMatrix: !0,
        _canApplyMatrix: !0,
        _canScaleStroke: !1,
        _pivot: null,
        _visible: !0,
        _blendMode: "normal",
        _opacity: 1,
        _locked: !1,
        _guide: !1,
        _clipMask: !1,
        _selection: 0,
        _selectBounds: !0,
        _selectChildren: !1,
        _serializeFields: {
          name: null,
          applyMatrix: null,
          matrix: new J(),
          pivot: null,
          visible: !0,
          blendMode: "normal",
          opacity: 1,
          locked: !1,
          guide: !1,
          clipMask: !1,
          selected: !1,
          data: {}
        },
        _prioritize: ["applyMatrix"]
      },
      new function() {
        var i = [
          "onMouseDown",
          "onMouseUp",
          "onMouseDrag",
          "onClick",
          "onDoubleClick",
          "onMouseMove",
          "onMouseEnter",
          "onMouseLeave"
        ];
        return o.each(
          i,
          function(r) {
            this._events[r] = {
              install: function(s) {
                this.getView()._countItemEvent(s, 1);
              },
              uninstall: function(s) {
                this.getView()._countItemEvent(s, -1);
              }
            };
          },
          {
            _events: {
              onFrame: {
                install: function() {
                  this.getView()._animateItem(this, !0);
                },
                uninstall: function() {
                  this.getView()._animateItem(this, !1);
                }
              },
              onLoad: {},
              onError: {}
            },
            statics: {
              _itemHandlers: i
            }
          }
        );
      }(),
      {
        initialize: function() {
        },
        _initialize: function(i, r) {
          var s = i && o.isPlainObject(i), l = s && i.internal === !0, u = this._matrix = new J(), d = s && i.project || Ve.project, p = Ve.settings;
          return this._id = l ? null : V.get(), this._parent = this._index = null, this._applyMatrix = this._canApplyMatrix && p.applyMatrix, r && u.translate(r), u._owner = this, this._style = new oi(d._currentStyle, this, d), l || s && i.insert == !1 || !p.insertItems && !(s && i.insert == !0) ? this._setProject(d) : (s && i.parent || d)._insertItem(t, this, !0), s && i !== X.NO_INSERT && i !== X.INSERT && this.set(i, {
            internal: !0,
            insert: !0,
            project: !0,
            parent: !0
          }), s;
        },
        _serialize: function(i, r) {
          var s = {}, l = this;
          function u(d) {
            for (var p in d) {
              var m = l[p];
              o.equals(m, p === "leading" ? d.fontSize * 1.2 : d[p]) || (s[p] = o.serialize(
                m,
                i,
                p !== "data",
                r
              ));
            }
          }
          return u(this._serializeFields), this instanceof Z || u(this._style._defaults), [this._class, s];
        },
        _changed: function(i) {
          var r = this._symbol, s = this._parent || r, l = this._project;
          i & 8 && (this._bounds = this._position = this._decomposed = t), i & 16 && (this._globalMatrix = t), s && i & 72 && X._clearBoundsCache(s), i & 2 && X._clearBoundsCache(this), l && l._changed(i, this), r && r._changed(i);
        },
        getId: function() {
          return this._id;
        },
        getName: function() {
          return this._name;
        },
        setName: function(i) {
          if (this._name && this._removeNamed(), i === +i + "")
            throw new Error(
              "Names consisting only of numbers are not supported."
            );
          var r = this._getOwner();
          if (i && r) {
            var s = r._children, l = r._namedChildren;
            (l[i] = l[i] || []).push(this), i in s || (s[i] = this);
          }
          this._name = i || t, this._changed(256);
        },
        getStyle: function() {
          return this._style;
        },
        setStyle: function(i) {
          this.getStyle().set(i);
        }
      },
      o.each(
        ["locked", "visible", "blendMode", "opacity", "guide"],
        function(i) {
          var r = o.capitalize(i), s = "_" + i, l = {
            locked: 256,
            visible: 265
          };
          this["get" + r] = function() {
            return this[s];
          }, this["set" + r] = function(u) {
            u != this[s] && (this[s] = u, this._changed(l[i] || 257));
          };
        },
        {}
      ),
      {
        beans: !0,
        getSelection: function() {
          return this._selection;
        },
        setSelection: function(i) {
          if (i !== this._selection) {
            this._selection = i;
            var r = this._project;
            r && (r._updateSelection(this), this._changed(257));
          }
        },
        _changeSelection: function(i, r) {
          var s = this._selection;
          this.setSelection(r ? s | i : s & ~i);
        },
        isSelected: function() {
          if (this._selectChildren) {
            for (var i = this._children, r = 0, s = i.length; r < s; r++)
              if (i[r].isSelected())
                return !0;
          }
          return !!(this._selection & 1);
        },
        setSelected: function(i) {
          if (this._selectChildren)
            for (var r = this._children, s = 0, l = r.length; s < l; s++)
              r[s].setSelected(i);
          this._changeSelection(1, i);
        },
        isFullySelected: function() {
          var i = this._children, r = !!(this._selection & 1);
          if (i && r) {
            for (var s = 0, l = i.length; s < l; s++)
              if (!i[s].isFullySelected())
                return !1;
            return !0;
          }
          return r;
        },
        setFullySelected: function(i) {
          var r = this._children;
          if (r)
            for (var s = 0, l = r.length; s < l; s++)
              r[s].setFullySelected(i);
          this._changeSelection(1, i);
        },
        isClipMask: function() {
          return this._clipMask;
        },
        setClipMask: function(i) {
          this._clipMask != (i = !!i) && (this._clipMask = i, i && (this.setFillColor(null), this.setStrokeColor(null)), this._changed(257), this._parent && this._parent._changed(2048));
        },
        getData: function() {
          return this._data || (this._data = {}), this._data;
        },
        setData: function(i) {
          this._data = i;
        },
        getPosition: function(i) {
          var r = i ? M : W, s = this._position || (this._position = this._getPositionFromBounds());
          return new r(s.x, s.y, this, "setPosition");
        },
        setPosition: function() {
          this.translate(M.read(arguments).subtract(this.getPosition(!0)));
        },
        _getPositionFromBounds: function(i) {
          return this._pivot ? this._matrix._transformPoint(this._pivot) : (i || this.getBounds()).getCenter(!0);
        },
        getPivot: function() {
          var i = this._pivot;
          return i ? new W(i.x, i.y, this, "setPivot") : null;
        },
        setPivot: function() {
          this._pivot = M.read(arguments, 0, { clone: !0, readNull: !0 }), this._position = t;
        }
      },
      o.each(
        {
          getStrokeBounds: { stroke: !0 },
          getHandleBounds: { handle: !0 },
          getInternalBounds: { internal: !0 }
        },
        function(i, r) {
          this[r] = function(s) {
            return this.getBounds(s, i);
          };
        },
        {
          beans: !0,
          getBounds: function(i, r) {
            var s = r || i instanceof J, l = o.set(
              {},
              s ? r : i,
              this._boundsOptions
            );
            (!l.stroke || this.getStrokeScaling()) && (l.cacheItem = this);
            var u = this._getCachedBounds(s && i, l).rect;
            return arguments.length ? u : new ee(
              u.x,
              u.y,
              u.width,
              u.height,
              this,
              "setBounds"
            );
          },
          setBounds: function() {
            var i = D.read(arguments), r = this.getBounds(), s = this._matrix, l = new J(), u = i.getCenter();
            l.translate(u), (i.width != r.width || i.height != r.height) && (s.isInvertible() || (s.set(s._backup || new J().translate(s.getTranslation())), r = this.getBounds()), l.scale(
              r.width !== 0 ? i.width / r.width : 0,
              r.height !== 0 ? i.height / r.height : 0
            )), u = r.getCenter(), l.translate(-u.x, -u.y), this.transform(l);
          },
          _getBounds: function(i, r) {
            var s = this._children;
            return !s || !s.length ? new D() : (X._updateBoundsCache(this, r.cacheItem), X._getBounds(s, i, r));
          },
          _getBoundsCacheKey: function(i, r) {
            return [
              i.stroke ? 1 : 0,
              i.handle ? 1 : 0,
              r ? 1 : 0
            ].join("");
          },
          _getCachedBounds: function(i, r, s) {
            i = i && i._orNullIfIdentity();
            var l = r.internal && !s, u = r.cacheItem, d = l ? null : this._matrix._orNullIfIdentity(), p = u && (!i || i.equals(d)) && this._getBoundsCacheKey(r, l), m = this._bounds;
            if (X._updateBoundsCache(this._parent || this._symbol, u), p && m && p in m) {
              var y = m[p];
              return {
                rect: y.rect.clone(),
                nonscaling: y.nonscaling
              };
            }
            var S = this._getBounds(i || d, r), L = S.rect || S, E = this._style, A = S.nonscaling || E.hasStroke() && !E.getStrokeScaling();
            if (p) {
              m || (this._bounds = m = {});
              var y = m[p] = {
                rect: L.clone(),
                nonscaling: A,
                internal: l
              };
            }
            return {
              rect: L,
              nonscaling: A
            };
          },
          _getStrokeMatrix: function(i, r) {
            var s = this.getStrokeScaling() ? null : r && r.internal ? this : this._parent || this._symbol && this._symbol._item, l = s ? s.getViewMatrix().invert() : i;
            return l && l._shiftless();
          },
          statics: {
            _updateBoundsCache: function(i, r) {
              if (i && r) {
                var s = r._id, l = i._boundsCache = i._boundsCache || {
                  ids: {},
                  list: []
                };
                l.ids[s] || (l.list.push(r), l.ids[s] = r);
              }
            },
            _clearBoundsCache: function(i) {
              var r = i._boundsCache;
              if (r) {
                i._bounds = i._position = i._boundsCache = t;
                for (var s = 0, l = r.list, u = l.length; s < u; s++) {
                  var d = l[s];
                  d !== i && (d._bounds = d._position = t, d._boundsCache && X._clearBoundsCache(d));
                }
              }
            },
            _getBounds: function(i, r, s) {
              var l = 1 / 0, u = -l, d = l, p = u, m = !1;
              s = s || {};
              for (var y = 0, S = i.length; y < S; y++) {
                var L = i[y];
                if (L._visible && !L.isEmpty(!0)) {
                  var E = L._getCachedBounds(
                    r && r.appended(L._matrix),
                    s,
                    !0
                  ), A = E.rect;
                  l = Math.min(A.x, l), d = Math.min(A.y, d), u = Math.max(A.x + A.width, u), p = Math.max(A.y + A.height, p), E.nonscaling && (m = !0);
                }
              }
              return {
                rect: isFinite(l) ? new D(l, d, u - l, p - d) : new D(),
                nonscaling: m
              };
            }
          }
        }
      ),
      {
        beans: !0,
        _decompose: function() {
          return this._applyMatrix ? null : this._decomposed || (this._decomposed = this._matrix.decompose());
        },
        getRotation: function() {
          var i = this._decompose();
          return i ? i.rotation : 0;
        },
        setRotation: function(i) {
          var r = this.getRotation();
          if (r != null && i != null) {
            var s = this._decomposed;
            this.rotate(i - r), s && (s.rotation = i, this._decomposed = s);
          }
        },
        getScaling: function() {
          var i = this._decompose(), r = i && i.scaling;
          return new W(r ? r.x : 1, r ? r.y : 1, this, "setScaling");
        },
        setScaling: function() {
          var i = this.getScaling(), r = M.read(arguments, 0, { clone: !0, readNull: !0 });
          if (i && r && !i.equals(r)) {
            var s = this.getRotation(), l = this._decomposed, u = new J(), d = I.isZero;
            if (d(i.x) || d(i.y))
              u.translate(l.translation), s && u.rotate(s), u.scale(r.x, r.y), this._matrix.set(u);
            else {
              var p = this.getPosition(!0);
              u.translate(p), s && u.rotate(s), u.scale(r.x / i.x, r.y / i.y), s && u.rotate(-s), u.translate(p.negate()), this.transform(u);
            }
            l && (l.scaling = r, this._decomposed = l);
          }
        },
        getMatrix: function() {
          return this._matrix;
        },
        setMatrix: function() {
          var i = this._matrix;
          i.set.apply(i, arguments);
        },
        getGlobalMatrix: function(i) {
          var r = this._globalMatrix;
          if (r)
            for (var s = this._parent, l = []; s; ) {
              if (!s._globalMatrix) {
                r = null;
                for (var u = 0, d = l.length; u < d; u++)
                  l[u]._globalMatrix = null;
                break;
              }
              l.push(s), s = s._parent;
            }
          if (!r) {
            r = this._globalMatrix = this._matrix.clone();
            var s = this._parent;
            s && r.prepend(s.getGlobalMatrix(!0));
          }
          return i ? r : r.clone();
        },
        getViewMatrix: function() {
          return this.getGlobalMatrix().prepend(this.getView()._matrix);
        },
        getApplyMatrix: function() {
          return this._applyMatrix;
        },
        setApplyMatrix: function(i) {
          (this._applyMatrix = this._canApplyMatrix && !!i) && this.transform(null, !0);
        },
        getTransformContent: "#getApplyMatrix",
        setTransformContent: "#setApplyMatrix"
      },
      {
        getProject: function() {
          return this._project;
        },
        _setProject: function(i, r) {
          if (this._project !== i) {
            this._project && this._installEvents(!1), this._project = i;
            for (var s = this._children, l = 0, u = s && s.length; l < u; l++)
              s[l]._setProject(i);
            r = !0;
          }
          r && this._installEvents(!0);
        },
        getView: function() {
          return this._project._view;
        },
        _installEvents: function i(r) {
          i.base.call(this, r);
          for (var s = this._children, l = 0, u = s && s.length; l < u; l++)
            s[l]._installEvents(r);
        },
        getLayer: function() {
          for (var i = this; i = i._parent; )
            if (i instanceof qe)
              return i;
          return null;
        },
        getParent: function() {
          return this._parent;
        },
        setParent: function(i) {
          return i.addChild(this);
        },
        _getOwner: "#getParent",
        getChildren: function() {
          return this._children;
        },
        setChildren: function(i) {
          this.removeChildren(), this.addChildren(i);
        },
        getFirstChild: function() {
          return this._children && this._children[0] || null;
        },
        getLastChild: function() {
          return this._children && this._children[this._children.length - 1] || null;
        },
        getNextSibling: function() {
          var i = this._getOwner();
          return i && i._children[this._index + 1] || null;
        },
        getPreviousSibling: function() {
          var i = this._getOwner();
          return i && i._children[this._index - 1] || null;
        },
        getIndex: function() {
          return this._index;
        },
        setIndex: function(i) {
          var r = this._parent, s = r && r._children;
          s && r.insertChildren(
            i in s ? i : t,
            [this]
          );
        },
        equals: function(i) {
          return i === this || i && this._class === i._class && this._style.equals(i._style) && this._matrix.equals(i._matrix) && this._locked === i._locked && this._visible === i._visible && this._blendMode === i._blendMode && this._opacity === i._opacity && this._clipMask === i._clipMask && this._guide === i._guide && this._equals(i) || !1;
        },
        _equals: function(i) {
          return o.equals(this._children, i._children);
        },
        clone: function(i) {
          var r = new this.constructor(X.NO_INSERT), s = this._children, l = o.pick(
            i ? i.insert : t,
            i === t || i === !0
          ), u = o.pick(i ? i.deep : t, !0);
          s && r.copyAttributes(this), (!s || u) && r.copyContent(this), s || r.copyAttributes(this), l && r.insertAbove(this);
          var d = this._name, p = this._parent;
          if (d && p) {
            for (var s = p._children, m = d, y = 1; s[d]; )
              d = m + " " + y++;
            d !== m && r.setName(d);
          }
          return r;
        },
        copyContent: function(i) {
          for (var r = i._children, s = 0, l = r && r.length; s < l; s++)
            this.addChild(r[s].clone(!1), !0);
        },
        copyAttributes: function(i, r) {
          this.setStyle(i._style);
          for (var s = [
            "_locked",
            "_visible",
            "_blendMode",
            "_opacity",
            "_clipMask",
            "_guide"
          ], l = 0, u = s.length; l < u; l++) {
            var d = s[l];
            i.hasOwnProperty(d) && (this[d] = i[d]);
          }
          r || this._matrix.set(i._matrix, !0), this.setApplyMatrix(i._applyMatrix), this.setPivot(i._pivot), this.setSelection(i._selection);
          var p = i._data, m = i._name;
          this._data = p ? o.clone(p) : null, m && this.setName(m);
        },
        rasterize: function(i, r) {
          var s, l, u;
          o.isPlainObject(i) ? (s = i.resolution, l = i.insert, u = i.raster) : (s = i, l = r), u || (u = new je(X.NO_INSERT));
          var d = this.getStrokeBounds(), p = (s || this.getView().getResolution()) / 72, m = d.getTopLeft().floor(), y = d.getBottomRight().ceil(), S = new U(y.subtract(m)), L = S.multiply(p);
          if (u.setSize(L, !0), !L.isZero()) {
            var E = u.getContext(!0), A = new J().scale(p).translate(m.negate());
            E.save(), A.applyToContext(E), this.draw(E, new o({ matrices: [A] })), E.restore();
          }
          return u._matrix.set(
            new J().translate(m.add(S.divide(2))).scale(1 / p)
          ), (l === t || l) && u.insertAbove(this), u;
        },
        contains: function() {
          var i = this._matrix;
          return i.isInvertible() && !!this._contains(i._inverseTransform(M.read(arguments)));
        },
        _contains: function(i) {
          var r = this._children;
          if (r) {
            for (var s = r.length - 1; s >= 0; s--)
              if (r[s].contains(i))
                return !0;
            return !1;
          }
          return i.isInside(this.getInternalBounds());
        },
        isInside: function() {
          return D.read(arguments).contains(this.getBounds());
        },
        _asPathItem: function() {
          return new $e.Rectangle({
            rectangle: this.getInternalBounds(),
            matrix: this._matrix,
            insert: !1
          });
        },
        intersects: function(i, r) {
          return i instanceof X ? this._asPathItem().getIntersections(
            i._asPathItem(),
            null,
            r,
            !0
          ).length > 0 : !1;
        }
      },
      new function() {
        function i() {
          var l = arguments;
          return this._hitTest(
            M.read(l),
            Ze.getOptions(l)
          );
        }
        function r() {
          var l = arguments, u = M.read(l), d = Ze.getOptions(l), p = [];
          return this._hitTest(u, new o({ all: p }, d)), p;
        }
        function s(l, u, d, p) {
          var m = this._children;
          if (m)
            for (var y = m.length - 1; y >= 0; y--) {
              var S = m[y], L = S !== p && S._hitTest(
                l,
                u,
                d
              );
              if (L && !u.all)
                return L;
            }
          return null;
        }
        return fe.inject({
          hitTest: i,
          hitTestAll: r,
          _hitTest: s
        }), {
          hitTest: i,
          hitTestAll: r,
          _hitTestChildren: s
        };
      }(),
      {
        _hitTest: function(i, r, s) {
          if (this._locked || !this._visible || this._guide && !r.guides || this.isEmpty())
            return null;
          var l = this._matrix, u = s ? s.appended(l) : this.getGlobalMatrix().prepend(this.getView()._matrix), d = Math.max(r.tolerance, 1e-12), p = r._tolerancePadding = new U(
            $e._getStrokePadding(
              d,
              l._shiftless().invert()
            )
          );
          if (i = l._inverseTransform(i), !i || !this._children && !this.getBounds({ internal: !0, stroke: !0, handle: !0 }).expand(p.multiply(2))._containsPoint(i))
            return null;
          var m = !(r.guides && !this._guide || r.selected && !this.isSelected() || r.type && r.type !== o.hyphenate(this._class) || r.class && !(this instanceof r.class)), y = r.match, S = this, L, E;
          function A(C) {
            return C && y && !y(C) && (C = null), C && r.all && r.all.push(C), C;
          }
          function T(C, N) {
            var j = N ? L["get" + N]() : S.getPosition();
            if (i.subtract(j).divide(p).length <= 1)
              return new Ze(C, S, {
                name: N ? o.hyphenate(N) : C,
                point: j
              });
          }
          var G = r.position, O = r.center, Y = r.bounds;
          if (m && this._parent && (G || O || Y)) {
            if ((O || Y) && (L = this.getInternalBounds()), E = G && T("position") || O && T("center", "Center"), !E && Y)
              for (var B = [
                "TopLeft",
                "TopRight",
                "BottomLeft",
                "BottomRight",
                "LeftCenter",
                "TopCenter",
                "RightCenter",
                "BottomCenter"
              ], z = 0; z < 8 && !E; z++)
                E = T("bounds", B[z]);
            E = A(E);
          }
          return E || (E = this._hitTestChildren(i, r, u) || m && A(this._hitTestSelf(
            i,
            r,
            u,
            this.getStrokeScaling() ? null : u._shiftless().invert()
          )) || null), E && E.point && (E.point = l.transform(E.point)), E;
        },
        _hitTestSelf: function(i, r) {
          if (r.fill && this.hasFill() && this._contains(i))
            return new Ze("fill", this);
        },
        matches: function(i, r) {
          function s(p, m) {
            for (var y in p)
              if (p.hasOwnProperty(y)) {
                var S = p[y], L = m[y];
                if (o.isPlainObject(S) && o.isPlainObject(L)) {
                  if (!s(S, L))
                    return !1;
                } else if (!o.equals(S, L))
                  return !1;
              }
            return !0;
          }
          var l = typeof i;
          if (l === "object") {
            for (var u in i)
              if (i.hasOwnProperty(u) && !this.matches(u, i[u]))
                return !1;
            return !0;
          } else {
            if (l === "function")
              return i(this);
            if (i === "match")
              return r(this);
            var d = /^(empty|editable)$/.test(i) ? this["is" + o.capitalize(i)]() : i === "type" ? o.hyphenate(this._class) : this[i];
            if (i === "class") {
              if (typeof r == "function")
                return this instanceof r;
              d = this._class;
            }
            if (typeof r == "function")
              return !!r(d);
            if (r) {
              if (r.test)
                return r.test(d);
              if (o.isPlainObject(r))
                return s(r, d);
            }
            return o.equals(d, r);
          }
        },
        getItems: function(i) {
          return X._getItems(this, i, this._matrix);
        },
        getItem: function(i) {
          return X._getItems(this, i, this._matrix, null, !0)[0] || null;
        },
        statics: {
          _getItems: function i(r, s, l, u, d) {
            if (!u) {
              var p = typeof s == "object" && s, m = p && p.overlapping, y = p && p.inside, S = m || y, A = S && D.read([S]);
              u = {
                items: [],
                recursive: p && p.recursive !== !1,
                inside: !!y,
                overlapping: !!m,
                rect: A,
                path: m && new $e.Rectangle({
                  rectangle: A,
                  insert: !1
                })
              }, p && (s = o.filter({}, s, {
                recursive: !0,
                inside: !0,
                overlapping: !0
              }));
            }
            var L = r._children, E = u.items, A = u.rect;
            l = A && (l || new J());
            for (var T = 0, G = L && L.length; T < G; T++) {
              var O = L[T], Y = l && l.appended(O._matrix), B = !0;
              if (A) {
                var S = O.getBounds(Y);
                if (!A.intersects(S))
                  continue;
                A.contains(S) || u.overlapping && (S.contains(A) || u.path.intersects(O, Y)) || (B = !1);
              }
              if (B && O.matches(s) && (E.push(O), d) || (u.recursive !== !1 && i(O, s, Y, u, d), d && E.length > 0))
                break;
            }
            return E;
          }
        }
      },
      {
        importJSON: function(i) {
          var r = o.importJSON(i, this);
          return r !== this ? this.addChild(r) : r;
        },
        addChild: function(i) {
          return this.insertChild(t, i);
        },
        insertChild: function(i, r) {
          var s = r ? this.insertChildren(i, [r]) : null;
          return s && s[0];
        },
        addChildren: function(i) {
          return this.insertChildren(this._children.length, i);
        },
        insertChildren: function(i, r) {
          var s = this._children;
          if (s && r && r.length > 0) {
            r = o.slice(r);
            for (var l = {}, u = r.length - 1; u >= 0; u--) {
              var d = r[u], p = d && d._id;
              !d || l[p] ? r.splice(u, 1) : (d._remove(!1, !0), l[p] = !0);
            }
            o.splice(s, r, i, 0);
            for (var m = this._project, y = m._changes, u = 0, S = r.length; u < S; u++) {
              var d = r[u], L = d._name;
              d._parent = this, d._setProject(m, !0), L && d.setName(L), y && d._changed(5);
            }
            this._changed(11);
          } else
            r = null;
          return r;
        },
        _insertItem: "#insertChild",
        _insertAt: function(i, r) {
          var s = i && i._getOwner(), l = i !== this && s ? this : null;
          return l && (l._remove(!1, !0), s._insertItem(i._index + r, l)), l;
        },
        insertAbove: function(i) {
          return this._insertAt(i, 1);
        },
        insertBelow: function(i) {
          return this._insertAt(i, 0);
        },
        sendToBack: function() {
          var i = this._getOwner();
          return i ? i._insertItem(0, this) : null;
        },
        bringToFront: function() {
          var i = this._getOwner();
          return i ? i._insertItem(t, this) : null;
        },
        appendTop: "#addChild",
        appendBottom: function(i) {
          return this.insertChild(0, i);
        },
        moveAbove: "#insertAbove",
        moveBelow: "#insertBelow",
        addTo: function(i) {
          return i._insertItem(t, this);
        },
        copyTo: function(i) {
          return this.clone(!1).addTo(i);
        },
        reduce: function(i) {
          var r = this._children;
          if (r && r.length === 1) {
            var s = r[0].reduce(i);
            return this._parent ? (s.insertAbove(this), this.remove()) : s.remove(), s;
          }
          return this;
        },
        _removeNamed: function() {
          var i = this._getOwner();
          if (i) {
            var r = i._children, s = i._namedChildren, l = this._name, u = s[l], d = u ? u.indexOf(this) : -1;
            d !== -1 && (r[l] == this && delete r[l], u.splice(d, 1), u.length ? r[l] = u[0] : delete s[l]);
          }
        },
        _remove: function(i, r) {
          var s = this._getOwner(), l = this._project, u = this._index;
          return this._style && this._style._dispose(), s ? (this._name && this._removeNamed(), u != null && (l._activeLayer === this && (l._activeLayer = this.getNextSibling() || this.getPreviousSibling()), o.splice(s._children, null, u, 1)), this._installEvents(!1), i && l._changes && this._changed(5), r && s._changed(11, this), this._parent = null, !0) : !1;
        },
        remove: function() {
          return this._remove(!0, !0);
        },
        replaceWith: function(i) {
          var r = i && i.insertBelow(this);
          return r && this.remove(), r;
        },
        removeChildren: function(i, r) {
          if (!this._children)
            return null;
          i = i || 0, r = o.pick(r, this._children.length);
          for (var s = o.splice(this._children, null, i, r - i), l = s.length - 1; l >= 0; l--)
            s[l]._remove(!0, !1);
          return s.length > 0 && this._changed(11), s;
        },
        clear: "#removeChildren",
        reverseChildren: function() {
          if (this._children) {
            this._children.reverse();
            for (var i = 0, r = this._children.length; i < r; i++)
              this._children[i]._index = i;
            this._changed(11);
          }
        },
        isEmpty: function(i) {
          var r = this._children, s = r ? r.length : 0;
          if (i) {
            for (var l = 0; l < s; l++)
              if (!r[l].isEmpty(i))
                return !1;
            return !0;
          }
          return !s;
        },
        isEditable: function() {
          for (var i = this; i; ) {
            if (!i._visible || i._locked)
              return !1;
            i = i._parent;
          }
          return !0;
        },
        hasFill: function() {
          return this.getStyle().hasFill();
        },
        hasStroke: function() {
          return this.getStyle().hasStroke();
        },
        hasShadow: function() {
          return this.getStyle().hasShadow();
        },
        _getOrder: function(i) {
          function r(p) {
            var m = [];
            do
              m.unshift(p);
            while (p = p._parent);
            return m;
          }
          for (var s = r(this), l = r(i), u = 0, d = Math.min(s.length, l.length); u < d; u++)
            if (s[u] != l[u])
              return s[u]._index < l[u]._index ? 1 : -1;
          return 0;
        },
        hasChildren: function() {
          return this._children && this._children.length > 0;
        },
        isInserted: function() {
          return this._parent ? this._parent.isInserted() : !1;
        },
        isAbove: function(i) {
          return this._getOrder(i) === -1;
        },
        isBelow: function(i) {
          return this._getOrder(i) === 1;
        },
        isParent: function(i) {
          return this._parent === i;
        },
        isChild: function(i) {
          return i && i._parent === this;
        },
        isDescendant: function(i) {
          for (var r = this; r = r._parent; )
            if (r === i)
              return !0;
          return !1;
        },
        isAncestor: function(i) {
          return i ? i.isDescendant(this) : !1;
        },
        isSibling: function(i) {
          return this._parent === i._parent;
        },
        isGroupedWith: function(i) {
          for (var r = this._parent; r; ) {
            if (r._parent && /^(Group|Layer|CompoundPath)$/.test(r._class) && i.isDescendant(r))
              return !0;
            r = r._parent;
          }
          return !1;
        }
      },
      o.each(["rotate", "scale", "shear", "skew"], function(i) {
        var r = i === "rotate";
        this[i] = function() {
          var s = arguments, l = (r ? o : M).read(s), u = M.read(s, 0, { readNull: !0 });
          return this.transform(new J()[i](
            l,
            u || this.getPosition(!0)
          ));
        };
      }, {
        translate: function() {
          var i = new J();
          return this.transform(i.translate.apply(i, arguments));
        },
        transform: function(i, r, s) {
          var l = this._matrix, u = i && !i.isIdentity(), d = s && this._canApplyMatrix || this._applyMatrix && (u || !l.isIdentity() || r && this._children);
          if (!u && !d)
            return this;
          if (u) {
            !i.isInvertible() && l.isInvertible() && (l._backup = l.getValues()), l.prepend(i, !0);
            var p = this._style, m = p.getFillColor(!0), y = p.getStrokeColor(!0);
            m && m.transform(i), y && y.transform(i);
          }
          if (d && (d = this._transformContent(
            l,
            r,
            s
          ))) {
            var S = this._pivot;
            S && l._transformPoint(S, S, !0), l.reset(!0), s && this._canApplyMatrix && (this._applyMatrix = !0);
          }
          var L = this._bounds, E = this._position;
          (u || d) && this._changed(25);
          var A = u && L && i.decompose();
          if (A && A.skewing.isZero() && A.rotation % 90 === 0) {
            for (var T in L) {
              var G = L[T];
              if (G.nonscaling)
                delete L[T];
              else if (d || !G.internal) {
                var O = G.rect;
                i._transformBounds(O, O);
              }
            }
            this._bounds = L;
            var Y = L[this._getBoundsCacheKey(
              this._boundsOptions || {}
            )];
            Y && (this._position = this._getPositionFromBounds(Y.rect));
          } else
            u && E && this._pivot && (this._position = i._transformPoint(E, E));
          return this;
        },
        _transformContent: function(i, r, s) {
          var l = this._children;
          if (l) {
            for (var u = 0, d = l.length; u < d; u++)
              l[u].transform(i, r, s);
            return !0;
          }
        },
        globalToLocal: function() {
          return this.getGlobalMatrix(!0)._inverseTransform(
            M.read(arguments)
          );
        },
        localToGlobal: function() {
          return this.getGlobalMatrix(!0)._transformPoint(
            M.read(arguments)
          );
        },
        parentToLocal: function() {
          return this._matrix._inverseTransform(M.read(arguments));
        },
        localToParent: function() {
          return this._matrix._transformPoint(M.read(arguments));
        },
        fitBounds: function(i, r) {
          i = D.read(arguments);
          var s = this.getBounds(), l = s.height / s.width, u = i.height / i.width, d = (r ? l > u : l < u) ? i.width / s.width : i.height / s.height, p = new D(
            new M(),
            new U(s.width * d, s.height * d)
          );
          p.setCenter(i.getCenter()), this.setBounds(p);
        }
      }),
      {
        _setStyles: function(i, r, s) {
          var l = this._style, u = this._matrix;
          if (l.hasFill() && (i.fillStyle = l.getFillColor().toCanvasStyle(i, u)), l.hasStroke()) {
            i.strokeStyle = l.getStrokeColor().toCanvasStyle(i, u), i.lineWidth = l.getStrokeWidth();
            var d = l.getStrokeJoin(), p = l.getStrokeCap(), m = l.getMiterLimit();
            if (d && (i.lineJoin = d), p && (i.lineCap = p), m && (i.miterLimit = m), Ve.support.nativeDash) {
              var y = l.getDashArray(), S = l.getDashOffset();
              y && y.length && ("setLineDash" in i ? (i.setLineDash(y), i.lineDashOffset = S) : (i.mozDash = y, i.mozDashOffset = S));
            }
          }
          if (l.hasShadow()) {
            var L = r.pixelRatio || 1, E = s._shiftless().prepend(
              new J().scale(L, L)
            ), A = E.transform(new M(l.getShadowBlur(), 0)), T = E.transform(this.getShadowOffset());
            i.shadowColor = l.getShadowColor().toCanvasStyle(i), i.shadowBlur = A.getLength(), i.shadowOffsetX = T.x, i.shadowOffsetY = T.y;
          }
        },
        draw: function(i, r, s) {
          if (this._updateVersion = this._project._updateVersion, !(!this._visible || this._opacity === 0)) {
            var l = r.matrices, u = r.viewMatrix, d = this._matrix, p = l[l.length - 1].appended(d);
            if (p.isInvertible()) {
              u = u ? u.appended(p) : p, l.push(p), r.updateMatrix && (this._globalMatrix = p);
              var m = this._blendMode, y = I.clamp(this._opacity, 0, 1), S = m === "normal", L = tt.nativeModes[m], E = S && y === 1 || r.dontStart || r.clip || (L || S && y < 1) && this._canComposite(), A = r.pixelRatio || 1, T, G, O;
              if (!E) {
                var Y = this.getStrokeBounds(u);
                if (!Y.width || !Y.height) {
                  l.pop();
                  return;
                }
                O = r.offset, G = r.offset = Y.getTopLeft().floor(), T = i, i = ft.getContext(Y.getSize().ceil().add(1).multiply(A)), A !== 1 && i.scale(A, A);
              }
              i.save();
              var B = s ? s.appended(d) : this._canScaleStroke && !this.getStrokeScaling(!0) && u, z = !E && r.clipItem, C = !B || z;
              if (E ? (i.globalAlpha = y, L && (i.globalCompositeOperation = m)) : C && i.translate(-G.x, -G.y), C && (E ? d : u).applyToContext(i), z && r.clipItem.draw(i, r.extend({ clip: !0 })), B) {
                i.setTransform(A, 0, 0, A, 0, 0);
                var N = r.offset;
                N && i.translate(-N.x, -N.y);
              }
              this._draw(i, r, u, B), i.restore(), l.pop(), r.clip && !r.dontFinish && i.clip(this.getFillRule()), E || (tt.process(
                m,
                i,
                T,
                y,
                G.subtract(O).multiply(A)
              ), ft.release(i), r.offset = O);
            }
          }
        },
        _isUpdated: function(i) {
          var r = this._parent;
          if (r instanceof It)
            return r._isUpdated(i);
          var s = this._updateVersion === i;
          return !s && r && r._visible && r._isUpdated(i) && (this._updateVersion = i, s = !0), s;
        },
        _drawSelection: function(i, r, s, l, u) {
          var d = this._selection, p = d & 1, m = d & 2 || p && this._selectBounds, y = d & 4;
          if (this._drawSelected || (p = !1), (p || m || y) && this._isUpdated(u)) {
            var S, L = this.getSelectedColor(!0) || (S = this.getLayer()) && S.getSelectedColor(!0), E = r.appended(this.getGlobalMatrix(!0)), A = s / 2;
            if (i.strokeStyle = i.fillStyle = L ? L.toCanvasStyle(i) : "#009dec", p && this._drawSelected(i, E, l), y) {
              var T = this.getPosition(!0), G = this._parent, O = G ? G.localToGlobal(T) : T, Y = O.x, B = O.y;
              i.beginPath(), i.arc(Y, B, A, 0, Math.PI * 2, !0), i.stroke();
              for (var z = [[0, -1], [1, 0], [0, 1], [-1, 0]], C = A, N = s + 1, j = 0; j < 4; j++) {
                var q = z[j], H = q[0], te = q[1];
                i.moveTo(Y + H * C, B + te * C), i.lineTo(Y + H * N, B + te * N), i.stroke();
              }
            }
            if (m) {
              var ae = E._transformCorners(this.getInternalBounds());
              i.beginPath();
              for (var j = 0; j < 8; j++)
                i[j ? "lineTo" : "moveTo"](ae[j], ae[++j]);
              i.closePath(), i.stroke();
              for (var j = 0; j < 8; j++)
                i.fillRect(
                  ae[j] - A,
                  ae[++j] - A,
                  s,
                  s
                );
            }
          }
        },
        _canComposite: function() {
          return !1;
        }
      },
      o.each(["down", "drag", "up", "move"], function(i) {
        this["removeOn" + o.capitalize(i)] = function() {
          var r = {};
          return r[i] = !0, this.removeOn(r);
        };
      }, {
        removeOn: function(i) {
          for (var r in i)
            if (i[r]) {
              var s = "mouse" + r, l = this._project, u = l._removeSets = l._removeSets || {};
              u[s] = u[s] || {}, u[s][this._id] = this;
            }
          return this;
        }
      }),
      {
        tween: function(i, r, s) {
          s || (s = r, r = i, i = null, s || (s = r, r = null));
          var l = s && s.easing, u = s && s.start, d = s != null && (typeof s == "number" ? s : s.duration), p = new et(this, i, r, d, l, u);
          function m(y) {
            p._handleFrame(y.time * 1e3), p.running || this.off("frame", m);
          }
          return d && this.on("frame", m), p;
        },
        tweenTo: function(i, r) {
          return this.tween(null, i, r);
        },
        tweenFrom: function(i, r) {
          return this.tween(i, null, r);
        }
      }
    ), Z = X.extend({
      _class: "Group",
      _selectBounds: !1,
      _selectChildren: !0,
      _serializeFields: {
        children: []
      },
      initialize: function(r) {
        this._children = [], this._namedChildren = {}, this._initialize(r) || this.addChildren(Array.isArray(r) ? r : arguments);
      },
      _changed: function i(r) {
        i.base.call(this, r), r & 2050 && (this._clipItem = t);
      },
      _getClipItem: function() {
        var i = this._clipItem;
        if (i === t) {
          i = null;
          for (var r = this._children, s = 0, l = r.length; s < l; s++)
            if (r[s]._clipMask) {
              i = r[s];
              break;
            }
          this._clipItem = i;
        }
        return i;
      },
      isClipped: function() {
        return !!this._getClipItem();
      },
      setClipped: function(i) {
        var r = this.getFirstChild();
        r && r.setClipMask(i);
      },
      _getBounds: function i(r, s) {
        var l = this._getClipItem();
        return l ? l._getCachedBounds(
          l._matrix.prepended(r),
          o.set({}, s, { stroke: !1 })
        ) : i.base.call(this, r, s);
      },
      _hitTestChildren: function i(r, s, l) {
        var u = this._getClipItem();
        return (!u || u.contains(r)) && i.base.call(
          this,
          r,
          s,
          l,
          u
        );
      },
      _draw: function(i, r) {
        var s = r.clip, l = !s && this._getClipItem();
        r = r.extend({ clipItem: l, clip: !1 }), s ? (i.beginPath(), r.dontStart = r.dontFinish = !0) : l && l.draw(i, r.extend({ clip: !0 }));
        for (var u = this._children, d = 0, p = u.length; d < p; d++) {
          var m = u[d];
          m !== l && m.draw(i, r);
        }
      }
    }), qe = Z.extend({
      _class: "Layer",
      initialize: function() {
        Z.apply(this, arguments);
      },
      _getOwner: function() {
        return this._parent || this._index != null && this._project;
      },
      isInserted: function i() {
        return this._parent ? i.base.call(this) : this._index != null;
      },
      activate: function() {
        this._project._activeLayer = this;
      },
      _hitTestSelf: function() {
      }
    }), Oe = X.extend(
      {
        _class: "Shape",
        _applyMatrix: !1,
        _canApplyMatrix: !1,
        _canScaleStroke: !0,
        _serializeFields: {
          type: null,
          size: null,
          radius: null
        },
        initialize: function(r, s) {
          this._initialize(r, s);
        },
        _equals: function(i) {
          return this._type === i._type && this._size.equals(i._size) && o.equals(this._radius, i._radius);
        },
        copyContent: function(i) {
          this.setType(i._type), this.setSize(i._size), this.setRadius(i._radius);
        },
        getType: function() {
          return this._type;
        },
        setType: function(i) {
          this._type = i;
        },
        getShape: "#getType",
        setShape: "#setType",
        getSize: function() {
          var i = this._size;
          return new Q(i.width, i.height, this, "setSize");
        },
        setSize: function() {
          var i = U.read(arguments);
          if (!this._size)
            this._size = i.clone();
          else if (!this._size.equals(i)) {
            var r = this._type, s = i.width, l = i.height;
            r === "rectangle" ? this._radius.set(U.min(this._radius, i.divide(2).abs())) : r === "circle" ? (s = l = (s + l) / 2, this._radius = s / 2) : r === "ellipse" && this._radius._set(s / 2, l / 2), this._size._set(s, l), this._changed(9);
          }
        },
        getRadius: function() {
          var i = this._radius;
          return this._type === "circle" ? i : new Q(i.width, i.height, this, "setRadius");
        },
        setRadius: function(i) {
          var r = this._type;
          if (r === "circle") {
            if (i === this._radius)
              return;
            var s = i * 2;
            this._radius = i, this._size._set(s, s);
          } else if (i = U.read(arguments), !this._radius)
            this._radius = i.clone();
          else {
            if (this._radius.equals(i))
              return;
            if (this._radius.set(i), r === "rectangle") {
              var s = U.max(this._size, i.multiply(2));
              this._size.set(s);
            } else
              r === "ellipse" && this._size._set(i.width * 2, i.height * 2);
          }
          this._changed(9);
        },
        isEmpty: function() {
          return !1;
        },
        toPath: function(i) {
          var r = new $e[o.capitalize(this._type)]({
            center: new M(),
            size: this._size,
            radius: this._radius,
            insert: !1
          });
          return r.copyAttributes(this), Ve.settings.applyMatrix && r.setApplyMatrix(!0), (i === t || i) && r.insertAbove(this), r;
        },
        toShape: "#clone",
        _asPathItem: function() {
          return this.toPath(!1);
        },
        _draw: function(i, r, s, l) {
          var u = this._style, d = u.hasFill(), p = u.hasStroke(), m = r.dontFinish || r.clip, y = !l;
          if (d || p || m) {
            var S = this._type, L = this._radius, E = S === "circle";
            if (r.dontStart || i.beginPath(), y && E)
              i.arc(0, 0, L, 0, Math.PI * 2, !0);
            else {
              var A = E ? L : L.width, T = E ? L : L.height, G = this._size, O = G.width, Y = G.height;
              if (y && S === "rectangle" && A === 0 && T === 0)
                i.rect(-O / 2, -Y / 2, O, Y);
              else {
                var B = O / 2, z = Y / 2, C = 1 - 0.5522847498307936, N = A * C, j = T * C, q = [
                  -B,
                  -z + T,
                  -B,
                  -z + j,
                  -B + N,
                  -z,
                  -B + A,
                  -z,
                  B - A,
                  -z,
                  B - N,
                  -z,
                  B,
                  -z + j,
                  B,
                  -z + T,
                  B,
                  z - T,
                  B,
                  z - j,
                  B - N,
                  z,
                  B - A,
                  z,
                  -B + A,
                  z,
                  -B + N,
                  z,
                  -B,
                  z - j,
                  -B,
                  z - T
                ];
                l && l.transform(q, q, 32), i.moveTo(q[0], q[1]), i.bezierCurveTo(q[2], q[3], q[4], q[5], q[6], q[7]), B !== A && i.lineTo(q[8], q[9]), i.bezierCurveTo(q[10], q[11], q[12], q[13], q[14], q[15]), z !== T && i.lineTo(q[16], q[17]), i.bezierCurveTo(q[18], q[19], q[20], q[21], q[22], q[23]), B !== A && i.lineTo(q[24], q[25]), i.bezierCurveTo(q[26], q[27], q[28], q[29], q[30], q[31]);
              }
            }
            i.closePath();
          }
          !m && (d || p) && (this._setStyles(i, r, s), d && (i.fill(u.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), p && i.stroke());
        },
        _canComposite: function() {
          return !(this.hasFill() && this.hasStroke());
        },
        _getBounds: function(i, r) {
          var s = new D(this._size).setCenter(0, 0), l = this._style, u = r.stroke && l.hasStroke() && l.getStrokeWidth();
          return i && (s = i._transformBounds(s)), u ? s.expand($e._getStrokePadding(
            u,
            this._getStrokeMatrix(i, r)
          )) : s;
        }
      },
      new function() {
        function i(s, l, u) {
          var d = s._radius;
          if (!d.isZero())
            for (var p = s._size.divide(2), m = 1; m <= 4; m++) {
              var y = new M(m > 1 && m < 4 ? -1 : 1, m > 2 ? -1 : 1), S = y.multiply(p), L = S.subtract(y.multiply(d)), E = new D(
                u ? S.add(y.multiply(u)) : S,
                L
              );
              if (E.contains(l))
                return { point: L, quadrant: m };
            }
        }
        function r(s, l, u, d) {
          var p = s.divide(l);
          return (!d || p.isInQuadrant(d)) && p.subtract(p.normalize()).multiply(l).divide(u).length <= 1;
        }
        return {
          _contains: function s(l) {
            if (this._type === "rectangle") {
              var u = i(this, l);
              return u ? l.subtract(u.point).divide(this._radius).getLength() <= 1 : s.base.call(this, l);
            } else
              return l.divide(this.size).getLength() <= 0.5;
          },
          _hitTestSelf: function s(l, u, d, p) {
            var m = !1, y = this._style, S = u.stroke && y.hasStroke(), L = u.fill && y.hasFill();
            if (S || L) {
              var E = this._type, A = this._radius, T = S ? y.getStrokeWidth() / 2 : 0, G = u._tolerancePadding.add(
                $e._getStrokePadding(
                  T,
                  !y.getStrokeScaling() && p
                )
              );
              if (E === "rectangle") {
                var O = G.multiply(2), Y = i(this, l, O);
                if (Y)
                  m = r(
                    l.subtract(Y.point),
                    A,
                    G,
                    Y.quadrant
                  );
                else {
                  var B = new D(this._size).setCenter(0, 0), z = B.expand(O), C = B.expand(O.negate());
                  m = z._containsPoint(l) && !C._containsPoint(l);
                }
              } else
                m = r(l, A, G);
            }
            return m ? new Ze(S ? "stroke" : "fill", this) : s.base.apply(this, arguments);
          }
        };
      }(),
      {
        statics: new function() {
          function i(r, s, l, u, d) {
            var p = o.create(Oe.prototype);
            return p._type = r, p._size = l, p._radius = u, p._initialize(o.getNamed(d), s), p;
          }
          return {
            Circle: function() {
              var r = arguments, s = M.readNamed(r, "center"), l = o.readNamed(r, "radius");
              return i(
                "circle",
                s,
                new U(l * 2),
                l,
                r
              );
            },
            Rectangle: function() {
              var r = arguments, s = D.readNamed(r, "rectangle"), l = U.min(
                U.readNamed(r, "radius"),
                s.getSize(!0).divide(2)
              );
              return i(
                "rectangle",
                s.getCenter(!0),
                s.getSize(!0),
                l,
                r
              );
            },
            Ellipse: function() {
              var r = arguments, s = Oe._readEllipse(r), l = s.radius;
              return i(
                "ellipse",
                s.center,
                l.multiply(2),
                l,
                r
              );
            },
            _readEllipse: function(r) {
              var s, l;
              if (o.hasNamed(r, "radius"))
                s = M.readNamed(r, "center"), l = U.readNamed(r, "radius");
              else {
                var u = D.readNamed(r, "rectangle");
                s = u.getCenter(!0), l = u.getSize(!0).divide(2);
              }
              return { center: s, radius: l };
            }
          };
        }()
      }
    ), je = X.extend({
      _class: "Raster",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _boundsOptions: { stroke: !1, handle: !1 },
      _serializeFields: {
        crossOrigin: null,
        source: null
      },
      _prioritize: ["crossOrigin"],
      _smoothing: "low",
      beans: !0,
      initialize: function(r, s) {
        if (!this._initialize(
          r,
          s !== t && M.read(arguments)
        )) {
          var l, u = typeof r, d = u === "string" ? a.getElementById(r) : u === "object" ? r : null;
          if (d && d !== X.NO_INSERT) {
            if (d.getContext || d.naturalHeight != null)
              l = d;
            else if (d) {
              var p = U.read(arguments);
              p.isZero() || (l = ft.getCanvas(p));
            }
          }
          l ? this.setImage(l) : this.setSource(r);
        }
        this._size || (this._size = new U(), this._loaded = !1);
      },
      _equals: function(i) {
        return this.getSource() === i.getSource();
      },
      copyContent: function(i) {
        var r = i._image, s = i._canvas;
        if (r)
          this._setImage(r);
        else if (s) {
          var l = ft.getCanvas(i._size);
          l.getContext("2d").drawImage(s, 0, 0), this._setImage(l);
        }
        this._crossOrigin = i._crossOrigin;
      },
      getSize: function() {
        var i = this._size;
        return new Q(
          i ? i.width : 0,
          i ? i.height : 0,
          this,
          "setSize"
        );
      },
      setSize: function(i, r) {
        var s = U.read(arguments);
        if (s.equals(this._size))
          r && this.clear();
        else if (s.width > 0 && s.height > 0) {
          var l = !r && this.getElement();
          this._setImage(ft.getCanvas(s)), l && this.getContext(!0).drawImage(
            l,
            0,
            0,
            s.width,
            s.height
          );
        } else
          this._canvas && ft.release(this._canvas), this._size = s.clone();
      },
      getWidth: function() {
        return this._size ? this._size.width : 0;
      },
      setWidth: function(i) {
        this.setSize(i, this.getHeight());
      },
      getHeight: function() {
        return this._size ? this._size.height : 0;
      },
      setHeight: function(i) {
        this.setSize(this.getWidth(), i);
      },
      getLoaded: function() {
        return this._loaded;
      },
      isEmpty: function() {
        var i = this._size;
        return !i || i.width === 0 && i.height === 0;
      },
      getResolution: function() {
        var i = this._matrix, r = new M(0, 0).transform(i), s = new M(1, 0).transform(i).subtract(r), l = new M(0, 1).transform(i).subtract(r);
        return new U(
          72 / s.getLength(),
          72 / l.getLength()
        );
      },
      getPpi: "#getResolution",
      getImage: function() {
        return this._image;
      },
      setImage: function(i) {
        var r = this;
        function s(l) {
          var u = r.getView(), d = l && l.type || "load";
          u && r.responds(d) && (Ve = u._scope, r.emit(d, new Gi(l)));
        }
        this._setImage(i), this._loaded ? setTimeout(s, 0) : i && Jt.add(i, {
          load: function(l) {
            r._setImage(i), s(l);
          },
          error: s
        });
      },
      _setImage: function(i) {
        this._canvas && ft.release(this._canvas), i && i.getContext ? (this._image = null, this._canvas = i, this._loaded = !0) : (this._image = i, this._canvas = null, this._loaded = !!(i && i.src && i.complete)), this._size = new U(
          i ? i.naturalWidth || i.width : 0,
          i ? i.naturalHeight || i.height : 0
        ), this._context = null, this._changed(1033);
      },
      getCanvas: function() {
        if (!this._canvas) {
          var i = ft.getContext(this._size);
          try {
            this._image && i.drawImage(this._image, 0, 0), this._canvas = i.canvas;
          } catch {
            ft.release(i);
          }
        }
        return this._canvas;
      },
      setCanvas: "#setImage",
      getContext: function(i) {
        return this._context || (this._context = this.getCanvas().getContext("2d")), i && (this._image = null, this._changed(1025)), this._context;
      },
      setContext: function(i) {
        this._context = i;
      },
      getSource: function() {
        var i = this._image;
        return i && i.src || this.toDataURL();
      },
      setSource: function(i) {
        var r = new e.Image(), s = this._crossOrigin;
        s && (r.crossOrigin = s), i && (r.src = i), this.setImage(r);
      },
      getCrossOrigin: function() {
        var i = this._image;
        return i && i.crossOrigin || this._crossOrigin || "";
      },
      setCrossOrigin: function(i) {
        this._crossOrigin = i;
        var r = this._image;
        r && (r.crossOrigin = i);
      },
      getSmoothing: function() {
        return this._smoothing;
      },
      setSmoothing: function(i) {
        this._smoothing = typeof i == "string" ? i : i ? "low" : "off", this._changed(257);
      },
      getElement: function() {
        return this._canvas || this._loaded && this._image;
      }
    }, {
      beans: !1,
      getSubCanvas: function() {
        var i = D.read(arguments), r = ft.getContext(i.getSize());
        return r.drawImage(
          this.getCanvas(),
          i.x,
          i.y,
          i.width,
          i.height,
          0,
          0,
          i.width,
          i.height
        ), r.canvas;
      },
      getSubRaster: function() {
        var i = D.read(arguments), r = new je(X.NO_INSERT);
        return r._setImage(this.getSubCanvas(i)), r.translate(i.getCenter().subtract(this.getSize().divide(2))), r._matrix.prepend(this._matrix), r.insertAbove(this), r;
      },
      toDataURL: function() {
        var i = this._image, r = i && i.src;
        if (/^data:/.test(r))
          return r;
        var s = this.getCanvas();
        return s ? s.toDataURL.apply(s, arguments) : null;
      },
      drawImage: function(i) {
        var r = M.read(arguments, 1);
        this.getContext(!0).drawImage(i, r.x, r.y);
      },
      getAverageColor: function(i) {
        var r, s;
        if (i ? i instanceof Gt ? (s = i, r = i.getBounds()) : typeof i == "object" && ("width" in i ? r = new D(i) : "x" in i && (r = new D(i.x - 0.5, i.y - 0.5, 1, 1))) : r = this.getBounds(), !r)
          return null;
        var l = 32, u = Math.min(r.width, l), d = Math.min(r.height, l), p = je._sampleContext;
        p ? p.clearRect(0, 0, l + 1, l + 1) : p = je._sampleContext = ft.getContext(
          new U(l)
        ), p.save();
        var m = new J().scale(u / r.width, d / r.height).translate(-r.x, -r.y);
        m.applyToContext(p), s && s.draw(p, new o({ clip: !0, matrices: [m] })), this._matrix.applyToContext(p);
        var y = this.getElement(), S = this._size;
        y && p.drawImage(y, -S.width / 2, -S.height / 2), p.restore();
        for (var L = p.getImageData(
          0.5,
          0.5,
          Math.ceil(u),
          Math.ceil(d)
        ).data, E = [0, 0, 0], A = 0, T = 0, G = L.length; T < G; T += 4) {
          var O = L[T + 3];
          A += O, O /= 255, E[0] += L[T] * O, E[1] += L[T + 1] * O, E[2] += L[T + 2] * O;
        }
        for (var T = 0; T < 3; T++)
          E[T] /= A;
        return A ? Tt.read(E) : null;
      },
      getPixel: function() {
        var i = M.read(arguments), r = this.getContext().getImageData(i.x, i.y, 1, 1).data;
        return new Tt(
          "rgb",
          [r[0] / 255, r[1] / 255, r[2] / 255],
          r[3] / 255
        );
      },
      setPixel: function() {
        var i = arguments, r = M.read(i), s = Tt.read(i), l = s._convert("rgb"), u = s._alpha, d = this.getContext(!0), p = d.createImageData(1, 1), m = p.data;
        m[0] = l[0] * 255, m[1] = l[1] * 255, m[2] = l[2] * 255, m[3] = u != null ? u * 255 : 255, d.putImageData(p, r.x, r.y);
      },
      clear: function() {
        var i = this._size;
        this.getContext(!0).clearRect(0, 0, i.width + 1, i.height + 1);
      },
      createImageData: function() {
        var i = U.read(arguments);
        return this.getContext().createImageData(i.width, i.height);
      },
      getImageData: function() {
        var i = D.read(arguments);
        return i.isEmpty() && (i = new D(this._size)), this.getContext().getImageData(
          i.x,
          i.y,
          i.width,
          i.height
        );
      },
      putImageData: function(i) {
        var r = M.read(arguments, 1);
        this.getContext(!0).putImageData(i, r.x, r.y);
      },
      setImageData: function(i) {
        this.setSize(i), this.getContext(!0).putImageData(i, 0, 0);
      },
      _getBounds: function(i, r) {
        var s = new D(this._size).setCenter(0, 0);
        return i ? i._transformBounds(s) : s;
      },
      _hitTestSelf: function(i) {
        if (this._contains(i)) {
          var r = this;
          return new Ze("pixel", r, {
            offset: i.add(r._size.divide(2)).round(),
            color: {
              get: function() {
                return r.getPixel(this.offset);
              }
            }
          });
        }
      },
      _draw: function(i, r, s) {
        var l = this.getElement();
        if (l && l.width > 0 && l.height > 0) {
          i.globalAlpha = I.clamp(this._opacity, 0, 1), this._setStyles(i, r, s);
          var u = this._smoothing, d = u === "off";
          Zt.setPrefixed(
            i,
            d ? "imageSmoothingEnabled" : "imageSmoothingQuality",
            d ? !1 : u
          ), i.drawImage(
            l,
            -this._size.width / 2,
            -this._size.height / 2
          );
        }
      },
      _canComposite: function() {
        return !0;
      }
    }), pt = X.extend({
      _class: "SymbolItem",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _boundsOptions: { stroke: !0 },
      _serializeFields: {
        symbol: null
      },
      initialize: function(r, s) {
        this._initialize(
          r,
          s !== t && M.read(arguments, 1)
        ) || this.setDefinition(r instanceof Te ? r : new Te(r));
      },
      _equals: function(i) {
        return this._definition === i._definition;
      },
      copyContent: function(i) {
        this.setDefinition(i._definition);
      },
      getDefinition: function() {
        return this._definition;
      },
      setDefinition: function(i) {
        this._definition = i, this._changed(9);
      },
      getSymbol: "#getDefinition",
      setSymbol: "#setDefinition",
      isEmpty: function() {
        return this._definition._item.isEmpty();
      },
      _getBounds: function(i, r) {
        var s = this._definition._item;
        return s._getCachedBounds(s._matrix.prepended(i), r);
      },
      _hitTestSelf: function(i, r, s) {
        var l = r.extend({ all: !1 }), u = this._definition._item._hitTest(i, l, s);
        return u && (u.item = this), u;
      },
      _draw: function(i, r) {
        this._definition._item.draw(i, r);
      }
    }), Te = o.extend({
      _class: "SymbolDefinition",
      initialize: function(r, s) {
        this._id = V.get(), this.project = Ve.project, r && this.setItem(r, s);
      },
      _serialize: function(i, r) {
        return r.add(this, function() {
          return o.serialize(
            [this._class, this._item],
            i,
            !1,
            r
          );
        });
      },
      _changed: function(i) {
        i & 8 && X._clearBoundsCache(this), i & 1 && this.project._changed(i);
      },
      getItem: function() {
        return this._item;
      },
      setItem: function(i, r) {
        i._symbol && (i = i.clone()), this._item && (this._item._symbol = null), this._item = i, i.remove(), i.setSelected(!1), r || i.setPosition(new M()), i._symbol = this, this._changed(9);
      },
      getDefinition: "#getItem",
      setDefinition: "#setItem",
      place: function(i) {
        return new pt(this, i);
      },
      clone: function() {
        return new Te(this._item.clone(!1));
      },
      equals: function(i) {
        return i === this || i && this._item.equals(i._item) || !1;
      }
    }), Ze = o.extend({
      _class: "HitResult",
      initialize: function(r, s, l) {
        this.type = r, this.item = s, l && this.inject(l);
      },
      statics: {
        getOptions: function(i) {
          var r = i && o.read(i);
          return new o({
            type: null,
            tolerance: Ve.settings.hitTolerance,
            fill: !r,
            stroke: !r,
            segments: !r,
            handles: !1,
            ends: !1,
            position: !1,
            center: !1,
            bounds: !1,
            guides: !1,
            selected: !1
          }, r);
        }
      }
    }), ce = o.extend({
      _class: "Segment",
      beans: !0,
      _selection: 0,
      initialize: function(r, s, l, u, d, p) {
        var m = arguments.length, y, S, L, E;
        m > 0 && (r == null || typeof r == "object" ? m === 1 && r && "point" in r ? (y = r.point, S = r.handleIn, L = r.handleOut, E = r.selection) : (y = r, S = s, L = l, E = u) : (y = [r, s], S = l !== t ? [l, u] : null, L = d !== t ? [d, p] : null)), new ut(y, this, "_point"), new ut(S, this, "_handleIn"), new ut(L, this, "_handleOut"), E && this.setSelection(E);
      },
      _serialize: function(i, r) {
        var s = this._point, l = this._selection, u = l || this.hasHandles() ? [s, this._handleIn, this._handleOut] : s;
        return l && u.push(l), o.serialize(u, i, !0, r);
      },
      _changed: function(i) {
        var r = this._path;
        if (r) {
          var s = r._curves, l = this._index, u;
          s && ((!i || i === this._point || i === this._handleIn) && (u = l > 0 ? s[l - 1] : r._closed ? s[s.length - 1] : null) && u._changed(), (!i || i === this._point || i === this._handleOut) && (u = s[l]) && u._changed()), r._changed(41);
        }
      },
      getPoint: function() {
        return this._point;
      },
      setPoint: function() {
        this._point.set(M.read(arguments));
      },
      getHandleIn: function() {
        return this._handleIn;
      },
      setHandleIn: function() {
        this._handleIn.set(M.read(arguments));
      },
      getHandleOut: function() {
        return this._handleOut;
      },
      setHandleOut: function() {
        this._handleOut.set(M.read(arguments));
      },
      hasHandles: function() {
        return !this._handleIn.isZero() || !this._handleOut.isZero();
      },
      isSmooth: function() {
        var i = this._handleIn, r = this._handleOut;
        return !i.isZero() && !r.isZero() && i.isCollinear(r);
      },
      clearHandles: function() {
        this._handleIn._set(0, 0), this._handleOut._set(0, 0);
      },
      getSelection: function() {
        return this._selection;
      },
      setSelection: function(i) {
        var r = this._selection, s = this._path;
        this._selection = i = i || 0, s && i !== r && (s._updateSelection(this, r, i), s._changed(257));
      },
      _changeSelection: function(i, r) {
        var s = this._selection;
        this.setSelection(r ? s | i : s & ~i);
      },
      isSelected: function() {
        return !!(this._selection & 7);
      },
      setSelected: function(i) {
        this._changeSelection(7, i);
      },
      getIndex: function() {
        return this._index !== t ? this._index : null;
      },
      getPath: function() {
        return this._path || null;
      },
      getCurve: function() {
        var i = this._path, r = this._index;
        return i ? (r > 0 && !i._closed && r === i._segments.length - 1 && r--, i.getCurves()[r] || null) : null;
      },
      getLocation: function() {
        var i = this.getCurve();
        return i ? new ht(i, this === i._segment1 ? 0 : 1) : null;
      },
      getNext: function() {
        var i = this._path && this._path._segments;
        return i && (i[this._index + 1] || this._path._closed && i[0]) || null;
      },
      smooth: function(i, r, s) {
        var l = i || {}, u = l.type, d = l.factor, p = this.getPrevious(), m = this.getNext(), y = (p || this)._point, S = this._point, L = (m || this)._point, E = y.getDistance(S), A = S.getDistance(L);
        if (!u || u === "catmull-rom") {
          var T = d === t ? 0.5 : d, G = Math.pow(E, T), O = G * G, Y = Math.pow(A, T), B = Y * Y;
          if (!r && p) {
            var z = 2 * B + 3 * Y * G + O, C = 3 * Y * (Y + G);
            this.setHandleIn(C !== 0 ? new M(
              (B * y._x + z * S._x - O * L._x) / C - S._x,
              (B * y._y + z * S._y - O * L._y) / C - S._y
            ) : new M());
          }
          if (!s && m) {
            var z = 2 * O + 3 * G * Y + B, C = 3 * G * (G + Y);
            this.setHandleOut(C !== 0 ? new M(
              (O * L._x + z * S._x - B * y._x) / C - S._x,
              (O * L._y + z * S._y - B * y._y) / C - S._y
            ) : new M());
          }
        } else if (u === "geometric") {
          if (p && m) {
            var N = y.subtract(L), j = d === t ? 0.4 : d, q = j * E / (E + A);
            r || this.setHandleIn(N.multiply(q)), s || this.setHandleOut(N.multiply(q - j));
          }
        } else
          throw new Error("Smoothing method '" + u + "' not supported.");
      },
      getPrevious: function() {
        var i = this._path && this._path._segments;
        return i && (i[this._index - 1] || this._path._closed && i[i.length - 1]) || null;
      },
      isFirst: function() {
        return !this._index;
      },
      isLast: function() {
        var i = this._path;
        return i && this._index === i._segments.length - 1 || !1;
      },
      reverse: function() {
        var i = this._handleIn, r = this._handleOut, s = i.clone();
        i.set(r), r.set(s);
      },
      reversed: function() {
        return new ce(this._point, this._handleOut, this._handleIn);
      },
      remove: function() {
        return this._path ? !!this._path.removeSegment(this._index) : !1;
      },
      clone: function() {
        return new ce(this._point, this._handleIn, this._handleOut);
      },
      equals: function(i) {
        return i === this || i && this._class === i._class && this._point.equals(i._point) && this._handleIn.equals(i._handleIn) && this._handleOut.equals(i._handleOut) || !1;
      },
      toString: function() {
        var i = ["point: " + this._point];
        return this._handleIn.isZero() || i.push("handleIn: " + this._handleIn), this._handleOut.isZero() || i.push("handleOut: " + this._handleOut), "{ " + i.join(", ") + " }";
      },
      transform: function(i) {
        this._transformCoordinates(i, new Array(6), !0), this._changed();
      },
      interpolate: function(i, r, s) {
        var l = 1 - s, u = s, d = i._point, p = r._point, m = i._handleIn, y = r._handleIn, S = r._handleOut, L = i._handleOut;
        this._point._set(
          l * d._x + u * p._x,
          l * d._y + u * p._y,
          !0
        ), this._handleIn._set(
          l * m._x + u * y._x,
          l * m._y + u * y._y,
          !0
        ), this._handleOut._set(
          l * L._x + u * S._x,
          l * L._y + u * S._y,
          !0
        ), this._changed();
      },
      _transformCoordinates: function(i, r, s) {
        var l = this._point, u = !s || !this._handleIn.isZero() ? this._handleIn : null, d = !s || !this._handleOut.isZero() ? this._handleOut : null, p = l._x, m = l._y, y = 2;
        return r[0] = p, r[1] = m, u && (r[y++] = u._x + p, r[y++] = u._y + m), d && (r[y++] = d._x + p, r[y++] = d._y + m), i && (i._transformCoordinates(r, r, y / 2), p = r[0], m = r[1], s ? (l._x = p, l._y = m, y = 2, u && (u._x = r[y++] - p, u._y = r[y++] - m), d && (d._x = r[y++] - p, d._y = r[y++] - m)) : (u || (r[y++] = p, r[y++] = m), d || (r[y++] = p, r[y++] = m))), r;
      }
    }), ut = M.extend({
      initialize: function(r, s, l) {
        var u, d, p;
        if (!r)
          u = d = 0;
        else if ((u = r[0]) !== t)
          d = r[1];
        else {
          var m = r;
          (u = m.x) === t && (m = M.read(arguments), u = m.x), d = m.y, p = m.selected;
        }
        this._x = u, this._y = d, this._owner = s, s[l] = this, p && this.setSelected(!0);
      },
      _set: function(i, r) {
        return this._x = i, this._y = r, this._owner._changed(this), this;
      },
      getX: function() {
        return this._x;
      },
      setX: function(i) {
        this._x = i, this._owner._changed(this);
      },
      getY: function() {
        return this._y;
      },
      setY: function(i) {
        this._y = i, this._owner._changed(this);
      },
      isZero: function() {
        var i = I.isZero;
        return i(this._x) && i(this._y);
      },
      isSelected: function() {
        return !!(this._owner._selection & this._getSelection());
      },
      setSelected: function(i) {
        this._owner._changeSelection(this._getSelection(), i);
      },
      _getSelection: function() {
        var i = this._owner;
        return this === i._point ? 1 : this === i._handleIn ? 2 : this === i._handleOut ? 4 : 0;
      }
    }), ze = o.extend(
      {
        _class: "Curve",
        beans: !0,
        initialize: function(r, s, l, u, d, p, m, y) {
          var S = arguments.length, L, E, A, T, G, O;
          S === 3 ? (this._path = r, L = s, E = l) : S ? S === 1 ? "segment1" in r ? (L = new ce(r.segment1), E = new ce(r.segment2)) : "point1" in r ? (A = r.point1, G = r.handle1, O = r.handle2, T = r.point2) : Array.isArray(r) && (A = [r[0], r[1]], T = [r[6], r[7]], G = [r[2] - r[0], r[3] - r[1]], O = [r[4] - r[6], r[5] - r[7]]) : S === 2 ? (L = new ce(r), E = new ce(s)) : S === 4 ? (A = r, G = s, O = l, T = u) : S === 8 && (A = [r, s], T = [m, y], G = [l - r, u - s], O = [d - m, p - y]) : (L = new ce(), E = new ce()), this._segment1 = L || new ce(A, null, G), this._segment2 = E || new ce(T, O, null);
        },
        _serialize: function(i, r) {
          return o.serialize(
            this.hasHandles() ? [
              this.getPoint1(),
              this.getHandle1(),
              this.getHandle2(),
              this.getPoint2()
            ] : [this.getPoint1(), this.getPoint2()],
            i,
            !0,
            r
          );
        },
        _changed: function() {
          this._length = this._bounds = t;
        },
        clone: function() {
          return new ze(this._segment1, this._segment2);
        },
        toString: function() {
          var i = ["point1: " + this._segment1._point];
          return this._segment1._handleOut.isZero() || i.push("handle1: " + this._segment1._handleOut), this._segment2._handleIn.isZero() || i.push("handle2: " + this._segment2._handleIn), i.push("point2: " + this._segment2._point), "{ " + i.join(", ") + " }";
        },
        classify: function() {
          return ze.classify(this.getValues());
        },
        remove: function() {
          var i = !1;
          if (this._path) {
            var r = this._segment2, s = r._handleOut;
            i = r.remove(), i && this._segment1._handleOut.set(s);
          }
          return i;
        },
        getPoint1: function() {
          return this._segment1._point;
        },
        setPoint1: function() {
          this._segment1._point.set(M.read(arguments));
        },
        getPoint2: function() {
          return this._segment2._point;
        },
        setPoint2: function() {
          this._segment2._point.set(M.read(arguments));
        },
        getHandle1: function() {
          return this._segment1._handleOut;
        },
        setHandle1: function() {
          this._segment1._handleOut.set(M.read(arguments));
        },
        getHandle2: function() {
          return this._segment2._handleIn;
        },
        setHandle2: function() {
          this._segment2._handleIn.set(M.read(arguments));
        },
        getSegment1: function() {
          return this._segment1;
        },
        getSegment2: function() {
          return this._segment2;
        },
        getPath: function() {
          return this._path;
        },
        getIndex: function() {
          return this._segment1._index;
        },
        getNext: function() {
          var i = this._path && this._path._curves;
          return i && (i[this._segment1._index + 1] || this._path._closed && i[0]) || null;
        },
        getPrevious: function() {
          var i = this._path && this._path._curves;
          return i && (i[this._segment1._index - 1] || this._path._closed && i[i.length - 1]) || null;
        },
        isFirst: function() {
          return !this._segment1._index;
        },
        isLast: function() {
          var i = this._path;
          return i && this._segment1._index === i._curves.length - 1 || !1;
        },
        isSelected: function() {
          return this.getPoint1().isSelected() && this.getHandle1().isSelected() && this.getHandle2().isSelected() && this.getPoint2().isSelected();
        },
        setSelected: function(i) {
          this.getPoint1().setSelected(i), this.getHandle1().setSelected(i), this.getHandle2().setSelected(i), this.getPoint2().setSelected(i);
        },
        getValues: function(i) {
          return ze.getValues(this._segment1, this._segment2, i);
        },
        getPoints: function() {
          for (var i = this.getValues(), r = [], s = 0; s < 8; s += 2)
            r.push(new M(i[s], i[s + 1]));
          return r;
        }
      },
      {
        getLength: function() {
          return this._length == null && (this._length = ze.getLength(this.getValues(), 0, 1)), this._length;
        },
        getArea: function() {
          return ze.getArea(this.getValues());
        },
        getLine: function() {
          return new he(this._segment1._point, this._segment2._point);
        },
        getPart: function(i, r) {
          return new ze(ze.getPart(this.getValues(), i, r));
        },
        getPartLength: function(i, r) {
          return ze.getLength(this.getValues(), i, r);
        },
        divideAt: function(i) {
          return this.divideAtTime(i && i.curve === this ? i.time : this.getTimeAt(i));
        },
        divideAtTime: function(i, r) {
          var s = 1e-8, l = 1 - s, u = null;
          if (i >= s && i <= l) {
            var d = ze.subdivide(this.getValues(), i), p = d[0], m = d[1], y = r || this.hasHandles(), S = this._segment1, L = this._segment2, E = this._path;
            y && (S._handleOut._set(p[2] - p[0], p[3] - p[1]), L._handleIn._set(m[4] - m[6], m[5] - m[7]));
            var A = p[6], T = p[7], G = new ce(
              new M(A, T),
              y && new M(p[4] - A, p[5] - T),
              y && new M(m[2] - A, m[3] - T)
            );
            E ? (E.insert(S._index + 1, G), u = this.getNext()) : (this._segment2 = G, this._changed(), u = new ze(G, L));
          }
          return u;
        },
        splitAt: function(i) {
          var r = this._path;
          return r ? r.splitAt(i) : null;
        },
        splitAtTime: function(i) {
          return this.splitAt(this.getLocationAtTime(i));
        },
        divide: function(i, r) {
          return this.divideAtTime(i === t ? 0.5 : r ? i : this.getTimeAt(i));
        },
        split: function(i, r) {
          return this.splitAtTime(i === t ? 0.5 : r ? i : this.getTimeAt(i));
        },
        reversed: function() {
          return new ze(this._segment2.reversed(), this._segment1.reversed());
        },
        clearHandles: function() {
          this._segment1._handleOut._set(0, 0), this._segment2._handleIn._set(0, 0);
        },
        statics: {
          getValues: function(i, r, s, l) {
            var u = i._point, d = i._handleOut, p = r._handleIn, m = r._point, y = u.x, S = u.y, L = m.x, E = m.y, A = l ? [y, S, y, S, L, E, L, E] : [
              y,
              S,
              y + d._x,
              S + d._y,
              L + p._x,
              E + p._y,
              L,
              E
            ];
            return s && s._transformCoordinates(A, A, 4), A;
          },
          subdivide: function(i, r) {
            var s = i[0], l = i[1], u = i[2], d = i[3], p = i[4], m = i[5], y = i[6], S = i[7];
            r === t && (r = 0.5);
            var L = 1 - r, E = L * s + r * u, A = L * l + r * d, T = L * u + r * p, G = L * d + r * m, O = L * p + r * y, Y = L * m + r * S, B = L * E + r * T, z = L * A + r * G, C = L * T + r * O, N = L * G + r * Y, j = L * B + r * C, q = L * z + r * N;
            return [
              [s, l, E, A, B, z, j, q],
              [j, q, C, N, O, Y, y, S]
            ];
          },
          getMonoCurves: function(i, r) {
            var s = [], l = r ? 0 : 1, u = i[l + 0], d = i[l + 2], p = i[l + 4], m = i[l + 6];
            if (u >= d == d >= p && d >= p == p >= m || ze.isStraight(i))
              s.push(i);
            else {
              var y = 3 * (d - p) - u + m, S = 2 * (u + p) - 4 * d, L = d - u, E = 1e-8, A = 1 - E, T = [], G = I.solveQuadratic(y, S, L, T, E, A);
              if (!G)
                s.push(i);
              else {
                T.sort();
                var O = T[0], Y = ze.subdivide(i, O);
                s.push(Y[0]), G > 1 && (O = (T[1] - O) / (1 - O), Y = ze.subdivide(Y[1], O), s.push(Y[0])), s.push(Y[1]);
              }
            }
            return s;
          },
          solveCubic: function(i, r, s, l, u, d) {
            var p = i[r], m = i[r + 2], y = i[r + 4], S = i[r + 6], L = 0;
            if (!(p < s && S < s && m < s && y < s || p > s && S > s && m > s && y > s)) {
              var E = 3 * (m - p), A = 3 * (y - m) - E, T = S - p - E - A;
              L = I.solveCubic(T, A, E, p - s, l, u, d);
            }
            return L;
          },
          getTimeOf: function(i, r) {
            var s = new M(i[0], i[1]), l = new M(i[6], i[7]), u = 1e-12, d = 1e-7, p = r.isClose(s, u) ? 0 : r.isClose(l, u) ? 1 : null;
            if (p === null)
              for (var m = [r.x, r.y], y = [], S = 0; S < 2; S++)
                for (var L = ze.solveCubic(i, S, m[S], y, 0, 1), E = 0; E < L; E++) {
                  var A = y[E];
                  if (r.isClose(ze.getPoint(i, A), d))
                    return A;
                }
            return r.isClose(s, d) ? 0 : r.isClose(l, d) ? 1 : null;
          },
          getNearestTime: function(i, r) {
            if (ze.isStraight(i)) {
              var s = i[0], l = i[1], u = i[6], d = i[7], p = u - s, m = d - l, y = p * p + m * m;
              if (y === 0)
                return 0;
              var S = ((r.x - s) * p + (r.y - l) * m) / y;
              return S < 1e-12 ? 0 : S > 0.999999999999 ? 1 : ze.getTimeOf(
                i,
                new M(s + S * p, l + S * m)
              );
            }
            var L = 100, E = 1 / 0, A = 0;
            function T(Y) {
              if (Y >= 0 && Y <= 1) {
                var B = r.getDistance(ze.getPoint(i, Y), !0);
                if (B < E)
                  return E = B, A = Y, !0;
              }
            }
            for (var G = 0; G <= L; G++)
              T(G / L);
            for (var O = 1 / (L * 2); O > 1e-8; )
              !T(A - O) && !T(A + O) && (O /= 2);
            return A;
          },
          getPart: function(i, r, s) {
            var l = r > s;
            if (l) {
              var u = r;
              r = s, s = u;
            }
            return r > 0 && (i = ze.subdivide(i, r)[1]), s < 1 && (i = ze.subdivide(i, (s - r) / (1 - r))[0]), l ? [i[6], i[7], i[4], i[5], i[2], i[3], i[0], i[1]] : i;
          },
          isFlatEnough: function(i, r) {
            var s = i[0], l = i[1], u = i[2], d = i[3], p = i[4], m = i[5], y = i[6], S = i[7], L = 3 * u - 2 * s - y, E = 3 * d - 2 * l - S, A = 3 * p - 2 * y - s, T = 3 * m - 2 * S - l;
            return Math.max(L * L, A * A) + Math.max(E * E, T * T) <= 16 * r * r;
          },
          getArea: function(i) {
            var r = i[0], s = i[1], l = i[2], u = i[3], d = i[4], p = i[5], m = i[6], y = i[7];
            return 3 * ((y - s) * (l + d) - (m - r) * (u + p) + u * (r - d) - l * (s - p) + y * (d + r / 3) - m * (p + s / 3)) / 20;
          },
          getBounds: function(i) {
            for (var r = i.slice(0, 2), s = r.slice(), l = [0, 0], u = 0; u < 2; u++)
              ze._addBounds(
                i[u],
                i[u + 2],
                i[u + 4],
                i[u + 6],
                u,
                0,
                r,
                s,
                l
              );
            return new D(r[0], r[1], s[0] - r[0], s[1] - r[1]);
          },
          _addBounds: function(i, r, s, l, u, d, p, m, y) {
            function S(j, q) {
              var H = j - q, te = j + q;
              H < p[u] && (p[u] = H), te > m[u] && (m[u] = te);
            }
            d /= 2;
            var L = p[u] + d, E = m[u] - d;
            if (i < L || r < L || s < L || l < L || i > E || r > E || s > E || l > E)
              if (r < i != r < l && s < i != s < l)
                S(i, 0), S(l, 0);
              else {
                var A = 3 * (r - s) - i + l, T = 2 * (i + s) - 4 * r, G = r - i, O = I.solveQuadratic(A, T, G, y), Y = 1e-8, B = 1 - Y;
                S(l, 0);
                for (var z = 0; z < O; z++) {
                  var C = y[z], N = 1 - C;
                  Y <= C && C <= B && S(
                    N * N * N * i + 3 * N * N * C * r + 3 * N * C * C * s + C * C * C * l,
                    d
                  );
                }
              }
          }
        }
      },
      o.each(
        ["getBounds", "getStrokeBounds", "getHandleBounds"],
        function(i) {
          this[i] = function() {
            this._bounds || (this._bounds = {});
            var r = this._bounds[i];
            return r || (r = this._bounds[i] = $e[i](
              [this._segment1, this._segment2],
              !1,
              this._path
            )), r.clone();
          };
        },
        {}
      ),
      o.each({
        isStraight: function(i, r, s, l) {
          if (r.isZero() && s.isZero())
            return !0;
          var u = l.subtract(i);
          if (u.isZero())
            return !1;
          if (u.isCollinear(r) && u.isCollinear(s)) {
            var d = new he(i, l), p = 1e-7;
            if (d.getDistance(i.add(r)) < p && d.getDistance(l.add(s)) < p) {
              var m = u.dot(u), y = u.dot(r) / m, S = u.dot(s) / m;
              return y >= 0 && y <= 1 && S <= 0 && S >= -1;
            }
          }
          return !1;
        },
        isLinear: function(i, r, s, l) {
          var u = l.subtract(i).divide(3);
          return r.equals(u) && s.negate().equals(u);
        }
      }, function(i, r) {
        this[r] = function(s) {
          var l = this._segment1, u = this._segment2;
          return i(
            l._point,
            l._handleOut,
            u._handleIn,
            u._point,
            s
          );
        }, this.statics[r] = function(s, l) {
          var u = s[0], d = s[1], p = s[6], m = s[7];
          return i(
            new M(u, d),
            new M(s[2] - u, s[3] - d),
            new M(s[4] - p, s[5] - m),
            new M(p, m),
            l
          );
        };
      }, {
        statics: {},
        hasHandles: function() {
          return !this._segment1._handleOut.isZero() || !this._segment2._handleIn.isZero();
        },
        hasLength: function(i) {
          return (!this.getPoint1().equals(this.getPoint2()) || this.hasHandles()) && this.getLength() > (i || 0);
        },
        isCollinear: function(i) {
          return i && this.isStraight() && i.isStraight() && this.getLine().isCollinear(i.getLine());
        },
        isHorizontal: function() {
          return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).y) < 1e-8;
        },
        isVertical: function() {
          return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).x) < 1e-8;
        }
      }),
      {
        beans: !1,
        getLocationAt: function(i, r) {
          return this.getLocationAtTime(
            r ? i : this.getTimeAt(i)
          );
        },
        getLocationAtTime: function(i) {
          return i != null && i >= 0 && i <= 1 ? new ht(this, i) : null;
        },
        getTimeAt: function(i, r) {
          return ze.getTimeAt(this.getValues(), i, r);
        },
        getParameterAt: "#getTimeAt",
        getTimesWithTangent: function() {
          var i = M.read(arguments);
          return i.isZero() ? [] : ze.getTimesWithTangent(this.getValues(), i);
        },
        getOffsetAtTime: function(i) {
          return this.getPartLength(0, i);
        },
        getLocationOf: function() {
          return this.getLocationAtTime(this.getTimeOf(M.read(arguments)));
        },
        getOffsetOf: function() {
          var i = this.getLocationOf.apply(this, arguments);
          return i ? i.getOffset() : null;
        },
        getTimeOf: function() {
          return ze.getTimeOf(this.getValues(), M.read(arguments));
        },
        getParameterOf: "#getTimeOf",
        getNearestLocation: function() {
          var i = M.read(arguments), r = this.getValues(), s = ze.getNearestTime(r, i), l = ze.getPoint(r, s);
          return new ht(this, s, l, null, i.getDistance(l));
        },
        getNearestPoint: function() {
          var i = this.getNearestLocation.apply(this, arguments);
          return i && i.getPoint();
        }
      },
      new function() {
        var i = [
          "getPoint",
          "getTangent",
          "getNormal",
          "getWeightedTangent",
          "getWeightedNormal",
          "getCurvature"
        ];
        return o.each(
          i,
          function(r) {
            this[r + "At"] = function(s, l) {
              var u = this.getValues();
              return ze[r](u, l ? s : ze.getTimeAt(u, s));
            }, this[r + "AtTime"] = function(s) {
              return ze[r](this.getValues(), s);
            };
          },
          {
            statics: {
              _evaluateMethods: i
            }
          }
        );
      }(),
      new function() {
        function i(l) {
          var u = l[0], d = l[1], p = l[2], m = l[3], y = l[4], S = l[5], L = l[6], E = l[7], A = 9 * (p - y) + 3 * (L - u), T = 6 * (u + y) - 12 * p, G = 3 * (p - u), O = 9 * (m - S) + 3 * (E - d), Y = 6 * (d + S) - 12 * m, B = 3 * (m - d);
          return function(z) {
            var C = (A * z + T) * z + G, N = (O * z + Y) * z + B;
            return Math.sqrt(C * C + N * N);
          };
        }
        function r(l, u) {
          return Math.max(2, Math.min(16, Math.ceil(Math.abs(u - l) * 32)));
        }
        function s(l, u, d, p) {
          if (u == null || u < 0 || u > 1)
            return null;
          var m = l[0], y = l[1], S = l[2], L = l[3], E = l[4], A = l[5], T = l[6], G = l[7], O = I.isZero;
          O(S - m) && O(L - y) && (S = m, L = y), O(E - T) && O(A - G) && (E = T, A = G);
          var Y = 3 * (S - m), B = 3 * (E - S) - Y, z = T - m - Y - B, C = 3 * (L - y), N = 3 * (A - L) - C, j = G - y - C - N, q, H;
          if (d === 0)
            q = u === 0 ? m : u === 1 ? T : ((z * u + B) * u + Y) * u + m, H = u === 0 ? y : u === 1 ? G : ((j * u + N) * u + C) * u + y;
          else {
            var te = 1e-8, ae = 1 - te;
            if (u < te ? (q = Y, H = C) : u > ae ? (q = 3 * (T - E), H = 3 * (G - A)) : (q = (3 * z * u + 2 * B) * u + Y, H = (3 * j * u + 2 * N) * u + C), p) {
              q === 0 && H === 0 && (u < te || u > ae) && (q = E - S, H = A - L);
              var le = Math.sqrt(q * q + H * H);
              le && (q /= le, H /= le);
            }
            if (d === 3) {
              var E = 6 * z * u + 2 * B, A = 6 * j * u + 2 * N, me = Math.pow(q * q + H * H, 3 / 2);
              q = me !== 0 ? (q * A - H * E) / me : 0, H = 0;
            }
          }
          return d === 2 ? new M(H, -q) : new M(q, H);
        }
        return { statics: {
          classify: function(l) {
            var u = l[0], d = l[1], p = l[2], m = l[3], y = l[4], S = l[5], L = l[6], E = l[7], A = u * (E - S) + d * (y - L) + L * S - E * y, T = p * (d - E) + m * (L - u) + u * E - d * L, G = y * (m - d) + S * (u - p) + p * d - m * u, O = 3 * G, Y = O - T, B = Y - T + A, z = Math.sqrt(B * B + Y * Y + O * O), C = z !== 0 ? 1 / z : 0, N = I.isZero, j = "serpentine";
            B *= C, Y *= C, O *= C;
            function q(le, me, se) {
              var de = me !== t, ve = de && me > 0 && me < 1, we = de && se > 0 && se < 1;
              return de && (!(ve || we) || le === "loop" && !(ve && we)) && (le = "arch", ve = we = !1), {
                type: le,
                roots: ve || we ? ve && we ? me < se ? [me, se] : [se, me] : [ve ? me : se] : null
              };
            }
            if (N(B))
              return N(Y) ? q(N(O) ? "line" : "quadratic") : q(j, O / (3 * Y));
            var H = 3 * Y * Y - 4 * B * O;
            if (N(H))
              return q("cusp", Y / (2 * B));
            var te = H > 0 ? Math.sqrt(H / 3) : Math.sqrt(-H), ae = 2 * B;
            return q(
              H > 0 ? j : "loop",
              (Y + te) / ae,
              (Y - te) / ae
            );
          },
          getLength: function(l, u, d, p) {
            if (u === t && (u = 0), d === t && (d = 1), ze.isStraight(l)) {
              var m = l;
              d < 1 && (m = ze.subdivide(m, d)[0], u /= d), u > 0 && (m = ze.subdivide(m, u)[1]);
              var y = m[6] - m[0], S = m[7] - m[1];
              return Math.sqrt(y * y + S * S);
            }
            return I.integrate(
              p || i(l),
              u,
              d,
              r(u, d)
            );
          },
          getTimeAt: function(l, u, d) {
            if (d === t && (d = u < 0 ? 1 : 0), u === 0)
              return d;
            var p = Math.abs, m = 1e-12, y = u > 0, S = y ? d : 0, L = y ? 1 : d, E = i(l), A = ze.getLength(l, S, L, E), T = p(u) - A;
            if (p(T) < m)
              return y ? L : S;
            if (T > m)
              return null;
            var G = u / A, O = 0;
            function Y(B) {
              return O += I.integrate(
                E,
                d,
                B,
                r(d, B)
              ), d = B, O - u;
            }
            return I.findRoot(
              Y,
              E,
              d + G,
              S,
              L,
              32,
              1e-12
            );
          },
          getPoint: function(l, u) {
            return s(l, u, 0, !1);
          },
          getTangent: function(l, u) {
            return s(l, u, 1, !0);
          },
          getWeightedTangent: function(l, u) {
            return s(l, u, 1, !1);
          },
          getNormal: function(l, u) {
            return s(l, u, 2, !0);
          },
          getWeightedNormal: function(l, u) {
            return s(l, u, 2, !1);
          },
          getCurvature: function(l, u) {
            return s(l, u, 3, !1).x;
          },
          getPeaks: function(l) {
            var u = l[0], d = l[1], p = l[2], m = l[3], y = l[4], S = l[5], L = l[6], E = l[7], A = -u + 3 * p - 3 * y + L, T = 3 * u - 6 * p + 3 * y, G = -3 * u + 3 * p, O = -d + 3 * m - 3 * S + E, Y = 3 * d - 6 * m + 3 * S, B = -3 * d + 3 * m, z = 1e-8, C = 1 - z, N = [];
            return I.solveCubic(
              9 * (A * A + O * O),
              9 * (A * T + Y * O),
              2 * (T * T + Y * Y) + 3 * (G * A + B * O),
              G * T + Y * B,
              N,
              z,
              C
            ), N.sort();
          }
        } };
      }(),
      new function() {
        function i(T, G, O, Y, B, z, C) {
          var N = !C && O.getPrevious() === B, j = !C && O !== B && O.getNext() === B, q = 1e-8, H = 1 - q;
          if (Y !== null && Y >= (N ? q : 0) && Y <= (j ? H : 1) && z !== null && z >= (j ? q : 0) && z <= (N ? H : 1)) {
            var te = new ht(O, Y, null, C), ae = new ht(B, z, null, C);
            te._intersection = ae, ae._intersection = te, (!G || G(te)) && ht.insert(T, te, !0);
          }
        }
        function r(T, G, O, Y, B, z, C, N, j, q, H, te, ae) {
          if (++j >= 4096 || ++N >= 40)
            return j;
          var le = 1e-9, me = G[0], se = G[1], de = G[6], ve = G[7], we = he.getSignedDistance, Se = we(me, se, de, ve, G[2], G[3]), Ae = we(me, se, de, ve, G[4], G[5]), Ge = Se * Ae > 0 ? 3 / 4 : 4 / 9, Qe = Ge * Math.min(0, Se, Ae), st = Ge * Math.max(0, Se, Ae), mt = we(me, se, de, ve, T[0], T[1]), Re = we(me, se, de, ve, T[2], T[3]), Fe = we(me, se, de, ve, T[4], T[5]), at = we(me, se, de, ve, T[6], T[7]), yt = s(mt, Re, Fe, at), bt = yt[0], Rt = yt[1], Pt, zt;
          if (Se === 0 && Ae === 0 && mt === 0 && Re === 0 && Fe === 0 && at === 0 || (Pt = l(bt, Rt, Qe, st)) == null || (zt = l(
            bt.reverse(),
            Rt.reverse(),
            Qe,
            st
          )) == null)
            return j;
          var Wt = q + (H - q) * Pt, Ft = q + (H - q) * zt;
          if (Math.max(ae - te, Ft - Wt) < le) {
            var Mi = (Wt + Ft) / 2, yi = (te + ae) / 2;
            i(
              B,
              z,
              C ? Y : O,
              C ? yi : Mi,
              C ? O : Y,
              C ? Mi : yi
            );
          } else {
            T = ze.getPart(T, Pt, zt);
            var Ai = ae - te;
            if (zt - Pt > 0.8)
              if (Ft - Wt > Ai) {
                var pi = ze.subdivide(T, 0.5), Mi = (Wt + Ft) / 2;
                j = r(
                  G,
                  pi[0],
                  Y,
                  O,
                  B,
                  z,
                  !C,
                  N,
                  j,
                  te,
                  ae,
                  Wt,
                  Mi
                ), j = r(
                  G,
                  pi[1],
                  Y,
                  O,
                  B,
                  z,
                  !C,
                  N,
                  j,
                  te,
                  ae,
                  Mi,
                  Ft
                );
              } else {
                var pi = ze.subdivide(G, 0.5), yi = (te + ae) / 2;
                j = r(
                  pi[0],
                  T,
                  Y,
                  O,
                  B,
                  z,
                  !C,
                  N,
                  j,
                  te,
                  yi,
                  Wt,
                  Ft
                ), j = r(
                  pi[1],
                  T,
                  Y,
                  O,
                  B,
                  z,
                  !C,
                  N,
                  j,
                  yi,
                  ae,
                  Wt,
                  Ft
                );
              }
            else
              Ai === 0 || Ai >= le ? j = r(
                G,
                T,
                Y,
                O,
                B,
                z,
                !C,
                N,
                j,
                te,
                ae,
                Wt,
                Ft
              ) : j = r(
                T,
                G,
                O,
                Y,
                B,
                z,
                C,
                N,
                j,
                Wt,
                Ft,
                te,
                ae
              );
          }
          return j;
        }
        function s(T, G, O, Y) {
          var B = [0, T], z = [1 / 3, G], C = [2 / 3, O], N = [1, Y], j = G - (2 * T + Y) / 3, q = O - (T + 2 * Y) / 3, H;
          if (j * q < 0)
            H = [[B, z, N], [B, C, N]];
          else {
            var te = j / q;
            H = [
              te >= 2 ? [B, z, N] : te <= 0.5 ? [B, C, N] : [B, z, C, N],
              [B, N]
            ];
          }
          return (j || q) < 0 ? H.reverse() : H;
        }
        function l(T, G, O, Y) {
          return T[0][1] < O ? u(T, !0, O) : G[0][1] > Y ? u(G, !1, Y) : T[0][0];
        }
        function u(T, G, O) {
          for (var Y = T[0][0], B = T[0][1], z = 1, C = T.length; z < C; z++) {
            var N = T[z][0], j = T[z][1];
            if (G ? j >= O : j <= O)
              return j === O ? N : Y + (O - B) * (N - Y) / (j - B);
            Y = N, B = j;
          }
          return null;
        }
        function d(T, G, O, Y, B) {
          var z = I.isZero;
          if (z(Y) && z(B)) {
            var C = ze.getTimeOf(T, new M(G, O));
            return C === null ? [] : [C];
          }
          for (var N = Math.atan2(-B, Y), j = Math.sin(N), q = Math.cos(N), H = [], te = [], ae = 0; ae < 8; ae += 2) {
            var le = T[ae] - G, me = T[ae + 1] - O;
            H.push(
              le * q - me * j,
              le * j + me * q
            );
          }
          return ze.solveCubic(H, 1, 0, te, 0, 1), te;
        }
        function p(T, G, O, Y, B, z, C) {
          for (var N = G[0], j = G[1], q = G[6], H = G[7], te = d(T, N, j, q - N, H - j), ae = 0, le = te.length; ae < le; ae++) {
            var me = te[ae], se = ze.getPoint(T, me), de = ze.getTimeOf(G, se);
            de !== null && i(
              B,
              z,
              C ? Y : O,
              C ? de : me,
              C ? O : Y,
              C ? me : de
            );
          }
        }
        function m(T, G, O, Y, B, z) {
          var C = he.intersect(
            T[0],
            T[1],
            T[6],
            T[7],
            G[0],
            G[1],
            G[6],
            G[7]
          );
          C && i(
            B,
            z,
            O,
            ze.getTimeOf(T, C),
            Y,
            ze.getTimeOf(G, C)
          );
        }
        function y(T, G, O, Y, B, z) {
          var C = 1e-12, N = Math.min, j = Math.max;
          if (j(T[0], T[2], T[4], T[6]) + C > N(G[0], G[2], G[4], G[6]) && N(T[0], T[2], T[4], T[6]) - C < j(G[0], G[2], G[4], G[6]) && j(T[1], T[3], T[5], T[7]) + C > N(G[1], G[3], G[5], G[7]) && N(T[1], T[3], T[5], T[7]) - C < j(G[1], G[3], G[5], G[7])) {
            var q = E(T, G);
            if (q)
              for (var H = 0; H < 2; H++) {
                var te = q[H];
                i(
                  B,
                  z,
                  O,
                  te[0],
                  Y,
                  te[1],
                  !0
                );
              }
            else {
              var ae = ze.isStraight(T), le = ze.isStraight(G), me = ae && le, se = ae && !le, de = B.length;
              if ((me ? m : ae || le ? p : r)(
                se ? G : T,
                se ? T : G,
                se ? Y : O,
                se ? O : Y,
                B,
                z,
                se,
                0,
                0,
                0,
                1,
                0,
                1
              ), !me || B.length === de)
                for (var H = 0; H < 4; H++) {
                  var ve = H >> 1, we = H & 1, Se = ve * 6, Ae = we * 6, Ge = new M(T[Se], T[Se + 1]), Qe = new M(G[Ae], G[Ae + 1]);
                  Ge.isClose(Qe, C) && i(
                    B,
                    z,
                    O,
                    ve,
                    Y,
                    we
                  );
                }
            }
          }
          return B;
        }
        function S(T, G, O, Y) {
          var B = ze.classify(T);
          if (B.type === "loop") {
            var z = B.roots;
            i(
              O,
              Y,
              G,
              z[0],
              G,
              z[1]
            );
          }
          return O;
        }
        function L(T, G, O, Y, B, z) {
          var C = 1e-7, N = !G;
          N && (G = T);
          for (var j = T.length, q = G.length, H = new Array(j), te = N ? H : new Array(q), ae = [], le = 0; le < j; le++)
            H[le] = T[le].getValues(Y);
          if (!N)
            for (var le = 0; le < q; le++)
              te[le] = G[le].getValues(B);
          for (var me = x.findCurveBoundsCollisions(
            H,
            te,
            C
          ), se = 0; se < j; se++) {
            var de = T[se], ve = H[se];
            N && S(ve, de, ae, O);
            var we = me[se];
            if (we)
              for (var Se = 0; Se < we.length; Se++) {
                if (z && ae.length)
                  return ae;
                var Ae = we[Se];
                if (!N || Ae > se) {
                  var Ge = G[Ae], Qe = te[Ae];
                  y(
                    ve,
                    Qe,
                    de,
                    Ge,
                    ae,
                    O
                  );
                }
              }
          }
          return ae;
        }
        function E(T, G) {
          function O(at) {
            var yt = at[6] - at[0], bt = at[7] - at[1];
            return yt * yt + bt * bt;
          }
          var Y = Math.abs, B = he.getDistance, z = 1e-8, C = 1e-7, N = ze.isStraight(T), j = ze.isStraight(G), q = N && j, H = O(T) < O(G), te = H ? G : T, ae = H ? T : G, le = te[0], me = te[1], se = te[6] - le, de = te[7] - me;
          if (B(le, me, se, de, ae[0], ae[1], !0) < C && B(le, me, se, de, ae[6], ae[7], !0) < C)
            !q && B(le, me, se, de, te[2], te[3], !0) < C && B(le, me, se, de, te[4], te[5], !0) < C && B(le, me, se, de, ae[2], ae[3], !0) < C && B(le, me, se, de, ae[4], ae[5], !0) < C && (N = j = q = !0);
          else if (q)
            return null;
          if (N ^ j)
            return null;
          for (var ve = [T, G], we = [], Se = 0; Se < 4 && we.length < 2; Se++) {
            var Ae = Se & 1, Ge = Ae ^ 1, Qe = Se >> 1, st = ze.getTimeOf(ve[Ae], new M(
              ve[Ge][Qe ? 6 : 0],
              ve[Ge][Qe ? 7 : 1]
            ));
            if (st != null) {
              var mt = Ae ? [Qe, st] : [st, Qe];
              (!we.length || Y(mt[0] - we[0][0]) > z && Y(mt[1] - we[0][1]) > z) && we.push(mt);
            }
            if (Se > 2 && !we.length)
              break;
          }
          if (we.length !== 2)
            we = null;
          else if (!q) {
            var Re = ze.getPart(T, we[0][0], we[1][0]), Fe = ze.getPart(G, we[0][1], we[1][1]);
            (Y(Fe[2] - Re[2]) > C || Y(Fe[3] - Re[3]) > C || Y(Fe[4] - Re[4]) > C || Y(Fe[5] - Re[5]) > C) && (we = null);
          }
          return we;
        }
        function A(T, G) {
          var O = T[0], Y = T[1], B = T[2], z = T[3], C = T[4], N = T[5], j = T[6], q = T[7], H = G.normalize(), te = H.x, ae = H.y, le = 3 * j - 9 * C + 9 * B - 3 * O, me = 3 * q - 9 * N + 9 * z - 3 * Y, se = 6 * C - 12 * B + 6 * O, de = 6 * N - 12 * z + 6 * Y, ve = 3 * B - 3 * O, we = 3 * z - 3 * Y, Se = 2 * le * ae - 2 * me * te, Ae = [];
          if (Math.abs(Se) < I.CURVETIME_EPSILON) {
            var Ge = le * we - me * ve, Se = le * de - me * se;
            if (Se != 0) {
              var Qe = -Ge / Se;
              Qe >= 0 && Qe <= 1 && Ae.push(Qe);
            }
          } else {
            var st = (se * se - 4 * le * ve) * ae * ae + (-2 * se * de + 4 * me * ve + 4 * le * we) * te * ae + (de * de - 4 * me * we) * te * te, mt = se * ae - de * te;
            if (st >= 0 && Se != 0) {
              var Re = Math.sqrt(st), Fe = -(mt + Re) / Se, at = (-mt + Re) / Se;
              Fe >= 0 && Fe <= 1 && Ae.push(Fe), at >= 0 && at <= 1 && Ae.push(at);
            }
          }
          return Ae;
        }
        return {
          getIntersections: function(T) {
            var G = this.getValues(), O = T && T !== this && T.getValues();
            return O ? y(G, O, this, T, []) : S(G, this, []);
          },
          statics: {
            getOverlaps: E,
            getIntersections: L,
            getCurveLineIntersections: d,
            getTimesWithTangent: A
          }
        };
      }()
    ), ht = o.extend(
      {
        _class: "CurveLocation",
        initialize: function(r, s, l, u, d) {
          if (s >= 0.99999999) {
            var p = r.getNext();
            p && (s = 0, r = p);
          }
          this._setCurve(r), this._time = s, this._point = l || r.getPointAtTime(s), this._overlap = u, this._distance = d, this._intersection = this._next = this._previous = null;
        },
        _setPath: function(i) {
          this._path = i, this._version = i ? i._version : 0;
        },
        _setCurve: function(i) {
          this._setPath(i._path), this._curve = i, this._segment = null, this._segment1 = i._segment1, this._segment2 = i._segment2;
        },
        _setSegment: function(i) {
          var r = i.getCurve();
          r ? this._setCurve(r) : (this._setPath(i._path), this._segment1 = i, this._segment2 = null), this._segment = i, this._time = i === this._segment1 ? 0 : 1, this._point = i._point.clone();
        },
        getSegment: function() {
          var i = this._segment;
          if (!i) {
            var r = this.getCurve(), s = this.getTime();
            s === 0 ? i = r._segment1 : s === 1 ? i = r._segment2 : s != null && (i = r.getPartLength(0, s) < r.getPartLength(s, 1) ? r._segment1 : r._segment2), this._segment = i;
          }
          return i;
        },
        getCurve: function() {
          var i = this._path, r = this;
          i && i._version !== this._version && (this._time = this._offset = this._curveOffset = this._curve = null);
          function s(l) {
            var u = l && l.getCurve();
            if (u && (r._time = u.getTimeOf(r._point)) != null)
              return r._setCurve(u), u;
          }
          return this._curve || s(this._segment) || s(this._segment1) || s(this._segment2.getPrevious());
        },
        getPath: function() {
          var i = this.getCurve();
          return i && i._path;
        },
        getIndex: function() {
          var i = this.getCurve();
          return i && i.getIndex();
        },
        getTime: function() {
          var i = this.getCurve(), r = this._time;
          return i && r == null ? this._time = i.getTimeOf(this._point) : r;
        },
        getParameter: "#getTime",
        getPoint: function() {
          return this._point;
        },
        getOffset: function() {
          var i = this._offset;
          if (i == null) {
            i = 0;
            var r = this.getPath(), s = this.getIndex();
            if (r && s != null)
              for (var l = r.getCurves(), u = 0; u < s; u++)
                i += l[u].getLength();
            this._offset = i += this.getCurveOffset();
          }
          return i;
        },
        getCurveOffset: function() {
          var i = this._curveOffset;
          if (i == null) {
            var r = this.getCurve(), s = this.getTime();
            this._curveOffset = i = s != null && r && r.getPartLength(0, s);
          }
          return i;
        },
        getIntersection: function() {
          return this._intersection;
        },
        getDistance: function() {
          return this._distance;
        },
        divide: function() {
          var i = this.getCurve(), r = i && i.divideAtTime(this.getTime());
          return r && this._setSegment(r._segment1), r;
        },
        split: function() {
          var i = this.getCurve(), r = i._path, s = i && i.splitAtTime(this.getTime());
          return s && this._setSegment(r.getLastSegment()), s;
        },
        equals: function(i, r) {
          var s = this === i;
          if (!s && i instanceof ht) {
            var l = this.getCurve(), u = i.getCurve(), d = l._path, p = u._path;
            if (d === p) {
              var m = Math.abs, y = 1e-7, S = m(this.getOffset() - i.getOffset()), L = !r && this._intersection, E = !r && i._intersection;
              s = (S < y || d && m(d.getLength() - S) < y) && (!L && !E || L && E && L.equals(E, !0));
            }
          }
          return s;
        },
        toString: function() {
          var i = [], r = this.getPoint(), s = k.instance;
          r && i.push("point: " + r);
          var l = this.getIndex();
          l != null && i.push("index: " + l);
          var u = this.getTime();
          return u != null && i.push("time: " + s.number(u)), this._distance != null && i.push("distance: " + s.number(this._distance)), "{ " + i.join(", ") + " }";
        },
        isTouching: function() {
          var i = this._intersection;
          if (i && this.getTangent().isCollinear(i.getTangent())) {
            var r = this.getCurve(), s = i.getCurve();
            return !(r.isStraight() && s.isStraight() && r.getLine().intersect(s.getLine()));
          }
          return !1;
        },
        isCrossing: function() {
          var i = this._intersection;
          if (!i)
            return !1;
          var r = this.getTime(), s = i.getTime(), l = 1e-8, u = 1 - l, d = r >= l && r <= u, p = s >= l && s <= u;
          if (d && p)
            return !this.isTouching();
          var m = this.getCurve(), y = m && r < l ? m.getPrevious() : m, S = i.getCurve(), L = S && s < l ? S.getPrevious() : S;
          if (r > u && (m = m.getNext()), s > u && (S = S.getNext()), !y || !m || !L || !S)
            return !1;
          var E = [];
          function A(te, ae) {
            var le = te.getValues(), me = ze.classify(le).roots || ze.getPeaks(le), se = me.length, de = ze.getLength(
              le,
              ae && se ? me[se - 1] : 0,
              !ae && se ? me[0] : 1
            );
            E.push(se ? de : de / 32);
          }
          function T(te, ae, le) {
            return ae < le ? te > ae && te < le : te > ae || te < le;
          }
          d || (A(y, !0), A(m, !1)), p || (A(L, !0), A(S, !1));
          var G = this.getPoint(), O = Math.min.apply(Math, E), Y = d ? m.getTangentAtTime(r) : m.getPointAt(O).subtract(G), B = d ? Y.negate() : y.getPointAt(-O).subtract(G), z = p ? S.getTangentAtTime(s) : S.getPointAt(O).subtract(G), C = p ? z.negate() : L.getPointAt(-O).subtract(G), N = B.getAngle(), j = Y.getAngle(), q = C.getAngle(), H = z.getAngle();
          return !!(d ? T(N, q, H) ^ T(j, q, H) && T(N, H, q) ^ T(j, H, q) : T(q, N, j) ^ T(H, N, j) && T(q, j, N) ^ T(H, j, N));
        },
        hasOverlap: function() {
          return !!this._overlap;
        }
      },
      o.each(ze._evaluateMethods, function(i) {
        var r = i + "At";
        this[i] = function() {
          var s = this.getCurve(), l = this.getTime();
          return l != null && s && s[r](l, !0);
        };
      }, {
        preserve: !0
      }),
      new function() {
        function i(r, s, l) {
          var u = r.length, d = 0, p = u - 1;
          function m(G, O) {
            for (var Y = G + O; Y >= -1 && Y <= u; Y += O) {
              var B = r[(Y % u + u) % u];
              if (!s.getPoint().isClose(
                B.getPoint(),
                1e-7
              ))
                break;
              if (s.equals(B))
                return B;
            }
            return null;
          }
          for (; d <= p; ) {
            var y = d + p >>> 1, S = r[y], L;
            if (l && (L = s.equals(S) ? S : m(y, -1) || m(y, 1)))
              return s._overlap && (L._overlap = L._intersection._overlap = !0), L;
            var E = s.getPath(), A = S.getPath(), T = E !== A ? E._id - A._id : s.getIndex() + s.getTime() - (S.getIndex() + S.getTime());
            T < 0 ? p = y - 1 : d = y + 1;
          }
          return r.splice(d, 0, s), s;
        }
        return { statics: {
          insert: i,
          expand: function(r) {
            for (var s = r.slice(), l = r.length - 1; l >= 0; l--)
              i(s, r[l]._intersection, !1);
            return s;
          }
        } };
      }()
    ), Gt = X.extend({
      _class: "PathItem",
      _selectBounds: !1,
      _canScaleStroke: !0,
      beans: !0,
      initialize: function() {
      },
      statics: {
        create: function(i) {
          var r, s, l;
          if (o.isPlainObject(i) ? (s = i.segments, r = i.pathData) : Array.isArray(i) ? s = i : typeof i == "string" && (r = i), s) {
            var u = s[0];
            l = u && Array.isArray(u[0]);
          } else
            r && (l = (r.match(/m/gi) || []).length > 1 || /z\s*\S+/i.test(r));
          var d = l ? It : $e;
          return new d(i);
        }
      },
      _asPathItem: function() {
        return this;
      },
      isClockwise: function() {
        return this.getArea() >= 0;
      },
      setClockwise: function(i) {
        this.isClockwise() != (i = !!i) && this.reverse();
      },
      setPathData: function(i) {
        var r = i && i.match(/[mlhvcsqtaz][^mlhvcsqtaz]*/ig), s, l = !1, u, d, p = new M(), m = new M();
        function y(C, N) {
          var j = +s[C];
          return l && (j += p[N]), j;
        }
        function S(C) {
          return new M(
            y(C, "x"),
            y(C + 1, "y")
          );
        }
        this.clear();
        for (var L = 0, E = r && r.length; L < E; L++) {
          var A = r[L], T = A[0], G = T.toLowerCase();
          s = A.match(/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g);
          var O = s && s.length;
          switch (l = T === G, u === "z" && !/[mz]/.test(G) && this.moveTo(p), G) {
            case "m":
            case "l":
              for (var Y = G === "m", B = 0; B < O; B += 2)
                this[Y ? "moveTo" : "lineTo"](p = S(B)), Y && (m = p, Y = !1);
              d = p;
              break;
            case "h":
            case "v":
              var z = G === "h" ? "x" : "y";
              p = p.clone();
              for (var B = 0; B < O; B++)
                p[z] = y(B, z), this.lineTo(p);
              d = p;
              break;
            case "c":
              for (var B = 0; B < O; B += 6)
                this.cubicCurveTo(
                  S(B),
                  d = S(B + 2),
                  p = S(B + 4)
                );
              break;
            case "s":
              for (var B = 0; B < O; B += 4)
                this.cubicCurveTo(
                  /[cs]/.test(u) ? p.multiply(2).subtract(d) : p,
                  d = S(B),
                  p = S(B + 2)
                ), u = G;
              break;
            case "q":
              for (var B = 0; B < O; B += 4)
                this.quadraticCurveTo(
                  d = S(B),
                  p = S(B + 2)
                );
              break;
            case "t":
              for (var B = 0; B < O; B += 2)
                this.quadraticCurveTo(
                  d = /[qt]/.test(u) ? p.multiply(2).subtract(d) : p,
                  p = S(B)
                ), u = G;
              break;
            case "a":
              for (var B = 0; B < O; B += 7)
                this.arcTo(
                  p = S(B + 5),
                  new U(+s[B], +s[B + 1]),
                  +s[B + 2],
                  +s[B + 4],
                  +s[B + 3]
                );
              break;
            case "z":
              this.closePath(1e-12), p = m;
              break;
          }
          u = G;
        }
      },
      _canComposite: function() {
        return !(this.hasFill() && this.hasStroke());
      },
      _contains: function(i) {
        var r = i.isInside(
          this.getBounds({ internal: !0, handle: !0 })
        ) ? this._getWinding(i) : {};
        return r.onPath || !!(this.getFillRule() === "evenodd" ? r.windingL & 1 || r.windingR & 1 : r.winding);
      },
      getIntersections: function(i, r, s, l) {
        var u = this === i || !i, d = this._matrix._orNullIfIdentity(), p = u ? d : (s || i._matrix)._orNullIfIdentity();
        return u || this.getBounds(d).intersects(
          i.getBounds(p),
          1e-12
        ) ? ze.getIntersections(
          this.getCurves(),
          !u && i.getCurves(),
          r,
          d,
          p,
          l
        ) : [];
      },
      getCrossings: function(i) {
        return this.getIntersections(i, function(r) {
          return r.isCrossing();
        });
      },
      getNearestLocation: function() {
        for (var i = M.read(arguments), r = this.getCurves(), s = 1 / 0, l = null, u = 0, d = r.length; u < d; u++) {
          var p = r[u].getNearestLocation(i);
          p._distance < s && (s = p._distance, l = p);
        }
        return l;
      },
      getNearestPoint: function() {
        var i = this.getNearestLocation.apply(this, arguments);
        return i && i.getPoint();
      },
      interpolate: function(i, r, s) {
        var l = !this._children, u = l ? "_segments" : "_children", d = i[u], p = r[u], m = this[u];
        if (!d || !p || d.length !== p.length)
          throw new Error("Invalid operands in interpolate() call: " + i + ", " + r);
        var y = m.length, S = p.length;
        if (y < S)
          for (var L = l ? ce : $e, E = y; E < S; E++)
            this.add(new L());
        else
          y > S && this[l ? "removeSegments" : "removeChildren"](S, y);
        for (var E = 0; E < S; E++)
          m[E].interpolate(d[E], p[E], s);
        l && (this.setClosed(i._closed), this._changed(9));
      },
      compare: function(i) {
        var r = !1;
        if (i) {
          var s = this._children || [this], l = i._children ? i._children.slice() : [i], u = s.length, d = l.length, p = [], m = 0;
          r = !0;
          for (var y = x.findItemBoundsCollisions(s, l, I.GEOMETRIC_EPSILON), S = u - 1; S >= 0 && r; S--) {
            var L = s[S];
            r = !1;
            var E = y[S];
            if (E)
              for (var A = E.length - 1; A >= 0 && !r; A--)
                L.compare(l[E[A]]) && (p[E[A]] || (p[E[A]] = !0, m++), r = !0);
          }
          r = r && m === d;
        }
        return r;
      }
    }), $e = Gt.extend(
      {
        _class: "Path",
        _serializeFields: {
          segments: [],
          closed: !1
        },
        initialize: function(r) {
          this._closed = !1, this._segments = [], this._version = 0;
          var s = arguments, l = Array.isArray(r) ? typeof r[0] == "object" ? r : s : r && r.size === t && (r.x !== t || r.point !== t) ? s : null;
          l && l.length > 0 ? this.setSegments(l) : (this._curves = t, this._segmentSelection = 0, !l && typeof r == "string" && (this.setPathData(r), r = null)), this._initialize(!l && r);
        },
        _equals: function(i) {
          return this._closed === i._closed && o.equals(this._segments, i._segments);
        },
        copyContent: function(i) {
          this.setSegments(i._segments), this._closed = i._closed;
        },
        _changed: function i(r) {
          if (i.base.call(this, r), r & 8) {
            if (this._length = this._area = t, r & 32)
              this._version++;
            else if (this._curves)
              for (var s = 0, l = this._curves.length; s < l; s++)
                this._curves[s]._changed();
          } else
            r & 64 && (this._bounds = t);
        },
        getStyle: function() {
          var i = this._parent;
          return (i instanceof It ? i : this)._style;
        },
        getSegments: function() {
          return this._segments;
        },
        setSegments: function(i) {
          var r = this.isFullySelected(), s = i && i.length;
          if (this._segments.length = 0, this._segmentSelection = 0, this._curves = t, s) {
            var l = i[s - 1];
            typeof l == "boolean" && (this.setClosed(l), s--), this._add(ce.readList(i, 0, {}, s));
          }
          r && this.setFullySelected(!0);
        },
        getFirstSegment: function() {
          return this._segments[0];
        },
        getLastSegment: function() {
          return this._segments[this._segments.length - 1];
        },
        getCurves: function() {
          var i = this._curves, r = this._segments;
          if (!i) {
            var s = this._countCurves();
            i = this._curves = new Array(s);
            for (var l = 0; l < s; l++)
              i[l] = new ze(
                this,
                r[l],
                r[l + 1] || r[0]
              );
          }
          return i;
        },
        getFirstCurve: function() {
          return this.getCurves()[0];
        },
        getLastCurve: function() {
          var i = this.getCurves();
          return i[i.length - 1];
        },
        isClosed: function() {
          return this._closed;
        },
        setClosed: function(i) {
          if (this._closed != (i = !!i)) {
            if (this._closed = i, this._curves) {
              var r = this._curves.length = this._countCurves();
              i && (this._curves[r - 1] = new ze(
                this,
                this._segments[r - 1],
                this._segments[0]
              ));
            }
            this._changed(41);
          }
        }
      },
      {
        beans: !0,
        getPathData: function(i, r) {
          var s = this._segments, l = s.length, u = new k(r), d = new Array(6), p = !0, m, y, S, L, E, A, T, G, O = [];
          function Y(z, C) {
            if (z._transformCoordinates(i, d), m = d[0], y = d[1], p)
              O.push("M" + u.pair(m, y)), p = !1;
            else if (E = d[2], A = d[3], E === m && A === y && T === S && G === L) {
              if (!C) {
                var N = m - S, j = y - L;
                O.push(
                  N === 0 ? "v" + u.number(j) : j === 0 ? "h" + u.number(N) : "l" + u.pair(N, j)
                );
              }
            } else
              O.push("c" + u.pair(T - S, G - L) + " " + u.pair(E - S, A - L) + " " + u.pair(m - S, y - L));
            S = m, L = y, T = d[4], G = d[5];
          }
          if (!l)
            return "";
          for (var B = 0; B < l; B++)
            Y(s[B]);
          return this._closed && l > 0 && (Y(s[0], !0), O.push("z")), O.join("");
        },
        isEmpty: function() {
          return !this._segments.length;
        },
        _transformContent: function(i) {
          for (var r = this._segments, s = new Array(6), l = 0, u = r.length; l < u; l++)
            r[l]._transformCoordinates(i, s, !0);
          return !0;
        },
        _add: function(i, p) {
          for (var s = this._segments, l = this._curves, u = i.length, d = p == null, p = d ? s.length : p, m = 0; m < u; m++) {
            var y = i[m];
            y._path && (y = i[m] = y.clone()), y._path = this, y._index = p + m, y._selection && this._updateSelection(y, 0, y._selection);
          }
          if (d)
            o.push(s, i);
          else {
            s.splice.apply(s, [p, 0].concat(i));
            for (var m = p + u, S = s.length; m < S; m++)
              s[m]._index = m;
          }
          if (l) {
            var L = this._countCurves(), E = p > 0 && p + u - 1 === L ? p - 1 : p, A = E, T = Math.min(E + u, L);
            i._curves && (l.splice.apply(l, [E, 0].concat(i._curves)), A += i._curves.length);
            for (var m = A; m < T; m++)
              l.splice(m, 0, new ze(this, null, null));
            this._adjustCurves(E, T);
          }
          return this._changed(41), i;
        },
        _adjustCurves: function(i, r) {
          for (var s = this._segments, l = this._curves, u, d = i; d < r; d++)
            u = l[d], u._path = this, u._segment1 = s[d], u._segment2 = s[d + 1] || s[0], u._changed();
          (u = l[this._closed && !i ? s.length - 1 : i - 1]) && (u._segment2 = s[i] || s[0], u._changed()), (u = l[r]) && (u._segment1 = s[r], u._changed());
        },
        _countCurves: function() {
          var i = this._segments.length;
          return !this._closed && i > 0 ? i - 1 : i;
        },
        add: function(i) {
          var r = arguments;
          return r.length > 1 && typeof i != "number" ? this._add(ce.readList(r)) : this._add([ce.read(r)])[0];
        },
        insert: function(i, r) {
          var s = arguments;
          return s.length > 2 && typeof r != "number" ? this._add(ce.readList(s, 1), i) : this._add([ce.read(s, 1)], i)[0];
        },
        addSegment: function() {
          return this._add([ce.read(arguments)])[0];
        },
        insertSegment: function(i) {
          return this._add([ce.read(arguments, 1)], i)[0];
        },
        addSegments: function(i) {
          return this._add(ce.readList(i));
        },
        insertSegments: function(i, r) {
          return this._add(ce.readList(r), i);
        },
        removeSegment: function(i) {
          return this.removeSegments(i, i + 1)[0] || null;
        },
        removeSegments: function(i, r, s) {
          i = i || 0, r = o.pick(r, this._segments.length);
          var l = this._segments, u = this._curves, d = l.length, p = l.splice(i, r - i), m = p.length;
          if (!m)
            return p;
          for (var y = 0; y < m; y++) {
            var S = p[y];
            S._selection && this._updateSelection(S, S._selection, 0), S._index = S._path = null;
          }
          for (var y = i, L = l.length; y < L; y++)
            l[y]._index = y;
          if (u) {
            for (var E = i > 0 && r === d + (this._closed ? 1 : 0) ? i - 1 : i, u = u.splice(E, m), y = u.length - 1; y >= 0; y--)
              u[y]._path = null;
            s && (p._curves = u.slice(1)), this._adjustCurves(E, E);
          }
          return this._changed(41), p;
        },
        clear: "#removeSegments",
        hasHandles: function() {
          for (var i = this._segments, r = 0, s = i.length; r < s; r++)
            if (i[r].hasHandles())
              return !0;
          return !1;
        },
        clearHandles: function() {
          for (var i = this._segments, r = 0, s = i.length; r < s; r++)
            i[r].clearHandles();
        },
        getLength: function() {
          if (this._length == null) {
            for (var i = this.getCurves(), r = 0, s = 0, l = i.length; s < l; s++)
              r += i[s].getLength();
            this._length = r;
          }
          return this._length;
        },
        getArea: function() {
          var i = this._area;
          if (i == null) {
            var r = this._segments, s = this._closed;
            i = 0;
            for (var l = 0, u = r.length; l < u; l++) {
              var d = l + 1 === u;
              i += ze.getArea(ze.getValues(
                r[l],
                r[d ? 0 : l + 1],
                null,
                d && !s
              ));
            }
            this._area = i;
          }
          return i;
        },
        isFullySelected: function() {
          var i = this._segments.length;
          return this.isSelected() && i > 0 && this._segmentSelection === i * 7;
        },
        setFullySelected: function(i) {
          i && this._selectSegments(!0), this.setSelected(i);
        },
        setSelection: function i(r) {
          r & 1 || this._selectSegments(!1), i.base.call(this, r);
        },
        _selectSegments: function(i) {
          var r = this._segments, s = r.length, l = i ? 7 : 0;
          this._segmentSelection = l * s;
          for (var u = 0; u < s; u++)
            r[u]._selection = l;
        },
        _updateSelection: function(i, r, s) {
          i._selection = s;
          var l = this._segmentSelection += s - r;
          l > 0 && this.setSelected(!0);
        },
        divideAt: function(i) {
          var r = this.getLocationAt(i), s;
          return r && (s = r.getCurve().divideAt(r.getCurveOffset())) ? s._segment1 : null;
        },
        splitAt: function(i) {
          var r = this.getLocationAt(i), s = r && r.index, l = r && r.time, u = 1e-8, d = 1 - u;
          l > d && (s++, l = 0);
          var p = this.getCurves();
          if (s >= 0 && s < p.length) {
            l >= u && p[s++].divideAtTime(l);
            var m = this.removeSegments(s, this._segments.length, !0), y;
            return this._closed ? (this.setClosed(!1), y = this) : (y = new $e(X.NO_INSERT), y.insertAbove(this), y.copyAttributes(this)), y._add(m, 0), this.addSegment(m[0]), y;
          }
          return null;
        },
        split: function(i, r) {
          var s, l = r === t ? i : (s = this.getCurves()[i]) && s.getLocationAtTime(r);
          return l != null ? this.splitAt(l) : null;
        },
        join: function(i, r) {
          var s = r || 0;
          if (i && i !== this) {
            var l = i._segments, u = this.getLastSegment(), d = i.getLastSegment();
            if (!d)
              return this;
            u && u._point.isClose(d._point, s) && i.reverse();
            var p = i.getFirstSegment();
            if (u && u._point.isClose(p._point, s))
              u.setHandleOut(p._handleOut), this._add(l.slice(1));
            else {
              var m = this.getFirstSegment();
              m && m._point.isClose(p._point, s) && i.reverse(), d = i.getLastSegment(), m && m._point.isClose(d._point, s) ? (m.setHandleIn(d._handleIn), this._add(l.slice(0, l.length - 1), 0)) : this._add(l.slice());
            }
            i._closed && this._add([l[0]]), i.remove();
          }
          var y = this.getFirstSegment(), S = this.getLastSegment();
          return y !== S && y._point.isClose(S._point, s) && (y.setHandleIn(S._handleIn), S.remove(), this.setClosed(!0)), this;
        },
        reduce: function(i) {
          for (var r = this.getCurves(), s = i && i.simplify, l = s ? 1e-7 : 0, u = r.length - 1; u >= 0; u--) {
            var d = r[u];
            !d.hasHandles() && (!d.hasLength(l) || s && d.isCollinear(d.getNext())) && d.remove();
          }
          return this;
        },
        reverse: function() {
          this._segments.reverse();
          for (var i = 0, r = this._segments.length; i < r; i++) {
            var s = this._segments[i], l = s._handleIn;
            s._handleIn = s._handleOut, s._handleOut = l, s._index = i;
          }
          this._curves = null, this._changed(9);
        },
        flatten: function(i) {
          for (var r = new rt(this, i || 0.25, 256, !0), s = r.parts, l = s.length, u = [], d = 0; d < l; d++)
            u.push(new ce(s[d].curve.slice(0, 2)));
          !this._closed && l > 0 && u.push(new ce(s[l - 1].curve.slice(6))), this.setSegments(u);
        },
        simplify: function(i) {
          var r = new it(this).fit(i || 2.5);
          return r && this.setSegments(r), !!r;
        },
        smooth: function(i) {
          var r = this, s = i || {}, l = s.type || "asymmetric", u = this._segments, d = u.length, p = this._closed;
          function m(bt, Rt) {
            var Pt = bt && bt.index;
            if (Pt != null) {
              var zt = bt.path;
              if (zt && zt !== r)
                throw new Error(bt._class + " " + Pt + " of " + zt + " is not part of " + r);
              Rt && bt instanceof ze && Pt++;
            } else
              Pt = typeof bt == "number" ? bt : Rt;
            return Math.min(Pt < 0 && p ? Pt % d : Pt < 0 ? Pt + d : Pt, d - 1);
          }
          var y = p && s.from === t && s.to === t, S = m(s.from, 0), L = m(s.to, d - 1);
          if (S > L)
            if (p)
              S -= d;
            else {
              var E = S;
              S = L, L = E;
            }
          if (/^(?:asymmetric|continuous)$/.test(l)) {
            var A = l === "asymmetric", T = Math.min, G = L - S + 1, O = G - 1, Y = y ? T(G, 4) : 1, B = Y, z = Y, C = [];
            if (p || (B = T(1, S), z = T(1, d - L - 1)), O += B + z, O <= 1)
              return;
            for (var N = 0, j = S - B; N <= O; N++, j++)
              C[N] = u[(j < 0 ? j + d : j) % d]._point;
            for (var q = C[0]._x + 2 * C[1]._x, H = C[0]._y + 2 * C[1]._y, te = 2, ae = O - 1, le = [q], me = [H], se = [te], de = [], ve = [], N = 1; N < O; N++) {
              var we = N < ae, Se = we || A ? 1 : 2, Ae = we ? 4 : A ? 2 : 7, Ge = we ? 4 : A ? 3 : 8, Qe = we ? 2 : A ? 0 : 1, st = Se / te;
              te = se[N] = Ae - st, q = le[N] = Ge * C[N]._x + Qe * C[N + 1]._x - st * q, H = me[N] = Ge * C[N]._y + Qe * C[N + 1]._y - st * H;
            }
            de[ae] = le[ae] / se[ae], ve[ae] = me[ae] / se[ae];
            for (var N = O - 2; N >= 0; N--)
              de[N] = (le[N] - de[N + 1]) / se[N], ve[N] = (me[N] - ve[N + 1]) / se[N];
            de[O] = (3 * C[O]._x - de[ae]) / 2, ve[O] = (3 * C[O]._y - ve[ae]) / 2;
            for (var N = B, mt = O - z, j = S; N <= mt; N++, j++) {
              var Re = u[j < 0 ? j + d : j], Fe = Re._point, at = de[N] - Fe._x, yt = ve[N] - Fe._y;
              (y || N < mt) && Re.setHandleOut(at, yt), (y || N > B) && Re.setHandleIn(-at, -yt);
            }
          } else
            for (var N = S; N <= L; N++)
              u[N < 0 ? N + d : N].smooth(
                s,
                !y && N === S,
                !y && N === L
              );
        },
        toShape: function(i) {
          if (!this._closed)
            return null;
          var r = this._segments, s, l, u, d;
          function p(A, T) {
            var G = r[A], O = G.getNext(), Y = r[T], B = Y.getNext();
            return G._handleOut.isZero() && O._handleIn.isZero() && Y._handleOut.isZero() && B._handleIn.isZero() && O._point.subtract(G._point).isCollinear(
              B._point.subtract(Y._point)
            );
          }
          function m(A) {
            var T = r[A], G = T.getPrevious(), O = T.getNext();
            return G._handleOut.isZero() && T._handleIn.isZero() && T._handleOut.isZero() && O._handleIn.isZero() && T._point.subtract(G._point).isOrthogonal(
              O._point.subtract(T._point)
            );
          }
          function y(A) {
            var T = r[A], G = T.getNext(), O = T._handleOut, Y = G._handleIn, B = 0.5522847498307936;
            if (O.isOrthogonal(Y)) {
              var z = T._point, C = G._point, N = new he(z, O, !0).intersect(
                new he(C, Y, !0),
                !0
              );
              return N && I.isZero(O.getLength() / N.subtract(z).getLength() - B) && I.isZero(Y.getLength() / N.subtract(C).getLength() - B);
            }
            return !1;
          }
          function S(A, T) {
            return r[A]._point.getDistance(r[T]._point);
          }
          if (!this.hasHandles() && r.length === 4 && p(0, 2) && p(1, 3) && m(1) ? (s = Oe.Rectangle, l = new U(S(0, 3), S(0, 1)), d = r[1]._point.add(r[2]._point).divide(2)) : r.length === 8 && y(0) && y(2) && y(4) && y(6) && p(1, 5) && p(3, 7) ? (s = Oe.Rectangle, l = new U(S(1, 6), S(0, 3)), u = l.subtract(new U(
            S(0, 7),
            S(1, 2)
          )).divide(2), d = r[3]._point.add(r[4]._point).divide(2)) : r.length === 4 && y(0) && y(1) && y(2) && y(3) && (I.isZero(S(0, 2) - S(1, 3)) ? (s = Oe.Circle, u = S(0, 2) / 2) : (s = Oe.Ellipse, u = new U(S(2, 0) / 2, S(3, 1) / 2)), d = r[1]._point), s) {
            var L = this.getPosition(!0), E = new s({
              center: L,
              size: l,
              radius: u,
              insert: !1
            });
            return E.copyAttributes(this, !0), E._matrix.prepend(this._matrix), E.rotate(d.subtract(L).getAngle() + 90), (i === t || i) && E.insertAbove(this), E;
          }
          return null;
        },
        toPath: "#clone",
        compare: function i(r) {
          if (!r || r instanceof It)
            return i.base.call(this, r);
          var s = this.getCurves(), l = r.getCurves(), u = s.length, d = l.length;
          if (!u || !d)
            return u == d;
          for (var p = s[0].getValues(), m = [], y = 0, S, L = 0, E, A = 0; A < d; A++) {
            var Y = l[A].getValues();
            m.push(Y);
            var T = ze.getOverlaps(p, Y);
            if (T) {
              S = !A && T[0][0] > 0 ? d - 1 : A, E = T[0][1];
              break;
            }
          }
          for (var G = Math.abs, O = 1e-8, Y = m[S], B; p && Y; ) {
            var T = ze.getOverlaps(p, Y);
            if (T) {
              var z = T[0][0];
              if (G(z - L) < O) {
                L = T[1][0], L === 1 && (p = ++y < u ? s[y].getValues() : null, L = 0);
                var C = T[0][1];
                if (G(C - E) < O) {
                  if (B || (B = [S, C]), E = T[1][1], E === 1 && (++S >= d && (S = 0), Y = m[S] || l[S].getValues(), E = 0), !p)
                    return B[0] === S && B[1] === E;
                  continue;
                }
              }
            }
            break;
          }
          return !1;
        },
        _hitTestSelf: function(i, r, s, l) {
          var u = this, d = this.getStyle(), p = this._segments, m = p.length, y = this._closed, S = r._tolerancePadding, L = S, E, A, T, G, O, Y, B = r.stroke && d.hasStroke(), z = r.fill && d.hasFill(), C = r.curves, N = B ? d.getStrokeWidth() / 2 : z && r.tolerance > 0 || C ? 0 : null;
          N !== null && (N > 0 ? (E = d.getStrokeJoin(), A = d.getStrokeCap(), T = d.getMiterLimit(), L = L.add(
            $e._getStrokePadding(N, l)
          )) : E = A = "round");
          function j(de, ve) {
            return i.subtract(de).divide(ve).length <= 1;
          }
          function q(de, ve, we) {
            if (!r.selected || ve.isSelected()) {
              var Se = de._point;
              if (ve !== Se && (ve = ve.add(Se)), j(ve, L))
                return new Ze(we, u, {
                  segment: de,
                  point: ve
                });
            }
          }
          function H(de, ve) {
            return (ve || r.segments) && q(de, de._point, "segment") || !ve && r.handles && (q(de, de._handleIn, "handle-in") || q(de, de._handleOut, "handle-out"));
          }
          function te(de) {
            G.add(de);
          }
          function ae(de) {
            var ve = y || de._index > 0 && de._index < m - 1;
            if ((ve ? E : A) === "round")
              return j(de._point, L);
            if (G = new $e({ internal: !0, closed: !0 }), ve ? de.isSmooth() || $e._addBevelJoin(
              de,
              E,
              N,
              T,
              null,
              l,
              te,
              !0
            ) : A === "square" && $e._addSquareCap(
              de,
              A,
              N,
              null,
              l,
              te,
              !0
            ), !G.isEmpty()) {
              var we;
              return G.contains(i) || (we = G.getNearestLocation(i)) && j(we.getPoint(), S);
            }
          }
          if (r.ends && !r.segments && !y) {
            if (Y = H(p[0], !0) || H(p[m - 1], !0))
              return Y;
          } else if (r.segments || r.handles) {
            for (var le = 0; le < m; le++)
              if (Y = H(p[le]))
                return Y;
          }
          if (N !== null) {
            if (O = this.getNearestLocation(i), O) {
              var me = O.getTime();
              me === 0 || me === 1 && m > 1 ? ae(O.getSegment()) || (O = null) : j(O.getPoint(), L) || (O = null);
            }
            if (!O && E === "miter" && m > 1)
              for (var le = 0; le < m; le++) {
                var se = p[le];
                if (i.getDistance(se._point) <= T * N && ae(se)) {
                  O = se.getLocation();
                  break;
                }
              }
          }
          return !O && z && this._contains(i) || O && !B && !C ? new Ze("fill", this) : O ? new Ze(B ? "stroke" : "curve", this, {
            location: O,
            point: O.getPoint()
          }) : null;
        }
      },
      o.each(
        ze._evaluateMethods,
        function(i) {
          this[i + "At"] = function(r) {
            var s = this.getLocationAt(r);
            return s && s[i]();
          };
        },
        {
          beans: !1,
          getLocationOf: function() {
            for (var i = M.read(arguments), r = this.getCurves(), s = 0, l = r.length; s < l; s++) {
              var u = r[s].getLocationOf(i);
              if (u)
                return u;
            }
            return null;
          },
          getOffsetOf: function() {
            var i = this.getLocationOf.apply(this, arguments);
            return i ? i.getOffset() : null;
          },
          getLocationAt: function(i) {
            if (typeof i == "number") {
              for (var r = this.getCurves(), s = 0, l = 0, u = r.length; l < u; l++) {
                var d = s, p = r[l];
                if (s += p.getLength(), s > i)
                  return p.getLocationAt(i - d);
              }
              if (r.length > 0 && i <= this.getLength())
                return new ht(r[r.length - 1], 1);
            } else if (i && i.getPath && i.getPath() === this)
              return i;
            return null;
          },
          getOffsetsWithTangent: function() {
            var i = M.read(arguments);
            if (i.isZero())
              return [];
            for (var r = [], s = 0, l = this.getCurves(), u = 0, d = l.length; u < d; u++) {
              for (var p = l[u], m = p.getTimesWithTangent(i), y = 0, S = m.length; y < S; y++) {
                var L = s + p.getOffsetAtTime(m[y]);
                r.indexOf(L) < 0 && r.push(L);
              }
              s += p.length;
            }
            return r;
          }
        }
      ),
      new function() {
        function i(s, l, u, d) {
          if (d <= 0)
            return;
          var p = d / 2, m = d - 2, y = p - 1, S = new Array(6), L, E;
          function A(z) {
            var C = S[z], N = S[z + 1];
            (L != C || E != N) && (s.beginPath(), s.moveTo(L, E), s.lineTo(C, N), s.stroke(), s.beginPath(), s.arc(C, N, p, 0, Math.PI * 2, !0), s.fill());
          }
          for (var T = 0, G = l.length; T < G; T++) {
            var O = l[T], Y = O._selection;
            if (O._transformCoordinates(u, S), L = S[0], E = S[1], Y & 2 && A(2), Y & 4 && A(4), s.fillRect(L - p, E - p, d, d), m > 0 && !(Y & 1)) {
              var B = s.fillStyle;
              s.fillStyle = "#ffffff", s.fillRect(L - y, E - y, m, m), s.fillStyle = B;
            }
          }
        }
        function r(s, l, u) {
          var d = l._segments, p = d.length, m = new Array(6), y = !0, S, L, E, A, T, G, O, Y;
          function B(C) {
            if (u)
              C._transformCoordinates(u, m), S = m[0], L = m[1];
            else {
              var N = C._point;
              S = N._x, L = N._y;
            }
            if (y)
              s.moveTo(S, L), y = !1;
            else {
              if (u)
                T = m[2], G = m[3];
              else {
                var j = C._handleIn;
                T = S + j._x, G = L + j._y;
              }
              T === S && G === L && O === E && Y === A ? s.lineTo(S, L) : s.bezierCurveTo(O, Y, T, G, S, L);
            }
            if (E = S, A = L, u)
              O = m[4], Y = m[5];
            else {
              var j = C._handleOut;
              O = E + j._x, Y = A + j._y;
            }
          }
          for (var z = 0; z < p; z++)
            B(d[z]);
          l._closed && p > 0 && B(d[0]);
        }
        return {
          _draw: function(s, l, u, d) {
            var p = l.dontStart, m = l.dontFinish || l.clip, y = this.getStyle(), S = y.hasFill(), L = y.hasStroke(), E = y.getDashArray(), A = !Ve.support.nativeDash && L && E && E.length;
            p || s.beginPath(), (S || L && !A || m) && (r(s, this, d), this._closed && s.closePath());
            function T(C) {
              return E[(C % A + A) % A];
            }
            if (!m && (S || L) && (this._setStyles(s, l, u), S && (s.fill(y.getFillRule()), s.shadowColor = "rgba(0,0,0,0)"), L)) {
              if (A) {
                p || s.beginPath();
                for (var G = new rt(
                  this,
                  0.25,
                  32,
                  !1,
                  d
                ), O = G.length, Y = -y.getDashOffset(), B, z = 0; Y > 0; )
                  Y -= T(z--) + T(z--);
                for (; Y < O; )
                  B = Y + T(z++), (Y > 0 || B > 0) && G.drawPart(
                    s,
                    Math.max(Y, 0),
                    Math.max(B, 0)
                  ), Y = B + T(z++);
              }
              s.stroke();
            }
          },
          _drawSelected: function(s, l) {
            s.beginPath(), r(s, this, l), s.stroke(), i(s, this._segments, l, Ve.settings.handleSize);
          }
        };
      }(),
      new function() {
        function i(r) {
          var s = r._segments;
          if (!s.length)
            throw new Error("Use a moveTo() command first");
          return s[s.length - 1];
        }
        return {
          moveTo: function() {
            var r = this._segments;
            r.length === 1 && this.removeSegment(0), r.length || this._add([new ce(M.read(arguments))]);
          },
          moveBy: function() {
            throw new Error("moveBy() is unsupported on Path items.");
          },
          lineTo: function() {
            this._add([new ce(M.read(arguments))]);
          },
          cubicCurveTo: function() {
            var r = arguments, s = M.read(r), l = M.read(r), u = M.read(r), d = i(this);
            d.setHandleOut(s.subtract(d._point)), this._add([new ce(u, l.subtract(u))]);
          },
          quadraticCurveTo: function() {
            var r = arguments, s = M.read(r), l = M.read(r), u = i(this)._point;
            this.cubicCurveTo(
              s.add(u.subtract(s).multiply(1 / 3)),
              s.add(l.subtract(s).multiply(1 / 3)),
              l
            );
          },
          curveTo: function() {
            var r = arguments, s = M.read(r), l = M.read(r), u = o.pick(o.read(r), 0.5), d = 1 - u, p = i(this)._point, m = s.subtract(p.multiply(d * d)).subtract(l.multiply(u * u)).divide(2 * u * d);
            if (m.isNaN())
              throw new Error(
                "Cannot put a curve through points with parameter = " + u
              );
            this.quadraticCurveTo(m, l);
          },
          arcTo: function() {
            var r = arguments, s = Math.abs, l = Math.sqrt, u = i(this), d = u._point, p = M.read(r), m, y = o.peek(r), S = o.pick(y, !0), L, E, A, T;
            if (typeof S == "boolean")
              var G = d.add(p).divide(2), m = G.add(G.subtract(d).rotate(
                S ? -90 : 90
              ));
            else if (o.remain(r) <= 2)
              m = p, p = M.read(r);
            else if (!d.equals(p)) {
              var O = U.read(r), Y = I.isZero;
              if (Y(O.width) || Y(O.height))
                return this.lineTo(p);
              var B = o.read(r), S = !!o.read(r), z = !!o.read(r), G = d.add(p).divide(2), C = d.subtract(G).rotate(-B), N = C.x, j = C.y, q = s(O.width), H = s(O.height), te = q * q, ae = H * H, le = N * N, me = j * j, se = l(le / te + me / ae);
              if (se > 1 && (q *= se, H *= se, te = q * q, ae = H * H), se = (te * ae - te * me - ae * le) / (te * me + ae * le), s(se) < 1e-12 && (se = 0), se < 0)
                throw new Error(
                  "Cannot create an arc with the given arguments"
                );
              L = new M(q * j / H, -H * N / q).multiply((z === S ? -1 : 1) * l(se)).rotate(B).add(G), T = new J().translate(L).rotate(B).scale(q, H), A = T._inverseTransform(d), E = A.getDirectedAngle(T._inverseTransform(p)), !S && E > 0 ? E -= 360 : S && E < 0 && (E += 360);
            }
            if (m) {
              var de = new he(
                d.add(m).divide(2),
                m.subtract(d).rotate(90),
                !0
              ), ve = new he(
                m.add(p).divide(2),
                p.subtract(m).rotate(90),
                !0
              ), we = new he(d, p), Se = we.getSide(m);
              if (L = de.intersect(ve, !0), !L) {
                if (!Se)
                  return this.lineTo(p);
                throw new Error(
                  "Cannot create an arc with the given arguments"
                );
              }
              A = d.subtract(L), E = A.getDirectedAngle(p.subtract(L));
              var Ae = we.getSide(L, !0);
              Ae === 0 ? E = Se * s(E) : Se === Ae && (E += E < 0 ? 360 : -360);
            }
            if (E) {
              for (var Ge = 1e-5, Qe = s(E), st = Qe >= 360 ? 4 : Math.ceil((Qe - Ge) / 90), mt = E / st, Re = mt * Math.PI / 360, Fe = 4 / 3 * Math.sin(Re) / (1 + Math.cos(Re)), at = [], yt = 0; yt <= st; yt++) {
                var C = p, bt = null;
                if (yt < st && (bt = A.rotate(90).multiply(Fe), T ? (C = T._transformPoint(A), bt = T._transformPoint(A.add(bt)).subtract(C)) : C = L.add(A)), !yt)
                  u.setHandleOut(bt);
                else {
                  var Rt = A.rotate(-90).multiply(Fe);
                  T && (Rt = T._transformPoint(A.add(Rt)).subtract(C)), at.push(new ce(C, Rt, bt));
                }
                A = A.rotate(mt);
              }
              this._add(at);
            }
          },
          lineBy: function() {
            var r = M.read(arguments), s = i(this)._point;
            this.lineTo(s.add(r));
          },
          curveBy: function() {
            var r = arguments, s = M.read(r), l = M.read(r), u = o.read(r), d = i(this)._point;
            this.curveTo(d.add(s), d.add(l), u);
          },
          cubicCurveBy: function() {
            var r = arguments, s = M.read(r), l = M.read(r), u = M.read(r), d = i(this)._point;
            this.cubicCurveTo(
              d.add(s),
              d.add(l),
              d.add(u)
            );
          },
          quadraticCurveBy: function() {
            var r = arguments, s = M.read(r), l = M.read(r), u = i(this)._point;
            this.quadraticCurveTo(u.add(s), u.add(l));
          },
          arcBy: function() {
            var r = arguments, s = i(this)._point, l = s.add(M.read(r)), u = o.pick(o.peek(r), !0);
            typeof u == "boolean" ? this.arcTo(l, u) : this.arcTo(l, s.add(M.read(r)));
          },
          closePath: function(r) {
            this.setClosed(!0), this.join(this, r);
          }
        };
      }(),
      {
        _getBounds: function(i, r) {
          var s = r.handle ? "getHandleBounds" : r.stroke ? "getStrokeBounds" : "getBounds";
          return $e[s](this._segments, this._closed, this, i, r);
        },
        statics: {
          getBounds: function(i, r, s, l, u, d) {
            var p = i[0];
            if (!p)
              return new D();
            var m = new Array(6), y = p._transformCoordinates(l, new Array(6)), S = y.slice(0, 2), L = S.slice(), E = new Array(2);
            function A(O) {
              O._transformCoordinates(l, m);
              for (var Y = 0; Y < 2; Y++)
                ze._addBounds(
                  y[Y],
                  y[Y + 4],
                  m[Y + 2],
                  m[Y],
                  Y,
                  d ? d[Y] : 0,
                  S,
                  L,
                  E
                );
              var B = y;
              y = m, m = B;
            }
            for (var T = 1, G = i.length; T < G; T++)
              A(i[T]);
            return r && A(p), new D(S[0], S[1], L[0] - S[0], L[1] - S[1]);
          },
          getStrokeBounds: function(i, r, s, l, u) {
            var d = s.getStyle(), p = d.hasStroke(), m = d.getStrokeWidth(), y = p && s._getStrokeMatrix(l, u), S = p && $e._getStrokePadding(
              m,
              y
            ), L = $e.getBounds(
              i,
              r,
              s,
              l,
              u,
              S
            );
            if (!p)
              return L;
            var E = m / 2, A = d.getStrokeJoin(), T = d.getStrokeCap(), G = d.getMiterLimit(), O = new D(new U(S));
            function Y(q) {
              L = L.include(q);
            }
            function B(q) {
              L = L.unite(
                O.setCenter(q._point.transform(l))
              );
            }
            function z(q, H) {
              H === "round" || q.isSmooth() ? B(q) : $e._addBevelJoin(
                q,
                H,
                E,
                G,
                l,
                y,
                Y
              );
            }
            function C(q, H) {
              H === "round" ? B(q) : $e._addSquareCap(
                q,
                H,
                E,
                l,
                y,
                Y
              );
            }
            var N = i.length - (r ? 0 : 1);
            if (N > 0) {
              for (var j = 1; j < N; j++)
                z(i[j], A);
              r ? z(i[0], A) : (C(i[0], T), C(i[i.length - 1], T));
            }
            return L;
          },
          _getStrokePadding: function(i, r) {
            if (!r)
              return [i, i];
            var s = new M(i, 0).transform(r), l = new M(0, i).transform(r), u = s.getAngleInRadians(), d = s.getLength(), p = l.getLength(), m = Math.sin(u), y = Math.cos(u), S = Math.tan(u), L = Math.atan2(p * S, d), E = Math.atan2(p, S * d);
            return [
              Math.abs(d * Math.cos(L) * y + p * Math.sin(L) * m),
              Math.abs(p * Math.sin(E) * y + d * Math.cos(E) * m)
            ];
          },
          _addBevelJoin: function(i, r, s, l, u, d, p, m) {
            var y = i.getCurve(), S = y.getPrevious(), L = y.getPoint1().transform(u), E = S.getNormalAtTime(1).multiply(s).transform(d), A = y.getNormalAtTime(0).multiply(s).transform(d), T = E.getDirectedAngle(A);
            if ((T < 0 || T >= 180) && (E = E.negate(), A = A.negate()), m && p(L), p(L.add(E)), r === "miter") {
              var G = new he(
                L.add(E),
                new M(-E.y, E.x),
                !0
              ).intersect(new he(
                L.add(A),
                new M(-A.y, A.x),
                !0
              ), !0);
              G && L.getDistance(G) <= l * s && p(G);
            }
            p(L.add(A));
          },
          _addSquareCap: function(i, r, s, l, u, d, p) {
            var m = i._point.transform(l), y = i.getLocation(), S = y.getNormal().multiply(y.getTime() === 0 ? s : -s).transform(u);
            r === "square" && (p && (d(m.subtract(S)), d(m.add(S))), m = m.add(S.rotate(-90))), d(m.add(S)), d(m.subtract(S));
          },
          getHandleBounds: function(i, r, s, l, u) {
            var d = s.getStyle(), p = u.stroke && d.hasStroke(), m, y;
            if (p) {
              var S = s._getStrokeMatrix(l, u), L = d.getStrokeWidth() / 2, E = L;
              d.getStrokeJoin() === "miter" && (E = L * d.getMiterLimit()), d.getStrokeCap() === "square" && (E = Math.max(E, L * Math.SQRT2)), m = $e._getStrokePadding(L, S), y = $e._getStrokePadding(E, S);
            }
            for (var A = new Array(6), T = 1 / 0, G = -T, O = T, Y = G, B = 0, z = i.length; B < z; B++) {
              var C = i[B];
              C._transformCoordinates(l, A);
              for (var N = 0; N < 6; N += 2) {
                var j = N ? m : y, q = j ? j[0] : 0, H = j ? j[1] : 0, te = A[N], ae = A[N + 1], le = te - q, me = te + q, se = ae - H, de = ae + H;
                le < T && (T = le), me > G && (G = me), se < O && (O = se), de > Y && (Y = de);
              }
            }
            return new D(T, O, G - T, Y - O);
          }
        }
      }
    );
    $e.inject({ statics: new function() {
      var i = 0.5522847498307936, r = [
        new ce([-1, 0], [0, i], [0, -i]),
        new ce([0, -1], [-i, 0], [i, 0]),
        new ce([1, 0], [0, -i], [0, i]),
        new ce([0, 1], [i, 0], [-i, 0])
      ];
      function s(u, d, p) {
        var m = o.getNamed(p), y = new $e(m && (m.insert == !0 ? X.INSERT : m.insert == !1 ? X.NO_INSERT : null));
        return y._add(u), y._closed = d, y.set(m, X.INSERT);
      }
      function l(u, d, p) {
        for (var m = new Array(4), y = 0; y < 4; y++) {
          var S = r[y];
          m[y] = new ce(
            S._point.multiply(d).add(u),
            S._handleIn.multiply(d),
            S._handleOut.multiply(d)
          );
        }
        return s(m, !0, p);
      }
      return {
        Line: function() {
          var u = arguments;
          return s([
            new ce(M.readNamed(u, "from")),
            new ce(M.readNamed(u, "to"))
          ], !1, u);
        },
        Circle: function() {
          var u = arguments, d = M.readNamed(u, "center"), p = o.readNamed(u, "radius");
          return l(d, new U(p), u);
        },
        Rectangle: function() {
          var u = arguments, d = D.readNamed(u, "rectangle"), p = U.readNamed(
            u,
            "radius",
            0,
            { readNull: !0 }
          ), m = d.getBottomLeft(!0), y = d.getTopLeft(!0), S = d.getTopRight(!0), L = d.getBottomRight(!0), E;
          if (!p || p.isZero())
            E = [
              new ce(m),
              new ce(y),
              new ce(S),
              new ce(L)
            ];
          else {
            p = U.min(p, d.getSize(!0).divide(2));
            var A = p.width, T = p.height, G = A * i, O = T * i;
            E = [
              new ce(m.add(A, 0), null, [-G, 0]),
              new ce(m.subtract(0, T), [0, O]),
              new ce(y.add(0, T), null, [0, -O]),
              new ce(y.add(A, 0), [-G, 0], null),
              new ce(S.subtract(A, 0), null, [G, 0]),
              new ce(S.add(0, T), [0, -O], null),
              new ce(L.subtract(0, T), null, [0, O]),
              new ce(L.subtract(A, 0), [G, 0])
            ];
          }
          return s(E, !0, u);
        },
        RoundRectangle: "#Rectangle",
        Ellipse: function() {
          var u = arguments, d = Oe._readEllipse(u);
          return l(d.center, d.radius, u);
        },
        Oval: "#Ellipse",
        Arc: function() {
          var u = arguments, d = M.readNamed(u, "from"), p = M.readNamed(u, "through"), m = M.readNamed(u, "to"), y = o.getNamed(u), S = new $e(y && y.insert == !1 && X.NO_INSERT);
          return S.moveTo(d), S.arcTo(p, m), S.set(y);
        },
        RegularPolygon: function() {
          for (var u = arguments, d = M.readNamed(u, "center"), p = o.readNamed(u, "sides"), m = o.readNamed(u, "radius"), y = 360 / p, S = p % 3 === 0, L = new M(0, S ? -m : m), E = S ? -1 : 0.5, A = new Array(p), T = 0; T < p; T++)
            A[T] = new ce(d.add(
              L.rotate((T + E) * y)
            ));
          return s(A, !0, u);
        },
        Star: function() {
          for (var u = arguments, d = M.readNamed(u, "center"), p = o.readNamed(u, "points") * 2, m = o.readNamed(u, "radius1"), y = o.readNamed(u, "radius2"), S = 360 / p, L = new M(0, -1), E = new Array(p), A = 0; A < p; A++)
            E[A] = new ce(d.add(L.rotate(S * A).multiply(A % 2 ? y : m)));
          return s(E, !0, u);
        }
      };
    }() });
    var It = Gt.extend(
      {
        _class: "CompoundPath",
        _serializeFields: {
          children: []
        },
        beans: !0,
        initialize: function(r) {
          this._children = [], this._namedChildren = {}, this._initialize(r) || (typeof r == "string" ? this.setPathData(r) : this.addChildren(Array.isArray(r) ? r : arguments));
        },
        insertChildren: function i(r, s) {
          var l = s, u = l[0];
          u && typeof u[0] == "number" && (l = [l]);
          for (var d = s.length - 1; d >= 0; d--) {
            var p = l[d];
            l === s && !(p instanceof $e) && (l = o.slice(l)), Array.isArray(p) ? l[d] = new $e({ segments: p, insert: !1 }) : p instanceof It && (l.splice.apply(l, [d, 1].concat(p.removeChildren())), p.remove());
          }
          return i.base.call(this, r, l);
        },
        reduce: function i(r) {
          for (var s = this._children, l = s.length - 1; l >= 0; l--) {
            var u = s[l].reduce(r);
            u.isEmpty() && u.remove();
          }
          if (!s.length) {
            var u = new $e(X.NO_INSERT);
            return u.copyAttributes(this), u.insertAbove(this), this.remove(), u;
          }
          return i.base.call(this);
        },
        isClosed: function() {
          for (var i = this._children, r = 0, s = i.length; r < s; r++)
            if (!i[r]._closed)
              return !1;
          return !0;
        },
        setClosed: function(i) {
          for (var r = this._children, s = 0, l = r.length; s < l; s++)
            r[s].setClosed(i);
        },
        getFirstSegment: function() {
          var i = this.getFirstChild();
          return i && i.getFirstSegment();
        },
        getLastSegment: function() {
          var i = this.getLastChild();
          return i && i.getLastSegment();
        },
        getCurves: function() {
          for (var i = this._children, r = [], s = 0, l = i.length; s < l; s++)
            o.push(r, i[s].getCurves());
          return r;
        },
        getFirstCurve: function() {
          var i = this.getFirstChild();
          return i && i.getFirstCurve();
        },
        getLastCurve: function() {
          var i = this.getLastChild();
          return i && i.getLastCurve();
        },
        getArea: function() {
          for (var i = this._children, r = 0, s = 0, l = i.length; s < l; s++)
            r += i[s].getArea();
          return r;
        },
        getLength: function() {
          for (var i = this._children, r = 0, s = 0, l = i.length; s < l; s++)
            r += i[s].getLength();
          return r;
        },
        getPathData: function(i, r) {
          for (var s = this._children, l = [], u = 0, d = s.length; u < d; u++) {
            var p = s[u], m = p._matrix;
            l.push(p.getPathData(i && !m.isIdentity() ? i.appended(m) : i, r));
          }
          return l.join("");
        },
        _hitTestChildren: function i(r, s, l) {
          return i.base.call(
            this,
            r,
            s.class === $e || s.type === "path" ? s : o.set({}, s, { fill: !1 }),
            l
          );
        },
        _draw: function(i, r, s, l) {
          var u = this._children;
          if (u.length) {
            r = r.extend({ dontStart: !0, dontFinish: !0 }), i.beginPath();
            for (var d = 0, p = u.length; d < p; d++)
              u[d].draw(i, r, l);
            if (!r.clip) {
              this._setStyles(i, r, s);
              var m = this._style;
              m.hasFill() && (i.fill(m.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), m.hasStroke() && i.stroke();
            }
          }
        },
        _drawSelected: function(i, r, s) {
          for (var l = this._children, u = 0, d = l.length; u < d; u++) {
            var p = l[u], m = p._matrix;
            s[p._id] || p._drawSelected(i, m.isIdentity() ? r : r.appended(m));
          }
        }
      },
      new function() {
        function i(r, s) {
          var l = r._children;
          if (s && !l.length)
            throw new Error("Use a moveTo() command first");
          return l[l.length - 1];
        }
        return o.each(
          [
            "lineTo",
            "cubicCurveTo",
            "quadraticCurveTo",
            "curveTo",
            "arcTo",
            "lineBy",
            "cubicCurveBy",
            "quadraticCurveBy",
            "curveBy",
            "arcBy"
          ],
          function(r) {
            this[r] = function() {
              var s = i(this, !0);
              s[r].apply(s, arguments);
            };
          },
          {
            moveTo: function() {
              var r = i(this), s = r && r.isEmpty() ? r : new $e(X.NO_INSERT);
              s !== r && this.addChild(s), s.moveTo.apply(s, arguments);
            },
            moveBy: function() {
              var r = i(this, !0), s = r && r.getLastSegment(), l = M.read(arguments);
              this.moveTo(s ? l.add(s._point) : l);
            },
            closePath: function(r) {
              i(this, !0).closePath(r);
            }
          }
        );
      }(),
      o.each(["reverse", "flatten", "simplify", "smooth"], function(i) {
        this[i] = function(r) {
          for (var s = this._children, l, u = 0, d = s.length; u < d; u++)
            l = s[u][i](r) || l;
          return l;
        };
      }, {})
    );
    Gt.inject(new function() {
      var i = Math.min, r = Math.max, s = Math.abs, l = {
        unite: { 1: !0, 2: !0 },
        intersect: { 2: !0 },
        subtract: { 1: !0 },
        exclude: { 1: !0, "-1": !0 }
      };
      function u(B) {
        return B._children || [B];
      }
      function d(B, z) {
        var C = B.clone(!1).reduce({ simplify: !0 }).transform(null, !0, !0);
        if (z) {
          for (var N = u(C), j = 0, q = N.length; j < q; j++) {
            var B = N[j];
            !B._closed && !B.isEmpty() && (B.closePath(1e-12), B.getFirstSegment().setHandleIn(0, 0), B.getLastSegment().setHandleOut(0, 0));
          }
          C = C.resolveCrossings().reorient(C.getFillRule() === "nonzero", !0);
        }
        return C;
      }
      function p(B, z, C, N, j) {
        var q = new It(X.NO_INSERT);
        return q.addChildren(B, !0), q = q.reduce({ simplify: z }), j && j.insert == !1 || q.insertAbove(N && C.isSibling(N) && C.getIndex() < N.getIndex() ? N : C), q.copyAttributes(C, !0), q;
      }
      function m(B) {
        return B.hasOverlap() || B.isCrossing();
      }
      function y(B, z, C, N) {
        if (N && (N.trace == !1 || N.stroke) && /^(subtract|intersect)$/.test(C))
          return S(B, z, C);
        var j = d(B, !0), q = z && B !== z && d(z, !0), H = l[C];
        H[C] = !0, q && (H.subtract || H.exclude) ^ (q.isClockwise() ^ j.isClockwise()) && q.reverse();
        var te = T(ht.expand(
          j.getIntersections(q, m)
        )), ae = u(j), le = q && u(q), me = [], se = [], de;
        function ve(bt) {
          for (var Rt = 0, Pt = bt.length; Rt < Pt; Rt++) {
            var zt = bt[Rt];
            o.push(me, zt._segments), o.push(se, zt.getCurves()), zt._overlapsOnly = !0;
          }
        }
        function we(bt) {
          for (var Rt = [], Pt = 0, zt = bt && bt.length; Pt < zt; Pt++)
            Rt.push(se[bt[Pt]]);
          return Rt;
        }
        if (te.length) {
          ve(ae), le && ve(le);
          for (var Se = new Array(se.length), Ae = 0, Ge = se.length; Ae < Ge; Ae++)
            Se[Ae] = se[Ae].getValues();
          for (var Qe = x.findCurveBoundsCollisions(
            Se,
            Se,
            0,
            !0
          ), st = {}, Ae = 0; Ae < se.length; Ae++) {
            var mt = se[Ae], Re = mt._path._id, Fe = st[Re] = st[Re] || {};
            Fe[mt.getIndex()] = {
              hor: we(Qe[Ae].hor),
              ver: we(Qe[Ae].ver)
            };
          }
          for (var Ae = 0, Ge = te.length; Ae < Ge; Ae++)
            O(
              te[Ae]._segment,
              j,
              q,
              st,
              H
            );
          for (var Ae = 0, Ge = me.length; Ae < Ge; Ae++) {
            var at = me[Ae], yt = at._intersection;
            at._winding || O(
              at,
              j,
              q,
              st,
              H
            ), yt && yt._overlap || (at._path._overlapsOnly = !1);
          }
          de = Y(me, H);
        } else
          de = A(
            le ? ae.concat(le) : ae.slice(),
            function(bt) {
              return !!H[bt];
            }
          );
        return p(de, !0, B, z, N);
      }
      function S(B, z, C) {
        var N = d(B), j = d(z), q = N.getIntersections(j, m), H = C === "subtract", te = C === "divide", ae = {}, le = [];
        function me(ve) {
          if (!ae[ve._id] && (te || j.contains(ve.getPointAt(ve.getLength() / 2)) ^ H))
            return le.unshift(ve), ae[ve._id] = !0;
        }
        for (var se = q.length - 1; se >= 0; se--) {
          var de = q[se].split();
          de && (me(de) && de.getFirstSegment().setHandleIn(0, 0), N.getLastSegment().setHandleOut(0, 0));
        }
        return me(N), p(le, !1, B, z);
      }
      function L(B, z) {
        for (var C = B; C; ) {
          if (C === z)
            return;
          C = C._previous;
        }
        for (; B._next && B._next !== z; )
          B = B._next;
        if (!B._next) {
          for (; z._previous; )
            z = z._previous;
          B._next = z, z._previous = B;
        }
      }
      function E(B) {
        for (var z = B.length - 1; z >= 0; z--)
          B[z].clearHandles();
      }
      function A(B, z, C) {
        var N = B && B.length;
        if (N) {
          var j = o.each(B, function(Qe, st) {
            this[Qe._id] = {
              container: null,
              winding: Qe.isClockwise() ? 1 : -1,
              index: st
            };
          }, {}), q = B.slice().sort(function(Qe, st) {
            return s(st.getArea()) - s(Qe.getArea());
          }), H = q[0], te = x.findItemBoundsCollisions(
            q,
            null,
            I.GEOMETRIC_EPSILON
          );
          C == null && (C = H.isClockwise());
          for (var ae = 0; ae < N; ae++) {
            var le = q[ae], me = j[le._id], se = 0, de = te[ae];
            if (de) {
              for (var ve = null, we = de.length - 1; we >= 0; we--)
                if (de[we] < ae) {
                  ve = ve || le.getInteriorPoint();
                  var Se = q[de[we]];
                  if (Se.contains(ve)) {
                    var Ae = j[Se._id];
                    se = Ae.winding, me.winding += se, me.container = Ae.exclude ? Ae.container : Se;
                    break;
                  }
                }
            }
            if (z(me.winding) === z(se))
              me.exclude = !0, B[me.index] = null;
            else {
              var Ge = me.container;
              le.setClockwise(
                Ge ? !Ge.isClockwise() : C
              );
            }
          }
        }
        return B;
      }
      function T(B, z, C) {
        var N = z && [], j = 1e-8, q = 1 - j, H = !1, te = C || [], ae = C && {}, le, me, se;
        function de(Rt) {
          return Rt._path._id + "." + Rt._segment1._index;
        }
        for (var ve = (C && C.length) - 1; ve >= 0; ve--) {
          var we = C[ve];
          we._path && (ae[de(we)] = !0);
        }
        for (var ve = B.length - 1; ve >= 0; ve--) {
          var Se = B[ve], Ae = Se._time, Ge = Ae, Qe = z && !z(Se), we = Se._curve, st;
          if (we && (we !== me ? (H = !we.hasHandles() || ae && ae[de(we)], le = [], se = null, me = we) : se >= j && (Ae /= se)), Qe) {
            le && le.push(Se);
            continue;
          } else
            z && N.unshift(Se);
          if (se = Ge, Ae < j)
            st = we._segment1;
          else if (Ae > q)
            st = we._segment2;
          else {
            var mt = we.divideAtTime(Ae, !0);
            H && te.push(we, mt), st = mt._segment1;
            for (var Re = le.length - 1; Re >= 0; Re--) {
              var Fe = le[Re];
              Fe._time = (Fe._time - Ae) / (1 - Ae);
            }
          }
          Se._setSegment(st);
          var at = st._intersection, yt = Se._intersection;
          if (at) {
            L(at, yt);
            for (var bt = at; bt; )
              L(bt._intersection, at), bt = bt._next;
          } else
            st._intersection = yt;
        }
        return C || E(te), N || B;
      }
      function G(B, z, C, N, j) {
        var q = Array.isArray(z) ? z : z[C ? "hor" : "ver"], H = C ? 1 : 0, te = H ^ 1, ae = [B.x, B.y], le = ae[H], me = ae[te], se = 1e-9, de = 1e-6, ve = le - se, we = le + se, Se = 0, Ae = 0, Ge = 0, Qe = 0, st = !1, mt = !1, Re = 1, Fe = [], at, yt;
        function bt(kt) {
          var fi = kt[te + 0], Ti = kt[te + 6];
          if (!(me < i(fi, Ti) || me > r(fi, Ti))) {
            var xi = kt[H + 0], tn = kt[H + 2], Hi = kt[H + 4], Zi = kt[H + 6];
            if (fi === Ti) {
              (xi < we && Zi > ve || Zi < we && xi > ve) && (st = !0);
              return;
            }
            var Xi = me === fi ? 0 : me === Ti || ve > r(xi, tn, Hi, Zi) || we < i(xi, tn, Hi, Zi) ? 1 : ze.solveCubic(kt, te, me, Fe, 0, 1) > 0 ? Fe[0] : 1, ji = Xi === 0 ? xi : Xi === 1 ? Zi : ze.getPoint(kt, Xi)[C ? "y" : "x"], Ki = fi > Ti ? 1 : -1, ln = at[te] > at[te + 6] ? 1 : -1, Fi = at[H + 6];
            return me !== fi ? (ji < ve ? Ge += Ki : ji > we ? Qe += Ki : st = !0, ji > le - de && ji < le + de && (Re /= 2)) : (Ki !== ln ? xi < ve ? Ge += Ki : xi > we && (Qe += Ki) : xi != Fi && (Fi < we && ji > we ? (Qe += Ki, st = !0) : Fi > ve && ji < ve && (Ge += Ki, st = !0)), Re /= 4), at = kt, !j && ji > ve && ji < we && ze.getTangent(kt, Xi)[C ? "x" : "y"] === 0 && G(B, z, !C, N, !0);
          }
        }
        function Rt(kt) {
          var fi = kt[te + 0], Ti = kt[te + 2], xi = kt[te + 4], tn = kt[te + 6];
          if (me <= r(fi, Ti, xi, tn) && me >= i(fi, Ti, xi, tn)) {
            for (var Hi = kt[H + 0], Zi = kt[H + 2], Xi = kt[H + 4], ji = kt[H + 6], Ki = ve > r(Hi, Zi, Xi, ji) || we < i(Hi, Zi, Xi, ji) ? [kt] : ze.getMonoCurves(kt, C), ln, Fi = 0, hn = Ki.length; Fi < hn; Fi++)
              if (ln = bt(Ki[Fi]))
                return ln;
          }
        }
        for (var Pt = 0, zt = q.length; Pt < zt; Pt++) {
          var Wt = q[Pt], Ft = Wt._path, Mi = Wt.getValues(), yi;
          if ((!Pt || q[Pt - 1]._path !== Ft) && (at = null, Ft._closed || (yt = ze.getValues(
            Ft.getLastCurve().getSegment2(),
            Wt.getSegment1(),
            null,
            !N
          ), yt[te] !== yt[te + 6] && (at = yt)), !at)) {
            at = Mi;
            for (var Ai = Ft.getLastCurve(); Ai && Ai !== Wt; ) {
              var pi = Ai.getValues();
              if (pi[te] !== pi[te + 6]) {
                at = pi;
                break;
              }
              Ai = Ai.getPrevious();
            }
          }
          if (yi = Rt(Mi))
            return yi;
          if (Pt + 1 === zt || q[Pt + 1]._path !== Ft) {
            if (yt && (yi = Rt(yt)))
              return yi;
            st && !Ge && !Qe && (Ge = Qe = Ft.isClockwise(N) ^ C ? 1 : -1), Se += Ge, Ae += Qe, Ge = Qe = 0, st && (mt = !0, st = !1), yt = null;
          }
        }
        return Se = s(Se), Ae = s(Ae), {
          winding: r(Se, Ae),
          windingL: Se,
          windingR: Ae,
          quality: Re,
          onPath: mt
        };
      }
      function O(B, z, C, N, j) {
        var q = [], H = B, te = 0, se;
        do {
          var ae = B.getCurve();
          if (ae) {
            var le = ae.getLength();
            q.push({ segment: B, curve: ae, length: le }), te += le;
          }
          B = B.getNext();
        } while (B && !B._intersection && B !== H);
        for (var me = [0.5, 0.25, 0.75], se = { winding: 0, quality: -1 }, de = 1e-3, ve = 1 - de, we = 0; we < me.length && se.quality < 0.5; we++)
          for (var le = te * me[we], Se = 0, Ae = q.length; Se < Ae; Se++) {
            var Ge = q[Se], Qe = Ge.length;
            if (le <= Qe) {
              var ae = Ge.curve, st = ae._path, mt = st._parent, Re = mt instanceof It ? mt : st, Fe = I.clamp(ae.getTimeAt(le), de, ve), at = ae.getPointAtTime(Fe), yt = s(ae.getTangentAtTime(Fe).y) < Math.SQRT1_2, bt = null;
              if (j.subtract && C) {
                var Rt = Re === z ? C : z, Pt = Rt._getWinding(at, yt, !0);
                if (Re === z && Pt.winding || Re === C && !Pt.winding) {
                  if (Pt.quality < 1)
                    continue;
                  bt = { winding: 0, quality: 1 };
                }
              }
              bt = bt || G(
                at,
                N[st._id][ae.getIndex()],
                yt,
                !0
              ), bt.quality > se.quality && (se = bt);
              break;
            }
            le -= Qe;
          }
        for (var Se = q.length - 1; Se >= 0; Se--)
          q[Se].segment._winding = se;
      }
      function Y(B, z) {
        var C = [], N;
        function j(zt) {
          var Wt;
          return !!(zt && !zt._visited && (!z || z[(Wt = zt._winding || {}).winding] && !(z.unite && Wt.winding === 2 && Wt.windingL && Wt.windingR)));
        }
        function q(zt) {
          if (zt) {
            for (var Wt = 0, Ft = N.length; Wt < Ft; Wt++)
              if (zt === N[Wt])
                return !0;
          }
          return !1;
        }
        function H(zt) {
          for (var Wt = zt._segments, Ft = 0, Mi = Wt.length; Ft < Mi; Ft++)
            Wt[Ft]._visited = !0;
        }
        function te(zt, Wt) {
          var Ft = zt._intersection, Mi = Ft, yi = [];
          Wt && (N = [zt]);
          function Ai(pi, kt) {
            for (; pi && pi !== kt; ) {
              var fi = pi._segment, Ti = fi && fi._path;
              if (Ti) {
                var xi = fi.getNext() || Ti.getFirstSegment(), tn = xi._intersection;
                fi !== zt && (q(fi) || q(xi) || xi && j(fi) && (j(xi) || tn && j(tn._segment))) && yi.push(fi), Wt && N.push(fi);
              }
              pi = pi._next;
            }
          }
          if (Ft) {
            for (Ai(Ft); Ft && Ft._previous; )
              Ft = Ft._previous;
            Ai(Ft, Mi);
          }
          return yi;
        }
        B.sort(function(zt, Wt) {
          var Ft = zt._intersection, Mi = Wt._intersection, yi = !!(Ft && Ft._overlap), Ai = !!(Mi && Mi._overlap), pi = zt._path, kt = Wt._path;
          return yi ^ Ai ? yi ? 1 : -1 : !Ft ^ !Mi ? Ft ? 1 : -1 : pi !== kt ? pi._id - kt._id : zt._index - Wt._index;
        });
        for (var ae = 0, le = B.length; ae < le; ae++) {
          var me = B[ae], se = j(me), de = null, ve = !1, we = !0, Se = [], Ae, Ge, Qe;
          if (se && me._path._overlapsOnly) {
            var st = me._path, mt = me._intersection._segment._path;
            st.compare(mt) && (st.getArea() && C.push(st.clone(!1)), H(st), H(mt), se = !1);
          }
          for (; se; ) {
            var Re = !de, Fe = te(me, Re), at = Fe.shift(), ve = !Re && (q(me) || q(at)), yt = !ve && at;
            if (Re && (de = new $e(X.NO_INSERT), Ae = null), ve) {
              (me.isFirst() || me.isLast()) && (we = me._path._closed), me._visited = !0;
              break;
            }
            if (yt && Ae && (Se.push(Ae), Ae = null), Ae || (yt && Fe.push(me), Ae = {
              start: de._segments.length,
              crossings: Fe,
              visited: Ge = [],
              handleIn: Qe
            }), yt && (me = at), !j(me)) {
              de.removeSegments(Ae.start);
              for (var bt = 0, Rt = Ge.length; bt < Rt; bt++)
                Ge[bt]._visited = !1;
              Ge.length = 0;
              do
                me = Ae && Ae.crossings.shift(), (!me || !me._path) && (me = null, Ae = Se.pop(), Ae && (Ge = Ae.visited, Qe = Ae.handleIn));
              while (Ae && !j(me));
              if (!me)
                break;
            }
            var Pt = me.getNext();
            de.add(new ce(
              me._point,
              Qe,
              Pt && me._handleOut
            )), me._visited = !0, Ge.push(me), me = Pt || me._path.getFirstSegment(), Qe = Pt && Pt._handleIn;
          }
          ve && (we && (de.getFirstSegment().setHandleIn(Qe), de.setClosed(we)), de.getArea() !== 0 && C.push(de));
        }
        return C;
      }
      return {
        _getWinding: function(B, z, C) {
          return G(B, this.getCurves(), z, C);
        },
        unite: function(B, z) {
          return y(this, B, "unite", z);
        },
        intersect: function(B, z) {
          return y(this, B, "intersect", z);
        },
        subtract: function(B, z) {
          return y(this, B, "subtract", z);
        },
        exclude: function(B, z) {
          return y(this, B, "exclude", z);
        },
        divide: function(B, z) {
          return z && (z.trace == !1 || z.stroke) ? S(this, B, "divide") : p([
            this.subtract(B, z),
            this.intersect(B, z)
          ], !0, this, B, z);
        },
        resolveCrossings: function() {
          var B = this._children, z = B || [this];
          function C(Ae, Ge) {
            var Qe = Ae && Ae._intersection;
            return Qe && Qe._overlap && Qe._path === Ge;
          }
          var N = !1, j = !1, q = this.getIntersections(null, function(Ae) {
            return Ae.hasOverlap() && (N = !0) || Ae.isCrossing() && (j = !0);
          }), H = N && j && [];
          if (q = ht.expand(q), N)
            for (var te = T(q, function(Ae) {
              return Ae.hasOverlap();
            }, H), ae = te.length - 1; ae >= 0; ae--) {
              var le = te[ae], me = le._path, se = le._segment, de = se.getPrevious(), ve = se.getNext();
              C(de, me) && C(ve, me) && (se.remove(), de._handleOut._set(0, 0), ve._handleIn._set(0, 0), de !== se && !de.getCurve().hasLength() && (ve._handleIn.set(de._handleIn), de.remove()));
            }
          j && (T(q, N && function(Ae) {
            var Ge = Ae.getCurve(), Qe = Ae.getSegment(), st = Ae._intersection, mt = st._curve, Re = st._segment;
            if (Ge && mt && Ge._path && mt._path)
              return !0;
            Qe && (Qe._intersection = null), Re && (Re._intersection = null);
          }, H), H && E(H), z = Y(o.each(z, function(Ae) {
            o.push(this, Ae._segments);
          }, [])));
          var we = z.length, Se;
          return we > 1 && B ? (z !== B && this.setChildren(z), Se = this) : we === 1 && !B && (z[0] !== this && this.setSegments(z[0].removeSegments()), Se = this), Se || (Se = new It(X.NO_INSERT), Se.addChildren(z), Se = Se.reduce(), Se.copyAttributes(this), this.replaceWith(Se)), Se;
        },
        reorient: function(B, z) {
          var C = this._children;
          return C && C.length ? this.setChildren(A(
            this.removeChildren(),
            function(N) {
              return !!(B ? N : N & 1);
            },
            z
          )) : z !== t && this.setClockwise(z), this;
        },
        getInteriorPoint: function() {
          var B = this.getBounds(), z = B.getCenter(!0);
          if (!this.contains(z)) {
            for (var C = this.getCurves(), N = z.y, j = [], q = [], H = 0, te = C.length; H < te; H++) {
              var ae = C[H].getValues(), le = ae[1], me = ae[3], se = ae[5], de = ae[7];
              if (N >= i(le, me, se, de) && N <= r(le, me, se, de))
                for (var ve = ze.getMonoCurves(ae), we = 0, Se = ve.length; we < Se; we++) {
                  var Ae = ve[we], Ge = Ae[1], Qe = Ae[7];
                  if (Ge !== Qe && (N >= Ge && N <= Qe || N >= Qe && N <= Ge)) {
                    var st = N === Ge ? Ae[0] : N === Qe ? Ae[6] : ze.solveCubic(Ae, 1, N, q, 0, 1) === 1 ? ze.getPoint(Ae, q[0]).x : (Ae[0] + Ae[6]) / 2;
                    j.push(st);
                  }
                }
            }
            j.length > 1 && (j.sort(function(mt, Re) {
              return mt - Re;
            }), z.x = (j[0] + j[1]) / 2);
          }
          return z;
        }
      };
    }());
    var rt = o.extend(
      {
        _class: "PathFlattener",
        initialize: function(i, r, s, l, u) {
          var d = [], p = [], m = 0, y = 1 / (s || 32), S = i._segments, L = S[0], E;
          function A(Y, B) {
            var z = ze.getValues(Y, B, u);
            d.push(z), T(z, Y._index, 0, 1);
          }
          function T(Y, B, z, C) {
            if (C - z > y && !(l && ze.isStraight(Y)) && !ze.isFlatEnough(Y, r || 0.25)) {
              var N = ze.subdivide(Y, 0.5), j = (z + C) / 2;
              T(N[0], B, z, j), T(N[1], B, j, C);
            } else {
              var q = Y[6] - Y[0], H = Y[7] - Y[1], te = Math.sqrt(q * q + H * H);
              te > 0 && (m += te, p.push({
                offset: m,
                curve: Y,
                index: B,
                time: C
              }));
            }
          }
          for (var G = 1, O = S.length; G < O; G++)
            E = S[G], A(L, E), L = E;
          i._closed && A(E || L, S[0]), this.curves = d, this.parts = p, this.length = m, this.index = 0;
        },
        _get: function(i) {
          for (var r = this.parts, s = r.length, l, u = this.index; l = u, !(!u || r[--u].offset < i); )
            ;
          for (; l < s; l++) {
            var d = r[l];
            if (d.offset >= i) {
              this.index = l;
              var p = r[l - 1], m = p && p.index === d.index ? p.time : 0, y = p ? p.offset : 0;
              return {
                index: d.index,
                time: m + (d.time - m) * (i - y) / (d.offset - y)
              };
            }
          }
          return {
            index: r[s - 1].index,
            time: 1
          };
        },
        drawPart: function(i, r, s) {
          for (var l = this._get(r), u = this._get(s), d = l.index, p = u.index; d <= p; d++) {
            var m = ze.getPart(
              this.curves[d],
              d === l.index ? l.time : 0,
              d === u.index ? u.time : 1
            );
            d === l.index && i.moveTo(m[0], m[1]), i.bezierCurveTo.apply(i, m.slice(2));
          }
        }
      },
      o.each(
        ze._evaluateMethods,
        function(i) {
          this[i + "At"] = function(r) {
            var s = this._get(r);
            return ze[i](this.curves[s.index], s.time);
          };
        },
        {}
      )
    ), it = o.extend({
      initialize: function(i) {
        for (var r = this.points = [], s = i._segments, l = i._closed, u = 0, d, p = s.length; u < p; u++) {
          var m = s[u].point;
          (!d || !d.equals(m)) && r.push(d = m.clone());
        }
        l && (r.unshift(r[r.length - 1]), r.push(r[1])), this.closed = l;
      },
      fit: function(i) {
        var r = this.points, s = r.length, l = null;
        return s > 0 && (l = [new ce(r[0])], s > 1 && (this.fitCubic(
          l,
          i,
          0,
          s - 1,
          r[1].subtract(r[0]),
          r[s - 2].subtract(r[s - 1])
        ), this.closed && (l.shift(), l.pop()))), l;
      },
      fitCubic: function(i, r, s, l, u, d) {
        var p = this.points;
        if (l - s === 1) {
          var m = p[s], y = p[l], S = m.getDistance(y) / 3;
          this.addCurve(i, [
            m,
            m.add(u.normalize(S)),
            y.add(d.normalize(S)),
            y
          ]);
          return;
        }
        for (var L = this.chordLengthParameterize(s, l), E = Math.max(r, r * r), A, T = !0, G = 0; G <= 4; G++) {
          var O = this.generateBezier(s, l, L, u, d), Y = this.findMaxError(s, l, O, L);
          if (Y.error < r && T) {
            this.addCurve(i, O);
            return;
          }
          if (A = Y.index, Y.error >= E)
            break;
          T = this.reparameterize(s, l, L, O), E = Y.error;
        }
        var B = p[A - 1].subtract(p[A + 1]);
        this.fitCubic(i, r, s, A, u, B), this.fitCubic(i, r, A, l, B.negate(), d);
      },
      addCurve: function(i, r) {
        var s = i[i.length - 1];
        s.setHandleOut(r[1].subtract(r[0])), i.push(new ce(r[3], r[2].subtract(r[3])));
      },
      generateBezier: function(i, r, s, l, u) {
        for (var d = 1e-12, p = Math.abs, m = this.points, y = m[i], S = m[r], L = [[0, 0], [0, 0]], E = [0, 0], A = 0, T = r - i + 1; A < T; A++) {
          var G = s[A], O = 1 - G, Y = 3 * G * O, B = O * O * O, z = Y * O, C = Y * G, N = G * G * G, j = l.normalize(z), q = u.normalize(C), H = m[i + A].subtract(y.multiply(B + z)).subtract(S.multiply(C + N));
          L[0][0] += j.dot(j), L[0][1] += j.dot(q), L[1][0] = L[0][1], L[1][1] += q.dot(q), E[0] += j.dot(H), E[1] += q.dot(H);
        }
        var te = L[0][0] * L[1][1] - L[1][0] * L[0][1], ae, le;
        if (p(te) > d) {
          var me = L[0][0] * E[1] - L[1][0] * E[0], se = E[0] * L[1][1] - E[1] * L[0][1];
          ae = se / te, le = me / te;
        } else {
          var de = L[0][0] + L[0][1], ve = L[1][0] + L[1][1];
          ae = le = p(de) > d ? E[0] / de : p(ve) > d ? E[1] / ve : 0;
        }
        var we = S.getDistance(y), Se = d * we, Ae, Ge;
        if (ae < Se || le < Se)
          ae = le = we / 3;
        else {
          var Qe = S.subtract(y);
          Ae = l.normalize(ae), Ge = u.normalize(le), Ae.dot(Qe) - Ge.dot(Qe) > we * we && (ae = le = we / 3, Ae = Ge = null);
        }
        return [
          y,
          y.add(Ae || l.normalize(ae)),
          S.add(Ge || u.normalize(le)),
          S
        ];
      },
      reparameterize: function(i, r, s, l) {
        for (var u = i; u <= r; u++)
          s[u - i] = this.findRoot(l, this.points[u], s[u - i]);
        for (var u = 1, d = s.length; u < d; u++)
          if (s[u] <= s[u - 1])
            return !1;
        return !0;
      },
      findRoot: function(i, r, s) {
        for (var l = [], u = [], d = 0; d <= 2; d++)
          l[d] = i[d + 1].subtract(i[d]).multiply(3);
        for (var d = 0; d <= 1; d++)
          u[d] = l[d + 1].subtract(l[d]).multiply(2);
        var p = this.evaluate(3, i, s), m = this.evaluate(2, l, s), y = this.evaluate(1, u, s), S = p.subtract(r), L = m.dot(m) + S.dot(y);
        return I.isMachineZero(L) ? s : s - S.dot(m) / L;
      },
      evaluate: function(i, r, s) {
        for (var l = r.slice(), u = 1; u <= i; u++)
          for (var d = 0; d <= i - u; d++)
            l[d] = l[d].multiply(1 - s).add(l[d + 1].multiply(s));
        return l[0];
      },
      chordLengthParameterize: function(i, r) {
        for (var s = [0], l = i + 1; l <= r; l++)
          s[l - i] = s[l - i - 1] + this.points[l].getDistance(this.points[l - 1]);
        for (var l = 1, u = r - i; l <= u; l++)
          s[l] /= s[u];
        return s;
      },
      findMaxError: function(i, r, s, l) {
        for (var u = Math.floor((r - i + 1) / 2), d = 0, p = i + 1; p < r; p++) {
          var m = this.evaluate(3, s, l[p - i]), y = m.subtract(this.points[p]), S = y.x * y.x + y.y * y.y;
          S >= d && (d = S, u = p);
        }
        return {
          error: d,
          index: u
        };
      }
    }), Xt = X.extend({
      _class: "TextItem",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _serializeFields: {
        content: null
      },
      _boundsOptions: { stroke: !1, handle: !1 },
      initialize: function(r) {
        this._content = "", this._lines = [];
        var s = r && o.isPlainObject(r) && r.x === t && r.y === t;
        this._initialize(s && r, !s && M.read(arguments));
      },
      _equals: function(i) {
        return this._content === i._content;
      },
      copyContent: function(i) {
        this.setContent(i._content);
      },
      getContent: function() {
        return this._content;
      },
      setContent: function(i) {
        this._content = "" + i, this._lines = this._content.split(/\r\n|\n|\r/mg), this._changed(521);
      },
      isEmpty: function() {
        return !this._content;
      },
      getCharacterStyle: "#getStyle",
      setCharacterStyle: "#setStyle",
      getParagraphStyle: "#getStyle",
      setParagraphStyle: "#setStyle"
    }), $t = Xt.extend({
      _class: "PointText",
      initialize: function() {
        Xt.apply(this, arguments);
      },
      getPoint: function() {
        var i = this._matrix.getTranslation();
        return new W(i.x, i.y, this, "setPoint");
      },
      setPoint: function() {
        var i = M.read(arguments);
        this.translate(i.subtract(this._matrix.getTranslation()));
      },
      _draw: function(i, r, s) {
        if (this._content) {
          this._setStyles(i, r, s);
          var l = this._lines, u = this._style, d = u.hasFill(), p = u.hasStroke(), m = u.getLeading(), y = i.shadowColor;
          i.font = u.getFontStyle(), i.textAlign = u.getJustification();
          for (var S = 0, L = l.length; S < L; S++) {
            i.shadowColor = y;
            var E = l[S];
            d && (i.fillText(E, 0, 0), i.shadowColor = "rgba(0,0,0,0)"), p && i.strokeText(E, 0, 0), i.translate(0, m);
          }
        }
      },
      _getBounds: function(i, r) {
        var s = this._style, l = this._lines, u = l.length, d = s.getJustification(), p = s.getLeading(), m = this.getView().getTextWidth(s.getFontStyle(), l), y = 0;
        d !== "left" && (y -= m / (d === "center" ? 2 : 1));
        var S = new D(
          y,
          u ? -0.75 * p : 0,
          m,
          u * p
        );
        return i ? i._transformBounds(S, S) : S;
      }
    }), Tt = o.extend(
      new function() {
        var i = {
          gray: ["gray"],
          rgb: ["red", "green", "blue"],
          hsb: ["hue", "saturation", "brightness"],
          hsl: ["hue", "saturation", "lightness"],
          gradient: ["gradient", "origin", "destination", "highlight"]
        }, r = {}, s = {
          transparent: [0, 0, 0, 0]
        }, l;
        function u(m) {
          var y = m.match(
            /^#([\da-f]{2})([\da-f]{2})([\da-f]{2})([\da-f]{2})?$/i
          ) || m.match(
            /^#([\da-f])([\da-f])([\da-f])([\da-f])?$/i
          ), S = "rgb", L;
          if (y) {
            var E = y[4] ? 4 : 3;
            L = new Array(E);
            for (var A = 0; A < E; A++) {
              var T = y[A + 1];
              L[A] = parseInt(T.length == 1 ? T + T : T, 16) / 255;
            }
          } else if (y = m.match(/^(rgb|hsl)a?\((.*)\)$/)) {
            S = y[1], L = y[2].trim().split(/[,\s]+/g);
            for (var G = S === "hsl", A = 0, O = Math.min(L.length, 4); A < O; A++) {
              var Y = L[A], T = parseFloat(Y);
              if (G)
                if (A === 0) {
                  var B = Y.match(/([a-z]*)$/)[1];
                  T *= {
                    turn: 360,
                    rad: 180 / Math.PI,
                    grad: 0.9
                  }[B] || 1;
                } else
                  A < 3 && (T /= 100);
              else
                A < 3 && (T /= /%$/.test(Y) ? 100 : 255);
              L[A] = T;
            }
          } else {
            var z = s[m];
            if (!z)
              if (n) {
                l || (l = ft.getContext(1, 1, {
                  willReadFrequently: !0
                }), l.globalCompositeOperation = "copy"), l.fillStyle = "rgba(0,0,0,0)", l.fillStyle = m, l.fillRect(0, 0, 1, 1);
                var C = l.getImageData(0, 0, 1, 1).data;
                z = s[m] = [
                  C[0] / 255,
                  C[1] / 255,
                  C[2] / 255
                ];
              } else
                z = [0, 0, 0];
            L = z.slice();
          }
          return [S, L];
        }
        var d = [
          [0, 3, 1],
          [2, 0, 1],
          [1, 0, 3],
          [1, 2, 0],
          [3, 1, 0],
          [0, 1, 2]
        ], p = {
          "rgb-hsb": function(m, y, S) {
            var L = Math.max(m, y, S), E = Math.min(m, y, S), A = L - E, T = A === 0 ? 0 : (L == m ? (y - S) / A + (y < S ? 6 : 0) : L == y ? (S - m) / A + 2 : (m - y) / A + 4) * 60;
            return [T, L === 0 ? 0 : A / L, L];
          },
          "hsb-rgb": function(m, y, S) {
            m = (m / 60 % 6 + 6) % 6;
            var E = Math.floor(m), L = m - E, E = d[E], A = [
              S,
              S * (1 - y),
              S * (1 - y * L),
              S * (1 - y * (1 - L))
            ];
            return [A[E[0]], A[E[1]], A[E[2]]];
          },
          "rgb-hsl": function(m, y, S) {
            var L = Math.max(m, y, S), E = Math.min(m, y, S), A = L - E, T = A === 0, G = T ? 0 : (L == m ? (y - S) / A + (y < S ? 6 : 0) : L == y ? (S - m) / A + 2 : (m - y) / A + 4) * 60, O = (L + E) / 2, Y = T ? 0 : O < 0.5 ? A / (L + E) : A / (2 - L - E);
            return [G, Y, O];
          },
          "hsl-rgb": function(m, y, S) {
            if (m = (m / 360 % 1 + 1) % 1, y === 0)
              return [S, S, S];
            for (var L = [m + 1 / 3, m, m - 1 / 3], E = S < 0.5 ? S * (1 + y) : S + y - S * y, A = 2 * S - E, T = [], G = 0; G < 3; G++) {
              var O = L[G];
              O < 0 && (O += 1), O > 1 && (O -= 1), T[G] = 6 * O < 1 ? A + (E - A) * 6 * O : 2 * O < 1 ? E : 3 * O < 2 ? A + (E - A) * (2 / 3 - O) * 6 : A;
            }
            return T;
          },
          "rgb-gray": function(m, y, S) {
            return [m * 0.2989 + y * 0.587 + S * 0.114];
          },
          "gray-rgb": function(m) {
            return [m, m, m];
          },
          "gray-hsb": function(m) {
            return [0, 0, m];
          },
          "gray-hsl": function(m) {
            return [0, 0, m];
          },
          "gradient-rgb": function() {
            return [];
          },
          "rgb-gradient": function() {
            return [];
          }
        };
        return o.each(i, function(m, y) {
          r[y] = [], o.each(m, function(S, L) {
            var E = o.capitalize(S), A = /^(hue|saturation)$/.test(S), T = r[y][L] = y === "gradient" ? S === "gradient" ? function(G) {
              var O = this._components[0];
              return G = Bi.read(
                Array.isArray(G) ? G : arguments,
                0,
                { readNull: !0 }
              ), O !== G && (O && O._removeOwner(this), G && G._addOwner(this)), G;
            } : function() {
              return M.read(arguments, 0, {
                readNull: S === "highlight",
                clone: !0
              });
            } : function(G) {
              return G == null || isNaN(G) ? 0 : +G;
            };
            this["get" + E] = function() {
              return this._type === y || A && /^hs[bl]$/.test(this._type) ? this._components[L] : this._convert(y)[L];
            }, this["set" + E] = function(G) {
              this._type !== y && !(A && /^hs[bl]$/.test(this._type)) && (this._components = this._convert(y), this._properties = i[y], this._type = y), this._components[L] = T.call(this, G), this._changed();
            };
          }, this);
        }, {
          _class: "Color",
          _readIndex: !0,
          initialize: function m(y) {
            var S = arguments, L = this.__read, E = 0, A, T, G, O;
            Array.isArray(y) && (S = y, y = S[0]);
            var Y = y != null && typeof y;
            if (Y === "string" && y in i && (A = y, y = S[1], Array.isArray(y) ? (T = y, G = S[2]) : (L && (E = 1), S = o.slice(S, 1), Y = typeof y)), !T) {
              if (O = Y === "number" ? S : Y === "object" && y.length != null ? y : null, O) {
                A || (A = O.length >= 3 ? "rgb" : "gray");
                var B = i[A].length;
                G = O[B], L && (E += O === arguments ? B + (G != null ? 1 : 0) : 1), O.length > B && (O = o.slice(O, 0, B));
              } else if (Y === "string") {
                var z = u(y);
                A = z[0], T = z[1], T.length === 4 && (G = T[3], T.length--);
              } else if (Y === "object")
                if (y.constructor === m) {
                  if (A = y._type, T = y._components.slice(), G = y._alpha, A === "gradient")
                    for (var C = 1, N = T.length; C < N; C++) {
                      var j = T[C];
                      j && (T[C] = j.clone());
                    }
                } else if (y.constructor === Bi)
                  A = "gradient", O = S;
                else {
                  A = "hue" in y ? "lightness" in y ? "hsl" : "hsb" : "gradient" in y || "stops" in y || "radial" in y ? "gradient" : "gray" in y ? "gray" : "rgb";
                  var q = i[A], H = r[A];
                  this._components = T = [];
                  for (var C = 0, N = q.length; C < N; C++) {
                    var te = y[q[C]];
                    te == null && !C && A === "gradient" && "stops" in y && (te = {
                      stops: y.stops,
                      radial: y.radial
                    }), te = H[C].call(this, te), te != null && (T[C] = te);
                  }
                  G = y.alpha;
                }
              L && A && (E = 1);
            }
            if (this._type = A || "rgb", !T) {
              this._components = T = [];
              for (var H = r[this._type], C = 0, N = H.length; C < N; C++) {
                var te = H[C].call(this, O && O[C]);
                te != null && (T[C] = te);
              }
            }
            return this._components = T, this._properties = i[this._type], this._alpha = G, L && (this.__read = E), this;
          },
          set: "#initialize",
          _serialize: function(m, y) {
            var S = this.getComponents();
            return o.serialize(
              /^(gray|rgb)$/.test(this._type) ? S : [this._type].concat(S),
              m,
              !0,
              y
            );
          },
          _changed: function() {
            this._canvasStyle = null, this._owner && (this._setter ? this._owner[this._setter](this) : this._owner._changed(129));
          },
          _convert: function(m) {
            var y;
            return this._type === m ? this._components.slice() : (y = p[this._type + "-" + m]) ? y.apply(this, this._components) : p["rgb-" + m].apply(
              this,
              p[this._type + "-rgb"].apply(
                this,
                this._components
              )
            );
          },
          convert: function(m) {
            return new Tt(m, this._convert(m), this._alpha);
          },
          getType: function() {
            return this._type;
          },
          setType: function(m) {
            this._components = this._convert(m), this._properties = i[m], this._type = m;
          },
          getComponents: function() {
            var m = this._components.slice();
            return this._alpha != null && m.push(this._alpha), m;
          },
          getAlpha: function() {
            return this._alpha != null ? this._alpha : 1;
          },
          setAlpha: function(m) {
            this._alpha = m == null ? null : Math.min(Math.max(m, 0), 1), this._changed();
          },
          hasAlpha: function() {
            return this._alpha != null;
          },
          equals: function(m) {
            var y = o.isPlainValue(m, !0) ? Tt.read(arguments) : m;
            return y === this || y && this._class === y._class && this._type === y._type && this.getAlpha() === y.getAlpha() && o.equals(this._components, y._components) || !1;
          },
          toString: function() {
            for (var m = this._properties, y = [], S = this._type === "gradient", L = k.instance, E = 0, A = m.length; E < A; E++) {
              var T = this._components[E];
              T != null && y.push(m[E] + ": " + (S ? T : L.number(T)));
            }
            return this._alpha != null && y.push("alpha: " + L.number(this._alpha)), "{ " + y.join(", ") + " }";
          },
          toCSS: function(m) {
            var y = this._convert("rgb"), S = m || this._alpha == null ? 1 : this._alpha;
            function L(E) {
              return Math.round((E < 0 ? 0 : E > 1 ? 1 : E) * 255);
            }
            return y = [
              L(y[0]),
              L(y[1]),
              L(y[2])
            ], S < 1 && y.push(S < 0 ? 0 : S), m ? "#" + ((1 << 24) + (y[0] << 16) + (y[1] << 8) + y[2]).toString(16).slice(1) : (y.length == 4 ? "rgba(" : "rgb(") + y.join(",") + ")";
          },
          toCanvasStyle: function(m, y) {
            if (this._canvasStyle)
              return this._canvasStyle;
            if (this._type !== "gradient")
              return this._canvasStyle = this.toCSS();
            var S = this._components, L = S[0], E = L._stops, A = S[1], T = S[2], G = S[3], O = y && y.inverted(), Y;
            if (O && (A = O._transformPoint(A), T = O._transformPoint(T), G && (G = O._transformPoint(G))), L._radial) {
              var B = T.getDistance(A);
              if (G) {
                var z = G.subtract(A);
                z.getLength() > B && (G = A.add(z.normalize(B - 0.1)));
              }
              var C = G || A;
              Y = m.createRadialGradient(
                C.x,
                C.y,
                0,
                A.x,
                A.y,
                B
              );
            } else
              Y = m.createLinearGradient(
                A.x,
                A.y,
                T.x,
                T.y
              );
            for (var N = 0, j = E.length; N < j; N++) {
              var q = E[N], H = q._offset;
              Y.addColorStop(
                H ?? N / (j - 1),
                q._color.toCanvasStyle()
              );
            }
            return this._canvasStyle = Y;
          },
          transform: function(m) {
            if (this._type === "gradient") {
              for (var y = this._components, S = 1, L = y.length; S < L; S++) {
                var E = y[S];
                m._transformPoint(E, E, !0);
              }
              this._changed();
            }
          },
          statics: {
            _types: i,
            random: function() {
              var m = Math.random;
              return new Tt(m(), m(), m());
            },
            _setOwner: function(m, y, S) {
              return m && (m._owner && y && m._owner !== y && (m = m.clone()), !m._owner ^ !y && (m._owner = y || null, m._setter = S || null)), m;
            }
          }
        });
      }(),
      new function() {
        var i = {
          add: function(r, s) {
            return r + s;
          },
          subtract: function(r, s) {
            return r - s;
          },
          multiply: function(r, s) {
            return r * s;
          },
          divide: function(r, s) {
            return r / s;
          }
        };
        return o.each(i, function(r, s) {
          this[s] = function(l) {
            l = Tt.read(arguments);
            for (var u = this._type, d = this._components, p = l._convert(u), m = 0, y = d.length; m < y; m++)
              p[m] = r(d[m], p[m]);
            return new Tt(
              u,
              p,
              this._alpha != null ? r(this._alpha, l.getAlpha()) : null
            );
          };
        }, {});
      }()
    ), Bi = o.extend({
      _class: "Gradient",
      initialize: function(r, s) {
        this._id = V.get(), r && o.isPlainObject(r) && (this.set(r), r = s = null), this._stops == null && this.setStops(r || ["white", "black"]), this._radial == null && this.setRadial(typeof s == "string" && s === "radial" || s || !1);
      },
      _serialize: function(i, r) {
        return r.add(this, function() {
          return o.serialize(
            [this._stops, this._radial],
            i,
            !0,
            r
          );
        });
      },
      _changed: function() {
        for (var i = 0, r = this._owners && this._owners.length; i < r; i++)
          this._owners[i]._changed();
      },
      _addOwner: function(i) {
        this._owners || (this._owners = []), this._owners.push(i);
      },
      _removeOwner: function(i) {
        var r = this._owners ? this._owners.indexOf(i) : -1;
        r != -1 && (this._owners.splice(r, 1), this._owners.length || (this._owners = t));
      },
      clone: function() {
        for (var i = [], r = 0, s = this._stops.length; r < s; r++)
          i[r] = this._stops[r].clone();
        return new Bi(i, this._radial);
      },
      getStops: function() {
        return this._stops;
      },
      setStops: function(i) {
        if (i.length < 2)
          throw new Error(
            "Gradient stop list needs to contain at least two stops."
          );
        var r = this._stops;
        if (r)
          for (var s = 0, l = r.length; s < l; s++)
            r[s]._owner = t;
        r = this._stops = en.readList(i, 0, { clone: !0 });
        for (var s = 0, l = r.length; s < l; s++)
          r[s]._owner = this;
        this._changed();
      },
      getRadial: function() {
        return this._radial;
      },
      setRadial: function(i) {
        this._radial = i, this._changed();
      },
      equals: function(i) {
        if (i === this)
          return !0;
        if (i && this._class === i._class) {
          var r = this._stops, s = i._stops, l = r.length;
          if (l === s.length) {
            for (var u = 0; u < l; u++)
              if (!r[u].equals(s[u]))
                return !1;
            return !0;
          }
        }
        return !1;
      }
    }), en = o.extend({
      _class: "GradientStop",
      initialize: function(r, s) {
        var l = r, u = s;
        typeof r == "object" && s === t && (Array.isArray(r) && typeof r[0] != "number" ? (l = r[0], u = r[1]) : ("color" in r || "offset" in r || "rampPoint" in r) && (l = r.color, u = r.offset || r.rampPoint || 0)), this.setColor(l), this.setOffset(u);
      },
      clone: function() {
        return new en(this._color.clone(), this._offset);
      },
      _serialize: function(i, r) {
        var s = this._color, l = this._offset;
        return o.serialize(
          l == null ? [s] : [s, l],
          i,
          !0,
          r
        );
      },
      _changed: function() {
        this._owner && this._owner._changed(129);
      },
      getOffset: function() {
        return this._offset;
      },
      setOffset: function(i) {
        this._offset = i, this._changed();
      },
      getRampPoint: "#getOffset",
      setRampPoint: "#setOffset",
      getColor: function() {
        return this._color;
      },
      setColor: function() {
        Tt._setOwner(this._color, null), this._color = Tt._setOwner(
          Tt.read(arguments, 0),
          this,
          "setColor"
        ), this._changed();
      },
      equals: function(i) {
        return i === this || i && this._class === i._class && this._color.equals(i._color) && this._offset == i._offset || !1;
      }
    }), oi = o.extend(new function() {
      var i = {
        fillColor: null,
        fillRule: "nonzero",
        strokeColor: null,
        strokeWidth: 1,
        strokeCap: "butt",
        strokeJoin: "miter",
        strokeScaling: !0,
        miterLimit: 10,
        dashOffset: 0,
        dashArray: [],
        shadowColor: null,
        shadowBlur: 0,
        shadowOffset: new M(),
        selectedColor: null
      }, r = o.set({}, i, {
        fontFamily: "sans-serif",
        fontWeight: "normal",
        fontSize: 12,
        leading: null,
        justification: "left"
      }), s = o.set({}, r, {
        fillColor: new Tt()
      }), l = {
        strokeWidth: 193,
        strokeCap: 193,
        strokeJoin: 193,
        strokeScaling: 201,
        miterLimit: 193,
        fontFamily: 9,
        fontWeight: 9,
        fontSize: 9,
        font: 9,
        leading: 9,
        justification: 9
      }, u = {
        beans: !0
      }, d = {
        _class: "Style",
        beans: !0,
        initialize: function(m, y, S) {
          this._values = {}, this._owner = y, this._project = y && y._project || S || Ve.project, this._defaults = !y || y instanceof Z ? r : y instanceof Xt ? s : i, m && this.set(m);
        }
      };
      return o.each(r, function(p, m) {
        var y = /Color$/.test(m), S = m === "shadowOffset", L = o.capitalize(m), E = l[m], A = "set" + L, T = "get" + L;
        d[A] = function(G) {
          var O = this._owner, Y = O && O._children, B = Y && Y.length > 0 && !(O instanceof It);
          if (B)
            for (var z = 0, C = Y.length; z < C; z++)
              Y[z]._style[A](G);
          if ((m === "selectedColor" || !B) && m in this._defaults) {
            var N = this._values[m];
            N !== G && (y && (N && (Tt._setOwner(N, null), N._canvasStyle = null), G && G.constructor === Tt && (G = Tt._setOwner(
              G,
              O,
              B && A
            ))), this._values[m] = G, O && O._changed(E || 129));
          }
        }, d[T] = function(G) {
          var O = this._owner, Y = O && O._children, B = Y && Y.length > 0 && !(O instanceof It), z;
          if (B && !G)
            for (var C = 0, N = Y.length; C < N; C++) {
              var j = Y[C]._style[T]();
              if (!C)
                z = j;
              else if (!o.equals(z, j))
                return t;
            }
          else if (m in this._defaults) {
            var z = this._values[m];
            if (z === t)
              z = this._defaults[m], z && z.clone && (z = z.clone());
            else {
              var q = y ? Tt : S ? M : null;
              q && !(z && z.constructor === q) && (this._values[m] = z = q.read(
                [z],
                0,
                { readNull: !0, clone: !0 }
              ));
            }
          }
          return z && y && (z = Tt._setOwner(z, O, B && A)), z;
        }, u[T] = function(G) {
          return this._style[T](G);
        }, u[A] = function(G) {
          this._style[A](G);
        };
      }), o.each({
        Font: "FontFamily",
        WindingRule: "FillRule"
      }, function(p, m) {
        var y = "get" + m, S = "set" + m;
        d[y] = u[y] = "#get" + p, d[S] = u[S] = "#set" + p;
      }), X.inject(u), d;
    }(), {
      set: function(i) {
        var r = i instanceof oi, s = r ? i._values : i;
        if (s) {
          for (var l in s)
            if (l in this._defaults) {
              var u = s[l];
              this[l] = u && r && u.clone ? u.clone() : u;
            }
        }
      },
      equals: function(i) {
        function r(s, l, u) {
          var d = s._values, p = l._values, m = l._defaults;
          for (var y in d) {
            var S = d[y], L = p[y];
            if (!(u && y in p) && !o.equals(
              S,
              L === t ? m[y] : L
            ))
              return !1;
          }
          return !0;
        }
        return i === this || i && this._class === i._class && r(this, i) && r(i, this, !0) || !1;
      },
      _dispose: function() {
        var i;
        i = this.getFillColor(), i && (i._canvasStyle = null), i = this.getStrokeColor(), i && (i._canvasStyle = null), i = this.getShadowColor(), i && (i._canvasStyle = null);
      },
      hasFill: function() {
        var i = this.getFillColor();
        return !!i && i.alpha > 0;
      },
      hasStroke: function() {
        var i = this.getStrokeColor();
        return !!i && i.alpha > 0 && this.getStrokeWidth() > 0;
      },
      hasShadow: function() {
        var i = this.getShadowColor();
        return !!i && i.alpha > 0 && (this.getShadowBlur() > 0 || !this.getShadowOffset().isZero());
      },
      getView: function() {
        return this._project._view;
      },
      getFontStyle: function() {
        var i = this.getFontSize();
        return this.getFontWeight() + " " + i + (/[a-z]/i.test(i + "") ? " " : "px ") + this.getFontFamily();
      },
      getFont: "#getFontFamily",
      setFont: "#setFontFamily",
      getLeading: function i() {
        var r = i.base.call(this), s = this.getFontSize();
        return /pt|em|%|px/.test(s) && (s = this.getView().getPixelSize(s)), r ?? s * 1.2;
      }
    }), Zt = new function() {
      function i(r, s, l, u) {
        for (var d = ["", "webkit", "moz", "Moz", "ms", "o"], p = s[0].toUpperCase() + s.substring(1), m = 0; m < 6; m++) {
          var y = d[m], S = y ? y + p : s;
          if (S in r) {
            if (l)
              r[S] = u;
            else
              return r[S];
            break;
          }
        }
      }
      return {
        getStyles: function(r) {
          var s = r && r.nodeType !== 9 ? r.ownerDocument : r, l = s && s.defaultView;
          return l && l.getComputedStyle(r, "");
        },
        getBounds: function(r, s) {
          var l = r.ownerDocument, u = l.body, d = l.documentElement, p;
          try {
            p = r.getBoundingClientRect();
          } catch {
            p = { left: 0, top: 0, width: 0, height: 0 };
          }
          var m = p.left - (d.clientLeft || u.clientLeft || 0), y = p.top - (d.clientTop || u.clientTop || 0);
          if (!s) {
            var S = l.defaultView;
            m += S.pageXOffset || d.scrollLeft || u.scrollLeft, y += S.pageYOffset || d.scrollTop || u.scrollTop;
          }
          return new D(m, y, p.width, p.height);
        },
        getViewportBounds: function(r) {
          var s = r.ownerDocument, l = s.defaultView, u = s.documentElement;
          return new D(
            0,
            0,
            l.innerWidth || u.clientWidth,
            l.innerHeight || u.clientHeight
          );
        },
        getOffset: function(r, s) {
          return Zt.getBounds(r, s).getPoint();
        },
        getSize: function(r) {
          return Zt.getBounds(r, !0).getSize();
        },
        isInvisible: function(r) {
          return Zt.getSize(r).equals(new U(0, 0));
        },
        isInView: function(r) {
          return !Zt.isInvisible(r) && Zt.getViewportBounds(r).intersects(
            Zt.getBounds(r, !0)
          );
        },
        isInserted: function(r) {
          return a.body.contains(r);
        },
        getPrefixed: function(r, s) {
          return r && i(r, s);
        },
        setPrefixed: function(r, s, l) {
          if (typeof s == "object")
            for (var u in s)
              i(r, u, !0, s[u]);
          else
            i(r, s, !0, l);
        }
      };
    }(), Jt = {
      add: function(i, r) {
        if (i)
          for (var s in r)
            for (var l = r[s], u = s.split(/[\s,]+/g), d = 0, p = u.length; d < p; d++) {
              var m = u[d], y = i === a && (m === "touchstart" || m === "touchmove") ? { passive: !1 } : !1;
              i.addEventListener(m, l, y);
            }
      },
      remove: function(i, r) {
        if (i)
          for (var s in r)
            for (var l = r[s], u = s.split(/[\s,]+/g), d = 0, p = u.length; d < p; d++)
              i.removeEventListener(u[d], l, !1);
      },
      getPoint: function(i) {
        var r = i.targetTouches ? i.targetTouches.length ? i.targetTouches[0] : i.changedTouches[0] : i;
        return new M(
          r.pageX || r.clientX + a.documentElement.scrollLeft,
          r.pageY || r.clientY + a.documentElement.scrollTop
        );
      },
      getTarget: function(i) {
        return i.target || i.srcElement;
      },
      getRelatedTarget: function(i) {
        return i.relatedTarget || i.toElement;
      },
      getOffset: function(i, r) {
        return Jt.getPoint(i).subtract(Zt.getOffset(
          r || Jt.getTarget(i)
        ));
      }
    };
    Jt.requestAnimationFrame = new function() {
      var i = Zt.getPrefixed(n, "requestAnimationFrame"), r = !1, s = [], l;
      function u() {
        var d = s;
        s = [];
        for (var p = 0, m = d.length; p < m; p++)
          d[p]();
        r = i && s.length, r && i(u);
      }
      return function(d) {
        s.push(d), i ? r || (i(u), r = !0) : l || (l = setInterval(u, 1e3 / 60));
      };
    }();
    var Qt = o.extend(
      h,
      {
        _class: "View",
        initialize: function i(r, s) {
          function l(E) {
            return s[E] || parseInt(s.getAttribute(E), 10);
          }
          function u() {
            var E = Zt.getSize(s);
            return E.isNaN() || E.isZero() ? new U(l("width"), l("height")) : E;
          }
          var d;
          if (n && s) {
            this._id = s.getAttribute("id"), this._id == null && s.setAttribute("id", this._id = "paper-view-" + i._id++), Jt.add(s, this._viewEvents);
            var p = "none";
            if (Zt.setPrefixed(s.style, {
              userDrag: p,
              userSelect: p,
              touchCallout: p,
              contentZooming: p,
              tapHighlightColor: "rgba(0,0,0,0)"
            }), f.hasAttribute(s, "resize")) {
              var m = this;
              Jt.add(n, this._windowEvents = {
                resize: function() {
                  m.setViewSize(u());
                }
              });
            }
            if (d = u(), f.hasAttribute(s, "stats") && typeof Stats < "u") {
              this._stats = new Stats();
              var y = this._stats.domElement, S = y.style, L = Zt.getOffset(s);
              S.position = "absolute", S.left = L.x + "px", S.top = L.y + "px", a.body.appendChild(y);
            }
          } else
            d = new U(s), s = null;
          this._project = r, this._scope = r._scope, this._element = s, this._pixelRatio || (this._pixelRatio = n && n.devicePixelRatio || 1), this._setElementSize(d.width, d.height), this._viewSize = d, i._views.push(this), i._viewsById[this._id] = this, (this._matrix = new J())._owner = this, i._focused || (i._focused = this), this._frameItems = {}, this._frameItemCount = 0, this._itemEvents = { native: {}, virtual: {} }, this._autoUpdate = !Ve.agent.node, this._needsUpdate = !1;
        },
        remove: function() {
          if (!this._project)
            return !1;
          Qt._focused === this && (Qt._focused = null), Qt._views.splice(Qt._views.indexOf(this), 1), delete Qt._viewsById[this._id];
          var i = this._project;
          return i._view === this && (i._view = null), Jt.remove(this._element, this._viewEvents), Jt.remove(n, this._windowEvents), this._element = this._project = null, this.off("frame"), this._animate = !1, this._frameItems = {}, !0;
        },
        _events: o.each(
          X._itemHandlers.concat(["onResize", "onKeyDown", "onKeyUp"]),
          function(i) {
            this[i] = {};
          },
          {
            onFrame: {
              install: function() {
                this.play();
              },
              uninstall: function() {
                this.pause();
              }
            }
          }
        ),
        _animate: !1,
        _time: 0,
        _count: 0,
        getAutoUpdate: function() {
          return this._autoUpdate;
        },
        setAutoUpdate: function(i) {
          this._autoUpdate = i, i && this.requestUpdate();
        },
        update: function() {
        },
        draw: function() {
          this.update();
        },
        requestUpdate: function() {
          if (!this._requested) {
            var i = this;
            Jt.requestAnimationFrame(function() {
              if (i._requested = !1, i._animate) {
                i.requestUpdate();
                var r = i._element;
                (!Zt.getPrefixed(a, "hidden") || f.getAttribute(r, "keepalive") === "true") && Zt.isInView(r) && i._handleFrame();
              }
              i._autoUpdate && i.update();
            }), this._requested = !0;
          }
        },
        play: function() {
          this._animate = !0, this.requestUpdate();
        },
        pause: function() {
          this._animate = !1;
        },
        _handleFrame: function() {
          Ve = this._scope;
          var i = Date.now() / 1e3, r = this._last ? i - this._last : 0;
          this._last = i, this.emit("frame", new o({
            delta: r,
            time: this._time += r,
            count: this._count++
          })), this._stats && this._stats.update();
        },
        _animateItem: function(i, r) {
          var s = this._frameItems;
          r ? (s[i._id] = {
            item: i,
            time: 0,
            count: 0
          }, ++this._frameItemCount === 1 && this.on("frame", this._handleFrameItems)) : (delete s[i._id], --this._frameItemCount === 0 && this.off("frame", this._handleFrameItems));
        },
        _handleFrameItems: function(i) {
          for (var r in this._frameItems) {
            var s = this._frameItems[r];
            s.item.emit("frame", new o(i, {
              time: s.time += i.delta,
              count: s.count++
            }));
          }
        },
        _changed: function() {
          this._project._changed(4097), this._bounds = this._decomposed = t;
        },
        getElement: function() {
          return this._element;
        },
        getPixelRatio: function() {
          return this._pixelRatio;
        },
        getResolution: function() {
          return this._pixelRatio * 72;
        },
        getViewSize: function() {
          var i = this._viewSize;
          return new Q(i.width, i.height, this, "setViewSize");
        },
        setViewSize: function() {
          var i = U.read(arguments), r = i.subtract(this._viewSize);
          r.isZero() || (this._setElementSize(i.width, i.height), this._viewSize.set(i), this._changed(), this.emit("resize", { size: i, delta: r }), this._autoUpdate && this.update());
        },
        _setElementSize: function(i, r) {
          var s = this._element;
          s && (s.width !== i && (s.width = i), s.height !== r && (s.height = r));
        },
        getBounds: function() {
          return this._bounds || (this._bounds = this._matrix.inverted()._transformBounds(
            new D(new M(), this._viewSize)
          )), this._bounds;
        },
        getSize: function() {
          return this.getBounds().getSize();
        },
        isVisible: function() {
          return Zt.isInView(this._element);
        },
        isInserted: function() {
          return Zt.isInserted(this._element);
        },
        getPixelSize: function(i) {
          var r = this._element, s;
          if (r) {
            var l = r.parentNode, u = a.createElement("div");
            u.style.fontSize = i, l.appendChild(u), s = parseFloat(Zt.getStyles(u).fontSize), l.removeChild(u);
          } else
            s = parseFloat(s);
          return s;
        },
        getTextWidth: function(i, r) {
          return 0;
        }
      },
      o.each(["rotate", "scale", "shear", "skew"], function(i) {
        var r = i === "rotate";
        this[i] = function() {
          var s = arguments, l = (r ? o : M).read(s), u = M.read(s, 0, { readNull: !0 });
          return this.transform(new J()[i](
            l,
            u || this.getCenter(!0)
          ));
        };
      }, {
        _decompose: function() {
          return this._decomposed || (this._decomposed = this._matrix.decompose());
        },
        translate: function() {
          var i = new J();
          return this.transform(i.translate.apply(i, arguments));
        },
        getCenter: function() {
          return this.getBounds().getCenter();
        },
        setCenter: function() {
          var i = M.read(arguments);
          this.translate(this.getCenter().subtract(i));
        },
        getZoom: function() {
          var i = this._decompose().scaling;
          return (i.x + i.y) / 2;
        },
        setZoom: function(i) {
          this.transform(new J().scale(
            i / this.getZoom(),
            this.getCenter()
          ));
        },
        getRotation: function() {
          return this._decompose().rotation;
        },
        setRotation: function(i) {
          var r = this.getRotation();
          r != null && i != null && this.rotate(i - r);
        },
        getScaling: function() {
          var i = this._decompose().scaling;
          return new W(i.x, i.y, this, "setScaling");
        },
        setScaling: function() {
          var i = this.getScaling(), r = M.read(arguments, 0, { clone: !0, readNull: !0 });
          i && r && this.scale(r.x / i.x, r.y / i.y);
        },
        getMatrix: function() {
          return this._matrix;
        },
        setMatrix: function() {
          var i = this._matrix;
          i.set.apply(i, arguments);
        },
        transform: function(i) {
          this._matrix.append(i);
        },
        scrollBy: function() {
          this.translate(M.read(arguments).negate());
        }
      }),
      {
        projectToView: function() {
          return this._matrix._transformPoint(M.read(arguments));
        },
        viewToProject: function() {
          return this._matrix._inverseTransform(M.read(arguments));
        },
        getEventPoint: function(i) {
          return this.viewToProject(Jt.getOffset(i, this._element));
        }
      },
      {
        statics: {
          _views: [],
          _viewsById: {},
          _id: 0,
          create: function(i, r) {
            a && typeof r == "string" && (r = a.getElementById(r));
            var s = n ? rn : Qt;
            return new s(i, r);
          }
        }
      },
      new function() {
        if (!n)
          return;
        var i, r, s = !1, l = !1;
        function u(se) {
          var de = Jt.getTarget(se);
          return de.getAttribute && Qt._viewsById[de.getAttribute("id")];
        }
        function d() {
          var se = Qt._focused;
          if (!se || !se.isVisible()) {
            for (var de = 0, ve = Qt._views.length; de < ve; de++)
              if ((se = Qt._views[de]).isVisible()) {
                Qt._focused = r = se;
                break;
              }
          }
        }
        function p(se, de, ve) {
          se._handleMouseEvent("mousemove", de, ve);
        }
        var m = n.navigator, y, S, L;
        m.pointerEnabled || m.msPointerEnabled ? (y = "pointerdown MSPointerDown", S = "pointermove MSPointerMove", L = "pointerup pointercancel MSPointerUp MSPointerCancel") : (y = "touchstart", S = "touchmove", L = "touchend touchcancel", "ontouchstart" in n && m.userAgent.match(
          /mobile|tablet|ip(ad|hone|od)|android|silk/i
        ) || (y += " mousedown", S += " mousemove", L += " mouseup"));
        var E = {}, A = {
          mouseout: function(se) {
            var de = Qt._focused, ve = Jt.getRelatedTarget(se);
            if (de && (!ve || ve.nodeName === "HTML")) {
              var we = Jt.getOffset(se, de._element), Se = we.x, Ae = Math.abs, Ge = Ae(Se), Qe = 1 << 25, st = Ge - Qe;
              we.x = Ae(st) < Ge ? st * (Se < 0 ? -1 : 1) : Se, p(de, se, de.viewToProject(we));
            }
          },
          scroll: d
        };
        E[y] = function(se) {
          var de = Qt._focused = u(se);
          s || (s = !0, de._handleMouseEvent("mousedown", se));
        }, A[S] = function(se) {
          var de = Qt._focused;
          if (!l) {
            var ve = u(se);
            ve ? de !== ve && (de && p(de, se), i || (i = de), de = Qt._focused = r = ve) : r && r === de && (i && !i.isInserted() && (i = null), de = Qt._focused = i, i = null, d());
          }
          de && p(de, se);
        }, A[y] = function() {
          l = !0;
        }, A[L] = function(se) {
          var de = Qt._focused;
          de && s && de._handleMouseEvent("mouseup", se), l = s = !1;
        }, Jt.add(a, A), Jt.add(n, {
          load: d
        });
        var T = !1, G = !1, O = {
          doubleclick: "click",
          mousedrag: "mousemove"
        }, Y = !1, B, z, C, N, j, q, H, te;
        function ae(se, de, ve, we, Se, Ae, Ge) {
          var Qe = !1, st;
          function mt(Re, Fe) {
            if (Re.responds(Fe)) {
              if (st || (st = new xt(
                Fe,
                we,
                Se,
                de || Re,
                Ae ? Se.subtract(Ae) : null
              )), Re.emit(Fe, st) && (T = !0, st.prevented && (G = !0), st.stopped))
                return Qe = !0;
            } else {
              var at = O[Fe];
              if (at)
                return mt(Re, at);
            }
          }
          for (; se && se !== Ge && !mt(se, ve); )
            se = se._parent;
          return Qe;
        }
        function le(se, de, ve, we, Se, Ae) {
          return se._project.removeOn(ve), G = T = !1, j && ae(
            j,
            null,
            ve,
            we,
            Se,
            Ae
          ) || de && de !== j && !de.isDescendant(j) && ae(de, null, ve === "mousedrag" ? "mousemove" : ve, we, Se, Ae, j) || ae(
            se,
            j || de || se,
            ve,
            we,
            Se,
            Ae
          );
        }
        var me = {
          mousedown: {
            mousedown: 1,
            mousedrag: 1,
            click: 1,
            doubleclick: 1
          },
          mouseup: {
            mouseup: 1,
            mousedrag: 1,
            click: 1,
            doubleclick: 1
          },
          mousemove: {
            mousedrag: 1,
            mousemove: 1,
            mouseenter: 1,
            mouseleave: 1
          }
        };
        return {
          _viewEvents: E,
          _handleMouseEvent: function(se, de, ve) {
            var we = this._itemEvents, Se = we.native[se], Ae = se === "mousemove", Ge = this._scope.tool, Qe = this;
            function st(Rt) {
              return we.virtual[Rt] || Qe.responds(Rt) || Ge && Ge.responds(Rt);
            }
            Ae && s && st("mousedrag") && (se = "mousedrag"), ve || (ve = this.getEventPoint(de));
            var mt = this.getBounds().contains(ve), Re = Se && mt && Qe._project.hitTest(ve, {
              tolerance: 0,
              fill: !0,
              stroke: !0
            }), Fe = Re && Re.item || null, at = !1, yt = {};
            if (yt[se.substr(5)] = !0, Se && Fe !== N && (N && ae(N, null, "mouseleave", de, ve), Fe && ae(Fe, null, "mouseenter", de, ve), N = Fe), Y ^ mt && (ae(
              this,
              null,
              mt ? "mouseenter" : "mouseleave",
              de,
              ve
            ), at = !0), (mt || yt.drag) && !ve.equals(z) && (le(
              this,
              Fe,
              Ae ? se : "mousemove",
              de,
              ve,
              z
            ), at = !0), Y = mt, yt.down && mt || yt.up && B) {
              if (le(this, Fe, se, de, ve, B), yt.down) {
                if (te = Fe === q && Date.now() - H < 300, C = q = Fe, !G && Fe) {
                  for (var bt = Fe; bt && !bt.responds("mousedrag"); )
                    bt = bt._parent;
                  bt && (j = Fe);
                }
                B = ve;
              } else
                yt.up && (!G && Fe === C && (H = Date.now(), le(this, Fe, te ? "doubleclick" : "click", de, ve, B), te = !1), C = j = null);
              Y = !1, at = !0;
            }
            z = ve, at && Ge && (T = Ge._handleMouseEvent(se, de, ve, yt) || T), de.cancelable !== !1 && (T && !yt.move || yt.down && st("mouseup")) && de.preventDefault();
          },
          _handleKeyEvent: function(se, de, ve, we) {
            var Se = this._scope, Ae = Se.tool, Ge;
            function Qe(st) {
              st.responds(se) && (Ve = Se, st.emit(se, Ge = Ge || new pe(se, de, ve, we)));
            }
            this.isVisible() && (Qe(this), Ae && Ae.responds(se) && Qe(Ae));
          },
          _countItemEvent: function(se, de) {
            var ve = this._itemEvents, we = ve.native, Se = ve.virtual;
            for (var Ae in me)
              we[Ae] = (we[Ae] || 0) + (me[Ae][se] || 0) * de;
            Se[se] = (Se[se] || 0) + de;
          },
          statics: {
            updateFocus: d,
            _resetState: function() {
              s = l = T = Y = !1, i = r = B = z = C = N = j = q = H = te = null;
            }
          }
        };
      }()
    ), rn = Qt.extend({
      _class: "CanvasView",
      initialize: function(r, s) {
        if (!(s instanceof n.HTMLCanvasElement)) {
          var l = U.read(arguments, 1);
          if (l.isZero())
            throw new Error(
              "Cannot create CanvasView with the provided argument: " + o.slice(arguments, 1)
            );
          s = ft.getCanvas(l);
        }
        var u = this._context = s.getContext("2d");
        if (u.save(), this._pixelRatio = 1, !/^off|false$/.test(f.getAttribute(s, "hidpi"))) {
          var d = n.devicePixelRatio || 1, p = Zt.getPrefixed(
            u,
            "backingStorePixelRatio"
          ) || 1;
          this._pixelRatio = d / p;
        }
        Qt.call(this, r, s), this._needsUpdate = !0;
      },
      remove: function i() {
        return this._context.restore(), i.base.call(this);
      },
      _setElementSize: function i(r, s) {
        var l = this._pixelRatio;
        if (i.base.call(this, r * l, s * l), l !== 1) {
          var u = this._element, d = this._context;
          if (!f.hasAttribute(u, "resize")) {
            var p = u.style;
            p.width = r + "px", p.height = s + "px";
          }
          d.restore(), d.save(), d.scale(l, l);
        }
      },
      getContext: function() {
        return this._context;
      },
      getPixelSize: function i(r) {
        var s = Ve.agent, l;
        if (s && s.firefox)
          l = i.base.call(this, r);
        else {
          var u = this._context, d = u.font;
          u.font = r + " serif", l = parseFloat(u.font), u.font = d;
        }
        return l;
      },
      getTextWidth: function(i, r) {
        var s = this._context, l = s.font, u = 0;
        s.font = i;
        for (var d = 0, p = r.length; d < p; d++)
          u = Math.max(u, s.measureText(r[d]).width);
        return s.font = l, u;
      },
      update: function() {
        if (!this._needsUpdate)
          return !1;
        var i = this._project, r = this._context, s = this._viewSize;
        return r.clearRect(0, 0, s.width + 1, s.height + 1), i && i.draw(r, this._matrix, this._pixelRatio), this._needsUpdate = !1, !0;
      }
    }), Gi = o.extend({
      _class: "Event",
      initialize: function(r) {
        this.event = r, this.type = r && r.type;
      },
      prevented: !1,
      stopped: !1,
      preventDefault: function() {
        this.prevented = !0, this.event.preventDefault();
      },
      stopPropagation: function() {
        this.stopped = !0, this.event.stopPropagation();
      },
      stop: function() {
        this.stopPropagation(), this.preventDefault();
      },
      getTimeStamp: function() {
        return this.event.timeStamp;
      },
      getModifiers: function() {
        return Lt.modifiers;
      }
    }), pe = Gi.extend({
      _class: "KeyEvent",
      initialize: function(r, s, l, u) {
        this.type = r, this.event = s, this.key = l, this.character = u;
      },
      toString: function() {
        return "{ type: '" + this.type + "', key: '" + this.key + "', character: '" + this.character + "', modifiers: " + this.getModifiers() + " }";
      }
    }), Lt = new function() {
      var i = {
        "	": "tab",
        " ": "space",
        "\b": "backspace",
        "": "delete",
        Spacebar: "space",
        Del: "delete",
        Win: "meta",
        Esc: "escape"
      }, r = {
        tab: "	",
        space: " ",
        enter: "\r"
      }, s = {}, l = {}, u, d, p = new o({
        shift: !1,
        control: !1,
        alt: !1,
        meta: !1,
        capsLock: !1,
        space: !1
      }).inject({
        option: {
          get: function() {
            return this.alt;
          }
        },
        command: {
          get: function() {
            var S = Ve && Ve.agent;
            return S && S.mac ? this.meta : this.control;
          }
        }
      });
      function m(S) {
        var L = S.key || S.keyIdentifier;
        return L = /^U\+/.test(L) ? String.fromCharCode(parseInt(L.substr(2), 16)) : /^Arrow[A-Z]/.test(L) ? L.substr(5) : L === "Unidentified" || L === t ? String.fromCharCode(S.keyCode) : L, i[L] || (L.length > 1 ? o.hyphenate(L) : L.toLowerCase());
      }
      function y(S, L, E, A) {
        var T = Qt._focused, G;
        if (s[L] = S, S ? l[L] = E : delete l[L], L.length > 1 && (G = o.camelize(L)) in p) {
          p[G] = S;
          var O = Ve && Ve.agent;
          if (G === "meta" && O && O.mac)
            if (S)
              u = {};
            else {
              for (var Y in u)
                Y in l && y(!1, Y, u[Y], A);
              u = null;
            }
        } else
          S && u && (u[L] = E);
        T && T._handleKeyEvent(
          S ? "keydown" : "keyup",
          A,
          L,
          E
        );
      }
      return Jt.add(a, {
        keydown: function(S) {
          var L = m(S), E = Ve && Ve.agent;
          L.length > 1 || E && E.chrome && (S.altKey || E.mac && S.metaKey || !E.mac && S.ctrlKey) ? y(
            !0,
            L,
            r[L] || (L.length > 1 ? "" : L),
            S
          ) : d = L;
        },
        keypress: function(S) {
          if (d) {
            var L = m(S), E = S.charCode, A = E >= 32 ? String.fromCharCode(E) : L.length > 1 ? "" : L;
            L !== d && (L = A.toLowerCase()), y(!0, L, A, S), d = null;
          }
        },
        keyup: function(S) {
          var L = m(S);
          L in l && y(!1, L, l[L], S);
        }
      }), Jt.add(n, {
        blur: function(S) {
          for (var L in l)
            y(!1, L, l[L], S);
        }
      }), {
        modifiers: p,
        isDown: function(S) {
          return !!s[S];
        }
      };
    }(), xt = Gi.extend({
      _class: "MouseEvent",
      initialize: function(r, s, l, u, d) {
        this.type = r, this.event = s, this.point = l, this.target = u, this.delta = d;
      },
      toString: function() {
        return "{ type: '" + this.type + "', point: " + this.point + ", target: " + this.target + (this.delta ? ", delta: " + this.delta : "") + ", modifiers: " + this.getModifiers() + " }";
      }
    }), Ne = Gi.extend({
      _class: "ToolEvent",
      _item: null,
      initialize: function(r, s, l) {
        this.tool = r, this.type = s, this.event = l;
      },
      _choosePoint: function(i, r) {
        return i || (r ? r.clone() : null);
      },
      getPoint: function() {
        return this._choosePoint(this._point, this.tool._point);
      },
      setPoint: function(i) {
        this._point = i;
      },
      getLastPoint: function() {
        return this._choosePoint(this._lastPoint, this.tool._lastPoint);
      },
      setLastPoint: function(i) {
        this._lastPoint = i;
      },
      getDownPoint: function() {
        return this._choosePoint(this._downPoint, this.tool._downPoint);
      },
      setDownPoint: function(i) {
        this._downPoint = i;
      },
      getMiddlePoint: function() {
        return !this._middlePoint && this.tool._lastPoint ? this.tool._point.add(this.tool._lastPoint).divide(2) : this._middlePoint;
      },
      setMiddlePoint: function(i) {
        this._middlePoint = i;
      },
      getDelta: function() {
        return !this._delta && this.tool._lastPoint ? this.tool._point.subtract(this.tool._lastPoint) : this._delta;
      },
      setDelta: function(i) {
        this._delta = i;
      },
      getCount: function() {
        return this.tool[/^mouse(down|up)$/.test(this.type) ? "_downCount" : "_moveCount"];
      },
      setCount: function(i) {
        this.tool[/^mouse(down|up)$/.test(this.type) ? "downCount" : "count"] = i;
      },
      getItem: function() {
        if (!this._item) {
          var i = this.tool._scope.project.hitTest(this.getPoint());
          if (i) {
            for (var r = i.item, s = r._parent; /^(Group|CompoundPath)$/.test(s._class); )
              r = s, s = s._parent;
            this._item = r;
          }
        }
        return this._item;
      },
      setItem: function(i) {
        this._item = i;
      },
      toString: function() {
        return "{ type: " + this.type + ", point: " + this.getPoint() + ", count: " + this.getCount() + ", modifiers: " + this.getModifiers() + " }";
      }
    }), Ie = v.extend({
      _class: "Tool",
      _list: "tools",
      _reference: "tool",
      _events: [
        "onMouseDown",
        "onMouseUp",
        "onMouseDrag",
        "onMouseMove",
        "onActivate",
        "onDeactivate",
        "onEditOptions",
        "onKeyDown",
        "onKeyUp"
      ],
      initialize: function(r) {
        v.call(this), this._moveCount = -1, this._downCount = -1, this.set(r);
      },
      getMinDistance: function() {
        return this._minDistance;
      },
      setMinDistance: function(i) {
        this._minDistance = i, i != null && this._maxDistance != null && i > this._maxDistance && (this._maxDistance = i);
      },
      getMaxDistance: function() {
        return this._maxDistance;
      },
      setMaxDistance: function(i) {
        this._maxDistance = i, this._minDistance != null && i != null && i < this._minDistance && (this._minDistance = i);
      },
      getFixedDistance: function() {
        return this._minDistance == this._maxDistance ? this._minDistance : null;
      },
      setFixedDistance: function(i) {
        this._minDistance = this._maxDistance = i;
      },
      _handleMouseEvent: function(i, r, s, l) {
        Ve = this._scope, l.drag && !this.responds(i) && (i = "mousemove");
        var u = l.move || l.drag, d = this.responds(i), p = !1, m = this;
        function y(L, E) {
          var A = s, T = u ? m._point : m._downPoint || A;
          if (u) {
            if (m._moveCount >= 0 && A.equals(T))
              return !1;
            if (T && (L != null || E != null)) {
              var G = A.subtract(T), O = G.getLength();
              if (O < (L || 0))
                return !1;
              E && (A = T.add(G.normalize(
                Math.min(O, E)
              )));
            }
            m._moveCount++;
          }
          return m._point = A, m._lastPoint = T || A, l.down && (m._moveCount = -1, m._downPoint = A, m._downCount++), !0;
        }
        function S() {
          d && (p = m.emit(i, new Ne(m, i, r)) || p);
        }
        if (l.down)
          y(), S();
        else if (l.up)
          y(null, this._maxDistance), S();
        else if (d)
          for (; y(this._minDistance, this._maxDistance); )
            S();
        return p;
      }
    }), et = o.extend(h, {
      _class: "Tween",
      statics: {
        easings: new o({
          linear: function(i) {
            return i;
          },
          easeInQuad: function(i) {
            return i * i;
          },
          easeOutQuad: function(i) {
            return i * (2 - i);
          },
          easeInOutQuad: function(i) {
            return i < 0.5 ? 2 * i * i : -1 + 2 * (2 - i) * i;
          },
          easeInCubic: function(i) {
            return i * i * i;
          },
          easeOutCubic: function(i) {
            return --i * i * i + 1;
          },
          easeInOutCubic: function(i) {
            return i < 0.5 ? 4 * i * i * i : (i - 1) * (2 * i - 2) * (2 * i - 2) + 1;
          },
          easeInQuart: function(i) {
            return i * i * i * i;
          },
          easeOutQuart: function(i) {
            return 1 - --i * i * i * i;
          },
          easeInOutQuart: function(i) {
            return i < 0.5 ? 8 * i * i * i * i : 1 - 8 * --i * i * i * i;
          },
          easeInQuint: function(i) {
            return i * i * i * i * i;
          },
          easeOutQuint: function(i) {
            return 1 + --i * i * i * i * i;
          },
          easeInOutQuint: function(i) {
            return i < 0.5 ? 16 * i * i * i * i * i : 1 + 16 * --i * i * i * i * i;
          }
        })
      },
      initialize: function i(r, s, l, u, d, p) {
        this.object = r;
        var m = typeof d, y = m === "function";
        this.type = y ? m : m === "string" ? d : "linear", this.easing = y ? d : i.easings[this.type], this.duration = u, this.running = !1, this._then = null, this._startTime = null;
        var S = s || l;
        this._keys = S ? Object.keys(S) : [], this._parsedKeys = this._parseKeys(this._keys), this._from = S && this._getState(s), this._to = S && this._getState(l), p !== !1 && this.start();
      },
      then: function(i) {
        return this._then = i, this;
      },
      start: function() {
        return this._startTime = null, this.running = !0, this;
      },
      stop: function() {
        return this.running = !1, this;
      },
      update: function(i) {
        if (this.running) {
          i >= 1 && (i = 1, this.running = !1);
          for (var r = this.easing(i), s = this._keys, l = function(L) {
            return typeof L == "function" ? L(r, i) : L;
          }, u = 0, d = s && s.length; u < d; u++) {
            var p = s[u], m = l(this._from[p]), y = l(this._to[p]), S = m && y && m.__add && y.__add ? y.__subtract(m).__multiply(r).__add(m) : (y - m) * r + m;
            this._setProperty(this._parsedKeys[p], S);
          }
          this.responds("update") && this.emit("update", new o({
            progress: i,
            factor: r
          })), !this.running && this._then && this._then(this.object);
        }
        return this;
      },
      _events: {
        onUpdate: {}
      },
      _handleFrame: function(i) {
        var r = this._startTime, s = r ? (i - r) / this.duration : 0;
        r || (this._startTime = i), this.update(s);
      },
      _getState: function(i) {
        for (var r = this._keys, s = {}, l = 0, u = r.length; l < u; l++) {
          var d = r[l], p = this._parsedKeys[d], m = this._getProperty(p), y;
          if (i) {
            var S = this._resolveValue(m, i[d]);
            this._setProperty(p, S), y = this._getProperty(p), y = y && y.clone ? y.clone() : y, this._setProperty(p, m);
          } else
            y = m && m.clone ? m.clone() : m;
          s[d] = y;
        }
        return s;
      },
      _resolveValue: function(i, r) {
        if (r) {
          if (Array.isArray(r) && r.length === 2) {
            var s = r[0];
            return s && s.match && s.match(/^[+\-\*\/]=/) ? this._calculate(i, s[0], r[1]) : r;
          } else if (typeof r == "string") {
            var l = r.match(/^[+\-*/]=(.*)/);
            if (l) {
              var u = JSON.parse(l[1].replace(
                /(['"])?([a-zA-Z0-9_]+)(['"])?:/g,
                '"$2": '
              ));
              return this._calculate(i, r[0], u);
            }
          }
        }
        return r;
      },
      _calculate: function(i, r, s) {
        return Ve.PaperScript.calculateBinary(i, r, s);
      },
      _parseKeys: function(i) {
        for (var r = {}, s = 0, l = i.length; s < l; s++) {
          var u = i[s], d = u.replace(/\.([^.]*)/g, "/$1").replace(/\[['"]?([^'"\]]*)['"]?\]/g, "/$1");
          r[u] = d.split("/");
        }
        return r;
      },
      _getProperty: function(i, r) {
        for (var s = this.object, l = 0, u = i.length - (r || 0); l < u && s; l++)
          s = s[i[l]];
        return s;
      },
      _setProperty: function(i, r) {
        var s = this._getProperty(i, 1);
        s && (s[i[i.length - 1]] = r);
      }
    }), Et = {
      request: function(i) {
        var r = new e.XMLHttpRequest();
        return r.open(
          (i.method || "get").toUpperCase(),
          i.url,
          o.pick(i.async, !0)
        ), i.mimeType && r.overrideMimeType(i.mimeType), r.onload = function() {
          var s = r.status;
          s === 0 || s === 200 ? i.onLoad && i.onLoad.call(r, r.responseText) : r.onerror();
        }, r.onerror = function() {
          var s = r.status, l = 'Could not load "' + i.url + '" (Status: ' + s + ")";
          if (i.onError)
            i.onError(l, s);
          else
            throw new Error(l);
        }, r.send(null);
      }
    }, ft = o.exports.CanvasProvider = {
      canvases: [],
      getCanvas: function(i, r, s) {
        if (!n)
          return null;
        var l, u = !0;
        typeof i == "object" && (r = i.height, i = i.width), this.canvases.length ? l = this.canvases.pop() : (l = a.createElement("canvas"), u = !1);
        var d = l.getContext("2d", s || {});
        if (!d)
          throw new Error("Canvas " + l + " is unable to provide a 2D context.");
        return l.width === i && l.height === r ? u && d.clearRect(0, 0, i + 1, r + 1) : (l.width = i, l.height = r), d.save(), l;
      },
      getContext: function(i, r, s) {
        var l = this.getCanvas(i, r, s);
        return l ? l.getContext("2d", s || {}) : null;
      },
      release: function(i) {
        var r = i && i.canvas ? i.canvas : i;
        r && r.getContext && (r.getContext("2d").restore(), this.canvases.push(r));
      }
    }, tt = new function() {
      var i = Math.min, r = Math.max, s = Math.abs, l, u, d, p, m, y, S, L, E, A, T;
      function G(j, q, H) {
        return 0.2989 * j + 0.587 * q + 0.114 * H;
      }
      function O(j, q, H, le) {
        var ae = le - G(j, q, H);
        E = j + ae, A = q + ae, T = H + ae;
        var le = G(E, A, T), me = i(E, A, T), se = r(E, A, T);
        if (me < 0) {
          var de = le - me;
          E = le + (E - le) * le / de, A = le + (A - le) * le / de, T = le + (T - le) * le / de;
        }
        if (se > 255) {
          var ve = 255 - le, we = se - le;
          E = le + (E - le) * ve / we, A = le + (A - le) * ve / we, T = le + (T - le) * ve / we;
        }
      }
      function Y(j, q, H) {
        return r(j, q, H) - i(j, q, H);
      }
      function B(j, q, H, te) {
        var ae = [j, q, H], le = r(j, q, H), me = i(j, q, H), se;
        me = me === j ? 0 : me === q ? 1 : 2, le = le === j ? 0 : le === q ? 1 : 2, se = i(me, le) === 0 ? r(me, le) === 1 ? 2 : 1 : 0, ae[le] > ae[me] ? (ae[se] = (ae[se] - ae[me]) * te / (ae[le] - ae[me]), ae[le] = te) : ae[se] = ae[le] = 0, ae[me] = 0, E = ae[0], A = ae[1], T = ae[2];
      }
      var z = {
        multiply: function() {
          E = m * l / 255, A = y * u / 255, T = S * d / 255;
        },
        screen: function() {
          E = m + l - m * l / 255, A = y + u - y * u / 255, T = S + d - S * d / 255;
        },
        overlay: function() {
          E = m < 128 ? 2 * m * l / 255 : 255 - 2 * (255 - m) * (255 - l) / 255, A = y < 128 ? 2 * y * u / 255 : 255 - 2 * (255 - y) * (255 - u) / 255, T = S < 128 ? 2 * S * d / 255 : 255 - 2 * (255 - S) * (255 - d) / 255;
        },
        "soft-light": function() {
          var j = l * m / 255;
          E = j + m * (255 - (255 - m) * (255 - l) / 255 - j) / 255, j = u * y / 255, A = j + y * (255 - (255 - y) * (255 - u) / 255 - j) / 255, j = d * S / 255, T = j + S * (255 - (255 - S) * (255 - d) / 255 - j) / 255;
        },
        "hard-light": function() {
          E = l < 128 ? 2 * l * m / 255 : 255 - 2 * (255 - l) * (255 - m) / 255, A = u < 128 ? 2 * u * y / 255 : 255 - 2 * (255 - u) * (255 - y) / 255, T = d < 128 ? 2 * d * S / 255 : 255 - 2 * (255 - d) * (255 - S) / 255;
        },
        "color-dodge": function() {
          E = m === 0 ? 0 : l === 255 ? 255 : i(255, 255 * m / (255 - l)), A = y === 0 ? 0 : u === 255 ? 255 : i(255, 255 * y / (255 - u)), T = S === 0 ? 0 : d === 255 ? 255 : i(255, 255 * S / (255 - d));
        },
        "color-burn": function() {
          E = m === 255 ? 255 : l === 0 ? 0 : r(0, 255 - (255 - m) * 255 / l), A = y === 255 ? 255 : u === 0 ? 0 : r(0, 255 - (255 - y) * 255 / u), T = S === 255 ? 255 : d === 0 ? 0 : r(0, 255 - (255 - S) * 255 / d);
        },
        darken: function() {
          E = m < l ? m : l, A = y < u ? y : u, T = S < d ? S : d;
        },
        lighten: function() {
          E = m > l ? m : l, A = y > u ? y : u, T = S > d ? S : d;
        },
        difference: function() {
          E = m - l, E < 0 && (E = -E), A = y - u, A < 0 && (A = -A), T = S - d, T < 0 && (T = -T);
        },
        exclusion: function() {
          E = m + l * (255 - m - m) / 255, A = y + u * (255 - y - y) / 255, T = S + d * (255 - S - S) / 255;
        },
        hue: function() {
          B(l, u, d, Y(m, y, S)), O(E, A, T, G(m, y, S));
        },
        saturation: function() {
          B(m, y, S, Y(l, u, d)), O(E, A, T, G(m, y, S));
        },
        luminosity: function() {
          O(m, y, S, G(l, u, d));
        },
        color: function() {
          O(l, u, d, G(m, y, S));
        },
        add: function() {
          E = i(m + l, 255), A = i(y + u, 255), T = i(S + d, 255);
        },
        subtract: function() {
          E = r(m - l, 0), A = r(y - u, 0), T = r(S - d, 0);
        },
        average: function() {
          E = (m + l) / 2, A = (y + u) / 2, T = (S + d) / 2;
        },
        negation: function() {
          E = 255 - s(255 - l - m), A = 255 - s(255 - u - y), T = 255 - s(255 - d - S);
        }
      }, C = this.nativeModes = o.each([
        "source-over",
        "source-in",
        "source-out",
        "source-atop",
        "destination-over",
        "destination-in",
        "destination-out",
        "destination-atop",
        "lighter",
        "darker",
        "copy",
        "xor"
      ], function(j) {
        this[j] = !0;
      }, {}), N = ft.getContext(1, 1, { willReadFrequently: !0 });
      N && (o.each(z, function(j, q) {
        var H = q === "darken", te = !1;
        N.save();
        try {
          N.fillStyle = H ? "#300" : "#a00", N.fillRect(0, 0, 1, 1), N.globalCompositeOperation = q, N.globalCompositeOperation === q && (N.fillStyle = H ? "#a00" : "#300", N.fillRect(0, 0, 1, 1), te = N.getImageData(0, 0, 1, 1).data[0] !== H ? 170 : 51);
        } catch {
        }
        N.restore(), C[q] = te;
      }), ft.release(N)), this.process = function(j, q, H, te, ae) {
        var le = q.canvas, me = j === "normal";
        if (me || C[j])
          H.save(), H.setTransform(1, 0, 0, 1, 0, 0), H.globalAlpha = te, me || (H.globalCompositeOperation = j), H.drawImage(le, ae.x, ae.y), H.restore();
        else {
          var se = z[j];
          if (!se)
            return;
          for (var de = H.getImageData(
            ae.x,
            ae.y,
            le.width,
            le.height
          ), ve = de.data, we = q.getImageData(
            0,
            0,
            le.width,
            le.height
          ).data, Se = 0, Ae = ve.length; Se < Ae; Se += 4) {
            l = we[Se], m = ve[Se], u = we[Se + 1], y = ve[Se + 1], d = we[Se + 2], S = ve[Se + 2], p = we[Se + 3], L = ve[Se + 3], se();
            var Ge = p * te / 255, Qe = 1 - Ge;
            ve[Se] = Ge * E + Qe * m, ve[Se + 1] = Ge * A + Qe * y, ve[Se + 2] = Ge * T + Qe * S, ve[Se + 3] = p * te + Qe * L;
          }
          H.putImageData(de, ae.x, ae.y);
        }
      };
    }(), _t = new function() {
      var i = "http://www.w3.org/2000/svg", r = "http://www.w3.org/2000/xmlns", s = "http://www.w3.org/1999/xlink", l = {
        href: s,
        xlink: r,
        xmlns: r + "/",
        "xmlns:xlink": r + "/"
      };
      function u(m, y, S) {
        return p(a.createElementNS(i, m), y, S);
      }
      function d(m, y) {
        var S = l[y], L = S ? m.getAttributeNS(S, y) : m.getAttribute(y);
        return L === "null" ? null : L;
      }
      function p(m, y, S) {
        for (var L in y) {
          var E = y[L], A = l[L];
          typeof E == "number" && S && (E = S.number(E)), A ? m.setAttributeNS(A, L, E) : m.setAttribute(L, E);
        }
        return m;
      }
      return {
        svg: i,
        xmlns: r,
        xlink: s,
        create: u,
        get: d,
        set: p
      };
    }(), Kt = o.each({
      fillColor: ["fill", "color"],
      fillRule: ["fill-rule", "string"],
      strokeColor: ["stroke", "color"],
      strokeWidth: ["stroke-width", "number"],
      strokeCap: ["stroke-linecap", "string"],
      strokeJoin: ["stroke-linejoin", "string"],
      strokeScaling: ["vector-effect", "lookup", {
        true: "none",
        false: "non-scaling-stroke"
      }, function(i, r) {
        return !r && (i instanceof Gt || i instanceof Oe || i instanceof Xt);
      }],
      miterLimit: ["stroke-miterlimit", "number"],
      dashArray: ["stroke-dasharray", "array"],
      dashOffset: ["stroke-dashoffset", "number"],
      fontFamily: ["font-family", "string"],
      fontWeight: ["font-weight", "string"],
      fontSize: ["font-size", "number"],
      justification: ["text-anchor", "lookup", {
        left: "start",
        center: "middle",
        right: "end"
      }],
      opacity: ["opacity", "number"],
      blendMode: ["mix-blend-mode", "style"]
    }, function(i, r) {
      var s = o.capitalize(r), l = i[2];
      this[r] = {
        type: i[1],
        property: r,
        attribute: i[0],
        toSVG: l,
        fromSVG: l && o.each(l, function(u, d) {
          this[u] = d;
        }, {}),
        exportFilter: i[3],
        get: "get" + s,
        set: "set" + s
      };
    }, {});
    new function() {
      var i;
      function r(z, C, N) {
        var j = new o(), q = z.getTranslation();
        if (C) {
          var H;
          z.isInvertible() ? (z = z._shiftless(), H = z._inverseTransform(q), q = null) : H = new M(), j[N ? "cx" : "x"] = H.x, j[N ? "cy" : "y"] = H.y;
        }
        if (!z.isIdentity()) {
          var te = z.decompose();
          if (te) {
            var ae = [], le = te.rotation, me = te.scaling, se = te.skewing;
            q && !q.isZero() && ae.push("translate(" + i.point(q) + ")"), le && ae.push("rotate(" + i.number(le) + ")"), (!I.isZero(me.x - 1) || !I.isZero(me.y - 1)) && ae.push("scale(" + i.point(me) + ")"), se.x && ae.push("skewX(" + i.number(se.x) + ")"), se.y && ae.push("skewY(" + i.number(se.y) + ")"), j.transform = ae.join(" ");
          } else
            j.transform = "matrix(" + z.getValues().join(",") + ")";
        }
        return j;
      }
      function s(z, C) {
        for (var N = r(z._matrix), j = z._children, q = _t.create("g", N, i), H = 0, te = j.length; H < te; H++) {
          var ae = j[H], le = Y(ae, C);
          if (le)
            if (ae.isClipMask()) {
              var me = _t.create("clipPath");
              me.appendChild(le), G(ae, me, "clip"), _t.set(q, {
                "clip-path": "url(#" + me.id + ")"
              });
            } else
              q.appendChild(le);
        }
        return q;
      }
      function l(z, C) {
        var N = r(z._matrix, !0), j = z.getSize(), q = z.getImage();
        return N.x -= j.width / 2, N.y -= j.height / 2, N.width = j.width, N.height = j.height, N.href = C.embedImages == !1 && q && q.src || z.toDataURL(), _t.create("image", N, i);
      }
      function u(z, C) {
        var N = C.matchShapes;
        if (N) {
          var j = z.toShape(!1);
          if (j)
            return d(j);
        }
        var q = z._segments, H = q.length, te, ae = r(z._matrix);
        if (N && H >= 2 && !z.hasHandles())
          if (H > 2) {
            te = z._closed ? "polygon" : "polyline";
            for (var le = [], me = 0; me < H; me++)
              le.push(i.point(q[me]._point));
            ae.points = le.join(" ");
          } else {
            te = "line";
            var se = q[0]._point, de = q[1]._point;
            ae.set({
              x1: se.x,
              y1: se.y,
              x2: de.x,
              y2: de.y
            });
          }
        else
          te = "path", ae.d = z.getPathData(null, C.precision);
        return _t.create(te, ae, i);
      }
      function d(z) {
        var C = z._type, N = z._radius, j = r(z._matrix, !0, C !== "rectangle");
        if (C === "rectangle") {
          C = "rect";
          var q = z._size, H = q.width, te = q.height;
          j.x -= H / 2, j.y -= te / 2, j.width = H, j.height = te, N.isZero() && (N = null);
        }
        return N && (C === "circle" ? j.r = N : (j.rx = N.width, j.ry = N.height)), _t.create(C, j, i);
      }
      function p(z, C) {
        var N = r(z._matrix), j = z.getPathData(null, C.precision);
        return j && (N.d = j), _t.create("path", N, i);
      }
      function m(z, C) {
        var N = r(z._matrix, !0), j = z._definition, q = T(j, "symbol"), H = j._item, te = H.getStrokeBounds();
        return q || (q = _t.create("symbol", {
          viewBox: i.rectangle(te)
        }), q.appendChild(Y(H, C)), G(j, q, "symbol")), N.href = "#" + q.id, N.x += te.x, N.y += te.y, N.width = te.width, N.height = te.height, N.overflow = "visible", _t.create("use", N, i);
      }
      function y(z) {
        var C = T(z, "color");
        if (!C) {
          var N = z.getGradient(), j = N._radial, q = z.getOrigin(), H = z.getDestination(), te;
          if (j) {
            te = {
              cx: q.x,
              cy: q.y,
              r: q.getDistance(H)
            };
            var ae = z.getHighlight();
            ae && (te.fx = ae.x, te.fy = ae.y);
          } else
            te = {
              x1: q.x,
              y1: q.y,
              x2: H.x,
              y2: H.y
            };
          te.gradientUnits = "userSpaceOnUse", C = _t.create((j ? "radial" : "linear") + "Gradient", te, i);
          for (var le = N._stops, me = 0, se = le.length; me < se; me++) {
            var de = le[me], ve = de._color, we = ve.getAlpha(), Se = de._offset;
            te = {
              offset: Se ?? me / (se - 1)
            }, ve && (te["stop-color"] = ve.toCSS(!0)), we < 1 && (te["stop-opacity"] = we), C.appendChild(
              _t.create("stop", te, i)
            );
          }
          G(z, C, "color");
        }
        return "url(#" + C.id + ")";
      }
      function S(z) {
        var C = _t.create(
          "text",
          r(z._matrix, !0),
          i
        );
        return C.textContent = z._content, C;
      }
      var L = {
        Group: s,
        Layer: s,
        Raster: l,
        Path: u,
        Shape: d,
        CompoundPath: p,
        SymbolItem: m,
        PointText: S
      };
      function E(z, C, N, j) {
        var q = {}, H = !j && z.getParent(), te = [];
        return z._name != null && (q.id = z._name), o.each(Kt, function(ae) {
          var le = ae.get, me = ae.type, se = z[le]();
          if (ae.exportFilter ? ae.exportFilter(z, se) : N.reduceAttributes == !1 || !H || !o.equals(H[le](), se)) {
            if (me === "color" && se != null) {
              var de = se.getAlpha();
              de < 1 && (q[ae.attribute + "-opacity"] = de);
            }
            me === "style" ? te.push(ae.attribute + ": " + se) : q[ae.attribute] = se == null ? "none" : me === "color" ? se.gradient ? y(se) : se.toCSS(!0) : me === "array" ? se.join(",") : me === "lookup" ? ae.toSVG[se] : se;
          }
        }), te.length && (q.style = te.join(";")), q.opacity === 1 && delete q.opacity, z._visible || (q.visibility = "hidden"), _t.set(C, q, i);
      }
      var A;
      function T(z, C) {
        return A || (A = { ids: {}, svgs: {} }), z && A.svgs[C + "-" + (z._id || z.__id || (z.__id = V.get("svg")))];
      }
      function G(z, C, N) {
        A || T();
        var j = A.ids[N] = (A.ids[N] || 0) + 1;
        C.id = N + "-" + j, A.svgs[N + "-" + (z._id || z.__id)] = C;
      }
      function O(z, C) {
        var N = z, j = null;
        if (A) {
          N = z.nodeName.toLowerCase() === "svg" && z;
          for (var q in A.svgs)
            j || (N || (N = _t.create("svg"), N.appendChild(z)), j = N.insertBefore(
              _t.create("defs"),
              N.firstChild
            )), j.appendChild(A.svgs[q]);
          A = null;
        }
        return C.asString ? new e.XMLSerializer().serializeToString(N) : N;
      }
      function Y(z, C, N) {
        var j = L[z._class], q = j && j(z, C);
        if (q) {
          var H = C.onExport;
          H && (q = H(z, q, C) || q);
          var te = JSON.stringify(z._data);
          te && te !== "{}" && te !== "null" && q.setAttribute("data-paper-data", te);
        }
        return q && E(z, q, C, N);
      }
      function B(z) {
        return z || (z = {}), i = new k(z.precision), z;
      }
      X.inject({
        exportSVG: function(z) {
          return z = B(z), O(Y(this, z, !0), z);
        }
      }), fe.inject({
        exportSVG: function(z) {
          z = B(z);
          var C = this._children, N = this.getView(), j = o.pick(z.bounds, "view"), q = z.matrix || j === "view" && N._matrix, H = q && J.read([q]), te = j === "view" ? new D([0, 0], N.getViewSize()) : j === "content" ? X._getBounds(C, H, { stroke: !0 }).rect : D.read([j], 0, { readNull: !0 }), ae = {
            version: "1.1",
            xmlns: _t.svg,
            "xmlns:xlink": _t.xlink
          };
          te && (ae.width = te.width, ae.height = te.height, (te.x || te.x === 0 || te.y || te.y === 0) && (ae.viewBox = i.rectangle(te)));
          var le = _t.create("svg", ae, i), me = le;
          H && !H.isIdentity() && (me = le.appendChild(_t.create(
            "g",
            r(H),
            i
          )));
          for (var se = 0, de = C.length; se < de; se++)
            me.appendChild(Y(C[se], z, !0));
          return O(le, z);
        }
      });
    }(), new function() {
      var i = {}, r;
      function s(C, N, j, q, H, te) {
        var ae = _t.get(C, N) || te, le = ae == null ? q ? null : j ? "" : 0 : j ? ae : parseFloat(ae);
        return /%\s*$/.test(ae) ? le / 100 * (H ? 1 : r[/x|^width/.test(N) ? "width" : "height"]) : le;
      }
      function l(C, N, j, q, H, te, ae) {
        return N = s(C, N || "x", !1, q, H, te), j = s(C, j || "y", !1, q, H, ae), q && (N == null || j == null) ? null : new M(N, j);
      }
      function u(C, N, j, q, H) {
        return N = s(C, N || "width", !1, q, H), j = s(C, j || "height", !1, q, H), q && (N == null || j == null) ? null : new U(N, j);
      }
      function d(C, N, j) {
        return C === "none" ? null : N === "number" ? parseFloat(C) : N === "array" ? C ? C.split(/[\s,]+/g).map(parseFloat) : [] : N === "color" ? Y(C) || C : N === "lookup" ? j[C] : C;
      }
      function p(C, N, j, q) {
        var H = C.childNodes, te = N === "clippath", ae = N === "defs", le = new Z(), me = le._project, se = me._currentStyle, de = [];
        if (!te && !ae && (le = O(le, C, q), me._currentStyle = le._style.clone()), q)
          for (var ve = C.querySelectorAll("defs"), we = 0, Se = ve.length; we < Se; we++)
            B(ve[we], j, !1);
        for (var we = 0, Se = H.length; we < Se; we++) {
          var Ae = H[we], Ge;
          Ae.nodeType === 1 && !/^defs$/i.test(Ae.nodeName) && (Ge = B(Ae, j, !1)) && !(Ge instanceof Te) && de.push(Ge);
        }
        return le.addChildren(de), te && (le = O(le.reduce(), C, q)), me._currentStyle = se, (te || ae) && (le.remove(), le = null), le;
      }
      function m(C, N) {
        for (var j = C.getAttribute("points").match(
          /[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g
        ), q = [], H = 0, te = j.length; H < te; H += 2)
          q.push(new M(
            parseFloat(j[H]),
            parseFloat(j[H + 1])
          ));
        var ae = new $e(q);
        return N === "polygon" && ae.closePath(), ae;
      }
      function y(C) {
        return Gt.create(C.getAttribute("d"));
      }
      function S(C, N) {
        var j = (s(C, "href", !0) || "").substring(1), q = N === "radialgradient", H;
        if (j)
          H = i[j].getGradient(), H._radial ^ q && (H = H.clone(), H._radial = q);
        else {
          for (var te = C.childNodes, ae = [], le = 0, me = te.length; le < me; le++) {
            var se = te[le];
            se.nodeType === 1 && ae.push(O(new en(), se));
          }
          H = new Bi(ae, q);
        }
        var de, ve, we, Se = s(C, "gradientUnits", !0) !== "userSpaceOnUse";
        q ? (de = l(
          C,
          "cx",
          "cy",
          !1,
          Se,
          "50%",
          "50%"
        ), ve = de.add(
          s(C, "r", !1, !1, Se, "50%"),
          0
        ), we = l(C, "fx", "fy", !0, Se)) : (de = l(
          C,
          "x1",
          "y1",
          !1,
          Se,
          "0%",
          "0%"
        ), ve = l(
          C,
          "x2",
          "y2",
          !1,
          Se,
          "100%",
          "0%"
        ));
        var Ae = O(
          new Tt(H, de, ve, we),
          C
        );
        return Ae._scaleToBounds = Se, null;
      }
      var L = {
        "#document": function(C, N, j, q) {
          for (var H = C.childNodes, te = 0, ae = H.length; te < ae; te++) {
            var le = H[te];
            if (le.nodeType === 1)
              return B(le, j, q);
          }
        },
        g: p,
        svg: p,
        clippath: p,
        polygon: m,
        polyline: m,
        path: y,
        lineargradient: S,
        radialgradient: S,
        image: function(C) {
          var N = new je(s(C, "href", !0));
          return N.on("load", function() {
            var j = u(C);
            this.setSize(j);
            var q = l(C).add(j.divide(2));
            this._matrix.append(new J().translate(q));
          }), N;
        },
        symbol: function(C, N, j, q) {
          return new Te(
            p(C, N, j, q),
            !0
          );
        },
        defs: p,
        use: function(C) {
          var N = (s(C, "href", !0) || "").substring(1), j = i[N], q = l(C);
          return j ? j instanceof Te ? j.place(q) : j.clone().translate(q) : null;
        },
        circle: function(C) {
          return new Oe.Circle(
            l(C, "cx", "cy"),
            s(C, "r")
          );
        },
        ellipse: function(C) {
          return new Oe.Ellipse({
            center: l(C, "cx", "cy"),
            radius: u(C, "rx", "ry")
          });
        },
        rect: function(C) {
          return new Oe.Rectangle(new D(
            l(C),
            u(C)
          ), u(C, "rx", "ry"));
        },
        line: function(C) {
          return new $e.Line(
            l(C, "x1", "y1"),
            l(C, "x2", "y2")
          );
        },
        text: function(C) {
          var N = new $t(l(C).add(
            l(C, "dx", "dy")
          ));
          return N.setContent(C.textContent.trim() || ""), N;
        },
        switch: p
      };
      function E(C, N, j, q) {
        if (C.transform) {
          for (var H = (q.getAttribute(j) || "").split(/\)\s*/g), te = new J(), ae = 0, le = H.length; ae < le; ae++) {
            var me = H[ae];
            if (!me)
              break;
            for (var se = me.split(/\(\s*/), de = se[0].trim(), ve = se[1].split(/[\s,]+/g), we = 0, Se = ve.length; we < Se; we++)
              ve[we] = parseFloat(ve[we]);
            switch (de) {
              case "matrix":
                te.append(
                  new J(ve[0], ve[1], ve[2], ve[3], ve[4], ve[5])
                );
                break;
              case "rotate":
                te.rotate(ve[0], ve[1] || 0, ve[2] || 0);
                break;
              case "translate":
                te.translate(ve[0], ve[1] || 0);
                break;
              case "scale":
                te.scale(ve);
                break;
              case "skewX":
                te.skew(ve[0], 0);
                break;
              case "skewY":
                te.skew(0, ve[0]);
                break;
            }
          }
          C.transform(te);
        }
      }
      function A(C, N, j) {
        var q = j === "fill-opacity" ? "getFillColor" : "getStrokeColor", H = C[q] && C[q]();
        H && H.setAlpha(parseFloat(N));
      }
      var T = o.set(o.each(Kt, function(C) {
        this[C.attribute] = function(N, j) {
          if (N[C.set] && (N[C.set](d(j, C.type, C.fromSVG)), C.type === "color")) {
            var q = N[C.get]();
            if (q && q._scaleToBounds) {
              var H = N.getBounds();
              q.transform(new J().translate(H.getPoint()).scale(H.getSize()));
            }
          }
        };
      }, {}), {
        id: function(C, N) {
          i[N] = C, C.setName && C.setName(N);
        },
        "clip-path": function(C, N) {
          var j = Y(N);
          if (j)
            if (j = j.clone(), j.setClipMask(!0), C instanceof Z)
              C.insertChild(0, j);
            else
              return new Z(j, C);
        },
        gradientTransform: E,
        transform: E,
        "fill-opacity": A,
        "stroke-opacity": A,
        visibility: function(C, N) {
          C.setVisible && C.setVisible(N === "visible");
        },
        display: function(C, N) {
          C.setVisible && C.setVisible(N !== null);
        },
        "stop-color": function(C, N) {
          C.setColor && C.setColor(N);
        },
        "stop-opacity": function(C, N) {
          C._color && C._color.setAlpha(parseFloat(N));
        },
        offset: function(C, N) {
          if (C.setOffset) {
            var j = N.match(/(.*)%$/);
            C.setOffset(j ? j[1] / 100 : parseFloat(N));
          }
        },
        viewBox: function(C, N, j, q, H) {
          var te = new D(d(N, "array")), ae = u(q, null, null, !0), le, me;
          if (C instanceof Z) {
            var se = ae ? ae.divide(te.getSize()) : 1, me = new J().scale(se).translate(te.getPoint().negate());
            le = C;
          } else
            C instanceof Te && (ae && te.setSize(ae), le = C._item);
          if (le) {
            if (G(q, "overflow", H) !== "visible") {
              var de = new Oe.Rectangle(te);
              de.setClipMask(!0), le.addChild(de);
            }
            me && le.transform(me);
          }
        }
      });
      function G(C, N, j) {
        var q = C.attributes[N], H = q && q.value;
        if (!H && C.style) {
          var te = o.camelize(N);
          H = C.style[te], !H && j.node[te] !== j.parent[te] && (H = j.node[te]);
        }
        return H ? H === "none" ? null : H : t;
      }
      function O(C, N, j) {
        var q = N.parentNode, H = {
          node: Zt.getStyles(N) || {},
          parent: !j && !/^defs$/i.test(q.tagName) && Zt.getStyles(q) || {}
        };
        return o.each(T, function(te, ae) {
          var le = G(N, ae, H);
          C = le !== t && te(C, le, ae, N, H) || C;
        }), C;
      }
      function Y(C) {
        var N = C && C.match(/\((?:["'#]*)([^"')]+)/), j = N && N[1], q = j && i[n ? j.replace(n.location.href.split("#")[0] + "#", "") : j];
        return q && q._scaleToBounds && (q = q.clone(), q._scaleToBounds = !0), q;
      }
      function B(C, N, j) {
        var q = C.nodeName.toLowerCase(), H = q !== "#document", te = a.body, ae, le, me;
        j && H && (r = Ve.getView().getSize(), r = u(C, null, null, !0) || r, ae = _t.create("svg", {
          style: "stroke-width: 1px; stroke-miterlimit: 10"
        }), le = C.parentNode, me = C.nextSibling, ae.appendChild(C), te.appendChild(ae));
        var se = Ve.settings, de = se.applyMatrix, ve = se.insertItems;
        se.applyMatrix = !1, se.insertItems = !1;
        var we = L[q], Se = we && we(C, q, N, j) || null;
        if (se.insertItems = ve, se.applyMatrix = de, Se) {
          H && !(Se instanceof Z) && (Se = O(Se, C, j));
          var Ae = N.onImport, Ge = H && C.getAttribute("data-paper-data");
          Ae && (Se = Ae(C, Se, N) || Se), N.expandShapes && Se instanceof Oe && (Se.remove(), Se = Se.toPath()), Ge && (Se._data = JSON.parse(Ge));
        }
        return ae && (te.removeChild(ae), le && (me ? le.insertBefore(C, me) : le.appendChild(C))), j && (i = {}, Se && o.pick(N.applyMatrix, de) && Se.matrix.apply(!0, !0)), Se;
      }
      function z(C, N, j) {
        if (!C)
          return null;
        N = typeof N == "function" ? { onLoad: N } : N || {};
        var q = Ve, H = null;
        function te(se) {
          try {
            var de = typeof se == "object" ? se : new e.DOMParser().parseFromString(
              se.trim(),
              "image/svg+xml"
            );
            if (!de.nodeName)
              throw de = null, new Error("Unsupported SVG source: " + C);
            Ve = q, H = B(de, N, !0), (!N || N.insert !== !1) && j._insertItem(t, H);
            var ve = N.onLoad;
            ve && ve(H, se);
          } catch (we) {
            ae(we);
          }
        }
        function ae(se, de) {
          var ve = N.onError;
          if (ve)
            ve(se, de);
          else
            throw new Error(se);
        }
        if (typeof C == "string" && !/^[\s\S]*</.test(C)) {
          var le = a.getElementById(C);
          le ? te(le) : Et.request({
            url: C,
            async: !0,
            onLoad: te,
            onError: ae
          });
        } else if (typeof File < "u" && C instanceof File) {
          var me = new FileReader();
          return me.onload = function() {
            te(me.result);
          }, me.onerror = function() {
            ae(me.error);
          }, me.readAsText(C);
        } else
          te(C);
        return H;
      }
      X.inject({
        importSVG: function(C, N) {
          return z(C, N, this);
        }
      }), fe.inject({
        importSVG: function(C, N) {
          return this.activate(), z(C, N, this);
        }
      });
    }(), o.exports.PaperScript = (function() {
      var i = this, r = i.acorn;
      if (!r && typeof qa < "u")
        try {
          r = Ew();
        } catch {
        }
      if (!r) {
        var s, l;
        r = s = l = {}, function(O, Y) {
          if (typeof s == "object" && typeof l == "object")
            return Y(s);
          if (typeof t == "function" && t.amd)
            return t(["exports"], Y);
          Y(O.acorn || (O.acorn = {}));
        }(this, function(O) {
          O.version = "0.5.0";
          var Y, B, z, C;
          O.parse = function(ie, oe) {
            return B = String(ie), z = B.length, j(oe), _e(), $s(Y.program);
          };
          var N = O.defaultOptions = {
            ecmaVersion: 5,
            strictSemicolons: !1,
            allowTrailingCommas: !0,
            forbidReserved: !1,
            allowReturnOutsideFunction: !1,
            locations: !1,
            onComment: null,
            ranges: !1,
            program: null,
            sourceFile: null,
            directSourceFile: null
          };
          function j(ie) {
            Y = ie || {};
            for (var oe in N)
              Object.prototype.hasOwnProperty.call(Y, oe) || (Y[oe] = N[oe]);
            C = Y.sourceFile || null;
          }
          var q = O.getLineInfo = function(ie, oe) {
            for (var Me = 1, ke = 0; ; ) {
              P.lastIndex = ke;
              var lt = P.exec(ie);
              if (lt && lt.index < oe)
                ++Me, ke = lt.index + lt[0].length;
              else
                break;
            }
            return { line: Me, column: oe - ke };
          };
          O.tokenize = function(ie, oe) {
            B = String(ie), z = B.length, j(oe), _e();
            var Me = {};
            function ke(lt) {
              return Ge = ae, fn(lt), Me.start = te, Me.end = ae, Me.startLoc = le, Me.endLoc = me, Me.type = se, Me.value = de, Me;
            }
            return ke.jumpTo = function(lt, At) {
              if (H = lt, Y.locations) {
                we = 1, Se = P.lastIndex = 0;
                for (var wt; (wt = P.exec(B)) && wt.index < lt; )
                  ++we, Se = wt.index + wt[0].length;
              }
              ve = At, Je();
            }, ke;
          };
          var H, te, ae, le, me, se, de, ve, we, Se, Ae, Ge, Qe, st, mt, Re;
          function Fe(ie, oe) {
            var Me = q(B, ie);
            oe += " (" + Me.line + ":" + Me.column + ")";
            var ke = new SyntaxError(oe);
            throw ke.pos = ie, ke.loc = Me, ke.raisedAt = H, ke;
          }
          var at = [], yt = { type: "num" }, bt = { type: "regexp" }, Rt = { type: "string" }, Pt = { type: "name" }, zt = { type: "eof" }, Wt = { keyword: "break" }, Ft = { keyword: "case", beforeExpr: !0 }, Mi = { keyword: "catch" }, yi = { keyword: "continue" }, Ai = { keyword: "debugger" }, pi = { keyword: "default" }, kt = { keyword: "do", isLoop: !0 }, fi = { keyword: "else", beforeExpr: !0 }, Ti = { keyword: "finally" }, xi = { keyword: "for", isLoop: !0 }, tn = { keyword: "function" }, Hi = { keyword: "if" }, Zi = { keyword: "return", beforeExpr: !0 }, Xi = { keyword: "switch" }, ji = { keyword: "throw", beforeExpr: !0 }, Ki = { keyword: "try" }, ln = { keyword: "var" }, Fi = { keyword: "while", isLoop: !0 }, hn = { keyword: "with" }, kr = { keyword: "new", beforeExpr: !0 }, Er = { keyword: "this" }, Ir = { keyword: "null", atomValue: null }, Nn = { keyword: "true", atomValue: !0 }, Pr = { keyword: "false", atomValue: !1 }, Rn = { keyword: "in", binop: 7, beforeExpr: !0 }, qn = {
            break: Wt,
            case: Ft,
            catch: Mi,
            continue: yi,
            debugger: Ai,
            default: pi,
            do: kt,
            else: fi,
            finally: Ti,
            for: xi,
            function: tn,
            if: Hi,
            return: Zi,
            switch: Xi,
            throw: ji,
            try: Ki,
            var: ln,
            while: Fi,
            with: hn,
            null: Ir,
            true: Nn,
            false: Pr,
            new: kr,
            in: Rn,
            instanceof: { keyword: "instanceof", binop: 7, beforeExpr: !0 },
            this: Er,
            typeof: { keyword: "typeof", prefix: !0, beforeExpr: !0 },
            void: { keyword: "void", prefix: !0, beforeExpr: !0 },
            delete: { keyword: "delete", prefix: !0, beforeExpr: !0 }
          }, Dn = { type: "[", beforeExpr: !0 }, Mn = { type: "]" }, gn = { type: "{", beforeExpr: !0 }, yn = { type: "}" }, ri = { type: "(", beforeExpr: !0 }, Ji = { type: ")" }, cn = { type: ",", beforeExpr: !0 }, sn = { type: ";", beforeExpr: !0 }, zn = { type: ":", beforeExpr: !0 }, xr = { type: "." }, Or = { type: "?", beforeExpr: !0 }, fr = { binop: 10, beforeExpr: !0 }, g = { isAssign: !0, beforeExpr: !0 }, F = { isAssign: !0, beforeExpr: !0 }, ue = { postfix: !0, prefix: !0, isUpdate: !0 }, ye = { prefix: !0, beforeExpr: !0 }, Ee = { binop: 1, beforeExpr: !0 }, nt = { binop: 2, beforeExpr: !0 }, gt = { binop: 3, beforeExpr: !0 }, Yt = { binop: 4, beforeExpr: !0 }, qt = { binop: 5, beforeExpr: !0 }, li = { binop: 6, beforeExpr: !0 }, ni = { binop: 7, beforeExpr: !0 }, si = { binop: 8, beforeExpr: !0 }, xn = { binop: 9, prefix: !0, beforeExpr: !0 }, dr = { binop: 10, beforeExpr: !0 };
          O.tokTypes = {
            bracketL: Dn,
            bracketR: Mn,
            braceL: gn,
            braceR: yn,
            parenL: ri,
            parenR: Ji,
            comma: cn,
            semi: sn,
            colon: zn,
            dot: xr,
            question: Or,
            slash: fr,
            eq: g,
            name: Pt,
            eof: zt,
            num: yt,
            regexp: bt,
            string: Rt
          };
          for (var tr in qn)
            O.tokTypes["_" + tr] = qn[tr];
          function Fn(ie) {
            ie = ie.split(" ");
            var oe = "", Me = [];
            e:
              for (var ke = 0; ke < ie.length; ++ke) {
                for (var lt = 0; lt < Me.length; ++lt)
                  if (Me[lt][0].length == ie[ke].length) {
                    Me[lt].push(ie[ke]);
                    continue e;
                  }
                Me.push([ie[ke]]);
              }
            function At(Vt) {
              if (Vt.length == 1)
                return oe += "return str === " + JSON.stringify(Vt[0]) + ";";
              oe += "switch(str){";
              for (var Ei = 0; Ei < Vt.length; ++Ei)
                oe += "case " + JSON.stringify(Vt[Ei]) + ":";
              oe += "return true}return false;";
            }
            if (Me.length > 3) {
              Me.sort(function(Vt, Ei) {
                return Ei.length - Vt.length;
              }), oe += "switch(str.length){";
              for (var ke = 0; ke < Me.length; ++ke) {
                var wt = Me[ke];
                oe += "case " + wt[0].length + ":", At(wt);
              }
              oe += "}";
            } else
              At(ie);
            return new Function("str", oe);
          }
          var sr = Fn("abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile"), wr = Fn("class enum extends super const export import"), gs = Fn("implements interface let package private protected public static yield"), Nr = Fn("eval arguments"), pn = Fn("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this"), ps = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/, ir = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԧԱ-Ֆՙա-ևא-תװ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࢠࢢ-ࢬऄ-हऽॐक़-ॡॱ-ॷॹ-ॿঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-ళవ-హఽౘౙౠౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൠൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛰᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤜᥐ-ᥭᥰ-ᥴᦀ-ᦫᧁ-ᧇᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᳩ-ᳬᳮ-ᳱᳵᳶᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿌ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚗꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꞎꞐ-ꞓꞠ-Ɦꟸ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꪀ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", Ns = "̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ؚؠ-ىٲ-ۓۧ-ۨۻ-ۼܰ-݊ࠀ-ࠔࠛ-ࠣࠥ-ࠧࠩ-࠭ࡀ-ࡗࣤ-ࣾऀ-ःऺ-़ा-ॏ॑-ॗॢ-ॣ०-९ঁ-ঃ়া-ৄেৈৗয়-ৠਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢ-ૣ૦-૯ଁ-ଃ଼ା-ୄେୈୋ-୍ୖୗୟ-ୠ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఁ-ఃె-ైొ-్ౕౖౢ-ౣ౦-౯ಂಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢ-ೣ೦-೯ംഃെ-ൈൗൢ-ൣ൦-൯ංඃ්ා-ුූෘ-ෟෲෳิ-ฺเ-ๅ๐-๙ິ-ູ່-ໍ໐-໙༘༙༠-༩༹༵༷ཁ-ཇཱ-྄྆-྇ྍ-ྗྙ-ྼ࿆က-ဩ၀-၉ၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟ᜎ-ᜐᜠ-ᜰᝀ-ᝐᝲᝳក-ឲ៝០-៩᠋-᠍᠐-᠙ᤠ-ᤫᤰ-᤻ᥑ-ᥭᦰ-ᧀᧈ-ᧉ᧐-᧙ᨀ-ᨕᨠ-ᩓ᩠-᩿᩼-᪉᪐-᪙ᭆ-ᭋ᭐-᭙᭫-᭳᮰-᮹᯦-᯳ᰀ-ᰢ᱀-᱉ᱛ-ᱽ᳐-᳒ᴀ-ᶾḁ-ἕ‌‍‿⁀⁔⃐-⃥⃜⃡-⃰ⶁ-ⶖⷠ-ⷿ〡-〨゙゚Ꙁ-ꙭꙴ-꙽ꚟ꛰-꛱ꟸ-ꠀ꠆ꠋꠣ-ꠧꢀ-ꢁꢴ-꣄꣐-꣙ꣳ-ꣷ꤀-꤉ꤦ-꤭ꤰ-ꥅꦀ-ꦃ꦳-꧀ꨀ-ꨧꩀ-ꩁꩌ-ꩍ꩐-꩙ꩻꫠ-ꫩꫲ-ꫳꯀ-ꯡ꯬꯭꯰-꯹ﬠ-ﬨ︀-️︠-︦︳︴﹍-﹏０-９＿", ns = new RegExp("[" + ir + "]"), $n = new RegExp("[" + ir + Ns + "]"), w = /[\n\r\u2028\u2029]/, P = /\r\n|[\n\r\u2028\u2029]/g, K = O.isIdentifierStart = function(ie) {
            return ie < 65 ? ie === 36 : ie < 91 ? !0 : ie < 97 ? ie === 95 : ie < 123 ? !0 : ie >= 170 && ns.test(String.fromCharCode(ie));
          }, ne = O.isIdentifierChar = function(ie) {
            return ie < 48 ? ie === 36 : ie < 58 ? !0 : ie < 65 ? !1 : ie < 91 ? !0 : ie < 97 ? ie === 95 : ie < 123 ? !0 : ie >= 170 && $n.test(String.fromCharCode(ie));
          };
          function ge() {
            this.line = we, this.column = H - Se;
          }
          function _e() {
            we = 1, H = Se = 0, ve = !0, Je();
          }
          function be(ie, oe) {
            ae = H, Y.locations && (me = new ge()), se = ie, Je(), de = oe, ve = ie.beforeExpr;
          }
          function He() {
            var ie = Y.onComment && Y.locations && new ge(), oe = H, Me = B.indexOf("*/", H += 2);
            if (Me === -1 && Fe(H - 2, "Unterminated comment"), H = Me + 2, Y.locations) {
              P.lastIndex = oe;
              for (var ke; (ke = P.exec(B)) && ke.index < H; )
                ++we, Se = ke.index + ke[0].length;
            }
            Y.onComment && Y.onComment(
              !0,
              B.slice(oe + 2, Me),
              oe,
              H,
              ie,
              Y.locations && new ge()
            );
          }
          function De() {
            for (var ie = H, oe = Y.onComment && Y.locations && new ge(), Me = B.charCodeAt(H += 2); H < z && Me !== 10 && Me !== 13 && Me !== 8232 && Me !== 8233; )
              ++H, Me = B.charCodeAt(H);
            Y.onComment && Y.onComment(
              !1,
              B.slice(ie + 2, H),
              ie,
              H,
              oe,
              Y.locations && new ge()
            );
          }
          function Je() {
            for (; H < z; ) {
              var ie = B.charCodeAt(H);
              if (ie === 32)
                ++H;
              else if (ie === 13) {
                ++H;
                var oe = B.charCodeAt(H);
                oe === 10 && ++H, Y.locations && (++we, Se = H);
              } else if (ie === 10 || ie === 8232 || ie === 8233)
                ++H, Y.locations && (++we, Se = H);
              else if (ie > 8 && ie < 14)
                ++H;
              else if (ie === 47) {
                var oe = B.charCodeAt(H + 1);
                if (oe === 42)
                  He();
                else if (oe === 47)
                  De();
                else
                  break;
              } else if (ie === 160)
                ++H;
              else if (ie >= 5760 && ps.test(String.fromCharCode(ie)))
                ++H;
              else
                break;
            }
          }
          function Ct() {
            var ie = B.charCodeAt(H + 1);
            return ie >= 48 && ie <= 57 ? qi(!0) : (++H, be(xr));
          }
          function Bt() {
            var ie = B.charCodeAt(H + 1);
            return ve ? (++H, ki()) : ie === 61 ? mi(F, 2) : mi(fr, 1);
          }
          function dt() {
            var ie = B.charCodeAt(H + 1);
            return ie === 61 ? mi(F, 2) : mi(dr, 1);
          }
          function Ut(ie) {
            var oe = B.charCodeAt(H + 1);
            return oe === ie ? mi(ie === 124 ? Ee : nt, 2) : oe === 61 ? mi(F, 2) : mi(ie === 124 ? gt : qt, 1);
          }
          function ti() {
            var ie = B.charCodeAt(H + 1);
            return ie === 61 ? mi(F, 2) : mi(Yt, 1);
          }
          function wi(ie) {
            var oe = B.charCodeAt(H + 1);
            return oe === ie ? oe == 45 && B.charCodeAt(H + 2) == 62 && w.test(B.slice(Ge, H)) ? (H += 3, De(), Je(), fn()) : mi(ue, 2) : oe === 61 ? mi(F, 2) : mi(xn, 1);
          }
          function bi(ie) {
            var oe = B.charCodeAt(H + 1), Me = 1;
            return oe === ie ? (Me = ie === 62 && B.charCodeAt(H + 2) === 62 ? 3 : 2, B.charCodeAt(H + Me) === 61 ? mi(F, Me + 1) : mi(si, Me)) : oe == 33 && ie == 60 && B.charCodeAt(H + 2) == 45 && B.charCodeAt(H + 3) == 45 ? (H += 4, De(), Je(), fn()) : (oe === 61 && (Me = B.charCodeAt(H + 2) === 61 ? 3 : 2), mi(ni, Me));
          }
          function Cn(ie) {
            var oe = B.charCodeAt(H + 1);
            return oe === 61 ? mi(li, B.charCodeAt(H + 2) === 61 ? 3 : 2) : mi(ie === 61 ? g : ye, 1);
          }
          function mn(ie) {
            switch (ie) {
              case 46:
                return Ct();
              case 40:
                return ++H, be(ri);
              case 41:
                return ++H, be(Ji);
              case 59:
                return ++H, be(sn);
              case 44:
                return ++H, be(cn);
              case 91:
                return ++H, be(Dn);
              case 93:
                return ++H, be(Mn);
              case 123:
                return ++H, be(gn);
              case 125:
                return ++H, be(yn);
              case 58:
                return ++H, be(zn);
              case 63:
                return ++H, be(Or);
              case 48:
                var oe = B.charCodeAt(H + 1);
                if (oe === 120 || oe === 88)
                  return Oi();
              case 49:
              case 50:
              case 51:
              case 52:
              case 53:
              case 54:
              case 55:
              case 56:
              case 57:
                return qi(!1);
              case 34:
              case 39:
                return rs(ie);
              case 47:
                return Bt();
              case 37:
              case 42:
                return dt();
              case 124:
              case 38:
                return Ut(ie);
              case 94:
                return ti();
              case 43:
              case 45:
                return wi(ie);
              case 60:
              case 62:
                return bi(ie);
              case 61:
              case 33:
                return Cn(ie);
              case 126:
                return mi(ye, 1);
            }
            return !1;
          }
          function fn(ie) {
            if (ie ? H = te + 1 : te = H, Y.locations && (le = new ge()), ie)
              return ki();
            if (H >= z)
              return be(zt);
            var oe = B.charCodeAt(H);
            if (K(oe) || oe === 92)
              return Hn();
            var Me = mn(oe);
            if (Me === !1) {
              var ke = String.fromCharCode(oe);
              if (ke === "\\" || ns.test(ke))
                return Hn();
              Fe(H, "Unexpected character '" + ke + "'");
            }
            return Me;
          }
          function mi(ie, oe) {
            var Me = B.slice(H, H + oe);
            H += oe, be(ie, Me);
          }
          function ki() {
            for (var lt = "", ie, oe, Me = H; ; ) {
              H >= z && Fe(Me, "Unterminated regular expression");
              var ke = B.charAt(H);
              if (w.test(ke) && Fe(Me, "Unterminated regular expression"), ie)
                ie = !1;
              else {
                if (ke === "[")
                  oe = !0;
                else if (ke === "]" && oe)
                  oe = !1;
                else if (ke === "/" && !oe)
                  break;
                ie = ke === "\\";
              }
              ++H;
            }
            var lt = B.slice(Me, H);
            ++H;
            var At = gr();
            At && !/^[gmsiy]*$/.test(At) && Fe(Me, "Invalid regexp flag");
            try {
              var wt = new RegExp(lt, At);
            } catch (Vt) {
              Vt instanceof SyntaxError && Fe(Me, Vt.message), Fe(Vt);
            }
            return be(bt, wt);
          }
          function En(ie, oe) {
            for (var Me = H, ke = 0, lt = 0, At = oe ?? 1 / 0; lt < At; ++lt) {
              var wt = B.charCodeAt(H), Vt;
              if (wt >= 97 ? Vt = wt - 97 + 10 : wt >= 65 ? Vt = wt - 65 + 10 : wt >= 48 && wt <= 57 ? Vt = wt - 48 : Vt = 1 / 0, Vt >= ie)
                break;
              ++H, ke = ke * ie + Vt;
            }
            return H === Me || oe != null && H - Me !== oe ? null : ke;
          }
          function Oi() {
            H += 2;
            var ie = En(16);
            return ie == null && Fe(te + 2, "Expected hexadecimal number"), K(B.charCodeAt(H)) && Fe(H, "Identifier directly after number"), be(yt, ie);
          }
          function qi(ie) {
            var oe = H, Me = !1, ke = B.charCodeAt(H) === 48;
            !ie && En(10) === null && Fe(oe, "Invalid number"), B.charCodeAt(H) === 46 && (++H, En(10), Me = !0);
            var lt = B.charCodeAt(H);
            (lt === 69 || lt === 101) && (lt = B.charCodeAt(++H), (lt === 43 || lt === 45) && ++H, En(10) === null && Fe(oe, "Invalid number"), Me = !0), K(B.charCodeAt(H)) && Fe(H, "Identifier directly after number");
            var At = B.slice(oe, H), wt;
            return Me ? wt = parseFloat(At) : !ke || At.length === 1 ? wt = parseInt(At, 10) : /[89]/.test(At) || Re ? Fe(oe, "Invalid number") : wt = parseInt(At, 8), be(yt, wt);
          }
          function rs(ie) {
            H++;
            for (var oe = ""; ; ) {
              H >= z && Fe(te, "Unterminated string constant");
              var Me = B.charCodeAt(H);
              if (Me === ie)
                return ++H, be(Rt, oe);
              if (Me === 92) {
                Me = B.charCodeAt(++H);
                var ke = /^[0-7]+/.exec(B.slice(H, H + 3));
                for (ke && (ke = ke[0]); ke && parseInt(ke, 8) > 255; )
                  ke = ke.slice(0, -1);
                if (ke === "0" && (ke = null), ++H, ke)
                  Re && Fe(H - 2, "Octal literal in strict mode"), oe += String.fromCharCode(parseInt(ke, 8)), H += ke.length - 1;
                else
                  switch (Me) {
                    case 110:
                      oe += `
`;
                      break;
                    case 114:
                      oe += "\r";
                      break;
                    case 120:
                      oe += String.fromCharCode(ar(2));
                      break;
                    case 117:
                      oe += String.fromCharCode(ar(4));
                      break;
                    case 85:
                      oe += String.fromCharCode(ar(8));
                      break;
                    case 116:
                      oe += "	";
                      break;
                    case 98:
                      oe += "\b";
                      break;
                    case 118:
                      oe += "\v";
                      break;
                    case 102:
                      oe += "\f";
                      break;
                    case 48:
                      oe += "\0";
                      break;
                    case 13:
                      B.charCodeAt(H) === 10 && ++H;
                    case 10:
                      Y.locations && (Se = H, ++we);
                      break;
                    default:
                      oe += String.fromCharCode(Me);
                      break;
                  }
              } else
                (Me === 13 || Me === 10 || Me === 8232 || Me === 8233) && Fe(te, "Unterminated string constant"), oe += String.fromCharCode(Me), ++H;
            }
          }
          function ar(ie) {
            var oe = En(16, ie);
            return oe === null && Fe(te, "Bad character escape sequence"), oe;
          }
          var _n;
          function gr() {
            _n = !1;
            for (var ie, oe = !0, Me = H; ; ) {
              var ke = B.charCodeAt(H);
              if (ne(ke))
                _n && (ie += B.charAt(H)), ++H;
              else if (ke === 92) {
                _n || (ie = B.slice(Me, H)), _n = !0, B.charCodeAt(++H) != 117 && Fe(H, "Expecting Unicode escape sequence \\uXXXX"), ++H;
                var lt = ar(4), At = String.fromCharCode(lt);
                At || Fe(H - 1, "Invalid Unicode escape"), (oe ? K(lt) : ne(lt)) || Fe(H - 4, "Invalid Unicode escape"), ie += At;
              } else
                break;
              oe = !1;
            }
            return _n ? ie : B.slice(Me, H);
          }
          function Hn() {
            var ie = gr(), oe = Pt;
            return !_n && pn(ie) && (oe = qn[ie]), be(oe, ie);
          }
          function ei() {
            Ae = te, Ge = ae, Qe = me, fn();
          }
          function Xn(ie) {
            if (Re = ie, H = te, Y.locations)
              for (; H < Se; )
                Se = B.lastIndexOf(`
`, Se - 2) + 1, --we;
            Je(), fn();
          }
          function In() {
            this.type = null, this.start = te, this.end = null;
          }
          function Rr() {
            this.start = le, this.end = null, C !== null && (this.source = C);
          }
          function Si() {
            var ie = new In();
            return Y.locations && (ie.loc = new Rr()), Y.directSourceFile && (ie.sourceFile = Y.directSourceFile), Y.ranges && (ie.range = [te, 0]), ie;
          }
          function an(ie) {
            var oe = new In();
            return oe.start = ie.start, Y.locations && (oe.loc = new Rr(), oe.loc.start = ie.loc.start), Y.ranges && (oe.range = [ie.range[0], 0]), oe;
          }
          function jt(ie, oe) {
            return ie.type = oe, ie.end = Ge, Y.locations && (ie.loc.end = Qe), Y.ranges && (ie.range[1] = Ge), ie;
          }
          function Dr(ie) {
            return Y.ecmaVersion >= 5 && ie.type === "ExpressionStatement" && ie.expression.type === "Literal" && ie.expression.value === "use strict";
          }
          function hi(ie) {
            if (se === ie)
              return ei(), !0;
          }
          function Ni() {
            return !Y.strictSemicolons && (se === zt || se === yn || w.test(B.slice(Ge, te)));
          }
          function An() {
            !hi(sn) && !Ni() && dn();
          }
          function ui(ie) {
            se === ie ? ei() : dn();
          }
          function dn() {
            Fe(te, "Unexpected token");
          }
          function zr(ie) {
            ie.type !== "Identifier" && ie.type !== "MemberExpression" && Fe(ie.start, "Assigning to rvalue"), Re && ie.type === "Identifier" && Nr(ie.name) && Fe(ie.start, "Assigning to " + ie.name + " in strict mode");
          }
          function $s(ie) {
            Ae = Ge = H, Y.locations && (Qe = new ge()), st = Re = null, mt = [], fn();
            var oe = ie || Si(), Me = !0;
            for (ie || (oe.body = []); se !== zt; ) {
              var ke = un();
              oe.body.push(ke), Me && Dr(ke) && Xn(!0), Me = !1;
            }
            return jt(oe, "Program");
          }
          var jr = { kind: "loop" }, Kn = { kind: "switch" };
          function un() {
            (se === fr || se === F && de == "/=") && fn(!0);
            var ie = se, oe = Si();
            switch (ie) {
              case Wt:
              case yi:
                ei();
                var Me = ie === Wt;
                hi(sn) || Ni() ? oe.label = null : se !== Pt ? dn() : (oe.label = Ye(), An());
                for (var ke = 0; ke < mt.length; ++ke) {
                  var lt = mt[ke];
                  if ((oe.label == null || lt.name === oe.label.name) && (lt.kind != null && (Me || lt.kind === "loop") || oe.label && Me))
                    break;
                }
                return ke === mt.length && Fe(oe.start, "Unsyntactic " + ie.keyword), jt(oe, Me ? "BreakStatement" : "ContinueStatement");
              case Ai:
                return ei(), An(), jt(oe, "DebuggerStatement");
              case kt:
                return ei(), mt.push(jr), oe.body = un(), mt.pop(), ui(Fi), oe.test = Pn(), An(), jt(oe, "DoWhileStatement");
              case xi:
                if (ei(), mt.push(jr), ui(ri), se === sn)
                  return or(oe, null);
                if (se === ln) {
                  var At = Si();
                  return ei(), pr(At, !0), jt(At, "VariableDeclaration"), At.declarations.length === 1 && hi(Rn) ? jn(oe, At) : or(oe, At);
                }
                var At = Ui(!1, !0);
                return hi(Rn) ? (zr(At), jn(oe, At)) : or(oe, At);
              case tn:
                return ei(), Be(oe, !0);
              case Hi:
                return ei(), oe.test = Pn(), oe.consequent = un(), oe.alternate = hi(fi) ? un() : null, jt(oe, "IfStatement");
              case Zi:
                return !st && !Y.allowReturnOutsideFunction && Fe(te, "'return' outside of function"), ei(), hi(sn) || Ni() ? oe.argument = null : (oe.argument = Ui(), An()), jt(oe, "ReturnStatement");
              case Xi:
                ei(), oe.discriminant = Pn(), oe.cases = [], ui(gn), mt.push(Kn);
                for (var wt, Vt; se != yn; )
                  if (se === Ft || se === pi) {
                    var Ei = se === Ft;
                    wt && jt(wt, "SwitchCase"), oe.cases.push(wt = Si()), wt.consequent = [], ei(), Ei ? wt.test = Ui() : (Vt && Fe(Ae, "Multiple default clauses"), Vt = !0, wt.test = null), ui(zn);
                  } else
                    wt || dn(), wt.consequent.push(un());
                return wt && jt(wt, "SwitchCase"), ei(), mt.pop(), jt(oe, "SwitchStatement");
              case ji:
                return ei(), w.test(B.slice(Ge, te)) && Fe(Ge, "Illegal newline after throw"), oe.argument = Ui(), An(), jt(oe, "ThrowStatement");
              case Ki:
                if (ei(), oe.block = Jn(), oe.handler = null, se === Mi) {
                  var Qi = Si();
                  ei(), ui(ri), Qi.param = Ye(), Re && Nr(Qi.param.name) && Fe(Qi.param.start, "Binding " + Qi.param.name + " in strict mode"), ui(Ji), Qi.guard = null, Qi.body = Jn(), oe.handler = jt(Qi, "CatchClause");
                }
                return oe.guardedHandlers = at, oe.finalizer = hi(Ti) ? Jn() : null, !oe.handler && !oe.finalizer && Fe(oe.start, "Missing catch or finally clause"), jt(oe, "TryStatement");
              case ln:
                return ei(), pr(oe), An(), jt(oe, "VariableDeclaration");
              case Fi:
                return ei(), oe.test = Pn(), mt.push(jr), oe.body = un(), mt.pop(), jt(oe, "WhileStatement");
              case hn:
                return Re && Fe(te, "'with' in strict mode"), ei(), oe.object = Pn(), oe.body = un(), jt(oe, "WithStatement");
              case gn:
                return Jn();
              case sn:
                return ei(), jt(oe, "EmptyStatement");
              default:
                var vn = de, wn = Ui();
                if (ie === Pt && wn.type === "Identifier" && hi(zn)) {
                  for (var ke = 0; ke < mt.length; ++ke)
                    mt[ke].name === vn && Fe(wn.start, "Label '" + vn + "' is already declared");
                  var mr = se.isLoop ? "loop" : se === Xi ? "switch" : null;
                  return mt.push({ name: vn, kind: mr }), oe.body = un(), mt.pop(), oe.label = wn, jt(oe, "LabeledStatement");
                } else
                  return oe.expression = wn, An(), jt(oe, "ExpressionStatement");
            }
          }
          function Pn() {
            ui(ri);
            var ie = Ui();
            return ui(Ji), ie;
          }
          function Jn(ie) {
            var oe = Si(), Me = !0, ke = !1, lt;
            for (oe.body = [], ui(gn); !hi(yn); ) {
              var At = un();
              oe.body.push(At), Me && ie && Dr(At) && (lt = ke, Xn(ke = !0)), Me = !1;
            }
            return ke && !lt && Xn(!1), jt(oe, "BlockStatement");
          }
          function or(ie, oe) {
            return ie.init = oe, ui(sn), ie.test = se === sn ? null : Ui(), ui(sn), ie.update = se === Ji ? null : Ui(), ui(Ji), ie.body = un(), mt.pop(), jt(ie, "ForStatement");
          }
          function jn(ie, oe) {
            return ie.left = oe, ie.right = Ui(), ui(Ji), ie.body = un(), mt.pop(), jt(ie, "ForInStatement");
          }
          function pr(ie, oe) {
            for (ie.declarations = [], ie.kind = "var"; ; ) {
              var Me = Si();
              if (Me.id = Ye(), Re && Nr(Me.id.name) && Fe(Me.id.start, "Binding " + Me.id.name + " in strict mode"), Me.init = hi(g) ? Ui(!0, oe) : null, ie.declarations.push(jt(Me, "VariableDeclarator")), !hi(cn))
                break;
            }
            return ie;
          }
          function Ui(ie, oe) {
            var Me = ss(oe);
            if (!ie && se === cn) {
              var ke = an(Me);
              for (ke.expressions = [Me]; hi(cn); )
                ke.expressions.push(ss(oe));
              return jt(ke, "SequenceExpression");
            }
            return Me;
          }
          function ss(ie) {
            var oe = ms(ie);
            if (se.isAssign) {
              var Me = an(oe);
              return Me.operator = de, Me.left = oe, ei(), Me.right = ss(ie), zr(oe), jt(Me, "AssignmentExpression");
            }
            return oe;
          }
          function ms(ie) {
            var oe = Sr(ie);
            if (hi(Or)) {
              var Me = an(oe);
              return Me.test = oe, Me.consequent = Ui(!0), ui(zn), Me.alternate = Ui(!0, ie), jt(Me, "ConditionalExpression");
            }
            return oe;
          }
          function Sr(ie) {
            return Tn(Wr(), -1, ie);
          }
          function Tn(ie, oe, Me) {
            var ke = se.binop;
            if (ke != null && (!Me || se !== Rn) && ke > oe) {
              var lt = an(ie);
              lt.left = ie, lt.operator = de;
              var At = se;
              ei(), lt.right = Tn(Wr(), ke, Me);
              var wt = jt(lt, At === Ee || At === nt ? "LogicalExpression" : "BinaryExpression");
              return Tn(wt, oe, Me);
            }
            return ie;
          }
          function Wr() {
            if (se.prefix) {
              var ie = Si(), oe = se.isUpdate;
              return ie.operator = de, ie.prefix = !0, ve = !0, ei(), ie.argument = Wr(), oe ? zr(ie.argument) : Re && ie.operator === "delete" && ie.argument.type === "Identifier" && Fe(ie.start, "Deleting local variable in strict mode"), jt(ie, oe ? "UpdateExpression" : "UnaryExpression");
            }
            for (var Me = Ms(); se.postfix && !Ni(); ) {
              var ie = an(Me);
              ie.operator = de, ie.prefix = !1, ie.argument = Me, zr(Me), ei(), Me = jt(ie, "UpdateExpression");
            }
            return Me;
          }
          function Ms() {
            return lr(Pe());
          }
          function lr(ie, oe) {
            if (hi(xr)) {
              var Me = an(ie);
              return Me.object = ie, Me.property = Ye(!0), Me.computed = !1, lr(jt(Me, "MemberExpression"), oe);
            } else if (hi(Dn)) {
              var Me = an(ie);
              return Me.object = ie, Me.property = Ui(), Me.computed = !0, ui(Mn), lr(jt(Me, "MemberExpression"), oe);
            } else if (!oe && hi(ri)) {
              var Me = an(ie);
              return Me.callee = ie, Me.arguments = We(Ji, !1), lr(jt(Me, "CallExpression"), oe);
            } else
              return ie;
          }
          function Pe() {
            switch (se) {
              case Er:
                var ke = Si();
                return ei(), jt(ke, "ThisExpression");
              case Pt:
                return Ye();
              case yt:
              case Rt:
              case bt:
                var ke = Si();
                return ke.value = de, ke.raw = B.slice(te, ae), ei(), jt(ke, "Literal");
              case Ir:
              case Nn:
              case Pr:
                var ke = Si();
                return ke.value = se.atomValue, ke.raw = se.keyword, ei(), jt(ke, "Literal");
              case ri:
                var ie = le, oe = te;
                ei();
                var Me = Ui();
                return Me.start = oe, Me.end = ae, Y.locations && (Me.loc.start = ie, Me.loc.end = me), Y.ranges && (Me.range = [oe, ae]), ui(Ji), Me;
              case Dn:
                var ke = Si();
                return ei(), ke.elements = We(Mn, !0, !0), jt(ke, "ArrayExpression");
              case gn:
                return ct();
              case tn:
                var ke = Si();
                return ei(), Be(ke, !1);
              case kr:
                return Ke();
              default:
                dn();
            }
          }
          function Ke() {
            var ie = Si();
            return ei(), ie.callee = lr(Pe(), !0), hi(ri) ? ie.arguments = We(Ji, !1) : ie.arguments = at, jt(ie, "NewExpression");
          }
          function ct() {
            var ie = Si(), oe = !0, Me = !1;
            for (ie.properties = [], ei(); !hi(yn); ) {
              if (oe)
                oe = !1;
              else if (ui(cn), Y.allowTrailingCommas && hi(yn))
                break;
              var ke = { key: vt() }, lt = !1, At;
              if (hi(zn) ? (ke.value = Ui(!0), At = ke.kind = "init") : Y.ecmaVersion >= 5 && ke.key.type === "Identifier" && (ke.key.name === "get" || ke.key.name === "set") ? (lt = Me = !0, At = ke.kind = ke.key.name, ke.key = vt(), se !== ri && dn(), ke.value = Be(Si(), !1)) : dn(), ke.key.type === "Identifier" && (Re || Me))
                for (var wt = 0; wt < ie.properties.length; ++wt) {
                  var Vt = ie.properties[wt];
                  if (Vt.key.name === ke.key.name) {
                    var Ei = At == Vt.kind || lt && Vt.kind === "init" || At === "init" && (Vt.kind === "get" || Vt.kind === "set");
                    Ei && !Re && At === "init" && Vt.kind === "init" && (Ei = !1), Ei && Fe(ke.key.start, "Redefinition of property");
                  }
                }
              ie.properties.push(ke);
            }
            return jt(ie, "ObjectExpression");
          }
          function vt() {
            return se === yt || se === Rt ? Pe() : Ye(!0);
          }
          function Be(ie, oe) {
            se === Pt ? ie.id = Ye() : oe ? dn() : ie.id = null, ie.params = [];
            var Me = !0;
            for (ui(ri); !hi(Ji); )
              Me ? Me = !1 : ui(cn), ie.params.push(Ye());
            var ke = st, lt = mt;
            if (st = !0, mt = [], ie.body = Jn(!0), st = ke, mt = lt, Re || ie.body.body.length && Dr(ie.body.body[0]))
              for (var At = ie.id ? -1 : 0; At < ie.params.length; ++At) {
                var wt = At < 0 ? ie.id : ie.params[At];
                if ((gs(wt.name) || Nr(wt.name)) && Fe(wt.start, "Defining '" + wt.name + "' in strict mode"), At >= 0)
                  for (var Vt = 0; Vt < At; ++Vt)
                    wt.name === ie.params[Vt].name && Fe(wt.start, "Argument name clash in strict mode");
              }
            return jt(ie, oe ? "FunctionDeclaration" : "FunctionExpression");
          }
          function We(ie, oe, Me) {
            for (var ke = [], lt = !0; !hi(ie); ) {
              if (lt)
                lt = !1;
              else if (ui(cn), oe && Y.allowTrailingCommas && hi(ie))
                break;
              Me && se === cn ? ke.push(null) : ke.push(Ui(!0));
            }
            return ke;
          }
          function Ye(ie) {
            var oe = Si();
            return ie && Y.forbidReserved == "everywhere" && (ie = !1), se === Pt ? (!ie && (Y.forbidReserved && (Y.ecmaVersion === 3 ? sr : wr)(de) || Re && gs(de)) && B.slice(te, ae).indexOf("\\") == -1 && Fe(te, "The keyword '" + de + "' is reserved"), oe.name = de) : ie && se.keyword ? oe.name = se.keyword : dn(), ve = !1, ei(), jt(oe, "Identifier");
          }
        }), r.version || (r = null);
      }
      function u(O, Y) {
        return (i.acorn || r).parse(O, Y);
      }
      var d = {
        "+": "__add",
        "-": "__subtract",
        "*": "__multiply",
        "/": "__divide",
        "%": "__modulo",
        "==": "__equals",
        "!=": "__equals"
      }, p = {
        "-": "__negate",
        "+": "__self"
      }, m = o.each(
        ["add", "subtract", "multiply", "divide", "modulo", "equals", "negate"],
        function(O) {
          this["__" + O] = "#" + O;
        },
        {
          __self: function() {
            return this;
          }
        }
      );
      M.inject(m), U.inject(m), Tt.inject(m);
      function y(O, Y, B) {
        var z = d[Y];
        if (O && O[z]) {
          var C = O[z](B);
          return Y === "!=" ? !C : C;
        }
        switch (Y) {
          case "+":
            return O + B;
          case "-":
            return O - B;
          case "*":
            return O * B;
          case "/":
            return O / B;
          case "%":
            return O % B;
          case "==":
            return O == B;
          case "!=":
            return O != B;
        }
      }
      function S(O, Y) {
        var B = p[O];
        if (Y && Y[B])
          return Y[B]();
        switch (O) {
          case "+":
            return +Y;
          case "-":
            return -Y;
        }
      }
      function L(O, Y) {
        if (!O)
          return "";
        Y = Y || {};
        var B = [];
        function z(Re) {
          for (var Fe = 0, at = B.length; Fe < at; Fe++) {
            var yt = B[Fe];
            if (yt[0] >= Re)
              break;
            Re += yt[1];
          }
          return Re;
        }
        function C(Re) {
          return O.substring(
            z(Re.range[0]),
            z(Re.range[1])
          );
        }
        function N(Re, Fe) {
          return O.substring(
            z(Re.range[1]),
            z(Fe.range[0])
          );
        }
        function j(Re, Fe) {
          for (var at = z(Re.range[0]), yt = z(Re.range[1]), bt = 0, Rt = B.length - 1; Rt >= 0; Rt--)
            if (at > B[Rt][0]) {
              bt = Rt + 1;
              break;
            }
          B.splice(bt, 0, [at, Fe.length - yt + at]), O = O.substring(0, at) + Fe + O.substring(yt);
        }
        function q(Re, Fe) {
          switch (Re.type) {
            case "UnaryExpression":
              if (Re.operator in p && Re.argument.type !== "Literal") {
                var at = C(Re.argument);
                j(Re, '$__("' + Re.operator + '", ' + at + ")");
              }
              break;
            case "BinaryExpression":
              if (Re.operator in d && Re.left.type !== "Literal") {
                var yt = C(Re.left), bt = C(Re.right), Rt = N(Re.left, Re.right), Pt = Re.operator;
                j(Re, "__$__(" + yt + "," + Rt.replace(
                  new RegExp("\\" + Pt),
                  '"' + Pt + '"'
                ) + ", " + bt + ")");
              }
              break;
            case "UpdateExpression":
            case "AssignmentExpression":
              var zt = Fe && Fe.type;
              if (!(zt === "ForStatement" || zt === "BinaryExpression" && /^[=!<>]/.test(Fe.operator) || zt === "MemberExpression" && Fe.computed)) {
                if (Re.type === "UpdateExpression") {
                  var at = C(Re.argument), Wt = "__$__(" + at + ', "' + Re.operator[0] + '", 1)', Ft = at + " = " + Wt;
                  Re.prefix ? Ft = "(" + Ft + ")" : (zt === "AssignmentExpression" || zt === "VariableDeclarator" || zt === "BinaryExpression") && (C(Fe.left || Fe.id) === at && (Ft = Wt), Ft = at + "; " + Ft), j(Re, Ft);
                } else if (/^.=$/.test(Re.operator) && Re.left.type !== "Literal") {
                  var yt = C(Re.left), bt = C(Re.right), Wt = yt + " = __$__(" + yt + ', "' + Re.operator[0] + '", ' + bt + ")";
                  j(Re, /^\(.*\)$/.test(C(Re)) ? "(" + Wt + ")" : Wt);
                }
              }
              break;
          }
        }
        function H(Re) {
          switch (Re.type) {
            case "ExportDefaultDeclaration":
              j({
                range: [Re.start, Re.declaration.start]
              }, "module.exports = ");
              break;
            case "ExportNamedDeclaration":
              var Fe = Re.declaration, at = Re.specifiers;
              if (Fe) {
                var yt = Fe.declarations;
                yt && (yt.forEach(function(Rt) {
                  j(Rt, "module.exports." + C(Rt));
                }), j({
                  range: [
                    Re.start,
                    Fe.start + Fe.kind.length
                  ]
                }, ""));
              } else if (at) {
                var bt = at.map(function(Rt) {
                  var Pt = C(Rt);
                  return "module.exports." + Pt + " = " + Pt + "; ";
                }).join("");
                bt && j(Re, bt);
              }
              break;
          }
        }
        function te(Re, Fe, at) {
          if (Re) {
            for (var yt in Re)
              if (yt !== "range" && yt !== "loc") {
                var bt = Re[yt];
                if (Array.isArray(bt))
                  for (var Rt = 0, Pt = bt.length; Rt < Pt; Rt++)
                    te(bt[Rt], Re, at);
                else
                  bt && typeof bt == "object" && te(bt, Re, at);
              }
            at.operatorOverloading !== !1 && q(Re, Fe), at.moduleExports !== !1 && H(Re);
          }
        }
        function ae(Re) {
          var Fe = "", at = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
          for (Re = (Math.abs(Re) << 1) + (Re < 0 ? 1 : 0); Re || !Fe; ) {
            var yt = Re & 31;
            Re >>= 5, Re && (yt |= 32), Fe += at[yt];
          }
          return Fe;
        }
        var le = Y.url || "", me = Y.sourceMaps, se = Y.paperFeatures || {}, de = Y.source || O, ve = Y.offset || 0, we = Ve.agent, Se = we.versionNumber, Ae = !1, Ge = /\r\n|\n|\r/mg, Qe;
        if (me && (we.chrome && Se >= 30 || we.webkit && Se >= 537.76 || we.firefox && Se >= 23 || we.node)) {
          if (we.node)
            ve -= 2;
          else if (n && le && !n.location.href.indexOf(le)) {
            var st = a.getElementsByTagName("html")[0].innerHTML;
            ve = st.substr(0, st.indexOf(O) + 1).match(
              Ge
            ).length + 1;
          }
          Ae = ve > 0 && !(we.chrome && Se >= 36 || we.safari && Se >= 600 || we.firefox && Se >= 40 || we.node);
          var mt = ["AA" + ae(Ae ? 0 : ve) + "A"];
          mt.length = (O.match(Ge) || []).length + 1 + (Ae ? ve : 0), Qe = {
            version: 3,
            file: le,
            names: [],
            mappings: mt.join(";AACA"),
            sourceRoot: "",
            sources: [le],
            sourcesContent: [de]
          };
        }
        return (se.operatorOverloading !== !1 || se.moduleExports !== !1) && te(u(O, {
          ranges: !0,
          preserveParens: !0,
          sourceType: "module"
        }), null, se), Qe && (Ae && (O = new Array(ve + 1).join(`
`) + O), /^(inline|both)$/.test(me) && (O += `
//# sourceMappingURL=data:application/json;base64,` + e.btoa(unescape(encodeURIComponent(
          JSON.stringify(Qe)
        )))), O += `
//# sourceURL=` + (le || "paperscript")), {
          url: le,
          source: de,
          code: O,
          map: Qe
        };
      }
      function E(O, Y, B) {
        Ve = Y;
        var z = Y.getView(), C = /\btool\.\w+|\s+on(?:Key|Mouse)(?:Up|Down|Move|Drag)\b/.test(O) && !/\bnew\s+Tool\b/.test(O) ? new Ie() : null, N = C ? C._events : [], j = ["onFrame", "onResize"].concat(N), q = [], H = [], te, ae = typeof O == "object" ? O : L(O, B);
        O = ae.code;
        function le(Se, Ae) {
          for (var Ge in Se)
            (Ae || !/^_/.test(Ge)) && new RegExp("([\\b\\s\\W]|^)" + Ge.replace(/\$/g, "\\$") + "\\b").test(O) && (q.push(Ge), H.push(Se[Ge]));
        }
        le(
          { __$__: y, $__: S, paper: Y, tool: C },
          !0
        ), le(Y), O = "var module = { exports: {} }; " + O;
        var ve = o.each(j, function(Se) {
          new RegExp("\\s+" + Se + "\\b").test(O) && (q.push(Se), this.push("module.exports." + Se + " = " + Se + ";"));
        }, []).join(`
`);
        ve && (O += `
` + ve), O += `
return module.exports;`;
        var me = Ve.agent;
        if (a && (me.chrome || me.firefox && me.versionNumber < 40)) {
          var se = a.createElement("script"), de = a.head || a.getElementsByTagName("head")[0];
          me.firefox && (O = `
` + O), se.appendChild(a.createTextNode(
            "document.__paperscript__ = function(" + q + ") {" + O + `
}`
          )), de.appendChild(se), te = a.__paperscript__, delete a.__paperscript__, de.removeChild(se);
        } else
          te = Function(q, O);
        var ve = te && te.apply(Y, H), we = ve || {};
        return o.each(N, function(Se) {
          var Ae = we[Se];
          Ae && (C[Se] = Ae);
        }), z && (we.onResize && z.setOnResize(we.onResize), z.emit("resize", {
          size: z.size,
          delta: new M()
        }), we.onFrame && z.setOnFrame(we.onFrame), z.requestUpdate()), ve;
      }
      function A(O) {
        if (/^text\/(?:x-|)paperscript$/.test(O.type) && f.getAttribute(O, "ignore") !== "true") {
          var Y = f.getAttribute(O, "canvas"), B = a.getElementById(Y), z = O.src || O.getAttribute("data-src"), C = f.hasAttribute(O, "async"), N = "data-paper-scope";
          if (!B)
            throw new Error('Unable to find canvas with id "' + Y + '"');
          var j = f.get(B.getAttribute(N)) || new f().setup(B);
          return B.setAttribute(N, j._id), z ? Et.request({
            url: z,
            async: C,
            mimeType: "text/plain",
            onLoad: function(q) {
              E(q, j, z);
            }
          }) : E(O.innerHTML, j, O.baseURI), O.setAttribute("data-paper-ignore", "true"), j;
        }
      }
      function T() {
        o.each(
          a && a.getElementsByTagName("script"),
          A
        );
      }
      function G(O) {
        return O ? A(O) : T();
      }
      return n && (a.readyState === "complete" ? setTimeout(T) : Jt.add(n, { load: T })), {
        compile: L,
        execute: E,
        load: G,
        parse: u,
        calculateBinary: y,
        calculateUnary: S
      };
    }).call(this);
    var Ve = new (f.inject(o.exports, {
      Base: o,
      Numerical: I,
      Key: Lt,
      DomEvent: Jt,
      DomElement: Zt,
      document: a,
      window: n,
      Symbol: Te,
      PlacedSymbol: pt
    }))();
    return Ve.agent.node && Vf(Ve), typeof t == "function" && t.amd ? t("paper", Ve) : b && (b.exports = Ve), Ve;
  }).call(ts, typeof self == "object" ? self : null);
})(og);
var Iw = og.exports;
const Pw = /* @__PURE__ */ ru(Iw);
function Ow(b) {
  if (b && !(typeof window > "u")) {
    var e = document.createElement("style");
    return e.setAttribute("type", "text/css"), e.innerHTML = b, document.head.appendChild(e), b;
  }
}
function Ma(b, e) {
  var t = b.__state.conversionName.toString(), n = Math.round(b.r), a = Math.round(b.g), o = Math.round(b.b), h = b.a, f = Math.round(b.h), v = b.s.toFixed(1), x = b.v.toFixed(1);
  if (e || t === "THREE_CHAR_HEX" || t === "SIX_CHAR_HEX") {
    for (var k = b.hex.toString(16); k.length < 6; )
      k = "0" + k;
    return "#" + k;
  } else {
    if (t === "CSS_RGB")
      return "rgb(" + n + "," + a + "," + o + ")";
    if (t === "CSS_RGBA")
      return "rgba(" + n + "," + a + "," + o + "," + h + ")";
    if (t === "HEX")
      return "0x" + b.hex.toString(16);
    if (t === "RGB_ARRAY")
      return "[" + n + "," + a + "," + o + "]";
    if (t === "RGBA_ARRAY")
      return "[" + n + "," + a + "," + o + "," + h + "]";
    if (t === "RGB_OBJ")
      return "{r:" + n + ",g:" + a + ",b:" + o + "}";
    if (t === "RGBA_OBJ")
      return "{r:" + n + ",g:" + a + ",b:" + o + ",a:" + h + "}";
    if (t === "HSV_OBJ")
      return "{h:" + f + ",s:" + v + ",v:" + x + "}";
    if (t === "HSVA_OBJ")
      return "{h:" + f + ",s:" + v + ",v:" + x + ",a:" + h + "}";
  }
  return "unknown format";
}
var Yf = Array.prototype.forEach, ja = Array.prototype.slice, Dt = {
  BREAK: {},
  extend: function(e) {
    return this.each(ja.call(arguments, 1), function(t) {
      var n = this.isObject(t) ? Object.keys(t) : [];
      n.forEach((function(a) {
        this.isUndefined(t[a]) || (e[a] = t[a]);
      }).bind(this));
    }, this), e;
  },
  defaults: function(e) {
    return this.each(ja.call(arguments, 1), function(t) {
      var n = this.isObject(t) ? Object.keys(t) : [];
      n.forEach((function(a) {
        this.isUndefined(e[a]) && (e[a] = t[a]);
      }).bind(this));
    }, this), e;
  },
  compose: function() {
    var e = ja.call(arguments);
    return function() {
      for (var t = ja.call(arguments), n = e.length - 1; n >= 0; n--)
        t = [e[n].apply(this, t)];
      return t[0];
    };
  },
  each: function(e, t, n) {
    if (e) {
      if (Yf && e.forEach && e.forEach === Yf)
        e.forEach(t, n);
      else if (e.length === e.length + 0) {
        var a = void 0, o = void 0;
        for (a = 0, o = e.length; a < o; a++)
          if (a in e && t.call(n, e[a], a) === this.BREAK)
            return;
      } else
        for (var h in e)
          if (t.call(n, e[h], h) === this.BREAK)
            return;
    }
  },
  defer: function(e) {
    setTimeout(e, 0);
  },
  debounce: function(e, t, n) {
    var a = void 0;
    return function() {
      var o = this, h = arguments;
      function f() {
        a = null, n || e.apply(o, h);
      }
      var v = n || !a;
      clearTimeout(a), a = setTimeout(f, t), v && e.apply(o, h);
    };
  },
  toArray: function(e) {
    return e.toArray ? e.toArray() : ja.call(e);
  },
  isUndefined: function(e) {
    return e === void 0;
  },
  isNull: function(e) {
    return e === null;
  },
  isNaN: function(b) {
    function e(t) {
      return b.apply(this, arguments);
    }
    return e.toString = function() {
      return b.toString();
    }, e;
  }(function(b) {
    return isNaN(b);
  }),
  isArray: Array.isArray || function(b) {
    return b.constructor === Array;
  },
  isObject: function(e) {
    return e === Object(e);
  },
  isNumber: function(e) {
    return e === e + 0;
  },
  isString: function(e) {
    return e === e + "";
  },
  isBoolean: function(e) {
    return e === !1 || e === !0;
  },
  isFunction: function(e) {
    return e instanceof Function;
  }
}, Nw = [
  {
    litmus: Dt.isString,
    conversions: {
      THREE_CHAR_HEX: {
        read: function(e) {
          var t = e.match(/^#([A-F0-9])([A-F0-9])([A-F0-9])$/i);
          return t === null ? !1 : {
            space: "HEX",
            hex: parseInt("0x" + t[1].toString() + t[1].toString() + t[2].toString() + t[2].toString() + t[3].toString() + t[3].toString(), 0)
          };
        },
        write: Ma
      },
      SIX_CHAR_HEX: {
        read: function(e) {
          var t = e.match(/^#([A-F0-9]{6})$/i);
          return t === null ? !1 : {
            space: "HEX",
            hex: parseInt("0x" + t[1].toString(), 0)
          };
        },
        write: Ma
      },
      CSS_RGB: {
        read: function(e) {
          var t = e.match(/^rgb\(\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*\)/);
          return t === null ? !1 : {
            space: "RGB",
            r: parseFloat(t[1]),
            g: parseFloat(t[2]),
            b: parseFloat(t[3])
          };
        },
        write: Ma
      },
      CSS_RGBA: {
        read: function(e) {
          var t = e.match(/^rgba\(\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*\)/);
          return t === null ? !1 : {
            space: "RGB",
            r: parseFloat(t[1]),
            g: parseFloat(t[2]),
            b: parseFloat(t[3]),
            a: parseFloat(t[4])
          };
        },
        write: Ma
      }
    }
  },
  {
    litmus: Dt.isNumber,
    conversions: {
      HEX: {
        read: function(e) {
          return {
            space: "HEX",
            hex: e,
            conversionName: "HEX"
          };
        },
        write: function(e) {
          return e.hex;
        }
      }
    }
  },
  {
    litmus: Dt.isArray,
    conversions: {
      RGB_ARRAY: {
        read: function(e) {
          return e.length !== 3 ? !1 : {
            space: "RGB",
            r: e[0],
            g: e[1],
            b: e[2]
          };
        },
        write: function(e) {
          return [e.r, e.g, e.b];
        }
      },
      RGBA_ARRAY: {
        read: function(e) {
          return e.length !== 4 ? !1 : {
            space: "RGB",
            r: e[0],
            g: e[1],
            b: e[2],
            a: e[3]
          };
        },
        write: function(e) {
          return [e.r, e.g, e.b, e.a];
        }
      }
    }
  },
  {
    litmus: Dt.isObject,
    conversions: {
      RGBA_OBJ: {
        read: function(e) {
          return Dt.isNumber(e.r) && Dt.isNumber(e.g) && Dt.isNumber(e.b) && Dt.isNumber(e.a) ? {
            space: "RGB",
            r: e.r,
            g: e.g,
            b: e.b,
            a: e.a
          } : !1;
        },
        write: function(e) {
          return {
            r: e.r,
            g: e.g,
            b: e.b,
            a: e.a
          };
        }
      },
      RGB_OBJ: {
        read: function(e) {
          return Dt.isNumber(e.r) && Dt.isNumber(e.g) && Dt.isNumber(e.b) ? {
            space: "RGB",
            r: e.r,
            g: e.g,
            b: e.b
          } : !1;
        },
        write: function(e) {
          return {
            r: e.r,
            g: e.g,
            b: e.b
          };
        }
      },
      HSVA_OBJ: {
        read: function(e) {
          return Dt.isNumber(e.h) && Dt.isNumber(e.s) && Dt.isNumber(e.v) && Dt.isNumber(e.a) ? {
            space: "HSV",
            h: e.h,
            s: e.s,
            v: e.v,
            a: e.a
          } : !1;
        },
        write: function(e) {
          return {
            h: e.h,
            s: e.s,
            v: e.v,
            a: e.a
          };
        }
      },
      HSV_OBJ: {
        read: function(e) {
          return Dt.isNumber(e.h) && Dt.isNumber(e.s) && Dt.isNumber(e.v) ? {
            space: "HSV",
            h: e.h,
            s: e.s,
            v: e.v
          } : !1;
        },
        write: function(e) {
          return {
            h: e.h,
            s: e.s,
            v: e.v
          };
        }
      }
    }
  }
], Wa = void 0, tl = void 0, Yh = function() {
  tl = !1;
  var e = arguments.length > 1 ? Dt.toArray(arguments) : arguments[0];
  return Dt.each(Nw, function(t) {
    if (t.litmus(e))
      return Dt.each(t.conversions, function(n, a) {
        if (Wa = n.read(e), tl === !1 && Wa !== !1)
          return tl = Wa, Wa.conversionName = a, Wa.conversion = n, Dt.BREAK;
      }), Dt.BREAK;
  }), tl;
}, Gf = void 0, bl = {
  hsv_to_rgb: function(e, t, n) {
    var a = Math.floor(e / 60) % 6, o = e / 60 - Math.floor(e / 60), h = n * (1 - t), f = n * (1 - o * t), v = n * (1 - (1 - o) * t), x = [[n, v, h], [f, n, h], [h, n, v], [h, f, n], [v, h, n], [n, h, f]][a];
    return {
      r: x[0] * 255,
      g: x[1] * 255,
      b: x[2] * 255
    };
  },
  rgb_to_hsv: function(e, t, n) {
    var a = Math.min(e, t, n), o = Math.max(e, t, n), h = o - a, f = void 0, v = void 0;
    if (o !== 0)
      v = h / o;
    else
      return {
        h: NaN,
        s: 0,
        v: 0
      };
    return e === o ? f = (t - n) / h : t === o ? f = 2 + (n - e) / h : f = 4 + (e - t) / h, f /= 6, f < 0 && (f += 1), {
      h: f * 360,
      s: v,
      v: o / 255
    };
  },
  rgb_to_hex: function(e, t, n) {
    var a = this.hex_with_component(0, 2, e);
    return a = this.hex_with_component(a, 1, t), a = this.hex_with_component(a, 0, n), a;
  },
  component_from_hex: function(e, t) {
    return e >> t * 8 & 255;
  },
  hex_with_component: function(e, t, n) {
    return n << (Gf = t * 8) | e & ~(255 << Gf);
  }
}, Rw = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(b) {
  return typeof b;
} : function(b) {
  return b && typeof Symbol == "function" && b.constructor === Symbol && b !== Symbol.prototype ? "symbol" : typeof b;
}, fs = function(b, e) {
  if (!(b instanceof e))
    throw new TypeError("Cannot call a class as a function");
}, ds = function() {
  function b(e, t) {
    for (var n = 0; n < t.length; n++) {
      var a = t[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, n) {
    return t && b(e.prototype, t), n && b(e, n), e;
  };
}(), js = function b(e, t, n) {
  e === null && (e = Function.prototype);
  var a = Object.getOwnPropertyDescriptor(e, t);
  if (a === void 0) {
    var o = Object.getPrototypeOf(e);
    return o === null ? void 0 : b(o, t, n);
  } else {
    if ("value" in a)
      return a.value;
    var h = a.get;
    return h === void 0 ? void 0 : h.call(n);
  }
}, Zs = function(b, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  b.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: b,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(b, e) : b.__proto__ = e);
}, qs = function(b, e) {
  if (!b)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : b;
}, er = function() {
  function b() {
    if (fs(this, b), this.__state = Yh.apply(this, arguments), this.__state === !1)
      throw new Error("Failed to interpret color arguments");
    this.__state.a = this.__state.a || 1;
  }
  return ds(b, [{
    key: "toString",
    value: function() {
      return Ma(this);
    }
  }, {
    key: "toHexString",
    value: function() {
      return Ma(this, !0);
    }
  }, {
    key: "toOriginal",
    value: function() {
      return this.__state.conversion.write(this);
    }
  }]), b;
}();
function mu(b, e, t) {
  Object.defineProperty(b, e, {
    get: function() {
      return this.__state.space === "RGB" ? this.__state[e] : (er.recalculateRGB(this, e, t), this.__state[e]);
    },
    set: function(a) {
      this.__state.space !== "RGB" && (er.recalculateRGB(this, e, t), this.__state.space = "RGB"), this.__state[e] = a;
    }
  });
}
function _u(b, e) {
  Object.defineProperty(b, e, {
    get: function() {
      return this.__state.space === "HSV" ? this.__state[e] : (er.recalculateHSV(this), this.__state[e]);
    },
    set: function(n) {
      this.__state.space !== "HSV" && (er.recalculateHSV(this), this.__state.space = "HSV"), this.__state[e] = n;
    }
  });
}
er.recalculateRGB = function(b, e, t) {
  if (b.__state.space === "HEX")
    b.__state[e] = bl.component_from_hex(b.__state.hex, t);
  else if (b.__state.space === "HSV")
    Dt.extend(b.__state, bl.hsv_to_rgb(b.__state.h, b.__state.s, b.__state.v));
  else
    throw new Error("Corrupted color state");
};
er.recalculateHSV = function(b) {
  var e = bl.rgb_to_hsv(b.r, b.g, b.b);
  Dt.extend(b.__state, {
    s: e.s,
    v: e.v
  }), Dt.isNaN(e.h) ? Dt.isUndefined(b.__state.h) && (b.__state.h = 0) : b.__state.h = e.h;
};
er.COMPONENTS = ["r", "g", "b", "h", "s", "v", "hex", "a"];
mu(er.prototype, "r", 2);
mu(er.prototype, "g", 1);
mu(er.prototype, "b", 0);
_u(er.prototype, "h");
_u(er.prototype, "s");
_u(er.prototype, "v");
Object.defineProperty(er.prototype, "a", {
  get: function() {
    return this.__state.a;
  },
  set: function(e) {
    this.__state.a = e;
  }
});
Object.defineProperty(er.prototype, "hex", {
  get: function() {
    return this.__state.space !== "HEX" && (this.__state.hex = bl.rgb_to_hex(this.r, this.g, this.b), this.__state.space = "HEX"), this.__state.hex;
  },
  set: function(e) {
    this.__state.space = "HEX", this.__state.hex = e;
  }
});
var ca = function() {
  function b(e, t) {
    fs(this, b), this.initialValue = e[t], this.domElement = document.createElement("div"), this.object = e, this.property = t, this.__onChange = void 0, this.__onFinishChange = void 0;
  }
  return ds(b, [{
    key: "onChange",
    value: function(t) {
      return this.__onChange = t, this;
    }
  }, {
    key: "onFinishChange",
    value: function(t) {
      return this.__onFinishChange = t, this;
    }
  }, {
    key: "setValue",
    value: function(t) {
      return this.object[this.property] = t, this.__onChange && this.__onChange.call(this, t), this.updateDisplay(), this;
    }
  }, {
    key: "getValue",
    value: function() {
      return this.object[this.property];
    }
  }, {
    key: "updateDisplay",
    value: function() {
      return this;
    }
  }, {
    key: "isModified",
    value: function() {
      return this.initialValue !== this.getValue();
    }
  }]), b;
}(), Dw = {
  HTMLEvents: ["change"],
  MouseEvents: ["click", "mousemove", "mousedown", "mouseup", "mouseover"],
  KeyboardEvents: ["keydown"]
}, lg = {};
Dt.each(Dw, function(b, e) {
  Dt.each(b, function(t) {
    lg[t] = e;
  });
});
var zw = /(\d+(\.\d+)?)px/;
function ws(b) {
  if (b === "0" || Dt.isUndefined(b))
    return 0;
  var e = b.match(zw);
  return Dt.isNull(e) ? 0 : parseFloat(e[1]);
}
var St = {
  makeSelectable: function(e, t) {
    e === void 0 || e.style === void 0 || (e.onselectstart = t ? function() {
      return !1;
    } : function() {
    }, e.style.MozUserSelect = t ? "auto" : "none", e.style.KhtmlUserSelect = t ? "auto" : "none", e.unselectable = t ? "on" : "off");
  },
  makeFullscreen: function(e, t, n) {
    var a = n, o = t;
    Dt.isUndefined(o) && (o = !0), Dt.isUndefined(a) && (a = !0), e.style.position = "absolute", o && (e.style.left = 0, e.style.right = 0), a && (e.style.top = 0, e.style.bottom = 0);
  },
  fakeEvent: function(e, t, n, a) {
    var o = n || {}, h = lg[t];
    if (!h)
      throw new Error("Event type " + t + " not supported.");
    var f = document.createEvent(h);
    switch (h) {
      case "MouseEvents": {
        var v = o.x || o.clientX || 0, x = o.y || o.clientY || 0;
        f.initMouseEvent(
          t,
          o.bubbles || !1,
          o.cancelable || !0,
          window,
          o.clickCount || 1,
          0,
          0,
          v,
          x,
          !1,
          !1,
          !1,
          !1,
          0,
          null
        );
        break;
      }
      case "KeyboardEvents": {
        var k = f.initKeyboardEvent || f.initKeyEvent;
        Dt.defaults(o, {
          cancelable: !0,
          ctrlKey: !1,
          altKey: !1,
          shiftKey: !1,
          metaKey: !1,
          keyCode: void 0,
          charCode: void 0
        }), k(t, o.bubbles || !1, o.cancelable, window, o.ctrlKey, o.altKey, o.shiftKey, o.metaKey, o.keyCode, o.charCode);
        break;
      }
      default: {
        f.initEvent(t, o.bubbles || !1, o.cancelable || !0);
        break;
      }
    }
    Dt.defaults(f, a), e.dispatchEvent(f);
  },
  bind: function(e, t, n, a) {
    var o = a || !1;
    return e.addEventListener ? e.addEventListener(t, n, o) : e.attachEvent && e.attachEvent("on" + t, n), St;
  },
  unbind: function(e, t, n, a) {
    var o = a || !1;
    return e.removeEventListener ? e.removeEventListener(t, n, o) : e.detachEvent && e.detachEvent("on" + t, n), St;
  },
  addClass: function(e, t) {
    if (e.className === void 0)
      e.className = t;
    else if (e.className !== t) {
      var n = e.className.split(/ +/);
      n.indexOf(t) === -1 && (n.push(t), e.className = n.join(" ").replace(/^\s+/, "").replace(/\s+$/, ""));
    }
    return St;
  },
  removeClass: function(e, t) {
    if (t)
      if (e.className === t)
        e.removeAttribute("class");
      else {
        var n = e.className.split(/ +/), a = n.indexOf(t);
        a !== -1 && (n.splice(a, 1), e.className = n.join(" "));
      }
    else
      e.className = void 0;
    return St;
  },
  hasClass: function(e, t) {
    return new RegExp("(?:^|\\s+)" + t + "(?:\\s+|$)").test(e.className) || !1;
  },
  getWidth: function(e) {
    var t = getComputedStyle(e);
    return ws(t["border-left-width"]) + ws(t["border-right-width"]) + ws(t["padding-left"]) + ws(t["padding-right"]) + ws(t.width);
  },
  getHeight: function(e) {
    var t = getComputedStyle(e);
    return ws(t["border-top-width"]) + ws(t["border-bottom-width"]) + ws(t["padding-top"]) + ws(t["padding-bottom"]) + ws(t.height);
  },
  getOffset: function(e) {
    var t = e, n = { left: 0, top: 0 };
    if (t.offsetParent)
      do
        n.left += t.offsetLeft, n.top += t.offsetTop, t = t.offsetParent;
      while (t);
    return n;
  },
  isActive: function(e) {
    return e === document.activeElement && (e.type || e.href);
  }
}, hg = function(b) {
  Zs(e, b);
  function e(t, n) {
    fs(this, e);
    var a = qs(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)), o = a;
    a.__prev = a.getValue(), a.__checkbox = document.createElement("input"), a.__checkbox.setAttribute("type", "checkbox");
    function h() {
      o.setValue(!o.__prev);
    }
    return St.bind(a.__checkbox, "change", h, !1), a.domElement.appendChild(a.__checkbox), a.updateDisplay(), a;
  }
  return ds(e, [{
    key: "setValue",
    value: function(n) {
      var a = js(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "setValue", this).call(this, n);
      return this.__onFinishChange && this.__onFinishChange.call(this, this.getValue()), this.__prev = this.getValue(), a;
    }
  }, {
    key: "updateDisplay",
    value: function() {
      return this.getValue() === !0 ? (this.__checkbox.setAttribute("checked", "checked"), this.__checkbox.checked = !0, this.__prev = !0) : (this.__checkbox.checked = !1, this.__prev = !1), js(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this);
    }
  }]), e;
}(ca), Fw = function(b) {
  Zs(e, b);
  function e(t, n, a) {
    fs(this, e);
    var o = qs(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)), h = a, f = o;
    if (o.__select = document.createElement("select"), Dt.isArray(h)) {
      var v = {};
      Dt.each(h, function(x) {
        v[x] = x;
      }), h = v;
    }
    return Dt.each(h, function(x, k) {
      var I = document.createElement("option");
      I.innerHTML = k, I.setAttribute("value", x), f.__select.appendChild(I);
    }), o.updateDisplay(), St.bind(o.__select, "change", function() {
      var x = this.options[this.selectedIndex].value;
      f.setValue(x);
    }), o.domElement.appendChild(o.__select), o;
  }
  return ds(e, [{
    key: "setValue",
    value: function(n) {
      var a = js(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "setValue", this).call(this, n);
      return this.__onFinishChange && this.__onFinishChange.call(this, this.getValue()), a;
    }
  }, {
    key: "updateDisplay",
    value: function() {
      return St.isActive(this.__select) ? this : (this.__select.value = this.getValue(), js(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this));
    }
  }]), e;
}(ca), Uw = function(b) {
  Zs(e, b);
  function e(t, n) {
    fs(this, e);
    var a = qs(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)), o = a;
    function h() {
      o.setValue(o.__input.value);
    }
    function f() {
      o.__onFinishChange && o.__onFinishChange.call(o, o.getValue());
    }
    return a.__input = document.createElement("input"), a.__input.setAttribute("type", "text"), St.bind(a.__input, "keyup", h), St.bind(a.__input, "change", h), St.bind(a.__input, "blur", f), St.bind(a.__input, "keydown", function(v) {
      v.keyCode === 13 && this.blur();
    }), a.updateDisplay(), a.domElement.appendChild(a.__input), a;
  }
  return ds(e, [{
    key: "updateDisplay",
    value: function() {
      return St.isActive(this.__input) || (this.__input.value = this.getValue()), js(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this);
    }
  }]), e;
}(ca);
function jf(b) {
  var e = b.toString();
  return e.indexOf(".") > -1 ? e.length - e.indexOf(".") - 1 : 0;
}
var ug = function(b) {
  Zs(e, b);
  function e(t, n, a) {
    fs(this, e);
    var o = qs(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)), h = a || {};
    return o.__min = h.min, o.__max = h.max, o.__step = h.step, Dt.isUndefined(o.__step) ? o.initialValue === 0 ? o.__impliedStep = 1 : o.__impliedStep = Math.pow(10, Math.floor(Math.log(Math.abs(o.initialValue)) / Math.LN10)) / 10 : o.__impliedStep = o.__step, o.__precision = jf(o.__impliedStep), o;
  }
  return ds(e, [{
    key: "setValue",
    value: function(n) {
      var a = n;
      return this.__min !== void 0 && a < this.__min ? a = this.__min : this.__max !== void 0 && a > this.__max && (a = this.__max), this.__step !== void 0 && a % this.__step !== 0 && (a = Math.round(a / this.__step) * this.__step), js(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "setValue", this).call(this, a);
    }
  }, {
    key: "min",
    value: function(n) {
      return this.__min = n, this;
    }
  }, {
    key: "max",
    value: function(n) {
      return this.__max = n, this;
    }
  }, {
    key: "step",
    value: function(n) {
      return this.__step = n, this.__impliedStep = n, this.__precision = jf(n), this;
    }
  }]), e;
}(ca);
function Vw(b, e) {
  var t = Math.pow(10, e);
  return Math.round(b * t) / t;
}
var xl = function(b) {
  Zs(e, b);
  function e(t, n, a) {
    fs(this, e);
    var o = qs(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n, a));
    o.__truncationSuspended = !1;
    var h = o, f = void 0;
    function v() {
      var W = parseFloat(h.__input.value);
      Dt.isNaN(W) || h.setValue(W);
    }
    function x() {
      h.__onFinishChange && h.__onFinishChange.call(h, h.getValue());
    }
    function k() {
      x();
    }
    function I(W) {
      var U = f - W.clientY;
      h.setValue(h.getValue() + U * h.__impliedStep), f = W.clientY;
    }
    function V() {
      St.unbind(window, "mousemove", I), St.unbind(window, "mouseup", V), x();
    }
    function M(W) {
      St.bind(window, "mousemove", I), St.bind(window, "mouseup", V), f = W.clientY;
    }
    return o.__input = document.createElement("input"), o.__input.setAttribute("type", "text"), St.bind(o.__input, "change", v), St.bind(o.__input, "blur", k), St.bind(o.__input, "mousedown", M), St.bind(o.__input, "keydown", function(W) {
      W.keyCode === 13 && (h.__truncationSuspended = !0, this.blur(), h.__truncationSuspended = !1, x());
    }), o.updateDisplay(), o.domElement.appendChild(o.__input), o;
  }
  return ds(e, [{
    key: "updateDisplay",
    value: function() {
      return this.__input.value = this.__truncationSuspended ? this.getValue() : Vw(this.getValue(), this.__precision), js(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this);
    }
  }]), e;
}(ug);
function Wf(b, e, t, n, a) {
  return n + (a - n) * ((b - e) / (t - e));
}
var Gh = function(b) {
  Zs(e, b);
  function e(t, n, a, o, h) {
    fs(this, e);
    var f = qs(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n, { min: a, max: o, step: h })), v = f;
    f.__background = document.createElement("div"), f.__foreground = document.createElement("div"), St.bind(f.__background, "mousedown", x), St.bind(f.__background, "touchstart", V), St.addClass(f.__background, "slider"), St.addClass(f.__foreground, "slider-fg");
    function x(U) {
      document.activeElement.blur(), St.bind(window, "mousemove", k), St.bind(window, "mouseup", I), k(U);
    }
    function k(U) {
      U.preventDefault();
      var Q = v.__background.getBoundingClientRect();
      return v.setValue(Wf(U.clientX, Q.left, Q.right, v.__min, v.__max)), !1;
    }
    function I() {
      St.unbind(window, "mousemove", k), St.unbind(window, "mouseup", I), v.__onFinishChange && v.__onFinishChange.call(v, v.getValue());
    }
    function V(U) {
      U.touches.length === 1 && (St.bind(window, "touchmove", M), St.bind(window, "touchend", W), M(U));
    }
    function M(U) {
      var Q = U.touches[0].clientX, D = v.__background.getBoundingClientRect();
      v.setValue(Wf(Q, D.left, D.right, v.__min, v.__max));
    }
    function W() {
      St.unbind(window, "touchmove", M), St.unbind(window, "touchend", W), v.__onFinishChange && v.__onFinishChange.call(v, v.getValue());
    }
    return f.updateDisplay(), f.__background.appendChild(f.__foreground), f.domElement.appendChild(f.__background), f;
  }
  return ds(e, [{
    key: "updateDisplay",
    value: function() {
      var n = (this.getValue() - this.__min) / (this.__max - this.__min);
      return this.__foreground.style.width = n * 100 + "%", js(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "updateDisplay", this).call(this);
    }
  }]), e;
}(ug), cg = function(b) {
  Zs(e, b);
  function e(t, n, a) {
    fs(this, e);
    var o = qs(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n)), h = o;
    return o.__button = document.createElement("div"), o.__button.innerHTML = a === void 0 ? "Fire" : a, St.bind(o.__button, "click", function(f) {
      return f.preventDefault(), h.fire(), !1;
    }), St.addClass(o.__button, "button"), o.domElement.appendChild(o.__button), o;
  }
  return ds(e, [{
    key: "fire",
    value: function() {
      this.__onChange && this.__onChange.call(this), this.getValue().call(this.object), this.__onFinishChange && this.__onFinishChange.call(this, this.getValue());
    }
  }]), e;
}(ca), jh = function(b) {
  Zs(e, b);
  function e(t, n) {
    fs(this, e);
    var a = qs(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n));
    a.__color = new er(a.getValue()), a.__temp = new er(0);
    var o = a;
    a.domElement = document.createElement("div"), St.makeSelectable(a.domElement, !1), a.__selector = document.createElement("div"), a.__selector.className = "selector", a.__saturation_field = document.createElement("div"), a.__saturation_field.className = "saturation-field", a.__field_knob = document.createElement("div"), a.__field_knob.className = "field-knob", a.__field_knob_border = "2px solid ", a.__hue_knob = document.createElement("div"), a.__hue_knob.className = "hue-knob", a.__hue_field = document.createElement("div"), a.__hue_field.className = "hue-field", a.__input = document.createElement("input"), a.__input.type = "text", a.__input_textShadow = "0 1px 1px ", St.bind(a.__input, "keydown", function(U) {
      U.keyCode === 13 && I.call(this);
    }), St.bind(a.__input, "blur", I), St.bind(a.__selector, "mousedown", function() {
      St.addClass(this, "drag").bind(window, "mouseup", function() {
        St.removeClass(o.__selector, "drag");
      });
    }), St.bind(a.__selector, "touchstart", function() {
      St.addClass(this, "drag").bind(window, "touchend", function() {
        St.removeClass(o.__selector, "drag");
      });
    });
    var h = document.createElement("div");
    Dt.extend(a.__selector.style, {
      width: "122px",
      height: "102px",
      padding: "3px",
      backgroundColor: "#222",
      boxShadow: "0px 1px 3px rgba(0,0,0,0.3)"
    }), Dt.extend(a.__field_knob.style, {
      position: "absolute",
      width: "12px",
      height: "12px",
      border: a.__field_knob_border + (a.__color.v < 0.5 ? "#fff" : "#000"),
      boxShadow: "0px 1px 3px rgba(0,0,0,0.5)",
      borderRadius: "12px",
      zIndex: 1
    }), Dt.extend(a.__hue_knob.style, {
      position: "absolute",
      width: "15px",
      height: "2px",
      borderRight: "4px solid #fff",
      zIndex: 1
    }), Dt.extend(a.__saturation_field.style, {
      width: "100px",
      height: "100px",
      border: "1px solid #555",
      marginRight: "3px",
      display: "inline-block",
      cursor: "pointer"
    }), Dt.extend(h.style, {
      width: "100%",
      height: "100%",
      background: "none"
    }), Zf(h, "top", "rgba(0,0,0,0)", "#000"), Dt.extend(a.__hue_field.style, {
      width: "15px",
      height: "100px",
      border: "1px solid #555",
      cursor: "ns-resize",
      position: "absolute",
      top: "3px",
      right: "3px"
    }), Yw(a.__hue_field), Dt.extend(a.__input.style, {
      outline: "none",
      textAlign: "center",
      color: "#fff",
      border: 0,
      fontWeight: "bold",
      textShadow: a.__input_textShadow + "rgba(0,0,0,0.7)"
    }), St.bind(a.__saturation_field, "mousedown", f), St.bind(a.__saturation_field, "touchstart", f), St.bind(a.__field_knob, "mousedown", f), St.bind(a.__field_knob, "touchstart", f), St.bind(a.__hue_field, "mousedown", v), St.bind(a.__hue_field, "touchstart", v);
    function f(U) {
      M(U), St.bind(window, "mousemove", M), St.bind(window, "touchmove", M), St.bind(window, "mouseup", x), St.bind(window, "touchend", x);
    }
    function v(U) {
      W(U), St.bind(window, "mousemove", W), St.bind(window, "touchmove", W), St.bind(window, "mouseup", k), St.bind(window, "touchend", k);
    }
    function x() {
      St.unbind(window, "mousemove", M), St.unbind(window, "touchmove", M), St.unbind(window, "mouseup", x), St.unbind(window, "touchend", x), V();
    }
    function k() {
      St.unbind(window, "mousemove", W), St.unbind(window, "touchmove", W), St.unbind(window, "mouseup", k), St.unbind(window, "touchend", k), V();
    }
    function I() {
      var U = Yh(this.value);
      U !== !1 ? (o.__color.__state = U, o.setValue(o.__color.toOriginal())) : this.value = o.__color.toString();
    }
    function V() {
      o.__onFinishChange && o.__onFinishChange.call(o, o.__color.toOriginal());
    }
    a.__saturation_field.appendChild(h), a.__selector.appendChild(a.__field_knob), a.__selector.appendChild(a.__saturation_field), a.__selector.appendChild(a.__hue_field), a.__hue_field.appendChild(a.__hue_knob), a.domElement.appendChild(a.__input), a.domElement.appendChild(a.__selector), a.updateDisplay();
    function M(U) {
      U.type.indexOf("touch") === -1 && U.preventDefault();
      var Q = o.__saturation_field.getBoundingClientRect(), D = U.touches && U.touches[0] || U, ee = D.clientX, J = D.clientY, he = (ee - Q.left) / (Q.right - Q.left), fe = 1 - (J - Q.top) / (Q.bottom - Q.top);
      return fe > 1 ? fe = 1 : fe < 0 && (fe = 0), he > 1 ? he = 1 : he < 0 && (he = 0), o.__color.v = fe, o.__color.s = he, o.setValue(o.__color.toOriginal()), !1;
    }
    function W(U) {
      U.type.indexOf("touch") === -1 && U.preventDefault();
      var Q = o.__hue_field.getBoundingClientRect(), D = U.touches && U.touches[0] || U, ee = D.clientY, J = 1 - (ee - Q.top) / (Q.bottom - Q.top);
      return J > 1 ? J = 1 : J < 0 && (J = 0), o.__color.h = J * 360, o.setValue(o.__color.toOriginal()), !1;
    }
    return a;
  }
  return ds(e, [{
    key: "updateDisplay",
    value: function() {
      var n = Yh(this.getValue());
      if (n !== !1) {
        var a = !1;
        Dt.each(er.COMPONENTS, function(f) {
          if (!Dt.isUndefined(n[f]) && !Dt.isUndefined(this.__color.__state[f]) && n[f] !== this.__color.__state[f])
            return a = !0, {};
        }, this), a && Dt.extend(this.__color.__state, n);
      }
      Dt.extend(this.__temp.__state, this.__color.__state), this.__temp.a = 1;
      var o = this.__color.v < 0.5 || this.__color.s > 0.5 ? 255 : 0, h = 255 - o;
      Dt.extend(this.__field_knob.style, {
        marginLeft: 100 * this.__color.s - 7 + "px",
        marginTop: 100 * (1 - this.__color.v) - 7 + "px",
        backgroundColor: this.__temp.toHexString(),
        border: this.__field_knob_border + "rgb(" + o + "," + o + "," + o + ")"
      }), this.__hue_knob.style.marginTop = (1 - this.__color.h / 360) * 100 + "px", this.__temp.s = 1, this.__temp.v = 1, Zf(this.__saturation_field, "left", "#fff", this.__temp.toHexString()), this.__input.value = this.__color.toString(), Dt.extend(this.__input.style, {
        backgroundColor: this.__color.toHexString(),
        color: "rgb(" + o + "," + o + "," + o + ")",
        textShadow: this.__input_textShadow + "rgba(" + h + "," + h + "," + h + ",.7)"
      });
    }
  }]), e;
}(ca), Hw = ["-moz-", "-o-", "-webkit-", "-ms-", ""];
function Zf(b, e, t, n) {
  b.style.background = "", Dt.each(Hw, function(a) {
    b.style.cssText += "background: " + a + "linear-gradient(" + e + ", " + t + " 0%, " + n + " 100%); ";
  });
}
function Yw(b) {
  b.style.background = "", b.style.cssText += "background: -moz-linear-gradient(top,  #ff0000 0%, #ff00ff 17%, #0000ff 34%, #00ffff 50%, #00ff00 67%, #ffff00 84%, #ff0000 100%);", b.style.cssText += "background: -webkit-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);", b.style.cssText += "background: -o-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);", b.style.cssText += "background: -ms-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);", b.style.cssText += "background: linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);";
}
var Gw = {
  load: function(e, t) {
    var n = t || document, a = n.createElement("link");
    a.type = "text/css", a.rel = "stylesheet", a.href = e, n.getElementsByTagName("head")[0].appendChild(a);
  },
  inject: function(e, t) {
    var n = t || document, a = document.createElement("style");
    a.type = "text/css", a.innerHTML = e;
    var o = n.getElementsByTagName("head")[0];
    try {
      o.appendChild(a);
    } catch {
    }
  }
}, jw = `<div id="dg-save" class="dg dialogue">

  Here's the new load parameter for your <code>GUI</code>'s constructor:

  <textarea id="dg-new-constructor"></textarea>

  <div id="dg-save-locally">

    <input id="dg-local-storage" type="checkbox"/> Automatically save
    values to <code>localStorage</code> on exit.

    <div id="dg-local-explain">The values saved to <code>localStorage</code> will
      override those passed to <code>dat.GUI</code>'s constructor. This makes it
      easier to work incrementally, but <code>localStorage</code> is fragile,
      and your friends may not see the same values you do.

    </div>

  </div>

</div>`, Ww = function(e, t) {
  var n = e[t];
  return Dt.isArray(arguments[2]) || Dt.isObject(arguments[2]) ? new Fw(e, t, arguments[2]) : Dt.isNumber(n) ? Dt.isNumber(arguments[2]) && Dt.isNumber(arguments[3]) ? Dt.isNumber(arguments[4]) ? new Gh(e, t, arguments[2], arguments[3], arguments[4]) : new Gh(e, t, arguments[2], arguments[3]) : Dt.isNumber(arguments[4]) ? new xl(e, t, { min: arguments[2], max: arguments[3], step: arguments[4] }) : new xl(e, t, { min: arguments[2], max: arguments[3] }) : Dt.isString(n) ? new Uw(e, t) : Dt.isFunction(n) ? new cg(e, t, "") : Dt.isBoolean(n) ? new hg(e, t) : null;
};
function Zw(b) {
  setTimeout(b, 1e3 / 60);
}
var qw = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || Zw, $w = function() {
  function b() {
    fs(this, b), this.backgroundElement = document.createElement("div"), Dt.extend(this.backgroundElement.style, {
      backgroundColor: "rgba(0,0,0,0.8)",
      top: 0,
      left: 0,
      display: "none",
      zIndex: "1000",
      opacity: 0,
      WebkitTransition: "opacity 0.2s linear",
      transition: "opacity 0.2s linear"
    }), St.makeFullscreen(this.backgroundElement), this.backgroundElement.style.position = "fixed", this.domElement = document.createElement("div"), Dt.extend(this.domElement.style, {
      position: "fixed",
      display: "none",
      zIndex: "1001",
      opacity: 0,
      WebkitTransition: "-webkit-transform 0.2s ease-out, opacity 0.2s linear",
      transition: "transform 0.2s ease-out, opacity 0.2s linear"
    }), document.body.appendChild(this.backgroundElement), document.body.appendChild(this.domElement);
    var e = this;
    St.bind(this.backgroundElement, "click", function() {
      e.hide();
    });
  }
  return ds(b, [{
    key: "show",
    value: function() {
      var t = this;
      this.backgroundElement.style.display = "block", this.domElement.style.display = "block", this.domElement.style.opacity = 0, this.domElement.style.webkitTransform = "scale(1.1)", this.layout(), Dt.defer(function() {
        t.backgroundElement.style.opacity = 1, t.domElement.style.opacity = 1, t.domElement.style.webkitTransform = "scale(1)";
      });
    }
  }, {
    key: "hide",
    value: function() {
      var t = this, n = function a() {
        t.domElement.style.display = "none", t.backgroundElement.style.display = "none", St.unbind(t.domElement, "webkitTransitionEnd", a), St.unbind(t.domElement, "transitionend", a), St.unbind(t.domElement, "oTransitionEnd", a);
      };
      St.bind(this.domElement, "webkitTransitionEnd", n), St.bind(this.domElement, "transitionend", n), St.bind(this.domElement, "oTransitionEnd", n), this.backgroundElement.style.opacity = 0, this.domElement.style.opacity = 0, this.domElement.style.webkitTransform = "scale(1.1)";
    }
  }, {
    key: "layout",
    value: function() {
      this.domElement.style.left = window.innerWidth / 2 - St.getWidth(this.domElement) / 2 + "px", this.domElement.style.top = window.innerHeight / 2 - St.getHeight(this.domElement) / 2 + "px";
    }
  }]), b;
}(), Xw = Ow(`.dg ul{list-style:none;margin:0;padding:0;width:100%;clear:both}.dg.ac{position:fixed;top:0;left:0;right:0;height:0;z-index:0}.dg:not(.ac) .main{overflow:hidden}.dg.main{-webkit-transition:opacity .1s linear;-o-transition:opacity .1s linear;-moz-transition:opacity .1s linear;transition:opacity .1s linear}.dg.main.taller-than-window{overflow-y:auto}.dg.main.taller-than-window .close-button{opacity:1;margin-top:-1px;border-top:1px solid #2c2c2c}.dg.main ul.closed .close-button{opacity:1 !important}.dg.main:hover .close-button,.dg.main .close-button.drag{opacity:1}.dg.main .close-button{-webkit-transition:opacity .1s linear;-o-transition:opacity .1s linear;-moz-transition:opacity .1s linear;transition:opacity .1s linear;border:0;line-height:19px;height:20px;cursor:pointer;text-align:center;background-color:#000}.dg.main .close-button.close-top{position:relative}.dg.main .close-button.close-bottom{position:absolute}.dg.main .close-button:hover{background-color:#111}.dg.a{float:right;margin-right:15px;overflow-y:visible}.dg.a.has-save>ul.close-top{margin-top:0}.dg.a.has-save>ul.close-bottom{margin-top:27px}.dg.a.has-save>ul.closed{margin-top:0}.dg.a .save-row{top:0;z-index:1002}.dg.a .save-row.close-top{position:relative}.dg.a .save-row.close-bottom{position:fixed}.dg li{-webkit-transition:height .1s ease-out;-o-transition:height .1s ease-out;-moz-transition:height .1s ease-out;transition:height .1s ease-out;-webkit-transition:overflow .1s linear;-o-transition:overflow .1s linear;-moz-transition:overflow .1s linear;transition:overflow .1s linear}.dg li:not(.folder){cursor:auto;height:27px;line-height:27px;padding:0 4px 0 5px}.dg li.folder{padding:0;border-left:4px solid rgba(0,0,0,0)}.dg li.title{cursor:pointer;margin-left:-4px}.dg .closed li:not(.title),.dg .closed ul li,.dg .closed ul li>*{height:0;overflow:hidden;border:0}.dg .cr{clear:both;padding-left:3px;height:27px;overflow:hidden}.dg .property-name{cursor:default;float:left;clear:left;width:40%;overflow:hidden;text-overflow:ellipsis}.dg .cr.function .property-name{width:100%}.dg .c{float:left;width:60%;position:relative}.dg .c input[type=text]{border:0;margin-top:4px;padding:3px;width:100%;float:right}.dg .has-slider input[type=text]{width:30%;margin-left:0}.dg .slider{float:left;width:66%;margin-left:-5px;margin-right:0;height:19px;margin-top:4px}.dg .slider-fg{height:100%}.dg .c input[type=checkbox]{margin-top:7px}.dg .c select{margin-top:5px}.dg .cr.function,.dg .cr.function .property-name,.dg .cr.function *,.dg .cr.boolean,.dg .cr.boolean *{cursor:pointer}.dg .cr.color{overflow:visible}.dg .selector{display:none;position:absolute;margin-left:-9px;margin-top:23px;z-index:10}.dg .c:hover .selector,.dg .selector.drag{display:block}.dg li.save-row{padding:0}.dg li.save-row .button{display:inline-block;padding:0px 6px}.dg.dialogue{background-color:#222;width:460px;padding:15px;font-size:13px;line-height:15px}#dg-new-constructor{padding:10px;color:#222;font-family:Monaco, monospace;font-size:10px;border:0;resize:none;box-shadow:inset 1px 1px 1px #888;word-wrap:break-word;margin:12px 0;display:block;width:440px;overflow-y:scroll;height:100px;position:relative}#dg-local-explain{display:none;font-size:11px;line-height:17px;border-radius:3px;background-color:#333;padding:8px;margin-top:10px}#dg-local-explain code{font-size:10px}#dat-gui-save-locally{display:none}.dg{color:#eee;font:11px 'Lucida Grande', sans-serif;text-shadow:0 -1px 0 #111}.dg.main::-webkit-scrollbar{width:5px;background:#1a1a1a}.dg.main::-webkit-scrollbar-corner{height:0;display:none}.dg.main::-webkit-scrollbar-thumb{border-radius:5px;background:#676767}.dg li:not(.folder){background:#1a1a1a;border-bottom:1px solid #2c2c2c}.dg li.save-row{line-height:25px;background:#dad5cb;border:0}.dg li.save-row select{margin-left:5px;width:108px}.dg li.save-row .button{margin-left:5px;margin-top:1px;border-radius:2px;font-size:9px;line-height:7px;padding:4px 4px 5px 4px;background:#c5bdad;color:#fff;text-shadow:0 1px 0 #b0a58f;box-shadow:0 -1px 0 #b0a58f;cursor:pointer}.dg li.save-row .button.gears{background:#c5bdad url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQJJREFUeNpiYKAU/P//PwGIC/ApCABiBSAW+I8AClAcgKxQ4T9hoMAEUrxx2QSGN6+egDX+/vWT4e7N82AMYoPAx/evwWoYoSYbACX2s7KxCxzcsezDh3evFoDEBYTEEqycggWAzA9AuUSQQgeYPa9fPv6/YWm/Acx5IPb7ty/fw+QZblw67vDs8R0YHyQhgObx+yAJkBqmG5dPPDh1aPOGR/eugW0G4vlIoTIfyFcA+QekhhHJhPdQxbiAIguMBTQZrPD7108M6roWYDFQiIAAv6Aow/1bFwXgis+f2LUAynwoIaNcz8XNx3Dl7MEJUDGQpx9gtQ8YCueB+D26OECAAQDadt7e46D42QAAAABJRU5ErkJggg==) 2px 1px no-repeat;height:7px;width:8px}.dg li.save-row .button:hover{background-color:#bab19e;box-shadow:0 -1px 0 #b0a58f}.dg li.folder{border-bottom:0}.dg li.title{padding-left:16px;background:#000 url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlI+hKgFxoCgAOw==) 6px 10px no-repeat;cursor:pointer;border-bottom:1px solid rgba(255,255,255,0.2)}.dg .closed li.title{background-image:url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlGIWqMCbWAEAOw==)}.dg .cr.boolean{border-left:3px solid #806787}.dg .cr.color{border-left:3px solid}.dg .cr.function{border-left:3px solid #e61d5f}.dg .cr.number{border-left:3px solid #2FA1D6}.dg .cr.number input[type=text]{color:#2FA1D6}.dg .cr.string{border-left:3px solid #1ed36f}.dg .cr.string input[type=text]{color:#1ed36f}.dg .cr.function:hover,.dg .cr.boolean:hover{background:#111}.dg .c input[type=text]{background:#303030;outline:none}.dg .c input[type=text]:hover{background:#3c3c3c}.dg .c input[type=text]:focus{background:#494949;color:#fff}.dg .c .slider{background:#303030;cursor:ew-resize}.dg .c .slider-fg{background:#2FA1D6;max-width:100%}.dg .c .slider:hover{background:#3c3c3c}.dg .c .slider:hover .slider-fg{background:#44abda}
`);
Gw.inject(Xw);
var qf = "dg", $f = 72, Xf = 20, lo = "Default", $a = function() {
  try {
    return !!window.localStorage;
  } catch {
    return !1;
  }
}(), eo = void 0, Kf = !0, wa = void 0, Eh = !1, fg = [], bn = function b(e) {
  var t = this, n = e || {};
  this.domElement = document.createElement("div"), this.__ul = document.createElement("ul"), this.domElement.appendChild(this.__ul), St.addClass(this.domElement, qf), this.__folders = {}, this.__controllers = [], this.__rememberedObjects = [], this.__rememberedObjectIndecesToControllers = [], this.__listening = [], n = Dt.defaults(n, {
    closeOnTop: !1,
    autoPlace: !0,
    width: b.DEFAULT_WIDTH
  }), n = Dt.defaults(n, {
    resizable: n.autoPlace,
    hideable: n.autoPlace
  }), Dt.isUndefined(n.load) ? n.load = { preset: lo } : n.preset && (n.load.preset = n.preset), Dt.isUndefined(n.parent) && n.hideable && fg.push(this), n.resizable = Dt.isUndefined(n.parent) && n.resizable, n.autoPlace && Dt.isUndefined(n.scrollable) && (n.scrollable = !0);
  var a = $a && localStorage.getItem(Sa(this, "isLocal")) === "true", o = void 0, h = void 0;
  if (Object.defineProperties(
    this,
    {
      parent: {
        get: function() {
          return n.parent;
        }
      },
      scrollable: {
        get: function() {
          return n.scrollable;
        }
      },
      autoPlace: {
        get: function() {
          return n.autoPlace;
        }
      },
      closeOnTop: {
        get: function() {
          return n.closeOnTop;
        }
      },
      preset: {
        get: function() {
          return t.parent ? t.getRoot().preset : n.load.preset;
        },
        set: function(V) {
          t.parent ? t.getRoot().preset = V : n.load.preset = V, e1(this), t.revert();
        }
      },
      width: {
        get: function() {
          return n.width;
        },
        set: function(V) {
          n.width = V, qh(t, V);
        }
      },
      name: {
        get: function() {
          return n.name;
        },
        set: function(V) {
          n.name = V, h && (h.innerHTML = n.name);
        }
      },
      closed: {
        get: function() {
          return n.closed;
        },
        set: function(V) {
          n.closed = V, n.closed ? St.addClass(t.__ul, b.CLASS_CLOSED) : St.removeClass(t.__ul, b.CLASS_CLOSED), this.onResize(), t.__closeButton && (t.__closeButton.innerHTML = V ? b.TEXT_OPEN : b.TEXT_CLOSED);
        }
      },
      load: {
        get: function() {
          return n.load;
        }
      },
      useLocalStorage: {
        get: function() {
          return a;
        },
        set: function(V) {
          $a && (a = V, V ? St.bind(window, "unload", o) : St.unbind(window, "unload", o), localStorage.setItem(Sa(t, "isLocal"), V));
        }
      }
    }
  ), Dt.isUndefined(n.parent)) {
    if (this.closed = n.closed || !1, St.addClass(this.domElement, b.CLASS_MAIN), St.makeSelectable(this.domElement, !1), $a && a) {
      t.useLocalStorage = !0;
      var f = localStorage.getItem(Sa(this, "gui"));
      f && (n.load = JSON.parse(f));
    }
    this.__closeButton = document.createElement("div"), this.__closeButton.innerHTML = b.TEXT_CLOSED, St.addClass(this.__closeButton, b.CLASS_CLOSE_BUTTON), n.closeOnTop ? (St.addClass(this.__closeButton, b.CLASS_CLOSE_TOP), this.domElement.insertBefore(this.__closeButton, this.domElement.childNodes[0])) : (St.addClass(this.__closeButton, b.CLASS_CLOSE_BOTTOM), this.domElement.appendChild(this.__closeButton)), St.bind(this.__closeButton, "click", function() {
      t.closed = !t.closed;
    });
  } else {
    n.closed === void 0 && (n.closed = !0);
    var v = document.createTextNode(n.name);
    St.addClass(v, "controller-name"), h = vu(t, v);
    var x = function(V) {
      return V.preventDefault(), t.closed = !t.closed, !1;
    };
    St.addClass(this.__ul, b.CLASS_CLOSED), St.addClass(h, "title"), St.bind(h, "click", x), n.closed || (this.closed = !1);
  }
  n.autoPlace && (Dt.isUndefined(n.parent) && (Kf && (wa = document.createElement("div"), St.addClass(wa, qf), St.addClass(wa, b.CLASS_AUTO_PLACE_CONTAINER), document.body.appendChild(wa), Kf = !1), wa.appendChild(this.domElement), St.addClass(this.domElement, b.CLASS_AUTO_PLACE)), this.parent || qh(t, n.width)), this.__resizeHandler = function() {
    t.onResizeDebounced();
  }, St.bind(window, "resize", this.__resizeHandler), St.bind(this.__ul, "webkitTransitionEnd", this.__resizeHandler), St.bind(this.__ul, "transitionend", this.__resizeHandler), St.bind(this.__ul, "oTransitionEnd", this.__resizeHandler), this.onResize(), n.resizable && Qw(this), o = function() {
    $a && localStorage.getItem(Sa(t, "isLocal")) === "true" && localStorage.setItem(Sa(t, "gui"), JSON.stringify(t.getSaveObject()));
  }, this.saveToLocalStorageIfPossible = o;
  function k() {
    var I = t.getRoot();
    I.width += 1, Dt.defer(function() {
      I.width -= 1;
    });
  }
  n.parent || k();
};
bn.toggleHide = function() {
  Eh = !Eh, Dt.each(fg, function(b) {
    b.domElement.style.display = Eh ? "none" : "";
  });
};
bn.CLASS_AUTO_PLACE = "a";
bn.CLASS_AUTO_PLACE_CONTAINER = "ac";
bn.CLASS_MAIN = "main";
bn.CLASS_CONTROLLER_ROW = "cr";
bn.CLASS_TOO_TALL = "taller-than-window";
bn.CLASS_CLOSED = "closed";
bn.CLASS_CLOSE_BUTTON = "close-button";
bn.CLASS_CLOSE_TOP = "close-top";
bn.CLASS_CLOSE_BOTTOM = "close-bottom";
bn.CLASS_DRAG = "drag";
bn.DEFAULT_WIDTH = 245;
bn.TEXT_CLOSED = "Close Controls";
bn.TEXT_OPEN = "Open Controls";
bn._keydownHandler = function(b) {
  document.activeElement.type !== "text" && (b.which === $f || b.keyCode === $f) && bn.toggleHide();
};
St.bind(window, "keydown", bn._keydownHandler, !1);
Dt.extend(
  bn.prototype,
  {
    add: function(e, t) {
      return to(this, e, t, {
        factoryArgs: Array.prototype.slice.call(arguments, 2)
      });
    },
    addColor: function(e, t) {
      return to(this, e, t, {
        color: !0
      });
    },
    remove: function(e) {
      this.__ul.removeChild(e.__li), this.__controllers.splice(this.__controllers.indexOf(e), 1);
      var t = this;
      Dt.defer(function() {
        t.onResize();
      });
    },
    destroy: function() {
      if (this.parent)
        throw new Error("Only the root GUI should be removed with .destroy(). For subfolders, use gui.removeFolder(folder) instead.");
      this.autoPlace && wa.removeChild(this.domElement);
      var e = this;
      Dt.each(this.__folders, function(t) {
        e.removeFolder(t);
      }), St.unbind(window, "keydown", bn._keydownHandler, !1), Jf(this);
    },
    addFolder: function(e) {
      if (this.__folders[e] !== void 0)
        throw new Error('You already have a folder in this GUI by the name "' + e + '"');
      var t = { name: e, parent: this };
      t.autoPlace = this.autoPlace, this.load && this.load.folders && this.load.folders[e] && (t.closed = this.load.folders[e].closed, t.load = this.load.folders[e]);
      var n = new bn(t);
      this.__folders[e] = n;
      var a = vu(this, n.domElement);
      return St.addClass(a, "folder"), n;
    },
    removeFolder: function(e) {
      this.__ul.removeChild(e.domElement.parentElement), delete this.__folders[e.name], this.load && this.load.folders && this.load.folders[e.name] && delete this.load.folders[e.name], Jf(e);
      var t = this;
      Dt.each(e.__folders, function(n) {
        e.removeFolder(n);
      }), Dt.defer(function() {
        t.onResize();
      });
    },
    open: function() {
      this.closed = !1;
    },
    close: function() {
      this.closed = !0;
    },
    hide: function() {
      this.domElement.style.display = "none";
    },
    show: function() {
      this.domElement.style.display = "";
    },
    onResize: function() {
      var e = this.getRoot();
      if (e.scrollable) {
        var t = St.getOffset(e.__ul).top, n = 0;
        Dt.each(e.__ul.childNodes, function(a) {
          e.autoPlace && a === e.__save_row || (n += St.getHeight(a));
        }), window.innerHeight - t - Xf < n ? (St.addClass(e.domElement, bn.CLASS_TOO_TALL), e.__ul.style.height = window.innerHeight - t - Xf + "px") : (St.removeClass(e.domElement, bn.CLASS_TOO_TALL), e.__ul.style.height = "auto");
      }
      e.__resize_handle && Dt.defer(function() {
        e.__resize_handle.style.height = e.__ul.offsetHeight + "px";
      }), e.__closeButton && (e.__closeButton.style.width = e.width + "px");
    },
    onResizeDebounced: Dt.debounce(function() {
      this.onResize();
    }, 50),
    remember: function() {
      if (Dt.isUndefined(eo) && (eo = new $w(), eo.domElement.innerHTML = jw), this.parent)
        throw new Error("You can only call remember on a top level GUI.");
      var e = this;
      Dt.each(Array.prototype.slice.call(arguments), function(t) {
        e.__rememberedObjects.length === 0 && Jw(e), e.__rememberedObjects.indexOf(t) === -1 && e.__rememberedObjects.push(t);
      }), this.autoPlace && qh(this, this.width);
    },
    getRoot: function() {
      for (var e = this; e.parent; )
        e = e.parent;
      return e;
    },
    getSaveObject: function() {
      var e = this.load;
      return e.closed = this.closed, this.__rememberedObjects.length > 0 && (e.preset = this.preset, e.remembered || (e.remembered = {}), e.remembered[this.preset] = il(this)), e.folders = {}, Dt.each(this.__folders, function(t, n) {
        e.folders[n] = t.getSaveObject();
      }), e;
    },
    save: function() {
      this.load.remembered || (this.load.remembered = {}), this.load.remembered[this.preset] = il(this), Wh(this, !1), this.saveToLocalStorageIfPossible();
    },
    saveAs: function(e) {
      this.load.remembered || (this.load.remembered = {}, this.load.remembered[lo] = il(this, !0)), this.load.remembered[e] = il(this), this.preset = e, Zh(this, e, !0), this.saveToLocalStorageIfPossible();
    },
    revert: function(e) {
      Dt.each(this.__controllers, function(t) {
        this.getRoot().load.remembered ? dg(e || this.getRoot(), t) : t.setValue(t.initialValue), t.__onFinishChange && t.__onFinishChange.call(t, t.getValue());
      }, this), Dt.each(this.__folders, function(t) {
        t.revert(t);
      }), e || Wh(this.getRoot(), !1);
    },
    listen: function(e) {
      var t = this.__listening.length === 0;
      this.__listening.push(e), t && gg(this.__listening);
    },
    updateDisplay: function() {
      Dt.each(this.__controllers, function(e) {
        e.updateDisplay();
      }), Dt.each(this.__folders, function(e) {
        e.updateDisplay();
      });
    }
  }
);
function vu(b, e, t) {
  var n = document.createElement("li");
  return e && n.appendChild(e), t ? b.__ul.insertBefore(n, t) : b.__ul.appendChild(n), b.onResize(), n;
}
function Jf(b) {
  St.unbind(window, "resize", b.__resizeHandler), b.saveToLocalStorageIfPossible && St.unbind(window, "unload", b.saveToLocalStorageIfPossible);
}
function Wh(b, e) {
  var t = b.__preset_select[b.__preset_select.selectedIndex];
  e ? t.innerHTML = t.value + "*" : t.innerHTML = t.value;
}
function Kw(b, e, t) {
  if (t.__li = e, t.__gui = b, Dt.extend(t, {
    options: function(h) {
      if (arguments.length > 1) {
        var f = t.__li.nextElementSibling;
        return t.remove(), to(b, t.object, t.property, {
          before: f,
          factoryArgs: [Dt.toArray(arguments)]
        });
      }
      if (Dt.isArray(h) || Dt.isObject(h)) {
        var v = t.__li.nextElementSibling;
        return t.remove(), to(b, t.object, t.property, {
          before: v,
          factoryArgs: [h]
        });
      }
    },
    name: function(h) {
      return t.__li.firstElementChild.firstElementChild.innerHTML = h, t;
    },
    listen: function() {
      return t.__gui.listen(t), t;
    },
    remove: function() {
      return t.__gui.remove(t), t;
    }
  }), t instanceof Gh) {
    var n = new xl(t.object, t.property, { min: t.__min, max: t.__max, step: t.__step });
    Dt.each(["updateDisplay", "onChange", "onFinishChange", "step", "min", "max"], function(o) {
      var h = t[o], f = n[o];
      t[o] = n[o] = function() {
        var v = Array.prototype.slice.call(arguments);
        return f.apply(n, v), h.apply(t, v);
      };
    }), St.addClass(e, "has-slider"), t.domElement.insertBefore(n.domElement, t.domElement.firstElementChild);
  } else if (t instanceof xl) {
    var a = function(h) {
      if (Dt.isNumber(t.__min) && Dt.isNumber(t.__max)) {
        var f = t.__li.firstElementChild.firstElementChild.innerHTML, v = t.__gui.__listening.indexOf(t) > -1;
        t.remove();
        var x = to(b, t.object, t.property, {
          before: t.__li.nextElementSibling,
          factoryArgs: [t.__min, t.__max, t.__step]
        });
        return x.name(f), v && x.listen(), x;
      }
      return h;
    };
    t.min = Dt.compose(a, t.min), t.max = Dt.compose(a, t.max);
  } else
    t instanceof hg ? (St.bind(e, "click", function() {
      St.fakeEvent(t.__checkbox, "click");
    }), St.bind(t.__checkbox, "click", function(o) {
      o.stopPropagation();
    })) : t instanceof cg ? (St.bind(e, "click", function() {
      St.fakeEvent(t.__button, "click");
    }), St.bind(e, "mouseover", function() {
      St.addClass(t.__button, "hover");
    }), St.bind(e, "mouseout", function() {
      St.removeClass(t.__button, "hover");
    })) : t instanceof jh && (St.addClass(e, "color"), t.updateDisplay = Dt.compose(function(o) {
      return e.style.borderLeftColor = t.__color.toString(), o;
    }, t.updateDisplay), t.updateDisplay());
  t.setValue = Dt.compose(function(o) {
    return b.getRoot().__preset_select && t.isModified() && Wh(b.getRoot(), !0), o;
  }, t.setValue);
}
function dg(b, e) {
  var t = b.getRoot(), n = t.__rememberedObjects.indexOf(e.object);
  if (n !== -1) {
    var a = t.__rememberedObjectIndecesToControllers[n];
    if (a === void 0 && (a = {}, t.__rememberedObjectIndecesToControllers[n] = a), a[e.property] = e, t.load && t.load.remembered) {
      var o = t.load.remembered, h = void 0;
      if (o[b.preset])
        h = o[b.preset];
      else if (o[lo])
        h = o[lo];
      else
        return;
      if (h[n] && h[n][e.property] !== void 0) {
        var f = h[n][e.property];
        e.initialValue = f, e.setValue(f);
      }
    }
  }
}
function to(b, e, t, n) {
  if (e[t] === void 0)
    throw new Error('Object "' + e + '" has no property "' + t + '"');
  var a = void 0;
  if (n.color)
    a = new jh(e, t);
  else {
    var o = [e, t].concat(n.factoryArgs);
    a = Ww.apply(b, o);
  }
  n.before instanceof ca && (n.before = n.before.__li), dg(b, a), St.addClass(a.domElement, "c");
  var h = document.createElement("span");
  St.addClass(h, "property-name"), h.innerHTML = a.property;
  var f = document.createElement("div");
  f.appendChild(h), f.appendChild(a.domElement);
  var v = vu(b, f, n.before);
  return St.addClass(v, bn.CLASS_CONTROLLER_ROW), a instanceof jh ? St.addClass(v, "color") : St.addClass(v, Rw(a.getValue())), Kw(b, v, a), b.__controllers.push(a), a;
}
function Sa(b, e) {
  return document.location.href + "." + e;
}
function Zh(b, e, t) {
  var n = document.createElement("option");
  n.innerHTML = e, n.value = e, b.__preset_select.appendChild(n), t && (b.__preset_select.selectedIndex = b.__preset_select.length - 1);
}
function Qf(b, e) {
  e.style.display = b.useLocalStorage ? "block" : "none";
}
function Jw(b) {
  var e = b.__save_row = document.createElement("li");
  St.addClass(b.domElement, "has-save"), b.__ul.insertBefore(e, b.__ul.firstChild), St.addClass(e, "save-row");
  var t = document.createElement("span");
  t.innerHTML = "&nbsp;", St.addClass(t, "button gears");
  var n = document.createElement("span");
  n.innerHTML = "Save", St.addClass(n, "button"), St.addClass(n, "save");
  var a = document.createElement("span");
  a.innerHTML = "New", St.addClass(a, "button"), St.addClass(a, "save-as");
  var o = document.createElement("span");
  o.innerHTML = "Revert", St.addClass(o, "button"), St.addClass(o, "revert");
  var h = b.__preset_select = document.createElement("select");
  if (b.load && b.load.remembered ? Dt.each(b.load.remembered, function(I, V) {
    Zh(b, V, V === b.preset);
  }) : Zh(b, lo, !1), St.bind(h, "change", function() {
    for (var I = 0; I < b.__preset_select.length; I++)
      b.__preset_select[I].innerHTML = b.__preset_select[I].value;
    b.preset = this.value;
  }), e.appendChild(h), e.appendChild(t), e.appendChild(n), e.appendChild(a), e.appendChild(o), $a) {
    var f = document.getElementById("dg-local-explain"), v = document.getElementById("dg-local-storage"), x = document.getElementById("dg-save-locally");
    x.style.display = "block", localStorage.getItem(Sa(b, "isLocal")) === "true" && v.setAttribute("checked", "checked"), Qf(b, f), St.bind(v, "change", function() {
      b.useLocalStorage = !b.useLocalStorage, Qf(b, f);
    });
  }
  var k = document.getElementById("dg-new-constructor");
  St.bind(k, "keydown", function(I) {
    I.metaKey && (I.which === 67 || I.keyCode === 67) && eo.hide();
  }), St.bind(t, "click", function() {
    k.innerHTML = JSON.stringify(b.getSaveObject(), void 0, 2), eo.show(), k.focus(), k.select();
  }), St.bind(n, "click", function() {
    b.save();
  }), St.bind(a, "click", function() {
    var I = prompt("Enter a new preset name.");
    I && b.saveAs(I);
  }), St.bind(o, "click", function() {
    b.revert();
  });
}
function Qw(b) {
  var e = void 0;
  b.__resize_handle = document.createElement("div"), Dt.extend(b.__resize_handle.style, {
    width: "6px",
    marginLeft: "-3px",
    height: "200px",
    cursor: "ew-resize",
    position: "absolute"
  });
  function t(o) {
    return o.preventDefault(), b.width += e - o.clientX, b.onResize(), e = o.clientX, !1;
  }
  function n() {
    St.removeClass(b.__closeButton, bn.CLASS_DRAG), St.unbind(window, "mousemove", t), St.unbind(window, "mouseup", n);
  }
  function a(o) {
    return o.preventDefault(), e = o.clientX, St.addClass(b.__closeButton, bn.CLASS_DRAG), St.bind(window, "mousemove", t), St.bind(window, "mouseup", n), !1;
  }
  St.bind(b.__resize_handle, "mousedown", a), St.bind(b.__closeButton, "mousedown", a), b.domElement.insertBefore(b.__resize_handle, b.domElement.firstElementChild);
}
function qh(b, e) {
  b.domElement.style.width = e + "px", b.__save_row && b.autoPlace && (b.__save_row.style.width = e + "px"), b.__closeButton && (b.__closeButton.style.width = e + "px");
}
function il(b, e) {
  var t = {};
  return Dt.each(b.__rememberedObjects, function(n, a) {
    var o = {}, h = b.__rememberedObjectIndecesToControllers[a];
    Dt.each(h, function(f, v) {
      o[v] = e ? f.initialValue : f.getValue();
    }), t[a] = o;
  }), t;
}
function e1(b) {
  for (var e = 0; e < b.__preset_select.length; e++)
    b.__preset_select[e].value === b.preset && (b.__preset_select.selectedIndex = e);
}
function gg(b) {
  b.length !== 0 && qw.call(window, function() {
    gg(b);
  }), Dt.each(b, function(e) {
    e.updateDisplay();
  });
}
var t1 = bn;
let Ih = null;
class i1 {
  constructor(e) {
    if (this.debug = null, this.config = null, this.updateConfig = (t) => {
      this.config = t;
    }, Ih)
      return Ih;
    Ih = this, this.config = e, this.init();
  }
  init() {
    if (this.debug)
      return;
    const e = new t1({ width: 300 });
    let t;
    window.parent !== window ? (t = this.getExportIntegration(), e.add(t, "export").name("Save")) : (t = this.getExportStandalone(), e.add(t, "export").name("Export")), this.debug = e, this.debug.domElement.style.display = "none", new URLSearchParams(window.location.search).get("config") === "true" && (this.debug.open(), this.debug.domElement.style.display = "block");
  }
  getExportIntegration() {
    return {
      export: () => {
        const t = "babylon-customization.json", n = this.exportConfigCustmizations(this.config);
        window.parent.postMessage(
          {
            type: "exportConfig",
            data: {
              filename: t,
              config: n
            }
          },
          "*"
        );
      }
    };
  }
  getExportStandalone() {
    return {
      export: () => {
        const t = "babylon-customization.json", n = JSON.stringify(this.exportConfigCustmizations(this.config));
        let a = document.createElement("a");
        a.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(n)), a.setAttribute("download", t), a.style.display = "none", document.body.appendChild(a), a.click(), document.body.removeChild(a);
      }
    };
  }
  updateDisplay(e) {
    if (e) {
      for (var t in e.__controllers)
        e.__controllers[t].updateDisplay();
      for (var n in e.__folders)
        this.updateDisplay(e.__folders[n]);
    }
  }
  exportConfigCustmizations(e) {
    if (!(!e || !this.debug))
      return e;
  }
  exportCustomProperties(e) {
    return Object.entries(e.__folders).map(([t, n]) => ({
      [t]: this.exportCustomPropertiesProps(n)
    })).reduce((t, n) => ({ ...n, ...t }), {});
  }
  exportCustomPropertiesProps(e) {
    const t = e.__controllers.reduce(
      (a, o) => ({
        ...a,
        [o.property]: o.getValue()
      }),
      {}
    ), n = Object.entries(e.__folders).map(([a, o]) => ({
      [a]: this.exportCustomPropertiesProps(o)
    })).reduce((a, o) => ({ ...o, ...a }), {});
    return {
      ...t,
      ...n
    };
  }
}
class n1 {
  constructor(e, t, n) {
    this.gui = null, this.config = null, this.sceneHelper = null, this.shadowMinZController = null, this.shadowMaxZController = null;
    const a = new i1(e);
    a.init(), this.gui = a, this.onUpdate = t, this.config = e, this.sceneHelper = n;
  }
  /**
   * The function "setupGui" configures the general, environment, lights, and camera settings based on
   * the provided configuration object, and calls the onUpdate function with the updated configuration.
   * @param {SceneConfig} config - The `config` parameter is an object that contains the initial configuration
   * for the GUI. It may include properties such as general settings, environment settings, lights
   * settings, and camera settings.
   * @param onUpdate - The `onUpdate` parameter is a callback function that will be called whenever
   * there is an update to the configuration. It takes a new configuration object as a parameter
   * (`newConfig: SceneConfig`).
   */
  setupGui(e) {
    if (!this.config)
      return;
    const t = (n) => {
      var a;
      this.onUpdate(n), (a = this.gui) == null || a.updateConfig(n);
    };
    this.configureGeneral(this.config, t), this.configureEnvironment(this.config, t), this.configureLights(this.config, t), this.configureCamera(this.config, t, e), this.configureShadows(this.config, t), this.configureAr(this.config, t), this.configureModel(this.config, t), this.configureAnimations(this.config, t, e);
  }
  configureModel(e, t) {
    var a, o;
    if (!e.model)
      return;
    const n = (o = (a = this.gui) == null ? void 0 : a.debug) == null ? void 0 : o.addFolder("Model");
    e.model.config || (e.model.config = { doubleSided: !0 }), n == null || n.add(e.model.config, "doubleSided").name("Double Sided").onFinishChange(() => {
      t(e);
    });
  }
  configureShadows(e, t) {
    var o, h, f, v, x, k;
    if (!e.environment || !e.environment.shadows)
      return;
    const n = (h = (o = this.gui) == null ? void 0 : o.debug) == null ? void 0 : h.addFolder("Shadows");
    n == null || n.add(e.environment.shadows, "enableShadows").name("Enable Shadows").onChange(() => {
      t(e);
    }), n == null || n.addColor(e.environment.shadows, "shadowHexColor").name("Hex Color").onChange(() => {
      t(e);
    }), n == null || n.add(e.environment.shadows, "shadowDarkness", 0, 1, 0.1).name("Transparency").onChange(() => {
      t(e);
    }), n == null || n.add(e.environment.shadows, "groundSizeMultiplierWidth", 0, 5, 0.1).name("Ground Width").onChange(() => {
      t(e);
    }), n == null || n.add(e.environment.shadows, "groundSizeMultiplierLength", 0, 5, 0.1).name("Ground Length").onChange(() => {
      t(e);
    }), n == null || n.add(e.environment.shadows, "shadowMapSize", 0, 128, 4).name("Map Size").onChange(() => {
      t(e);
    });
    const a = {
      enableShadowMinZ: !!((v = (f = e == null ? void 0 : e.environment) == null ? void 0 : f.shadows) != null && v.shadowMinZ),
      enableShadowMaxZ: !!((k = (x = e == null ? void 0 : e.environment) == null ? void 0 : x.shadows) != null && k.shadowMaxZ)
    };
    n == null || n.add(a, "enableShadowMinZ").name("Enable starting shadow clipping").onChange(() => {
      a.enableShadowMinZ ? e.environment.shadows.shadowMinZ = 0 : (e.environment.shadows.shadowMinZ = null, t(e)), this.buildShadowZConfig(e, n, t);
    }), n == null || n.add(a, "enableShadowMaxZ").name("Enable ending shadow clipping").onChange(() => {
      a.enableShadowMaxZ ? e.environment.shadows.shadowMaxZ = 0 : (e.environment.shadows.shadowMaxZ = null, t(e)), this.buildShadowZConfig(e, n, t);
    }), n && this.buildShadowZConfig(e, n, t);
  }
  buildShadowZConfig(e, t, n) {
    var a, o, h, f, v, x, k, I, V, M;
    ((o = (a = e == null ? void 0 : e.environment) == null ? void 0 : a.shadows) == null ? void 0 : o.shadowMinZ) !== void 0 && ((f = (h = e == null ? void 0 : e.environment) == null ? void 0 : h.shadows) == null ? void 0 : f.shadowMinZ) !== null ? this.shadowMinZController || (this.shadowMinZController = t == null ? void 0 : t.add((v = e == null ? void 0 : e.environment) == null ? void 0 : v.shadows, "shadowMinZ", -50, 0, 1).name("Clipping Start").onChange(() => {
      n(e);
    })) : this.shadowMinZController && (t == null || t.remove(this.shadowMinZController), this.shadowMinZController = null), ((k = (x = e == null ? void 0 : e.environment) == null ? void 0 : x.shadows) == null ? void 0 : k.shadowMaxZ) !== void 0 && ((V = (I = e == null ? void 0 : e.environment) == null ? void 0 : I.shadows) == null ? void 0 : V.shadowMaxZ) !== null ? this.shadowMaxZController || (this.shadowMaxZController = t == null ? void 0 : t.add((M = e == null ? void 0 : e.environment) == null ? void 0 : M.shadows, "shadowMaxZ", 0, 50, 1).name("Clipping End").onChange(() => {
      n(e);
    })) : this.shadowMaxZController && (t == null || t.remove(this.shadowMaxZController), this.shadowMaxZController = null);
  }
  configureGeneral(e, t) {
    var a, o;
    if (!e.general)
      return;
    const n = (o = (a = this.gui) == null ? void 0 : a.debug) == null ? void 0 : o.addFolder("General");
    n == null || n.addColor(e.general, "backgroundColor").name("Background Color").onChange(() => {
      t(e);
    }), n == null || n.add(e.general, "removeDefaultBackground").name("Remove Background").onChange(() => {
      t(e);
    }), e.camera && (n == null || n.add(e.camera, "toneMappingEnabled").name("Tone Mapping Enabled").onFinishChange(() => {
      t(e);
    }), n == null || n.add(e.camera, "toneMappingType", {
      Standard: 0,
      AcesToneMapping: 1
    }).name("Tone Mapping Type").onFinishChange(() => {
      var h;
      (h = e == null ? void 0 : e.camera) != null && h.toneMappingType && (e.camera.toneMappingType = Number(e.camera.toneMappingType)), t(e);
    }), this.configureAntialias(n, e, t));
  }
  configureAntialias(e, t, n) {
    if (!e || !t.general)
      return;
    const a = e == null ? void 0 : e.addFolder("Antialias"), o = a == null ? void 0 : a.addFolder("Desktop"), h = a == null ? void 0 : a.addFolder("Mobile"), f = {
      desktop: null,
      mobile: null
    };
    t.general.antialias ? t.general.antialias && t.general.antialias.desktop && !t.general.antialias.mobile && (t.general.antialias.mobile = {
      enabled: t.general.antialias.desktop.enabled,
      inRotationEnabled: t.general.antialias.desktop.inRotationEnabled
    }) : t.general.antialias = {
      desktop: {
        enabled: !0,
        inRotationEnabled: !1
      },
      mobile: {
        enabled: !0,
        inRotationEnabled: !1
      }
    };
    function v(V, M, W = !0) {
      var ee, J, he;
      const U = (J = (ee = t.general) == null ? void 0 : ee.antialias) == null ? void 0 : J[V];
      if (!U)
        return;
      const { enabled: Q, inRotationEnabled: D } = U;
      if (U.inRotationEnabled = Q ? D : !1, M) {
        const fe = (he = M.domElement.parentElement) == null ? void 0 : he.parentElement;
        fe && (fe.style.display = Q ? "" : "none");
      }
      W && n(t);
    }
    function x(V, M) {
      var Q, D;
      const W = (D = (Q = t.general) == null ? void 0 : Q.antialias) == null ? void 0 : D[M];
      if (!W)
        return null;
      V == null || V.add(W, "enabled").name("Enabled").onChange(() => {
        v(M, f[M] ?? void 0);
      });
      const U = V == null ? void 0 : V.add(W, "inRotationEnabled").name("In Rotation Enabled").listen().onChange(() => n(t));
      return f[M] = U, U;
    }
    const k = x(o, "desktop"), I = x(h, "mobile");
    v("desktop", k ?? void 0, !1), v("mobile", I ?? void 0, !1);
  }
  configureAr(e, t) {
    var k, I, V, M, W;
    if (!e.general || !e.general.meshSize)
      return;
    const n = (I = (k = this.gui) == null ? void 0 : k.debug) == null ? void 0 : I.addFolder("Augmented Reality");
    n == null || n.add(e.general, "arEnabled").name("Enabled").onChange(() => {
      t(e);
    }), n == null || n.add({ enabled: e.general.arAnchor === "wall" }, "enabled").name("Enable wall placement").onChange((U) => {
      e.general && (e.general.arAnchor = U ? "wall" : null), t(e);
    }), n == null || n.add({ enabled: e.general.arScale ?? !1 }, "enabled").name("Resizable in AR").onChange((U) => {
      e.general && (e.general.arScale = U), t(e);
    }), n == null || n.add({ enabled: e.general.arOnTheFly }, "enabled").name("Faster AR Conversion").onChange((U) => {
      e.general && (e.general.arOnTheFly = U), t(e);
    });
    const a = n == null ? void 0 : n.addFolder("Measure Scene Ar"), o = {
      options: {
        width: ((V = e.general.meshSize) == null ? void 0 : V.width) ?? !1,
        height: ((M = e.general.meshSize) == null ? void 0 : M.height) ?? !1,
        depth: ((W = e.general.meshSize) == null ? void 0 : W.depth) ?? !1
      }
    };
    let f = (() => {
      const { width: U, height: Q, depth: D } = o.options;
      return U ? "width" : Q ? "height" : D ? "depth" : null;
    })();
    const v = (U) => {
      if (U === "none" || !U)
        return 0;
      if (e.general && e.general.meshSize)
        return e.general.meshSize[U];
    };
    a == null || a.add(o, "options", {
      None: "none",
      Width: "width",
      Height: "height",
      Depth: "depth"
    }).name("Know Dimension").setValue(f).onFinishChange((U) => {
      f = U, U === "none" && e.general && e.general.meshSize && (e.general.meshSize = {
        width: null,
        height: null,
        depth: null
      }, t(e)), x == null || x.setValue(v(f));
    });
    const x = a == null ? void 0 : a.add({ size: 0 }, "size", -500, 500, 1).name("Measure (cm)").setValue(v(f)).onFinishChange((U) => {
      e.general && e.general.meshSize && (Object.keys(e.general.meshSize).forEach((Q) => {
        e.general && e.general.meshSize && (e.general.meshSize[Q] = Q !== f ? null : U);
      }), t(e));
    });
  }
  configureEnvironment(e, t) {
    var a, o;
    if (!e.general || !e.general.environmentOptions)
      return;
    const n = (o = (a = this.gui) == null ? void 0 : a.debug) == null ? void 0 : o.addFolder("Environment");
    n == null || n.add(e.general, "exposure", 0, 5, 0.1).name("Exposure").onChange(() => {
      t(e);
    }), n == null || n.add(e.general, "contrast", 0, 5, 0.1).name("Contrast").onChange(() => {
      t(e);
    }).isModified, n == null || n.add(e.general.environmentOptions, "rotationY", 0, 10, 1e-3).name("Rotation Y").onChange(() => {
      t(e);
    }), n == null || n.add(e.general.environmentOptions, "intensity", 0, 20, 0.1).name("Intensity").onChange(() => {
      t(e);
    }), n == null || n.add(e.general.environmentOptions, "pbrIntensity", 0, 20, 0.1).name("PBR Intensity").onChange(() => {
      t(e);
    });
  }
  configureCamera(e, t, n) {
    var k, I;
    const a = n == null ? void 0 : n.cameras.find((V) => V instanceof BABYLON.ArcRotateCamera);
    if (!e.camera || !e.camera.position || !a)
      return;
    const o = (I = (k = this.gui) == null ? void 0 : k.debug) == null ? void 0 : I.addFolder("Camera");
    o == null || o.add(e.camera, "autoRotate").name("Auto Rotate").onChange(() => {
      t(e);
    }), e.camera.zoom === void 0 && (e.camera.zoom = 0), o == null || o.add(e.camera, "zoom", -50, 10, 0.1).name("Initial Zoom").onChange(() => {
      t(e);
    }), o == null || o.add(e.camera.position, "fov", 0, 1.6, 1e-3).name("Fov").onChange((V) => {
      a.fov = V, n == null || n.render();
    });
    const h = o == null ? void 0 : o.addFolder("Rotation");
    h == null || h.add(e.camera.position, "alpha", -10, 10, 0.01).name("X").onChange((V) => {
      a.alpha = V, n == null || n.render();
    }), h == null || h.add(e.camera.position, "beta", -3, 3, 0.01).name("Y").onChange((V) => {
      a.beta = V, n == null || n.render();
    });
    const f = o == null ? void 0 : o.addFolder("Zoom Settings");
    e.camera.useMinZoomPerc = e.camera.useMinZoomPerc === null ? !1 : e.camera.useMinZoomPerc, e.camera.useMaxZoomPerc = e.camera.useMaxZoomPerc === null ? !1 : e.camera.useMaxZoomPerc, f == null || f.add(e.camera, "useMinZoomPerc", 0, 1, 0.01).name("Enable Max Zoom").onChange(() => {
      t(e);
    });
    const v = f == null ? void 0 : f.add(e.camera, "minZoomPerc", 0, 10, 0.01).name("Max Zoom");
    v == null || v.onChange((V) => {
      var W;
      const M = (W = e.camera) == null ? void 0 : W.maxZoomPerc;
      M && V > M && v.setValue(M), t(e);
    }), f == null || f.add(e.camera, "useMaxZoomPerc", 0, 1, 0.01).name("Enable Min Zoom").onChange(() => {
      t(e);
    });
    const x = f == null ? void 0 : f.add(e.camera, "maxZoomPerc", 0, 10, 0.01).name("Min Zoom");
    x == null || x.onChange((V) => {
      var W;
      const M = (W = e.camera) == null ? void 0 : W.minZoomPerc;
      V === 0 ? x.setValue(0.01) : M && V < M && x.setValue(M), t(e);
    });
  }
  configureLights(e, t) {
    var a, o;
    if (!e.lights)
      return;
    const n = (o = (a = this.gui) == null ? void 0 : a.debug) == null ? void 0 : o.addFolder("Lights");
    this.configureLight(
      n,
      "Directional Light Back",
      e.lights.directionalLightBack,
      e,
      t
    ), this.configureLight(
      n,
      "Directional Light Left",
      e.lights.directionalLightLeft,
      e,
      t
    ), this.configureLight(n, "Point Light Back", e.lights.pointLightBack, e, t), this.configureLight(n, "Point Light Front", e.lights.pointLightFront, e, t), this.configureLight(n, "Hemisphere Light", e.lights.hemisphereLight, e, t);
  }
  configureLight(e, t, n, a, o) {
    const h = e == null ? void 0 : e.addFolder(t), f = h == null ? void 0 : h.addFolder("position"), v = h == null ? void 0 : h.addFolder("general");
    f == null || f.add(n.position, "x", -100, 100, 0.1).name("Position X").onChange(() => {
      o(a);
    }), f == null || f.add(n.position, "y", -100, 100, 0.1).name("Position Y").onChange(() => {
      o(a);
    }), f == null || f.add(n.position, "z", -100, 100, 0.1).name("Position Z").onChange(() => {
      o(a);
    }), v == null || v.add(n.general, "intensity", 0, 50, 0.1).name("Intensity").onChange(() => {
      o(a);
    }), v == null || v.add(n.general, "visible").name("Visible").onChange(() => {
      o(a);
    });
  }
  configureAnimations(e, t, n) {
    var h, f;
    const a = (n == null ? void 0 : n.animationGroups) && n.animationGroups.length > 0;
    if (!e.animations || !a)
      return;
    const o = (f = (h = this.gui) == null ? void 0 : h.debug) == null ? void 0 : f.addFolder("animations");
    o == null || o.add(e.animations, "runAtStart").name("Run At Start").onChange(() => t(e)), o == null || o.add(e.animations, "loop").name("Loop").onChange(() => t(e)), o == null || o.add(e.animations, "speed", 0.1, 5, 0.1).name("Speed").onChange(() => t(e));
  }
}
var r1 = /* @__PURE__ */ ((b) => (b.CameraMovement = "camera-movement", b.ScriptExecution = "script-execution", b.DesignChanged = "design-changed", b))(r1 || {});
class yu {
  constructor(e) {
    this._zkScene = null, this._zkModel = null, this._canvasID = "zakeke-canvas-viewer3D-" + Zakeke.makeID(5), this._canvas = null, this._domElement = null, this._lastWidth = Number.MIN_VALUE, this._lastHeight = Number.MIN_VALUE, this._engine = null, this._scene = null, this._bindedResize = null, this._sceneHelper = null, this._environmentManager = null, this._glowManager = null, this._sceneActionsExecutor = null, this._renderingNeeded = !1, this._renderingPaused = !1, this._autoRender = !1, this._antiAliasConfig = {
      enabled: !0,
      inRotationEnabled: !1
    }, this._postProcesses = [], this._camera = null, this._hemiLight = null, this._pointLight = null, this._highlightColor = "#00ff00", this._highlightSize = 2, this._highlightLayer = null, this._highlightBlurHorizontalSize = 1, this._highlightBlurVerticalSize = 1, this._highlightAnimationID = null, this._highlightCurrentMeshes = [], this._highlightNextMeshes = [], this._deviceType = MPlaza.DeviceType.All, this._destroyed = !1, this._sceneDesignManager = null, this._meshLocationsManager = null, this._renderDesignQueue = Promise.resolve(), this._groupPickedListeners = [], this._focusAttributesListeners = [], this._designNotifyMessageListeners = [], this._designRemoveMessageListeners = [], this._designEventMessages = [], this._onDelayLoadingStart = null, this._onDelayLoadingProgress = null, this._onDelayLoadingSuccess = null, this._onDelayLoadingError = null, this._infoPointPickedListeners = [], this._infoPointContentShownListeners = [], this._infoPointContentHiddenListeners = [], this._beginAssetsLoadingListeners = [], this._endAssetsLoadingListeners = [], this._nextSceneMeshesLoadedListeners = [], this._nextSceneTexturesLoadedListeners = [], this._beginSceneLoadingListeners = [], this._endSceneLoadingListeners = [], this._arFileUrls = {}, this._designTextureResolution = 1024, this._configPreview = !1, this._defaultBackgroundColor = null, this._grids = [], this._dracoCompression = null, this._infoPointsManager = null, this._infoPointsManagerStyle = null, this._canShowInfoPoints = !0, this._canShowInfoPointsContent = !0, this._broadcastChannel = null, this._isHologramSource = !1, this._isHologram = !1, this._lastResizableMeshID = "", this._brandLogoButton = null, this._advancedTexture = null, this._createGui = null, this._performanceInfo = null, this._currentRotation = 0, this._isRotating = !1, this._isViewer = !1, this._isSelectionMode = !0, this._mouseWheelInput = null, this._modelParentNode = null, this.setCameraLocked = (t) => {
      this._zkScene && this._sceneHelper && this._scene && (this._sceneHelper.setupCamera(), this._camera = this._scene.activeCamera, this._camera && (t ? (this._sceneHelper.setCameraLimitLowerRadius(!0), this._sceneHelper.setMinZoomPerc(1), this._sceneHelper.setMaxZoomPerc(1)) : (this._sceneHelper.setCameraLimitLowerRadius(!1), this._sceneHelper.setMinZoomPerc(1), this._sceneHelper.setMaxZoomPerc(1.5))));
    }, e != null && (typeof e == "boolean" ? this._configPreview = e : (this._configPreview = e.configPreview, e.defaultBackgroundColor && (this._defaultBackgroundColor = BABYLON.Color4.FromHexString(e.defaultBackgroundColor)), this._isViewer = (e == null ? void 0 : e.isViewer) ?? !1)), this._elementSelector = new Hd();
  }
  get zkScene() {
    return this._zkScene;
  }
  get zkModel() {
    return this._zkModel;
  }
  get canvas() {
    return this._canvas;
  }
  get engine() {
    return this._engine;
  }
  get scene() {
    return this._scene;
  }
  get autoRender() {
    return this._autoRender;
  }
  set autoRender(e) {
    this._autoRender = e;
  }
  get antiAliasConfig() {
    return this._antiAliasConfig;
  }
  set antiAliasConfig(e) {
    this._antiAliasConfig = e;
  }
  get isLowEndDevice() {
    return this._performanceInfo && this._performanceInfo.isLowEndDevice;
  }
  get isHologramSource() {
    return this.isHologramSource;
  }
  get createGui() {
    return this._createGui;
  }
  set createGui(e) {
    this._createGui = e;
  }
  set isHologramSource(e) {
    this._isHologramSource = e, e && (this._isHologram = !1, this.detachBroadcastChannelEventHandlers());
  }
  get isHologram() {
    return this._isHologram;
  }
  set isHologram(e) {
    this._isHologram = e, e ? (this._isHologramSource = !1, this.attachBroadcastChannelEventHandlers()) : this.detachBroadcastChannelEventHandlers(), this.refreshEnvironment();
  }
  get isSelectionMode() {
    return this._isSelectionMode;
  }
  set isSelectionMode(e) {
    this._isSelectionMode = e;
  }
  setupAntiAliasing() {
    if (this._zkScene) {
      let e = this.getAntiAliasingConfig();
      this._antiAliasConfig = e, e.enabled === !0 ? this.enableAntialiasing() : e.enabled === !1 && this.disableAntialiasing();
    }
  }
  getAntiAliasingConfig() {
    var t, n, a, o, h;
    if (!this._zkScene)
      return this._antiAliasConfig;
    const e = (o = (a = (n = (t = this._zkScene).get) == null ? void 0 : n.call(t, "config")) == null ? void 0 : a.toJSON) == null ? void 0 : o.call(a);
    return (h = e == null ? void 0 : e.general) != null && h.antialias ? iw() ? e.general.antialias.mobile ?? this._antiAliasConfig : e.general.antialias.desktop ?? this._antiAliasConfig : this._antiAliasConfig;
  }
  enableAntialiasing() {
    this._scene && this._antiAliasConfig.enabled && (this.createAntialiasPostProcesses(), this._scene.postProcessesEnabled = !0);
  }
  disableAntialiasing(e = !1) {
    this._scene && (this._scene.postProcessesEnabled = !1), e && this.disposePostProcesses();
  }
  // Per coerenza con tutto il resto inserisco questi metodi set & get,
  // andrebbero usate solo le proprietà, ma questo anche in SceneEditor
  getARScale() {
    let e = !0;
    if (this._zkScene) {
      let t = this._zkScene.getARScale();
      return t ?? e;
    }
    return e;
  }
  setARScale(e) {
    this._zkScene && this._zkScene.setARScale(e);
  }
  getUseMaterialOffloading() {
    let e = !1;
    if (this.zkScene) {
      let t = this.zkScene.getUseMaterialOffloading();
      return t ?? e;
    }
    return e;
  }
  setUseMaterialOffloading(e) {
    this._zkScene && this._zkScene.setUseMaterialOffloading(e);
  }
  getPrefetchMeshes() {
    if (this.zkScene) {
      const t = this.zkScene.getPrefetchMeshes();
      return t ?? !0;
    }
    return !0;
  }
  setPrefetchMeshes(e) {
    this._zkScene && this._zkScene.setPrefetchMeshes(e);
  }
  getPrefetchMaterials() {
    if (this.zkScene) {
      const t = this.zkScene.getPrefetchMaterials();
      return t ?? !0;
    }
    return !0;
  }
  setPrefetchMaterials(e) {
    this._zkScene && this._zkScene.setPrefetchMaterials(e);
  }
  getShowHideInfoPoints() {
    return this.canShowInfoPoints;
  }
  setShowHideInfoPoints(e) {
    this.canShowInfoPoints = e;
  }
  get camera() {
    return this._camera;
  }
  get deviceType() {
    return this._deviceType;
  }
  set deviceType(e) {
    this._deviceType = e;
  }
  getDeviceType() {
    return this.deviceType;
  }
  get highlightColor() {
    return this._highlightColor;
  }
  set highlightColor(e) {
    this._highlightColor = e;
  }
  get highlightSize() {
    return this._highlightSize;
  }
  set highlightSize(e) {
    this._highlightSize = e;
  }
  get destroyed() {
    return this._destroyed;
  }
  /**
   * Recupera il token di autorizzazione disponibile
   * @returns Il token se disponibile, altrimenti null
   */
  getAvailableAuthToken() {
    return this._authorizationToken && typeof this._authorizationToken == "string" ? this._authorizationToken : window.token && typeof window.token == "string" && window.token.trim() !== "" ? window.token : null;
  }
  get onDelayLoadingStart() {
    return this._onDelayLoadingStart;
  }
  set onDelayLoadingStart(e) {
    this._onDelayLoadingStart = e;
  }
  get onDelayLoadingProgress() {
    return this._onDelayLoadingProgress;
  }
  set onDelayLoadingProgress(e) {
    this._onDelayLoadingProgress = e;
  }
  get onDelayLoadingSuccess() {
    return this._onDelayLoadingSuccess;
  }
  set onDelayLoadingSuccess(e) {
    this._onDelayLoadingSuccess = e;
  }
  get onDelayLoadingError() {
    return this._onDelayLoadingError;
  }
  set onDelayLoadingError(e) {
    this._onDelayLoadingError = e;
  }
  get dracoCompression() {
    return this._dracoCompression || (this._dracoCompression = _w.Default), this._dracoCompression;
  }
  get infoPointsShown() {
    return this._infoPointsManager ? this._infoPointsManager.infoPointsShown : !1;
  }
  get infoPointsManagerStyle() {
    return this._infoPointsManagerStyle;
  }
  set infoPointsManagerStyle(e) {
    this._infoPointsManagerStyle = e, this.updateInfoPointsManagerStyle();
  }
  get canShowInfoPoints() {
    return this._canShowInfoPoints;
  }
  set canShowInfoPoints(e) {
    this._canShowInfoPoints = e, this.refreshInfoPoints();
  }
  get canShowInfoPointsContent() {
    return this._canShowInfoPointsContent;
  }
  set canShowInfoPointsContent(e) {
    this._canShowInfoPointsContent = e, this._infoPointsManager && (this._infoPointsManager.canShowInfoPointsContent = e);
  }
  static async createSceneViewerAsync(e) {
    const t = new yu(e);
    return await t.initAsync(), t;
  }
  dispose() {
    this.closeBroadcastChannel(), this.removeCanvas(), this.removeDomElement(), this.deleteScene(), this.deleteEngine();
  }
  async initAsync() {
    this._bindedResize = this.resize.bind(this), Zakeke.Tools.Init(), BABYLON.Geometry.onDelayLoadingStart = (e) => {
      this._onDelayLoadingStart && this._onDelayLoadingStart(e);
    }, BABYLON.Geometry.onDelayLoadingProgress = (e) => {
      this._onDelayLoadingProgress && this._onDelayLoadingProgress(e);
    }, BABYLON.Geometry.onDelayLoadingSuccess = (e) => {
      this._onDelayLoadingSuccess && this._onDelayLoadingSuccess(e);
    }, BABYLON.Geometry.onDelayLoadingError = (e) => {
      this._onDelayLoadingError && this._onDelayLoadingError(e);
    }, BABYLON.Geometry.dracoDecodingFunction = (e, t, n) => {
      this.dracoDecodingFunction(e, t, n);
    }, this.createCanvas(), this.createDOMElement(), await this.init3DEngineAsync();
  }
  async init3DEngineAsync() {
    this.createEngine(), await this.createEmptySceneAsync(), this._destroyed = !1;
  }
  createCanvas() {
    return this._canvas = document.createElement("canvas"), this._canvas.setAttribute("id", this._canvasID), this._canvas.setAttribute("touch-action", "none"), this._canvas.addEventListener("dblclick", (e) => this.setRenderingNeeded()), this._canvas;
  }
  removeCanvas() {
    this._canvas && (this._canvas.remove(), this._canvas = null);
  }
  deleteEngine() {
    this._engine && (this._engine.dispose(), this._engine = null), this._destroyed = !0, $(window).off("resize", this._bindedResize);
  }
  deleteScene() {
    this.deleteComponents(), this._scene && (this._scene.dispose(), this._scene = null);
  }
  deleteComponents() {
    this.resetPerformanceInfo(), this.emptyArFileCache(), this.disposeInfoPointsManager(), this._meshLocationsManager && (this._meshLocationsManager.dispose(), this._meshLocationsManager = null), this._sceneDesignManager && (this._sceneDesignManager.dispose(), this._sceneDesignManager = null), this._sceneHelper && (this._sceneHelper.dispose(), this._sceneHelper = null), this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null), this._glowManager && (this._glowManager.dispose(), this._glowManager = null), this._sceneActionsExecutor && (this._sceneActionsExecutor.dispose(), this._sceneActionsExecutor = null), this.disposePostProcesses();
  }
  disposeInfoPointsManager() {
    this._infoPointsManager && (this._infoPointsManager.dispose(), this._infoPointsManager = null);
  }
  disposePostProcesses() {
    for (; this._postProcesses.length > 0; ) {
      var e = this._postProcesses.pop();
      e && e.dispose();
    }
  }
  emptyArFileCache() {
    this._arFileUrls = {};
  }
  async resetSceneAsync() {
    await this.init3DEngineAsync();
  }
  /**
   * In some case, we need to replace the model with a new one for example when reverting some changes in the preview 3D.
   * Backbone don't allow to replace all the model, so we need to replace the model with a old clone.
   * @param zkModel The new model to replace the old one.
   */
  replaceModel(e) {
    this._zkModel = e, this.render();
  }
  setZkScene(e) {
    this._zkScene = e;
  }
  closeBroadcastChannel() {
    this._broadcastChannel && (this._broadcastChannel.close(), this._broadcastChannel = null);
  }
  openBroadcastChannel() {
    if (!this._broadcastChannel && window.BroadcastChannel)
      try {
        this._broadcastChannel = new BroadcastChannel("zakeke-broadcast-channel");
      } catch (e) {
        console.error("Failed opening broadcast channel"), console.error(e);
      }
  }
  getOrCreateBroadcastChannel() {
    return this.openBroadcastChannel(), this._broadcastChannel;
  }
  createEngine() {
    this.deleteScene(), this.deleteEngine(), this._engine = new BABYLON.Engine(this._canvas, !0, { stencil: !0, preserveDrawingBuffer: !0 }), this._engine.enableOfflineSupport = !1, this._engine.disableUniformBuffers = !0, Logger.info("WebGL version: " + this._engine.webGLVersion), $(window).resize(this._bindedResize), $(window).on("orientationchange", () => {
      setTimeout(() => this._bindedResize(), 100);
    });
  }
  createBrandLogoButton() {
    var e = BABYLON.GUI.Button.CreateImageOnlyButton(
      "zakeke-logo",
      "https://zakeke.blob.core.windows.net/files/images/logo_hq.png"
    );
    return e.image.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM, e.width = "120px", e.height = "70px", e.color = "transparent", e.hoverCursor = "pointer", e.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT, e.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_TOP, e.left = "40px", e.top = "15px", e.onPointerClickObservable.add(function() {
      window.open("https://www.zakeke.com/");
    }), this._brandLogoButton = e, this._advancedTexture = BABYLON.GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI", !0, this._scene), this._advancedTexture.updateSamplingMode(BABYLON.Texture.NEAREST_NEAREST), this._advancedTexture.renderScale = 2, this._advancedTexture.addControl(this._brandLogoButton), this._brandLogoButton;
  }
  async createEmptySceneAsync() {
    this.deleteScene(), this._engine && (this._scene = new BABYLON.Scene(this._engine), this._defaultBackgroundColor && this._scene.clearColor.copyFrom(this._defaultBackgroundColor), await this.setupSceneAsync());
  }
  refreshLights() {
    var n, a, o, h, f, v;
    if (!this._zkScene)
      return;
    ((a = (n = this._zkScene) == null ? void 0 : n.getGeneralConfig()) == null ? void 0 : a.get("preventDefaultLights")) !== !0 && ((o = this._sceneHelper) == null || o.setupLights());
    const t = (f = (h = this._zkScene) == null ? void 0 : h.getSceneConfig()) == null ? void 0 : f.get("lights");
    t != null && t.attributes && ((v = this._sceneHelper) == null || v.setUpCustomLights(t.attributes));
  }
  async setupSceneAsync(e = !0) {
    var t, n, a, o, h, f, v, x, k, I, V, M, W, U, Q;
    if (this._zkScene && this._zkScene.get("config") && ((n = (t = this._zkScene.get("config")) == null ? void 0 : t.get("general")) != null && n.get("meshSize"))) {
      const D = (o = (a = this._zkScene.get("config")) == null ? void 0 : a.get("general")) == null ? void 0 : o.get("meshSize"), ee = (h = this._scene) == null ? void 0 : h.meshes.find((J) => !J.parent);
      ee && D && (D.width || D.height || D.depth) && (ee.metadata ? ee.metadata.sizecm = D : ee.metadata = { sizecm: D });
    }
    if (this.refreshModel(), this._engine && this._scene) {
      this._sceneHelper = new di(this._scene);
      const D = this.getAvailableAuthToken();
      D && this._sceneHelper.setAuthorizationToken(D);
      const ee = this._zkScene ? this._zkScene.getCameraPositionScale() : void 0, J = this._zkScene ? this._zkScene.getCameraPositionFOV() : void 0, he = this._zkScene ? this._zkScene.getCameraLimitLowerRadius() : void 0, fe = this._zkScene ? this._zkScene.getCameraZoomEnabled() : void 0, X = this._zkScene ? this._zkScene.getCameraUseMinZoomPerc() : !1, Z = this._zkScene ? this._zkScene.getCameraMinZoomPerc() : 1, qe = this._zkScene ? this._zkScene.getCameraUseMaxZoomPerc() : !1, Oe = this._zkScene ? this._zkScene.getCameraMaxZoomPerc() : 1.5, je = this._zkScene ? this._zkScene.getCameraLowerAlphaLimit() : null, pt = this._zkScene ? this._zkScene.getCameraUpperAlphaLimit() : null, Te = this._zkScene ? this._zkScene.getCameraLowerBetaLimit() : null, Ze = this._zkScene ? this._zkScene.getCameraUpperBetaLimit() : null, ce = this._zkScene ? (f = this._zkScene.getCameraConfig()) == null ? void 0 : f.get("zoom") : null;
      if (ee != null && ee != null && this._sceneHelper.setCameraPositionScale(ee, !1), J != null && J != null && this._sceneHelper.setCameraPositionFOV(J), he != null && he != null && this._sceneHelper.setCameraLimitLowerRadius(he, !1), fe != null && fe != null && this._sceneHelper.setZoomEnabled(fe), this._sceneHelper.setCameraZoom(ce), this._sceneHelper.setupCamera(), this._camera = this._scene.activeCamera, this._mouseWheelInput = ((v = this._camera) == null ? void 0 : v.inputs.attached.mousewheel) ?? null, this._camera && (X ? this._sceneHelper.setMinZoomPerc(Z) : this._sceneHelper.setMinZoomPerc(null), qe ? this._sceneHelper.setMaxZoomPerc(Oe) : this._sceneHelper.setMaxZoomPerc(null), this._sceneHelper.setCameraAlphaLimits(je, pt), this._sceneHelper.setCameraBetaLimits(Te, Ze)), this._camera && e && (this._camera.onViewMatrixChangedObservable.add(() => {
        this.notifyCameraMovement();
      }), this._camera.onRestoreStateObservable.add(() => {
        this.setupShaderMaterialsCameraPosition(), this.setRenderingNeeded();
      }), this.refreshCameraPosition()), (x = this._sceneHelper) == null || x.setupAnimations(this._zkScene), this._modelParentNode || (this._modelParentNode = new BABYLON.TransformNode("modelParent")), (k = this._sceneHelper) == null || k.setupShadows(this._zkScene), this.refreshLights(), this.createHighlightLayer(), await this.refreshEnvironment(), await this.fixEnvironmentTexture(), this.setupGlowManager(), this._zkScene && (this._meshLocationsManager = new Xx(), this._meshLocationsManager.setModelAndScene(this._zkScene, this._scene), this._meshLocationsManager.addMeshAnimationCompletedListener(() => this.setRenderingNeeded())), await this.setupSceneActionsExecutorAsync(), this.setRenderingOnDelayLoaded(), this.setupAntiAliasing(), this._scene.onPointerDown = (ut, ze) => this.onPointerDown(ut, ze), this._scene.registerBeforeRender(() => {
        this.onBeforeRender();
      }), this.refreshInfoPoints(), this.refreshModel(), (W = (M = (V = (I = this._zkScene) == null ? void 0 : I.get("config")) == null ? void 0 : V.get("general")) == null ? void 0 : M.get("environmentOptions")) != null && W.get("pbrIntensity") && this.updatePBRMaterialsIntensity(), this._zkScene) {
        const ut = (Q = (U = this._zkScene) == null ? void 0 : U.getGeneralConfig()) == null ? void 0 : Q.get("removeDefaultBackground");
        this._sceneHelper.removeDefaultBackground(ut), this._sceneHelper.setUpSceneToneMapping(this._zkScene);
      }
      this._engine.stopRenderLoop(), this.render(), this._engine.runRenderLoop(() => {
        this.checkRendering();
      });
    }
  }
  onBeforeRender() {
    if (this._scene && this._sceneHelper) {
      if (this._camera) {
        const e = this._sceneHelper.getDefaultPointLight();
        e && (e.position = this._camera.position);
      }
      this._scene.meshes.forEach((e) => {
        e.mustDepthSortFacets && e.isFacetDataEnabled && e.updateFacetData();
      });
    }
  }
  render() {
    this._scene && !this._scene.isDisposed && !this._renderingPaused && this._scene.render();
  }
  // Disabilito il post-processing quando la camera è in movimento
  checkRendering() {
    this._scene && (this._autoRender || this._renderingNeeded || this._scene._activeAnimatables.length !== 0 || this._sceneHelper && this._sceneHelper.userIsMoving() ? (this.checkPerformance(), (this.isLowEndDevice || this._autoRender && !this._camera.autoRotationBehavior || // fix: in autorotate the antialiasing will be disabled without autoRotationBehavior check
    this._scene._activeAnimatables.length !== 0 || this._sceneHelper && this._sceneHelper.userIsMoving()) && !this._antiAliasConfig.inRotationEnabled ? this.disableAntialiasing() : this.enableAntialiasing(), this.render(), this._renderingNeeded && (this._renderingNeeded = !1)) : !this._scene.postProcessesEnabled && !this._antiAliasConfig.inRotationEnabled && (this.enableAntialiasing(), this.render()), this._infoPointsManager && this._infoPointsManager.updateInfoPointsVisibility() && this.render());
  }
  resetPerformanceInfo() {
    this._performanceInfo = null;
  }
  checkPerformance() {
    if (this._performanceInfo || (this._performanceInfo = { totalFPS: 0, countFPS: 0, isLowEndDevice: !1, chekDone: !1 }), this._engine && !this._performanceInfo.chekDone) {
      this._performanceInfo.totalFPS += this._engine.getFps(), this._performanceInfo.countFPS++;
      const e = this._performanceInfo.totalFPS / this._performanceInfo.countFPS;
      this._performanceInfo.countFPS > 30 && (this._performanceInfo.isLowEndDevice = e <= 30, this._performanceInfo.chekDone = !0);
    }
  }
  createAntialiasPostProcesses() {
    if (this._camera && this._postProcesses.length === 0) {
      var e = /firefox/i.test(navigator.userAgent);
      e || this._postProcesses.push(
        new BABYLON.PassPostProcess("scale_pass", 4, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE)
      ), this._postProcesses.push(
        new BABYLON.PassPostProcess("scale_pass", 2, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE)
      ), this._postProcesses.push(
        new BABYLON.PassPostProcess("scale_pass", 1, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE)
      );
    }
  }
  getDAMMainMesh() {
    var e, t;
    return (t = (e = this._sceneHelper) == null ? void 0 : e.getVTOMeshes().userMeshes.filter((n) => !n.parent)) == null ? void 0 : t[0];
  }
  setRenderingNeeded() {
    this._renderingNeeded = !0;
  }
  setLongRenderingNeeded() {
    this.setRenderingNeeded();
    for (let e = 50; e <= 1e3; e += 200)
      setTimeout(() => this.setRenderingNeeded(), e);
  }
  refreshRendering() {
    this.setLongRenderingNeeded();
  }
  pauseRendering() {
    this._renderingPaused = !0;
  }
  resumeRendering() {
    this._renderingPaused = !1, this.setRenderingNeeded();
  }
  setLoadingScreen(e) {
    this._engine && (this._engine.loadingScreen = e);
  }
  setRenderingOnDelayLoaded() {
    if (this._scene) {
      var e = this;
      this._scene.getGeometries().forEach(function(t) {
        var n = t.onGeometryUpdated;
        t.onGeometryUpdated = function(a, o) {
          e.setLongRenderingNeeded(), n && n.apply(this, [a, o]);
        };
      });
    }
  }
  createHighlightLayer() {
    this._scene && (this._highlightLayer = new BABYLON.HighlightLayer("hl1", this._scene), this.updateHighlightLayerExcludedDesignMeshes(), this.setupHighlightLayerIntensity());
  }
  setupHighlightLayerIntensity() {
    this._highlightLayer && (this._highlightLayer.blurHorizontalSize = this._highlightSize, this._highlightLayer.blurVerticalSize = this._highlightSize, this._highlightBlurHorizontalSize = this._highlightSize, this._highlightBlurVerticalSize = this._highlightSize);
  }
  updateHighlightLayerExcludedDesignMeshes() {
    this.scene && this._sceneHelper && this._highlightLayer && (this._highlightLayer.removeAllMeshes(), this.scene.meshes.filter(this._sceneHelper.isCanvasMesh).forEach((e) => this._highlightLayer.addExcludedMesh(e)));
  }
  createDOMElement() {
    this._canvas && (this._domElement = document.createElement("div"), this._domElement.setAttribute("id", "zakeke-canvas-viewer3D-div-" + Zakeke.makeID(5)), this._domElement.appendChild(this._canvas), this._domElement.style.position = "absolute", this._domElement.style.width = "100%", this._domElement.style.height = "100%", this._domElement.style.left = "0", this._domElement.style.top = "0");
  }
  removeDomElement() {
    this._domElement && (this.detach(), this._domElement.remove(), this._domElement = null);
  }
  appendTo(e) {
    this._domElement && (e.firstChild ? e.insertBefore(this._domElement, e.firstChild) : e.appendChild(this._domElement), e.appendChild(this._domElement), this.resize(), this.resize());
  }
  detach() {
    this._domElement && this._domElement.parentNode && this._domElement.parentNode.removeChild(this._domElement);
  }
  updateView(e = !0, t = !1) {
    this.resize(t), e && this._scene && this.adjustCamera(!1);
  }
  resize(e = !1) {
    if (this._canvas) {
      this.disableAntialiasing(!0);
      var t = this._canvas.parentNode;
      if (!(!t || !(t instanceof HTMLElement))) {
        var n = t.offsetWidth, a = t.offsetHeight;
        (n != this._lastWidth || a != this._lastHeight || e) && (this._canvas.style.width = "100%", this._canvas.style.height = "100%", this._engine && (this._engine.resize(), this.setRenderingNeeded())), this._lastWidth = n, this._lastHeight = a, this.enableAntialiasing();
      }
    }
  }
  switchFullScreen(e) {
    this._sceneHelper && this._sceneHelper.switchFullScreen(e);
  }
  setupGlowManager() {
    this._glowManager && (this._glowManager.dispose(), this._glowManager = null), this._zkScene && this._scene && (this._glowManager = new Kx(this._zkScene, this._scene), this._glowManager.update(), this.setRenderingNeeded());
  }
  async setupSceneActionsExecutorAsync() {
    this._zkScene && this._scene && (this._sceneActionsExecutor = new $x(this._zkScene, this._scene), this._sceneActionsExecutor.deviceType = this.deviceType, this._sceneActionsExecutor.useMaterialOffloading = !this._configPreview && this.getUseMaterialOffloading(), this._sceneActionsExecutor.prefetchMeshes = this.getPrefetchMeshes(), this._sceneActionsExecutor.prefetchMaterials = this.getPrefetchMaterials(), this._sceneActionsExecutor.addMeshDesignRefreshRequiredListeners(async (e) => {
      await this.refreshMeshesDesignAsync(e.meshes, e.effect);
    }), this._sceneActionsExecutor.addBeginAssetsLoadingListener(() => this.fireBeginAssetsLoadingEvent()), this._sceneActionsExecutor.addEndAssetsLoadingListener(() => this.fireEndAssetsLoadingEvent()));
  }
  restoreCameraState() {
    this._sceneHelper && (this._sceneHelper.restoreCameraState(), this._sceneHelper.setupShaderMaterialsCameraPosition(), this.setRenderingNeeded());
  }
  async fixEnvironmentTexture() {
    if (this._scene && this._scene.environmentTexture && this._scene.environmentTexture.url && typeof this._scene.environmentTexture.url == "string") {
      const e = this._scene.environmentTexture.url, t = (e.match(/http/g) || []).length;
      let n = e;
      if (t > 1) {
        let f = e.lastIndexOf("http");
        f >= 0 && (n = e.substring(f));
      } else if (t == 0 && this._zkScene && this._zkScene.get("rootUrl")) {
        let f = this._zkScene.get("rootUrl");
        if (f) {
          const v = f.endsWith("/") ? "" : "/";
          n = f + v + e;
        }
      } else if (t === 0)
        return;
      let a, o, h;
      this._scene && this._scene.metadata && (this._scene.metadata.environmentTextureRotationY !== void 0 && typeof this._scene.metadata.environmentTextureRotationY == "number" && (a = this._scene.metadata.environmentTextureRotationY), this._scene.metadata.environmentTextureExtensions && (o = this._scene.metadata.environmentTextureExtensions), this._scene.metadata.environmentTextureFiles && (h = this._scene.metadata.environmentTextureFiles)), await this.setSceneEnvironmentTexture(n, a, o, h);
    } else
      await this.checkSceneEmptyEnvironmentTexture();
  }
  async checkSceneEmptyEnvironmentTexture() {
    this._scene && this._sceneHelper && this._sceneHelper.containsPBRMaterials() && !this._scene.environmentTexture && await this.setDefaultSceneEnvironmentTexture();
  }
  async setDefaultSceneEnvironmentTexture() {
    const e = ci.Environment.EnvironmentTextureCDNUrl;
    await this.setSceneEnvironmentTexture(e);
  }
  async setSceneEnvironmentTexture(e, t, n, a, o, h) {
    return new Promise((f) => {
      if (this._scene && this._sceneHelper)
        if (this._scene.environmentTexture && this._sceneHelper.isTextureWithUrl(this._scene.environmentTexture) && this._scene.environmentTexture.url && this._scene.environmentTexture.url != e && (this._scene.environmentTexture.dispose(), this._scene.environmentTexture = null), this._scene && this._sceneHelper) {
          this._scene.environmentTexture && this._sceneHelper.isTextureWithUrl(this._scene.environmentTexture) && this._scene.environmentTexture.url && this._scene.environmentTexture.url != e && (this._scene.environmentTexture.dispose(), this._scene.environmentTexture = null);
          const v = () => {
            o && o(), this.setLongRenderingNeeded();
          };
          this._scene.metadata || (this._scene.metadata = {}), delete this._scene.metadata.environmentTextureType, delete this._scene.metadata.environmentTextureSize, delete this._scene.metadata.environmentTextureExtensions, delete this._scene.metadata.environmentTextureFiles;
          let x = null;
          e.endsWith(".dds") ? x = BABYLON.CubeTexture.CreateFromPrefilteredData(e, this._scene) : e.endsWith(".hdr") ? (x = new BABYLON.HDRCubeTexture(
            e,
            this._scene,
            128,
            (h == null ? void 0 : h.get("mipMaps")) || void 0,
            (h == null ? void 0 : h.get("generateHarmonics")) || void 0,
            (h == null ? void 0 : h.get("gammaSpace")) || void 0,
            (h == null ? void 0 : h.get("prefilterOnLoad")) || void 0,
            v
          ), this._scene.metadata.environmentTextureType = "BABYLON.HDRCubeTexture", this._scene.metadata.environmentTextureSize = 128) : e.endsWith(".env") ? x = new BABYLON.CubeTexture(
            e,
            this._scene,
            null,
            !1,
            null,
            v,
            null,
            void 0,
            !0,
            void 0,
            !0
          ) : e.endsWith(".basis") ? x = BABYLON.CubeTexture.CreateFromPrefilteredData(e, this._scene) : n && n.length === 6 && a && a.length === 6 && (x = new BABYLON.CubeTexture(
            e,
            this._scene,
            n,
            !1,
            a,
            v
          ), this._scene.metadata.environmentTextureExtensions = n, this._scene.metadata.environmentTextureFiles = a), x && di.whenTextureIsReadyAsync(x).then(() => {
            var k, I, V, M, W, U, Q, D;
            if (x && this._scene) {
              const ee = (M = (V = (I = (k = this._zkScene) == null ? void 0 : k.get("config")) == null ? void 0 : I.get("general")) == null ? void 0 : V.get("environmentOptions")) == null ? void 0 : M.get("intensity"), J = (D = (Q = (U = (W = this._zkScene) == null ? void 0 : W.get("config")) == null ? void 0 : U.get("general")) == null ? void 0 : Q.get("environmentOptions")) == null ? void 0 : D.get("rotationY");
              ee && (x.level = ee), J ? x.rotationY = J : this._scene.metadata && this._scene.metadata.environmentTextureRotationY != null && delete this._scene.metadata.environmentTextureRotationY, this._scene.environmentTexture = x, this.setRenderingNeeded(), f();
            }
          });
        } else
          f();
    });
  }
  async loadSceneFromModelAsync(e, t, n) {
    if (e && e instanceof MPlaza.Model && (this._zkModel = e), t && t instanceof Zakeke.Scene) {
      this._zkScene = t, this.checkSceneShaderMaterials(t);
      const a = t.get("rootUrl"), o = t.get("sceneFileName");
      a && o && await this.loadSceneFromRemoteFilesAsync(a, o, n);
    }
  }
  async loadSceneFromModelDataAsync(e, t, n, a) {
    if (e && e instanceof MPlaza.Model && (this._zkModel = e), t && t instanceof Zakeke.Scene) {
      this._zkScene = t, this.checkSceneShaderMaterials(t);
      var o = "data:" + n;
      const h = t.get("rootUrl");
      h && await this.loadSceneFromRemoteFilesAsync(h, o, a);
    }
  }
  preSceneFileLoading() {
  }
  postSceneFileLoading() {
  }
  // Carica la scena Babylon JS tramite rootUrl e sceneFilename
  // La scena verrà caricata direttamente da Babylon JS. Le texture verranno lette risolvendo
  // il path in base a rootUrl e al nome della texture
  // textureUrl = rootUrl + texture.name
  async loadSceneFromRemoteFilesAsync(e, t, n) {
    if (!this._engine)
      throw new Error("Unable to load scene when the 3D engine is null");
    try {
      this.fireBeginSceneLoadingEvent(), this.preSceneFileLoading(), this.pauseRendering(), this._engine.sceneFileRootUrl = e;
      let a = await BABYLON.SceneLoader.LoadAsync(e, t, this._engine, n);
      if (this._destroyed) {
        Logger.info("Loading scene engine destroyed"), a.dispose();
        return;
      }
      if (await new Promise((x) => a.executeWhenReady(() => x())), this._destroyed)
        throw Logger.info("Loading scene engine destroyed"), a.dispose(), new Error("Engine destroyed while loading scene");
      const o = di.visibleMeshesRequireDelayedLoading(a);
      o && this.fireBeginAssetsLoadingEvent();
      let h = 0;
      const f = a.meshes.filter((x) => x.isVisible);
      for (let x = 0; x < f.length; x++)
        await this.fireNextSceneMeshesLoadedEvent(x + 1, f.length), await new Promise((k) => {
          setTimeout(() => {
            k();
          }, 10);
        });
      await di.whenAllVisibleMeshesAreReadyAsync(f), o && this.fireEndAssetsLoadingEvent(), this.deleteScene(), this._scene = a, this._defaultBackgroundColor ? this._scene.clearColor.copyFrom(this._defaultBackgroundColor) : this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0);
      let v = [];
      for (let x = 0; x < this._scene.textures.length; x++) {
        const k = this._scene.textures[x];
        v.push(k.name), k instanceof BABYLON.Texture && k.onLoadObservable && k.onLoadObservable.add((I) => {
          this.setLongRenderingNeeded();
        });
      }
      if (this._scene && this._scene.metadata && !this._scene.metadata.delayedMaterials)
        for (let x = 0; x < this._scene.textures.length; x++)
          await this.fireNextSceneTextureLoadedEvent(x + 1, this._scene.textures.length), await new Promise((k) => {
            setTimeout(() => {
              k();
            }, 10);
          });
      if (await this.setupSceneAsync(), this._sceneHelper) {
        if (this._configPreview && this._scene.metadata && this._scene.metadata.delayedMaterials) {
          this._scene.useDelayedTextureLoading = !0;
          try {
            console.log("Trying loading delayed materials using Zip file"), await this._sceneHelper.loadAllDelayedMaterialFromZip(
              e,
              this.zkScene.get("version"),
              this.fireNextSceneTextureLoadedEvent.bind(this)
            ), console.log("Delayed materials loaded using zip file");
          } catch (x) {
            console.warn(
              "Delayed materials not loaded using zip file error:",
              x,
              ", trying to load delayed materials the stanrdad way"
            ), await this._sceneHelper.cleanupAllTemporaryMaterialsAsync(), await this._sceneHelper.loadAllDelayedMaterialsAsync(
              e,
              this.fireNextSceneTextureLoadedEvent.bind(this)
            );
          }
        }
        this._configPreview && this._scene.metadata && this._scene.metadata.offloadedMaterials && this._sceneHelper.loadAllOffloadedMaterials(e), this._configPreview && this._scene.metadata && this._scene.metadata.originalMeshMaterials && this._sceneHelper.unsetAllDummyMaterials(), this._sceneHelper.setupShaderMaterialsCameraPosition();
        try {
          await this.reloadAllLoadingErrorTexturesAsync();
        } catch (x) {
          console.error(x);
        }
      }
      if (this._environmentManager) {
        const x = this._environmentManager.getSkyboxTexture();
        x && await di.whenTextureIsReadyAsync(x);
      }
    } finally {
      this.resumeRendering(), this.postSceneFileLoading(), this.fireEndSceneLoadingEvent();
    }
  }
  getSkyboxTexture() {
    var e;
    return (e = this._environmentManager) == null ? void 0 : e.getSkyboxTexture();
  }
  // Carica la scena Babylon JS tramite rootUrl e sceneFilename
  // La scena verrà caricata direttamente da Babylon JS. Le texture verranno lette risolvendo
  // il path in base a rootUrl e al nome della texture
  // textureUrl = rootUrl + texture.name
  async loadSceneFromRemoteFilesAsync_OLD(e, t, n) {
    return new Promise(async (a, o) => {
      this._engine || o(), this.preSceneFileLoading(), this._engine.sceneFileRootUrl = e;
      let h = await BABYLON.SceneLoader.LoadAsync(e, t, this._engine, n);
      if (this._destroyed) {
        Logger.info("Loading scene engine destroyed"), h.dispose();
        return;
      }
      h.executeWhenReady(async () => {
        this._destroyed && (Logger.info("Loading scene engine destroyed"), h.dispose(), o());
        const f = h.meshes.filter((x) => x.isVisible), v = di.visibleMeshesRequireDelayedLoading(h);
        v && this.fireBeginAssetsLoadingEvent(), await di.whenAllVisibleMeshesAreReadyAsync(f), v && this.fireEndAssetsLoadingEvent(), this.deleteScene(), this._scene = h;
        for (let x = 0; x < this._scene.textures.length; x++) {
          const k = this._scene.textures[x];
          k instanceof BABYLON.Texture && k.onLoadObservable && k.onLoadObservable.add((I) => {
            this.setLongRenderingNeeded();
          });
        }
        await this.setupSceneAsync(), this._sceneHelper && (this._configPreview && this._scene.metadata && this._scene.metadata.delayedMaterials && await this._sceneHelper.loadAllDelayedMaterialsAsync(e), this._configPreview && this._scene.metadata && this._scene.metadata.offloadedMaterials && this._sceneHelper.loadAllOffloadedMaterials(e), this._configPreview && this._scene.metadata && this._scene.metadata.originalMeshMaterials && this._sceneHelper.unsetAllDummyMaterials(), this._sceneHelper.setupShaderMaterialsCameraPosition()), this.postSceneFileLoading(), a();
      });
    });
  }
  checkSceneShaderMaterials(e) {
    if (e instanceof Zakeke.Scene && e.get("shaderMaterials"))
      for (let t = 0; t < e.get("shaderMaterials").length; t++) {
        const n = e.get("shaderMaterials").at(t), a = n.get("name"), o = n.get("vertex"), h = n.get("fragment");
        if (a && o && h) {
          const f = { name: a, vertex: o, fragment: h };
          this.setupShadersStore(f);
        }
      }
  }
  checkShaderMaterial(e) {
    if (e && e instanceof Zakeke.Material && e.get("shaders")) {
      const n = e.get("shaders").get("name"), a = e.get("shaders").get("vertex"), o = e.get("shaders").get("fragment");
      if (n && a && o) {
        const h = { name: n, vertex: a, fragment: o };
        this.setupShadersStore(h);
      }
    }
  }
  setupShadersStore(e) {
    if (e && e.hasOwnProperty("name") && e.hasOwnProperty("vertex") && e.hasOwnProperty("fragment")) {
      var t = e.name + "VertexShader", n = e.name + "FragmentShader";
      BABYLON.Effect.ShadersStore[t] = e.vertex, BABYLON.Effect.ShadersStore[n] = e.fragment;
    }
  }
  isRealMesh(e) {
    return this._sceneHelper ? this._sceneHelper.isRealMesh(e) : !1;
  }
  countSceneMeshes() {
    return this._sceneHelper ? this._sceneHelper.countSceneMeshes() : 0;
  }
  getVisibleMeshes() {
    return this._sceneHelper ? this._sceneHelper.getVisibleMeshes() : [];
  }
  getSceneBoundingInfo() {
    return this._sceneHelper ? this._sceneHelper.getSceneBoundingInfo() : null;
  }
  selectMesh(e) {
    this.selectUnselectMesh(e, !0);
  }
  unselectMesh(e) {
    this.selectUnselectMesh(e, !1);
  }
  unselectAllMeshes() {
    this._scene && (this._scene.meshes.forEach((e) => this.unselectSingleMesh(e)), this.fireFocusAttributesEvent({ groups: [] }));
  }
  selectUnselectMesh(e, t) {
    if (this._scene && (this._scene.meshes.forEach((a) => this.unselectSingleMesh(a)), t)) {
      let a = (h) => {
        this.selectSingleMesh(h);
        const f = h.getChildMeshes();
        f && f.forEach((v) => a(v));
      };
      const o = this._scene.getMeshByID(e);
      if (o) {
        a(o);
        const h = this.getGroupForMesh(o);
        h && (this.highlightGroupForMesh(o), this.fireGroupPickedEvent({ groupID: h.get("groupID") }));
        var n = this.getVisibleHiddenAttributesForMesh(o);
        this.fireFocusAttributesEvent({ groups: n }), n.length > 0 && this.highlightMeshes([o]);
      }
    }
  }
  selectSingleMesh(e) {
    this.setRenderingNeeded(), e.selected = !0;
  }
  unselectSingleMesh(e) {
    this.setRenderingNeeded(), e.selected = !1;
  }
  selectMeshesWithMaterial(e) {
    this.selectUnselectMeshesWithMaterial(e, !0);
  }
  unselectMeshesWithMaterial(e) {
    this.selectUnselectMeshesWithMaterial(e, !1);
  }
  selectUnselectMeshesWithMaterial(e, t) {
    if (this._scene && (this._scene.meshes.forEach((n) => this.unselectSingleMesh(n)), t)) {
      let n = (a) => {
        a.material && a.material.id === e && this.selectSingleMesh(a);
        const o = a.getChildMeshes();
        o && o.forEach((h) => {
          n(h);
        });
      };
      this._scene.meshes.forEach((a) => {
        n(a);
      });
    }
  }
  onPointerDown(e, t) {
    t.hit && t.pickedMesh ? this.selectMesh(t.pickedMesh.id) : this.unselectAllMeshes();
  }
  getSelectedRootMesh() {
    if (this._scene)
      for (let e = 0; e < this._scene.meshes.length; e++) {
        const t = this._scene.meshes[e];
        if (t.selected) {
          const n = t.parent;
          if (!n || !n.selected)
            return t;
        }
      }
    return null;
  }
  getMeshByID(e) {
    return this._scene ? this._scene.getMeshByID(e) : null;
  }
  getMeshByName(e) {
    return this._scene ? this._scene.getMeshByName(e) : null;
  }
  getMaterialByID(e) {
    return this._scene ? this._scene.getMaterialByID(e) : null;
  }
  setCameraLocation(e, t = !1, n = !0) {
    if (this._zkScene && this._sceneHelper) {
      const a = this._zkScene.getCameraLocation(e);
      if (a) {
        const o = new BABYLON.Vector3(
          a.get("px"),
          a.get("py"),
          a.get("pz")
        ), h = new BABYLON.Vector3(
          a.get("tx"),
          a.get("ty"),
          a.get("tz")
        );
        if (n) {
          if (!t)
            this._sceneHelper.animateCamera(h, o, 0.5);
          else if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            const f = this._sceneHelper.computeCameraAngleOfView(h, o);
            this._sceneHelper.animateCameraToFinalParamters(
              f.alpha,
              f.beta,
              this._camera.radius,
              this._camera.target,
              0.5
            );
          }
        } else if (!t)
          this._sceneHelper.moveCamera(h, o);
        else if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
          const f = this._sceneHelper.computeCameraAngleOfView(h, o);
          this._sceneHelper.moveCameraToFinalParameters(
            f.alpha,
            f.beta,
            this._camera.radius,
            this._camera.target
          );
        }
      }
    }
    this.setRenderingNeeded();
  }
  adjustCamera(e) {
    this._sceneHelper && (e != null && e != null && typeof e == "boolean" ? this._sceneHelper.adjustCamera(void 0, void 0, void 0, e) : this._sceneHelper.adjustCamera(), this.setupShaderMaterialsCameraPosition(), this.setRenderingNeeded());
  }
  zoomIn() {
    this._sceneHelper && this._sceneHelper.zoomIn();
  }
  zoomOut() {
    this._sceneHelper && this._sceneHelper.zoomOut();
  }
  zoom(e) {
    this._sceneHelper && this._sceneHelper.zoom(e);
  }
  rotateCameraLeft(e, t) {
    this._sceneHelper && this._sceneHelper.rotateCameraLeft(e, t);
  }
  rotateCameraRight(e, t) {
    this._sceneHelper && this._sceneHelper.rotateCameraRight(e, t);
  }
  rotateCameraUp(e, t) {
    this._sceneHelper && this._sceneHelper.rotateCameraUp(e, t);
  }
  rotateCameraDown(e, t) {
    this._sceneHelper && this._sceneHelper.rotateCameraDown(e, t);
  }
  setCameraPivot(e) {
    if (this._scene && this._sceneHelper) {
      const t = e ? this._scene.getMeshByID(e) : null;
      this._sceneHelper.setCameraPivot(t);
    }
  }
  setCameraZoomEnabled(e) {
    this._scene && this._sceneHelper && (this._sceneHelper.setZoomEnabled(e), this.setRenderingNeeded());
  }
  async executeScriptAsync(e) {
    this._sceneActionsExecutor && (await this._sceneActionsExecutor.executeScriptAsync(e), this.notifyScriptExecution(e), this.setupShaderMaterialsCameraPosition(), this.refreshInfoPoints(), this.setLongRenderingNeeded());
  }
  async executeActionsAsync(e, t, n) {
    this._sceneActionsExecutor && (await this._sceneActionsExecutor.executeActionsAsync(e, t, n), this.notifyActionExecution(e, t, n), this.setupShaderMaterialsCameraPosition(), this.refreshInfoPoints(), this.setLongRenderingNeeded());
  }
  async prefetchMeshesForUnselectedOptionsAsync(e) {
    this._sceneActionsExecutor && await this._sceneActionsExecutor.prefetchMeshesForUnselectedOptionsAsync(e);
  }
  async prefetchDataForUnselectedOptionsAsync(e) {
    this._sceneActionsExecutor && await this._sceneActionsExecutor.prefetchDataForUnselectedOptionsAsync(e);
  }
  async updatePBRMaterialsIntensity() {
    var a, o, h, f, v;
    const e = (a = this._scene) == null ? void 0 : a.materials, t = (h = (o = this._zkScene) == null ? void 0 : o.get("config")) == null ? void 0 : h.toJSON();
    if (!t || !e)
      return;
    const n = (v = (f = t == null ? void 0 : t.general) == null ? void 0 : f.environmentOptions) == null ? void 0 : v.pbrIntensity;
    n && (e == null || e.forEach((x) => {
      x instanceof BABYLON.PBRMaterial && (x.environmentIntensity = n);
    }));
  }
  async refreshModel() {
    var n, a, o, h, f, v, x, k;
    const e = (n = this._scene) == null ? void 0 : n.meshes, t = (o = (a = this._zkScene) == null ? void 0 : a.get("config")) == null ? void 0 : o.toJSON();
    if (!(!t || !e) && ((x = this._sceneHelper) == null || x.transformEntireScene(
      (h = t.model) == null ? void 0 : h.position,
      (f = t.model) == null ? void 0 : f.rotation,
      (v = t.model) == null ? void 0 : v.scale,
      this._modelParentNode
    ), (k = t.model) != null && k.config)) {
      const I = t.model.config.doubleSided;
      I !== void 0 && (e == null || e.forEach((V) => {
        V.material instanceof BABYLON.PBRMaterial && V.material && !(V instanceof BABYLON.GroundMesh) && (V.material.backFaceCulling = !I);
      }));
    }
  }
  async refreshEnvironment() {
    if (this._zkScene && this._scene) {
      const e = this._zkScene.getOrCreateGeneralConfig().get("environmentTexture"), t = this._zkScene.getOrCreateGeneralConfig().get("environmentOptions");
      e && t && !this._scene.textures.some((n) => n.url === e) && await this.setSceneEnvironmentTexture(e, void 0, void 0, void 0, void 0, t), (!this._environmentManager || this._environmentManager.scene != this._scene || this._environmentManager.isHologram != this._isHologram) && (this._environmentManager = new Jd(this._zkScene, this._scene, this._isHologram)), this._environmentManager.update(), this.setLongRenderingNeeded(), this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._autoRender = this._camera.useAutoRotationBehavior), this.setRenderingNeeded();
    }
  }
  highlightMeshes(e) {
    if (!e || Object.prototype.toString.call(e) !== "[object Array]" || this._highlightSize == 0)
      return;
    const t = this._highlightBlurHorizontalSize, n = this._highlightBlurVerticalSize, a = (f) => {
      f.isVisible && this._highlightLayer && this._highlightLayer.addMesh(f, BABYLON.Color3.FromHexString(this._highlightColor)), f.getChildMeshes().forEach((x) => {
        x instanceof BABYLON.Mesh && a(x);
      });
    }, o = (f) => {
      this._highlightLayer && this._highlightLayer.removeMesh(f), f.getChildMeshes().forEach((x) => {
        x instanceof BABYLON.Mesh && o(x);
      });
    }, h = () => {
      if (this._highlightAnimationID && (clearInterval(this._highlightAnimationID), this._highlightAnimationID = null), this._highlightCurrentMeshes && this._highlightCurrentMeshes.forEach((f) => {
        f instanceof BABYLON.Mesh && o(f);
      }), this._highlightLayer && (this._highlightLayer.blurHorizontalSize = t, this._highlightLayer.blurVerticalSize = n), this._highlightNextMeshes) {
        const f = this._highlightNextMeshes;
        this._highlightNextMeshes = [], this.highlightMeshes(f);
      }
    };
    if (this._highlightAnimationID) {
      this._highlightNextMeshes = e, h();
      return;
    }
    if (this._highlightLayer || this.createHighlightLayer(), this._highlightLayer) {
      this._highlightCurrentMeshes = e, e.forEach((V) => {
        V instanceof BABYLON.Mesh && a(V);
      });
      const f = 800, v = 20, x = v / f;
      let k = t, I = n;
      this._highlightAnimationID = window.setInterval(() => {
        this._highlightLayer && (k -= t * x, I -= n * x, k = Math.max(0, k), I = Math.max(0, I), k >= 0 && (this._highlightLayer.blurHorizontalSize = k), I >= 0 && (this._highlightLayer.blurVerticalSize = I), (k == 0 || I == 0) && h(), this.setRenderingNeeded());
      }, v), this.setRenderingNeeded();
    }
  }
  highlightGroupForMesh(e) {
    const t = this.getGroupForMesh(e);
    this.highlightGroup(t);
  }
  highlightGroupByID(e) {
    if (this._zkModel) {
      const t = this._zkModel.get("attributeGroups").findWhere({ groupID: e });
      t ? this.highlightGroup(t) : this.highlightGroup(null);
    }
  }
  highlightGroup(e) {
    if (this._zkScene && this._scene && e) {
      const n = e.get("meshSelector");
      if (n) {
        var t = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          n,
          MPlaza.SceneElementType.Mesh
        );
        this.highlightMeshes(t);
      }
    }
  }
  getGroupForMesh(e) {
    if (this._zkModel && this._zkScene && this._scene && e && this._sceneHelper) {
      const t = this._zkModel.get("attributeGroups");
      for (let n = 0; n < t.length; n++) {
        const a = t.at(n), o = a.get("meshSelector");
        if (o) {
          const h = this._elementSelector.getMeshElements(
            this._zkScene,
            this._scene,
            null,
            o,
            MPlaza.SceneElementType.Mesh
          );
          for (let f = 0; f < h.length; f++) {
            let v = h[f];
            if (e.id == v.id || this._sceneHelper.meshHasParent(e.id, v.id))
              return a;
          }
        }
      }
    }
    return null;
  }
  highlightAttributeByID(e) {
    if (this._zkModel) {
      const t = this._zkModel.get("attributes").findWhere({ attributeID: e });
      t ? this.highlightAttribute(t) : this.highlightAttribute(null);
    }
  }
  highlightAttribute(e) {
    if (this._zkScene && this._scene && e) {
      const n = e.get("meshSelector");
      if (n) {
        var t = this._elementSelector.getMeshElements(
          this._zkScene,
          this._scene,
          null,
          n,
          MPlaza.SceneElementType.Mesh
        );
        this.highlightMeshes(t);
      }
    }
  }
  getVisibleHiddenAttributesForMesh(e) {
    const t = [], n = (o) => {
      let h = t.find((f) => f.groupId == o);
      return h || (h = { groupId: o, visibleAttributes: [], hiddenAttributes: [] }, t.push(h)), h;
    };
    if (this._zkModel && this._zkScene && this._scene && e) {
      const o = this._zkModel.get("attributes");
      for (let h = 0; h < o.length; h++) {
        const f = o.at(h), v = f.get("attributeID"), x = f.get("meshSelector");
        if (x) {
          const k = n(f.get("groupID"));
          var a = this._elementSelector.getMeshElements(
            this._zkScene,
            this._scene,
            null,
            x,
            MPlaza.SceneElementType.Mesh
          );
          a.find((V) => this._sceneHelper ? e.id == V.id || this._sceneHelper.meshHasParent(e.id, V.id) : !1) ? k.visibleAttributes.push(v) : k.hiddenAttributes.push(v);
        }
      }
    }
    return t.filter((o) => o.visibleAttributes.length > 0);
  }
  // -------------------------------------------------------------
  // Events
  // -------------------------------------------------------------
  fireGroupPickedEvent(e) {
    for (let t = 0; t < this._groupPickedListeners.length; t++)
      this._groupPickedListeners[t](e);
  }
  addGroupPickedListener(e) {
    this._groupPickedListeners.push(e);
  }
  fireFocusAttributesEvent(e) {
    for (let t = 0; t < this._focusAttributesListeners.length; t++)
      this._focusAttributesListeners[t](e);
  }
  addFocusAttributesListener(e) {
    this._focusAttributesListeners.push(e);
  }
  addNotifyMessageListener(e) {
    this._designNotifyMessageListeners.push(e), this._sceneDesignManager && this._sceneDesignManager.addNotifyMessageListener(e);
  }
  addRemoveMessageListener(e) {
    this._designRemoveMessageListeners.push(e), this._sceneDesignManager && this._sceneDesignManager.addRemoveMessageListener(e);
  }
  setEventMessages(e) {
    this._designEventMessages = e, this._sceneDesignManager && this._sceneDesignManager.setEventMessages(e);
  }
  addInfoPointPickedListener(e) {
    this._infoPointPickedListeners.push(e), this._infoPointsManager && this._infoPointsManager.addInfoPointPickedListener(e);
  }
  addInfoPointContentShownListener(e) {
    this._infoPointContentShownListeners.push(e), this._infoPointsManager && this._infoPointsManager.addInfoPointContentShownListener(e);
  }
  addInfoPointContentHiddenListener(e) {
    this._infoPointContentHiddenListeners.push(e), this._infoPointsManager && this._infoPointsManager.addInfoPointContentHiddenListener(e);
  }
  // begin assets loading
  addBeginAssetsLoadingListener(e) {
    this._beginAssetsLoadingListeners.push(e);
  }
  fireBeginAssetsLoadingEvent() {
    Logger.info("Begin Assets Loading");
    for (let e = 0; e < this._beginAssetsLoadingListeners.length; ++e)
      this._beginAssetsLoadingListeners[e]();
  }
  addEndAssetsLoadingListener(e) {
    this._endAssetsLoadingListeners.push(e);
  }
  fireEndAssetsLoadingEvent() {
    Logger.info("End Assets Loading");
    for (let e = 0; e < this._endAssetsLoadingListeners.length; ++e)
      this._endAssetsLoadingListeners[e]();
  }
  addNextSceneMeshesLoadedListeners(e) {
    this._nextSceneMeshesLoadedListeners.push(e);
  }
  async fireNextSceneMeshesLoadedEvent(e, t) {
    let n = [];
    for (let a = 0; a < this._nextSceneMeshesLoadedListeners.length; ++a)
      n.push(this._nextSceneMeshesLoadedListeners[a](e, t));
    await Promise.all(n);
  }
  addNextSceneTextureLoadedListeners(e) {
    this._nextSceneTexturesLoadedListeners.push(e);
  }
  async fireNextSceneTextureLoadedEvent(e, t) {
    let n = [];
    for (let a = 0; a < this._nextSceneTexturesLoadedListeners.length; ++a)
      n.push(this._nextSceneTexturesLoadedListeners[a](e, t));
    await Promise.all(n);
  }
  addBeginSceneLoadingListener(e) {
    this._beginAssetsLoadingListeners.push(e);
  }
  fireBeginSceneLoadingEvent() {
    Logger.info("Begin Scene Loading");
    for (let e = 0; e < this._beginAssetsLoadingListeners.length; ++e)
      this._beginAssetsLoadingListeners[e]();
  }
  addEndSceneLoadingListener(e) {
    this._endAssetsLoadingListeners.push(e);
  }
  fireEndSceneLoadingEvent() {
    Logger.info("End Scene Loading");
    for (let e = 0; e < this._endAssetsLoadingListeners.length; ++e)
      this._endAssetsLoadingListeners[e]();
  }
  // --------------------------------------------------------------
  async getSceneScreenshotAsync(e, t) {
    return this._sceneHelper ? (this.setRenderingNeeded(), await this._sceneHelper.takeScreenshotAsync(e, t)) : null;
  }
  async getSceneContentScreenshotAsync(e, t, n = 0, a, o, h, f) {
    if (!this._sceneHelper || !this.scene || !this.zkModel || !this.zkScene)
      return null;
    this.preSceneContentScreenshot(), this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null), this.setRenderingNeeded();
    let v = "";
    const x = f ? typeof f == "string" ? BABYLON.Color4.FromHexString(f) : f : void 0;
    if (o)
      v = await this._sceneHelper.takeContentScreenshotAsync(e, t, x);
    else {
      const I = this._canvas;
      if (I) {
        const V = I.width, M = I.height;
        I.width = e, I.height = t;
        const W = this.scene.activeCamera.position.clone(), U = this.scene.activeCamera.target.clone(), Q = h ? {
          position: new BABYLON.Vector3(h.get("px"), h.get("py"), h.get("pz")),
          target: new BABYLON.Vector3(h.get("tx"), h.get("ty"), h.get("tz"))
        } : {
          position: this._scene.activeCamera.position,
          target: this._scene.activeCamera.target
        };
        this._scene.activeCamera.position = Q.position, this._scene.activeCamera.target = Q.target, this._scene.render(), v = await this._sceneHelper.takeContentScreenshotAsync(e, t, x), this._scene.activeCamera.position = W, this._scene.activeCamera.target = U, I.width = V, I.height = M;
      }
    }
    console.log("senza Utils");
    let k = await Uh(v);
    if (k || (console.error("Failed trimming image.", v), k = v), k = await lw(k, e, t, n), !k)
      throw new Error("Failed resizing image.");
    return this.refreshEnvironment(), this.postSceneContentScreenshot(), k;
  }
  preSceneContentScreenshot() {
  }
  postSceneContentScreenshot() {
  }
  preSceneMaterialScreenshot() {
    this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null);
  }
  postSceneMaterialScreenshot() {
    this.refreshEnvironment();
  }
  async getMaterialScreenshotAsync(e, t, n) {
    if (!this._scene || !this._sceneHelper)
      return null;
    this.preSceneMaterialScreenshot();
    let a = null;
    const o = await this.getSceneRootUrl();
    if (o) {
      const h = await ao.getPreviewsAsync(
        this._scene,
        o,
        [e],
        {
          width: t,
          height: n,
          crop: !0
        },
        !1
      ), f = Object.keys(h.previewFiles);
      f.length == 1 && (a = h.previewFiles[f[0]]);
    } else {
      const h = await this._sceneHelper.takeMaterialScreenshotAsync(e, t, n), f = await Uh(h);
      f && (a = f);
    }
    return this.postSceneMaterialScreenshot(), a;
  }
  // Used to avoid multiple listeners when using react redraw
  clearListeners() {
    this._groupPickedListeners = [], this._focusAttributesListeners = [];
  }
  // Il parametro showDesign è stato aggiunto per impedire la visualizzazione dei design sugli oggetti.
  // Un utilizzo di questo parametro viene fatto quando si vogliono ottenere le informazioni sugli item
  // del design senza volerli visualizzare perché ad esempio potrebbero essere elementi di testo con
  // dei font ancora non caricati. In tal caso andrebbero prima caricati i font e poi visualizzato il design
  async renderDesignAsync(e, t = !0) {
    console.log("[renderDesignAsync] QUEUED", { showDesign: t });
    const n = this._renderDesignQueue;
    return this._renderDesignQueue = n.catch(() => {
    }).then(() => this._renderDesignInternalAsync(e, t)), this._renderDesignQueue;
  }
  async _renderDesignInternalAsync(e, t) {
    if (console.log("[renderDesignAsync] START", { showDesign: t }), this._scene && this._zkScene && this._zkModel && e) {
      if (this._sceneDesignManager && this._sceneDesignManager.isForModels(this._scene, this._zkModel, e))
        this._sceneDesignManager.showDesign = t, this._sceneDesignManager.rotation = this._currentRotation, await this._sceneDesignManager.refreshAsync();
      else {
        this.emptyArFileCache(), this._sceneDesignManager && (this._sceneDesignManager.dispose(), this._sceneDesignManager = null), this._sceneDesignManager = new gw(
          this._scene,
          this._zkScene,
          this._zkModel,
          e,
          t
        ), this._sceneDesignManager.addRenderingNeededListener(() => {
          this.setLongRenderingNeeded(), this.notifyDesignChanged(e);
        }), this._sceneDesignManager.setCustomizerGrids(this._grids), this._sceneDesignManager.setEventMessages(this._designEventMessages);
        for (const n of this._designNotifyMessageListeners)
          this._sceneDesignManager.addNotifyMessageListener(n);
        for (const n of this._designRemoveMessageListeners)
          this._sceneDesignManager.addRemoveMessageListener(n);
        await this._sceneDesignManager.refreshAsync();
      }
      this.updateHighlightLayerExcludedDesignMeshes(), this.setLongRenderingNeeded();
    }
    console.log("[renderDesignAsync] END");
  }
  resetDesign() {
    this._scene && this._zkScene && this._zkModel && (this._sceneDesignManager && (this._sceneDesignManager.dispose(), this._sceneDesignManager = null), this.updateHighlightLayerExcludedDesignMeshes(), this.setLongRenderingNeeded());
  }
  clearMeshDesignManagers() {
    this._sceneDesignManager && this._sceneDesignManager.clearMeshDesignManagers();
  }
  async refreshMeshesDesignAsync(e, t) {
    e && Object.prototype.toString.call(e) === "[object Array]" && e.forEach(async (n) => await this.refreshMeshDesignAsync(n.id, void 0, t || void 0));
  }
  async refreshMeshDesignAsync(e, t = 0, n) {
    var a;
    (a = this._sceneDesignManager) == null || a.refreshMeshDesignAsync(e, t, n);
  }
  setCustomizerGrids(e) {
    var t;
    this._grids = e, (t = this._sceneDesignManager) == null || t.setCustomizerGrids(e);
  }
  removeDesignItem(e, t) {
    var n;
    t == null || t.deselectAll(), t == null || t.removeItemByGuid(e), t == null || t.updateSelectionState(), (n = this._sceneDesignManager) == null || n.removeItem(e);
  }
  addDesignItemText(e, t, n) {
    var a;
    return n ? n.addTextElement(null, e, !1) : (a = this._sceneDesignManager) == null ? void 0 : a.addItemText(e, t);
  }
  async addDesignItemImage(e, t, n) {
    var o;
    return n ? await n.insertImageById(e) : await ((o = this._sceneDesignManager) == null ? void 0 : o.addItemImage(e, t));
  }
  getDesignItemsInfo(e) {
    var t;
    return ((t = this._sceneDesignManager) == null ? void 0 : t.getItemsInfo(e)) || [];
  }
  setDesignItemText(e, t, n) {
    var a;
    (a = this._sceneDesignManager) == null || a.setItemText(e, t), n == null || n.modifyTextElementContentByGuid(e, t);
  }
  /**
   * Get font weights from font variations - same logic as MeshDesignManager
   */
  getFontWeights(e) {
    let t = e.faces.map((V) => V.variation), n = t.filter((V) => V.startsWith("i")).map((V) => parseInt(V.charAt(V.length - 1)) * 100), a = t.filter((V) => V.startsWith("n")).map((V) => parseInt(V.charAt(V.length - 1)) * 100), o = a.filter((V) => V <= 500).sort((V, M) => M - V)[0], h = n.filter((V) => V <= 500).sort((V, M) => M - V)[0], f = a.filter((V) => V == 700), v = (f.length ? f : a.filter((V) => V > 500)).sort((V, M) => V - M)[0], x = n.filter((V) => V == v);
    x = x.length ? x : n.filter((V) => V == 700);
    let k = (x.length ? x : n.filter((V) => V > 500)).sort((V, M) => V - M)[0];
    const I = [];
    return o && I.push({ style: "normal", weight: o }), v && I.push({ style: "normal", weight: v }), h && I.push({ style: "italic", weight: h }), k && I.push({ style: "italic", weight: k }), I;
  }
  setDesignItemBold(e, t, n, a) {
    var o;
    (o = this._sceneDesignManager) == null || o.setItemBold(e, t, n);
  }
  setDesignItemItalic(e, t, n, a) {
    var o;
    (o = this._sceneDesignManager) == null || o.setItemItalic(e, t, n);
  }
  setDesignItemColor(e, t, n) {
    var a;
    (a = this._sceneDesignManager) == null || a.setItemColor(e, t), n == null || n.modifyTextElementFillColorByGuid(e, t);
  }
  setDesignItemFontFamily(e, t, n) {
    var a;
    (a = this._sceneDesignManager) == null || a.setItemFontFamily(e, t), n == null || n.modifyTextElementFontFamilyByGuid(e, t);
  }
  setDesignItemFontWeight(e, t, n, a) {
    let o = a == null ? void 0 : a.findItemByGuid(e);
    if (!o || !a || !n)
      return;
    let f = a.getTextItemInfo(o).fontWeight.split(" "), v = f.includes("italic"), x = !1;
    for (let V of f) {
      let M = parseInt(V);
      if (!isNaN(M)) {
        x = M > 500;
        break;
      }
    }
    const k = this.getFontWeights(n);
    let I;
    if (v) {
      const V = k.filter((M) => M.style === "italic");
      if (V.length === 0) {
        v = !1;
        const M = k.filter((W) => W.style === "normal");
        if (x) {
          const W = M.filter((U) => U.weight > 500).sort((U, Q) => U.weight - Q.weight)[0];
          I = W == null ? void 0 : W.weight;
        } else {
          const W = M.filter((U) => U.weight <= 500).sort((U, Q) => Q.weight - U.weight)[0];
          I = W == null ? void 0 : W.weight;
        }
      } else if (x) {
        const M = V.filter((W) => W.weight > 500).sort((W, U) => W.weight - U.weight)[0];
        I = M == null ? void 0 : M.weight;
      } else {
        const M = V.filter((W) => W.weight <= 500).sort((W, U) => U.weight - W.weight)[0];
        I = M == null ? void 0 : M.weight;
      }
    } else {
      const V = k.filter((M) => M.style === "normal");
      if (x) {
        const M = V.filter((W) => W.weight > 500).sort((W, U) => W.weight - U.weight)[0];
        I = M == null ? void 0 : M.weight;
      } else {
        const M = V.filter((W) => W.weight <= 500).sort((W, U) => U.weight - W.weight)[0];
        I = M == null ? void 0 : M.weight;
      }
    }
    if (I !== void 0) {
      let V = v ? `italic ${I}` : I.toString();
      a.modifyTextElementFontWeight(o, V);
    }
  }
  async setDesignItemImage(e, t, n) {
    var a;
    await ((a = this._sceneDesignManager) == null ? void 0 : a.setItemImage(e, t)), n == null || n.replaceImageByGuid(e, t);
  }
  setItemTextOnPath(e, t, n, a) {
    var h;
    (h = this._sceneDesignManager) == null || h.setItemTextOnPath(e, t, n);
    let o = a == null ? void 0 : a.findItemByGuid(e);
    n ? a == null || a.convertToTextOnPath(o) : a == null || a.convertToTextArea(o);
  }
  removeDesignItemImage(e, t) {
    var n;
    t == null || t.deselectAll(), t == null || t.removeImageByGuid(e), t == null || t.updateSelectionState(), (n = this._sceneDesignManager) == null || n.removeItemImage(e);
  }
  async setDesignItemSize(e, t, n, a) {
    var o;
    a && await a.setItemSize(e, t, n), await ((o = this._sceneDesignManager) == null ? void 0 : o.setItemSize(e, t, n));
  }
  setDesignItemConstraints(e, t, n) {
    var a;
    (n == null ? void 0 : n.setItemConstraints(e, t)) ?? ((a = this._sceneDesignManager) == null || a.setItemConstraints(e, t));
  }
  setDesignPrintingMethod(e, t, n) {
    var a;
    (n == null ? void 0 : n.setDesignPrintingMethod(e, t)) ?? ((a = this._sceneDesignManager) == null || a.setDesignPrintingMethod(e, t));
  }
  setDesignVisibility(e, t) {
    var n;
    (n = this._sceneDesignManager) == null || n.setDesignVisibility(e, t);
  }
  setupShaderMaterialsCameraPosition() {
    if (this._scene)
      for (let e = 0; e < this._scene.materials.length; e++) {
        const t = this._scene.materials[e];
        this.setupShaderMaterialCameraPosition(t);
      }
  }
  setupShaderMaterialCameraPosition(e) {
    this._scene && this._scene.activeCamera && e && e instanceof BABYLON.ShaderMaterial && e.setVector3("cameraPosition", this._scene.activeCamera.position);
  }
  setMeshLocation(e) {
    this._meshLocationsManager && this._meshLocationsManager.setMeshLocationByID(e);
  }
  async explodeMeshes() {
    this._meshLocationsManager && await this._meshLocationsManager.explodeMeshes();
  }
  async collapseMeshes() {
    this._meshLocationsManager && await this._meshLocationsManager.collapseMeshes();
  }
  dracoDecodingFunction(e, t, n) {
    this.decodeDracoFile(e, t, n);
  }
  decodeDracoFile(e, t, n) {
    var a = (/* @__PURE__ */ new Date()).getTime(), o = new Uint8Array(t), h = msgpack.decode(o);
    this.dracoCompression.decodeMeshAsync(h.data, h.attributes).then(function(f) {
      let v = {};
      f && (f.indices && (v.indices = f.indices), f.positions && (v.positions = f.positions), f.normals && (v.normals = f.normals), f.tangents && (v.tangents = f.tangents), f.uvs && (v.uvs = f.uvs), f.uvs2 && (v.uv2s = f.uvs2), f.uvs3 && (v.uv3s = f.uvs3), f.uvs4 && (v.uv4s = f.uvs4), f.uvs5 && (v.uv5s = f.uvs5), f.uvs6 && (v.uv6s = f.uvs6));
      var x = /* @__PURE__ */ new Date(), k = x.getTime(), I = k - a, V = x.getHours() + ":" + x.getMinutes() + ":" + x.getSeconds() + "." + x.getMilliseconds();
      console.log(
        "Draco Decoding [" + V + "] - " + e + "	" + t.byteLength + "	" + I + " ms"
      ), n && n(v);
    });
  }
  exportSceneToBabylon() {
    return !this._zkScene || !this._sceneHelper ? null : this._sceneHelper.exportSceneToBabylon();
  }
  exportVisibleMeshesToBabylon() {
    return !this._zkScene || !this._sceneHelper ? null : this._sceneHelper.exportVisibleMeshesToBabylon();
  }
  async exportMeshesForTyOnToBabylon() {
    return !this._zkScene || !this._sceneHelper ? null : await this._sceneHelper.exportMeshesForTyOnToBabylon();
  }
  async exportMeshToBabylon(e) {
    if (!this._scene || !this._zkScene || !this._sceneHelper)
      return null;
    const t = this._scene.getMeshById(e);
    return t ? await this._sceneHelper.exportMeshToBabylon(t) : null;
  }
  async downloadMeshToBabylon(e) {
    if (!this._scene || !this._zkScene || !this._sceneHelper)
      return;
    const t = this._scene.getMeshById(e);
    t && await this._sceneHelper.downloadMeshBabylonAsync(t);
  }
  async saveSceneOnDatabaseAsync(e) {
    const t = this.exportSceneToBabylon();
    if (t) {
      const n = new Uf();
      await n.openAsync(), await n.saveFileAsync(e, t);
    }
  }
  async saveVisibleMeshesOnDatabaseAsync(e) {
    const t = await this.exportMeshesForTyOnToBabylon();
    if (t) {
      const n = new Uf();
      await n.openAsync(), await n.saveFileAsync(e, t);
    }
  }
  async saveGlbOnDatabaseAsync(e) {
    let t = null, n = "";
    if (t = await this.exportSceneToLocalGLBAsync(), t) {
      const a = await t.arrayBuffer(), o = Math.random().toString(36).substring(7), h = new FormData();
      h.append("blob", new Blob([a]), `model_${o}.glb`);
      try {
        const f = await fetch(Zakeke.config.baseApiUrl + "tryonassetupload/asset-upload", {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + window.token
          },
          body: h
        });
        if (f.status === 200)
          return n = await f.text(), n = n.replace(/^"|"$/g, "").substring(n.indexOf("fileUrl=") + 8 - 1), console.log("solo parametro restituito da asset-upload", n), n;
        console.error("Error uploading model", f);
      } catch (f) {
        console.error("Error uploading model", f);
      }
    }
    return n;
  }
  getArFileUrlCacheKey(e, t, n = "usdz") {
    let a = "scene_" + e;
    if (t && (a += "_code_" + t), this._sceneDesignManager) {
      var o = this._sceneDesignManager.getDesignItemsJson();
      if (o) {
        var h = CryptoJS.SHA1(o).toString();
        a += "_design_" + this._sceneDesignManager.getDesignID() + "_" + h;
      }
    }
    return a += "_" + n, a;
  }
  getCachedArFileUrl(e, t, n = "usdz") {
    var a = this.getArFileUrlCacheKey(e, t, n);
    return this._arFileUrls.hasOwnProperty(a) ? this._arFileUrls[a] : null;
  }
  cacheArFileUrl(e, t, n, a) {
    if (a) {
      var o = this.getArFileUrlCacheKey(e, t || void 0, n);
      this._arFileUrls[o] = a;
    }
  }
  async exportMeshToGLBBlob(e) {
    var o, h, f, v;
    if (!this._scene || !this._zkScene || !this._sceneHelper)
      return null;
    let t = null;
    const n = this._zkScene.get("rootUrl");
    n && (t = n), await ((o = this._sceneDesignManager) == null ? void 0 : o.changeToRasterizedTextures()), (h = this._sceneDesignManager) == null || h.expandCanvasMeshes(0.05);
    let a = await this._sceneHelper.exportMeshToGLBBlob(t, e);
    return console.log("dopo l'export faccio rientrare l'expand", a), (f = this._sceneDesignManager) == null || f.expandCanvasMeshes(-0.05), await ((v = this._sceneDesignManager) == null ? void 0 : v.changeToDynamicTextures()), a;
  }
  async exportSceneToUsdzAsync(e, t, n) {
    var k, I, V, M;
    if (!this._zkScene || !this._sceneHelper)
      return null;
    const a = "usdz";
    let o = null;
    if (e && (!this._sceneDesignManager || n) && (o = this.getCachedArFileUrl(e, t, a)), o)
      return o;
    let h = null, f = null;
    const v = this._zkScene.get("name");
    v && (h = v);
    const x = this._zkScene.get("rootUrl");
    return x && (f = x), await ((k = this._sceneDesignManager) == null ? void 0 : k.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), o = await this._sceneHelper.exportSceneToUsdzAsync(
      h,
      f,
      this._sceneDesignManager && !n ? void 0 : e,
      this._sceneDesignManager && !n ? void 0 : t,
      ((I = this.zkScene) == null ? void 0 : I.getARMeshSize()) ?? null,
      this.getDAMMainMesh() ?? null,
      (V = this._zkScene) == null ? void 0 : V.getARScale()
    ), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((M = this._sceneDesignManager) == null ? void 0 : M.changeToDynamicTextures()), o && e && !this._sceneDesignManager && this.cacheArFileUrl(e, t || null, a, o), o;
  }
  async exportMeshToUsdzAsync(e) {
    var n, a, o;
    const t = this.getMeshByID(e);
    if (t && this._zkScene && this._sceneHelper) {
      let h = null;
      const f = this._zkScene.get("rootUrl");
      f && (h = f), await ((n = this._sceneDesignManager) == null ? void 0 : n.changeToRasterizedTextures());
      const v = await this._sceneHelper.exportMeshToUsdzAsync(
        h,
        t,
        ((a = this.zkScene) == null ? void 0 : a.getARMeshSize()) ?? null,
        this.getDAMMainMesh() ?? null,
        this.getARScale()
      );
      return await ((o = this._sceneDesignManager) == null ? void 0 : o.changeToDynamicTextures()), Logger.info("USDZ: " + v), v;
    }
    return null;
  }
  async exportSceneToRemoteGlTFAsync(e, t, n) {
    var v, x, k, I;
    if (!this._sceneHelper)
      return null;
    const a = "glTF";
    let o = null;
    if (e && (!this._sceneDesignManager || n) && (o = this.getCachedArFileUrl(e, t, a)), o)
      return o;
    let h = null, f = null;
    if (this._zkScene) {
      const V = this._zkScene.get("name");
      V && (h = V);
      const M = this._zkScene.get("rootUrl");
      M && (f = M);
    }
    return await ((v = this._sceneDesignManager) == null ? void 0 : v.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), o = await this._sceneHelper.exportSceneToRemoteGlTFAsync(
      h,
      f,
      this._sceneDesignManager && !n ? void 0 : e,
      this._sceneDesignManager && !n ? void 0 : t,
      ((x = this.zkScene) == null ? void 0 : x.getARMeshSize()) ?? null,
      this.getDAMMainMesh() ?? null,
      (k = this._zkScene) == null ? void 0 : k.getARScale()
    ), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((I = this._sceneDesignManager) == null ? void 0 : I.changeToDynamicTextures()), o && e && !this._sceneDesignManager && this.cacheArFileUrl(e, t || null, a, o), Logger.info("GlTF: " + o), o;
  }
  async exportMeshToRemoteGlTFAsync(e) {
    var n, a, o;
    const t = this.getMeshByID(e);
    if (t && this._zkScene && this._sceneHelper) {
      let h = null;
      const f = this._zkScene.get("rootUrl");
      f && (h = f), await ((n = this._sceneDesignManager) == null ? void 0 : n.changeToRasterizedTextures());
      const v = await this._sceneHelper.exportMeshToRemoteGlTFAsync(
        h,
        t,
        ((a = this.zkScene) == null ? void 0 : a.getARMeshSize()) ?? null,
        this.getDAMMainMesh() ?? null,
        this.getARScale()
      );
      return Logger.info("GlTF: " + v), await ((o = this._sceneDesignManager) == null ? void 0 : o.changeToDynamicTextures()), v;
    }
    return null;
  }
  async exportSceneToRemoteGLBAsync(e, t, n) {
    var v, x, k, I;
    if (!this._sceneHelper)
      return null;
    const a = "glb";
    let o = null;
    if (e && (!this._sceneDesignManager || n) && (o = this.getCachedArFileUrl(e, t, a)), o)
      return o;
    let h = null, f = null;
    if (this._zkScene) {
      const V = this._zkScene.get("name");
      V && (h = V);
      const M = this._zkScene.get("rootUrl");
      M && (f = M);
    }
    return await ((v = this._sceneDesignManager) == null ? void 0 : v.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), o = await this._sceneHelper.exportSceneToRemoteGLBAsync(
      h,
      f,
      this._sceneDesignManager && !n ? void 0 : e,
      this._sceneDesignManager && !n ? void 0 : t,
      ((x = this.zkScene) == null ? void 0 : x.getARMeshSize()) ?? null,
      this.getDAMMainMesh() ?? null,
      (k = this._zkScene) == null ? void 0 : k.getARScale()
    ), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((I = this._sceneDesignManager) == null ? void 0 : I.changeToDynamicTextures()), o && e && !this._sceneDesignManager && this.cacheArFileUrl(e, t || null, a, o), Logger.info("GLB: " + o), o;
  }
  async exportMeshToRemoteGLBAsync(e) {
    var n, a, o;
    const t = this.getMeshByID(e);
    if (t && this._zkScene && this._sceneHelper) {
      let h = null;
      const f = this._zkScene.get("rootUrl");
      f && (h = f), await ((n = this._sceneDesignManager) == null ? void 0 : n.changeToRasterizedTextures());
      const v = await this._sceneHelper.exportMeshToRemoteGLBAsync(
        h,
        t,
        ((a = this.zkScene) == null ? void 0 : a.getARMeshSize()) ?? null,
        this.getDAMMainMesh() ?? null,
        this.getARScale()
      );
      return Logger.info("GlTF: " + v), await ((o = this._sceneDesignManager) == null ? void 0 : o.changeToDynamicTextures()), v;
    }
    return null;
  }
  // Esporta la scena nei formati glb e usdz utili per visualizzarli con model-viewer
  // il formato png viene richiesto per ottenere un poster del modello da visualizzare inizialmente
  async exportSceneToARAsync(e, t) {
    var h, f;
    let n = [];
    if (!this._sceneHelper)
      return n;
    let a = null, o = null;
    if (this._zkScene) {
      const v = this._zkScene.get("name");
      v && (a = v);
      const x = this._zkScene.get("rootUrl");
      x && (o = x);
    }
    return await ((h = this._sceneDesignManager) == null ? void 0 : h.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), n = await this._sceneHelper.exportSceneToARMultiformatAsync(
      a,
      o,
      ["usdz", "glb"],
      e,
      t
    ), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((f = this._sceneDesignManager) == null ? void 0 : f.changeToDynamicTextures()), n;
  }
  // Esporta la mesh nei formati glb e usdz utili per visualizzarli con model-viewer
  // il formato png viene richiesto per ottenere un poster del modello da visualizzare inizialmente
  async exportMeshToARAsync(e) {
    var a, o, h;
    let t = [];
    const n = this.getMeshByID(e);
    if (n && this._zkScene && this._sceneHelper) {
      let f = null;
      const v = this._zkScene.get("rootUrl");
      v && (f = v), await ((a = this._sceneDesignManager) == null ? void 0 : a.changeToRasterizedTextures()), t = await this._sceneHelper.exportMeshToARMultiformatAsync(
        f,
        n,
        ["usdz", "glb"],
        ((o = this.zkScene) == null ? void 0 : o.getARMeshSize()) ?? null,
        this.getDAMMainMesh() ?? null,
        this.getARScale()
      ), await ((h = this._sceneDesignManager) == null ? void 0 : h.changeToDynamicTextures());
    }
    return t;
  }
  isAREnabled() {
    if (!this._zkScene)
      return !1;
    let e = this._zkScene.getAREnabled();
    return e != null && e && this._sceneHelper != null && // this._sceneHelper.getMeshesForAR().length > 0 &&
    this._sceneHelper.checkMaterialsForAR();
  }
  async exportSceneToLocalGLBAsync() {
    var t, n;
    await ((t = this._sceneDesignManager) == null ? void 0 : t.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes();
    let e = null;
    return this._sceneHelper && (e = await this._sceneHelper.exportSceneToLocalGLBBlobAsync()), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((n = this._sceneDesignManager) == null ? void 0 : n.changeToDynamicTextures()), e;
  }
  async downloadSceneLocalGLBAsync() {
    this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), this._sceneHelper && await this._sceneHelper.downloadSceneLocalGLBAsync(), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes();
  }
  async exportSceneToLocalUSDZAsync() {
    var t, n;
    await ((t = this._sceneDesignManager) == null ? void 0 : t.changeToRasterizedTextures()), this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes();
    let e = null;
    return this._sceneHelper && (e = await this._sceneHelper.exportSceneToLocalUSDZUrlAsync()), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes(), await ((n = this._sceneDesignManager) == null ? void 0 : n.changeToDynamicTextures()), e;
  }
  async downloadSceneLocalUSDZAsync() {
    this._sceneDesignManager && this._sceneDesignManager.expandCanvasMeshes(), this._sceneHelper && await this._sceneHelper.downloadSceneLocalUSDZAsync(), this._sceneDesignManager && this._sceneDesignManager.contractCanvasMeshes();
  }
  getSceneRootUrl() {
    return new Promise((e, t) => {
      let n = null;
      this._zkScene ? (n = this._zkScene.get("rootUrl") || null, n ? e(n) : jQuery.ajax({
        url: this._zkScene.getSceneRootUrlApiUrl(),
        type: "GET",
        success: function(a) {
          n = a, e(n);
        },
        error: function(a, o, h) {
          t(h);
        }
      })) : e(n);
    });
  }
  isTryOnMeshVisibleEnabledToShow() {
    const e = this.getVisibleMeshes();
    for (const t of e) {
      const n = t.getChildren();
      if (n.length > 0 && n.find(
        (o) => this._sceneHelper.isTryOnEnabledForMesh(o)
      ) && this._sceneHelper.isTryOnEnabledForMesh(t))
        return !0;
    }
    return !1;
  }
  getTryOnMeshVisible() {
    const e = this.getVisibleMeshes();
    for (let t of e) {
      const n = t.getChildren();
      if (n.length > 0 && !t.parent && n.find(
        (o) => {
          var h;
          return (h = this._sceneHelper) == null ? void 0 : h.isTryOnEnabledForMesh(o);
        }
      ))
        return t;
    }
    return null;
  }
  getFrameDAMSettings() {
    if (this._zkScene) {
      const e = this._zkScene.getFrameDAMSettings() ?? null;
      if (e)
        return JSON.parse(e);
    }
    return null;
  }
  getMeshFineTuningData(e) {
    const t = typeof e == "string" ? this.getMeshByID(e) : e;
    return t && t.metadata && t.metadata.tryOnFineTuningSettings ? t.metadata.tryOnFineTuningSettings : null;
  }
  getDAMFineTuningData() {
    var e, t;
    return (e = this.zkScene) != null && e.getFrameDAMSettings() && ((t = this.getFrameDAMSettings()) == null ? void 0 : t.finetuning) || null;
  }
  getTryOnFineTuningMeshVisible() {
    var t;
    const e = this.getVisibleMeshes();
    for (const n of e) {
      const a = n.getChildren();
      if (a.length > 0 && a.find(
        (h) => {
          var f;
          return (f = this._sceneHelper) == null ? void 0 : f.isTryOnEnabledForMesh(h);
        }
      ) && (t = n == null ? void 0 : n.metadata) != null && t.tryOnFineTuningSettings)
        return n;
    }
    return null;
  }
  refreshInfoPoints() {
    if (!(this._zkScene && this._zkScene.getInfoPointsEnabled() && this.canShowInfoPoints)) {
      this.disposeInfoPointsManager(), this.setLongRenderingNeeded();
      return;
    }
    const t = this.getInfoPointsManagerStyle();
    let n = null;
    this._infoPointsManager || this._scene && this._zkScene && (this._infoPointsManager = new xw(this._zkScene, this._scene, t), this._infoPointPickedListeners && this._infoPointPickedListeners.length > 0 && this._infoPointsManager.addInfoPointPickedListenerRange(this._infoPointPickedListeners), this._infoPointContentShownListeners && this._infoPointContentShownListeners.length > 0 && this._infoPointsManager.addInfoPointContentShownListenerRange(this._infoPointContentShownListeners), this._infoPointContentHiddenListeners && this._infoPointContentHiddenListeners.length > 0 && this._infoPointsManager.addInfoPointContentHiddenListenerRange(
      this._infoPointContentHiddenListeners
    ), this._infoPointsManager.onBeforeShowImages = () => {
      n === null && (n = this.antiAliasConfig.enabled), this.antiAliasConfig.enabled = !1, this.disableAntialiasing();
    }, this._infoPointsManager.onAfterShowImages = () => {
      this.antiAliasConfig.enabled = n, n = null, this.enableAntialiasing(), this.setLongRenderingNeeded();
    }, this._infoPointsManager.addRenderingNeededListener(() => this.setRenderingNeeded())), this._infoPointsManager && (this.updateInfoPointsManagerStyle(), this._infoPointsManager.canShowInfoPointsContent = this.canShowInfoPointsContent, this._infoPointsManager.refresh()), this.setLongRenderingNeeded();
  }
  getInfoPointsManagerStyle() {
    const e = this._infoPointsManagerStyle ? this._infoPointsManagerStyle : {};
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsStyleConfig();
      t && (e.infoPointsStyle || (e.infoPointsStyle = {}), t.get("borderColor") && (e.infoPointsStyle.borderColor = t.get("borderColor")), t.get("innerPointColor") && (e.infoPointsStyle.innerPointColor = t.get("innerPointColor")), t.get("color") && (e.infoPointsStyle.color = t.get("color")), t.get("highlightColor") && (e.infoPointsStyle.highlightColor = t.get("highlightColor")));
    }
    return e;
  }
  updateInfoPointsManagerStyle() {
    if (this._infoPointsManager) {
      const e = this.getInfoPointsManagerStyle();
      this._infoPointsManager.applyStyle(e);
    }
  }
  showInfoPoints() {
    this._infoPointsManager && (this._infoPointsManager.showInfoPoints(), this.render(), this.setRenderingNeeded());
  }
  hideInfoPoints() {
    this._infoPointsManager && (this._infoPointsManager.hideInfoPoints(), this.render(), this.setRenderingNeeded());
  }
  // try to reload all textures with loading errors
  async reloadAllLoadingErrorTexturesAsync() {
    if (this._zkScene && this._sceneHelper) {
      const e = this._zkScene.get("rootUrl");
      e && await this._sceneHelper.reloadAllLoadingErrorTexturesAsync(e);
    }
  }
  // try to reload the material textures with loading errors
  async reloadMaterialLoadingErrorTexturesAsync(e) {
    if (this._zkScene && this._sceneHelper) {
      const t = this._zkScene.get("rootUrl");
      t && await this._sceneHelper.reloadMaterialLoadingErrorTexturesAsync(t, e);
    }
  }
  // try to reload the texture having loading errors
  async reloadLoadingErrorTextureAsync(e) {
    if (this._zkScene && this._sceneHelper) {
      const t = this._zkScene.get("rootUrl");
      t && await this._sceneHelper.reloadLoadingErrorTextureAsync(t, e);
    }
  }
  // were there any loading errors for the texture?
  isTextureLoadingError(e) {
    return this._sceneHelper ? this._sceneHelper.isTextureLoadingError(e) : !1;
  }
  // the material has some texture with loading errors
  materialHasLoadingErrorTextues(e) {
    return this._sceneHelper ? this._sceneHelper.materialHasLoadingErrorTextues(e) : !1;
  }
  notifyCameraMovement() {
    if (this._isHologramSource && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      let e = this.getOrCreateBroadcastChannel();
      if (!e)
        return;
      e.postMessage({
        type: "camera-movement",
        target: { x: this._camera.target.x, y: this._camera.target.y, z: this._camera.target.z },
        alpha: this._camera.alpha,
        beta: this._camera.beta,
        radius: this._camera.radius
      });
    }
  }
  notifyScriptExecution(e) {
    if (this._isHologramSource) {
      const t = e.map((a) => ({
        attributeID: a.attributeID,
        selectedValue: a.selectedValue,
        actions: a.actions.map((o) => o.toJSON())
        /*
        actions: s.actions.map(a => ({
        	attributeGuid: a.get("actionGuid"),
        	name: a.get("name"),
        	actionTypeID: a.get("actionTypeID"),
        	sceneElementTypeID: a.get("sceneElementTypeID"),
        	selector: a.get("selector"),
        	propertyName: a.get("propertyName"),
        	value: a.get("value"),
        	execOrder: a.get("execOrder"),
        	deviceTypes: a.get("deviceTypes")
        }))
        */
      }));
      let n = this.getOrCreateBroadcastChannel();
      if (!n)
        return;
      n.postMessage({
        type: "script-execution",
        script: t
      });
    }
  }
  notifyDesignChanged(e) {
    if (this._isHologramSource) {
      let t = this.getOrCreateBroadcastChannel();
      if (!t)
        return;
      t.postMessage({
        type: "design-changed",
        design: e.toJSON()
      });
    }
  }
  notifyActionExecution(e, t, n) {
    this.notifyScriptExecution([
      {
        attributeID: e,
        selectedValue: t,
        actions: n
      }
    ]);
  }
  attachBroadcastChannelEventHandlers() {
    if (this._isHologram && !this._isHologramSource) {
      var e = this.getOrCreateBroadcastChannel();
      if (!e)
        return;
      e.onmessage = (t) => this.onBroadcastMessageReceived(t);
    }
  }
  detachBroadcastChannelEventHandlers() {
    this._broadcastChannel && (this._broadcastChannel.onmessage = null);
  }
  onBroadcastMessageReceived(e) {
    this._isHologram && e && e.data && e.data.type && (e.data.type === "camera-movement" ? this.processCameraMovementEvent(e) : e.data.type === "script-execution" ? this.processScriptExecution(e) : e.data.type === "design-changed" && this.processDesignChanged(e));
  }
  processCameraMovementEvent(e) {
    this._camera && this._camera instanceof BABYLON.ArcRotateCamera && e && e.data && (this._camera.target = new BABYLON.Vector3(e.data.target.x, e.data.target.y, e.data.target.z), this._camera.alpha = e.data.alpha, this._camera.beta = e.data.beta, this._camera.radius = e.data.radius, this.setRenderingNeeded());
  }
  processScriptExecution(e) {
    if (e && e.data && e.data.script && Object.prototype.toString.call(e.data.script) === "[object Array]") {
      var t = e.data.script.map(
        (n) => ({
          attributeID: n.attributeID,
          selectedValue: n.selectedValue,
          actions: n.actions.map((a) => new MPlaza.AttributeSceneAction(a))
        })
      );
      this.executeScriptAsync(t);
    }
  }
  processDesignChanged(e) {
    if (e && e.data && e.data.design) {
      let t = new MPlaza.Design(e.data.design);
      this.renderDesignAsync(t);
    }
  }
  loadSceneConfig(e) {
    const t = new Zakeke.SceneConfig(e);
    if (this._zkScene && !this._zkScene.get("config"))
      this._zkScene.set("config", t);
    else {
      const n = new Zakeke.Scene();
      n.set("config", t), this._zkScene = n;
    }
    this.checkSceneShaderMaterials(this._zkScene);
  }
  updateFromConfig(e, t) {
    var n, a;
    if (this._zkScene) {
      let o = (a = (n = this._zkScene) == null ? void 0 : n.get("config")) == null ? void 0 : a.toJSON();
      const h = Lw.merge(o, e), f = new Zakeke.SceneConfig(h);
      if (this._zkScene.set("config", f), (t == null ? void 0 : t.preventRefresh) === !0)
        return;
      this.setupSceneAsync((t == null ? void 0 : t.updateCamera) === !0);
    }
  }
  /**
   * Set up new camera position if parameter is present in config
   */
  refreshCameraPosition() {
    var n, a, o;
    const e = (a = (n = this._zkScene) == null ? void 0 : n.get("config")) == null ? void 0 : a.toJSON(), t = e == null ? void 0 : e.camera;
    t && (t != null && t.position) && ((o = this._sceneHelper) == null || o.setUpCameraByOptions(t.position));
  }
  setupDebugGUI() {
    var n;
    const e = (n = this._zkScene) == null ? void 0 : n.get("config"), t = (a) => {
      this.updateFromConfig(a, { updateCamera: !1 });
    };
    this._createGui = new n1(
      e.toJSON(),
      (a) => t(a),
      this._sceneHelper
    ), this._createGui.setupGui(this._scene);
  }
  async setUpEmptyScene(e) {
    this._scene && (e && this.loadSceneConfig(e), await this.setupSceneAsync(), this.setRenderingNeeded());
  }
  /**
   * Loads a babylon scene from a remote URL.
   * @param rootUrl The root URL of the scene.
   * @param sceneFileName The name of the scene file.
   * @param sceneConfig Optional scene configuration.
   */
  async loadFromSceneUrl(e, t, n) {
    await this.loadSceneFromRemoteFilesAsync(e, t), n && this.loadSceneConfig(n), await this.setupSceneAsync(), this.setRenderingNeeded();
  }
  stopAllAnimations() {
    this._scene && this._sceneHelper && this._sceneHelper.stopAllAnimations();
  }
  hasAnimations() {
    return this._scene && this._sceneHelper ? this._sceneHelper.hasAnimations() : !1;
  }
  playAnimations() {
    this._scene && this._sceneHelper && this._sceneHelper.playAnimations();
  }
  // al momento Marco FF ha detto che non serve esposto
  // public setupAnimations () {
  // 	if (this._scene && this._sceneHelper) {
  // 		this._sceneHelper.setupAnimations(this._zkScene);
  // 	}
  // }
  /**
   * Loads a scene from a GLB file URL.
   * @param url The URL of the GLB file.
   * @param sceneConfig Optional scene configuration.
   */
  async loadFromGlbUrl(e, t) {
    var a, o, h;
    const n = ((a = t == null ? void 0 : t.camera) == null ? void 0 : a.animateIntro) !== void 0 ? (o = t == null ? void 0 : t.camera) == null ? void 0 : o.animateIntro : !0;
    await ((h = this._sceneHelper) == null ? void 0 : h.importMeshesFromUrlAsync(e, null, void 0, n, ".glb", this._isViewer)), t && this.loadSceneConfig(t), await this.setupSceneAsync(), this.updateView(!1, !0);
  }
  /**
   * Loads a scene from a file.
   * @param file The file to load the scene from.
   */
  async loadFromFile(e, t) {
    var n, a;
    ((n = t == null ? void 0 : t.camera) == null ? void 0 : n.animateIntro) !== void 0 && ((a = t == null ? void 0 : t.camera) == null || a.animateIntro);
    try {
      await BABYLON.SceneLoader.AppendAsync(e.name, e, this._scene);
    } catch (o) {
      console.log("dropObjectIntoScene: ", o);
    }
    t && this.loadSceneConfig(t), await this.setupSceneAsync(), this.updateView(!0, !0), this.setRenderingNeeded();
  }
  async showResizableCanvasModel(e) {
    if (this._scene && this._zkScene && this._zkModel && this._sceneHelper) {
      const t = await this._sceneHelper.showResizableCanvas(
        e.width,
        e.height,
        e.depth,
        e.borderRadius,
        e.type,
        e.borderColor,
        e.columns,
        e.rows,
        e.ppcm,
        e.backgroundColor,
        e.backgroundUrl,
        e.shape
      );
      if (!t)
        return { meshes: [], matrixJson: "" };
      const n = new Pw.PaperScope();
      n.setup(new n.Size(1, 1));
      const a = new n.Matrix(), o = Xd.DEFAULT_SIZE;
      a.translate(o / 2, o / 2), a.scale(o / e.width, o / e.height);
      const h = JSON.stringify(a.values);
      return { meshes: t, matrixJson: h };
    }
    return { meshes: [], matrixJson: "" };
  }
  async showResizableCanvasPerCurrentSide(e) {
    console.log("showResizableCanvasPerCurrentSide", e);
    const t = `resizable-canvas-${e.width}-${e.height}-${e.colorId}-${e.currentSideId}-${e.columns}-${e.rows}-${e.type}-${e.borderColor}`;
    if (this._lastResizableMeshID === t)
      return;
    this._lastResizableMeshID = t;
    const n = await this.showResizableCanvasModel(e);
    if (n.meshes.length === 0)
      return;
    const a = this._zkModel.get("scenes").at(0).get("meshSides");
    a.filter((v) => v.get("isResizable")).forEach((v) => a.remove(v));
    const h = e.type === "mirrored" ? ["front", "borders"] : ["front"];
    let f = 0;
    for (const v of n.meshes)
      if (v && h.includes(v.name)) {
        v.id = t.replace("sideIdPlaceholder", e.currentSideId.toString()) + f++;
        const x = new MPlaza.ModelSceneMeshSide({
          sideID: e.currentSideId,
          meshID: v.id,
          uvChannel: 0,
          percWidth: 1,
          percHeight: 1,
          subMeshID: 0,
          matrix: n.matrixJson,
          isResizable: !0
        });
        a.push(x);
      }
    console.log({ meshSides: a }), setTimeout(() => this.adjustCamera(!1), 100);
  }
  async showResizableCanvasPerVariant(e) {
    if (console.log("showResizableCanvasPerVariant", e), !this.zkModel)
      return;
    const t = `resizable-canvas-${e.width}-${e.height}-${e.colorId}-sideIdPlaceholder-${e.columns}-${e.rows}-${e.type}-${e.borderColor}`;
    if (this._lastResizableMeshID === t)
      return;
    this._lastResizableMeshID = t;
    const n = await this.showResizableCanvasModel(e);
    if (n.meshes.length === 0)
      return;
    let a = 0;
    const o = e.sidesIds.length > 1;
    let h = ["front", "back", "borders"];
    e.type === "none" || e.type === "colored" ? o ? h = ["front", "back"] : h = ["front"] : e.type === "mirrored" && (o ? h = ["front", "back", "borders"] : h = ["front", "borders"]);
    const f = this._zkModel.get("scenes").at(0).get("meshSides");
    f.filter((x) => x.get("isResizable")).forEach((x) => f.remove(x));
    for (const x of n.meshes)
      if (x && h.includes(x.name)) {
        const k = !o || x.name === "front" ? e.sidesIds[0] : e.sidesIds[1];
        x.id = t.replace("sideIdPlaceholder", k.toString()) + a++;
        const I = new MPlaza.ModelSceneMeshSide({
          sideID: k,
          meshID: x.id,
          uvChannel: 0,
          percWidth: 1,
          percHeight: 1,
          subMeshID: 0,
          matrix: n.matrixJson,
          isResizable: !0
        });
        f.push(I);
      }
    setTimeout(() => this.adjustCamera(!1), 100);
  }
  clearResizableProduct() {
    var e;
    (e = this._sceneHelper) == null || e.clearResizableMeshes();
  }
  setMouseWheelInputEnabled(e) {
    this._camera && this._mouseWheelInput && (e ? this._camera.inputs.add(this._mouseWheelInput) : this._camera.inputs.remove(this._mouseWheelInput));
  }
  setCameraPinchingZoom(e) {
    if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const t = this._camera.inputs.attached.pointers;
      t.pinchZoom = e, t.multiTouchPanAndZoom = e;
    }
  }
  switchMode(e) {
    var t;
    e === "upload" && (this._lastResizableMeshID = ""), (t = this._sceneHelper) == null || t.switchMode(e), setTimeout(() => this.adjustCamera(!1), 100);
  }
  async setCanvasRotation(e, t) {
    var v;
    if (e = e % 360, this._isRotating || !this._zkModel || !this._sceneHelper || !this._sceneDesignManager || this._currentRotation === e)
      return;
    const n = this._zkModel.get("scenes").at(0).get("meshSides");
    if (n.length === 0)
      return;
    const o = n.at(0).get("meshID"), h = this.getMeshByID(o);
    if (!h)
      return;
    const f = h.getFacetNormal(0);
    this._isRotating = !0, await ((v = this._sceneHelper) == null ? void 0 : v.rotate(this._currentRotation - e, f, t)), this._currentRotation = e, this._isRotating = !1, this._sceneDesignManager.rotation = this._currentRotation, await this._sceneDesignManager.refreshAsync(), this.setRenderingNeeded();
  }
  getFitToScreenMargin() {
    return this._zkScene ? this._zkScene.getFitToScreenMargin() : 1;
  }
  setFitToScreenMargin(e) {
    this._zkScene && this._zkScene.setFitToScreenMargin(e);
  }
  moveDesignItemUp(e, t) {
    var n;
    console.log("sceneViewer moveDesignItemUp", e), t ? t.moveItemUp(e) : (n = this._sceneDesignManager) == null || n.moveItemUp(e);
  }
  moveDesignItemDown(e, t) {
    var n;
    console.log("sceneViewer moveDesignItemDown", e), t ? t.moveItemDown(e) : (n = this._sceneDesignManager) == null || n.moveItemDown(e);
  }
}
class s1 {
  constructor(e) {
    this.materials = [], this.guid = Zakeke.generateUUID(), this.groupName = e;
  }
}
var a1 = /* @__PURE__ */ ((b) => (b[b.uploading = 0] = "uploading", b[b.progress = 1] = "progress", b[b.checking = 2] = "checking", b[b.success = 3] = "success", b[b.completed_success = 4] = "completed_success", b[b.completed_error = 5] = "completed_error", b))(a1 || {});
const pg = class ul extends yu {
  constructor(e) {
    super({ configPreview: !0 }), this._dracoEnabled = !0, this._dracoEncodingSpeed = 5, this._dracoDecodingSpeed = 5, this._envMode = Lr.Editor, this._selectOnPick = !0, this._showBoundingBox = !1, this._editorBackgroundColor = "#444444", this._showGround = !0, this._ground = null, this._showLights = !1, this._lightsLayer = null, this._showAxes = !1, this._axesLayer = null, this._showFineTuning = !1, this._fineTuningModelLoaded = !1, this._showHighlight = !0, this._highlightOver = !0, this._highlightOverColor = "#0082ff", this._editingMode = Za.None, this._manipulatedNode = null, this._oldManipulatedNode = null, this._EditControl = org.ssatguru.babylonjs.component.EditControl, this._editControl = null, this._editControlVisible = !1, this._shiftPressed = !1, this._ctrlPressed = !1, this._realMeshVisibility = {}, this._sceneSourceTasks = [], this._isLoadingSourceFiles = !1, this._authorizationToken = "", this._incrementalWorkersScriptsUrls = [], this._preUpdateListeners = [], this._postUpdateListeners = [], this._meshSelectedListeners = [], this._selectionChangedListeners = [], this._lightSelectedListeners = [], this._sceneCreatedListeners = [], this._cameraLocationCreatedListeners = [], this._sceneSourceTaskSuccessListeners = [], this._sceneSourceTaskErrorListeners = [], this._sceneSourceTasksCheckListeners = [], this._meshesUpdateListeners = [], this._materialsUpdateListeners = [], this._lightsUpdateListeners = [], this._cameraLocationsUpdateListeners = [], this._meshLocationCreatedListeners = [], this._meshLocationsUpdateListeners = [], this._arTaskSuccessListeners = [], this._arTaskErrorListeners = [], this._arTasksCheckListeners = [], this._tryOnFineTuningSettingListeners = [], this._tryOnFineTuningCloseListeners = [], this._pickedProvider = rg.NotSelected, this._providerData = { mesh: new Blob() }, this._sessionTryOnEnabled = !1, this._tryOnInfoLoading = !0, this._initialMeshMaterials = {}, this._initialSubMeshMaterials = {}, this._lastMeshMaterials = {}, this._lastSubMeshMaterials = {}, this._meshOver = null, this._incrementalFilesMaker = null, this._sceneToBlobs = null, this._showMeasurements = !1, this._modelMeasurements = BABYLON.Vector3.Zero(), e && (this._incrementalWorkersScriptsUrls = e.incrementalWorkersScriptsUrls, this._authorizationToken = e.authorizationToken, e.showGround != null && e.showGround != null && (this._showGround = e.showGround), e.editorBackgroundColor !== void 0 && e.editorBackgroundColor !== null && (this._editorBackgroundColor = e.editorBackgroundColor), e.showHighlight !== void 0 && e.showHighlight !== null && (this._showHighlight = e.showHighlight), e.highlightColor !== void 0 && e.highlightColor !== null && (this._highlightColor = e.highlightColor), e.highlightOver !== void 0 && e.highlightOver != null && (this._highlightOver = e.highlightOver), e.highlightOverColor !== void 0 && e.highlightOverColor != null && (this._highlightOverColor = e.highlightOverColor));
  }
  // Real mesh visibility
  get realMeshVisibility() {
    return this._realMeshVisibility;
  }
  // Environemnt manager
  get environmentManager() {
    return this._environmentManager;
  }
  // EnvMode
  get envMode() {
    return this._envMode;
  }
  // Source tasks
  get sceneSourceTasks() {
    return this._sceneSourceTasks;
  }
  set envMode(e) {
    this._envMode != e && (this._envMode = e, this.refreshEnvironment());
  }
  // SelectOnPick
  get selectOnPick() {
    return this._selectOnPick;
  }
  set seletOnPick(e) {
    this._selectOnPick != e && (this._selectOnPick = e);
  }
  // ShowBoundingBox
  get showBoundingBox() {
    return this._showBoundingBox;
  }
  set showBoundingBox(e) {
    this._showBoundingBox != e && (this._showBoundingBox = e, this.updateBoundingBox(), this.setRenderingNeeded());
  }
  // EditorBackgroundColor
  get editorBackgroundColor() {
    return this._editorBackgroundColor;
  }
  set editorBackgroundColor(e) {
    this._editorBackgroundColor != e && this.setEditorBackgroundColor(e);
  }
  // ShowGround
  get showGround() {
    return this._showGround;
  }
  set showGround(e) {
    this._showGround != e && (this._showGround = e, this.refreshGround());
  }
  // ShowLights
  get showLights() {
    return this._showLights;
  }
  set showLights(e) {
    this._showLights != e && (this._showLights = e, this._lightsLayer && this._lightsLayer.refresh(), this.setRenderingNeeded());
  }
  // ShowAxes
  get showAxes() {
    return this._showAxes;
  }
  set showAxes(e) {
    this._showAxes != e && (this._showAxes = e, this._axesLayer && this._axesLayer.refresh(), this.setRenderingNeeded());
  }
  get showFineTuning() {
    return this._showFineTuning;
  }
  set showFineTuning(e) {
    this._showFineTuning = e, this._fineTuningModelLoaded = !1;
  }
  set fineTuningModelLoaded(e) {
    this._fineTuningModelLoaded = e;
  }
  get fineTuningModelLoaded() {
    return this._fineTuningModelLoaded;
  }
  get sessionTryOnEnabled() {
    return this._sessionTryOnEnabled;
  }
  set sessionTryOnEnabled(e) {
    this._sessionTryOnEnabled = e;
  }
  get tryOnInfoLoading() {
    return this._tryOnInfoLoading;
  }
  set tryOnInfoLoading(e) {
    this._tryOnInfoLoading = e;
  }
  // ShowHighlight
  get showHighlight() {
    return this._showHighlight;
  }
  set showHighlight(e) {
    this._showHighlight != e && (this._showHighlight = e);
  }
  // HighlightOver
  get highlightOver() {
    return this._highlightOver;
  }
  set highlightOver(e) {
    this._highlightOver != e && (this._highlightOver = e);
  }
  // HighlightOverColor
  get highlightOverColor() {
    return this._highlightOverColor;
  }
  set highlightOverColor(e) {
    this._highlightOverColor != e && (this._highlightOverColor = e);
  }
  // EditingMode
  get editingMode() {
    return this._editingMode;
  }
  set editingMode(e) {
    this._editingMode != e && this.setEditingMode(e);
  }
  // EditingControlVisible
  get editControlVisible() {
    return this._editControlVisible;
  }
  set editControlVisible(e) {
    this._editControlVisible != e && this.showHideEditControl(e);
  }
  get selectedProvider() {
    return this._pickedProvider;
  }
  get selectedProviderFineTuningData() {
    return this._providerData;
  }
  get modelMeasurements() {
    return this._modelMeasurements;
  }
  set modelMeasurements(e) {
    this._modelMeasurements = e;
  }
  get showMeasurements() {
    return this._showMeasurements;
  }
  fireHideMeasurementsEvent() {
    this._showMeasurements = !1;
  }
  fireShowMeasurementsEvent() {
    this._showMeasurements = !0;
  }
  static async createSceneEditorAsync(e) {
    const t = new ul(e);
    return await t.initAsync(), t.checkSceneSourceTasks(), t;
  }
  createCanvas() {
    const e = super.createCanvas();
    return e.addEventListener(
      "keydown",
      (t) => {
        this._shiftPressed = t.key == "Shift", this._ctrlPressed = t.key == "Control";
      },
      !1
    ), e.addEventListener(
      "keyup",
      (t) => {
        this._shiftPressed = t.key != "Shift", this._ctrlPressed = t.key != "Control";
      },
      !1
    ), e.addEventListener("dblclick", (t) => {
      this.setRenderingNeeded();
    }), e;
  }
  deleteComponents() {
    super.deleteComponents(), this._editControl && (this._editControl.detach(), this._editControl = null), this._lightsLayer && (this._lightsLayer.dispose(), this._lightsLayer = null), this._axesLayer && (this._axesLayer.dispose(), this._axesLayer = null);
  }
  dispose() {
    super.dispose(), this._incrementalFilesMaker && (this._incrementalFilesMaker.dispose(), delete this._incrementalFilesMaker), this._sceneToBlobs && (this._sceneToBlobs.dispose(), delete this._sceneToBlobs);
  }
  createEngine() {
    super.createEngine(), BABYLON.SceneLoader.ForceFullSceneLoadingForIncremental = !0;
  }
  async createEmptySceneAsync() {
    await super.createEmptySceneAsync(), this._engine && this.fireSceneCreatedEvent();
  }
  async setupSceneAsync() {
    var e;
    await super.setupSceneAsync(), this._engine && this._scene && (this._scene.setRenderingAutoClearDepthStencil(1, !0, !0, !1), this._scene.setRenderingAutoClearDepthStencil(2, !0, !0, !1), this._lightsLayer = new Cw(this), this._lightsLayer.addLightSelectedListener((t) => {
      this.lightsLayer_onLightSelected(t);
    }), (e = this._sceneHelper) == null || e.cleanUnusedMaterialsMappings(this._zkScene), this.addMaterialsUpdateListener(() => {
      var t;
      return (t = this._sceneHelper) == null ? void 0 : t.cleanUnusedMaterialsMappings(this._zkScene);
    }), this.setupAxes(), this._zkModel && this._meshLocationsManager && (this._meshLocationsManager.addBeforeSaveMeshLocationListener(() => this.onBeforeSaveMeshLocation()), this._meshLocationsManager.addAfterSaveMeshLocationListener(() => this.onAfterSaveMeshLocation())), this._scene.onPointerMove = (t, n) => this.onPointerMove(t, n));
  }
  render() {
    this.firePreUpdateEvent(), super.render(), this._lightsLayer && this._lightsLayer.render(), this._axesLayer && this._axesLayer.render(), this.firePostUpdateEvent();
  }
  deleteHighlightLayer() {
    this._highlightLayer && (this._highlightLayer.dispose(), this._highlightLayer = null), this.setRenderingNeeded();
  }
  setupHighlightLayerIntensity() {
    this._highlightLayer && (this._highlightLayer.blurHorizontalSize = this._highlightBlurHorizontalSize, this._highlightLayer.blurVerticalSize = this._highlightBlurVerticalSize);
  }
  setupAxes() {
    this._axesLayer = new Mw(this);
  }
  getMatchSameNameTextures() {
    if (this._zkScene) {
      let e = this._zkScene.getMatchSameNameTextures();
      return e ?? !1;
    }
    return !1;
  }
  setMatchSameNameTextures(e) {
    this._zkScene && this._zkScene.setMatchSameNameTextures(e);
  }
  getAREnabled() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getAREnabled();
      return t ?? e;
    }
    return e;
  }
  setAREnabled(e) {
    this._zkScene && this._zkScene.setAREnabled(e);
  }
  getAROnTheFly() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getAROnTheFly();
      return t ?? e;
    }
    return e;
  }
  setAROnTheFly(e) {
    this._zkScene && this._zkScene.setAROnTheFly(e);
  }
  setARAnchor(e) {
    this._zkScene && this._zkScene.setARAnchor(e);
  }
  getTryOnEnabled() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getTryOnEnabled();
      return t ?? e;
    }
    return e;
  }
  setTryOnEnabled(e) {
    this._zkScene && this._zkScene.setTryOnEnabled(e);
  }
  setTryOnSelectedType(e) {
    if (this._zkScene) {
      const t = this.getTryOnDefaultTypeSettings(), n = this._zkScene.getTryOnSettings() || t;
      n.type = e, this.setTryOnTypeSettings(n);
    }
  }
  setFrameDAMSettings(e) {
    this._zkScene && this._zkScene.setFrameDAMSettings(typeof e == "string" ? e : JSON.stringify(e));
  }
  getForceDracoCompression() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getForceDracoCompression();
      return t ?? e;
    }
    return e;
  }
  setForceDracoCompression(e) {
    this._zkScene && this._zkScene.setForceDracoCompression(e);
  }
  getWebPEnabled() {
    return this._zkScene ? this._zkScene.getWebPEnabled() : !1;
  }
  setWebPEnabled(e) {
    this._zkScene && this._zkScene.setWebPEnabled(e);
  }
  getWebPType() {
    return this._zkScene ? this._zkScene.getWebPType() : "Lossless";
  }
  setWebPType(e) {
    this._zkScene && this._zkScene.setWebPType(e);
  }
  getWebPQuality() {
    return this._zkScene ? this._zkScene.getWebPQuality() : 80;
  }
  setWebPQuality(e) {
    this._zkScene && this._zkScene.setWebPQuality(e);
  }
  setProvider(e) {
    this._pickedProvider = e;
  }
  setProviderFineTuningData(e) {
    this._providerData = {
      mesh: e.mesh ? e.mesh : this._providerData.mesh,
      settings: e.settings ? e.settings : this._providerData.settings
    };
  }
  resetProviderFineTuningData() {
    var e;
    (e = this._scene) == null || e.meshes.forEach((t) => {
      t.metadata && t.metadata.tryOnFineTuningSettings && (t.metadata.tryOnFineTuningSettings = null);
    }), this._providerData = {};
  }
  setMeshFineTuningData(e, t) {
    const n = typeof e == "string" ? this.getMeshByID(e) : e;
    n && (n.metadata || (n.metadata = {}), n.metadata.tryOnFineTuningSettings = t);
  }
  setDAMFineTuningData(e) {
    const t = {
      finetuning: e
    };
    this.setFrameDAMSettings(t);
  }
  getTryOnSelectedType() {
    if (this._zkScene) {
      let e = this._zkScene.getTryOnSettings();
      if (e && e.type)
        return e.type;
    }
    return null;
  }
  getTryOnSettings() {
    const e = this.getTryOnDefaultTypeSettings();
    if (this._zkScene) {
      let t = this._zkScene.getTryOnSettings();
      if (t)
        return t;
    }
    return e;
  }
  getTryOnSetting(e) {
    if (this._zkScene) {
      let t = this._zkScene.getTryOnSettings();
      if (t && e in t.typeSettings && t.typeSettings[e] && typeof t.typeSettings[e] == "boolean")
        return t.typeSettings[e];
    }
    return !1;
  }
  setTryOnSetting(e, t) {
    let n = this.getTryOnDefaultTypeSettings();
    if (this._zkScene) {
      let a = this._zkScene.getTryOnSettings();
      if (!a) {
        switch (e) {
          case Os.GlassPupillaryDistanceTool:
          case Os.VirtualTryOn:
          case Os.MandatoryPupillaryDistance:
            n.typeSettings[e] = t;
            break;
          case Os.StyleButton:
            n.styleButton = t;
        }
        this.setTryOnTypeSettings(n);
        return;
      }
      switch (e) {
        case Os.GlassPupillaryDistanceTool:
          a.typeSettings.pd = t;
          break;
        case Os.VirtualTryOn:
          a.typeSettings.try_on = t;
          break;
        case Os.MandatoryPupillaryDistance:
          a.typeSettings.mandatoryPD = t;
          break;
        case Os.StyleButton:
          a.styleButton = t;
          break;
      }
      a.typeSettings.pd && a.typeSettings.try_on || (a.styleButton = "single"), this._zkScene.setTryOnSettings(a);
    }
  }
  setTryOnTypeSettings(e) {
    this._zkScene && this._zkScene.setTryOnSettings(e);
  }
  getTryOnDefaultTypeSettings() {
    return {
      type: ng.NotSelected,
      styleButton: "single",
      buttonCustomizations: [
        {
          image: "base",
          textLabel: "Virtual Try-on",
          textColor: null,
          backgroundColor: null,
          borderColor: null,
          borderWidth: 0,
          borderRadius: 0
        }
      ],
      typeSettings: {
        try_on: !0,
        pd: !1,
        active: this.getTryOnEnabled() ?? !1
      }
    };
  }
  setTryOnDefaultTypeSettings() {
    let e = this.getTryOnDefaultTypeSettings();
    this.setTryOnTypeSettings(e);
  }
  getUseDelayedMaterialLoading() {
    let e = !1;
    if (this.zkScene) {
      let t = this.zkScene.getUseDelayedMaterialLoading();
      return t ?? e;
    }
    return e;
  }
  setUseDelayedMaterialLoading(e) {
    this._zkScene && this._zkScene.setUseDelayedMaterialLoading(e);
  }
  getUseDelayedTextureLoading() {
    if (this._zkScene) {
      let t = this._zkScene.getUseDelayedTextureLoading();
      return t ?? !1;
    }
    return !1;
  }
  setUseDelayedTextureLoading(e) {
    this._zkScene && this._zkScene.setUseDelayedTextureLoading(e);
  }
  getGlowEnabled() {
    return this._glowManager ? this._glowManager.enabled : !1;
  }
  setGlowEnabled(e) {
    this._glowManager && (this._glowManager.enabled = e, this.setRenderingNeeded());
  }
  getGlowIntensity() {
    return this._glowManager ? this._glowManager.intensity : 1;
  }
  setGlowIntensity(e) {
    this._glowManager && (this._glowManager.intensity = e, this.setRenderingNeeded());
  }
  getGlowBlurSize() {
    return this._glowManager ? this._glowManager.blurSize : 16;
  }
  setGlowBlurSize(e) {
    this._glowManager && (this._glowManager.blurSize = e, this.setRenderingNeeded());
  }
  getInfoPointsEnabled() {
    let e = !1;
    if (this._zkScene) {
      let t = this._zkScene.getInfoPointsEnabled();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsEnabled(e) {
    this._zkScene && this._zkScene.setInfoPointsEnabled(e), this.refreshInfoPoints();
  }
  getInfoPointsBorderColor() {
    const e = "";
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsBorderColor();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsBorderColor(e) {
    this._zkScene && (this._zkScene.setInfoPointsBorderColor(e), this.refreshInfoPoints());
  }
  getInfoPointsInnerPointColor() {
    const e = "";
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsInnerPointColor();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsInnerPointColor(e) {
    this._zkScene && (this._zkScene.setInfoPointsInnerPointColor(e), this.refreshInfoPoints());
  }
  getInfoPointsColor() {
    const e = "";
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsColor();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsColor(e) {
    this._zkScene && (this._zkScene.setInfoPointsColor(e), this.refreshInfoPoints());
  }
  getInfoPointsHighlightColor() {
    const e = "";
    if (this._zkScene) {
      const t = this._zkScene.getInfoPointsHighlightColor();
      return t ?? e;
    }
    return e;
  }
  setInfoPointsHighlightColor(e) {
    this._zkScene && (this._zkScene.setInfoPointsHighlightColor(e), this.refreshInfoPoints());
  }
  enableGlowForMesh(e) {
    this._glowManager && this._glowManager.enableGlowForMesh(e);
  }
  disableGlowForMesh(e) {
    this._glowManager && (this._glowManager.disableGlowForMesh(e), this.setRenderingNeeded());
  }
  enableARForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.AR = !0);
  }
  disableARForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.AR = !1);
  }
  disableTryOnForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.TryOn = !1, e.getChildMeshes().forEach((t) => this.disableTryOnForMesh(t)));
  }
  enableTryOnForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.TryOn = !0, e.getChildMeshes().forEach((t) => this.enableTryOnForMesh(t)));
  }
  enableInfoPointsForMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.showInfoPoints = !0, this.refreshInfoPoints());
  }
  disableInfoPointsForMesh(e) {
    e && e.metadata && e.metadata.showInfoPoints !== void 0 && e.metadata.showInfoPoints !== null && (delete e.metadata.showInfoPoints, this.refreshInfoPoints());
  }
  enableForcedInfoPointsVisibilityOnMesh(e) {
    e && (e.metadata || (e.metadata = {}), e.metadata.forceShowInfoPoints = !0, this.refreshInfoPoints());
  }
  disableForcedInfoPointsVisibilityOnMesh(e) {
    e && e.metadata && e.metadata.forceShowInfoPoints !== void 0 && e.metadata.forceShowInfoPoints !== null && (delete e.metadata.forceShowInfoPoints, this.refreshInfoPoints());
  }
  setEditorBackgroundColor(e) {
    this._editorBackgroundColor = e, this.refreshEnvironment();
  }
  setViewerBackgroundAlpha(e) {
    this._zkScene && (this._zkScene.getOrCreateGeneralConfig().set("backgroundAlpha", e), this.refreshEnvironment());
  }
  setViewerBackgroundColor(e) {
    this._zkScene && (this._zkScene.getOrCreateGeneralConfig().set("backgroundColor", e), this.refreshEnvironment());
  }
  setViewerEnvironmentSizeAuto(e) {
    this._zkScene && (this._zkScene.getOrCreateEnvironmentConfig().set("sizeAuto", e), this.refreshEnvironment());
  }
  setViewerEnvironmentMainColor(e) {
    this._zkScene && (this._zkScene.getOrCreateEnvironmentConfig().set("mainColor", e), this.refreshEnvironment());
  }
  setViewerSkyboxCreateSkybox(e) {
    this._zkScene && (this._zkScene.getOrCreateSkyboxConfig().set("createSkybox", e), this.refreshEnvironment());
  }
  setViewerSkyboxSize(e) {
    this._zkScene && (this._zkScene.getOrCreateSkyboxConfig().set("size", e), this.refreshEnvironment());
  }
  setViewerSkyboxBlur(e) {
    if (this._zkScene) {
      let t = e >= 0 ? e : 0;
      this._zkScene.getOrCreateSkyboxConfig().set("blur", t), this.refreshEnvironment();
    }
  }
  setViewerSkyboxTexture(e, t, n) {
    if (this._zkScene && e != null && typeof e == "string") {
      const a = this._zkScene.getOrCreateSkyboxConfig();
      a.set("texture", e), a.set("extensions", t), a.set("files", n), this.refreshEnvironment();
    }
  }
  removeViewerSkyboxTexture() {
    if (this._zkScene) {
      const e = this._zkScene.getSkyboxConfig();
      e && e.get("texture") != null && (e.unset("texture"), this.refreshEnvironment());
    }
  }
  setViewerSkyboxColor(e) {
    this._zkScene && e != null && typeof e == "string" && (this._zkScene.getOrCreateSkyboxConfig().set("color", e), this.refreshEnvironment());
  }
  setViewerGroundCreateGround(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateGroundConfig().set("createGround", e), this.refreshEnvironment());
  }
  setViewerGroundSize(e) {
    this._zkScene && (this._zkScene.getOrCreateGroundConfig().set("size", e), this.refreshEnvironment());
  }
  setViewerGroundTexture(e) {
    this._zkScene && e != null && typeof e == "string" && (this._zkScene.getOrCreateGroundConfig().set("texture", e), this.refreshEnvironment());
  }
  removeViewerGroundTexture() {
    if (this._zkScene) {
      const e = this._zkScene.getGroundConfig();
      e && e.get("texture") != null && (e.unset("texture"), this.refreshEnvironment());
    }
  }
  setViewerGroundColor(e) {
    this._zkScene && e != null && typeof e == "string" && (this._zkScene.getOrCreateGroundConfig().set("color", e), this.refreshEnvironment());
  }
  setViewerGroundOpacity(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateGroundConfig().set("opacity", e), this.refreshEnvironment());
  }
  setViewerGroundEnableShadow(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateGroundConfig().set("enableShadow", e), this.refreshEnvironment());
  }
  setViewerGroundShadowLevel(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateGroundConfig().set("shadowLevel", e), this.refreshEnvironment());
  }
  setViewerGroundEnableMirror(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateGroundConfig().set("enableMirror", e), this.refreshEnvironment());
  }
  setViewerGroundMirrorBlur(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateGroundConfig().set("mirrorBlurKernel", e), this.refreshEnvironment());
  }
  setViewerCameraAutoRotate(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateCameraConfig().set("autoRotate", e), this.autoRender = e, this.refreshEnvironment());
  }
  setViewerCameraContrast(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateCameraConfig().set("contrast", e), this.refreshEnvironment());
  }
  setViewerCameraExposure(e) {
    this._zkScene && e != null && typeof e == "number" && (this._zkScene.getOrCreateCameraConfig().set("exposure", e), this.refreshEnvironment());
  }
  setViewerCameraUpperAlphaLimit(e) {
    var t;
    if (this._zkScene && e != null && typeof e == "number") {
      const a = this._zkScene.getOrCreateCameraConfig().get("lowerAlphaLimit");
      this._zkScene.setCameraUpperAlphaLimit(Math.max(e, a ?? e)), (t = this._sceneHelper) == null || t.setCameraUpperAlphaLimit(Math.max(e, a ?? e)), this.setRenderingNeeded();
    }
  }
  setViewerCameraLowerAlphaLimit(e) {
    var t;
    if (this._zkScene && e != null && typeof e == "number") {
      const a = this._zkScene.getOrCreateCameraConfig().get("upperAlphaLimit");
      this._zkScene.setCameraLowerAlphaLimit(Math.min(e, a ?? e)), (t = this._sceneHelper) == null || t.setCameraLowerAlphaLimit(Math.min(e, a ?? e)), this.setRenderingNeeded();
    }
  }
  setViewerCameraLowerBetaLimit(e) {
    var t;
    if (this._zkScene && e != null && typeof e == "number") {
      const a = this._zkScene.getOrCreateCameraConfig().get("upperBetaLimit");
      this._zkScene.setCameraLowerBetaLimit(Math.min(e, a ?? e)), (t = this._sceneHelper) == null || t.setCameraLowerBetaLimit(Math.min(e, a ?? e)), this.setRenderingNeeded();
    }
  }
  setViewerCameraUpperBetaLimit(e) {
    var t;
    if (this._zkScene && e != null && typeof e == "number") {
      const a = this._zkScene.getOrCreateCameraConfig().get("lowerBetaLimit");
      this._zkScene.setCameraUpperBetaLimit(Math.max(e, a ?? e)), (t = this._sceneHelper) == null || t.setCameraUpperBetaLimit(Math.max(e, a ?? e)), this.setRenderingNeeded();
    }
  }
  setViewerCameraToneMappingEnabled(e) {
    this._zkScene && e != null && typeof e == "boolean" && (this._zkScene.getOrCreateCameraConfig().set("toneMappingEnabled", e), this.refreshEnvironment());
  }
  serializeFromVector(e) {
    return e ? { x: e.x, y: e.y, z: e.z } : null;
  }
  setModelTransformsFromDAMMesh() {
    var t;
    const e = this.getDAMMainMesh();
    if (e) {
      const n = e.position, a = e.rotation, o = e.scaling, h = new BABYLON.Vector3(
        Math.abs(o.x),
        Math.abs(o.y),
        Math.abs(o.z)
      );
      console.log("🔧 [DAM-SAVE] Reading transforms from mesh:", {
        nodeName: e.name,
        originalScale: { x: o.x, y: o.y, z: o.z }
      }), console.log("🔵 [DAM-SAVE] Normalized scale:", { x: h.x, y: h.y, z: h.z });
      const f = (t = this._zkScene) == null ? void 0 : t.getOrCreateModelConfig();
      f.set("position", this.serializeFromVector(n)), f.set("rotation", this.serializeFromVector(a)), f.set("scale", this.serializeFromVector(h));
    }
  }
  resetEditorEnvironment() {
    this.resetEditorBackground(), this.resetEditorCamera(), this.setRenderingNeeded();
  }
  resetEditorBackground() {
    this._scene && (this._scene.clearColor = BABYLON.Color3.FromHexString(this._editorBackgroundColor).toColor4(), this.refreshGround(), this.setRenderingNeeded());
  }
  resetEditorCamera() {
    if (this._scene) {
      const e = this._scene.activeCamera;
      e instanceof BABYLON.ArcRotateCamera && (e.useAutoRotationBehavior = !1), this._autoRender = !1, this.setRenderingNeeded();
    }
  }
  preSceneContentScreenshot() {
    this.resetEditorEnvironment(), this.removeGround();
  }
  postSceneContentScreenshot() {
  }
  preSceneMaterialScreenshot() {
    super.preSceneMaterialScreenshot(), this.adjustSceneForSerialization();
  }
  postSceneMaterialScreenshot() {
    super.postSceneMaterialScreenshot();
  }
  sceneReadyForSave() {
    if (this._scene) {
      for (let e = 0; e < this._scene.meshes.length; e++)
        if (!this._scene.meshes[e].isReady())
          return !1;
    }
    return !0;
  }
  isCurrentCameraPivot(e) {
    if (this._sceneHelper) {
      const t = this._sceneHelper.getCameraPivot();
      return t && t.id === e;
    }
    return !1;
  }
  getCurrentCameraPivotID() {
    if (this._scene && this._sceneHelper) {
      const e = this._sceneHelper.getCameraPivot();
      if (e) {
        const t = this._scene.getMeshByID(e.id);
        if (t)
          return t.id;
      }
    }
    return null;
  }
  // Riscritta quella di SceneViewer perché viene salvata l'informazione
  // sul nuovo pivot, non solo modifcato il punto di vista
  setCameraPivot(e) {
    if (this._scene && this._sceneHelper) {
      for (let n = 0; n < this._scene.meshes.length; n++) {
        var t = this._scene.meshes[n];
        t.metadata && t.metadata.isCameraPivot != null && delete t.metadata.isCameraPivot;
      }
      if (e) {
        const n = this._scene.getMeshByID(e);
        n && (n.metadata = n.metadata || {}, n.metadata.isCameraPivot = !0), this._sceneHelper.setCameraPivot(n || null);
      } else
        this._sceneHelper.setCameraPivot(null);
    }
  }
  // --------------------------------------------------------
  // Funzioni per il salvataggio della scena
  // --------------------------------------------------------
  async getBlobFromEmbeddedTextureAsync(e) {
    let t = null;
    if (e.url) {
      const h = e.url;
      var n = h.substring(0, 5) === "data:", a = h.substring(0, 5) === "blob:", o = n && h.indexOf(";base64,") !== -1;
      if (n && e._buffer && (e._buffer instanceof ArrayBuffer || e._buffer instanceof Uint8Array || e._buffer instanceof Blob))
        e._buffer instanceof Blob ? t = e._buffer : e._buffer instanceof Uint8Array ? t = new Blob([e._buffer], { type: e.mimeType }) : e._buffer instanceof ArrayBuffer && (t = new Blob([new Uint8Array(e._buffer)], { type: e.mimeType }));
      else if (a)
        await new Promise((f) => {
          var v = new XMLHttpRequest();
          v.open("GET", h, !0), v.responseType = "blob", v.onload = function(x) {
            this.status == 200 && f(this.response);
          }, v.send();
        });
      else if (o) {
        const f = new Uint8Array(BABYLON.Tools.DecodeBase64(h));
        t = new Blob([f], { type: e.mimeType });
      }
    }
    return t;
  }
  async uploadEmbeddedTexturesAsync(e) {
    const t = [];
    if (this._zkScene && this._scene && this._sceneHelper) {
      this._scene, this._zkScene;
      const n = this._sceneHelper;
      this.getAllMaterials().forEach((o) => {
        o.getActiveTextures().filter((f) => f instanceof BABYLON.Texture).forEach((f) => {
          if (f.url) {
            var v = f.url.substring(0, 5) === "data:", x = f.url.substring(0, 5) === "blob:", k = v && f.url.indexOf(";base64,") !== -1;
            if (v || x || k) {
              const I = n.getMaterialTextureType(o, f);
              I && t.push({
                texture: f,
                material: o,
                type: I
              });
            }
          }
        });
      });
    }
    for (let n = 0; n < t.length; n++) {
      const a = t[n], o = a.texture, h = await this.getBlobFromEmbeddedTextureAsync(o);
      if (h) {
        let f = ".png";
        o.mimeType === "image/jpeg" && (f = ".jpg");
        const x = `${a.type.replace(" ", "_")}${f}`;
        let k = new File([h], x);
        const I = await this.uploadTextureFileAsync(k, a.material);
        if (I) {
          const V = I.get("url");
          V && await new Promise((M, W) => {
            o.updateURL(
              V,
              void 0,
              () => M(),
              void 0,
              () => W()
            );
          });
        }
        e && e(n / t.length * 100, "textures");
      }
    }
  }
  useIncrementalLoading() {
    if (this._sceneHelper) {
      const e = this._sceneHelper.getTotalVertices(), t = this._sceneHelper.getTotalIndices();
      if (e + t >= 1e3)
        return !0;
    }
    return !1;
  }
  // Prepara il modello backbone zkScene per il salvataggio. Nel dettaglio:
  // 1. Esegue lo screenshot della scena e imposta i byte nel modello zkScene
  // 2. Recupera il JSON della scena da Babylon JS.
  // 3. Esegue l'upload del file in modo che possa essere salvato nel percorso previsto per la scena corrente.
  // 4. Aggiorna il modello impostando i dati relativi al file "uploadato" (essenzialmente il fileObject)
  updateSceneModel(e, t, n, a) {
    if (this._zkScene && this._scene) {
      this._scene;
      const o = this._zkScene;
      this.resetRealVisibility();
      const h = this.infoPointsShown;
      h && this.hideInfoPoints(), this.uploadEmbeddedTexturesAsync((f, v) => {
        n && n(f, v);
      }).then(() => {
        this.getSceneScreenshotAsync(500, 450).then((f) => {
          h && this.showInfoPoints(), o.set("imageData", f), o.set("version", o.get("version") + 1);
          var v = this.useIncrementalLoading();
          v ? this.uploadSceneIncrementalFiles(
            (x) => {
              this.onUploadScenFileSuccess(x), e && e();
            },
            (x) => {
              t && t(x);
            },
            (x) => {
              n && n(x);
            },
            a
          ) : this.uploadSceneFile(
            (x) => {
              this.onUploadScenFileSuccess(x), e && e();
            },
            (x) => {
              t && t(x);
            },
            (x, k) => {
              n && n(x, k);
            }
          );
        });
      }).catch((f) => {
        t && t(f);
      });
    }
  }
  // Aggiorna il modello con i dati sul file di scena salvato
  onUploadScenFileSuccess(e) {
    this._zkScene && e && (e.hasOwnProperty("fileObjectID") || e.hasOwnProperty("fileLength")) && e.hasOwnProperty("rootUrl") && e.hasOwnProperty("sceneFileName") && (e.hasOwnProperty("manifestFileObjectID") || e.hasOwnProperty("manifestFileLength")) && (e.hasOwnProperty("incrementalsFileObjectID") || e.hasOwnProperty("incrementalsFileLength")) ? (this._zkScene.set("fileObjectID", e.fileObjectID), this._zkScene.set("fileLength", e.fileLength), this._zkScene.set("url", e.url), this._zkScene.set("rootUrl", e.rootUrl), this._zkScene.set("sceneFileName", e.sceneFileName), this._zkScene.set("manifestFileObjectID", e.manifestFileObjectID), this._zkScene.set("manifestFileLength", e.manifestFileLength), this._zkScene.set("manifestFileUrl", e.manifestFileUrl), this._zkScene.set("incrementalsFileObjectID", e.incrementalsFileObjectID), this._zkScene.set("incrementalsFileLength", e.incrementalsFileLength), this._zkScene.set("incrementalsFileUrl", e.incrementalsFileUrl)) : Logger.info("le informazioni sul file di scena salvato sono vuote o incorrette");
  }
  uploadSceneFile(e, t, n) {
    if (!this._scene || !this._zkScene) {
      t && t("No scene to upload");
      return;
    }
    this._scene;
    const a = this._zkScene, o = a.get("version"), h = this.getSceneJson();
    this.getSceneFileBlobsAsync(h, o, (f) => {
      n && n(f, "optimize");
    }).then((f) => {
      const v = new FormData();
      for (let x = 0; x < f.length; x++) {
        const k = f[x];
        v.append("file_" + x, k.blob, k.name);
      }
      fetch(a.getSceneIncrementalFileUploadUrl(), {
        method: "POST",
        body: v,
        headers: {
          Authorization: "Bearer " + this._authorizationToken
        }
      }).then((x) => {
        if (!x.ok)
          throw new Error("HTTP error " + x.status);
        return x.json();
      }).then((x) => {
        e && e(x);
      }).catch((x) => {
        t && t(x.message);
      });
    });
  }
  async getSceneFileBlobsAsync(e, t, n) {
    let a = [];
    return this._sceneToBlobs || (this._sceneToBlobs = new bw(this._incrementalWorkersScriptsUrls)), this._sceneToBlobs && (await this._sceneToBlobs.whenReadyAsync(), a = await this._sceneToBlobs.getSceneBlobsAsync(e, t, n)), a;
  }
  // Serializza in JSON la scena Babylon JS
  getSceneJson() {
    var t;
    let e = "";
    if (this._scene && this._sceneHelper) {
      const n = this._envMode;
      this.setEnvironmentMode(Lr.Editor), this.disableAntialiasing(!0);
      const a = this.resetCameraRotationLimits();
      this.deleteHighlightLayer();
      const o = this._manipulatedNode;
      this.setManipulatedNode(null), this.getUseMaterialOffloading() && !this.getUseDelayedMaterialLoading() && this._sceneHelper.offloadAllUnusedMaterials(), this._sceneHelper.setDummyMaterialToInvisibleMeshes(), this.adjustSceneForSerialization();
      const h = BABYLON.SceneSerializer.Serialize(this._scene);
      if (h.postProcesses = [], e = JSON.stringify(h), this.getUseMaterialOffloading() && !this.getUseDelayedMaterialLoading()) {
        const f = (t = this._zkScene) == null ? void 0 : t.get("rootUrl");
        f && this._sceneHelper.loadAllOffloadedMaterials(f);
      }
      this._sceneHelper.unsetAllDummyMaterials(), n != Lr.Editor && this.setEnvironmentMode(n), this.enableAntialiasing(), this.createHighlightLayer(), this.setManipulatedNode(o), this.setCameraRotationLimits(a);
    }
    return e;
  }
  resetCameraRotationLimits() {
    const e = {
      lowerAlphaLimit: null,
      upperAlphaLimit: null,
      lowerBetaLimit: null,
      upperBetaLimit: null
    };
    return this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (e.lowerAlphaLimit = this._camera.lowerAlphaLimit, e.upperAlphaLimit = this._camera.upperAlphaLimit, e.lowerBetaLimit = this._camera.lowerBetaLimit, e.upperBetaLimit = this._camera.upperBetaLimit, this._camera.lowerAlphaLimit = null, this._camera.upperAlphaLimit = null, this._camera.lowerBetaLimit = 0.01, this._camera.upperBetaLimit = Math.PI - 0.01), e;
  }
  setCameraRotationLimits(e) {
    e = e || {
      lowerAlphaLimit: null,
      upperAlphaLimit: null,
      lowerBetaLimit: 0.01,
      upperBetaLimit: Math.PI - 0.01
    }, this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this._camera.lowerAlphaLimit = e.lowerAlphaLimit, this._camera.upperAlphaLimit = e.upperAlphaLimit, this._camera.lowerBetaLimit = e.lowerBetaLimit || 0.01, this._camera.upperBetaLimit = e.upperBetaLimit || Math.PI - 0.01);
  }
  // Metodo fondamentale per modificare gli url delle texture ed eliminare le
  // le texture non più utilizzate. In fase di caricamento della scena, Babylon JS
  // risolve il nome delle texture in base al path della scena. Quindi gli url delle
  // texture vanno, se necessario, trasformanti in path relativi.
  adjustSceneForSerialization() {
    if (this._scene && this._sceneHelper && this._zkScene) {
      const e = this._sceneHelper;
      this.removeDisabledFresnelParameters();
      let t = !1;
      this._zkScene.getUseDelayedTextureLoading() != null && (t = this._zkScene.getUseDelayedTextureLoading()), this._scene.useDelayedTextureLoading = t;
      const n = this.getMatchSameNameTextures(), a = this._zkScene.getSourcesIDs();
      this._zkScene.getLibraryMaterialIDs();
      const o = {}, h = [], f = [], v = [], x = e.getTextureUrl(this._scene.environmentTexture), k = x !== null && x.endsWith(ci.Environment.EnvironmentTextureName);
      if (this._zkScene.set("useDefaultEnvironmentTexture", k), this._scene.environmentTexture && (this._scene.environmentTexture instanceof BABYLON.CubeTexture || this._scene.environmentTexture instanceof BABYLON.HDRCubeTexture)) {
        const D = this._scene.environmentTexture.rotationY;
        this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.environmentTextureRotationY = D;
      }
      this._scene.textures.forEach((D) => {
        var J, he;
        if (!e.isTextureWithUrl(D))
          return;
        let ee = D.url;
        if (D.getInternalTexture) {
          const fe = D.getInternalTexture();
          fe && fe.url && (ee = fe.url);
        }
        if (ee) {
          let fe = ee;
          if (fe === ci.Environment.EnvironmentTextureCDNUrl) {
            D.url = "textures/" + Zakeke.getEmptyUUID().replace(/-/g, "") + "/" + ci.Environment.EnvironmentTextureName, D.name = D.url;
            return;
          }
          if (fe == ci.Environment.SkyboxTextureCDNUrl || fe == ci.Environment.GroundTextureCDNUrl)
            return;
          let X = !1;
          fe.startsWith("blob:") && D.metadata && D.metadata.fileUrl && (fe = D.metadata.fileUrl);
          for (let Oe = 0; Oe < a.length; Oe++) {
            let je = a[Oe].replace(/-/g, ""), pt = fe.indexOf(je);
            if (pt != -1) {
              X = !0, D.name = fe.substring(pt), D.url = D.name, Logger.info("texture url: " + D.url);
              break;
            }
          }
          let Z = !1;
          const qe = this._zkScene.get("rootUrl") || "";
          if (D.materialMapping) {
            Z = !0;
            const Oe = ((he = (J = D.name) == null ? void 0 : J.split("/")) == null ? void 0 : he.pop()) || D.name, je = D.materialMapping, pt = je.libraryMaterialID.replace(/-/g, ""), Te = je.sceneMaterialID.replace(/-/g, "");
            D.url = `textures/${Te}/${Oe}`, D.name = D.url;
            const Ze = `textures/${pt}/${Oe}`;
            if (ra(h, Ze) || h.push(Ze), D.metadata && D.metadata.mobileUrl) {
              const ut = D.metadata.mobileUrl.split("/").pop();
              D.metadata.mobileUrl = `${qe}textures/${Te}/${ut}`;
              const ze = `textures/${pt}/${ut}`;
              ra(h, ze) || h.push(ze);
            }
          }
          if (!X && !Z) {
            const Oe = this.extractTextureNameAndUrl(fe, n, o);
            if (Oe.url && Oe.name && (D.url = Oe.url, D.name = Oe.name, ra(h, D.url) || h.push(D.url)), D.metadata && D.metadata.mobileUrl && D.materialMapping) {
              const je = this.extractTextureNameAndUrl(
                D.metadata.mobileUrl,
                n,
                o
              );
              je.url && je.name && (D.metadata.mobileUrl = je.url, ra(h, D.metadata.mobileUrl) || h.push(D.metadata.mobileUrl), ra(v, D.metadata.mobileUrl) || v.push(D.metadata.mobileUrl), ra(f, D.url) || f.push(D.url));
            }
          }
        }
      });
      const I = ["px", "py", "pz", "nx", "ny", "nz"], V = (D) => {
        let ee = D.lastIndexOf("."), J = D;
        if (ee !== -1) {
          let he = D.substring(0, ee);
          for (let fe = 0; fe < I.length; fe++) {
            const X = I[fe];
            if (ee = he.lastIndexOf("_" + X), ee != -1) {
              J = he.substring(0, ee);
              break;
            }
          }
        }
        return J;
      }, M = (D) => {
        const ee = V(D);
        for (let J = 0; J < h.length; J++) {
          const he = h[J];
          if (ee.endsWith(he))
            return !0;
        }
        return !1;
      }, W = (D) => {
        const ee = V(D);
        for (let J = 0; J < f.length; J++) {
          const he = f[J];
          if (ee.endsWith(he))
            return !0;
        }
        return !1;
      }, U = (D) => {
        const ee = V(D);
        for (let J = 0; J < v.length; J++) {
          const he = v[J];
          if (ee.endsWith(he))
            return !0;
        }
        return !1;
      }, Q = [];
      for (let D = 0; D < this._zkScene.get("textures").length; D++) {
        const ee = this._zkScene.get("textures").at(D), J = ee.get("url");
        J && M(J) ? W(J) ? ee.set("usage", Zakeke.TextureUsage.Desktop) : U(J) ? ee.set("usage", Zakeke.TextureUsage.Mobile) : ee.set("usage", Zakeke.TextureUsage.Any) : Q.push(ee);
      }
      Q.length > 0 && this._zkScene.get("textures").remove(Q), this._zkScene.set("usedTextureUrls", h);
    }
  }
  // Metodo da usare per le texture caricate dall'utente, per trasformre il percorso assoluto
  // del tipo ..../textures/{ materialID }/{filename.xxx} nel percorso relativo textures/{materialID}/{filename.xxx}
  // Utilizza ed aggiorna eventualmente un dictionary per riutilizzare lo stesso percorso a parità di nome
  extractTextureNameAndUrl(e, t, n) {
    const a = { name: "", url: "" };
    let o = e.lastIndexOf("/");
    if (o !== -1) {
      const h = e.substring(o + 1);
      if (n.hasOwnProperty(h))
        a.url = n[h], a.name = a.url;
      else if (o = e.lastIndexOf("/", o - 1), o !== -1 && (o = e.lastIndexOf("/", o - 1), o !== -1)) {
        const f = e.substring(o + 1);
        a.url = f, a.name = f, t && (n[h] = f);
      }
    }
    return a;
  }
  removeDisabledFresnelParameters() {
    const e = function(t) {
      return t && t.isEnabled != null && !t.isEnabled && t.leftColor != null && t.leftColor != null && t.leftColor instanceof BABYLON.Color3 && t.leftColor.equals(BABYLON.Color3.White()) && t.rightColor != null && t.rightColor != null && t.rightColor instanceof BABYLON.Color3 && t.rightColor.equals(BABYLON.Color3.Black()) && t.bias != null && t.bias == 0 && t.power != null && t.power == 1;
    };
    this._scene && this._scene.materials.forEach(function(t) {
      t instanceof BABYLON.StandardMaterial ? (t.diffuseFresnelParameters && e(t.diffuseFresnelParameters) && (t.diffuseFresnelParameters = new BABYLON.FresnelParameters(), t.diffuseFresnelParameters.isEnabled = !1), t.emissiveFresnelParameters && e(t.emissiveFresnelParameters) && (t.emissiveFresnelParameters = new BABYLON.FresnelParameters(), t.emissiveFresnelParameters.isEnabled = !1), t.opacityFresnelParameters && e(t.opacityFresnelParameters) && (t.opacityFresnelParameters = new BABYLON.FresnelParameters(), t.opacityFresnelParameters.isEnabled = !1), t.reflectionFresnelParameters && e(t.reflectionFresnelParameters) && (t.reflectionFresnelParameters = new BABYLON.FresnelParameters(), t.reflectionFresnelParameters.isEnabled = !1), t.refractionFresnelParameters && e(t.refractionFresnelParameters) && (t.refractionFresnelParameters = new BABYLON.FresnelParameters(), t.refractionFresnelParameters.isEnabled = !1)) : t instanceof BABYLON.PBRMaterial || t instanceof Zakeke.PBRMaterial && t.opacityFresnelParameters && e(t.opacityFresnelParameters) && (t.opacityFresnelParameters = void 0);
    });
  }
  // Versione che utilizza un webworker (incapsulato in IncrementalFiles) per produrre i file incrementali (ed eventualmente
  // codificarli con Draco). In futuro si potrebbe convertire in async.
  uploadSceneIncrementalFiles(e, t, n, a) {
    if (!this._scene || !this._zkScene || !this._sceneHelper) {
      t && t("No scene to upload");
      return;
    }
    const o = this._zkScene, h = this._sceneHelper;
    let f = o.get("version"), v = this.envMode;
    this.setEnvironmentMode(Lr.Editor), this.disableAntialiasing(!0);
    let x = this.resetCameraRotationLimits();
    this.deleteHighlightLayer(), this.adjustSceneForSerialization(), h.setDummyMaterialToInvisibleMeshes();
    let k = this.getUseDelayedMaterialLoading(), I = this.getUseMaterialOffloading(), V = {}, M = {};
    k ? this.getAllMaterials().forEach((D) => {
      const ee = this.getMeshesUsingMaterial(D.id);
      D.id !== "default material" && ee.length === 0 && (V[D.id] = {
        name: D.name,
        file: "material_" + f + "_" + D.id.replace(/[^a-z0-9]/gi, "_").toLowerCase() + ".json"
      });
    }) : I && this.getAllMaterials().forEach((D) => {
      const ee = this.getMeshesUsingMaterial(D.id);
      D.id !== "default material" && ee.length === 0 && (M[D.id] = h.getOffloadedMaterialInfo(D));
    }), this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.offloadedMaterials = M, this._scene.metadata.delayedMaterials = V;
    let W = BABYLON.SceneSerializer.Serialize(this._scene);
    if (W.postProcesses = [], W.metadata && W.metadata.originalMeshMaterials) {
      const Q = JSON.parse(JSON.stringify(W.metadata.originalMeshMaterials));
      h.unsetAllDummyMaterials(), W.metadata.originalMeshMaterials = Q;
    }
    const U = {
      useDraco: this._dracoEnabled,
      forceDraco: o.getForceDracoCompression() ?? !1,
      dracoEncodingSpeed: this._dracoEncodingSpeed,
      dracoDecodingSpeed: this._dracoDecodingSpeed,
      excludedMeshes: [],
      delayMatarialLoading: Object.keys(V),
      offloadedMaterialIDs: Object.keys(M)
    };
    console.log(U), this.getSceneIncrementalFilesAsync(f, W, U, n).then(
      (Q) => {
        let D = new FormData();
        for (let J = 0; J < Q.length; J++) {
          const he = Q[J];
          let fe = he.name, X = he.data, Z = !1;
          !he.dracoEncoded && he.data.length > 180 && he.data.length < 45e4 && (Logger.info("Uncompressed file length: " + he.data.length), X = LZString.compressToUint8Array(he.data), Logger.info("Compressed file length: " + X.length), fe = "compressed_" + he.name, Z = !0);
          let qe;
          if (!he.dracoEncoded && !Z)
            qe = new Blob([X], { type: "text/plain" });
          else {
            var ee = X.buffer;
            qe = new Blob([ee]);
          }
          D.append("file_" + J, qe, fe);
        }
        fetch(o.getSceneIncrementalFileUploadUrl(), {
          method: "POST",
          headers: {
            Authorization: "Bearer " + this._authorizationToken
          },
          body: D
        }).then((J) => {
          if (!J.ok)
            throw new Error("HTTP error " + J.status);
          return J.json();
        }).then((J) => {
          e && e(J);
        }).catch(function(J) {
          t && t(J.message);
        }), v != Lr.Editor && this.setEnvironmentMode(v), this.enableAntialiasing(), this.createHighlightLayer(), this.setCameraRotationLimits(x);
      }
    );
  }
  // Utilizza il web worker MakeIncrementalFiles per ottenere i file incrementali (eventualmente codificati con Draco)
  async getSceneIncrementalFilesAsync(e, t, n, a) {
    let o = [];
    return this._incrementalFilesMaker || (this._incrementalFilesMaker = new ew(this._incrementalWorkersScriptsUrls)), this._incrementalFilesMaker && (await this._incrementalFilesMaker.whenReadyAsync(), o = await this._incrementalFilesMaker.getIncrementalFilesAsync(t, e, n)), o;
  }
  // Fine funzioni salvataggio scena
  // --------------------------------------------------------
  async setNewSceneModelAsync(e, t) {
    this._zkModel = e, this._zkScene = t, await this.init3DEngineAsync(), this.fireMeshesUpdateEvent(), this.fireMaterialsUpdateEvent(), this.fireLightsUpdateEvent(), this.fireCameraLocationsUpdateEvent();
  }
  getSceneConfig() {
    var e;
    return ((e = this._zkScene) == null ? void 0 : e.getSceneConfig()) ?? null;
  }
  preSceneFileLoading() {
    this.resetRealVisibility();
  }
  postSceneFileLoading() {
    this.fireSceneCreatedEvent(), this.fireMeshesUpdateEvent(), this.fireMaterialsUpdateEvent(), this.fireLightsUpdateEvent(), this.fireCameraLocationsUpdateEvent();
  }
  // ==============================================================================
  // Importazione Assets
  // ==============================================================================
  // I file "uploadati" dall'utente non vengono caricati immediatamente nella scena
  // ma viene creato un task di elaborazione lato server il cui stato verrà controllato tramite polling.
  // Per ogni task server di caricamento verrà creato un oggetto task lato client che è utile
  // per il recupero tramite polling delle informazioni.
  // I task lato client avranno uno degli stati:
  //   uploading         - Task avviato per l'uploading dei file
  //   progress          - Task in elaborazione
  //   checking          - Chimata Ajax di controllo stato in corso
  //   success           - Task server completato con successo, si possono importare i relativi file nella scena Babylon JS corrente
  //   completed_success - Task eseguito correttamente e file importati nella scena Babylon JS
  //   completed_error   - Task in errore, può essere eliminato dalla lista dei task da controllare
  loadSceneSourceFiles(e, t, n, a) {
    if (this._zkScene) {
      const x = this._zkScene, k = new FormData();
      if (t)
        k.append("url", t);
      else if (e) {
        for (let D = 0; D < e.length; D++)
          k.append("file-" + D, e[D]);
        var o = this._zkScene.getTexturesConfig();
        if (o) {
          var h = new Zakeke.SceneSourceTaskOptions();
          h.set("textures", o);
          var f = JSON.stringify(h), v = new Blob([f], {
            type: "application/json"
          });
          k.append("task-options", v, "task-options.json");
        }
      }
      const I = {
        downloadProgress: 0,
        uploadProgress: 0,
        status: 0,
        message: "",
        sceneSourceInfo: {},
        taskID: void 0,
        sourceID: void 0,
        meshes: []
      };
      this._sceneSourceTasks.push(I);
      const V = x.getSourceTasksUrl(), M = new Request(V, {
        method: "POST",
        headers: {
          Authorization: "Bearer " + this._authorizationToken
        },
        body: k
      }), W = (D) => {
        const ee = D.loaded / D.total;
        I.uploadProgress = ee * 100, this.fireSceneSourceTaskCheckEvent();
      }, U = (D) => {
        const ee = D.loaded / D.total;
        I.downloadProgress = ee * 100, this.fireSceneSourceTaskCheckEvent();
      }, Q = new XMLHttpRequest();
      Q.upload.addEventListener("progress", W), Q.addEventListener("progress", U), M.signal.addEventListener("fetch", () => Q.send()), fetch(M).then((D) => D.json()).then((D) => {
        D && D.hasOwnProperty("taskID") && D.hasOwnProperty("sourceID") ? (I.taskID = D.taskID, I.sourceID = D.sourceID, I.status = 1, this.fireSceneSourceTaskCheckEvent()) : Logger.info("task creation process did not go well"), n && n(I);
      }).catch((D) => {
        this._sceneSourceTasks = this._sceneSourceTasks.filter((ee) => {
        }), this.fireSceneSourceTaskCheckEvent(), a && a(D);
      }), this.fireSceneSourceTaskCheckEvent();
    }
  }
  // Il metodo viene richiamato ogni secondo per il controllo dei task di caricamento file
  // eventualmente presenti in coda
  checkSceneSourceTasks() {
    if (this._scene && this._zkScene && this._sceneSourceTasks && this._sceneSourceTasks.length > 0) {
      const t = this._zkScene;
      for (let n = 0; n < this._sceneSourceTasks.length; n++) {
        let a = this._sceneSourceTasks[n];
        if (a.status == 5 || a.status == 4) {
          this._sceneSourceTasks.splice(n--, 1), this.fireSceneSourceTaskCheckEvent();
          continue;
        }
        if (!(a.status == 2 || a.status == 0)) {
          if (a.status == 1) {
            a.status = 2;
            const o = (h) => {
              h.status = 5, this.fireSceneSourceTaskErrorEvent(h.taskID), this.fireSceneSourceTaskCheckEvent();
            };
            var e = async (h) => {
              try {
                const f = await fetch(t.getSourceTaskResultUrl(h.taskID), {
                  method: "GET",
                  cache: "no-cache",
                  headers: {
                    Authorization: "Bearer " + this._authorizationToken
                  }
                });
                if (f.ok) {
                  const v = await f.json();
                  if (v && v.hasOwnProperty("taskID") && v.hasOwnProperty("state") && v.hasOwnProperty("message") && v.hasOwnProperty("sourceFile"))
                    if (v.state == 2) {
                      h.sceneSourceInfo = {
                        sourceID: v.sourceFile.sourceID,
                        fileObjectID: v.sourceFile.fileObjectID,
                        fileLength: v.sourceFile.fileLength,
                        url: v.sourceFile.url,
                        rootUrl: v.sourceFile.rootUrl,
                        sceneFileName: v.sourceFile.sceneFileName,
                        textureFiles: []
                      };
                      for (let x = 0; x < v.sourceFile.textureFiles.length; x++)
                        h.sceneSourceInfo.textureFiles.push({
                          textureID: v.sourceFile.textureFiles[x].textureID,
                          fileObjectID: v.sourceFile.textureFiles[x].fileObjectID,
                          fileLength: v.sourceFile.textureFiles[x].fileLength,
                          url: v.sourceFile.textureFiles[x].url
                        });
                      h.status = 3;
                    } else
                      v.state == 3 ? o(h) : h.status = 1;
                  else
                    o(h);
                } else
                  o(h);
              } catch {
                o(h);
              }
            };
            e(a);
          }
          a.status == 3 && (this._isLoadingSourceFiles || (this._isLoadingSourceFiles = !0, a.sceneSourceInfo.rootUrl && a.sceneSourceInfo.sceneFileName ? (this.updateSceneModelFromSourceTask(a), this.loadMeshesFromRemoteFiles(
            a.sceneSourceInfo.rootUrl,
            a.sceneSourceInfo.sceneFileName,
            (o) => {
              o && Object.prototype.toString.call(o) === "[object Array]" && o.forEach((h) => {
                h.isPickable = !0;
              }), this._isLoadingSourceFiles = !1, this.fireSceneSourceTaskSuccessEvent(o), this.fireMeshesUpdateEvent(), this.fireMaterialsUpdateEvent(), this.fireLightsUpdateEvent(), a.meshes = o, a.status = 4;
            },
            (o) => {
              Logger.info("Errore nel caricamento delle mesh: " + o), this._isLoadingSourceFiles = !1, this.fireSceneSourceTaskErrorEvent(a.taskID), a.status = 5;
            }
          )) : (Logger.info("Risultato del task di caricamento non valido"), this._isLoadingSourceFiles = !1, this.fireSceneSourceTaskErrorEvent(a.taskID), a.status = 5), this.fireSceneSourceTaskCheckEvent()));
        }
      }
    }
    setTimeout(() => this.checkSceneSourceTasks(), 500);
  }
  updateSceneModelFromSourceTask(e) {
    if (this._zkScene) {
      const t = new Zakeke.SceneSource();
      t.set("sourceID", e.sceneSourceInfo.sourceID), t.set("fileObjectID", e.sceneSourceInfo.fileObjectID), t.set("fileLength", e.sceneSourceInfo.fileLength), t.set("url", e.sceneSourceInfo.url), t.set("rootUrl", e.sceneSourceInfo.rootUrl), t.set("sceneFileName", e.sceneSourceInfo.sceneFileName);
      for (let n = 0; n < e.sceneSourceInfo.textureFiles.length; n++) {
        const a = e.sceneSourceInfo.textureFiles[n];
        if (a.textureID && (a.fileObjectID || a.fileLength) && a.url) {
          const o = new Zakeke.SceneSourceTexture();
          o.set("textureID", a.textureID), o.set("fileObjectID", a.fileObjectID), o.set("fileLength", a.fileLength), o.set("url", a.url), t.get("textures").push(o);
        }
      }
      this._zkScene.get("sources").push(t);
    }
  }
  // Carica i file provenienti da una sorgente nella scena Babylon JS corrente
  // Ad ogni mesh e ad ogni materiale viene assegnato un identificativo univoco (GUID).
  // Inoltre tutte le mesh vengono inserite in un nuovo gruppo il cui nome deriva da quello
  // del file di scena
  loadMeshesFromRemoteFiles(e, t, n, a) {
    if (!this._scene || !this._sceneHelper) {
      a && a("No scene to fill with imported meshes");
      return;
    }
    this._scene;
    const o = this._sceneHelper;
    let h = e + t;
    o.importMeshesFromUrlAsync(h, null, void 0).then(async (f) => (Logger.info("Uploading embedded textures..."), await this.uploadEmbeddedTexturesAsync(), f)).then((f) => (Logger.info("File imported successfully."), this.checkSceneEmptyEnvironmentTexture(), this.refreshEnvironment(), f)).then((f) => {
      Logger.info("Operation completed successfully."), n == null || n(f);
    }).catch((f) => {
      Logger.info("Error loading file"), a && a(f);
    }), Logger.info("loading finished");
  }
  // Carica i file provenienti da una sorgente nella scena Babylon JS corrente
  // Ad ogni mesh e ad ogni materiale viene assegnato un identificativo univoco (GUID).
  // Inoltre tutte le mesh vengono inserite in un nuovo gruppo il cui nome deriva da quello
  // del file di scena
  loadMeshesFromRemoteFiles_OLD(e, t, n, a) {
    if (!this._scene || !this._sceneHelper) {
      a && a("No scene to fill with imported meshes");
      return;
    }
    const o = this._scene, h = this._sceneHelper;
    let f = t, v = t.lastIndexOf(".");
    v !== -1 && (f = t.substr(0, v));
    const x = this._scene.materials.map((M) => M.id);
    let k;
    BABYLON.GLTFFileLoader.IncrementalLoading = !1, BABYLON.SceneLoader.OnPluginActivatedObservable.add((M) => {
      k = M.name;
    });
    const I = new BABYLON.AssetsManager(this._scene), V = I.addMeshTask("mesh-task", "", e, t);
    V.onSuccess = (M) => {
      Logger.info("task completed successfully");
      const W = M.loadedMeshes, U = new BABYLON.Mesh(f, o);
      U.id = Zakeke.generateUUID(), U.metadata = {
        isRealMesh: !0,
        isGroup: !0
      }, W.forEach((Q) => {
        Q.parent || (Q.parent = U), Q.material || (Q.material = new BABYLON.StandardMaterial(Q.name + "Mat", o)), Q.id = Zakeke.generateUUID();
      }), o.materials.forEach((Q) => {
        ra(x, Q.id) || (Q.id = Zakeke.generateUUID());
      }), this.checkSceneEmptyEnvironmentTexture(), this.refreshEnvironment(), h.adjustCamera(k, !1, !1), h.setupShaderMaterialsCameraPosition(), n && n(W);
    }, V.onError = (M, W, U) => {
      Logger.info("task completed with errors"), a && a(W);
    }, I.onFinish = function() {
      Logger.info("loading finished");
    }, I.load();
  }
  // Fine importazione Assets
  // ==============================================================================
  isRealMesh(e) {
    return this._sceneHelper ? this._sceneHelper.isRealMesh(e) : !1;
  }
  onMeshChanged(e) {
    this.updateBoundingBox(), this.setRenderingNeeded();
  }
  onSubMeshChanged(e) {
    this.updateBoundingBox(), this.setRenderingNeeded();
  }
  onMaterialChanged(e) {
    this.setRenderingNeeded();
  }
  onLightChanged(e) {
    this.setRenderingNeeded();
  }
  getSceneMeshesByName(e) {
    return this._sceneHelper ? this._sceneHelper.getSceneMeshesByName(e) : [];
  }
  getSceneMeshes() {
    return this._sceneHelper ? this._sceneHelper.getSceneMeshes() : [];
  }
  getMeshesUsingMaterial(e) {
    return this._sceneHelper ? this._sceneHelper.getMeshesUsingMaterial(e) : [];
  }
  getMeshesMaterials(e) {
    return this._sceneHelper ? this._sceneHelper.getMeshesMaterials(e) : [];
  }
  getMeshMaterials(e) {
    return this._sceneHelper ? this._sceneHelper.getMeshMaterials(e) : [];
  }
  getAllMaterials() {
    return this._sceneHelper ? this._sceneHelper.getAllMaterials() : [];
  }
  // restituisce un array di gruppi di materiali
  // ogni gruppo è del tipo MaterialGroup, con proprietà
  // "group"(nome del gruppo)
  // "materials"(elenco materiali)
  getGroupedMaterials() {
    const e = [], t = {}, n = this.getAllMaterials();
    for (let a = 0; a < n.length; a++) {
      let o = n[a];
      if (o.id == "groundMaterial")
        continue;
      const h = this.getMaterialGroup(o.id);
      let f = null;
      t.hasOwnProperty(h) ? f = t[h] : (f = new s1(h), e.push(f), t[h] = f), f && f.materials.push(o);
    }
    return e.sort(function(a, o) {
      var h = a.groupName.toLowerCase(), f = o.groupName.toLowerCase();
      return h < f ? -1 : h > f ? 1 : 0;
    });
  }
  // Assegna il gruppo ad un array di materiali
  setMaterialsGroup(e, t, n = !0) {
    for (let a = 0; a < e.length; a++) {
      const o = e[a];
      this.setMaterialGroup(o, t, n);
    }
  }
  // Assegna il gruppo ad un singolo materiale
  setMaterialGroup(e, t, n = !0) {
    !this._scene || !this._scene.getMaterialByID(e) || (this._scene.metadata || (this._scene.metadata = {}), this._scene.metadata.groups || (this._scene.metadata.groups = {}), this._scene.metadata.groups[e] = t, n && this.fireMaterialsUpdateEvent());
  }
  // Restituisce il gruppo di un materiale
  getMaterialGroup(e) {
    return this._scene && this._scene.metadata && this._scene.metadata.groups && this._scene.metadata.groups.hasOwnProperty(e) ? this._scene.metadata.groups[e] : ul.EmptyGroupName;
  }
  // Elimina il gruppo di un materiale
  removeMaterialGroup(e) {
    this._scene && this._scene.metadata && this._scene.metadata.groups && this._scene.metadata.groups.hasOwnProperty(e) && (delete this._scene.metadata.groups[e], this.fireMaterialsUpdateEvent());
  }
  getMaterialsByGroup(e) {
    const t = [], n = e || ul.EmptyGroupName;
    return this._scene && this._sceneHelper && this._sceneHelper.getAllMaterials().forEach((a) => {
      this.getMaterialGroup(a.id) === n && t.push(a);
    }), t;
  }
  getGroupCenter(e) {
    return this._sceneHelper ? this._sceneHelper.getMeshHierarchyCenter(e) : null;
  }
  getGroupBoundingInfo(e) {
    let t = e.getHierarchyBoundingVectors(!0);
    return new BABYLON.BoundingInfo(t.min, t.max);
  }
  showHideBoundingBox(e) {
    this._showBoundingBox = e, this.updateBoundingBox(), this.setRenderingNeeded();
  }
  updateBoundingBox() {
    this.deleteBoundingBox(), this.showBoundingBox && this.createSceneBoundingBox(!0);
  }
  deleteBoundingBox() {
    let e = this.getSceneBoundingBox();
    e && e.dispose();
  }
  setCameraPositionScale(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraPositionScale(e), this._sceneHelper.setCameraPositionScale(e, !0), this.setRenderingNeeded());
  }
  setCameraPositionFOV(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraPositionFOV(e), this._sceneHelper.setCameraPositionFOV(e), this.setRenderingNeeded());
  }
  setCameraLimitLowerRadius(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraLimitLowerRadius(e), this._sceneHelper.setCameraLimitLowerRadius(e, !0), this.setRenderingNeeded());
  }
  setCameraZoomEnabled(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraZoomEnabled(e), this._sceneHelper.setZoomEnabled(e), this.setRenderingNeeded());
  }
  setCameraUseMinZoomPercentage(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraUseMinZoomPerc(e), this._sceneHelper.setMinZoomPerc(e ? this._zkScene.getCameraMinZoomPerc() : void 0), this.setRenderingNeeded());
  }
  setCameraMinZoomPercentage(e) {
    if (this._zkScene && this._sceneHelper) {
      this._zkScene.setCameraMinZoomPerc(e);
      var t = this._zkScene.getCameraUseMinZoomPerc();
      this._sceneHelper.setMinZoomPerc(t ? e : void 0), this.setRenderingNeeded();
    }
  }
  setCameraUseMaxZoomPercentage(e) {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraUseMaxZoomPerc(e), this._sceneHelper.setMaxZoomPerc(e ? this._zkScene.getCameraMaxZoomPerc() : void 0), this.setRenderingNeeded());
  }
  setCameraMaxZoomPercentage(e) {
    if (this._zkScene && this._sceneHelper) {
      this._zkScene.setCameraMaxZoomPerc(e);
      const t = this._zkScene.getCameraUseMaxZoomPerc();
      this._sceneHelper.setMaxZoomPerc(t ? e : void 0), this.setRenderingNeeded();
    }
  }
  lockCameraAlphaAngle() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const e = this._camera.alpha ?? 0;
      this._zkScene.setCameraLowerAlphaLimit(e), this._zkScene.setCameraUpperAlphaLimit(e), this._sceneHelper.setCameraAlphaLimits(e, e), this.setRenderingNeeded();
    }
  }
  unlockCameraAlphaAngle() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraLowerAlphaLimit(null), this._zkScene.setCameraUpperAlphaLimit(null), this._sceneHelper.setCameraAlphaLimits(null, null), this.setRenderingNeeded());
  }
  lockCameraBetaAngle() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      var e = this._camera.beta ?? -1.57;
      this._zkScene.setCameraLowerBetaLimit(e), this._zkScene.setCameraUpperBetaLimit(e), this._sceneHelper.setCameraBetaLimits(e, e), this.setRenderingNeeded();
    }
  }
  unlockCameraBetaAngle() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraLowerBetaLimit(null), this._zkScene.setCameraUpperBetaLimit(null), this._sceneHelper.setCameraBetaLimits(null, null), this.setRenderingNeeded());
  }
  setCameraLowerAlphaLimit() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const e = this._camera.alpha;
      this._zkScene.setCameraLowerAlphaLimit(e), this._sceneHelper.setCameraLowerAlphaLimit(e), this.setRenderingNeeded();
    }
  }
  unsetCameraLowerAlphaLimit() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraLowerAlphaLimit(null), this._sceneHelper.setCameraLowerAlphaLimit(null), this.setRenderingNeeded());
  }
  setCameraUpperAlphaLimit() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      var e = this._camera.alpha;
      this._zkScene.setCameraUpperAlphaLimit(e), this._sceneHelper.setCameraUpperAlphaLimit(e), this.setRenderingNeeded();
    }
  }
  unsetCameraUpperAlphaLimit() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraUpperAlphaLimit(null), this._sceneHelper.setCameraUpperAlphaLimit(null), this.setRenderingNeeded());
  }
  setCameraLowerBetaLimit() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const e = this._camera.beta;
      this._zkScene.setCameraLowerBetaLimit(e), this._sceneHelper.setCameraLowerBetaLimit(e), this.setRenderingNeeded();
    }
  }
  unsetCameraLowerBetaLimit() {
    this._zkScene && this._zkScene && this._sceneHelper && (this._zkScene.setCameraLowerBetaLimit(null), this._sceneHelper.setCameraLowerBetaLimit(null), this.setRenderingNeeded());
  }
  setCameraUpperBetaLimit() {
    if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const e = this._camera.beta;
      this._zkScene.setCameraUpperBetaLimit(e), this._sceneHelper.setCameraUpperBetaLimit(e), this.setRenderingNeeded();
    }
  }
  unsetCameraUpperBetaLimit() {
    this._zkScene && this._sceneHelper && (this._zkScene.setCameraUpperBetaLimit(null), this._sceneHelper.setCameraUpperBetaLimit(null), this.setRenderingNeeded());
  }
  // Mesh selection overrides (the selection logic si a little bit different
  // respect the parent SceneViewer one)
  selectMesh(e) {
    this.selectUnselectMesh(e, !0);
  }
  unselectMesh(e) {
    this.selectUnselectMesh(e, !1);
  }
  unselectAllMeshes() {
    this._scene && this._scene.meshes.forEach((e) => this.unselectSingleMesh(e));
  }
  selectUnselectMesh(e, t) {
    if (this._scene) {
      if (this.deleteBoundingBox(), this.unselectAllMeshes(), t) {
        const n = (o) => {
          this.selectSingleMesh(o), o.getChildMeshes().forEach((h) => n(h));
        };
        let a = this._scene.getMeshByID(e);
        this._isSelectionMode || (a = this.getDAMMainMesh() ?? a), a && n(a), this.setManipulatedNode(a);
      } else
        this.setManipulatedNode(null);
      this.fireSelectionChangedEvent();
    }
  }
  selectSingleMesh(e) {
    e.selected = !0, this.highlightMesh(e, !0), this.setRenderingNeeded();
  }
  unselectSingleMesh(e) {
    e.selected = !1, this.highlightMesh(e, !1), this.setRenderingNeeded();
  }
  isMeshSelected(e) {
    return e && e.selected != null && e.selected;
  }
  // Show-hide mesh methods
  showMesh(e) {
    this.resetRealVisibility(), this.showHideMesh(e, !0, !0);
  }
  hideMesh(e) {
    this.resetRealVisibility(), this.showHideMesh(e, !1, !0);
  }
  showHideMesh(e, t, n = !0) {
    var a;
    if (this._scene && this._sceneHelper && this._camera) {
      this._scene;
      const o = this._sceneHelper, h = this._camera, f = (k, I) => {
        k.isVisible = I, Logger.info(k.name), k.getChildMeshes().forEach((V) => f(V, I));
      }, v = (k, I) => {
        f(k, I), !(o && h && k.metadata && k.metadata.isGroup && k.getChildMeshes().length === 0) && I && !h.isCompletelyInFrustum(k) && (o.adjustCamera(void 0, !1, !1), o.setupShaderMaterialsCameraPosition()), n && this.fireMeshesUpdateEvent(), this.setRenderingNeeded();
      }, x = this._scene.getMeshByID(e);
      if (x) {
        const k = (a = this._zkScene) == null ? void 0 : a.get("rootUrl");
        k ? o.unsetMeshDummyMaterialAsync(x, k, !0).then(() => v(x, t)) : v(x, t);
      }
      this.refreshInfoPoints();
    }
  }
  // Permette di mostrare esclusivamente la mesh selezionata (e i suoi figli)
  // Lo stato precedente delle mesh viene memorizzato in modo da poter essere
  // ripristinato con la funzione resetRealVisibility
  setTemporaryExclusivelyVisible(e) {
    this._scene && (this.resetRealVisibility(), this._realMeshVisibility = {}, this._scene.meshes.forEach((t) => {
      this._realMeshVisibility[t.id] = t.isVisible, this.isRealMesh(t) && (t.isVisible = !1);
    }), this.showHideMesh(e, !0, !1));
  }
  // Reimposto lo stato di visibilità come era precedentemente alla chiamata
  // a setTempraryExclusiveVisible
  resetRealVisibility() {
    this._scene && this._sceneHelper && this._realMeshVisibility && (this._sceneHelper.getSceneMeshes().forEach((t) => {
      this._realMeshVisibility.hasOwnProperty(t.id) && (t.isVisible = this._realMeshVisibility[t.id]);
    }), this.setRenderingNeeded());
  }
  // Funzione per modificare il colore di un materiale in modo progressivo (tramite animazione)
  changeMaterialColor(e, t, n) {
    this._sceneHelper && this._sceneHelper.changeMaterialColor(e, t, n);
  }
  renameMesh(e, t) {
    if (this._scene) {
      const n = this._scene.getMeshByID(e);
      n && (n.name = t, this.fireMeshesUpdateEvent());
    }
  }
  //#region Events
  // PreUpdateEvent
  firePreUpdateEvent() {
    this._preUpdateListeners.forEach((e) => e());
  }
  addPreUpdateListener(e) {
    this._preUpdateListeners.push(e);
  }
  removePreUpdateListener(e) {
    for (let t = 0; t < this._preUpdateListeners.length; t++)
      if (this._preUpdateListeners[t] == e) {
        this._preUpdateListeners.splice(t--, 1);
        break;
      }
  }
  // PostUpdateEvent
  firePostUpdateEvent() {
    this._postUpdateListeners.forEach((e) => e());
  }
  addPostUpdateListener(e) {
    this._postUpdateListeners.push(e);
  }
  removePostUpdateListener(e) {
    for (let t = 0; t < this._postUpdateListeners.length; t++)
      if (this._postUpdateListeners[t] == e) {
        this._postUpdateListeners.splice(t--, 1);
        break;
      }
  }
  // MeshSelected
  fireMeshSelectedEvent(e) {
    this._meshSelectedListeners.forEach((t) => t(e));
  }
  addMeshSelectedListener(e) {
    this._meshSelectedListeners.push(e);
  }
  removeMeshSelectedListener(e) {
    const t = this._meshSelectedListeners.indexOf(e);
    t != -1 && this._meshSelectedListeners.splice(t, 1);
  }
  // SelectionChanged
  fireSelectionChangedEvent() {
    this._selectionChangedListeners.forEach((e) => e());
  }
  addSelectionChangedListener(e) {
    this._selectionChangedListeners.push(e);
  }
  removeSelectionChangedListener(e) {
    const t = this._selectionChangedListeners.indexOf(e);
    t != -1 && this._selectionChangedListeners.splice(t, 1);
  }
  // LightsSelected
  fireLightSelectedEvent(e) {
    this._lightSelectedListeners.forEach((t) => t(e));
  }
  addLightSelectedListener(e) {
    this._lightSelectedListeners.push(e);
  }
  // SceneCreated
  fireSceneCreatedEvent() {
    this._sceneCreatedListeners.forEach((e) => e());
  }
  addSceneCreatedListener(e) {
    this._sceneCreatedListeners.push(e);
  }
  // CameraLocationCreated
  fireCameraLocationCreatedEvent(e) {
    this._cameraLocationCreatedListeners.forEach((t) => t(e));
  }
  addCameraLocationCreatedListener(e) {
    this._cameraLocationCreatedListeners.push(e);
  }
  // CameraLocationsUpdate
  fireCameraLocationsUpdateEvent(e) {
    if (!e && this._scene && (e = this.getAllCameraLocations()), !e)
      throw "Failed firing positions update event: lights are null and no scene present";
    this._cameraLocationsUpdateListeners.forEach((t) => t(e));
  }
  addCameraLocationsUpdateListener(e) {
    this._cameraLocationsUpdateListeners.push(e);
  }
  removeCameraLocationsUpdateListener(e) {
    const t = this._cameraLocationsUpdateListeners.indexOf(e);
    t != -1 && this._cameraLocationsUpdateListeners.splice(t, 1);
  }
  // SceneSourceTaskSuccess
  fireSceneSourceTaskSuccessEvent(e) {
    this._sceneSourceTaskSuccessListeners.forEach((t) => t(e));
  }
  addSceneSourceTaskSuccessListener(e) {
    this._sceneSourceTaskSuccessListeners.push(e);
  }
  // SceneSourceTaskError
  fireSceneSourceTaskErrorEvent(e) {
    this._sceneSourceTaskErrorListeners.forEach((t) => t(e));
  }
  addSceneSourceTaskErrorListener(e) {
    this._sceneSourceTaskErrorListeners.push(e);
  }
  removeSceneSourceTaskErrorListener(e) {
    const t = this._sceneSourceTaskErrorListeners.indexOf(e);
    t != -1 && this._sceneSourceTaskErrorListeners.splice(t, 1);
  }
  // SceneSourceTaskCheck
  fireSceneSourceTaskCheckEvent() {
    this._sceneSourceTasksCheckListeners.forEach((e) => e());
  }
  addSceneSourceTaskCheckListener(e) {
    this._sceneSourceTasksCheckListeners.push(e);
  }
  removeSceneSourceTaskCheckListener(e) {
    const t = this._sceneSourceTasksCheckListeners.indexOf(e);
    t != -1 && this._sceneSourceTasksCheckListeners.splice(t, 1);
  }
  // MeshesUpdate
  fireMeshesUpdateEvent(e) {
    if (!e && this._scene && (e = this.getSceneMeshes()), !e)
      throw "Failed firing mesh update event: meshes are null and no scene present";
    this._meshesUpdateListeners.forEach((t) => t(e));
  }
  addMeshesUpdateListener(e) {
    this._meshesUpdateListeners.push(e);
  }
  removeMeshesUpdateListener(e) {
    const t = this._meshesUpdateListeners.indexOf(e);
    t != -1 && this._meshesUpdateListeners.splice(t, 1);
  }
  // MaterialsUpdate
  fireMaterialsUpdateEvent(e) {
    if (!e && this._scene && (e = this.getGroupedMaterials()), !e)
      throw "Failed firing materials update event: materials are null and no scene present";
    this._materialsUpdateListeners.forEach((t) => t(e));
  }
  addMaterialsUpdateListener(e) {
    this._materialsUpdateListeners.push(e);
  }
  removeMaterialsUpdateListener(e) {
    const t = this._materialsUpdateListeners.indexOf(e);
    t != -1 && this._materialsUpdateListeners.splice(t, 1);
  }
  // LightsUpdate
  fireLightsUpdateEvent(e) {
    if (!e && this._scene && (e = this.getAllLights()), !e)
      throw "Failed firing lights update event: lights are null and no scene present";
    this._lightsUpdateListeners.forEach((t) => t(e));
  }
  addLightsUpdateListener(e) {
    this._lightsUpdateListeners.push(e);
  }
  removeLightsUpdateListener(e) {
    const t = this._lightsUpdateListeners.indexOf(e);
    t != -1 && this._lightsUpdateListeners.splice(t, 1);
  }
  // MeshLocationCreated
  fireMeshLocationCreatedEvent(e) {
    this._meshLocationCreatedListeners.forEach((t) => t(e));
  }
  addMeshLocationCreatedListener(e) {
    this._meshLocationCreatedListeners.push(e);
  }
  // MeshLocationsUpdate
  fireMeshLocationsUpdateEvent(e) {
    if (!e && this._scene && (e = this.getAllMeshLocations()), e)
      this._meshLocationsUpdateListeners.forEach((t) => t(e));
    else
      throw "Failed firing mesh positions update event: positions are null and no scene present";
  }
  addMeshLocatonsUpdateListener(e) {
    this._meshLocationsUpdateListeners.push(e);
  }
  // ArTaskSuccess
  fireArTaskSuccessEvent() {
    this._arTaskSuccessListeners.forEach((e) => e());
  }
  addArTaskSuccessListener(e) {
    this._arTaskSuccessListeners.push(e);
  }
  // ArTaskError
  fireArTaskErrorEvent() {
    this._arTaskErrorListeners.forEach((e) => e());
  }
  addArTaskErrorListener(e) {
    this._arTaskErrorListeners.push(e);
  }
  // ArTaskCheck
  fireArTaskCheckEvent() {
    this._arTasksCheckListeners.forEach((e) => e());
  }
  addArTaskCheckListener(e) {
    this._arTasksCheckListeners.push(e);
  }
  fireFineTuningSettingEvent(e) {
    this._tryOnFineTuningSettingListeners.forEach((t) => t(e));
  }
  addFineTuningSettingListener(e) {
    return this._tryOnFineTuningSettingListeners.push(e), this._tryOnFineTuningSettingListeners.length - 1;
  }
  removeFineTuningSettingListener(e) {
    this._tryOnFineTuningSettingListeners.splice(e, 1);
  }
  removeAllFineTuningSettingListeners() {
    this._tryOnFineTuningSettingListeners = [];
  }
  fireFineTuningCloseEvent() {
    this._tryOnFineTuningCloseListeners.forEach((e) => e());
  }
  addFineTuningCloseListener(e) {
    this._tryOnFineTuningCloseListeners.push(e);
  }
  // Clear
  clearListeners() {
    this._meshSelectedListeners = [], this._selectionChangedListeners = [], this._lightSelectedListeners = [], this._sceneCreatedListeners = [], this._cameraLocationCreatedListeners = [], this._sceneSourceTaskSuccessListeners = [], this._sceneSourceTaskErrorListeners = [], this._sceneSourceTasksCheckListeners = [], this._meshesUpdateListeners = [], this._materialsUpdateListeners = [], this._lightsUpdateListeners = [], this._cameraLocationsUpdateListeners = [], this._meshLocationCreatedListeners = [], this._meshLocationsUpdateListeners = [], this._arTaskSuccessListeners = [], this._arTaskErrorListeners = [], this._arTasksCheckListeners = [], this._tryOnFineTuningSettingListeners = [], this._tryOnFineTuningCloseListeners = [];
  }
  //#endregion
  //#region Interazione utente (Pointer Down/Move)
  onPointerDown(e, t) {
    if (!(!this._scene || !this._sceneHelper || this._envMode != Lr.Editor) && this._selectOnPick && t && t.hit && t.pickedMesh && t.pickedMesh !== this._ground) {
      this.selectMesh(t.pickedMesh.id);
      const n = this.convertSceneToScreenPoint(this._scene.pointerX, this._scene.pointerY);
      if (n) {
        const a = {
          name: t.pickedMesh.name,
          id: t.pickedMesh.id,
          scenePointerX: this._scene.pointerX,
          scenePointerY: this._scene.pointerY,
          screenPointerX: n.X,
          screenPointerY: n.Y
        };
        this.fireMeshSelectedEvent(a);
      }
    }
  }
  onPointerMove(e, t) {
    if (!this._scene || !this._sceneHelper || this._envMode != Lr.Editor)
      return;
    if (this.highlightMeshOver(!1), !this._highlightOver) {
      this._meshOver = null;
      return;
    }
    const n = this._scene.pick(this._scene.pointerX, this._scene.pointerY);
    n && n.hit && n.pickedMesh && this._sceneHelper.isRealMesh(n.pickedMesh) && (this._meshOver = n.pickedMesh, this.highlightMeshOver(!0));
  }
  //#endregion
  //#region Element Selection
  getSubMesh(e, t) {
    return this._sceneHelper ? this._sceneHelper.getSubMesh(e, t) : null;
  }
  getLightByID(e) {
    return this._scene ? this._scene.getLightByID(e) : null;
  }
  //#endregion
  //#region Apply material
  applyMaterialByName(e, t) {
    this._sceneHelper && this._sceneHelper.applyMaterialByName(e, t);
  }
  applyMaterial(e, t) {
    this._sceneHelper && (this._sceneHelper.applyMaterial(e, t), this.setLongRenderingNeeded());
  }
  applyMaterialToSubMeshByName(e, t, n) {
    this._sceneHelper && this._sceneHelper.applyMaterialToSubMeshByName(e, t, n);
  }
  applyMaterialToSubMesh(e, t, n) {
    this._sceneHelper && this._sceneHelper.applyMaterialToSubMesh(e, t, n);
  }
  resetMeshMaterial(e, t) {
    t ? this._initialMeshMaterials : this._lastMeshMaterials;
  }
  resetSubMeshMaterial(e, t, n) {
    const a = n ? this._initialSubMeshMaterials : this._lastSubMeshMaterials;
    if (e && t && e.material instanceof BABYLON.MultiMaterial) {
      const o = t.materialIndex;
      if (o >= 0 && o < e.material.subMaterials.length) {
        const h = `${e.id}_${o}`;
        if (a.hasOwnProperty(h)) {
          const f = a[h], v = this.getMaterialByID(f);
          v && (e.material.subMaterials[o] = v);
        }
      }
    }
    this.setRenderingNeeded();
  }
  //#endregion
  getExtension(e) {
    var t = e.lastIndexOf(".");
    if (t !== -1) {
      var n = e.substring(t).toLowerCase();
      return n;
    }
  }
  //#region Caricamento texture da file esterni
  loadMobileTextureFilesAsync(e, t, n, a) {
    return new Promise((o, h) => {
      this.loadMobileTextureFiles(
        e,
        t,
        n,
        a,
        () => o(),
        (f) => h()
      );
    });
  }
  loadMobileTextureFiles(e, t, n, a, o, h) {
    const f = e.length === 6 || this.getExtension(e[0].name) === ".dds" || this.getExtension(e[0].name) === ".hdr" || this.getExtension(e[0].name) === ".env" || this.getExtension(e[0].name) === ".basis";
    this.uploadTextureFiles(
      e,
      t,
      n,
      (v) => {
        v.length > 0 && (f ? this.setMobileCubeTextureImages(v, t, n) : this.setMobileTextureImage(v[0], t, n, a)), o && o();
      },
      h,
      !1
    );
  }
  loadTextureFilesAsync(e, t, n, a) {
    return new Promise((o, h) => {
      this.loadTextureFiles(
        e,
        t,
        n,
        a,
        () => o(),
        (f) => h(f)
      );
    });
  }
  // Per il caso di texture di ambiente si suppone che material sia null e che type sia
  // uno di "environment", "skybox", "ground"
  loadTextureFiles(e, t, n, a, o, h) {
    const f = e.length === 6 || this.getExtension(e[0].name) === ".dds" || this.getExtension(e[0].name) === ".hdr" || this.getExtension(e[0].name) === ".env" || this.getExtension(e[0].name) === ".basis";
    this.uploadTextureFiles(
      e,
      t,
      n,
      async (v) => {
        var x, k, I;
        if (v.length > 0) {
          if (f)
            await this.setCubeTextureImages(v, t, n);
          else {
            await this.setTextureImage(v[0], t, n, a);
            const M = ((W) => {
              const U = {
                clearCoat_textureRoughness: "textureRoughness",
                clearCoat_bump: "bumpTexture",
                clearCoat_tint: "tintTexture",
                clearCoat_texture: "texture",
                sheen_texture: "texture",
                sheen_textureRoughness: "textureRoughness",
                anisotropy_texture: "texture",
                subSurface_thickness: "thicknessTexture",
                subSurface_refractionIntensity: "refractionIntensityTexture",
                subSurface_translucencyIntensity: "translucencyIntensityTexture"
              };
              return U[W] ? U[W] : W.toLowerCase().includes("texture") ? "texture" : W.split("_")[1] + "Texture";
            })(n);
            (!n.includes("sheen") && !n.includes("clearCoat") && !n.includes("subSurface") && !n.includes("anisotropy") && (!t[n + "Texture"].metadata || !t[n + "Texture"].metadata.mobileUrl) || !((x = t[n.split("_")[0]][M]) != null && x.metadata) || !((I = (k = t[n.split("_")[0]][M]) == null ? void 0 : k.metadata) != null && I.mobileUrl)) && await new Promise(async (W) => {
              this.uploadTextureFiles(
                e,
                t,
                n,
                async (U) => {
                  this.setMobileTextureImage(U[0], t, n, a), W();
                },
                h,
                !0
              );
            });
          }
          o && o();
        }
      },
      h,
      !1
    );
  }
  getRecursiveBoundingBox(e) {
    this.calculateRecursiveBoundingBox(e);
    const t = e.getBoundingInfo().boundingBox.scale(2);
    return e.setBoundingInfo(new BABYLON.BoundingInfo(BABYLON.Vector3.Zero(), BABYLON.Vector3.Zero())), new BABYLON.BoundingBox(t.minimum, t.maximum);
  }
  calculateRecursiveBoundingBox(e) {
    const t = (a) => {
      a.refreshBoundingInfo();
      for (const o of a.getChildMeshes(!0))
        t(o);
    };
    t(e);
    const n = e.getHierarchyBoundingVectors(!0);
    e.setBoundingInfo(new BABYLON.BoundingInfo(n.min, n.max));
  }
  calculateBoundingBox(e) {
    let { min: t, max: n } = e[0].getHierarchyBoundingVectors(!1);
    for (let a = 1; a < e.length; a++) {
      const o = e[a].getHierarchyBoundingVectors(!1);
      t = BABYLON.Vector3.Minimize(t, o.min), n = BABYLON.Vector3.Maximize(n, o.max);
    }
    return new BABYLON.BoundingBox(t, n).extendSizeWorld.length();
  }
  // VERIFICA SE CI SONO MESH CHE SUPERANO I BOUNDS DELLE MESH DI RIFERIMENTO
  // Ritorna 1 se la mesh supera il volume di tutte le altre mesh
  // Ritorna -1 se la mesh è superata da almeno una delle altre mesh
  // Ritorna 0 se la mesh non supera il volume di nessuna delle altre mesh o se il volume è simile
  //maxThreshold percentuale di sensibilità del controllo
  //minThreshold aumentondolo aumenta la sensibilità del controllo
  checkMeshHiddenByMeshes(e, t, n, a) {
    const o = this.calculateBoundingBox(t), h = this.calculateBoundingBox(e);
    return h - h * n > o ? 1 : h + h * a < o ? -1 : 0;
  }
  uploadTextureFileAsync(e, t) {
    return new Promise((n, a) => {
      if (!this._scene || !this._zkScene || !e) {
        n(null);
        return;
      }
      const o = t ? t.id : Zakeke.getEmptyUUID(), h = (x) => {
        if (this._zkScene && x && x.textureID && x.materialID && (x.fileObjectID || x.fileLength) && x.url) {
          const k = new Zakeke.SceneTexture();
          return k.set("textureID", x.textureID), k.set("materialID", x.materialID), k.set("fileObjectID", x.fileObjectID), k.set("fileLength", x.fileLength), k.set("url", x.url), this._zkScene.get("textures").push(k), k;
        }
        return null;
      }, f = new FormData();
      f.append("file", e);
      const v = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${this._authorizationToken}`
        },
        body: f
      };
      fetch(this.getTexturesUploadUrl(o), v).then((x) => {
        if (x.ok)
          return x.json();
        throw new Error("An error occurred");
      }).then((x) => {
        if (Array.isArray(x)) {
          const k = h(x[0]);
          k ? n(k) : a("Invalid image");
        } else
          a("Invalid image");
      }).catch((x) => {
        a("An error occurred: " + x.message);
      });
    });
  }
  async uploadTextureFiles(e, t, n, a, o, h) {
    if (!this._scene || !this._zkScene || !e || e.length == 0)
      return;
    const f = t ? t.id : Zakeke.getEmptyUUID(), v = (J) => {
      if (this._zkScene && J && J.textureID && J.materialID && (J.fileObjectID || J.fileLength) && J.url) {
        const he = new Zakeke.SceneTexture();
        return he.set("textureID", J.textureID), he.set("materialID", J.materialID), he.set("fileObjectID", J.fileObjectID), he.set("fileLength", J.fileLength), he.set("url", J.url), this._zkScene.get("textures").push(he), he;
      }
      return null;
    }, x = (J) => {
      const he = J.lastIndexOf(".");
      return he !== -1 ? J.substring(he) : null;
    }, k = (J, he) => {
      const fe = J.lastIndexOf(".");
      return fe !== -1 ? J.substring(0, fe).endsWith("_" + he) : !1;
    }, I = x(e[0].name), V = this.canLoadCubemap(t, n) && (e.length == 6 || I === ".dds" || I === ".hdr" || I === ".env" || I === ".basis"), M = [];
    if (V && e.length == 6) {
      const J = ["px", "py", "pz", "nx", "ny", "nz"];
      for (let he = 0; he < e.length; he++) {
        const fe = e[he];
        let X = -1;
        for (let Z = 0; Z < J.length; Z++)
          if (k(fe.name, J[Z])) {
            M.push(fe), X = Z;
            break;
          }
        X !== -1 && J.splice(X, 1);
      }
      if (J.length != 0) {
        const he = "Immagini per la cube map non valide";
        o && o(he), Logger.info(he);
        return;
      }
    } else
      M.push(e[0]);
    const W = new FormData();
    for (let J = 0; J < M.length; J++)
      W.append("file-" + J, M[J]);
    var U = this._zkScene.getTexturesConfig();
    if (U) {
      var Q = JSON.stringify(U), D = new Blob([Q], {
        type: "application/json"
      });
      W.append("options", D, "options.json");
    }
    W.forEach((J) => console.log("File: ", J));
    const ee = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${this._authorizationToken}`
        // 'Content-Type': 'multipart/form-data',
      },
      body: W
    };
    fetch(this.getTexturesUploadUrl(f) + "?resize=" + h, ee).then((J) => {
      if (!J.ok)
        throw new Error("An error occurred: " + J.status);
      return J.json();
    }).then((J) => {
      const he = [];
      if (Object.prototype.toString.call(J) === "[object Array]")
        for (let fe = 0; fe < J.length; fe++) {
          const X = v(J[fe]);
          if (!X) {
            const Z = "Immagini non valide";
            if (o) {
              o(Z);
              return;
            }
          }
          X && he.push(X);
        }
      a && a(he);
    }).catch((J) => {
      const he = "An error occurred: " + J.message;
      o && o(he);
    });
  }
  getTexturesUploadUrl(e) {
    return this._zkScene ? this._zkScene.getTexturesUrl(e) : "";
  }
  removeAllMaterialPhotos(e) {
    if (this._zkScene) {
      const t = [];
      for (let n = 0; n < this._zkScene.get("materialPhotos").length; n++)
        this._zkScene.get("materialPhotos").at(n).get("materialID") === e.id && t.push(this._zkScene.get("materialPhotos").at(n));
      t.length > 0 && this._zkScene.get("materialPhotos").remove(t);
    }
  }
  removeMaterialPhotoAtIndex(e, t) {
    if (this._zkScene) {
      const n = [];
      for (let a = 0; a < this._zkScene.get("materialPhotos").length; a++)
        this._zkScene.get("materialPhotos").at(a).get("materialID") === e.id && n.push(this._zkScene.get("materialPhotos").at(a));
      if (n.length > 0) {
        const a = n[t];
        this._zkScene.get("materialPhotos").remove(a);
      }
    }
  }
  loadMaterialPhotoFiles(e, t, n, a) {
    this.uploadMaterialPhotoFiles(
      e,
      t,
      (o) => {
        this.refreshInfoPoints(), n && n();
      },
      a
    );
  }
  uploadMaterialPhotoFiles(e, t, n, a) {
    if (!this._scene || !this._zkScene || !e || e.length === 0)
      return;
    const o = t.id, h = (x) => {
      if (this._zkScene && x && x.photoID && x.materialID && (x.fileObjectID || x.fileLength) && x.url) {
        const k = new Zakeke.SceneMaterialPhoto();
        return k.set("photoID", x.photoID), k.set("materialID", x.materialID), k.set("fileObjectID", x.fileObjectID), k.set("fileLength", x.fileLength), k.set("url", x.url), this._zkScene.get("materialPhotos").push(k), k;
      }
      return null;
    }, f = (x) => {
      const k = x.lastIndexOf(".");
      return k !== -1 ? x.substring(k) : null;
    }, v = new FormData();
    for (let x = 0; x < e.length; x++) {
      const k = f(e[x].name);
      (k === ".png" || k === ".jpg") && v.append("file-" + x, e[x]);
    }
    jQuery.ajax({
      url: this.getMaterialPhotosUploadUrl(o),
      data: v,
      cache: !1,
      contentType: !1,
      processData: !1,
      type: "POST",
      success: (x) => {
        const k = [];
        if (Object.prototype.toString.call(x) === "[object Array]")
          for (let I = 0; I < x.length; I++) {
            const V = h(x[I]);
            if (!V) {
              const M = "Immagini non valide";
              if (a) {
                a(M);
                return;
              }
            }
            V && k.push(V);
          }
        n && n(k);
      },
      error: (x, k, I) => {
        const V = "An error occurred: " + k + " Error: " + I;
        a && a(V);
      }
    });
  }
  getMaterialPhotosUploadUrl(e) {
    return this._zkScene ? this._zkScene.getMaterialPhotosUrl(e) : "";
  }
  // Verifica se il material può caricare una cubemap per il tipo di proprietà specificato (type)
  canLoadCubemap(e, t) {
    return e ? e instanceof BABYLON.StandardMaterial && (t == "reflection" || t == "refraction") ? !0 : e instanceof BABYLON.PBRMetallicRoughnessMaterial || e instanceof BABYLON.PBRSpecularGlossinessMaterial ? t === "environment" : e instanceof BABYLON.PBRMaterial || e instanceof Zakeke.PBRMaterial ? t === "reflection" : e instanceof BABYLON.ShaderMaterial : t == "environment" || t == "skybox";
  }
  // Aggiorna la configurazione di ambiente impostando l'url di una texture caricata
  setEnvironmentTexture(e, t, n, a, o) {
    t === "environment" ? this.setSceneEnvironmentTexture(e, void 0, n, a, o) : t === "skybox" ? this.setViewerSkyboxTexture(e, n, a) : t === "ground" && this.setViewerGroundTexture(e);
  }
  removeSceneEnvironmentTexture() {
    this._scene && this._scene.environmentTexture && (this._scene.environmentTexture.dispose(), this._scene.environmentTexture = null, this._scene.metadata && this._scene.metadata.environmentTextureRotationY != null && delete this._scene.metadata.environmentTextureRotationY), this.setRenderingNeeded();
  }
  setSceneEnvironmentTextureRotationY(e) {
    this._scene && this._scene.environmentTexture && (this._scene.environmentTexture instanceof BABYLON.CubeTexture || this._scene.environmentTexture instanceof BABYLON.HDRCubeTexture) && (this._scene.environmentTexture.rotationY = e * Math.PI / 180, this.setLongRenderingNeeded());
  }
  // Crea e imposta la singola texture sul materiale per il tipo di proprietà specificato
  async setTextureImage(e, t, n, a) {
    return new Promise((o) => {
      if (this._scene && e && e instanceof Zakeke.SceneTexture) {
        const h = e.get("url");
        if (h)
          if (!t)
            this.setEnvironmentTexture(h, n);
          else {
            const f = this.getMaterialTexture(t, n);
            let v = !0;
            f && f instanceof BABYLON.Texture && (v = f.invertY);
            const x = new BABYLON.Texture(
              h,
              this._scene,
              a,
              v,
              void 0,
              () => this.setRenderingNeeded()
            );
            f && f instanceof BABYLON.Texture && (x.uScale = f.uScale, x.vScale = f.vScale, x.uOffset = f.uOffset, x.vOffset = f.vOffset, x.uAng = f.uAng, x.vAng = f.vAng, x.level = f.level, x.coordinatesIndex = f.coordinatesIndex, x.coordinatesMode = f.coordinatesMode, x.hasAlpha = f.hasAlpha, x.wrapU = f.wrapU, x.wrapV = f.wrapV, x.gammaSpace = f.gammaSpace), di.whenTextureIsReadyAsync(x).then(() => {
              this.applyTexture(x, t, n), f && !this.isTextureUsed(f) && f.dispose(), this.setRenderingNeeded(), o();
            });
          }
      }
    });
  }
  // Crea la cubemap e la imposta sul materiale e tipo di poprietà specificato
  async setCubeTextureImages(e, t, n) {
    return new Promise((a) => {
      (!this._scene || Object.prototype.toString.call(e) != "[object Array]") && a();
      for (let v = 0; v < e.length; v++) {
        const x = e[v];
        (!x || !(x instanceof Zakeke.SceneTexture)) && a();
      }
      const o = () => this.setLongRenderingNeeded();
      let h = null;
      const f = this.getCubeTextureInfo(e);
      if (f.url && this._scene)
        if (e.length === 1) {
          const v = f.url;
          v && (t ? v.endsWith(".dds") ? h = BABYLON.CubeTexture.CreateFromPrefilteredData(v, this._scene) : v.endsWith(".hdr") ? h = new BABYLON.HDRCubeTexture(
            v,
            this._scene,
            128,
            void 0,
            void 0,
            void 0,
            void 0,
            o
          ) : v.endsWith(".env") ? h = new BABYLON.CubeTexture(
            v,
            this._scene,
            null,
            !1,
            null,
            o,
            null,
            void 0,
            !0,
            void 0,
            !0
          ) : v.endsWith(".basis") && (h = BABYLON.CubeTexture.CreateFromPrefilteredData(v, this._scene)) : this.setEnvironmentTexture(v, n));
        } else
          e.length === 6 && f.files.length === 6 && f.extensions.length === 6 && (t ? h = new BABYLON.CubeTexture(
            f.url,
            this._scene,
            f.extensions,
            !1,
            f.files,
            o
          ) : this.setEnvironmentTexture(
            f.url,
            n,
            f.extensions,
            f.files,
            o
          ));
      h ? di.whenTextureIsReadyAsync(h).then(() => {
        if (t) {
          const v = this.getMaterialTexture(t, n);
          this.applyTexture(h, t, n), v && !this.isTextureUsed(v) && v.dispose(), this.setRenderingNeeded(), a();
        }
      }) : a();
    });
  }
  setMobileTextureImage(e, t, n, a) {
    if (this._scene && this._sceneHelper) {
      const o = e.get("url");
      if (o) {
        let h = null;
        t ? h = this.getMaterialTexture(t, n) : h = this._scene.environmentTexture, h !== null && this._sceneHelper.isTextureWithUrl(h) && (h.metadata || (h.metadata = {}), h.metadata.mobileUrl = o);
      }
    }
  }
  setMobileCubeTextureImages(e, t, n) {
    if (!this._scene || Object.prototype.toString.call(e) != "[object Array]")
      return;
    for (let o = 0; o < e.length; o++) {
      const h = e[o];
      if (!h || !(h instanceof Zakeke.SceneTexture))
        return;
    }
    const a = this.getCubeTextureInfo(e);
    if (a.url) {
      let o = null;
      t ? o = this.getMaterialTexture(t, n) : o = this._scene.environmentTexture, o && o instanceof BABYLON.CubeTexture && (o.metadata || (o.metadata = {}), o.metadata.mobileUrl = a.url, a.files.length === 6 && (o.metadata.mobileFiles = a.files, o.metadata.mobileExtensions = a.extensions));
    }
  }
  // Costruisce l'url della cubemap da utilizzare per la costruzione della texture di Babylon JS
  // Nel caso di cubemap con 6 immagini (_px _nx...), restituisce l'url senza il suffisso
  getCubeTextureInfo(e) {
    const t = {
      url: null,
      files: [],
      extensions: []
    };
    if (e.length === 1)
      t.url = e[0].get("url") || null;
    else if (e.length === 6) {
      const n = ["px", "py", "pz", "nx", "ny", "nz"];
      let a = null;
      const o = [], h = [], f = (k, I) => {
        const V = k.lastIndexOf(".");
        return V !== -1 ? k.substring(0, V).endsWith("_" + I) : !1;
      }, v = (k, I) => {
        const V = k.lastIndexOf(".");
        if (V !== -1) {
          const M = k.substring(0, V);
          if (M.endsWith("_" + I))
            return M.substring(0, M.length - ("_" + I).length);
        }
        return null;
      }, x = (k, I) => {
        const V = k.lastIndexOf("_" + I);
        return V !== -1 ? k.substr(V) : null;
      };
      for (let k = 0; k < n.length; k++) {
        const I = n[k];
        for (let V = 0; V < e.length; V++) {
          const M = e[V].get("url");
          if (M && f(M, I)) {
            o.push(M);
            const W = x(M, I);
            W && h.push(W), a || (a = v(M, I));
            break;
          }
        }
      }
      t.url = a, t.files = o, t.extensions = h;
    }
    return t;
  }
  isTextureUsed(e) {
    if (this._scene && e)
      for (let t = 0; t < this._scene.materials.length; t++) {
        const a = this._scene.materials[t].getActiveTextures();
        for (let o = 0; o < a.length; o++)
          if (a[o].uid === e.uid)
            return !0;
      }
    return !1;
  }
  async changeTextureInvertYAsync(e, t, n) {
    if (this._scene && this._sceneHelper) {
      var a = this._sceneHelper.getMaterialTexture(e, t);
      if (a && a instanceof BABYLON.Texture && a.invertY != n) {
        let h = a.url;
        if (h) {
          let f = h;
          if (!/^(?:\/|[a-z]+:\/\/)/.test(h)) {
            var o = await this.getSceneRootUrl();
            o && (f = o + h);
          }
          const x = new BABYLON.Texture(
            f,
            this._scene,
            void 0,
            n,
            void 0,
            () => this.setRenderingNeeded()
          );
          a && a instanceof BABYLON.Texture && (x.uScale = a.uScale, x.vScale = a.vScale, x.uOffset = a.uOffset, x.vOffset = a.vOffset, x.uAng = a.uAng, x.vAng = a.vAng, x.level = a.level, x.coordinatesIndex = a.coordinatesIndex, x.coordinatesMode = a.coordinatesMode, x.hasAlpha = a.hasAlpha, x.wrapU = a.wrapU, x.wrapV = a.wrapV, x.gammaSpace = a.gammaSpace), await di.whenTextureIsReadyAsync(x), this.applyTexture(x, e, t), a && !this.isTextureUsed(a) && a.dispose(), this.setRenderingNeeded();
        }
      }
    }
  }
  applyTextureByName(e, t, n) {
    if (this._scene) {
      const a = this._scene.textures.find((o) => o.name === e);
      a && this.applyTexture(a, t, n);
    }
  }
  applyTexture(e, t, n) {
    if (e && n == "lightmap" && (e.coordinatesIndex = 1, (t instanceof BABYLON.StandardMaterial || t instanceof BABYLON.PBRMaterial || t instanceof BABYLON.PBRBaseSimpleMaterial) && (t.useLightmapAsShadowmap = !0)), t instanceof BABYLON.StandardMaterial)
      switch (n) {
        case "diffuse":
          t.diffuseTexture = e;
          break;
        case "emissive":
          t.emissiveTexture = e;
          break;
        case "ambient":
          t.ambientTexture = e;
          break;
        case "lightmap":
          t.lightmapTexture = e;
          break;
        case "opacity":
          t.opacityTexture = e;
          break;
        case "specular":
          t.specularTexture = e;
          break;
        case "reflection":
          t.reflectionTexture = e;
          break;
        case "refraction":
          t.refractionTexture = e;
          break;
        case "bump":
          t.bumpTexture = e;
          break;
      }
    else if (t instanceof BABYLON.PBRMetallicRoughnessMaterial)
      switch (n) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "base":
        case "metallicRoughness":
          t[`${n}Texture`] = e;
          break;
      }
    else if (t instanceof BABYLON.PBRSpecularGlossinessMaterial)
      switch (n) {
        case "environment":
        case "normal":
        case "emissive":
        case "occlusion":
        case "diffuse":
        case "specularGlossiness":
          t[`${n}Texture`] = e;
          break;
      }
    else if (t instanceof BABYLON.PBRMaterial)
      switch (n) {
        case "cameraColorGrading":
          t.cameraColorGradingTexture = e;
          break;
        case "albedo":
        case "ambient":
        case "opacity":
        case "reflection":
        case "emissive":
        case "reflectivity":
        case "metallic":
        case "microSurface":
        case "bump":
        case "lightmap":
          t[`${n}Texture`] = e;
          break;
        case "refraction":
          t.refractionTexture = e;
          break;
        case "environmentBRDF":
          t.environmentBRDFTexture = e;
          break;
        case "clearCoat_texture":
          t.clearCoat.texture = e;
          break;
        case "clearCoat_bump":
          t.clearCoat.bumpTexture = e;
          break;
        case "clearCoat_tint":
          t.clearCoat.tintTexture = e;
          break;
        case "clearCoat_textureRoughness":
          t.clearCoat.textureRoughness = e;
          break;
        case "anisotropy_texture":
          t.anisotropy.texture = e;
          break;
        case "sheen_texture":
          t.sheen.texture = e;
          break;
        case "sheen_textureRoughness":
          t.sheen.textureRoughness = e;
          break;
        case "subSurface_thickness":
          t.subSurface.thicknessTexture = e;
          break;
        case "subSurface_translucencyIntensity":
          t.subSurface.translucencyIntensityTexture = e;
          break;
        case "subSurface_refractionIntensity":
          t.subSurface.refractionIntensityTexture = e;
          break;
      }
    else if (t instanceof BABYLON.ShaderMaterial)
      e && e instanceof BABYLON.Texture ? t.setTexture(n, e) : t.removeTexture(n);
    else if (t instanceof Zakeke.PBRMaterial)
      switch (n) {
        case "albedo":
          t.albedoTexture = e;
          break;
        case "bump":
          t.bumpTexture = e;
          break;
        case "reflection":
          t.reflectionTexture = e;
          break;
        case "matCapReflection":
          t.matCapReflectionTexture = e;
          break;
        case "reflectivity":
          t.reflectivityTexture = e;
          break;
        case "microsurface":
          t.microsurfaceTexture = e;
          break;
        case "ambient":
          t.ambientTexture = e;
          break;
        case "ao":
          t.aoTexture = e;
          break;
        case "opacity":
          t.opacityTexture = e;
          break;
      }
    this.setLongRenderingNeeded();
  }
  getMaterialTexture(e, t) {
    if (e instanceof BABYLON.StandardMaterial)
      switch (t) {
        case "diffuse":
          return e.diffuseTexture;
        case "emissive":
          return e.emissiveTexture;
        case "ambient":
          return e.ambientTexture;
        case "lightmap":
          return e.lightmapTexture;
        case "opacity":
          return e.opacityTexture;
        case "specular":
          return e.specularTexture;
        case "reflection":
          return e.reflectionTexture;
        case "refraction":
          return e.refractionTexture;
        case "bump":
          return e.bumpTexture;
      }
    else if (e instanceof BABYLON.PBRMetallicRoughnessMaterial)
      switch (t) {
        case "environment":
          return e.environmentTexture;
        case "normal":
          return e.normalTexture;
        case "emissive":
          return e.emissiveTexture;
        case "occlusion":
          return e.occlusionTexture;
        case "base":
          return e.baseTexture;
        case "metallicRoughness":
          return e.metallicRoughnessTexture;
      }
    else if (e instanceof BABYLON.PBRSpecularGlossinessMaterial)
      switch (t) {
        case "environment":
          return e.environmentTexture;
        case "normal":
          return e.normalTexture;
        case "emissive":
          return e.emissiveTexture;
        case "occlusion":
          return e.occlusionTexture;
        case "diffuse":
          return e.diffuseTexture;
        case "specularGlossiness":
          return e.specularGlossinessTexture;
      }
    else if (e instanceof BABYLON.PBRMaterial)
      switch (t) {
        case "cameraColorGrading":
          return e.cameraColorGradingTexture;
        case "albedo":
          return e.albedoTexture;
        case "ambient":
          return e.ambientTexture;
        case "opacity":
          return e.opacityTexture;
        case "reflection":
          return e.reflectionTexture;
        case "emissive":
          return e.emissiveTexture;
        case "reflectivity":
          return e.reflectivityTexture;
        case "metallic":
          return e.metallicTexture;
        case "microSurface":
          return e.microSurfaceTexture;
        case "bump":
          return e.bumpTexture;
        case "lightmap":
          return e.lightmapTexture;
        case "refraction":
          return e.refractionTexture;
        case "clearCoat":
          return e.clearCoat.texture;
        case "clearCoat_bump":
          return e.clearCoat.bumpTexture;
        case "clearCoat_tint":
          return e.clearCoat.tintTexture;
        case "clearCoat_textureRoughness":
          return e.clearCoat.textureRoughness;
        case "clearCoat_texture":
          return e.clearCoat.texture;
        case "anisotropy_texture":
          return e.anisotropy.texture;
        case "sheen_texture":
          return e.sheen.texture;
        case "sheen_textureRoughness":
          return e.sheen.textureRoughness;
        case "subSurface_thickness":
          return e.subSurface.thicknessTexture;
        case "subSurface_refractionIntensity":
          return e.subSurface.refractionIntensityTexture;
        case "subSurface_translucencyIntensity":
          return e.subSurface.translucencyIntensityTexture;
      }
    else if (e instanceof Zakeke.PBRMaterial)
      switch (t) {
        case "albedo":
          return e.albedoTexture;
        case "bump":
          return e.bumpTexture;
        case "reflection":
          return e.reflectionTexture;
        case "matCapReflection":
          return e.matCapReflectionTexture;
        case "reflectivity":
          return e.reflectivityTexture;
        case "microsurface":
          return e.microsurfaceTexture;
        case "ambient":
          return e.ambientTexture;
        case "ao":
          return e.aoTexture;
        case "opacity":
          return e.opacityTexture;
      }
    return null;
  }
  removeMaterialTexture(e, t) {
    this.applyTexture(null, e, t);
  }
  removeMaterialMobileTexture(e, t) {
    const n = this.getMaterialTexture(e, t);
    n && n.metadata && n.metadata.mobileUrl && (delete n.metadata.mobileUrl, n.metadata.hasOwnProperty("mobileFiles") && delete n.metadata.mobileFiles, n.metadata.hasOwnProperty("mobileExtensions") && delete n.metadata.mobileExtensions, Object.keys(n.metadata).length === 0 && n.metadata.constructor === Object && delete n.metadata);
  }
  //#endregion
  //#region Operazioni sugli elementi della scena
  /**
   * Create a group of meshes
   * @param parentId Id of the parent node of the group
   * @param name Name of the group
   * @param children Array of meshes to be included in the group
   */
  createGroup(e, t, n) {
    if (this._scene) {
      const a = new BABYLON.Mesh(t, this._scene);
      if (a.id = Zakeke.generateUUID(), a.metadata = {
        isRealMesh: !0,
        isGroup: !0
      }, e) {
        const o = this._scene.getMeshByID(e);
        o && (a.parent = o);
      }
      return n && n.forEach((o) => o.parent = a), this.fireMeshesUpdateEvent(), a;
    }
    return null;
  }
  deleteMesh(e, t) {
    const n = { meshIDs: [], materialIDs: [] };
    if (this._scene && this._sceneHelper && this._zkScene) {
      const a = this._scene, o = this._sceneHelper, h = this._zkScene, f = a.getMeshByID(e);
      if (f) {
        const v = (k) => {
          const I = this.getMeshMaterials(k);
          for (let V = 0; V < I.length; V++) {
            const M = I[V];
            if (!M)
              continue;
            const W = this.getMeshesUsingMaterial(M.id);
            W.length === 1 && W.every((U) => o.meshHasParent(U.id, f.id)) && (n.materialIDs.push(I[V].id), I[V].dispose());
          }
          k.getChildMeshes().forEach((V) => v(V));
        };
        t && (v(f), this.fireMaterialsUpdateEvent());
        const x = o.getCameraPivot();
        x && x === f && this.setCameraPivot(null), this.isMeshSelected(f) && this.unselectMesh(f.id), f.dispose(), n.meshIDs.push(e);
      }
      this.fireMeshesUpdateEvent(), this.setRenderingNeeded(), n.materialIDs.forEach((v) => {
        const x = h.getLibraryShaderMaterialIDForSceneMaterial(v);
        x && h.unregisterShaderMaterial(x);
      });
    }
    return n;
  }
  // Cancella tutte le mesh
  deleteAllMeshes() {
    if (this._scene && this._sceneHelper) {
      for (let e = 0; e < this._scene.meshes.length; e++) {
        const t = this._scene.meshes[e];
        this._sceneHelper.isRealMesh(t) && (this._scene.meshes.splice(e--, 1), t.dispose());
      }
      this.setCameraPivot(null), this.setRenderingNeeded();
    }
  }
  deleteDuplicatedMeshesWithDifferentParent(e, t) {
    const n = { meshIDs: [], materialIDs: [] };
    if (this._scene && this._sceneHelper && this._zkScene) {
      const a = this._scene, o = this._sceneHelper, h = this._zkScene, f = (x) => {
        const k = this.getSceneMeshesByName(x.name);
        let I = !1;
        for (let M = 0; M < k.length; M++) {
          var V = k[M];
          if (V.id != x.id && !o.meshHasParent(V.id, e)) {
            if (t) {
              const W = this.getMeshMaterials(V);
              for (let U = 0; U < W.length; U++)
                this.getMeshesUsingMaterial(W[U].id).length == 1 && (n.materialIDs.push(W[U].id), W[U].dispose());
            }
            n.meshIDs.push(V.id), V.dispose(), k.splice(M--, 1), I = !0;
            break;
          }
        }
        I || x.getChildMeshes().forEach((M) => f(M));
      }, v = a.getMeshByID(e);
      v && v.getChildMeshes().forEach((x) => f(x)), this.setRenderingNeeded(), n.materialIDs.forEach((x) => {
        const k = h.getLibraryShaderMaterialIDForSceneMaterial(x);
        k && h.unregisterShaderMaterial(k);
      });
    }
    return n;
  }
  // Cancella tutte le mesh figlie di quella in input
  // che hanno lo stesso nome di altre mesh con id diverso
  // Questa funzione può essere utile per elminiare oggetti duplicati importati
  // con file diversi
  deleteDuplicatedChildMeshes(e, t) {
    const n = { meshIDs: [], materialIDs: [] };
    if (this._scene && this._sceneHelper && this._zkScene) {
      const a = this._scene, o = this._sceneHelper, h = this._zkScene, f = (x) => {
        const k = this.getSceneMeshesByName(x.name);
        let I = !1;
        for (let V = 0; V < k.length; V++) {
          const M = k[V];
          if (M.id != x.id && !o.meshHasParent(M.id, e)) {
            if (t) {
              const W = this.getMeshMaterials(x);
              for (let U = 0; U < W.length; U++)
                this.getMeshesUsingMaterial(W[U].id).length == 1 && (n.materialIDs.push(W[U].id), W[U].dispose());
            }
            n.meshIDs.push(x.id), x.dispose(), I = !0;
            break;
          }
        }
        if (!I) {
          const V = x.getChildMeshes();
          for (let M = 0; M < V.length; M++)
            f(V[M]);
        }
      }, v = a.getMeshByID(e);
      v && v.getChildMeshes().forEach((x) => f(x)), this.setRenderingNeeded(), n.materialIDs.forEach((x) => {
        const k = h.getLibraryShaderMaterialIDForSceneMaterial(x);
        k && h.unregisterShaderMaterial(k);
      });
    }
    return n;
  }
  deleteMaterial(e) {
    if (this._scene && this._sceneHelper) {
      const t = this._scene.getMaterialByID(e);
      t && (this.deleteMaterialInternal(t), this.fireMaterialsUpdateEvent(), this.setRenderingNeeded());
    }
  }
  deleteMaterialInternal(e) {
    if (this._scene && this._sceneHelper && e) {
      const t = e.id;
      if (this._zkScene) {
        const a = this._zkScene.getLibraryShaderMaterialIDForSceneMaterial(e.id);
        a && this._zkScene.unregisterShaderMaterial(a);
      }
      const n = this._sceneHelper.getTexturesExclusivelyForMaterial(e);
      e.dispose();
      for (let a = 0; a < n.length; a++)
        n[a].dispose();
      this._sceneHelper.removeSceneMaterialMetadata(t);
    }
  }
  deleteAllMaterials() {
    if (this._scene) {
      for (; this._scene.materials.length > 0; ) {
        const e = this._scene.materials.pop();
        e && this.deleteMaterialInternal(e);
      }
      this.fireMaterialsUpdateEvent(), this.setRenderingNeeded(), this.fireMaterialsUpdateEvent();
    }
  }
  renameMaterial(e, t) {
    if (this._scene) {
      const n = this._scene.getMaterialByID(e);
      n && (n.name = t), this.fireMaterialsUpdateEvent();
    }
  }
  cloneMesh(e) {
    let t = null;
    return this._scene && this._sceneHelper && (t = this._sceneHelper.cloneMesh(e, !1, !1), this.setRenderingNeeded(), this.fireMeshesUpdateEvent()), t;
  }
  // Same as clone but with duplicated geometry data too
  duplicateMesh(e, t = !1) {
    let n = null;
    return this._scene && this._sceneHelper && (n = this._sceneHelper.cloneMesh(e, !0, t), this.setRenderingNeeded(), this.fireMeshesUpdateEvent()), n;
  }
  cloneMaterial(e, t, n) {
    let a = null;
    if (this._scene && this._sceneHelper) {
      const h = this._scene.getMaterialById(e);
      if (h) {
        const f = n || h.name + " - clone";
        if (a = h.clone(f), a) {
          const v = t || Zakeke.generateUUID();
          a.id = v;
          const x = this._sceneHelper.getTexturesForMaterial(h), k = this._sceneHelper.getTexturesForMaterial(a);
          for (let I = 0; I < k.length; I++) {
            const V = k[I], M = x[I];
            M && M.metadata && (V.metadata = JSON.parse(JSON.stringify(M.metadata)));
          }
          if (this._zkScene) {
            const I = this._zkScene.getMappingForSceneMaterial(h.id);
            if (I) {
              var o = I.get("libraryMaterialID");
              this._zkScene.mapLibraryMaterial(o, a.id);
              const V = this._sceneHelper.getTexturesForMaterial(h), M = this._sceneHelper.getTexturesForMaterial(a);
              for (let W = 0; W < M.length; W++) {
                const U = M[W], Q = V[W];
                U.materialMapping = Q.materialMapping;
              }
            }
          }
        }
      }
      this.setRenderingNeeded(), this.fireMaterialsUpdateEvent();
    }
    return a;
  }
  createMaterial(e, t, n) {
    let a = null;
    if (this._scene) {
      const o = e || "new material", h = t || "Standard";
      h === "Standard" ? a = new BABYLON.StandardMaterial(o, this._scene) : h === "PBRMetallicRoughness" ? (a = new BABYLON.PBRMetallicRoughnessMaterial(o, this._scene), a.subSurface.indexOfRefraction = 1, a._imageProcessingConfiguration.contrast = 1) : h === "PBRSpecularGlossiness" ? a = new BABYLON.PBRSpecularGlossinessMaterial(o, this._scene) : h === "PBR" ? (a = new BABYLON.PBRMaterial(o, this._scene), a.enableSpecularAntiAliasing = !0, a.metallic = 0.9, a.roughness = 0.3, a.indexOfRefraction = 1.5) : h === "NewPBR" && (a = new Zakeke.PBRMaterial(o, this._scene)), a && (a.id = Zakeke.generateUUID(), n && (a.metadata || (a.metadata = {}), a.metadata.group = n)), this.checkSceneEmptyEnvironmentTexture(), this.setRenderingNeeded(), this.fireMaterialsUpdateEvent();
    }
    return a;
  }
  changeMeshParent(e, t) {
    if (this._scene) {
      const n = this._scene.getMeshById(e);
      if (n && (!n.parent || n.parent.id != t)) {
        const a = this._scene.getMeshById(t);
        n.setParent(a), this.setRenderingNeeded(), this.fireMeshesUpdateEvent();
      }
    }
  }
  removeMeshParent(e) {
    if (this._scene) {
      const t = this._scene.getMeshByID(e);
      t && (t.parent = null, this.fireMeshesUpdateEvent());
    }
  }
  setManipulatedNode(e) {
    e !== this._manipulatedNode && (this._manipulatedNode = e, this.showHideEditControl(this._editControlVisible), this.setRenderingNeeded());
  }
  importLibraryMaterial(e) {
    if (this._scene && this._sceneHelper && this._zkScene && e && e instanceof Zakeke.Material) {
      e.get("shaders") && this.checkShaderMaterial(e);
      const n = e.get("JSON") || e.get("json"), a = e.get("rootUrl");
      if (n && a) {
        const o = JSON.parse(n), h = BABYLON.Material.Parse(o, this._scene, a);
        if (h) {
          if (h.id = Zakeke.generateUUID(), this._zkScene.mapLibraryMaterial(e.getMaterialID(), h.id), e.get("shaders")) {
            const x = e.get("shaders"), k = x.get("name"), I = x.get("vertex"), V = x.get("fragment");
            k && I && V && this._zkScene.registerShaderMaterial(
              e.getMaterialID(),
              k,
              I,
              V
            ), this.setupShaderMaterialCameraPosition(h);
          }
          e.get("sourceTextureImages").forEach(async (x) => {
            var I, V;
            if ((I = this._zkScene) != null && I.get("textures").find((M) => M.get("url") === x.get("url")))
              return;
            let k = new Zakeke.SceneTexture();
            k.set("textureID", Zakeke.generateUUID()), k.set("materialID", h.id), k.set("fileObjectID", x.get("fileObjectID")), k.set("fileLength", (x == null ? void 0 : x.get("fileLength")) || -1), k.set("url", x.get("url")), (V = this.zkScene) == null || V.get("textures").push(k);
          });
          const v = this._sceneHelper.getTexturesForMaterial(h);
          for (let x = 0; x < v.length; x++) {
            var t = v[x];
            t.materialMapping = {
              libraryMaterialRootUrl: a,
              libraryMaterialID: e.getMaterialID(),
              sceneMaterialID: h.id
            }, t.url && !t.url.startsWith("http") && (t.name = t.url, t.url = a + t.url), t.metadata && t.metadata.mobileUrl && !t.metadata.mobileUrl.startsWith("http") && (t.metadata.mobileUrl = a + t.metadata.mobileUrl);
          }
        }
      }
      this.fireMaterialsUpdateEvent(), this.setRenderingNeeded();
    }
  }
  //#endregion
  //#region Recupero Texture
  // I metodi per il recupero delle texture sono stati spostati in SceneHelper
  // Li lascio qui solo momentaneamente
  getTexturesForMaterial(e) {
    return this._sceneHelper ? this._sceneHelper.getTexturesForMaterial(e) : [];
  }
  getStandardMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getStandardMaterialTextures(e) : [];
  }
  getPBRBaseSimpleMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getPBRBaseSimpleMaterialTextures(e) : [];
  }
  getPBRMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getPBRMaterialTextures(e) : [];
  }
  getNewPBRMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getNewPBRMaterialTextures(e) : [];
  }
  getPBRMetallicRoughnessMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getPBRMetallicRoughnessMaterialTextures(e) : [];
  }
  getPBRSpecularGlossinessMaterialTextures(e) {
    return this._sceneHelper ? this._sceneHelper.getPBRSpecularGlossinessMaterialTextures(e) : [];
  }
  //#endregion
  //#region Camera Location
  removeCameraLocation(e) {
    var t;
    (t = this._zkScene) == null || t.get("cameraLocations").remove(e), this.fireCameraLocationsUpdateEvent();
  }
  saveCameraLocation(e) {
    if (this._zkScene && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const t = this._camera.position, n = this._camera.target, a = new Zakeke.SceneCameraLocation();
      a.set("name", e), a.set("px", t.x), a.set("py", t.y), a.set("pz", t.z), a.set("tx", n.x), a.set("ty", n.y), a.set("tz", n.z), this._zkScene.get("cameraLocations").push(a), this.fireCameraLocationCreatedEvent(a), this.fireCameraLocationsUpdateEvent();
    }
  }
  clearCameraLocations() {
    if (this._zkScene) {
      const e = this._zkScene.get("cameraLocations");
      for (; e.length > 0; )
        e.remove(e.at(0));
      this.fireCameraLocationsUpdateEvent();
    }
  }
  //public setCameraLocation(locationID: string) {
  //    if (this._sceneHelper && this._zkScene) {
  //        const zkCameraLocation = this._zkScene.getCameraLocation(locationID);
  //        if (zkCameraLocation) {
  //            const position = new BABYLON.Vector3(zkCameraLocation.get("px"), zkCameraLocation.get("py"), zkCameraLocation.get("pz"));
  //            const target = new BABYLON.Vector3(zkCameraLocation.get("tx"), zkCameraLocation.get("ty"), zkCameraLocation.get("tz"));
  //            this._sceneHelper.animateCamera(target, position, 0.5);
  //        }
  //    }
  //    this.setRenderingNeeded();
  //}
  getAllCameraLocations() {
    const e = [];
    if (this._zkScene)
      for (let t = 0; t < this._zkScene.get("cameraLocations").length; t++)
        e.push(this._zkScene.get("cameraLocations").at(t));
    return e;
  }
  //#endregion
  //#region Collapse / Explode (Mesh Locations)
  saveMeshLocation(e) {
    this._meshLocationsManager && this._meshLocationsManager.saveMeshLocation(e);
  }
  saveExplodedMeshLocation() {
    this._meshLocationsManager && this._meshLocationsManager.saveExplodedMeshLocation();
  }
  saveCollapsedMeshLocation() {
    this._meshLocationsManager && this._meshLocationsManager.saveCollapsedMeshLocation();
  }
  onBeforeSaveMeshLocation() {
    this._oldManipulatedNode = this._manipulatedNode, this.setManipulatedNode(null);
  }
  onAfterSaveMeshLocation() {
    this.fireMeshLocationsUpdateEvent(), this.setManipulatedNode(this._oldManipulatedNode);
  }
  clearMeshLocations() {
    this._meshLocationsManager && this._meshLocationsManager.clearMeshLocations();
  }
  getAllMeshLocations() {
    const e = [];
    if (this._zkScene)
      for (let t = 0; t < this._zkScene.get("meshLocations").length; t++)
        e.push(this._zkScene.get("meshLocations").at(t));
    return e;
  }
  //#endregion
  //#region Material Library
  // Nota Bene
  // E' un po' incasinato, c'è da mettere ordine, primo abbozzo di implementazione.
  // Il problema principale è la gestione delle texture
  // che possono provenire da fonti diverse (sorgenti, librerie e caricate singolarmente dall'utente).
  // In breve: innanzitutto scatta una screenshot del materiale. per fare questo nasconde tutte le mesh,
  // crea una sfera temporanea e una camera temporanea prende la screenshot e poi rattiva le mesh così
  // come erano inialmente. Poi, clona il materiale iniziale (babylon) e lo associa ad un nuovo materiale lato server (zkMaterial).
  // Recupera le texture (babylon) associate al materiale di scena.
  // Per copiare le immagini lato server, recupera i fileObjectID per ognuna delle texture.
  // (Per una texture babylon possono esserci più file fileObjectID associati. Ad esempio, per una cubemap, ci saranno 6 fileObjectID associati.)
  // Per ogni fileObjectID, memorizza su skMaterial anche la provenienza, in modo che lato server il path possa essere costruito correttamente.
  // Salva il nuovo zkMaterial (lato server avverrà la copia dei file di immagini texture).
  // Alla fine elimina il nuovo materiale creato come clone.
  makeLibraryMaterial(e, t) {
    return new Promise((n, a) => {
      this.getMaterialScreenShotForLibrary(e, (o) => {
        o ? this.createLibraryMaterial(e, t, o, n) : a("No data generated for screenshot");
      });
    });
  }
  getMaterialScreenShotForLibrary(e, t) {
    if (this._scene && this._sceneHelper) {
      this.resetEditorEnvironment(), this.removeGround(), this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null);
      const n = 500, a = 500;
      this._sceneHelper.takeMaterialScreenshotAsync(e, n, a).then((o) => {
        aw(o, n, a, (h) => {
          this.refreshEnvironment(), t && t(h);
        });
      });
    } else
      t && t(null);
  }
  createLibraryMaterial(e, t, n, a) {
    let o = null;
    const h = () => {
      o && this.deleteMaterial(o.id), a && a();
    };
    if (!this._scene || !this._sceneHelper || !this._zkScene) {
      h();
      return;
    }
    const f = this._scene, v = this._sceneHelper, x = this._zkScene;
    if (!f.getMaterialById(e)) {
      h();
      return;
    }
    const I = new Zakeke.Material();
    I.set("name", t), I.set("imageData", n);
    let V = e, M = V.replace(/-/g, "");
    const W = I.getMaterialID(), U = W.replace(/-/g, "");
    if (o = this.cloneMaterial(e, W, t), !o) {
      h();
      return;
    }
    const Q = x.getSourcesIDs(), D = v.getTexturesForMaterial(o), ee = [];
    for (let qe = 0; qe < D.length; qe++) {
      const Oe = D[qe];
      if (Oe.materialMapping) {
        const je = Oe.materialMapping.libraryMaterialID;
        je && ee.push(je);
      }
    }
    let J = new Zakeke.Materials();
    const he = ["px", "py", "pz", "nx", "ny", "nz"], fe = function(qe) {
      const Oe = qe.lastIndexOf(".");
      if (Oe !== -1) {
        const je = qe.substring(0, Oe);
        if (he.some((pt) => je.endsWith("_" + pt)))
          return je.substring(0, je.length - 3);
      }
      return qe;
    }, X = (qe, Oe) => fe(qe).endsWith(Oe), Z = async () => {
      var Oe;
      for (let je = 0; je < D.length; je++) {
        const pt = D[je];
        if (pt && v.isTextureWithUrl(pt) && pt.url) {
          let Te = null, Ze = null;
          for (let $e = 0; $e < Q.length; $e++) {
            const It = Q[$e].replace(/-/g, "");
            if (pt.url.indexOf(It) != -1) {
              Te = Q[$e], Ze = It;
              break;
            }
          }
          const ce = [];
          for (let $e = 0; $e < x.get("textures").length; $e++) {
            const It = x.get("textures").at($e);
            It.get("url") && X(It.get("url"), pt.url) && ce.push({
              fileObjectID: It.get("fileObjectID"),
              url: It.get("url"),
              fileLength: It.get("fileLength")
            });
          }
          const ut = (pt.url.startsWith("http") ? pt.url : x.get("rootUrl") + pt.url) || "";
          ut && ce.filter(($e) => $e.url === ut).length === 0 && ce.push({
            url: ut,
            fileLength: ((Oe = pt == null ? void 0 : pt._texture) == null ? void 0 : Oe._size) || -1
          });
          for (let $e = 0; $e < ce.length; $e++) {
            const It = new Zakeke.MaterialSourceTextureImage();
            It.set("fileObjectID", ce[$e].fileObjectID), It.set("url", ce[$e].url || ""), It.set("fileLength", ce[$e].fileLength || -1), Te ? (It.set("sceneID", x.getSceneID()), It.set("sourceID", Te)) : (It.set("sceneID", x.getSceneID()), It.set("materialID", V)), I.get("sourceTextureImages").push(It);
          }
          if (pt.metadata && pt.metadata.mobileUrl) {
            const $e = pt.metadata.mobileUrl, It = new Zakeke.MaterialSourceTextureImage(), rt = $e.startsWith("http") ? $e : (I.get("rootUrl") || x.get("rootUrl")) + $e;
            if (It.set("url", rt), It.set("sceneID", x.getSceneID()), It.set("materialID", V), I.get("sourceTextureImages").push(It), console.log("#2 scene texture", pt), pt.metadata && pt.metadata.mobileUrl) {
              const it = pt.metadata.mobileUrl;
              pt.metadata.mobileUrl = "textures/" + U + "/" + it.substring(it.lastIndexOf("/") + 1);
            }
          }
          let ze = "", ht = "", Gt = pt.name;
          if (Te && Ze) {
            const $e = pt.url.indexOf(Ze);
            $e != -1 && (Gt = pt.url.substring($e)), ze = Ze, ht = "textures/" + U, pt.name = Gt.replace(new RegExp(ze, "g"), ht);
          } else {
            var qe = pt.url.lastIndexOf("/");
            qe !== -1 && (qe = pt.url.lastIndexOf("/", qe - 1), qe !== -1 && (qe = pt.url.lastIndexOf("/", qe - 1), qe != -1 && (Gt = pt.url.substring(qe + 1)))), ze = M, ht = U, pt.name = Gt.replace(
              new RegExp("textures/([A-Za-z0-9]*)/(.*)", "g"),
              "textures/" + ht + "/$2"
            );
          }
          pt.url = pt.name;
        }
      }
      if (o) {
        const je = o.serialize(), pt = JSON.stringify(je);
        I.set("JSON", pt), I.save(null, {
          success: function(Te, Ze, ce) {
            h();
          },
          error: function(Te, Ze, ce) {
            h();
          }
        });
      } else
        h();
    };
    if (ee.length > 0) {
      const qe = { ids: ee.join(",") };
      try {
        J.fetch({
          success: (Oe, je, pt) => {
            J = Oe, Z();
          },
          error: (Oe, je, pt) => {
            Logger.info("Errore nel salvataggio del materiale di libreria"), h();
          },
          data: qe
        });
      } catch {
      }
    } else
      Z();
  }
  //#endregion
  //#region Lights
  lightsLayer_onLightSelected(e) {
    this.fireLightSelectedEvent(e);
  }
  isDefaultLight(e) {
    return this._sceneHelper ? this._sceneHelper.isDefaultLight(e) : !1;
  }
  createLight(e, t) {
    let n = null;
    if (this._scene) {
      const a = e || "new light", o = t || "Point", h = BABYLON.Vector3.Zero(), f = BABYLON.Vector3.Zero(), v = 25 * Math.PI / 180, x = 2;
      o == "Point" ? n = new BABYLON.PointLight(a, h, this._scene) : o == "Directional" ? n = new BABYLON.DirectionalLight(a, f, this._scene) : o == "Spot" ? n = new BABYLON.SpotLight(a, h, f, v, x, this._scene) : o == "Hemispheric" && (n = new BABYLON.HemisphericLight(a, f, this._scene)), n && (n.id = Zakeke.generateUUID()), this._lightsLayer && this._lightsLayer.refresh(), this.setRenderingNeeded(), this.fireLightsUpdateEvent();
    }
    return n;
  }
  cloneLight(e, t, n) {
    let a = null;
    if (this._scene) {
      const o = this._scene.getLightByID(e);
      if (o) {
        const h = n || o.name + " - clone";
        if (a = o.clone(h), a) {
          a.name = h;
          const f = t || Zakeke.generateUUID();
          a.id = f, this._lightsLayer && this._lightsLayer.refresh();
        }
      }
      this.setRenderingNeeded(), this.fireLightsUpdateEvent();
    }
    return a;
  }
  renameLight(e, t) {
    if (this._scene) {
      const n = this._scene.getLightByID(e);
      n && (n.name = t, this._lightsLayer && this._lightsLayer.refresh()), this.fireLightsUpdateEvent();
    }
  }
  deleteLight(e) {
    if (this._scene) {
      const t = this._scene.getLightByID(e);
      t && (t.dispose(), this._scene.meshes.forEach((n) => n._markSubMeshesAsLightDirty()), this._lightsLayer && this._lightsLayer.refresh()), this.setRenderingNeeded(), this.fireLightsUpdateEvent();
    }
  }
  getAllLights() {
    return this._scene ? this._scene.lights : [];
  }
  canShowLights() {
    return this._showLights && this._envMode == Lr.Editor;
  }
  showHideLights(e) {
    this._showLights = e, this._lightsLayer && this._lightsLayer.refresh(), this.setRenderingNeeded();
  }
  //#endregion
  //#region Ground
  canShowGround() {
    return this._showGround && this._envMode == Lr.Editor;
  }
  removeGround() {
    this._ground && (this._ground.dispose(), this._ground = null), this.setRenderingNeeded();
  }
  refreshGround() {
    if (!this._scene)
      return;
    if (this.removeGround(), !this.canShowGround()) {
      this.setRenderingNeeded();
      return;
    }
    const e = this._scene.clearColor, t = e.toHexString(), n = rw(t) ? 0.8 : -0.5, a = BABYLON.Color3.FromHexString(sw(t, n));
    let o = 1e3, h = 1;
    if (this.countSceneMeshes() > 0) {
      const v = this._scene.getWorldExtends((I) => this.isRealMesh(I)), k = v.max.subtract(v.min).length() * 1.5;
      isFinite(k) && (o = k * 20, h = o / 100);
    }
    this._ground = BABYLON.Mesh.CreateGround("ground", o, o, 10, this._scene), this._ground.doNotSerialize = !0, this._ground.isVisible = this.showGround, this._ground.isPickable = !1, this._ground.metadata = {
      isRealMesh: !1,
      isGround: !0
    };
    const f = new BABYLON.GridMaterial("groundMaterial", this._scene);
    f.doNotSerialize = !0, f.backFaceCulling = !1, f.mainColor = new BABYLON.Color3(e.r, e.g, e.b), f.opacity = 1, f.gridRatio = h, f.lineColor = a, f.metadata = { isRealMaterial: !1 }, this._ground.material = f, this.setRenderingNeeded();
  }
  showHideGround(e) {
    this.showGround = e, this.refreshGround();
  }
  //#endregion
  //#region Axes
  canShowAxes() {
    return this._showAxes && this._envMode == Lr.Editor;
  }
  showHideAxes(e) {
    this._showAxes = e, this._axesLayer && this._axesLayer.refresh(), this.setRenderingNeeded();
  }
  //#endregion
  //#region Highlights
  showHideHighlight(e) {
    this._showHighlight = e;
    const t = this.getSelectedRootMesh();
    this.highlightMesh(t, e), this.setRenderingNeeded();
  }
  setHighlightOver(e) {
    this._highlightOver = e;
  }
  highlightMesh(e, t) {
    if (!this._showHighlight || this._envMode != Lr.Editor) {
      this.deleteHighlightLayer();
      return;
    }
    e && e instanceof BABYLON.Mesh && (t ? (this._highlightLayer || this.createHighlightLayer(), this._highlightLayer && this._highlightLayer.addMesh(e, BABYLON.Color3.FromHexString(this._highlightColor))) : this._highlightLayer && this._highlightLayer.removeMesh(e)), this.setLongRenderingNeeded();
  }
  highlightMeshOver(e) {
    if (!this._showHighlight || this._envMode != Lr.Editor) {
      this.deleteHighlightLayer();
      return;
    }
    this._meshOver && this._meshOver instanceof BABYLON.Mesh && !this.isMeshSelected(this._meshOver) && (e && this._highlightOver ? (this._highlightLayer || this.createHighlightLayer(), this._highlightLayer && !this._highlightLayer.hasMesh(this._meshOver) && this._highlightLayer.addMesh(this._meshOver, BABYLON.Color3.FromHexString(this.highlightOverColor))) : this._highlightLayer && this._highlightLayer.removeMesh(this._meshOver)), this.setLongRenderingNeeded();
  }
  //#endregion
  //#region Edit control (Gizmo)
  showHideEditControl(e) {
    this._scene && this._camera && this._canvas && (this._editControlVisible = e, this._editControl && (!e || this._manipulatedNode == null) && (this._editControl.detach(), this._editControl = null), e && this._manipulatedNode && (this._editControl ? this._editControl.switchTo(this._manipulatedNode) : (this._editControl = new this._EditControl(
      this._manipulatedNode,
      this._camera,
      this._canvas,
      0.75,
      !0
    ), this._editControl.setRotSnapValue(3.14 / 18), this._editControl.setTransSnapValue(0.5), this._editControl.setScaleSnapValue(0.25), this._editControl.addActionEndListener((t) => {
      this.fireMeshesUpdateEvent();
    })), this.setEditingMode(this._editingMode)), this.setRenderingNeeded());
  }
  setEditingMode(e) {
    this._editingMode = e, this._editControl && (e === Za.Translate ? this._editControl.enableTranslation() : e === Za.Rotate ? this._editControl.enableRotation() : e === Za.Scaling && this._editControl.enableScaling()), this.setRenderingNeeded();
  }
  undoEditing() {
    this._editControl && this._editControl.undo();
  }
  redoEditing() {
    this._editControl && this._editControl.redo();
  }
  //#endregion
  //#region Environment
  setEnvironmentMode(e) {
    e != this._envMode && (this._envMode = e, this.refreshEnvironment());
  }
  async refreshEnvironment() {
    this._scene && (this.setRenderingNeeded(), this._envMode == Lr.Editor ? (this.disableAntialiasing(), this.resetEditorEnvironment(), this._environmentManager && (this._environmentManager.dispose(), this._environmentManager = null)) : (this.deleteHighlightLayer(), this.refreshGround(), this._zkScene && ((!this._environmentManager || this._environmentManager.scene != this._scene) && (this._environmentManager = new Jd(this._zkScene, this._scene)), this._environmentManager.update(), this.setLongRenderingNeeded())), this.refreshGround(), this._lightsLayer && this._lightsLayer.refresh(), this._axesLayer && this._axesLayer.refresh(), this._camera && this._camera instanceof BABYLON.ArcRotateCamera && (this.autoRender = this._camera.useAutoRotationBehavior), this.setRenderingNeeded());
  }
  //#endregion
  //#region Zoom & Move camera
  zoomOnMesh(e) {
    this._sceneHelper && this._sceneHelper.zoomOnMesh(e);
  }
  // Sperimentale (è difficile capire come muovere la camera per inquadrare un oggetto)
  moveCameraToMeshPosition(e) {
    if (this._scene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
      const n = this._sceneHelper.getMeshHierarchyCenter(e), a = this._camera.target, o = this._camera.radius, h = n.subtract(a), f = h.length();
      if (isFinite(f)) {
        let v = h.normalize(), x = a.add(v.scale(o));
        const k = new BABYLON.Ray(x, v.scale(-1), o), I = this._scene.pickWithRay(k, (V) => V === e);
        if (I && I.hit) {
          const V = new BABYLON.Vector3(), M = new BABYLON.Quaternion(), W = new BABYLON.Vector3();
          e.getWorldMatrix().decompose(V, M, W), 0.1 / V.length() * 100, I.pickedPoint;
          var t = I.getNormal();
          t && (v = t.normalize(), x = a.add(v.scale(o)));
        }
        this._sceneHelper.animateCamera(a, x, 1);
      }
      this.setRenderingNeeded();
    }
  }
  //#endregion
  //#region Scene & Mesh Export: USDZ, glTF, Obj, AR
  exportMeshToOBJ(e) {
    if (!this._scene)
      return;
    const t = this._scene.getMeshByID(e);
    if (!t || !(t instanceof BABYLON.Mesh))
      return;
    const n = BABYLON.OBJExport.OBJ([t]);
    this.saveTextAsFile(n, t.name + ".obj");
  }
  exportMeshGeometryToJson(e) {
    if (!this._scene)
      return;
    const t = this._scene.getMeshByID(e);
    if (!t || !(t instanceof BABYLON.Mesh))
      return;
    const n = {
      positions: t.getVerticesData(BABYLON.VertexBuffer.PositionKind),
      normals: t.getVerticesData(BABYLON.VertexBuffer.NormalKind),
      colors: t.getVerticesData(BABYLON.VertexBuffer.ColorKind),
      uvs: t.getVerticesData(BABYLON.VertexBuffer.UVKind),
      uvs2: t.getVerticesData(BABYLON.VertexBuffer.UV2Kind),
      indices: t.getIndices()
    }, a = JSON.stringify(n, null, 0);
    this.saveTextAsFile(a, t.name + ".json");
  }
  enableDisableARForMesh(e, t) {
    const n = this.getMeshByID(e);
    n && (n.metadata || (n.metadata = {}), n.metadata.AR = t);
  }
  isAREnabledForMesh(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata ? t.metadata.AR !== void 0 ? t.metadata.AR : !0 : !1;
  }
  enableDisableTryOnForMesh(e, t) {
    const n = this.getMeshByID(e);
    n && (n.metadata || (n.metadata = {}), n.metadata.AR = t);
  }
  isTryOnEnabledForMesh(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata ? t.metadata.TryOn !== void 0 ? t.metadata.TryOn : !0 : !1;
  }
  //#endregion
  //#region Utilities
  splitSubMeshes(e) {
    if (this._scene && this._sceneHelper) {
      const t = this._scene.getMeshByID(e);
      t && this._sceneHelper.createMeshesFromSubMeshes(t);
    }
  }
  flipMeshFaces(e) {
    const t = this.getMeshByID(e);
    if (!t)
      return;
    const n = (a) => {
      a instanceof BABYLON.Mesh && a.flipFaces(!0), a.getChildMeshes().forEach((o) => n(o));
    };
    n(t);
  }
  convertSceneToScreenPoint(e, t) {
    if (this._canvas) {
      let n = 0, a = 0, o = this._canvas;
      do
        n += o.offsetLeft, a += o.offsetTop, o = o.offsetParent;
      while (o);
      return { X: e + n, Y: t + a };
    }
    return null;
  }
  saveTextAsFile(e, t) {
    const n = e, a = new Blob([n], { type: "text/plain" }), o = window.URL.createObjectURL(a), h = t;
    this.downloadFile(h, o);
  }
  saveBytesAsFile(e, t) {
    const n = new Blob([e]), a = window.URL.createObjectURL(n);
    this.downloadFile(t, a);
  }
  saveBlobAsFile(e, t, n) {
    let a = null;
    n ? a = window.URL.createObjectURL(new Blob([e], { type: n })) : a = window.URL.createObjectURL(new Blob([e])), this.downloadFile(t, a);
  }
  downloadFile(e, t) {
    var n = document.createElement("a");
    n.download = e, n.innerHTML = "Download File", n.href = t, n.onclick = (a) => {
      document.body.removeChild(n);
    }, n.style.display = "none", document.body.appendChild(n), n.click();
  }
  //#endregion
  //#region Draco
  // Test Draco encoding
  exportDracoEncodedToFile(e) {
    if (!this._scene)
      return;
    const t = this._scene.getMeshByID(e);
    if (!t)
      return;
    const n = this.getDracoEncodedGeometry(t);
    n && this.saveBytesAsFile(n, t.name + "_draco.dat");
  }
  // Funzione utile per testare la codifica Draco delle geometrie
  // La codifica reale delle mesh avviene durante il salvataggio e se ne
  // occupa la classe MakeIncremental, utilizzata in un worker thread
  getDracoEncodedGeometry(e) {
    let t = null;
    if (this._scene && e && e instanceof BABYLON.Mesh) {
      const a = e.getVerticesData(BABYLON.VertexBuffer.PositionKind), o = e.getVerticesData(BABYLON.VertexBuffer.NormalKind), h = e.getVerticesData(BABYLON.VertexBuffer.ColorKind), f = e.getVerticesData(BABYLON.VertexBuffer.UVKind), v = e.getVerticesData(BABYLON.VertexBuffer.UV2Kind), x = e.getIndices(), k = {};
      x && (k.indices = new Uint32Array(x)), a && (k.positions = new Float32Array(a)), o && (k.normals = new Float32Array(o)), f && (k.uvs = new Float32Array(f)), v && (k.uvs2 = new Float32Array(v)), h && (k.colors = new Uint32Array(h));
      const I = DracoEncoderModule(), V = new I.Encoder(), M = new I.MeshBuilder(), W = new I.Mesh(), U = k.indices.length / 3, Q = k.positions.length / 3;
      M.AddFacesToMesh(W, U, k.indices), M.AddFloatAttributeToMesh(W, I.POSITION, Q, 3, k.positions), k.normals && M.AddFloatAttributeToMesh(W, I.NORMAL, Q, 3, k.normals), k.colors && M.AddFloatAttributeToMesh(W, I.COLOR, Q, 4, k.colors), k.uvs && M.AddFloatAttributeToMesh(W, I.TEX_COORD, Q, 2, k.uvs), k.uvs2 && M.AddFloatAttributeToMesh(W, I.TEX_COORD, Q, 2, k.uvs2), V.SetSpeedOptions(5, 5), V.SetAttributeQuantization(I.POSITION, 14), V.SetAttributeQuantization(I.TEX_COORD, 12), V.SetAttributeQuantization(I.NORMAL, 10), V.SetAttributeQuantization(I.COLOR, 10), V.SetAttributeQuantization(I.GENERIC, 8), V.SetEncodingMethod(I.MESH_EDGEBREAKER_ENCODING);
      const D = new I.DracoInt8Array(), ee = V.EncodeMeshToDracoBuffer(W, D);
      t = new ArrayBuffer(ee);
      var n = new Int8Array(t);
      for (let J = 0; J < ee; ++J)
        n[J] = D.GetValue(J);
      I.destroy(W), I.destroy(D), I.destroy(V), I.destroy(M);
    }
    return t;
  }
  // Decodifica dei dati Draco ereditata da SceneViewer
  //#endregion
  //#region Mesh Creation
  // Crea una mesh (cubo) custom specificandone la geometria
  // utile per comprendere il modo in cui Babylon JS organizza i dati delle geomtrie
  createCustomMesh() {
    let e = null;
    if (this._scene) {
      e = new BABYLON.Mesh("custom", this._scene);
      var t = [-5, 2, -3, -7, -2, -3, -3, -2, -3, 5, 2, 3, 7, -2, 3, 3, -2, 3], n = [0, 1, 2, 3, 4, 5], a = [1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 0, 1, 0, 0, 0, 1, 1, 0, 0, 1, 0, 1], o = [0, 1, 0, 0, 1, 0], h = [];
      BABYLON.VertexData.ComputeNormals(t, n, h);
      const f = new BABYLON.VertexData();
      f.positions = t, f.indices = n, f.colors = a, f.normals = h, f.uvs = o, f.applyToMesh(e);
    }
    return e;
  }
  createBox(e, t) {
    let n = null, a = null;
    return this._scene && this._sceneHelper && (e && (a = this._scene.getMeshByID(e)), n = this._sceneHelper.createBox(a, t), this.setLongRenderingNeeded()), n;
  }
  getSceneBoundingBox() {
    let e = null;
    if (this._scene)
      for (let t = 0; t < this._scene.meshes.length; t++) {
        const n = this._scene.meshes[t];
        if (n && n.metadata && n.metadata.sceneBoundingBox) {
          e = n;
          break;
        }
      }
    return e;
  }
  getOrCreateSceneBoundingBox(e = !0) {
    let t = this.getSceneBoundingBox();
    return t || (t = this.createBoundingBox(null, "SceneBoundingBox", e), t && (t.metadata || (t.metadata = {}), t.metadata.boundingBox = !0, t.metadata.sceneBoundingBox = !0)), t;
  }
  createSceneBoundingBox(e = !0) {
    let t = this.getSceneBoundingBox();
    return t ? t.isVisible = e : (t = this.createBoundingBox(null, "SceneBoundingBox", e), t && (t.metadata || (t.metadata = {}), t.metadata.boundingBox = !0, t.metadata.sceneBoundingBox = !0)), t;
  }
  createBoundingBox(e, t, n = !0) {
    let a = null;
    if (e && (a = this.getMeshByID(e)), this._sceneHelper) {
      var o = this._sceneHelper.createBoundingBox(a, t);
      return o && (o.isVisible = n), this.setLongRenderingNeeded(), o;
    }
    return null;
  }
  createSphere(e, t) {
    let n = null, a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createSphere(a, t), this.setLongRenderingNeeded()), n;
  }
  createPlane(e, t) {
    let n = null, a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createPlane(a, t), this.setLongRenderingNeeded()), n;
  }
  createDisc(e, t) {
    let n = null, a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createDisc(a, t), this.setLongRenderingNeeded()), n;
  }
  createCylinder(e, t) {
    let n = null, a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createCylinder(a, t), this.setLongRenderingNeeded()), n;
  }
  createTorus(e, t) {
    let n = null, a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createTorus(a, t), this.setLongRenderingNeeded()), n;
  }
  createKnot(e, t) {
    let n = null, a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createKnot(a, t), this.setLongRenderingNeeded()), n;
  }
  createRibbon(e, t) {
    let n = null, a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = this._sceneHelper.createRibbon(a, t), this.setLongRenderingNeeded()), n;
  }
  async createRoundedCubeAsync(e, t) {
    let n = [], a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createRoundedCubeAsync(a, t), this.setLongRenderingNeeded()), n;
  }
  async createRoundedCylinderAsync(e, t) {
    let n = [], a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createRoundedCylinderAsync(a, t), this.setLongRenderingNeeded()), n;
  }
  async createMatBallAsync(e, t) {
    let n = [], a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createMatBallAsync(a, t), this.setLongRenderingNeeded()), n;
  }
  async createMaleHeadAsync(e, t) {
    let n = [], a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createMaleHeadAsync(a, t), this.setLongRenderingNeeded()), n;
  }
  async createFemaleHeadAsync(e, t) {
    let n = [], a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createFemaleHeadAsync(a, t), this.setLongRenderingNeeded()), n;
  }
  async createPokemonBallAsync(e, t) {
    let n = [], a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createPokemonBallAsync(a, t), this.setLongRenderingNeeded()), n;
  }
  async createShaderBallAsync(e, t) {
    let n = [], a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createShaderBallAsync(a, t), this.setLongRenderingNeeded()), n;
  }
  async createBootsAsync(e, t) {
    let n = [], a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createBootsAsync(a, t), this.setLongRenderingNeeded()), n;
  }
  async createSuzanneAsync(e, t) {
    let n = [], a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createSuzanneAsync(a, t), this.setLongRenderingNeeded()), n;
  }
  async createStepPyramidAsync(e, t) {
    let n = [], a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createStepPyramidAsync(a, t), this.setLongRenderingNeeded()), n;
  }
  async createTeapotAsync(e, t) {
    let n = [], a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createTeapotAsync(a, t), this.setLongRenderingNeeded()), n;
  }
  async createAlloyWheelAsync(e, t) {
    let n = [], a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createAlloyWheelAsync(a, t), this.setLongRenderingNeeded()), n;
  }
  async createTryonReferenceGlassesFrameAsync(e, t) {
    let n = [], a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.createTryonReferenceGlassesFrameAsync(a, t), this.setLongRenderingNeeded()), n;
  }
  removeAllVTOReferenceMeshes() {
    if (!this.scene)
      return [];
    const e = [], t = [...this.scene.meshes];
    for (const n of t)
      n.name && n.name.toLowerCase().includes("vto_reference") ? n.dispose(!1, !0) : e.push(n);
    return e;
  }
  hideAllVTOFiles(e) {
    for (const t of e)
      t.name && t.name.toLowerCase().includes("vto_reference") && (t.metadata || (t.metadata = {}), t.metadata.TryOn = !1);
  }
  async createTryOnReferenceModelsAsync(e, t, n) {
    let a = null, o = [];
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (o = await this._sceneHelper.createTryOnReferenceModelsAsync(a, t, n), this.fireMeshesUpdateEvent(), this.setRenderingNeeded(), this.hideAllVTOFiles(o)), o;
  }
  setTryOnReferenceVisible(e) {
    this._sceneHelper && (this._sceneHelper.setTryOnReferenceVisible(e), this.setRenderingNeeded());
  }
  isTryOnReferenceVisible() {
    return this._sceneHelper ? this._sceneHelper.isTryOnReferenceVisible() : !1;
  }
  scaleSceneToTryonReferenceModels(e) {
    var t;
    this._sceneHelper && (this._sceneHelper.scaleSceneToTryonReferenceModels(e), (t = this._sceneHelper) == null || t.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  getSceneScalingPercentageForVTO() {
    return this._sceneHelper ? this._sceneHelper.getSceneScalingPercentageForVTO() : 100;
  }
  setSceneScalePercentageForVTO(e) {
    var t;
    this._sceneHelper && (this._sceneHelper.setSceneScalePercentageForVTO(e), (t = this._sceneHelper) == null || t.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  getScenePositionPercentageForVTO() {
    return this._sceneHelper ? this._sceneHelper.getScenePositionPercentageForVTO() : { x: 0, y: 0, z: 0 };
  }
  setScenePositionPercentageForVTO(e, t, n) {
    var a;
    this._sceneHelper && (this._sceneHelper.setScenePositionPercentageForVTO(e, t, n), (a = this._sceneHelper) == null || a.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  getSceneRotationForVTO() {
    return this._sceneHelper ? this._sceneHelper.getSceneRotationForVTO() : { x: 0, y: 0, z: 0 };
  }
  setSceneRotationForVTO(e, t, n) {
    var a;
    this._sceneHelper && (this._sceneHelper.setSceneRotationForVTO(e, t, n), (a = this._sceneHelper) == null || a.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  setVTOReferenceVisible(e) {
    this._sceneHelper && (this._sceneHelper.setVTOReferenceVisible(e), this.setRenderingNeeded());
  }
  setShadowsVisibility(e) {
    var t;
    this._sceneHelper && (this._sceneHelper.setShadowsVisibility(e), (t = this._sceneHelper) == null || t.setupShadows(this._zkScene), this.setRenderingNeeded());
  }
  async importMeshesFromUrlAsync(e, t) {
    let n = [], a = null;
    return this._scene && e && (a = this._scene.getMeshById(e)), this._sceneHelper && (n = await this._sceneHelper.importMeshesFromUrlAsync(t, a), this.checkSceneEmptyEnvironmentTexture(), this.setLongRenderingNeeded()), n;
  }
  //#endregion
  //#region 2D Design Rendering
  async connectMeshToModelSideAsync(e, t, n) {
    this._sceneDesignManager && this._sceneDesignManager.connectMeshToModelSideAsync(e, t, n);
  }
  clearMeshDesignManagers() {
    this._sceneDesignManager && this._sceneDesignManager.clearMeshDesignManagers();
  }
  getMeshDesignMananger(e, t) {
    var n;
    return this._sceneDesignManager && this.scene ? (n = this._sceneDesignManager) == null ? void 0 : n.getMeshDesignMananger(e, t) : null;
  }
  // -------------------------------------------------------------
  // Design view transformation
  // -------------------------------------------------------------
  translateDesignView(e, t, n, a) {
    this._sceneDesignManager && this._sceneDesignManager.translateDesignView(e, t, n, a);
  }
  rotateDesignView(e, t, n, a, o) {
    this._sceneDesignManager && this._sceneDesignManager.rotateDesignView(e, t, n, a, o);
  }
  scaleDesignView(e, t, n, a, o, h) {
    this._sceneDesignManager && this._sceneDesignManager.scaleDesignView(e, t, n, a, o, h);
  }
  async setDesignViewTextureUVChannelAsync(e, t, n) {
    this._sceneDesignManager && await this._sceneDesignManager.setDesignViewTextureUVChannelAsync(e, t, n);
  }
  async setDesignViewFormFactorAsync(e, t, n, a) {
    this._sceneDesignManager && await this._sceneDesignManager.setDesignViewFormFactorAsync(e, t, n, a);
  }
  //#endregion
  //#region Mesh measuring
  getCurrentARMeshUsedForMeasure() {
    var t;
    return (t = this.scene) == null ? void 0 : t.meshes.find((n) => n.metadata && n.metadata.sizecm);
  }
  getCurrentARSizeCm() {
    var t;
    const e = this.getCurrentARMeshUsedForMeasure();
    return (t = e == null ? void 0 : e.metadata) == null ? void 0 : t.sizecm;
  }
  setSceneSizeCm(e, t) {
    const n = this.getOrCreateSceneBoundingBox(!1);
    n && this.setMeshSizeCm(n.id, e, t);
  }
  getSceneWidthCm() {
    const e = this.getSceneBoundingBox();
    return e && e.metadata && e.metadata.sizecm && e.metadata.sizecm.width ? e.metadata.sizecm.width : null;
  }
  getSceneHeightCm() {
    const e = this.getSceneBoundingBox();
    return e && e.metadata && e.metadata.sizecm && e.metadata.sizecm.height ? e.metadata.sizecm.height : null;
  }
  getSceneDepthCm() {
    const e = this.getSceneBoundingBox();
    return e && e.metadata && e.metadata.sizecm && e.metadata.sizecm.depth ? e.metadata.sizecm.depth : null;
  }
  setMeshSizeCm(e, t, n) {
    const a = this.getMeshByID(e);
    if (a) {
      let o = null;
      t && typeof t == "number" && !isNaN(t) && (n === "width" ? o = { width: t } : n === "height" ? o = { height: t } : n === "depth" && (o = { depth: t })), a.metadata || (a.metadata = {}), a.metadata.sizecm = o;
    }
  }
  getMeshWidthCm(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata && t.metadata.sizecm && t.metadata.sizecm.width ? t.metadata.sizecm.width : null;
  }
  getMeshHeightCm(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata && t.metadata.sizecm && t.metadata.sizecm.height ? t.metadata.sizecm.height : null;
  }
  getMeshDepthCm(e) {
    const t = this.getMeshByID(e);
    return t && t.metadata && t.metadata.sizecm && t.metadata.sizecm.depth ? t.metadata.sizecm.depth : null;
  }
  //#endregion
  //#region Material Previews
  async getMaterialsPreviewsAsync(e, t, n, a, o = !0) {
    const h = [];
    if (this._scene && this._sceneHelper && this._zkScene) {
      const v = await this.getSceneRootUrl();
      if (v) {
        const x = await ao.getPreviewsAsync(
          this._scene,
          v,
          e,
          { width: t, height: n },
          !0
        );
        for (var f in x.previewFiles)
          h.push(x.previewFiles[f]);
      }
    }
    return h;
  }
  async getAllMaterialsPreviewsAsync(e, t, n, a = !0) {
    const o = [];
    if (this._scene && this._sceneHelper && this._zkScene) {
      const f = this._sceneHelper.getAllMaterials().map((v) => v.id);
      return this.getMaterialsPreviewsAsync(f, e, t, n, a);
    }
    return o;
  }
  async downloadMaterialsPreviewsAsync(e, t, n, a) {
    if (this._scene && this._sceneHelper && this._zkScene) {
      const o = await this.getSceneRootUrl();
      o && await ao.downloadPreviewsAsync(this._scene, o, e, {
        width: t,
        height: n,
        crop: a
      });
    }
  }
  async downloadAllMaterialsPreviewsAsync(e, t, n) {
    if (this._scene && this._sceneHelper && this._zkScene) {
      const o = this._sceneHelper.getAllMaterials().map((h) => h.id);
      await this.downloadMaterialsPreviewsAsync(o, e, t, n);
    }
  }
  //#endregion
  createEnvelopeMesh(e) {
    if (this._scene && this._sceneHelper) {
      const t = this._scene.getMeshByID(e);
      if (t && t instanceof BABYLON.Mesh)
        return this._sceneHelper.createEnvelopeMesh(t);
    }
    return null;
  }
  expandMesh(e, t) {
    if (this._scene && this._sceneHelper) {
      const n = this._scene.getMeshByID(e);
      n && n instanceof BABYLON.Mesh && this._sceneHelper.expandMesh(n, t);
    }
  }
  enableDisableMeshFacetData(e, t) {
    if (this._scene && this._sceneHelper) {
      const n = this._scene.getMeshByID(e);
      n && (t ? n.updateFacetData() : n.disableFacetData());
    }
  }
  enableDisableDepthSortFacets(e, t) {
    if (this._scene && this._sceneHelper) {
      const n = this._scene.getMeshByID(e);
      n && (n.mustDepthSortFacets = t);
    }
  }
};
pg.EmptyGroupName = "_dummy_";
let o1 = pg;
var l1 = /* @__PURE__ */ ((b) => (b[b.Box = 0] = "Box", b[b.RoundedBox = 1] = "RoundedBox", b[b.Sphere = 2] = "Sphere", b[b.Plane = 3] = "Plane", b[b.Cylinder = 4] = "Cylinder", b[b.RoundedCylinder = 5] = "RoundedCylinder", b[b.Torus = 6] = "Torus", b[b.Knot = 7] = "Knot", b[b.Ribbon = 8] = "Ribbon", b[b.Custom = 9] = "Custom", b))(l1 || {});
class mg extends o1 {
  constructor(e) {
    super(e), this._zkMaterial = null, this._material = null, this._meshType = 0, this._mesh = null, this._materialCreatedListeners = [], this._filesInput = null;
  }
  get zkMaterial() {
    return this._zkMaterial;
  }
  get material() {
    return this._material;
  }
  static async createMaterialEditorAsync(e) {
    e || (e = {
      authorizationToken: "",
      showGround: !1,
      editorBackgroundColor: "#33334c",
      showHighlight: !1,
      incrementalWorkersScriptsUrls: []
    });
    const t = new mg(e);
    return await t.initAsync(), t;
  }
  deleteComponents() {
    super.deleteComponents(), this.deleteEditorMaterial(), this.deleteEditorMesh();
  }
  deleteEditorMaterial() {
    this._material && (this._material.dispose(), this._material = null, this.fireMaterialCreatedEvent());
  }
  deleteEditorMesh() {
    this._mesh && (this._mesh.dispose(), this._mesh = null), this._scene && this._sceneHelper && this._sceneHelper.getSceneMeshes().forEach((t) => t.dispose());
  }
  dispose() {
    super.dispose();
  }
  async createEmptySceneAsync() {
    await super.createEmptySceneAsync(), this.createEditorMaterial(void 0, "Standard"), await this.createEditorMeshAsync();
  }
  createEditorMaterial(e, t, n) {
    let a = null;
    return t != "ShaderMaterial" ? a = super.createMaterial(e, t, n) : (a = this.createShaderMaterial(), a && (a.id = Zakeke.generateUUID(), this.checkSceneEmptyEnvironmentTexture())), this._material = a, this.setRenderingNeeded(), this.fireMaterialCreatedEvent(), a;
  }
  applyEditorMaterial() {
    this._material && this._mesh && this.applyMaterial(this._material, this._mesh);
  }
  async replaceSceneAsync(e) {
    var t = null, n = null;
    this._material && this._zkMaterial && (t = this._material.serialize(), n = this._zkMaterial.get("rootUrl")), this.deleteScene(), this._scene = e, await this.setupSceneAsync(), t && n ? (this._material = BABYLON.Material.Parse(t, this._scene, n), this.fireMaterialCreatedEvent()) : this.createEditorMaterial(void 0, "Standard"), this.applyEditorMaterial(), this.adjustCamera(!1);
  }
  createShaderMaterial() {
    let e = null;
    if (this._scene && this._zkMaterial && this._zkMaterial.get("shaders")) {
      const n = this._zkMaterial.get("name") || "ShaderMaterial - " + Zakeke.makeID(5);
      var t = {
        vertex: this._zkMaterial.get("shaders").get("name"),
        fragment: this._zkMaterial.get("shaders").get("name")
      };
      const a = {
        attributes: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Attribute),
        uniforms: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Uniform),
        samplers: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Sampler)
      };
      e = new BABYLON.ShaderMaterial(n, this._scene, t, a), this.setupShaderMaterialCameraPosition(e);
    }
    return e;
  }
  createEditorMaterialFromJson(e, t) {
    if (this._scene) {
      var n = JSON.parse(e);
      this._material = BABYLON.Material.Parse(n, this._scene, t), this._material && this.setupShaderMaterialCameraPosition(this._material), this.checkSceneEmptyEnvironmentTexture(), this.fireMaterialCreatedEvent();
    }
  }
  async createEditorMeshAsync() {
    switch (this.deleteEditorMesh(), this._meshType) {
      case 0:
        this._mesh = this.createBox(null, "box");
        break;
      case 1:
        {
          const e = await this.createRoundedCubeAsync(null, "rounded box");
          e.length == 1 ? this._mesh = e[0] : this._mesh = this.createGroup(null, "rounded box group", e);
        }
        break;
      case 2:
        this._mesh = this.createSphere(null, "sphere");
        break;
      case 3:
        this._mesh = this.createPlane(null, "plane");
        break;
      case 4:
        this._mesh = this.createCylinder(null, "cylinder");
        break;
      case 5:
        {
          const e = await this.createRoundedCylinderAsync(null, "rounded cylinder");
          e.length == 1 ? this._mesh = e[0] : (this._mesh = this.createGroup(null, "rounded cylinder group"), e.forEach((t) => t.parent = this._mesh));
        }
        break;
      case 6:
        this._mesh = this.createTorus(null, "torus");
        break;
      case 7:
        this._mesh = this.createKnot(null, "knot");
        break;
      case 8:
        this._mesh = this.createRibbon(null, "ribbon");
        break;
    }
    this.applyEditorMaterial(), this.adjustCamera(!1);
  }
  async setEditorMeshType(e) {
    this._meshType = e, await this.createEditorMeshAsync();
  }
  async updateMaterialModelAsync() {
    if (this._zkMaterial && this._material && this._sceneHelper) {
      const t = await this._sceneHelper.takeMaterialScreenshotAsync(this._material.id, 500, 450);
      this._zkMaterial.set("imageData", t);
      const n = this._zkMaterial.get("name");
      n && n != this._material.name && (this._material.name = n);
      var e = this.getEditorMaterialJson();
      e && this._zkMaterial.set("JSON", e);
    }
  }
  getEditorMaterialJson() {
    if (this._scene && this._sceneHelper && this._material) {
      const n = this._sceneHelper;
      this._scene.textures.forEach((a) => {
        if (n.isTextureWithUrl(a) && a.url) {
          var o = a.url.lastIndexOf("/");
          if (o !== -1 && (o = a.url.lastIndexOf("/", o - 1), o !== -1 && (o = a.url.lastIndexOf("/", o - 1), o != -1))) {
            var h = a.url.substring(o + 1);
            a.name = h, a.url = a.name;
          }
        }
      });
      var e = this._material.serialize(), t = JSON.stringify(e);
      return t;
    }
    return null;
  }
  setMaterialModel(e, t) {
    if (this._zkMaterial = e, this.deleteEditorMaterial(), this._zkMaterial && this._zkMaterial instanceof Zakeke.Material) {
      const o = this._zkMaterial.get("shaders");
      if (o) {
        const h = o.get("name"), f = o.get("vertex"), v = o.get("fragment");
        h && f && v && this.setupShadersStore({ name: h, vertex: f, fragment: v });
      }
      var n = this._zkMaterial.get("JSON"), a = this._zkMaterial.get("rootUrl");
      n && a ? this.createEditorMaterialFromJson(n, a) : this.createEditorMaterial(this._zkMaterial.get("name") || void 0, t), this._material && (this._material.id = this._zkMaterial.getMaterialID());
    } else
      this.createEditorMaterial(void 0, t);
    this.applyEditorMaterial(), this.adjustCamera(!1), this.setupShaderMaterialsCameraPosition();
  }
  getTexturesUploadUrl(e) {
    return this._zkMaterial ? this._zkMaterial.getTexturesUrl() : "";
  }
  loadEditorMaterialTextureFiles__(e, t, n, a) {
    this.loadTextureFiles(e, this._material, t, !1, n, a);
  }
  loadEditorMaterialTextureFiles(e, t, n, a) {
    if (!this._material)
      return;
    const o = (M) => {
      let W = M.lastIndexOf(".");
      if (W !== -1)
        return M.substring(W);
    }, h = (M, W) => {
      const U = M.lastIndexOf(".");
      return U !== -1 ? M.substring(0, U).endsWith("_" + W) : !1;
    };
    if (!(!e || e.length == 0)) {
      var f = this.canLoadCubemap(this._material, t) && (e.length == 6 || o(e[0].name) == ".dds" || o(e[0].name) == ".hdr"), v = [];
      if (f && e.length == 6) {
        var x = ["px", "py", "pz", "nx", "ny", "nz"];
        for (let M = 0; M < e.length; M++) {
          const W = e[M];
          let U = -1;
          for (var k = 0; k < x.length; k++)
            if (h(W.name, x[k])) {
              v.push(W), U = k;
              break;
            }
          U !== -1 && x.splice(U, 1);
        }
        if (x.length != 0) {
          var I = "Immagini per la cube map non valide";
          a && a(I), Logger.info(I);
          return;
        }
      } else
        v.push(e[0]);
      var V = new FormData();
      for (let M = 0; M < v.length; M++)
        V.append("file-" + M, v[M]);
      jQuery.ajax({
        url: this.getTexturesUploadUrl(this._material.id),
        data: V,
        cache: !1,
        contentType: !1,
        processData: !1,
        type: "POST",
        success: (M) => {
          Object.prototype.toString.call(M) === "[object Array]" && (f ? this.setEditorMaterialCubeTextureImages(M, t) : this.setEditorMaterialTextureImage(M[0], t)), n && n();
        },
        error: (M, W, U) => {
          var Q = "An error occurred: " + W + "nError: " + U;
          a && a(Q);
        }
      });
    }
  }
  setEditorMaterialTextureImage(e, t) {
    if (this._scene && this._zkMaterial && this._material && e && e.imageUrl && e.fileObjectID) {
      const n = new Zakeke.MaterialTextureImage();
      n.set("textureImageID", Zakeke.generateUUID()), n.set("fileObjectID", e.fileObjectID), n.set("imageUrl", e.imageUrl), this._zkMaterial.get("textureImages").push(n);
      const a = e.imageUrl, o = new BABYLON.Texture(a, this._scene), h = this.getMaterialTexture(this._material, t);
      h && h instanceof BABYLON.Texture && (o.uScale = h.uScale, o.vScale = h.vScale, o.uOffset = h.uOffset, o.vOffset = h.vOffset, o.uAng = h.uAng, o.vAng = h.vAng, o.level = h.level, o.coordinatesIndex = h.coordinatesIndex, o.coordinatesMode = h.coordinatesMode, o.hasAlpha = h.hasAlpha, o.wrapU = h.wrapU, o.wrapV = h.wrapV), this.applyTexture(o, this._material, t), h && !this.isTextureUsed(h) && h.dispose();
    }
  }
  setEditorMaterialCubeTextureImages(e, t) {
    if (!this._scene || !this._zkMaterial || !this._material || Object.prototype.toString.call(e) != "[object Array]")
      return;
    let n = null;
    const a = () => this.setRenderingNeeded();
    if (e.length == 1) {
      let v = e[0];
      if (v.imageUrl && v.fileObjectID) {
        v.imageUrl.endsWith(".dds") ? n = BABYLON.CubeTexture.CreateFromPrefilteredData(v.imageUrl, this._scene) : v.imageUrl.endsWith(".hdr") && (n = new BABYLON.HDRCubeTexture(
          v.imageUrl,
          this._scene,
          512,
          void 0,
          void 0,
          void 0,
          void 0,
          a
        ));
        var o = new Zakeke.MaterialTextureImage();
        o.set("textureImageID", Zakeke.generateUUID()), o.set("fileObjectID", v.fileObjectID), o.set("imageUrl", v.imageUrl), this._zkMaterial.get("textureImages").push(o);
      }
    } else if (e.length == 6) {
      const v = ["px", "py", "pz", "nx", "ny", "nz"];
      let x = "";
      const k = [], I = [], V = (U, Q) => {
        var D = U.lastIndexOf(".");
        if (D !== -1) {
          var ee = U.substring(0, D);
          return ee.endsWith("_" + Q);
        }
        return !1;
      }, M = (U, Q) => {
        const D = U.lastIndexOf(".");
        if (D !== -1) {
          var ee = U.substring(0, D);
          if (ee.endsWith("_" + Q))
            return ee.substring(0, ee.length - ("_" + Q).length);
        }
        return null;
      }, W = (U, Q) => {
        const D = U.lastIndexOf("_" + Q);
        return D !== -1 ? U.substr(D) : null;
      };
      for (let U = 0; U < v.length; U++) {
        var h = v[U];
        for (let Q = 0; Q < e.length; Q++) {
          const ee = e[Q].imageUrl;
          if (ee && V(ee, h)) {
            k.push(ee), I.push(W(ee, h) ?? ""), x || (x = M(ee, h) ?? "");
            break;
          }
        }
      }
      for (let U = 0; U < e.length; U++) {
        const Q = e[U];
        if (Q.imageUrl && Q.fileObjectID != null) {
          const D = Q.imageUrl, ee = Q.fileObjectID, J = new Zakeke.MaterialTextureImage();
          J.set("textureImageID", Zakeke.generateUUID()), J.set("fileObjectID", ee), J.set("imageUrl", D), this._zkMaterial.get("textureImages").push(J);
        }
      }
      n = new BABYLON.CubeTexture(x, this._scene, I, !1, k);
    }
    if (n) {
      var f = this.getMaterialTexture(this._material, t);
      this.applyTexture(n, this._material, t), f && !this.isTextureUsed(f) && f.dispose();
    }
  }
  // -------------------------------------------------------------
  // Events
  // -------------------------------------------------------------
  fireMaterialCreatedEvent() {
    for (let e = 0; e < this._materialCreatedListeners.length; ++e)
      this._materialCreatedListeners[e]();
  }
  addMaterialCreatedListener(e) {
    this._materialCreatedListeners.push(e);
  }
  //#region Load Custom Mesh
  loadFiles(e, t, n) {
    if (!this._engine || !this._scene || !this._sceneHelper)
      return;
    const a = this._engine, o = this._scene, h = this._sceneHelper;
    this._filesInput || (this._filesInput = new BABYLON.FilesInput(
      a,
      o,
      async (f, v) => {
        await this.replaceSceneAsync(v);
        const x = h.getSceneMeshes();
        this._meshType = 9, this._mesh = this.createGroup(null, "group", x), this.applyEditorMaterial(), t && t();
      },
      null,
      //(progress: BABYLON.SceneLoaderProgressEvent) => { }, // progressCallback
      null,
      //() => { },  // additionalRenderLoopLogicCallback
      null,
      //(remaining: number) => { }, // textureLoadingCallback
      null,
      //(files?: File[]) => { },  // startingProcessingFilesCallback
      null,
      //(sceneFile: File) => { }, // onReloadCallback
      (f, v, x) => {
        n && n(x);
      }
    )), this._filesInput && this._filesInput.loadFiles(e);
  }
  //#endregion
}
const h1 = "https://3dviewer-img.futurefashionsolution.com/_common/envMap/default.env", A1 = {
  general: {
    backgroundAlpha: 1,
    backgroundColor: "#ffffff",
    screenshotBackgroundColor: null,
    removeDefaultBackground: !0,
    environmentTexture: h1,
    matchSameNameTextures: null,
    antialiasEnabled: null,
    tryOnEnabled: null,
    tryOnSettings: null,
    arEnabled: !0,
    arOnTheFly: !1,
    arAnchor: null,
    arScale: null,
    meshSize: {
      height: null,
      width: null,
      depth: null
    },
    antialias: {
      desktop: {
        enabled: !0,
        inRotationEnabled: !0
      }
    },
    frameDAMSettings: null,
    useDelayedTextureLoading: null,
    useDelayedMaterialLoading: null,
    useMaterialOffloading: null,
    prefetchMeshes: null,
    prefetchMaterials: null,
    exposure: 1,
    contrast: 1,
    preventDefaultLights: !0,
    forceDracoCompression: null,
    fitToScreenMargin: 1,
    environmentOptions: {
      mipMaps: !1,
      generateHarmonics: !1,
      gammaSpace: !0,
      prefilterOnLoad: !0,
      rotationY: 1.57,
      intensity: 1,
      // environment intensity
      pbrIntensity: 1
      // pbr intensity
    }
  },
  environment: {
    sizeAuto: null,
    mainColor: "#CB0E00",
    backgroundColor: "#5CA0B5",
    skybox: {
      createSkybox: !1,
      size: null,
      texture: null,
      extensions: null,
      files: null,
      color: null,
      blur: 0
    },
    ground: {
      createGround: !1,
      size: null,
      texture: null,
      color: null,
      opacity: null,
      enableShadow: !1,
      shadowLevel: null,
      enableMirror: !0,
      mirrorBlurKernel: null
    },
    shadows: {
      enableShadows: !1,
      groundSizeMultiplierWidth: 1.2,
      groundSizeMultiplierLength: 1.5,
      shadowMapSize: 51,
      shadowHexColor: "#454545",
      contactHardeningUVRatio: 0.4,
      useContactHardeningShadow: !0,
      useBlurCloseExponentialShadowMap: !1,
      usePercentageCloserFiltering: !1,
      useKernelBlur: !0,
      usePoissonSampling: !1,
      blurBoxOffset: 10,
      blurScale: 4,
      blurKernel: 10,
      depthScale: 1,
      shadowDarkness: 0.3
    }
  },
  camera: {
    autoRotate: !1,
    rotationSpeed: 0.2,
    changeRotationDirection: !1,
    contrast: 1.6,
    exposure: 0.8,
    toneMappingEnabled: !0,
    toneMappingType: 0,
    setInitialZoomToBoundingBox: !0,
    initialZoomToBBInertiaDamping: 0.9,
    initialZoomToBBModelSizeRadius: 0.7,
    initialZoomToBBScrollZoomEnabled: !0,
    initialZoomToBBScrollLowerLimit: 2,
    initialZoomToBBScrollUpperLimit: 2,
    positionScale: null,
    limitLowerRadius: !0,
    zoomEnabled: null,
    useMinZoomPerc: !0,
    minZoomPerc: 0.5,
    useMaxZoomPerc: !0,
    maxZoomPerc: 1.5,
    lowerAlphaLimit: null,
    upperAlphaLimit: null,
    fixedAlphaAngle: null,
    fixedBetaAngle: null,
    useLowerAlphaLimit: null,
    lowerBetaLimit: 0,
    upperBetaLimit: 3,
    useLowerBetaLimit: null,
    useUpperAlphaLimit: null,
    useUpperBetaLimit: null,
    zoom: 0,
    position: {
      alpha: 1.57,
      beta: 1.55,
      fov: 0.4
    },
    animateIntro: !1
  },
  model: {
    rotation: {
      x: 0,
      y: 0,
      z: 0
    },
    position: {
      x: 0,
      y: 0,
      z: 0
    },
    scale: {
      x: 1,
      y: 1,
      z: 1
    },
    config: {
      doubleSided: !1
    }
  },
  glow: null,
  infoPoints: null,
  uiConfig: {
    urlARIcon: "",
    urlLoader: ""
  },
  lights: {
    directionalLightBack: {
      position: {
        x: -1,
        y: 0,
        z: -1
      },
      general: {
        intensity: 3,
        visible: !0
      }
    },
    directionalLightLeft: {
      position: {
        x: 0,
        y: 0,
        z: 1
      },
      general: {
        intensity: 1.2,
        visible: !0
      }
    },
    pointLightBack: {
      position: {
        x: 1,
        y: 0.5,
        z: 0.5
      },
      general: {
        intensity: 2,
        visible: !1
      }
    },
    pointLightFront: {
      position: {
        x: -1,
        y: 0.5,
        z: -0.5
      },
      general: {
        intensity: 2,
        visible: !1
      }
    },
    hemisphereLight: {
      position: {
        x: 0,
        y: 30.76964,
        z: 0
      },
      general: {
        intensity: 0.5,
        visible: !1
      }
    }
  },
  textures: null,
  animations: {
    runAtStart: !0,
    loop: !0,
    speed: 1
  }
};
export {
  kl as AndroidAR,
  Mw as AxesLayer,
  Vd as BlendProceduralTexture,
  no as BlurXProceduralTexture,
  ro as BlurYProceduralTexture,
  r1 as BroadcastChannelEventType,
  Sw as DAMViewerAnalyticsEventType,
  Uf as Database,
  ci as DefaultAssetUrls,
  _w as DracoCompression,
  Za as EditingMode,
  l1 as EditorMeshType,
  Hd as ElementSelector,
  Jd as EnvironmentManager,
  Lr as EnvironmentMode,
  Aw as EventState,
  so as ForegroundBackgroundProceduralTexture,
  Kx as GlowManager,
  zf as IS_ANDROID,
  Ff as IS_IOS,
  ew as IncrementalFiles,
  xw as InfoPointsManager,
  fw as InnerShadow,
  Cw as LightsLayer,
  mg as MaterialEditor,
  s1 as MaterialGroup,
  hw as MaterialPreviewData,
  ao as MaterialsPreview,
  Xd as MeshDesignManager,
  Ax as MeshExpander,
  Xx as MeshLocationsManager,
  hu as MoveProceduralTexture,
  sg as MultiObserver,
  Qa as MultiplyProceduralTexture,
  zd as NormalMapProceduralTexture,
  ag as Observable,
  Tw as Observer,
  Hx as OpacityProceduralTexture,
  dw as OuterShadow,
  ll as OverlayProceduralTexture,
  C1 as Preview3DConfigurationManager,
  cw as ProceduralNormalMap,
  $x as SceneActionsExecutor,
  gw as SceneDesignManager,
  o1 as SceneEditor,
  di as SceneHelper,
  bw as SceneToBlobs,
  yu as SceneViewer,
  a1 as SourceTaskStatus,
  xs as StringTools,
  ww as TryOnFineTuningMazingEnvironment,
  rg as TryOnProvider,
  Os as TryOnSettingsType,
  ng as TryOnType,
  Tx as UsdzHelper,
  pu as WorkerPool,
  wy as ZakekeEnvironment,
  ra as arrayContains,
  sw as changeColorLuminosity,
  y1 as chunkString,
  aw as cropImageTransparency,
  _1 as cropImageTransparencyAsync,
  qd as dataURItoBlob,
  Bh as debounce,
  A1 as defaultSceneConfig,
  S1 as flipImage,
  x1 as getAbsoluteUrl,
  nw as getColorBrightness,
  v1 as getColorImage,
  p1 as getContrastYIQ,
  m1 as getContrastYIQHex,
  M1 as getNavigatorQueryParams,
  w1 as getRandomString,
  b1 as getStringHashCode,
  g1 as getViewport,
  f1 as isAndroid,
  rw as isColorDark,
  c1 as isIPhoneX,
  iw as isMobile,
  Qo as isPBRMaterial,
  d1 as isiOS,
  Zd as removeBlanks,
  lw as resizeImageFromDataUri,
  ow as trimCanvas,
  Uh as trimImageAsync
};
